webpackJsonp([1],Array(75).concat([
/* 75 */
/***/ (function(module, exports) {

module.exports = "<div ng-controller=\"DashboardController as dashboard\">\n\n    <ng-include src=\"'app/dashboard/mobileAppNotice.html'\" ng-if=\"dashboard.showMobileAppMessaging === true\"></ng-include>\n\n    <div class=\"hp-module animate-element-show ng-animate\"\n         ng-repeat=\"module in dashboard.dashboardModules\">\n        <div class=\"hp-inner\" ng-if=\"module.name.toLowerCase() !== 'start project'\">\n            <ng-include src=\"module.path\"></ng-include>\n        </div>\n        <ng-include src=\"module.path\" ng-if=\"module.name.toLowerCase() === 'start project'\"></ng-include>\n    </div>\n</div>\n";

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// console.log(`Env variable: ${process.env.NODE_ENV}`);


var HPConfig = {
    environment: '#{Environment.AbstractName}',
    renovateLink: '#{Urls.Web.FOAHI}',
    heroProApi: '#{Urls.API.HEROPro}/',
    authApi: '#{Urls.API.Auth}',
    heroProLoginLink: '#{Urls.Web.Contractor}/login',
    heroProLink: '#{Urls.HEROPro}',
    applyLink: '#{Urls.HEROApplication}',
    idVerifyLink: '#{Urls.idVerify}',
    proPitchLink: '#{Urls.Propitch}',
    benjiFinancingLink: '#{Urls.Web.Contractor}',
    heroCalcLink: '#{Urls.RAFinancingCalculator}',
    rackspaceCdn: '#{herobl.ContractorCDNPath}',
    mapBoxAuthKey: '#{MapBox.HEROProAuthKey}',
    qualityRatingEnabled: '#{HEROPro.QualityRatingEnabled}',
    tokenExpirationInSeconds: '#{HEROPro.TokenExpirationInSeconds}',
    docGenWaitTimeInSeconds: '#{HEROPro.DocGenWaitTimeInSeconds}',
    showMFACalc: 'true',
    addProductsPartialSearchEnabled: '#{HEROPro.AddProductsPartialSearchEnabled}',
    splashMtnEnabled: '#{HEROPro.splashMtnEnabled}',
    splashMtnUrl: '#{HEROPro.splashMtnUrl}',
    splashMtnApiKey: '#{HEROPro.splashMtnApiKey}',
    addProductsWebLink: '#{Urls.Web.AddProducts}',
    apiVersion: 'unknown',
    applicationSource: '35',
    screenSizes: {
        screen_sm: 768,
        screen_md: 992,
        screen_lg: 1200
    },
    plaid: {
        url: '#{Plaid.APIUrl}',
        clientId: '#{Plaid.ClientId}',
        publicKey: '#{Plaid.PublicKey}'
    }
};

if (false) {
    HPConfig.environment = 'DEV';
    HPConfig.renovateLink = 'http://www.dev-foahomeimprovement.com/';
    HPConfig.heroProApi = 'https://proapi.dev-foahomeimprovement.com/';
    HPConfig.authApi = 'https://authapi.dev-foahomeimprovement.com/';
    HPConfig.heroProLoginLink = 'https://contractor.dev-foahomeimprovement.com/login'; // New HERO Pro login link
    HPConfig.heroProLink = 'https://pro.dev-foahomeimprovement.com';
    HPConfig.applyLink = 'https://apply.dev-foahomeimprovement.com/';
    HPConfig.idVerifyLink = 'https://verifydev.renovateamerica.com/';
    HPConfig.proPitchLink = 'https://proposaldev.heroprogram.com/';
    HPConfig.benjiFinancingLink = 'https://contractordev.benjifinancing.com/';
    HPConfig.heroCalcLink = 'https://calc.devrafinancing.com/';
    HPConfig.rackspaceCdn = 'https://19f39596af1cdc4c037d-9b07ea34782da317d49e180c0a5bc867.ssl.cf2.rackcdn.com/';
    HPConfig.mapBoxAuthKey = 'pk.eyJ1IjoianJpY2htb25kIiwiYSI6ImNpbTQyczFoYzAwNW50em02YjB0c2l3cDEifQ.VXU8NHSLe3s5MLjhk0e5DA';
    HPConfig.qualityRatingEnabled = 'true';
    HPConfig.tokenExpirationInSeconds = 600000;
    HPConfig.docGenWaitTimeInSeconds = 45;
    HPConfig.showMFACalc = 'false';
    HPConfig.addProductsPartialSearchEnabled = 'true';
    HPConfig.splashMtnEnabled = 'both';
    HPConfig.splashMtnUrl = 'https://ut6rx1f93l.execute-api.us-west-2.amazonaws.com/0_0';
    HPConfig.splashMtnApiKey = 'H1I6f2HYJHmok3PnVGDq7nLDXeOOAZUalqQC574a';
    HPConfig.addProductsWebLink = 'https://addproducts.devrenovateamerica.com';

    HPConfig.plaid.url = 'https://sandbox.plaid.com/';
    HPConfig.plaid.publicKey = 'd6eb2ea28494fdaef199c57961a4e1';
    HPConfig.plaid.clientId = '5dcc524ec0e3b800125554ba';

    // HPConfig.addProductsWebLink = 'http://localhost:4200';
    // heroProApi: "https://localhost:44307/",
    // heroProLoginLink: "http://localhost:3000/",
}

exports.default = HPConfig;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _user = __webpack_require__(78);

var _user2 = _interopRequireDefault(_user);

var _financing = __webpack_require__(373);

var _financing2 = _interopRequireDefault(_financing);

var _licenses = __webpack_require__(390);

var _licenses2 = _interopRequireDefault(_licenses);

var _offices = __webpack_require__(409);

var _offices2 = _interopRequireDefault(_offices);

var _accountsController = __webpack_require__(477);

var _accountsController2 = _interopRequireDefault(_accountsController);

var _accountsFactory = __webpack_require__(479);

var _accountsFactory2 = _interopRequireDefault(_accountsFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.accounts', [
// features
_user2.default, _financing2.default, _licenses2.default, _offices2.default]).controller('AccountsController', _accountsController2.default).service('AccountsFactory', _accountsFactory2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/accounts/user/myprofile.html', __webpack_require__(480)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/user/paceCredential/paceCredential.html', __webpack_require__(481)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/user/users.html', __webpack_require__(482)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/offices/offices.html', __webpack_require__(483)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/financing/financing.html', __webpack_require__(484)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/licenses/licenses.html', __webpack_require__(485)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _userController = __webpack_require__(338);

var _userController2 = _interopRequireDefault(_userController);

var _paceCredentialController = __webpack_require__(340);

var _paceCredentialController2 = _interopRequireDefault(_paceCredentialController);

var _userTableController = __webpack_require__(342);

var _userTableController2 = _interopRequireDefault(_userTableController);

var _changePasswordFactory = __webpack_require__(79);

var _changePasswordFactory2 = _interopRequireDefault(_changePasswordFactory);

var _addUserController = __webpack_require__(343);

var _addUserController2 = _interopRequireDefault(_addUserController);

var _deleteUserController = __webpack_require__(345);

var _deleteUserController2 = _interopRequireDefault(_deleteUserController);

var _contractorUserLicenseRegistration = __webpack_require__(347);

var _contractorUserLicenseRegistration2 = _interopRequireDefault(_contractorUserLicenseRegistration);

var _addOfficeAssignmentController = __webpack_require__(349);

var _addOfficeAssignmentController2 = _interopRequireDefault(_addOfficeAssignmentController);

var _removeOfficeAssignmentController = __webpack_require__(351);

var _removeOfficeAssignmentController2 = _interopRequireDefault(_removeOfficeAssignmentController);

var _ParticipantVsCertifiedProfessionalComparisonController = __webpack_require__(353);

var _ParticipantVsCertifiedProfessionalComparisonController2 = _interopRequireDefault(_ParticipantVsCertifiedProfessionalComparisonController);

var _hpRolesSelector = __webpack_require__(355);

var _hpRolesSelector2 = _interopRequireDefault(_hpRolesSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.accounts.user', []).controller('UserController', _userController2.default).controller('PaceCredentialController', _paceCredentialController2.default).controller('UserTableController', _userTableController2.default).controller('AddUserController', _addUserController2.default).controller('ContractorUserLicenseRegistrationController', _contractorUserLicenseRegistration2.default).controller('ParticipantVsCertifiedProfessionalComparisonController', _ParticipantVsCertifiedProfessionalComparisonController2.default).controller('DeleteUserController', _deleteUserController2.default).controller('AddOfficeAssignmentController', _addOfficeAssignmentController2.default).controller('RemoveOfficeAssignmentController', _removeOfficeAssignmentController2.default).factory('ChangePasswordFactory', _changePasswordFactory2.default).directive('hpRolesSelector', _hpRolesSelector2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/accounts/user/personalInformation/personalInformationHeader.html', __webpack_require__(357)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/user/personalInformation/personalInformation.html', __webpack_require__(358)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/user/personalInformation/editPersonalInformation.html', __webpack_require__(359)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/user/profilePassword/profilePassword.html', __webpack_require__(360)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/user/preferences/preferences.html', __webpack_require__(361)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/user/preferences/changePreferences.html', __webpack_require__(362)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/user/officeAssignments/officeAssignments.html', __webpack_require__(363)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/user/userTable.html', __webpack_require__(364)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/user/personalInformation/contractorUserLicenseRegistration/contractorUserLicense-popover-template.html', __webpack_require__(365)); // eslint-disable-line global-require

    $templateCache.put('app/accounts/user/addUser/addUserContent.html', __webpack_require__(366)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/user/addUser/addUser.html', __webpack_require__(367)); // eslint-disable-line global-require

    $templateCache.put('app/accounts/user/deleteUser/deleteUser.html', __webpack_require__(368)); // eslint-disable-line global-require

    $templateCache.put('app/accounts/user/personalInformation/contractorUserLicenseRegistration/contractorUserLicenseRegistration.html', __webpack_require__(369)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/user/addOfficeAssignment/addOfficeAssignment.html', __webpack_require__(370)); // eslint-disable-line global-require

    $templateCache.put('app/accounts/user/officeAssignments/removeOfficeAssignment.html', __webpack_require__(371)); // eslint-disable-line global-require

    $templateCache.put('app/accounts/user/personalInformation/roles/rolesSelector.html', __webpack_require__(372)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = changePasswordFactory;
changePasswordFactory.$inject = ['$http', 'HPConfig'];
/* @ngInject */
function changePasswordFactory($http, HPConfig) {
    var changePasswordEnabled = false;
    var userObj = {};
    var statusMessage = '';
    var isPasswordDirty = false;

    return {
        changeUserPassword: changeUserPassword,
        requestRecoverPasswordEmail: requestRecoverPasswordEmail,
        changePasswordEnabled: changePasswordEnabled,
        userObj: userObj,
        statusMessage: statusMessage,
        isPasswordDirty: isPasswordDirty
    };

    function changeUserPassword(data) {
        return $http({
            url: HPConfig.heroProApi + 'ContractorUser/Auth',
            method: 'POST',
            data: data
        });
    }

    function requestRecoverPasswordEmail(email) {
        var passwordResetUrl = void 0;
        var data = void 0;
        passwordResetUrl = HPConfig.heroProApi + 'Login/SendPasswordRecoveryEmail';
        data = {
            Email: email
        };
        return $http({
            url: passwordResetUrl,
            method: 'POST',
            data: data
        });
    }
}

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = "<div class=\"view-profile-container\">\n    <div class=\"row\">\n        <!-- <div class=\"col-md-7\">\n            <div class=\"row company-counties-description\" ng-show=\"officeProfile.currentCounties[0].length > 0\">\n                <div class=\"col-md-12\">\n                    <div class=\"row\">\n                        <div class=\"col-md-12\">\n                            <h3>In which counties do you do business?</h3>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-md-6 company-counties-left-column\">\n                            <div class=\"row\">\n                                <div class=\"col-md-12 county-row\" ng-repeat=\"county in officeProfile.currentCounties[0]\">\n                                    <span ng-bind=\"county.Name\"></span>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-6\">\n                            <div class=\"row\">\n                                <div class=\"col-md-12 county-row\" ng-repeat=\"county in officeProfile.currentCounties[1]\">\n                                    <span ng-bind=\"county.Name\"></span>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div> -->\n        <div class=\"col-md-5\">\n            <div class=\"row\" ng-if=\"officeProfile.displayLogo === true\">\n                <div class=\"col-md-12\">\n                    <img class=\"profile-logo-image\" ng-src=\"{{officeProfile.logoImage}}\">\n                </div>\n            </div>\n            <div class=\"row company-services company-website\">\n                <div class=\"col-md-12\">\n                    <h3>Website</h3>\n                    <span class=\"link\" ng-click=\"officeProfile.navigateToWebsite()\" ng-bind=\"officeProfile.profileDetail.CompanyURL\"></span>\n                </div>\n            </div>\n            <div class=\"row company-services company-primary-service\">\n                <div class=\"col-md-12\">\n                    <h3>Primary Service</h3>\n                    <div>\n                        <p class=\"body-text\" ng-bind=\"officeProfile.selectedPrimaryService.Description\"></p>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row company-services company-other-services\">\n                <div class=\"col-md-12\">\n                    <h3>Other Services</h3>\n                    <div ng-repeat=\"type in officeProfile.secondaryServices\">\n                        <p class=\"body-text\" ng-bind=\"type.Description\"></p>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(92);

/**
 * Importing the app images
 */
__webpack_require__(964);
__webpack_require__(974);

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(94);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _angulartics = __webpack_require__(115);

var _angulartics2 = _interopRequireDefault(_angulartics);

var _angularticsGoogleAnalytics = __webpack_require__(117);

var _angularticsGoogleAnalytics2 = _interopRequireDefault(_angularticsGoogleAnalytics);

var _angularUiBootstrap = __webpack_require__(119);

var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);

var _uiSelect = __webpack_require__(121);

var _uiSelect2 = _interopRequireDefault(_uiSelect);

var _angularLocalStorage = __webpack_require__(123);

var _angularLocalStorage2 = _interopRequireDefault(_angularLocalStorage);

var _angularSanitize = __webpack_require__(125);

var _angularSanitize2 = _interopRequireDefault(_angularSanitize);

var _angularAnimate = __webpack_require__(127);

var _angularAnimate2 = _interopRequireDefault(_angularAnimate);

var _angularUiMask = __webpack_require__(129);

var _angularUiMask2 = _interopRequireDefault(_angularUiMask);

__webpack_require__(131);

__webpack_require__(134);

__webpack_require__(135);

__webpack_require__(136);

__webpack_require__(137);

__webpack_require__(138);

__webpack_require__(139);

__webpack_require__(140);

var _config = __webpack_require__(141);

var _config2 = _interopRequireDefault(_config);

var _applicationController = __webpack_require__(143);

var _applicationController2 = _interopRequireDefault(_applicationController);

var _permissionsService = __webpack_require__(144);

var _permissionsService2 = _interopRequireDefault(_permissionsService);

var _requestHandler = __webpack_require__(145);

var _requestHandler2 = _interopRequireDefault(_requestHandler);

var _userAuthFactory = __webpack_require__(146);

var _userAuthFactory2 = _interopRequireDefault(_userAuthFactory);

var _topNavFactory = __webpack_require__(147);

var _topNavFactory2 = _interopRequireDefault(_topNavFactory);

var _authentication = __webpack_require__(148);

var _authentication2 = _interopRequireDefault(_authentication);

var _authentication3 = __webpack_require__(149);

var _authentication4 = _interopRequireDefault(_authentication3);

var _httpInterceptorFactory = __webpack_require__(150);

var _httpInterceptorFactory2 = _interopRequireDefault(_httpInterceptorFactory);

var _PartnerAppsFactory = __webpack_require__(151);

var _PartnerAppsFactory2 = _interopRequireDefault(_PartnerAppsFactory);

var _singleSignOnFactory = __webpack_require__(152);

var _singleSignOnFactory2 = _interopRequireDefault(_singleSignOnFactory);

var _fundingRequest = __webpack_require__(153);

var _fundingRequest2 = _interopRequireDefault(_fundingRequest);

var _sidebarFactory = __webpack_require__(154);

var _sidebarFactory2 = _interopRequireDefault(_sidebarFactory);

var _UserDataFactory = __webpack_require__(155);

var _UserDataFactory2 = _interopRequireDefault(_UserDataFactory);

var _coachmarkFactory = __webpack_require__(156);

var _coachmarkFactory2 = _interopRequireDefault(_coachmarkFactory);

var _directiveService = __webpack_require__(159);

var _directiveService2 = _interopRequireDefault(_directiveService);

var _hpProgressIndicator = __webpack_require__(160);

var _hpProgressIndicator2 = _interopRequireDefault(_hpProgressIndicator);

var _loggerService = __webpack_require__(163);

var _loggerService2 = _interopRequireDefault(_loggerService);

var _MainController = __webpack_require__(173);

var _MainController2 = _interopRequireDefault(_MainController);

var _sidebarController = __webpack_require__(176);

var _sidebarController2 = _interopRequireDefault(_sidebarController);

var _TopNavController = __webpack_require__(178);

var _TopNavController2 = _interopRequireDefault(_TopNavController);

var _ssoController = __webpack_require__(181);

var _ssoController2 = _interopRequireDefault(_ssoController);

var _contactInfoController = __webpack_require__(183);

var _contactInfoController2 = _interopRequireDefault(_contactInfoController);

var _startProjectController = __webpack_require__(185);

var _startProjectController2 = _interopRequireDefault(_startProjectController);

var _app = __webpack_require__(186);

var _app2 = _interopRequireDefault(_app);

var _appHttp = __webpack_require__(189);

var _appHttp2 = _interopRequireDefault(_appHttp);

var _appLogging = __webpack_require__(190);

var _appLogging2 = _interopRequireDefault(_appLogging);

var _constants = __webpack_require__(191);

var _constants2 = _interopRequireDefault(_constants);

var _app3 = __webpack_require__(76);

var HPConfig = _interopRequireWildcard(_app3);

var _appRoles = __webpack_require__(210);

var HPRoles = _interopRequireWildcard(_appRoles);

var _appGeoStates = __webpack_require__(211);

var HPGeoStates = _interopRequireWildcard(_appGeoStates);

var _appDisplayRules = __webpack_require__(212);

var HPDisplayRules = _interopRequireWildcard(_appDisplayRules);

var _appTopNavRules = __webpack_require__(213);

var HPTopNavRules = _interopRequireWildcard(_appTopNavRules);

var _appSidebarRules = __webpack_require__(214);

var HPSidebarRules = _interopRequireWildcard(_appSidebarRules);

var _appDashboardRules = __webpack_require__(215);

var HPDashboardRules = _interopRequireWildcard(_appDashboardRules);

var _search = __webpack_require__(216);

var _search2 = _interopRequireDefault(_search);

var _dashboard = __webpack_require__(220);

var _dashboard2 = _interopRequireDefault(_dashboard);

var _pipelineSummary = __webpack_require__(229);

var _pipelineSummary2 = _interopRequireDefault(_pipelineSummary);

var _pipeline = __webpack_require__(234);

var _pipeline2 = _interopRequireDefault(_pipeline);

var _productCenter = __webpack_require__(267);

var _productCenter2 = _interopRequireDefault(_productCenter);

var _resources = __webpack_require__(319);

var _resources2 = _interopRequireDefault(_resources);

var _certification = __webpack_require__(330);

var _certification2 = _interopRequireDefault(_certification);

var _accounts = __webpack_require__(77);

var _accounts2 = _interopRequireDefault(_accounts);

var _lead = __webpack_require__(486);

var _lead2 = _interopRequireDefault(_lead);

var _actionItems = __webpack_require__(528);

var _actionItems2 = _interopRequireDefault(_actionItems);

var _appDetail = __webpack_require__(539);

var _appDetail2 = _interopRequireDefault(_appDetail);

var _modals = __webpack_require__(698);

var _modals2 = _interopRequireDefault(_modals);

var _notificationCenter = __webpack_require__(704);

var _notificationCenter2 = _interopRequireDefault(_notificationCenter);

var _hisWizard = __webpack_require__(798);

var _hisWizard2 = _interopRequireDefault(_hisWizard);

var _spinner = __webpack_require__(803);

var _spinner2 = _interopRequireDefault(_spinner);

var _controls = __webpack_require__(814);

var _controls2 = _interopRequireDefault(_controls);

var _smarty = __webpack_require__(822);

var _smarty2 = _interopRequireDefault(_smarty);

var _job = __webpack_require__(829);

var _job2 = _interopRequireDefault(_job);

var _primaryInformation = __webpack_require__(837);

var _primaryInformation2 = _interopRequireDefault(_primaryInformation);

var _dataFactories = __webpack_require__(845);

var _dataFactories2 = _interopRequireDefault(_dataFactories);

var _footer = __webpack_require__(851);

var _footer2 = _interopRequireDefault(_footer);

var _hints = __webpack_require__(857);

var _hints2 = _interopRequireDefault(_hints);

var _angular3 = __webpack_require__(862);

var _angular4 = _interopRequireDefault(_angular3);

var _windowResizeDirective = __webpack_require__(933);

var _windowResizeDirective2 = _interopRequireDefault(_windowResizeDirective);

var _hpFullScreenModalSuccess = __webpack_require__(934);

var _hpFullScreenModalSuccess2 = _interopRequireDefault(_hpFullScreenModalSuccess);

var _dropdownSmallPopupDirective = __webpack_require__(936);

var _dropdownSmallPopupDirective2 = _interopRequireDefault(_dropdownSmallPopupDirective);

var _spinnerButtonDirective = __webpack_require__(938);

var _spinnerButtonDirective2 = _interopRequireDefault(_spinnerButtonDirective);

var _spinnerLinkDirective = __webpack_require__(940);

var _spinnerLinkDirective2 = _interopRequireDefault(_spinnerLinkDirective);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Import Angular Helpers


// Import Common Modules


// Import Feature modules


// constants
// do this first - node_module css files should be loaded first (could it go somewhere else?)
// import '../../node_modules/bootstrap-sass/assets/stylesheets/_bootstrap.scss';
// import '../../node_modules/hopscotch/dist/css/hopscotch.min.css';
__webpack_require__(942);

// things everyone depends on that need to come first

// import ngSessionStorage from 'angular-sessionstorage';

// import angularuiscrollpoint from 'angular-ui-scrollpoint';

__webpack_require__(943);
__webpack_require__(944);

// Define the HeroPro module that will be manually bootstrapped
var HEROPro = _angular2.default.module('HeroPRO', [_angularUiBootstrap2.default, _angularjs2.default,
//  angularuiscrollpoint,
_angularAnimate2.default, _angulartics2.default, _angularticsGoogleAnalytics2.default, 'bw.paging', 'ngMask', _angularUiMask2.default, 'angularMoment',
// ngSessionStorage,
_angularLocalStorage2.default,
// "document",
_uiSelect2.default, _angularSanitize2.default, _config2.default,

// Common Features
_spinner2.default, _controls2.default, _smarty2.default, _job2.default, _primaryInformation2.default, _dataFactories2.default, _footer2.default, _hints2.default,

// Features
_search2.default, _dashboard2.default, _pipelineSummary2.default, _pipeline2.default, _productCenter2.default, _resources2.default, _certification2.default, _accounts2.default, _lead2.default, _actionItems2.default, _appDetail2.default, _modals2.default, _notificationCenter2.default, _hisWizard2.default,

// Constants
_constants2.default,
// Directives
_windowResizeDirective2.default,

// Misc Helpers
_angular4.default])
// Configs
.config(_appHttp2.default).config(_app2.default).config(_appLogging2.default)

// Don't know why this is required for constants to do Name.Name
.constant('HPConfig', HPConfig.default).constant('HPGeoStates', HPGeoStates.default).constant('HPDisplayRules', HPDisplayRules.HPDisplayRules).constant('HPTopNavRules', HPTopNavRules.HPTopNavRules).constant('HPSidebarRules', HPSidebarRules.HPSidebarRules).constant('HPDashboardRules', HPDashboardRules.HPDashboardRules).constant('HPRoles', HPRoles.default)

// End Constants

// Controllers
.controller('MainController', _MainController2.default).controller('ApplicationController', _applicationController2.default).controller('TopNavController', _TopNavController2.default).controller('SSOController', _ssoController2.default).controller('ContactInfoController', _contactInfoController2.default).controller('SidebarController', _sidebarController2.default).controller('StartProjectController', _startProjectController2.default)

// Services
.service('UserData', _UserDataFactory2.default).service('PermissionsFactory', _permissionsService2.default).service('requestHandlerService', _requestHandler2.default).service('UserAuthFactory', _userAuthFactory2.default).service('TopNavFactory', _topNavFactory2.default).service('authenticationService', _authentication2.default).service('AuthenticationFactory', _authentication4.default).service('HttpInterceptorFactory', _httpInterceptorFactory2.default).service('PartnerAppsFactory', _PartnerAppsFactory2.default).service('SingleSignOnFactory', _singleSignOnFactory2.default).service('FundingRequestDatastore', _fundingRequest2.default).service('SidebarFactory', _sidebarFactory2.default).service('coachmark', _coachmarkFactory2.default).service('DirectiveService', _directiveService2.default).service('hpLoggerService', _loggerService2.default)

// Directives
.directive('fullScreenModalSuccess', _hpFullScreenModalSuccess2.default).directive('hpProgressIndicator', _hpProgressIndicator2.default).directive('dropdownSmallPopup', _dropdownSmallPopupDirective2.default).directive('hpSpinnerButton', _spinnerButtonDirective2.default).directive('hpSpinnerLink', _spinnerLinkDirective2.default).run(['$templateCache', function ($templateCache) {
  // add html files that need to be cached
  $templateCache.put('app/application/application.html', __webpack_require__(945)); // eslint-disable-line global-require
  $templateCache.put('app/common/specialNotice/specialNotice.html', __webpack_require__(946)); // eslint-disable-line global-require
  $templateCache.put('app/common/specialNotice/shouldSignTC.html', __webpack_require__(947)); // eslint-disable-line global-require
  $templateCache.put('app/common/topNav/topNav.html', __webpack_require__(948)); // eslint-disable-line global-require
  $templateCache.put('app/common/sidebar/sidebar.html', __webpack_require__(949)); // eslint-disable-line global-require
  $templateCache.put('app/common/topNav/popovers/contactInfo.html', __webpack_require__(950)); // eslint-disable-line global-require
  $templateCache.put('app/common/topNav/popovers/brandSwitcher.html', __webpack_require__(951)); // eslint-disable-line global-require
  $templateCache.put('app/common/topNav/popovers/locationSwitcher.html', __webpack_require__(952)); // eslint-disable-line global-require
  $templateCache.put('app/common/topNav/popovers/proposalOptions.html', __webpack_require__(953)); // eslint-disable-line global-require
  $templateCache.put('app/common/topNav/popovers/userInfo.html', __webpack_require__(954)); // eslint-disable-line global-require
  $templateCache.put('app/common/fullScreenModalSuccess/fullScreenModalSuccess.html', __webpack_require__(955)); // eslint-disable-line global-require

  $templateCache.put('app/common/coachmark/coachmarkDefaultTemplate.html', __webpack_require__(956)); // eslint-disable-line global-require
  $templateCache.put('app/common/httpError/httpError.html', __webpack_require__(957)); // eslint-disable-line global-require
  $templateCache.put('app/common/controls/spinnerButton/spinnerButton.html', __webpack_require__(958)); // eslint-disable-line global-require
  $templateCache.put('app/common/controls/spinnerLink/spinnerLink.html', __webpack_require__(959)); // eslint-disable-line global-require
  $templateCache.put('app/common/topNav/sso.html', __webpack_require__(960)); // eslint-disable-line global-require
  $templateCache.put('app/accounts/user/paceCredential/popoverTemplates/paceParticipant.html', __webpack_require__(961)); // eslint-disable-line global-require
  $templateCache.put('app/accounts/user/paceCredential/popoverTemplates/certifiedPaceProfessional.html', __webpack_require__(962)); // eslint-disable-line global-require
  $templateCache.put('app/accounts/user/paceCredential/modals/ParticipantVsCertifiedProfessionalComparison.html', __webpack_require__(963)); // eslint-disable-line global-require
}]);

/*eslint-disable */

var HEROProPermissions = [];

function getAuthToken() {
  var authToken = localStorage.getItem('ls.authorizationData');

  if (authToken !== null) {
    return JSON.parse(authToken).access_token;
  }

  // If the auth token is not available in local storage, try to get it from the cookie
  return getCookie('copo_token');
}

function getCookie(cname) {
  var name = cname + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var cookieArray = decodedCookie.split(';');

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = cookieArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var cookie = _step.value;

      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return '';
}

function getPermissions() {
  var initInjector = _angular2.default.injector(['ng']);
  var $http = initInjector.get('$http');

  var applicationSource = '35'; // Hardcoded to HEROPro Web value
  var heroProApi =  false ? 'https://proapi.dev-foahomeimprovement.com/' : '#{Urls.API.HEROPro}/';

  var authToken = getAuthToken();

  var httpConfig = {
    headers: {
      common: {
        'X-RACtx': 'sa=' + applicationSource,
        'X-Requested-With': 'XMLHttpRequest'
      },
      Authorization: 'Bearer ' + authToken
    },
    withCredentials: true
  };

  return $http.get(heroProApi + 'User/Permissions', httpConfig).then(function (response) {
    HEROProPermissions = response.data.Permissions !== undefined ? response.data.Permissions : [];
  }, function (errorResponse) {
    console.log('errorResponse: ', errorResponse);
  });
}

function bootstrapApplication() {
  _angular2.default.element(document).ready(function () {
    _angular2.default.bootstrap(document, ['HeroPRO']);
  });
}

if (/PhantomJS/.test(window.navigator.userAgent) || window.jasmine) {
  bootstrapApplication();
} else {
  // START HERE: Wait until permissions are retrived before bootstraping the Angular app
  getPermissions().then(bootstrapApplication);
}

// This is executed after the application is bootstrapped
HEROPro.run(['PermissionsFactory', function (PermissionsFactory) {
  //
  PermissionsFactory.setPermissions(HEROProPermissions);
}]);

/* eslint-enable */

/***/ }),
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 132 */,
/* 133 */,
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _uibTooltip = __webpack_require__(142);

var _uibTooltip2 = _interopRequireDefault(_uibTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.configs', []).config(_uibTooltip2.default).name;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = uibTooltipConfig;
uibTooltipConfig.$inject = ['$uibTooltipProvider'];
// .config(['$uibTooltipProvider',


/* @ngInject */
function uibTooltipConfig($uibTooltipProvider) {
    var triggers = {};
    triggers.show = 'hide';

    $uibTooltipProvider.setTriggers(triggers);
}

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = applicationController;
applicationController.$inject = ['$stateParams', 'SearchService', '$state'];
// angular
// .module("HeroPRO")
// .controller("ApplicationController", applicationController);

/* @ngInject */
function applicationController($stateParams, SearchService, $state) {
    init();

    /*= ========================================
    =            Private Functions            =
    ========================================= */
    function init() {
        // SearchCriteria 5 = HEROId
        var params = {
            SearchCriteria: 5,
            SearchValue: $stateParams.HEROId
        };

        SearchService.search(params).then(function (response) {
            if (response.data.Data.PipelineFundingRequests !== undefined) {
                // Redirect to the first funding request that is returned
                $state.go('app-detail', { appId: response.data.Data.PipelineFundingRequests[0].FundingRequestId });
            } else {
                // Funding request not found with the HEROId passed
                $state.go('dashboard');
            }
        });
    }
    /* -----  End of Private Functions  ------*/

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    /* -----  End of Public Functions  ------*/
}

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* @ngInject */
var PermissionsService = function () {
    function PermissionsService(HPConfig, $http, $q) {
        _classCallCheck(this, PermissionsService);

        this.HPConfig = HPConfig;
        this.$http = $http;
        this.$q = $q;
        this.permissions = null;
    }

    _createClass(PermissionsService, [{
        key: "hasPermission",
        value: function hasPermission(permissionName) {
            return _.find(this.permissions, function (permission) {
                return permission === permissionName;
            }) !== undefined;
        }
    }, {
        key: "getPermissions",
        value: function getPermissions(attrs) {
            var _this = this;

            // attrs.fetchNewData - force fetch new data from the API
            // attrs.locationId - locationId to get permissions for
            attrs = attrs || {};

            var httpConfig = {
                params: {
                    id: attrs !== undefined && attrs.locationId !== undefined ? attrs.locationId : 0
                }
            };

            return this.$q(function (resolve) {
                if (_this.permissions === null || attrs !== undefined && attrs.fetchNewData === true) {
                    _this.$http.get(_this.HPConfig.heroProApi + "User/Permissions", httpConfig).then(function (response) {
                        _this.permissions = response.data.Permissions !== undefined ? response.data.Permissions : [];
                        resolve(_this.permissions);
                    });
                } else {
                    // Pass back data that is currently stored in the factory
                    resolve(_this.permissions);
                }
            });
        }
    }, {
        key: "setPermissions",
        value: function setPermissions(newPermissions) {
            this.permissions = newPermissions;
        }
    }]);

    return PermissionsService;
}();

PermissionsService.$inject = ["HPConfig", "$http", "$q"];
exports.default = PermissionsService;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RequestHandlerService = function () {
    function RequestHandlerService() {
        _classCallCheck(this, RequestHandlerService);

        this.pendingRefreshDeferred = [];
        this.pendingNewRefreshToken = false;
    }

    _createClass(RequestHandlerService, [{
        key: "AddNewDeferred",
        value: function AddNewDeferred(deferredFunction) {
            this.pendingRefreshDeferred.push(deferredFunction);
        }
    }, {
        key: "finishedRefresh",
        value: function finishedRefresh() {
            this.pendingNewRefreshToken = false;

            for (var i in this.pendingRefreshDeferred) {
                this.pendingRefreshDeferred[i](success);
            }
            this.pendingRefreshDeferred = [];
        }
    }]);

    return RequestHandlerService;
}();

/**
 * Created by charris on 4/9/2015.
 */
// (function(){
// 'use strict';
// angular.module('HeroPRO')
//   .service('requestHandlerService', function () {

//     //this is a singleton of the pending requests that need to be made that were queued up as a result of a expire token.. The first request to claim the pendingNewRefreshToken "mutex"
//     this.pendingRefreshDeferred = [];
//     this.pendingNewRefreshToken = false;

//     this.AddNewDeferred = function (_deferredFunction) {
//       this.pendingRefreshDeferred.push(_deferredFunction);
//     };

//     this.finishedRefresh = function (success) {

//       this.pendingNewRefreshToken = false;

//       for (var i in this.pendingRefreshDeferred) {
//         this.pendingRefreshDeferred[i](success);
//       }
//       this.pendingRefreshDeferred = [];
//     };
//   });
// })();


exports.default = RequestHandlerService;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* @ngInject */
var UserAuthService = function () {
    function UserAuthService($http, $q, HPConfig) {
        _classCallCheck(this, UserAuthService);

        this.$q = $q;
        this.$http = $http;
        this.HPConfig = HPConfig;
        this.cache = {};
        this.userId = null;
    }

    _createClass(UserAuthService, [{
        key: "getUserData",
        value: function getUserData() {
            return this.$http.get(this.HPConfig.heroProApi + "User");
        }
    }, {
        key: "getAuthorization",
        value: function getAuthorization() {
            var _this = this;

            var deferred = this.$q.defer();

            if (this.userId !== null && this.cache[this.userId] !== undefined) {
                deferred.resolve(this.cache[this.userId]);
            } else {
                this.getUserData().then(function (result) {
                    _this.userId = result.data.Data.ContractorUserId;
                    _this.cache[_this.userId] = result.data.Data;
                    deferred.resolve(_this.cache[_this.userId]);
                }).catch(function (err) {
                    deferred.reject(err);
                });
            }

            return deferred.promise;
        }
    }, {
        key: "getRegistrationInfo",
        value: function getRegistrationInfo(licenseNumber) {
            return this.$http.get(this.HPConfig.heroProApi + "Contractor/RegistrationInfo?LicenseNumber=" + licenseNumber);
        }
    }, {
        key: "deleteAuthorization",
        value: function deleteAuthorization() {
            if (this.userId !== null || this.cache[this.userId] !== undefined) {
                this.userId = null;
                this.cache = {};
            }
        }
    }]);

    return UserAuthService;
}();

UserAuthService.$inject = ["$http", "$q", "HPConfig"];
exports.default = UserAuthService;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* @ngInject */
var TopNavService = function () {
    function TopNavService($http, $q, HPConfig) {
        _classCallCheck(this, TopNavService);

        this.$http = $http;
        this.$q = $q;
        this.HPConfig = HPConfig;
    }

    _createClass(TopNavService, [{
        key: 'login',
        value: function login() {
            return this.$http({
                url: this.HPConfig.heroProApi + 'Login',
                method: 'POST'
            });
        }
    }, {
        key: 'getContactHours',
        value: function getContactHours() {
            return this.$http({
                url: this.HPConfig.heroProApi + 'RA/OfficeHours',
                method: 'GET'
            });
        }
    }, {
        key: 'logout',
        value: function logout() {
            this.$q.defer();
            var p2 = void 0;

            var p1 = this.$http({
                url: this.HPConfig.heroProApi + 'Login/Logout',
                method: 'POST'
            });

            return this.$q.all([p1, p2]);
        }
    }]);

    return TopNavService;
}();

exports.default = ['$http', '$q', 'HPConfig', TopNavService];

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* @ngInject */
var AuthenticationService = function () {
    function AuthenticationService(HPConfig, $q, $injector, AuthenticationFactory) {
        _classCallCheck(this, AuthenticationService);

        this.HPConfig = HPConfig;
        this.$q = $q;
        this.AuthenticationFactory = AuthenticationFactory;
        this.$injector = $injector;

        this.serviceBase = this.HPConfig.authApi;
        this.$http = null;
    }

    _createClass(AuthenticationService, [{
        key: 'logOut',
        value: function logOut() {
            this.AuthenticationFactory.removeAuthenticationData();
        }
    }, {
        key: 'refreshToken',
        value: function refreshToken() {
            var _this = this;

            var deferred = this.$q.defer();

            var authData = this.AuthenticationFactory.getAuthenticationData();

            if (authData && authData.useRefreshTokens) {
                var data = 'grant_type=refresh_token&refresh_token=' + authData.refresh_token + '&client_id=' + this.HPConfig.applicationSource;

                this.AuthenticationFactory.removeAuthenticationData();

                this.$http = this.$http || this.$injector.get('$http');
                this.$http.post(this.serviceBase + 'token', data, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }).then(function (response) {
                    response.data.useRefreshTokens = true;
                    _this.AuthenticationFactory.setAuthenticationData(response.data);

                    deferred.resolve(response.data);
                }).error(function (err) {
                    _this._logOut();
                    deferred.reject(err);
                });
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }
    }]);

    return AuthenticationService;
}();

exports.default = ['HPConfig', '$q', '$injector', 'AuthenticationFactory', AuthenticationService];

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* @ngInject */
var AuthenticationFactory = function () {
    function AuthenticationFactory(HPConfig, localStorageService, $interval) {
        _classCallCheck(this, AuthenticationFactory);

        this.HPConfig = HPConfig;
        this.localStorageService = localStorageService;
        this.$interval = $interval;

        this.authDataStorageKey = 'authorizationData';
        this.expiresInSeconds = this.HPConfig.tokenExpirationInSeconds; // seconds
        this.authDataIntervalDelay = 1; // seconds
        this.authDataInterval = null;

        this.startAuthDataInterval();
    }

    _createClass(AuthenticationFactory, [{
        key: 'getAuthenticationData',
        value: function getAuthenticationData() {
            // set expiration for storage
            var expiresIn = this.localStorageService.get(this.authDataStorageKey + '_expiresIn');
            expiresIn = expiresIn === undefined || expiresIn === null ? expiresIn = 0 : expiresIn;

            if (expiresIn < Date.now()) {
                // Expired
                this.localStorageService.remove(this.authDataStorageKey);
                return null;
            }
            try {
                return this.localStorageService.get(this.authDataStorageKey);
            } catch (e) {
                console.log('getStorage: Error reading token from localStorage: ' + JSON.stringify(e));
                return null;
            }
        }
    }, {
        key: 'removeAuthenticationData',
        value: function removeAuthenticationData() {
            try {
                this.localStorageService.remove(this.authDataStorageKey);
                this.localStorageService.remove(this.authDataStorageKey + '_expiresIn');
            } catch (e) {
                console.log('removeStorage: Error removing token localStorage: ' + JSON.stringify(e));
                return false;
            }
            return true;
        }
    }, {
        key: 'stopAuthenticationInterval',
        value: function stopAuthenticationInterval(expiration) {
            // Stop interval for 40 minutes(by default), so user doesn't get logged out when docusign
            if (expiration === undefined) {
                expiration = 60 * 40; // 40 minutes
            }
            this.stopAuthDataInterval();
            var schedule = Date.now() + expiration * 1000;
            this.localStorageService.set(this.authDataStorageKey + '_expiresIn', schedule);
        }
    }, {
        key: 'setAuthenticationData',
        value: function setAuthenticationData(authData) {
            this.stopAuthDataInterval();

            var schedule = Date.now() + this.expiresInSeconds * 1000;
            try {
                this.localStorageService.set(this.authDataStorageKey, authData);
                this.localStorageService.set(this.authDataStorageKey + '_expiresIn', schedule);
                this.startAuthDataInterval();
            } catch (e) {
                console.log('setStorage: Error setting token on localStorage: ' + JSON.stringify(e));
                return false;
            }
            return true;
        }
    }, {
        key: 'startAuthDataInterval',
        value: function startAuthDataInterval() {
            var _this = this;

            // start interval to keep the token alive
            this.authDataInterval = this.$interval(function () {
                if (_this.localStorageService.get(_this.authDataStorageKey + '_expiresIn') !== undefined) {
                    var newSchedule = Date.now() + _this.expiresInSeconds * 1000;
                    _this.localStorageService.set(_this.authDataStorageKey + '_expiresIn', newSchedule);
                }
            }, this.authDataIntervalDelay * 1000, 0, false);
        }
    }, {
        key: 'stopAuthDataInterval',
        value: function stopAuthDataInterval() {
            // stop the interval;
            if (this.authDataInterval !== undefined) {
                this.$interval.cancel(this.authDataInterval);
            }
        }
    }]);

    return AuthenticationFactory;
}();

exports.default = ['HPConfig', 'localStorageService', '$interval', AuthenticationFactory];

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* @ngInject */
var httpIntercetorService = function () {
	function httpIntercetorService($q, $rootScope, $injector, HPConfig, AuthenticationFactory, requestHandlerService) {
		var _this = this;

		_classCallCheck(this, httpIntercetorService);

		Object.defineProperty(this, 'request', {
			enumerable: true,
			writable: true,
			value: function value(config) {
				var authData = _this.AuthenticationFactory.getAuthenticationData();

				//If Auth data exists, retrieve from LocalStorage
				if (authData && config.url.indexOf(_this.HPConfig.heroProApi) >= 0) {
					config.headers = config.headers || {};

					config.headers.common = config.headers.common || {};

					config.headers.common["X-RACtx"] = 'sa=' + _this.HPConfig.applicationSource;

					if (authData.access_token) {
						config.headers.Authorization = 'Bearer ' + authData.access_token;
					}
					if (authData.secret_key) {
						config.headers.common["X-RACtx"] = 'sk=' + authData.secret_key + '&sa=' + _this.HPConfig.applicationSource;
					}
				}
				return config;
			}
		});
		Object.defineProperty(this, 'response', {
			enumerable: true,
			writable: true,
			value: function value(resp) {
				var headerRACtx = _this._parseHeaderRACtx(resp.headers("X-RACtx"));
				if (headerRACtx.sv !== null) {
					if (_this.HPConfig.apiVersion === "unknown") {
						_this.HPConfig.apiVersion = headerRACtx.sv;
					} else if (_this.HPConfig.apiVersion !== headerRACtx.sv) {
						// alert ("refresh");
					}
				}
				return resp || _this.$q.when(resp);
			}
		});
		Object.defineProperty(this, 'responseError', {
			enumerable: true,
			writable: true,
			value: function value(rejection) {

				var deferred = _this.$q.defer();

				var eventName = "";

				// Parsing header X-RACtx into an object
				rejection.headerRACtx = _this._parseHeaderRACtx(rejection.headers("X-RACtx"));

				// Not Authenticated
				if (rejection.status === 401) {

					//check to see if the mutex has already been claimed... if so create a new promise of the request to do work and enqueue it
					if (_this.requestHandlerService.pendingNewRefreshToken === true) {

						var deferredFunction = function deferredFunction(success) {
							var _config = rejection.config;
							var _deffered = deferred;
							if (success) {
								_this._retryHttpRequest(_config, _deffered);
							} else {
								_deffered.reject(rejection);
							}
						};

						_this.requestHandlerService.AddNewDeferred(deferredFunction);

						return deferred.promise;
					}

					//otherwise claim the mutex and try and get a new token.. if successful then release the mutex and tell the refreshTokenService to process the pending requests
					//if unsuccessful then reject the list of promises waiting and log out.
					_this.requestHandlerService.pendingNewRefreshToken = true;

					var authenticationService = _this.$injector.get('authenticationService');
					authenticationService.refreshToken().then(function () {

						_this.requestHandlerService.finishedRefresh(true);
						_this._retryHttpRequest(rejection.config, deferred);
					}, function () {

						_this.requestHandlerService.finishedRefresh(false);
						authenticationService.logOut(_this.$injector.get('$stateParams'));
						/*$state.go('login');*/
					});
					eventName = "HPErrorUnauthorized";
				}

				// Forbidden
				else if (rejection.status === 403) {
						eventName = "HPErrorForbidden";
					}

					// Not Found
					else if (rejection.status === 404) {
							eventName = "HPErrorNotFound";
						}

						// Internal server error / timeout (transaction id)
						else if (rejection.status === 500) {
								eventName = "HPErrorServer";
							}

							// Default to any other error
							else {
									eventName = "HPErrorUnknown";
								}

				deferred.reject(rejection);
				_this.$rootScope.$broadcast(eventName, rejection);

				return deferred.promise;
			}
		});

		this.$q = $q;
		this.$rootScope = $rootScope;
		this.$injector = $injector;
		this.HPConfig = HPConfig;
		this.AuthenticationFactory = AuthenticationFactory;
		this.requestHandlerService = requestHandlerService;
	}

	_createClass(httpIntercetorService, [{
		key: '_parseHeaderRACtx',


		// private functions
		value: function _parseHeaderRACtx(headerRACtx) {
			var headerRACtxObject = {};
			if (headerRACtx !== null) {
				headerRACtx = headerRACtx.split("&");
				for (var i = 0; i < headerRACtx.length; i++) {
					var headerSplit = headerRACtx[i].split("=");
					headerRACtxObject[headerSplit[0]] = headerSplit[1];
				}
			}
			return headerRACtxObject;
		}
	}, {
		key: '_retryHttpRequest',
		value: function _retryHttpRequest(config, deferred) {
			$http = $http || this.$injector.get('$http');
			$http(config).then(function (response) {
				deferred.resolve(response);
			}, function (response) {
				deferred.reject(response);
			});
		}
	}]);

	return httpIntercetorService;
}();

httpIntercetorService.$inject = ['$q', '$rootScope', '$injector', 'HPConfig', 'AuthenticationFactory', 'requestHandlerService'];
exports.default = httpIntercetorService;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* @ngInject */
var PartnerAppsService = function () {
    function PartnerAppsService(HPConfig, $q, AuthenticationFactory, SingleSignOnFactory, FundingRequestDatastore, UiDisplayFactory, KBYGFactory) {
        _classCallCheck(this, PartnerAppsService);

        this.$q = $q;
        this.HPConfig = HPConfig;
        this.UiDisplayFactory = UiDisplayFactory;
        this.AuthenticationFactory = AuthenticationFactory;
        this.FundingRequestDatastore = FundingRequestDatastore;
        this.SingleSignOnFactory = SingleSignOnFactory;
        this.KBYGFactory = KBYGFactory;
    }

    _createClass(PartnerAppsService, [{
        key: 'getBenjiLink',
        value: function getBenjiLink() {
            var contractorType = this.UiDisplayFactory.getDisplayRules().isBenjiOnlyUser ? 0 : 1;
            return this.HPConfig.benjiFinancingLink + '?ct=' + contractorType;
        }
    }, {
        key: 'getProPitchLink',
        value: function getProPitchLink() {
            var proPitchLink = '';
            var primaryInfo = this.FundingRequestDatastore.getPrimaryInformation();

            proPitchLink = this.HPConfig.proPitchLink + '/#/login?bt=' + this.AuthenticationFactory.getAuthenticationData().access_token;
            if (primaryInfo && (primaryInfo.PreQualID || primaryInfo.FundingRequestId)) {
                // If ApplicationDetail is open, load Primary Information
                if (primaryInfo.PreQualID) {
                    // Check if a KBYG/Lead AppDetail is open.
                    proPitchLink += '&kbyg=' + primaryInfo.ProposaltoolSecureId;
                } else {
                    proPitchLink += '&fundingRequestId=' + primaryInfo.FundingRequestSecureId;
                }
            }

            return proPitchLink;
        }
    }, {
        key: 'getHeroCalcLink',
        value: function getHeroCalcLink() {
            var heroCalcLink = '';

            heroCalcLink = this.HPConfig.heroCalcLink + '?token=' + this.AuthenticationFactory.getAuthenticationData().access_token;

            return heroCalcLink;
        }
    }, {
        key: 'getReportLink',
        value: function getReportLink(destination) {
            var _this = this;

            return this.$q(function (resolve) {
                _this.SingleSignOnFactory.getAuthorization().then(function (result) {
                    var reportLink = result.sfdc_community_url + '/secur/frontdoor.jsp';
                    reportLink += '?sid=' + result.access_token;
                    reportLink += '&retURL=' + result.sfdc_community_url + '/s/' + destination;
                    return resolve(reportLink);
                });
            });
        }
    }, {
        key: 'getOneAppLink',
        value: function getOneAppLink(contractorLocationId) {
            var _this2 = this;

            return this.$q(function (resolve) {
                _this2.KBYGFactory.getOneAppLink(contractorLocationId).then(function (result) {
                    return resolve(result.data.Data.Url);
                });
            });
        }
    }]);

    return PartnerAppsService;
}();

PartnerAppsService.$inject = ['HPConfig', '$q', 'AuthenticationFactory', 'SingleSignOnFactory', 'FundingRequestDatastore', 'UiDisplayFactory', 'KBYGFactory'];
exports.default = PartnerAppsService;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* @ngInject */
var SingleSignOnService = function () {
    function SingleSignOnService(HPConfig, $http, $q) {
        _classCallCheck(this, SingleSignOnService);

        this.HPConfig = HPConfig;
        this.$http = $http;
        this.$q = $q;
    }

    _createClass(SingleSignOnService, [{
        key: "getAuthorization",
        value: function getAuthorization() {
            var def = this.$q.defer();

            var url = this.HPConfig.heroProApi + "SingleSignOn/GetAccessToken";
            this.$http.post(url).then(function (resp) {
                def.resolve(resp.Data || resp.data);
            });

            return def.promise;
        }
    }]);

    return SingleSignOnService;
}();

SingleSignOnService.$inject = ["HPConfig", "$http", "$q"];
exports.default = SingleSignOnService;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FundingRequestService = function () {
    function FundingRequestService() {
        _classCallCheck(this, FundingRequestService);

        this.primaryInformation = {};
    }

    _createClass(FundingRequestService, [{
        key: "getPrimaryInformation",
        value: function getPrimaryInformation() {
            return this.primaryInformation;
        }
    }, {
        key: "setPrimaryInformation",
        value: function setPrimaryInformation(primaryInfo) {
            this.primaryInformation = primaryInfo;
        }
    }, {
        key: "clearPrimaryInformation",
        value: function clearPrimaryInformation() {
            this.primaryInformation = {};
        }
    }]);

    return FundingRequestService;
}();

exports.default = FundingRequestService;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SidebarService = function () {
    function SidebarService() {
        _classCallCheck(this, SidebarService);

        this.menuItems = [
        //     {
        //     name: 'Search',
        //     link: '/search',
        //     analyticsEvent: 'Search click',
        //     icon: 'icon-ra-search',
        //     pageName: 'search',
        //     displayFlag: 'showSearch',
        // },
        // {
        //     name: 'Dashboard',
        //     link: '/dashboard',
        //     analyticsEvent: 'Dashboard click',
        //     icon: 'icon-ra-dashboard',
        //     pageName: 'dashboard',
        //     displayFlag: 'showDashboard',
        // },
        // {
        //     name: 'Pipeline',
        //     link: '/pipeline/leads',
        //     analyticsEvent: 'Pipeline click',
        //     icon: 'icon-ra-pipeline',
        //     pageName: 'pipeline',
        //     displayFlag: 'showPipeline',
        // },
        // {
        //     name: 'Benji',
        //     link: '',
        //     analyticsEvent: 'Benji Portal click',
        //     icon: 'icon-ra-pipeline',
        //     pageName: 'benji',
        //     isEnabled: false,
        // },
        // {
        //     name: 'Product Lookup',
        //     link: '/product-lookup/directory/CA/',
        //     analyticsEvent: 'Product Lookup click',
        //     icon: 'icon-ra-product-lookup',
        //     pageName: 'product-lookup',
        //     displayFlag: 'showProductLookup'        
        // },
        // {
        //     name: 'Reports',
        //     link: 'sso/leadsummary',
        //     analyticsEvent: 'Reports Portal click',
        //     icon: 'icon-reports-thick',
        //     pageName: 'reports',
        //     isEnabled: true,
        // },
        // {
        //     name: 'Resources',
        //     link: '/resources',
        //     analyticsEvent: 'Resources click',
        //     icon: 'icon-ra-resources',
        //     pageName: 'resources',
        //     displayFlag: 'showResources',
        // },
        // {
        //     name: 'Certification',
        //     link: '/certification',
        //     analyticsEvent: 'Certification click',
        //     icon: 'icon-ra-certificate',
        //     pageName: 'certification',
        //     displayFlag: 'showCertification',
        // },
        {
            name: 'Account',
            link: '/accounts/myprofile/',
            analyticsEvent: 'Account click',
            icon: 'icon-ra-account',
            pageName: 'accounts',
            displayFlag: 'showAccounts'
        }];
    }

    _createClass(SidebarService, [{
        key: 'getSidebar',
        value: function getSidebar() {
            return this.menuItems;
        }
    }]);

    return SidebarService;
}();

exports.default = SidebarService;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* @ngInject */
var UserDataService = function () {
    function UserDataService(HPConfig, $http, $q) {
        _classCallCheck(this, UserDataService);

        this.HPConfig = HPConfig;
        this.$http = $http;
        this.$q = $q;
        this._ = _lodash2.default;

        this.goodStanding = true;
        this.profilePicture = '';
        this.currentLocation = null;
        this.kbygCurrentLocation = null;
        this.mainLocation = null;
        this.locationPromise = null;
        this.kbygLocationPromise = null;

        this.setupLocationPromise();
        this.setupKBYGLocationPromise();
    }

    _createClass(UserDataService, [{
        key: 'getUserData',
        value: function getUserData() {
            return this.$http.get(this.HPConfig.heroProApi + 'User', {
                cache: true
            }).then(function (response) {
                return response.data.Data;
            });
        }
    }, {
        key: 'getHISTrainingMandate',
        value: function getHISTrainingMandate() {
            return this.$http.get(this.HPConfig.heroProApi + 'ContractorUser/GetHISTrainingMandate', {
                cache: true
            }).then(function (response) {
                return response.data.Data;
            });
        }
    }, {
        key: 'getTrainingDaysRemaining',
        value: function getTrainingDaysRemaining(trainingExpDate) {
            var gpExpire = Date.parse(trainingExpDate);
            return Math.max(0, Math.floor((gpExpire - new Date()) / 86400000)) + 1;
        }
    }, {
        key: 'resetPromises',
        value: function resetPromises() {
            var that = this;
            return this.$q(function (resolve) {
                that.locationPromise = undefined;
                that.setupLocationPromise();
                that.kbygLocationPromise = undefined;
                that.setupKBYGLocationPromise();
                resolve();
            });
        }
    }, {
        key: 'getUserLocations',
        value: function getUserLocations() {
            return this.locationPromise;
        }

        // (ajt 11/16/2015) Add new KBYG location lookup.

    }, {
        key: 'getKBYGLocations',
        value: function getKBYGLocations() {
            return this.kbygLocationPromise;
        }
    }, {
        key: 'getCurrentLocation',
        value: function getCurrentLocation() {
            var _this = this;

            var that = this; // fix with =>

            return this.$q(function (resolve) {
                that.locationPromise.then(function () {
                    resolve(_this.currentLocation);
                });
            });
        }
        // (ajt 11/16/2015) Add support to get current KBYG location.

    }, {
        key: 'getCurrentKBYGLocation',
        value: function getCurrentKBYGLocation() {
            var _this2 = this;

            return this.$q(function (resolve) {
                _this2.kbygLocationPromise.then(function () {
                    resolve(_this2.kbygCurrentLocation);
                });
            });
        }
    }, {
        key: 'setCurrentLocation',
        value: function setCurrentLocation(newLocation) {
            this.currentLocation = newLocation;
        }
        // (ajt 6/3/2016) Add main location lookup.

    }, {
        key: 'getMainLocation',
        value: function getMainLocation() {
            var _this3 = this;

            return this.$q(function (resolve) {
                _this3.locationPromise.then(function () {
                    resolve(_this3.mainLocation);
                });
            });
        }

        // private functions

    }, {
        key: 'setupLocationPromise',
        value: function setupLocationPromise() {
            var _this4 = this;

            this.locationPromise = this.$http({
                url: this.HPConfig.heroProApi + 'Contractor/Location',
                method: 'GET',
                params: {
                    includeServiceStates: true,
                    contractorStatusList: [2, 3, 10, 11],
                    includeTermSets: true
                }
            }).then(function (response) {
                var locations = response.data.Data;
                if (locations.length === 1) {
                    _this4.currentLocation = locations[0];
                    if (locations[0].IsMaster) {
                        _this4.mainLocation = locations;
                    }
                    return locations;
                } else if (locations.length > 1) {
                    var muniIds = [];
                    _lodash2.default.each(locations, function (loc) {
                        if (loc.ServiceStateDetails && loc.ServiceStateDetails.length > 0) {
                            muniIds = muniIds.concat(loc.ServiceStateDetails);
                        }
                    });

                    var serviceStates = _lodash2.default.uniq(muniIds, function (muni) {
                        return muni.StateGeoId;
                    });
                    var financingProducts = _this4.constructor.getFinancingProducts(locations);

                    var allLocations = [{
                        ContractorId: '',
                        OrganizationId: locations[0].OrganizationId,
                        LocationNickname: 'All Locations',
                        CompanyName: locations[0].CompanyName,
                        Address: locations[0].Address,
                        City: locations[0].City,
                        State: locations[0].State,
                        Zip: locations[0].Zip,
                        LicenseNumber: locations[0].LicenseNumber,
                        AccountManager: locations[0].AccountManager,
                        ContractorNumber: locations[0].ContractorNumber,
                        ContractorStatusId: locations[0].ContractorStatusId,
                        OrganizationTermSets: locations[0].OrganizationTermSets,
                        ServiceStateDetails: serviceStates,
                        FinancingProducts: financingProducts
                    }];
                    _this4.currentLocation = allLocations[0];
                    _this4.mainLocation = _lodash2.default.filter(locations, function (location) {
                        return location.IsMaster;
                    });
                    return allLocations.concat(locations);
                }
                return null;
            });
        }
    }, {
        key: 'setupKBYGLocationPromise',
        value: function setupKBYGLocationPromise() {
            var _this5 = this;

            this.kbygLocationPromise = this.$http({
                url: this.HPConfig.heroProApi + 'Contractor/Location',
                method: 'GET',
                params: {
                    includeServiceStates: true,
                    contractorStatusList: [2, 3, 10, 11],
                    includeTermSets: true
                }
            }).then(function (response) {
                var locations = response.data.Data;
                var kbygLocations = [];
                if (locations.length === 1) {
                    kbygLocations = [{
                        ContractorId: locations[0].ContractorId,
                        OrganizationId: locations[0].OrganizationId,
                        LocationNickname: locations[0].LocationNickname,
                        CompanyName: locations[0].CompanyName,
                        Address: locations[0].Address,
                        City: locations[0].City,
                        State: locations[0].State,
                        Zip: locations[0].Zip,
                        LicenseNumber: locations[0].LicenseNumber,
                        ContractorStatusId: locations[0].ContractorStatusId,
                        AccountManager: locations[0].AccountManager,
                        OrganizationTermSets: locations[0].OrganizationTermSets
                    }];
                    _this5.kbygCurrentLocation = kbygLocations[0];
                    return locations;
                } else if (locations.length > 1) {
                    var masterFound = false;
                    // Find the Master location
                    for (var j = 0; j < locations.length; j += 1) {
                        if (locations[j].isMaster !== undefined && locations[j].isMaster === true) {
                            kbygLocations = [{
                                ContractorId: locations[j].ContractorId,
                                OrganizationId: locations[j].OrganizationId,
                                LocationNickname: locations[j].LocationNickname,
                                CompanyName: locations[j].CompanyName,
                                Address: locations[j].Address,
                                City: locations[j].City,
                                State: locations[j].State,
                                Zip: locations[j].Zip,
                                LicenseNumber: locations[j].LicenseNumber,
                                ContractorStatusId: locations[j].ContractorStatusId,
                                AccountManager: locations[j].AccountManager
                            }];
                            masterFound = true;
                        }
                    }
                    // If the master does not exist, default to the first location
                    if (masterFound !== true) {
                        kbygLocations = [{
                            ContractorId: locations[0].ContractorId,
                            OrganizationId: locations[0].OrganizationId,
                            LocationNickname: locations[0].LocationNickname,
                            CompanyName: locations[0].CompanyName,
                            Address: locations[0].Address,
                            City: locations[0].City,
                            State: locations[0].State,
                            Zip: locations[0].Zip,
                            LicenseNumber: locations[0].LicenseNumber,
                            ContractorStatusId: locations[0].ContractorStatusId,
                            AccountManager: locations[0].AccountManager
                        }];
                    }
                    // Add remaining locations to array
                    if (locations.length > 1) {
                        for (var i = 1; i < locations.length; i += 1) {
                            kbygLocations.push(locations[i]);
                        }
                    }

                    // Set current location
                    _this5.kbygCurrentLocation = kbygLocations[0];
                    return kbygLocations;
                }
                return null;
            });
        }
    }], [{
        key: 'getFinancingProducts',
        value: function getFinancingProducts(locations) {
            var uniqLocations = _lodash2.default.uniq(locations, function (location) {
                return location.FinancingProducts;
            });

            var financingProducts = uniqLocations === null ? null : uniqLocations[0].FinancingProducts;
            var missingProducts = [];
            _lodash2.default.each(uniqLocations, function (location) {
                missingProducts = _lodash2.default.difference(location.FinancingProducts, financingProducts);
                if (missingProducts && missingProducts.length > 0) {
                    financingProducts.concat(missingProducts);
                }
            });

            return financingProducts;
        }
    }]);

    return UserDataService;
}();

UserDataService.$inject = ['HPConfig', '$http', '$q'];
exports.default = UserDataService;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = coachmarkFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _hopscotch = __webpack_require__(157);

var _hopscotch2 = _interopRequireDefault(_hopscotch);

__webpack_require__(158);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

coachmarkFactory.$inject = ['$http', '$templateCache', '$analytics', 'localStorageService', '$window']; // angular
// .module("HeroPRO")
// .factory("coachmark", coachmarkFactory);


/* @ngInject */
function coachmarkFactory($http, $templateCache, $analytics, localStorageService, $window) {
    var templateMarkup = void 0,
        template = void 0;

    getCoachmarkMarkup();

    function getCoachmarkMarkup() {
        templateMarkup = $templateCache.get('app/common/coachmark/coachmarkDefaultTemplate.html');

        if (templateMarkup !== undefined) {
            template = _lodash2.default.template(templateMarkup);
        } else {
            $http.get('app/common/coachmark/coachmarkDefaultTemplate.html').then(function (templateMarkup) {
                template = _lodash2.default.template(templateMarkup.data);
            });
        }
    }

    function setCoachmarkTemplate() {
        _hopscotch2.default.templates.hpTemplate = function (data) {
            return template(data);
        };

        _hopscotch2.default.setRenderer('hpTemplate');
    }

    function hideActionItemButtonGroup() {
        var actionItemContextMenu = $window.document.querySelector('.action-item:first-child .btn-group');

        if (actionItemContextMenu !== null && actionItemContextMenu.classList) {
            actionItemContextMenu.classList.remove('open');
        }
    }

    function getTourConfig() {
        var steps = [];

        if (document.getElementById('navbar-brand-coach-target')) {
            steps.push({
                title: 'Switch between HERO and Benji',
                content: '<p>Easily switch between HERO and Benji by clicking the logo in the corner.</p>',
                target: '.navbar-brand',
                placement: 'right',
                xOffset: 60,
                yOffset: 50,
                onShow: function onShow() {
                    document.getElementById('navbar-brand-coach-target').click();
                },
                onNext: function onNext() {
                    localStorageService.set('lastCoachmarkViewed', _hopscotch2.default.getCurrStepNum());
                }
            });
        }

        steps.push({
            title: 'Contact Us',
            content: '<p>Have any questions? Our customer service experts are available to assist you.</p>',
            target: '.topNav-contact-info',
            placement: 'left',
            xOffset: -240,
            yOffset: 105,
            onShow: function onShow() {
                document.getElementById('topNav-contact-info-coach-target').click();
            },
            onNext: function onNext() {
                localStorageService.set('lastCoachmarkViewed', _hopscotch2.default.getCurrStepNum());
            }
        });

        steps.push({
            title: 'Account Details',
            content: '<p>This menu links to your account information.</p>',
            target: '.topNav-user-info',
            placement: 'left',
            xOffset: -260, // getUserDropdownXCoordinate(),
            yOffset: 57,
            onShow: function onShow() {
                document.getElementById('topNav-user-info-coach-target').click();
            },
            onNext: function onNext() {
                localStorageService.set('lastCoachmarkViewed', _hopscotch2.default.getCurrStepNum());
            }
        });

        steps.push({
            title: 'Company Pipeline',
            content: '<p>Here is a summary of your projects. Additional metrics are also provided to show you the health of your HERO pipeline.</p>',
            target: '.hp-module:nth-child(2) h1',
            placement: 'top',
            xOffset: 60,
            arrowOffset: 30
        });

        return {
            id: 'heropro-coachmark',
            i18n: {
                nextBtn: 'Got It'
            },
            customData: {
                dismissText: 'Skip this tour'
            },
            onEnd: function onEnd() {
                hideActionItemButtonGroup();

                localStorageService.set('preventAutoCoachmark', true);
                _hopscotch2.default.endTour(true);
            },
            onClose: function onClose() {
                hideActionItemButtonGroup();

                $analytics.eventTrack('Dismiss', { category: 'Coachmark', label: _hopscotch2.default.getCurrStepNum() + '/' + _hopscotch2.default.getCurrTour().steps.length });
                _hopscotch2.default.endTour(true);
            },
            onNext: function onNext() {
                localStorageService.set('lastCoachmarkViewed', _hopscotch2.default.getCurrStepNum());
            },

            steps: steps
        };
    }

    return {
        startCoachmarkTour: function startCoachmarkTour(autoStart) {
            if (autoStart) {
                if (!localStorageService.get('preventAutoCoachmark')) {
                    setCoachmarkTemplate();
                    _hopscotch2.default.startTour(getTourConfig(), localStorageService.get('lastCoachmarkViewed'));
                    $analytics.eventTrack('AutoShow', { category: 'Coachmark', label: _hopscotch2.default.getCurrStepNum() + '/' + _hopscotch2.default.getCurrTour().steps.length });
                }
            } else {
                setCoachmarkTemplate();
                _hopscotch2.default.startTour(getTourConfig());
                $analytics.eventTrack('Manual Launch', { category: 'Coachmark' });
            }
        },
        endCoachmarkTour: function endCoachmarkTour() {
            _hopscotch2.default.endTour(true);
            // Set preventAutoCoachmark to false since this function is only called when a user navigates to a different page
            localStorageService.set('preventAutoCoachmark', false);
        },
        getCurrTour: function getCurrTour() {
            return _hopscotch2.default.getCurrTour();
        }
    };
}

/***/ }),
/* 157 */,
/* 158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = directiveService;
function directiveService() {
    var listeners = [];
    return {
        subscribe: function subscribe(callback) {
            listeners.push(callback);
        },
        publish: function publish(msg) {
            angular.forEach(listeners, function (value) {
                value(msg);
            });
        }
    };
}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = progressIndicator;

__webpack_require__(161);

function progressIndicator() {
    var progressController = function progressController() {
        var vm = this;

        init();

        /*= =======================================
        =            Public Functions            =
        ======================================== */

        vm.click = function (step) {
            vm.clickHandler()(step);
        };

        /* -----  End of Public Functions  ------*/

        /*= =======================================
        =            Private Functions            =
        ======================================== */
        function init() {}
    };

    return {
        transclude: true,
        replace: true,
        restrict: 'E',
        scope: {
            progressSteps: '=',
            clickHandler: '&?'
        },
        require: '^form',
        template: __webpack_require__(162),
        // templateUrl: 'app/common/progressIndicator/desktop/desktopProgress.html',
        controller: progressController,
        controllerAs: 'progress',
        bindToController: true
    };
} // angular
// 	.module("HeroPRO")
// 	.directive('hpProgressIndicator', progressIndicator);

/***/ }),
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports = "<div class=\"desktop-progress-container\">\n    <div ng-repeat=\"step in progress.progressSteps\" class=\"desktop-progress-step-container\" ng-click=\"progress.click(step)\" ng-class=\"{'two-steps': progress.progressSteps.length === 2, 'three-steps': progress.progressSteps.length === 3, 'four-steps': progress.progressSteps.length === 4}\">\n        <div class=\"progress-step-outer-circle\"\n             ng-class=\"{'active' : step.isActive,'visited' : step.isVisited, 'completed' : step.isCompleted}\">\n            <div class=\"progress-step-inner-circle\"\n                 ng-class=\"{'active' : step.isActive,'visited' : step.isVisited, 'completed' : step.isCompleted}\">\n                <span class=\"icon icon-complete\"></span>\n            </div>\n        </div>\n        <div class=\"progress-connector\"\n             ng-class=\"{'start' : step.id === 0, 'end' : step.id === progress.progressSteps.length - 1, 'completed' : step.isCompleted}\"></div>\n        <div class=\"progress-step-title\" ng-bind=\"step.title\"\n             ng-class=\"{'active' : step.isActive, 'completed' : step.isCompleted, 'visited' : step.isVisited}\"></div>\n    </div>\n</div>\n\n";

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = hpLoggerService;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _stacktraceGps = __webpack_require__(164);

var _stacktraceGps2 = _interopRequireDefault(_stacktraceGps);

var _errorStackParser = __webpack_require__(172);

var _errorStackParser2 = _interopRequireDefault(_errorStackParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

hpLoggerService.$inject = ['HPConfig', 'HPLogging', '$injector', '$log']; // angular
// 	.module("HeroPRO")
// 	.service("hpLoggerService", hpLoggerService);

/* @ngInject */
function hpLoggerService(HPConfig, HPLogging, $injector, $log) {
    var $http = void 0,
        FundingRequestInfo = void 0,
        $location = void 0,
        $state = void 0,
        $window = void 0,
        $q = void 0,
        timeDelay = 60000,
        maxCacheSize = 100,
        cachedFrameworkErrors = [],
        cachedLogMessages = [],
        throttleSubmitFramework = _lodash2.default.throttle(submitFrameworkErrors, timeDelay),
        throttleSubmitMessages = _lodash2.default.throttle(submitPageErrors, timeDelay);

    var gps = new _stacktraceGps2.default();

    /*= ========================================
    =            Private Functions            =
    ========================================= */

    function submitFrameworkErrors() {
        var data = {
            LogItems: cachedFrameworkErrors
        };

        $http = $http || $injector.get('$http');
        var _url = HPConfig.heroProApi + 'Logging/Add';

        $http.post(_url, data);

        // Clear cache
        cachedFrameworkErrors = [];
    }

    function submitPageErrors() {
        var data = {
            LogItems: cachedLogMessages
        };

        $http = $http || $injector.get('$http');
        var _url = HPConfig.heroProApi + 'Logging/Add';

        $http.post(_url, data);

        // Clear cache
        cachedLogMessages = [];
    }

    function logMessage(logLevel, message, controllerName, methodName, uiState) {
        $location = $location || $injector.get('$location');
        $state = $state || $injector.get('$state');
        $window = $window || $injector.get('$window');

        var parameterPayload = {
            DateLogged: new Date(),
            Exception: message.stack !== undefined && message.stack !== null ? message.stack.toString() : 'No Exception Text',
            Route: $location.path(),
            UserAgent: $window.navigator.userAgent
        };

        var methodParams = {};

        methodParams.Name = controllerName + '::' + methodName;
        methodParams.Params = uiState ? uiState : null;

        // (ajt 8/8/2016) - Only load state for app-detail route
        if ($state.includes('app-detail')) {
            // (ajt 8/8/2016) - Inject or use FRInformationFactory, Location service, or ui-router State service
            FundingRequestInfo = FundingRequestInfo || $injector.get('FRInformationFactory');

            var stateData = FundingRequestInfo.getStateMachineData();
            var appInfo = FundingRequestInfo.getAppInfo();

            parameterPayload.StateMachine = Object.keys(stateData).length !== 0 ? stateData : 'No State Information';
            parameterPayload.ApplicationInfo = Object.keys(appInfo).length !== 0 ? appInfo : 'No Application Information';

            // (ajt 8/8/2016) - Extend existing UI logging params with Application & State data
            _lodash2.default.extend(methodParams.Params, parameterPayload);
        }

        var logItem = {
            SourceApplicationName: 'RA.Web.HEROPro',
            Message: message.toString(),
            LogLevel: logLevel, // HPLogging.LogLevel.Error,
            MethodParameters: methodParams
        };

        cachedLogMessages.push(logItem);

        if (cachedLogMessages.length > maxCacheSize) {
            submitPageErrors();
        } else {
            throttleSubmitMessages();
        }
    }

    function _generateSourceMapStackTraceErrors(messageStack) {
        var _arguments = arguments;


        $q = $q || $injector.get("$q");

        return $q(function (resolve, reject) {
            var stackFrames = _errorStackParser2.default.parse({ stack: messageStack });
            var newFrames = new Array(stackFrames.length);
            var frameResolved = 0;
            stackFrames.forEach(function (stackFrame, i) {
                gps.pinpoint(stackFrame).then(function (newFrame) {
                    newFrames[i] = newFrame;
                    frameResolved++;

                    if (frameResolved === stackFrames.length) {
                        var newFrameStrings = newFrames.map(function (frame) {
                            return frame.toString();
                        });
                        resolve(newFrameStrings.join("\n"));
                    }
                }, function () {
                    reject(_arguments);
                });
            });
        });
    }

    /* -----  End of Private Functions  ------*/

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    // Method used in exceptionHandler wrapper to cache and log errors from the framework.
    this.frameworkError = function createFrameworkError(message) {
        $location = $location || $injector.get('$location');
        $state = $state || $injector.get('$state');
        $window = $window || $injector.get('$window');

        // (ajt - 5/5/2016) This step allows error to be logged to console. Remove if errors should be 'swallowed' by the service.
        $log.error(message);

        if (!message.stack) {
            return;
        }

        _generateSourceMapStackTraceErrors(message.stack).then(function (sourceMapsStackTrace) {

            var parameterPayload = {
                DateLogged: new Date(),
                StackTrace: sourceMapsStackTrace,
                Exception: message.stack.toString(),
                Route: $location.path(),
                UserAgent: $window.navigator.userAgent
            };

            // (ajt 8/8/2016) - Only load state for app-detail route
            if ($state.includes('app-detail')) {
                // (ajt 8/8/2016) - Inject or use FRInformationFactory, Location service, or ui-router State service
                FundingRequestInfo = FundingRequestInfo || $injector.get('FRInformationFactory');

                var stateData = FundingRequestInfo.getStateMachineData();
                var appInfo = FundingRequestInfo.getAppInfo();

                parameterPayload.StateMachine = Object.keys(stateData).length !== 0 ? stateData : 'No State Information';
                parameterPayload.ApplicationInfo = Object.keys(appInfo).length !== 0 ? appInfo : 'No Application Information';
            }

            var methodParams = {};

            methodParams.Name = 'ExceptionHandler';
            methodParams.Params = parameterPayload;

            var logItem = {
                SourceApplicationName: 'RA.Web.HEROPro',
                Message: message.toString(),
                StackTrace: sourceMapsStackTrace,
                LogLevel: HPLogging.LogLevel.Error,
                MethodParameters: methodParams
            };

            cachedFrameworkErrors.push(logItem);

            if (cachedFrameworkErrors.length > maxCacheSize) {
                submitFrameworkErrors();
            } else {
                throttleSubmitFramework();
            }
        }).catch(function (err) {
            return console.log(err);
        });
    };

    // Method used to log errors generated within a page.
    this.error = function (message, controllerName, methodName, uiState) {
        logMessage(HPLogging.LogLevel.Error, message, controllerName, methodName, uiState);
    };

    // Method used to log informational messages generated in a page controller.
    this.info = function (message, controllerName, methodName, uiState) {
        logMessage(HPLogging.LogLevel.Info, message, controllerName, methodName, uiState);
    };
}

/***/ }),
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = MainController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _psl = __webpack_require__(174);

var psl = _interopRequireWildcard(_psl);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

MainController.$inject = ['$q', '$http', '$scope', '$window', '$location', '$state', '$rootScope', '$analytics', '$uibModal', 'HPConfig', 'UserData', 'Timestamp', 'raSpinnerService', 'coachmark', 'HPRoles', 'ModalService', 'UserAuthFactory', 'AuthenticationFactory', 'FundingRequestDatastore', 'UiDisplayFactory', 'PartnerAppsFactory', 'TopNavFactory', 'BenjiUserFactory', 'PermissionsFactory', 'document', '$transitions', 'HISWizardFactory']; // angular
//     .module("HeroPRO")
//     .controller("MainController", MainController);

function clearTempAuthCookie() {
    var domain = '.' + psl.parse(window.location.hostname);
    document.cookie = 'copo_token=;domain=' + domain + ';expires=' + new Date(0).toUTCString();
}

function getCookie(cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(';');

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = cookieArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var cookie = _step.value;

            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(name) === 0) {
                return cookie.substring(name.length, cookie.length);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return '';
}

/* @ngInject */
function MainController($q, $http, $scope, $window, $location, $state, $rootScope, $analytics, $uibModal, HPConfig, UserData, Timestamp, raSpinnerService, coachmark, HPRoles, ModalService, UserAuthFactory, AuthenticationFactory, FundingRequestDatastore, UiDisplayFactory, PartnerAppsFactory, TopNavFactory, BenjiUserFactory, PermissionsFactory, document, $transitions, HISWizardFactory) {
    var vm = this;

    // Check the URL for a token
    var token = getCookie('copo_token');
    if (token) {
        clearTempAuthCookie();
        AuthenticationFactory.setAuthenticationData({ access_token: token });
    }

    // Health check used to show a blank page while checking authentication
    vm.isAuthorized = false;
    $http.get(HPConfig.heroProApi + 'HealthChecks/AuthorizedPing').then(function () {
        vm.isAuthorized = true;
    });

    vm.hisTrainingMandate = {};
    vm.forceHIStraining = false;

    vm.HPConfig = HPConfig;
    vm.locationId = 0;

    vm.showSidebar = true;
    vm.isBenjiOnlyUser = false;
    vm.shouldBenjiRedirect = false;
    vm.currentYear = new Date().getFullYear();

    UiDisplayFactory.setDisplayRule('isBenjiUser', false);
    UiDisplayFactory.setDisplayRule('isBenjiOnlyUser', false);

    vm.showSpinner = true;

    if ($window.sessionStorage.getItem('showSpecialNotice') === null) {
        $window.sessionStorage.setItem('showSpecialNotice', true);
    }

    var targetDate = new Date('2019-01-01');
    function targetDateHasPassed() {
        return new Date() >= targetDate;
    }

    var showSpecialNoticeModal = function showSpecialNoticeModal() {
        var today = new Date();
        var limitDate = new Date(2019, 0, 1);

        // UserData.getUserLocations().then((userLocations) => {
        //     const isCaliforniaUser = _.some(userLocations, location => location.State === 'CA');
        //     if (isCaliforniaUser === true) {
        //         if ($window.sessionStorage.getItem('showSpecialNotice') !== null && $window.sessionStorage.getItem('showSpecialNotice') === 'true') {

        //          if(targetDateHasPassed())
        //          return;
        //             ModalService.launchLgModal({
        //                 templateUrl: 'app/common/specialNotice/specialNotice.html',
        //                 windowClass: 'kbyg-modal specialNotice-modal',
        //                 controller: 'MainController',
        //                 controllerAs: 'main',
        //             });
        //             $window.sessionStorage.setItem('showSpecialNotice', false);
        //         }
        //     }
        // });
    };

    var closeSpecialNoticeModal = function closeSpecialNoticeModal(buttonClicked) {
        if (buttonClicked) {
            $analytics.eventTrack('AB1284 Click', { category: 'Special Notice' });
        } else {
            $analytics.eventTrack('AB1284 Exit', { category: 'Special Notice' });
        }
        ModalService.closeLgModal();
    };
    vm.closeSpecialNotice = closeSpecialNoticeModal;

    $scope.$on('ShowMainSpinner', function () {
        vm.showSpinner = true;
    });

    $scope.$on('HideMainSpinner', function () {
        vm.showSpinner = false;
        // leaving this commented out for future reference of where
        // to pop the special notice
        showSpecialNoticeModal();
    });

    vm.startCoachmarkTour = function () {
        coachmark.startCoachmarkTour(false);
    };

    $scope.$on('HPErrorUnauthorized', function () {
        // If the current URL contains httpError, don't set that as the returnURL on the login page. Set it to /dashboard instead.
        var returnURL = $window.location.href;
        var indexOfHttpError = returnURL.toLowerCase().indexOf('httperror');
        if (indexOfHttpError !== -1) {
            returnURL = returnURL.substring(0, indexOfHttpError) + 'dashboard';
        }
        if (vm.isAuthorized) {
            $window.location.href = HPConfig.heroProLoginLink + '?SessionTimeout=true&ReturnUrl=' + encodeURIComponent(returnURL);
        } else {
            $window.location.href = HPConfig.heroProLoginLink + '?&ReturnUrl=' + encodeURIComponent(returnURL);
        }
    });

    $scope.$on('HPErrorForbidden', function () {
        $window.location.href = HPConfig.heroProLink;
    });

    $scope.$on('HPErrorNotFound', function (event, data) {
        $location.path('/httpError/' + data.status);
    });

    $scope.$on('HPErrorServer', function (event, data) {
        vm.showSpinner = false;
        $location.path('/httpError/' + data.status + '/' + data.headerRACtx.ti);
    });

    $scope.$on('HPErrorUnknown', function (event, data) {
        if (data.headerRACtx.ti !== null) {
            $location.path('/httpError/' + data.status + '/' + data.headerRACtx.ti);
        } else {
            $location.path('/httpError/' + data.status);
        }
    });

    $scope.$on('officesUpdated', loadLocations);

    $scope.$on('RefreshPermissions', function () {
        PermissionsFactory.getPermissions({ fetchNewData: true });
    });

    function updateLocation(event, userLocation) {
        var oldLocation = vm.currentLocation;
        vm.currentLocation = userLocation;
        UserData.setCurrentLocation(userLocation);
        UiDisplayFactory.setDisplayData(vm.currentLocation);

        $rootScope.$broadcast('HPLocationChange', userLocation, function () {
            vm.currentLocation = oldLocation;
            UserData.setCurrentLocation(oldLocation);
        });

        $analytics.eventTrack('Location Change', { category: 'TopNav', label: $location.url() + ':' + userLocation.LocationNickname });
    }
    vm.updateLocation = updateLocation;

    function onStateChangeStart(transitionEvent) {
        var toState = transitionEvent.$to();
        var fromState = transitionEvent.$from();

        // Don't process this function if the fromState and toState is an error page.
        // This prevents an infinite loop of errors from occuring.
        if (fromState.name.indexOf('httpError') === -1 && toState.name.indexOf('httpError') === -1) {
            UserAuthFactory.getAuthorization().then(function (result) {
                // AdvancedRegistrationStatus -- 0 = None -- 2 = Completed
                if (result.AdvancedRegistrationStatus !== '0' && result.AdvancedRegistrationStatus !== '2') {
                    // Process advanced reg in HEROPro
                    $rootScope.$broadcast('loadNotifications');
                } else if (vm.forceHISTraining) {
                    vm.showSpinner = false;
                    HISWizardFactory.openHISWizardModal(true);
                } else {
                    // Advanced reg status is good, but Terms and Conditions need to be signed.
                    UserData.getCurrentLocation().then(function (currentLocation) {
                        UserAuthFactory.getRegistrationInfo(currentLocation.LicenseNumber).then(function (response) {
                            if (response.data.ShouldSignTC) {
                                vm.showSpinner = false;
                                $uibModal.open({
                                    templateUrl: 'app/common/specialNotice/shouldSignTC.html',
                                    keyboard: false,
                                    size: 'full-screen',
                                    controller: 'MainController',
                                    controllerAs: 'main',
                                    animation: false
                                });
                            } else {
                                $rootScope.$broadcast('loadNotifications');
                            }
                        });
                    });
                }
            });
        }
    }

    $transitions.onStart({}, onStateChangeStart);

    function trackPageEvent(toState, toParams) {
        var myurl = toState.self.url;

        for (var param in toParams) {
            if (param) {
                myurl = myurl.replace(':' + param, toParams[param]);
            }
        }

        UserData.getCurrentLocation().then(function (data) {
            $analytics.setUserProperties({ dimension1: data.ContractorNumber }); // RACNumber
            $analytics.setUserProperties({ dimension2: data.OrganizationId }); // organizationID
            $analytics.pageTrack(myurl);
        });
    }

    function onStateChangeSuccess(transitionEvent) {
        var toState = transitionEvent.$to();

        // Capture the state change time and store it in the timestamp factory
        Timestamp.setTimestamp('stateChangeTimestamp');

        // Log the page event to Google Analytics
        trackPageEvent(toState, toState.params);

        // Unregister all existing spinners
        raSpinnerService.unregisterAll();

        // Clear Loaded Record
        FundingRequestDatastore.clearPrimaryInformation();

        // Find the existing coachmark tour and end it
        if (coachmark.getCurrTour() !== undefined && coachmark.getCurrTour() !== null) {
            coachmark.endCoachmarkTour();
        }
    }
    $transitions.onSuccess({}, onStateChangeSuccess);

    function isPageActive(viewLocation) {
        return viewLocation === $state.current.name;
    }
    vm.isPageActive = isPageActive;

    function checkForBenji() {
        if (!vm.userData || !vm.userLocations) {
            return;
        }

        // Add RA Employee condition
        if (!_lodash2.default.contains(vm.userData.Roles, HPRoles.COPO_COMPANY_ADMIN.Name) && !_lodash2.default.contains(vm.userData.Roles, HPRoles.COPO_COMPANY_MGR.Name) && !_lodash2.default.contains(vm.userData.Roles, HPRoles.COPO_ADMIN.Name) && !_lodash2.default.contains(vm.userData.Roles, HPRoles.COPO_MGR.Name) && !_lodash2.default.contains(vm.userData.Roles, HPRoles.COPO_REP.Name) && !_lodash2.default.contains(vm.userData.Roles, HPRoles.COPO_PROJECT_REP.Name) && !_lodash2.default.contains(vm.userData.Roles, HPRoles.COPO_RAEMPLOYEE.Name)) {
            return;
        }

        // Check if the user is selling Benji in any of their locations
        var isBenjiUser = _lodash2.default.some(vm.userLocations, function (location) {
            return location.FinancingProducts !== undefined && location.FinancingProducts !== null && location.FinancingProducts.indexOf('BENJI') !== -1;
        });

        if (isBenjiUser === true) {
            UiDisplayFactory.setDisplayRule('isBenjiUser', true);
        }

        // Check if the user is only selling Benji in all of their locations
        vm.isBenjiOnlyUser = true; //6/24/21 - HERO Pro should think everyone is always just Benji, even when they have an LP record in addition to Benji at this point.  This was broke in Prod on Deployment night.  //_.every(vm.userLocations, location => location.FinancingProducts !== undefined && location.FinancingProducts !== null && location.FinancingProducts.length === 1 && location.FinancingProducts.indexOf('BENJI') !== -1);

        if (vm.isBenjiOnlyUser === true) {
            UiDisplayFactory.setDisplayRule('isBenjiOnlyUser', true);

            vm.showSidebar = false;

            BenjiUserFactory.setIsBenjiUserOnly(vm.isBenjiOnlyUser).doNotRedirectOnAccountPages();
        }
    }

    function loadLocations() {
        return UserData.getUserLocations().then(function (response) {
            vm.userLocations = response;
        });
    }

    UserData.getUserData().then(function (response) {
        vm.userData = response;
        if (vm.userData && vm.userData.ContractorUserId) {
            $analytics.setUserProperties({ dimension3: vm.userData.ContractorUserId }); // contractorUserID
            $analytics.setUsername(vm.userData.ContractorUserId); // contractorUserID
        }

        UiDisplayFactory.setDisplayRule('suspendedCompliance', vm.userData.IsSuspendedCompliance);

        loadLocations().then(function () {
            checkForBenji();

            // Check if we need to force HIS training modal
            UserData.getHISTrainingMandate().then(function (response) {
                vm.hisTrainingMandate = response;
                if (vm.hisTrainingMandate.IsTrainingRequired || vm.hisTrainingMandate.IsLicenseEntryRequired) {
                    var today = new Date();
                    var gpExpire = Date.parse(vm.hisTrainingMandate.TrainingRequiredBy);
                    if (gpExpire - today < 0) {
                        vm.forceHISTraining = true;
                        HISWizardFactory.openHISWizardModal(true);
                    }
                } else if (vm.hisTrainingMandate.IsLicenseSuspended || vm.hisTrainingMandate.IsLicenseExpired) {
                    vm.forceHISTraining = true;
                    HISWizardFactory.openHISWizardModal(true);
                }
            });

            UserData.getCurrentLocation().then(function (currentLocation) {
                vm.currentLocation = currentLocation;

                UiDisplayFactory.setDisplayData(vm.currentLocation);

                if (PermissionsFactory.hasPermission('Coqr.LinkEnabled')) {
                    UiDisplayFactory.setDisplayRule('showCoQR', true);
                }
            });
        });
    });

    vm.benjiLinkClick = function (newWindow) {
        if (newWindow === true) {
            $window.open(PartnerAppsFactory.getBenjiLink(), '_blank');
        } else {
            $window.location.href = PartnerAppsFactory.getBenjiLink();
        }
    };

    vm.applicationClick = function () {
        var contractorId = vm.currentLocation.ContractorId;
        // More than one location and "All Locations" is selected, then get the first location in the list (i.e. the main location)
        if (contractorId === '' && vm.userLocations.length > 1) {
            contractorId = vm.userLocations[1].ContractorId;
        }
        var newWindow = $window.open('');
        PartnerAppsFactory.getOneAppLink(contractorId).then(function (result) {
            newWindow.location = result + '&BLS=HEROPortal';
        });
    };
}

/***/ }),
/* 174 */,
/* 175 */,
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(177);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* @ngInject */
var SidebarController = function () {
    function SidebarController($scope, UiDisplayFactory, SidebarFactory, $state, PermissionsFactory, $rootScope, UserData) {
        var _this = this;

        _classCallCheck(this, SidebarController);

        this.$state = $state;
        this.UiDisplayFactory = UiDisplayFactory;
        this.SidebarFactory = SidebarFactory;
        this.PermissionsFactory = PermissionsFactory;

        this.navItems = [];
        this.prevNavItems = [];
        this.toggleSidebar = null;
        this.showReports = false;
        this.init();

        $scope.$on('UpdateDisplay', function () {
            var rules = _this.UiDisplayFactory.getDisplayRules();
            if (rules.showFullSidebar !== _this.toggleSidebar) {
                _this.navItems = [];
                _lodash2.default.delay(function () {
                    var sidebarItems = _lodash2.default.map(_this.SidebarFactory.getSidebar(), _lodash2.default.clone);
                    _lodash2.default.each(sidebarItems, function (item) {
                        _this.configureSidebarItem(item, rules);
                        if (item.pageName.toLowerCase() === 'benji') {
                            item.isEnabled = rules.isBenjiUser;
                        }
                        if (item.isEnabled) {
                            _this.navItems.push(item);
                        }
                    });
                    _this.toggleSidebar = rules.showFullSidebar;
                    _this.prevNavItems = angular.copy(_this.navItems);

                    /* Remove this code to enable OH product lookup */
                    UserData.getUserLocations().then(function (response) {
                        if (response.every(function (item) {
                            return item.State === 'OH';
                        })) {
                            _this.removeProductLookUpFromMenu();
                        }
                    });
                });
            }
        });

        /* Remove this code to enable OH product lookup */
        $rootScope.$on('HPLocationChange', function (event, data) {
            if (data.State === 'OH') {
                _this.removeProductLookUpFromMenu();
            } else {
                _this.navItems = _this.prevNavItems;
            }
        });
    }

    /* Remove this code to enable OH product lookup */


    _createClass(SidebarController, [{
        key: 'removeProductLookUpFromMenu',
        value: function removeProductLookUpFromMenu() {
            this.navItems = this.navItems.filter(function (item) {
                return item.pageName !== 'product-lookup';
            });
        }
    }, {
        key: 'isPageActive',
        value: function isPageActive(viewLocation) {
            return viewLocation === this.$state.current.name;
        }

        // private functions

    }, {
        key: 'init',
        value: function init() {
            if (this.PermissionsFactory.hasPermission('LeadSummary.LinkEnabled')) {
                this.UiDisplayFactory.setDisplayRule('showReports', true);
                this.showReports = this.UiDisplayFactory.getDisplayRules().showReports;
            }
        }
    }, {
        key: 'configureSidebarItem',
        value: function configureSidebarItem(item, rules) {
            _lodash2.default.each(rules, function (rule, key) {
                if (item.displayFlag === key) {
                    item.isEnabled = rule;
                }
            });
        }
    }]);

    return SidebarController;
}();

SidebarController.$inject = ['$scope', 'UiDisplayFactory', 'SidebarFactory', '$state', 'PermissionsFactory', '$rootScope', 'UserData'];
exports.default = SidebarController;

/***/ }),
/* 177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(179);

__webpack_require__(180);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } // angular.module("HeroPRO").controller("TopNavController", TopNavController);
// import moment from "moment";


/* @ngInject */
var TopNavController = function TopNavController($window, $document, HPConfig, $state, $analytics, ModalService, UserAuthFactory, $scope, UiDisplayFactory, TopNavFactory, authenticationService, PartnerAppsFactory, SidebarFactory, moment, PermissionsFactory) {
    _classCallCheck(this, TopNavController);

    var vm = this;

    vm.isPopoverOpen = false;
    vm.isCollapsed = true;
    vm.navClass = '';
    vm.navItems = [];

    // (ajt 5/24/2016) Booleans to control element display on UI
    vm.showTopNav = false;
    vm.showCSLB = false;
    vm.showBenji = false;
    vm.benjiLink = PartnerAppsFactory.getBenjiLink();
    vm.showNavBar = showNavBar;
    vm.logout = logout;
    vm.openUserInfoDropDown = openUserInfoDropDown;
    vm.contactDropdownClick = contactDropdownClick;
    vm.kbygClick = kbygClick;
    vm.applicationClick = applicationClick;
    vm.coQRClick = coQRClick;
    vm.isPageActive = isPageActive;
    vm.showCoQR = false;
    vm.toolClick = toolClick;
    vm.proposalTools = ['Calculator', 'Proposal Plus'];
    vm.userInfoPopoverIsOpen = false;
    vm.contactInfoPopoverIsOpen = false;
    vm.proposalPopoverIsOpen = false;
    vm.proposalPlusEnabled = PermissionsFactory.hasPermission('ProposalPlus.Enabled');
    vm.isSolicitor = PermissionsFactory.hasPermission('IsSolicitor');
    vm.isAdvertiser = PermissionsFactory.hasPermission('IsAdvertiser');

    function showNavBar() {
        vm.isCollapsed = !vm.isCollapsed;
        if (vm.isCollapsed) {
            vm.navClass = '';
        } else {
            vm.navClass = 'topNav-collapse';
        }
    }

    function logout() {
        $analytics.eventTrack('Logout', {
            category: 'TopNav',
            label: $state.current.name
        });

        TopNavFactory.logout().then(function () {
            // (ajt 3/23/16) PBI 414 Implement IDV validation
            authenticationService.logOut();

            UserAuthFactory.deleteAuthorization();

            var logoutUrl = HPConfig.heroProLoginLink;

            logoutUrl += '?logout=true';

            $window.location.href = logoutUrl;
        });
    }

    function proPitchClick() {
        $window.open(PartnerAppsFactory.getProPitchLink(), '_blank');
    }

    function heroCalculatorClick() {
        $analytics.eventTrack('Calculator Open', {
            category: 'TopNav',
            label: $state.current.name
        });
        $window.open(PartnerAppsFactory.getHeroCalcLink(), '_blank');
    }

    function toolClick(toolName) {
        switch (toolName.toLowerCase()) {
            case 'proposal plus':
                proPitchClick();
                break;
            case 'calculator':
                heroCalculatorClick();
                break;
            default:
                break;
        }
    }

    function openUserInfoDropDown(open) {
        if (open) {
            $analytics.eventTrack('User details Shown', {
                category: 'TopNav',
                label: $state.current.name
            });
        }
    }

    function contactDropdownClick(open) {
        if (open) {
            $analytics.eventTrack('Contact Dropdown Shown', {
                category: 'TopNav',
                label: $state.current.name
            });
        }
    }

    function kbygClick() {
        $analytics.eventTrack('KBYG Open', {
            category: 'TopNav',
            label: $state.current.name
        });
        ModalService.launchLgModal({
            templateUrl: 'app/lead/kbyg/modal/KBYGModalTemplate.html',
            windowClass: 'kbyg-modal',
            controller: 'KBYGModalController',
            controllerAs: 'kbygModal'
        });
    }

    function applicationClick() {
        $analytics.eventTrack('Application Open', {
            category: 'TopNav',
            label: $state.current.name
        });
    }

    function coQRClick(username, organizationId) {
        var today = moment().local().format();

        $analytics.eventTrack('COQR Open', {
            category: 'TopNav',
            label: JSON.stringify({
                username: username,
                date: today,
                organizationId: organizationId
            })
        });
    }

    function isPageActive(viewLocation) {
        return viewLocation === $state.current.name;
    }

    function configureSidebarItem(item, rules) {
        _lodash2.default.each(rules, function (rule, key) {
            if (item.displayFlag === key) {
                item.isEnabled = rule;
            }
        });
    }

    // prevent scroll when popovers are open on tablet and lower (SDM - Don't hate me for this.)
    $scope.$watch(function () {
        return vm.isPopoverOpen;
    }, function (current) {
        if ($window.outerWidth <= 992) {
            if (current === true) {
                angular.element($document).find('body').css('overflow', 'hidden');
            } else {
                angular.element($document).find('body').css('overflow', 'auto');
            }
        }
    });

    $scope.$on('UpdateDisplay', function () {
        // (ajt - 5/26/2016) TODO: Remove delay if the rules processing can be performed synchronously.
        _lodash2.default.defer(function () {
            var rules = UiDisplayFactory.getDisplayRules();
            vm.showBenji = rules.isBenjiUser;
            vm.isBenjiOnlyUser = rules.isBenjiOnlyUser;
            vm.showApply = rules.showApply;
            vm.showKbyg = rules.showKbyg;
            vm.showProposal = rules.showProposal && vm.proposalPlusEnabled === true;
            vm.showContact = rules.showContact;
            vm.showPersonalInfo = rules.isBenjiOnlyUser ? false : rules.showPersonalInfo;
            vm.showTopNavLocation = !rules.isBenjiOnlyUser;
            vm.backToProjects = rules.isBenjiOnlyUser;
            vm.showCSLB = rules.showCSLB;
            vm.showTopNav = true;
            vm.showCoQR = rules.showCoQR;

            // setup nav items (COPIED FROM SIDEBAR CONTROLLER - REFACTOR Opportunity? -> Propably in the factory itself...)
            vm.navItems = [];
            _lodash2.default.delay(function () {
                var sidebarItems = _lodash2.default.map(SidebarFactory.getSidebar(), _lodash2.default.clone);
                _lodash2.default.each(sidebarItems, function (item) {
                    configureSidebarItem(item, rules);
                    if (item.pageName.toLowerCase() === 'benji') {
                        item.isEnabled = rules.isBenjiUser;
                    }
                    if (item.isEnabled) {
                        vm.navItems.push(item);
                    }
                });
            });
        });
    });

    // when changing window size manually reset popover to close
    angular.element($window).on('resize', function () {
        vm.isPopoverOpen = false;
    });
};

TopNavController.$inject = ['$window', '$document', 'HPConfig', '$state', '$analytics', 'ModalService', 'UserAuthFactory', '$scope', 'UiDisplayFactory', 'TopNavFactory', 'authenticationService', 'PartnerAppsFactory', 'SidebarFactory', 'moment', 'PermissionsFactory'];
TopNavController.$inject = ['$window', '$document', 'HPConfig', '$state', '$analytics', 'ModalService', 'UserAuthFactory', '$scope', 'UiDisplayFactory', 'TopNavFactory', 'authenticationService', 'PartnerAppsFactory', 'SidebarFactory', 'moment', 'PermissionsFactory'];
exports.default = TopNavController;


TopNavController.$inject = ['$window', '$document', 'HPConfig', '$state', '$analytics', 'ModalService', 'UserAuthFactory', '$scope', 'UiDisplayFactory', 'TopNavFactory', 'authenticationService', 'PartnerAppsFactory', 'SidebarFactory', 'moment', 'PermissionsFactory'];

/***/ }),
/* 179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = SSOController;

__webpack_require__(182);

SSOController.$inject = ['PartnerAppsFactory', '$window', '$stateParams']; // angular
// 	.module("HeroPRO")
// 	.controller("SSOController", SSOController);

/* @ngInject */
function SSOController(PartnerAppsFactory, $window, $stateParams) {
    init();

    function init() {
        PartnerAppsFactory.getReportLink($stateParams.destination).then(function (link) {
            $window.location.href = link;
        });
    }
}

/***/ }),
/* 182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(184);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } // angular
//     .module("HeroPRO")
//     .controller("ContactInfoController", ContactInfoController);


/* @ngInject */
var ContractInfoController = function ContractInfoController(UserData, TopNavFactory) {
    var _this = this;

    _classCallCheck(this, ContractInfoController);

    var vm = this; // switch to => case don't need to do this anymore (PUN)

    vm.contactInfo = { phone: null, callHours: null }; // Added to prevent trying to read contactInfo off undefined object.

    TopNavFactory.getContactHours().then(function (response) {
        var hours = response.data.Data;

        vm.contactInfo = {
            phone: '844-722-7759',
            callHours: hours
        };
    });

    UserData.getCurrentLocation().then(function (response) {
        if (response.ContractorStatusId === 10) {
            _this.contactInfo.phone = '844-928-8327';
        }
    });
};

ContractInfoController.$inject = ['UserData', 'TopNavFactory'];
exports.default = ['UserData', 'TopNavFactory', ContractInfoController];

/***/ }),
/* 184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = StartProjectController;
StartProjectController.$inject = ['$window', '$state', '$analytics', 'ModalService', 'HPConfig', 'coachmark', '$timeout', 'PartnerAppsFactory', 'PermissionsFactory', '$location'];

/* @ngInject */
function StartProjectController($window, $state, $analytics, ModalService, HPConfig, coachmark, $timeout, PartnerAppsFactory, PermissionsFactory, $location) {
    var vm = this;
    vm.kbygClick = kbygClick;
    vm.applicationClick = applicationClick;
    vm.proPitchClick = proPitchClick;
    vm.mapClick = mapClick;
    vm.isSolicitor = PermissionsFactory.hasPermission('IsSolicitor');
    vm.isAdvertiser = PermissionsFactory.hasPermission('IsAdvertiser');

    autoKBYG();
    // (ajt - 7/26/2016) TODO: Move this code to any additional Dashboard panel with async call.
    if ($window.innerWidth >= HPConfig.screenSizes.screen_md) {
        $timeout(function () {
            coachmark.startCoachmarkTour(true);
        });
    }

    function kbygClick() {
        $analytics.eventTrack('KBYG Open', { category: 'StartProject', label: $state.current.name });
        ModalService.launchLgModal({
            templateUrl: 'app/lead/kbyg/modal/KBYGModalTemplate.html',
            windowClass: 'kbyg-modal',
            controller: 'KBYGModalController',
            controllerAs: 'kbygModal'
        });
    }

    // openKYBG
    function autoKBYG() {
        if ($location.search().openKBYG !== undefined) {
            kbygClick();
        }
    }

    function mapClick() {
        $analytics.eventTrack('Map Open', { category: 'StartProject', label: $state.current.name });
    }

    function applicationClick() {
        $analytics.eventTrack('Application Open', { category: 'StartProject', label: $state.current.name });
    }

    function proPitchClick() {
        $analytics.eventTrack('Proposal Open', { category: 'StartProject', label: $state.current.name });
        $window.open(PartnerAppsFactory.getProPitchLink(), '_blank');
    }
}

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = RouteConfig;
RouteConfig.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider', '$analyticsProvider'];
/* @ngInject */
function RouteConfig($stateProvider, $urlRouterProvider, $locationProvider, $analyticsProvider) {
    // (ajt 11/3/2015) - Added redirection for original /pipeline route.
    $urlRouterProvider.when('/pipeline', '/pipeline/leads').when('/resources', '/resources/videos').when('/certification', '/certification/courses').when('/accounts', '/accounts/myprofile/').otherwise('dashboard');

    $stateProvider.state('dashboard', {
        url: '/dashboard',
        template: __webpack_require__(75), // eslint-disable-line global-require
        controller: 'DashboardController',
        controllerAs: 'dashboard'
    }).state('todo', {
        url: '/todo',
        templateUrl: 'app/actionItems/actionItems.html'
    }).state('pipeline', {
        url: '/pipeline/:stageName',
        templateUrl: 'app/pipeline/pipeline.html',
        controller: 'PipelineController',
        controllerAs: 'pipeline'
    }).state('search', {
        url: '/search',
        template: __webpack_require__(187), // eslint-disable-line global-require
        controller: 'SearchController',
        controllerAs: 'search'
    }).state('resources', {
        url: '/resources/:resourceName',
        templateUrl: 'app/resources/resources.html',
        controller: 'ResourcesController',
        controllerAs: 'resources'
    }).state('certification', {
        url: '/certification/:certificationPage',
        templateUrl: 'app/certification/certification.html',
        controller: 'CertificationController',
        controllerAs: 'certification'
    }).state('accounts', {
        url: '/accounts/:accountsPage/:accountId',
        template: __webpack_require__(188), // eslint-disable-line global-require
        controller: 'AccountsController',
        controllerAs: 'accounts',
        params: {
            accountsPage: 'myprofile',
            accountId: null
        }
    }).state('product-lookup', {
        url: '/product-lookup/:productLookupPage/:GeoState/:Id',
        templateUrl: 'app/productCenter/productCenter.html',
        controller: 'ProductCenterController',
        controllerAs: 'productCenter'
    }).state('lead', {
        url: '/lead/:prequalId',
        templateUrl: 'app/lead/lead.html',
        controller: 'LeadController',
        controllerAs: 'lead'
    }).state('app-detail', {
        url: '/app-detail/:appId',
        templateUrl: 'app/appDetail/appDetail.html',
        controller: 'AppDetailController',
        controllerAs: 'appDetail'
    }).state('ESign', {
        url: '/ESign/Result',
        templateUrl: 'app/appDetail/ESign/ESign.html',
        controller: 'ESignRedirectController',
        controllerAs: 'ESign'
    }).state('sso', {
        url: '/sso/:destination',
        templateUrl: 'app/common/topNav/sso.html',
        controller: 'SSOController',
        controllerAs: 'sso'
    }).state('httpError1', {
        url: '/httpError/:status',
        templateUrl: 'app/common/httpError/httpError.html'
    }).state('httpError2', {
        url: '/httpError/:status/:transactionId',
        templateUrl: 'app/common/httpError/httpError.html'
    }).state('esignature', {
        url: '/EsignatureDisclosure',
        templateUrl: 'app/common/footer/legalDocuments/legalDocuments.html'
    }).state('application', {
        url: '/application/:HEROId',
        templateUrl: 'app/application/application.html',
        controller: 'ApplicationController',
        controllerAs: 'application'
    });

    $locationProvider.html5Mode({
        enabled: true,
        requireBase: false
    });

    $locationProvider.hashPrefix('');

    $analyticsProvider.virtualPageviews(false);
}

/***/ }),
/* 187 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-module search-input-module\">\n\t<div class=\"hp-inner\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-2\">\n\t\t\t\t<h1>Search</h1>\n\t\t\t</div>\n\t\t\t<div class=\"col-md-10\">\n\t\t\t\t<form class=\"search-form\">\n\t\t\t\t\t<span uib-dropdown dropdown-small-popup class=\"dropdown\" >\n\t\t\t\t\t\t<span uib-dropdown-toggle class=\"dropdown-toggle\">\n\t\t\t\t\t\t\t\t<a class=\"dropdown-text\" ng-bind=\"search.searchCriterias[search.SearchCriteria - 1]\"></a>\n\t\t\t\t\t\t\t\t<span class=\"icon\"></span>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<ul uib-dropdown-menu class=\"dropdown-menu\">\n\t\t\t\t\t\t\t<li ng-click=\"search.switchCriteria($index + 1);\" ng-repeat=\"criteria in search.searchCriterias track by $index\" ng-class=\"{ 'active': search.SearchCriteria === $index + 1 }\">\n\t\t\t\t\t\t\t\t<a ng-bind=\"criteria\"></a>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</span>\n\t\t\t\t\t<input type=\"text\" ng-model=\"search.SearchValue\" />\n\t\t\t\t\t<button ng-click=\"search.submitSearch();\">Search</button>\n\t\t\t\t</form>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n\n<div class=\"hp-module pipeline-module search-results-module\">\n\t<div class=\"hp-inner\">\n\t\t<div class=\"pipeline-header\" ng-if=\"search.hasSubmittedSearch === true\">\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-md-9\">\n\t\t\t\t\t<!-- Search stats with paging -->\n\t\t\t\t\t<!-- <h1>Showing <strong>{{search.TotalCount === 0 ? 0 : ((search.PageNumber - 1) * 20) + 1}} - {{ search.PageNumber*20>search.TotalCount ? search.TotalCount : search.PageNumber*20 }} of {{ search.TotalCount }}</strong> results</h1> -->\n\n\t\t\t\t\t<!-- Search stats without paging -->\n\t\t\t\t\t<h1 ng-if=\"search.TotalCount <= 60 && search.hasSubmittedSearch === true\">\n\t\t\t\t\t\t<span ng-if=\"search.loading === false\">Showing <strong>{{ search.TotalCount }} of {{ search.TotalCount }}</strong> results</span>\n\t\t\t\t\t</h1>\n\t\t\t\t\t<h1 ng-if=\"search.TotalCount > 60\">Showing the first <strong>60</strong> results. Try again with a more specific search.</h1>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-3\">\n\t\t\t\t\t<div class=\"dropdown dropdown-bordered\" uib-dropdown dropdown-title=\"Job Status\" ng-if=\"$root.screenSize ==='large' && search.loading === false\">\n                        <a blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle data-toggle=\"dropdown\">\n                            <span class=\"dropdown-text\">{{search.selectedFilter.filterName}}</span>\n                            <span class=\"icon\"></span>\n                        </a>\n                        <ul class=\"dropdown-menu\" uib-dropdown-menu>\n                            <li ng-repeat=\"filter in search.filters\"\n                                ng-class=\"{'active': search.selectedFilter.filterId === filter.filterId }\"\n                                ng-click=\"search.filterSelected(filter)\">\n                                <span>{{filter.filterName}}</span>\n                            </li>\n                        </ul>\n                    </div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div><!-- pipeline-header -->\n\n\t\t<div ng-hide=\"!search.hasSubmittedSearch\" ra-spinner hide-content-when-shown=\"true\" show=\"search.loading\" class=\"hp-loading-spinner\" name=\"searchTableSpinner\">\n\t\t\t<pipeline-table template=\"pipelineTable\" source=\"search\"></pipeline-table>\n\t\t\t<!--<div class=\"pipeline-pagination\">-->\n\t\t\t\t<!--<paging-->\n\t\t\t\t<!--class=\"small\"-->\n\t\t\t\t<!--page=\"search.PageNumber\"-->\n\t\t\t\t<!--page-size=\"20\"-->\n\t\t\t\t<!--total=\"search.TotalCount\"-->\n\t\t\t\t<!--hide-if-empty=\"false\"-->\n\t\t\t\t<!--show-prev-next=\"true\"-->\n\t\t\t\t<!--paging-action=\"search.switchPage(page);\"></paging>-->\n\t\t\t<!--</div>-->\n\t\t</div>\n\t</div>\n</div>\n";

/***/ }),
/* 188 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-module accounts-module\">\n    <div class=\"hp-inner\">\n        <div class=\"accounts-header\">\n            <div class=\"row\">\n                <div class=\"col-md-12\">\n                    <h1>Accounts</h1>\n                </div>\n            </div>\n        </div>\n        <div class=\"accounts-nav navbar\">\n            <ul class=\"nav navbar-nav\">\n                <li ng-repeat=\"page in accounts.accountsPages\" ng-if=\"page.isPublic === true || (page.isPublic === false && accounts.hasElevatedAccess === true)\">\n                    <a ng-click=\"accounts.switchPage(page);\">\n                        <span ng-class=\"{ 'active': page.pageName === accounts.currentPage.pageName }\" >{{page.pageDisplayName}}</span>\n                    </a>\n                </li>\n            </ul>\n        </div>\n        <ng-include src=\"accounts.pageUrl\"></ng-include>\n    </div>\n</div>\n";

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = configHTTP;
configHTTP.$inject = ['$httpProvider'];
/* @ngInject */
// class configHttp {
//   constructor($httpProvider) {
//     $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
//     $httpProvider.defaults.withCredentials = true;
//     $httpProvider.interceptors.push('HttpInterceptorFactory');
//   }
// }

// export default['$httpProvider', configHttp];


// angular
// .module("HeroPRO")
// .config(configHTTP);

/* @ngInject */
function configHTTP($httpProvider) {
    // HTTP defaults
    $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    $httpProvider.defaults.withCredentials = true;
    $httpProvider.interceptors.push('HttpInterceptorFactory');
}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exceptionInterceptor;
exceptionInterceptor.$inject = ['$provide'];
// angular
// 	.module('HeroPRO')
// 	.config(exceptionInterceptor);
/* @ngInject */
function exceptionInterceptor($provide) {
    $provide.decorator('$exceptionHandler', ['hpLoggerService', function (hpLoggerService) {
        return function (exception, cause) {
            hpLoggerService.frameworkError(exception, cause);
        };
    }]);
}

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _LicenseAttachmentTypes = __webpack_require__(192);

var LicenseAttachmentTypes = _interopRequireWildcard(_LicenseAttachmentTypes);

var _LicenseIntegrationTypes = __webpack_require__(193);

var LicenseIntegrationTypes = _interopRequireWildcard(_LicenseIntegrationTypes);

var _LicenseRejectReasons = __webpack_require__(194);

var LicenseRejectReasons = _interopRequireWildcard(_LicenseRejectReasons);

var _LicenseTemplateUrls = __webpack_require__(195);

var LicenseTemplateUrls = _interopRequireWildcard(_LicenseTemplateUrls);

var _LicenseTypes = __webpack_require__(196);

var LicenseTypes = _interopRequireWildcard(_LicenseTypes);

var _logLevels = __webpack_require__(197);

var LogLevels = _interopRequireWildcard(_logLevels);

var _hpProjectAdvanceReasons = __webpack_require__(198);

var HPProjectAdvanceReasons = _interopRequireWildcard(_hpProjectAdvanceReasons);

var _PipelineStages = __webpack_require__(199);

var PipelineStages = _interopRequireWildcard(_PipelineStages);

var _StateMachine = __webpack_require__(200);

var HPStateMachineConfig = _interopRequireWildcard(_StateMachine);

var _ConditionTypes = __webpack_require__(201);

var ConditionTypes = _interopRequireWildcard(_ConditionTypes);

var _AddProductsConfig = __webpack_require__(202);

var AddProductsConfig = _interopRequireWildcard(_AddProductsConfig);

var _NotificationTypes = __webpack_require__(203);

var NotificationTypes = _interopRequireWildcard(_NotificationTypes);

var _NotificationPriorityTypes = __webpack_require__(204);

var NotificationPrioirty = _interopRequireWildcard(_NotificationPriorityTypes);

var _NotificationUpdateableTypes = __webpack_require__(205);

var NotificationUpdateableTypes = _interopRequireWildcard(_NotificationUpdateableTypes);

var _TrainingTypes = __webpack_require__(206);

var TrainingTypes = _interopRequireWildcard(_TrainingTypes);

var _ActionItemStatusTypes = __webpack_require__(207);

var ActionItemTypes = _interopRequireWildcard(_ActionItemStatusTypes);

var _ActionItemCategoryTypes = __webpack_require__(208);

var ActionItemCategoryTypes = _interopRequireWildcard(_ActionItemCategoryTypes);

var _ActionItemUrls = __webpack_require__(209);

var ActionItemUrls = _interopRequireWildcard(_ActionItemUrls);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.config.constants', []).constant('LicenseAttachmentTypes', LicenseAttachmentTypes.default).constant('LicenseIntegrationTypes', LicenseIntegrationTypes.default).constant('LicenseRejectReasons', LicenseRejectReasons.default).constant('LicenseTemplateUrls', LicenseTemplateUrls.default).constant('LicenseTypes', LicenseTypes.default).constant('HPLogging', LogLevels.default).constant('HPProjectAdvance', HPProjectAdvanceReasons.default).constant('HPPipelineStages', PipelineStages.default).constant('HPStateMachineConfig', HPStateMachineConfig.default).constant('HPConditionTypes', ConditionTypes.default).constant('AddProductsConfig', AddProductsConfig.default).constant('HPNotifications', NotificationTypes.default).constant('HPNotificationPriority', NotificationPrioirty.default).constant('HPUpdatableNotifications', NotificationUpdateableTypes.default).constant('HPTrainingType', TrainingTypes.default).constant('HPActionItemStatuses', ActionItemTypes.default).constant('HPActionItemCategories', ActionItemCategoryTypes.default).constant('HPActionItemUrls', ActionItemUrls.default).name;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var LicenseAttachmentTypes = {
    BusinessLicense: 79,
    ContractorLicense: 78
};

exports.default = LicenseAttachmentTypes;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var LicenseIntegrationTypes = {
    LicenseBoard: 3,
    Business: 1,
    Contractor: 2
};

exports.default = LicenseIntegrationTypes;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var LicenseRejectReasons = {
    Duplicate: { Id: -1, Msg: 'It appears you\'ve already registered with us. Please log into pro.heroprogram.com or give us a call at 844-722-7559 with any questions.' },
    NotUnique: { Id: 3, Msg: 'It appears you\'ve already registered with us. Please log into pro.heroprogram.com or give us a call at 844-722-7559 with any questions.' },
    LicenseNotValid: { Id: 5, Msg: 'Issue with license. Please contact license authority to resolve.' },
    ExpirationNotFuture: { Id: 7, Msg: 'Expiration date must be in the future.' },
    InvalidFileType: { Id: 8, Msg: 'The file type selected is not supported. Please try again.' },
    Required: { Id: 9, Msg: 'Please provide all required fields before continuing.' }

};

exports.default = LicenseRejectReasons;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var LicenseTemplateUrls = {
    CA: 'app/accounts/licenses/addLicense/CA/licenseCA.html',
    FL: 'app/accounts/licenses/addLicense/FL/licenseFL.html',
    2: 'app/accounts/licenses/addLicense/businessLicense/addBusinessLicense.html',
    1: 'app/accounts/licenses/addLicense/businessLicense/addBusinessLicense.html'

};

exports.default = LicenseTemplateUrls;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var LicenseTypes = {
    CSLB: 1,
    CILB: 4,
    Contractor: 1,
    Business: 2
};

exports.default = LicenseTypes;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

// angular
// .module('HeroPRO')
var HPLogging = {
    LogLevel: {
        Trace: 1000,
        Debug: 2000,
        Info: 3000,
        Warn: 4000,
        Error: 5000,
        Fatal: 6000
    }
};

exports.default = HPLogging;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// angular
// .module('HeroPRO')
var HPProjectAdvance = {
    'PA Requested': {
        buttonText: 'Advance eligible',
        template: 'app/pipeline/pipelineTable/projectAdvanceTemplates/projectAdvanceScheduled.html',
        stages: [2, 3, 4]
    },
    'PA In Review': {
        buttonText: 'Advance eligible',
        template: 'app/pipeline/pipelineTable/projectAdvanceTemplates/projectAdvanceScheduled.html',
        stages: [2, 3, 4]
    },
    'PA Sent': {
        buttonText: 'Advance sent',
        template: 'app/pipeline/pipelineTable/projectAdvanceTemplates/projectAdvanceSent.html',
        stages: [4, 5]
    },
    'PA Invoiced': {
        buttonText: 'Advance invoiced',
        template: 'app/pipeline/pipelineTable/projectAdvanceTemplates/projectAdvanceInvoiced.html',
        stages: [4, 5]
    },
    'PA Delinquent': {
        buttonText: 'Advance past due',
        template: 'app/pipeline/pipelineTable/projectAdvanceTemplates/projectAdvancePastDue.html',
        stages: [4, 5]
    },
    'PA Completed': {
        buttonText: 'Advance repaid',
        template: 'app/pipeline/pipelineTable/projectAdvanceTemplates/projectAdvancePaidBack.html',
        stages: [4, 5]
    },
    'PA Denied': {
        buttonText: 'Advance unavailable',
        template: 'app/pipeline/pipelineTable/projectAdvanceTemplates/projectAdvanceUnavailable.html',
        stages: [4, 5]
    }
};

exports.default = HPProjectAdvance;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// angular
// .module('HeroPRO')
var HPPipelineStages = {
    Leads: {
        name: 'Leads',
        pipelineStageName: 'leads',
        pipelineStageId: 1
    },
    Application: {
        name: 'Application',
        pipelineStageName: 'application',
        pipelineStageId: 2
    },
    StartWork: {
        name: 'Start Work',
        pipelineStageName: 'startwork',
        pipelineStageId: 3
    },
    GetPaid: {
        name: 'Get Paid',
        pipelineStageName: 'getpaid',
        pipelineStageId: 4
    },
    Closed: {
        name: 'Closed',
        pipelineStageName: 'closed',
        pipelineStageId: 5
    }
};

exports.default = HPPipelineStages;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var HPStateMachineConfig = {

    Loan: {
        Application_Submitted: 26,
        AUS_Reviewed: 27,
        AUS_Denied: 28,
        AUS_Conditionally_Approved: 29,
        UW_Reviewed_Info_Needed: 30,
        Decision_Info_Received: 31,
        Application_Denied: 32,
        Application_Terminated: 33,
        Application_Approved: 12,
        Product_And_Price_Added: 13,
        Products_Submitted: 34,
        Fin_Docs_Sent: 1,
        // Fin Docs state machine begins
        Fin_Docs_Signed_By_All_PO: 11,
        // Funding request state machine begins
        Final: 254,
        Unknown: 255
    },

    CC: {
        Completion_Cert_Generated: 1,
        Product_Details_Confirmed: 2,
        Payment_Instructions_Confirmed: 3,
        CO_Signed_Completion_Cert: 4,
        CO_Emailed_PO_Completion_Cert: 5,
        Completion_Cert_Sent_To_Installer: 6,
        PO_Initiated_Completion_Cert_eSign: 7,
        PO_Completed_Completion_Cert_eSign: 8,
        Completion_Cert_Uploaded_Or_eSigned: 9,
        Unknown: 255
    },

    ACA: {
        No_ACA: 0,
        ACA_Generated: 1,
        CO_Emailed_PO_ACA: 2,
        ACA_Sent_To_Installer: 3,
        PO_Initiated_ACA_eSign: 4,
        PO_Completed_ACA_eSign: 5,
        ACA_Signed_By_All_PO: 6,
        COG_Countersigned_ACA: 7,
        Unknown: 255
    },

    FR: {
        Project_Started: 1,
        Project_Completed: 2,
        All_Documents_Uploaded_Or_Signed: 3,
        Documents_Submitted: 4,
        Closer_Accepted_Case: 5,
        HERO_Funding_Scheduled: 6,
        HERO_Funded: 7,
        Closer_Rejected_Documents: 8,
        CO_Corrects_Documents: 9,
        Application_Denied: 10,
        HLP_Recording_Scheduled: 11,
        HLP_Completed: 12,
        Final: 254,
        Unknown: 255
    },

    FD: {
        Fin_Docs_Created: 1,
        Fin_Docs_Approved_By_CO: 2,
        Fin_Docs_Emailed_To_PO: 3,
        Fin_Docs_eSign_Initiated_By_PO: 4,
        Fin_Docs_Signed_By_PO: 5,
        Fin_Docs_Signed_By_All_PO: 6,
        Issuer_Reviewed: 7,
        Issuer_Countersigned: 8,
        Unknown: 255
    }
};

exports.default = HPStateMachineConfig;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var HPConditionTypes = {
    CompletionCertificate: 39,
    Invoice: 40,
    HIC: 56,
    InitialBuildingPermitPaperwork: 41,
    ProofFinalPermitInspection: 42,
    ProofInitialFinalPermit: 46,
    SolarLeasePPAAgreement: 44

};

exports.default = HPConditionTypes;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var AddProductsConfig = {
  // IMPORTANT! -----------------------------------------------------------------
  // All Product Types referenced in this file are referring to
  // the ProductTypeId column in RAHERO.dbo.ProductType and not EETypeId
  // IMPORTANT! -----------------------------------------------------------------

  // ------------------------------ solarPanelProductTypeIds ------------------------------
  solarPanelProductTypeIds: [40, 95],
  // ------------------------------ solarPanelProductTypeIds ------------------------------

  // ------------------------------ solarInverterProductTypeIds ------------------------------
  solarInverterProductTypeIds: [41, 96],
  // ------------------------------ solarInverterProductTypeIds ------------------------------

  // ------------------------------ miniSplitHeatPumpProductTypeId ------------------------------
  miniSplitHeatPumpProductTypeId: 46,
  // ------------------------------ miniSplitHeatPumpProductTypeId ------------------------------

  // ------------------------------ installationDetailsAsFiltersProductTypeIds ------------------------------
  // The products in these product types are set up differently in that you need to supply
  // all product details to resolve to a productid rather than first selecting a manufacturer/brand
  // and then entering installation details
  // FL Windows
  // FL Skylights
  // FL Doors
  // FL Roofing
  installationDetailsAsFiltersProductTypeIds: [91, 92, 93, 94],
  // ------------------------------ installationDetailsAsFiltersProductTypeIds ------------------------------

  // ------------------------------ manufacturerFilterOnlyProductTypeIds ------------------------------
  // These product types will use the Manfucaturer only filter template
  manufacturerFilterOnlyProductTypeIds: [20, 21, 22, 23, 45, 49, 59, 60, 97, 98],
  // ------------------------------ manufacturerFilterOnlyProductTypeIds ------------------------------

  // ------------------------------ quantityEEProductAttributeNameIds ------------------------------
  // new list 02/28/2017
  // DECLARE @listStr VARCHAR(MAX)
  // 		SELECT @listStr = COALESCE(@listStr+',' ,'') + CAST(EEProductAttributeNameId as varchar)
  //    FROM eeproductattributename
  //    where isinputfield = 1 and (Name LIKE '%quantity%' OR Name LIKE '%sq%')
  // SELECT @listStr
  //
  // Adding in this additional query to retrieve some missed attributes - MS 5/16/17
  // DECLARE @listStr VARCHAR(MAX)
  // SELECT @listStr = COALESCE(@listStr+',' ,'') + CAST(EEProductAttributeNameId as varchar)
  //     FROM eeproductattributename
  //     where isinputfield = 1
  // 		and (Name NOT LIKE '%quantity%' AND Name NOT LIKE '%sq%')
  // 		and DisplayName like '%sq%'
  //  SELECT @listStr
  quantityEEProductAttributeNameIds: [363, 367, 370, 401, 419, 420, 421, 423, 424, 425, 426, 427, 428, 429, 430, 431, 432, 433, 434, 436, 437, 438, 439, 440, 441, 442, 443, 444, 445, 446, 474, 498, 503, 516, 523, 543, 793, 803, 806, 816, 820, 822, 827, 828, 830, 840, 853, 864, 870, 876, 881, 887, 893, 899, 906, 910, 918, 923, 925, 940, 951, 957, 966, 971, 1006, 1012, 1022, 1028, 1032, 1040, 1054, 1057, 1060, 1063, 1065],
  // ------------------------------ quantityEEProductAttributeNameIds ------------------------------

  // ------------------------------ sqftProductTypes ------------------------------
  sqftProductTypes: [12, 16, 17, 18, 19, 30, 39, 42, 43, 45, 59, 60, 61, 63, 94, 99, 100, 101],
  // ------------------------------ sqftProductTypes ------------------------------

  // ------------------------------ lnftProductTypes ------------------------------
  lnftProductTypes: [77, 97],
  // ------------------------------ lnftProductTypes ------------------------------

  // ------------------------------ hideQtyFieldProductTypes ------------------------------
  hideQtyFieldProductTypes: [7, 8, 31, 33, 34, 44, 58, 85, 86, 87, 88, 89, 90],
  // ------------------------------ hideQtyFieldProductTypes ------------------------------

  // ------------------------------ hideEditProductTypes ------------------------------
  hideEditInstallDetailsProductTypes: [85, 86, 87, 88, 89, 90],
  // ------------------------------ hideEditProductTypes ------------------------------

  // ------------------------------ progThermostatEEProductAttributeNameIds ------------------------------
  progThermostatEEProductAttributeNameIds: [751, 755, 766, 769, 787]
  // ------------------------------ progThermostatEEProductAttributeNameIds ------------------------------
};

exports.default = AddProductsConfig;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// angular
//     .module('HeroPRO')
var HPNotifications = {
    CSLB: {
        actionItemTypeId: 22,
        template: 'app/notificationCenter/modal/templates/contractorCSLB/contractorCSLB.html',
        menuText: 'Contractor CSLB Required'
    },
    MandatoryTraining: {
        actionItemTypeId: 18,
        template: 'app/notificationCenter/modal/training/trainingContent.html',
        menuText: 'Required training'
    },
    DelayedMandatoryTraining: {
        actionItemTypeId: 19,
        template: 'app/notificationCenter/modal/training/trainingContent.html',
        menuText: 'Required training'
    },
    MandatoryTrainingDaysLeft: {
        actionItemTypeId: 1,
        template: '',
        menuText: 'Required training'
    },
    Ach: {
        actionItemTypeId: 16,
        template: 'app/notificationCenter/modal/templates/addBankInfo/addBankInfo.html',
        menuText: "Company's bank info"
    },
    TurningOffAccess: {
        actionItemTypeId: 20,
        template: 'app/notificationCenter/modal/templates/territoryUpdate/territoryUpdate.html',
        menuText: 'Territory Update'
    },
    AdvancedRegistration: {
        actionItemTypeId: 21,
        template: 'app/notificationCenter/modal/templates/advancedRegistration/advancedRegistration.html',
        menuText: 'Advanced Registration'
    },
    TermsAndConditions: {
        actionItemTypeId: 14,
        template: 'app/notificationCenter/modal/templates/termsSign/termsSign.html',
        menuText: 'Get Started'
    },
    MandatoryPCC: {
        actionItemTypeId: 23,
        template: 'app/notificationCenter/modal/templates/pcc/pcc.html',
        menuText: 'HIS Status'
    },
    ReminderPCC: {
        actionItemTypeId: 24,
        template: 'app/notificationCenter/modal/templates/pcc/pcc.html',
        menuText: 'HIS Status'
    },
    HISCodeOfConduct: {
        actionItemTypeId: 25,
        template: 'app/notificationCenter/modal/templates/hisCodeOfConduct/hisCodeOfConduct.html',
        menuText: 'CA HERO Role Overview'
    },
    LACountyTurnOff: {
        actionItemTypeId: 26,
        template: 'app/notificationCenter/modal/templates/territoryUpdate/territoryUpdateLAC.html',
        menuText: 'Territory Update'
    }
};

exports.default = HPNotifications;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var HPNotificationPriority = {
    Mandatory: 1,
    Optional: 2
};

exports.default = HPNotificationPriority;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var HPUpdatableNotifications = [20];

exports.default = HPUpdatableNotifications;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var HPTrainingType = {
    ALL: 1,
    HERO: 2,
    BENJI: 3
};

exports.default = HPTrainingType;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var HPActionItemStatuses = {
    Open: 1,
    Invalidated: 2,
    Completed: 3,
    Initiated: 4,
    Dismissed: 5
};

exports.default = HPActionItemStatuses;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var HPActionItemCategories = {
    Loan: 1,
    Setup: 2,
    Compliance: 3,
    Marketing: 4
};

exports.default = HPActionItemCategories;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var HPActionItemUrls = {
    Completed: 'app/notificationCenter/modal/training/complete/complete.html'
};

exports.default = HPActionItemUrls;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var HPRoles = {
    COPO_COMPANY_ADMIN: {
        roleId: 16,
        displayName: 'Company Admin',
        Name: 'COPO_COMPANY_ADMIN',
        rank: 1,
        isAdmin: true,
        isManager: false
    },
    COPO_COMPANY_MGR: {
        roleId: 17,
        displayName: 'Company Manager',
        Name: 'COPO_COMPANY_MGR',
        rank: 1,
        isAdmin: false,
        isManager: true
    },
    COPO_ADMIN: {
        roleId: 7,
        displayName: 'Office Admin',
        Name: 'COPO_ADMIN',
        rank: 2,
        isAdmin: true,
        isManager: false
    },
    COPO_MGR: {
        roleId: 8,
        displayName: 'Office Manager',
        Name: 'COPO_MGR',
        rank: 2,
        isAdmin: false,
        isManager: true
    },
    COPO_PROJECT_REP: {
        roleId: 11,
        displayName: 'Project Sales Rep',
        Name: 'COPO_PROJECT_REP',
        rank: 3,
        isAdmin: false,
        isManager: false
    },
    COPO_REP: {
        roleId: 9,
        displayName: 'Sales Rep',
        Name: 'COPO_REP',
        rank: 3,
        isAdmin: false,
        isManager: false
    },
    COPO_LIMITED_REP: {
        roleId: 14,
        displayName: 'Limited Sales Rep',
        Name: 'COPO_LIMITED_REP',
        rank: 3,
        isAdmin: false,
        isManager: false
    },
    LACounty: {
        roleId: 101,
        displayName: 'LACounty',
        Name: 'LACounty',
        rank: 4,
        isAdmin: false,
        isManager: false
    },
    COPO_RAEMPLOYEE: {
        roleId: 10,
        displayName: 'RA Employee',
        Name: 'COPO_RAEMPLOYEE',
        rank: 5,
        isAdmin: false,
        isManager: false
    }
};

exports.default = HPRoles;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var HPGeoStates = {
    whitelist: {
        California: 6,
        Kansas: 20,
        Missouri: 29,
        Florida: 12
    },
    blacklist: {
        Tennessee: 47,
        Arizona: 4,
        Texas: 48
    }
};

exports.default = HPGeoStates;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var HPDisplayRules = exports.HPDisplayRules = {
    whitelist: {
        showFullTopNav: true,
        showFullSidebar: true
    },
    blacklist: {
        showFullTopNav: false,
        showFullSidebar: false
    }
};

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var HPTopNavRules = exports.HPTopNavRules = {
    standard: {
        showApply: true,
        showKbyg: true,
        showProposal: false,
        showContact: true,
        showPersonalInfo: true,
        showCoQR: false,
        showReports: false
    },
    suspendedCompliance: {
        showApply: false,
        showKbyg: false,
        showProposal: false,
        showContact: true,
        showPersonalInfo: true,
        showCoQR: false,
        showReports: false
    },
    benjiView: {
        showApply: false,
        showKbyg: false,
        showProposal: false,
        showContact: false,
        showPersonalInfo: true,
        showCoQR: false,
        showReports: false
    }
};

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var HPSidebarRules = exports.HPSidebarRules = {
    standard: {
        showSearch: true,
        showDashboard: true,
        showToDoList: true,
        showPipeline: true,
        showProductLookup: true,
        showResources: true,
        showCertification: true,
        showAccounts: true
    },
    PACEParticipant: { // Advertiser
        showSearch: true,
        showDashboard: true,
        showToDoList: true,
        showPipeline: true,
        showProductLookup: true,
        showResources: true,
        showCertification: false, // GALA-2219
        showAccounts: true
    },
    suspendedCompliance: {
        showSearch: true,
        showDashboard: true,
        showToDoList: false,
        showPipeline: true,
        showProductLookup: false,
        showResources: false,
        showCertification: false,
        showAccounts: true
    },
    benjiView: {
        showSearch: false,
        showDashboard: true,
        showToDoList: false,
        showPipeline: false,
        showProductLookup: false,
        showResources: false,
        showCertification: false, // originally true
        showAccounts: true
    }
};

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var HPDashboardRules = exports.HPDashboardRules = {
    standard: {
        showStartProject: true,
        showToDoSummary: false,
        showPipelineSummary: true,
        showComingSoon: false
    },
    benjiView: {
        showStartProject: false,
        showToDoSummary: false,
        showPipelineSummary: false,
        showComingSoon: false
    },
    suspendedCompliance: {
        showStartProject: false,
        showToDoSummary: false,
        showPipelineSummary: true,
        showComingSoon: false
    }
};

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _search = __webpack_require__(217);

var _search2 = _interopRequireDefault(_search);

var _search3 = __webpack_require__(219);

var _search4 = _interopRequireDefault(_search3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.search', []).controller('SearchController', _search2.default).service('SearchService', _search4.default).run(function () {}).name;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(218);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* @ngInject */
var SearchController = function () {
    function SearchController($scope, $q, SearchService, $analytics) {
        _classCallCheck(this, SearchController);

        this.$scope = $scope;
        this.$q = $q;
        this.SearchService = SearchService;
        this.$analytics = $analytics;
        this.pipelineTableReadyForData = null;
        this.PageNumber = 0;
        this.TotalCount = 0;
        this.SearchValue = '';
        this.SearchCriteria = 1;
        this.loading = false;
        this.hasSubmittedSearch = false;
        this.filters = SearchService.getSearchFilters();
        this.selectedFilter = this.filters[1]; // Active Projects

        this.searchCriterias = ['Last Name', 'Email', 'Phone', 'Street Address', 'HERO ID', 'Job Number'];

        this.init();
    }

    /*= ========================================
    =            Private Functions            =
    ========================================= */


    _createClass(SearchController, [{
        key: 'init',
        value: function init() {
            var _this = this;

            this.pipelineTableReadyForData = this.$q(function (resolve) {
                _this.$scope.$on('pipelineTableReady', resolve);
            });
        }
    }, {
        key: 'search',
        value: function search() {
            var _this2 = this;

            this.loading = true;
            this.SearchService.search({
                SearchCriteria: this.SearchCriteria,
                SearchValue: this.SearchValue,
                PageNumber: this.PageNumber,
                DisplayOption: this.selectedFilter.filterId
            }).then(function (response) {
                var data = response.data.Data;
                _this2.loading = false;
                _this2.TotalCount = data.TotalCount === undefined ? 0 : data.TotalCount;
                _this2.alertPipelineTable(data.PipelineFundingRequests);
            });
        }
    }, {
        key: 'alertPipelineTable',
        value: function alertPipelineTable(data) {
            var _this3 = this;

            this.pipelineTableReadyForData.then(function () {
                _this3.$scope.$broadcast('pipelineTableUpdate', {
                    pipelineStageId: 'search',
                    data: data
                });
            });
        }
        /* -----  End of Private Functions  ------*/

        /*= =======================================
        =            Public Functions            =
        ======================================== */

    }, {
        key: 'switchCriteria',
        value: function switchCriteria(i) {
            this.SearchCriteria = i;
        }
    }, {
        key: 'submitSearch',
        value: function submitSearch() {
            this.$analytics.eventTrack(this.searchCriterias[this.SearchCriteria - 1], { category: 'Search' });

            this.PageNumber = 0;
            this.hasSubmittedSearch = true;
            this.search();
        }
    }, {
        key: 'switchPage',
        value: function switchPage(page) {
            this.PageNumber = page - 1;
            this.search();
        }
    }, {
        key: 'filterSelected',
        value: function filterSelected(filter) {
            this.selectedFilter = filter;
            this.search();
        }
        /* -----  End of Public Functions  ------*/

    }]);

    return SearchController;
}();

SearchController.$inject = ['$scope', '$q', 'SearchService', '$analytics'];
exports.default = SearchController;

/***/ }),
/* 218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* @ngInject */
var SearchService = function () {
    function SearchService($http, HPConfig, $location) {
        _classCallCheck(this, SearchService);

        this.$http = $http;
        this.HPConfig = HPConfig;
        this.$location = $location;

        this.filters = [{
            filterId: 1,
            filterName: 'All Projects',
            selected: false
        }, {
            filterId: 2,
            filterName: 'Active Projects',
            selected: true
        }, {
            filterId: 3,
            filterName: 'Hidden Projects',
            selected: false
        }];
    }

    _createClass(SearchService, [{
        key: 'search',
        value: function search(options) {
            var defaultSearchDataOptions = {
                SearchCriteria: 1,
                SearchValue: '',
                PageSize: '20',
                PageNumber: '0',
                LocationContractorId: null,
                DisplayOption: '2'
            };

            var promise = this.$http({
                // url: HPConfig.heroProApi + "/Loan/FundingRequest/Pipeline/Search",
                url: this.HPConfig.heroProApi + 'Loan/FundingRequest/Pipeline/SearchAll',
                method: 'GET',
                params: _angular2.default.extend({}, defaultSearchDataOptions, options || {})
            });

            this.heroProbe(promise);

            return promise;
        }
    }, {
        key: 'getSearchFilters',
        value: function getSearchFilters() {
            return this.filters;
        }

        // heroProbe

    }, {
        key: 'heroProbe',
        value: function heroProbe(promise) {
            if (this.$location.search().heroprobe !== undefined) {
                promise.then(function (response) {
                    console.table(response.data.PipelineFundingRequests, ['Owner1FirstName', 'Owner1LastName', 'FundingRequestId', 'LoanStateId', 'FundingRequestStateId', 'FinDocsStateId', 'PipelineStageId', 'FundingRequestPipelineStageId']);
                });
            }
        }
        // heroProbe

    }]);

    return SearchService;
}();

SearchService.$inject = ['$http', 'HPConfig', '$location'];
exports.default = SearchService;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _dashboard = __webpack_require__(221);

var _dashboard2 = _interopRequireDefault(_dashboard);

var _dashboard3 = __webpack_require__(224);

var _dashboard4 = _interopRequireDefault(_dashboard3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.dashboard', []).controller('DashboardController', _dashboard2.default).service('DashboardService', _dashboard4.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/dashboard/startProject.html', __webpack_require__(225)); // eslint-disable-line global-require
    $templateCache.put('app/dashboard/comingSoon.html', __webpack_require__(226)); // eslint-disable-line global-require
    $templateCache.put('app/dashboard/dashboard.html', __webpack_require__(75)); // eslint-disable-line global-require
    $templateCache.put('app/dashboard/dashboardToDoList.html', __webpack_require__(227)); // eslint-disable-line global-require
    $templateCache.put('app/dashboard/mobileAppNotice.html', __webpack_require__(228)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(222);

__webpack_require__(223);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* @ngInject */
var DashboardController = function () {
    function DashboardController($scope, UiDisplayFactory, DashboardService, PermissionsFactory) {
        var _this = this;

        _classCallCheck(this, DashboardController);

        this.UiDisplayFactory = UiDisplayFactory;
        this.DashboardService = DashboardService;
        this.PermissionsFactory = PermissionsFactory;

        this.title = 'HEROPro';
        this.rules = {};
        this.dashboardModules = [];
        this.showBenjiLink = false;
        this.comingSoonStateName = '';
        this.showMobileAppMessaging = false;

        this.init();

        $scope.$on('UpdateDisplay', function () {
            // (ajt - 5/26/2016) TODO: Remove delay if the rules processing can be performed synchronously.
            _lodash2.default.defer(function () {
                _this.setRules();
            });
        });
    }

    _createClass(DashboardController, [{
        key: 'init',
        value: function init() {
            this.setRules();

            if (this.PermissionsFactory.hasPermission('HeroPro.IntegratedExperience.Enabled')) {
                this.showMobileAppMessaging = true;
            }
        }
    }, {
        key: 'setRules',
        value: function setRules() {
            var _this2 = this;

            this.rules = this.UiDisplayFactory.getDisplayRules();
            if (this.rules.rulesLoaded === true) {
                var elements = this.DashboardService.getDashboard();
                this.dashboardModules = [];
                _lodash2.default.each(elements, function (item) {
                    switch (item.name.toLowerCase()) {
                        case 'start project':
                            item.isEnabled = _this2.rules.showStartProject;
                            break;
                        case 'action items':
                            item.isEnabled = _this2.rules.showToDoSummary;
                            break;
                        case 'pipeline summary':
                            item.isEnabled = _this2.rules.showPipelineSummary;
                            break;
                        case 'coming soon':
                            item.isEnabled = _this2.rules.showComingSoon;
                            _this2.comingSoonStateName = _this2.UiDisplayFactory.getBlacklistStateName();
                            break;
                        default:
                            console.log("unknown case for 'setRules' in dashboardController");
                    }
                    if (item.isEnabled === true) {
                        _this2.dashboardModules.push(item);
                    }
                });
                this.showBenjiLink = this.rules.isBenjiUser;
            }
        }
    }]);

    return DashboardController;
}();

DashboardController.$inject = ['$scope', 'UiDisplayFactory', 'DashboardService', 'PermissionsFactory'];
exports.default = DashboardController;

/***/ }),
/* 222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* @ngInject */
var DashboardService = function () {
    function DashboardService() {
        _classCallCheck(this, DashboardService);

        this.dashboardModules = [{
            name: 'Start Project',
            path: 'app/dashboard/startProject.html',
            isEnabled: false
        }, {
            name: 'Action Items',
            path: 'app/dashboard/dashboardToDoList.html',
            isEnabled: false
        }, {
            name: 'Pipeline Summary',
            path: 'app/pipelineSummary/pipelineSummary.html',
            isEnabled: false
        }, {
            name: 'Coming Soon',
            path: 'app/dashboard/comingSoon.html',
            isEnabled: false
        }];
    }

    _createClass(DashboardService, [{
        key: 'getDashboard',
        value: function getDashboard() {
            return this.dashboardModules;
        }
    }]);

    return DashboardService;
}();

DashboardService.$inject = [];
exports.default = DashboardService;

/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports = "<ul class=\"hp-inner\" ng-controller=\"StartProjectController as startProject\">\n    <h1>Start a Project</h1>\n    <div class=\"text-center\">\n        <ul class=\"hp-inner-button-list\">\n            <li>\n                <a class=\"btn btn-default\" ng-click=\"startProject.kbygClick();\">\n                    KBYG\n                </a>\n            </li>\n            <li ng-show=\"startProject.isSolicitor === true\">\n                <a class=\"btn btn-default\" ng-click=\"startProject.proPitchClick();\">\n                    Proposal Plus\n                </a>\n            <li>\n            <li>\n                <a class=\"btn btn-default\" ng-href=\"/resources/map\" ng-click=\"startProject.mapClick();\">\n                    Map\n                </a>\n            <li>\n\n            <li>\n                <button class=\"btn btn-primary\" ng-show=\"startProject.isSolicitor === true\" ng-click=\"startProject.applicationClick(); main.applicationClick()\">\n                    Get Approved\n                </button>\n                <button class=\"btn btn-primary\" ng-show=\"startProject.isSolicitor !== true\" ng-click=\"startProject.applicationClick(); main.applicationClick()\">\n                    Homeowner Apply\n                </button>\n            <li>\n            <li>\n                <button class=\"btn btn-default\" ng-href=\"pipeline/leads\">\n                    My Pipeline\n                </button>\n            </li>\n        </ul>\n    </div>\n</ul>";

/***/ }),
/* 226 */
/***/ (function(module, exports) {

module.exports = "<div class=\"coming-soon-container\">\n    <div class=\"row\">\n        <div class=\"col-md-8 col-md-offset-2 coming-soon-content\">\n            <img src=\"src/assets/images/logo_hero@2x.png\" alt=\"HEROPro\"/>\n            <h2>HERO is in CA, MO, and on its way to FL!</h2>\n            <p>\n               Look for an email from us to find out when HERO is ready to start operating in your state. For more details about product offerings available where you do business, contact us at 844-722-7759.\n            </p>\n            <p ng-show=\"dashboard.showBenjiLink\">\n                Have Benji projects in <span ng-bind=\"dashboard.comingSoonStateName\"></span>? You can <span class=\"link\" ng-click=\"main.benjiLinkClick(false)\">access those right now</span>.\n            </p>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 227 */
/***/ (function(module, exports) {

module.exports = "<action-items show-filters=\"false\" show-refresh-button=\"false\" show-see-all=\"true\" show-completed-today=\"true\"\n              max-action-items=\"5\" source=\"summaryView\"></action-items>\n";

/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports = "<p class=\"mobileapp-notice\">\n    Now get OneApp: one application, one credit check, HERO and Benji results in minutes. <a href=\"#\" ng-click=\"main.applicationClick()\" analytics-on=\"click\" analytics-category=\"StartProject\" analytics-event=\"Banner Application Open\">Try it now</a> or <a href=\"https://raone.app/install\" target=\"_blank\" analytics-on=\"click\" analytics-category=\"StartProject\" analytics-event=\"Download mobile app click\">download mobile app &rsaquo;</a>\n</p>";

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _pipelineSummary = __webpack_require__(230);

var _pipelineSummary2 = _interopRequireDefault(_pipelineSummary);

var _pipelineSummary3 = __webpack_require__(232);

var _pipelineSummary4 = _interopRequireDefault(_pipelineSummary3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.pipelineSummary', []).controller('PipelineSummaryController', _pipelineSummary2.default).service('PipelineSummaryService', _pipelineSummary4.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/pipelineSummary/pipelineSummary.html', __webpack_require__(233)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(231);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* @ngInject */
var PipelineSummaryController = function () {
    function PipelineSummaryController($scope, UserData, PipelineSummaryService) {
        var _this = this;

        _classCallCheck(this, PipelineSummaryController);

        this.PipelineSummaryService = PipelineSummaryService;

        this.summaries = {};
        this.loading = false;
        this.errorState = false;

        UserData.getCurrentLocation().then(function (newLocation) {
            _this.getSummary(newLocation.ContractorId);
        });

        $scope.$on('HPLocationChange', function (event, newLocation) {
            _this.getSummary(newLocation.ContractorId);
        });
    }

    _createClass(PipelineSummaryController, [{
        key: 'getSummary',
        value: function getSummary(contractorId) {
            var _this2 = this;

            this.loading = true;
            this.PipelineSummaryService.getSummary(contractorId).then(function (response) {
                if (response.data.ResultCode !== 1) {
                    _this2.summaries = response.data.Data;
                    _this2.errorState = false;
                } else {
                    _this2.errorState = true;
                }
                _this2.loading = false;
            });
        }
    }]);

    return PipelineSummaryController;
}();

PipelineSummaryController.$inject = ['$scope', 'UserData', 'PipelineSummaryService'];
exports.default = PipelineSummaryController;

/***/ }),
/* 231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* @ngInject */
var PipelineSummaryService = function () {
    function PipelineSummaryService($http, UserData, HPConfig) {
        _classCallCheck(this, PipelineSummaryService);

        this.$http = $http;
        this.UserData = UserData;
        this.HPConfig = HPConfig;
    }

    _createClass(PipelineSummaryService, [{
        key: 'getSummary',
        value: function getSummary(contractorId) {
            var conf = {};

            if (contractorId !== undefined) {
                conf.ContractorLocationId = contractorId;
            }

            return this.$http({
                url: this.HPConfig.heroProApi + 'Contractor/GetPipelineSummaryHP',
                method: 'GET',
                params: conf,
                cache: true
            });
        }
    }]);

    return PipelineSummaryService;
}();

PipelineSummaryService.$inject = ['$http', 'UserData', 'HPConfig'];
exports.default = PipelineSummaryService;

/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports = "<div id=\"pipeline-summary\" class=\"hp-inner\" ng-controller=\"PipelineSummaryController as pipelineSummary\">\n    <h1>Pipeline Summary</h1>\n    <div>\n        <div class=\"pipeline-summary-error\" ng-if=\"pipelineSummary.errorState\">\n            <br />\n            <h4 style=\"text-align: center\" class=\"pipeline-summary-offline-message\">We are working on this feature. Please be patient while we make updates.</h4>\n            <br />\n        </div>\n    </div>\n    <div ng-if=\"!pipelineSummary.errorState\" class=\"pipeline-summary hp-loading-spinner\" ra-spinner name=\"pipelineSummarySpinner\" hide-content-when-shown=\"true\" show=\"pipelineSummary.loading\" register=\"false\">\n        <div class=\"pipeline-summary-container\" >\n            <div class=\"pipeline-summary-col-2\">\n                <p class=\"icon icon-pipeline-installation\"></p>\n                <h3>Start Work</h3>\n                <h5 ng-bind=\"pipelineSummary.summaries.StartWork | currency : '$' : 0\"></h5>\n                <a href=\"#\"  class=\"icon icon-pipeline-tip\" hp-popover popover-placement=\"top\" popover-trigger=\"show\" popover-title=\"Start Work\" uib-popover='Total $ amount of HERO project funds approved or signed.'></a>\n            </div>\n            <div class=\"pipeline-summary-col-3\">\n                <p class=\"icon icon-pipeline-funding\"></p>\n                <h3>Get Paid</h3>\n                <h5 ng-bind=\"pipelineSummary.summaries.GetPaid | currency : '$' : 0\"></h5>\n                <a href=\"#\"  class=\"icon icon-pipeline-tip\" hp-popover popover-placement=\"top\" popover-trigger=\"show\" popover-title=\"Get Paid\" uib-popover='Total $ amount of work in progress or scheduled for funding.'></a>\n            </div>\n            <div class=\"pipeline-summary-col-4\">\n                <p class=\"icon icon-todo\"></p>\n                <h3>Closed</h3>\n                <h5 ng-bind=\"pipelineSummary.summaries.Closed | currency : '$' : 0\"></h5>\n                <a href=\"#\"  class=\"icon icon-pipeline-tip\" hp-popover popover-placement=\"top\" popover-trigger=\"show\" popover-title=\"Closed\" uib-popover=\"Congratulations! This is the $ amount of HERO projects completed and funded.\"></a>\n            </div>\n        </div>\n\n        <div class=\"pipeline-metrics-container\">\n            <div class=\"row\">\n                <div class=\"pipeline-metric pad-left col-md-4\">\n                    <p class=\"icon icon-pipeline-average-funding\"></p>\n                    <h3 ng-bind=\"pipelineSummary.summaries.AverageTicketAmount | currency : '$' : 0\"></h3>\n                    <h5>Average Deal Size</h5>\n                    <a href=\"#\" class=\"icon icon-pipeline-tip\" hp-popover popover-placement=\"top\" popover-trigger=\"show\" popover-title=\"Average Funding Per Project\" uib-popover=\"This is the average funding amount per project you have completed with HERO.\"></a>\n                </div>\n                <div class=\"pipeline-metric pad-center col-md-4\">\n                    <p class=\"icon icon-pipeline-approved-to-sign\"></p>\n                    <h3>{{ pipelineSummary.summaries.ApprovedToSignedPullThrough * 100 | number:0 }}<span ng-show=\"pipelineSummary.summaries.ApprovedToSignedPullThrough !== undefined\">%</span></h3>\n                    <h5>Approved to Sign Rate</h5>\n                    <a href=\"#\" class=\"icon icon-pipeline-tip\" hp-popover popover-placement=\"top\" popover-trigger=\"show\" popover-title=\"Why This Matters\" uib-popover='The \"Approved-to-Signed Rate\" is the percentage of your HERO-approved deals that get signed. Getting property owners to sign is the best way to lift this % and immediately drive revenue. Check your \"To-Do List\" to help make sure your customers sign.'></a>\n                </div>\n                <div class=\"pipeline-metric pad-right col-md-4\">\n                    <p class=\"icon icon-pipeline-sign-to-funded\"></p>\n                    <h3>{{ pipelineSummary.summaries.SignedToFundedPullThrough * 100 | number:0 }}<span ng-show=\"pipelineSummary.summaries.SignedToFundedPullThrough !== undefined\">%</span></h3>\n                    <h5>Signed to Funded Rate</h5>\n                    <a href=\"#\" class=\"icon icon-pipeline-tip\" hp-popover popover-placement=\"top\" popover-trigger=\"show\" popover-title=\"Why This Matters\" uib-popover='The \"Signed-to-Funded Rate\" is the percentage of your HERO-signed deals that get funded.'></a>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _pipelineController = __webpack_require__(235);

var _pipelineController2 = _interopRequireDefault(_pipelineController);

var _pipelineFactory = __webpack_require__(237);

var _pipelineFactory2 = _interopRequireDefault(_pipelineFactory);

var _pipelineMappingsConstant = __webpack_require__(238);

var _pipelineMappingsConstant2 = _interopRequireDefault(_pipelineMappingsConstant);

var _pipelineFilterModalController = __webpack_require__(239);

var _pipelineFilterModalController2 = _interopRequireDefault(_pipelineFilterModalController);

var _pipelineFilterFactory = __webpack_require__(241);

var _pipelineFilterFactory2 = _interopRequireDefault(_pipelineFilterFactory);

var _filterOptionsDirective = __webpack_require__(242);

var _filterOptionsDirective2 = _interopRequireDefault(_filterOptionsDirective);

var _filterBreadcrumbsDirective = __webpack_require__(244);

var _filterBreadcrumbsDirective2 = _interopRequireDefault(_filterBreadcrumbsDirective);

var _pipelineJobModalController = __webpack_require__(245);

var _pipelineJobModalController2 = _interopRequireDefault(_pipelineJobModalController);

var _pipelineTableController = __webpack_require__(247);

var _pipelineTableController2 = _interopRequireDefault(_pipelineTableController);

var _pipelineTableDirective = __webpack_require__(249);

var _pipelineTableDirective2 = _interopRequireDefault(_pipelineTableDirective);

var _projectAdvanceController = __webpack_require__(250);

var _projectAdvanceController2 = _interopRequireDefault(_projectAdvanceController);

var _projectAdvanceFactory = __webpack_require__(252);

var _projectAdvanceFactory2 = _interopRequireDefault(_projectAdvanceFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// pipelineTable/projectAdvanceTemplates


// pipelineTable


// filterBreadCrumbs
exports.default = _angular2.default.module('app.pipeline', []).controller('PipelineController', _pipelineController2.default).service('PipelineFactory', _pipelineFactory2.default).service('PipelineMappings', _pipelineMappingsConstant2.default).controller('PipelineFilterModalController', _pipelineFilterModalController2.default).service('PipelineFilterFactory', _pipelineFilterFactory2.default).directive('filterOption', _filterOptionsDirective2.default).directive('filterBreadcrumbs', _filterBreadcrumbsDirective2.default).controller('PipelineJobModalController', _pipelineJobModalController2.default).controller('PipelineTableController', _pipelineTableController2.default).directive('pipelineTable', _pipelineTableDirective2.default).controller('ProjectAdvanceController', _projectAdvanceController2.default).service('ProjectAdvanceFactory', _projectAdvanceFactory2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/pipeline/pipeline.html', __webpack_require__(253)); // eslint-disable-line global-require

    $templateCache.put('app/pipeline/filter/filterOptions/filterOptionsTemplate.html', __webpack_require__(254)); // eslint-disable-line global-require
    $templateCache.put('app/pipeline/filter/pipelineFilterModal.html', __webpack_require__(255)); // eslint-disable-line global-require

    $templateCache.put('app/pipeline/filterBreadcrumbs/filterBreadcrumbsTemplate.html', __webpack_require__(256)); // eslint-disable-line global-require

    $templateCache.put('app/pipeline/job/pipelineJobDetails.html', __webpack_require__(257)); // eslint-disable-line global-require
    $templateCache.put('app/pipeline/job/pipelineJobModal.html', __webpack_require__(258)); // eslint-disable-line global-require

    $templateCache.put('app/pipeline/pipelineTable/pipelineLeadsTable.html', __webpack_require__(259)); // eslint-disable-line global-require
    $templateCache.put('app/pipeline/pipelineTable/pipelineTable.html', __webpack_require__(260)); // eslint-disable-line global-require
    $templateCache.put('app/pipeline/pipelineTable/projectAdvanceTemplates/projectAdvanceInvoiced.html', __webpack_require__(261)); // eslint-disable-line global-require
    $templateCache.put('app/pipeline/pipelineTable/projectAdvanceTemplates/projectAdvancePaidBack.html', __webpack_require__(262)); // eslint-disable-line global-require
    $templateCache.put('app/pipeline/pipelineTable/projectAdvanceTemplates/projectAdvancePastDue.html', __webpack_require__(263)); // eslint-disable-line global-require
    $templateCache.put('app/pipeline/pipelineTable/projectAdvanceTemplates/projectAdvanceScheduled.html', __webpack_require__(264)); // eslint-disable-line global-require
    $templateCache.put('app/pipeline/pipelineTable/projectAdvanceTemplates/projectAdvanceSent.html', __webpack_require__(265)); // eslint-disable-line global-require
    $templateCache.put('app/pipeline/pipelineTable/projectAdvanceTemplates/projectAdvanceUnavailable.html', __webpack_require__(266)); // eslint-disable-line global-require

    // $templateCache.put('app/common/spinner/template/defaultSpinnerTemplate.html', require('./template/defaultSpinnerTemplate.html')); // eslint-disable-line global-require
}]).name;

// job


// filter/filterOptions


// filter

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = PipelineController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(236);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

PipelineController.$inject = ['$scope', '$rootScope', '$q', '$state', '$stateParams', '$filter', 'PipelineFactory', 'ProjectAdvanceFactory', 'UserData', 'ModalService', 'hpLoggerService', 'HPConfig', 'HPProjectAdvance', '$analytics', '$transitions', '$timeout']; // angular
// 	.module("HeroPRO")
// 	.controller("PipelineController", PipelineController);

/* @ngInject */
function PipelineController($scope, $rootScope, $q, $state, $stateParams, $filter, PipelineFactory, ProjectAdvanceFactory, UserData, ModalService, hpLoggerService, HPConfig, HPProjectAdvance, $analytics, $transitions, $timeout) {
    var vm = this;
    var pipelineTableReadyForData = void 0;
    var contractorId = void 0;
    vm.currentStage = 0;
    vm.PageNumber = 0;
    vm.TotalCount = 0;
    vm.loading = true;
    vm.template = '';
    vm.pipelineStages = PipelineFactory.getPipelineStages();
    vm.currentFilter = [];
    vm.visibilityFilters = PipelineFactory.pipelineVisibilityFilters;
    vm.canDownloadPipelineReport = false;
    vm.downloadPipelineReportUrl = HPConfig.heroProApi + 'Pipeline/SpreadSheet';
    vm.downloadingPipelineReport = false;

    init();

    /*= ========================================
    =            Private Functions            =
    ========================================= */
    function init() {
        pipelineTableReadyForData = $q(function (resolve) {
            $scope.$on('pipelineTableReady', resolve);
        });

        $scope.$watch(function () {
            return PipelineFactory.pipelineFilterItems;
        }, function (newVal) {
            vm.currentFilter = newVal;
        });

        setRoutedPipelineStage();
        vm.template = vm.currentStage === 1 ? 'pipelineLeadsTable' : 'pipelineTable';

        validateOptions();
        setSelectedVisibilityFilter();

        // Load pipeline data on page load
        UserData.getCurrentLocation().then(function (data) {
            contractorId = data.ContractorId;
            getPipelineData();
        });

        UserData.getUserData().then(function (response) {
            if (response.HasElevatedAccess === true) {
                vm.canDownloadPipelineReport = true;
            }
        });

        // Update pipeline data when the location dropdown is changed
        $scope.$on('HPLocationChange', function (event, data) {
            contractorId = data.ContractorId;
            PipelineFactory.clearPipelineDataOptions();
            getPipelineData();
        });

        // Update pipeline data when a column header is clicked
        $scope.$on('sortClicked', function () {
            vm.PageNumber = 0;
            getPipelineData();
        });

        // If we're coming from a non-pipeline page, clear ALL pipeline data options
        // $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState) => {
        // 	if (fromState.name !== "pipeline") {
        // 		PipelineFactory.clearPipelineDataOptions();
        // 	}
        // });

        $transitions.onStart({}, function (transition) {
            if (transition.$from().name !== 'pipeline') {
                PipelineFactory.clearPipelineDataOptions();
            }
        });
    }

    function getPipelineData() {
        vm.loading = true;
        if (vm.currentStage === 1) {
            getPipelineLeadData();
        } else {
            getPipelineLoanData();
        }
    }

    function getPipelineLeadData() {
        PipelineFactory.setPipelineDataOptions({
            PipelineStageId: vm.currentStage,
            LocationContractorId: contractorId,
            PageNumber: vm.PageNumber,
            DisplayOption: vm.selectedVisibilityFilter.filterId
        });

        PipelineFactory.getPipelineLeadData().then(function (response) {
            var data = response.data.Data;
            vm.TotalCount = data.TotalCount;
            alertPipelineTable(data.PipelineKBYGs);
            vm.loading = false;
        }, function (errResponse) {
            var loggingPayload = PipelineFactory.getPipelineState();
            _lodash2.default.extend(loggingPayload, { ErrorMessage: errResponse });
            hpLoggerService.error('Failure retrieving Pipeline Leads from API.', 'PipelineController', 'getPipelineLeadData', loggingPayload);
        });
    }

    function getPipelineLoanData() {
        PipelineFactory.setPipelineDataOptions({
            LocationContractorId: contractorId,
            PipelineStageId: vm.currentStage,
            PageNumber: vm.PageNumber,
            DisplayOption: vm.selectedVisibilityFilter.filterId
        });

        PipelineFactory.getPipelineLoanData().then(function (response) {
            var data = response.data.Data;
            getAdvancePaymentData(data);
            getProjectAdvanceData(data);
            vm.TotalCount = data.TotalCount;
            alertPipelineTable(data.PipelineFundingRequests);
            vm.loading = false;
        }, function (errResponse) {
            var loggingPayload = PipelineFactory.getPipelineState();
            _lodash2.default.extend(loggingPayload, { ErrorMessage: errResponse });
            hpLoggerService.error('Failure retrieving Pipeline Loans from API.', 'PipelineController', 'getPipelineLoanData', loggingPayload);
        });
    }

    function setSelectedVisibilityFilter() {
        if (PipelineFactory.getPipelineDataOptions().DisplayOption !== undefined) {
            // If the visibility filter has previously been set, use that value
            vm.selectedVisibilityFilter = _lodash2.default.findWhere(PipelineFactory.pipelineVisibilityFilters, { filterId: PipelineFactory.getPipelineDataOptions().DisplayOption });
        } else {
            // Otherwise, default to active projects
            vm.selectedVisibilityFilter = vm.visibilityFilters[1];
        }
    }

    function getAdvancePaymentData(fundingRequests) {
        if (fundingRequests.TotalCount !== undefined && fundingRequests.TotalCount > 0) {
            var fundingRequestIds = _lodash2.default.pluck(fundingRequests.PipelineFundingRequests, 'FundingRequestId');

            PipelineFactory.getAdvancePaymentData({ FundingRequestIds: fundingRequestIds }).then(function (response) {
                var advancePaymentData = response.data.Data;

                _lodash2.default.each(fundingRequests.PipelineFundingRequests, function (fundingRequest) {
                    fundingRequest.advancePaymentData = advancePaymentData[fundingRequest.FundingRequestId];
                    var description = void 0,
                        buttonText = '';
                    var showAdvancePaymentTooltip = false;

                    if (fundingRequest.advancePaymentData.DisbursementStatusId === 1 || fundingRequest.advancePaymentData.DisbursementStatusId === null || fundingRequest.advancePaymentData.DisbursementStatusId === undefined && vm.currentStage !== 5) {
                        // Do not show advance payment tooltips in the closed tab (pipelineStageId === 5)
                        description = 'This job is eligible for Advance Payment. Once docs are signed, payment will be sent 5 days after NTP.';
                        buttonText = 'Advance scheduled';
                        showAdvancePaymentTooltip = true;
                    } else if (fundingRequest.advancePaymentData.DisbursementStatusId === 2) {
                        description = $filter('currency')(fundingRequest.advancePaymentData.DisbursementAmount, '$', 2);
                        description += ' Advance Payment sent on ';
                        description += $filter('date')(fundingRequest.advancePaymentData.DisbursementStatusChangedDate, 'shortDate');
                        buttonText = 'Advance sent';
                        showAdvancePaymentTooltip = true;
                    } else if (fundingRequest.advancePaymentData.DisbursementStatusId === 5) {
                        description = $filter('currency')(fundingRequest.advancePaymentData.DisbursementAmount, '$', 2);
                        description += ' Advance Payment invoiced on ';
                        description += $filter('date')(fundingRequest.advancePaymentData.DisbursementStatusChangedDate, 'shortDate');
                        buttonText = 'Advance invoiced';
                        showAdvancePaymentTooltip = true;
                    }

                    fundingRequest.advancePaymentData.tooltipDescription = description;
                    fundingRequest.advancePaymentData.buttonText = buttonText;
                    fundingRequest.advancePaymentData.showAdvancePaymentTooltip = showAdvancePaymentTooltip;
                });

                alertPipelineTable(fundingRequests.PipelineFundingRequests);
            });
        }
    }

    function getProjectAdvanceData(fundingRequests) {
        if (fundingRequests.TotalCount !== undefined && fundingRequests.TotalCount > 0) {
            var fundingRequestIds = _lodash2.default.pluck(fundingRequests.PipelineFundingRequests, 'FundingRequestId');

            ProjectAdvanceFactory.getProjectAdvanceStatus({ FundingRequestIds: fundingRequestIds }).then(function (response) {
                var projectAdvanceData = response.data.Data;

                if (projectAdvanceData !== undefined && projectAdvanceData.ProjectAdvanceStatusList !== undefined && projectAdvanceData.ProjectAdvanceStatusList.length > 0) {
                    _lodash2.default.each(fundingRequests.PipelineFundingRequests, function (fundingRequest) {
                        var matchingProjAdvFound = false;
                        _lodash2.default.each(projectAdvanceData.ProjectAdvanceStatusList, function (paStatus) {
                            if (matchingProjAdvFound === false) {
                                if (fundingRequest.FundingRequestId === Number(paStatus.FundingRequestId)) {
                                    matchingProjAdvFound = true;
                                    fundingRequest.projectAdvanceData = paStatus;
                                    processProjectAdvance(fundingRequest);
                                }
                            }
                        });
                    });

                    alertPipelineTable(fundingRequests.PipelineFundingRequests);
                }
            });
        }
    }

    function alertPipelineTable(data) {
        pipelineTableReadyForData.then(function () {
            $scope.$broadcast('pipelineTableUpdate', {
                pipelineStageId: vm.currentStage,
                data: data
            });
        });
    }

    // Added function to use stateParams to set the correct currentStage.
    function setRoutedPipelineStage() {
        for (var key in vm.pipelineStages) {
            var stage = vm.pipelineStages[key];
            if (stage.pipelineStageName === $stateParams.stageName) {
                vm.currentStage = stage.pipelineStageId;
            }
        }
        // Default path if stageName does not exist as a pipeline stage.
        if (vm.currentStage === 0) {
            $state.go('pipeline', { stageName: 'leads' });
        }
    }

    // Added function to check if the current stage matches the filterDataOptions stageId.
    // If filter stage and current stage do not match, remove the filter from the PipelineFactory.
    // Added sortoptions.
    function validateOptions() {
        var filterData = PipelineFactory.getPipelineDataOptions();
        if (vm.currentStage !== filterData.PipelineStageId) {
            PipelineFactory.pipelineFilterItems = [];
            PipelineFactory.clearPipelineDataOption('filterOptions');
            PipelineFactory.clearPipelineDataOption('sortOptions');
        }
    }

    function processProjectAdvance(fundingRequest) {
        var paStatusFound = false;
        _lodash2.default.each(HPProjectAdvance, function (paConfig, key) {
            if (paStatusFound === false) {
                if (key === fundingRequest.projectAdvanceData.StatusName) {
                    paStatusFound = true;
                    fundingRequest.projectAdvanceData.template = paConfig.template;
                    fundingRequest.projectAdvanceData.buttonText = paConfig.buttonText;
                    enableProjectAdvanceTooltip(fundingRequest, paConfig);
                }
            }
        });
    }

    function enableProjectAdvanceTooltip(fundingRequest, paConfig) {
        var matchingStage = _lodash2.default.find(paConfig.stages, function (allowedStage) {
            return allowedStage === vm.currentStage;
        });

        if (matchingStage !== undefined && matchingStage !== null) {
            fundingRequest.projectAdvanceData.showProjectAdvanceTooltip = true;
        } else {
            fundingRequest.projectAdvanceData.showProjectAdvanceTooltip = false;
        }
    }

    /* -----  End of Private Functions  ------*/

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.switchPage = function (pageNumber) {
        vm.PageNumber = pageNumber - 1;
        getPipelineData();
    };

    vm.switchStage = function (pipelineStage) {
        // (ajt 11/2/2015) - Changed method to receive selected stage JS object. Assign selected Id to currentStage and set state to new selected stage
        vm.currentStage = pipelineStage.pipelineStageId;
        PipelineFactory.pipelineFilterItems = [];
        PipelineFactory.clearPipelineDataOptionsExcept('DisplayOption'); // preserve DisplayOption (visibility filter)
        vm.PageNumber = 0;
        $state.go('pipeline', { stageName: pipelineStage.pipelineStageName });
    };

    vm.displayPipelineFilter = function () {
        ModalService.launchPipelineFilterModal({
            templateUrl: 'app/pipeline/filter/pipelineFilterModal.html',
            windowClass: 'pipeline-filter-modal',
            controller: 'PipelineFilterModalController',
            controllerAs: 'pipelineFilterModal'
        });
    };

    vm.clearPipelineFilter = function () {
        PipelineFactory.pipelineFilterItems = [];
        PipelineFactory.clearPipelineDataOption('filterOptions');
        getPipelineData();
    };

    vm.visibilityFilterSelected = function (filter) {
        vm.selectedVisibilityFilter = filter;
        PipelineFactory.setPipelineDataOptions({
            DisplayOption: filter.filterId
        });
        vm.PageNumber = 0;
        getPipelineData();
    };

    vm.downloadPipelineReport = function () {
        if (vm.downloadingPipelineReport === false) {
            $analytics.eventTrack('Download Report', { category: 'Pipeline', label: vm.pipelineStages[vm.currentStage - 1].name });
            vm.downloadingPipelineReport = true;
            // Add a delay of 2s so that the spinner appears before the download
            $timeout(function () {
                vm.downloadingPipelineReport = false;
            }, 3000);
        }
    };
    /* -----  End of Public Functions  ------*/
}

/***/ }),
/* 236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = PipelineFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

PipelineFactory.$inject = ['$http', '$location', '$q', 'HPConfig']; // angular
// 	.module("HeroPRO")
// 	.factory("PipelineFactory", PipelineFactory);

/* @ngInject */
function PipelineFactory($http, $location, $q, HPConfig) {
    var pipelineState = {};

    var pipelineDataOptions = {
        // sort: {},
        // filterOptions: {}
    };

    var pipelineFilterItems = [];

    var pipelineStages = [{
        name: 'Leads',
        pipelineStageName: 'leads',
        pipelineStageId: 1
    }, {
        name: 'Application',
        pipelineStageName: 'application',
        pipelineStageId: 2
    }, {
        name: 'Start Work',
        pipelineStageName: 'startwork',
        pipelineStageId: 3
    }, {
        name: 'Get Paid',
        pipelineStageName: 'getpaid',
        pipelineStageId: 4
    }, {
        name: 'Closed',
        pipelineStageName: 'closed',
        pipelineStageId: 5
    }];

    var pipelineVisibilityFilters = [{
        filterId: 1,
        filterName: 'All Projects',
        selected: false
    }, {
        filterId: 2,
        filterName: 'Active Projects',
        selected: true
    }, {
        filterId: 3,
        filterName: 'Hidden Projects',
        selected: false
    }];

    return {
        getPipelineLoanData: getPipelineLoanData,
        getPipelineLeadData: getPipelineLeadData,
        getPipelineStages: getPipelineStages,
        setPipelineDataOptions: setPipelineDataOptions,
        getPipelineDataOptions: getPipelineDataOptions,
        clearPipelineDataOption: clearPipelineDataOption,
        clearPipelineDataOptions: clearPipelineDataOptions,
        clearPipelineDataOptionsExcept: clearPipelineDataOptionsExcept,
        pipelineFilterItems: pipelineFilterItems,
        pipelineVisibilityFilters: pipelineVisibilityFilters,
        getAdvancePaymentData: getAdvancePaymentData,
        getPipelineState: getPipelineState
    };

    function clearPipelineDataOption(optionName) {
        pipelineDataOptions = _lodash2.default.omit(pipelineDataOptions, optionName);
    }

    function clearPipelineDataOptionsExcept(key) {
        pipelineDataOptions = _lodash2.default.pick(pipelineDataOptions, key);
    }

    function clearPipelineDataOptions() {
        pipelineDataOptions = {};
    }

    function setPipelineDataOptions(options) {
        _lodash2.default.extend(pipelineDataOptions, options);
    }

    function getPipelineDataOptions() {
        return pipelineDataOptions;
    }

    function getPipelineLeadData() {
        var defaultPipelineLeadDataOptions = {
            LocationContractorId: null,
            PageSize: '20',
            PageNumber: '0',
            sortOptions: {
                SortOrderID: 1, // 1 = Descending, 2 = Ascending
                SortColumnId: 8 // 8 = Date
            }
        };

        pipelineDataOptions = _lodash2.default.omit(pipelineDataOptions, 'PipelineStageId');

        var data = angular.extend({}, defaultPipelineLeadDataOptions, pipelineDataOptions || {});

        setPipelineState(data);

        var promise = $http({
            url: HPConfig.heroProApi + 'KBYG/Pipeline/Get',
            method: 'POST',
            data: data
        });

        heroProbeLead(promise);

        return promise;
    }

    function getPipelineLoanData() {
        var defaultPipelineLoanDataOptions = {
            LocationContractorId: null,
            PageSize: '20',
            PageNumber: '0',
            sortOptions: {
                SortOrderID: 1, // 1 = Descending, 2 = Ascending
                SortColumnId: pipelineDataOptions.PipelineStageId === 5 ? 9 : 8 // 9 = FundDate, 8 = Date
            }
        };

        var data = angular.extend({}, defaultPipelineLoanDataOptions, pipelineDataOptions || {});

        setPipelineState(data);

        var promise = $http({
            url: HPConfig.heroProApi + 'Loan/FundingRequest/Pipeline',
            method: 'POST',
            data: data
        });

        heroProbeLoan(promise);

        return promise;
    }

    function getAdvancePaymentData(params) {
        return $http.get(HPConfig.heroProApi + 'Loan/FundingRequest/Pipeline/AdvancePayments', {
            params: params
        });
    }

    function getPipelineStages() {
        return pipelineStages;
    }

    function setPipelineState(data) {
        pipelineState = {};
        _lodash2.default.extend(pipelineState, data);
    }

    function getPipelineState() {
        return pipelineState;
    }

    // heroProbe
    function heroProbeLoan(promise) {
        if ($location.search().heroprobe !== undefined) {
            promise.then(function (response) {
                console.table(response.data.Data.PipelineFundingRequests, ['Owner1FirstName', 'Owner1LastName', 'FundingRequestId', 'LoanStateId', 'FundingRequestStateId', 'FinDocsStateId', 'PipelineStageId', 'FundingRequestPipelineStageId']);
            });
        }
    }

    function heroProbeLead(promise) {
        if ($location.search().heroprobe !== undefined) {
            promise.then(function (response) {
                console.table(response.data.Data.PipelineKBYGs, ['Address', 'City', 'PreQualId', 'Status', 'ApprovedAmount', 'LeadSource']);
            });
        }
    }

    // heroProbe
}

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = PipelineMappingService;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

PipelineMappingService.$inject = ['$filter']; // angular
// 	.module("HeroPRO")
// 	.factory("PipelineMappings", PipelineMappings);

/* @ngInject */
function PipelineMappingService($filter) {
    function phone(n) {
        var d = String(n).replace(/\D/g, '');
        d = ({
            7: 1,
            10: 1
        }[d.length] ? d.match(/\d{1,3}/g) : 0) || [];
        switch (d.length) {
            case 3:
                return d[0] + '-' + d[1] + d[2];
            case 4:
                return '(' + d[0] + ') ' + d[1] + '-' + d[2] + d[3];
        }
        return n;
    }

    var operators = [{
        id: 1,
        value: 3,
        label: 'Contains'
    }, {
        id: 2,
        value: 1,
        label: 'Is Equal To'
    }, {
        id: 3,
        value: 6,
        label: 'Greater Than'
    }, {
        id: 4,
        value: 5,
        label: 'Less Than'
    }, {
        id: 5,
        value: 6,
        label: 'Is After'
    }, {
        id: 6,
        value: 5,
        label: 'Is Before'
    }];

    /* API Column ID mapping
    Status 		= 1, //Result in KBYG, LoanState Everywhere but Leads
    LeadSource 	= 2, //Lead Source
    PropertyOwner 	= 3, //PO 1 First Name, Last Name
    Address 		= 4, //Street Address (KBYG), Address (Everywhere else)
    City 			= 5, //City
    Amount 		= 6, //EST Max Amount (KBYG), $ Amount
    Lessor 		= 7, //Financing Type
    Date 			= 8, //Expiration Date, Date Initiated
    FundDate 		= 9, //Est. Fund
    SalesRep 		= 10 //Sales Rep
    */

    var columns = {
        status: {
            key: 'Status',
            sort: true,
            val: function val(row) {
                if (!!row.PrequalId) {
                    return 'Lead';
                }
                return row.PipelineStatus;
            },

            apiColumnId: 1,
            filter: {
                type: 'predefined',
                key: 'status'
            }
        },
        finDocStatus: {
            key: 'Status',
            sort: true,
            val: function val(row) {
                return row.PipelineStatus;
            },

            apiColumnId: 1,
            filter: {
                type: 'predefined',
                key: 'finDocStatus'
            }
        },
        leadStatus: {
            key: 'Status',
            sort: true,
            val: function val(row) {
                return row.Status;
            },

            apiColumnId: 1,
            filter: {
                type: 'predefined',
                key: 'leadStatus'
            }
        },
        getPaidStatus: {
            key: 'Status',
            sort: true,
            val: function val(row) {
                return row.PipelineStatus;
            },

            apiColumnId: 1,
            filter: {
                type: 'predefined',
                key: 'fundingRequestStates'
            }
        },
        closedStatus: {
            key: 'Status',
            sort: true,
            val: function val(row) {
                return row.PipelineStatus;
            },

            apiColumnId: 1,
            filter: {
                type: 'predefined',
                key: 'fundingRequestStates'
            }
        },
        propertyOwner: {
            key: 'Property Owner',
            sort: true,
            val: function val(row) {
                return row.Owner1FirstName + ' ' + row.Owner1LastName;
            },

            apiColumnId: 3,
            filter: {
                type: 'propertyOwner',
                operators: [1, 2]
            }
        },
        address: {
            key: 'Address',
            sort: false,
            val: function val(row) {
                return (row.PropertyAddress1 || '') + '\n' + (row.PropertyAddress2 || '') + '\n' + (row.PropertyCity || '') + (row.PropertyCity !== undefined && row.PropertyState !== undefined ? ', ' : '') + (row.PropertyState || '') + ' ' + (row.PropertyZip || '');
            },

            apiColumnId: 4,
            filter: {
                type: 'operator',
                operators: [1, 2]
            }
        },
        strAddress: {
            key: 'Street Address',
            sort: false,
            val: function val(row) {
                return row.Address !== undefined ? row.Address.toUpperCase() : '';
            },

            apiColumnId: 4,
            filter: {
                type: 'operator',
                operators: [1, 2]
            }
        },
        city: {
            key: 'City',
            sort: true,
            val: function val(row) {
                return row.City || '';
            },

            apiColumnId: 5,
            filter: {
                type: 'operator',
                operators: [1, 2]
            }
        },
        appApproved: {
            key: '$ Approved',
            sort: true,
            val: function val(row) {
                return $filter('currency')(row.ApplicationApprovedAmount);
            },

            apiColumnId: 6,
            filter: {
                type: 'currency',
                operators: [2, 3, 4]
            }
        },
        fundingApproved: {
            key: 'Product Amount',
            sort: true,
            val: function val(row) {
                return $filter('currency')(!!row.FundingRequestTotalApproved ? row.FundingRequestTotalApproved : row.FundingRequestInitialRequested);
            },

            apiColumnId: 6,
            filter: {
                type: 'currency',
                operators: [2, 3, 4]
            }
        },
        dateInitiated: {
            key: 'Date Initiated',
            sort: true,
            val: function val(row) {
                return $filter('date')(row.CreatedDate, 'MM/dd/yyyy');
            },

            apiColumnId: 8,
            filter: {
                type: 'date',
                operators: [2, 5, 6]
            }
        },
        approvedThrough: {
            key: 'Expiration',
            sort: true,
            val: function val(row) {
                return $filter('date')(row.LoanApprovedThroughDate, 'MM/dd/yyyy');
            },

            apiColumnId: 8,
            filter: {
                type: 'date',
                operators: [2, 5, 6]
            }
        },
        saleRep: {
            sort: true,
            key: 'Sales Rep',
            val: function val(row) {
                return (row.SalesRepFirstName !== undefined ? row.SalesRepFirstName + ' ' : '') + (row.SalesRepLastName !== undefined ? row.SalesRepLastName : '');
            },

            apiColumnId: 10,
            filter: {
                type: 'predefined',
                key: 'salesRep'
            }
        },
        leadSalesRep: {
            sort: true,
            key: 'Sales Rep',
            val: function val(row) {
                return (row.RepFirstName !== undefined ? row.RepFirstName + ' ' : '') + (row.RepLastName !== undefined ? row.RepLastName + ' ' : '');
            },

            apiColumnId: 10,
            filter: {
                type: 'predefined',
                key: 'salesRep'
            }
        },
        financingType: {
            key: 'Financing Type',
            sort: true,
            val: function val(row) {
                return row.Lessor;
            },

            apiColumnId: 7
        },
        est: {
            key: 'Est Fund',
            sort: true,
            val: function val(row) {
                return $filter('date')(row.FundingRequestScheduledDisbursementDate, 'MM/dd/yyyy');
            },

            apiColumnId: 9,
            filter: {
                type: 'date',
                operators: [2, 5, 6]
            }
        },
        contact: {
            key: 'Contact',
            sort: true,
            val: function val(row) {
                return (phone(row.Owner1Phone) || '') + '\n' + (row.Owner1Email || '');
            }
        },
        heroId: {
            key: 'HERO ID',
            val: function val(row) {
                return row.HEROId;
            }
        },
        jobNumber: {
            key: 'Job Numbers',
            val: function val(row) {
                var jobnumbers = '';
                for (var number in row.JobIds) {
                    jobnumbers += row.JobIds[number] + '\n';
                }
                return jobnumbers;
            }
        },
        leadSource: {
            key: 'Lead Source',
            sort: true,
            val: function val(row) {
                if (!!row.RAApplicationID) {
                    return "Pre-Qual";
                }
                return row.LeadSource;
            },

            apiColumnId: 2
        },
        jobActions: {
            key: 'Job Actions',
            sort: false,
            apiColumnId: 0
        },
        searchExpiration: {
            key: 'Expiration',
            sort: true,
            val: function val(row) {
                if (row.PipelineStageId === 2) {
                    return $filter('date')(row.ApplicationExpirationDate, 'MM/dd/yyyy');
                } else if (row.PipelineStageId === 3 || row.PipelineStageId === 4) {
                    return $filter('date')(row.LoanApprovedThroughDate, 'MM/dd/yyyy');
                }
            },

            apiColumnId: 8,
            filter: {
                type: 'date',
                operators: [2, 5, 6]
            }
        }
    };

    return {
        columns: columns,
        mappings: {
            search: ['propertyOwner', 'address', 'contact', 'heroId', 'status', 'searchExpiration', 'jobNumber'],
            1: ['leadStatus', 'leadSource', 'strAddress', 'city', 'dateInitiated', 'leadSalesRep', 'jobActions'],
            2: ['status', 'address', 'propertyOwner', 'approvedThrough', 'saleRep', 'jobActions'],
            3: ['finDocStatus', 'address', 'propertyOwner', 'financingType', 'fundingApproved', 'approvedThrough', 'saleRep', 'jobActions'],
            4: ['getPaidStatus', 'address', 'propertyOwner', 'financingType', 'fundingApproved', 'approvedThrough', 'est', 'saleRep', 'jobActions'],
            5: ['closedStatus', 'address', 'propertyOwner', 'financingType', 'fundingApproved', 'est', 'saleRep']
        },
        getOperators: getOperators
    };

    function getOperators(columnName) {
        var result = [];
        if (columns.hasOwnProperty(columnName)) {
            if (columns[columnName].filter !== undefined && columns[columnName].filter.type === 'predefined') {} else if (columns[columnName].filter !== undefined && columns[columnName].filter.type !== 'predefined' && columns[columnName].filter.operators !== undefined) {
                var colOperators = columns[columnName].filter.operators;
                _lodash2.default.each(colOperators, function (val) {
                    result.push(_lodash2.default.findWhere(operators, {
                        id: val
                    }));
                });
            }
        } else {
            console.log(false, columnName);
        }
        return result;
    }
}

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = pipelineFilterModalController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(240);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

pipelineFilterModalController.$inject = ['$scope', 'PipelineFilterFactory', 'PipelineFactory', 'PipelineMappings', 'UserData', '$state', '$filter']; // angular
//  .module("HeroPRO")
//  .controller("PipelineFilterModalController", pipelineFilterModalController);

/* @ngInject */
function pipelineFilterModalController($scope, PipelineFilterFactory, PipelineFactory, PipelineMappings, UserData, $state, $filter) {
    var vm = this;

    vm.selectedStage = {};
    vm.lastStage = {};
    vm.selectedColumn = {};
    vm.selectedOperator = {};

    vm.filterValue = '';
    vm.filterFirstName = '';

    vm.opened = false;

    vm.filterTermPlaceholderText = 'Enter Term';
    vm.filterPOPlaceholderText = 'Enter First Name';
    vm.filterDatePlaceholderText = 'Select a Date';

    vm.pipelineStages = [];
    vm.stageColumns = [];
    vm.operators = [];

    vm.datepickerOptions = {
        formatDay: 'dd',
        formatMonth: 'MM',
        formatYear: 'yyyy',
        showWeeks: false,
        startingDay: 0
    };

    vm.defaultStage = {
        name: '-- Select a Stage --',
        pipelineStageName: 'null',
        pipelineStageId: -1
    };
    vm.defaultColumn = {
        key: '-- Select a Column --',
        mapping: 'none',
        apiColumnId: -1
    };
    vm.defaultOperator = {
        id: -1,
        value: 'none',
        label: '-- Select a Filter Operator --'
    };

    /*= =======================================
    =            Private Functions            =
    ======================================== */
    function initializeFields() {
        vm.filterValue = '';
        vm.filterFirstName = '';
    }

    function getColumns() {
        vm.stageColumns = _lodash2.default.reject(PipelineFilterFactory.getStageColumns(vm.selectedStage.pipelineStageId), function (col) {
            return col.filter === undefined;
        });
        if (_lodash2.default.findWhere(vm.stageColumns, {
            mapping: 'none'
        }) === undefined) {
            vm.stageColumns.unshift(vm.defaultColumn);
        }
        vm.selectedColumn = vm.stageColumns[0];
    }

    function getOperators() {
        if (vm.selectedColumn.filter.type === 'predefined') {
            switch (vm.selectedColumn.filter.key) {
                case 'status':
                case 'finDocStatus':
                case 'fundingRequestStates':
                case 'closedStatus':
                    vm.operators = _lodash2.default.filter(PipelineFilterFactory.getFilterOptions()[vm.selectedColumn.filter.key], function (status) {
                        return status.pipelineStageId === vm.selectedStage.pipelineStageId;
                    });
                    break;
                case 'leadStatus':
                    vm.operators = _lodash2.default.map(PipelineFilterFactory.getFilterOptions()[vm.selectedColumn.filter.key], function (leadStatus) {
                        return {
                            id: leadStatus.id,
                            value: leadStatus.value,
                            label: leadStatus.label
                        };
                    });
                    break;
                default:
                    vm.operators = PipelineFilterFactory.getFilterOptions()[vm.selectedColumn.filter.key];
                    break;
            }
        } else {
            vm.operators = PipelineMappings.getOperators(vm.selectedColumn.mapping);
        }
        vm.selectedOperator = vm.operators[0];
    }

    function deconstructFilterData(data) {
        // Find Stage dropdown value
        if (data.PipelineStageId !== undefined && data.PipelineStageId !== null) {
            var stg = _lodash2.default.find(vm.pipelineStages, function (stage) {
                return stage.pipelineStageId === data.PipelineStageId;
            });
            if (stg !== undefined && stg !== null) {
                vm.selectedStage = stg;
            }
        } else {
            vm.selectedStage = _lodash2.default.find(vm.pipelineStages, function (stage) {
                return stage.pipelineStageId === 1;
            });
        }
        getColumns();

        // Find Column dropdown value.
        if (data.filterOptions.FilterColumnId !== undefined && data.filterOptions.FilterColumnId !== null) {
            var col = _lodash2.default.find(vm.stageColumns, function (column) {
                return column.apiColumnId === data.filterOptions.FilterColumnId;
            });
            if (col !== undefined && col !== null) {
                vm.selectedColumn = col;
            }
            getOperators();
        }

        // Find Operator dropdown value.
        var opr = void 0;
        if (vm.selectedColumn.filter.type === 'predefined') {
            opr = _lodash2.default.find(vm.operators, function (operator) {
                return operator.value === data.filterOptions.Value;
            });
            if (opr !== undefined && opr !== null) {
                vm.selectedOperator = opr;
            }
        } else {
            if (data.filterOptions.FilterOperatorId !== undefined && data.filterOptions.FilterOperatorId !== null) {
                opr = _lodash2.default.find(vm.operators, function (operator) {
                    return operator.value === data.filterOptions.FilterOperatorId;
                });
                if (opr !== undefined && opr !== null) {
                    vm.selectedOperator = opr;
                }
            }

            // Populate field values.
            if (data.filterOptions.Value !== undefined && data.filterOptions.Value !== null && data.filterOptions.Value !== '') {
                vm.filterValue = data.filterOptions.Value;
                if (vm.selectedColumn.filter.type === 'propertyOwner') {
                    vm.filterTermPlaceholderText = 'Enter Last Name';
                } else {
                    vm.filterTermPlaceholderText = 'Enter Term';
                }
            }
            if (data.filterOptions.Value2 !== undefined && data.filterOptions.Value2 !== null && data.filterOptions.Value2 !== '') {
                vm.filterFirstName = data.filterOptions.Value2;
            }
        }
    }

    function getStages() {
        vm.pipelineStages = _lodash2.default.map(PipelineFactory.getPipelineStages(), _lodash2.default.clone);
        if (_lodash2.default.findWhere(vm.pipelineStages, {
            pipelineStageId: -1
        }) === undefined) {
            vm.pipelineStages.unshift(vm.defaultStage);
        }
        var options = PipelineFactory.getPipelineDataOptions();
        if (options.filterOptions !== undefined && options.filterOptions !== null) {
            deconstructFilterData(options);
        } else {
            vm.selectedStage = vm.pipelineStages[0];
            initializeFields();
        }
    }

    function loadFilterData() {
        PipelineFilterFactory.getFilterOptions();
    }

    function getSalesReps() {
        UserData.getCurrentLocation().then(function (currentLocation) {
            if (currentLocation.ContractorId === '') {
                UserData.getUserLocations().then(function (response) {
                    var contractorIds = _lodash2.default.reject(_lodash2.default.pluck(response, 'ContractorId'), function (val) {
                        return val === '';
                    });
                    PipelineFilterFactory.getSalesReps(contractorIds);
                });
            } else {
                PipelineFilterFactory.getSalesReps(currentLocation.ContractorId);
            }
        });
    }

    function constructFilterData() {
        var requestData = {};

        requestData.FilterColumnId = vm.selectedColumn.apiColumnId === -1 ? '' : vm.selectedColumn.apiColumnId;

        if (vm.selectedColumn.filter && vm.selectedColumn.filter.type === 'predefined') {
            requestData.FilterOperatorId = 1;
            requestData.Value = vm.selectedOperator.value;
        } else {
            requestData.FilterOperatorId = vm.selectedOperator.id === -1 ? '' : vm.selectedOperator.value;
            requestData.Value = vm.filterValue === undefined ? '' : vm.filterValue;
            if (vm.filterFirstName !== undefined && vm.filterFirstName !== null && vm.filterFirstName !== '') {
                requestData.Value2 = vm.filterFirstName;
            }
        }

        return requestData;
    }

    function constructFilterDataset() {
        var path = [vm.selectedStage.name];
        if (vm.selectedColumn.apiColumnId !== -1) {
            path.push(vm.selectedColumn.key);
        }
        if (vm.selectedOperator.id !== undefined && vm.selectedOperator.id !== -1) {
            path.push(vm.selectedOperator.label);
        }
        if (vm.filterFirstName !== undefined && vm.filterFirstName !== '' && vm.filterValue !== undefined && vm.filterValue !== '') {
            path.push(vm.filterFirstName + ' ' + vm.filterValue);
        } else if (vm.filterValue !== undefined && vm.filterValue !== '' && vm.selectedColumn.filter.type === 'date') {
            path.push($filter('date')(vm.filterValue, 'MM/dd/yyyy'));
        } else if (vm.filterValue !== undefined && vm.filterValue !== '' && vm.selectedColumn.filter.type === 'currency') {
            path.push($filter('currency')(vm.filterValue));
        } else if (vm.filterValue !== undefined && vm.filterValue !== '') {
            path.push(vm.filterValue);
        }
        return path;
    }

    function init() {
        getStages();
        getSalesReps();
        loadFilterData();
    }

    init();
    /* -----  End of Private Functions  ------ */

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.closePipelineFilterModal = function closePipelineFilterModal() {
        $scope.$close();
    };

    vm.stageClicked = function stageClicked(item) {
        vm.selectedStage = item;
        if (item.pipelineStageId === -1) {
            vm.stageColumns = [];
            vm.operators = [];
        } else {
            getColumns();
            vm.operators = [];
            initializeFields();
        }
    };

    vm.columnClicked = function columnClicked(item) {
        vm.selectedColumn = item;
        if (item.mapping !== 'none') {
            getOperators();
            initializeFields();
            if (vm.selectedColumn.mapping === 'propertyOwner') {
                vm.filterTermPlaceholderText = 'Enter Last Name';
            } else {
                vm.filterTermPlaceholderText = 'Enter Term';
            }
        } else {
            vm.operators = [];
            initializeFields();
        }
    };

    vm.operatorClicked = function operatorClicked(item) {
        vm.selectedOperator = item;
    };

    vm.submitFilter = function submitFilter(isValid) {
        if (isValid) {
            if (vm.selectedStage.pipelineStageId !== -1) {
                var filterData = constructFilterData();
                var dataOptions = {
                    PipelineStageId: vm.selectedStage.pipelineStageId,
                    filterOptions: filterData
                };
                PipelineFactory.setPipelineDataOptions(dataOptions);
                PipelineFactory.clearPipelineDataOption('sortOptions');
                PipelineFactory.pipelineFilterItems = constructFilterDataset();
            } else {
                PipelineFactory.clearPipelineDataOption('filterOptions');
                PipelineFactory.pipelineFilterItems = [];
                vm.selectedStage = vm.lastStage;
                vm.lastStage = {};
            }
            vm.closePipelineFilterModal();
            $state.go('pipeline', {
                stageName: vm.selectedStage.pipelineStageName
            }, {
                reload: true
            });
        }
    };

    vm.clearClicked = function clearClicked() {
        vm.lastStage = _lodash2.default.clone(vm.selectedStage);
        vm.selectedStage = vm.pipelineStages[0];
        vm.stageColumns = [];
        vm.operators = [];
    };

    vm.open = function open() {
        if (vm.opened === true) {
            vm.opened = false;
        } else {
            vm.opened = true;
        }
    };

    /* -----  End of Public Functions  ------ */
}

/***/ }),
/* 240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = pipelineFilterFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

pipelineFilterFactory.$inject = ['PipelineMappings', '$http', 'HPConfig', 'ModalService']; // angular
// 	.module("HeroPRO")
// 	.factory("PipelineFilterFactory", pipelineFilterFactory);

/* @ngInject */
function pipelineFilterFactory(PipelineMappings, $http, HPConfig, ModalService) {
    var filterOptions = {
        status: [],
        leadSource: [],
        salesRep: [],
        financingType: [],
        leadStatus: [{
            id: 1,
            value: 'green',
            label: 'Green'
        }, {
            id: 2,
            value: 'yellow',
            label: 'Yellow'
        }, {
            id: 3,
            value: 'red',
            label: 'Red'
        }, {
            id: 4,
            value: 'grey',
            label: 'Grey'
        }],
        fundingRequestStates: []
    };

    function buildStatesFilterOptions(states) {
        var transformedStatuses = _lodash2.default.map(states, function (state) {
            return {
                id: state.LoanStateId,
                value: state.LoanStateId,
                label: state.Description,
                pipelineStageId: state.PipelineStageId
            };
        });
        transformedStatuses = _lodash2.default.sortBy(transformedStatuses, 'label');
        filterOptions.status = transformedStatuses;
    }

    function buildFinDocStatesFilterOptions(states) {
        var transformedStatuses = _lodash2.default.map(states, function (state) {
            return {
                id: state.FinDocsStateId,
                value: state.FinDocsStateId,
                label: state.Description,
                pipelineStageId: state.PipelineStageId
            };
        });
        transformedStatuses = _lodash2.default.sortBy(transformedStatuses, 'label');
        filterOptions.finDocStatus = transformedStatuses;
    }

    function buildFundingStatesFilterOptions(states) {
        var transformedStatuses = _lodash2.default.map(states, function (state) {
            return {
                id: state.FundingRequestStateId,
                value: state.FundingRequestStateId,
                label: state.Description,
                pipelineStageId: state.PipelineStageId
            };
        });
        transformedStatuses = _lodash2.default.filter(transformedStatuses, function (status) {
            return status.id !== 1;
        });
        transformedStatuses = _lodash2.default.sortBy(transformedStatuses, 'label');
        filterOptions.fundingRequestStates = transformedStatuses;
    }

    return {
        getStageColumns: function getStageColumns(stageId) {
            var columns = PipelineMappings.columns;
            var mappings = PipelineMappings.mappings[stageId];
            var dataset = _lodash2.default.map(mappings, function (mapping) {
                for (var key in columns) {
                    if (columns.hasOwnProperty(key) && key === mapping) {
                        return _lodash2.default.extend(columns[key], {
                            mapping: mapping
                        });
                    }
                }
            });
            return dataset;
        },
        getSalesReps: function getSalesReps(payload) {
            $http({
                url: HPConfig.heroProApi + 'ContractorUser',
                method: 'GET',
                cache: true,
                params: {
                    ContractorLocationIds: payload
                }
            }).then(function (response) {
                var transformedReps = _lodash2.default.map(response.data.Data, function (rep) {
                    return {
                        id: rep.ContractorUserId,
                        value: rep.ContractorUserId,
                        label: rep.FirstName + ' ' + rep.LastName
                    };
                });
                transformedReps = _lodash2.default.sortBy(transformedReps, 'label');
                filterOptions.salesRep = transformedReps;
            });
        },
        getFilterOptions: function getFilterOptions() {
            if (filterOptions.status.length === 0) {
                $http({
                    url: HPConfig.heroProApi + 'Loan/Filters',
                    method: 'GET',
                    cache: true
                }).then(function (response) {
                    // Process  filter options
                    buildStatesFilterOptions(response.data.Data.LoanStates);
                    buildFinDocStatesFilterOptions(response.data.Data.FinDocsStates);
                    buildFundingStatesFilterOptions(response.data.Data.FundingRequestStates);
                }, function () {
                    // Close Filter Modal if open. Display error page.
                    var modal = ModalService.getPipelineFilterModal();
                    if (modal !== undefined && modal !== null) {
                        modal.close();
                    }
                });
            }
            return filterOptions;
        }
    };
}

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = FilterOptionDirective;

__webpack_require__(243);

function FilterOptionDirective() {
    return {
        restrict: 'E',
        templateUrl: 'app/pipeline/filter/filterOptions/filterOptionsTemplate.html',
        scope: {
            label: '=',
            value: '=',
            isStatus: '='
        },
        controllerAs: 'filterOptn'
    };
} // angular.module('HeroPRO')
// 	.directive('filterOption',

/***/ }),
/* 243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = FilterBreadcrumbsDirective;
// angular.module('HeroPRO')
// 	.directive('filterBreadcrumbs',


function FilterBreadcrumbsDirective() {
    return {
        restrict: 'E',
        templateUrl: 'app/pipeline/filterBreadcrumbs/filterBreadcrumbsTemplate.html',
        scope: {
            dataset: '=',
            removeFilter: '&',
            launchModal: '&'
        }
    };
}

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = pipelineJobModalController;

__webpack_require__(246);

pipelineJobModalController.$inject = ['$scope', 'ModalService', 'JobFactory', 'raSpinnerService']; // angular
// 	.module("HeroPRO")
// 	.controller("PipelineJobModalController", pipelineJobModalController);

/* @ngInject */
function pipelineJobModalController($scope, ModalService, JobFactory, raSpinnerService) {
    var vm = this;
    var jobModal = {};

    vm.isAssignMode = false;

    vm.propertyOwner = '';
    vm.streetAddress = '';
    vm.cityStateZip = '';

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    vm.closeJobModal = function () {
        ModalService.closeLgModal();
        raSpinnerService._unregister('jobSpinner');
    };

    jobModal.result.then(function () {}, function () {
        raSpinnerService._unregister('jobSpinner');
    });

    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */
    function init() {
        var job = JobFactory.getActiveJob();
        vm.isAssignMode = JobFactory.getAssignJobFlag();
        if (job.PreQualId !== undefined && job.PreQualId !== null && job.PreQualId !== '') {
            vm.streetAddress = job.Address;
            vm.cityStateZip = job.City;
        } else {
            vm.propertyOwner = job.Owner1FirstName + ' ' + job.Owner1LastName;
            vm.streetAddress = job.PropertyAddress1;
            vm.cityStateZip = job.PropertyCity + ', ' + job.PropertyState + ' ' + job.PropertyZip;
        }

        jobModal = ModalService.getLgModal();
    }
}

/***/ }),
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = PipelineTableController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(248);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

PipelineTableController.$inject = ['$scope', '$state', '$analytics', 'PipelineMappings', 'PipelineFactory', 'ProjectAdvanceFactory', 'ModalService', 'JobFactory']; // angular
// 	.module("HeroPRO")
// 	.controller("PipelineTableController", PipelineTableController);

/* @ngInject */
function PipelineTableController($scope, $state, $analytics, PipelineMappings, PipelineFactory, ProjectAdvanceFactory, ModalService, JobFactory) {
    var vm = this;
    vm.columns = PipelineMappings.columns;
    vm.data = [];
    vm.currentSort = {};
    vm.pipelineStageId = null;

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.goToAppDetail = function (row) {
        if (row.PrequalId !== undefined) {
            $state.go('lead', {
                prequalId: row.PrequalId
            });
        } else {
            $state.go('app-detail', {
                appId: row.FundingRequestId
            });
        }
    };

    vm.goToLeadDetail = function (row) {
        $state.go('lead', {
            prequalId: row.PreQualId
        });
    };

    vm.headerClick = function (column) {
        if (PipelineMappings.columns[column].sort === true) {
            if (vm.columns[column].apiColumnId === vm.currentSort.SortColumnId) {
                // Current column that we're sorting by was clicked, change sort order
                vm.currentSort.SortOrderID = vm.currentSort.SortOrderID === 1 ? 2 : 1;
            } else {
                // Sort by a new column
                vm.currentSort.SortColumnId = vm.columns[column].apiColumnId;
                vm.currentSort.SortOrderID = 1;
            }

            PipelineFactory.setPipelineDataOptions({
                sortOptions: vm.currentSort
            });
            $scope.$emit('sortClicked');
        }
    };

    vm.showExpirationPopover = function (pipelineEntry) {
        if (pipelineEntry.PipelineStageId === 2 && pipelineEntry.daysToExpiration <= 10 || (pipelineEntry.PipelineStageId === 3 || pipelineEntry.PipelineStageId === 4) && pipelineEntry.daysToExpiration <= 30) {
            return true;
        }
        return false;
    };

    vm.getExpirationMessage = function (pipelineEntry) {
        if (pipelineEntry.daysToExpiration <= 0) {
            return 'Expired';
        } else if (pipelineEntry.daysToExpiration === 1) {
            return 'Expiring in 1 day';
        }
        return 'Expiring in ' + pipelineEntry.daysToExpiration + ' days';
    };

    vm.launchAssignJobModal = function (row, $event) {
        $event.preventDefault();
        $event.stopPropagation();
        JobFactory.setActiveJob(row);
        JobFactory.setAssignJobFlag(true);

        $analytics.eventTrack('Open Assign Modal', {
            category: 'AssignJob',
            label: PipelineFactory.getPipelineStages()[vm.pipelineStageId - 1].name
        });

        ModalService.launchLgModal({
            templateUrl: 'app/pipeline/job/pipelineJobModal.html',
            windowClass: 'pipeline-job-modal',
            controller: 'PipelineJobModalController',
            controllerAs: 'pipelineJobModal'
        });
    };

    vm.launchHideJobModal = function (row, $event) {
        $event.preventDefault();
        $event.stopPropagation();
        JobFactory.setActiveJob(row);
        JobFactory.setAssignJobFlag(false);

        $analytics.eventTrack('Open Hide Modal', {
            category: 'HideAJob',
            label: PipelineFactory.getPipelineStages()[vm.pipelineStageId - 1].name
        });

        ModalService.launchLgModal({
            templateUrl: 'app/pipeline/job/pipelineJobModal.html',
            windowClass: 'pipeline-job-modal',
            controller: 'PipelineJobModalController',
            controllerAs: 'pipelineJobModal'
        });
    };

    vm.unhideJob = function (row, $event, undo) {
        $event.preventDefault();
        $event.stopPropagation();

        if (undo !== undefined && undo === true) {
            $analytics.eventTrack('Click Undo Button', {
                category: 'HideAJob',
                label: PipelineFactory.getPipelineStages()[vm.pipelineStageId - 1].name
            });
        } else {
            $analytics.eventTrack('Click UnHide Button', {
                category: 'HideAJob',
                label: PipelineFactory.getPipelineStages()[vm.pipelineStageId - 1].name
            });
        }

        if (row.FundingRequestId !== undefined) {
            JobFactory.unhideApplication({
                FundingRequestId: row.FundingRequestId
            }).then(function () {
                row.hidden.status = false;
                row.unhidden.status = true;
                row.unhidden.address = row.PropertyAddress1 + ' ' + row.PropertyCity + ', ' + row.PropertyState + ' ' + row.PropertyZip;
            });
        } else if (row.PreQualId !== undefined) {
            JobFactory.unhideLead({
                PreQualId: row.PreQualId
            }).then(function () {
                row.hidden.status = false;
                row.unhidden.status = true;
                row.unhidden.address = row.Address;
            });
        }
    };

    vm.jobActionsClick = function ($event) {
        $event.preventDefault();
        $event.stopPropagation();
    };

    // Track popover opening to change arrow direction
    vm.clickAdvPayPopover = function (row) {
        row.popoverOpen = !row.popoverOpen;
    };

    // Track popover opening to change arrow direction
    vm.clickProjAdvPopover = function (row) {
        ProjectAdvanceFactory.setActiveProjectAdvanceFundingRequestId({
            FundingRequestId: row.FundingRequestId
        });
        row.paPopoverOpen = !row.paPopoverOpen;
    };

    /* -----  End of Public Functions  ------*/

    /*= ========================================
    =            Private Functions            =
    ========================================= */
    function init() {
        $scope.$on('pipelineTableUpdate', handleNewPipelineData);
        $scope.$emit('pipelineTableReady');
        $scope.$on('pipelineJobAssignment', handleAssignment);
        $scope.$on('pipelineHideJob', handleHide);
    }

    function handleNewPipelineData(ev, data) {
        vm.pipelineStageId = data.pipelineStageId;
        vm.mappings = PipelineMappings.mappings[vm.pipelineStageId];
        vm.data = data.data;
        processPipelineData();
        setCurrentSortOptions(PipelineFactory.getPipelineDataOptions(), data.pipelineStageId);
    }

    function setCurrentSortOptions(sortOptions, pipelineStageId) {
        if (PipelineFactory.getPipelineDataOptions().sortOptions === undefined) {
            vm.currentSort.SortColumnId = pipelineStageId === 5 ? 9 : 8; // 9 = FundDate, 8 = Date
            vm.currentSort.SortOrderID = 1; // 1 = Descending, 2 = Ascending
        } else {
            vm.currentSort.SortColumnId = sortOptions.sortOptions.SortColumnId;
            vm.currentSort.SortOrderID = sortOptions.sortOptions.SortOrderID;
        }
    }

    function processPipelineData() {
        _lodash2.default.each(vm.data, function (pipelineEntry) {
            // Set some defaults for each pipeline entry
            pipelineEntry.reassigned = {};
            pipelineEntry.reassigned.status = false;
            pipelineEntry.hidden = {};
            pipelineEntry.hidden.status = false;
            pipelineEntry.unhidden = {};
            pipelineEntry.unhidden.status = false;
            pipelineEntry.daysToExpiration = calculateExpirationDate(pipelineEntry);
            if (pipelineEntry.advancePaymentData !== undefined && pipelineEntry.advancePaymentData.APEligible === true) {
                pipelineEntry.popoverOpen = false;
            }
            if (pipelineEntry.projectAdvanceData !== undefined && pipelineEntry.projectAdvanceData !== null) {
                pipelineEntry.paPopoverOpen = false;
            }
        });
    }

    function calculateExpirationDate(pipelineEntry) {
        var expirationSource = null;

        if (pipelineEntry.PipelineStageId === 2 || pipelineEntry.PipelineStageId === 3 || pipelineEntry.PipelineStageId === 4) {
            expirationSource = 'LoanApprovedThroughDate';
        }

        if (expirationSource !== null) {
            var timeDiff = new Date(pipelineEntry[expirationSource]).getTime() - new Date().getTime();
            var daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
            return daysDiff;
        }
        return 99; // Setting a large default
    }

    // (ajt 1/3/2016) - [HP-162] Added new subscriber method to handle job assignments based on Lead vs Application/Loan
    function handleAssignment(ev, data) {
        var assignedJob = data.data;
        if (assignedJob.PreQualId !== undefined && assignedJob.PreQualId !== null && assignedJob.PreQualId !== '') {
            for (var i = 0; i < vm.data.length; i++) {
                if (vm.data[i].PreQualId === assignedJob.PreQualId) {
                    vm.data[i].reassigned.status = true;
                    vm.data[i].reassigned.locationName = assignedJob.Location;
                    vm.data[i].reassigned.salesRepName = assignedJob.SalesRepName;
                }
            }
        } else {
            for (var j = 0; j < vm.data.length; j++) {
                if (vm.data[j].FundingRequestId === assignedJob.FundingRequestId) {
                    vm.data[j].reassigned.status = true;
                    vm.data[j].reassigned.locationName = assignedJob.Location;
                    vm.data[j].reassigned.salesRepName = assignedJob.SalesRepName;
                }
            }
        }
    }

    // (ajt 4/4/2016) - [HP-1179] Added new subscriber method to handle hiding jobs based on Lead vs Application/Loan
    function handleHide(ev, data) {
        var hiddenJob = data.data;
        if (hiddenJob.PreQualId !== undefined && hiddenJob.PreQualId !== null && hiddenJob.PreQualId !== '') {
            for (var i = 0; i < vm.data.length; i++) {
                if (vm.data[i].PreQualId === hiddenJob.PreQualId) {
                    vm.data[i].hidden.status = true;
                    vm.data[i].hidden.address = hiddenJob.Address;
                }
            }
        } else {
            for (var j = 0; j < vm.data.length; j++) {
                if (vm.data[j].FundingRequestId === hiddenJob.FundingRequestId) {
                    vm.data[j].hidden.status = true;
                    vm.data[j].hidden.address = hiddenJob.Address;
                }
            }
        }
    }

    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PipelineTable;
// angular
//   .module("HeroPRO")
//   .directive("pipelineTable", PipelineTable);

function PipelineTable() {
  return {
    controller: 'PipelineTableController',
    controllerAs: 'pipelineTable',
    bindToController: true,
    restrict: 'E',
    scope: {
      template: '@template', // string
      source: '@source' // string
    },
    link: function link(scope, element, attrs) {
      scope.getContentUrl = function () {
        return 'app/pipeline/pipelineTable/' + attrs.template + '.html';
      };
    },

    template: '<div class="pipeline-scroll" ng-include="getContentUrl()"></div>'
  };
}

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = projectAdvanceController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(251);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

projectAdvanceController.$inject = ['ProjectAdvanceFactory']; // angular
// 	.module("HeroPRO")
// 	.controller("ProjectAdvanceController", projectAdvanceController);

/* @ngInject */
function projectAdvanceController(ProjectAdvanceFactory) {
    var vm = this;
    vm.loadingData = true;
    vm.advanceData = {};

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */

    function init() {
        ProjectAdvanceFactory.getProjectAdvanceDetails().then(function (response) {
            vm.advanceData = response.data.Data;
            vm.loadingData = false;
        });
    }

    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = projectAdvanceFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

projectAdvanceFactory.$inject = ['$q', '$http', 'HPConfig']; // angular
// 	.module("HeroPRO")
// 	.factory("ProjectAdvanceFactory", projectAdvanceFactory);

/* @ngInject */
function projectAdvanceFactory($q, $http, HPConfig) {
    var _projectAdvanceDetailPromise = void 0;
    var _activeAdvanceId = {};

    return {
        getProjectAdvanceStatus: getProjectAdvanceStatus,
        getProjectAdvanceDetails: getProjectAdvanceDetails,
        setActiveProjectAdvanceFundingRequestId: setActiveProjectAdvanceFundingRequestId,
        getProjectAdvanceDetailsPromise: getProjectAdvanceDetailsPromise
    };

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    function getProjectAdvanceStatus(params) {
        return $http.get(HPConfig.heroProApi + 'PEFI/ProjectAdvanceStatus', {
            params: params
        });
    }

    function getProjectAdvanceDetails(params) {
        _projectAdvanceDetailPromise = $q(function (resolve) {
            $http.get(HPConfig.heroProApi + 'PEFI/ProjectAdvanceDetails', {
                params: params !== null && params !== undefined ? params : _activeAdvanceId
            }).then(function (response) {
                resolve(response);
            });
        });

        return _projectAdvanceDetailPromise;
    }

    function getProjectAdvanceDetailsPromise() {
        return _projectAdvanceDetailPromise;
    }

    function setActiveProjectAdvanceFundingRequestId(fundingRequestId) {
        _activeAdvanceId = fundingRequestId;
    }

    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */

    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-module pipeline-module\">\n\t<div class=\"hp-inner\">\n\t\t<div class=\"pipeline-header\">\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<h1>Pipeline</h1>\n\t\t\t\t</div>\n\n        \t\t<div class=\"col-md-5\">\n            \t\t<filter-breadcrumbs dataset=\"pipeline.currentFilter\" remove-filter=\"pipeline.clearPipelineFilter();\" launch-modal=\"pipeline.displayPipelineFilter();\" ng-if=\"pipeline.loading === false\"></filter-breadcrumbs>\n        \t\t</div>\n\n\t\t        <div class=\"col-md-2 pipeline-header-btn\" ng-if=\"pipeline.loading === false\">\n\t\t        \t<button class=\"btn btn-pipeline-filter\" ng-class=\"{'btn-default' : pipeline.currentFilter.length === 0, 'btn-primary' : pipeline.currentFilter.length > 0 }\" ng-click=\"pipeline.displayPipelineFilter()\">\n\t\t            \t<span ng-if=\"pipeline.currentFilter == ''\">Filter</span>\n\t\t            \t<span ng-if=\"pipeline.currentFilter != ''\">Filtered</span>\n\t\t          \t</button>\n\t\t        </div>\n\n\t\t        <div class=\"col-md-3\">\n\t\t\t\t\t<div class=\"dropdown dropdown-bordered\" uib-dropdown dropdown-title=\"Job Status\" ng-if=\"$root.screenSize ==='large' && pipeline.loading === false\">\n                        <a blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle data-toggle=\"dropdown\">\n                            <span class=\"dropdown-text\">{{pipeline.selectedVisibilityFilter.filterName}}</span>\n                            <span class=\"icon\"></span>\n                        </a>\n                        <ul class=\"dropdown-menu\" uib-dropdown-menu>\n                            <li ng-repeat=\"filter in pipeline.visibilityFilters\"\n                                ng-class=\"{'active': pipeline.selectedVisibilityFilter.filterId === filter.filterId }\"\n                                ng-click=\"pipeline.visibilityFilterSelected(filter)\">\n                                <span>{{filter.filterName}}</span>\n                            </li>\n                        </ul>\n                    </div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=\"row\" ng-if=\"pipeline.canDownloadPipelineReport === true\">\n\t\t\t\t<div class=\"col-md-12\">\n\t\t\t\t\t<hp-spinner-link link-text=\"Download Pipeline\" link-fn=\"pipeline.downloadPipelineReport()\" link-url=\"pipeline.downloadPipelineReportUrl\" display-spinner=\"pipeline.downloadingPipelineReport === true\" icon=\"download-thick\"></hp-spinner-link>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div><!-- pipeline-header -->\n\n\t\t<div class=\"pipeline-nav navbar\">\n\t\t\t<ul class=\"nav navbar-nav\">\n\t\t\t\t<li ng-repeat=\"stage in pipeline.pipelineStages\" >\n\t\t\t\t\t<a ng-bind=\"stage.name\" ng-click=\"pipeline.switchStage(stage);\" ng-class=\"{ 'active': stage.pipelineStageId === pipeline.currentStage }\"></a>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t</div><!-- pipeline-nav -->\n\n\t\t<div ra-spinner hide-content-when-shown=\"true\" show=\"pipeline.loading\" class=\"hp-loading-spinner\" name=\"pipelineTableSpinner\">\n\t\t\t<pipeline-table template=\"{{pipeline.template}}\" source=\"pipeline\" ng-if=\"pipeline.TotalCount !== 0 || (pipeline.TotalCount === 0 && pipeline.loading === true)\"></pipeline-table>\n\t\t\t<div class=\"pipeline-pagination\" ng-if=\"pipeline.TotalCount !== 0 || (pipeline.TotalCount === 0 && pipeline.loading === true)\">\n\t\t\t\t<paging\n\t\t\t\tclass=\"small\"\n\t\t\t\tpage=\"pipeline.PageNumber + 1\"\n\t\t\t\tpage-size=\"20\"\n\t\t\t\ttotal=\"pipeline.TotalCount\"\n\t\t\t\thide-if-empty=\"false\"\n\t\t\t\tshow-prev-next=\"true\"\n\t\t\t\tpaging-action=\"pipeline.switchPage(page);\"></paging>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"pipeline-no-results text-center\" ng-if=\"pipeline.TotalCount === 0 && pipeline.loading === false\">\n\t\t\t<p><span class=\"icon icon-resources\"></span></p>\n\t\t\t<h3>There are no projects available</h3>\n\t\t</div>\n\t</div>\n</div>\n";

/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports = "<div class=\"filter-option-container\">\n    <div class=\"circle {{value}}\" ng-show=\"isStatus && value !== ''\"></div>\n    <div class=\"lead-status-filter\">{{label}}</div>\n</div>\n\n";

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <span class=\"icon icon-delete-circle\" ng-click=\"pipelineFilterModal.closePipelineFilterModal();\"></span>\n</div>\n\n<div class=\"modal-body\">\n    <p class=\"modal-title\">Filter the Pipeline</p>\n\n    <form id=\"pipeline-filter-form\" name=\"pipelineFilterForm\" class=\"pipeline-filter-form\"\n          ng-submit=\"pipelineFilterModal.submitFilter(pipelineFilterForm.$valid)\" novalidate>\n        <div>\n            <div class=\"row\">\n                <div class=\"col-md-7\">\n                    <div class=\"pipeline-filter-label-container\">\n                        <label>Which stage do you want to view? </label>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-7\">\n                    <div class=\"dropdown\" uib-dropdown dropdown-small-popup dropdown-title=\"Stages\">\n                        <a id=\"ddl-pipeline-stages\" blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle\n                           data-toggle=\"dropdown\">\n                            <span class=\"dropdown-text\">{{pipelineFilterModal.selectedStage.name}}</span>\n                            <span class=\"icon\"></span>\n                        </a>\n                        <ul class=\"dropdown-menu\" uib-dropdown-menu>\n                            <li ng-repeat=\"stage in pipelineFilterModal.pipelineStages\"\n                                ng-class=\"{'active': pipelineFilterModal.selectedStage.name === stage.name }\"\n                                ng-click=\"pipelineFilterModal.stageClicked(stage, $event)\">\n                                <span>{{stage.name}}</span>\n                            </li>\n                        </ul>\n                    </div>\n                </div>\n            </div>\n            <div ng-if=\"pipelineFilterModal.stageColumns.length > 0\">\n                <div class=\"row\">\n                    <div class=\"col-md-7\">\n                        <div class=\"pipeline-filter-label-container\">\n                            <label>Which column to filter? </label>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-md-7\">\n                        <div class=\"dropdown\" uib-dropdown dropdown-small-popup dropdown-title=\"Columns\">\n                            <a id=\"ddl-stage-columns\" blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle\n                               data-toggle=\"dropdown\">\n                                <span class=\"dropdown-text\">{{pipelineFilterModal.selectedColumn.key}}</span>\n                                <span class=\"icon\"></span>\n                            </a>\n                            <ul class=\"dropdown-menu\" uib-dropdown-menu>\n                                <li ng-repeat=\"column in pipelineFilterModal.stageColumns\"\n                                    ng-class=\"{'active': pipelineFilterModal.selectedColumn.key === column.key }\"\n                                    ng-click=\"pipelineFilterModal.columnClicked(column, $event)\">\n                                    <span>{{column.key}}</span>\n                                </li>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div ng-if=\"pipelineFilterModal.operators.length > 0\">\n                <div class=\"row\">\n                    <div class=\"col-md-7\">\n                        <div class=\"pipeline-filter-label-container\">\n                            <label>Filter this column </label>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-md-7\">\n                        <div class=\"dropdown\" uib-dropdown dropdown-small-popup dropdown-title=\"Operators\">\n                            <a id=\"ddl-operators\" blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle\n                               data-toggle=\"dropdown\">\n                                <div class=\"dropdown-text\">\n                                    <filter-option label=\"pipelineFilterModal.selectedOperator.label\" value=\"pipelineFilterModal.selectedOperator.value\"\n                                                   is-status = \"pipelineFilterModal.selectedColumn.filter.key === 'leadStatus'\"></filter-option>\n                                </div>\n                                <div class=\"icon\"></div>\n                            </a>\n                            <ul class=\"dropdown-menu\" uib-dropdown-menu>\n                                <li ng-repeat=\"operator in pipelineFilterModal.operators\"\n                                    ng-class=\"{'active': pipelineFilterModal.selectedOperator.value === operator.value }\"\n                                    ng-click=\"pipelineFilterModal.operatorClicked(operator, $event)\">\n                                    <filter-option label=\"operator.label\" value=\"operator.value\" is-status = \"pipelineFilterModal.selectedColumn.filter.key === 'leadStatus'\"></filter-option>\n                                </li>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-7\">\n                    <div class=\"pipeline-filter-field-container\">\n                        <input id=\"txt-filter-po-firstname\" name=\"txtFilterPOFirstName\"  class=\"form-control pipeline-filter-field pipeline-filter-fname-field\"\n                               type=\"text\" placeholder=\"{{pipelineFilterModal.filterPOPlaceholderText}}\"\n                               ng-model=\"pipelineFilterModal.filterFirstName\" maxlength=\"25\" autocomplete=\"off\"\n                               ng-if=\"pipelineFilterModal.selectedColumn.filter.type === 'propertyOwner' && pipelineFilterModal.operators.length > 1\"/>\n\n                        <input id=\"txt-filter-term\" name=\"txtFilterTerm\" class=\"form-control pipeline-filter-field\" type=\"text\"\n                               placeholder=\"{{pipelineFilterModal.filterTermPlaceholderText}}\"\n                               ng-model=\"pipelineFilterModal.filterValue\" maxlength=\"25\" autocomplete=\"off\" required\n                               ng-if=\"(pipelineFilterModal.selectedColumn.filter.type === 'operator' || pipelineFilterModal.selectedColumn.filter.type === 'propertyOwner') && pipelineFilterModal.operators.length > 1\"/>\n                        <input id=\"txt-filter-term\" name=\"txtFilterTerm\" class=\"form-control pipeline-filter-field\" type=\"text\"\n                               placeholder=\"{{pipelineFilterModal.filterTermPlaceholderText}}\"\n                               ng-model=\"pipelineFilterModal.filterValue\" maxlength=\"25\" autocomplete=\"off\" required ra-currency=\"$:2\"\n                               ng-if=\"(pipelineFilterModal.selectedColumn.filter.type === 'currency') && pipelineFilterModal.operators.length > 1\"/>\n                        <p class=\"error-message\" ng-if=\"pipelineFilterForm.txtFilterTerm.$invalid && pipelineFilterForm.$submitted \" >Required</p>\n                        <div class=\"pipeline-datepicker-field-container\">\n                            <input id=\"txt-filter-datepicker\" name=\"txtFilterDatepicker\" class=\"form-control filter-date-field\" type=\"text\"\n                                maxlength=\"10\" placeholder=\"{{pipelineFilterModal.filterDatePlaceholderText}}\"\n                                readonly required ng-click=\"pipelineFilterModal.open($event)\"\n                                ng-model=\"pipelineFilterModal.filterValue\" autocomplete=\"off\" uib-datepicker-popup=\"MM/dd/yyyy\"\n                                datepicker-options=\"pipelineFilterModal.datepickerOptions\" is-open=\"pipelineFilterModal.opened\"\n                                ng-if=\"pipelineFilterModal.selectedColumn.filter.type === 'date' && pipelineFilterModal.operators.length > 1\"/>\n                            <div class=\"input-group-btn\" ng-if=\"pipelineFilterModal.selectedColumn.filter.type === 'date' && pipelineFilterModal.operators.length > 1\">\n                                <button type=\"button\" class=\"btn btn-default filter-calendar-btn\" ng-click=\"pipelineFilterModal.open($event)\">\n                                    <i class=\"glyphicon glyphicon-calendar\"></i>\n                                </button>\n                            </div>\n                        </div>\n                        <p class=\"error-message\" ng-if=\"pipelineFilterForm.txtFilterDatepicker.$invalid && pipelineFilterForm.$submitted \" >Required</p>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-12\">\n                    <div class=\"pipeline-filter-buttons\">\n                        <button class=\"btn btn-primary\"\n                                id=\"btn-pipeline-filter-submit\" type=\"submit\">Apply</button>\n                        <a class=\"btn btn-default\" ng-disabled=\"pipelineFilterModal.selectedStage.pipelineStageId === -1\"\n                           id=\"btn-pipeline-filter-clear\" ng-click=\"pipelineFilterModal.clearClicked()\">Clear</a>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </form>\n</div>\n";

/***/ }),
/* 256 */
/***/ (function(module, exports) {

module.exports = "<div class=\"pipeline-filter-breadcrumbs\" ng-if=\"dataset.length > 0\">\n    <span class=\"icon icon-delete-circle\" ng-click=\"removeFilter();\"></span>\n    <a id=\"link-filter-breadcrumbs\" ng-click=\"launchModal();\">\n        <span ng-repeat=\"data in dataset track by $index\">{{data}}<span ng-if=\"$index < dataset.length - 1\" class='pipeline-breadcrumbs'\\>|</span></span>\n    </a>\n</div>\n";

/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"pipeline-job-modal-details-container\">\n        <h3>Property Owner</h3>\n        <p ng-bind=\"pipelineJobModal.propertyOwner\"></p>\n        <p ng-bind=\"pipelineJobModal.streetAddress\"></p>\n        <p ng-bind=\"pipelineJobModal.cityStateZip\"></p>\n    </div>\n</div>\n";

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\r\n    <span class=\"icon icon-delete-circle\" ng-click=\"pipelineJobModal.closeJobModal();\"></span>\r\n</div>\r\n\r\n<div class=\"modal-body\">\r\n    <div class=\"job-modal-title-container\">\r\n        <p class=\"modal-title\" ng-if=\"pipelineJobModal.isAssignMode\">Assign a Job</p>\r\n\r\n        <p class=\"modal-title\" ng-if=\"!pipelineJobModal.isAssignMode\">Hide Project</p>\r\n    </div>\r\n    <!-- Assign a Job content -->\r\n    <div class=\"row\" ng-if=\"pipelineJobModal.isAssignMode\">\r\n        <div class=\"col-md-6\">\r\n            <ng-include src=\"'app/pipeline/job/pipelineJobDetails.html'\"></ng-include>\r\n        </div>\r\n        <div class=\"col-md-6\">\r\n            <ng-include src=\"'app/common/job/assign/assignJobTemplate.html'\"></ng-include>\r\n        </div>\r\n    </div>\r\n    <!-- End Assign a Job content -->\r\n    <!-- Hide a Job content -->\r\n    <div class=\"row\" ng-if=\"!pipelineJobModal.isAssignMode\">\r\n        <div class=\"col-md-8\">\r\n            <ng-include src=\"'app/common/job/hide/hideJob.html'\"></ng-include>\r\n        </div>\r\n        <div class=\"col-md-4\">\r\n            <ng-include src=\"'app/pipeline/job/pipelineJobDetails.html'\"></ng-include>\r\n        </div>\r\n    </div>\r\n    <div class=\"row bottom-modal-row\" ng-if=\"!pipelineJobModal.isAssignMode\">\r\n        <div class=\"col-md-offset-4 col-md-8 hide-job-protip-container\">\r\n            <div class=\"pro-tip\">\r\n                <span>Pro Tip</span> <span class=\"pro-tip-hide-job\">You can access hidden projects using Search or Filter.</span>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <!-- End Hide a Job content -->\r\n</div>\r\n";

/***/ }),
/* 259 */
/***/ (function(module, exports) {

module.exports = "<table class=\"table pipeline-table\">\n    <thead>\n    <tr>\n        <th ng-repeat=\"mapping in pipelineTable.mappings\" ng-class=\"[mapping, {'sortable': pipelineTable.source === 'pipeline' && pipelineTable.columns[mapping].sort, 'currentSort': pipelineTable.source === 'pipeline' && pipelineTable.currentSort.SortColumnId === pipelineTable.columns[mapping].apiColumnId}]\" ng-click=\"pipelineTable.headerClick(mapping)\">\n            <span ng-bind=\"pipelineTable.columns[mapping].key\" ng-if=\"pipelineTable.columns[mapping].key !== 'Job Actions'\"></span>\n            <div class=\"arrow arrow-down\" ng-if=\"pipelineTable.source === 'pipeline' && pipelineTable.currentSort.SortOrderID === 1 && pipelineTable.currentSort.SortColumnId === pipelineTable.columns[mapping].apiColumnId\"></div>\n            <div class=\"arrow arrow-up\" ng-if=\"pipelineTable.source === 'pipeline' && pipelineTable.currentSort.SortOrderID === 2 && pipelineTable.currentSort.SortColumnId === pipelineTable.columns[mapping].apiColumnId\"></div>\n        </th>\n    </tr>\n    </thead>\n    <tbody>\n        <tr ng-repeat=\"row in pipelineTable.data\" ng-class=\"{'hidden-lead': row.IsContractorJobHidden === true}\" popover-trigger=\"mouseenter\" popover-enable=\"row.IsContractorJobHidden === true && row.unhidden.status === false\" popover-placement=\"bottom\" uib-popover=\"{{row.ContractorJobHideReason}}\" popover-title=\"Hidden\" popover-popup-delay=\"300\" popover-append-to-body=\"true\" popover-class=\"hidden-job-popover\">\n\n            <td ng-repeat=\"mapping in pipelineTable.mappings track by $index\" ng-if=\"row.reassigned.status === false && row.hidden.status === false && row.unhidden.status === false\">\n                <a ui-sref=\"lead({prequalId: row.PreQualId})\" class=\"leadColumnData\" ng-if=\"pipelineTable.columns[mapping].key === 'Status'\">\n                    <div ng-if=\"!!row.RAApplicationID\">\n                        <div ng-if=\"row.PrequalResultDecisionTypeId == 1 || row.PrequalResultDecisionTypeId == 2\" class=\"pass\"></div>\n                        <div ng-if=\"row.PrequalResultDecisionTypeId == 3 || row.PrequalResultDecisionTypeId == 0\" class=\"maybe\"></div>\n                        <div ng-if=\"row.PrequalResultDecisionTypeId == 4 || row.PrequalResultDecisionTypeId == 5\" class=\"fail\"></div>\n                        <span><span ng-if=\"row.PrequalResultDecisionTypeId == 4\">Not&nbsp;</span>Pre-qualified</span>\n                    </div>\n                    <div ng-if=\"!row.RAApplicationID\">\n                        <div class=\"{{pipelineTable.columns[mapping].val(row).toLowerCase()}}\" ng-class=\"{'undetermined': pipelineTable.columns[mapping].val(row) === undefined}\">\n                            <span class=\"duplicate-text\" ng-if=\"pipelineTable.columns[mapping].val(row) === 'Duplicate' || pipelineTable.columns[mapping].val(row) === undefined\">&#33;</span>\n                        </div>\n                        <span>KBYG</span>\n                        <span ng-if=\"pipelineTable.columns[mapping].val(row) === 'Duplicate' || pipelineTable.columns[mapping].val(row) === 'Undetermined'\" ng-bind=\"pipelineTable.columns[mapping].val(row)\"></span>\n                        <span ng-if=\"pipelineTable.columns[mapping].val(row) === undefined\">Undetermined</span>\n                    </div>\n                </a>\n\n                <a  ui-sref=\"lead({prequalId: row.PreQualId})\"\n                    ng-bind=\"pipelineTable.columns[mapping].val(row)\"\n                    ng-if=\"pipelineTable.columns[mapping].key !== 'Status' && pipelineTable.columns[mapping].key !== 'Job Actions'\"></a>\n\n                <div class=\"btn-group job-actions\" uib-dropdown dropdown-small-popup dropdown-title=\"Action\" ng-if=\"pipelineTable.columns[mapping].key === 'Job Actions'\">\n                    <button type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle ng-click=\"pipelineTable.jobActionsClick($event)\">\n                        <span class=\"icon icon-ellipsis\"></span>\n                    </button>\n                    <ul class=\"dropdown-menu dropdown-menu-right\" role=\"menu\" uib-dropdown-menu>\n                        <li ng-if=\"row.IsContractorJobHidden === false\" role=\"menuitem\" ng-click=\"pipelineTable.launchAssignJobModal(row, $event)\">Assign</li>\n                        <li ng-if=\"row.IsContractorJobHidden === false\" role=\"menuitem\" ng-click=\"pipelineTable.launchHideJobModal(row, $event)\">Hide</li>\n                        <li ng-if=\"row.IsContractorJobHidden === true\" role=\"menuitem\" ng-click=\"pipelineTable.unhideJob(row, $event)\">Unhide</li>\n                    </ul>\n                </div>\n            </td>\n\n            <!-- reassigned loan -->\n            <td colspan=\"{{pipelineTable.mappings.length}}\" class=\"updated\" ng-if=\"row.reassigned.status === true\">\n                <p>Project was reassigned to {{row.reassigned.locationName}}, {{row.reassigned.salesRepName}}.</p>\n            </td>\n            <!-- reassigned loan -->\n\n            <!-- Hidden Loan -->\n            <td colspan=\"{{pipelineTable.mappings.length}}\" class=\"updated\" ng-if=\"row.hidden.status === true\">\n                <div class=\"row\">\n                    <div class=\"col-md-9\">\n                        <p class=\"hidden-message\">{{row.hidden.address}} has been successfully hidden.</p>\n                    </div>\n                    <div class=\"col-md-3\">\n                        <button class=\"btn btn-default pull-right\" ng-click=\"pipelineTable.unhideJob(row, $event)\">\n                            <span>Undo</span>\n                        </button>\n                    </div>\n                </div>\n            </td>\n            <!-- Hidden Loan -->\n\n            <!-- Unhidden Loan -->\n            <td colspan=\"{{pipelineTable.mappings.length}}\" class=\"updated\" ng-if=\"row.unhidden.status === true\">\n                <p>{{row.unhidden.address}} is now active.</p>\n            </td>\n            <!-- Unhidden Loan -->\n        </tr>\n    </tbody>\n</table>\n";

/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports = "<table class=\"table pipeline-table\">\n    <thead>\n        <tr>\n            <th ng-repeat=\"mapping in pipelineTable.mappings\" ng-class=\"[mapping, {'sortable': pipelineTable.source === 'pipeline' && pipelineTable.columns[mapping].sort, 'currentSort': pipelineTable.source === 'pipeline' && pipelineTable.currentSort.SortColumnId === pipelineTable.columns[mapping].apiColumnId}]\" ng-click=\"pipelineTable.headerClick(mapping)\">\n                <span ng-bind=\"pipelineTable.columns[mapping].key\" ng-if=\"pipelineTable.columns[mapping].key !== 'Job Actions'\"></span>\n                <div class=\"arrow arrow-down\" ng-if=\"pipelineTable.source === 'pipeline' && pipelineTable.currentSort.SortOrderID === 1 && pipelineTable.currentSort.SortColumnId === pipelineTable.columns[mapping].apiColumnId\"></div>\n                <div class=\"arrow arrow-up\" ng-if=\"pipelineTable.source === 'pipeline' && pipelineTable.currentSort.SortOrderID === 2 && pipelineTable.currentSort.SortColumnId === pipelineTable.columns[mapping].apiColumnId\"></div>\n            </th>\n        </tr>\n    </thead>\n    <tbody>\n    <tr ng-repeat=\"row in pipelineTable.data\" ng-class=\"{'hidden-job': row.IsContractorJobHidden === true}\" popover-trigger=\"mouseenter\" popover-enable=\"row.IsContractorJobHidden === true && row.unhidden.status === false\" popover-placement=\"bottom\" uib-popover=\"{{row.ContractorJobHideReason}}\" popover-title=\"Hidden\" popover-popup-delay=\"300\" popover-append-to-body=\"true\" popover-class=\"hidden-job-popover\">\n        <td ng-repeat=\"mapping in pipelineTable.mappings track by $index\" ng-class=\"[mapping]\" ng-if=\"row.reassigned.status === false && row.hidden.status === false && row.unhidden.status === false\">\n            <!-- Column Data -->\n            <a ui-sref=\"app-detail({appId: row.FundingRequestId})\" class=\"loanColumnData\" ng-if=\"!!row.FundingRequestId && pipelineTable.columns[mapping].key !== 'Job Actions'\" ng-class=\"{'hasSibling': ((pipelineTable.showExpirationPopover(row) === true && pipelineTable.columns[mapping].key === 'Expiration') || (pipelineTable.columns[mapping].key === '$ Approved' && row.advancePaymentData.APEligible === true && row.advancePaymentData.DisbursementStatusId !== 3 && row.advancePaymentData.DisbursementStatusId !== 6 && row.advancePaymentData.DisbursementStatusId !== 7) || (pipelineTable.columns[mapping].key === '$ Approved' && (!!row.projectAdvanceData && row.projectAdvanceData !== null)))}\">\n                <span ng-repeat=\"p in pipelineTable.columns[mapping].val(row).split('\\n') track by $index\" ng-bind=\"p\"></span>\n            </a>\n\n            <a ui-sref=\"lead({prequalId: row.PrequalId})\" class=\"loanColumnData\" ng-if=\"!!row.PrequalId && pipelineTable.columns[mapping].key !== 'Job Actions'\" ng-class=\"{'hasSibling': ((pipelineTable.showExpirationPopover(row) === true && pipelineTable.columns[mapping].key === 'Expiration') || (pipelineTable.columns[mapping].key === '$ Approved' && row.advancePaymentData.APEligible === true && row.advancePaymentData.DisbursementStatusId !== 3 && row.advancePaymentData.DisbursementStatusId !== 6 && row.advancePaymentData.DisbursementStatusId !== 7) || (pipelineTable.columns[mapping].key === '$ Approved' && (!!row.projectAdvanceData && row.projectAdvanceData !== null)))}\">\n                <span ng-repeat=\"p in pipelineTable.columns[mapping].val(row).split('\\n') track by $index\" ng-bind=\"p\"></span>\n            </a>\n            <!-- Column Data -->\n\n            <!-- Expiring / Expired -->\n            <p ng-if=\"pipelineTable.showExpirationPopover(row) === true && pipelineTable.columns[mapping].key === 'Expiration'\" class=\"expiration-message\">{{pipelineTable.getExpirationMessage(row)}}</p>\n            <!-- Expiring / Expired -->\n\n            <!-- Advance Payment -->\n            <div class=\"advance-payment-indicator\" ng-click=\"pipelineTable.clickAdvPayPopover(row)\"\n                 ng-if=\"pipelineTable.columns[mapping].key === '$ Approved' && row.advancePaymentData.APEligible === true && row.advancePaymentData.showAdvancePaymentTooltip === true\"\n                 hp-popover popover-placement=\"bottom\" popover-trigger=\"show\" uib-popover=\"{{row.advancePaymentData.tooltipDescription}}\">\n                <span class=\"status\">{{row.advancePaymentData.buttonText}}</span>\n                <span class=\"icon icon-arrow-circle-down-thick\" ng-if=\"row.popoverOpen === false\"></span>\n                <span class=\"icon icon-arrow-circle-up-thick\" ng-if=\"row.popoverOpen === true\"></span>\n            </div>\n            <!-- Advance Payment -->\n\n            <!-- Project Advance -->\n            <div class=\"project-advance-indicator\" ng-click=\"pipelineTable.clickProjAdvPopover(row)\"\n                 ng-if=\"pipelineTable.columns[mapping].key === '$ Approved' && (row.projectAdvanceData !== null && !!row.projectAdvanceData) && row.projectAdvanceData.showProjectAdvanceTooltip === true\"\n                 hp-popover popover-placement=\"bottom\" popover-trigger=\"show\" uib-popover-template=\"row.projectAdvanceData.template\" >\n                <span class=\"status\">{{row.projectAdvanceData.buttonText}}</span>\n                <span class=\"icon icon-arrow-circle-down-thick\" ng-if=\"row.paPopoverOpen === false\"></span>\n                <span class=\"icon icon-arrow-circle-up-thick\" ng-if=\"row.paPopoverOpen === true\"></span>\n            </div>\n            <!-- Project Advance -->\n\n            <!-- Job Actions -->\n            <div class=\"btn-group job-actions\" uib-dropdown dropdown-small-popup dropdown-title=\"Action\" ng-if=\"pipelineTable.columns[mapping].key === 'Job Actions'\">\n                <button type=\"button\" class=\"btn btn-default job-actions\" uib-dropdown-toggle ng-click=\"pipelineTable.jobActionsClick($event)\">\n                    <span  class=\"icon icon-ellipsis\"></span>\n                </button>\n                <ul class=\"dropdown-menu dropdown-menu-right\" role=\"menu\" uib-dropdown-menu>\n                    <li ng-if=\"row.IsContractorJobHidden === false\" role=\"menuitem\" ng-click=\"pipelineTable.launchAssignJobModal(row, $event)\">Assign</li>\n                    <li ng-if=\"row.IsContractorJobHidden === false\" role=\"menuitem\" ng-click=\"pipelineTable.launchHideJobModal(row, $event)\">Hide</li>\n                    <li ng-if=\"row.IsContractorJobHidden === true\" role=\"menuitem\" ng-click=\"pipelineTable.unhideJob(row, $event)\">Unhide</li>\n                </ul>\n            </div>\n            <!-- Job Actions -->\n        </td>\n\n        <!-- Reassigned Loan -->\n        <td colspan=\"{{pipelineTable.mappings.length}}\" class=\"updated\" ng-if=\"row.reassigned.status === true\">\n            <p>Project was reassigned to {{row.reassigned.locationName}} office, {{row.reassigned.salesRepName}}.</p>\n        </td>\n        <!-- Reassigned Loan -->\n\n        <!-- Hidden Loan -->\n        <td colspan=\"{{pipelineTable.mappings.length}}\" class=\"updated\" ng-if=\"row.hidden.status === true\">\n            <div class=\"row\">\n                <div class=\"col-md-9\">\n                    <p class=\"hidden-message\">{{row.hidden.address}} has been successfully hidden.</p>\n                </div>\n                <div class=\"col-md-3\">\n                    <button class=\"btn btn-default pull-right\" ng-click=\"pipelineTable.unhideJob(row, $event, true)\">\n                        <span>Undo</span>\n                    </button>\n                </div>\n            </div>\n        </td>\n        <!-- Hidden Loan -->\n\n        <!-- Unhidden Loan -->\n        <td colspan=\"{{pipelineTable.mappings.length}}\" class=\"updated\" ng-if=\"row.unhidden.status === true\">\n            <p>{{row.unhidden.address}} is now active.</p>\n        </td>\n        <!-- Unhidden Loan -->\n    </tr>\n    </tbody>\n</table>\n";

/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports = "<div ng-controller=\"ProjectAdvanceController as pa\" class=\"pa-invoiced-container\">\n    <div ra-spinner register=\"false\" template=\"indeterminateSpinnerSmallRed\" show=\"pa.loadingData === true\" hide-content-when-shown=\"true\">\n        <div class=\"pa-invoiced-info\" ng-hide=\"pa.loadingData\">\n            <p>\n                This project was cancelled after the advance payment was sent.\n            </p>\n        </div>\n        <div class=\"pa-invoiced-details\" ng-hide=\"pa.loadingData\">\n            <div class=\"row\">\n                <div class=\"col-md-7\">\n                    <p>Advanced payment</p>\n                </div>\n                <div class=\"col-md-5\">\n                    <span ng-bind=\"pa.advanceData.ProjectAdvanceAmount | currency\"></span>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-7\">\n                    <p>Interest accrued to date</p>\n                    <p class=\"pa-starting-date\">Starting <span ng-bind=\"pa.advanceData.InterestStartDate |  date : 'MM/dd/yyyy'\"></span></p>\n                </div>\n                <div class=\"col-md-5\">\n                    <span ng-bind=\"pa.advanceData.InterestAccrued | currency\"></span>\n                </div>\n            </div>\n            <hr>\n        </div>\n        <div class=\"pa-invoiced-total\" ng-hide=\"pa.loadingData\">\n            <div class=\"row\">\n                <div class=\"col-md-7\">\n                    <p>Payment due</p>\n                </div>\n                <div class=\"col-md-5\">\n                    <span ng-bind=\"(pa.advanceData.ProjectAdvanceAmount + pa.advanceData.InterestAccrued) | currency\"></span>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 262 */
/***/ (function(module, exports) {

module.exports = "<div ng-controller=\"ProjectAdvanceController as pa\" class=\"pa-paid-back-container\">\n    <p>\n        The advance payment on this project has been repaid.\n    </p>\n</div>\n";

/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports = "<div ng-controller=\"ProjectAdvanceController as pa\" class=\"pa-past-due-container\">\n    <div ra-spinner register=\"false\" template=\"indeterminateSpinnerSmallRed\" show=\"pa.loadingData === true\" hide-content-when-shown=\"true\">\n        <div class=\"pa-past-due-info\"  ng-hide=\"pa.loadingData\">\n            <p>\n                This project was cancelled after the advance payment was sent and is now past due.\n            </p>\n        </div>\n        <div class=\"pa-past-due-details\"  ng-hide=\"pa.loadingData\">\n            <div class=\"row\">\n                <div class=\"col-md-7\">\n                    <p>Advanced payment</p>\n                </div>\n                <div class=\"col-md-5\">\n                    <span ng-bind=\"pa.advanceData.ProjectAdvanceAmount | currency\"></span>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-7\">\n                    <p>Interest accrued to date</p>\n                    <p class=\"pa-starting-date\">Starting <span ng-bind=\"pa.advanceData.InterestStartDate |  date : 'MM/dd/yyyy'\"></span></p>\n                </div>\n                <div class=\"col-md-5\">\n                    <span ng-bind=\"pa.advanceData.InterestAccrued | currency\"></span>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-7\">\n                    <p>Late fee</p>\n                    <p class=\"pa-starting-date\">Starting <span ng-bind=\"pa.advanceData.LateFeeDate |  date : 'MM/dd/yyyy'\"></span></p>\n                </div>\n                <div class=\"col-md-5\">\n                    <span ng-bind=\"pa.advanceData.LateFeeAmount | currency\"></span>\n                </div>\n            </div>\n            <hr>\n        </div>\n        <div class=\"pa-past-due-total\"  ng-hide=\"pa.loadingData\">\n            <div class=\"row\">\n                <div class=\"col-md-7\">\n                    <p>Payment due</p>\n                </div>\n                <div class=\"col-md-5\">\n                    <span ng-bind=\"(pa.advanceData.ProjectAdvanceAmount + pa.advanceData.InterestAccrued + pa.advanceData.LateFeeAmount) | currency\"></span>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports = "<div ng-controller=\"ProjectAdvanceController as pa\" class=\"pa-scheduled-container\">\n    <div ra-spinner register=\"false\" template=\"indeterminateSpinnerSmallRed\" show=\"pa.loadingData === true\" hide-content-when-shown=\"true\">\n        <div class=\"pa-scheduled-info\" ng-hide=\"pa.loadingData\">\n            <p>\n                This project is eligible for an advance payment <span ng-bind=\"pa.advanceData.NDaysAfterNTP\"></span> days after notice to proceed (NTP) is issued.\n            </p>\n        </div>\n        <div class=\"pa-scheduled-details\" ng-hide=\"pa.loadingData\">\n            <p>\n                If you don't want an advance on this project, email us at <a href=\"mailto:ProjectAdvance@renovateamerica.com\">ProjectAdvance@renovateamerica.com</a> with the HERO ID in the subject line.\n            </p>\n            <p>\n                For immediate assistance, call us at 858-605-9400.\n            </p>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 265 */
/***/ (function(module, exports) {

module.exports = "<div ng-controller=\"ProjectAdvanceController as pa\" class=\"pa-sent-container\">\n    <div ra-spinner register=\"false\" template=\"indeterminateSpinnerSmallRed\" show=\"pa.loadingData === true\" hide-content-when-shown=\"true\">\n            <div class=\"pa-sent-info\" ng-hide=\"pa.loadingData\">\n                <p>\n                    Your advance payment has been sent to your account.\n                </p>\n            </div>\n            <div class=\"pa-sent-details\" ng-hide=\"pa.loadingData\">\n                <div class=\"row\">\n                    <div class=\"col-md-7\">\n                        <p>Advanced payment</p>\n                    </div>\n                    <div class=\"col-md-5\">\n                        <span ng-bind=\"pa.advanceData.ProjectAdvanceAmount | currency\"></span>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-md-7\">\n                        <p>Date sent</p>\n                    </div>\n                    <div class=\"col-md-5\">\n                        <span ng-bind=\"pa.advanceData.ProjectAdvanceDateSent | date : 'MM/dd/yyyy'\"></span>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-md-7\">\n                        <p>Interest accrued to date</p>\n                        <p class=\"pa-sent-interest-date\">Starting <span ng-bind=\"pa.advanceData.InterestStartDate |  date : 'MM/dd/yyyy'\"></span></p>\n                    </div>\n                    <div class=\"col-md-5\">\n                        <span ng-bind=\"pa.advanceData.InterestAccrued | currency\"></span>\n                    </div>\n                </div>\n            </div>\n    </div>\n</div>\n";

/***/ }),
/* 266 */
/***/ (function(module, exports) {

module.exports = "<div ng-controller=\"ProjectAdvanceController as pa\" class=\"pa-unavailable-container\">\n    <p>\n        Advance payment is not available for this project.\n    </p>\n</div>\n";

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _productCenterController = __webpack_require__(268);

var _productCenterController2 = _interopRequireDefault(_productCenterController);

var _eligibilityRequirements = __webpack_require__(270);

var _eligibilityRequirements2 = _interopRequireDefault(_eligibilityRequirements);

var _productDetailController = __webpack_require__(272);

var _productDetailController2 = _interopRequireDefault(_productDetailController);

var _productDirectoryController = __webpack_require__(274);

var _productDirectoryController2 = _interopRequireDefault(_productDirectoryController);

var _productSearchController = __webpack_require__(276);

var _productSearchController2 = _interopRequireDefault(_productSearchController);

var _optionsPopupController = __webpack_require__(278);

var _optionsPopupController2 = _interopRequireDefault(_optionsPopupController);

var _categoryCacheService = __webpack_require__(279);

var _categoryCacheService2 = _interopRequireDefault(_categoryCacheService);

var _geoStateCacheService = __webpack_require__(280);

var _geoStateCacheService2 = _interopRequireDefault(_geoStateCacheService);

var _optionPopupService = __webpack_require__(281);

var _optionPopupService2 = _interopRequireDefault(_optionPopupService);

var _productFilterService = __webpack_require__(282);

var _productFilterService2 = _interopRequireDefault(_productFilterService);

var _productLookupService = __webpack_require__(283);

var _productLookupService2 = _interopRequireDefault(_productLookupService);

var _geoStateSelect = __webpack_require__(284);

var _geoStateSelect2 = _interopRequireDefault(_geoStateSelect);

var _geoStateSelect3 = __webpack_require__(285);

var _geoStateSelect4 = _interopRequireDefault(_geoStateSelect3);

var _directoryBox = __webpack_require__(286);

var _directoryBox2 = _interopRequireDefault(_directoryBox);

var _directoryBox3 = __webpack_require__(287);

var _directoryBox4 = _interopRequireDefault(_directoryBox3);

var _inputTypeGenerator = __webpack_require__(288);

var _inputTypeGenerator2 = _interopRequireDefault(_inputTypeGenerator);

var _inputTypeCheckboxDirective = __webpack_require__(289);

var _inputTypeCheckboxDirective2 = _interopRequireDefault(_inputTypeCheckboxDirective);

var _inputTypeDropdownDirective = __webpack_require__(290);

var _inputTypeDropdownDirective2 = _interopRequireDefault(_inputTypeDropdownDirective);

var _inputTypeNumericTextboxDirective = __webpack_require__(291);

var _inputTypeNumericTextboxDirective2 = _interopRequireDefault(_inputTypeNumericTextboxDirective);

var _inputTypeRadioDirective = __webpack_require__(292);

var _inputTypeRadioDirective2 = _interopRequireDefault(_inputTypeRadioDirective);

var _searchFilterGenerator = __webpack_require__(293);

var _searchFilterGenerator2 = _interopRequireDefault(_searchFilterGenerator);

var _searchFilterCheckbox = __webpack_require__(294);

var _searchFilterCheckbox2 = _interopRequireDefault(_searchFilterCheckbox);

var _searchFilterDescriptiveInput = __webpack_require__(295);

var _searchFilterDescriptiveInput2 = _interopRequireDefault(_searchFilterDescriptiveInput);

var _searchFilterMinMax = __webpack_require__(296);

var _searchFilterMinMax2 = _interopRequireDefault(_searchFilterMinMax);

var _searchFilterNumericCheckbox = __webpack_require__(297);

var _searchFilterNumericCheckbox2 = _interopRequireDefault(_searchFilterNumericCheckbox);

var _searchFilterNumericCheckboxDynamic = __webpack_require__(298);

var _searchFilterNumericCheckboxDynamic2 = _interopRequireDefault(_searchFilterNumericCheckboxDynamic);

var _numberFormatFilter = __webpack_require__(299);

var _numberFormatFilter2 = _interopRequireDefault(_numberFormatFilter);

var _selectedOptionsFilter = __webpack_require__(300);

var _selectedOptionsFilter2 = _interopRequireDefault(_selectedOptionsFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Filters
// geoStateSelect


// Services


// Controllers
exports.default = _angular2.default.module('app.productLookup', []).controller('ProductCenterController', _productCenterController2.default).controller('EligibilityRequirementsController', _eligibilityRequirements2.default).controller('ProductDetailController', _productDetailController2.default).controller('ProductDirectoryController', _productDirectoryController2.default).controller('ProductSearchController', _productSearchController2.default).controller('OptionsPopupController', _optionsPopupController2.default).controller('GEOStateSelectController', _geoStateSelect4.default).controller('DirectoryBoxController', _directoryBox4.default).service('categoryCacheService', _categoryCacheService2.default).service('geoStateCacheService', _geoStateCacheService2.default).service('optionsPopupService', _optionPopupService2.default).service('productFilterService', _productFilterService2.default).service('productLookupService', _productLookupService2.default).directive('inputTypeGenerator', _inputTypeGenerator2.default).directive('geoStateSelect', _geoStateSelect2.default).directive('directoryBox', _directoryBox2.default)

// input types directives
.directive('hpInputType2', _inputTypeCheckboxDirective2.default).directive('hpInputType4', _inputTypeDropdownDirective2.default).directive('hpInputType1', _inputTypeNumericTextboxDirective2.default).directive('hpInputType3', _inputTypeRadioDirective2.default)

// search filters directives
.directive('searchFilterGenerator', _searchFilterGenerator2.default).directive('searchFilters1', _searchFilterCheckbox2.default).directive('searchFilters4', _searchFilterDescriptiveInput2.default).directive('searchFilters6', _searchFilterMinMax2.default).directive('searchFilters2', _searchFilterNumericCheckbox2.default).directive('searchFilters5', _searchFilterNumericCheckboxDynamic2.default)

// filters
.filter('pcNumberFormat', _numberFormatFilter2.default).filter('selectedOptions', _selectedOptionsFilter2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/productCenter/productCenter.html', __webpack_require__(301)); // eslint-disable-line global-require

    // shared
    $templateCache.put('app/productCenter/pages/_shared/eligibilityrequirements/eligibilityRequirements.html', __webpack_require__(302)); // eslint-disable-line global-require
    $templateCache.put('app/productCenter/pages/_shared/geoStateSelect/geoStateSelect.html', __webpack_require__(303)); // eslint-disable-line global-require

    // product detail
    $templateCache.put('app/productCenter/pages/productdetail/productDetail.html', __webpack_require__(304)); // eslint-disable-line global-require
    $templateCache.put('app/productCenter/pages/productdetail/templates/checkbox.html', __webpack_require__(305)); // eslint-disable-line global-require
    $templateCache.put('app/productCenter/pages/productdetail/templates/dropdown.html', __webpack_require__(306)); // eslint-disable-line global-require
    $templateCache.put('app/productCenter/pages/productdetail/templates/numericTextbox.html', __webpack_require__(307)); // eslint-disable-line global-require
    $templateCache.put('app/productCenter/pages/productdetail/templates/radio.html', __webpack_require__(308)); // eslint-disable-line global-require

    // product directory
    $templateCache.put('app/productCenter/pages/productdirectory/productDirectory.html', __webpack_require__(309)); // eslint-disable-line global-require
    $templateCache.put('app/productCenter/pages/productdirectory/directoryBox/directoryBox.html', __webpack_require__(310)); // eslint-disable-line global-require

    // product search
    $templateCache.put('app/productCenter/pages/productsearch/productSearch.html', __webpack_require__(311)); // eslint-disable-line global-require
    $templateCache.put('app/productCenter/pages/productsearch/optionsPopup/optionsPopup.html', __webpack_require__(312)); // eslint-disable-line global-require
    $templateCache.put('app/productCenter/pages/productsearch/searchFilters/searchFilters.html', __webpack_require__(313)); // eslint-disable-line global-require

    $templateCache.put('app/productCenter/pages/productsearch/searchFilters/templates/checkbox.html', __webpack_require__(314)); // eslint-disable-line global-require
    $templateCache.put('app/productCenter/pages/productsearch/searchFilters/templates/descriptive-input.html', __webpack_require__(315)); // eslint-disable-line global-require
    $templateCache.put('app/productCenter/pages/productsearch/searchFilters/templates/minmax.html', __webpack_require__(316)); // eslint-disable-line global-require
    $templateCache.put('app/productCenter/pages/productsearch/searchFilters/templates/numeric-checkbox-dynamic.html', __webpack_require__(317)); // eslint-disable-line global-require
    $templateCache.put('app/productCenter/pages/productsearch/searchFilters/templates/numeric-checkbox.html', __webpack_require__(318)); // eslint-disable-line global-require
}]).name;

// Directives

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = productCenterController;

__webpack_require__(269);

productCenterController.$inject = ['$rootScope', '$scope', '$sce', '$window', '$timeout', '$document', '$stateParams', '$location', '$q', 'HPConfig', 'raSpinnerService', 'productLookupService', 'geoStateCacheService', 'categoryCacheService']; /* jshint ignore:start */
// angular
//   .module("HeroPRO")
//   .controller("ProductCenterController", productCenterController)
//   .config(function($locationProvider) {
//   	  $locationProvider.html5Mode(true);
//   });

/* @ngInject */
function productCenterController($rootScope, $scope, $sce, $window, $timeout, $document, $stateParams, $location, $q, HPConfig, raSpinnerService, productLookupService, geoStateCacheService, categoryCacheService) {
    var vm = this;

    var INITIAL_GEO_STATE = $stateParams.GeoState || 'CA';

    vm.iFrameLoaded = false;

    vm.iframeLoad = function () {
        angular.element(document.querySelectorAll('#resources')).addClass('show');
        angular.element(document.querySelectorAll('#productLookupOne')).addClass('hide');
        if (raSpinnerService.isRegistered('productLookupOne')) {
            raSpinnerService.hide('productLookupOne');
        }
        vm.iFrameLoaded = true;
    };

    vm.pageView = $stateParams.productLookupPage;

    vm.historyBack = function () {
        $window.history.back();
    };

    vm.categories = null;

    setupProductCenter();

    function setupProductCenter() {
        if (raSpinnerService.isRegistered('productCenterSpinner')) {
            raSpinnerService.show('productCenterSpinner');
        }

        var currentGeoState = geoStateCacheService.getGeoStates() ? geoStateCacheService.getCurrentStateObject().StateAbbreviation : INITIAL_GEO_STATE;

        // show spinner so need to have this trigger after watch is over
        $timeout(function () {
            var promise1 = productLookupService.getProductCategories(currentGeoState, null);
            var promise2 = productLookupService.getGeoStates();

            $q.all([promise1, promise2]).then(function (data) {
                categoryCacheService.setCategories(data[0].data.ProductCategories);
                vm.categories = data[0].data.ProductCategories;

                geoStateCacheService.setGeoStates(data[1].data.StateGeos);

                $rootScope.$broadcast('productCenter.setupComplete');

                $timeout(function () {
                    if (raSpinnerService.isRegistered('productCenterSpinner')) {
                        raSpinnerService.hide('productCenterSpinner');
                    }
                });
            }, function (reason) {
                $window.alert('Failed: ' + reason);
            });
        });
    }
}
/* jshint ignore:end */

/***/ }),
/* 269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = EligibilityRequirementsController;

__webpack_require__(271);

EligibilityRequirementsController.$inject = ['$scope', '$stateParams', '$sce', '$rootScope', 'categoryCacheService']; // angular
//   .module("HeroPRO")
//   .controller("EligibilityRequirementsController",

/* @ngInject */
function EligibilityRequirementsController($scope, $stateParams, $sce, $rootScope, categoryCacheService) {
    var vm = this;
    vm.showRequirements = false;
    vm.specifications = null;
    vm.mfaTerm = null;
    vm.productCode = $stateParams.Id.split('_');
    vm.productTypeId = parseInt(vm.productCode[0]);

    function setupProductTypeData() {
        var productType = categoryCacheService.getProductTypeByProductTypeId(vm.productTypeId);

        if (productType !== null) {
            vm.productTypeNamePlural = productType.NamePlural;
            vm.specifications = $sce.trustAsHtml(productType.Specifications);
            vm.mfaTerm = productType.MaximumFinanceTerm;
        }
    }

    setupProductTypeData(); // needs to be called here for no product products

    $scope.$on('productCenter.setupComplete', function () {
        setupProductTypeData();
    });

    $scope.$on('productSearchController.showRequirements', function () {
        vm.showRequirements = !vm.showRequirements;
    });

    $scope.$on('productDetailController.isNoProductProduct', function () {
        vm.showRequirements = true;
    });
}

/***/ }),
/* 271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ProductDetailController;

__webpack_require__(273);

ProductDetailController.$inject = ['$scope', '$rootScope', '$stateParams', '$location', '$window', 'productLookupService', 'categoryCacheService', 'geoStateCacheService', 'HPGeoStates', 'HPConfig', 'raSpinnerService']; // angular
//   .module("HeroPRO")
//   .controller("ProductDetailController",

/* @ngInject */
function ProductDetailController($scope, $rootScope, $stateParams, $location, $window, productLookupService, categoryCacheService, geoStateCacheService, HPGeoStates, HPConfig, raSpinnerService) {
    var vm = this;
    vm.mfaForm = {};

    vm.productDetail = [];
    vm.productCode = $stateParams.Id.split('_');
    vm.productTypeID = parseInt(vm.productCode[0]);
    vm.productID = parseInt(vm.productCode[1]) || null;
    vm.productGeoState = $stateParams.GeoState;
    vm.type = null;
    vm.MFAResultLow = null;
    vm.MFAResultMean = null;
    vm.MFAResultMax = null;
    vm.formCheckBoxesValid = true;
    vm.calculatedOnce = false;
    vm.showMFACalc = HPConfig.showMFACalc && $location.search().showMFACalc;

    $scope.$on('productCenter.setupComplete', function () {
        vm.currentGeoStateObject = geoStateCacheService.getCurrentStateObject();
        // find the type
        vm.type = angular.copy(categoryCacheService.getProductTypeByProductTypeId(vm.productTypeID));
        getProductDetail();
    });

    // Get product detail
    var getProductDetail = function getProductDetail() {
        var promise = productLookupService.getProductInfo(vm.productTypeID, vm.productID);
        promise.then(function (response) {
            vm.productDetail = response.data;
            if (raSpinnerService.isRegistered('productDetailSpinner')) {
                raSpinnerService.hide('productDetailSpinner');
            }
            if (vm.type.NoProducts) {
                $rootScope.$broadcast('productDetailController.isNoProductProduct');
            }
        }, function (reason) {
            $window.alert('Failed: ' + reason);
        });
    };

    $scope.$on('inputTypesDirective.MFAFormChanged', function () {
        vm.MFAResultLow = null;
        vm.MFAResultMean = null;
        vm.MFAResultMax = null;
    });

    $scope.$on('inputTypesDirective.checkBoxValidation', function () {
        validateCheckboxes();
    });

    vm.calculateMFA = function () {
        var productDetails = [];

        // build product details - could go somewhere else, or a function?
        for (var i = 0; i < vm.productDetail.InputsForMFA.length; i++) {
            var inputForMFA = vm.productDetail.InputsForMFA[i];

            var inputName = inputForMFA.TypeId + '-' + inputForMFA.Deprecated_ProductAttributeNameId;

            switch (inputForMFA.TypeId) {
                case 1:
                    // textbox
                    productDetails.push({
                        productAttributeId: inputForMFA.Deprecated_ProductAttributeNameId,
                        productOptionIds: [],
                        Val: vm.mfaForm[inputName]
                    });
                    break;
                case 2: // checkbox
                case 5:

                    var options = [];

                    for (var key in vm.mfaForm[inputName]) {
                        if (vm.mfaForm[inputName][key] === true) {
                            options.push(key);
                        }
                    }

                    productDetails.push({
                        productAttributeId: inputForMFA.Deprecated_ProductAttributeNameId,
                        productOptionIds: options
                    });

                    break;
                case 3:
                    // radio
                    productDetails.push({
                        productAttributeId: inputForMFA.Deprecated_ProductAttributeNameId,
                        productOptionIds: [vm.mfaForm[inputName].$viewValue]
                    });
                    break;
                case 4:
                    // dropdown
                    productDetails.push({
                        productAttributeId: inputForMFA.Deprecated_ProductAttributeNameId,
                        productOptionIds: [vm.mfaForm[inputName].InputOptionId]
                    });

                    break;
            }
        }

        var promise = productLookupService.getMFACalculation({
            StateId: geoStateCacheService.getCurrentStateObject().StateGeoId,
            CalculatorArgs: {
                ProductId: vm.productID,
                ProductDetails: productDetails
            }
        });
        promise.then(function (response) {
            vm.MFAResultLow = response.data.FMPCCalculatorResult.PredictedPriceDeviation;
            vm.MFAResultMean = response.data.FMPCCalculatorResult.PredictedMeanPrice;
            vm.MFAResultMax = response.data.MaximumFinancingAmount;
            vm.calculatedOnce = true;
            // vm.productDetail = response.data;
        }, function (reason) {
            $window.alert('Failed: ' + reason);
        });
    };

    $scope.$on('inputTypesDirective.filtersLoaded', function () {
        // Loop through mfaForm values, check if its a checkbox and if so, if it's valid
        validateCheckboxes();
    });

    function validateCheckboxes() {
        vm.formCheckBoxesValid = true;
        for (var input in vm.mfaForm) {
            if (input.charAt(0) === '2' && vm.mfaForm[input].checkboxInvalid) {
                vm.formCheckBoxesValid = false;
                break;
            }
        }
    }
}

/***/ }),
/* 273 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ProductDirectoryController;

__webpack_require__(275);

ProductDirectoryController.$inject = ['$scope', '$window', '$timeout', '$stateParams', 'productLookupService', 'categoryCacheService', 'geoStateCacheService']; // angular
//   .module("HeroPRO")
//   .controller("ProductDirectoryController",

/* @ngInject */
function ProductDirectoryController($scope, $window, $timeout, $stateParams, productLookupService, categoryCacheService, geoStateCacheService) {
    var vm = this;
    vm.productTypeSearchTerm = null;
    vm.productTypeSearchMinumCharacterCount = 2;
    vm.productTypeSearchResults = null;
    vm.productGeoState = $stateParams.GeoState;
    vm.categories = categoryCacheService.getCategories();

    $scope.$on('productCenter.setupComplete', function () {
        vm.categories = categoryCacheService.getCategories();
    });

    vm.productSearch = function (searchTerm) {
        vm.productTypeSearchTerm = searchTerm;

        var promise = productLookupService.getProductTypeSearch({
            searchTerm: searchTerm
        });

        return promise.then(function (response) {
            if (response.data.SearchResults) {
                vm.productTypeSearchResults = response.data.SearchResults;
                return response.data.SearchResults.map(function (item) {
                    item.key = item.ProductTypeName + ' in ' + item.CategoryTypeName;
                    return item.key;
                });
            }
        }, function (reason) {
            $window.alert('Get Filters for Search failed: ' + reason);
        });
    };

    vm.productTypeSearchResultSelect = function ($item) {
        for (var i = 0; i < this.productTypeSearchResults.length; i++) {
            if (this.productTypeSearchResults[i].key === $item) {
                var url = categoryCacheService.getProductTypeUrl(this.productTypeSearchResults[i].ProductTypeId, geoStateCacheService.getCurrentStateObject().StateAbbreviation);
                $window.location = url;
                break;
            }
        }
    };
}

/***/ }),
/* 275 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ProductSearchController;

__webpack_require__(277);

ProductSearchController.$inject = ['$scope', '$sce', '$location', '$timeout', '$stateParams', '$anchorScroll', '$window', '$rootScope', 'productLookupService', 'orderByFilter', 'raSpinnerService', 'productFilterService', 'categoryCacheService', 'geoStateCacheService']; // angular
//   .module("HeroPRO")
//   .controller("ProductSearchController",

/* @ngInject */
function ProductSearchController($scope, $sce, $location, $timeout, $stateParams, $anchorScroll, $window, $rootScope, productLookupService, orderByFilter, raSpinnerService, productFilterService, categoryCacheService, geoStateCacheService) {
    /*
       *  Overview
       *
       *  Search is driven by the URL by two main parts the query and the filters. When the URL changes then a new search will be triggered.
       *  Running everything from the URL is required to allow for deep linked search results.
       *
       */

    var vm = this;

    vm.searchTerms = $location.search().query ? $location.search().query : '';
    vm.enteredSearchTerm = vm.searchTerms;
    vm.productTypeId = $stateParams.Id.split('_')[0];
    vm.productGeoState = null;
    vm.productSearchResults = null;
    vm.PagingIndex = 0;
    vm.foundCount = 0;
    vm.pagingCount = 0;
    vm.pagingSize = 20;
    vm.lastPage = null;
    vm.filtersActive = $location.search().filters !== ''; // ? true : false;
    vm.filters = null;
    vm.showPageWrapSpinner = true;
    vm.resultsPending = false;
    vm.productTypeNamePlural = null;
    vm.productTypeStateGeos = null;
    vm.setupComplete = false;
    vm.showSelectAttributePopup = false;

    vm.sortOptions = [];

    vm.selectedSort = null;

    vm.switchSort = function (i) {
        vm.selectedSort = vm.sortOptions[i];
        productSearch();
    };

    // Highlighting search results to match the search query
    vm.highlight = function (text) {
        if (!vm.enteredSearchTerm) {
            return $sce.trustAsHtml(text);
        }
        // return $sce.trustAsHtml(text.replace(new RegExp(vm.enteredSearchTerm, 'gi'), '<span class="highlight-text">$&</span>'));
        RegExp.quote = function (str) {
            return ('' + str).replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
        };
        return $sce.trustAsHtml(decodeURI(encodeURI(text).replace(new RegExp(RegExp.quote(vm.enteredSearchTerm), 'gi'), '<span class="highlight-text">$&</span>')));
    };

    // Initiate new search, resets filters
    vm.productSearchButton = function () {
        vm.clearFilters();

        // Cache search term for the text "no products found for xxxx", if we don't cache it binds directly to what the user is typing in the search box
        vm.enteredSearchTerm = angular.copy(vm.searchTerms);

        // Set the search term - initiates the search by changing the URL
        $location.search({ query: vm.searchTerms, filters: '' });
    };

    // paging
    vm.switchPage = function (pageNumber) {
        if (raSpinnerService.isRegistered('productSearchSpinnner')) {
            raSpinnerService.show('productSearchSpinnner');
        }

        vm.PagingIndex = pageNumber - 1;
        productSearchRequest();
    };

    vm.clearSearchTerms = function () {
        // if (raSpinnerService.isRegistered("productSearchSpinnner")) {
        //    raSpinnerService.show("productSearchSpinnner");
        // }
        if (raSpinnerService.isRegistered('productSearchNoResultsSpinnner')) {
            raSpinnerService.show('productSearchNoResultsSpinnner');
        }

        $location.search('query', '');

        vm.enteredSearchTerm = '';
    };

    vm.clearFilters = function () {
        if (raSpinnerService.isRegistered('productSearchSpinnner')) {
            raSpinnerService.show('productSearchSpinnner');
        }

        $rootScope.$broadcast('productSearchController.filtersCleared');

        // Replace with original data object here and on service
        productFilterService.clearFilterDTOs();
        vm.filters = productFilterService.getFiltersForDisplay();
        vm.filtersActive = false;

        // Remove filters from URL
        $location.search('filters', '');
    };

    // initiate a search, this will reset paging
    function productSearch() {
        if (raSpinnerService.isRegistered('productSearchSpinnner')) {
            raSpinnerService.show('productSearchSpinnner');
        }
        if (raSpinnerService.isRegistered('productSearchNoResultsSpinnner')) {
            raSpinnerService.show('productSearchNoResultsSpinnner');
        }

        // set default if nothing is set
        if (typeof $location.search().query === 'undefined') {
            $location.search({ query: '', filters: '' });
        }

        vm.resultsPending = true;

        // Reset Paging
        vm.PagingIndex = 0;
        vm.FoundCount = 0;

        productSearchRequest();
    }

    // search request, is called directly by paging, otherwise called from productSearch();
    function productSearchRequest() {
        vm.productSearchResults = null;
        vm.searchTerms = $location.search().query;

        var request = {
            GeoState: geoStateCacheService.getCurrentStateObject().StateAbbreviation,
            ProductTypeId: vm.productTypeId,
            SearchTerms: $location.search().query,
            PagingIndex: vm.PagingIndex,
            SortOrder: vm.selectedSort ? vm.selectedSort.SortOrder : null,
            SortKey: vm.selectedSort ? vm.selectedSort.SortKey : null,
            /* global atob */
            Filters: productFilterService.getFiltersForSearchRequest(atob($location.search().filters))
        };

        var searchPromise = productLookupService.getProductSearch(request);

        searchPromise.then(function (response) {
            vm.showPageWrapSpinner = false;
            vm.resultsPending = false;
            vm.productSearchResults = response.data.Products;
            vm.foundCount = response.data.FoundCount;
            vm.pagingCount = response.data.FoundCount > 10000 ? 10000 : response.data.FoundCount;
            vm.lastPage = vm.pagingCount / vm.pagingSize;
            vm.returnedFilters = response.data.FilterOptionResults;

            vm.sortOptions = response.data.ProductSearchSortLabels;

            if (vm.selectedSort === null) {
                vm.selectedSort = vm.sortOptions[0];
            }

            productFilterService.setupFilterOptions(response.data.FilterOptionResults);
            vm.filters = productFilterService.getFiltersForDisplay();
        }, function (reason) {
            $window.alert('Search Failed: ' + reason);
        }).finally(function () {
            if (raSpinnerService.isRegistered('productSearchSpinnner')) {
                raSpinnerService.hide('productSearchSpinnner');
            }
            if (raSpinnerService.isRegistered('productSearchNoResultsSpinnner')) {
                raSpinnerService.hide('productSearchNoResultsSpinnner');
            }
            if (raSpinnerService.isRegistered('productSearchResultsSpinnner')) {
                raSpinnerService.hide('productSearchResultsSpinnner');
            }
        });
    }

    // gets the query string parameter for the filtery query string
    function pushFiltersToURL() {
        var filterStringsForURL = productFilterService.getFilterStringsForURL();

        if (filterStringsForURL.length > 0) {
            /* global btoa */
            $location.search('filters', btoa(filterStringsForURL.join('|')));
        } else {
            $location.search('filters', '');
        }
    }

    // setup complete is called after filters and state geos are loaded
    $scope.$on('productCenter.setupComplete', function () {
        var productType = categoryCacheService.getProductTypeByProductTypeId(vm.productTypeId);
        vm.productTypeNamePlural = productType.NamePlural;
        vm.specifications = $sce.trustAsHtml(productType.Specifications);
        vm.productTypeStateGeos = productType.StateGeos; // todo : Fix Name... StateGeos
        vm.productGeoState = geoStateCacheService.getCurrentStateObject().StateAbbreviation;

        // Get the filters for a given product type
        var promise = productLookupService.getProductFilters(vm.productTypeId);
        promise.then(function (response) {
            productFilterService.setupFilterDTOs(response.data.SearchFilters);
            vm.filters = productFilterService.getFiltersForDisplay();
        }, function (reason) {
            $window.alert('Get Filters for Search failed: ' + reason);
        });
    });

    // shows the modal to select attribute options
    $scope.$on('searchFilters.showOptionsPopup', function () {
        vm.showSelectAttributePopup = true;
    });

    $scope.$on('optionsPopupController.popupShown', function () {
        // required to allow popup to completely load to compare size to window height
        $timeout(function () {
            resizePopup();
        });
    });

    // once filters are loaded, setup is completed and the initial search can occur
    $scope.$on('searchFiltersDirective.filtersLoaded', function () {
        if (!vm.setupComplete) {
            productSearch();
            vm.setupComplete = true;
        }
    });

    // this shouldn't be necessary but was added in order to control the location change event not properly being cleared when controller is removed from DOM
    $scope.$on('$destroy', function () {
        vm.setupComplete = false;
    });

    $scope.$on('searchFiltersGenerator.processFilter', function () {
        pushFiltersToURL();
    });

    $rootScope.$on('optionsPopupController.applyOptions', function () {
        pushFiltersToURL();
    });

    // handles when the url changes to run the search
    $rootScope.$on('$locationChangeSuccess', function () {
        // This is to prevent the $locationChange event from triggering on other pages, however it shouldn't be. When the page is removed
        // from the DOM it should remove its events. For some reason that is not happening????

        if (vm.setupComplete && $location.$$path.indexOf('product-lookup/search') !== -1) {
            productSearch();
            vm.filtersActive = $location.search().filters !== '';
            vm.productGeoState = geoStateCacheService.getCurrentStateObject().StateAbbreviation;
        }
    });

    function resizePopup() {
        /* jshint ignore:start */
        // If popup is visible
        if (angular.element(document.querySelector('.popup'))[0]) {
            console.log('resize');

            var popupBottom = angular.element(document.querySelector('.attribute-popup .popup'))[0].getBoundingClientRect().bottom;
            var windowHeight = window.innerHeight;

            // If popup is taller than the window
            if (popupBottom > windowHeight) {
                angular.element(document.querySelector('.attribute-popup')).addClass('short-window');
            } else {}
            // angular.element(document.querySelector('.attribute-popup')).removeClass('short-window');


            // manuall $digest required as resize event
            // is outside of angular
            // scope.$digest();
        }
        /* jshint ignore:end */
    }

    /* jshint ignore:start */
    angular.element(window).bind('resize', function () {
        resizePopup();
    });
    /* jshint ignore:end */
}

/***/ }),
/* 277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = OptionsPopupController;
OptionsPopupController.$inject = ['$scope', '$anchorScroll', '$rootScope', '$location', 'raSpinnerService', 'productFilterService', 'optionsPopupService'];
// angular
//   .module("HeroPRO")
//   .controller("OptionsPopupController",

/* @ngInject */
function OptionsPopupController($scope, $anchorScroll, $rootScope, $location, raSpinnerService, productFilterService, optionsPopupService) {
    var vm = this;

    vm.alphabet = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

    var alphabeticalOptions = [];
    vm.letterGroupedOptions = angular.copy(optionsPopupService.letterGroupedOptions());
    vm.currentFilter = angular.copy(optionsPopupService.getPopupData().currentFilter);

    // Check if letter exists
    vm.checkLetter = function (letter) {
        for (var i = 0; i < vm.letterGroupedOptions.length; i++) {
            if (letter === vm.letterGroupedOptions[i].letterHead) {
                return true;
            }
        }
        return false;
    };

    // Scroll to corresponding letter
    vm.scrollToLetter = function (letter) {
        $anchorScroll(letter);
    };

    // Clear out alphabeticalOptions and remove alphabet grouping, save chekced options
    function rebuildOptionsObject() {
        var obj = vm.letterGroupedOptions;
        alphabeticalOptions = [];
        for (var i = 0; i < obj.length; i++) {
            for (var j = 0; j < obj[i].letterOptions.length; j++) {
                var option = obj[i].letterOptions[j];
                alphabeticalOptions.push({
                    DisplayName: option.DisplayName,
                    optionID: option.optionID,
                    isChecked: option.isChecked
                });
            }
        }
    }

    // Group of options to show in the sidebar
    function putSelectedOptionsInFront() {
        var options = alphabeticalOptions;
        var selectedOptions = [];
        var unselectedOptions = [];
        if (options) {
            // prevent function running before data is loaded
            // seperate selected options
            for (var i = 0; i < options.length; i++) {
                if (options[i].isChecked) {
                    selectedOptions.push(options[i]);
                } else {
                    unselectedOptions.push(options[i]);
                }
            }

            // if there are any selected options, swap it out with new sidebarOptions
            if (selectedOptions.length > 0) {
                alphabeticalOptions = selectedOptions.concat(unselectedOptions);
            } else {}
        }
    }

    // Apply selected options back into main DTO
    function updateMainDTO() {
        var filter = vm.currentFilter;
        for (var i = 0; i < productFilterService.productTypeFilters.length; i++) {
            // Find matching options object
            if (productFilterService.productTypeFilters[i].Deprecated_ProductAttributeNameId === filter.Deprecated_ProductAttributeNameId) {
                // Copy object back into main DTO
                productFilterService.productTypeFilters[i].InputOptions = alphabeticalOptions;
            }
        }
    }

    // Apply selected options back vm.currentFilter
    function updateCurrentFilter() {
        // Copy object back into main DTO
        vm.currentFilter.InputOptions = alphabeticalOptions;
    }

    // So we know when the popup is loaded
    $rootScope.$broadcast('optionsPopupController.popupShown');

    // Apply options modal
    vm.applyOptions = function () {
        rebuildOptionsObject();
        putSelectedOptionsInFront();
        updateMainDTO();
        updateCurrentFilter();
        $rootScope.$broadcast('optionsPopupController.applyOptions', vm.currentFilter);
    };

    vm.cancelOptions = function () {
        vm.showAttributes = false;
    };
}

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CategoryCacheService;
// (function () {
//     'use strict';
//     angular.module('HeroPRO')
//       .service('categoryCacheService',

function CategoryCacheService() {
    var _productCategories = null;

    this.setCategories = function (productCategories) {
        _productCategories = productCategories;
    };

    this.getCategories = function () {
        return _productCategories;
    };

    this.clearCategories = function () {
        _productCategories = null;
    };

    this.getProductTypeByProductTypeId = function (typeId) {
        if (_productCategories == null) {
            return null;
        }

        var TypeId = parseInt(typeId);

        for (var i = 0; i < _productCategories.length; i++) {
            for (var j = 0; j < _productCategories[i].ProductTypes.length; j++) {
                if (_productCategories[i].ProductTypes[j].EETypeId === TypeId) {
                    return _productCategories[i].ProductTypes[j];
                }
            }
        }
    };

    this.getProductTypeUrl = function (productTypeId, geoStateAbbreviation) {
        var type = this.getProductTypeByProductTypeId(productTypeId);

        return type.NoProducts ? "/product-lookup/detail/" + geoStateAbbreviation + "/" + type.EETypeId + "_" + type.NoProductProductId : "/product-lookup/search/" + geoStateAbbreviation + "/" + type.EETypeId + "?query=&filters=";
    };
}

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = GEOStateCacheService;
GEOStateCacheService.$inject = ['$stateParams'];
// /* jshint ignore:start */
// (function () {
//     'use strict';
//     angular.module('HeroPRO')
//         .service('geoStateCacheService',

/* @ngInject */
function GEOStateCacheService($stateParams) {
    var _geoState = null;
    var urlGeoState = '';

    this.setGeoStates = function (geoState) {
        _geoState = geoState;
    };

    this.getGeoStates = function () {
        return _geoState;
    };

    this.getGeoStateObject = function (geoStateCode) {
        var gStates = this.getGeoStates();
        for (var i = 0; i < gStates.length; i++) {
            if (geoStateCode === gStates[i].StateAbbreviation) {
                return gStates[i];
            }
        }
    };

    this.getCurrentStateObject = function () {
        return this.getGeoStateObject($stateParams.GeoState);
    };
}

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = OptionsPopupService;
// /* jshint ignore:start */
// (function () {
//     'use strict';
//     angular.module('HeroPRO')
//       .service('optionsPopupService',

function OptionsPopupService() {
    var _popupData = null;

    var _letterGroupedOptions = null;

    this.setPopupData = function (popupData) {
        _popupData = popupData;
        _letterGroupedOptions = groupOptionsByLetter(popupData.alphabeticalOptions);
    };

    this.getPopupData = function () {
        return _popupData;
    };

    this.letterGroupedOptions = function () {
        return _letterGroupedOptions;
    };

    // Display letter if it's a new letter and has options present
    function groupOptionsByLetter(options) {
        var letterGroupedOptions = [];
        var letterIndex = 0;

        // Get first letter of attribute
        function grabFirstLetter(name) {
            return name && name.charAt(0);
        }

        function pushNewGroup(letterGroupedOptions, options) {
            letterGroupedOptions.push({
                letterHead: grabFirstLetter(options[i].DisplayName),
                letterOptions: []
            });
        }

        function pushGroupCategories(letterGroupedOptions, options) {
            letterGroupedOptions[letterIndex].letterOptions.push({
                DisplayName: options[i].DisplayName,
                optionID: options[i].optionID,
                isChecked: options[i].isChecked
            });
        }

        for (var i = 0; i < options.length; i++) {
            // for first option
            if (i === 0) {
                pushNewGroup(letterGroupedOptions, options);
                pushGroupCategories(letterGroupedOptions, options);
            }

            // if second option has a different letter
            else if (i > 0 && letterIndex === 0 && grabFirstLetter(options[i].DisplayName) !== grabFirstLetter(options[i - 1].DisplayName)) {
                    letterIndex += 1;
                    pushNewGroup(letterGroupedOptions, options);
                    pushGroupCategories(letterGroupedOptions, options);
                    letterIndex += 1;
                }

                // if second option
                else if (i > 0 && letterIndex === 0) {
                        pushGroupCategories(letterGroupedOptions, options);
                        letterIndex += 1;
                    }

                    // if option starts with a new letter, create a new letter group
                    else if (grabFirstLetter(options[i].DisplayName) !== grabFirstLetter(options[i - 1].DisplayName)) {
                            pushNewGroup(letterGroupedOptions, options);
                            pushGroupCategories(letterGroupedOptions, options);
                            letterIndex += 1;
                        }

                        // if option has the same letter as the previous, add it to current letter object's array
                        else {
                                letterGroupedOptions[letterIndex - 1].letterOptions.push({
                                    DisplayName: options[i].DisplayName,
                                    optionID: options[i].optionID,
                                    isChecked: options[i].isChecked
                                });
                            }
        }
        return letterGroupedOptions;
    }
}

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ProductFilterService;
// (function () {
//     'use strict';
//     angular.module('HeroPRO')
//       .service('productFilterService',

function ProductFilterService() {
    // var defaultProductFilterLimit = 7;
    this.productTypeFilters = [];
    this.productTypeFiltersClean = [];
    // this.productFilterLimit = defaultProductFilterLimit;

    // this.resetProductFilterLimit = function () {
    //     this.productFilterLimit = defaultProductFilterLimit;
    // };

    this.setupFilterDTOs = function (filters) {
        // add default attribute for showFilter
        for (var i = 0; i < filters.length; i++) {
            filters[i].showFilter = true;
        }
        this.productTypeFilters = angular.copy(filters);
        this.productTypeFiltersClean = angular.copy(filters);
    };

    this.clearFilterDTOs = function () {
        this.productTypeFilters = angular.copy(this.productTypeFiltersClean);
    };

    this.setupFilterOptions = function (filterOptions) {
        // copy the clean filters
        var filters = angular.copy(this.productTypeFiltersClean);
        // build the options per filter type
        for (var i = 0; i < filterOptions.length; i++) {
            var filterOptionSet = filterOptions[i];
            var currentFilters = getFiltersByName(filters, filterOptionSet.Name);

            for (var j = 0; j < currentFilters.length; j++) {
                var currentFilter = currentFilters[j];

                switch (currentFilter.TypeId) {
                    // checkbox / options
                    case 1:
                    case 2:
                        currentFilter.InputOptions = filterOptionSet.Values ? getOptionsList(filterOptionSet.Values, currentFilter.Deprecated_ProductAttributeNameId) : null;
                        break;
                    // min/max
                    case 6:
                    case 7:
                        currentFilter.InputRangeAttributes = filterOptionSet.Values ? getMinMaxRangeValues(currentFilter, filterOptionSet.Values) : null;
                        break;
                    default:
                    // alert("Haven't setup building filter option values for TypeId: " + currentFilter.TypeId);
                }
            }
        }
        // reset the initial filter list
        this.setupFilterDTOs(filters);
    };

    this.getFiltersForDisplay = function () {
        var resultFilters = [];

        for (var i = 0; i < this.productTypeFilters.length; i++) {
            // ignore the max filter
            if (this.productTypeFilters[i].TypeId !== 7) {
                resultFilters.push(this.productTypeFilters[i]);
            }
        }

        return resultFilters;
    };

    this.getFilterByAttributeNameId = function (filters, attributeNameId, searchFilterTypeId) {
        for (var i = 0; i < filters.length; i++) {
            if (filters[i].Deprecated_ProductAttributeNameId === parseInt(attributeNameId)) {
                if (searchFilterTypeId && searchFilterTypeId !== filters[i].SearchFilterTypeId) {
                    continue;
                }

                return filters[i];
            }
        }
    };

    this.getFilterStringsForURL = function () {
        var filterStringsForURL = [];
        var serviceFilters = this.productTypeFilters;

        for (var i = 0; i < serviceFilters.length; i++) {
            var currentFilter = serviceFilters[i];
            var currentFilterString = '';

            if (currentFilter.showFilter === false) {
                continue;
            }

            // If checkboxes
            if (currentFilter.TypeId === 1 && currentFilter.InputOptions) {
                var checkedOptions = [];
                for (var j = 0; j < currentFilter.InputOptions.length; j++) {
                    var currentOption = currentFilter.InputOptions[j];

                    // Add selected options to temp array
                    if (currentOption.isChecked) {
                        checkedOptions.push(currentOption.DisplayName);
                    }
                }

                if (checkedOptions.length > 0) {
                    currentFilterString = currentFilter.Deprecated_ProductAttributeNameId + '_' + checkedOptions.join('~');
                    filterStringsForURL.push(currentFilterString);
                }
            }

            // If numeric checkbox list
            if (currentFilter.TypeId === 2) {
                var numericCheckedOptions = [];
                for (var k = 0; k < currentFilter.InputOptions.length; k++) {
                    // TODO was 'var currentOption', might break
                    var optn = currentFilter.InputOptions[k];

                    // Add selected options to temp array
                    if (optn.isChecked) {
                        numericCheckedOptions.push(optn.DisplayName);
                    }
                }
                // add temp array back into filter object
                if (numericCheckedOptions.length > 0) {
                    currentFilterString = currentFilter.Deprecated_ProductAttributeNameId + '_' + numericCheckedOptions.join('~');
                    filterStringsForURL.push(currentFilterString);
                }
            }

            // If min/max
            if (currentFilter.TypeId === 6) {
                // If min value set
                if (currentFilter.InputRangeAttributes && currentFilter.InputRangeAttributes.minValue) {
                    currentFilterString = currentFilter.Deprecated_ProductAttributeNameId + '_' + currentFilter.InputRangeAttributes.minValue + '_' + currentFilter.SearchFilterTypeId; // -1 => Min
                    filterStringsForURL.push(currentFilterString);
                }
            }

            if (currentFilter.TypeId === 7) {
                // If max value set
                if (currentFilter.InputRangeAttributes && currentFilter.InputRangeAttributes.maxValue) {
                    currentFilterString = currentFilter.Deprecated_ProductAttributeNameId + '_' + currentFilter.InputRangeAttributes.maxValue + '_' + currentFilter.SearchFilterTypeId; // -2 => Max
                    filterStringsForURL.push(currentFilterString);
                }
            }

            // If descriptive input
            if (currentFilter.TypeId === 4 && currentFilter.userInput) {
                currentFilterString = currentFilter.Deprecated_ProductAttributeNameId + '_' + currentFilter.userInput;
                filterStringsForURL.push(currentFilterString);
            }
        }

        return filterStringsForURL;
    };

    this.getFiltersForSearchRequest = function (filterQueryString) {
        // Filter Type Enum
        //    TextSearch = 0
        //    Min = 1
        //    Max = 2
        //

        var filtersForSearch = [];

        var filterPartsFromQueryString = null;

        if (filterQueryString !== undefined && filterQueryString !== '') {
            filterPartsFromQueryString = filterQueryString.split('|');
        }

        if (filterPartsFromQueryString && filterPartsFromQueryString.length > 0) {
            for (var i = 0; i < filterPartsFromQueryString.length; i++) {
                var filterParts = filterPartsFromQueryString[i];
                var parts = filterParts.split('_');
                var productAttributeNameId = parts[0];
                var values = parts[1] ? parts[1].split('~') : null;
                var currentFilter = this.getFilterByAttributeNameId(this.productTypeFilters, productAttributeNameId, parseInt(parts[2]));

                if (currentFilter.TypeId === 1) {
                    // add temp array back into filter object
                    if (values.length > 0) {
                        filtersForSearch.push({
                            FilterName: currentFilter.FilterKey,
                            FilterId: currentFilter.Deprecated_ProductAttributeNameId,
                            FilterType: currentFilter.SearchFilterTypeId, // TextSearch
                            Values: values
                        });
                    }
                }

                // If numeric checkbox list
                if (currentFilter.TypeId === 2) {
                    // add temp array back into filter object
                    if (values.length > 0) {
                        for (var valueIndex = 0; valueIndex < values.length; valueIndex++) {
                            var selectedInputOption = null;

                            for (var inputOptionIndex = 0; inputOptionIndex < currentFilter.InputOptions.length; inputOptionIndex++) {
                                if (values[valueIndex] === currentFilter.InputOptions[inputOptionIndex].DisplayName) {
                                    selectedInputOption = currentFilter.InputOptions[inputOptionIndex];
                                }
                            }

                            filtersForSearch.push({
                                FilterName: currentFilter.FilterKey,
                                FilterId: currentFilter.Deprecated_ProductAttributeNameId,
                                FilterType: currentFilter.SearchFilterTypeId,
                                Values: [selectedInputOption.min, selectedInputOption.max]
                            });
                        }
                    }
                }

                if (currentFilter.TypeId === 6 && currentFilter.InputRangeAttributes) {
                    // If min value set
                    if (currentFilter.InputRangeAttributes.minValue) {
                        filtersForSearch.push({
                            FilterName: currentFilter.FilterKey,
                            FilterId: currentFilter.Deprecated_ProductAttributeNameId,
                            FilterType: currentFilter.SearchFilterTypeId, // Min
                            Values: values
                        });
                    }
                }

                if (currentFilter.TypeId === 7 && currentFilter.InputRangeAttributes) {
                    // If max value set
                    if (currentFilter.InputRangeAttributes.maxValue) {
                        filtersForSearch.push({
                            FilterName: currentFilter.FilterKey,
                            FilterId: currentFilter.Deprecated_ProductAttributeNameId,
                            FilterType: currentFilter.SearchFilterTypeId, // Max
                            Values: values
                        });
                    }
                }

                if (currentFilter.TypeId === 4 && currentFilter.userInput) {
                    filtersForSearch.push({
                        FilterName: currentFilter.FilterKey,
                        FilterId: currentFilter.Deprecated_ProductAttributeNameId,
                        FilterType: currentFilter.SearchFilterTypeId, // Text
                        Values: [currentFilter.userInput]
                    });
                }
            }
        }

        return filtersForSearch;
    };

    // specific for min/max filters, min filter is passed into the minmax directive, and the max filter is requested upon initialization
    this.getMaxFilter = function (filterToMatch) {
        var filter = null;

        // looping through filters looking for filtertypeid = 7 (max), that matches the display name (Maybe could match an id?)

        for (var i = 0; i < this.productTypeFilters.length; i++) {
            if (this.productTypeFilters[i].TypeId === 7 && this.productTypeFilters[i].DisplayName === filterToMatch.DisplayName) {
                filter = this.productTypeFilters[i];
                break;
            }
        }

        return filter;
    };

    function getFiltersByName(filters, name) {
        var foundFilters = [];

        for (var i = 0; i < filters.length; i++) {
            if (filters[i].FilterKey.toLowerCase() === name.toLowerCase()) {
                foundFilters.push(filters[i]);
            }
        }

        return foundFilters;
    }

    function getOptionsList(values, productAttributeNameId) {
        var options = [];

        // optn.optionID = vm.currentFilter.ProductAttributeNameId + "-" + options;
        // optn.isChecked = false;
        // optn.letter = optn.DisplayName.charAt(0);

        for (var i = 0; i < values.length; i++) {
            options.push({
                DisplayName: values[i].Value,
                isChecked: false,
                letter: values[i].Value.charAt(0),
                optionID: productAttributeNameId + '-' + i,
                count: values[i].Count
            });
        }

        return options;
    }

    function getMinMaxRangeValues(filter, values) {
        var min = null;
        var max = null;

        for (var i = 0; i < values.length; i++) {
            var value = parseFloat(values[i].Value);

            if (i === 0) {
                min = value;
                max = value;
                continue;
            }

            min = min > value ? value : min;
            max = max < value ? value : max;
        }

        return {
            Min: min,
            Max: max
        };
    }
}

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ProductLookupService;
ProductLookupService.$inject = ['$timeout', '$q', '$http', 'HPConfig', 'geoStateCacheService'];
// /* jshint ignore:start */
// (function () {
//     'use strict';
//     angular.module('HeroPRO')
//       .service('productLookupService',

/* @ngInject */
function ProductLookupService($timeout, $q, $http, HPConfig, geoStateCacheService) {
    var serviceBase = HPConfig.heroProApi;

    // Product Categories
    var _productCategories = {};
    var _getProductCategories = function _getProductCategories(geoState, programId) {
        //should this be a route?
        var _url = serviceBase + 'ProductLookup/GetCategories?geoState=' + geoState + '&programId=' + programId + '&includeProductTypes';
        if (programId === null || programId === 'undefined') _url = serviceBase + 'ProductLookup/GetCategories?geoState=' + geoState + '&includeProductTypes';
        var deferred = $q.defer();

        $http.get(_url).then(function (results) {
            deferred.resolve(results);
        });

        return deferred.promise;
    };
    this.getProductCategories = function (geoState, programId) {
        var deferred = $q.defer();

        if (angular.isDefined(_productCategories[geoState])) {
            deferred.resolve(_productCategories[geoState]);
            return deferred.promise;
        }

        _getProductCategories(geoState, programId).then(function (results) {
            _productCategories[geoState] = results;
            deferred.resolve(results);
        });

        return deferred.promise;
    };
    // END Product Categories


    // Geo State
    var _geoStates = void 0;
    var _getGeoStates = function _getGeoStates(request) {
        var _url = serviceBase + 'ProductLookup/GetGeoStates';
        var deferred = $q.defer();
        $http.get(_url).then(function (results) {
            deferred.resolve(results);
        });

        return deferred.promise;
    };
    this.getGeoStates = function (request) {
        var deferred = $q.defer();

        if (angular.isDefined(_geoStates)) {
            deferred.resolve(_geoStates);
            return deferred.promise;
        }

        _getGeoStates(request).then(function (results) {
            _geoStates = results;
            deferred.resolve(results);
        });

        return deferred.promise;
    };
    // END Geo State


    // Product Search
    var _productSearch = void 0;
    var _getProductSearch = function _getProductSearch(request) {
        var _url = serviceBase + 'ProductLookup/ProductSearch';
        var deferred = $q.defer();
        $http.post(_url, request).then(function (results) {
            deferred.resolve(results);
        });

        return deferred.promise;
    };
    this.getProductSearch = function (request) {
        var deferred = $q.defer();

        _getProductSearch(request).then(function (results) {
            _productSearch = results;
            deferred.resolve(results);
        });

        return deferred.promise;
    };
    // END Product Search

    // Product Type Search
    var _productTypeSearch = void 0;
    var _getProductTypeSearch = function _getProductTypeSearch(request) {
        var _url = serviceBase + 'ProductLookup/ProductTypeSearch?searchTerm=' + request.searchTerm + '&StateGeoAbbreviation=' + geoStateCacheService.getCurrentStateObject().StateAbbreviation;
        var deferred = $q.defer();
        $http.get(_url).then(function (results) {
            deferred.resolve(results);
        });

        return deferred.promise;
    };
    this.getProductTypeSearch = function (request) {
        var deferred = $q.defer();

        _getProductTypeSearch(request).then(function (results) {
            _productTypeSearch = results;
            deferred.resolve(results);
        });

        return deferred.promise;
    };
    // END Product Type Search

    // Product Filters
    var _productFilters = void 0;
    var _getProductFilters = function _getProductFilters(productTypeId) {
        var _url = serviceBase + 'ProductLookup/ProductFilters?ProductTypeId=' + productTypeId;
        var deferred = $q.defer();

        $http.get(_url).then(function (results) {
            deferred.resolve(results);
        });

        return deferred.promise;
    };
    this.getProductFilters = function (productID) {
        var deferred = $q.defer();

        _getProductFilters(productID).then(function (results) {
            _productFilters = results;
            deferred.resolve(results);
        });

        return deferred.promise;
    };
    // END Product Filters

    // Product Info
    var _productInfo = void 0;
    var _getProductInfo = function _getProductInfo(productTypeId, productID) {
        var _url = serviceBase + 'ProductLookup/ProductInfo?ProductTypeId=' + productTypeId + (productID ? '&ProductId=' + productID : '');
        _url += '&geoState=' + geoStateCacheService.getCurrentStateObject().StateAbbreviation;
        var deferred = $q.defer();

        $http.get(_url).then(function (results) {
            deferred.resolve(results);
        });

        return deferred.promise;
    };
    this.getProductInfo = function (productTypeId, productID) {
        var deferred = $q.defer();

        _getProductInfo(productTypeId, productID).then(function (results) {
            _productInfo = results;
            deferred.resolve(results);
        });

        return deferred.promise;
    };
    // END Product Info

    // MFA Calculation
    var _MFAResult = void 0;
    var _getMFACalculation = function _getMFACalculation(request) {
        var _url = serviceBase + 'ProductLookup/MFACalculation';
        var deferred = $q.defer();

        $http.post(_url, request).then(function (results) {
            deferred.resolve(results);
        });

        return deferred.promise;
    };
    this.getMFACalculation = function (productTypeId, productID) {
        var deferred = $q.defer();

        _getMFACalculation(productTypeId, productID).then(function (results) {
            _MFAResult = results;
            deferred.resolve(results);
        });

        return deferred.promise;
    };

    // END Calculation

    // Return data for specific input type
    this.getInputTypeByID = function (data, inputTypeID) {
        for (var i = 0; i < data.length; i++) {
            if (data[i].TypeId === inputTypeID) {
                return data[i].InputOptions;
            }
        }
    };
}

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = geoStateSelectDirective;

/* @ngInject */
function geoStateSelectDirective() {
	return {
		scope: {
			filterList: '='
		},
		restrict: 'E',
		templateUrl: 'app/productCenter/pages/_shared/geoStateSelect/geoStateSelect.html',
		controller: 'GEOStateSelectController',
		controllerAs: 'geoState'
	};
}

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = GEOStateSelectController;
GEOStateSelectController.$inject = ['$rootScope', '$scope', '$state', '$location', '$stateParams', '$timeout', 'geoStateCacheService', 'categoryCacheService', 'productFilterService'];


/* @ngInject */
function GEOStateSelectController($rootScope, $scope, $state, $location, $stateParams, $timeout, geoStateCacheService, categoryCacheService, productFilterService) {
    var vm = this;
    vm.selectedState = '';
    vm.selectedStateOptions = [];

    // Wait until Categories & Geo States are set
    $scope.$on('productCenter.setupComplete', function () {
        init();
    });

    init();

    // Dynamically set State Options
    $rootScope.$on('productCenter.setupComplete', function () {});

    vm.switchState = function (i) {
        vm.selectedState = vm.stateSelectOptions[i];

        categoryCacheService.clearCategories();

        productFilterService.clearFilterDTOs();

        $location.search('filters', '');

        $state.go('product-lookup', {
            GeoState: vm.selectedState.StateAbbreviation
        }, {
            notify: true
        });
    };

    function init() {
        vm.stateSelectOptions = geoStateCacheService.getGeoStates();
        vm.selectedState = geoStateCacheService.getGeoStateObject($stateParams.GeoState);

        // Filter out ineligible states
        if ($scope.filterList && $scope.filterList.length > 0) {
            var geoStates = [];

            for (var i = 0; i < $scope.filterList.length; i++) {
                for (var j = 0; j < vm.stateSelectOptions.length; j++) {
                    if ($scope.filterList[i] === vm.stateSelectOptions[j].StateAbbreviation) {
                        geoStates.push(vm.stateSelectOptions[j]);
                    }
                }
            }

            vm.stateSelectOptions = geoStates;
        }
    }
}

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = DirectoryBoxDirective;
// angular.module("HeroPRO")
// 	.directive('directoryBox',

/* @ngInject */
function DirectoryBoxDirective() {
    return {
        restrict: 'E',
        templateUrl: 'app/productCenter/pages/productdirectory/directoryBox/directoryBox.html',
        controller: 'DirectoryBoxController',
        controllerAs: 'product'
    };
}

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = DirectoryBoxController;
DirectoryBoxController.$inject = ['$scope', '$attrs', '$window', '$rootScope', 'productLookupService', 'raSpinnerService', 'categoryCacheService', 'geoStateCacheService'];
/* @ngInject */
function DirectoryBoxController($scope, $attrs, $window, $rootScope, productLookupService, raSpinnerService, categoryCacheService, geoStateCacheService) {
    var vm = this;
    vm.category = null;
    vm.iconClass = null;
    vm.currentState = geoStateCacheService.getCurrentStateObject();
    var categoryId = null;

    if ($scope.category) {
        categoryId = $scope.category.Id;
    }

    switch (categoryId) {
        case 1:
            vm.iconClass = 'hvac';
            break;
        case 2:
            vm.iconClass = 'solar';
            break;
        case 3:
            vm.iconClass = 'roofing';
            break;
        case 4:
            vm.iconClass = 'windowdoor';
            break;
        case 5:
            vm.iconClass = 'insulation';
            break;
        case 6:
            vm.iconClass = 'plumbing';
            break;
        case 7:
            vm.iconClass = 'waterheating';
            break;
        case 8:
            vm.iconClass = 'landscaping';
            break;
        case 9:
            vm.iconClass = 'altenergy';
            break;
        case 10:
            vm.iconClass = 'lighting';
            break;
        case 11:
            vm.iconClass = 'pool';
            break;
        case 13:
            vm.iconClass = 'wind';
            break;
    }

    var data = categoryCacheService.getCategories();
    for (var i = 0; i < data.length; i++) {
        if (data[i].Id === parseInt(categoryId)) {
            vm.category = data[i];
        }
    }

    vm.getUrl = function (type) {
        var currentGeoState = geoStateCacheService.getCurrentStateObject();
        if (currentGeoState !== undefined) {
            var GeoStateAbbreviation = currentGeoState.StateAbbreviation;

            return type.NoProducts ? '/product-lookup/detail/' + GeoStateAbbreviation + '/' + type.EETypeId + '_' + type.NoProductProductId : '/product-lookup/search/' + GeoStateAbbreviation + '/' + type.EETypeId + '?query=&filters=';
        }
    };
}

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = InputTypeGeneratorDirective;
// angular.module('HeroPRO').directive('inputTypeGenerator',


function InputTypeGeneratorDirective($compile, $rootScope) {
    return {
        restrict: 'E',
        scope: {
            objectSource: '=',
            formSource: '=',
            last: '='
        },
        link: function link(scope, element) {
            // this is very specific to min/max, would be better to have a general format handler
            function setupMinMaxInputTypeFormatProperties(format) {
                var formatProperties = {};

                formatProperties.minMaxParts = format;

                for (var i = 0; i < formatProperties.minMaxParts.length; i++) {
                    var parts = formatProperties.minMaxParts[i];
                    var name = parts.Name;
                    var value = parts.Value;

                    switch (name) {
                        case 'min':
                            formatProperties.min = parseFloat(value);
                            break;
                        case 'max':
                            formatProperties.max = parseFloat(value);
                            break;
                        case 'format':
                            formatProperties.format = value;
                            break;
                    }
                }

                return formatProperties;
            }

            scope.getFormatProperties = function (format) {
                // we only have one type currently, possible in the future there will be others...
                return setupMinMaxInputTypeFormatProperties(format);
            };

            scope.inputChanged = function () {
                $rootScope.$broadcast('inputTypesDirective.MFAFormChanged');
            };

            // <hp-input-types object-source="inputGroup" form-source="model.mfaForm" last="$last"></hp-input-types>

            var directiveName = 'hp-input-type-' + scope.objectSource.TypeId;
            var generatedTemplate = '<' + directiveName + '></' + directiveName + '>';
            element.append($compile(generatedTemplate)(scope));
        }
    };
}

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = InputTypeCheckboxDirective;
// angular.module("HeroPRO")

// 	.directive('hpInputType2',

function InputTypeCheckboxDirective() {
    return {
        restrict: 'E',
        templateUrl: 'app/productCenter/pages/productdetail/inputTypes/templates/checkbox.html',
        /* @ngInject */
        controller: function controller($scope, $rootScope, $timeout) {
            var vm = this;

            vm.dataSource = $scope.objectSource;
            vm.form = $scope.formSource;
            vm.selectedCheckboxes = [];

            // Access form control object
            var currentFormId = vm.dataSource.TypeId + '-' + vm.dataSource.Deprecated_ProductAttributeNameId;
            vm.form[currentFormId] = {};
            vm.form[currentFormId].checkboxInvalid = !!vm.dataSource.IsRequired;
            vm.form[currentFormId].name = vm.dataSource.DisplayName;

            vm.checkboxValidation = function (model, option) {
                vm.selectedCheckboxes = vm.selectedCheckboxes || [];

                if (model) {
                    vm.selectedCheckboxes.push(option.InputOptionId);
                    /* jshint ignore:start */

                    vm.selectedCheckboxes = _.uniq(vm.selectedCheckboxes);
                } else {
                    vm.selectedCheckboxes = _.without(vm.selectedCheckboxes, option.InputOptionId);
                    /* jshint ignore:end */
                }

                if (vm.selectedCheckboxes.length > 0 && vm.dataSource.IsRequired) {
                    vm.form[currentFormId].checkboxInvalid = false;
                } else if (vm.selectedCheckboxes.length === 0 && vm.dataSource.IsRequired) {
                    vm.form[currentFormId].checkboxInvalid = true;
                } else if (!vm.dataSource.IsRequired) {
                    vm.form[currentFormId].checkboxInvalid = false;
                }

                $timeout(function () {
                    $rootScope.$broadcast('inputTypesDirective.checkBoxValidation');
                });
            };

            // Common
            vm.inputChanged = function () {
                $scope.inputChanged();
            };

            if ($scope.last) {
                $rootScope.$broadcast('inputTypesDirective.filtersLoaded');
            }
        },

        controllerAs: 'inputTypes'
    };
}

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = InputTypeDropdownDirective;
// angular.module("HeroPRO")

// 	.directive('hpInputType4',

function InputTypeDropdownDirective() {
    return {
        restrict: 'E',
        templateUrl: 'app/productCenter/pages/productdetail/inputTypes/templates/dropdown.html',
        /* @ngInject */
        controller: function controller($scope, $rootScope) {
            var vm = this;

            vm.dataSource = $scope.objectSource;
            vm.form = $scope.formSource;

            var selectedDropDownItemInputId = vm.dataSource.TypeId + '-' + vm.dataSource.Deprecated_ProductAttributeNameId;
            vm.dropDownItems = vm.dataSource.InputOptions;
            vm.selectedDropDownItem = vm.dropDownItems[0];
            vm.form[selectedDropDownItemInputId] = vm.selectedDropDownItem;

            vm.switchOption = function (i) {
                // update drowdown
                vm.selectedDropDownItem = vm.dropDownItems[i];
                // update hidden input
                vm.form[selectedDropDownItemInputId] = vm.selectedDropDownItem;
            };

            // Common
            vm.inputChanged = function () {
                $scope.inputChanged();
            };

            if ($scope.last) {
                $rootScope.$broadcast('inputTypesDirective.filtersLoaded');
            }
        },

        controllerAs: 'inputTypes'
    };
}

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = InputTypeNumericTextboxDirective;
// angular.module("HeroPRO")

// 	.directive('hpInputType1',

function InputTypeNumericTextboxDirective() {
    return {
        restrict: 'E',
        templateUrl: 'app/productCenter/pages/productdetail/inputTypes/templates/numericTextbox.html',
        /* @ngInject */
        controller: function controller($scope, $rootScope) {
            var vm = this;

            vm.numberInput = null;

            vm.dataSource = $scope.objectSource;
            vm.form = $scope.formSource;

            if ($scope.objectSource.Format) {
                vm.formatProperties = $scope.getFormatProperties($scope.objectSource.Format);
            }

            // Common
            vm.inputChanged = function () {
                $scope.inputChanged();
            };

            if ($scope.last) {
                $rootScope.$broadcast('inputTypesDirective.filtersLoaded');
            }
        },

        controllerAs: 'inputTypes'
    };
}

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = InputTypeRadioDirective;
// angular.module("HeroPRO")

// 	.directive('hpInputType3',

function InputTypeRadioDirective() {
    return {
        restrict: 'E',
        templateUrl: 'app/productCenter/pages/productdetail/inputTypes/templates/radio.html',
        /* @ngInject */
        controller: function controller($scope, $rootScope) {
            var vm = this;

            vm.numberInput = null;

            vm.dataSource = $scope.objectSource;
            vm.form = $scope.formSource;

            vm.radio = vm.dataSource.InputOptions[0].InputOptionId;

            // Common
            vm.inputChanged = function () {
                $scope.inputChanged();
            };

            if ($scope.last) {
                $rootScope.$broadcast('inputTypesDirective.filtersLoaded');
            }
        },

        controllerAs: 'inputTypes'
    };
}

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = SearchFilterGeneratorDirective;
SearchFilterGeneratorDirective.$inject = ['$compile', '$rootScope', '$location'];
// angular.module('HeroPRO').directive('searchFilterGenerator',

/* @ngInject */
function SearchFilterGeneratorDirective($compile, $rootScope, $location) {
    return {
        restrict: 'E',
        scope: {
            currentFilter: '=',
            last: '='
        },
        link: function link(scope, element) {
            scope.processFilter = function () {
                $rootScope.$broadcast('searchFiltersGenerator.processFilter');
            };

            scope.getFilterURLValues = function (currentFilter) {
                var resultValues = [];

                /* global atob */
                var filterQueryString = $location.search().filters ? atob($location.search().filters) : undefined;
                var filterPartsFromQueryString = null;

                if (filterQueryString !== undefined && filterQueryString !== '') {
                    filterPartsFromQueryString = filterQueryString.split('|');
                }

                if (filterPartsFromQueryString && filterPartsFromQueryString.length > 0) {
                    for (var filterParts in filterPartsFromQueryString) {
                        var parts = filterPartsFromQueryString[filterParts].split('_');
                        var productAttributeNameId = parts[0];
                        var values = parts[1] ? parts[1].split('~') : null;

                        if (currentFilter.Deprecated_ProductAttributeNameId === parseInt(productAttributeNameId)) {
                            resultValues.push({ values: values, searchFilterType: parts[2] });
                        }
                    }
                }

                if (resultValues.length === 0) {
                    resultValues.push({ values: [] });
                }

                return resultValues;
            };

            // ignore 7 (the max filter type)
            var generatedTemplate = '<search-filters-' + scope.currentFilter.TypeId + '></search-filters>'; // '<' + scope.filter.FilterId + '-feed-item item="item"></div>';
            element.append($compile(generatedTemplate)(scope));
        }
    };
}

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = searchFilters1Directive;
searchFilters1Controller.$inject = ['$scope', '$attrs', '$stateParams', '$location', '$timeout', '$anchorScroll', '$window', '$rootScope', 'raSpinnerService', 'productLookupService', 'productFilterService', 'orderByFilter', 'optionsPopupService'];

/* @ngInject */
function searchFilters1Controller($scope, $attrs, $stateParams, $location, $timeout, $anchorScroll, $window, $rootScope, raSpinnerService, productLookupService, productFilterService, orderByFilter, optionsPopupService) {
    var vm = this;
    var MINIMUM_DISPLAYED_LIST_LENGTH = 7;
    var checkboxTimeout = void 0;

    vm.currentFilter = $scope.currentFilter;
    vm.currentFilterTypeId = vm.currentFilter.TypeId;
    vm.currentFilter.showFilter = true;

    // run on init
    function init() {
        addOptionAttributes();
        updateFilterFromURL();

        if ($scope.last) {
            $rootScope.$broadcast('searchFiltersDirective.filtersLoaded');
        }
    }
    init();

    function addOptionAttributes() {
        // Add attributes to all checkbox options
        vm.currentFilter.InputOptions = orderByFilter(vm.currentFilter.InputOptions, '+DisplayName');
        for (var options in vm.currentFilter.InputOptions) {
            var optn = vm.currentFilter.InputOptions[options];
            optn.optionID = vm.currentFilter.Deprecated_ProductAttributeNameId + '-' + options;
            optn.isChecked = false;
            optn.letter = optn.DisplayName.charAt(0);
        }

        // Find matching object in productFilterService and copy entire filter back in for a clean version
        for (var filter in productFilterService.productTypeFilters) {
            if (productFilterService.productTypeFilters[filter].Deprecated_ProductAttributeNameId === vm.currentFilter.Deprecated_ProductAttributeNameId) {
                productFilterService.productTypeFiltersClean[filter] = angular.copy(vm.currentFilter);
            }
        }
    }

    function updateFilterFromURL() {
        var currentFilter = vm.currentFilter;
        var values = $scope.getFilterURLValues(currentFilter)[0].values;

        if (currentFilter.InputOptions) {
            // loop through the checkbox options and set checked true where value is matched
            for (var i = 0; i < currentFilter.InputOptions.length; i++) {
                for (var j = 0; j < values.length; j++) {
                    if (currentFilter.InputOptions[i].DisplayName === values[j]) {
                        currentFilter.InputOptions[i].isChecked = true;
                        break;
                    }
                }
            }

            var optionsChecked = [];
            var optionsNotChecked = [];

            for (var k = 0; k < currentFilter.InputOptions.length; k++) {
                // js lint complained about a ternary that doesn't assign any result..
                if (currentFilter.InputOptions[k].isChecked) {
                    optionsChecked.push(currentFilter.InputOptions[k]);
                } else {
                    optionsNotChecked.push(currentFilter.InputOptions[k]);
                }
            }

            // concatenate checked and not checked, do not do this on numeric range inputs
            currentFilter.InputOptions = optionsChecked.concat(optionsNotChecked);
            currentFilter.DisplayLimit = optionsChecked.length > MINIMUM_DISPLAYED_LIST_LENGTH ? optionsChecked.length : currentFilter.DisplayLimit;
        }
    }

    (function checkFilterShow() {
        if (typeof vm.currentFilter.InputOptions === 'undefined' || vm.currentFilter.InputOptions !== null) {
            vm.currentFilter.showFilter = true;
        } else if (vm.currentFilter.InputOptions === null) {
            vm.currentFilter.showFilter = false;
        }
    })();

    // Function to pass options from "vew all" link to popup box, then alphabetize
    vm.showOptionsPopup = function () {
        optionsPopupService.setPopupData({
            currentFilter: vm.currentFilter,
            alphabeticalOptions: orderByFilter(vm.currentFilter.InputOptions, '+DisplayName')
        });
        $rootScope.$broadcast('searchFilters.showOptionsPopup');
    };

    vm.checkboxChanged = function () {
        $timeout.cancel(checkboxTimeout);

        checkboxTimeout = $timeout(function () {
            $scope.processFilter();
        }, 500);
    };
}

function searchFilters1Directive() {
    return {
        restrict: 'E',
        templateUrl: 'app/productCenter/pages/productsearch/searchFilters/templates/checkbox.html',
        controller: searchFilters1Controller,
        controllerAs: 'searchFilter'
    };
}

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = SearchFilters4Directive;
SearchFilters4Controller.$inject = ['$scope', '$attrs', '$stateParams', '$location', '$timeout', '$anchorScroll', '$window', '$rootScope', 'raSpinnerService', 'productLookupService', 'productFilterService'];

/* @ngInject */
function SearchFilters4Controller($scope, $attrs, $stateParams, $location, $timeout, $anchorScroll, $window, $rootScope, raSpinnerService, productLookupService, productFilterService) {
    var vm = this;

    vm.currentFilter = $scope.currentFilter;
    vm.currentFilterTypeId = vm.currentFilter.TypeId;
    vm.descriptiveInput = vm.currentFilter.userInput;
    vm.dirty = false;

    // run on init
    function init() {
        updateFilterFromURL();

        if ($scope.last) {
            $rootScope.$broadcast('searchFiltersDirective.filtersLoaded');
        }
    }
    init();

    function updateFilterFromURL() {
        var currentFilter = vm.currentFilter;
        var values = $scope.getFilterURLValues(currentFilter)[0].values;

        var descriptiveInputText = values[0];

        // set service dto
        var filterForDescriptiveInput = productFilterService.getFilterByAttributeNameId(productFilterService.productTypeFilters, currentFilter.Deprecated_ProductAttributeNameId);
        if (filterForDescriptiveInput) {
            filterForDescriptiveInput.userInput = descriptiveInputText;
            vm.descriptiveInput = descriptiveInputText;

            if (typeof descriptiveInputText !== 'undefined' && descriptiveInputText !== null && descriptiveInputText.length > 0) {
                vm.dirty = true;
            }
        }
    }

    // vm.descriptiveInputChanged = function() {
    //     //$rootScope.$broadcast('searchFiltersDirective.descriptive-input-changed');
    //     if(vm.descriptiveInput.length >= 3) {
    //     	vm.currentFilter.userInput = vm.descriptiveInput;
    //     	$scope.processFilter();
    //     } else if (vm.currentFilter.userInput !== vm.descriptiveInput && vm.descriptiveInput.length === 0) {
    //     	vm.currentFilter.userInput = vm.descriptiveInput;
    //     	$scope.processFilter();
    //     }
    // };

    vm.descriptiveInputSubmit = function () {
        vm.currentFilter.userInput = vm.descriptiveInput;
        $scope.processFilter();
        vm.dirty = true;
    };
}

function SearchFilters4Directive() {
    return {
        restrict: 'E',
        templateUrl: 'app/productCenter/pages/productsearch/searchFilters/templates/descriptive-input.html',
        controller: SearchFilters4Controller,
        controllerAs: 'searchFilter'
    };
}

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = SearchFilters6Directive;
SearchFilters6Controller.$inject = ['$scope', '$attrs', '$stateParams', '$location', '$timeout', '$anchorScroll', '$window', '$rootScope', 'raSpinnerService', 'productLookupService', 'productFilterService'];


/* @ngInject */
function SearchFilters6Controller($scope, $attrs, $stateParams, $location, $timeout, $anchorScroll, $window, $rootScope, raSpinnerService, productLookupService, productFilterService) {
    var vm = this;

    vm.maxFilter = productFilterService.getMaxFilter($scope.currentFilter);
    vm.minFilter = $scope.currentFilter;

    vm.currentFilter = $scope.currentFilter;
    vm.currentFilterTypeId = vm.currentFilter.TypeId;

    // run on init

    function init() {
        // On init, otherwise will set dynamically later when user enters values
        vm.minLimit = null;
        vm.maxLimit = null;
        vm.minValue = null;
        vm.maxValue = null;

        updateFilterFromURL();

        if ($scope.last) {
            $rootScope.$broadcast('searchFiltersDirective.filtersLoaded');
        }
    }
    init();

    (function checkFilterShow() {
        if (typeof vm.currentFilter.InputRangeAttributes === 'undefined' || vm.currentFilter.InputRangeAttributes !== null) {
            vm.currentFilter.showFilter = true;
        } else if (vm.currentFilter.InputRangeAttributes === null) {
            vm.currentFilter.showFilter = false;
        }
    })();

    function updateFilterFromURL() {
        var currentFilter = vm.currentFilter;
        var urlResults = $scope.getFilterURLValues(currentFilter);

        for (var i = 0; i < urlResults.length; i++) {
            if (urlResults[i].searchFilterType === '2') {
                // min
                var minimum = parseFloat(urlResults[i].values[0]);

                // set service dto
                var filterForMin = productFilterService.getFilterByAttributeNameId(productFilterService.productTypeFilters, currentFilter.Deprecated_ProductAttributeNameId);

                if (filterForMin.InputRangeAttributes) {
                    currentFilter.InputRangeAttributes.minValue = minimum;
                } else {
                    currentFilter.InputRangeAttributes = { minValue: minimum };
                }

                // set vm model
                vm.minValue = currentFilter.InputRangeAttributes.minValue;
            }

            // If max value set
            if (urlResults[i].searchFilterType === '3') {
                // max
                var maximum = parseFloat(urlResults[i].values[0]);

                // set service dto
                var filterForMax = productFilterService.getFilterByAttributeNameId(productFilterService.productTypeFilters, currentFilter.Deprecated_ProductAttributeNameId);

                if (filterForMax.InputRangeAttributes) {
                    currentFilter.InputRangeAttributes.maxValue = maximum;
                } else {
                    currentFilter.InputRangeAttributes = { maxValue: maximum };
                }

                // set vm model
                vm.maxValue = currentFilter.InputRangeAttributes.maxValue;
            }
        }

        // setup the max filter
        vm.maxFilter.InputRangeAttributes = angular.copy(currentFilter.InputRangeAttributes);
    }

    function updateFilterMinMaxLimits() {
        if (vm.currentFilter.InputRangeAttributes) {
            // Dynamically set min max limits on whats returned from the backend, unless entered value in opposite field is less/greater than that
            vm.minLimit = vm.minValue && vm.minValue > vm.currentFilter.InputRangeAttributes.Min ? vm.minValue : vm.currentFilter.InputRangeAttributes.Min;
            vm.maxLimit = vm.maxValue && vm.maxValue < vm.currentFilter.InputRangeAttributes.Max ? vm.maxValue : vm.currentFilter.InputRangeAttributes.Max;
        }
    }
    updateFilterMinMaxLimits();

    vm.minMaxChanged = function () {
        for (var filter in productFilterService.productTypeFilters) {
            // Create new values in main DTO for user input values
            if (productFilterService.productTypeFilters[filter].Deprecated_ProductAttributeNameId === vm.currentFilter.Deprecated_ProductAttributeNameId) {
                // setup if not set (for max)
                if (!productFilterService.productTypeFilters[filter].InputRangeAttributes) {
                    productFilterService.productTypeFilters[filter].InputRangeAttributes = { minValue: null, maxValue: null };
                }

                productFilterService.productTypeFilters[filter].InputRangeAttributes.minValue = vm.minValue;
                productFilterService.productTypeFilters[filter].InputRangeAttributes.maxValue = vm.maxValue;
            }
        }

        updateFilterMinMaxLimits();

        $scope.processFilter();

        // check for a few different scenarios for min/max filters on when we should run search
        var minValueAboveLimit = vm.minLimit <= vm.minValue && vm.minValue <= vm.maxLimit;
        var maxValueBelowLimit = vm.minLimit <= vm.maxValue && vm.maxValue <= vm.maxLimit;

        var minValid = vm.minValue ? vm.minValue && minValueAboveLimit : true;
        var maxValid = vm.maxValue ? vm.maxValue && maxValueBelowLimit : true;

        // Make sure min & max values are valid then trigger search
        // if ((min is entered and above limit) OR (max is entered and below limit)
        if (minValid && maxValid) {
            // $rootScope.$broadcast('searchFiltersDirective.descriptive-input-changed');
            $scope.processFilter();
        }
    };

    vm.showApply = function () {
        return vm.minValue !== null || vm.minValue !== null || vm.maxValue !== null || vm.maxValue !== null;
    };
}

function SearchFilters6Directive() {
    return {
        restrict: 'E',
        templateUrl: 'app/productCenter/pages/productsearch/searchFilters/templates/minmax.html',
        /* @ngInject */
        controller: SearchFilters6Controller,
        controllerAs: 'searchFilter'
    };
}

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = SearchFilters2;
SearchFilters2Controller.$inject = ['$scope', '$attrs', '$stateParams', '$location', '$timeout', '$anchorScroll', '$window', '$rootScope'];

/* @ngInject */
function SearchFilters2Controller($scope, $attrs, $stateParams, $location, $timeout, $anchorScroll, $window, $rootScope) {
    var vm = this;
    var MINIMUM_DISPLAYED_LIST_LENGTH = 7;
    var checkboxTimeout = void 0;

    vm.currentFilter = $scope.currentFilter;
    vm.currentFilterTypeId = vm.currentFilter.TypeId;
    vm.numbericCheckboxListOptions = [];

    // run on init
    function init() {
        getStaticNumericCheckboxList();
        updateFilterFromURL();

        if ($scope.last) {
            $rootScope.$broadcast('searchFiltersDirective.filtersLoaded');
        }
    }
    init();

    function updateFilterFromURL() {
        var currentFilter = vm.currentFilter;
        var values = $scope.getFilterURLValues(currentFilter)[0].values;

        if (currentFilter.InputOptions) {
            // loop through the checkbox options and set checked true where value is matched
            for (var i = 0; i < currentFilter.InputOptions.length; i++) {
                for (var j = 0; j < values.length; j++) {
                    if (currentFilter.InputOptions[i].DisplayName === values[j]) {
                        currentFilter.InputOptions[i].isChecked = true;
                        break;
                    }
                }
            }

            var optionsChecked = [];
            var optionsNotChecked = [];

            for (var k = 0; k < currentFilter.InputOptions.length; k++) {
                // js lint complained about a ternary that doesn't assign any result..
                if (currentFilter.InputOptions[k].isChecked) {
                    optionsChecked.push(currentFilter.InputOptions[k]);
                } else {
                    optionsNotChecked.push(currentFilter.InputOptions[k]);
                }
            }

            // concatenate checked and not checked, do not do this on numeric range inputs
            if (currentFilter.TypeId === 1) {
                currentFilter.InputOptions = optionsChecked.concat(optionsNotChecked);
                currentFilter.DisplayLimit = optionsChecked.length > MINIMUM_DISPLAYED_LIST_LENGTH ? optionsChecked.length : currentFilter.DisplayLimit;
            }
        }
    }

    function getStaticNumericCheckboxList() {
        var formatParts = vm.currentFilter.Format.split('|');
        var low = parseFloat(formatParts[0].split(':')[1]);
        var step = parseFloat(formatParts[1].split(':')[1]);
        // var round = parseInt(formatParts[2].split(":")[1], 10);

        vm.numbericCheckboxListOptions = [];
        var increment = low;
        for (var i = 0; i < vm.currentFilter.DisplayLimit; i++) {
            // First object
            if (i === 0) {
                vm.numbericCheckboxListOptions.push({
                    DisplayName: 'Less than ' + increment,
                    optionID: increment,
                    isChecked: false,
                    min: null,
                    max: increment
                });
            }

            // Last object
            else if (i + 1 === vm.currentFilter.DisplayLimit) {
                    vm.numbericCheckboxListOptions.push({
                        DisplayName: 'Greater than ' + increment,
                        optionID: increment,
                        isChecked: false,
                        min: increment,
                        max: null
                    });
                }

                // Middle objects
                else {
                        vm.numbericCheckboxListOptions.push({
                            DisplayName: increment + ' - ' + Math.floor((increment + step) * 100) / 100, // gets rid of extra decimal spaces
                            optionID: increment + '_' + step,
                            isChecked: false,
                            min: increment,
                            max: increment + step
                        });

                        increment = parseFloat((increment + step).toFixed(2));
                    }

            vm.currentFilter.InputOptions = vm.numbericCheckboxListOptions;
        }
    }

    vm.checkboxChanged = function () {
        $timeout.cancel(checkboxTimeout);

        checkboxTimeout = $timeout(function () {
            $scope.processFilter();
        }, 500);
    };
}

function SearchFilters2() {
    return {
        restrict: 'E',
        templateUrl: 'app/productCenter/pages/productsearch/searchFilters/templates/numeric-checkbox.html',
        controller: SearchFilters2Controller,
        controllerAs: 'searchFilter'
    };
}

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = SearchFilters5Directive;
SearchFilters5DirectiveController.$inject = ['$scope', '$attrs', '$stateParams', '$location', '$timeout', '$anchorScroll', '$window', '$rootScope'];


/* @ngInject */
function SearchFilters5DirectiveController($scope, $attrs, $stateParams, $location, $timeout, $anchorScroll, $window, $rootScope) {
    var vm = this;
    var MINIMUM_DISPLAYED_LIST_LENGTH = 7;
    var checkboxTimeout = void 0;

    vm.currentFilter = $scope.currentFilter;
    vm.currentFilterTypeId = vm.currentFilter.TypeId;
    vm.numbericCheckboxListOptions = [];

    // run on init
    function init() {
        getStaticNumericCheckboxList();
        updateFilterFromURL();

        if ($scope.last) {
            $rootScope.$broadcast('searchFiltersDirective.filtersLoaded');
        }
    }
    init();

    function updateFilterFromURL() {
        var currentFilter = vm.currentFilter;
        var values = $scope.getFilterURLValues(currentFilter)[0].values;

        if (currentFilter.InputOptions) {
            // loop through the checkbox options and set checked true where value is matched
            for (var i = 0; i < currentFilter.InputOptions.length; i++) {
                for (var j = 0; j < values.length; j++) {
                    if (currentFilter.InputOptions[i].DisplayName === values[j]) {
                        currentFilter.InputOptions[i].isChecked = true;
                        break;
                    }
                }
            }

            var optionsChecked = [];
            var optionsNotChecked = [];

            for (var k = 0; k < currentFilter.InputOptions.length; k++) {
                // js lint complained about a ternary that doesn't assign any result..
                if (currentFilter.InputOptions[k].isChecked) {
                    optionsChecked.push(currentFilter.InputOptions[k]);
                } else {
                    optionsNotChecked.push(currentFilter.InputOptions[k]);
                }
            }

            // concatenate checked and not checked, do not do this on numeric range inputs
            if (currentFilter.TypeId === 1) {
                currentFilter.InputOptions = optionsChecked.concat(optionsNotChecked);
                currentFilter.DisplayLimit = optionsChecked.length > MINIMUM_DISPLAYED_LIST_LENGTH ? optionsChecked.length : currentFilter.DisplayLimit;
            }
        }
    }

    function getStaticNumericCheckboxList() {
        var formatParts = vm.currentFilter.Format.split('|');
        var low = parseFloat(formatParts[0].split(':')[1]);
        var step = parseFloat(formatParts[1].split(':')[1]);
        // var round = parseInt(formatParts[2].split(":")[1], 10);

        vm.numbericCheckboxListOptions = [];
        var increment = low;
        for (var i = 0; i < vm.currentFilter.DisplayLimit; i++) {
            // First object
            if (i === 0) {
                vm.numbericCheckboxListOptions.push({
                    DisplayName: 'Less than ' + increment,
                    optionID: increment,
                    isChecked: false,
                    min: null,
                    max: increment
                });
            }

            // Last object
            else if (i + 1 === vm.currentFilter.DisplayLimit) {
                    vm.numbericCheckboxListOptions.push({
                        DisplayName: 'Greater than ' + increment,
                        optionID: increment,
                        isChecked: false,
                        min: increment,
                        max: null
                    });
                }

                // Middle objects
                else {
                        vm.numbericCheckboxListOptions.push({
                            DisplayName: increment + ' - ' + (increment + step).toFixed(2),
                            optionID: increment + '_' + step,
                            isChecked: false,
                            min: increment,
                            max: increment + step
                        });

                        increment = parseFloat((increment + step).toFixed(2));
                    }

            vm.currentFilter.InputOptions = vm.numbericCheckboxListOptions;
        }
    }

    vm.checkboxChanged = function () {
        $timeout.cancel(checkboxTimeout);

        checkboxTimeout = $timeout(function () {
            $scope.processFilter();
        }, 500);
    };
}

function SearchFilters5Directive() {
    return {
        restrict: 'E',
        templateUrl: 'app/productCenter/pages/productsearch/searchFilters/templates/numeric-checkbox-dynamic.html',
        controller: SearchFilters5DirectiveController,
        controllerAs: 'searchFilter'
    };
}

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = PCNumberFormatFilter;
// angular.module('HeroPRO').filter('pcNumberFormat',


function PCNumberFormatFilter() {
    return function (number) {
        if (/^[0-9.]+$/.test(number)) {
            // check if string contains digits
            // if it's a number, trim
            return parseFloat(number).toFixed(2);
        }

        // If it's not a number, return
        return number;
    };
}

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = SelectedOptionsFilter;
SelectedOptionsFilter.$inject = ["limitToFilter"];
// angular.module('HeroPRO').filter('selectedOptions',

/* @ngInject */
function SelectedOptionsFilter(limitToFilter) {
    return function (items) {
        var ordered = [];
        angular.forEach(items, function (item) {
            ordered.push(item);
        });
        ordered.sort(function (a, b) {
            if (a.isChecked === b.isChecked) {
                return a.DisplayName - b.DisplayName;
            } else if (a.isChecked) {
                return -1;
            }
            return -1;
        });

        return limitToFilter(ordered, 10);
    };
}

/***/ }),
/* 301 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-module hp-module-product-center\">\n\n    <div class=\"hp-inner\">\n        <div class=\"product-category-grid hp-loading-spinner container\" ra-spinner name=\"productCenterSpinner\" hide-content-when-shown=\"true\" show=\"true\">\n            <div>\n                <ng-include ng-if=\"productCenter.pageView === 'directory'\" src=\"'app/productCenter/pages/productdirectory/productDirectory.html'\"></ng-include>\n                <ng-include ng-if=\"productCenter.pageView === 'search'\" src=\"'app/productCenter/pages/productsearch/productSearch.html'\"></ng-include>\n                <ng-include ng-if=\"productCenter.pageView === 'detail'\" src=\"'app/productCenter/pages/productdetail/productDetail.html'\"></ng-include>\n                <ng-include ng-if=\"productCenter.pageView === 'error'\" src=\"'app/productCenter/pages/errorPage/errorPage.html'\"></ng-include>\n            </div>\n        </div>\n\n\n    </div>\n</div>\n";

/***/ }),
/* 302 */
/***/ (function(module, exports) {

module.exports = "<div ng-controller=\"EligibilityRequirementsController as model\">\n    <p>HERO Eligibility Requirements <span class=\"link show-hide\" ng-click=\"model.showRequirements = !model.showRequirements\">{{model.showRequirements == true ? 'Hide' : 'Show'}}</span></p>\n    <div ng-show=\"model.showRequirements\" class=\"specifications\">\n    \t<p class=\"title\">Specifications</p>\n    \t<p ng-bind-html=\"model.specifications\"></p>\n    \t<p class=\"title\">Maximum Finance Term</p>\n    \t<p>{{model.mfaTerm}} Years</p>\n    </div>\n    \n</div>\n";

/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports = "<div class=\"state-selector \">\n\t<a href=\"#\" class=\"icon icon-pipeline-tip pull-right\" hp-popover popover-placement=\"left\" popover-trigger=\"show\"\n\t\tpopover-title=\"\" uib-popover=\"Some products or models may not be eligible in all states.\"></a>\n\t<form class=\"hp-dropdown pull-right col-sm-12\">\n\t\t<span uib-dropdown dropdown-small-popup class=\"dropdown\">\n\t\t\t<span uib-dropdown-toggle class=\"dropdown-toggle\">\n\t\t\t\t<a class=\"dropdown-text\" ng-bind=\"geoState.selectedState.StateAbbreviation\"></a>\n\t\t\t\t<span class=\"icon\"></span>\n\t\t\t</span>\n\t\t\t<ul uib-dropdown-menu class=\"dropdown-menu\">\n\t\t\t\t<li ng-click=\"geoState.switchState($index);\"\n\t\t\t\t\tng-repeat=\"option in geoState.stateSelectOptions track by $index\"\n\t\t\t\t\tng-class=\"{ 'active': geoState.selectedState == option }\" \n\t\t\t\t\tng-if=\"option.StateAbbreviation !== 'OH'\">\n\t\t\t\t\t<!-- remove ng-if to show OH Product Lookup -->\n\t\t\t\t\t<a ng-bind=\"option.StateAbbreviation\"></a>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t</span>\n\t</form>\n\t<span class=\"text-right\">\n\t\tView Products For:\n\t</span>\n</div>";

/***/ }),
/* 304 */
/***/ (function(module, exports) {

module.exports = "<div ng-controller=\"ProductDetailController as model\">\n    <div class=\"product-detail-container\">\n        <div class=\"product-center-breadcrumbs row\">\n            <div class=\"col-sm-12\">\n                <a class=\"crumb link\" href=\"/product-lookup/directory/{{model.productGeoState}}/\">Browse Products</a> >\n                <span ng-if=\"!model.type.NoProducts\">\n                    <a class=\"crumb link\" href=\"/product-lookup/search/{{model.productGeoState}}/{{model.productTypeID}}\">{{model.type.NamePlural}}</a> >\n                    <span class=\"crumb\">{{model.productDetail.DisplayName}}</span>\n                </span>\n                <span ng-if=\"model.type.NoProducts\">\n                    <span class=\"crumb\">{{model.type.NamePlural}}</span>\n                </span>\n            </div>\n        </div>\n        <div class=\"product-detail-header pc-header row\">\n            <div class=\"col-sm-8\" ng-if=\"model.type.NoProducts\">\n                <h1>{{model.type.NamePlural}}</h1>\n                <ng-include src=\"'app/productCenter/pages/_shared/eligibilityrequirements/eligibilityRequirements.html'\" />\n            </div>\n            <div class=\"col-sm-8\" ng-if=\"!model.type.NoProducts\">\n                <h1>{{model.productDetail.DisplayName}}</h1>\n            </div>\n            <div class=\"col-sm-4\">\n                <a href=\"mailto:productlookupfeedback@heroprogram.com\" class=\"ask-question text-right\">Give Us Feedback</a>\n                <p class=\"text-right pull-right view-prods\">Viewing Products for <span class=\"caps\">{{model.currentGeoStateObject.Name}}</span></p>\n            </div>\n        </div>\n        <div class=\"product-specification-body row hp-loading-spinner\" ra-spinner name=\"productDetailSpinner\" hide-content-when-shown=\"true\" show=\"true\">\n            <div class=\"col-sm-8 spec-details\" ng-if=\"!model.type.NoProducts\">\n                <div class=\"col-sm-11\">\n                    <table>\n                        <thead>\n                            <tr>\n                                <td colspan=\"2\">Product Details</td>\n                            </tr>\n                        </thead>\n                        <tbody>\n                            <tr ng-repeat=\"detail in model.productDetail.Attributes | orderBy: 'LongDetailAttributeOrder'\">\n                                <td>{{detail.DisplayName}}</td>\n                                <td>{{detail.Value}}</td>\n                            </tr>\n                        </tbody>\n                    </table>\n                </div>\n            </div>\n            <div ng-class=\"{'col-sm-4':!model.type.NoProducts, 'col-sm-8 col-sm-offset-2' : model.type.NoProducts}\" ng-if=\"model.showMFACalc\">\n                <h2>How Much Financing Can HERO Provide?</h2>\n                <div ng-if=\"!model.productDetail.InputsForMFA\">\n                    <p>We don’t have enough pricing info on this product right now to calculate the maximum finance amount. Check back for updates.</p>\n                </div>\n                <div ng-if=\"model.productDetail.InputsForMFA\">\n                    <p>Give us the installation details and we will let you know the maximum price for which HERO can provide financing.</p>\n                    <form name=\"model.mfaForm\">\n                        <div class=\"conditions\">\n                            <div class=\"condition\" ng-repeat=\"inputGroup in model.productDetail.InputsForMFA | orderBy : 'DisplayOrder'\">\n                                <!--<hp-input-types object-source=\"inputGroup\" form-source=\"model.mfaForm\" last=\"$last\"></hp-input-types>-->\n                                <!-- inputTypeGenerator -->\n                                <input-type-generator class=\"hp-input-types\" object-source=\"inputGroup\" form-source=\"model.mfaForm\" last=\"$last\"></input-type-generator>\n                            </div>\n                        </div>\n                        <!-- Comment this back in when the low/median/max chart is ready\n                        <div class=\"mfa-bar-graph\" ng-show=\"model.MFAResultMax\">\n                            <p>HERO Price Range</p>\n                            <div class=\"graph\" >\n                                <div class=\"low\">\n                                    <span>{{model.MFAResultLow|currency:'$':0}}</span>\n                                    <p>LOW</p>\n                                </div>\n                                <div class=\"average\">\n                                    <span>{{model.MFAResultMean|currency:'$':0}}</span>\n                                    <p>AVERAGE</p>\n                                </div>\n                                <div class=\"max\">\n                                    <span>{{model.MFAResultMax|currency:'$':0}}</span>\n                                    <p>MAX</p>\n                                </div>\n                            </div>\n                        </div>\n                        <button class=\"total-result text-center\"\n                                ng-click=\"model.calculateMFA();\"\n                                ng-disabled=\"(model.mfaForm.$invalid || model.mfaForm.$pristine) || !model.formCheckBoxesValid || model.MFAResultMax\">\n                                {{model.calculatedOnce ? 'Recalculate' : 'Calculate'}}                            \n                        </button> -->\n                        <button class=\"total-result text-center\"\n                                ng-click=\"model.calculateMFA();\"\n                                ng-class=\"{'calculated' : model.MFAResultMax}\"\n                                ng-disabled=\"(model.mfaForm.$invalid || model.mfaForm.$pristine) || !model.formCheckBoxesValid\">\n                                <span ng-if=\"model.MFAResultMax !== null\" class=\"max-price\">Max Price</span>\n                            {{model.MFAResultMax == null ? \"calculate\" : (model.MFAResultMax|currency:'$':0)}}\n                        </button>\n\n                    </form>\n                    <p class=\"legal\">*PRODUCT ELIGIBLE FINANCE AMOUNT IS SUBJECT TO CHANGE AND IS NOT TIED TO THE HERO FINANCING APPLICATION APPROVAL AMOUNT, WHICH IS SUBJECT TO THE PROPERTY OWNER MEETING ALL OTHER ELIGIBILITY REQUIREMENTS. REQUESTED PRODUCT FINANCE AMOUNT MAY ONLY INCLUDE COSTS OF HERO-ELIGIBLE PRODUCTS AND COSTS DIRECTLY RELATED TO THE INSTALLATION OF ELIGIBLE PRODUCTS. COSTS OF INELIGIBLE PRODUCTS MAY NOT BE INCLUDED IN REQUESTED AMOUNT.</p>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 305 */
/***/ (function(module, exports) {

module.exports = "<!-- CHECKBOXES -->\n<div class=\"checkboxes\"\n     ng-class=\"{'columns' : inputTypes.dataSource.InputOptions.length > 5}\">\n    <p>{{inputTypes.dataSource.DisplayName}}<span ng-show=\"inputTypes.dataSource.IsRequired\" class=\"required\"> *</span></p>\n    <div class=\"column-wrapper\">\n        <div class=\"input-wrapper\" ng-repeat=\"option in inputTypes.dataSource.InputOptions\">\n            <input type=\"checkbox\"\n                   ng-model=\"inputTypes.form[inputTypes.dataSource.TypeId + '-' + inputTypes.dataSource.Deprecated_ProductAttributeNameId][option.InputOptionId]\"\n                   ng-change=\"inputTypes.inputChanged()\"\n                   ng-click=\"inputTypes.checkboxValidation(inputTypes.form[inputTypes.dataSource.TypeId + '-' + inputTypes.dataSource.Deprecated_ProductAttributeNameId][option.InputOptionId], option)\"\n                   id=\"{{option.InputOptionId}}\" />\n            <label for=\"{{option.InputOptionId}}\">\n                <span></span>\n            </label>\n            {{checkbox.Name}}\n            {{option.DisplayName}}\n            <br />\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports = "<!-- DROPDOWN -->\n<div class=\"dropdown-input\">\n    <p>{{inputTypes.dataSource.DisplayName}}<span ng-show=\"inputTypes.dataSource.IsRequired\" class=\"required\"> *</span></p>\n\n    <input name=\"{{inputTypes.form[inputTypes.dataSource.TypeId + '-' + inputTypes.dataSource.Deprecated_ProductAttributeNameId]}}\"\n           ng-model=\"inputTypes.form[inputTypes.dataSource.TypeId + '-' + inputTypes.dataSource.Deprecated_ProductAttributeNameId]\"\n           class=\"hide\" />\n\n    <div class=\"hp-dropdown\">\n        <span uib-dropdown dropdown-small-popup class=\"dropdown\">\n            <span uib-dropdown-toggle class=\"dropdown-toggle\">\n                <a class=\"dropdown-text\"\n                   ng-bind=\"inputTypes.selectedDropDownItem.DisplayName\"></a>\n                <span class=\"icon\"></span>\n            </span>\n            <ul uib-dropdown-menu class=\"dropdown-menu\">\n                <li ng-click=\"inputTypes.switchOption($index); inputTypes.inputChanged();\"\n                    ng-repeat=\"option in inputTypes.dataSource.InputOptions\"\n                    ng-class=\"{ 'active': inputTypes.selectedDropDownItem == option }\">\n                    <a ng-bind=\"option.DisplayName\"></a>\n                </li>\n            </ul>\n        </span>\n    </div>\n</div>";

/***/ }),
/* 307 */
/***/ (function(module, exports) {

module.exports = "<!-- TEXTBOX -->\n<div class=\"number-input\">\n    <p>{{inputTypes.dataSource.DisplayName}}<span ng-show=\"inputTypes.dataSource.IsRequired\" class=\"required\"> *</span></p>\n    <input placeholder=\"{{inputTypes.formatProperties.min}} - {{inputTypes.formatProperties.max}}\"\n           type=\"number\"\n           class=\"number-input\"\n           ng-model=\"inputTypes.form[inputTypes.dataSource.TypeId + '-' + inputTypes.dataSource.Deprecated_ProductAttributeNameId]\"\n           ng-change=\"inputTypes.inputChanged()\"\n           step=\"any\"\n           name=\"{{inputTypes.form[inputTypes.dataSource.TypeId + '-' + inputTypes.dataSource.Deprecated_ProductAttributeNameId]}}\"\n           ng-min=\"inputTypes.formatProperties.min\"\n           ng-max=\"inputTypes.formatProperties.max\"\n           ng-required=\"inputTypes.dataSource.IsRequired\" />\n\n    <div class=\"error-message-container\"><p class=\"error-message\" ng-show=\"inputTypes.form.numberInput.$invalid && inputTypes.form.numberInput.$dirty\">Enter a number between {{inputTypes.formatProperties.min}} and {{inputTypes.formatProperties.max}}</p></div>\n</div>";

/***/ }),
/* 308 */
/***/ (function(module, exports) {

module.exports = "<!-- RADIO -->\n<div class=\"radios\">\n    <p>{{inputTypes.dataSource.DisplayName}}<span ng-show=\"inputTypes.dataSource.IsRequired\" class=\"required\"> *</span></p>\n    <div class=\"input-wrapper\" ng-repeat=\"option in inputTypes.dataSource.InputOptions | orderBy: 'DisplayOrder'\">\n        <input type=\"radio\"\n               name=\"{{inputTypes.dataSource.TypeId}}-{{inputTypes.dataSource.Deprecated_ProductAttributeNameId}}\"\n               ng-model=\"inputTypes.radio\"\n               ng-change=\"inputTypes.inputChanged()\"\n               id=\"{{option.InputOptionId}}\"\n               value=\"{{option.InputOptionId}}\"\n               ng-required=\"inputTypes.dataSource.IsRequired\" />\n        <label for=\"{{option.InputOptionId}}\">\n            <span></span>\n        </label>\n        {{option.DisplayName}}\n        <br />\n    </div>\n</div>";

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports = "<div ng-controller=\"ProductDirectoryController as model\">\n\t<div class=\"product-center-breadcrumbs row\">\n\t\t<div class=\"col-sm-12\">\n\t\t\t<span class=\"crumb\">Browse Products</span>\n\t\t</div>\n\t</div>\n\t<div class=\"product-directory-header pc-header row\">\n\t\t<div class=\"col-sm-8\">\n\t\t\t<h1>Product Lookup</h1>\n\t\t\t<p>Check which products qualify for HERO</p>\n\t\t</div>\n\t\t<div class=\"col-sm-4\" ng-if=\"model.categories\">\n\t\t\t<a href=\"mailto:productlookupfeedback@heroprogram.com\" class=\"ask-question text-right\">Give Us Feedback</a>\n\t\t\t<geo-state-select></geo-state-select>\n\t\t</div>\n\t</div>\n    <div ng-if=\"model.categories\" class=\"categories-wrap\">\n        <directory-box ng-repeat=\"category in model.categories track by category.Id\" category-id=\"category.Id\"></directory-box>\n\t</div>\n\t<!-- comment back in for product look up typeahead \n    <div class=\"search-box-wrap\">\n\t\t<div class=\"col-sm-12\">\n\t\t\t<div class=\"col-sm-12 search-box\">\n\t\t\t\t<div class=\"col-sm-6 col-sm-offset-3\">\n\t\t\t\t\t<p class=\"text-center\">Don't see a product type?\n\t\t\t\t\t\t<span class=\"try\">Try searching by what you call it.</span></p>\n\t\t\t\t    <input type=\"text\"\n\t\t\t\t           ng-model=\"model.productTypeSearchTerm\"\n\t\t\t\t           placeholder=\"Search...\"\n\t\t\t\t           uib-typeahead=\"result for result in model.productSearch($viewValue)\"\n\t\t\t\t           typeahead-loading=\"model.loadingProductTypeSearch\"\n\t\t\t\t           typeahead-no-results=\"model.productTypeSearchNoResults\"\n\t\t\t\t           typeahead-min-length=\"model.productTypeSearchMinumCharacterCount\"\n\t\t\t\t           typeahead-wait-ms=\"250\"\n                           typeahead-on-select =\"model.productTypeSearchResultSelect($item, $model, $label, $event)\"\n\t\t\t\t           class=\"form-control\">\n                    <i ng-show=\"model.loadingProductTypeSearch\" class=\"glyphicon glyphicon-refresh\"></i>\n                    <div class=\"product-type-search-no-results\" ng-show=\"model.productTypeSearchNoResults && model.productTypeSearchTerm.length > 0\">\n                        No product type matching &quot;{{model.productTypeSearchTerm}}&quot;\n                    </div>\n\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t-->\n</div>\n";

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports = "<div \n\tclass=\"product-category {{product.category.Name}}\" \n\tng-class=\"{'long':product.category.ProductTypes.length > 8}\">\n\t<h2>\n\t\t<!-- <span class=\"hicon-{{product.iconClass}}\"></span> -->\n\t\t<img ng-src=\"/src/assets/images/product-icons/icon-{{product.iconClass}}.svg\" ng-shadow>\n\t\t{{product.category.Name}}\n\t</h2>\n\t<ul>\n\t\t<li ng-repeat=\"(key, type) in product.category.ProductTypes\">\n\t\t\t<a ng-href=\"{{product.getUrl(type)}}\">{{type.NamePlural}}</a>\n\t\t</li>\n\t</ul>\n</div>\n";

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports = "<div ng-controller=\"ProductSearchController as model\">\n\t<div class=\"product-search-container\">\n\t\t<div class=\"product-center-breadcrumbs row\">\n\t\t\t<div class=\"col-sm-12\">\n\t\t\t\t<a class=\"crumb link\" href=\"/product-lookup/directory/{{model.productGeoState}}/\">Browse Products</a> > \n\t\t\t\t<span class=\"crumb\">{{model.productTypeNamePlural}}</span>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"product-directory-header pc-header row\">\n\t\t\t<div class=\"col-sm-8\">\n\t\t\t\t<h1>{{model.productTypeNamePlural}}</h1>\n\t\t\t    <ng-include src=\"'app/productCenter/pages/_shared/eligibilityrequirements/eligibilityRequirements.html'\"/>\n\t\t\t</div>\n\t\t\t<div class=\"col-sm-4\" ng-if=\"model.setupComplete\">\n\t\t\t\t<a href=\"mailto:productlookupfeedback@heroprogram.com\" class=\"ask-question text-right\">Give Us Feedback</a>\n\t\t\t\t<geo-state-select filter-list=\"model.productTypeStateGeos\" ></geo-state-select>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"loading-spinner-wrap hp-loading-spinner\" ra-spinner name=\"productSearchPageSpinnner\" hide-content-when-shown=\"true\" show=\"model.showPageWrapSpinner\">\n\t\t\t<div class=\"product-search-row row\">\n\t\t\t\t<div class=\"col-sm-12 product-search-container\">\n\t\t\t\t\t<form class=\"pull-right\">\n\t\t\t\t\t\t<input ng-model=\"model.searchTerms\" placeholder=\"Enter Reference Number, Manufacturer, Brand, or Model.\" />\n\t\t\t\t\t\t<span class=\"clear-x\" ng-click=\"model.clearSearchTerms();\" ng-show=\"model.searchTerms\">x</span>\n\t\t\t\t\t\t<button \n\t\t\t\t\t\t\ttype=\"submit\" \n\t\t\t\t\t\t\tng-click=\"model.productSearchButton();\"\n\t\t\t\t\t\t\tng-disabled=\"model.enteredSearchTerm === model.searchTerms\">Search</button>\n\t\t\t\t\t</form>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"product-clear-sort-row row\" ng-show=\"model.foundCount !== 0 && model.resultsPending == false \">\n\t\t\t\t<div class=\"col-sm-3 clear-filters-wrap\">\n\t\t\t\t\t<button class=\"btn btn-primary\" \n\t\t\t\t\t\t\tng-click=\"model.clearFilters();\" \n\t\t\t\t\t\t\tng-class=\"{'disabled': !model.filtersActive}\"\n\t\t\t\t\t\t\tng-disabled=\"!model.filtersActive\">Clear Filters</button>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-sm-9 results-sort-container\">\n\t\t\t\t\t<p class=\"pull-left results\">Results: {{model.foundCount | number:0}}</p>\n\t\t\t\t\t<div class=\"pull-right sort-container\">\n\t\t\t\t\t\t<form class=\"hp-dropdown pull-right col-sm-12\">\n\t\t\t\t\t\t\t<span uib-dropdown dropdown-small-popup class=\"dropdown\" >\n\t\t\t\t\t\t\t\t<span uib-dropdown-toggle class=\"dropdown-toggle\">\n\t\t\t\t\t\t\t\t\t<a class=\"dropdown-text\" ng-bind=\"model.selectedSort.SortLabel + ' ' + model.selectedSort.SortOptionName\"></a>\n\t\t\t\t\t\t\t\t\t<span class=\"icon\"></span>\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t<ul uib-dropdown-menu class=\"dropdown-menu\">\n\t\t\t\t\t\t\t\t\t<li \n\t\t\t\t\t\t\t\t\t\tng-click=\"model.switchSort($index);\" \n\t\t\t\t\t\t\t\t\t\tng-repeat=\"option in model.sortOptions track by $index\" \n\t\t\t\t\t\t\t\t\t\tng-class=\"{ 'active': model.selectedSort == option }\">\n\t\t\t\t\t\t\t\t\t\t<a ng-bind=\"option.SortLabel + ' ' + option.SortOptionName\"></a>\n\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</form>\n\t\t\t\t\t\t<span class=\"text-right pull-right\">\n\t\t\t\t\t\t\tSort by: \n\t\t\t\t\t\t</span>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"search-results row hp-loading-spinner\" ra-spinner name=\"productSearchSpinnner\" hide-content-when-shown=\"true\" ng-show=\"model.foundCount > 0 || model.filtersActive === true\">\n\t\t\t\t<div class=\"col-sm-3 filters\">\n\t\t\t\t\t<div class=\"category-filter\" ng-repeat=\"filter in model.filters | orderBy: 'DisplayOrder'\" ng-show=\"filter.showFilter\">\n\t\t\t\t\t    <p>{{filter.DisplayName}}</p>\n\n\t\t\t\t\t    <!--<search-filters current-filter=\"filter\" last=\"$last\"></search-filters>-->\n                        <search-filter-generator current-filter=\"filter\" last=\"$last\"></search-filter-generator>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t    <div class=\"col-sm-9 product-results hp-loading-spinner\" ra-spinner name=\"productSearchResultsSpinnner\" hide-content-when-shown=\"true\">\n\t\t\t        <div\n\t\t\t            class=\"product row\"\n\t\t\t            ng-repeat=\"(key, product) in model.productSearchResults\"\n\t\t\t            ng-show=\"model.foundCount > 0\">\n\t\t\t            <!-- <a href=\"/product-lookup/detail/{{model.productGeoState}}/{{model.productTypeId}}_{{product.Id}}\">{{product.DisplayName}}</a> -->\n\t\t\t            <a href=\"/product-lookup/detail/{{model.productGeoState}}/{{model.productTypeId}}_{{product.Id}}\" ng-bind-html=\"model.highlight(product.DisplayName)\"></a>\n\t\t\t            <div class=\"spec-list\">\n\t\t\t                <div\n\t\t\t                    class=\"spec\"\n\t\t\t                    ng-repeat=\"(key, specs) in product.Attributes | orderBy:'DisplayOrder'\">\n\t\t\t                    <span class=\"name\">{{specs.DisplayName}}</span>\n                                \n\t\t\t                    <span ng-if=\"specs.DisplayName === 'AHRI Number'\" class=\"attribute\">{{specs.Value}}</span> <!-- HACKS -> Need to do this till we have a real way to know the format *sigh* -->\n\n\t\t\t                    <span ng-if=\"specs.DisplayName !== 'AHRI Number'\"  class=\"attribute\">{{specs.Value | pcNumberFormat}}</span> <!-- This is garbage until we have a format for this value  :(  -->\n\t\t\t                </div>\n\t\t\t            </div>\n\t\t\t        </div>\n\t\t\t        <div class=\"no-results no-results-search\" ng-show=\"model.foundCount === 0\">\n\t\t\t            <p>Selected filters have returned no products.</p>\n\t\t\t        </div>\n\t\t\t        \n\t\t\t    </div>\n\t\t\t    <div class=\"last-result\" ng-show=\"model.foundCount > 10000 && (model.PagingIndex + 1) === model.lastPage\">\n\t\t\t    \tOnly showing 10,000 products. To narrow results, choose filter or search.\n\t\t\t    </div>\n                <div class=\"pagination-container col-sm-12\">\n                    <paging class=\"small\"\n                            page=\"model.PagingIndex + 1\"\n                            page-size=\"model.pagingSize\"\n                            total=\"model.pagingCount\"\n                            hide-if-empty=\"false\"\n                            show-prev-next=\"true\"\n                            paging-action=\"model.switchPage(page)\">\n                    </paging>\n                </div>\n\n\t\t\t</div>\n\t\t    <div class=\"no-results\" ng-show=\"model.foundCount === 0 && model.filtersActive === false\">\n\t\t    \t<div class=\"hp-loading-spinner\" ra-spinner name=\"productSearchNoResultsSpinnner\" hide-content-when-shown=\"true\">\n\t\t\t        <p>No products found for \"{{model.enteredSearchTerm}}\".</p>\n\t\t\t        <p class=\"details\">Check spelling or if it meets <span class=\"link\" ng-click=\"model.showRequirements();\">HERO Eligibility Requirements</span>. If you need more details, call us at 844-722-7759.\n\t\t\t        </p>\n\t\t        </div>\n\t\t    </div>\n\t\t</div>\n\t</div>\n\n\t<ng-include ng-if=\"model.showSelectAttributePopup\" src=\"'app/productCenter/pages/productsearch/optionsPopup/optionsPopup.html'\"></ng-include>\n</div>";

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports = "<div class=\"popup-container attribute-popup\" ng-controller=\"OptionsPopupController as popup\">\n\t<form>\n\t\t<div \n\t\t\tclass=\"col-sm-12 overlay\"\n\t\t\tng-click=\"model.showSelectAttributePopup = false\">\n\t\t</div>\n\t\t<div class=\"col-sm-10 col-sm-offset-1 popup\">\n\t\t\t<div class=\"close\" ng-click=\"model.showSelectAttributePopup = false\">x</div>\n\t\t\t<div class=\"col-sm-12 header\">\n\t\t\t\t<h1>Directory of {{popup.currentFilter.DisplayName}}s</h1>\n\t\t\t</div>\n\t\t\t<div class=\"col-sm-12 alphabet\">\n\t\t\t\t<ul>\n\t\t\t\t\t<li ng-repeat=\"letter in popup.alphabet\"\n\t\t\t\t\t\tng-class=\"{'exists': popup.checkLetter(letter)}\"\n\t\t\t\t\t\tng-click=\"popup.scrollToLetter(letter)\">\n\t\t\t\t\t\t{{letter}}\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t</div>\n\t\t\t<div class=\"col-sm-12 options-scroll-wrap\">\n\t\t\t\t<div class=\"col-sm-12 options\">\n\t\t\t\t\t<div class=\"options-box\" ng-repeat=\"group in popup.letterGroupedOptions\">\n\t\t\t\t\t\t<p class=\"letter-header\" id=\"{{group.letterHead}}\">\n\t\t\t\t\t\t\t{{group.letterHead}}\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<div class=\"options-group\" ng-repeat=\"option in group.letterOptions\">\n\t\t\t\t\t\t\t<div class=\"input-wrapper\">\n\t\t\t\t\t\t\t\t<input \n\t\t\t\t\t\t\t\t\ttype=\"checkbox\" \n\t\t\t\t\t\t\t\t\tid=\"{{option.optionID}}-popup\"\n\t\t\t\t\t\t\t\t\tng-model=\"option.isChecked\">\n\t\t\t\t\t\t\t\t<label for=\"{{option.optionID}}-popup\">\n\t\t\t\t\t\t\t\t\t<span></span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t{{option.DisplayName}}\n\t\t\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"col-sm-12\">\n\t\t\t\t<div class=\"btn-group\">\n\t\t\t\t\t<button class=\"btn btn-primary\" ng-click=\"popup.applyOptions(); model.showSelectAttributePopup = false\">Apply</button>\n\t\t\t\t\t<button class=\"btn btn-default\" ng-click=\"model.showSelectAttributePopup = false\">Cancel</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</form>\n</div>\n";

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports = "\n\t<div class=\"filter-wrap\">\n\n\t\t<!-- CHECKBOXES -->\n\t\t<div ng-if=\"searchFilter.currentFilterTypeId === 1\">\n\t\t\t<div class=\"input-wrapper\" \n\t\t\t\t ng-repeat=\"option in searchFilter.currentFilter.InputOptions | limitTo: searchFilter.currentFilter.DisplayLimit\">\n\t\t\t\t<input type=\"checkbox\" \n\t\t\t\t\t   id=\"{{option.optionID}}\" \n\t\t\t\t\t   ng-model=\"option.isChecked\"\n\t\t\t\t\t   ng-change=\"searchFilter.checkboxChanged();\">\n\t\t\t\t<label for=\"{{option.optionID}}\">\n\t\t\t\t\t<span></span>\n\t\t\t\t</label>\n\t\t\t\t{{option.DisplayName}}\n\t\t\t\t<br/>\n\t\t\t</div>\n\t\t\t<a ng-if=\"searchFilter.currentFilter.InputOptions.length > 7\" ng-click=\"searchFilter.showOptionsPopup(filter)\">See All {{searchFilter.currentFilter.DisplayName}}s</a> \n\t\t</div>\n\t\t<!-- /CHECKBOXES -->\n\n\t    <!-- Static Numeric Checkbox-->\n        <div ng-if=\"searchFilter.currentFilterTypeId === 2\">\n            <div class=\"input-wrapper\"\n                 ng-repeat=\"option in searchFilter.currentFilter.InputOptions\">\n                <input type=\"checkbox\"\n                       id=\"{{option.optionID}}\"\n                       ng-model=\"option.isChecked\"\n                       ng-change=\"searchFilter.checkboxChanged();\">\n                <label for=\"{{option.optionID}}\">\n                    <span></span>\n                </label>\n                {{option.DisplayName}}\n                <br />\n            </div>\n        </div>\n        <!-- /Static Numeric Checkbox-->\n\n\t    <!-- MIN/MAX -->\n\t\t<div ng-if=\"searchFilter.currentFilterTypeId === 3\">\n\t\t\t<div class=\"number-range\">\n\t\t\t\t<div class=\"min-max\" class=\"form-group\" ng-form name=\"searchFilter.minFormControl\">\n\t\t\t\t\tMin\n\t\t\t\t\t<input placeholder=\"{{searchFilter.currentFilter.InputRangeAttributes.Min}}\"\n\t\t\t\t\t\t   type=\"number\"\n\t\t\t\t\t\t   name=\"searchFilter.minValue\"\n\t\t\t\t\t\t   ng-model=\"searchFilter.minValue\"\n\t\t\t\t\t\t   ng-change=\"searchFilter.minMaxChanged();\"\n\t\t\t\t\t\t   ng-model-options=\"{ debounce: 500, allowInvalid: true }\"\n\t\t\t\t\t\t   ng-min=\"searchFilter.minLimit\"\n\t\t\t\t\t\t   ng-max=\"searchFilter.maxLimit\" />\n\t\t\t\t\t<p ng-if=\"searchFilter.minFormControl.$error.min\" class=\"error-message\">Must be greater than or equal to {{searchFilter.minLimit}}</p>\n\t\t\t\t\t<p ng-if=\"searchFilter.minFormControl.$error.max\" class=\"error-message\">Must be less than or equal to {{searchFilter.maxLimit}}</p>\n\t\t\t\t</div>\n\t\t\t\t<span class=\"to\">to</span>\n\t\t\t\t<div class=\"min-max\" class=\"form-group\" ng-form name=\"searchFilter.maxFormControl\">\n\t\t\t\t\tMax\n\t\t\t\t\t<input placeholder=\"{{searchFilter.currentFilter.InputRangeAttributes.Max}}\"\n\t\t\t\t\t\t   type=\"number\"\n\t\t\t\t\t\t   name=\"searchFilter.maxValue\"\n\t\t\t\t\t\t   ng-model=\"searchFilter.maxValue\"\n\t\t\t\t\t\t   ng-change=\"searchFilter.minMaxChanged();\"\n\t\t\t\t\t\t   ng-model-options=\"{ debounce: 500, allowInvalid: true }\" \n\t\t\t\t\t\t   ng-min=\"searchFilter.minLimit\"\n\t\t\t\t\t\t   ng-max=\"searchFilter.maxLimit\" />\n\t\t\t\t    <p ng-if=\"searchFilter.maxFormControl.$error.min\" class=\"error-message\">Must be greater than or equal to {{searchFilter.minLimit}}</p>\n\t\t\t\t\t<p ng-if=\"searchFilter.maxFormControl.$error.max\" class=\"error-message\">Must be less than or equal to {{searchFilter.maxLimit}}</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t    <!-- /MIN/MAX -->\n\n        <!-- DESCRIPTIVE INPUT -->\n    \t<div ng-if=\"searchFilter.currentFilterTypeId === 4\">\n\t\t\t<input \n\t\t\t\tplaceholder=\"Enter a Model Number\"\n\t\t\t\ttype=\"text\"\n\t\t\t\tname=\"searchFilter.descriptiveInput\"\n\t\t\t\tng-model=\"searchFilter.descriptiveInput\"\n\t\t\t\tng-change=\"searchFilter.descriptiveInputChanged();\"\n\t\t\t\tng-model-options=\"{ debounce: 500, allowInvalid: true }\" />\n    \t</div>\n        <!-- /DESCRIPTIVE INPUT -->\n\n\t    <div ng-if=\"searchFilter.currentFilterTypeId !== 1 && searchFilter.currentFilterTypeId !== 2 && searchFilter.currentFilterTypeId !== 3 && searchFilter.currentFilterTypeId !== 4\">\n            {{searchFilter.currentFilter.Type}} - {{searchFilter.currentFilterTypeId}}\n\t    </div>\n\n\n\t</div>";

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports = "\n\t<div class=\"filter-wrap\">\n\t\t<div ng-if=\"searchFilter.currentFilterTypeId === 1\">\n\t\t\t<div class=\"input-wrapper\" \n\t\t\t\t ng-repeat=\"option in searchFilter.currentFilter.InputOptions | limitTo: searchFilter.currentFilter.DisplayLimit\">\n\t\t\t\t<input type=\"checkbox\" \n\t\t\t\t\t   id=\"{{option.optionID}}\" \n\t\t\t\t\t   ng-model=\"option.isChecked\"\n\t\t\t\t\t   ng-change=\"searchFilter.checkboxChanged();\">\n\t\t\t\t<label for=\"{{option.optionID}}\">\n\t\t\t\t\t<span></span>\n\t\t\t\t</label>\n\t\t\t\t{{option.DisplayName}}\n\t\t\t\t<br/>\n\t\t\t</div>\n\t\t\t<a ng-if=\"searchFilter.currentFilter.InputOptions.length > 7\" ng-click=\"searchFilter.showOptionsPopup(filter)\">See All {{searchFilter.currentFilter.DisplayName}}s</a> \n\t\t</div>\n\t</div>";

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports = "\n\t<div class=\"filter-wrap\">\n    \t<div class=\"search-filter-descriptive-input\" ng-if=\"searchFilter.currentFilterTypeId === 4\">\n\t        <input\n\t            placeholder=\"Enter a Model Number\"\n\t            type=\"text\"\n\t            name=\"searchFilter.descriptiveInput\"\n\t            ng-model=\"searchFilter.descriptiveInput\"\n\t            ng-keyup=\"$event.keyCode == 13 && searchFilter.descriptiveInputSubmit()\"\n\t            />\n            <button class=\"btn btn-default\" ng-click=\"searchFilter.descriptiveInputSubmit()\" ng-show=\"searchFilter.dirty || (searchFilter.descriptiveInput !== null && searchFilter.descriptiveInput.length > 0)\">Apply</button>\n    \t</div>\n\t</div>";

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports = "\n\t<div class=\"filter-wrap\">\n\n\t\t<div ng-if=\"searchFilter.currentFilterTypeId === 6\">\n\t\t\t<div class=\"number-range\">\n\t\t\t\t<div class=\"min-max\" class=\"form-group\" ng-form name=\"searchFilter.minFormControl\">\n\t\t\t\t\tMin\n\t\t\t\t\t<input placeholder=\"{{searchFilter.currentFilter.InputRangeAttributes.Min}}\"\n\t\t\t\t\t\t   type=\"number\"\n\t\t\t\t\t\t   name=\"searchFilter.minValue\"\n\t\t\t\t\t\t   ng-model=\"searchFilter.minValue\"\n\t\t\t\t\t\t   ng-model-options=\"{allowInvalid: true }\"\n\t\t\t\t\t\t   ng-min=\"searchFilter.minLimit\"\n\t\t\t\t\t\t   ng-max=\"searchFilter.maxLimit\" />\n\t\t\t\t</div>\n\t\t\t\t<span class=\"to\">to</span>\n\t\t\t    <div class=\"min-max\" class=\"form-group\" ng-form name=\"searchFilter.maxFormControl\">\n\t\t\t        Max\n\t\t\t        <input placeholder=\"{{searchFilter.currentFilter.InputRangeAttributes.Max}}\"\n\t\t\t               type=\"number\"\n\t\t\t               name=\"searchFilter.maxValue\"\n\t\t\t               ng-model=\"searchFilter.maxValue\"\n\t\t\t               ng-model-options=\"{allowInvalid: true }\"\n\t\t\t               ng-min=\"searchFilter.minLimit\"\n\t\t\t               ng-max=\"searchFilter.maxLimit\"/>\n\t\t\t    </div>\n\t\t\t    <button class=\"btn btn-default\" ng-click=\"searchFilter.minMaxChanged()\" ng-show=\"searchFilter.showApply()\">Apply</button>\n\n\t\t\t    <p ng-if=\"searchFilter.minFormControl.$error.max\" class=\"error-message\">Min must be less than or equal to {{searchFilter.maxLimit}}</p>\n                <p ng-if=\"searchFilter.maxFormControl.$error.min\" class=\"error-message\">Max must be greater than or equal to {{searchFilter.minLimit}}</p>\n\n\t\t\t    <!--<p ng-if=\"searchFilter.minFormControl.$error.min\" class=\"error-message\">Min must be greater than or equal to {{searchFilter.minLimit}}</p>\n\t\t\t    \n                \n                <p ng-if=\"searchFilter.maxFormControl.$error.max\" class=\"error-message\">Max must be less than or equal to {{searchFilter.maxLimit}}</p>-->\n\n\n\t\t\t</div>\n\t\t</div>\n\n\t</div>";

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports = "\t<div class=\"filter-wrap\">\n\n        <div ng-if=\"searchFilter.currentFilterTypeId === 5\">\n            <div class=\"input-wrapper\"\n                 ng-repeat=\"option in searchFilter.currentFilter.InputOptions\">\n                <input type=\"checkbox\"\n                       id=\"{{option.optionID}}\"\n                       ng-model-options=\"{ debounce: 500, allowInvalid: true }\"\n                       ng-model=\"option.isChecked\"\n                       ng-change=\"searchFilter.checkboxChanged();\">\n                <label for=\"{{option.optionID}}\">\n                    <span></span>\n                </label>\n                {{option.DisplayName}}\n                <br />\n            </div>\n        </div>\n    \n\t</div>";

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports = "\t<div class=\"filter-wrap\">\n\n        <div ng-if=\"searchFilter.currentFilterTypeId === 2\">\n            <div class=\"input-wrapper\"\n                 ng-repeat=\"option in searchFilter.currentFilter.InputOptions\">\n                <input type=\"checkbox\"\n                       id=\"{{option.optionID}}\"\n                       ng-model=\"option.isChecked\"\n                       ng-change=\"searchFilter.checkboxChanged();\">\n                <label for=\"{{option.optionID}}\">\n                    <span></span>\n                </label>\n                {{option.DisplayName}}\n                <br />\n            </div>\n        </div>\n    \n\t</div>";

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _resourcesController = __webpack_require__(320);

var _resourcesController2 = _interopRequireDefault(_resourcesController);

var _resourcesFactory = __webpack_require__(322);

var _resourcesFactory2 = _interopRequireDefault(_resourcesFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.resources', []).controller('ResourcesController', _resourcesController2.default).service('ResourcesFactory', _resourcesFactory2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/resources/resources.html', __webpack_require__(323)); // eslint-disable-line global-require
    $templateCache.put('app/resources/resources_documents.html', __webpack_require__(324)); // eslint-disable-line global-require
    $templateCache.put('app/resources/resources_map.html', __webpack_require__(325)); // eslint-disable-line global-require
    $templateCache.put('app/resources/resources_marketing.html', __webpack_require__(326)); // eslint-disable-line global-require
    $templateCache.put('app/resources/resources_videos.html', __webpack_require__(327)); // eslint-disable-line global-require
    $templateCache.put('app/resources/resources_pace.html', __webpack_require__(328)); // eslint-disable-line global-require
    $templateCache.put('app/resources/resources_participant.html', __webpack_require__(329)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = resourcesController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(321);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

resourcesController.$inject = ['ResourcesFactory', '$stateParams', '$state', '$window', '$analytics', 'HPConfig', '$http', 'mapBoxGL', '$scope', 'UserData', 'PermissionsFactory'];


/* @ngInject */
function resourcesController(ResourcesFactory, $stateParams, $state, $window, $analytics, HPConfig, $http, mapBoxGL, $scope, UserData, PermissionsFactory) {
    var vm = this;
    var glMap = null;

    vm.resourcePages = [];
    vm.resourceVideos = [];
    vm.currentPage = {};
    vm.pageUrl = '';
    vm.sproutLoudData = {};
    vm.mapType = 'company';
    vm.mapLoading = true;
    vm.user;
    vm.isSolicitor = PermissionsFactory.hasPermission('IsSolicitor');
    vm.isAdvertiser = PermissionsFactory.hasPermission('IsAdvertiser');

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    vm.trackClick = function (eventName) {
        var clickEvent = {
            title: 'Resource Clicked',
            action: ''
        };
        switch (eventName) {
            case 'openLetter':
                clickEvent.title = 'User clicked "An open letter to California contractors"';
                clickEvent.action = 'Letter to CO click';
                break;
            case 'watchTutorial':
                clickEvent.title = 'User clicked "A tutorial on the new HERO application"';
                clickEvent.action = 'App tutorial click';
                break;
            case 'seeSteps':
                clickEvent.title = 'User clicked "How to Apply helper"';
                clickEvent.action = 'How to apply click';
                break;
            case 'takeLook':
                clickEvent.title = 'User clicked "The HAC Walkthrough"';
                clickEvent.action = 'HAC Walkthrough click';
                break;
            case 'getGuide':
                clickEvent.title = 'User clicked "Income Verification: The Guide"';
                clickEvent.action = 'Income verification guide click';
                break;
            case 'getOverview':
                clickEvent.title = 'User clicked "Get a high-level overview"';
                clickEvent.action = 'Overview click';
                break;
            case 'getFullStory':
                clickEvent.title = 'User clicked "Get the full story"';
                clickEvent.action = 'Full story click';
                break;
            default:
                break;
        }
        $analytics.eventTrack(clickEvent.title, {
            action: clickEvent.action,
            category: 'PACE Resources',
            label: vm.user.UserName
        });
    };

    vm.switchPage = function (page) {
        vm.currentPage = page;
        buildPageUrl();
        $state.go('resources', {
            resourceName: page.pageName
        });
    };

    vm.sproutLoudHandShake = function () {
        $analytics.eventTrack('SSO Initiate', {
            category: 'SproutLoud'
        });
        var newWindow = $window.open('');
        ResourcesFactory.sproutLoudHandShake().then(function (response) {
            if (response.data.Errors === undefined) {
                var doc = newWindow.document;
                var form = doc.createElement('form');
                form.setAttribute('method', 'POST');
                form.setAttribute('action', response.data.Data.SeamlessLoginURL);
                var hiddenField = doc.createElement('input');
                hiddenField.setAttribute('type', 'hidden');
                hiddenField.setAttribute('name', 'login_data');
                hiddenField.value = response.data.Data.EncrypedDataXML;
                form.appendChild(hiddenField);
                doc.body.appendChild(form);

                form.submit();
            } else {
                $analytics.eventTrack('SSO Failed', {
                    category: 'SproutLoud',
                    label: JSON.stringify(response.data.Errors)
                });
                newWindow.location = response.data.Data.SeamlessLoginURL;
            }
        }, function (response) {
            $analytics.eventTrack('SSO Failed', {
                category: 'SproutLoud',
                label: JSON.stringify(response.data.Errors)
            });
            newWindow.location = 'http://app.sproutloud.com';
        });
    };

    vm.changeMapType = function () {
        vm.mapLoading = true;
        initializeHEROMap();
    };
    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */
    function init() {
        if (vm.isAdvertiser && $stateParams.resourceName === 'videos') {
            // Advertiser doesn't have Videos page access, but that's the default route - so have to redirect.
            $window.location.href = '/resources/participant';
        }

        getResourcePages();
        setInitialPage();
        buildPageUrl();

        if ($stateParams.resourceName === 'videos') {
            getResourceVideos();
        }

        if ($stateParams.resourceName === 'map') {
            // Need to defer to ensure that the map DOM element has already been loaded
            _lodash2.default.defer(function () {
                initializeHEROMap();
            });
        }
        console.log('should be getting userData');
        UserData.getUserData().then(function (result) {
            vm.user = result;
        });
    }

    function getResourcePages() {
        vm.resourcePages = ResourcesFactory.getResourcePages();
    }

    function getResourceVideos() {
        vm.resourceVideos = ResourcesFactory.getResourceVideos();
    }

    function initializeHEROMap() {
        if (vm.mapType === 'company') {
            $http.get(HPConfig.heroProApi + 'Contractor/GeoJSON', {
                cache: true
            }).then(function (response) {
                loadHEROMap({
                    style: 'mapbox://styles/mapbox/basic-v8',
                    data: response.data
                });
            });
        } else if (vm.mapType === 'all') {
            loadHEROMap({
                style: 'mapbox://styles/jrichmond/ciusglhby004h2ipho7pzjkkh'
            });
        }
    }

    function loadHEROMap(options) {
        // https://www.mapbox.com/mapbox-gl-js/api/
        if (glMap !== null) {
            glMap.remove();
        }

        mapBoxGL.accessToken = HPConfig.mapBoxAuthKey;

        glMap = new mapBoxGL.Map({
            attributionControl: false,
            container: 'resourcesHeroMap',
            style: options.style,
            maxBounds: new mapBoxGL.LngLatBounds(new mapBoxGL.LngLat(-127.881285, 23.827067), new mapBoxGL.LngLat(-66.565297, 49.976707)),
            maxZoom: 15,
            zoom: 5,
            center: [-119.882153, 35.929159]
        });

        glMap.addControl(new mapBoxGL.Navigation({
            position: 'top-left'
        }));
        glMap.addControl(new mapBoxGL.Geolocate({
            position: 'top-left'
        }));

        if (options.data !== undefined && options.data.features !== null) {
            glMap.on('style.load', function () {
                glMap.addSource('markers', new mapBoxGL.GeoJSONSource({
                    data: options.data
                }));
                glMap.addLayer({
                    id: 'geojsondata',
                    source: 'markers',
                    type: 'circle',
                    paint: {
                        'circle-color': '#ED1F34',
                        'circle-radius': 5,
                        'circle-opacity': 1
                    }
                    // type: "symbol",
                    // layout: {
                    //      "icon-image": "circle-11"
                    //  },
                    //  paint: {
                    // 	"icon-opacity": 0.7,
                    // 	// "icon-color": "#ED1F34", //doesn't seem to be supported
                    // }
                });
            });
        }

        glMap.on('load', function () {
            vm.mapLoading = false;
            $scope.$digest();
            _lodash2.default.defer(function () {
                glMap.resize();
            });
        });
    }

    function setInitialPage() {
        var pages = _lodash2.default.filter(vm.resourcePages, function (page) {
            return page.pageName === $stateParams.resourceName;
        });
        if (pages !== undefined && pages !== null) {
            vm.currentPage = pages[0];
        } else {
            vm.currentPage = vm.resourcePages[0];
        }
    }

    function buildPageUrl() {
        if (vm.currentPage && vm.currentPage.pageName) {
            vm.pageUrl = 'app/resources/resources_' + vm.currentPage.pageName + '.html';
        }
    }
    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = resourcesFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

resourcesFactory.$inject = ['$http', '$sce', 'HPConfig', 'PermissionsFactory']; // angular
// .module("HeroPRO")
// .factory("ResourcesFactory", resourcesFactory);

/* @ngInject */
function resourcesFactory($http, $sce, HPConfig, PermissionsFactory) {
    var isSolicitor = PermissionsFactory.hasPermission('IsSolicitor');
    var isAdvertiser = PermissionsFactory.hasPermission('IsAdvertiser');

    var resourcePages = [{
        pageName: 'videos',
        pageDisplayName: 'Videos',
        isEnabled: isSolicitor
    }, {
        pageName: 'marketing',
        pageDisplayName: 'Marketing Materials',
        isEnabled: isSolicitor
    }, {
        pageName: 'participant',
        pageDisplayName: 'Participant Resources',
        isEnabled: isAdvertiser
    }, {
        pageName: 'documents',
        pageDisplayName: 'Documents',
        isEnabled: isSolicitor
    }, {
        pageName: 'map',
        pageDisplayName: 'HERO Map',
        isEnabled: true
    }, {
        pageName: 'products',
        pageDisplayName: 'Product Lookup',
        isEnabled: false
    }, {
        pageName: 'pace',
        pageDisplayName: 'The Future of PACE and HERO',
        isEnabled: true
    }];

    var resourceVideos = [{
        videoURL: $sce.trustAsResourceUrl('https://www.youtube.com/embed/GYKpAJai0NU?rel=0&amp;showinfo=0'),
        videoTitle: 'Why Contractors Choose the HERO Program',
        videoDescription: 'See how contractors are benefiting from the HERO Program.'
    }, {
        videoURL: $sce.trustAsResourceUrl('https://www.youtube.com/embed/IypViqe9Qnw?rel=0&amp;showinfo=0'),
        videoTitle: 'How the HERO Program Works',
        videoDescription: 'Video providing an overview of how financing works and program benefits.'
    }, {
        videoURL: $sce.trustAsResourceUrl('https://www.youtube.com/embed/A8pcrT5pf2c?rel=0&amp;showinfo=0'),
        videoTitle: 'How the HERO Program Works - Spanish',
        videoDescription: 'Video en español que proporciona una visión general sobre cómo funciona el financiamiento y los beneficios del programa.'
    }, {
        videoURL: $sce.trustAsResourceUrl('https://www.youtube.com/embed/9KjjU-Kh4js?rel=0&amp;showinfo=0'),
        videoTitle: 'HERO for Windows',
        videoDescription: 'The ins and outs of HERO Financing as it relates to Windows.'
    }, {
        videoURL: $sce.trustAsResourceUrl('https://www.youtube.com/embed/Eec35VQR3ss?rel=0&amp;showinfo=0'),
        videoTitle: 'HERO for HVAC',
        videoDescription: 'The ins and outs of HERO Financing as it relates to Heating and Air Conditioning Systems.'
    }, {
        videoURL: $sce.trustAsResourceUrl('https://www.youtube.com/embed/45HHe9EGINE?rel=0&amp;showinfo=0'),
        videoTitle: 'HERO Registered Contractors on the eSign Feature',
        videoDescription: "HERO's esign feature makes the process even easier."
    }, {
        videoURL: $sce.trustAsResourceUrl('https://www.youtube.com/embed/Ubb5-nKYbOU?rel=0&amp;showinfo=0'),
        videoTitle: 'HERO Celebrates Carini Heating & Air Conditioning Expansion',
        videoDescription: 'View how Carini Heating & Air grew their business with HERO.'
    }];

    function getResourcePages() {
        return _lodash2.default.filter(resourcePages, function (page) {
            return page.isEnabled === true;
        });
    }

    function getResourceVideos() {
        return resourceVideos;
    }

    function sproutLoudHandShake() {
        return $http.get(HPConfig.heroProApi + 'SproutLoud/HandShake');
    }

    return {
        getResourcePages: getResourcePages,
        getResourceVideos: getResourceVideos,
        sproutLoudHandShake: sproutLoudHandShake
    };
}

/***/ }),
/* 323 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-module resources-module\">\n    <div class=\"hp-inner\">\n        <div class=\"resources-header\">\n            <div class=\"row\">\n                <div class=\"col-md-12\">\n                    <h1>Resources</h1>\n                </div>\n            </div>\n        </div>\n        <div class=\"resources-nav navbar\">\n            <ul class=\"nav navbar-nav\">\n                <li ng-repeat=\"page in resources.resourcePages\">\n                    <a ng-click=\"resources.switchPage(page);\">\n                        <span ng-class=\"{ 'active': page.pageName === resources.currentPage.pageName }\">{{page.pageDisplayName}}</span>\n                    </a>\n                </li>\n            </ul>\n        </div>\n        <ng-include src=\"resources.pageUrl\"></ng-include>\n    </div>\n</div>\n";

/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-module pipeline-module\">\n\t<div class=\"hp-inner\">\n\t\t<div class=\"resources-content-container\">\n\t\t\t<h3>Documents and Forms</h3>\n\t\t\t<div class=\"row resources-document\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>Program Handbooks</h4>\n\t\t\t\t\t<p>\n                        Comprehensive document for each Program (WRCOG, SANBAG, LA COUNTY, CA HERO, CSCDA and MCED) outlining the terms, disclosures, process, and other important information.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://9662473e561b2ca15fec-e991096dabe6d2069d3f005000c6b73d.ssl.cf2.rackcdn.com/ProgramHandbooks.zip\" target=\"_blank\">Download</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-document\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>Application in Review</h4>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tDocument listing all the reasons that a HERO application might be assigned an “In Review” status.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://e6cd8b4b39dd042fc477-c39597e5c7b01ac033a978dbfa710d50.ssl.cf1.rackcdn.com/HP102_Application%20In%20Review%20Reasons.pdf\" target=\"_blank\">Download</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-document\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>Renovate America Contractor Participation Agreement</h4>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tThe Contractor Participation Agreement that each Contractor must sign to register with Renovate America, which confirms agreement with the Terms &amp; Conditions.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"http://7144b0b2ad28a8e9d39f-c7daaeaa05869c3b736fd3d320921c0f.r39.cf2.rackcdn.com/National-Contractor-Participation-Agreement-And-Terms-And-Conditions-Main-CA-Global.pdf\" target=\"_blank\">View</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-document\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>HERO Program Contractor Participation Agreement - Reference Materials</h4>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tDetailed reference materials that accompany the Contractor Participation Agreement. Signing the Contractor Participation agreement also confirms receipt of, familiarity with, and agreement to the Reference Materials.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://d281c9f0836d81226639-c7daaeaa05869c3b736fd3d320921c0f.ssl.cf2.rackcdn.com/National-Contractor-Participation-Reference-Materials-Main-CA-Global.pdf\" target=\"_blank\">Download</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-document\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>PACE Professional Code of Conduct</h4>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tCalifornia Only - the code of conduct that accompanies completion of the 6 hour training requirement. Included here for your reference.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://cdn2.renovateamerica.com/Documents/california-hero-pace-professional-code-of-conduct-sept-26-2019.pdf\" target=\"_blank\">Download</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-document\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>HERO Eligible Products List</h4>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tThe Eligible Products List provides general eligibility specifications for products eligible for HERO Financing across all HERO Programs.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://9662473e561b2ca15fec-e991096dabe6d2069d3f005000c6b73d.ssl.cf2.rackcdn.com/HEROEligibleProductsList.pdf\" target=\"_blank\">Download</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-document\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>Hard Copy HERO Financing Application</h4>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tHard Copy versions of all HERO Financing Applications that the customer should read, complete, and sign before the Contractor calls in the HERO Application.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://e5ba42824be3ad90847f-3608ad1b944f1b4a386fab4a8bac1b83.ssl.cf2.rackcdn.com/HEROProgramApplications.zip\" target=\"_blank\">Download</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-document\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>Custom Product Application</h4>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tIf a Property Owner requires a custom project, the Contractor will need to fill out a Custom Product Application. The Custom Product Application is also used to submit products for inclusion on the HERO Eligible Product List. Property Owners and Contractors must wait to be approved before installing a custom or new product in order to ensure they will be approved by HERO Financing.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://9662473e561b2ca15fec-e991096dabe6d2069d3f005000c6b73d.ssl.cf2.rackcdn.com/CustomProductApplication.pdf\" target=\"_blank\">Download</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-document\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>Project Funding Checklist</h4>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tBefore turning in the HERO Completion Certificate, contractors should review this Project Funding Checklist ensure that all product funding requirements are also included as attachments to their project file. If any items are missing or incomplete, project completion documentation may need to be resigned or resubmitted, resulting in delays for the project.e approved by HERO Financing.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://e46c35b14ba172b610db-5bdc7e6ccbce2b667854e87f83bdb832.ssl.cf1.rackcdn.com/Project_Funding_Checklist.pdf\" target=\"_blank\">Download</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-document\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>Closing Checklist for Solar</h4>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tDocument that provides a list of required documents for solar projects that contractors need to submit to HERO for funding.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"http://b5e82a6d7efde409c9ba-5bdc7e6ccbce2b667854e87f83bdb832.r26.cf1.rackcdn.com/Closing%20Checklist_Solar.pdf\" target=\"_blank\">Download</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-document\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>Closing Checklist for Non-Solar</h4>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tDocument that provides a list of required documents for non-solar projects that contractors need to submit to HERO for funding.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"http://b5e82a6d7efde409c9ba-5bdc7e6ccbce2b667854e87f83bdb832.r26.cf1.rackcdn.com/Closing%20Checklist_NonSolar.pdf\" target=\"_blank\">Download</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-document\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>CA Household Income Contribution Declaration</h4>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tDeclaration form to be completed when a CA homeowner has income contributions from other household members (not on mortgage or title) they would like to document.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"http://7144b0b2ad28a8e9d39f-c7daaeaa05869c3b736fd3d320921c0f.r39.cf2.rackcdn.com/HouseholdIncomeContributionDeclaration.pdf\" target=\"_blank\">Download</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-document\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>Pasco County Disclosure</h4>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tRequired disclosure in Pasco County, FL which contains PACE FAQs and an attestation regarding additional PACE assessments. Disclosure must be wet-signed by all property owners and the in-home contractor, and provided as part of the Underwriting process.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://d281c9f0836d81226639-c7daaeaa05869c3b736fd3d320921c0f.ssl.cf2.rackcdn.com/PascoCountyDisclosure.pdf\" target=\"_blank\">Download</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"resources-content-container\">\n\t\t\t<h3>Sample Documents and Forms</h3>\n\t\t\t<div class=\"row resources-document\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>Sample Financing Documents - English</h4>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tSample versions of the HERO Financing Documents for all HERO Programs. Use these to help explain the HERO process and required documents to the Property Owner.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://9662473e561b2ca15fec-e991096dabe6d2069d3f005000c6b73d.ssl.cf2.rackcdn.com/SampleFinancingDocuments.zip\" target=\"_blank\">Download</a>\n\t\t\t\t</div>\n\t\t\t</div>\n            <div class=\"row resources-document\">\n                <div class=\"col-md-10\">\n                    <h4>Sample Financing Documents - Spanish</h4>\n                    <p>\n                        Sample versions of the HERO Financing Documents for all HERO Programs. Use these to help explain the HERO process and required documents to the Property Owner.\n                    </p>\n                </div>\n                <div class=\"col-md-2\">\n                    <a class=\"btn btn-default pull-right\" href=\"https://9662473e561b2ca15fec-e991096dabe6d2069d3f005000c6b73d.ssl.cf2.rackcdn.com/Sample-Financing-Docs-Spanish.zip\" target=\"_blank\">Download</a>\n                </div>\n            </div>\n            <div class=\"row resources-document\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>Sample Completion Certificate</h4>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tSample versions of the Completion Certificates for each HERO Program. The Completion Certificate will need to be signed and completed AFTER all work has been completed.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://9662473e561b2ca15fec-e991096dabe6d2069d3f005000c6b73d.ssl.cf2.rackcdn.com/SampleCompletionCertificates.zip\" target=\"_blank\">Download</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n";

/***/ }),
/* 325 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-module pipeline-module\">\n\t<div class=\"hp-inner\">\n\t\t<div class=\"resources-content-container resources-map\">\n\t\t\t<h3>Completed Projects</h3>\n\t\t\t<p class=\"map-type\">\n\t\t\t\t<input type=\"radio\" id=\"map-type-company\" ng-model=\"resources.mapType\" value=\"company\" ng-click=\"resources.changeMapType()\"/>\n\t\t\t\t<label for=\"map-type-company\"> <span></span> {{main.currentLocation.CompanyName}} Projects</label>\n\t\t\t</p>\n\t\t\t<p class=\"map-type\">\n\t\t\t\t<input type=\"radio\" id=\"map-type-all\" ng-model=\"resources.mapType\" value=\"all\" ng-click=\"resources.changeMapType()\"/>\n\t\t\t\t<label for=\"map-type-all\"> <span></span> All HERO Projects</label>\n\t\t\t</p>\n\t\t\t<div class=\"hp-loading-spinner\" ra-spinner name=\"heroMapSpinner\" show=\"resources.mapLoading === true\" hide-content-when-shown=\"true\" text=\"Loading HERO Map\" register=\"false\">\n\t\t\t\t<div id=\"resourcesHeroMap\"></div>\t\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>";

/***/ }),
/* 326 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-module pipeline-module\">\n\t<div class=\"hp-inner\">\n\t\t<div class=\"resources-content-container\">\n\t\t    <h3>Print Your Own Materials</h3>\n\t\t    <div class=\"divider\"></div>\n\t\t\t<div class=\"row resources-document all-documents\" ng-hide=\"true\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<p>\n\t\t\t\t\t\tSelect the button to the right to download all materials. To download a specific material, select one of the download buttons below.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-primary pull-right\" href=\"https://fa764b62064d3d71bb81-96f3848a50256afc7db699af5389ae43.ssl.cf2.rackcdn.com/DownloadAll.zip\" target=\"_blank\">Download All</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t\n\n\t\t\t<div class=\"row resources-document\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>Renovate America Marketing Guidelines</h4>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tWhile we encourage you to use our brand in your marketing materials (e.g., in newspaper advertisements, radio or direct mail pieces) we ask you to follow these specific guidelines.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://www.foahomeimprovement.com/contractors/contractor-marketing-guidelines\" target=\"_blank\">Download</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-document\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>Contractor Co-Marketing Icons (logos)</h4>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tPlease use these downloadable icons if you would like to co-brand with Renovate America, HERO or Benji and reference the above guidelines for usage paramaters.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://cdn.foahomeimprovement.com/contractor/logos.zip\" target=\"_blank\">Download</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-document\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>Sample California Property Tax Bill</h4>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tThe sample provided illustrates how HERO financing will be included on your customer's tax bill.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://fa764b62064d3d71bb81-96f3848a50256afc7db699af5389ae43.ssl.cf2.rackcdn.com/HERO_SamplePropertyTaxBill_COPO_R1.pdf\" target=\"_blank\">Download</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-document\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>Sample Missouri Property Tax Bill</h4>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tThe sample provided illustrates how HERO financing will be included on your customer's tax bill.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://9662473e561b2ca15fec-e991096dabe6d2069d3f005000c6b73d.ssl.cf2.rackcdn.com/Sample_PropertyTaxBill_MO_JacksonCounty.pdf\" target=\"_blank\">Download</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-document\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>Sample Florida Property Tax Bill</h4>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tThe sample provided illustrates how HERO financing will be included on your customer's tax bill.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://9662473e561b2ca15fec-e991096dabe6d2069d3f005000c6b73d.ssl.cf2.rackcdn.com/Sample_PropertyTaxBill_FL_OrangeCounty.png\" target=\"_blank\">Download</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-document\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>Contractor FAQs</h4>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tThe most frequently asked contractor questions are addressed in an easy to reference format.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://fa764b62064d3d71bb81-96f3848a50256afc7db699af5389ae43.ssl.cf2.rackcdn.com/HERO_Contractor_FAQs.pdf\" target=\"_blank\">Download</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n";

/***/ }),
/* 327 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-module pipeline-module\">\n\t<div class=\"hp-inner\">\n\t\t<div class=\"resources-content-container\">\n\t\t\t<div class=\"container\">\n\t\t\t\t<div class=\"row\">\n\t\t\t\t\t<div class=\"col-md-6 resource-video\" ng-repeat=\"video in resources.resourceVideos\" ng-class-odd=\"'nextRow'\">\n\t\t\t\t\t\t<div class=\"embed-responsive embed-responsive-16by9\">\n\t\t\t\t\t\t\t<iframe ng-src=\"{{video.videoURL}}\" frameborder=\"0\" allowfullscreen></iframe>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<h4>{{video.videoTitle}}</h4>\n\t\t\t\t\t\t<p>{{video.videoDescription}}</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>";

/***/ }),
/* 328 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-module pipeline-module\">\n\t<div class=\"hp-inner\">\n\t\t<div class=\"resources-content-container\">\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-md-7\">\n                    <h3>HERO gets better. PACE gets stronger.</h3>\n                    <h4>In 2018, processes get streamlined for contractors and new laws protect your customers.</h4>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tOver the last few years, we’ve been evolving. Growing. And through the ups and downs of a rapidly-changing environment, we’ve learned to streamline processes and help you move forward. So navigating PACE and HERO is better for you and your customers.\n                    </p>\n                    <p>\n                        Now, updates to HERO and PACE have arrived. Take a look below at how we stay ahead of the curve so you’re always more prepared than the competition.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>Affordable home improvement payments.<br/>\n\t\t\t\t\t\tAnd a bold new HERO application.</h3>\n\t\t\t\t\t<h4>We already ask for income. Now we verify it.</h4>\n                    <p>\n                        Starting March 29 in California, in addition to asking for income in our new HERO application, we’ll verify it. How? We’ve automated over 100 ways to connect online and get the information they need. And it’s all built right into the application, which has been redesigned to make HERO easier to use and set you up for success.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h4>Why are we verifying income in California?</h4>\n                    <p>\n                        It’s all about going the extra mile so homeowners can afford their home improvement payments. Because we pride ourselves on doing things right. Verifying income will boost customer satisfaction, referrals, and positive contractor reviews while matching the right customers with the right financing products.\n                    </p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-5\">\n\t\t\t\t\t<img class=\"pace-image\" alt=\"HERO gets better. PACE gets stronger.\" src=\"src/assets/images/illustration_safeguards_laptop.svg\"/>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"resources-content-container\">\n            <h3>The landscape has changed. <br/>So let’s make sure you’re ready for everything.</h3>\n            <p>\n                From the California coast to the shores of Florida, industry guidelines and regulations are changing—and we are here to partner with you to help you understand this new environment and grow your business.\n            </p>\n            <p>\n                So what’s next?\n            </p>\n\t\t    <div class=\"divider\"></div>\n\t\t\t<div class=\"row resources-document\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>An open letter to California contractors.</h4>\n\t\t\t\t\t<p>\n                            Welcome to a level playing field. The CEOs of three leading PACE companies— Renovate America, Ygrene, and Renew Financial—penned a message to contractors like you, committing to the new laws in California.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://cdn.renovateamerica.com/contractor/PACE_CEOs_Letter_to_Contractors.pdf\" target=\"_blank\" ng-click=\"resources.trackClick('openLetter')\">READ THE LETTER</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-document\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>A tutorial on how income verification works.</h4>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tGet the scoop on how we’re integrating third party services to make the application process easier and more secure.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://vimeo.com/operationalexcellence/review/258867508/2a0d2e7524\" target=\"_blank\" ng-click=\"resources.trackClick('watchTutorial')\">WATCH THE TUTORIAL</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-document\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>Downloadable “How to Apply” helper.</h4>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tTake a deeper look at the application and what information a homeowner will need to have handy to apply.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\" http://go.renovateamerica.com/contractor/HERO-How-to-apply\" target=\"_blank\" ng-click=\"resources.trackClick('seeSteps')\">SEE THE STEPS</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-document\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>Using the Homeowner Action Center</h4>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tA step-by-step view of how a homeowner can easily connect with us to verify their income and resolve other outstanding conditions.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"http://go.renovateamerica.com/contractor/The-Homeowner-Action-Center-Guide\" target=\"_blank\" ng-click=\"resources.trackClick('takeLook')\">TAKE A LOOK</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-document\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>Income Verification Frequently Asked Questions</h4>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tThis handy guide is for your eyes only. And it’s full of detailed Q & A regarding our new income verification process and it’s benefits.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"http://go.renovateamerica.com/contractor/HERO-Income-Verification-FAQ\" target=\"_blank\" ng-click=\"resources.trackClick('getGuide')\">GET THE GUIDE</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-document\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>Get a high-level overview.</h4>\n\t\t\t\t\t<p>\n                            Dig into an interactive infographic with an at-a-glance look into why these changes are happening.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://www.foahomeimprovement.com/lp/herochanges\" target=\"_blank\" ng-click=\"resources.trackClick('getOverview')\">VIEW NOW</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-document\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>Get the full story.</h4>\n\t\t\t\t\t<p>\n                        Download the SlideShare Presentation below and get state-by-state insight into what’s new.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://www.slideshare.net/secret/HRTCxFBzrV17x1\" target=\"_blank\" ng-click=\"resources.trackClick('getFullStory')\">TAKE A LOOK</a>\n\t\t\t\t</div>\n\t\t\t</div>\t\t\t\n\t\t</div>\n\t</div>\n</div>\n";

/***/ }),
/* 329 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-module pipeline-module\">\n    <div class=\"hp-inner\">\n        <div class=\"resources-content-container\">\n\t\t\t<div class=\"row resources-participant\">\n\t\t\t\t<div class=\"col-md-12\">\n\t\t\t\t\t<h4 class=\"pull-left\">Participant - How HERO Works Video</h4>\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"http://go.renovateamerica.com/co/pace-participant/how-hero-works\" target=\"_blank\">View</a>\n                </div>\n            </div>\n\t\t\t<div class=\"row resources-participant\">\n\t\t\t\t<div class=\"col-md-12\">\n\t\t\t\t\t<h4 class=\"pull-left\">Participant - Code of Conduct</h4>\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://fa764b62064d3d71bb81-96f3848a50256afc7db699af5389ae43.ssl.cf2.rackcdn.com/California%20HERO%20PACE%20Participant%20Code%20of%20Conduct.pdf\" target=\"_blank\">View</a>\n                </div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-participant\">\n\t\t\t\t<div class=\"col-md-12\">\n\t\t\t\t\t<h4 class=\"pull-left\">Participant Brochure</h4>\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://cdn.renovateamerica.com/contractor/HERO-PACE-Participant-Flyer.pdf\" target=\"_blank\">View</a>\n                </div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-participant\">\n\t\t\t\t<div class=\"col-md-12\">\n\t\t\t\t\t<h4 class=\"pull-left\">Homeowner Landing Page</h4>\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://www.foahomeimprovement.com/lp/disp/heroapplication\" target=\"_blank\">View</a>\n                </div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-participant\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>Application in Review</h4>\n\t\t\t\t\t<p>\n                        Document listing all the reasons that a HERO application might be assigned an “In Review” status.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://e6cd8b4b39dd042fc477-c39597e5c7b01ac033a978dbfa710d50.ssl.cf1.rackcdn.com/HP102_Application%20In%20Review%20Reasons.pdf\" target=\"_blank\">View</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-participant\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>Renovate America Contractor Participation Agreement</h4>\n\t\t\t\t\t<p>\n                        The Contractor Participation Agreement that each Contractor must sign to register with Renovate America, which confirms agreement with the Terms & Conditions.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"http://7144b0b2ad28a8e9d39f-c7daaeaa05869c3b736fd3d320921c0f.r39.cf2.rackcdn.com/National-Contractor-Participation-Agreement-And-Terms-And-Conditions-Main-CA-Global.pdf\" target=\"_blank\">View</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-participant\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>HERO Program Contractor Participation Agreement - Reference Materials</h4>\n\t\t\t\t\t<p>\n                        Detailed reference materials that accompany the Contractor Participation Agreement. Signing the Contractor Participation agreement also confirms receipt of, familiarity with, and agreement to the Reference Materials.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://d281c9f0836d81226639-c7daaeaa05869c3b736fd3d320921c0f.ssl.cf2.rackcdn.com/National-Contractor-Participation-Reference-Materials-Main-CA-Global.pdf\" target=\"_blank\">View</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-participant\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>HERO Eligible Products List</h4>\n\t\t\t\t\t<p>\n                        The Eligible Products List provides general eligibility specifications for products eligible for HERO Financing across all HERO Programs.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://9662473e561b2ca15fec-e991096dabe6d2069d3f005000c6b73d.ssl.cf2.rackcdn.com/HEROEligibleProductsList.pdf\" target=\"_blank\">View</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-participant\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>Custom Product Application</h4>\n\t\t\t\t\t<p>\n                        If a Property Owner requires a custom project, the Contractor will need to fill out a Custom Product Application. The Custom Product Application is also used to submit products for inclusion on the HERO Eligible Product List. Property Owners and Contractors must wait to be approved before installing a custom or new product in order to ensure they will be approved by HERO Financing.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://9662473e561b2ca15fec-e991096dabe6d2069d3f005000c6b73d.ssl.cf2.rackcdn.com/CustomProductApplication.pdf\" target=\"_blank\">View</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-participant\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>Project Funding Checklist</h4>\n\t\t\t\t\t<p>\n                        Before turning in the HERO Completion Certificate, contractors should review this Project Funding Checklist ensure that all product funding requirements are also included as attachments to their project file. If any items are missing or incomplete, project completion documentation may need to be resigned or resubmitted, resulting in delays for the project.e approved by HERO Financing.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://e46c35b14ba172b610db-5bdc7e6ccbce2b667854e87f83bdb832.ssl.cf1.rackcdn.com/Project_Funding_Checklist.pdf\" target=\"_blank\">View</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-participant\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>Closing Checklist for Solar</h4>\n\t\t\t\t\t<p>\n                        Document that provides a list of required documents for solar projects that contractors need to submit to HERO for funding.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"http://b5e82a6d7efde409c9ba-5bdc7e6ccbce2b667854e87f83bdb832.r26.cf1.rackcdn.com/Closing%20Checklist_Solar.pdf\" target=\"_blank\">View</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-participant\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>Closing Checklist for Non-Solar</h4>\n\t\t\t\t\t<p>\n                        Document that provides a list of required documents for non-solar projects that contractors need to submit to HERO for funding.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"http://b5e82a6d7efde409c9ba-5bdc7e6ccbce2b667854e87f83bdb832.r26.cf1.rackcdn.com/Closing%20Checklist_NonSolar.pdf\" target=\"_blank\">View</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row resources-participant\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>CA Household Income Contribution Declaration</h4>\n\t\t\t\t\t<p>\n                        Declaration form to be completed when a CA homeowner has income contributions from other household members (not on mortgage or title) they would like to document.\t\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"http://7144b0b2ad28a8e9d39f-c7daaeaa05869c3b736fd3d320921c0f.r39.cf2.rackcdn.com/HouseholdIncomeContributionDeclaration.pdf\" target=\"_blank\">View</a>\n\t\t\t\t</div>\n\t\t\t</div>\t\t\t\n\t\t\t<div class=\"row resources-participant\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>Pasco County Disclosure</h4>\n\t\t\t\t\t<p>\n                        Required disclosure in Pasco County, FL which contains PACE FAQs and an attestation regarding additional PACE assessments. Disclosure must be wet-signed by all property owners and the in-home contractor, and provided as part of the Underwriting process.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://d281c9f0836d81226639-c7daaeaa05869c3b736fd3d320921c0f.ssl.cf2.rackcdn.com/PascoCountyDisclosure.pdf\" target=\"_blank\">View</a>\n\t\t\t\t</div>\n\t\t\t</div>\t\t\t\n\t\t\t<div class=\"row resources-participant\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4>California HERO Pace Participant Terms and Conditions</h4>\n\t\t\t\t\t<p>\n                        Sample version of the PACE Participant Terms and Conditions\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"https://fa764b62064d3d71bb81-96f3848a50256afc7db699af5389ae43.ssl.cf2.rackcdn.com/California HERO PACE Participant Code of Conduct.pdf\" target=\"_blank\">View</a>\n\t\t\t\t</div>\n\t\t\t</div>\t\t\n\t\t</div>\n        <div class=\"resources-content-container\">\n\t\t\t<h3>Sample Completion Certificates</h3>\t\t\t\n\t\t\t<div class=\"row resources-participant\">\n\t\t\t\t<div class=\"col-md-12\">\n\t\t\t\t\t<p>\n                        Sample versions of the Completion Certificates for each HERO Program. The Completion Certificate will need to be signed and completed AFTER all work has been completed.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\t\t\t\t\t\t\n\t\t\t<div class=\"row resources-participant\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4 class=\"pull-left\">CAHERO</h4>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"http://6c19f1173cfe5683abbc-e991096dabe6d2069d3f005000c6b73d.r5.cf2.rackcdn.com/CAHERO_SampleHEROCompletionCertificate.pdf\" target=\"_blank\">View</a>\n\t\t\t\t</div>\n\t\t\t</div>\t\n\t\t\t<div class=\"row resources-participant\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4 class=\"pull-left\">LA County</h4>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"http://6c19f1173cfe5683abbc-e991096dabe6d2069d3f005000c6b73d.r5.cf2.rackcdn.com/LAHERO_SampleHEROCompletionCertificate.pdf\" target=\"_blank\">View</a>\n\t\t\t\t</div>\n\t\t\t</div>\t\n\t\t\t<div class=\"row resources-participant\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4 class=\"pull-left\">CSCDA</h4>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"http://6c19f1173cfe5683abbc-e991096dabe6d2069d3f005000c6b73d.r5.cf2.rackcdn.com/CSCDA_SampleHEROCompletionCertificate.pdf\" target=\"_blank\">View</a>\n\t\t\t\t</div>\n\t\t\t</div>\t\n\t\t\t<div class=\"row resources-participant\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4 class=\"pull-left\">FDFC</h4>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"http://6c19f1173cfe5683abbc-e991096dabe6d2069d3f005000c6b73d.r5.cf2.rackcdn.com/FDFC_SampleHEROCompletionCertificate.pdf\" target=\"_blank\">View</a>\n\t\t\t\t</div>\n\t\t\t</div>\t\n\t\t\t<div class=\"row resources-participant\">\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<h4 class=\"pull-left\">MCED</h4>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<a class=\"btn btn-default pull-right\" href=\"http://6c19f1173cfe5683abbc-e991096dabe6d2069d3f005000c6b73d.r5.cf2.rackcdn.com/MCED_SampleHEROCompletionCertificate.pdf\" target=\"_blank\">View</a>\n\t\t\t\t</div>\n\t\t\t</div>\t\n\t\t</div>\n    </div>\n</div>";

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _certificationController = __webpack_require__(331);

var _certificationController2 = _interopRequireDefault(_certificationController);

var _certificationFactory = __webpack_require__(333);

var _certificationFactory2 = _interopRequireDefault(_certificationFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.certification', []).controller('CertificationController', _certificationController2.default).service('CertificationFactory', _certificationFactory2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/certification/certification.html', __webpack_require__(334)); // eslint-disable-line global-require
    $templateCache.put('app/certification/courses/certification_courses.html', __webpack_require__(335)); // eslint-disable-line global-require
    $templateCache.put('app/certification/guides/certification_guides.html', __webpack_require__(336)); // eslint-disable-line global-require
    $templateCache.put('app/certification/walkthrough/certification_walkthrough.html', __webpack_require__(337)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CertificationController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(332);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

CertificationController.$inject = ['CertificationFactory', '$stateParams', '$state', '$window', '$sce'];


/* @ngInject */
function CertificationController(CertificationFactory, $stateParams, $state, $window, $sce) {
    var vm = this;

    vm.certificationPages = [];
    vm.guideColumns = [];
    vm.guides = [];
    vm.courseCategories = [];
    vm.currentPage = {};
    vm.pageUrl = '';
    vm.tlmsUserId = '';
    vm.isCertified = null;
    vm.finalExamInfo = null;
    vm.finalExamCertificate = null;
    vm.tlmsError = false;

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.switchPage = function (page) {
        vm.currentPage = page;
        buildPageUrl();
        $state.go('certification', { certificationPage: page.pageName });
    };

    vm.getCourseUrl = function (courseId) {
        var newWindow = $window.open('');
        CertificationFactory.getCourseUrl(courseId).then(function (response) {
            newWindow.location = response.data.Data;
        });
    };

    vm.parseCourseData = function (data) {
        return $sce.trustAsHtml(data);
    };

    vm.courseClicked = function (course) {
        if (course.Description !== '') {
            course.isCollapsed = !course.isCollapsed;
        }
    };
    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */
    function init() {
        getCertificationPages();
        getCertificationColumns();
        getCertificationGuides();
        setInitialPage();
        buildPageUrl();
        getUserCourses();
    }

    function getCertificationPages() {
        vm.certificationPages = CertificationFactory.getCertificationPages();
    }

    function getCertificationColumns() {
        vm.guideColumns = CertificationFactory.getCertificationGuideColumns();
    }

    function getCertificationGuides() {
        vm.guides = CertificationFactory.getCertificationGuides();
    }

    function getUserCourses() {
        CertificationFactory.getUserCourses().then(function (response) {
            if (response.data.ResultCode !== 1) {
                // Getting information about all other courses
                vm.tlmsUserId = response.data.Data.TLMSUserId;
                vm.isCertified = response.data.Data.IsCertified;

                if (vm.isCertified === true) {
                    vm.finalExamCertificate = CertificationFactory.getUserCertificate();
                }

                formatUserCourses(response.data.Data.Courses);

                // Getting information about the final exam
                vm.finalExamInfo = response.data.Data.CoursesCertification[0];
                CertificationFactory.getCourseUrl(vm.finalExamInfo.Id).then(function (response) {
                    vm.finalExamInfo.Url = response.data.Data;
                });
            } else {
                vm.tlmsError = true;
            }
        });
    }

    function formatUserCourses(courses) {
        var formattedCourses = [];

        // Group the courses by courseType
        courses = _lodash2.default.groupBy(courses, 'CourseType');

        // Properly format the groupings
        _lodash2.default.each(courses, function (value, key) {
            formattedCourses.push({
                categoryName: key,
                courses: value
            });
        });

        // Sort the formatted courses by categoryName
        formattedCourses = _lodash2.default.sortBy(formattedCourses, 'categoryName');

        // Remove the leading numbers from the categoryName now that we've sorted the array
        _lodash2.default.each(formattedCourses, function (courseCategory) {
            courseCategory.categoryName = courseCategory.categoryName.substring(1);
            courseCategory.courses.isCollapsed = true;
        });

        vm.courseCategories = formattedCourses;
    }

    function setInitialPage() {
        var pages = _lodash2.default.filter(vm.certificationPages, function (page) {
            return page.pageName === $stateParams.certificationPage;
        });
        if (pages !== undefined && pages !== null) {
            vm.currentPage = pages[0];
        } else {
            vm.currentPage = vm.certificationPages[0];
        }
    }

    function buildPageUrl() {
        vm.pageUrl = 'app/certification/' + vm.currentPage.pageName + '/certification_' + vm.currentPage.pageName + '.html';
    }
}

/***/ }),
/* 332 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CertificationFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

CertificationFactory.$inject = ['$sce', '$http', 'HPConfig'];


/* @ngInject */
function CertificationFactory($sce, $http, HPConfig) {
    var certificationPages = [{
        pageName: 'courses',
        pageDisplayName: 'Suggested Courses',
        isEnabled: true
    }, {
        pageName: 'guides',
        pageDisplayName: 'Quick Reference Guides',
        isEnabled: true
    }];

    var certificationGuideColumns = [{
        name: 'title',
        displayName: 'Title',
        isEnabled: true
    }, {
        name: 'courseNo',
        displayName: 'Course #',
        isEnabled: true
    }];

    var certificationGuides = [{
        english: {
            name: 'Certification Requirements',
            courseNo: 'HU100',
            action: '8/15/2014',
            url: $sce.trustAsResourceUrl('http://d9d9087c54be8c649af5-c39597e5c7b01ac033a978dbfa710d50.r92.cf1.rackcdn.com/WT100_Certification%20Requirements.pdf')
        }
    }, {
        english: {
            name: 'How It Works',
            courseNo: 'HU100',
            action: '8/15/2014',
            url: $sce.trustAsResourceUrl('http://d9d9087c54be8c649af5-c39597e5c7b01ac033a978dbfa710d50.r92.cf1.rackcdn.com/WT100_How%20It%20Works.pdf')
        },
        spanish: {
            name: 'How It Works (Spanish)',
            courseNo: 'HU100',
            action: '8/15/2014',
            url: $sce.trustAsResourceUrl('https://e6cd8b4b39dd042fc477-c39597e5c7b01ac033a978dbfa710d50.ssl.cf1.rackcdn.com/WT100_How%20It%20Works%20Spanish.pdf')
        }
    }, {
        english: {
            name: 'Application - In Review Reasons',
            courseNo: 'HU101',
            action: '8/15/2014',
            url: $sce.trustAsResourceUrl('http://d9d9087c54be8c649af5-c39597e5c7b01ac033a978dbfa710d50.r92.cf1.rackcdn.com/HP102_Application%20In%20Review%20Reasons.pdf')
        },
        spanish: {
            name: 'Application - In Review Reasons (Spanish)',
            courseNo: 'HU101',
            action: '8/15/2014',
            url: $sce.trustAsResourceUrl('https://e6cd8b4b39dd042fc477-c39597e5c7b01ac033a978dbfa710d50.ssl.cf1.rackcdn.com/HP102_Application%20In%20Review%20Reasons%20Spanish.pdf')
        }
    }, {
        english: {
            name: 'HERO Program Eligibility',
            courseNo: 'HU101',
            action: '8/15/2014',
            url: $sce.trustAsResourceUrl('https://e6cd8b4b39dd042fc477-c39597e5c7b01ac033a978dbfa710d50.ssl.cf1.rackcdn.com/HP102_HERO%20Program%20Eligibility.pdf')
        },
        spanish: {
            name: 'HERO Program Eligibility (Spanish)',
            courseNo: 'HU101',
            action: '8/15/2014',
            url: $sce.trustAsResourceUrl('https://e6cd8b4b39dd042fc477-c39597e5c7b01ac033a978dbfa710d50.ssl.cf1.rackcdn.com/HP102_HERO%20Program%20Eligibility%20Spanish.pdf')
        }
    }, {
        english: {
            name: 'Calling In Products',
            courseNo: 'HU101',
            action: '8/15/2014',
            url: $sce.trustAsResourceUrl('http://d9d9087c54be8c649af5-c39597e5c7b01ac033a978dbfa710d50.r92.cf1.rackcdn.com/HP103_Calling%20In%20Products.pdf')
        }
    }, {
        english: {
            name: 'Eligible Products',
            courseNo: 'HU101',
            action: '8/15/2014',
            url: $sce.trustAsResourceUrl('https://9662473e561b2ca15fec-e991096dabe6d2069d3f005000c6b73d.ssl.cf2.rackcdn.com/HEROEligibleProductsList.pdf')
        }
    }, {
        english: {
            name: 'Financing Document Set Guide',
            courseNo: 'HU102',
            action: '8/15/2014',
            url: $sce.trustAsResourceUrl('http://d9d9087c54be8c649af5-c39597e5c7b01ac033a978dbfa710d50.r92.cf1.rackcdn.com/HP104_Financing Document Set Guide.pdf')
        }
    }, {
        english: {
            name: 'eSign Financing Documents',
            courseNo: 'HU102',
            action: '8/15/2014',
            url: $sce.trustAsResourceUrl('http://d9d9087c54be8c649af5-c39597e5c7b01ac033a978dbfa710d50.r92.cf1.rackcdn.com/HP104_eSign%20Financing%20Documents.pdf')
        }
    }, {
        english: {
            name: 'eSign Project Completion',
            courseNo: 'HU103',
            action: '8/15/2014',
            url: $sce.trustAsResourceUrl('http://d9d9087c54be8c649af5-c39597e5c7b01ac033a978dbfa710d50.r92.cf1.rackcdn.com/HP105_eSign%20Project%20Completion.pdf')
        }
    }, {
        english: {
            name: 'Project Funding Checklist',
            courseNo: 'HU103',
            action: '8/15/2014',
            url: $sce.trustAsResourceUrl('https://e46c35b14ba172b610db-5bdc7e6ccbce2b667854e87f83bdb832.ssl.cf1.rackcdn.com/Project_Funding_Checklist.pdf')
        }
    }, {
        english: {
            name: 'Making Payments',
            courseNo: 'HU103',
            action: '8/15/2014',
            url: $sce.trustAsResourceUrl('http://d9d9087c54be8c649af5-c39597e5c7b01ac033a978dbfa710d50.r92.cf1.rackcdn.com/HP106_Making%20Payments.pdf')
        }
    }, {
        english: {
            name: 'Proposal Plus - Solar Tax Credit Pay Down',
            courseNo: 'HU101',
            action: '10/7/2014',
            url: $sce.trustAsResourceUrl('http://d9d9087c54be8c649af5-c39597e5c7b01ac033a978dbfa710d50.r92.cf1.rackcdn.com/Proposal%20Tool%20-%20Solar%20Tax%20Credit%20Pay%20Down.pdf')
        }
    }, {
        english: {
            name: 'Change Order Request - FAQ',
            courseNo: 'HU102',
            action: '10/31/2014',
            url: $sce.trustAsResourceUrl('http://d9d9087c54be8c649af5-c39597e5c7b01ac033a978dbfa710d50.r92.cf1.rackcdn.com/HP104.5_Change%20Order%20Process_FAQ.pdf')
        }
    }, {
        english: {
            name: 'Funding Document Submission Guide',
            courseNo: 'HU103',
            action: '2/25/2015',
            url: $sce.trustAsResourceUrl('http://d9d9087c54be8c649af5-c39597e5c7b01ac033a978dbfa710d50.r92.cf1.rackcdn.com/HERO-Contractor-Funding-Document-Submission.pdf')
        }
    }, {
        english: {
            name: 'HERO Confirmation Call Checklist',
            courseNo: 'HU101',
            action: '2/25/2015',
            url: $sce.trustAsResourceUrl('https://e6cd8b4b39dd042fc477-c39597e5c7b01ac033a978dbfa710d50.ssl.cf1.rackcdn.com/HERO%20Confirmation%20Call%20Checklist.pdf')
        }
    }];

    return {
        getCertificationPages: getCertificationPages,
        getCertificationGuideColumns: getCertificationGuideColumns,
        getCertificationGuides: getCertificationGuides,
        getUserCertificate: getUserCertificate,
        getUserCourses: getUserCourses,
        getCourseUrl: getCourseUrl
    };

    function getCertificationPages() {
        return _lodash2.default.filter(certificationPages, function (page) {
            return page.isEnabled === true;
        });
    }

    function getCertificationGuideColumns() {
        return _lodash2.default.filter(certificationGuideColumns, function (column) {
            return column.isEnabled === true;
        });
    }

    function getUserCertificate() {
        return HPConfig.heroProApi + 'ELearning/UserCertificate';
    }

    function getCertificationGuides() {
        return certificationGuides;
    }

    function getUserCourses() {
        return $http.get(HPConfig.heroProApi + 'ELearning/UserCourses', { cache: true });
    }

    function getCourseUrl(courseId) {
        return $http.get(HPConfig.heroProApi + 'ELearning/CourseUrl?courseId=' + courseId);
    }
}

/***/ }),
/* 334 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-module certification-module\">\n    <div class=\"hp-inner\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <h1>HERO Certification</h1>\n            </div>\n        </div>\n        <div class=\"row hp-inner-center\">\n            <div class=\"col-md-12\">\n                <ng-include src=\"'app/certification/walkthrough/certification_walkthrough.html'\"></ng-include>\n            </div>\n        </div>\n        <div class=\"certification-nav navbar\" ng-show=\"certification.certificationPages\">\n            <ul class=\"nav navbar-nav\">\n                <li ng-repeat=\"page in certification.certificationPages\">\n                    <a ng-bind=\"page.pageDisplayName\" ng-click=\"certification.switchPage(page);\" ng-class=\"{ 'active': page.pageName === certification.currentPage.pageName }\"></a>\n                </li>\n            </ul>\n        </div>\n        <ng-include src=\"certification.pageUrl\"></ng-include>\n    </div>\n</div>\n";

/***/ }),
/* 335 */
/***/ (function(module, exports) {

module.exports = "<div class=\"certification-courses-container\" ng-show=\"certification.courseCategories.length > 0\">\n\n\t<table>\n\t\t<thead>\n\t\t\t<tr>\n\t\t\t\t<th class=\"course-title\">Course Title</th>\n\t\t\t\t<th class=\"course-number\">Course #</th>\n\t\t\t\t<th class=\"course-progress\">Progress</th>\n\t\t\t\t<th class=\"course-action\">Action</th>\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tbody ng-repeat=\"courses in certification.courseCategories\">\n\t\t\t<tr>\n\t\t\t\t<td colspan=\"4\" class=\"category-heading\">\n\t\t\t\t\t{{courses.categoryName}}\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t\t<tr ng-repeat=\"course in courses.courses\">\n\t\t\t\t<td class=\"course-title\">\n\t\t\t\t\t<p ng-click=\"certification.courseClicked(course)\">\n\t\t\t\t\t\t<span ng-if=\"course.Description !== ''\" class=\"arrow\" ng-class=\"{'arrow-opened' : course.isCollapsed}\"></span>\n\t\t\t\t\t\t<span class=\"course-name\" ng-class=\"{'no-description': course.Description === ''}\" ng-bind-html=\"certification.parseCourseData(course.Name)\"></span>\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class=\"course-description\" uib-collapse=\"!course.isCollapsed\" ng-bind-html=\"certification.parseCourseData(course.Description)\"></p>\n\t\t\t\t</td>\n\t\t\t\t<td class=\"course-number\">{{course.Code}}</td>\n\t\t\t\t<td class=\"course-progress\">\n\t\t\t\t\t<div ng-class=\"{'notStarted': course.CompletionPercentage === undefined || course.CompletionPercentage === 0, 'inProgress': course.CompletionPercentage !== 100 && course.CompletionPercentage !== undefined && course.CompletionPercentage !== 0, 'completed': course.CompletionPercentage === 100}\"><p></p></div>\n\t\t\t\t</td>\n\t\t\t\t<td class=\"course-action\">\n\t\t\t\t\t<span class=\"link\" ng-click=\"certification.getCourseUrl(course.Id)\">Launch Course</span>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t</table>\n\n</div>\n";

/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports = "<div class=\"certification-guides-container\">\n    <table class=\"table table-striped certification-guides-table\">\n        <thead>\n        <tr>\n            <th ng-repeat=\"column in certification.guideColumns\" ng-class=\"[column.name]\">\n                <span>{{column.displayName}}</span>\n            </th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr ng-repeat=\"guide in certification.guides\">\n            <td>\n                <a ng-href=\"{{guide.english.url}}\" target=\"_blank\">{{guide.english.name}}</a>\n                <a ng-href=\"{{guide.spanish.url}}\" ng-if=\"guide.spanish\" target=\"_blank\">{{guide.spanish.name}}</a>\n            </td>\n            <td>\n                <span>{{guide.english.courseNo}}</span>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n";

/***/ }),
/* 337 */
/***/ (function(module, exports) {

module.exports = "<div class=\"certification-walkthrough hp-loading-spinner\" ra-spinner name=\"certificationSpinner\" show=\"certification.finalExamInfo === null && certification.tlmsError === false\">\n\n    <div class=\"certification-walkthrough-exam\" ng-if=\"certification.isCertified === false\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-12\">\n\t\t\t\t<div ng-if=\"certification.finalExamInfo.ExamStatus === 'incomplete'\">\n\t\t\t\t\t<span class=\"step-warning icon icon-exclamation\"></span>\n\t\t\t\t</div>\n\t\t\t\t<h2>Final Examination</h2>\n\t\t\t\t<h4 ng-if=\"certification.finalExamInfo.ExamStatus === 'incomplete'\">In Progress</h4>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-12\">\n\t\t\t\t<p>\n\t\t\t\tShow you have the know-how to be a HERO Certified Contractor! Pass the final with a score of 90% or higher to earn your HERO Certificate. We recommend completing the coursework beforehand. These contain quick tutorials and practice quizzes to make sure you have all of the information you need to be successful. Good Luck!\n\t\t\t\t<p>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-12\">\n\t\t\t\t<a href=\"{{certification.finalExamInfo.Url}}\" class=\"btn btn-primary\" target=\"_blank\" ng-if=\"certification.finalExamInfo.ExamStatus !== 'incomplete'\">Take the Exam</a>\n\t\t\t\t<a href=\"{{certification.finalExamInfo.Url}}\" class=\"btn btn-primary\" target=\"_blank\" ng-if=\"certification.finalExamInfo.ExamStatus === 'incomplete'\">Continue Exam</a>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n    <div class=\"certification-walkthrough-certificate\" ng-if=\"certification.isCertified === true\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-12\">\n\t\t\t\t<div class=\"certificate-container\">\n\t\t\t\t\t<p class=\"certificate-name\">{{main.userData.FirstName}} {{main.userData.LastName}}</p>\n\t\t\t\t\t<p class=\"certificate-company\">{{main.currentLocation.CompanyName}}</p>\n\t\t\t\t\t<img src=\"src/assets/images/hero_certificate.png\" alt=\"HERO Certificate\" width=\"650\"/>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-12\">\n\t\t\t\t<a hp-download-link href=\"{{certification.finalExamCertificate}}\" class=\"btn btn-primary\">Download Certificate</a>\n\t\t\t\t<a href=\"{{certification.finalExamInfo.Url}}\" ng-if=\"certification.finalExamInfo.Url !== undefined\" class=\"btn btn-default\" target=\"_blank\">View Exam Results</a>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n    <div class=\"certification-walkthrough-error\" ng-if=\"certification.tlmsError === true\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"certificate-container\">\n                    <img class=\"error-image\" src=\"src/assets/images/cert-error-load.png\" alt=\"Error\" />\n                    <h1>Oops! Something went wrong.</h1>\n                    <p>There was an issue retrieving your certification material.</p>\n                    <p>Please give us a call at 844-722-7759</p>\n                </div>\n            </div>\n        </div>\n    </div>\n\n</div>\n";

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = userController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(339);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

userController.$inject = ['$scope', '$rootScope', 'AccountsFactory', 'ModalService', 'ChangePasswordFactory', '$timeout', 'UserData', '$stateParams', '$state', 'HPRoles', 'LicensesFactory']; // angular
// 	.module("HeroPRO")
// 	.controller("UserController", userController);

/* @ngInject */
function userController($scope, $rootScope, AccountsFactory, ModalService, ChangePasswordFactory, $timeout, UserData, $stateParams, $state, HPRoles, LicensesFactory) {
    var vm = this;

    vm.currentUser = {};
    vm.userProfile = {};
    vm.officesSubheader = '';
    vm.email = '';
    vm.confirmEmail = '';
    vm.phone = '';
    vm.phoneExt = '';
    vm.mobilePhone = '';
    vm.personalInfoStatusMessage = '';
    vm.passwordStatusMessage = '';
    vm.role = {};
    vm.enableDisableMessage = '';
    vm.preferencesStatusMessage = '';
    vm.enableDisableStatus = null;

    // Flags
    vm.isAdmin = false;
    vm.isEditUser = false;
    vm.isEditingProfile = false;
    vm.editPersonalInfoMode = false;
    vm.isPersonalInfoDirty = false;
    vm.isEditEmail = false;
    vm.isPersonalInfoError = false;
    vm.isPersonalInfoMessageDisplayed = false;
    vm.isPasswordErrorMessage = false;
    vm.changePasswordMode = false;
    vm.isPasswordMessageDisplayed = false;
    vm.isCompanyLevelUser = false; // Company Admin or Company Mgr
    vm.enableUserComplete = false;
    vm.changePreferencesMode = false;
    vm.isPreferencesError = false;
    vm.isLoggedInUserSalesRep = true;
    vm.submitted = 'false';

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    vm.editPersonalinformation = function () {
        vm.editPersonalInfoMode = true;

        vm.user = {
            FirstName: vm.userProfile.FirstName,
            LastName: vm.userProfile.LastName,
            MiddleInitial: vm.userProfile.CSLBPersonnelMI,
            Suffix: vm.userProfile.CSLBPersonnelSuffix,
            Email: vm.userProfile.Email,
            PhoneNumber: vm.userProfile.Phone,
            Extension: vm.userProfile.PhoneExt,
            MobilePhone: vm.userProfile.MobilePhone,
            IsCSLBHolder: vm.userProfile.IsCSLBHolder,
            TitleId: vm.userProfile.CSLBTitleId,
            Licenses: vm.userProfile.Licenses === undefined ? new Array() : vm.userProfile.Licenses
        };
        console.log("user to edit", vm.user);
    };

    vm.cancelEditPersonalinformation = function () {
        resetUpdatePersonalInformation();
        vm.submitted = 'false';
        AccountsFactory.editProfileDirty = false;
    };

    vm.savePersonalinformation = function (isValid) {
        vm.submitted = 'true';
        if (isValid) {
            var user = {
                ContractorUserId: vm.userProfile.ContractorUserId,
                PhoneNumber: vm.user.PhoneNumber,
                MobilePhone: vm.user.MobilePhone,
                Email: vm.user.Email,
                Extension: vm.user.Extension,
                RoleId: vm.role.RoleId,
                Licenses: vm.user.Licenses
            };
            if (vm.user.licenseHolderSelected === true) {
                user.CSLBTitleId = vm.user.TitleId;
                user.CSLBMiddleInitial = vm.user.MiddleInitial;
                user.CSLBSuffix = vm.user.Suffix;
                user.FirstName = vm.user.FirstName;
            }
            savePersonalInformation(user);
        }
    };

    vm.changePreferences = function () {
        vm.changePreferencesMode = true;
        vm.userPreferences = {
            ContactByEmail: vm.userProfile.ContactByEmail
        };
    };

    vm.cancelChangePreferences = function () {
        vm.submitted = 'false';
        vm.changePreferencesMode = false;
    };

    vm.updateContactPreferences = function (user) {
        vm.submitted = 'true';
        AccountsFactory.updateContactPreferences({ ContractorUserId: vm.userProfile.ContractorUserId, ContactByEmail: user.ContactByEmail }).then(function (response) {
            vm.userProfile.ContactByEmail = user.ContactByEmail;
            vm.changePreferencesMode = false;
        });
    };

    vm.addOfficeAssignment = function () {
        var modal = ModalService.launchLgModal({
            templateUrl: 'app/accounts/user/addOfficeAssignment/addOfficeAssignment.html',
            windowClass: 'add-office-assignment',
            controller: 'AddOfficeAssignmentController',
            controllerAs: 'addOfficeAssignment',
            size: 'full-screen',
            resolve: {
                currentUserProfile: function currentUserProfile() {
                    return vm.userProfile;
                },
                signedInUserId: function signedInUserId() {
                    return vm.currentUser.ContractorUserId;
                }
            }
        });

        modal.result.then(function (addedoffice) {
            if (addedoffice !== undefined) {
                // Add the office to the list of office assignments
                vm.userProfile.Locations.push(addedoffice);
            }
            ModalService.closeLgModal();
        });
    };

    vm.removeOfficeAssignment = function (office) {
        var modal = ModalService.launchLgModal({
            templateUrl: 'app/accounts/user/officeAssignments/removeOfficeAssignment.html',
            windowClass: 'remove-office-assignment',
            controller: 'RemoveOfficeAssignmentController',
            controllerAs: 'removeOfficeAssignment',
            size: 'full-screen',
            resolve: {
                selectedOffice: function selectedOffice() {
                    return office;
                },
                contractorUserId: function contractorUserId() {
                    return vm.userProfile.ContractorUserId;
                }
            }
        });

        modal.result.then(function (result) {
            if (result === true) {
                // Remove the office from the list of office assignments
                vm.userProfile.Locations = _lodash2.default.without(vm.userProfile.Locations, office);
            }
            ModalService.closeLgModal();
        });
    };

    vm.changePassword = function () {
        vm.changePasswordMode = true;
        ChangePasswordFactory.changePasswordEnable = true;
        ChangePasswordFactory.userObj = vm.userProfile;
    };

    vm.requestPassword = function () {
        sendForgotPasswordEmail(vm.userProfile.Email);
    };

    vm.backToUsers = function () {
        vm.isEditUser = false;
        $state.go('accounts', { accountsPage: 'users', accountId: null });
    };

    vm.disableUser = function () {
        vm.enableDisableStatus = 3;
        AccountsFactory.disableUser({ ContractorUserId: vm.userProfile.ContractorUserId }).then(function (response) {
            if (response.data.Data === vm.userProfile.ContractorUserId) {
                vm.userProfile.isEnabled = false;
                vm.enableDisableStatus = 0;
                vm.enableDisableMessage = 'This user is currently disabled.';
                vm.enableUserComplete = false;
            }
        });
    };

    vm.enableUser = function () {
        vm.enableDisableStatus = 1;
        AccountsFactory.enableUser({ ContractorUserId: vm.userProfile.ContractorUserId }).then(function (response) {
            if (response.data.Data === vm.userProfile.ContractorUserId) {
                vm.userProfile.isEnabled = true;
                vm.enableDisableStatus = 2;
                vm.enableDisableMessage = 'This user is now enabled.';
                $timeout(function () {
                    vm.enableUserComplete = true;
                }, 5000);
            }
        });
    };

    vm.deleteUser = function () {
        var modal = ModalService.launchLgModal({
            templateUrl: 'app/accounts/user/deleteUser/deleteUser.html',
            windowClass: 'delete-user',
            controller: 'DeleteUserController',
            controllerAs: 'deleteUser',
            size: 'full-screen',
            resolve: {
                selectedUser: function selectedUser() {
                    return vm.userProfile;
                }
            }
        });

        modal.result.then(function (result) {
            if (result === true) {
                // If user is successfully deleted, take the user to the users page
                $state.go('accounts', { accountsPage: 'users', accountId: null });
            }
            ModalService.closeLgModal();
        });
    };

    vm.showContractorUserLicense = function () {
        return vm.hasCaliforniaLocation || vm.userProfile && vm.userProfile.Licenses || vm.user && vm.user.Licenses;
    };

    vm.canEditContractorUserLicense = function () {
        // Users cannot edit the HIS of other users
        return vm.userProfile.ContractorUserId === vm.currentUser.ContractorUserId;
    };

    vm.openContractorUserLicenseRegistrationModal = function () {
        var modal = ModalService.launchLgModal({
            templateUrl: 'app/accounts/user/personalInformation/contractorUserLicenseRegistration/contractorUserLicenseRegistration.html',
            windowClass: 'contractor-user-license-registration',
            controller: 'ContractorUserLicenseRegistrationController',
            controllerAs: 'contractorUserLicenseRegistration',
            size: 'full-screen',
            resolve: {
                selectedUser: function selectedUser() {
                    return undefined;
                }
            }
        });

        modal.result.then(function (result) {
            if (result) {
                console.log("Contractor License Registration result", result);
                vm.user.Licenses.push(result);
            }
            ModalService.closeLgModal();
        });
    };
    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */
    function init() {
        getContractorUser();
        vm.isPasswordMessageDisplayed = false;
        vm.changePasswordMode = false;
        ChangePasswordFactory.changePasswordEnable = false;
        resetUpdatePersonalInformation();
        enableBackLink();
        setProfileFlag();
        getOrganizationLicense();
    }

    function getOrganizationLicense() {
        // Find the california license
        LicensesFactory.getLicenses().then(function (response) {
            var californiaLicense = _lodash2.default.findWhere(response.data.Data.Licenses, { OrganizationLicenseTypeId: 1 });
            if (californiaLicense !== undefined) {
                vm.licenseNumber = californiaLicense.LicenseNumber;
            }
        });
    }

    function getContractorUser() {
        AccountsFactory.getContractorUser($stateParams.accountId).then(function (response) {
            if (response.data.Data !== undefined || response.data.Data !== null) {
                vm.userProfile = response.data.Data;
                vm.hasCaliforniaLocation = _lodash2.default.findWhere(vm.userProfile.Locations, { State: 'CA' }) !== undefined;
                vm.role = vm.userProfile.Roles[0];
                getUserPermissions();
                buildOfficesSubheader();
                initializeUserState();
            }
        });
    }

    function buildOfficesSubheader() {
        if (vm.userProfile.Locations.length > 1) {
            vm.officesSubheader = 'Office Assignments';
        } else {
            vm.officesSubheader = 'Office Assignment';
        }
    }

    function initializeUserState() {
        if (vm.userProfile.isEnabled === true) {
            vm.enableDisableStatus = 2;
            vm.enableUserComplete = true;
        } else {
            vm.userProfile.isEnabled = false;
            vm.enableDisableStatus = 0;
            vm.enableDisableMessage = 'This user is currently disabled';
            vm.enableUserComplete = false;
        }
    }

    function savePersonalInformation(user) {
        AccountsFactory.updateContractorUser(user).then(function (response) {
            if (response.data.ResultCode === 2) {
                $rootScope.$broadcast('EmailInUse');
            } else if (response.data.ResultCode === 1) {
                var result = response.data.Data;
                vm.errorMessage = '';
                vm.userProfile.FirstName = result.FirstName;
                vm.userProfile.CSLBPersonnelMI = result.CSLBMiddleInitial;
                vm.userProfile.CSLBPersonnelSuffix = result.CSLBSuffix;
                vm.userProfile.CSLBTitleId = result.CSLBTitleId;
                vm.userProfile.IsCSLBHolder = result.IsValidOfficer;
                vm.userProfile.Email = result.Email;
                vm.userProfile.Phone = result.Phone;
                vm.userProfile.PhoneExt = result.PhoneExt;
                vm.userProfile.MobilePhone = result.MobilePhone;
                vm.userProfile.Roles[0] = vm.role;
                vm.userProfile.Licenses = result.Licenses;
                resetUpdatePersonalInformation();
                $rootScope.$broadcast('CSLB-Qualifier-Fixed');
            }
        });
    }

    function resetUpdatePersonalInformation() {
        vm.editPersonalInfoMode = false;
        vm.isEditEmail = false;
        vm.isEmailConfirmed = false;
        vm.email = '';
        vm.confirmEmail = '';
        vm.phone = '';
        vm.phoneExt = '';
        vm.mobilePhone = '';
        vm.personalInfoStatusMessage = '';
        vm.isPersonalInfoError = false;
        //		AccountsFactory.setEditProfileDirtyFlag(false);
    }

    function enableBackLink() {
        if ($stateParams.accountId !== null) {
            vm.isEditUser = true;
        } else {
            vm.isEditUser = false;
        }
    }

    function sendForgotPasswordEmail(email) {
        ChangePasswordFactory.requestRecoverPasswordEmail(email).then(function (response) {
            if (response.data.Result || response.data.Data) {
                ChangePasswordFactory.statusMessage = 'We\'ve sent a reset password link to ' + vm.userProfile.Email;
            }
        });
    }

    function getUserPermissions() {
        UserData.getUserData().then(function (response) {
            vm.currentUser = response;
            vm.isAdmin = vm.currentUser.HasElevatedAccess;
            vm.isLoggedInUserSalesRep = HPRoles[vm.currentUser.Roles[0]].rank === 3;
            vm.isProfileView = $stateParams.accountId === null || $stateParams.accountId === undefined;
            userProfileCheck();
        });

        if (vm.role.RoleId === HPRoles.COPO_COMPANY_ADMIN.roleId || vm.role.RoleId === HPRoles.COPO_COMPANY_MGR.roleId) {
            vm.isCompanyLevelUser = true;
        }
    }

    function userProfileCheck() {
        if (($stateParams.accountId !== null || $stateParams.accountId !== undefined) && vm.currentUser.ContractorUserId === Number($stateParams.accountId)) {
            $state.go('accounts', { accountsPage: 'myprofile', accountId: null });
        }
    }

    function setProfileFlag() {
        if ($stateParams.accountId === null || $stateParams.accountId === undefined) {
            vm.isEditingProfile = true;
        } else {
            vm.isEditingProfile = false;
        }
    }

    $rootScope.$watch(function () {
        return AccountsFactory.statusMessage;
    }, function (value) {
        if (value !== undefined && value !== '') {
            vm.passwordStatusMessage = value;
            vm.isPasswordMessageDisplayed = true;
            $timeout(function () {
                vm.isPasswordMessageDisplayed = false;
                ChangePasswordFactory.statusMessage = '';
            }, 5000);
        }
    });

    $scope.$on('editPersonalInfo', function (event, payload) {
        vm.editPersonalInfoMode = payload.isEdit;
    });

    $rootScope.$watch(function () {
        return ChangePasswordFactory.changePasswordEnable;
    }, function (value) {
        if (value !== vm.changePasswordMode) {
            vm.changePasswordMode = value;
        }
    });

    $rootScope.$watch(function () {
        return ChangePasswordFactory.statusMessage;
    }, function (value) {
        if (value !== '') {
            vm.passwordStatusMessage = value;
            vm.isPasswordMessageDisplayed = true;
            $timeout(function () {
                vm.isPasswordMessageDisplayed = false;
                ChangePasswordFactory.statusMessage = '';
            }, 5000);
        }
    });
}

/***/ }),
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = paceCredentialController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(341);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

paceCredentialController.$inject = ['UserData', 'AccountsFactory', 'ModalService', 'PermissionsFactory', '$rootScope', 'HISWizardFactory', '$state']; // angular
// 	.module("HeroPRO")
// 	.controller("PaceCredentialController", pccontroller);

/* @ngInject */
function paceCredentialController(UserData, AccountsFactory, ModalService, PermissionsFactory, $rootScope, HISWizardFactory, $state) {
    var vm = this;

    vm.isSolicitor = false;
    vm.advertiserRequirements_HasTraining = false;
    vm.advertiserRequirements_Eligible = false;
    vm.solicitorRequirements_HasTraining = false;
    vm.solicitorRequirements_HasLicenseNumber = false;
    vm.solicitorRequirements_Eligible = false;
    vm.HISLicenseNumber = 0;
    vm.trainingDaysRemaining = 0;

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    vm.openContractorUserLicenseRegistrationModal = function () {
        var modal = ModalService.launchLgModal({
            templateUrl: 'app/accounts/user/personalInformation/contractorUserLicenseRegistration/contractorUserLicenseRegistration.html',
            windowClass: 'contractor-user-license-registration',
            controller: 'ContractorUserLicenseRegistrationController',
            controllerAs: 'contractorUserLicenseRegistration',
            size: 'full-screen',
            resolve: {
                selectedUser: function selectedUser() {
                    return vm.userProfile;
                }
            }
        });

        modal.result.then(function (user) {
            if (user) {
                vm.userProfile = user;
                vm.hisComplete = vm.userProfile.Licenses !== null && _lodash2.default.findWhere(vm.userProfile.Licenses, {
                    LicenseTypeId: 1
                }) !== undefined;
                $rootScope.$broadcast('RefreshPermissions');
                window.location.reload();
            }
        });
    };

    vm.openStatusComparisonModal = function () {
        var modal = ModalService.launchLgModal({
            templateUrl: 'app/accounts/user/paceCredential/modals/ParticipantVsCertifiedProfessionalComparison.html',
            windowClass: 'comparison-modal',
            size: 'lg',
            controller: 'ParticipantVsCertifiedProfessionalComparisonController',
            controllerAs: 'ParticipantVsCertifiedProfessionalComparisonController'
        });
    };

    vm.GoToTraining = function (trainingType) {
        if (trainingType === 'advertiser') {
            trainingType = 2;
        } else if (trainingType === 'solicitor') {
            trainingType = 1;
        }

        var params = {
            overrideTrainingType: trainingType
        };

        AccountsFactory.getContractorUserHISTrainingRedirectURI(params).then(function (response) {
            // console.log(response);
            if (response && response.data && response.data.Data) {
                var data = response.data.Data;
                if (data.RedirectURI) {
                    window.open(data.RedirectURI), '_blank';
                }
            }
        });
    };

    vm.adjustContractorUserHISStatus = function (statusToSwitchTo) {
        var hisStatusType = 1;

        if (statusToSwitchTo === 'advertiser') {
            hisStatusType = 1;
        } else if (statusToSwitchTo === 'solicitor') {
            hisStatusType = 2;
        }

        var params = {
            HISStatusType: hisStatusType
        };

        AccountsFactory.adjustContractorUserHISStatus(params).then(function (response) {
            if (response && response.data) {
                var data = response.data;
                window.location.reload();
            }
        });
    };

    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */

    function getContractorUserHISRequirementsStatus() {
        vm.isLoading = true;
        AccountsFactory.getContractorUserHISRequirementsStatus().then(function (response) {
            // console.log(response);
            var data = void 0;
            if (response && response.data && response.data.Data) {
                data = response.data.Data;
            }

            if (data && data.AdvertiserRequirements) {
                vm.advertiserRequirements_HasTraining = data.AdvertiserRequirements.HasTraining;
                vm.advertiserRequirements_Eligible = data.AdvertiserRequirements.Eligible;
            }
            if (data) {
                vm.isSolicitor = data.IsSolicitor;
                vm.HISLicenseNumber = data.LicenseNumber;
            }
            if (data && data.SolicitorRequirements) {
                vm.solicitorRequirements_HasTraining = data.SolicitorRequirements.HasTraining;
                vm.solicitorRequirements_HasLicenseNumber = data.SolicitorRequirements.HasLicenseNumber;
                vm.solicitorRequirements_Eligible = data.SolicitorRequirements.Eligible;
            }

            if (vm.isSolicitor && !vm.solicitorRequirements_HasTraining || !vm.isSolicitor && !vm.advertiserRequirements_HasTraining) {
                HISWizardFactory.openHISWizardModal(false);
                $state.go('accounts', { accountsPage: 'myprofile', accountId: null });
            }

            vm.isLoading = false;
        });
    }

    function getContractorUser() {
        AccountsFactory.getContractorUser().then(function (response) {
            if (response.data.Data !== undefined || response.data.Data !== null) {
                vm.userProfile = response.data.Data;
                vm.hisComplete = vm.userProfile.Licenses !== null && _lodash2.default.findWhere(vm.userProfile.Licenses, {
                    LicenseTypeId: 1
                }) !== undefined;
            }
        });
    }

    function init() {
        getContractorUserHISRequirementsStatus();
        getContractorUser();
        // getContractorUserTraining();
    }

    // function getContractorUserTraining() {
    //     AccountsFactory.getContractorUserTrainings().then((response) => {
    //         vm.trainings = response.data.Data;
    //         vm.training30Min = _.findWhere(vm.trainings, { PersonIdentityTrainingTypeId: 1 });
    //         vm.training30MinComplete = vm.training30Min !== undefined && vm.training30Min.PersonIdentityTrainingStatusId === 3;
    //         vm.training6Hours = _.findWhere(vm.trainings, { PersonIdentityTrainingTypeId: 2 });
    //         vm.training6HoursComplete = vm.training6Hours !== undefined && vm.training6Hours.PersonIdentityTrainingStatusId === 3;
    //     });
    // }
}

/***/ }),
/* 341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = userTableController;
userTableController.$inject = ['AccountsFactory', '$state', 'ModalService'];
/* @ngInject */
function userTableController(AccountsFactory, $state, ModalService) {
    var vm = this;

    vm.users = [];
    vm.userTableColumns = AccountsFactory.getUserTableColumns();
    vm.pageNumber = 0;
    vm.sortCol = 2;
    vm.sortOrder = 2;
    vm.totalCount = 0;
    vm.loadingUsers = true;

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.switchPage = function (pageNumber) {
        vm.pageNumber = pageNumber - 1;
        getUsers();
    };

    vm.headerClick = function (column) {
        if (column.sort === true) {
            if (column.apiColumnId === vm.sortCol) {
                // Current column that we're sorting by was clicked, change sort order
                vm.sortOrder = vm.sortOrder === 1 ? 2 : 1;
            } else {
                // Sort by a new column
                vm.sortCol = column.apiColumnId;
                vm.sortOrder = 2;
            }
            vm.pageNumber = 0;
            getUsers();
        }
    };

    vm.addUser = function () {
        var modal = ModalService.launchLgModal({
            templateUrl: 'app/accounts/user/addUser/addUser.html',
            windowClass: 'add-user',
            controller: 'AddUserController',
            controllerAs: 'addUser',
            size: 'full-screen'
        });

        modal.result.then(function (result) {
            if (result === true) {
                //				console.log("do we need to do anything here like update the usertable to include the new user?");
                getUsers();
            }
            ModalService.closeLgModal();
        });
    };

    vm.viewUser = function (user) {
        $state.go('accounts', { accountPage: 'users', accountId: user.ContractorUserId });
        AccountsFactory.isEditUser = true;
    };
    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */
    function init() {
        getUsers();
    }

    function getUsers() {
        vm.loadingUsers = true;

        var params = {
            PageNumber: vm.pageNumber,
            PageSize: 20,
            SortCol: vm.sortCol,
            SortOrder: vm.sortOrder
        };

        AccountsFactory.getUsers(params).then(function (response) {
            vm.users = response.data.Data.Users;
            vm.totalCount = response.data.Data.TotalCount;
            vm.loadingUsers = false;
        });
    }
    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = addUserController;

__webpack_require__(344);

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

addUserController.$inject = ['$scope', '$rootScope', '$uibModalInstance', 'AccountsFactory', 'OfficesFactory', 'HPRoles', 'LicensesFactory']; // angular
// 	.module("HeroPRO")
// 	.controller("AddUserController", addUserController);

/* @ngInject */
function addUserController($scope, $rootScope, $uibModalInstance, AccountsFactory, OfficesFactory, HPRoles, LicensesFactory) {
    var vm = this;

    vm.defaultText = 'Choose One';
    vm.contentShown = 'addUserInProgress';
    vm.submitted = 'false';
    vm.hasOneLocation = false;
    vm.disableUI = true;
    vm.saving = false;
    vm.isAddLocationButtonVisible = false;

    vm.user = {
        FirstName: '',
        MiddleInitial: null,
        LastName: '',
        Suffix: null,
        Role: null,
        ContractorLocationIds: []
    };

    vm.contact = {
        Email: '',
        PhoneNumber: '',
        Extension: ''
    };

    vm.defaultLocation = {
        LocationNickname: vm.defaultText,
        ContractorId: -1
    };

    vm.availableOffices = [];

    vm.states = [];

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.closeModal = function () {
        var result = false;

        if (vm.contentShown === 'addUserSuccess') {
            result = true;
        }

        $uibModalInstance.close(result);
    };

    vm.submitNewUser = function () {
        vm.submitted = 'true';
        vm.validateLocationState();
        if (vm.hasLocationState()) {
            vm.validateLocations();
        }

        if (vm.addUserForm.$valid && vm.contact.PhoneNumber !== '' && vm.saving !== true) {
            vm.saving = true;
            var data = {
                FirstName: vm.user.FirstName,
                LastName: vm.user.LastName,
                Email: vm.contact.Email,
                Phone: vm.contact.PhoneNumber,
                PhoneExt: vm.contact.Extension,
                RoleId: vm.user.Role.RoleId,
                CSLBTitleId: vm.user.TitleId,
                CSLBMiddleInitial: vm.user.MiddleInitial,
                CSLBSuffix: vm.user.Suffix,
                ContractorLocationIds: prepLocationsForSave()
            };
            saveNewUser(data);
        }
    };

    vm.addLocation = function () {
        vm.selectedLocations.push({
            selectedState: vm.defaultText,
            selectedLocation: vm.defaultLocation
        });

        displayAddAdditionalLocation();
    };

    vm.stateClicked = function (state, index) {
        var originalState = null,
            originalLocation = null;

        if (vm.selectedLocations[index].selectedState !== vm.defaultText) {
            // (ajt - 8/8/2016) Mark original Location unselected and clear location from selected locations
            originalState = _lodash2.default.find(vm.availableOffices, function (office) {
                return office.State === vm.selectedLocations[index].selectedState;
            });
            originalLocation = _lodash2.default.find(originalState.Locations, function (origLoc) {
                return origLoc.LocationNickname === vm.selectedLocations[index].selectedLocation.LocationNickname;
            });

            if (originalLocation !== undefined) {
                originalLocation.selectedRow = -1;
            }

            vm.selectedLocations[index].selectedLocation = vm.defaultLocation;
        }

        vm.selectedLocations[index].selectedState = state;

        checkIfStateHasLocation(originalState);
    };

    vm.locationClicked = function (location, index) {
        var originalLocation = null;

        // (ajt - 8/8/2016) Find and store the last location
        if (vm.selectedLocations[index].selectedLocation.LocationNickname !== vm.defaultText) {
            originalLocation = vm.selectedLocations[index].selectedLocation;
        }

        vm.selectedLocations[index].selectedLocation = location;

        var selectedState = _lodash2.default.find(vm.availableOffices, function (office) {
            return office.State === vm.selectedLocations[index].selectedState;
        });

        // (ajt - 8/8/2016) Mark new location selected
        var selectedLoc = _lodash2.default.find(selectedState.Locations, function (loc) {
            return loc.LocationNickname === location.LocationNickname;
        });

        selectedLoc.selectedRow = index;

        checkIfStateHasLocation(selectedState);

        // (ajt - 8/8/2016) Check if old location needs to be unselected
        if (originalLocation !== null) {
            selectedState = _lodash2.default.find(vm.availableOffices, function (office) {
                return office.State === originalLocation.State;
            });

            var removedLoc = _lodash2.default.find(selectedState.Locations, function (loc) {
                return loc.LocationNickname === originalLocation.LocationNickname;
            });

            removedLoc.selectedRow = -1;
        }

        displayAddAdditionalLocation();
        vm.validateLocations();
    };

    vm.removeLocation = function (location, index) {
        var originalState = null,
            originalLocation = null;

        // (ajt - 8/8/2016) Unselect previously selected location
        originalState = _lodash2.default.find(vm.availableOffices, function (office) {
            return office.State === vm.selectedLocations[index].selectedState;
        });

        originalLocation = _lodash2.default.find(originalState.Locations, function (origLoc) {
            return origLoc.LocationNickname === vm.selectedLocations[index].selectedLocation.LocationNickname;
        });
        originalLocation.selectedRow = -1;

        checkIfStateHasLocation(originalState);

        vm.selectedLocations = _lodash2.default.without(vm.selectedLocations, _lodash2.default.findWhere(vm.selectedLocations, location));

        displayAddAdditionalLocation();
    };

    // (ajt 5/31/2016) Add validation method to check if a User Role is not selected.
    vm.validateUserRole = function () {
        return vm.user.Role === null || vm.user.Role.Name === 'DEFAULT';
    };

    vm.hasLocationState = function () {
        if (vm.selectedLocations && vm.selectedLocations[0].selectedState !== vm.defaultText) {
            return true;
        }

        return false;
    };

    vm.validateLocationState = function () {
        if (!vm.isAllOfficesDisplayed) {
            if (vm.hasLocationState()) {
                vm.addUserForm.$setValidity('nolocationstate', true);
            } else {
                vm.addUserForm.$setValidity('nolocationstate', false);
            }
        }
    };

    vm.hasLocations = function () {
        if (vm.selectedLocations && vm.selectedLocations[0].selectedLocation.ContractorId !== -1) {
            return true;
        }

        return false;
    };

    vm.validateLocations = function () {
        if (!vm.isAllOfficesDisplayed) {
            if (vm.hasLocations()) {
                vm.addUserForm.$setValidity('nolocation', true);
            } else {
                vm.addUserForm.$setValidity('nolocation', false);
            }
        }
    };

    vm.checkRemainingAvailableLocations = function () {
        var numUnselected = 0;
        _lodash2.default.each(vm.availableOffices, function (office) {
            var unselectedLocations = _lodash2.default.filter(office.Locations, function (loc) {
                return loc.selectedRow === -1;
            });
            numUnselected += unselectedLocations.length;
        });

        return numUnselected > 0;
    };

    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions           =
    ======================================== */
    function init() {
        getOfficeLocations();
        getOrganizationLicense();
    }

    function getOfficeLocations() {
        vm.loadingOffices = true;
        var locations = [],
            states = [];
        OfficesFactory.getOffices().then(function (response) {
            _lodash2.default.each(response.data.Data, function (location) {
                locations.push({
                    ContractorId: location.ContractorId,
                    LocationNickname: location.LocationNickname,
                    State: location.State,
                    selectedRow: -1
                });
            });

            locations = _lodash2.default.sortBy(locations, function (location) {
                return location.LocationNickname.toLowerCase();
            });

            states = _lodash2.default.sortBy(_lodash2.default.pluck(_lodash2.default.uniq(locations, function (location) {
                return location.State;
            }), 'State'));

            _lodash2.default.each(states, function (state) {
                vm.availableOffices.push({
                    State: state.toString(),
                    Locations: _lodash2.default.filter(locations, function (location) {
                        return location.State === state;
                    }),
                    hasLocations: true
                });
            });
            setInitialSelectedLocation();
        });
    }

    function getOrganizationLicense() {
        // Find the california license
        LicensesFactory.getLicenses().then(function (response) {
            var californiaLicense = _lodash2.default.findWhere(response.data.Data.Licenses, { OrganizationLicenseTypeId: 1 });
            if (californiaLicense !== undefined) {
                vm.licenseNumber = californiaLicense.LicenseNumber;
            }
        });
    }

    // (ajt - 8/8/2016) Recheck state to see if locations are available after state change.
    function checkIfStateHasLocation(state) {
        if (state !== undefined && state !== null) {
            var availLocations = _lodash2.default.find(state.Locations, function (loc) {
                return loc.selectedRow === -1;
            });
            if (availLocations === undefined) {
                state.hasLocations = false;
            } else {
                state.hasLocations = true;
            }
        }
    }

    function setInitialSelectedLocation() {
        vm.selectedLocations = [{
            selectedState: vm.defaultText,
            selectedLocation: vm.defaultLocation
        }];
    }

    function toggleDisabledState(role) {
        if (vm.addUserForm !== undefined && vm.addUserForm !== null) {
            vm.addUserForm.$setPristine();
        }
        if (role === null || role.RoleId === -1) {
            vm.disableUI = true;
        } else {
            vm.disableUI = false;
        }
    }

    function displayAllOffices() {
        if (vm.user.Role !== null && vm.user.Role !== undefined && vm.user.Role.RoleId !== undefined && vm.user.Role.RoleId !== null) {
            var companyRole = _lodash2.default.find(HPRoles, function (role) {
                return role.roleId === vm.user.Role.RoleId && role.rank === 1;
            });
            if (companyRole !== undefined && companyRole !== null && !vm.hasOneLocation) {
                vm.isAllOfficesDisplayed = true;
                vm.addUserForm.$setValidity('nolocation', true);
            } else {
                vm.isAllOfficesDisplayed = false;
            }
        }
    }

    function prepLocationsForSave() {
        var currentSelectedLocations = [];

        if (vm.isAllOfficesDisplayed) {
            currentSelectedLocations.push(vm.availableOffices[0].Locations[0].ContractorId);
        } else {
            _lodash2.default.each(vm.selectedLocations, function (location) {
                if (location.selectedLocation.ContractorId !== undefined && location.selectedLocation.ContractorId !== null && location.selectedLocation.ContractorId !== -1) {
                    currentSelectedLocations.push(location.selectedLocation.ContractorId);
                }
            });
        }
        return currentSelectedLocations;
    }

    function saveNewUser(data) {
        AccountsFactory.addUser(data).then(function (response) {
            vm.saving = false;
            if ((response.data !== null || response.data !== undefined) && response.data.ResultCode === 2) {
                $rootScope.$broadcast('EmailInUse');
            } else if (response.data === null || response.data === undefined || response.data.ResultCode === 1) {
                vm.successText = vm.user.FirstName + ' ' + vm.user.LastName + ' has been created successfully.';
                vm.secondaryText = vm.user.FirstName + ' will get an email from us to finish their account setup.';
                vm.contentShown = 'addUserSuccess';

                // ProTip
            }
        });
    }

    function displayAddAdditionalLocation() {
        if (vm.selectedLocations.length > 1) {
            vm.isAddLocationButtonVisible = vm.selectedLocations[vm.selectedLocations.length - 1].selectedLocation.ContractorId !== -1 && !vm.isAllOfficesDisplayed && !vm.hasOneLocation;
        } else {
            vm.isAddLocationButtonVisible = vm.selectedLocations[0].selectedLocation.ContractorId !== -1 && !vm.isAllOfficesDisplayed && !vm.hasOneLocation;
        }
    }

    $scope.$watch(function () {
        return vm.user.Role;
    }, function (val) {
        displayAllOffices();
        toggleDisabledState(val);
        vm.submitted = 'false';
    });
    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = deleteUserController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(346);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

deleteUserController.$inject = ['$uibModalInstance', 'selectedUser', 'AccountsFactory']; // angular
// 	.module("HeroPRO")
// 	.controller("DeleteUserController", deleteUserController);

/* @ngInject */
function deleteUserController($uibModalInstance, selectedUser, AccountsFactory) {
    var vm = this;
    vm.selectedUser = selectedUser;
    vm.jobLocations = null;
    vm.usersByLocation = [];
    vm.blockDisableButtonClick = true;
    vm.selectedUserHasJobs = null;
    vm.contractorJobLocationsReturned = false;
    vm.contentShown = 'deleteInProgress';
    vm.successData = [];
    vm.disableDeleteButton = true;

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.closeModal = function () {
        var result = false;

        if (vm.contentShown === 'deleteSuccess') {
            result = true;
        }

        $uibModalInstance.close(result);
    };

    vm.transferToUser = function (location, newUser) {
        var tempLocation = _lodash2.default.find(vm.usersByLocation, function (locationObject) {
            return location.ContractorId === locationObject.ContractorId;
        });

        tempLocation.newContractorUser = newUser;
        setDeleteButtonStatus();
    };

    vm.reassignJobsAndDeleteUser = function () {
        var newSalesReps = [];

        _lodash2.default.each(vm.usersByLocation, function (location) {
            newSalesReps.push({
                ContractorLocationId: location.ContractorId,
                ContractorUserId: location.newContractorUser.ContractorUserId
            });

            vm.successData.push([location.nickname, location.newContractorUser.FirstName + ' ' + location.newContractorUser.LastName]);
        });

        AccountsFactory.reassignJobsAndDeleteUser({
            ContractorUserId: vm.selectedUser.ContractorUserId,
            NewSalesRepAndLocation: newSalesReps
        }).then(function () {
            vm.contentShown = 'deleteSuccess';
        });
    };
    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions           =
    ======================================== */
    function init() {
        AccountsFactory.getContractorJobLocations({
            ContractorUserId: vm.selectedUser.ContractorUserId
        }).then(function (response) {
            vm.contractorJobLocationsReturned = true;

            var responseData = response.data.Data;

            if (_locationsAreAvailable(responseData.Locations)) {
                vm.selectedUserHasJobs = true;
                vm.jobLocations = responseData.Locations;

                AccountsFactory.getContractorUsersByLocation({
                    ContractorLocationIds: _lodash2.default.pluck(vm.jobLocations, 'ContractorId')
                }).then(function (response) {
                    processUsersByLocation(response.data.Data);
                    setDeleteButtonStatus();
                });
            } else {
                vm.selectedUserHasJobs = false;
                setDeleteButtonStatus();
            }
        });
    }

    function processUsersByLocation(data) {
        var tempLocations = [];
        _lodash2.default.each(vm.jobLocations, function (location) {
            tempLocations[location.ContractorId] = {
                nickname: location.Nickname
            };
        });

        vm.usersByLocation = _lodash2.default.each(data, function (location) {
            location.nickname = tempLocations[location.ContractorId].nickname;
            location.newContractorUser = null;

            // Remove the currentUser from the list of users from each location
            location.Users = _lodash2.default.filter(location.Users, function (user) {
                return user.ContractorUserId !== vm.selectedUser.ContractorUserId;
            });
        });
    }

    function setDeleteButtonStatus() {
        vm.disableDeleteButton = _lodash2.default.some(vm.usersByLocation, function (location) {
            return location.newContractorUser === null;
        }) && vm.selectedUserHasJobs === true;
    }

    var _locationsAreAvailable = function _locationsAreAvailable(locations) {
        return !!locations && locations.length > 0;
    };
    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = contractorUserLicenseRegistrationController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(348);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

contractorUserLicenseRegistrationController.$inject = ['$uibModalInstance', 'selectedUser', 'AccountsFactory']; // angular
// 	.module("HeroPRO")
// 	.controller("ContractorUserLicenseRegistrationController", contractorUserLicenseRegistrationController);

/* @ngInject */
function contractorUserLicenseRegistrationController($uibModalInstance, selectedUser, AccountsFactory) {
    var vm = this;

    vm.contractorUserLicense;
    vm.confirmCheckBoxValue;
    vm.showCheckSpinner;
    vm.showAddSpinner;
    vm.contractorUserLicenseResponse;
    vm.contractorUserLicenseResponseValid;
    vm.validateContractorUserLicenseClicked;
    vm.contractorUserLicenseErrorMessage;

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.closeModal = function () {
        $uibModalInstance.close();
    };

    vm.validateContractorUserLicense = function () {
        vm.validateContractorUserLicenseClicked = true;
        if (vm.contractorUserLicenseRegistrationForm.$valid) {
            vm.showCheckSpinner = true;
            AccountsFactory.validateContractorUserLicenseLicense({ "LicenseNumber": vm.contractorUserLicense, "PersonIdentityLicenseTypeId": 1 }).then(function (response) {
                vm.contractorUserLicenseResponse = response.data.Data;
                vm.contractorUserLicenseResponseValid = vm.contractorUserLicenseResponse.Status === 1;
                switch (vm.contractorUserLicenseResponse.Status) {
                    case 1:
                        break;
                    case 3:
                        vm.contractorUserLicenseErrorMessage = ': Already registered'; // Duplicate license
                        break;
                    case 4:
                        vm.contractorUserLicenseErrorMessage = ': Expired';
                        break;
                    default:
                        vm.contractorUserLicenseErrorMessage = vm.contractorUserLicenseResponse.Metadata !== undefined ? ': ' + vm.contractorUserLicenseResponse.Metadata.Status : ': Not found';
                        break;
                }

                vm.showCheckSpinner = false;
            });
        }
    };

    vm.addContractorUserLicense = function () {
        if (vm.isFormValid) {
            var license = {
                LicenseTypeId: 1,
                LicenseNumber: vm.contractorUserLicense,
                ExpireDate: vm.contractorUserLicenseResponse.Metadata.ExpireDate,
                IssueDate: vm.contractorUserLicenseResponse.Metadata.IssueDate,
                Status: vm.contractorUserLicenseResponse.Metadata.Status
            };
            if (selectedUser !== undefined) {
                vm.showAddSpinner = true;
                var licenses = new Array();
                licenses.push(license);
                var user = {
                    ContractorUserId: selectedUser.ContractorUserId,
                    Email: selectedUser.Email,
                    PhoneNumber: selectedUser.Phone,
                    Extension: selectedUser.PhoneExt === undefined ? null : selectedUser.PhoneExt,
                    MobilePhone: selectedUser.MobilePhone === undefined ? null : selectedUser.MobilePhone,
                    RoleId: selectedUser.Roles[0].RoleId,
                    Licenses: licenses
                };
                AccountsFactory.updateContractorUser(user).then(function (userResponse) {
                    $uibModalInstance.close(userResponse.data.Data);
                });
            } else {
                $uibModalInstance.close(license);
            }
        }
    };

    vm.confirmCheckBoxClicked = function () {
        vm.confirmCheckBoxValue = !vm.confirmCheckBoxValue;
    };

    vm.isFormValid = function () {
        return vm.contractorUserLicenseRegistrationForm.$valid && vm.contractorUserLicenseResponseValid && vm.confirmCheckBoxValue;
    };

    vm.clearContractorUserLicenseData = function () {
        clearContractorUserLicenseData();
    };

    /*= =======================================
    =            Private Functions           =
    ======================================== */

    function init() {
        vm.confirmCheckBoxValue = false;
        vm.showCheckSpinner = false;
        vm.showAddSpinner = false;
        vm.contractorUserLicenseResponse = null;
        vm.contractorUserLicenseResponseValid = false;
        vm.validateContractorUserLicenseClicked = false;
        vm.contractorUserLicenseErrorMessage = undefined;
    }

    function clearContractorUserLicenseData() {
        vm.confirmCheckBoxValue = false;
        vm.showCheckSpinner = false;
        vm.showAddSpinner = false;
        vm.contractorUserLicenseResponse = null;
        vm.contractorUserLicenseResponseValid = false;
        vm.contractorUserLicenseErrorMessage = undefined;
    }

    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = addOfficeAssignmentController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(350);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

addOfficeAssignmentController.$inject = ['$uibModalInstance', 'AccountsFactory', 'currentUserProfile', 'signedInUserId']; // angular
//   .module('HeroPRO')
//   .controller('AddOfficeAssignmentController', addOfficeAssignmentController);

/* @ngInject */
function addOfficeAssignmentController($uibModalInstance, AccountsFactory, currentUserProfile, signedInUserId) {
    var vm = this;
    vm.contentShown = 'addOfficeAssignmentInProgress';
    vm.currentUser = currentUserProfile;
    vm.signedInUserLocations = null;
    vm.locationToAdd = null;

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.closeModal = function () {
        if (vm.contentShown === 'addOfficeAssignmentSuccess') {
            $uibModalInstance.close(vm.locationToAdd);
        } else {
            $uibModalInstance.close();
        }
    };

    vm.setNewLocation = function (location) {
        vm.locationToAdd = location;
    };

    vm.addOfficeToUser = function () {
        AccountsFactory.addOfficeToUser({
            ContractorUserId: vm.currentUser.ContractorUserId,
            ContractorLocationId: vm.locationToAdd.ContractorId
        }).then(function () {
            vm.contentShown = 'addOfficeAssignmentSuccess';
        });
    };
    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions           =
    ======================================== */
    function init() {
        AccountsFactory.getContractorUser(signedInUserId).then(function (response) {
            if (vm.currentUser.Locations === undefined || vm.currentUser.Locations.length === 0) {
                vm.signedInUserLocations = response.data.Data.Locations;
            } else {
                // Filter out the locations that the current user already has
                vm.signedInUserLocations = _lodash2.default.reject(response.data.Data.Locations, function (possibleLocation) {
                    return _lodash2.default.some(vm.currentUser.Locations, function (currentLocation) {
                        return possibleLocation.ContractorId === currentLocation.ContractorId;
                    });
                });
            }
        });
    }
    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = removeofficeAssignmentController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(352);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

removeofficeAssignmentController.$inject = ['$uibModalInstance', 'selectedOffice', 'contractorUserId', 'JobFactory', 'AccountsFactory']; // angular
// 	.module("HeroPRO")
// 	.controller("RemoveOfficeAssignmentController", removeofficeAssignmentController);


/* @ngInject */
function removeofficeAssignmentController($uibModalInstance, selectedOffice, contractorUserId, JobFactory, AccountsFactory) {
    var vm = this;
    vm.contentShown = 'reassignJobs';
    vm.selectedOffice = selectedOffice;
    vm.newUser = null;
    vm.successData = [];

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.closeModal = function () {
        var result = false;

        if (vm.contentShown === 'reassignSuccess') {
            result = true;
        }

        $uibModalInstance.close(result);
    };

    vm.transferToUser = function (user) {
        vm.newUser = user;
        vm.successData.push([vm.newUser.FirstName + ' ' + vm.newUser.LastName, vm.selectedOffice.LocationNickname]);
    };

    vm.reassignJobsAndRemoveOffice = function () {
        AccountsFactory.reassignJobsAndRemoveOffice(vm.selectedOffice, vm.currentUser, vm.newUser).then(function () {
            vm.contentShown = 'reassignSuccess';
        });
    };
    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions           =
    ======================================== */
    function init() {
        getCurrentUser();
    }

    function getCurrentUser() {
        AccountsFactory.getContractorUser(contractorUserId).then(function (response) {
            vm.currentUser = response.data.Data;
            getAvailableUsers();
        });
    }

    function getAvailableUsers() {
        JobFactory.getSalesReps(vm.selectedOffice.ContractorId).then(function (result) {
            var users = result.data.Data;
            vm.selectedOffice.users = _lodash2.default.filter(users, function (user) {
                return user.ContractorUserId !== vm.currentUser.ContractorUserId;
            });
        });
    }
    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ParticipantVsCertifiedProfessionalComparisonController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(354);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

ParticipantVsCertifiedProfessionalComparisonController.$inject = ['$uibModalInstance']; // angular
// 	.module("HeroPRO")
// 	.controller("ParticipantVsCertifiedProfessionalComparisonController", ParticipantVsCertifiedProfessionalComparisonController);

/* @ngInject */
function ParticipantVsCertifiedProfessionalComparisonController($uibModalInstance) {
    var vm = this;

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.closeModal = function () {
        $uibModalInstance.close();
    };

    /*= =======================================
    =            Private Functions           =
    ======================================== */

    function init() {}

    init();

    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = rolesSelector;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(356);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

rolesSelector.$inject = ['AccountsFactory', 'UserData', 'HPRoles']; // angular
// 	.module("HeroPRO")
// 	.directive('hpRolesSelector', rolesSelector);

/* @ngInject */
function rolesSelector(AccountsFactory, UserData, HPRoles) {
    var rolesSelectorController = function rolesSelectorController() {
        var vm = this;

        vm.defaultRole = {
            DisplayName: 'Choose Account Permission',
            DisplayDescription: '',
            Name: 'DEFAULT',
            RoleId: -1
        };

        vm.roles = [];
        vm.selectedRole = {};

        // CSLB variables
        vm.cslbShowCheckBox = false;
        vm.cslbCheckBoxValue = false;
        vm.cslbshowError = false;
        vm.cslbSelectedQualifier = null;
        vm.cslbQualifiers = null;

        _lodash2.default.delay(function () {
            init();
        });

        /*= =======================================
        =            Public Functions            =
        ======================================== */

        vm.roleClicked = function (role) {
            vm.selectedRole = role;
            vm.role = role;
            displayCSLBCheckBox(vm.role);
        };

        vm.cslbCheckBoxClicked = function () {
            cslbCheckBoxClicked();
        };

        vm.cslbQualifierClicked = function (qualifier) {
            cslbQualifierClicked(qualifier);
        };

        /* -----  End of Public Functions  ------*/

        /*= =======================================
        =            Private Functions            =
        ======================================== */
        function init() {
            //			console.log("HPRoleSelector Init");
            getUser();
            setInitialUserData();
            displayCSLBCheckBox(vm.role);
            if (vm.user.IsCSLBHolder === true) {
                cslbCheckBoxClicked();
            }
        }

        function getUser() {
            UserData.getUserData().then(function (response) {
                vm.currentUser = response;
                getRoles();
            });
        }

        function getRoles() {
            AccountsFactory.getUserRoles().then(function (response) {
                var roles = response.data.Data;
                buildRoleList(roles);
            });
        }

        function buildRoleList(roles) {
            // TODO: (ajt 2/25/2016) Modify to handle hierarchy sorting
            var roleList = _lodash2.default.sortBy(roles, 'DisplayOrder');
            var roleIndex = -1;
            _lodash2.default.each(roleList, function (role, idx) {
                if (role.Name === vm.currentUser.Roles[0]) {
                    roleIndex = idx;
                }
            });
            vm.roles = roleList.slice(roleIndex);
            if (vm.role === undefined || vm.role === null) {
                if (_lodash2.default.findWhere(vm.roles, { RoleId: -1 }) === undefined) {
                    vm.roles.unshift(vm.defaultRole);
                }
                vm.selectedRole = vm.roles[0];
            } else {
                vm.selectedRole = _lodash2.default.find(vm.roles, function (role) {
                    return role.Name === vm.role.Name;
                });
            }
        }

        function displayCSLBCheckBox(role) {
            // Show CSLB checkbox only for California and Company Admins
            if (role !== null && vm.licenseNumber !== null && vm.licenseNumber !== undefined) {
                if (role.Name === HPRoles.COPO_COMPANY_ADMIN.Name) {
                    vm.cslbShowCheckBox = true;
                } else {
                    // Clear all CSLB variables
                    vm.cslbShowCheckBox = false;
                    vm.cslbCheckBoxValue = false;
                    vm.cslbshowError = false;
                    vm.cslbSelectedQualifier = null;
                }
            }
        }

        function cslbCheckBoxClicked() {
            vm.cslbCheckBoxValue = !vm.cslbCheckBoxValue;

            if (vm.cslbCheckBoxValue === true) {
                var data = { LicenseNumber: vm.licenseNumber };
                if (vm.filterLastName === 'true') {
                    data.OfficerLastName = vm.user.LastName;
                }
                AccountsFactory.getCSLBLicenseHolders(data).then(function (response) {
                    if (response.data.Data.Personel && response.data.Data.Personel.length > 0) {
                        vm.cslbQualifiers = response.data.Data.Personel;
                        _lodash2.default.forEach(vm.cslbQualifiers, function (qualifier) {
                            qualifier.MiddleInitial = qualifier.MiddleName.substring(0, 1);
                        });
                        vm.cslbShowError = false;
                        if (vm.filterLastName === 'true') {
                            var qualifier = _lodash2.default.find(vm.cslbQualifiers, function (q) {
                                var found = vm.user.FirstName === q.FirstName && vm.user.LastName === q.LastName && vm.user.TitleId === q.TitleId;
                                if (vm.user.MiddleInitial !== undefined && vm.user.MiddleInitial !== null && vm.user.MiddleInitial !== '') {
                                    found = found && vm.user.MiddleInitial === q.MiddleInitial;
                                }
                                if (vm.user.Suffix !== undefined && vm.user.Suffix !== null && vm.user.Suffix !== '') {
                                    found = found && vm.user.Suffix === q.Suffix;
                                }
                                return found;
                            });
                            cslbQualifierClicked(qualifier);
                        }
                    } else {
                        vm.cslbShowError = true;
                    }
                });
            } else {
                vm.cslbSelectedQualifier = null;
                resetUserData();
            }
        }

        function resetUserData() {
            vm.user.FirstName = vm.initialUserData.FirstName;
            vm.user.LastName = vm.initialUserData.LastName;
            vm.user.MiddleInitial = vm.initialUserData.MiddleInitial;
            vm.user.Suffix = vm.initialUserData.Suffix;
            vm.user.TitleId = vm.initialUserData.TitleId;
            vm.user.licenseHolderSelected = false;
        }

        function setInitialUserData() {
            vm.initialUserData = {
                FirstName: vm.user.FirstName,
                LastName: vm.user.LastName,
                MiddleInitial: vm.user.MiddleInitial,
                Suffix: vm.user.Suffix,
                TitleId: vm.user.TitleId
            };
        }

        function cslbQualifierClicked(qualifier) {
            if (qualifier !== undefined && qualifier !== null) {
                vm.cslbSelectedQualifier = qualifier;
                vm.user.FirstName = qualifier.FirstName;
                vm.user.LastName = qualifier.LastName;
                vm.user.MiddleInitial = qualifier.MiddleInitial;
                vm.user.Suffix = qualifier.Suffix;
                vm.user.TitleId = qualifier.TitleId;
                vm.user.licenseHolderSelected = true;
            }
        }
    };

    return {
        replace: true,
        restrict: 'E',
        scope: {
            user: '=',
            role: '=',
            submitted: '=',
            licenseNumber: '=',
            hideSelector: '@',
            filterLastName: '@',
            required: '='
        },
        require: '^form',
        templateUrl: 'app/accounts/user/personalInformation/roles/rolesSelector.html',
        controller: rolesSelectorController,
        controllerAs: 'rolesSelector',
        bindToController: true
    };
}

/***/ }),
/* 356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 357 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"row message-container user-enable-disable-message\"\n         ng-class=\"{ 'success': (user.enableDisableStatus === 1 || user.enableDisableStatus === 2) }\"\n         ng-show=\"user.enableUserComplete === false && user.enableDisableMessage !== ''\">\n        <div class=\"col-md-12\">\n            <p>{{user.enableDisableMessage}}</p>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 358 */
/***/ (function(module, exports) {

module.exports = "<div class=\"personal-information-container\" ng-class=\"{ 'disabled-user': user.userProfile.isEnabled === false}\">\n    <div class=\"row personal-information-header-container\">\n        <div class=\"col-md-6\">\n            <h2>Personal Information</h2>\n        </div>\n        <div class=\"col-md-6\">\n            <div class=\"pull-right personal-information-btn-container\">\n                <button ng-if=\"user.isEditUser\" class=\"btn btn-default\" id=\"btn-personal-info-delete\" ng-click=\"user.deleteUser()\">Delete User</button>\n                <button ng-if=\"user.isEditUser\" id=\"btn-personal-info-enable-disable\" ng-click=\"user.userProfile.isEnabled === true ? user.disableUser() : user.enableUser()\" class=\"btn btn-default\" hp-dynamic-text-button=\"Disable\" hp-spinner-button-texts=\"['Enable User', 'Enabling ...', 'Disable User', 'Disabling ...']\" hp-spinner-button-status=\"user.enableDisableStatus\" hp-spinner-button-styles=\"false\">\n                </button>\n                <button class=\"btn btn-default\" id=\"btn-personal-info-submit\" ng-click=\"user.editPersonalinformation()\" ng-if=\"user.userProfile.isEnabled === true\">Edit</button>\n            </div>\n        </div>\n    </div>\n    <div class=\"row message-container\" ng-class=\"{ 'success': (user.isPersonalInfoError === false ), 'error': (user.isPersonalInfoError === true) }\" ng-show=\"user.personalInfoStatusMessage !== ''\">\n        <div class=\"col-md-12\">\n            <p ng-bind=\"user.personalInfoStatusMessage\"></p>\n        </div>\n    </div>\n    <div class=\"row personal-information-contact-info-container\">\n        <div class=\"col-md-6\">\n            <p class=\"personal-information-name\">\n                {{user.userProfile.FirstName}} {{user.userProfile.CSLBPersonnelMI ? user.userProfile.CSLBPersonnelMI + \". \" : \"\"}} {{user.userProfile.LastName}} {{user.userProfile.CSLBPersonnelSuffix}}\n            </p>\n            <p class=\"personal-information-email\" ng-bind=\"user.userProfile.Email\"></p>\n            <p class=\"personal-information-phone\">\n                <span ng-bind=\"user.userProfile.Phone | tel\"></span>\n                <span class=\"personal-information-phone-ext\" ng-if=\"user.userProfile.PhoneExt !== null && user.userProfile.PhoneExt !== undefined && user.userProfile.PhoneExt !== ''\" ng-bind=\"'Ext. ' + user.userProfile.PhoneExt\"></span>\n            </p>\n            <p class=\"personal-information-phone\" ng-if=\"user.userProfile.MobilePhone\">\n                <label>Mobile Phone:</label><br />\n                <span ng-bind=\"user.userProfile.MobilePhone | tel\"></span>\n            </p>\n        </div>\n        <div class=\"col-md-6\">\n            <p class=\"personal-information-role\" ng-bind=\"user.userProfile.Roles[0].DisplayName\"></p>\n            <p class=\"personal-information-role-description\" ng-bind=\"user.userProfile.Roles[0].DisplayDescription\"></p>\n\n            <div class=\"cslb-badge\" ng-if=\"user.userProfile.IsCSLBHolder === true\">\n                <div class=\"cslb-badge-inner\">\n                    <span>CSLB Qualifier</span>\n                </div>\n            </div>\n\n            <!-- Contractor User License section (HIS) -->\n            <div class=\"personal-information-contractor-user-license\" ng-if=\"false && user.showContractorUserLicense() === true\">\n                <h5>Home Improvement Salesperson (HIS) Registration</h5>\n                <p class=\"contractor-user-license-incomplete\" ng-if=\"!user.userProfile.Licenses\">\n                    Incomplete.\n                    <!-- <span class=\"link add-product-popover\" hp-popover popover-placement=\"bottom\" popover-trigger=\"outsideClick\" uib-popover-template=\"'app/accounts/user/personalInformation/contractorUserLicenseRegistration/contractorUserLicense-popover-template.html'\">\n            Learn more\n          </span> -->\n                </p>\n                <p class=\"contractor-user-license-number\" ng-repeat=\"license in user.userProfile.Licenses\">\n                    <span class=\"icon icon-todo\"></span> HIS number: {{license.LicenseNumber}}-SP\n                    <span class=\"text-error\" ng-if=\"license.Status !== 'Active' && !license.IsExpired\">({{license.Status}})</span>\n                    <span class=\"text-error\" ng-if=\"license.IsExpired\">(Expired)</span>\n                </p>\n            </div>\n\n        </div>\n    </div>\n</div>";

/***/ }),
/* 359 */
/***/ (function(module, exports) {

module.exports = "<div class=\"personal-information-container\">\n    <div class=\"row personal-information-header-container\">\n        <div class=\"col-md-12\">\n            <h2>Personal Information</h2>\n        </div>\n    </div>\n    <div class=\"row message-container\" ng-class=\"{ 'success': (user.isPersonalInfoError === false ), 'error': (user.isPersonalInfoError === true) }\" ng-show=\"user.personalInfoStatusMessage !== ''\">\n        <div class=\"col-md-12\">\n            <p ng-bind=\"user.personalInfoStatusMessage\"></p>\n        </div>\n    </div>\n    <form id=\"edit-personal-information-form\" name=\"user.editPersonalInfoForm\" class=\"edit-personal-info-form\" ng-submit=\"user.savePersonalinformation(user.editPersonalInfoForm.$valid)\" novalidate>\n        <div class=\"personal-information-edit-container\">\n            <div class=\"row personal-information-edit-full-name\">\n                <div class=\"col-md-6\">\n                    <div class=\"contact-info-container\">\n                        <div class=\"row contact-info-field-container\">\n                            <div class=\"col-md-12\">\n                                <input type=\"text\" ng-model=\"user.user.FirstName\" disabled=\"disabled\" />\n                                <input class=\"pull-right\" type=\"text\" ng-model=\"user.user.MiddleInitial\" disabled=\"disabled\" />\n                            </div>\n                        </div>\n                        <div class=\"row contact-info-field-container\">\n                            <div class=\"col-md-12\">\n                                <input type=\"text\" ng-model=\"user.user.LastName\" disabled=\"disabled\" />\n                                <input class=\"pull-right\" type=\"text\" ng-model=\"user.user.Suffix\" disabled=\"disabled\" />\n                            </div>\n                        </div>\n                    </div>\n                    <hp-contact-info class=\"edit-contact-info-container\" contact=\"user.user\" required=\"true\" submitted=\"user.submitted\" show-mobile-phone=\"true\" editor=\"true\"></hp-contact-info>\n                </div>\n                <div class=\"col-md-6 edit-roles-container\">\n                    <hp-roles-selector required=\"true\" user=\"user.user\" role=\"user.role\" license-number=\"user.licenseNumber\" filter-last-name=\"true\" hide-selector=\"{{user.isProfileView || user.isLoggedInUserSalesRep}}\"> </hp-roles-selector>\n\n                    <!-- Contractor User License section (HIS) -->\n                    <div class=\"personal-information-contractor-user-license\" ng-if=\"false && user.showContractorUserLicense() === true\">\n                        <h5>Home Improvement Salesperson (HIS) Registration</h5>\n                        <p class=\"contractor-user-license-incomplete\" ng-if=\"user.user.Licenses.length === 0 && user.canEditContractorUserLicense() === true\">\n                            Enter your HIS number\n                            <!-- Enter your HIS number to access full sales features -->\n                            <!-- <span class=\"link add-product-popover\" hp-popover popover-placement=\"bottom\" popover-trigger=\"outsideClick\" uib-popover-template=\"'app/accounts/user/personalInformation/contractorUserLicenseRegistration/contractorUserLicense-popover-template.html'\">\n                Learn more\n              </span> -->\n                            <button type=\"button\" class=\"btn btn-default\" ng-click=\"user.openContractorUserLicenseRegistrationModal()\">Enter Number</button>\n                        </p>\n                        <p class=\"contractor-user-license-incomplete\" ng-if=\"!user.userProfile.Licenses && user.canEditContractorUserLicense() === false\">\n                            Incomplete.\n                            <!-- <span class=\"link add-product-popover\" hp-popover popover-placement=\"bottom\" popover-trigger=\"outsideClick\" uib-popover-template=\"'app/accounts/user/personalInformation/contractorUserLicenseRegistration/contractorUserLicense-popover-template.html'\">\n                        Learn more\n                      </span> -->\n                        </p>\n                        <p class=\"contractor-user-license-number\" ng-repeat=\"license in user.user.Licenses\">\n                            <span class=\"icon icon-todo\"></span> HIS number: {{license.LicenseNumber}}-SP <span class=\"text-error\" ng-if=\"license.Status !== 'Active'\">({{license.Status}})</span>\n                        </p>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-6\">\n                    <div class=\"personal-information-edit-button-container\">\n                        <div class=\"pull-left\">\n                            <button class=\"btn btn-primary\" id=\"btn-personal-info-save\">Save\n                            </button>\n                        </div>\n                        <div class=\"edit-personal-information-cancel-container pull-left\">\n                            <button class=\"btn btn-default\" id=\"btn-personal-info-cancel\" ng-click=\"user.cancelEditPersonalinformation()\">Cancel\n                            </button>\n                        </div>\n\n                    </div>\n                </div>\n                <div class=\"col-md-6\">\n\n                </div>\n            </div>\n        </div>\n    </form>\n</div>";

/***/ }),
/* 360 */
/***/ (function(module, exports) {

module.exports = "<div class=\"profile-password-container\" ng-class=\"{ 'disabled-user': user.userProfile.isEnabled === false}\">\n    <div class=\"row profile-password-header-container\">\n        <div class=\"col-md-6\">\n            <h2>Password</h2>\n        </div>\n        <div class=\"col-md-6\">\n            <button class=\"btn btn-default pull-right\" id=\"btn-password-submit\" ng-click=\"user.changePassword()\" ng-if=\"!user.changePasswordMode && !user.isEditUser\">Edit</button>\n        </div>\n    </div>\n    <div class=\"row message-container\" ng-class=\"{ 'success': user.passwordStatusMessage !== '' }\" ng-show=\"user.isPasswordMessageDisplayed\">\n        <div class=\"col-md-12\" >\n            <p ng-bind=\"user.passwordStatusMessage\"></p>\n        </div>\n    </div>\n    <div class=\"row profile-password-value-container\" ng-class=\"{'profile-password-edit-mode' : user.changePasswordMode}\">\n        <div class=\"col-md-6\">\n            <p class=\"profile-password-mask\" ng-if=\"!user.changePasswordMode\">\n                *********\n            </p>\n            <ng-include src=\"'app/common/controls/changePassword/changePassword.html'\" ng-if=\"user.changePasswordMode\"></ng-include>\n        </div>\n        <div class=\"col-md-6 profile-forgot-password-link-container\">\n            <span class=\"link pull-right\" id=\"ancForgotPassword\" ng-click=\"user.requestPassword()\" ng-if=\"user.userProfile.isEnabled === true\">Forgot Current Password</span>\n        </div>\n    </div>\n\n</div>\n";

/***/ }),
/* 361 */
/***/ (function(module, exports) {

module.exports = "<div class=\"preferences-container\" ng-class=\"{ 'disabled-user': user.userProfile.isEnabled === false}\">\n    <div class=\"row preferences-header-container\">\n        <div class=\"col-md-6\">\n            <h2>Notification Preferences</h2>\n        </div>\n        <div class=\"col-md-6\">\n            <button class=\"btn btn-default pull-right\" id=\"btn-prefrences-submit\" ng-click=\"user.changePreferences()\" ng-if=\"!user.changePreferencesMode && !user.isEditUser\">Edit</button>\n        </div>\n    </div>\n    <div class=\"row message-container\" ng-class=\"{ 'success': (user.isPreferencesError === false ), 'error': (user.isPreferencesError === true) }\" ng-show=\"user.preferencesStatusMessage !== ''\">\n        <div class=\"col-md-12\">\n            <p ng-bind=\"user.preferencesStatusMessage\"></p>\n        </div>\n    </div>\n    <div class=\"row preferences-value-container\" ng-class=\"{'preferences-edit-mode' : user.changePreferencesMode}\">\n        <div class=\"col-md-12\">\n            <p class=\"preferences-message\">\n                When there is new activity on one or more of my accounts, the Program should:\n            </p>\n            <div class=\"preferences-checkbox-container\">\n                <span class=\"icon icon-complete\" ng-if=\"user.userProfile.ContactByEmail === true\"></span>\n                <span class=\"empty-checkbox\" ng-if=\"user.userProfile.ContactByEmail === false\"></span>\n                <label>Email: Send an Email</label>        \n            </div>\n        </div>\n    </div>\n\n</div>\n";

/***/ }),
/* 362 */
/***/ (function(module, exports) {

module.exports = "<div class=\"preferences-container\" ng-class=\"{ 'disabled-user': user.userProfile.isEnabled === false}\">\n    <div class=\"row preferences-header-container\">\n        <div class=\"col-md-6\">\n            <h2>Notification Preferences</h2>\n        </div>\n        <div class=\"col-md-6\">\n            <button class=\"btn btn-default pull-right\" id=\"btn-prefrences-submit\" ng-click=\"user.changePreferences()\" ng-if=\"!user.changePreferencesMode && !user.isEditUser\">Edit</button>\n        </div>\n    </div>\n    <div class=\"row message-container\" ng-class=\"{ 'success': (user.isPreferencesError === false ), 'error': (user.isPreferencesError === true) }\" ng-show=\"user.preferencesStatusMessage !== ''\">\n        <div class=\"col-md-12\">\n            <p ng-bind=\"user.preferencesStatusMessage\"></p>\n        </div>\n    </div>\n    <form id=\"edit-preferences-form\" name=\"user.editPreferencesForm\" class=\"edit-preferences-form\"\n          ng-submit=\"user.updateContactPreferences(user.userPreferences)\" >\n        <div class=\"row preferences-edit-container\" ng-class=\"{'preferences-edit-mode' : user.changePreferencesMode}\">\n            <div class=\"col-md-12\">\n                <p class=\"preferences-message\">\n                    When there is new activity on one or more of my accounts, the Program should:\n                </p>\n                <div class=\"preferences-checkbox-container\" name=\"preferencesEmail\" ng-click=\"user.userPreferences.ContactByEmail = !user.userPreferences.ContactByEmail\">\n                    <span class=\"icon icon-complete\" ng-if=\"user.userPreferences.ContactByEmail === true\"></span>\n                    <span class=\"empty-checkbox\" ng-if=\"user.userPreferences.ContactByEmail === false\"></span>\n                    <label>Email: Send an Email</label>        \n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-12\">\n                    <div class=\"preferences-edit-button-container\">\n                        <div class=\"pull-left\">\n                            <button class=\"btn btn-primary\" id=\"btn-preferences-save\">Save</button>\n                        </div>\n                        <div class=\"edit-preferences-cancel-container pull-left\">\n                            <button class=\"btn btn-default\" id=\"btn-preferences-cancel\" ng-click=\"user.cancelChangePreferences()\">Cancel</button>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </form>\n\n</div>\n";

/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports = "<div class=\"associated-offices-container\" ng-class=\"{ 'disabled-user': user.userProfile.isEnabled === false}\">\n    <div class=\"row associated-offices-header-container\">\n        <div class=\"col-md-6\">\n            <h2 ng-bind=\"user.officesSubheader\"></h2>\n        </div>\n        <div class=\"col-md-6\">\n            <button class=\"btn btn-default pull-right\" ng-click=\"user.addOfficeAssignment()\" ng-if=\"user.isLoggedInUserSalesRep === false && user.isCompanyLevelUser === false\">Add</button>\n        </div>\n    </div>\n    <div class=\"row associated-offices-row\" ng-class=\"{'associated-offices-row-border' : $index < user.userProfile.Locations.length - 1} \"\n         ng-repeat=\"location in user.userProfile.Locations | orderBy : 'LocationNickname'\">\n        <div class=\"col-md-3\">\n            <p ng-bind=\"location.LocationNickname\"></p>\n        </div>\n        <div class=\"col-md-3\">\n            <p ng-bind=\"location.Address\"></p>\n            <p ng-bind=\"location.City + ', ' + location.State + ' ' + location.Zip\"></p>\n        </div>\n        <div class=\"col-md-3\">\n            <p ng-bind=\"location.ContactPhone | tel\"></p>\n            <p ng-bind=\"location.ContactEmail\"></p>\n        </div>\n        <div class=\"col-md-3\">\n            <span class=\"link pull-right\" ng-click=\"user.removeOfficeAssignment(location)\" ng-if=\"user.userProfile.Locations.length > 1 && user.userProfile.isEnabled === true && user.isCompanyLevelUser === false\">\n                Remove this one\n            </span>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 364 */
/***/ (function(module, exports) {

module.exports = "<div ng-controller=\"UserTableController as userTable\">\n    <div class=\"row users-header-container\">\n        <div class=\"col-md-12 text-right\">\n            <button class=\"btn btn-default\" id=\"btn-add-user\" ng-click=\"userTable.addUser()\">Add User</button>\n        </div>\n    </div>\n    <div class=\"accounts-users-content-container hp-loading-spinner\" ra-spinner name=\"usersSpinner\" show=\"userTable.loadingUsers === true\" hide-content-when-shown=\"true\">\n        <table class=\"table table-striped pipeline-table\">\n            <thead>\n            <tr>\n                <th ng-repeat=\"column in userTable.userTableColumns\" ng-class=\"[column, {'sortable' : column.sort === true, 'currentSort' : userTable.sortCol === column.apiColumnId}]\" ng-click=\"userTable.headerClick(column)\">\n                    <span ng-bind=\"column.key\"></span>\n                    <div class=\"arrow arrow-down\" ng-if=\"userTable.sortOrder === 1 && userTable.sortCol === column.apiColumnId\"></div>\n                    <div class=\"arrow arrow-up\" ng-if=\"userTable.sortOrder === 2 && userTable.sortCol === column.apiColumnId\"></div>\n                </th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr ng-repeat=\"userRow in userTable.users\" ng-class=\"{'disabled' : userRow.IsEnabled === false}\" class=\"user-row\">\n                <td ng-click=\"userTable.viewUser(userRow)\" ng-repeat=\"column in userTable.userTableColumns\">\n                    <p ng-bind=\"column.val(userRow)\"></p>\n                    <div class=\"cslb-badge\" ng-if=\"userRow.IsCSLBHolder === true && column.key === 'Role'\">\n                        <div class=\"cslb-badge-inner\">\n                            <span>CSLB Qualifier</span>\n                        </div>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n        <div class=\"pipeline-pagination\">\n            <paging\n                class=\"small\"\n                page=\"userTable.pageNumber + 1\"\n                page-size=\"20\"\n                total=\"userTable.totalCount\"\n                hide-if-empty=\"false\"\n                show-prev-next=\"true\"\n                paging-action=\"userTable.switchPage(page)\">\n            </paging>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 365 */
/***/ (function(module, exports) {

module.exports = "<h5><b>Home Improvement Sales Person (HIS) Registration</b></h5>\n<br />\n<p>\n  If you've completed HIS registration with the CSLB, then enter number here to unlock full access to sales features including the following:\n</p>\n<br />\n<ul>\n  <li>Apply button</li>\n  <li>Know before you go</li>\n  <li>Pipeline and Search</li>\n  <li>Transfer a project</li>\n</ul>";

/***/ }),
/* 366 */
/***/ (function(module, exports) {

module.exports = "<div class=\"text-left add-user-content-container\">\n    <div class=\"account-permission-container\">\n        <div class=\"row account-permission-label-container\">\n            <div class=\"col-md-12\">\n                <span>Account Permissions</span>\n            </div>\n        </div>\n        <div class=\"row account-permissions-dropdown-container\">\n            <div class=\"col-md-12\">\n                <div\n                    ng-class=\"{ 'invalid-no-role' : addUser.validateUserRole() && addUser.submitted === 'true' }\">\n                    <hp-roles-selector required=\"true\"\n                                       user=\"addUser.user\"\n                                       role=\"addUser.user.Role\"\n                                       license-number=\"addUser.licenseNumber\"\n                                       submitted=\"addUser.submitted\">\n                    </hp-roles-selector>\n                </div>\n                <div class=\"error-message-container\">\n                    <p class=\"error-message\"\n                       ng-if=\"addUser.validateUserRole() && addUser.submitted === 'true'\">\n                        Required</p>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"user-contact-info-container\" ng-class=\"{'disabled' : addUser.disableUI }\">\n        <div class=\"user-contact-name-container\">\n            <div class=\"row user-name-label-container\">\n                <div class=\"col-md-12\">\n                    <span>User Contact Information</span>\n                </div>\n            </div>\n            <div class=\"row user-name-field-container\">\n                <div class=\"col-md-8 contact-first-name-container\">\n                    <input id=\"txt-contact-first-name\" name=\"txtContactFirstName\" type=\"text\" ng-required=\"true\"\n                           ng-disabled=\"addUser.disableUI || addUser.user.licenseHolderSelected === true\"\n                           ng-class=\"{ 'is-required' : addUser.addUserForm.txtContactFirstName.$error.required && addUser.submitted === 'true'}\"\n                           placeholder=\"First Name\" maxlength=\"30\" ng-model=\"addUser.user.FirstName\">\n\n                    <div class=\"error-message-container\">\n                        <p class=\"error-message\"\n                           ng-if=\"addUser.addUserForm.txtContactFirstName.$error.required && addUser.submitted === 'true' && !addUser.disableUI\">\n                            Required</p>\n                    </div>\n                </div>\n                <div class=\"col-md-4 contact-middle-initial-container\">\n                    <input id=\"txt-contact-middle-initial\" name=\"txtContactMiddleInitial\" type=\"text\"\n                           ng-disabled=\"addUser.disableUI || addUser.user.licenseHolderSelected === true\"\n                           placeholder=\"Middle Initial\" maxlength=\"1\" ng-model=\"addUser.user.MiddleInitial\"/>\n                </div>\n            </div>\n            <div class=\"row user-name-field-container\">\n                <div class=\"col-md-8 contact-last-name-container\">\n                    <input id=\"txt-contact-last-name\" name=\"txtContactLastName\" type=\"text\" ng-required=\"true\"\n                           ng-disabled=\"addUser.disableUI || addUser.user.licenseHolderSelected === true\"\n                           ng-class=\"{ 'is-required' : addUser.addUserForm.txtContactFirstName.$error.required && addUser.submitted === 'true'}\"\n                           placeholder=\"Last Name\" maxlength=\"30\" ng-model=\"addUser.user.LastName\">\n\n                    <div class=\"error-message-container\">\n                        <p class=\"error-message\"\n                           ng-if=\"addUser.addUserForm.txtContactLastName.$error.required && addUser.submitted === 'true' && !addUser.disableUI\">\n                            Required</p>\n                    </div>\n                </div>\n                <div class=\"col-md-4 contact-suffix-container\">\n                    <input id=\"txt-contact-suffix\" name=\"txtContactSuffix\" type=\"text\"\n                           ng-disabled=\"addUser.disableUI || addUser.user.licenseHolderSelected === true\"\n                           placeholder=\"Suffix\" maxlength=\"5\" ng-model=\"addUser.user.Suffix\"/>\n                </div>\n            </div>\n        </div>\n        <hp-contact-info contact=\"addUser.contact\" required=\"!addUser.validateUserRole()\" submitted=\"addUser.submitted\"\n                         editor=\"false\" toggle-off=\"addUser.disableUI\"></hp-contact-info>\n    </div>\n    <div class=\"user-associated-office-container\" ng-class=\"{'disabled' : addUser.disableUI }\">\n        <div class=\"row associated-office-label-container\">\n            <div class=\"col-md-12\">\n                <span>Associated Office</span>\n            </div>\n        </div>\n        <div class=\"row associated-office-dropdown-container\" ng-if=\"!addUser.isAllOfficesDisplayed\">\n            <div ng-repeat=\"location in addUser.selectedLocations\" class=\"disabled\">\n                <div class=\"dropdown-container\">\n                    <div class=\"col-md-3 associated-office-state-container\">\n                        <div class=\"dropdown full\" uib-dropdown dropdown-small-popup dropdown-title=\"States\"\n                             ng-class=\"{'invalid-no-location-state' : !addUser.hasLocationState() && addUser.submitted === 'true' && !addUser.disableUI,\n                                        'single-location' : addUser.hasOneLocation, 'disabled': addUser.disableUI}\">\n                            <a id=\"ddl-state-{{$index}}\" blur-element href=\"#\" class=\"dropdown-toggle\"\n                               uib-dropdown-toggle\n                               data-toggle=\"dropdown\" ng-disabled=\"addUser.disableUI || addUser.hasOneLocation\"\n                               ng-class=\"{'single-location' : addUser.hasOneLocation, 'disabled': addUser.disableUI}\">\n                                <span class=\"dropdown-text\" ng-bind=\"location.selectedState\"></span>\n                                <span class=\"icon\"></span>\n                            </a>\n                            <ul class=\"dropdown-menu address-breakdown-small\" uib-dropdown-menu>\n                                <li ng-repeat=\"office in addUser.availableOffices | filter: {hasLocations: true}\"\n                                    ng-class=\"{'active': location.selectedState === office.State }\"\n                                    ng-click=\"addUser.stateClicked(office.State, $parent.$index)\">\n                                    <span>{{office.State}}</span>\n                                </li>\n                            </ul>\n                        </div>\n                    </div>\n                    <div class=\"col-md-9 associated-office-location-container\">\n                        <div class=\"dropdown\" uib-dropdown dropdown-small-popup dropdown-title=\"Locations\"\n                             ng-class=\"{ 'full' : $index === 0, 'secondary' : $index > 0,\n                                         'invalid-no-location' : !addUser.hasLocations() && addUser.submitted === 'true' && !addUser.disableUI,\n                                         'single-location' : addUser.hasOneLocation}\"\n                             ng-if=\"addUser.selectedLocations[$index].selectedState !== 'Choose One'\">\n                            <a id=\"ddl-location-{{$index}}\" blur-element href=\"#\" class=\"dropdown-toggle\"\n                               uib-dropdown-toggle\n                               data-toggle=\"dropdown\" ng-disabled=\"addUser.disableUI || addUser.hasOneLocation\"\n                               ng-class=\"{'single-location' : addUser.hasOneLocation, 'disabled': addUser.disableUI}\">\n                                <span class=\"dropdown-text\" ng-bind=\"location.selectedLocation.LocationNickname\"></span>\n                                <span class=\"icon\"></span>\n                            </a>\n                            <ul class=\"dropdown-menu address-breakdown-small\" uib-dropdown-menu\n                                ng-repeat=\"office in addUser.availableOffices | filter: {'State': location.selectedState}\">\n                                <li ng-repeat=\"loc in office.Locations | filter:{ selectedRow: -1 }\"\n                                    ng-class=\"{'active': location.selectedLocation.ContractorId === loc.ContractorId }\"\n                                    ng-click=\"addUser.locationClicked(loc, $parent.$parent.$index)\">\n                                    <span>{{loc.LocationNickname}}</span>\n                                </li>\n                            </ul>\n                            <!--<ul class=\"dropdown-menu address-breakdown-small\" uib-dropdown-menu>-->\n                            <!--<li ng-repeat=\"loc in office | filter:{ selectedRow: -1 }\"-->\n                            <!--ng-class=\"{'active': location.selectedLocation.ContractorId === loc.ContractorId }\"-->\n                            <!--ng-click=\"addUser.locationClicked(loc, $parent.$index)\">-->\n                            <!--<span>{{loc.LocationNickname}}</span>-->\n                            <!--</li>-->\n                            <!--</ul>-->\n                        </div>\n                        <span class=\"icon icon-zoom-out remove-location-icon\"\n                              ng-click=\"addUser.removeLocation(location, $index)\" ng-if=\"$index > 0\"></span>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"error-message-container\">\n                <p class=\"error-message\"\n                   ng-if=\"addUser.hasLocationState() && !addUser.hasLocations() && addUser.submitted === 'true' && !addUser.isAllOfficesDisplayed && !addUser.disableUI && !addUser.hasOneLocation\">\n                    Please select at least one location.</p>\n                <p class=\"error-message\"\n                   ng-if=\"!addUser.hasLocationState() && addUser.submitted === 'true' && !addUser.isAllOfficesDisplayed && !addUser.disableUI && !addUser.hasOneLocation\">\n                    Please select at least one state.</p>\n            </div>\n        </div>\n\n        <div class=\"row add-location-button-container\" ng-if=\"addUser.isAddLocationButtonVisible\">\n            <div class=\"col-md-12\">\n                <div class=\"add-location-container\" ng-click=\"addUser.addLocation()\"\n                     ng-if=\"addUser.checkRemainingAvailableLocations() && !addUser.disableUI\">\n                    <div class=\"icon icon-zoom-in add-location-icon\"></div>\n                    <div class=\"add-location-label\"> Add Location</div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row associate-office-admin-container text-center\" ng-if=\"addUser.isAllOfficesDisplayed\">\n            ALL OFFICES\n        </div>\n\n    </div>\n</div>\n";

/***/ }),
/* 367 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <span class=\"icon icon-delete\" ng-click=\"addUser.closeModal()\"></span>\n</div>\n\n<div class=\"row\">\n    <div class=\"col-md-10 col-md-offset-1\">\n        <div class=\"modal-body\">\n            <p class=\"modal-title\">Add User</p>\n            <div class=\"add-office\" ng-if=\"addUser.contentShown === 'addUserInProgress'\">\n                <form name=\"addUser.addUserForm\" ng-submit=\"addUser.submitNewUser(addUser.addUserForm.$valid)\" novalidate>\n                    <div class=\"row\">\n                        <div class=\"col-md-8 col-md-offset-2 text-center\">\n                            <ng-include src=\"'app/accounts/user/addUser/addUserContent.html'\"></ng-include>\n                        </div>\n                    </div>\n                    <div class=\"row add-user-buttons-container\">\n                        <div class=\"col-md-8 col-md-offset-2 text-center\">\n                            <div class=\"modal-buttons text-center\">\n                                <hp-spinner-button button-text=\"Add\" button-name=\"btnAddOffice\" is-primary-btn=\"true\"\n                                                   is-submit-button=\"true\" display-spinner=\"addUser.saving\"></hp-spinner-button>\n                                <button class=\"btn btn-default\" name=\"btnCancelAddOffice\" ng-click=\"addUser.closeModal()\">Cancel</button>\n\n                            </div>\n                        </div>\n                    </div>\n                </form>\n            </div>\n            <div ng-if=\"addUser.contentShown === 'addUserSuccess'\">\n                <full-screen-modal-success\n                    primary-text=\"{{addUser.successText}}\"\n                    secondary-text=\"{{addUser.secondaryText}}\"\n                    pro-tip-text=\"Creating different accounts for each employee helps your company manage and close jobs faster.\"\n                    button-text=\"Done\"\n                    button-fn=\"addUser.closeModal()\">\n                </full-screen-modal-success>\n            </div>\n\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 368 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <span class=\"icon icon-delete\" ng-click=\"deleteUser.closeModal()\"></span>\n</div>\n\n<div class=\"row\">\n\t<div class=\"col-md-10 col-md-offset-1\">\n\t\t<div class=\"modal-body\">\n\t\t\t<p class=\"modal-title\">Delete Account</p>\n\n\t\t\t<div class=\"delete-user\" ng-if=\"deleteUser.contentShown === 'deleteInProgress'\">\n\t\t\t\t<div class=\"row\">\n\t\t\t\t\t<!-- Reassign jobs and delete user -->\n\t\t\t\t\t<div class=\"col-md-8 col-md-offset-2 text-center\" ng-if=\"deleteUser.contractorJobLocationsReturned === true && deleteUser.selectedUserHasJobs === true\">\n\t\t\t\t\t\t<div class=\"current-user-message\">\n\t\t\t\t\t\t\t<h2>Deleting {{deleteUser.selectedUser.FirstName}} {{deleteUser.selectedUser.LastName}}'s Account</h2>\n\t\t\t\t\t\t\t<p>Before deleting, re-assign {{deleteUser.selectedUser.FirstName}} {{deleteUser.selectedUser.LastName}}'s HERO accounts</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div ng-repeat=\"location in deleteUser.usersByLocation\">\n\t\t\t\t\t\t\t<p class=\"location-nickname\">{{location.nickname}}</p>\n\t\t\t\t\t\t\t<div class=\"dropdown\" uib-dropdown dropdown-small-popup dropdown-title=\"Choose Employee\">\n\t\t\t\t\t\t\t    <a blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle data-toggle=\"dropdown\">\n\t\t\t\t\t\t\t    \t<span ng-if=\"location.newContractorUser !== null\" class=\"dropdown-text\">{{location.newContractorUser.FirstName}} {{location.newContractorUser.LastName}}</span>\n\t\t\t\t\t\t\t    \t<span ng-if=\"location.newContractorUser === null\" class=\"dropdown-text\">Choose Employee</span>\n\t\t\t\t\t\t\t        <span class=\"icon\"></span>\n\t\t\t\t\t\t\t    </a>\n\t\t\t\t\t\t\t    <ul class=\"dropdown-menu\" uib-dropdown-menu>\n\t\t\t\t\t\t\t        <li ng-repeat=\"user in location.Users\" ng-class=\"{'active': false}\" ng-click=\"deleteUser.transferToUser(location, user)\">\n\t\t\t\t\t\t\t        \t<span>{{user.FirstName}} {{user.LastName}}</span>\n\t\t\t\t\t\t\t        </li>\n\t\t\t\t\t\t\t    </ul>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<!-- Reassign jobs and delete user -->\n\n\t\t\t\t\t<!-- Delete a user that currently has no jobs -->\n\t\t\t\t\t<div class=\"col-md-8 col-md-offset-2 text-center\" ng-if=\"deleteUser.contractorJobLocationsReturned === true && deleteUser.selectedUserHasJobs === false\">\n\t\t\t\t\t\t<div class=\"current-user-message\">\n\t\t\t\t\t\t\t<h2 class=\"no-current-jobs\">Are you sure you want to delete {{deleteUser.selectedUser.FirstName}} {{deleteUser.selectedUser.LastName}}'s Account?</h2>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<!-- Delete a user that currently has no jobs -->\n\t\t\t\t</div>\n\t\t\t\t<div class=\"modal-buttons text-center\" ng-if=\"deleteUser.contractorJobLocationsReturned === true\">\n\t\t\t\t\t<button class=\"btn btn-primary\" ng-click=\"deleteUser.reassignJobsAndDeleteUser()\" ng-disabled=\"deleteUser.disableDeleteButton\">{{ deleteUser.selectedUserHasJobs === true ? 'Reassign &amp; Delete' : 'Delete' }}</button>\n\t\t\t\t\t<button class=\"btn btn-default\" ng-click=\"deleteUser.closeModal()\">Cancel</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<full-screen-modal-success ng-if=\"deleteUser.contentShown === 'deleteSuccess' && deleteUser.selectedUserHasJobs === true\"\n\t\t\t\tprimary-text=\"Account has been deleted\"\n\t\t\t\tsecondary-text=\"HERO projects for {{deleteUser.selectedUser.FirstName}} {{deleteUser.selectedUser.LastName}} have been re-assigned to:\"\n\t\t\t\tcontent-list=\"deleteUser.successData\"\n\t\t\t\tbutton-text=\"Done\"\n\t\t\t\tbutton-fn=\"deleteUser.closeModal()\">\n\t\t\t</full-screen-modal-success>\n\n\n\t\t\t<full-screen-modal-success ng-if=\"deleteUser.contentShown === 'deleteSuccess' && deleteUser.selectedUserHasJobs === false\"\n\t\t\t\tprimary-text=\"Account has been deleted\"\n\t\t\t\tsecondary-text=\"{{deleteUser.selectedUser.FirstName}} {{deleteUser.selectedUser.LastName}} had no active HERO accounts that needed to be re-assigned\"\n\t\t\t\tcontent-list=\"deleteUser.successData\"\n\t\t\t\tbutton-text=\"Done\"\n\t\t\t\tbutton-fn=\"deleteUser.closeModal()\">\n\t\t\t</full-screen-modal-success>\n\t\t</div>\n\t</div>\n</div>\n";

/***/ }),
/* 369 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <span class=\"icon icon-delete\" ng-click=\"contractorUserLicenseRegistration.closeModal()\"></span>\n</div>\n\n<div class=\"modal-body\">\n    <p class=\"modal-title\">Enter HIS number</p>\n    <form name=\"contractorUserLicenseRegistration.contractorUserLicenseRegistrationForm\" novalidate>\n        <div class=\"contractor-user-license-registration-container\">\n            <div class=\"contractor-user-license-number\">\n                <span class=\"contractor-user-license-number__input\" ng-class=\"{ 'contractor-user-license-number__input--invalid' :\n                  (contractorUserLicenseRegistration.contractorUserLicenseRegistrationForm.inputContractorUserLicense.$error.required && contractorUserLicenseRegistration.validateContractorUserLicenseClicked)\n                  || contractorUserLicenseRegistration.contractorUserLicenseErrorMessage\n              }\">\n                    <input id=\"input-contractor-user-license-number\" name=\"inputContractorUserLicense\" ng-model=\"contractorUserLicenseRegistration.contractorUserLicense\" ng-required=\"true\" type=\"text\" maxlength=\"8\" placeholder=\"Up to 8 digits\" ng-change=\"contractorUserLicenseRegistration.clearContractorUserLicenseData()\" />\n                    <span class=\"icon icon-todo\" ng-if=\"contractorUserLicenseRegistration.contractorUserLicenseResponseValid\"></span>\n                </span>\n                <span class=\"contractor-user-license-number__sufix\">SP</span>\n                <hp-spinner-button class=\"contractor-user-license-number__button\" button-text=\"Check #\" button-name=\"btnCheckContratorUserLicense\" is-primary-btn=\"true\" is-submit-button=\"false\" display-spinner=\"contractorUserLicenseRegistration.showCheckSpinner\" ng-click=\"contractorUserLicenseRegistration.validateContractorUserLicense();\"></hp-spinner-button>\n                <div class=\"error-message-container\">\n                    <p class=\"error-message\" ng-if=\"contractorUserLicenseRegistration.contractorUserLicenseRegistrationForm.inputContractorUserLicense.$error.required && contractorUserLicenseRegistration.validateContractorUserLicenseClicked\">\n                        Required\n                    </p>\n                    <p class=\"error-message\" ng-if=\"contractorUserLicenseRegistration.contractorUserLicenseErrorMessage\">\n                        Invalid number{{contractorUserLicenseRegistration.contractorUserLicenseErrorMessage}}\n                    </p>\n                </div>\n            </div>\n            <div class=\" contractor-user-license-confirmation\" ng-if=\"contractorUserLicenseRegistration.contractorUserLicenseResponseValid\">\n                <p>\n                    <b>\n                        This HIS number belongs to\n                        {{contractorUserLicenseRegistration.contractorUserLicenseResponse.Metadata.FirstName}} {{contractorUserLicenseRegistration.contractorUserLicenseResponse.Metadata.LastName}}.\n                        Is this you?\n                    </b>\n                </p>\n                <p>\n                    <div id=\"cb-confirm-contractor-user-license\" class=\"contractor-user-license_checkbox\" name=\"cbConfirmContractorUserLicense\" ng-click=\"contractorUserLicenseRegistration.confirmCheckBoxClicked()\">\n                        <span class=\"icon icon-complete contractor-user-license_checkbox__complete\" ng-if=\"contractorUserLicenseRegistration.confirmCheckBoxValue\"></span>\n                        <span class=\"contractor-user-license_checkbox__empty\" ng-if=\"!contractorUserLicenseRegistration.confirmCheckBoxValue\"></span>\n                        <label>Yes, I confirm this is my HIS number</label>\n                    </div>\n                </p>\n            </div>\n        </div>\n    </form>\n</div>\n\n<div class=\"modal-buttons text-center\">\n    <!-- <button class=\"btn btn-primary\" ng-disabled=\"!contractorUserLicenseRegistration.isFormValid()\" ng-click=\"contractorUserLicenseRegistration.addContractorUserLicense()\">Add #</button> -->\n    <hp-spinner-button is-disabled=\"!contractorUserLicenseRegistration.isFormValid()\" button-text=\"Add #\" button-name=\"btnAddContratorUserLicense\" is-primary-btn=\"true\" is-submit-button=\"false\" display-spinner=\"contractorUserLicenseRegistration.showAddSpinner\" ng-click=\"contractorUserLicenseRegistration.addContractorUserLicense();\"></hp-spinner-button>\n    <button class=\"btn btn-default\" type=\"button\" ng-click=\"contractorUserLicenseRegistration.closeModal()\">Cancel</button>\n</div>";

/***/ }),
/* 370 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <span class=\"icon icon-delete\" ng-click=\"addOfficeAssignment.closeModal()\"></span>\n</div>\n\n<div class=\"row\">\n\t<div class=\"col-md-10 col-md-offset-1\">\n\t\t<div class=\"modal-body\">\n\t\t\t<p class=\"modal-title\">Assign to Office</p>\n\n\t\t\t<div class=\"add-office-assignment\" ng-if=\"addOfficeAssignment.contentShown === 'addOfficeAssignmentInProgress'\">\n\t\t\t\t<div class=\"row\">\n\t\t\t\t\t<div class=\"col-md-8 col-md-offset-2 text-center\">\n\t\t\t\t\t\t<div class=\"current-user-message\">\n\t\t\t\t\t\t\t<p>Select the office you would like to add {{addOfficeAssignment.currentUser.FirstName}} {{addOfficeAssignment.currentUser.LastName}} to:</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t<div class=\"col-md-8 col-md-offset-2\">\n\t\t\t\t\t\t\t\t<div class=\"dropdown\" uib-dropdown dropdown-small-popup dropdown-title=\"Choose Office\">\n\t\t\t\t\t\t\t\t    <a blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle data-toggle=\"dropdown\">\n\t\t\t\t\t\t\t\t    \t<span ng-if=\"addOfficeAssignment.locationToAdd !== null\" class=\"dropdown-text\">{{addOfficeAssignment.locationToAdd.LocationNickname}}</span>\n\t\t\t\t\t\t\t\t    \t<span ng-if=\"addOfficeAssignment.locationToAdd === null\" class=\"dropdown-text\">Choose Office</span>\n\t\t\t\t\t\t\t\t        <span class=\"icon\"></span>\n\t\t\t\t\t\t\t\t    </a>\n\t\t\t\t\t\t\t\t    <ul class=\"dropdown-menu\" uib-dropdown-menu>\n\t\t\t\t\t\t\t\t        <li ng-repeat=\"location in addOfficeAssignment.signedInUserLocations\" ng-class=\"{'active': location.ContractorId === addOfficeAssignment.locationToAdd.ContractorId}\" ng-click=\"addOfficeAssignment.setNewLocation(location)\">\n\t\t\t\t\t\t\t\t        \t<span>{{location.LocationNickname}}</span>\n\t\t\t\t\t\t\t\t        </li>\n\t\t\t\t\t\t\t\t    </ul>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"modal-buttons text-center\">\n\t\t\t\t\t<button class=\"btn btn-primary\" ng-click=\"addOfficeAssignment.addOfficeToUser()\" ng-disabled=\"addOfficeAssignment.locationToAdd === null\">Add</button>\n\t\t\t\t\t<button class=\"btn btn-default\" ng-click=\"addOfficeAssignment.closeModal()\">Cancel</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<full-screen-modal-success ng-if=\"addOfficeAssignment.contentShown === 'addOfficeAssignmentSuccess'\"\n\t\t\t\tprimary-text=\"{{addOfficeAssignment.currentUser.FirstName}} {{addOfficeAssignment.currentUser.LastName}} has been successfully added to the {{addOfficeAssignment.locationToAdd.LocationNickname}} location\"\n\t\t\t\tbutton-text=\"Done\"\n\t\t\t\tbutton-fn=\"addOfficeAssignment.closeModal()\">\n\t\t\t</full-screen-modal-success>\n\t\t</div>\n\t</div>\n</div>\n";

/***/ }),
/* 371 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <span class=\"icon icon-delete\" ng-click=\"removeOfficeAssignment.closeModal()\"></span>\n</div>\n\n<div class=\"row\">\n\t<div class=\"col-md-10 col-md-offset-1\">\n\t\t<div class=\"modal-body\">\n\t\t\t<p class=\"modal-title\">Remove Office Assignment</p>\n\n\t\t\t<div class=\"reassign-jobs\" ng-if=\"removeOfficeAssignment.contentShown === 'reassignJobs'\">\n\t\t\t\t<div class=\"row\">\n\t\t\t\t\t<div class=\"col-md-8 col-md-offset-2 text-center\">\n\t\t\t\t\t\t<p class=\"reassign-message\">Before we remove it, choose someone else in the {{removeOfficeAssignment.selectedOffice.LocationNickname}} office to reassign {{removeOfficeAssignment.currentUser.FirstName}} {{removeOfficeAssignment.currentUser.LastName}}'s HERO jobs to.</p>\n\t\t\t\t\t\t<div class=\"dropdown\" uib-dropdown dropdown-small-popup dropdown-title=\"Assign To\">\n\t\t\t\t\t\t    <a blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle data-toggle=\"dropdown\">\n\t\t\t\t\t\t    \t<span ng-if=\"removeOfficeAssignment.newUser !== null\" class=\"dropdown-text\">{{removeOfficeAssignment.newUser.FirstName}} {{removeOfficeAssignment.newUser.LastName}}</span>\n\t\t\t\t\t\t    \t<span ng-if=\"removeOfficeAssignment.newUser === null\" class=\"dropdown-text\">Choose Employee</span>\n\t\t\t\t\t\t        <span class=\"icon\"></span>\n\t\t\t\t\t\t    </a>\n\t\t\t\t\t\t    <ul class=\"dropdown-menu\" uib-dropdown-menu>\n\t\t\t\t\t\t        <li ng-repeat=\"user in removeOfficeAssignment.selectedOffice.users\" ng-class=\"{'active': user.ContractorUserId === removeOfficeAssignment.newUser.ContractorUserId}\" ng-click=\"removeOfficeAssignment.transferToUser(user)\">\n\t\t\t\t\t\t        \t<span>{{user.FirstName}} {{user.LastName}}</span>\n\t\t\t\t\t\t        </li>\n\t\t\t\t\t\t    </ul>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"modal-buttons text-center\">\n\t\t\t\t\t<button class=\"btn btn-primary\" ng-click=\"removeOfficeAssignment.reassignJobsAndRemoveOffice(removeOfficeAssignment.selectedOffice, removeOfficeAssignment.currentUser, removeOfficeAssignment.newUser)\" ng-disabled=\"removeOfficeAssignment.newUser === null\">Reassign &amp; Remove</button>\n\t\t\t\t\t<button class=\"btn btn-default\" ng-click=\"removeOfficeAssignment.closeModal()\">Cancel</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<full-screen-modal-success ng-if=\"removeOfficeAssignment.contentShown === 'reassignSuccess'\"\n\t\t\t\tsecondary-text=\"Office assignment removed and HERO jobs reassigned to:\"\n\t\t\t\tcontent-list=\"removeOfficeAssignment.successData\"\n\t\t\t\tbutton-text=\"Done\"\n\t\t\t\tbutton-fn=\"removeOfficeAssignment.closeModal()\">\n\t\t\t</full-screen-modal-success>\n\t\t</div>\n\t</div>\n</div>";

/***/ }),
/* 372 */
/***/ (function(module, exports) {

module.exports = "<div class=\"roles-selector-container\">\n    <ng-form name=\"rolesSelectorForm\">\n        <div class=\"dropdown\" uib-dropdown dropdown-small-popup dropdown-title=\"Roles\" ng-if=\"!rolesSelector.hideSelector || rolesSelector.hideSelector === 'false'\">\n            <a id=\"ddl-roles\" blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle data-toggle=\"dropdown\">\n                <span class=\"dropdown-text\" ng-bind=\"rolesSelector.selectedRole.DisplayName\"></span>\n                <span class=\"icon\"></span>\n            </a>\n            <ul class=\"dropdown-menu address-breakdown-small\" uib-dropdown-menu>\n                <li ng-repeat=\"role in rolesSelector.roles\"\n                    ng-class=\"{'active': rolesSelector.selectedRole.Name === role.Name}\"\n                    ng-click=\"rolesSelector.roleClicked(role)\">\n                    <div class=\"dropdown-content-container\">\n                        <span class=\"role-title\">{{role.DisplayName}}</span>\n                        <span class=\"role-description\">{{role.DisplayDescription}}</span>\n                    </div>\n                </li>\n            </ul>\n        </div>\n        <div class=\"role-info\" ng-if=\"rolesSelector.hideSelector === 'true'\">\n            <p class=\"role-name\" ng-bind=\"rolesSelector.role.DisplayName\"></p>\n            <p class=\"role-description\" ng-bind=\"rolesSelector.role.DisplayDescription\"></p>\n        </div>\n\n        <!-- CSLB section -->\n        <div class=\"cslb-container\" ng-if=\"rolesSelector.cslbShowCheckBox\">\n            <div id=\"cb-select-qualifier\" class=\"cslb-checkbox\" name=\"cbSelectQualifier\" ng-click=\"rolesSelector.cslbCheckBoxClicked()\">\n                <span class=\"icon icon-complete\" ng-if=\"rolesSelector.cslbCheckBoxValue === true\"></span>\n                <span class=\"empty-checkbox\" ng-if=\"rolesSelector.cslbCheckBoxValue === false\"></span>\n                <label>Select from Qualifiers on your CSLB License</label>\n            </div>\n            <div class=\"roles-selector-container\" ng-if=\"rolesSelector.cslbCheckBoxValue === true && rolesSelector.cslbQualifiers\">\n                <div class=\"dropdown\" uib-dropdown dropdown-small-popup dropdown-title=\"CSLB Qualifiers\"  ng-class=\"{'invalid-no-qualifier' : !rolesSelector.cslbSelectedQualifier && rolesSelector.submitted === 'true'}\">\n                    <a id=\"ddl-cslb-qualifier\" blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle data-toggle=\"dropdown\">\n                        <span class=\"dropdown-text\" ng-if=\"rolesSelector.cslbSelectedQualifier\">\n                            {{rolesSelector.cslbSelectedQualifier.FirstName}} {{rolesSelector.cslbSelectedQualifier.MiddleInitial}} {{rolesSelector.cslbSelectedQualifier.LastName}} {{rolesSelector.cslbSelectedQualifier.Suffix}}\n                        </span>\n                        <span class=\"dropdown-text\" ng-if=\"!rolesSelector.cslbSelectedQualifier\">\n                            Choose a CSLB License holder\n                        </span>\n                        <span class=\"icon\"></span>\n                    </a>\n                    <ul class=\"dropdown-menu address-breakdown-small\" uib-dropdown-menu>\n                        <li ng-repeat=\"qualifier in rolesSelector.cslbQualifiers\"\n                            ng-class=\"{'active': rolesSelector.cslbSelectedQualifier === qualifier}\"\n                            ng-click=\"rolesSelector.cslbQualifierClicked(qualifier)\">\n                            <div class=\"dropdown-content-container\">\n                                <span>{{qualifier.FirstName}} {{qualifier.MiddleInitial}} {{qualifier.LastName}} {{qualifier.Suffix}}</span>\n                                <span class=\"qualifier-title\">{{qualifier.TitleName}}</span>\n                            </div>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n            <div class=\"no-qualifiers-found\" ng-if=\"rolesSelector.cslbCheckBoxValue === true && rolesSelector.cslbShowError == true\">\n                <span ng-if=\"rolesSelector.filterLastName !== 'true'\">There are no CSLB qualifiers on this license.</span>\n                <span ng-if=\"rolesSelector.filterLastName === 'true'\">There are no CSLB qualifiers on this license for the Last Name entered '{{rolesSelector.user.LastName}}'.</span>\n            </div>\n        </div>\n    </ng-form>\n</div>\n";

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _user = __webpack_require__(78);

var _user2 = _interopRequireDefault(_user);

var _financingController = __webpack_require__(374);

var _financingController2 = _interopRequireDefault(_financingController);

var _termSetController = __webpack_require__(376);

var _termSetController2 = _interopRequireDefault(_termSetController);

var _financingFactory = __webpack_require__(378);

var _financingFactory2 = _interopRequireDefault(_financingFactory);

var _termSetDirective = __webpack_require__(379);

var _termSetDirective2 = _interopRequireDefault(_termSetDirective);

var _financingTermsModalController = __webpack_require__(381);

var _financingTermsModalController2 = _interopRequireDefault(_financingTermsModalController);

var _appAppDetail = __webpack_require__(383);

var _appAppDetail2 = _interopRequireDefault(_appAppDetail);

var _appFinancing = __webpack_require__(384);

var _appFinancing2 = _interopRequireDefault(_appFinancing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.accounts.financing', [_user2.default]).controller('FinancingController', _financingController2.default).controller('FinancingTermsModalController', _financingTermsModalController2.default).controller('TermSetController', _termSetController2.default).service('FinancingFactory', _financingFactory2.default).constant('HPAppDetailTypes', _appAppDetail2.default).constant('FinancingConfig', _appFinancing2.default).directive('termSet', _termSetDirective2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/accounts/financing/financingTermSets.html', __webpack_require__(385)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/financing/financingTermsModal/confirmSelectedRates.html', __webpack_require__(386)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/financing/financingTermsModal/financingTermsModal.html', __webpack_require__(387)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/financing/financingTermsModal/selectedRatesConfirmed.html', __webpack_require__(388)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/financing/financingTermsModal/viewAvailableRates.html', __webpack_require__(389)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = financingController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(375);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

financingController.$inject = ['FinancingFactory', 'UserData', 'AccountsFactory', 'HPRoles', '$uibModal', 'HPAppDetailTypes', 'HPGeoStates', 'FinancingConfig'];

/* @ngInject */
function financingController(FinancingFactory, UserData, AccountsFactory, HPRoles, $uibModal, HPAppDetailTypes, HPGeoStates, FinancingConfig) {
    var vm = this;

    vm.currentRates = undefined;
    vm.scheduledRates = undefined;
    vm.effectiveDate = undefined;
    vm.states = {};
    vm.selectedState = undefined;
    vm.financingOptions = {};
    vm.isCompanyAdmin = false;
    vm.isRateChangeScheduled = false;
    vm.phoneNumber = FinancingFactory.getPhoneNumber();
    vm.userData = {};
    vm.premierTier = {};

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.openFinancingTermsModal = function () {
        $uibModal.open({
            templateUrl: 'app/accounts/financing/financingTermsModal/financingTermsModal.html',
            windowClass: 'financing-terms-modal',
            controller: 'FinancingTermsModalController',
            controllerAs: 'financingTermsModal',
            size: 'full-screen',
            animation: false
        });
    };

    vm.stateClicked = function (state) {
        vm.selectedState = state;
        FinancingFactory.setSelectedState(state);
        vm.currentRates = FinancingFactory.getCurrentRates(state.StateGeoId);
        vm.scheduledRates = FinancingFactory.getScheduledRates(state.StateGeoId);
    };

    vm.allowRateChange = function () {
        return vm.isCompanyAdmin === true && // user is company admin
        !vm.userData.ImpersonatorName && // user is not impersonating
        vm.isRateChangeScheduled === false; // organization does not have a change of rate scheduled
    };

    vm.isEmptyStates = function () {
        return _lodash2.default.isEmpty(vm.states);
    };

    vm.selectedStateHasNewRates = function () {
        return _lodash2.default.find(vm.newRatesConfig.stateGeoIds, function (stateGeoId) {
            return stateGeoId === vm.selectedState.StateGeoId;
        });
    };
    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions           =
    ======================================== */
    function init() {
        vm.newRatesConfig = FinancingConfig.newRates;

        // Get active states
        FinancingFactory.getServiceStates().then(function (response) {
            if (!_lodash2.default.isEmpty(response)) {
                vm.states = response;
                vm.selectedState = vm.states[0];
                FinancingFactory.setSelectedState(vm.selectedState);

                // Get default rates for the first state on the list
                getDefaultPlanRates(vm.selectedState);

                // Get Financing Options
                getFinancingOptions();
            }
        });

        FinancingFactory.getPremierTier().then(function (response) {
            vm.premierTier = response;
        });

        // Get User Data
        UserData.getUserData().then(function (data) {
            vm.userData = data;
            if (data.Roles[0] === HPRoles.COPO_COMPANY_ADMIN.Name) {
                vm.isCompanyAdmin = true;
            }
        });
    }

    function getDefaultPlanRates(state) {
        FinancingFactory.getDefaultPlanRates().then(function () {
            vm.currentRates = FinancingFactory.getCurrentRates(state.StateGeoId);
            vm.isRateChangeScheduled = !_lodash2.default.isEmpty(FinancingFactory.getScheduledRates());
            if (vm.isRateChangeScheduled) {
                var scheduledForSelectedState = FinancingFactory.getScheduledRates(state.StateGeoId);
                if (scheduledForSelectedState) {
                    vm.scheduledRates = scheduledForSelectedState;
                    vm.effectiveDate = scheduledForSelectedState.EffectiveDate;
                } else {
                    vm.scheduledRates = undefined;
                    var firstRate = _lodash2.default.find(FinancingFactory.getScheduledRates(), function (rate) {
                        return rate !== undefined;
                    });
                    vm.effectiveDate = firstRate.EffectiveDate;
                }
            }
        });
    }

    function getFinancingOptions() {
        FinancingFactory.getFinancingOptions().then(function (response) {
            vm.financingOptions = response.data.Data;
        });
    }
    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = termSetController;

__webpack_require__(377);

termSetController.$inject = ['FinancingFactory'];


/* @ngInject */
function termSetController(FinancingFactory) {
    var vm = this;
    vm.today = '';

    vm.termSetSelected = function (termSet) {
        FinancingFactory.setSelectedRates(termSet.termSetData, vm.state.StateGeoId);
    };

    vm.rateAfterDiscount = function (rate, discountRate) {
        if (rate === null || rate === undefined || discountRate === null || discountRate === undefined) {
            return null;
        }

        rate = parseFloat(rate);
        discountRate = parseFloat(discountRate);

        var r = rate - discountRate;
        r *= 100;
        r = Math.round(r);
        r /= 100;
        if (r <= 0) r = 0;
        return r;
    };

    vm.init = function () {
        vm.today = new Date(FinancingFactory.getCurrentDate());
        vm.today.setHours(0, 0, 0, 0);
    };
    vm.init();
}

/***/ }),
/* 377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = financingFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

financingFactory.$inject = ['$http', 'HPConfig', '$q'];


/* @ngInject */
function financingFactory($http, HPConfig, $q) {
    var _states = null;
    var _currentRates = {}; // Rates that are currently being used
    var _scheduledRates = {}; // Rates that have been scheduled, but not yet in use
    var _allRates = {}; // All possible AllRates
    var _selectedRates = {}; // Rates that have been selected but not yet scheduled
    var _currentDate = '';
    var _selectedState = void 0;
    var _premierTier = void 0;

    return {
        getCurrentDate: getCurrentDate,
        getServiceStates: getServiceStates,
        getDefaultPlanRates: getDefaultPlanRates,
        getFinancingOptions: getFinancingOptions,
        getAllPlanRates: getAllPlanRates,
        getAllRates: getAllRates,
        getCurrentRates: getCurrentRates,
        getScheduledRates: getScheduledRates,
        getSelectedRates: getSelectedRates,
        getPremierTier: getPremierTier,
        setSelectedRates: setSelectedRates,
        resetSelectedRates: resetSelectedRates,
        getPhoneNumber: getPhoneNumber,
        confirmRates: confirmRates,
        getSelectedState: getSelectedState,
        setSelectedState: setSelectedState
    };

    function getSelectedState() {
        return _selectedState;
    }

    function setSelectedState(selectedState) {
        _selectedState = selectedState;
    }

    function getPhoneNumber() {
        return '844-722-7759';
    }
    function getCurrentDate() {
        return _currentDate;
    }

    function getServiceStates() {
        if (_states !== null) {
            return $q(function (resolve) {
                resolve(_states);
            });
        }
        return $http({
            url: HPConfig.heroProApi + 'Organization/ServiceStates',
            method: 'GET'
        }).then(function (response) {
            _states = response.data.Data.States;
            _currentDate = response.data.Date;
            return _states;
        }).catch(function (response) {
            return $q.reject(response.data);
        });
    }

    function getDefaultPlanRates() {
        return $http({
            url: HPConfig.heroProApi + 'Organization/CurrentRates',
            method: 'GET'
        }).then(function (response) {
            setCurrentRates(response.data.Data);
            setScheduledRates(response.data.Data);
            return response.data.Data;
        }).catch(function (response) {
            return $q.reject(response.data.Data);
        });
    }

    function sortRatesByTerm(terms) {
        return _lodash2.default.sortBy(terms, 'Term');
    }

    function setCurrentRates(data) {
        if (data.CurrentRates !== undefined) {
            _currentRates = [];
            _lodash2.default.each(data.CurrentRates, function (rate) {
                rate.TermSets[0].PlanTermSets[0].Terms = sortRatesByTerm(rate.TermSets[0].PlanTermSets[0].Terms);
                _currentRates[rate.StateGeoId] = rate.TermSets[0];
                _currentRates[rate.StateGeoId].canEditRates = rate.CanEditRates;
                convertRatePlanDates(rate.TermSets[0]);
            });
        }
    }

    function getCurrentRates(stateGeoId) {
        if (stateGeoId === undefined) {
            return _currentRates;
        }
        return _currentRates[stateGeoId];
    }

    function setScheduledRates(data) {
        if (data.ScheduledRates !== undefined) {
            _scheduledRates = {};
            _lodash2.default.each(data.ScheduledRates, function (rate) {
                if (rate.TermSets !== undefined && rate.TermSets.length > 0) {
                    if (rate.TermSets[0].PlanTermSets !== undefined && rate.TermSets[0].PlanTermSets.length > 0) {
                        rate.TermSets[0].PlanTermSets[0].Terms = sortRatesByTerm(rate.TermSets[0].PlanTermSets[0].Terms);
                    }
                    _scheduledRates[rate.StateGeoId] = rate.TermSets[0];
                    convertRatePlanDates(rate.TermSets[0]);
                }
            });
        }
    }

    function getScheduledRates(stateGeoId) {
        if (stateGeoId === undefined) {
            return _scheduledRates;
        }

        return _scheduledRates[stateGeoId];
    }

    function getFinancingOptions() {
        return $http({
            url: HPConfig.heroProApi + 'Organization/FinancingOptions',
            method: 'GET'
        });
    }

    function getAllPlanRates(stateGeoId) {
        return $http({
            url: HPConfig.heroProApi + 'Plan/AllRates',
            method: 'GET',
            params: { stateGeoId: stateGeoId }
        }).then(function (response) {
            setAllRates(response.data.Data);
            return response.data.Data;
        }).catch(function (response) {
            return $q.reject(response.data.Data);
        });
    }

    function getPremierTier() {
        return $http({
            url: HPConfig.heroProApi + 'Contractor/GetPremierTier',
            method: 'GET'
        }).then(function (response) {
            _premierTier = response.data.Data;
            return _premierTier;
        }).catch(function (response) {
            return $q.reject(response.data.Data);
        });
    }

    function convertRatePlanDates(ratePlan) {
        _lodash2.default.each(ratePlan.PlanTermSets, function (rates) {
            if (rates.DisplayDate) {
                rates.DisplayDate = new Date(rates.DisplayDate);
            }
            if (rates.EndDate) {
                rates.EndDate = new Date(rates.EndDate);
            }
            if (rates.StartDate) {
                rates.StartDate = new Date(rates.StartDate);
            }
        });
    }

    function setAllRates(data) {
        if (!_lodash2.default.isEmpty(data) && data[0].TermSets !== undefined) {
            if (_allRates[data[0].StateGeoId] !== undefined) {
                _allRates[data[0].StateGeoId] = {};
            }

            var tempArray = [];

            _lodash2.default.each(data[0].TermSets, function (rate) {
                if (!_lodash2.default.isEmpty(_currentRates) && !_lodash2.default.isEmpty(_currentRates[data[0].StateGeoId]) && rate.TermSetId === _currentRates[data[0].StateGeoId].TermSetId) {
                    tempArray.unshift(rate);
                    rate.status = 'current';
                } else {
                    tempArray.push(rate);
                    rate.status = '';
                }
                convertRatePlanDates(rate);
                rate.isSelected = false;
            });

            _allRates[data[0].StateGeoId] = tempArray;
        }
    }

    function getAllRates(stateGeoId) {
        return _allRates[stateGeoId];
    }

    function setSelectedRates(selectedRates, stateGeoId) {
        _lodash2.default.each(_allRates[stateGeoId], function (rate) {
            if (rate.TermSetId === selectedRates.TermSetId) {
                rate.isSelected = true;
            } else {
                rate.isSelected = false;
            }
        });

        if (selectedRates !== undefined) {
            if (_selectedRates[stateGeoId] !== undefined) {
                _selectedRates[stateGeoId] = {};
            }
            _selectedRates[stateGeoId] = selectedRates;
        }
    }

    function getSelectedRates(stateGeoId) {
        if (stateGeoId === undefined) {
            return _selectedRates;
        }

        return _selectedRates[stateGeoId];
    }

    function resetSelectedRates() {
        _selectedRates = {};
    }

    function confirmRates(selectedDate) {
        return $http({
            url: HPConfig.heroProApi + 'Organization/ScheduleRates',
            method: 'POST',
            data: {
                SelectedRates: _selectedRates,
                EffectiveDate: selectedDate
            }
        }).then(function (response) {
            angular.copy(_selectedRates, _scheduledRates);
            _selectedRates = {};
            return response.data.Data;
        }).catch(function (response) {
            return $q.reject(response.data);
        });
    }
}

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TermSetDirective;
function TermSetDirective() {
    return {
        restrict: 'E',
        controller: 'TermSetController',
        controllerAs: 'termSet',
        template: __webpack_require__(380), // eslint-disable-line global-require
        bindToController: true,
        scope: {
            hasSelectColumn: '=',
            isSelectable: '=',
            isSelected: '=',
            status: '=',
            termSetData: '=',
            state: '=',
            premierTier: '='
        }
    };
}

// export default angular.module('directives.termSetDirective',[])
//     .directive('termSet', TermSetDirective)
//     .name;

/***/ }),
/* 380 */
/***/ (function(module, exports) {

module.exports = "<div class=\"term-set\" ng-class=\"{ 'has-select-column' : termSet.hasSelectColumn === true, 'selected' : termSet.isSelected === true }\">\n    <div class=\"term-set-status current\" ng-if=\"termSet.status === 'current'\">\n        <p>Current Rates</p>\n    </div>\n    <p class=\"selected-state\" ng-if=\"termSet.state !== undefined && termSet.status === 'scheduled'\">\n        {{termSet.state.Name}} Rates\n    </p>\n    <div class=\"term-set-status scheduled\" ng-if=\"termSet.status === 'scheduled'\">\n        <p>Pending Rates</p>\n    </div>\n\n    <table>\n        <thead>\n            <tr>\n                <th class=\"term-set-label\">{{termSet.termSetData.TermSetName}}</th>\n                <th class=\"term-set-value\">5 years</th>\n                <th class=\"term-set-value\">10 years</th>\n                <th class=\"term-set-value\">15 years</th>\n                <th class=\"term-set-value\">20 years</th>\n                <th class=\"term-set-value\">25 years</th>\n                <th class=\"term-set-action\" ng-if=\"termSet.hasSelectColumn === true\"></th>\n            </tr>\n        </thead>\n        <tbody>\n            <tr ng-repeat-start=\"rates in termSet.termSetData.PlanTermSets\">\n                <td ng-if=\"$first && rates.StartDate <= termSet.today && termSet.termSetData.PlanTermSets.length > 1\" colspan=\"7\" class=\"new-rates\">\n                    RATES/FEES IN EFFECT THROUGH {{ rates.EndDate.toLocaleDateString() }}\n                </td>\n                <td ng-if=\"$first && rates.StartDate > termSet.today\" colspan=\"7\" class=\"new-rates\">\n                    RATES/FEES AVAILABLE STARTING {{ rates.StartDate.toLocaleDateString() }}\n                </td>\n                <td ng-if=\"!$first\" colspan=\"7\" class=\"new-rates\">\n                    RATES/FEES IN EFFECT STARTING {{ rates.StartDate.toLocaleDateString() }}\n                </td>\n            </tr>\n            <tr>\n                <td class=\"term-set-label\">Interest rate</td>\n                <td class=\"term-set-value\">{{rates.Terms[0].InterestRate | dashPercentage}}</td>\n                <td class=\"term-set-value\">{{rates.Terms[1].InterestRate | dashPercentage}}</td>\n                <td class=\"term-set-value\">{{rates.Terms[2].InterestRate | dashPercentage}}</td>\n                <td class=\"term-set-value\">{{rates.Terms[3].InterestRate | dashPercentage}}</td>\n                <td class=\"term-set-value\">{{rates.Terms[4].InterestRate | dashPercentage}}</td>\n                <td class=\"term-set-action\" ng-if=\"termSet.hasSelectColumn === true && $first\">\n                    <button class=\"btn btn-default\" ng-class=\"{ 'selected' : termSet.isSelected === true }\" ng-if=\"termSet.isSelectable === true\" ng-click=\"termSet.termSetSelected(termSet, financingTermsModal.selectedState)\">\n                        <p>\n                            <span ng-if=\"termSet.isSelected === true\">Selected</span>\n                            <span ng-if=\"termSet.isSelected === false\">Select</span>\n                        </p>\n                    </button>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"term-set-label\">Contractor fee</td>\n                <td class=\"term-set-value\">{{rates.Terms[0].BuydownRate | dashPercentage}}</td>\n                <td class=\"term-set-value\">{{rates.Terms[1].BuydownRate | dashPercentage}}</td>\n                <td class=\"term-set-value\">{{rates.Terms[2].BuydownRate | dashPercentage}}</td>\n                <td class=\"term-set-value\">{{rates.Terms[3].BuydownRate | dashPercentage}}</td>\n                <td class=\"term-set-value\">{{rates.Terms[4].BuydownRate | dashPercentage}}</td>\n                <td class=\"term-set-action\" ng-if=\"termSet.hasSelectColumn === true\"></td>\n            </tr>\n            <tr ng-if=\"termSet.premierTier.BuydownRateDiscountRate > 0\">\n                <td class=\"term-set-label\">Contractor fee discount rate</td>\n                <td class=\"term-set-value\">{{ termSet.premierTier.BuydownRateDiscountRate | dashPercentage }}</td>\n                <td class=\"term-set-value\">{{ termSet.premierTier.BuydownRateDiscountRate | dashPercentage }}</td>\n                <td class=\"term-set-value\">{{ termSet.premierTier.BuydownRateDiscountRate | dashPercentage }}</td>\n                <td class=\"term-set-value\">{{ termSet.premierTier.BuydownRateDiscountRate | dashPercentage }}</td>\n                <td class=\"term-set-value\">{{ termSet.premierTier.BuydownRateDiscountRate | dashPercentage }}</td>\n            </tr>\n            <tr ng-repeat-end ng-if=\"termSet.premierTier.BuydownRateDiscountRate > 0\">\n                <td class=\"term-set-label\">Fee after discount applied</td>\n                <td class=\"term-set-value\">{{ termSet.rateAfterDiscount(rates.Terms[0].BuydownRate, termSet.premierTier.BuydownRateDiscountRate) | dashPercentage }}</td>\n                <td class=\"term-set-value\">{{ termSet.rateAfterDiscount(rates.Terms[1].BuydownRate, termSet.premierTier.BuydownRateDiscountRate) | dashPercentage }}</td>\n                <td class=\"term-set-value\">{{ termSet.rateAfterDiscount(rates.Terms[2].BuydownRate, termSet.premierTier.BuydownRateDiscountRate) | dashPercentage }}</td>\n                <td class=\"term-set-value\">{{ termSet.rateAfterDiscount(rates.Terms[3].BuydownRate, termSet.premierTier.BuydownRateDiscountRate) | dashPercentage }}</td>\n                <td class=\"term-set-value\">{{ termSet.rateAfterDiscount(rates.Terms[4].BuydownRate, termSet.premierTier.BuydownRateDiscountRate) | dashPercentage }}</td>\n            </tr>\n        </tbody>\n    </table>\n</div>\n";

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = financingTermsModalController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(382);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

financingTermsModalController.$inject = ['$uibModalInstance', 'FinancingFactory', '$state', '$stateParams', 'DirectiveService', 'FinancingConfig']; // angular
// 	.module("HeroPRO")
// 	.controller("FinancingTermsModalController", financingTermsModalController);

/* @ngInject */
function financingTermsModalController($uibModalInstance, FinancingFactory, $state, $stateParams, DirectiveService, FinancingConfig) {
    var vm = this;

    vm.currentView = 'viewAvailableRates'; // viewAvailableRates || confirmSelectedRates || selectedRatesConfirmed
    vm.states = {};
    vm.selectedRates = {};
    vm.allPlanRates = {};
    vm.scheduledDate = undefined;
    vm.scheduledDatePlaceholder = 'Date';
    vm.datepickerOpen = false;
    vm.selectionError = false;
    vm.phoneNumber = undefined;
    vm.scheduledRates = undefined;
    vm.effectiveDate = null;
    vm.confirmInProgress = false;
    vm.premierTier = {};

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.datepickerMinDate = function () {
        var today = new Date(FinancingFactory.getCurrentDate());
        var firstAvailable = void 0;
        if (!_lodash2.default.isEmpty(vm.selectedRates)) {
            firstAvailable = new Date(vm.selectedRates[vm.selectedState.StateGeoId].FirstAvailableScheduleDate);

            // if the effective date is within two days
            // then default to normal availability of today + 2 days
            var tempDate = new Date();
            if (firstAvailable > tempDate.setDate(tempDate.getDate() + 2)) {
                return firstAvailable;
            }
        }

        firstAvailable = new Date(today.setDate(today.getDate() + 2));
        return firstAvailable;
    };

    vm.datepickerMaxDate = function () {
        var today = new Date(FinancingFactory.getCurrentDate());
        today.setMonth(today.getMonth() + 3);
        return today;
    };

    vm.datepickerOptions = {
        formatDay: 'dd',
        formatMonth: 'MM',
        formatYear: 'yyyy',
        showWeeks: false,
        startingDay: 0,
        minDate: vm.datepickerMinDate(),
        maxDate: vm.datepickerMaxDate()
    };

    vm.switchState = function (state) {
        vm.selectedState = state;
        getAllPlanRates(vm.selectedState.StateGeoId);
    };

    vm.closeModal = function () {
        FinancingFactory.resetSelectedRates();
        $uibModalInstance.close();

        if (vm.currentView === 'selectedRatesConfirmed') {
            $state.go($state.current, $stateParams, { reload: true, inherit: false });
        }
    };

    vm.setCurrentView = function (viewName) {
        vm.currentView = viewName;
    };

    vm.toggleDatepicker = function () {
        vm.datepickerOpen = !vm.datepickerOpen;
    };
    /* -----  End of Public Functions  ------*/

    vm.getState = function (stateGeoId) {
        return _lodash2.default.find(vm.states, function (state) {
            return state.StateGeoId === Number(stateGeoId);
        });
    };

    vm.proceedClicked = function () {
        vm.selectionError = _lodash2.default.isEmpty(FinancingFactory.getSelectedRates());

        if (vm.selectionError === false) {
            vm.selectedRates = FinancingFactory.getSelectedRates();
            vm.datepickerOptions = {
                formatDay: 'dd',
                formatMonth: 'MM',
                formatYear: 'yyyy',
                showWeeks: false,
                startingDay: 0,
                minDate: vm.datepickerMinDate(),
                maxDate: vm.datepickerMaxDate()
            };
            vm.setCurrentView('confirmSelectedRates');
            DirectiveService.publish('scroll');
        }
    };

    vm.confirmClicked = function () {
        if (vm.confirmTermsForm.$valid === true && vm.cb1 && vm.cb2 && vm.cb3 && vm.confirmInProgress === false) {
            vm.confirmInProgress = true;
            FinancingFactory.confirmRates(vm.confirmTermsForm.txtTermsDatepicker.$viewValue).then(function (response) {
                vm.confirmInProgress = false;
                vm.effectiveDate = response.EffectiveDate;
                vm.setCurrentView('selectedRatesConfirmed');
            });
        }
    };

    vm.doneClicked = function () {
        vm.closeModal();
    };

    vm.toggleCheckbox = function (cb) {
        cb = cb ? undefined : true;
    };

    vm.selectedStateHasNewRates = function () {
        return _lodash2.default.find(vm.newRatesConfig.stateGeoIds, function (stateGeoId) {
            return stateGeoId === vm.selectedState.StateGeoId;
        });
    };
    /*= =======================================
    =            Private Functions            =
    ======================================== */
    function init() {
        vm.newRatesConfig = FinancingConfig.newRates;
        vm.phoneNumber = FinancingFactory.getPhoneNumber();
        vm.selectedState = FinancingFactory.getSelectedState();
        getAllPlanRates(vm.selectedState.StateGeoId);
        vm.scheduledRates = FinancingFactory.getScheduledRates();

        FinancingFactory.getPremierTier().then(function (response) {
            vm.premierTier = response;
        });
    }

    function getAllPlanRates(stateGeoId) {
        FinancingFactory.getAllPlanRates(stateGeoId).then(function () {
            vm.allPlanRates = FinancingFactory.getAllRates(stateGeoId);
        });
    }
    /* -----  End of Private Functions  ------*/

    init();
}

/***/ }),
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var HPAppDetailTypes = {
    TermSetTypes: {
        Default: 1,
        BuyDown: 2
    },
    Programs: {
        WRCOG: 1,
        SANBAG: 2,
        LACounty: 3,
        MCED: 4,
        FDFC: 5,
        CSCDA: 6
    }
};

exports.default = HPAppDetailTypes;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var FinancingConfig = {
    newRates: {
        effectiveDate: '', // Effective date of new rates. Set to empty string if there are no new rates scheduled
        stateGeoIds: [] // States where new rates will be made avaialble. Set to empty array if there are no new rates scheduled
    }
};

exports.default = FinancingConfig;

/***/ }),
/* 385 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"financing.isEmptyStates() === true\" class=\"financing-header-container financing-header-container-border\">\n    <h4 class=\"text-center\">\n        For your current rates, call {{financing.phoneNumber}}\n    </h4>\n</div>\n\n<div ng-if=\"financing.isRateChangeScheduled && financing.isCompanyAdmin\" class=\"row financing-header-container financing-header-container-border\">\n    <div class=\"col-md-8 col-md-offset-2\">\n        <p class=\"text-center\">\n            Thanks for choosing your new rates. The pending rate plan will take effect as early as {{financing.effectiveDate | date : \"shortDate\" }}.\n        </p>\n\n        <!-- Additional message when new rates are going to take effect on a certain date  -->\n        <p class=\"text-center\" ng-if=\"financing.newRatesConfig.effectiveDate !== '' && financing.selectedStateHasNewRates() !== undefined\">\n            Please note, if you've selected a date after {{financing.newRatesConfig.effectiveDate}} for your new rate plan to take effect, the rates/fees on your current rate plan will still be updated to the new rates/fees for that plan as of {{financing.newRatesConfig.effectiveDate}}.\n        </p>\n        <!-- Additional message when new rates are going to take effect on a certain date  -->\n\n        <p class=\"text-center secondary-text\">\n            If you have any questions, please call {{financing.phoneNumber}}.\n        </p>\n    </div>\n</div>\n\n<!-- Show the whole section only if there are service states -->\n<div ng-show=\"financing.isEmptyStates() === false\">\n    <div class=\"term-set-header\">\n        <h4 ng-if=\"financing.states.length === 1\">{{financing.selectedState.Name | capitalize }} rates</h4>\n        <div ng-if=\"financing.states.length > 1\" class=\"dropdown\" uib-dropdown dropdown-small-popup dropdown-title=\"States\" ng-show=\"financing.selectedState\">\n            <a id=\"ddl-state\" blur-element class=\"dropdown-toggle\" uib-dropdown-toggle data-toggle=\"dropdown\">\n                <span class=\"dropdown-text\">{{financing.selectedState.Name | capitalize }} Rates</span>\n                <span class=\"icon\"></span>\n            </a>\n            <ul class=\"dropdown-menu address-breakdown-small\" uib-dropdown-menu>\n                <li ng-repeat=\"state in financing.states\"\n                    ng-class=\"{'active': financing.selectedState.StateGeoId === state.StateGeoId }\"\n                    ng-click=\"financing.stateClicked(state)\">\n                    <span>{{state.Name | capitalize}} Rates</span>\n                </li>\n            </ul>\n        </div>\n        <button ng-class=\"{'hide-edit-rates': !financing.allowRateChange()}\" ng-click=\"financing.openFinancingTermsModal();\" class=\"btn btn-default pull-right\">\n            Choose New Rates\n        </button>\n    </div>\n\n    <div class=\"term-set-container\">\n        <term-set ng-if=\"financing.currentRates !== undefined\" has-select-column=\"false\" is-selectable=\"false\" is-selected=\"false\" status=\"'current'\" term-set-data=\"financing.currentRates\" premier-tier=\"financing.premierTier\"></term-set>\n        <term-set ng-if=\"financing.scheduledRates !== undefined\" has-select-column=\"false\" is-selectable=\"false\" is-selected=\"false\" status=\"'scheduled'\" term-set-data=\"financing.scheduledRates\" premier-tier=\"financing.premierTier\"></term-set>\n    </div>\n</div>\n";

/***/ }),
/* 386 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"financingTermsModal.currentView ==='confirmSelectedRates'\">\n    <p class=\"modal-title\">Confirm new interest rates</p>\n    <h4>Selected new Rate Plan</h4>\n    <div class=\"selected-rate-container\">\n        <term-set ng-repeat=\"(stateGeoId, scheduledRate) in financingTermsModal.selectedRates\"\n                  has-select-column=\"false\" is-selectable=\"false\" is-selected=\"false\" status=\"'scheduled'\" term-set-data=\"scheduledRate\" state=\"financingTermsModal.getState(stateGeoId)\" premier-tier=\"financingTermsModal.premierTier\">\n        </term-set>\n    </div>\n    <form name=\"financingTermsModal.confirmTermsForm\" novalidate>\n        <h4>Start date</h4>\n        <p>Select a date for this term set to take effect:</p>\n        <div class=\"date-picker\">\n            <input id=\"txt-terms-datepicker\" name=\"txtTermsDatepicker\" class=\"form-control filter-date-field\" type=\"text\" ng-class=\"{'datepicker-open': financingTermsModal.datepickerOpen}\"\n                   maxlength=\"10\" placeholder=\"{{financingTermsModal.scheduledDatePlaceholder}}\"\n                   readonly required ng-click=\"financingTermsModal.toggleDatepicker($event)\"\n                   ng-model=\"financingTermsModal.scheduledDate\" autocomplete=\"off\" uib-datepicker-popup=\"MM/dd/yyyy\"\n                   datepicker-options=\"financingTermsModal.datepickerOptions\" is-open=\"financingTermsModal.datepickerOpen\" />\n            <div class=\"input-group-btn\">\n                <button type=\"button\" class=\"btn btn-default filter-calendar-btn\" ng-click=\"financingTermsModal.toggleDatepicker($event)\">\n                    <i class=\"glyphicon glyphicon-calendar\"></i>\n                </button>\n            </div>\n        </div>\n        <h4>Acknowledgements</h4>\n        <p>If you agree to the terms below, you can sign your company's updated financing agreement.</p>\n        <div class=\"ack-container\">\n            <div class=\"term-ack\" ng-click=\"financingTermsModal.cb1 = !financingTermsModal.cb1\">\n                <div class=\"term-ack-cb\">\n                    <span class=\"icon icon-complete\" ng-if=\"financingTermsModal.cb1\"></span>\n                    <span class=\"empty-checkbox\" ng-if=\"!financingTermsModal.cb1\" ng-model=\"financingTermsModal.cb1\" required></span>\n                </div>\n                <div class=\"term-ack-statement\">\n                    <label for=\"cb1\">Registered Contractor agrees to pay Renovate America the applicable Contractor Fee associated with the Rate Plan that I have selected on behalf of Registered Contractor.</label>\n                </div>\n            </div>\n\n            <div class=\"term-ack\" ng-click=\"financingTermsModal.cb2 = !financingTermsModal.cb2\">\n                <div class=\"term-ack-cb\">\n                    <span class=\"icon icon-complete\" ng-if=\"financingTermsModal.cb2\"></span>\n                    <span class=\"empty-checkbox\" ng-if=\"!financingTermsModal.cb2\" ng-model=\"financingTermsModal.cb2\" required></span>\n                </div>\n                <div class=\"term-ack-statement\">\n                    <label for=\"cb2\">Registered Contractor agrees that, with respect to each project for which Registered Contractor pays a Contractor Fee, Registered Contractor shall not include, add, charge, or otherwise transfer the cost of any Contractor Fee to the respective homeowner.</label>\n                </div>\n            </div>\n\n            <div class=\"term-ack\" ng-click=\"financingTermsModal.cb3 = !financingTermsModal.cb3\">\n                <div class=\"term-ack-cb\">\n                    <span class=\"icon icon-complete\" ng-if=\"financingTermsModal.cb3\"></span>\n                    <span class=\"empty-checkbox\" ng-if=\"!financingTermsModal.cb3\" ng-model=\"financingTermsModal.cb3\" required></span>\n                </div>\n                <div class=\"term-ack-statement\">\n                    <label for=\"cb3\">Registered Contractor acknowledges that the selected Rate Plan shall take effect no earlier than <span class=\"scheduled-date\">{{financingTermsModal.scheduledDate | date : \"MMMM d, y\"}}</span><span class=\"scheduled-date\" ng-show=\"!financingTermsModal.scheduledDate\">selected date</span>, and will remain in effect for ninety (90) calendar days, at which time Registered Contractor may continue with the selected Rate Plan, or may select a new Rate Plan.</label>\n                </div>\n            </div>\n        </div>\n        <div class=\"button-container text-center\">\n            <div class=\"error-message text-center\" ng-if=\"(financingTermsModal.confirmTermsForm.$invalid || !financingTermsModal.cb1 || !financingTermsModal.cb2 || !financingTermsModal.cb3) && financingTermsModal.confirmTermsForm.$submitted\">\n                <p>You must select a date for this Rate Plan to take effect and agree to all of the terms above.</p>\n            </div>\n            <button class=\"btn btn-default\" ng-click=\"financingTermsModal.setCurrentView('viewAvailableRates')\">Edit Rates</button>\n\n            <hp-spinner-button button-text=\"Confirm\" button-name=\"btnConfirmRates\" is-primary-btn=\"true\" is-submit-button=\"true\" display-spinner=\"financingTermsModal.confirmInProgress === true\" button-fn=\"financingTermsModal.confirmClicked()\"></hp-spinner-button>\n            <!--<input class=\"btn btn-primary\" type=\"submit\" value=\"Confirm\" ng-click=\"financingTermsModal.confirmClicked()\" />-->\n        </div>\n    </form>\n</div>";

/***/ }),
/* 387 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\" modal-scroll-to-top>\n    <span class=\"icon icon-delete\" ng-click=\"financingTermsModal.closeModal()\"></span>\n</div>\n\n<div class=\"row\">\n    <div class=\"col-md-10 col-md-offset-1\">\n        <div class=\"modal-body\">\n            <ng-include ng-if=\"financingTermsModal.currentView === 'viewAvailableRates'\" src=\"'app/accounts/financing/financingTermsModal/viewAvailableRates.html'\"></ng-include>\n            <ng-include ng-if=\"financingTermsModal.currentView === 'confirmSelectedRates'\" src=\"'app/accounts/financing/financingTermsModal/confirmSelectedRates.html'\"></ng-include>\n            <ng-include ng-if=\"financingTermsModal.currentView === 'selectedRatesConfirmed'\" src=\"'app/accounts/financing/financingTermsModal/selectedRatesConfirmed.html'\"></ng-include>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 388 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"financingTermsModal.currentView ==='selectedRatesConfirmed'\" class=\"full-screen-modal-success\">\n    <p class=\"modal-title\">Interest rates confirmed</p>\n    <div class=\"row row-modal-success\">\n        <div class=\"col-md-8 col-md-offset-2 text-center\">\n            <span class=\"icon icon-todo\"></span>\n            <p class=\"secondary-text\">\n                Thanks for choosing your new rates. The pending rate plan will take effect as early as {{financingTermsModal.effectiveDate | date : \"shortDate\" }}.\n            </p>\n            <p class=\"secondary-text\" ng-if=\"financingTermsModal.newRatesConfig.effectiveDate !== '' && financingTermsModal.selectedStateHasNewRates() !== undefined\">\n                Please note, if you've selected a date after {{financingTermsModal.newRatesConfig.effectiveDate}} for your new rate plan to take effect, the rates/fees on your current rate plan will still be updated to the new rates/fees for that plan as of {{financingTermsModal.newRatesConfig.effectiveDate}}.\n            </p>            \n        </div>\n    </div>\n\n    <div class=\"selected-rate-container\">\n        <term-set ng-repeat=\"(stateGeoId, scheduledRate) in financingTermsModal.scheduledRates\"\n            has-select-column=\"false\" is-selectable=\"false\" is-selected=\"false\" status=\"'scheduled'\" term-set-data=\"scheduledRate\" state=\"financingTermsModal.getState(stateGeoId)\">\n        </term-set>\n    </div>\n\n    <div class=\"row-modal-message\">\n        <p class=\"text-center\">If you have any questions, please call {{financingTermsModal.phoneNumber}}.</p>\n    </div>\n\n    <div class=\"button-container text-center\">\n        <button class=\"btn btn-primary\" ng-click=\"financingTermsModal.doneClicked()\">Done</button>\n    </div>\n</div>";

/***/ }),
/* 389 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"financingTermsModal.currentView ==='viewAvailableRates'\">\n    <p class=\"modal-title\">Select a rate plan</p>\n    <p class=\"view-rates-message\">\n        The Rate Plan will be in effect for ninety (90) calendar days, starting the day after you make your selection. After ninety (90) calendar days, Registered Contractor may continue with the selected Rate Plan, or may select a new Rate Plan.\n    </p>\n\n    <p class=\"view-rates-message\">\n        Renovate America offers volume discounts. To learn more about our discount program, please click <a href=\"http://go.renovateamerica.com/co/premier-dealer-program\" target=\"_blank\">here</a>\n    </p>\n\n    <div class=\"states-nav navbar\">\n        <ul class=\"nav navbar-nav\">\n            <li>\n                <a href=\"#\">\n                    <span class=\"active\">{{financingTermsModal.selectedState.Name}}</span>\n                </a>\n            </li>\n        </ul>\n    </div>\n\n    <div ng-repeat=\"planRates in financingTermsModal.allPlanRates\">\n        <term-set has-select-column=\"true\" is-selectable=\"planRates.status === ''\" is-selected=\"planRates.isSelected\" status=\"planRates.status\" term-set-data=\"planRates\" state=\"financingTermsModal.selectedState\" premier-tier=\"financingTermsModal.premierTier\"></term-set>\n    </div>\n\n    <div class=\"button-container text-center\">\n        <p ng-if=\"financingTermsModal.selectionError === true\" class=\"selection-error\">You must select a new Rate Plan before proceeding.</p>\n        <button class=\"btn btn-default\" ng-click=\"financingTermsModal.closeModal()\">Cancel</button>\n        <button class=\"btn btn-primary\" ng-click=\"financingTermsModal.proceedClicked()\">Proceed</button>\n    </div>\n</div>\n";

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _licensesFactory = __webpack_require__(391);

var _licensesFactory2 = _interopRequireDefault(_licensesFactory);

var _licensesUtilityFactory = __webpack_require__(392);

var _licensesUtilityFactory2 = _interopRequireDefault(_licensesUtilityFactory);

var _licensesTableController = __webpack_require__(393);

var _licensesTableController2 = _interopRequireDefault(_licensesTableController);

var _addLicenseController = __webpack_require__(394);

var _addLicenseController2 = _interopRequireDefault(_addLicenseController);

var _addCALicenseController = __webpack_require__(397);

var _addCALicenseController2 = _interopRequireDefault(_addCALicenseController);

var _addFLLicenseController = __webpack_require__(399);

var _addFLLicenseController2 = _interopRequireDefault(_addFLLicenseController);

var _deleteLicenseController = __webpack_require__(401);

var _deleteLicenseController2 = _interopRequireDefault(_deleteLicenseController);

__webpack_require__(403);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// no controller to import this from

exports.default = _angular2.default.module('app.accounts.licenses', []).controller('LicensesTableController', _licensesTableController2.default).controller('AddLicenseController', _addLicenseController2.default).controller('AddFLLicenseController', _addFLLicenseController2.default).controller('AddCALicenseController', _addCALicenseController2.default).controller('DeleteLicenseController', _deleteLicenseController2.default).factory('LicensesFactory', _licensesFactory2.default).factory('LicensesUtilityFactory', _licensesUtilityFactory2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/accounts/licenses/licensesTable/licensesTable.html', __webpack_require__(404)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/licenses/addLicense/addLicense.html', __webpack_require__(405)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/licenses/addLicense/businessLicense/addBusinessLicense.html', __webpack_require__(406)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/licenses/addLicense/FL/licenseFL.html', __webpack_require__(407));
    $templateCache.put('app/accounts/licenses/deleteLicense/deleteLicense.html', __webpack_require__(408));
}]).name;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = licensesFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

licensesFactory.$inject = ['$http', '$q', 'moment', 'HPConfig', 'LicenseTemplateUrls', 'LicenseTypes'];


/* @ngInject */
function licensesFactory($http, $q, moment, HPConfig, LicenseTemplateUrls, LicenseTypes) {
    return {
        getLicenses: getLicenses,
        deleteLicense: deleteLicense,
        getActiveStates: getActiveStates,
        validateLicense: validateLicense,
        addLicense: addLicense,
        licenseUpdateValidation: licenseUpdateValidation,
        updateLicense: updateLicense
    };

    function getLicenses(organizationId) {
        return $http({
            url: HPConfig.heroProApi + 'Contractor/Licenses',
            method: 'GET',
            params: {
                OrganizationId: organizationId
            }
        });
    }

    function deleteLicense(params) {
        return $http({
            url: HPConfig.heroProApi + 'Contractor/DeleteLicense',
            method: 'POST',
            data: params
        });
    }
    function processActiveStates(states) {
        _lodash2.default.each(states, function (state) {
            _lodash2.default.extend(state, {
                Url: LicenseTemplateUrls[state.StateCode] || LicenseTemplateUrls[state.LicenseTypes[0].LicenseCategoryTypeId] || ''
            });
        });

        return states;
    }

    function getActiveStates() {
        var deferred = $q.defer();

        $http.get(HPConfig.heroProApi + 'Contractor/LicensePageData').then(function (data) {
            deferred.resolve(processActiveStates(data.data.LicenseTypes.LicenseStates));
        });

        return deferred.promise;
    }

    function validateLicense(licenseNumber, licenseType, contractorId, jurisdiction, expiration) {
        var data = {
            LicenseNumber: licenseNumber,
            LicenseTypeId: licenseType,
            EnsureUnique: true,
            ContractorLocationId: contractorId,
            LicenseExpirationDate: expiration || null,
            Jurisdiction: jurisdiction || null
        };

        return $http.post(HPConfig.heroProApi + 'Contractor/validateLicense', data);
    }

    function convertToISO(date) {
        if (date === null || date.length < 8) {
            return null;
        } else if (date && date.length === 10) {
            var exp = date.split('-');
            var exp2 = date.split('/');

            return exp.length > 1 ? exp[exp.length - 1] + '-' + exp[0] + '-' + exp[exp.length - 2] : exp2[exp2.length - 1] + '-' + exp2[0] + '-' + exp2[exp2.length - 2];
        }
        return date.substring(4) + '-' + date.substring(0, 2) + '-' + date.substring(2, 4);
    }

    function processLicenseData(contractorId, orgId, licenseType, licenseNumber, expiration, integrationType, jurisdiction) {
        var request = {
            ContractorLocationId: contractorId,
            License: {
                OrganizationId: orgId,
                OrganizationLicenseTypeId: licenseType,
                LicenseNumber: licenseNumber,
                IntegrationType: integrationType,
                Jurisdiction: jurisdiction,
                LicenseExpireDate: null,
                OrganizationLicenseStatusId: 1 // valid license
            },
            Document: null
        };

        if (expiration && moment(convertToISO(expiration)).isValid) {
            request.License.LicenseExpireDate = moment(convertToISO(expiration));
        }

        return request;
    }

    function addLicense(contractorId, orgId, licenseType, licenseNumber, expiration, integrationType, jurisdiction) {
        var data = processLicenseData(contractorId, orgId, licenseType, licenseNumber, expiration, integrationType, jurisdiction);

        return $http.post(HPConfig.heroProApi + 'Contractor/AddLicense', data);
    }

    function licenseUpdateValidation(licenseTypeId) {
        return licenseTypeId !== LicenseTypes.CSLB || licenseTypeId !== LicenseTypes.CILB;
    }

    function updateLicense(contractorId, orgId, licenseId, licenseType, licenseNumber, expiration, integrationType, jurisdiction) {
        var data = processLicenseData(contractorId, orgId, licenseType, licenseNumber, expiration, integrationType, jurisdiction);
        data.License.OrganizationLicenseId = licenseId;

        return $http.post(HPConfig.heroProApi + 'Contractor/UpdateLicense', data);
    }
}

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = LicensesUtilityFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

LicensesUtilityFactory.$inject = ['moment', 'LicenseRejectReasons', 'LicenseTypes', 'LicenseIntegrationTypes'];


/* @ngInject */
function LicensesUtilityFactory(moment, LicenseRejectReasons, LicenseTypes, LicenseIntegrationTypes) {
    return {
        getStreetAddress: getStreetAddress,
        getCityState: getCityState,
        getOwnerNames: getOwnerNames,
        getLicenseType: getLicenseType,
        getRegjectionMsg: getRegjectionMsg,
        isDateEmpty: isDateEmpty,
        licenseExists: licenseExists,
        validate: validate,
        validateExpirationDate: validateExpirationDate,
        validateLicenseExists: validateLicenseExists
    };

    function getStreetAddress(bizInfo) {
        var address = '';

        address += bizInfo.Address1;

        if (bizInfo.Address2 !== '') {
            address += ' ' + bizInfo.Address2;
        }

        return address;
    }

    function getCityState(bizInfo) {
        return bizInfo.City + ', ' + bizInfo.State + ' ' + bizInfo.Zip;
    }

    function getOwnerNames(owners, stateId) {
        var names = [];

        switch (stateId) {
            case 6:
                _lodash2.default.each(owners, function (owner) {
                    var name = '' + owner.FirstName;

                    if (owner.hasOwnProperty('MiddleName') && owner.MiddleName !== '') {
                        name += ' ' + owner.MiddleName;
                    }

                    name += ' ' + owner.LastName;

                    names.push({
                        Name: name
                    });
                });
                break;
            case 12:
                _lodash2.default.each(owners, function (owner) {
                    // var nomes = owner.Licensee.split(',');
                    // var name = '' + nomes[1].trim() + " " + nomes[0].trim();
                    names.push({
                        Name: owner.Licensee
                    });
                });
                break;
            default:
                break;
        }

        return names;
    }

    function getRegjectionMsg(rejectionId, data) {
        var msg = data.RejectReason && data.Messages ? data.Messages.length > 0 ? data.Messages[0] : null : null;

        if (!msg) {
            switch (rejectionId) {
                case LicenseRejectReasons.Duplicate.Id:
                    msg = LicenseRejectReasons.Duplicate.Msg;
                    break;
                case LicenseRejectReasons.NotUnique.Id:
                    if (angular.isUndefined(data.Messages)) {
                        msg = LicenseRejectReasons.NotUnique.Msg;
                    }
                    break;
                default:
                    msg = LicenseRejectReasons.LicenseNotValid.Msg;
                    break;
            }
        }

        return msg;
    }

    function licenseExists(licenseNumber, licenses) {
        var filtered = _lodash2.default.filter(licenses, function (license) {
            return license.LicenseNumber === licenseNumber;
        });

        return filtered.length > 0;
    }

    function validate(licenseType, licenseNumber, expiration) {
        if (licenseType && licenseType.LicenseCategoryTypeId) {
            // License is not required
            return true;
        }

        return validateLB(licenseNumber, expiration);
    }

    function validateExpirationDate(expiration) {
        var today = moment().format('YYYY-MM-DD');
        var expireDate = moment(convertToDate(expiration));
        return !expiration || expireDate.isValid() && expireDate.isAfter(today, 'day');
    }

    function getLicenseType(licenseCategoryTypeId) {
        var licenseType = '';

        switch (licenseCategoryTypeId) {
            case LicenseTypes.Contractor:
                licenseType = 'contractor license.';
                break;
            default:
                licenseType = 'business license.';
                break;
        }

        return licenseType;
    }

    function isDateEmpty(date) {
        if (!date || angular.isUndefined(date)) {
            return true;
        } else if (date.length < 8) {
            return true;
        }
        return false;
    }

    /* private functions */

    function convertToDate(expirationDate) {
        if (!expirationDate || expirationDate.length < 8) {
            return null;
        }

        if (expirationDate.length === 10) {
            var exp = expirationDate.split('-');
            var exp2 = expirationDate.split('/');

            return exp.length > 1 ? exp[exp.length - 1] + '-' + exp[0] + '-' + exp[exp.length - 2] : exp2[exp2.length - 1] + '-' + exp2[0] + '-' + exp2[exp2.length - 2];
        }

        if (expirationDate.length === 8) {
            return expirationDate.substring(4) + '-' + expirationDate.substring(0, 2) + '-' + expirationDate.substring(2, 4);
        }

        return expirationDate;
    }

    function validateLB(licenseNumber, expiration) {
        return licenseNumber && validateExpirationDate(expiration);
    }

    /* function validateDocument(document) {
        if (document.DocumentType !== LicenseAttachmentTypes.BusinessLicense) {
            return false;
        }
        if (angular.isUndefined(document.FileName) || document.FileName === null || document.FileName === '') {
            return false;
        }
        if (angular.isUndefined(document.Url) || document.Url === null || document.Url === '') {
            return false;
        }
         return true;
    } */

    function validateLicenseExists(edit, license, licenses) {
        var exists = _lodash2.default.filter(licenses, function (l) {
            return l.LicenseNumber.toUpperCase() === (license.licenseNumber || '').toUpperCase();
        } // l.OrganizationLicenseTypeId === license.licenseTypeId;  //l.LicenseNumber === license.licenseNumber && l.StateGeoId === license.stateId
        );

        if (exists.length === 0) {
            return true;
        }

        var isUnique = _lodash2.default.filter(exists, function (e) {
            return e.OrganizationLicenseTypeId === license.licenseTypeId;
        });

        if (edit && isUnique.length > 0) {
            var isSame = _lodash2.default.filter(isUnique, function (u) {
                return u.OrganizationLicenseId === license.licenseId && u.LicenseNumber.toUpperCase() === license.licenseNumber.toUpperCase();
            });

            return isSame.length === 1;
        }

        return isUnique.length === 0;
    }
}

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = licensesTableController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

licensesTableController.$inject = ['$state', 'LicensesFactory', 'LicenseTypes', '$scope', 'UserData', 'ModalService', 'moment']; // angular
// .module("HeroPRO")
// .controller("LicensesTableController",licensesTableController);

/* @ngInject */
function licensesTableController($state, LicensesFactory, LicenseTypes, $scope, UserData, ModalService, moment) {
    var vm = this;
    vm.licenseList = [];
    vm.licenseLength = 0;
    vm.licensesHeader = '';
    vm.loadingLicenses = true;
    vm.ContractorId = -1;
    vm.OrganizationId = -1;
    init();
    vm.expireText = function (row) {
        var today = new Date();
        if (row.LicenseExpireDate && row.LicenseExpireDate < today.getDate()) {
            return 'Expired';
        } else if (row.LicenseExpireDate && row.LicenseExpireDate > today.getDate()) {
            return 'Expires';
        }
        return '';
    };

    vm.CanBeEdited = function (license) {
        var editable = true;

        switch (license.OrganizationLicenseTypeId) {
            case LicenseTypes.CSLB:
            case LicenseTypes.CILB:
                editable = false;
                break;
            default:
                break;
        }

        return editable;
    };

    vm.deleteLicense = function (license) {
        var licenseInfo = {
            ContractorLocationId: vm.ContractorId,
            OrganizationId: vm.OrganizationId,
            OrganizationLicenseId: license.OrganizationLicenseId,
            State: license.State
        };
        var modal = ModalService.launchLgModal({
            templateUrl: 'app/accounts/licenses/deleteLicense/deleteLicense.html',
            windowClass: 'delete-license',
            controller: 'DeleteLicenseController',
            controllerAs: 'deleteLicense',
            size: 'full-screen',
            resolve: {
                selectedLicense: function selectedLicense() {
                    return licenseInfo;
                }
            }
        });
        modal.result.then(function (result) {
            if (result === true) {
                getLicenses(vm.OrganizationId);
            }
            ModalService.closeLgModal();
        });
    };

    vm.addLicense = function () {
        var modal = ModalService.launchLgModal({
            templateUrl: 'app/accounts/licenses/addLicense/addLicense.html',
            windowClass: 'add-license',
            controller: 'AddLicenseController',
            controllerAs: 'addLicense',
            size: 'full-screen',
            resolve: {
                activeStates: function activeStates() {
                    return filterStates(vm.licenseList);
                },
                contractorId: function contractorId() {
                    return vm.ContractorId;
                },
                organizationId: function organizationId() {
                    return vm.OrganizationId;
                },
                edit: function edit() {
                    return false;
                },
                licenseInfo: function licenseInfo() {
                    return null;
                },
                licenseList: function licenseList() {
                    return vm.licenseList;
                }
            }
        });
        modal.result.then(function (result) {
            if (result === true) {
                getLicenses(vm.OrganizationId);
            }
            ModalService.closeLgModal();
        });
    };

    vm.editLicense = function (license) {
        var modal = ModalService.launchLgModal({
            templateUrl: 'app/accounts/licenses/addLicense/addLicense.html',
            windowClass: 'add-license',
            controller: 'AddLicenseController',
            controllerAs: 'addLicense',
            size: 'full-screen',
            resolve: {
                activeStates: function activeStates() {
                    return LicensesFactory.getActiveStates();
                },
                contractorId: function contractorId() {
                    return vm.ContractorId;
                },
                organizationId: function organizationId() {
                    return vm.OrganizationId;
                },
                edit: function edit() {
                    return true;
                },
                licenseInfo: function licenseInfo() {
                    return license;
                },
                licenseList: function licenseList() {
                    return vm.licenseList;
                }
            }
        });
        modal.result.then(function (result) {
            if (result === true) {
                getLicenses(vm.OrganizationId);
            }
            ModalService.closeLgModal();
        });
    };

    /* Private functions */

    function buildLicenseTableHeader() {
        if (vm.licenseLength < 2) {
            vm.licensesHeader = 'License';
        } else {
            vm.licensesHeader = 'Licenses';
        }
    }

    function init() {
        vm.loadingLicenses = true;
        UserData.getCurrentKBYGLocation().then(function (data) {
            // changed to getCurrentKBYGLocation from getCurrentLocation in case of no location selected.
            vm.OrganizationId = data.OrganizationId;
            vm.ContractorId = data.ContractorId;
            getLicenses(vm.OrganizationId);
        });
    }

    function getLicenses(organizationId) {
        LicensesFactory.getLicenses(organizationId).then(function (response) {
            vm.licenseList = response.data.Data.Licenses;
            _lodash2.default.each(vm.licenseList, function (license, key) {
                license.Expire = moment.isDate(license.LicenseExpireDate) && moment(license.LicenseExpireDate).isBefore() ? 'Expired' : 'Expires';
                license.LicenseType = license.OrganizationLicenseTypeId === 1 ? 'CSLB' : license.LicenseType;
                license.CanBeDeleted = determineDelete(license, key); // license.Licenses > 1 ? true : false;
            });
            vm.licenseLength = vm.licenseList ? vm.licenseList.length : 0;
            buildLicenseTableHeader();
            vm.loadingLicenses = false;
        });
    }

    function filterStates(licenses) {
        return LicensesFactory.getActiveStates().then(function (data) {
            var states = data.data || data;

            if (licenses.length > 0) {
                _lodash2.default.each(licenses, function (exist) {
                    // if there is an Expiration date and the license is NOT expired, remove the corresponding state
                    if (exist.LicenseExpireDate && new Date(exist.LicenseExpireDate) > new Date()) {
                        var index = _lodash2.default.findIndex(states, function (state) {
                            return state.LicenseTypes[0].LicenseTypeId === exist.OrganizationLicenseTypeId;
                        });

                        if (index > -1) {
                            states.splice(index, 1);
                        }
                    }
                });
            }

            return states;
        });
    }

    function determineDelete(license) {
        if (license.Licenses === 1) {
            return false;
        }

        if (license.IntegrationType !== 3 && license.IntegrationType !== 2) {
            return true;
        }

        return false;
    }
}

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = addLicenseController;

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(395);

__webpack_require__(396);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

addLicenseController.$inject = ['$scope', 'LicensesFactory', 'LicensesUtilityFactory', 'LicenseRejectReasons', 'LicenseTypes', 'LicenseIntegrationTypes', '$rootScope', '$window', '$timeout', 'HPGeoStates', '$uibModalInstance', 'raSpinnerService', 'LicenseAttachmentTypes', 'moment', 'activeStates', 'contractorId', 'organizationId', 'edit', 'licenseInfo']; // angular
// 	.module("HeroPRO")
// 	.controller("AddLicenseController", addLicenseController);

/* @ngInject */
function addLicenseController($scope, LicensesFactory, LicensesUtilityFactory, LicenseRejectReasons, LicenseTypes, LicenseIntegrationTypes, $rootScope, $window, $timeout, HPGeoStates, $uibModalInstance, raSpinnerService, LicenseAttachmentTypes, moment, activeStates, contractorId, organizationId, edit, licenseInfo) {
    var orgId = null;
    var vm = this;
    var licenseId = null;

    vm.processing = false;
    vm.states = [];
    vm.selectedState = null;
    vm.contentShown = 'addLicenseInProgress';
    vm.template = '';
    vm.contractorId = null;
    vm.licenseNumber = '';
    vm.jurisdiction = null;
    vm.integrationType = null;
    vm.expiration = null;
    vm.edit = false;
    vm.submitted = false;
    vm.fileUploaded = false;
    vm.loading = false;
    vm.errorMsg = LicenseRejectReasons.Required.Msg;
    vm.showErrorMsg = false;
    vm.isRequired = false;
    vm.action = 'ADD';
    vm.document = {
        DocumentType: LicenseAttachmentTypes.BusinessLicense,
        FileName: null,
        Key: null,
        Url: null
    };

    init();

    vm.closeModal = function () {
        var result = false;
        if (vm.contentShown === 'addLicenseSuccess') {
            result = true;
        }
        raSpinnerService._unregister('addLicenseSpinner');
        $uibModalInstance.close(result);
    };

    vm.submitAddLicense = function () {
        addLicense();
    };

    vm.reset = function () {
        reset();
    };

    vm.validate = function () {
        if (!vm.submitted) {
            vm.showErrorMsg = false;
            return;
        }

        vm.errorMsg = getErrorMsg(LicensesUtilityFactory.validateExpirationDate(vm.expiration), LicensesUtilityFactory.isDateEmpty(vm.expiration), vm.licenseNumber, vm.jurisdiction, vm.selectedState.LicenseTypes[0].LicenseCategoryTypeId);
        vm.showErrorMsg = !LicensesUtilityFactory.validate(vm.selectedState.LicenseTypes[0], vm.licenseNumber, vm.expiration);
    };

    vm.required = function (submited, input) {
        vm.isRequired = false;
        if (!submited) {
            return vm.isRequired;
        }
        var integrationType = vm.selectedState ? vm.selectedState.LicenseTypes[0].IntegrationType : LicenseIntegrationTypes.Business;
        switch (integrationType) {
            case LicenseIntegrationTypes.Contractor:
                vm.isRequired = !!(input === null || input === '');
                break;
            default:
                vm.isRequired = false;
                break;
        }

        return vm.isRequired;
    };

    vm.uploadButtonClicked = function ($event) {
        $event.preventDefault();
    };

    vm.getLicenseType = function (state) {
        return LicensesUtilityFactory.getLicenseType(state.LicenseTypes[0].LicenseCategoryTypeId);
    };

    $scope.$on('HPFileUploaded', function (evt, data) {
        fileUploadComplete(data);
    });

    $scope.$on('HPFileRemoved', function () {
        fileRemoved();

        $timeout(function () {
            if (vm.submitted) {
                vm.errorMsg = !LicensesUtilityFactory.validateExpirationDate(vm.expiration) ? LicenseRejectReasons.ExpirationNotFuture.Msg : LicenseRejectReasons.Required.Msg;
                vm.showErrorMsg = !LicensesUtilityFactory.validate(vm.selectedState.LicenseTypes[0], vm.licenseNumber, vm.expiration);
            }
        }, 0);
    });

    /* private functions */
    function init() {
        vm.states = activeStates;
        vm.contractorId = contractorId;
        orgId = organizationId;
        vm.edit = edit;
        vm.integrationType = licenseInfo ? licenseInfo.IntegrationType : 1;

        if (edit && licenseInfo) {
            vm.action = 'SAVE';
            vm.licenseNumber = licenseInfo.LicenseNumber;
            vm.jurisdiction = licenseInfo.Jurisdiction;
            vm.integrationType = licenseInfo.IntegrationType;
            licenseId = licenseInfo.OrganizationLicenseId;

            setSelectedState(licenseInfo.StateGeoId);

            if (licenseInfo.LicenseExpireDate !== '' && licenseInfo.LicenseExpireDate !== null && _angular2.default.isDefined(licenseInfo.LicenseExpireDate)) {
                vm.expiration = moment(licenseInfo.LicenseExpireDate).format('MM-DD-YYYY');
            }
        }
    }

    function addLicense() {
        vm.processing = true;

        $rootScope.$broadcast('submitted');

        var isExistingLicense = !LicensesUtilityFactory.validateLicenseExists(vm.edit, {
            jurisdiction: vm.jurisdiction,
            licenseNumber: vm.licenseNumber,
            expiration: vm.expiration,
            stateId: vm.selectedState.StateGeoId,
            licenseTypeId: vm.selectedState.LicenseTypes[0].LicenseTypeId,
            licenseId: (licenseInfo || {}).OrganizationLicenseId || null
        }, $scope.$resolve.licenseList);

        if (isExistingLicense) {
            vm.submitted = true;
            vm.errorMsg = LicenseRejectReasons.Duplicate.Msg;
            vm.showErrorMsg = true;
            return;
        }

        var isValidLicense = LicensesUtilityFactory.validate(vm.selectedState.LicenseTypes[0], vm.licenseNumber, vm.expiration);
        if (!isValidLicense) {
            vm.submitted = true;
            vm.errorMsg = LicenseRejectReasons.Required.Msg;

            if (vm.expiration && determineDateValidity(!LicensesUtilityFactory.validateExpirationDate(vm.expiration), vm.licenseNumber, vm.selectedState.LicenseTypes[0].LicenseCategoryTypeId)) {
                vm.errorMsg = getErrorMsg(LicensesUtilityFactory.validateExpirationDate(vm.expiration), vm.licenseNumber, vm.jurisdiction, vm.selectedState.LicenseTypes[0].IntegrationType);
            }

            vm.showErrorMsg = true;
            return;
        }

        vm.showErrorMsg = false;

        if (!vm.contractorId) {
            vm.contractorId = $scope.$resolve.contractorId;
        }

        if (edit && LicensesFactory.licenseUpdateValidation(vm.selectedState.LicenseTypes[0].LicenseTypeId)) {
            LicensesFactory.updateLicense(vm.contractorId, orgId, licenseId, vm.selectedState.LicenseTypes[0].LicenseTypeId, vm.licenseNumber, vm.expiration, vm.selectedState.LicenseTypes[0].IntegrationType, vm.jurisdiction).then(function () {
                vm.submitted = true;
                vm.contentShown = 'addLicenseSuccess';
                vm.closeModal();
            });
        } else {
            LicensesFactory.addLicense(vm.contractorId, orgId, vm.selectedState.LicenseTypes[0].LicenseTypeId, vm.licenseNumber, vm.expiration, vm.selectedState.LicenseTypes[0].IntegrationType, vm.jurisdiction).then(function () {
                vm.submitted = true;
                vm.contentShown = 'addLicenseSuccess';
                vm.closeModal();
            }, function (error) {
                if (error.status === 400) {
                    vm.submitted = true;
                    vm.errorMsg = LicenseRejectReasons.Duplicate.Msg;
                    vm.showErrorMsg = true;
                }
            });
        }
    }

    function reset() {
        vm.contractorId = null;
        vm.licenseNumber = '';
        vm.jurisdiction = null;
        vm.expiration = null;
        vm.submitted = false;
        vm.showErrorMsg = false;

        fileRemoved();

        var dropZone = $window.document.querySelector('#add-license');

        if (dropZone) {
            var scc = _angular2.default.element(dropZone).isolateScope();
            scc.resetDropzone();
        }

        $rootScope.$broadcast('reset');
    }

    function setSelectedState(stateId) {
        var index = _lodash2.default.findIndex(vm.states, function (state) {
            return state.StateGeoId === stateId;
        });

        if (index > -1) {
            vm.selectedState = vm.states[index];
        }
    }

    function fileUploadComplete(args) {
        $timeout(function () {
            vm.document.Key = args[0].Document.DocumentId;
            vm.document.FileName = args[0].Document.CurrentVersion.Filename;
            vm.document.Url = args[0].Document.CurrentVersion.Url;
            vm.fileUploaded = true;
            // vm.loading = false;

            if (vm.submitted) {
                vm.errorMsg = !LicensesUtilityFactory.validateExpirationDate(vm.expiration) && !LicensesUtilityFactory.isDateEmpty(vm.expiration) ? LicenseRejectReasons.ExpirationNotFuture.Msg : LicenseRejectReasons.Required.Msg;
                vm.showErrorMsg = !LicensesUtilityFactory.validate(vm.selectedState.LicenseTypes[0], vm.licenseNumber, vm.expiration);
            }
        }, 0);
    }

    function fileRemoved() {
        $timeout(function () {
            vm.document.Key = null;
            vm.document.FileName = null;
            vm.document.Url = null;
            vm.fileUploaded = false;
        }, 0);
    }

    /* function setDocument(licenseType, document) {
        switch (licenseType) {
            case LicenseTypes.CSLB:
            case LicenseTypes.CILB:
                return null;
            default:
                return document;
        }
    } */

    function determineDateValidity(isExpirationInvalid, licenseNumber, licenseCategory) {
        switch (licenseCategory) {
            case LicenseTypes.Contractor:
                return isExpirationInvalid && licenseNumber;
            default:
                if (isExpirationInvalid && licenseNumber) {
                    return true;
                }
                return false;
        }
    }

    /* function isDocumentEmpty(document) {
        return document.FileName === null;
    } */

    function getErrorMsg(isExpirationValid, isDateEmpty, licenseNumber, licenseCategory) {
        var required = true;
        switch (licenseCategory) {
            /* case LicenseTypes.Business:
                    required = licenseNumber !== null ? false : true;
                    break; */
            default:
                required = licenseNumber === null;
                break;
        }

        return required ? LicenseRejectReasons.Required.Msg : LicenseRejectReasons.ExpirationNotFuture.Msg;
    }
}

/***/ }),
/* 395 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 396 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = AddCALicenseController;

__webpack_require__(398);

AddCALicenseController.$inject = ['$scope', 'LicensesFactory', 'LicenseTypes', 'LicenseRejectReasons', 'moment', 'LicensesUtilityFactory']; // angular
//     .module('HeroPRO')
//     .controller('addCALicenseController', addCALicenseController);

/* @ngInject */
function AddCALicenseController($scope, LicensesFactory, LicenseTypes, LicenseRejectReasons, moment, LicensesUtilityFactory) {
    var vm = this;
    var minLength = 6;

    vm.valid = false;
    vm.submitted = false;
    vm.businessInfo = {};
    vm.owners = [];
    vm.errorMsg = '';
    vm.showError = false;

    vm.validateLicense = function (contractorId, state) {
        vm.valid = false;

        if (state.LicenseTypes[0].LicenseTypeId !== LicenseTypes.CSLB) {
            return;
        }

        if ($scope.addLicense.licenseNumber && $scope.addLicense.licenseNumber.length < minLength) {
            vm.submitted = true;
            return;
        }

        if (!contractorId) {
            contractorId = $scope.$resolve.contractorId;
        }

        $scope.addLicense.loading = true;
        LicensesFactory.validateLicense($scope.addLicense.licenseNumber, LicenseTypes.CSLB, contractorId).then(function (response) {
            vm.submitted = true;
            var data = response.data || response;

            if (LicensesUtilityFactory.licenseExists($scope.addLicense.licenseNumber, $scope.$resolve.licenseList)) {
                vm.showError = true;

                vm.errorMsg = LicensesUtilityFactory.getRegjectionMsg(LicenseRejectReasons.Duplicate.Id, data);
                $scope.addLicense.loading = false;

                return;
            }

            if (data.hasOwnProperty('RejectReason')) {
                vm.showError = true;

                vm.errorMsg = LicensesUtilityFactory.getRegjectionMsg(data.RejectReason, data);
                $scope.addLicense.loading = false;

                return;
            }

            vm.valid = data.hasOwnProperty('Success');

            vm.businessInfo = data.MetaData;

            $scope.addLicense.expiration = moment(vm.businessInfo.ExpireDate).format('MM/DD/YYYY');
            vm.businessInfo.BusinessInfo.Address = LicensesUtilityFactory.getStreetAddress(vm.businessInfo.BusinessInfo);
            vm.businessInfo.BusinessInfo.CityState = LicensesUtilityFactory.getCityState(vm.businessInfo.BusinessInfo);

            if (data.MetaData.hasOwnProperty('OwnerPrincipals')) {
                vm.owners = LicensesUtilityFactory.getOwnerNames(vm.businessInfo.OwnerPrincipals, state.StateGeoId);
            }

            $scope.addLicense.loading = false;
        });
    };

    vm.updateSubmit = function () {
        vm.submitted = false;
        vm.showError = false;
        vm.valid = false;
    };

    vm.resetErrorMsg = function ($event) {
        var element = $event.target;
        if (angular.isDefined(element.value) && element.value !== null && element.value.length > 0) {
            $scope.addLicense.showErrorMsg = false;
        } else {
            $scope.addLicense.showErrorMsg = true;
        }
    };

    $scope.$on('reset', function () {
        vm.updateSubmit();
    });
}

/***/ }),
/* 398 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = addFLLicenseController;

__webpack_require__(400);

addFLLicenseController.$inject = ['$scope', 'LicensesFactory', 'LicenseTypes', 'LicenseRejectReasons', 'moment', 'LicensesUtilityFactory']; // angular
//     .module('HeroPRO')
//     .controller('addFLLicenseController', addFLLicenseController);

/* @ngInject */
function addFLLicenseController($scope, LicensesFactory, LicenseTypes, LicenseRejectReasons, moment, LicensesUtilityFactory) {
    var vm = this;
    var minLength = 3;

    vm.valid = false;
    vm.businessInfo = {};
    vm.owners = [];
    vm.submitted = false;
    vm.errorMsg = '';
    vm.showError = false;

    vm.validateLicense = function (contractorId, state) {
        vm.valid = false;

        if (state.LicenseTypes[0].LicenseTypeId !== LicenseTypes.CILB) {
            return;
        }

        if ($scope.addLicense.licenseNumber && $scope.addLicense.licenseNumber.length < minLength) {
            vm.submitted = true;
            return;
        }

        if (!contractorId) {
            contractorId = $scope.$resolve.contractorId;
        }

        $scope.addLicense.loading = true;
        LicensesFactory.validateLicense($scope.addLicense.licenseNumber, LicenseTypes.CILB, contractorId).then(function (response) {
            vm.submitted = true;
            var data = response.data || response;

            if (LicensesUtilityFactory.licenseExists($scope.addLicense.licenseNumber, $scope.$resolve.licenseList)) {
                vm.showError = true;

                vm.errorMsg = LicensesUtilityFactory.getRegjectionMsg(LicenseRejectReasons.Duplicate.Id, data);
                $scope.addLicense.loading = false;

                return;
            }

            if (!!data.RejectReason) {
                vm.showError = true;

                vm.errorMsg = LicensesUtilityFactory.getRegjectionMsg(data.RejectReason, data);
                $scope.addLicense.loading = false;

                return;
            }

            vm.valid = !!data.Success;

            vm.businessInfo = data.MetaData;

            $scope.addLicense.expiration = moment(vm.businessInfo.ExpireDate).format('MM/DD/YYYY');

            vm.businessInfo.BusinessInfo.Address = LicensesUtilityFactory.getStreetAddress(vm.businessInfo.BusinessInfo);
            vm.businessInfo.BusinessInfo.CityState = LicensesUtilityFactory.getCityState(vm.businessInfo.BusinessInfo);

            if (!!data.MetaData.OwnerPrincipals) {
                vm.owners = LicensesUtilityFactory.getOwnerNames(vm.businessInfo.OwnerPrincipals, state.StateGeoId);
            }

            $scope.addLicense.loading = false;
        });
    };

    vm.resetErrorMsg = function ($event) {
        var element = $event.target;
        if (angular.isDefined(element.value) && element.value !== null && element.value.length > 0) {
            $scope.addLicense.showErrorMsg = false;
        } else {
            $scope.addLicense.showErrorMsg = true;
        }
    };

    vm.updateSubmit = function () {
        vm.submitted = false;
        vm.showError = false;
        vm.valid = false;
    };

    $scope.$on('reset', function () {
        vm.updateSubmit();
    });
}

/***/ }),
/* 400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = deleteLicenseController;

__webpack_require__(402);

deleteLicenseController.$inject = ['$scope', 'selectedLicense', 'LicensesFactory', '$rootScope', '$uibModalInstance']; // angular
// 	.module("HeroPRO")
// 	.controller("DeleteLicenseController", deleteLicenseController);

/* @ngInject */
function deleteLicenseController($scope, selectedLicense, LicensesFactory, $rootScope, $uibModalInstance) {
    var vm = this;
    var license = selectedLicense;
    vm.State = license.State;
    vm.processing = false;
    vm.contentShown = 'deleteLicenseInProgress';
    vm.closeModal = function () {
        var result = false;
        if (vm.contentShown === 'deleteLicenseSuccess') {
            result = true;
        }
        $uibModalInstance.close(result);
    };
    vm.submitDeleteLicense = function () {
        deleteLicense();
    };
    function deleteLicense() {
        vm.processing = true;
        LicensesFactory.deleteLicense(license).then(function () {
            vm.processing = false;
            vm.contentShown = 'deleteLicenseSuccess';
        });
    }
}

/***/ }),
/* 402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 403 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 404 */
/***/ (function(module, exports) {

module.exports = "\n<div class=\"licenses-table-container\" ng-controller=\"LicensesTableController as licensesTable\">\n    <div class=\"row licenses-header-container\">\n        <div class=\"col-md-6\">\n            <h2 ng-bind=\"licensesTable.licensesHeader\"></h2>\n            <p style=\"font-size:12px\">At least one valid license must be provided for each state in which your company does business.</p>\n        </div>\n        <div class=\"col-md-6\" style=\"text-align: right;\">\n            <button class=\"btn btn-default\" id=\"btn-add-license\" ng-click=\"licensesTable.addLicense()\">Add License</button>\n        </div>\n    </div>\n    <div class=\"hp-loading-spinner\" ra-spinner name=\"licensesSpinner\" show=\"licensesTable.loadingLicenses === true\" hide-content-when-shown=\"true\">\n        <div class=\"row licenses-row\" ng-repeat=\"license in licensesTable.licenseList\"\n             ng-class=\"{'licenses-row-border' : $index < licensesTable.licenseLength - 1,'licenses-row-alert':license.Expire==='Expired'}\">\n            <div class=\"row row-right\">\n\n                <div class=\"col-md-2\">\n                    <p ng-bind=\"license.State\"></p>\n                </div>\n                <div class=\"col-md-3\">\n                    <p ng-bind=\"license.LicenseType+' #'\"></p>\n                    <p ng-bind=\"license.LicenseNumber\"></p>\n                </div>\n                <div class=\"col-md-3\">                    \n                    <p ng-bind=\"license.Jurisdiction\"></p>\n                </div>\n                <!--<div class=\"col-md-2\">\n                    &nbsp;\n                </div>-->\n                <div class=\"col-md-2\" ng-class=\"{'expiration-message':license.Expire==='Expired'}\">\n                    <p ng-bind=\"license.Expire\"></p>\n                    <p ng-bind=\"license.LicenseExpireDate  |date:'MM/dd/yyyy'\"></p>\n                </div>\n                <div class=\"col-md-1\">\n                    <div class=\"button-blue\" ng-click=\"licensesTable.editLicense(license);\" ng-show=\"licensesTable.CanBeEdited(license)\"><span class=\"icon icon-edit-thick\"></span><span class=\"link-text\"> Edit</span></div>\n                    <div>&nbsp;</div>\n                </div>\n                <div class=\"col-md-1\">\n                    <div class=\"button-blue\" ng-click=\"licensesTable.deleteLicense(license)\" ng-show=\"license.CanBeDeleted\"><span class=\"icon icon-remove\"></span><span class=\"link-text\"> Delete</span></div>\n                    <div>&nbsp;</div>\n                </div>\n\n            </div>\n            <div class=\"alert-license-row\" ng-if=\"license.Expire==='Expired'\">\n                <div class=\"space-right\"><span class=\"icon icon-exclamation\"></span></div>\n                <div class=\"float-left\"><p class=\"font-alert-big\"> License Expired - </p></div>\n                <div class=\"float-left\"><p class=\"font-alert-small\">Update now.</p></div>\n            </div>\n        </div>\n\n        <div class=\"row\" ng-if=\"!licensesTable.licenseList\">\n            <div class=\"col-xs-12 text-center\">\n                <div class=\"licensesTable-icon-container\">\n                    <div class=\"icon hicon-document-add\"></div>\n                    <p>Licenses haven't been added yet</p>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 405 */
/***/ (function(module, exports) {

module.exports = "<!-- Modal Content-->\n<div class=\"modal-content content-container\">\n    <div class=\"modal-header\">\n        <span class=\"icon icon-delete\" ng-click=\"addLicense.closeModal()\"></span>\n    </div>\n    <div class=\"modal-body\">\n       <div class=\"add-license-modal-content-container\">\n           <div class=\"row\">\n               <div class=\"col-md-10 col-md-offset-1\">\n                   <p class=\"modal-title\" ng-if=\"!addLicense.edit\">Add License</p>\n                   <p class=\"modal-title\" ng-if=\"addLicense.edit\">Edit License</p>                   \n               </div>\n           </div>\n\n           <div class=\"row\" ng-if=\"!addLicense.edit\">\n               <div class=\"col-md-8 col-md-offset-2 text-center\">\n                   <div class=\"text-left add-license-content-container\">\n                       <div class=\"add-license-label-container\">\n                           <div class=\"add-license-dropdown-container\">\n                               <p>Choose State*</p>\n                               <select class=\"form-control input-lg select\" ng-model=\"addLicense.selectedState\" ng-change=\"addLicense.reset();\" ng-options=\"option.Name for option in addLicense.states track by option.StateGeoId\">\n                                   <option value=\"\" ng-if=\"addLicense.selectedState === null\">Select One</option>\n                               </select>\n                           </div>\n                       </div>\n                   </div>\n               </div>\n           </div>\n\n           <div class=\"row template-container\" ng-class=\"{'error': addLicense.submitted && addLicense.showErrorMsg}\">\n               <div class=\"col-md-8 col-md-offset-2 text-center\">\n                   <div class=\"add-license-template-container\" ng-if=\"addLicense.selectedState !== null || addLicense.selectedState !== ''\">\n                       <div class=\"hp-loading-spinner\" ra-spinner name=\"addLicenseSpinner\" show=\"addLicense.loading\" hide-content-when-shown=\"true\">\n                           <div ng-include=\"addLicense.selectedState.Url\"></div>\n                       </div>\n                   </div>\n                   <!--<div ng-if=\"addLicense.contentShown === 'addLicenseSuccess'\">\n                <full-screen-modal-success primary-text=\"This license has been added\"\n                                           button-text=\"Done\"\n                                           button-fn=\"addLicense.closeModal()\">\n                </full-screen-modal-success>\n            </div>-->\n\n               </div>\n           </div>\n       </div>\n\n        <div class=\"row error-message-container\" ng-if=\"addLicense.showErrorMsg\">\n            <div class=\"col-xs-12 text-center\">\n                <p class=\"error\">{{addLicense.errorMsg}}</p>\n            </div>\n        </div>\n\n        <div class=\"row btn-container\">\n            <div class=\"col-md-10 col-md-offset-1 text-center\">\n                <div class=\"btn-group add-cancel\">\n                    <button class=\"btn btn-primary\" ng-click=\"addLicense.submitAddLicense()\">{{addLicense.action}}</button>\n                    <button class=\"btn btn-default\" ng-click=\"addLicense.closeModal()\">CANCEL</button>\n                </div>\n            </div>\n        </div>\n        </div>\n    </div>\n";

/***/ }),
/* 406 */
/***/ (function(module, exports) {

module.exports = "<div class=\"add-business-license\" >\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <div class=\"label-container\">\n                <p><span>Please provide your state or local contractor's license number for {{addLicense.selectedState.Name}}</span></p>\n                <p>Note: If you are not required to have a state or local license, please write \"not required\" below.</p>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <div class=\"input-group\">\n                <span>License number*</span>\n                <input type=\"text\" class=\"form-control\" maxlength=\"32\" ng-change=\"addLicense.validate()\" ng-model=\"addLicense.licenseNumber\" hp-required=\"{{addLicense.submitted}}\" integration-type=\"{{addLicense.selectedState.LicenseTypes[0].IntegrationType}}\" ng-disabled=\"addLicense.edit && addLicense.integrationType === 2\"/>\n            </div>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <div class=\"input-group\">\n                <span>Licensing Authority</span>\n                <input type=\"text\" class=\"form-control\" maxlength=\"50\" ng-change=\"addLicense.validate()\" ng-model=\"addLicense.jurisdiction\" />\n            </div>\n        </div>\n    </div>\n\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <div class=\"input-group\">\n                <span>Expiration date</span>\n                <input type=\"text\" class=\"form-control\" ng-change=\"addLicense.validate()\" ng-model=\"addLicense.expiration\" ui-mask=\"99/99/9999\" placeholder=\"MM/DD/YYYY\" hp-valid-date  /> \n            </div>\n        </div>\n    </div>\n\n    <!--<div class=\"row\" ng-if=\"addLicense.selectedState.LicenseTypes[0].LicenseCategoryTypeId === 2\">\n        <div class=\"col-xs-12\">\n            <div class=\"dropzone-label\">\n                <span>Proof of license*</span>\n            </div>\n            <div class=\"dropzone-container\">\n                <div class=\"dropzone hp-dropzone\" id=\"add-license\" dropzone=\"\" ng-class=\"{'invalid': !addLicense.fileUploaded && addLicense.submitted}\"\n                     dropzone-url=\"DocumentManagement/UploadAttachment\"\n                     dropzone-form-data=\"{ContractorId: 24614}\"\n                     dropzone-accepted-files=\".jpg,.jpeg,.png,.gif,.tif,.bmp,.pdf\"\n                     drop-zone-max-file-size=\"10\">\n                    <div class=\"dz-default dz-message\">\n                        <p class=\"icon icon-checkbook\"></p>\n                        <p class=\"draganddrop-message\">Drag and drop a file here</p>\n                        <p class=\"draganddrop-message\">\n                            or <span class=\"link\"\n                                     ng-click=\"addLicense.uploadButtonClicked($event)\">Choose file</span>\n                        </p>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"row\" ng-if=\"addLicense.selectedState.LicenseTypes[0].LicenseCategoryTypeId === 2\">\n        <div class=\"col-xs-12\">\n            <div class=\"upload-instructions-container\">\n                <p>Max accepted file size is 10 MB.</p>\n                <p>Supported file types: jpeg, jpg, tiff, gif, bmp, png, pdf</p>\n            </div>\n        </div>\n    </div>-->\n\n</div>\n";

/***/ }),
/* 407 */
/***/ (function(module, exports) {

module.exports = "<div class=\"add-fl-license add-ca-license\" ng-controller=\"AddFLLicenseController as florida\">\n\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <div class=\"license-label-container\">\n                <p>\n                Florida is a state where we require a <span class=\"bold\">CILB license.</span>\n                </p>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <div class=\"cslb-input-container\">\n                <div class=\"input-group col-xs-8 pull-left\">\n                    <p>CILB number *</p>\n                    <input type=\"text\"\n                           class=\"form-control\"\n                           ng-class=\"{'valid': florida.valid, 'invalid': !florida.valid && florida.submitted }\"\n                           ng-model=\"addLicense.licenseNumber\"\n                           ng-minlength=\"3\"\n                           hp-max=\"15\"\n                           ng-keyup=\"florida.resetErrorMsg($event)\"\n                           ng-change=\"florida.updateSubmit()\"\n                           hp-required=\"addLicense.submitted\"\n                           placeholder=\"3-15 characters license number\" />\n                    <span class=\"icon-checkmark-thick\" ng-if=\"florida.valid\"></span>\n                </div>\n                <div class=\"col-xs-4 pull-right\">\n                    <button class=\"btn btn-default\" ng-click=\"florida.validateLicense(addLicense.contractorId, addLicense.selectedState)\">CHECK LICENSE</button>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"row error-msg\" ng-if=\"florida.showError\">\n        <div class=\"col-xs-12\">\n            <p>{{florida.errorMsg}}</p>\n        </div>\n    </div>\n\n    <div class=\"row valid-result-row\" ng-if=\"florida.valid\">\n        <div class=\"col-xs-12\">\n            <div class=\"valid-result-container\">\n                <div>\n                    <span>Company name</span>\n                    <p>{{florida.businessInfo.BusinessInfo.DoingBusinessAs || florida.businessInfo.BusinessInfo.Name}}</p>\n                </div>\n\n                <div>\n                    <span>License Holder</span>\n                    <p ng-repeat=\"owner in florida.owners\"> {{owner.Name}}</p>\n                </div>\n\n                <div>\n                    <span>Registered Address</span>\n                    <p class=\"no-margin-bottom\">{{florida.businessInfo.BusinessInfo.Address}}</p>\n                    <p>{{florida.businessInfo.BusinessInfo.CityState}}</p>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"row note-container text-left\" ng-if=\"florida.valid\">\n        <div class=\"col-xs-12\">\n            <div>\n                <p>\n                    The license holder and registered address must match the required documents.\n                </p>\n            </div>\n        </div>\n    </div>\n\n</div>";

/***/ }),
/* 408 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <span class=\"icon icon-delete\" ng-click=\"deleteLicense.closeModal()\"></span>\n</div>\n\n<div class=\"row\">\n    <div class=\"col-md-10 col-md-offset-1\">\n        <div class=\"modal-body\">\n            <p class=\"modal-title\">Delete License</p> \n\n\n         <div ng-if=\"deleteLicense.contentShown === 'deleteLicenseInProgress'\">                    \n           <div class=\"col-md-8 col-md-offset-2 text-center\">\n\t\t\t <div>\n\t\t\t   <h3>Are you sure you want to delete the license for {{deleteLicense.State}}?</h3>\n\t\t\t </div>\n             <div class=\"divDelete\">\n                 <h4>If you delete this license, you won't be able to do jobs in this state</h4>\n             </div>\n\t\t  </div> \n              <form name=\"deleteLicense.deleteLicenseForm\" ng-submit=\"deleteLicense.submitDeleteLicense(deleteLicense.deleteLicenseForm.$valid)\" novalidate>\n                     <div>\n                        <div class=\"col-md-8 col-md-offset-2 text-center\">\n                        <div class=\"modal-buttons text-center\">\n                            <hp-spinner-button button-text=\"Delete\" button-name=\"btnDeleteLicense\" is-primary-btn=\"true\"\n                            is-submit-button=\"true\" display-spinner=\"deleteLicense.processing\"></hp-spinner-button>\n                            <button type=\"button\" class=\"btn btn-default\" ng-click=\"deleteLicense.closeModal()\">Cancel</button>\n                        </div>\n                        </div>\n                    </div>\n              </form>\n         </div>\n            <div ng-if=\"deleteLicense.contentShown === 'deleteLicenseSuccess'\">\n                <full-screen-modal-success\n                    primary-text=\"{{deleteLicense.State}} license has been deleted\"\n                    secondary-text=\"Keep in mind, you'll need to add a license to do jobs in {{deleteLicense.State}}\"\n                    button-text=\"Done\"\n                    button-fn=\"deleteLicense.closeModal()\">\n                </full-screen-modal-success>\n            </div>\n\n        </div>\n    </div>\n</div>";

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _addOffice = __webpack_require__(410);

var _addOffice2 = _interopRequireDefault(_addOffice);

var _financing = __webpack_require__(439);

var _financing2 = _interopRequireDefault(_financing);

var _profile = __webpack_require__(451);

var _profile2 = _interopRequireDefault(_profile);

var _officesController = __webpack_require__(462);

var _officesController2 = _interopRequireDefault(_officesController);

var _officeDetailController = __webpack_require__(464);

var _officeDetailController2 = _interopRequireDefault(_officeDetailController);

var _officesTableController = __webpack_require__(465);

var _officesTableController2 = _interopRequireDefault(_officesTableController);

var _deleteOfficeController = __webpack_require__(466);

var _deleteOfficeController2 = _interopRequireDefault(_deleteOfficeController);

var _officesFactory = __webpack_require__(468);

var _officesFactory2 = _interopRequireDefault(_officesFactory);

__webpack_require__(469);

__webpack_require__(470);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// no controller

exports.default = _angular2.default.module('app.accounts.offices', [_addOffice2.default, _financing2.default, _profile2.default]).controller('OfficesController', _officesController2.default).controller('OfficeDetailController', _officeDetailController2.default).controller('OfficesTableController', _officesTableController2.default).controller('DeleteOfficeController', _deleteOfficeController2.default).service('OfficesFactory', _officesFactory2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/accounts/offices/officeDetail.html', __webpack_require__(471)); // eslint-disable-line global-require

    $templateCache.put('app/accounts/offices/officesTable/officesTable.html', __webpack_require__(472)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/offices/deleteOffice/deleteOffice.html', __webpack_require__(473)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/offices/header/detailHeader.html', __webpack_require__(474)); // eslint-disable-line global-require

    $templateCache.put('app/accounts/offices/licensure/officeLicensure.html', __webpack_require__(475)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/offices/licensure/viewLicensure.html', __webpack_require__(476)); // eslint-disable-line global-require
}]).name; // no controller

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _info = __webpack_require__(411);

var _info2 = _interopRequireDefault(_info);

var _addOfficeController = __webpack_require__(428);

var _addOfficeController2 = _interopRequireDefault(_addOfficeController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.accounts.offices.addOffice', [_info2.default]).controller('AddOfficeController', _addOfficeController2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/accounts/offices/addOffice/addOffice.html', __webpack_require__(434)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/offices/addOffice/addContactInfo/addContactInfo.html', __webpack_require__(435)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/offices/addOffice/addOfficeInfo/addOfficeInfo.html', __webpack_require__(436)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/offices/addOffice/addOfficePaymentInfo/addOfficePaymentInfo.html', __webpack_require__(437)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/offices/addOffice/addOfficeProfile/addOfficeProfile.html', __webpack_require__(438)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _officeInfoController = __webpack_require__(412);

var _officeInfoController2 = _interopRequireDefault(_officeInfoController);

var _hpContactInfo = __webpack_require__(414);

var _hpContactInfo2 = _interopRequireDefault(_hpContactInfo);

var _hpOfficeAddress = __webpack_require__(416);

var _hpOfficeAddress2 = _interopRequireDefault(_hpOfficeAddress);

var _hpActiveStates = __webpack_require__(418);

var _hpActiveStates2 = _interopRequireDefault(_hpActiveStates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.accounts.offices.info', []).controller('OfficeInfoController', _officeInfoController2.default).directive('hpContactInfo', _hpContactInfo2.default).directive('hpOfficeAddress', _hpOfficeAddress2.default).directive('hpActiveStates', _hpActiveStates2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/accounts/offices/info/address/officeAddress.html', __webpack_require__(420)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/offices/info/contactInfo/contactInfo.html', __webpack_require__(421)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/offices/info/state/activeStates.html', __webpack_require__(422)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/offices/info/officeInfo.html', __webpack_require__(423)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/offices/info/editContacts.html', __webpack_require__(424)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/offices/info/editInfo.html', __webpack_require__(425)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/offices/info/viewContacts.html', __webpack_require__(426)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/offices/info/viewInfo.html', __webpack_require__(427)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = officeInfoController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(413);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

officeInfoController.$inject = ['$rootScope', '$stateParams', 'UserData', 'OfficesFactory', 'HPRoles']; // angular
// 	.module("HeroPRO")
// 	.controller("OfficeInfoController", officeInfoController);

/* @ngInject */
function officeInfoController($rootScope, $stateParams, UserData, OfficesFactory, HPRoles) {
    var vm = this;
    vm.isEditingInfo = false;
    vm.isEditingContacts = false;
    vm.submitted = 'false';
    vm.officeName = '';
    vm.contactFirstName = '';
    vm.contactLastName = '';

    vm.address = {};

    vm.contact = {};

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    vm.editOfficeInformation = function () {
        vm.isEditingInfo = true;
    };

    vm.editOfficeContacts = function () {
        vm.isEditingContacts = true;
    };

    vm.cancelEditOfficeInformation = function () {
        vm.submitted = 'false';
        vm.isEditingInfo = false;
    };

    vm.cancelEditOfficeContacts = function () {
        vm.submitted = 'false';
        vm.isEditingContacts = false;
        // reset the data
        getOfficeProfile();
    };

    vm.submitOfficeInfo = function (isValid) {
        vm.submitted = 'true';
        if (isValid) {
            var data = {
                ContractorLocationId: $stateParams.accountId,
                LocationDetail: {
                    LocationNickname: vm.officeName,
                    Address: vm.address.street,
                    City: vm.address.city,
                    State: vm.address.state,
                    Zip: vm.address.zip
                }
            };
            saveOfficeProfile(data);
        }
    };

    vm.submitOfficeContacts = function (isValid) {
        vm.submitted = 'true';
        if (isValid) {
            // the contactInfo directive uses the field PhoneNumber
            // so I need to update the Phone values before returning.
            _lodash2.default.each(vm.locationContactDetails.LeadContacts, function (leadContact) {
                leadContact.Phone = leadContact.PhoneNumber;
            });

            var data = {
                ContractorLocationId: $stateParams.accountId,
                OfficeEmail: vm.contact.Email,
                OfficePhone: vm.contact.PhoneNumber,
                OfficeExtension: vm.contact.Extension,
                OfficeFirstName: vm.contactFirstName,
                OfficeLastName: vm.contactLastName,
                LeadContacts: vm.locationContactDetails.LeadContacts
            };
            saveOfficeContacts(data);
        }
    };

    vm.addSecondaryLead = function () {
        vm.showAddSecondary = false;
        var newLead = {
            Priority: 2,
            ContactTypeId: 1,
            IsActive: true
        };
        vm.locationContactDetails.LeadContacts.push(newLead);
    };

    vm.removeSecondaryLead = function () {
        vm.showAddSecondary = true;
        var secondaryLead = _lodash2.default.last(vm.locationContactDetails.LeadContacts);
        if (secondaryLead.ContactId) {
            secondaryLead.IsActive = false;
        } else {
            vm.locationContactDetails.LeadContacts.pop();
        }
    };

    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */
    function init() {
        getOfficeProfile();
    }

    function getOfficeProfile() {
        var data = {
            ContractorLocationId: Number($stateParams.accountId)
        };

        UserData.getUserData().then(function (response) {
            var currentRole = _lodash2.default.find(HPRoles, function (key, other) {
                return other === response.Roles[0];
            });

            data.IncludeACHInfo = currentRole.isAdmin;
            OfficesFactory.getOfficeProfile(data).then(function (response) {
                vm.cleanOfficeProfile = angular.copy(response.data);
                vm.locationDetail = response.data.LocationDetail;
                vm.locationContactDetails = response.data.LocationContactDetails;
                vm.showAddSecondary = vm.locationContactDetails.LeadContacts.length === 1;
                _lodash2.default.each(vm.locationContactDetails.LeadContacts, function (leadContact) {
                    leadContact.PhoneNumber = leadContact.Phone;
                });

                vm.officeName = vm.locationDetail.LocationNickname;
                vm.contactFirstName = vm.locationContactDetails.OfficeContactFirstName;
                vm.contactLastName = vm.locationContactDetails.OfficeContactLastName;

                vm.address = {
                    street: vm.locationDetail.Address,
                    city: vm.locationDetail.City,
                    state: vm.locationDetail.State,
                    zip: vm.locationDetail.Zip
                };
                vm.contact = {
                    Email: vm.locationContactDetails.OfficeContactEmail,
                    PhoneNumber: vm.locationContactDetails.OfficeContactPhone,
                    Extension: vm.locationContactDetails.OfficeContactPhoneExtension
                };
            });
        });
    }

    function saveOfficeProfile(data) {
        OfficesFactory.saveInfo(data).then(function () {
            // reload the data
            getOfficeProfile();

            if (vm.isEditingInfo) {
                $rootScope.$broadcast('LocationNicknameUpdated', { LocationNickname: vm.locationDetail.LocationNickname });
                vm.isEditingInfo = false;
            }
            vm.submitted = 'false';
        });
    }

    function saveOfficeContacts(data) {
        OfficesFactory.saveContacts(data).then(function () {
            vm.isEditingContacts = false;
            getOfficeProfile();
            vm.submitted = 'false';
        });
    }
}

/***/ }),
/* 413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = contactInfo;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(415);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

contactInfo.$inject = ['UserData', '$rootScope']; // angular
// 	.module("HeroPRO")
// 	.directive('hpContactInfo', contactInfo);

/* @ngInject */
function contactInfo(UserData, $rootScope) {
    var contactInfoController = function contactInfoController() {
        var vm = this;

        vm.isEditEmail = false;

        init();

        /*= =======================================
        =            Public Functions            =
        ======================================== */
        vm.trigger_onupdate = function () {
            // this is a way to provide a parent event that can be executed whenever
            // the model for the directive changes.
            if (vm.onupdate) {
                vm.onupdate();
            }
        };
        vm.checkPrimaryEmail = function () {
            editEmail();
            if (!vm.noconfirm) {
                vm.checkEmailChange();
            }
        };

        vm.checkEmailChange = function () {
            // when the email field is programmatically reset, wipe out the confirm field
            if (!vm.contactInfoForm.txtContactInformationEmail && !vm.contact.Email) {
                vm.contactInfoForm.txtContactInformationConfirmEmail = undefined;
            }
            if (vm.contactInfoForm.txtContactInformationEmail !== undefined) {
                vm.contactInfoForm.txtContactInformationEmail.$setValidity('inuse', true);
            }
            if (vm.contactInfoForm.txtContactInformationConfirmEmail !== undefined) {
                vm.contactInfoForm.txtContactInformationConfirmEmail.$setValidity('inuse', true);
            }
            if (vm.email === vm.contact.Email && vm.contactInfoForm.$valid) {
                vm.isEmailConfirmed = false;
                vm.isEditEmail = false;
            } else if (vm.contact.Email !== vm.confirmEmail && !_lodash2.default.isEmpty(vm.confirmEmail)) {
                vm.contactInfoForm.txtContactInformationEmail.$setValidity('nomatch', false);
                if (vm.contactInfoForm.txtContactInformationConfirmEmail !== undefined) {
                    vm.contactInfoForm.txtContactInformationConfirmEmail.$setValidity('nomatch', false);
                }
                vm.errorMessage = 'Emails do not match';
                vm.isEmailConfirmed = false;
            } else if (vm.contact.Email !== vm.confirmEmail && _lodash2.default.isEmpty(vm.confirmEmail) && vm.editor === true) {
                vm.contactInfoForm.txtContactInformationEmail.$setValidity('nomatch', false);
                if (vm.contactInfoForm.txtContactInformationConfirmEmail !== undefined) {
                    vm.contactInfoForm.txtContactInformationConfirmEmail.$setValidity('nomatch', false);
                }
                vm.errorMessage = 'Emails do not match';
                vm.isEmailConfirmed = false;
            } else if (vm.contact.Email !== vm.confirmEmail && _lodash2.default.isEmpty(vm.confirmEmail) && vm.editor === false) {
                vm.isEmailConfirmed = false;
                vm.isEditEmail = true;
            } else {
                vm.contactInfoForm.txtContactInformationEmail.$setValidity('nomatch', true);
                if (vm.contactInfoForm.txtContactInformationConfirmEmail !== undefined) {
                    vm.contactInfoForm.txtContactInformationConfirmEmail.$setValidity('nomatch', true);
                }
                vm.errorMessage = '';
                if (vm.email === vm.contact.Email) {
                    vm.isEmailConfirmed = false;
                    vm.isEditEmail = false;
                } else if (vm.contact.Email === vm.confirmEmail && vm.contactInfoForm.$valid || vm.contact.Email === vm.confirmEmail && vm.contactInfoForm.$dirty) {
                    if (!_lodash2.default.isEmpty(vm.contact.Email)) {
                        vm.isEmailConfirmed = true;
                    } else {
                        vm.isEmailConfirmed = false;
                    }
                }
            }
        };

        vm.validatePhone = function () {
            if (vm.contactInfoForm.txtContactInformationPhone.$invalid) {
                vm.isPhoneInvalid = true;
            } else {
                vm.isPhoneInvalid = false;
            }
            vm.trigger_onupdate();
        };
        vm.validateMobilePhone = function () {
            if (vm.contactInfoForm.txtContactInformationMobilePhone.$invalid) {
                vm.isMobilePhoneInvalid = true;
            } else {
                vm.isMobilePhoneInvalid = false;
            }
            vm.trigger_onupdate();
        };

        /* -----  End of Public Functions  ------*/

        /*= =======================================
        =            Private Functions            =
        ======================================== */
        function init() {
            getElevatedAccess();
        }

        function editEmail() {
            if (!_lodash2.default.isEmpty(vm.email) || !vm.noconfirm) {
                vm.isEditEmail = true;
            }
        }

        function getElevatedAccess() {
            UserData.getUserData().then(function (response) {
                if (response.HasElevatedAccess === undefined || response.HasElevatedAccess === null) {
                    vm.isAdmin = false;
                } else {
                    vm.isAdmin = true;
                }
                vm.email = vm.contact.Email;
            });
        }

        $rootScope.$on('EmailInUse', function () {
            _lodash2.default.delay(function () {
                vm.contactInfoForm.txtContactInformationEmail.$setValidity('inuse', false);
                if (vm.contactInfoForm.txtContactInformationConfirmEmail) {
                    vm.contactInfoForm.txtContactInformationConfirmEmail.$setValidity('inuse', false);
                }
                vm.errorMessage = 'Email is in use.';
                vm.isEmailConfirmed = false;
                $rootScope.$apply();
            });
        });
    };

    return {
        replace: true,
        restrict: 'E',
        scope: {
            contact: '=',
            required: '=',
            submitted: '=',
            toggleOff: '=',
            editor: '=',
            showMobilePhone: '=',
            onupdate: '=',
            noconfirm: '='
        },
        require: '^form',
        templateUrl: 'app/accounts/offices/info/contactInfo/contactInfo.html',
        controller: contactInfoController,
        controllerAs: 'contactInfo',
        bindToController: true
    };
}

/***/ }),
/* 415 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = officeAddress;

__webpack_require__(417);

officeAddress.$inject = ['CommonDataFactory']; // angular
// 	.module("HeroPRO")
// 	.directive('hpOfficeAddress', officeAddress);

/* @ngInject */
function officeAddress(CommonDataFactory) {
    function link(scope) {
        CommonDataFactory.getStates().then(function (response) {
            scope.states = response.data.Data;
            scope.selectedState = null;
            for (var i = 0; i < scope.states.length; i++) {
                if (scope.states[i].StateAbbreviation === scope.address.state) {
                    scope.selectedState = scope.states[i];
                }
            }
        });

        scope.stateClicked = function (state) {
            scope.selectedState = state;
            scope.address.state = state.StateAbbreviation;
        };
    }

    return {
        transclude: true,
        replace: true,
        restrict: 'E',
        scope: {
            address: '=',
            required: '=',
            submitted: '='
        },
        templateUrl: 'app/accounts/offices/info/address/officeAddress.html',
        link: link
    };
}

/***/ }),
/* 417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = activeStates;

__webpack_require__(419);

activeStates.$inject = ['CommonDataFactory'];
// angular
// .module("HeroPRO")
// .directive('hpActiveStates', activeStates);

/* @ngInject */
function activeStates(CommonDataFactory) {
    function link(scope) {
        scope.selectedState = null;

        if (angular.isDefined(scope.activeStates)) {
            scope.states = scope.activeStates;
            angular.forEach(scope.states, function (state) {
                if (angular.equals(state, scope.currentState)) {
                    scope.selectedState = state;
                }
            });
        } else {
            CommonDataFactory.getStates(true).then(function (response) {
                scope.states = response.data.Data;
                angular.forEach(scope.states, function (state) {
                    if (angular.equals(state, scope.currentState)) {
                        scope.selectedState = state;
                    }
                });
            });
        }

        scope.stateClicked = function (state) {
            scope.selectedState = state;
            scope.currentState = state;
        };
    }

    return {
        transclude: true,
        scope: {
            required: '=',
            currentState: '=',
            activeStates: '='
        },
        replace: true,
        restrict: 'E',
        templateUrl: 'app/accounts/offices/info/state/activeStates.html',
        link: link
    };
}

/***/ }),
/* 419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports = "<div class=\"address-container\">\n    <ng-form name=\"officeAddress\">\n        <div class=\"row address-label-container\">\n            <div class=\"col-md-12\">\n                <span>Address</span>\n            </div>\n        </div>\n        <div class=\"row address-field-container\">\n            <div class=\"col-md-12\">\n                <input id=\"txt-address-street\" name=\"txtAddressStreet\" type=\"text\" ng-model=\"address.street\" maxlength=\"100\" placeholder=\"Street\"\n                       ng-required=\"required\">\n                <div class=\"error-message-container\">\n                    <p class=\"error-message\" ng-if=\"officeAddress.txtAddressStreet.$error.required && submitted === 'true'\">Required</p>\n                </div>\n            </div>\n        </div>\n        <div class=\"row address-field-container\">\n            <div class=\"col-md-6\">\n                <input id=\"txt-address-city\" name=\"txtAddressCity\" type=\"text\" ng-model=\"address.city\" maxlength=\"40\" placeholder=\"City\"\n                       ng-required=\"required\">\n                <div class=\"error-message-container\">\n                    <p class=\"error-message\" ng-if=\"officeAddress.txtAddressCity.$error.required && submitted === 'true'\">Required</p>\n                </div>\n            </div>\n            <div class=\"col-md-3 state-dropdown-container\">\n                <div class=\"dropdown\" uib-dropdown dropdown-small-popup dropdown-title=\"States\" ng-class=\"{'error-border': selectedState === null && required && submitted === 'true'}\">\n                    <a id=\"ddl-state\" blur-element class=\"dropdown-toggle\" uib-dropdown-toggle data-toggle=\"dropdown\">\n                        <span class=\"dropdown-text\">{{selectedState.StateAbbreviation || 'Choose One'}}</span>\n                        <span class=\"icon\"></span>\n                    </a>\n                    <ul class=\"dropdown-menu address-breakdown-small\" uib-dropdown-menu>\n                        <li ng-repeat=\"state in states\"\n                            ng-class=\"{'active': selectedState === state }\"\n                            ng-click=\"stateClicked(state)\">\n                            <span>{{state.StateAbbreviation}}</span>\n                        </li>\n                    </ul>\n                </div>\n                <div class=\"error-message-container\">\n                    <p class=\"error-message\" ng-if=\"selectedState === null && required && submitted === 'true'\">Required</p>\n                </div>\n            </div>\n            <div class=\"col-md-3 zip-field-container\">\n                <input id=\"txt-address-zip\" name=\"txtAddressZip\" type=\"text\" ng-model=\"address.zip\" maxlength=\"5\" placeholder=\"Zip\"\n                       ng-required=\"required\" hp-numeric-only>\n                <div class=\"error-message-container\">\n                    <p class=\"error-message\" ng-if=\"officeAddress.txtAddressZip.$error.required && submitted === 'true'\">Required</p>\n                </div>\n            </div>\n        </div>\n    </ng-form>\n</div>\n";

/***/ }),
/* 421 */
/***/ (function(module, exports) {

module.exports = "<div class=\"contact-info-container\">\n    <ng-form name=\"contactInfo.contactInfoForm\">\n        <div class=\"row contact-info-field-container\">\n            <div class=\"col-md-12\" ng-if=\"contactInfo.isAdmin === false\">\n                <p class=\"contact-information-email\" ng-bind=\"contactInfo.contact.Email\"></p>\n            </div>\n\n            <div class=\"col-md-12\" ng-if=\"contactInfo.isAdmin === true\">\n                <span class=\"icon icon-todo\" ng-if=\"contactInfo.isEmailConfirmed\"></span>\n                <input type=\"email\" id=\"txt-contact-information-email\" name=\"txtContactInformationEmail\" class=\"contact-information-email-field\" maxlength=\"60\" placeholder=\"Email\" ng-model=\"contactInfo.contact.Email\" ng-change=\"contactInfo.checkPrimaryEmail()\" ng-required=\"contactInfo.required && (contactInfo.submitted === 'true' || contactInfo.contactInfoForm.txtContactInformationEmail.$touched === true)\" ng-disabled=\"contactInfo.toggleOff\" ng-pattern=\"/^[\\w.!%+-]+@[\\w.-]+\\.[A-Za-z-]{2,}$/\" />\n\n                <div class=\"error-message-container\">\n                    <p class=\"error-message\" ng-show=\"contactInfo.contactInfoForm.txtContactInformationEmail.$error.required && contactInfo.submitted === 'true'\">\n                        Required</p>\n\n                    <p class=\"error-message\" ng-show=\"contactInfo.contactInfoForm.txtContactInformationEmail.$error.pattern\">\n                        Invalid Email</p>\n                </div>\n            </div>\n        </div>\n        <div class=\"row contact-info-field-container\" ng-if=\"contactInfo.isEditEmail\">\n            <div class=\"col-md-12\">\n                <span class=\"icon icon-todo\" ng-if=\"contactInfo.isEmailConfirmed\"></span>\n                <input type=\"email\" id=\"txt-contact-information-confirm-email\" maxlength=\"60\" name=\"txtContactInformationConfirmEmail\" ng-required=\"contactInfo.isEditEmail\" class=\"contact-information-email-field\" ng-model=\"contactInfo.confirmEmail\" placeholder=\"Confirm Email\" ng-change=\"contactInfo.checkEmailChange()\" ng-pattern=\"/^[\\w.!%+-]+@[\\w.-]+\\.[A-Za-z-]{2,}$/\" />\n\n                <div class=\"error-message-container confirm-email-error\">\n                    <p class=\"error-message\" ng-show=\"contactInfo.contactInfoForm.txtContactInformationConfirmEmail.$error.required && contactInfo.contactInfoForm.txtContactInformationEmail.$dirty && contactInfo.submitted === 'true'\">\n                        Required</p>\n\n                    <p class=\"error-message\" ng-show=\"contactInfo.contactInfoForm.txtContactInformationConfirmEmail.$error.pattern && !contactInfo.contactInfoForm.txtContactInformationConfirmEmail.$error.required && contactInfo.submitted === 'true'\">\n                        Invalid Email</p>\n\n                    <p class=\"error-message \" ng-bind=\"contactInfo.errorMessage\" ng-show=\"contactInfo.errorMessage !== '' && !contactInfo.contactInfoForm.txtContactInformationConfirmEmail.$error.pattern && !contactInfo.contactInfoForm.txtContactInformationConfirmEmail.$error.required && contactInfo.submitted === 'true'\"></p>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"row contact-info-field-container\">\n            <div class=\"col-md-9\">\n                <div class=\"contact-information-phone-container\">\n                    <input type=\"text\" id=\"txt-contact-information-phone\" class=\"contact-information-phone-field\" name=\"txtContactInformationPhone\" ng-disabled=\"contactInfo.toggleOff\" ng-required=\"contactInfo.required && (contactInfo.submitted === 'true' || contactInfo.contactInfoForm.txtContactInformationPhone.$touched === true)\" ng-model=\"contactInfo.contact.PhoneNumber\" ui-mask=\"(999) 999-9999\" ng-change=\"contactInfo.validatePhone()\" />\n\n                    <div class=\"error-message-container\">\n                        <p class=\"error-message\" ng-if=\"(contactInfo.contactInfoForm.txtContactInformationPhone.$error.required || contactInfo.isPhoneInvalid) && contactInfo.submitted === 'true'\">\n                            Required</p>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-md-3 extension-container\">\n                <div class=\"contact-information-phone-ext-container\">\n                    <input type=\"text\" id=\"txt-personal-information-phone-ext\" hp-numeric-only ng-disabled=\"contactInfo.toggleOff\" class=\"personal-information-phone-ext-field\" maxlength=\"6\" ng-change=\"contactInfo.validateExt()\" ng-model=\"contactInfo.contact.Extension\" placeholder=\"Ext\" />\n                </div>\n            </div>\n        </div>\n        <div class=\"row contact-info-field-container\" ng-if=\"contactInfo.showMobilePhone === true\">\n            <div class=\"col-md-12\">\n                <label>Mobile phone</label>\n                <input type=\"text\" id=\"txt-contact-information-mobilephone\" class=\"contact-information-phone-field\" name=\"txtContactInformationMobilePhone\" ng-disabled=\"contactInfo.toggleOff\" ng-model=\"contactInfo.contact.MobilePhone\" ui-mask=\"(999) 999-9999\" ng-change=\"contactInfo.validateMobilePhone()\" />\n\n                <div class=\"error-message-container\">\n                    <p class=\"error-message\" ng-if=\"contactInfo.isMobilePhoneInvalid && contactInfo.submitted === 'true'\">\n                        Invalid phone number</p>\n                </div>\n            </div>\n        </div>\n    </ng-form>\n</div>";

/***/ }),
/* 422 */
/***/ (function(module, exports) {

module.exports = "<div class=\"active-states-container\">\r\n    <div class=\"dropdown\" uib-dropdown dropdown-small-popup ng-class=\"{'error-border': selectedState === null && required === 'true' }\">\r\n        <a blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle data-toggle=\"dropdown\">\r\n            <span class=\"dropdown-text\">{{selectedState.StateAbbreviation || 'Choose One'}}</span>\r\n            <span class=\"icon\"></span>\r\n        </a>\r\n        <ul class=\"dropdown-menu address-breakdown-small\" uib-dropdown-menu>\r\n            <li ng-repeat=\"state in states\"\r\n                ng-class=\"{'active': selectedState === state }\"\r\n                ng-click=\"stateClicked(state)\">\r\n                <span>{{state.StateAbbreviation}}</span>\r\n            </li>\r\n        </ul>\r\n    </div>\r\n    <div class=\"error-message-container\">\r\n        <p class=\"error-message\" ng-if=\"selectedState === null && required === 'true'\">Required</p>\r\n    </div>\r\n</div>";

/***/ }),
/* 423 */
/***/ (function(module, exports) {

module.exports = "<div class=\"office-information-container\" ng-controller=\"OfficeInfoController as officeInfo\">\n    <div class=\"row office-information-header-container\">\n        <div class=\"col-md-6\">\n            <h2>Office Information</h2>\n        </div>\n        <div class=\"col-md-6\">\n            <button class=\"btn btn-default pull-right\" id=\"btn-office-info-edit\" ng-if=\"!officeInfo.isEditingInfo\"\n                    ng-click=\"officeInfo.editOfficeInformation()\">Edit\n            </button>\n        </div>\n    </div>\n    <div class=\"row message-container\"\n         ng-class=\"{ 'success': (officeInfo.isOfficeInfoError === false ), 'error': (officeInfo.isOfficeInfoError === true), 'edit-background' : (officeInfo.isEditingInfo === true) }\"\n         ng-show=\"officeInfo.officeInfoStatusMessage !== ''\">\n        <div class=\"col-md-12\">\n            <p ng-bind=\"officeInfo.officeInfoStatusMessage\"></p>\n        </div>\n    </div>\n    <ng-include src=\"'app/accounts/offices/info/viewInfo.html'\" ng-if=\"!officeInfo.isEditingInfo\"></ng-include>\n    <ng-include src=\"'app/accounts/offices/info/editInfo.html'\" ng-if=\"officeInfo.isEditingInfo\"></ng-include>\n    <div class=\"row office-information-header-container\">\n        <div class=\"col-md-6\">\n            <h2>Contacts</h2>\n        </div>\n        <div class=\"col-md-6\">\n            <button class=\"btn btn-default pull-right\" id=\"btn-office-contact-edit\" ng-if=\"!officeInfo.isEditingContacts\"\n                    ng-click=\"officeInfo.editOfficeContacts()\">\n                Edit\n            </button>\n        </div>\n    </div>\n    <div class=\"row message-container\"\n         ng-class=\"{ 'success': (officeInfo.isOfficeContactError === false ), 'error': (officeInfo.isOfficeContactError === true), 'edit-background' : (officeInfo.isEditingContacts === true) }\"\n         ng-show=\"officeInfo.officeContactStatusMessage !== ''\">\n        <div class=\"col-md-12\">\n            <p ng-bind=\"officeInfo.officeContactStatusMessage\"></p>\n        </div>\n    </div>\n    <ng-include src=\"'app/accounts/offices/info/viewContacts.html'\" ng-if=\"!officeInfo.isEditingContacts\"></ng-include>\n    <ng-include src=\"'app/accounts/offices/info/editContacts.html'\" ng-if=\"officeInfo.isEditingContacts\"></ng-include>\n</div>\n";

/***/ }),
/* 424 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row office-info-edit-container\" ng-class=\"{ 'edit-background' : officeInfo.isEditingContacts }\">\n    <form name=\"officeInfo.editOfficeContactsForm\" ng-submit=\"officeInfo.submitOfficeContacts(officeInfo.editOfficeContactsForm.$valid)\" novalidate>\n        <div class=\"row\">\n            <div class=\"col-md-8 office-info-edit-left-column\">\n                <div class=\"office-name-container\">\n                    <div class=\"row office-name-label-container\">\n                        <div class=\"col-md-8\">\n                            <span>Office contact</span>\n                        </div>\n                    </div>\n                    <div class=\"row office-name-field-container\">\n                        <div class=\"col-md-6 contact-first-name-container\">\n                            <input id=\"txt-contact-first-name\" name=\"txtContactFirstName\" type=\"text\"\n                                   placeholder=\"First Name\" maxlength=\"30\"\n                                   ng-required=\"true\" ng-model=\"officeInfo.contactFirstName\">\n                            <div class=\"error-message-container\">\n                                <p class=\"error-message\" ng-if=\"officeInfo.editOfficeContactsForm.txtContactFirstName.$error.required\">\n                                    Required\n                                </p>\n                            </div>\n                        </div>\n                        <div class=\"col-md-6 contact-last-name-container\">\n                            <input id=\"txt-contact-last-name\" name=\"txtContactLastName\" type=\"text\"\n                                   placeholder=\"Last Name\" maxlength=\"30\"\n                                   ng-required=\"true\" ng-model=\"officeInfo.contactLastName\">\n                            <div class=\"error-message-container\">\n                                <p class=\"error-message\" ng-if=\"officeInfo.editOfficeContactsForm.txtContactLastName.$error.required\">\n                                    Required\n                                </p>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <hp-contact-info contact=\"officeInfo.contact\" required=\"true\" submitted=\"officeInfo.submitted\" editor=\"true\"></hp-contact-info>\n            </div>\n            <div class=\"col-md-4 office-info-edit-right-column\">\n\n            </div>\n        </div>\n        <div class=\"row\" ng-init=\"contactIndex = $index\" ng-repeat=\"leadContact in officeInfo.locationContactDetails.LeadContacts | filter: {IsActive : true }\">\n            <div class=\"col-md-8 office-info-edit-left-column edit-leads\">\n                <div class=\"office-name-container\">\n                    <div class=\"row office-name-label-container\">\n                        <div class=\"col-md-3\">\n                            <span ng-if=\"$index === 0\">Primary lead contact</span>\n                            <span ng-if=\"$index === 1\">Secondary lead contact</span>\n                        </div>\n                        <div class=\"col-md-8\"></div>\n                        <div class=\"col-md-1\">\n                            <span class=\"link\" ng-if=\"$index === 1\" ng-click=\"officeInfo.removeSecondaryLead()\">Delete</span>\n                        </div>\n                    </div>\n                    <div class=\"row office-name-field-container\">\n                        <div class=\"col-md-6 contact-first-name-container\">\n                            <input id=\"txt-lead-contact-first-name{{$index}}\" name=\"txtLeadContactFirstName{{$index}}\" type=\"text\"\n                                   placeholder=\"First Name\" maxlength=\"30\"\n                                   ng-required=\"officeInfo.editOfficeContactsForm.$submitted === true || officeInfo.editOfficeContactsForm.txtLeadContactFirstName{{contactIndex}}.$touched === true\"\n                                   ng-model=\"leadContact.FirstName\">\n                            <div class=\"error-message-container\">\n                                <p class=\"error-message\" ng-show=\"officeInfo.editOfficeContactsForm.txtLeadContactFirstName{{contactIndex}}.$error.required\">\n                                    Required\n                                </p>\n                            </div>\n                        </div>\n                        <div class=\"col-md-6 contact-last-name-container\">\n                            <input id=\"txt--lead-contact-last-name{{$index}}\" name=\"txtLeadContactLastName{{$index}}\" type=\"text\"\n                                   placeholder=\"Last Name\" maxlength=\"30\"\n                                   ng-required=\"officeInfo.editOfficeContactsForm.$submitted === true || officeInfo.editOfficeContactsForm.txtLeadContactLastName{{contactIndex}}.$touched === true\"\n                                   ng-model=\"leadContact.LastName\">\n                            <div class=\"error-message-container\">\n                                <p class=\"error-message\" ng-show=\"officeInfo.editOfficeContactsForm.txtLeadContactLastName{{contactIndex}}.$error.required\">\n                                    Required\n                                </p>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <hp-contact-info contact=\"leadContact\" required=\"true\" submitted=\"officeInfo.submitted\" editor=\"true\"></hp-contact-info>\n                <div class=\"office-name-container add-secondary\" ng-if=\"officeInfo.showAddSecondary\">\n                    <div ng-click=\"officeInfo.addSecondaryLead()\">\n                        <span class=\"icon icon-zoom-in\"></span>\n                        <div class=\"add-secondary-text\">Add a secondary contact for this location</div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-md-4 office-info-edit-right-column edit-leads\">\n                <div class=\"lead-contacts-instruction\" ng-if=\"$index === 0\">\n                    When a homeowner contacts your company via FOAHI.com,\n                    the lead will be sent to this office using this contact information.\n                    This information is not displayed to the public.\n                </div>\n                <div class=\"lead-contacts-instruction\" ng-if=\"$index === 0\">\n                    Leads for this office will also be emailed automatically\n                    to everyone who has Admin access in Contractor Portal.\n                </div>\n                <div class=\"lead-contacts-instruction\" ng-if=\"$index === 1\">\n                    All leads for this office will also be routed to the following secondary contact.\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12 edit-button-container\">\n                <div class=\"pull-left\">\n                    <button class=\"btn btn-primary\" id=\"btn-office-info-save\">\n                        Save\n                    </button>\n                </div>\n                <div class=\"pull-left\">\n                    <button class=\"btn btn-default\" id=\"btn-office-info-cancel\"\n                            ng-click=\"officeInfo.cancelEditOfficeContacts()\">\n                        Cancel\n                    </button>\n                </div>\n            </div>\n        </div>\n    </form>\n</div>\n";

/***/ }),
/* 425 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row office-info-edit-container\" ng-class=\"{ 'edit-background' : officeInfo.isEditingInfo }\">\n    <form name=\"editOfficeInfo\" ng-submit=\"officeInfo.submitOfficeInfo(editOfficeInfo.$valid)\" novalidate>\n        <div class=\"row\">\n            <div class=\"col-md-6 office-info-edit-left-column\">\n                <div class=\"office-name-container\">\n                    <div class=\"row office-name-label-container\">\n                        <div class=\"col-md-12\">\n                            <span>Office Name</span>\n                        </div>\n                    </div>\n                    <div class=\"row office-name-field-container\">\n                        <div class=\"col-md-12\">\n                            <input id=\"txt-office-name\" name=\"txtOfficeName\" type=\"text\"\n                                   ng-required=\"editOfficeInfo.$dirty\" maxlength=\"60\" ng-model=\"officeInfo.officeName\">\n                            <div class=\"error-message-container\">\n                                <p class=\"error-message\" ng-if=\"editOfficeInfo.txtOfficeName.$error.required\">\n                                    Required</p>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <hp-office-address address=\"officeInfo.address\" required=\"true\" submitted=\"officeInfo.submitted\"></hp-office-address>\n            </div>\n            <div class=\"col-md-6 office-info-edit-right-column\">\n\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12 edit-button-container\">\n                <div class=\"pull-left\">\n                    <button class=\"btn btn-primary\" id=\"btn-office-info-save\">Save\n                    </button>\n                </div>\n                <div class=\"pull-left\">\n                    <button class=\"btn btn-default\" id=\"btn-office-info-cancel\"\n                            ng-click=\"officeInfo.cancelEditOfficeInformation()\">Cancel\n                    </button>\n                </div>\n            </div>\n        </div>\n    </form>\n</div>\n";

/***/ }),
/* 426 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row office-info-container\">\n    <div class=\"col-md-5\">\n        <h5>Office contact</h5>\n        <p ng-bind=\"officeInfo.locationContactDetails.OfficeContactFirstName + ' ' + officeInfo.locationContactDetails.OfficeContactLastName \"></p>\n        <p ng-bind=\"officeInfo.locationContactDetails.OfficeContactPhone | tel\"></p>\n        <p ng-bind=\"officeInfo.locationContactDetails.OfficeContactEmail\"></p>\n    </div>\n    <div class=\"col-md-5\">\n        <div class=\"view-leads-contact-container\" ng-repeat=\"contactLead in officeInfo.locationContactDetails.LeadContacts\">\n            <div class=\"row\">\n                <div class=\"col-md-12\">\n                    <h5 ng-if=\"$index === 0\">Leads primary contact</h5>\n                    <h5 ng-if=\"$index === 1\">Leads secondary contact</h5>\n                    <div ng-if=\"$index === 0\" class=\"leads-popover\" hp-popover popover-placement=\"bottom\" popover-trigger=\"outsideClick\" popover-is-open=\"officeInfo.leadsPopoverIsOpen\"\n                         uib-popover=\"Leads will be sent here when a homeowner finds your company on RenovateAmerica.com\">\n                        <span class=\"icon\" ng-class=\"{'icon-protip': !officeInfo.leadsPopoverIsOpen, 'icon-protip-active': officeInfo.leadsPopoverIsOpen}\"></span>\n                    </div>\n                </div>\n\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-12\">\n                    <p ng-bind=\"contactLead.FirstName + ' ' + contactLead.LastName \"></p>\n                    <p ng-bind=\"contactLead.Phone | tel\"></p>\n                    <p ng-bind=\"contactLead.Email\"></p>                    \n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"col-md-2\">\n\n    </div>\n</div>\n";

/***/ }),
/* 427 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row office-info-container\">\n    <div class=\"col-md-5\">\n        <h5>Office name</h5>\n        <p ng-bind=\"officeInfo.locationDetail.LocationNickname\"></p>\n        <span class=\"hp-badge\" ng-if=\"officeInfo.locationDetail.IsMaster\"> <span class=\"icon icon-main-office\"></span> Main Office</span>\n    </div>\n    <div class=\"col-md-5\">\n        <h5>Address</h5>\n        <p ng-bind=\"officeInfo.locationDetail.Address\"></p>\n        <p ng-bind=\"officeInfo.locationDetail.City + ', ' + officeInfo.locationDetail.State + ' ' + officeInfo.locationDetail.Zip\"></p>\n    </div>\n    <div class=\"col-md-2\">\n\n    </div>\n</div>\n";

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = addOfficeController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(429);

__webpack_require__(430);

__webpack_require__(431);

__webpack_require__(432);

__webpack_require__(433);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

addOfficeController.$inject = ['$uibModalInstance', '$window', '$rootScope', 'OfficesFactory', 'HPConfig', 'UserData', '$sce', 'HPRoles', 'DirectiveService', '$analytics', 'CommonDataFactory']; // angular
//     .module("HeroPRO")
//     .controller("AddOfficeController", addOfficeController);

/* @ngInject */
function addOfficeController($uibModalInstance, $window, $rootScope, OfficesFactory, HPConfig, UserData, $sce, HPRoles, DirectiveService, $analytics, CommonDataFactory) {
    var vm = this;
    vm.contentShown = 'addOfficeInProgress';
    vm.enableValidation = 'false';
    vm.maxDescriptionLength = 900;
    vm.orgId = -1;
    vm.currentStep = {};
    vm.leadContact = {};
    vm.scrollToTop = false;
    vm.saving = false;
    vm.leadSameAsContact = false;

    vm.addACHEnabled = false;

    vm.steps = [{
        id: 0,
        title: 'Office Info',
        defaultBtnText: 'Next',
        isCompleted: false,
        isActive: true,
        isVisited: false,
        primaryBtnText: 'Cancel',
        path: 'app/accounts/offices/addOffice/addOfficeInfo/addOfficeInfo.html'
    }, {
        id: 1,
        title: 'Contact Info',
        defaultBtnText: 'Next',
        isCompleted: false,
        isActive: false,
        isVisited: false,
        primaryBtnText: 'Previous',
        path: 'app/accounts/offices/addOffice/addContactInfo/addContactInfo.html'
    },
    /*
    {
        id: 2,
        title: 'Payment Info',
        defaultBtnText: 'Next',
        isCompleted: false,
        isActive: false,
        isVisited: false,
        primaryBtnText: 'Previous',
        path: 'app/accounts/offices/addOffice/addOfficePaymentInfo/addOfficePaymentInfo.html',
    },
    */{
        id: 2,
        title: 'Office Profile',
        defaultBtnText: 'Finish',
        isCompleted: false,
        isActive: false,
        isVisited: false,
        primaryBtnText: 'Previous',
        path: 'app/accounts/offices/addOffice/addOfficeProfile/addOfficeProfile.html'
    }];

    vm.officeName = '';
    vm.contactFirstName = '';
    vm.contactLastName = '';
    vm.officeWebsite = '';
    vm.officeDescription = '';
    vm.fullCountyList = [];

    vm.defaultServiceType = {
        Description: 'Choose one',
        Name: 'null',
        ContractorTypeId: -1
    };

    vm.defaultAccountType = {
        BankAccountTypeId: -1,
        Name: 'null',
        Description: 'Choose one'
    };

    vm.address = {
        street: '',
        city: '',
        state: '',
        zip: ''
    };

    vm.contact = {
        Email: '',
        PhoneNumber: '',
        Extension: ''
    };

    vm.profileDetail = {
        CompanyOverview: '',
        CompanyURL: ''
    };

    // Logo
    vm.logoImage = null;
    vm.logoFileName = '';
    vm.displayLogo = null;

    // Errors
    vm.description = '';
    vm.uploadErrorMessage = '';
    vm.countiesErrorMessage = '';

    // states
    vm.states = [];
    vm.selectedState = null;
    var allStates = [];

    // Counties/Municipalities
    vm.counties = [];
    vm.currentCounties = [];

    // Primary Service
    vm.selectedPrimaryService = null;

    // Additional Services
    vm.primaryService = {};
    vm.secondaryServices = [];
    vm.availableServices = [];
    vm.contractorServiceTypes = [];

    // Payment Info
    vm.selectedAccountType = {};
    vm.accountTypes = [];
    vm.verifyAccountNumber = '';
    vm.LocationACH = {
        ACHBank: '',
        ACHRoutingNumber: '',
        ACHAccountNumber: ''
    };
    vm.mainOfficeACH = {};
    vm.content = '<img class="hero-check" src="src/assets/images/hero-check-sample.jpg" alt="Sample Check">';
    var trusted = {};
    vm.displayApprovalBadge = false;
    vm.useMainACH = false;

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.updateLeadContact = function () {
        if (vm.leadSameAsContact) {
            vm.leadContact = vm.contact;
            vm.leadContact.contactFirstName = vm.contactFirstName;
            vm.leadContact.contactLastName = vm.contactLastName;
        }
    };
    vm.sameAsContactInfo = function () {
        if (vm.leadSameAsContact) {
            vm.leadContact = vm.contact;
            vm.leadContact.contactFirstName = vm.contactFirstName;
            vm.leadContact.contactLastName = vm.contactLastName;
        } else {
            vm.leadContact = {};
        }
    };

    vm.closeModal = function () {
        var result = false;

        if (vm.contentShown === 'addOfficeSuccess') {
            result = true;
        }

        $uibModalInstance.close(result);
        vm.contentShown = 'addOfficeInProgress';
        vm.submitted = false;
    };

    vm.navigateProgress = function (step) {
        if (step.isVisited === true) {
            if (step.id > vm.currentStep.id) {
                vm.addNewOffice.$setSubmitted();
                vm.submitted = 'true';

                validateStep(vm.currentStep.id);
                if (vm.addNewOffice.$valid) {
                    processStep(vm.currentStep.id, step.id, null);
                }
            } else {
                processStep(vm.currentStep.id, step.id, null);
            }
        }
    };

    vm.defaultBtnClick = function (event) {
        event.preventDefault();
        vm.scrollToTop = true;
        processStep(vm.currentStep.id, vm.currentStep.id - 1, event);
    };

    vm.setFieldRequiredState = function () {
        return (!vm.addNewOffice.$submitted).toString();
    };

    vm.openContractorPage = function () {
        $window.open(HPConfig.renovateLink + '/find-a-contractor', '_blank');
    };

    vm.accountTypeClicked = function (type) {
        vm.selectedAccountType = type;
        if (hasAccountType()) {
            vm.LocationACH.ACHBankAccountTypeId = vm.selectedAccountType.BankAccountTypeId;
        }
        validateAccountType();
    };

    vm.submitForm = function (event) {
        vm.submitted = 'true';
        validateStep(vm.currentStep.id);
        if (vm.addNewOffice.$valid && vm.saving !== true) {
            processStep(vm.currentStep.id, vm.currentStep.id + 1, event);
        }
    };

    vm.calcCharactersRemaining = function () {
        if (vm.officeDescription !== undefined && vm.officeDescription !== null && vm.officeDescription !== '') {
            return vm.maxDescriptionLength - vm.officeDescription.replace(/\n/g, '\r\n').length;
        }
        return vm.maxDescriptionLength;
    };

    vm.selectCounty = function (selectedCounty) {
        var county = _lodash2.default.find(vm.counties[0], function (item) {
            return item.MuniId === selectedCounty.MuniId;
        });
        if (county !== null && county !== undefined) {
            county.isSelected = !county.isSelected;
        } else {
            county = _lodash2.default.find(vm.counties[1], function (item) {
                return item.MuniId === selectedCounty.MuniId;
            });
            if (county !== null && county !== undefined) {
                county.isSelected = !county.isSelected;
            }
        }
    };

    vm.primaryServiceClicked = function (service) {
        service.isSelected = true;
        vm.addNewOffice.$setValidity('noservicetype', true);
        vm.selectedPrimaryService = service;
        vm.contractorServiceTypes = _lodash2.default.without(vm.contractorServiceTypes, vm.defaultServiceType);
        vm.availableServices = _lodash2.default.without(vm.contractorServiceTypes, _lodash2.default.findWhere(vm.contractorServiceTypes, vm.selectedPrimaryService));

        // Check if selected primary is a secondary
        var secService = _lodash2.default.find(vm.secondaryServices, function (secSvc) {
            return secSvc.ContractorTypeId === service.ContractorTypeId;
        });

        if (secService !== undefined && secService !== null) {
            vm.secondaryServices = _lodash2.default.without(vm.secondaryServices, secService);
        }

        _lodash2.default.each(vm.secondaryServices, function (secSvc) {
            vm.availableServices = _lodash2.default.without(vm.availableServices, _lodash2.default.find(vm.availableServices, function (service) {
                return service.ContractorTypeId === secSvc.ContractorTypeId;
            }));
        });
    };

    vm.addService = function () {
        vm.secondaryServices.push(vm.defaultServiceType);
    };

    vm.secondaryServiceClicked = function (type, index) {
        vm.secondaryServices[index] = type;
        vm.availableServices = _lodash2.default.map(vm.contractorServiceTypes, _lodash2.default.clone);
        vm.availableServices = _lodash2.default.without(vm.availableServices, _lodash2.default.findWhere(vm.availableServices, vm.selectedPrimaryService));
        // Rebuild available list
        _lodash2.default.each(vm.secondaryServices, function (selSvc) {
            vm.availableServices = _lodash2.default.without(vm.availableServices, _lodash2.default.findWhere(vm.availableServices, selSvc));
        });
    };

    vm.removeService = function (type) {
        vm.secondaryServices = _lodash2.default.without(vm.secondaryServices, _lodash2.default.findWhere(vm.secondaryServices, type));
        vm.availableServices = _lodash2.default.map(vm.contractorServiceTypes, _lodash2.default.clone);
        vm.availableServices = _lodash2.default.without(vm.availableServices, _lodash2.default.findWhere(vm.availableServices, vm.selectedPrimaryService));
        // Rebuild available list
        _lodash2.default.each(vm.secondaryServices, function (selSvc) {
            vm.availableServices = _lodash2.default.without(vm.availableServices, _lodash2.default.findWhere(vm.availableServices, selSvc));
        });
        vm.availableServices = _lodash2.default.sortBy(vm.availableServices, 'ContractorTypeId');
    };

    vm.checkAccountNumber = function () {
        vm.isEditAccountNumber = true;
        vm.checkAccountNumberChange();
    };

    vm.checkAccountNumberChange = function () {
        if (vm.verifyAccountNumber && vm.LocationACH.ACHAccountNumber !== vm.verifyAccountNumber) {
            vm.addNewOffice.txtAccountNumber.$setValidity('nomatch', false);
            if (vm.addNewOffice.txtVerifyAccountNumber !== undefined) {
                vm.addNewOffice.txtVerifyAccountNumber.$setValidity('nomatch', false);
            }
            vm.errorMessage = 'Account Numbers do not match';
            vm.isAcctNumberConfirmed = false;
        } else {
            vm.addNewOffice.txtAccountNumber.$setValidity('nomatch', true);
            if (vm.addNewOffice.txtVerifyAccountNumber !== undefined) {
                vm.addNewOffice.txtVerifyAccountNumber.$setValidity('nomatch', true);
            }
            vm.errorMessage = '';
            if (vm.LocationACH.ACHAccountNumber === vm.verifyAccountNumber && vm.addNewOffice.$valid) {
                vm.isAcctNumberConfirmed = true;
            }
        }

        if (vm.addNewOffice.$invalid) {
            vm.isAcctNumberConfirmed = false;
        }
    };

    vm.getExampleCheck = function (content) {
        return trusted[content] || (trusted[content] = $sce.trustAsHtml(content));
    };

    vm.selectCopyPaymentInfo = function () {
        vm.useMainACH = !vm.useMainACH;
        if (vm.useMainACH) {
            //			getMainInfo();
            vm.LocationACH = _lodash2.default.extend({}, vm.mainOfficeACH);
            var loadedType = _lodash2.default.filter(vm.accountTypes, function (type) {
                return type.BankAccountTypeId === vm.mainOfficeACH.ACHBankAccountTypeId;
            });
            vm.selectedAccountType = loadedType[0];
            vm.errorMessage = '';

            // Clear validation when copying Payment Info from Main. (This is needed when validation is triggered, then the user selects the checkbox.
            vm.addNewOffice.$setValidity('nocheck', true);
            vm.addNewOffice.$setValidity('noaccounttype', true);
        } else {
            // Don't need to setValidity, since formValidation is always triggered before advancing steps. This code clears out field values.
            vm.LocationACH = {
                ACHBank: '',
                ACHRoutingNumber: '',
                ACHAccountNumber: ''
            };
            vm.verifyAccountNumber = '';
            vm.selectedAccountType = vm.accountTypes[0];
        }
    };

    vm.checkState = function () {
        var activeState = void 0;

        if (vm.selectedState !== null) {
            activeState = _lodash2.default.filter(vm.states, function (state) {
                return state.StateGeoId === vm.selectedState.StateGeoId;
            });
        }

        // Added condition to check activeState length. Filter returns an empty array if no records match condition.
        // Refactored condition to return condition rather than explicit true/false
        return vm.selectedState !== null && activeState !== undefined && activeState.length > 0;
    };

    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions           =
    ======================================== */
    function init() {
        getCurrentLocation();
        vm.submitted = 'false';
        vm.currentStep = vm.steps[0];

        $rootScope.$on('HPFileUploaded', function (event, args, file) {
            vm.LocationACH.VoidedCheckFileName = file.name;
            vm.LocationACH.VoidedCheckTempFileKey = file.tempFileKey;
            vm.displayApprovalBadge = true;
            $rootScope.$apply();
        });
    }

    function getCurrentLocation() {
        UserData.getCurrentLocation().then(function (response) {
            vm.orgId = response.OrganizationId;
            getContractorServices();
            getActiveStates();
            getAccountTypes();
            getUserRights();
        });
    }

    function getUserRights() {
        UserData.getUserData().then(function (response) {
            var currentRole = _lodash2.default.find(HPRoles, function (key, other) {
                return other === response.Roles[0];
            });

            vm.isAdmin = !!currentRole && currentRole.rank === 1;
            if (vm.isAdmin) {
                getMainInfo();
            } else {
                vm.useMainACH = true;
            }
        });
    }

    function getMainInfo() {
        var data = {};

        data.IncludeACHInfo = vm.isAdmin;
        UserData.getMainLocation().then(function (response) {
            data.ContractorLocationId = response[0].ContractorId;
            data.ExcludeLocationInfo = true;
            data.ExcludeProfileInfo = true;
            data.IncludeACHInfo = true;

            OfficesFactory.getOfficeProfile(data).then(function (response) {
                vm.mainOfficeACH = response.data.PaymentDetail;
                if (!vm.mainOfficeACH || !vm.mainOfficeACH.ACHBankAccountTypeId) {
                    vm.mainOfficeACH = null;
                    vm.LocationACH = {
                        ACHBank: '',
                        ACHRoutingNumber: '',
                        ACHAccountNumber: ''
                    };
                    vm.verifyAccountNumber = '';
                    vm.selectedAccountType = vm.accountTypes[0];
                }
            });
        });
    }

    function getContractorServices() {
        OfficesFactory.getServices().then(function (response) {
            vm.contractorServiceTypes = response.data.Data;
            if (_lodash2.default.findWhere(vm.contractorServiceTypes, { ContractorTypeId: -1 }) === undefined) {
                vm.contractorServiceTypes.unshift(vm.defaultServiceType);
            }
            vm.selectedPrimaryService = vm.contractorServiceTypes[0];
            vm.availableServices = vm.contractorServiceTypes;
        });
    }

    // temp. replacing vm.states with all states. also flipped flag from active to all i.e. false
    function getActiveStates() {
        CommonDataFactory.getStates(true).then(function (response) {
            allStates = response.data.Data;
            // vm.states = _.filter(allStates, function (state) {
            //	return state.StateGeoId === 6;
            // });
            vm.states = response.data.Data;
            var state = _lodash2.default.filter(allStates, function (state) {
                return state.StateAbbreviation === vm.address.state;
            });

            if (state.length > 0) {
                vm.selectedState = state[0];
                getCounties(vm.selectedState);
            }
        });
    }

    /* modified. needs to be reverted. e */
    function getCounties(state) {
        if (state === null || angular.isUndefined(state.StateGeoId)) {} else if (vm.fullCountyList.length === 0 || vm.fullCountyList.length === 1 && state.StateGeoId === 6) {
            OfficesFactory.getCounties().then(function (response) {
                vm.fullCountyList = _lodash2.default.each(_lodash2.default.sortBy(response.data.Data.Munis, 'Name'), function (item) {
                    return _lodash2.default.extend(item, { isSelected: false });
                });
                formatCounties(getCountiesByState(state));
            });
        } else {
            formatCounties(getCountiesByState(state));
        }
    }

    function getCountiesByState(state) {
        return _lodash2.default.filter(vm.fullCountyList, function (f) {
            return angular.equals(f.FIPSCode.substring(0, 2), state.StateFIPSPrefix);
        });
    }

    function formatCounties(counties) {
        vm.counties = [];
        var firstHalfCounties = counties.slice(0, counties.length / 2);
        var secondHalfCounties = counties.slice(counties.length / 2);
        vm.counties.push(firstHalfCounties);
        vm.counties.push(secondHalfCounties);
    }

    function getAccountTypes() {
        OfficesFactory.getAccountTypes().then(function (response) {
            vm.accountTypes = response;
            if (_lodash2.default.findWhere(vm.accountTypes, { BankAccountTypeId: -1 }) === undefined) {
                vm.accountTypes.unshift(vm.defaultAccountType);
            }
            vm.selectedAccountType = vm.accountTypes[0];
        });
    }

    function prepServicesForSave() {
        var currentSelectedServices = [];
        _lodash2.default.each(vm.secondaryServices, function (service) {
            if (service.ContractorTypeId !== undefined && service.ContractorTypeId !== null && service.ContractorTypeId !== -1) {
                currentSelectedServices.push({
                    ContractorTypeId: service.ContractorTypeId,
                    IsPrimaryType: false
                });
            }
        });
        currentSelectedServices.push({
            ContractorTypeId: vm.selectedPrimaryService.ContractorTypeId,
            IsPrimaryType: true
        });
        return currentSelectedServices;
    }

    function prepMunisForSave() {
        // var munis = vm.counties[0].slice();
        // munis.push.apply(munis, vm.counties[1]);
        var filteredMunis = _lodash2.default.filter(vm.fullCountyList, function (muni) {
            return muni.isSelected === true;
        });
        var currentMunis = [];
        _lodash2.default.each(filteredMunis, function (muni) {
            currentMunis.push({ MuniId: muni.MuniId });
        });
        return currentMunis;
    }

    function hasPrimaryService() {
        if (vm.selectedPrimaryService.ContractorTypeId === -1) {
            return false;
        }

        return true;
    }

    function validatePrimaryService() {
        if (hasPrimaryService()) {
            vm.addNewOffice.$setValidity('noservicetype', true);
        } else {
            vm.addNewOffice.$setValidity('noservicetype', false);
        }
    }

    function hasState() {
        if (vm.address.state) {
            return true;
        }

        return false;
    }

    function validateState() {
        if (hasState()) {
            vm.addNewOffice.$setValidity('nostate', true);
        } else {
            vm.addNewOffice.$setValidity('nostate', false);
        }
    }

    function hasAccountType() {
        if (!vm.selectedAccountType || vm.selectedAccountType.BankAccountTypeId === -1) {
            return false;
        }

        return true;
    }

    function validateAccountType() {
        if (hasAccountType()) {
            vm.addNewOffice.$setValidity('noaccounttype', true);
        } else {
            vm.addNewOffice.$setValidity('noaccounttype', false);
        }
    }

    function hasCheck() {
        if (vm.LocationACH.VoidedCheckTempFileKey === undefined || vm.LocationACH.VoidedCheckFileName === undefined) {
            return false;
        }

        return true;
    }

    function validateCheck() {
        if (hasCheck()) {
            vm.addNewOffice.$setValidity('nocheck', true);
        } else {
            vm.addNewOffice.$setValidity('nocheck', false);
        }
    }

    function validateStep(id) {
        vm.scrollToTop = false;
        switch (id) {
            case 0:
                validateState();
                break;
            case 1:
                break;
            /*
            case 2:
            if (!vm.useMainACH) {
                validateAccountType();
                validateCheck();
            }
            break;
            */
            default:
                validatePrimaryService();
                break;
        }
    }

    function clearValidation(id) {
        switch (id) {
            case 0:
                vm.addNewOffice.$setValidity('nostate', true);
                break;
            case 1:
                vm.addNewOffice.$setValidity('noaccounttype', true);
                vm.addNewOffice.$setValidity('nocheck', true);
                break;
            default:
                vm.countiesErrorMessage = '';
                vm.addNewOffice.$setValidity('noservicetype', true);
                break;
        }
    }

    function processStep(fromId, toId, event) {
        switch (fromId) {
            case 0:
                if (fromId > toId) {
                    vm.closeModal();
                    break;
                } else {
                    moveStep(fromId, toId);
                }
                if (event) {
                    event.preventDefault();
                }
                break;
            case 1:
                // case 2:
                if (fromId > toId) {
                    moveStep(fromId, toId);
                } else {
                    moveStep(fromId, toId);
                }
                if (event) {
                    event.preventDefault();
                }
                break;
            default:
                if (fromId > toId) {
                    moveStep(fromId, toId);
                } else {
                    vm.saving = true;
                    var data = {
                        OrganizationId: vm.orgId,
                        LocationDetail: {
                            LocationNickname: vm.officeName,
                            Address: vm.address.street,
                            City: vm.address.city,
                            State: vm.address.state,
                            Zip: vm.address.zip
                        },
                        ProfileDetail: {
                            CompanyOverview: vm.officeDescription,
                            CompanyURL: vm.officeWebsite,
                            LogoFilename: vm.logoFileName,
                            ContractorTypes: prepServicesForSave(),
                            Munis: prepMunisForSave()
                        },
                        LocationACH: vm.LocationACH,
                        LocationContact: {
                            OfficeContactFirstName: vm.contactFirstName,
                            OfficeContactLastName: vm.contactLastName,
                            OfficeContactPhone: vm.contact.PhoneNumber,
                            OfficeContactPhoneExtension: vm.contact.Extension,
                            OfficeContactEmail: vm.contact.Email,
                            LeadContacts: [{
                                FirstName: vm.leadContact.contactFirstName,
                                LastName: vm.leadContact.contactLastName,
                                Email: vm.leadContact.Email,
                                Phone: vm.leadContact.PhoneNumber,
                                Extension: vm.leadContact.Extension
                            }]
                        }
                    };

                    // if (vm.useMainACH || !vm.isAdmin) {
                    data.CopyACHFromMasterLocation = true;
                    data.LocationACH = null;
                    // }

                    saveNewOffice(data);
                }
                break;
        }
    }

    function saveNewOffice(data) {
        OfficesFactory.saveNewOffice(data).then(function () {
            vm.saving = false;
            vm.successText = vm.officeName + ' office has been added successfully!';
            vm.contentShown = 'addOfficeSuccess';
            UserData.resetPromises().then(function () {
                $rootScope.$broadcast('officesUpdated');
            });
        });
    }

    function moveStep(fromId, toId) {
        if (fromId > toId) {
            // Backward
            vm.steps[fromId].isVisited = true;
            vm.steps[fromId].isActive = false;
            vm.steps[toId].isVisited = false;
            vm.steps[toId].isActive = true;
            clearValidation(fromId);
        } else {
            // Forward
            vm.steps[fromId].isVisited = true;
            vm.steps[fromId].isCompleted = true;
            vm.steps[fromId].isActive = false;
            vm.steps[toId].isActive = true;
            vm.steps[toId].isVisited = false;
        }
        vm.currentStep = vm.steps[toId];
        DirectiveService.publish('scroll');
        vm.addNewOffice.$setPristine();
        vm.submitted = 'false';
    }

    $rootScope.$watch(function () {
        return vm.logoImage;
    }, function (val) {
        if (val !== undefined && val !== null) {
            vm.uploadErrorMessage = '';
            vm.displayLogo = true;
        }
    });
    /* modified used allStates instead of vm.states */
    $rootScope.$watch(function () {
        return vm.address.state;
    }, function (val, oldval) {
        if (!angular.equals(val, oldval)) {
            var state = _lodash2.default.find(allStates, function (s) {
                return s.StateAbbreviation === val;
            });
            vm.selectedState = angular.isUndefined(state) ? null : state;
        }
    });
    /* modified used allStates instead of vm.states */
    $rootScope.$watch(function () {
        return vm.selectedState;
    }, function (val, oldval) {
        if (!angular.equals(val, oldval)) {
            if (val === null) {
                vm.counties = [];
                return;
            }
            var state = _lodash2.default.find(allStates, function (s) {
                return s === val;
            });
            if (angular.isUndefined(state)) {
                return;
            }
            getCounties(vm.selectedState);
        }
    });

    $rootScope.$on('addLogoInvalidUploadType', function (event, payload) {
        vm.uploadErrorMessage = 'That file is not a jpeg, jpg, tiff, gif, bmp, or png.';
        $analytics.eventTrack('Invalid Logo Upload', { category: 'Add Office', label: 'File Extension: ' + payload.fileType });
    });

    $rootScope.$on('addLogoInvalidUploadSize', function () {
        vm.uploadErrorMessage = 'That file is larger than 10 MB.';
    });

    $rootScope.$on('addLogoStartUpload', function (event, payload) {
        OfficesFactory.saveLogo(payload).then(function (response) {
            vm.logoImage = HPConfig.rackspaceCdn + response.data.Data.FileName;
            vm.logoFileName = response.data.Data.FileName;
            vm.uploadErrorMessage = '';
        });
    });

    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 429 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 430 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 432 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 434 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <span class=\"icon icon-delete\" ng-click=\"addOffice.closeModal()\"></span>\n</div>\n\n<div class=\"row\" modal-scroll-to-top>\n    <div class=\"col-md-10 col-md-offset-1\">\n        <div class=\"modal-body\">\n            <p class=\"modal-title\">Add Office</p>\n\n            <div class=\"add-office-steps-detail\" ng-if=\"addOffice.contentShown === 'addOfficeInProgress'\">\n                <form name=\"addOffice.addNewOffice\" ng-submit=\"addOffice.submitForm($event)\" novalidate>\n                    <div class=\"row\">\n                        <div class=\"col-md-12 text-center progress-spacer\">\n                            <hp-progress-indicator progress-steps=\"addOffice.steps\" click-handler=\"addOffice.navigateProgress\" ></hp-progress-indicator>\n                        </div>\n                    </div>\n                    <div class=\"row\" ng-repeat=\"step in addOffice.steps\">\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-md-8 col-md-offset-2 text-center\">\n                            <ng-include src=\"addOffice.currentStep.path\"></ng-include>\n                        </div>\n                    </div>\n                    <div class=\"row modal-buttons-container\">\n                        <div class=\"col-md-8 col-md-offset-2 text-center\">\n                            <div class=\"modal-buttons text-center\">\n                                <hp-spinner-button button-text=\"{{addOffice.currentStep.defaultBtnText}}\" button-name=\"btnAddOffice\" is-primary-btn=\"true\"\n                                                   is-submit-button=\"true\" display-spinner=\"addOffice.saving\"></hp-spinner-button>\n                                <button class=\"btn btn-default\" ng-click=\"addOffice.defaultBtnClick($event)\">\n                                    {{addOffice.currentStep.primaryBtnText}}\n                                </button>\n                            </div>\n                        </div>\n                    </div>\n                </form>\n            </div>\n\n            <full-screen-modal-success ng-if=\"addOffice.contentShown === 'addOfficeSuccess'\"\n                                       primary-text=\"{{addOffice.successText}}\"\n                                       secondary-text=\"\"\n                                       button-text=\"Done\"\n                                       button-fn=\"addOffice.closeModal()\">\n            </full-screen-modal-success>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 435 */
/***/ (function(module, exports) {

module.exports = "<h2>Contact Information</h2>\n<div class=\"text-left add-office-info\">\n    <div class=\"office-contact-info-container\">\n        <div class=\"row office-name-label-container\">\n            <div class=\"col-md-12\">\n                <span>Office Contact Information</span>\n            </div>\n        </div>\n        <div class=\"row office-name-field-container\">\n            <div class=\"col-md-6 contact-first-name-container\">\n                <input id=\"txt-contact-first-name\" name=\"txtContactFirstName\" type=\"text\" ng-required=\"true\" placeholder=\"First Name\" maxlength=\"30\"\n                       ng-model=\"addOffice.contactFirstName\" ng-change=\"addOffice.updateLeadContact()\">\n                <div class=\"error-message-container\">\n                    <p class=\"error-message\" ng-if=\"addOffice.addNewOffice.txtContactFirstName.$error.required && addOffice.submitted === 'true'\">Required</p>\n                </div>\n            </div>\n            <div class=\"col-md-6 contact-last-name-container\">\n                <input id=\"txt-contact-last-name\" name=\"txtContactLastName\" type=\"text\" ng-required=\"true\" placeholder=\"Last Name\" maxlength=\"30\"\n                       ng-model=\"addOffice.contactLastName\" ng-change=\"addOffice.updateLeadContact()\">\n                <div class=\"error-message-container\">\n                    <p class=\"error-message\" ng-if=\"addOffice.addNewOffice.txtContactLastName.$error.required && addOffice.submitted === 'true'\">Required</p>\n                </div>\n            </div>\n        </div>\n    </div>\n    <hp-contact-info contact=\"addOffice.contact\" required=\"true\" submitted=\"addOffice.submitted\" editor=\"false\" onupdate=\"addOffice.updateLeadContact\"></hp-contact-info>\n</div>\n<div class=\"text-left add-office-info\">\n    <div class=\"office-contact-info-container\">\n        <div class=\"row office-name-label-container\">\n            <div class=\"col-md-12\">\n                <span>Leads Primary Contact</span>\n            </div>\n        </div>\n        <div class=\"row office-name-label-container\">\n            <div class=\"col-md-12\">\n                <div class=\"checkbox-container\">\n                    <span class=\"icon icon-checkbox-default\" ng-class=\"{'icon-checkbox-selected': addOffice.leadSameAsContact}\"></span>\n                    <input id=\"check_same\" name=\"check_same\" type=\"checkbox\" class=\"icon-checkbox-default\"\n                           ng-model=\"addOffice.leadSameAsContact\" ng-change=\"addOffice.sameAsContactInfo()\"/>\n                    <label for=\"check_same\">Same as office contact information</label>                    \n                </div>\n            </div>\n        </div>\n        <div class=\"row office-name-field-container\">\n            <div class=\"col-md-6 contact-first-name-container\">\n                    <input id=\"txt-lead-contact-first-name\" name=\"txtLeadContactFirstName\" type=\"text\" ng-required=\"!addOffice.leadSameAsContact\" placeholder=\"First Name\" maxlength=\"30\"\n                       ng-model=\"addOffice.leadContact.contactFirstName\" ng-disabled=\"addOffice.leadSameAsContact\">\n                <div class=\"error-message-container\">\n                    <p class=\"error-message\" ng-if=\"addOffice.addNewOffice.txtLeadContactFirstName.$error.required && addOffice.submitted === 'true'\">Required</p>\n                </div>\n            </div>\n            <div class=\"col-md-6 contact-last-name-container\">\n                <input id=\"txt-lead-contact-last-name\" name=\"txtLeadContactLastName\" type=\"text\" ng-required=\"!addOffice.leadSameAsContact\" placeholder=\"Last Name\" maxlength=\"30\"\n                       ng-model=\"addOffice.leadContact.contactLastName\" ng-disabled=\"addOffice.leadSameAsContact\">\n                <div class=\"error-message-container\">\n                    <p class=\"error-message\" ng-if=\"addOffice.addNewOffice.txtLeadContactLastName.$error.required && addOffice.submitted === 'true'\">Required</p>\n                </div>\n            </div>\n        </div>\n    </div>\n    <hp-contact-info contact=\"addOffice.leadContact\" required=\"!addOffice.leadSameAsContact\" submitted=\"addOffice.submitted\" editor=\"false\" toggle-off=\"addOffice.leadSameAsContact\" noconfirm=\"true\"></hp-contact-info>\n    <div class=\"leads-info\">\n        <h5>When a homeowner contacts your company via FOAHI.com, the lead will be sent to this office using this contact information. This information is not displayed to the public.</h5>\n        <h5>Leads for this office will also be emailed automatically to everyone who has Admin access in Contractor Portal.</h5>        \n    </div>\n\n</div>\n";

/***/ }),
/* 436 */
/***/ (function(module, exports) {

module.exports = "<h2>Office Information</h2>\n<div class=\"text-left add-office-info\">\n    <div class=\"office-name-container\">\n        <div class=\"row office-name-label-container\">\n            <div class=\"col-md-12\">\n                <span>Office name</span>\n            </div>\n        </div>\n        <div class=\"row office-name-field-container\">\n            <div class=\"col-md-12\">\n                <input id=\"txt-office-name\" name=\"txtOfficeName\" type=\"text\" ng-required=\"true\" ng-class=\"{ 'is-required' : addOffice.addNewOffice.txtOfficeName.$required && addOffice.submitted === 'true'}\"\n                       maxlength=\"60\" ng-model=\"addOffice.officeName\" placeholder=\"Nickname to tell this office from others\">\n                <div class=\"error-message-container\">\n                    <p class=\"error-message\" ng-if=\"addOffice.addNewOffice.txtOfficeName.$error.required && addOffice.submitted === 'true'\">Required</p>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"office-address-container\">\n        <hp-office-address address=\"addOffice.address\" required=\"true\" submitted=\"addOffice.submitted\"></hp-office-address>\n    </div>\n</div>\n";

/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports = "<h2 ng-if=\"addOffice.isAdmin\">Payment Information</h2>\n<div class=\"text-left add-office-payment-info\">\n    <div class=\"office-copy-payment-info-container\" ng-if=\"addOffice.mainOfficeACH\">\n        <div class=\"row office-payment-field-container\">\n            <div class=\"col-md-12\">\n                <div id=\"cb-copy-payment-info\" name=\"cbCopyPaymentInfo\" ng-click=\"addOffice.selectCopyPaymentInfo()\">\n                    <span class=\"icon icon-complete\" ng-if=\"addOffice.useMainACH === true\"></span>\n                    <span class=\"empty-checkbox\" ng-if=\"addOffice.useMainACH === false\"></span>\n                    <label>Same as the main office account</label>\n                </div>\n                <p>If you'd like to have other ACH information used for this office, you can configure that once you complete this flow.</p>\n            </div>\n        </div>\n    </div>\n    <div class=\"office-add-payment-info-container\" ng-if=\"addOffice.isAdmin && addOffice.addACHEnabled\">\n        <div class=\"office-payment-info-container\">\n            <div class=\"row office-payment-label-container\">\n                <div class=\"col-md-12\">\n                    <span>Account name</span>\n                </div>\n            </div>\n            <div class=\"row office-payment-field-container\">\n                <div class=\"col-md-12\">\n                    <input id=\"txt-account-name\" name=\"txtAccountName\" type=\"text\" ng-disabled=\"addOffice.useMainACH\"\n                           ng-required=\"true\" placeholder=\"This is a nickname to tell your accounts apart\"\n                           ng-class=\"{ 'is-required' : addOffice.addNewOffice.txtAccountName.$error.required && addOffice.submitted === 'true'}\"\n                           ng-model=\"addOffice.LocationACH.ACHBank\" maxlength=\"100\" \\>\n                    <div class=\"error-message-container\">\n                        <p class=\"error-message\"\n                           ng-if=\"addOffice.addNewOffice.txtAccountName.$error.required && addOffice.submitted === 'true'\">\n                            Required</p>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"office-payment-info-container\">\n            <div class=\"row office-payment-label-container\">\n                <div class=\"col-md-12\">\n                    <span>Account type</span>\n                </div>\n            </div>\n            <div class=\"row office-payment-dropdown-container\">\n                <div class=\"col-md-12\">\n                    <div class=\"dropdown\" uib-dropdown dropdown-small-popup dropdown-title=\"AccountType\"\n                         ng-class=\"{ 'invalid-type': addOffice.selectedAccountType.BankAccountTypeId === -1 && addOffice.submitted === 'true' }\">\n                        <a id=\"ddl-account-type\" blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle\n                           data-toggle=\"dropdown\" ng-class=\"{'disabled' : addOffice.useMainACH}\">\n                                <span class=\"dropdown-text\"\n                                      ng-bind=\"addOffice.selectedAccountType.Description\"></span>\n                            <span class=\"icon\"></span>\n                        </a>\n                        <ul class=\"dropdown-menu address-breakdown-small\" uib-dropdown-menu>\n                            <li ng-repeat=\"type in addOffice.accountTypes\"\n                                ng-class=\"{'active': addOffice.selectedAccountType.BankAccountTypeId === type.BankAccountTypeId }\"\n                                ng-click=\"addOffice.accountTypeClicked(type)\">\n                                <span>{{type.Description}}</span>\n                            </li>\n                        </ul>\n                    </div>\n                    <div class=\"error-message-container\">\n                        <p class=\"error-message\"\n                           ng-if=\"addOffice.selectedAccountType.BankAccountTypeId === -1 && addOffice.submitted === 'true'\">\n                            Required</p>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"office-payment-info-container\">\n            <div class=\"row office-payment-label-container\">\n                <div class=\"col-md-12\">\n                    <span>Routing number</span>\n                    <span>\n                        <a href=\"#\" class=\"icon icon-pipeline-tip\" hp-popover popover-placement=\"bottom\"\n                           popover-trigger=\"show\" popover-title=\"\"\n                           uib-popover-html=\"addOffice.getExampleCheck(addOffice.content)\"></a>\n                    </span>\n\n                </div>\n            </div>\n            <div class=\"row office-payment-field-container\">\n                <div class=\"col-md-12\">\n                    <input id=\"txt-routing-number\" name=\"txtRoutingNumber\" type=\"text\"\n                           placeholder=\"Enter routing number\"\n                           ng-required=\"true\" hp-numeric-only ng-disabled=\"addOffice.useMainACH\"\n                           ng-class=\"{ 'is-required' : addOffice.addNewOffice.txtRoutingNumber.$error.required && addOffice.submitted === 'true'}\"\n                           ng-model=\"addOffice.LocationACH.ACHRoutingNumber\" maxlength=\"50\" \\>\n                    <div class=\"error-message-container\">\n                        <p class=\"error-message\"\n                           ng-if=\"addOffice.addNewOffice.txtRoutingNumber.$error.required && addOffice.addNewOffice.$submitted\">\n                            Required</p>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"office-payment-info-container\">\n            <div class=\"row office-payment-label-container\">\n                <div class=\"col-md-12\">\n                    <span>Account number</span>\n                </div>\n            </div>\n            <div class=\"row office-payment-field-container\">\n                <div class=\"col-md-12\">\n                    <span class=\"icon icon-todo\" ng-if=\"addOffice.isAcctNumberConfirmed\"></span>\n                    <input id=\"txt-account-number\" name=\"txtAccountNumber\" type=\"text\"\n                           ng-disabled=\"addOffice.useMainACH\" placeholder=\"Enter account number\"\n                           ng-required=\"true\" hp-numeric-only ng-change=\"addOffice.checkAccountNumber()\"\n                           ng-class=\"{ 'is-required' : addOffice.addNewOffice.txtAccountNumber.$error.required && addOffice.submitted === 'true',\n                                        'is-invalid' : addOffice.errorMessage !== '' && addOffice.submitted === 'true'}\"\n                           ng-model=\"addOffice.LocationACH.ACHAccountNumber\" maxlength=\"50\" \\>\n                    <div class=\"error-message-container\">\n                        <p class=\"error-message\"\n                           ng-if=\"addOffice.addNewOffice.txtAccountNumber.$error.required && addOffice.addNewOffice.$submitted\">\n                            Required</p>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"office-payment-info-container\" ng-hide=\"addOffice.useMainACH\">\n            <div class=\"row office-payment-label-container\">\n                <div class=\"col-md-12\">\n                    <span>Verify account number</span>\n                </div>\n            </div>\n            <div class=\"row office-payment-field-container\">\n                <div class=\"col-md-12\">\n                    <span class=\"icon icon-todo\" ng-if=\"addOffice.isAcctNumberConfirmed\"></span>\n                    <input id=\"txt-verify-account-number\" name=\"txtVerifyAccountNumber\" type=\"text\"\n                           ng-required=\"!addOffice.useMainACH\" hp-numeric-only placeholder=\"Re-enter account number\"\n                           ng-change=\"addOffice.checkAccountNumber()\"\n                           ng-class=\"{ 'is-required' : addOffice.addNewOffice.txtAccountNumber.$error.required && addOffice.submitted === 'true',\n                                        'is-invalid' : addOffice.errorMessage !== '' && addOffice.submitted === 'true'}\"\n                           ng-model=\"addOffice.verifyAccountNumber\" maxlength=\"50\" \\>\n                    <div class=\"error-message-container\">\n                        <p class=\"error-message\"\n                           ng-if=\"addOffice.addNewOffice.txtVerifyAccountNumber.$error.required && addOffice.addNewOffice.$submitted\">\n                            Required</p>\n                        <p class=\"error-message \"\n                           ng-show=\"addOffice.errorMessage !== '' && addOffice.submitted === 'true'\"\n                           ng-bind=\"addOffice.errorMessage\"></p>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"office-payment-info-container\" ng-hide=\"addOffice.useMainACH\">\n            <div class=\"row office-payment-label-container\">\n                <div class=\"col-md-12\">\n                    <span>Voided check</span>\n                    <div class=\"approval-container pull-right\" ng-if=\"addOffice.displayApprovalBadge\">\n                        <span class=\"approval-status\">Pending Approval</span>\n                        <span class=\"hp-badge approval-needed\">!</span>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row office-finance-check-upload-container\">\n                <div class=\"col-md-12\">\n                    <div class=\"dropzone hp-dropzone\" dropzone=\"\" id=\"dropzone\"\n                         ng-class=\"{'no-check': addOffice.displayApprovalBadge === false && addOffice.submitted === 'true'}\"\n                         dropzone-url=\"DocumentManagement/UploadAttachment\"\n                         dropzone-form-data=\"{ContractorId:24614}\"\n                         dropzone-form-data-field=\"Payload\"\n                         dropzone-accepted-files=\".jpg,.jpeg,.png,.gif,.tif,.bmp,.pdf\"\n                         drop-zone-max-file-size=\"10\">\n                        <div class=\"dz-default dz-message\">\n                            <p class=\"icon icon-checkbook\"></p>\n                            <p class=\"draganddrop-message\">Drag and drop a file here</p>\n                            <p class=\"draganddrop-message\">or <span class=\"link\"\n                                                                    ng-click=\"addOffice.uploadButtonClicked($event)\">Choose file</span>\n                            </p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-12 upload-instructions-container\">\n                    <p>Max accepted file size is 10 MB.</p>\n                    <p>Supported file types: jpeg, jpg, tiff, gif, bmp, png, pdf</p>\n                </div>\n            </div>\n            <div>\n                <div class=\"error-message-container dropzone-error text-center\">\n                    <p class=\"error-message \" ng-show=\"addOffice.displayApprovalBadge === false && addOffice.submitted === 'true'\">Please upload a voided check.</p>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"office-default-payment-info-container\" ng-if=\"!addOffice.isAdmin\">\n        <h2>For this office's banking info, we'll use what's on record for the company's main office.</h2>\n        <p>To check or change the details, ask the person who's the administrator of your company's account.</p>\n    </div>\n</div>\n";

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports = "<h2>Office Profile</h2>\n<div>\n    <p>Your office profile will appear in the customer search results at <span class=\"link\" ng-click=\"addOffice.openContractorPage()\">www.foahi.com/find-a-contractor</span> </p>\n</div>\n<div class=\"text-left add-office-profile\">\n    <div class=\"row\">\n        <div class=\"col-md-12 office-profile-edit-right-column\">\n            <div class=\"row office-profile-label-container\">\n                <div class=\"col-md-12\">\n                    <span>Office logo</span>\n                </div>\n            </div>\n            <div class=\"row office-profile-logo-upload-container\">\n                <div class=\"col-md-12\">\n                    <div class=\"add-logo-upload-container\">\n                        <ng-form name=\"addOffice.imageUpload\">\n                            <div class=\"row\">\n                                <div class=\"col-md-12\">\n                                    <div class=\"add-logo-image-container\" ng-class=\"{ 'upload-error' : addOffice.uploadErrorMessage !== '', 'upload' : addOffice.uploadErrorMessage === ''}\" ng-if=\"addOffice.displayLogo === true\">\n                                        <img id=\"imgLogoPreview\" ng-src=\"{{addOffice.logoImage}}\" />\n                                    </div>\n                                    <div class=\"logo-image-placeholder\" ng-class=\"{ 'upload-error' : addOffice.uploadErrorMessage !== '', 'upload' : addOffice.uploadErrorMessage === ''}\" ng-if=\"addOffice.displayLogo === false || addOffice.displayLogo === null\">\n                                        <div class=\"placeholder-content-container\">\n                                            <div class=\"icon icon-company-default\"></div>\n                                            <div class=\"placeholder-text\">Add Company Logo</div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"col-md-12\">\n                                    <div class=\"logo-upload-button-container\">\n                                        <div class=\"btn btn-primary btn-overlay\">Choose File</div>\n                                        <input type=\"file\" id=\"btn-logo-upload\" class=\"btn-browse\" size=\"100\" fileread=\"addOffice.logoImage\" source=\"addLogo\">\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"col-md-12 upload-instructions-container\">\n                                    <p>Max accepted file size is 10 MB.</p>\n                                    <p>Supported file types: jpeg, jpg, tiff, gif, bmp, png</p>\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"col-md-12 error-message-container\">\n                                    <p class=\"error-message\" ng-bind=\"addOffice.uploadErrorMessage\" ng-if=\"addOffice.uploadErrorMessage !== ''\"></p>\n                                </div>\n                            </div>\n                        </ng-form>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row office-profile-label-container label-spacer\">\n                <div class=\"col-md-12\">\n                    <span>Office website</span>\n                </div>\n            </div>\n            <div class=\"row office-profile-field-container\">\n                <div class=\"col-md-12\">\n                    <input id=\"txt-company-url\" name=\"txtCompanyWebsite\" type=\"text\" ng-required=\"true\" ng-class=\"{ 'is-required' : addOffice.addNewOffice.txtCompanyWebsite.$error.required && addOffice.submitted === 'true'}\" ng-model=\"addOffice.officeWebsite\" \\>\n\n                    <div class=\"error-message-container\">\n                        <p class=\"error-message\" ng-if=\"addOffice.addNewOffice.txtCompanyWebsite.$error.required && addOffice.submitted === 'true'\">Required</p>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row office-profile-label-container service-label-spacer\">\n                <div class=\"col-md-12\">\n                    <span>Most of your jobs are:</span>\n                </div>\n            </div>\n            <div class=\"row office-profile-dropdown-container\">\n                <div class=\"col-md-12\">\n                    <div class=\"dropdown\" uib-dropdown dropdown-small-popup dropdown-title=\"PrimaryJob\" ng-class=\"{ 'invalid-type': addOffice.selectedPrimaryService.ContractorTypeId === -1 && addOffice.submitted === 'true' }\">\n                        <a id=\"ddl-primary-job\" blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle data-toggle=\"dropdown\">\n                            <span class=\"dropdown-text\" ng-bind=\"addOffice.selectedPrimaryService.Description\"></span>\n                            <span class=\"icon\"></span>\n                        </a>\n                        <ul class=\"dropdown-menu address-breakdown-small\" uib-dropdown-menu>\n                            <li ng-repeat=\"type in addOffice.contractorServiceTypes\" ng-class=\"{'active': addOffice.selectedPrimaryService.ContractorTypeId === type.ContractorTypeId }\" ng-click=\"addOffice.primaryServiceClicked(type)\">\n                                <span>{{type.Description}}</span>\n                            </li>\n                        </ul>\n                    </div>\n                    <div class=\"error-message-container\">\n                        <p class=\"error-message\" ng-if=\"addOffice.selectedPrimaryService.ContractorTypeId === -1 && addOffice.submitted === 'true'\">Required</p>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row\">\n        <!-- <div class=\"col-md-7 office-profile-edit-left-column\">\n            <div class=\"office-counties-header-container\">\n                <div class=\"row office-profile-label-container label-spacer\">\n                    <div class=\"col-md-12\">\n                        <div ng-hide=\"!addOffice.checkState();\"> \n                            <span>In which state does this office do business?</span>\n                            <div class=\"office-counties-subtext\">(At least one must be selected)</div>\n                            <hp-active-states current-state=\"addOffice.selectedState\" active-states=\"addOffice.states\" required=\"false\"></hp-active-states>\n                        </div>\n\n                    </div>\n                </div>\n\n                <div ng-hide=\"!addOffice.checkState();\">\n                    <div class=\"row office-profile-label-container\">\n                        <div class=\"col-md-12\">\n                            <span ng-show=\"addOffice.address.state === 'CA'\">In which counties do you do business?</span>\n                            <div class=\"office-counties-subtext\" ng-show=\"addOffice.address.state === 'CA'\">(At least one must be selected)</div>\n                        </div>\n                    </div>\n                    <div class=\"row office-counties-container\">\n                        <div class=\"col-md-12\">\n                            <div class=\"row\" ng-show=\"addOffice.address.state !== ''\"> \n                                <div class=\"col-md-6\">\n                                    <div class=\"row\">\n                                        <div class=\"col-md-12 county-row\" ng-repeat=\"county in addOffice.counties[0]\" ng-attr-id=\"{{ 'cb' + county.Name }}\" ng-click=\"addOffice.selectCounty(county)\">\n                                            <span class=\"icon icon-complete\" ng-if=\"county.isSelected === true\"></span>\n                                            <span class=\"empty-checkbox\" ng-if=\"county.isSelected === false\"></span>\n                                            <span ng-bind=\"county.Name\"></span>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"col-md-6\">\n                                    <div class=\"row\">\n                                        <div class=\"col-md-12 county-row\" ng-repeat=\"county in addOffice.counties[1]\" ng-attr-id=\"{{ 'cb' + county.Name }}\" ng-click=\"addOffice.selectCounty(county)\">\n                                            <span class=\"icon icon-complete\" ng-if=\"county.isSelected === true\"></span>\n                                            <span class=\"empty-checkbox\" ng-if=\"county.isSelected === false\"></span>\n                                            <span ng-bind=\"county.Name\"></span>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"col-md-12 error-message-container\">\n                                    <p class=\"error-message\" ng-bind=\"addOffice.countiesErrorMessage\"></p>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div> -->\n        <div class=\"col-md-5 office-profile-edit-right-column\">\n            <div class=\"row office-profile-label-container label-spacer\">\n                <div class=\"col-md-12\">\n                    <span>Other jobs include:</span>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-12 additional-services-dropdown-container\">\n                    <div ng-repeat=\"service in addOffice.secondaryServices track by $index\">\n                        <div class=\"dropdown-container\">\n                            <div class=\"dropdown\" uib-dropdown dropdown-small-popup>\n                                <a blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle data-toggle=\"dropdown\">\n                                    <span class=\"dropdown-text\" ng-bind=\"addOffice.secondaryServices[$index].Description\"></span>\n                                    <span class=\"icon\"></span>\n                                </a>\n                                <ul class=\"dropdown-menu address-breakdown-small\" uib-dropdown-menu>\n                                    <li ng-repeat=\"type in addOffice.availableServices\" ng-class=\"{'active': service.ContractorTypeId === type.ContractorTypeId }\" ng-click=\"addOffice.secondaryServiceClicked(type,$parent.$index)\">\n                                        <span>{{type.Description}}</span>\n                                    </li>\n                                </ul>\n                            </div>\n                            <span class=\"icon icon-zoom-out remove-service-icon\" ng-click=\"addOffice.removeService(service)\"></span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-12\">\n                    <div class=\"add-service-container\" ng-click=\"addOffice.addService()\" ng-if=\"addOffice.availableServices.length > 0\" ng-class=\"{'disabled': (addOffice.selectedPrimaryService === null || addOffice.selectedPrimaryService === undefined) }\">\n                        <div class=\"icon icon-zoom-in add-service-icon\"></div>\n                        <div class=\"add-service-label\"> Add Service</div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _officeFinancingController = __webpack_require__(440);

var _officeFinancingController2 = _interopRequireDefault(_officeFinancingController);

var _achController = __webpack_require__(442);

var _achController2 = _interopRequireDefault(_achController);

var _achDirective = __webpack_require__(444);

var _achDirective2 = _interopRequireDefault(_achDirective);

__webpack_require__(445);

var _plaidFactory = __webpack_require__(446);

var _plaidFactory2 = _interopRequireDefault(_plaidFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.accounts.offices.financing', []).controller('OfficeFinancingController', _officeFinancingController2.default).controller('AchController', _achController2.default).factory('PlaidFactory', _plaidFactory2.default).directive('hpAch', _achDirective2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/accounts/offices/financing/officeFinancing.html', __webpack_require__(447)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/offices/financing/viewFinancing.html', __webpack_require__(448)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/offices/financing/ach/ach.html', __webpack_require__(449)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/offices/financing/checkUpload/checkUpload.html', __webpack_require__(450)); // eslint-disable-line global-require
}]).name; // no controller

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = officeFinancingController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(441);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

officeFinancingController.$inject = ['PlaidFactory', 'OfficesFactory', '$stateParams', 'UserData', 'HPRoles', '$q', 'raSpinnerService']; // angular
// 	.module("HeroPRO")
// 	.controller("OfficeFinancingController", officeFinancingController);


/* @ngInject */
function officeFinancingController(PlaidFactory, OfficesFactory, $stateParams, UserData, HPRoles, $q, raSpinnerService) {
    var vm = this;

    vm.heroDescription = 'Payments will be sent to the account information provided here.';

    // Flags
    vm.isEditingFinancing = false;
    vm.isImpersonation = false;
    vm.plaidValidation = {
        AccountOwnerNamesMatched: true,
        AccountAddressesMatched: true
    };

    init();

    /*= =======================================
     =            Public Functions            =
     ======================================== */

    vm.editFinancing = function () {
        //vm.isEditingFinancing = true;

        UserData.getUserData().then(function (userData) {
            PlaidFactory.createLinkToken(userData.ContractorUserId).then(function (response) {
                if (response.Data.LinkToken !== '') {
                    PlaidFactory.openPlaid(response.Data.LinkToken).then(function (metadata) {
                        var publicToken = metadata.public_token;

                        var selectedAccountId = null;
                        if (metadata.account) {
                            selectedAccountId = metadata.account.id;
                        }

                        if (!publicToken) {
                            // TODO: Handle plaid error / not found
                        } else {
                            vm.loading = true;

                            PlaidFactory.updateContractorLocationACH(Number($stateParams.accountId), publicToken, selectedAccountId).then(function (achResponse) {
                                vm.plaidValidation = achResponse.data.Data;
                                init();
                            }, function (err) {
                                throw err;
                            });
                        }
                    }, function (err) {
                        throw err;
                    });
                }
            }, function (err) {
                throw err;
            });
        });
    };

    // Function used to add additional behavior to Cancel button in Edit ACH Directive
    vm.cancelEditFinancing = function () {
        vm.isEditingFinancing = false;
    };

    // Function used to add additional behavior to Save button in Edit ACH Directive
    vm.saveFinancingUpdate = function () {
        vm.isEditingFinancing = false;
    };

    /* -----  End of Public Functions  ------*/

    /*= =======================================
     =            Private Functions            =
     ======================================== */
    function init() {
        vm.loading = true;
        getOfficeProfile().then(function () {
            vm.loading = false;
        });
    }

    function getOfficeProfile() {
        return $q(function (resolve, reject) {
            var data = {
                ContractorLocationId: Number($stateParams.accountId)
            };
            UserData.getUserData().then(function (response) {
                var currentRole = _lodash2.default.find(HPRoles, function (key, other) {
                    return other === response.Roles[0];
                });
                vm.isImpersonation = !!response.ImpersonatorName;

                data.IncludeACHInfo = currentRole.isAdmin;
                OfficesFactory.getOfficeProfile(data).then(function (response) {
                    vm.financeInfo = response.data.PaymentDetail;
                    getPaymentStatuses().then(function () {
                        resolve();
                    });
                });
            });
        });
    }

    function getPaymentStatuses() {
        return $q(function (resolve, reject) {
            OfficesFactory.getPaymentStatuses().then(function (response) {
                vm.paymentStatuses = response;
                _lodash2.default.each(vm.paymentStatuses, function (status) {
                    if (status.PaymentMethodStatusId === vm.financeInfo.PaymentMethodStatusId) {
                        vm.financeInfo.currentStatusMessage = status.Description;
                    }
                });
                resolve();
            });
        });
    }
}

/***/ }),
/* 441 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = achController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(443);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

achController.$inject = ['OfficesFactory', '$stateParams', 'UserData', 'HPRoles', '$rootScope']; // angular
// 	.module("HeroPRO")
// 	.controller("AchController", achController);

/* @ngInject */
function achController(OfficesFactory, $stateParams, UserData, HPRoles, $rootScope) {
    var vm = this;

    vm.bankName = '';
    vm.routingNumber = '';
    vm.accountNumber = '';
    vm.verifyAccountNumber = '';
    vm.mainLocationId = -1;

    vm.defaultAccountType = {
        key: '-- Select a Type --',
        BankAccountTypeId: -1
    };

    // Flags
    vm.isAcctNumberConfirmed = false;
    vm.isEditAccountNumber = false;
    vm.displayCheck = false;
    vm.saving = false;

    // Errors
    vm.uploadErrorMessage = '';

    // Check
    vm.checkFileName = '';
    vm.voidedCheckTempFileKey = '';

    // Account Types
    vm.selectedAccountType = {};
    vm.accountTypes = [];

    // Payment Status
    vm.paymentStatuses = [];
    vm.currentStatusMessage = '';

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    vm.onCancelClick = function () {
        resetUIState();
        vm.cancelClick();
    };

    vm.accountTypeClicked = function (type) {
        vm.selectedAccountType = type;
        console.log(type);
    };

    vm.uploadButtonClicked = function ($event) {
        $event.preventDefault();
    };

    vm.checkAccountNumber = function () {
        vm.isEditAccountNumber = true;
        vm.checkAccountNumberChange();
    };

    vm.checkAccountNumberChange = function () {
        if (vm.accountNumber === vm.achData.ACHAccountNumber && vm.editOfficeFinance.$valid) {
            vm.isAcctNumberConfirmed = false;
            vm.isEditAccountNumber = false;
        } else if (vm.accountNumber !== vm.verifyAccountNumber && vm.verifyAccountNumber !== '' && vm.verifyAccountNumber !== undefined) {
            vm.editOfficeFinance.txtAccountNumber.$setValidity('nomatch', false);
            if (vm.editOfficeFinance.txtVerifyAccountNumber !== undefined) {
                vm.editOfficeFinance.txtVerifyAccountNumber.$setValidity('nomatch', false);
            }
            vm.errorMessage = 'Account Numbers do not match';
            vm.isAcctNumberConfirmed = false;
        } else {
            vm.editOfficeFinance.txtAccountNumber.$setValidity('nomatch', true);
            if (vm.editOfficeFinance.txtVerifyAccountNumber !== undefined) {
                vm.editOfficeFinance.txtVerifyAccountNumber.$setValidity('nomatch', true);
            }
            vm.errorMessage = '';
            if (vm.accountNumber === vm.achData.ACHAccountNumber) {
                vm.isAcctNumberConfirmed = false;
                vm.isEditAccountNumber = false;
            } else if (vm.achData.ACHAccountNumber === vm.verifyAccountNumber && vm.editOfficeFinance.$valid) {
                vm.isAcctNumberConfirmed = true;
            }
        }

        if (vm.editOfficeFinance.$invalid) {
            vm.isAcctNumberConfirmed = false;
        }
    };

    vm.submitFinancing = function (isValid) {
        //		console.log(isValid);
        if (isValid) {
            vm.saving = true;
            var data = {
                ContractorLocationId: vm.notificationView === true ? vm.mainLocationId : $stateParams.accountId,
                LocationACH: {
                    ACHAccountNumber: vm.accountNumber,
                    ACHBank: vm.bankName,
                    ACHBankAccountTypeId: vm.selectedAccountType.BankAccountTypeId,
                    ACHRoutingNumber: vm.routingNumber,
                    VoidedCheckTempFileKey: vm.voidedCheckTempFileKey,
                    VoidedCheckFileName: vm.checkFileName
                }
            };
            savePaymentInfo(data);
        }
    };

    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */
    function init() {
        if (vm.achData !== undefined && vm.achData !== null) {
            rebindData();
        }
        if (vm.notificationView === null || vm.notificationView === undefined) {
            vm.notificationView = false;
        }
        if (vm.notificationView === true) {
            UserData.getMainLocation().then(function (response) {
                vm.mainLocationId = response[0].ContractorId;
            });
        }

        getPaymentStatuses();
    }

    function getPaymentStatuses() {
        OfficesFactory.getPaymentStatuses().then(function (response) {
            vm.paymentStatuses = response;
            _lodash2.default.each(vm.paymentStatuses, function (status) {
                if (status.PaymentMethodStatusId === vm.achData.PaymentMethodStatusId) {
                    vm.achData.currentStatusMessage = status.Description;
                }
            });
            getAccountTypes();
        });
    }

    function getAccountTypes() {
        OfficesFactory.getAccountTypes().then(function (response) {
            vm.accountTypes = response;
            if (vm.achData.ACHBankAccountTypeId !== undefined && vm.achData.ACHBankAccountTypeId !== null) {
                var currentAccountType = _lodash2.default.find(vm.accountTypes, function (type) {
                    return type.BankAccountTypeId === vm.achData.ACHBankAccountTypeId;
                });
                vm.selectedAccountType = currentAccountType;
            } else {
                vm.selectedAccountType = vm.accountTypes[0];
            }
        });
    }

    function rebindData() {
        vm.bankName = vm.achData.ACHBank;
        vm.routingNumber = vm.achData.ACHRoutingNumber;
        vm.accountNumber = vm.achData.ACHAccountNumber;
    }

    function resetUIState() {
        vm.verifyAccountNumber = '';
        vm.errorMessage = '';
        vm.isAcctNumberConfirmed = false;
        vm.isEditAccountNumber = false;
        vm.displayCheck = false;
        vm.checkFileName = '';
        vm.voidedCheckTempFileKey = '';
    }

    function savePaymentInfo(data) {
        OfficesFactory.saveFinanceInfo(data).then(function (response) {
            vm.achData.ACHBank = response.data.Data.LocationACH.ACHBank;
            vm.achData.ACHRoutingNumber = response.data.Data.LocationACH.ACHRoutingNumber;
            vm.achData.ACHAccountNumber = response.data.Data.LocationACH.ACHAccountNumber;
            vm.achData.PaymentMethodStatusId = response.data.Data.LocationACH.PaymentMethodStatusId;
            _lodash2.default.each(vm.paymentStatuses, function (status) {
                if (status.PaymentMethodStatusId === response.data.Data.LocationACH.PaymentMethodStatusId) {
                    vm.achData.currentStatusMessage = status.Description;
                }
            });
            vm.achData.ACHBankAccountTypeId = response.data.Data.LocationACH.ACHBankAccountTypeId;
            var currentAccountType = _lodash2.default.find(vm.accountTypes, function (type) {
                return type.BankAccountTypeId === response.data.Data.LocationACH.ACHBankAccountTypeId;
            });
            vm.selectedAccountType = currentAccountType;
            vm.saving = false;
            resetUIState();
            if (vm.saveClick !== undefined && vm.saveClick !== null) {
                vm.saveClick();
            }
        });
    }

    $rootScope.$on('HPFileUploaded', function (event, args, file) {
        vm.checkFileName = file.name;
        vm.voidedCheckTempFileKey = file.tempFileKey;
        $rootScope.$apply();
    });
}

/***/ }),
/* 443 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = achDirective;
// angular
// 	.module("HeroPRO")
// 	.directive('hpAch', achDirective);

function achDirective() {
    return {
        restrict: 'E',
        controller: 'AchController',
        controllerAs: 'ach',
        bindToController: true,
        scope: {
            cancelClick: '&',
            saveClick: '&?',
            achData: '=?',
            displayLogo: '=?',
            notificationView: '=?'

        },
        templateUrl: 'app/accounts/offices/financing/ach/ach.html',
        link: function link() {
            console.log('ach');
        }
    };
}

/***/ }),
/* 445 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = PlaidFactory;
PlaidFactory.$inject = ['HPConfig', '$http', '$q'];
/* @ngInject */
function PlaidFactory(HPConfig, $http, $q) {
    return {
        openPlaid: openPlaid,
        updateContractorLocationACH: updateContractorLocationACH,
        createLinkToken: createLinkToken,
        exchangeToken: exchangeToken
    };

    function openPlaid(linkToken) {
        return $q(function (resolve, reject) {
            var plaidHandler = Plaid.create({
                token: linkToken,
                onLoad: function onLoad() {},
                onSuccess: function onSuccess(public_token, metadata) {
                    //console.log("plaid onSuccess:");
                    //console.log("public_token: " + public_token);
                    //console.log("metadata" + JSON.stringify(metadata));

                    // Note: metadata already included public_token property
                    resolve(metadata);
                },
                onExit: function onExit(err, metadata) {
                    if (err != null) {
                        reject(err);
                    } else {
                        resolve(metadata);
                    }
                },
                onEvent: function onEvent(eventName, metadata) {
                    //console.log("EV");
                    //console.log(eventName);
                    //console.log(JSON.stringify(metadata));
                }
            });

            plaidHandler.open();
        });
    }

    function updateContractorLocationACH(contractorId, publicToken, selectedAccountId) {
        return $http({
            url: HPConfig.heroProApi + 'Contractor/PlaidACH',
            method: 'POST',
            data: {
                ContractorLocationId: contractorId,
                PublicToken: publicToken,
                SelectedAccountId: selectedAccountId
            }
        });
    }

    function createLinkToken(contractorId) {
        return $http({
            url: HPConfig.heroProApi + 'Contractor/Plaid/Link/Token/Create',
            method: 'POST',
            data: {
                clientName: 'Finance of America',
                user: {
                    clientUserId: contractorId
                },
                products: ['auth', 'transactions']
            }
        }).then(function (response) {
            return response.data;
        });
    }

    function exchangeToken(publicToken) {
        return $http({
            url: HPConfig.heroProApi + 'Contractor/Plaid/Item/Public_Token/Exchange',
            method: 'POST',
            data: {
                public_token: publicToken
            }
        }).then(function (response) {
            return response.data;
        });
    }
}

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports = "<div class=\"office-financing-container\" ng-controller=\"OfficeFinancingController as officeFinance\">\n    <div class=\"hp-loading-spinner\" ra-spinner show=\"officeFinance.loading\" hide-content-when-shown=\"true\">\n        <div class=\"row office-financing-header-container\">\n            <div class=\"col-md-6\">\n                <h2>Payment &amp; Financing</h2>\n            </div>\n            <div class=\"col-md-6 office-financing-header-button-container\">\n                <div class=\"office-financing-header-button-overlay\" tooltip-placement=\"bottom\"\n                    uib-tooltip=\"Disabled during impersonation\" tooltip-class=\"customClass\"\n                    tooltip-enable=\"officeFinance.isEditingFinancing === false && officeFinance.isImpersonation === true\"\n                    tooltip-animation=\"false\"\n                    ng-if=\"officeFinance.isEditingFinancing === false && officeFinance.isImpersonation === true\">\n                </div>\n                <button class=\"btn btn-default pull-right\" id=\"btn-office-financing-edit\"\n                    ng-if=\"officeFinance.isEditingFinancing === false\"\n                    ng-disabled=\"officeFinance.isEditingFinancing === false && officeFinance.isImpersonation === true\"\n                    ng-click=\"officeFinance.editFinancing()\">Edit\n                </button>\n            </div>\n        </div>\n        <div class=\"row message-container\">\n            <div class=\"col-md-12\">\n                <div class=\"alert alert-info text-center\" style=\"margin-bottom: 0\" role=\"alert\">Click edit above to use Plaid to log into your bank and select an account to use for payments from us.<br>You can also reach out to your account manager for assistance as needed.</div>\n            </div>\n        </div>\n        <div class=\"row message-container\"\n            ng-class=\"{ 'success': (officeFinance.isOfficeInfoError === false ), 'error': (officeFinance.isOfficeInfoError === true), 'edit-background' : (officeFinance.isEditingFinancing === true) }\"\n            ng-show=\"officeFinance.officeInfoStatusMessage !== ''\">\n            <div class=\"col-md-12\">\n                <p ng-bind=\"officeFinance.officeInfoStatusMessage\"></p>\n                <p class=\"alert alert-danger\" ng-if=\"!officeFinance.plaidValidation.AccountOwnerNamesMatched\">\n                    At least one person who is on your bank account must be set up as a location manager with us. Please add them as a location manager and then start this process again.\n                </p>\n                <p class=\"alert alert-danger\" ng-if=\"!officeFinance.plaidValidation.AccountAddressesMatched\">\n                    Click <a href=\"mailto:RACOReg@foahi.com\">here (RACOReg@foahi.com)</a> to email us an updated W9 with an address that matches the bank account(s) you’re trying to link We'll respond to your email within two business days, and then you'll be able to finish setting up your account.\n                </p>\n            </div>\n        </div>\n        <ng-include src=\"'app/accounts/offices/financing/viewFinancing.html'\" ng-if=\"!officeFinance.isEditingFinancing\">\n        </ng-include>\n        <!--\n    <div class=\"office-finance-edit-container\" ng-class=\"{ 'edit-background' : officeFinance.isEditingFinancing }\" ng-if=\"officeFinance.isEditingFinancing\">\n        <hp-ach cancel-click=\"officeFinance.cancelEditFinancing()\" ach-data=\"officeFinance.financeInfo\" save-click=\"officeFinance.saveFinancingUpdate()\" display-logo=\"true\" notification-view=\"false\"></hp-ach>\n    </div>\n    -->\n    </div>\n</div>\n";

/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports = "<div class=\"view-financing-container\">\n    <div class=\"row\">\n        <div class=\"col-md-7 payment-description\">\n            <p ng-bind=\"officeFinance.heroDescription\"></p>\n        </div>\n        <div class=\"col-md-5\">\n            <div class=\"row financing-summary\">\n                <div class=\"col-md-12\">\n                    <h3 ng-bind=\"officeFinance.financeInfo.ACHBank\"></h3>\n                </div>\n            </div>\n            <div class=\"row financing-summary\">\n                <div class=\"col-md-5\">\n                    <span class=\"label\">Routing Number</span>\n                </div>\n                <div class=\"col-md-7\">\n                    <span ng-bind=\"officeFinance.financeInfo.ACHRoutingNumber\"></span>\n                </div>\n            </div>\n            <div class=\"row financing-summary\">\n                <div class=\"col-md-5\">\n                    <span class=\"label\">Account Number</span>\n                </div>\n                <div class=\"col-md-7\">\n                    <span ng-bind=\"officeFinance.financeInfo.ACHAccountNumber | numMask : 3\"></span>\n                </div>\n            </div>\n            <div class=\"row financing-summary\">\n                <div class=\"col-md-5\">\n                    <span class=\"label\">Status</span>\n                </div>\n                <div class=\"col-md-4\">\n                    <span ng-bind=\"officeFinance.financeInfo.currentStatusMessage\"></span>\n                </div>\n                <div class=\"col-md-3 approval-container\">\n                    <span class=\"hp-badge approval-needed\" ng-if=\"officeFinance.financeInfo.PaymentMethodStatusId === 1\">!</span>\n                    <span class=\"hp-badge approved\" ng-if=\"officeFinance.financeInfo.PaymentMethodStatusId === 2\"><span class=\"icon icon-complete\"></span></span>\n                    <span class=\"hp-badge denied\" ng-if=\"officeFinance.financeInfo.PaymentMethodStatusId === 3\"><span class=\"icon icon-delete\"></span></span>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports = "\n    <form name=\"ach.editOfficeFinance\"\n          ng-submit=\"ach.submitFinancing(ach.editOfficeFinance.$valid)\"\n          novalidate>\n        <div class=\"row logo-row\" ng-if=\"ach.displayLogo\">\n            <img class=\"product-payment-logo\" src=\"src/assets/images/HEROPgm-Logo.png\" alt=\"HEROPro\"/>\n        </div>\n        <div class=\"row\">\n            <div class=\"office-finance-edit-left-column\" ng-class=\"{'col-md-7' : ach.notificationView === false, 'col-md-12': ach.notificationView === true}\">\n                <div class=\"row office-finance-label-container\">\n                    <div class=\"col-md-12\">\n                        <span>Account Name</span>\n                    </div>\n                </div>\n                <div class=\"row office-finance-field-container\">\n                    <div class=\"col-md-12\">\n                        <input id=\"txt-account-name\" name=\"txtAccountName\" type=\"text\" ng-required=\"ach.editOfficeFinance.$submitted\"\n                               ng-model=\"ach.bankName\" maxlength=\"100\" \\>\n\n                        <div class=\"error-message-container\">\n                            <p class=\"error-message\"\n                               ng-if=\"ach.editOfficeFinance.txtAccountName.$error.required && ach.editOfficeFinance.$submitted\">Required</p>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row office-finance-label-container\">\n                    <div class=\"col-md-12\">\n                        <span>Account Type</span>\n                    </div>\n                </div>\n                <div class=\"row office-finance-dropdown-container\">\n                    <div class=\"col-md-12\">\n                        <div class=\"dropdown\" uib-dropdown dropdown-small-popup dropdown-title=\"AccountType\">\n                            <a id=\"ddl-account-type\" blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle\n                               data-toggle=\"dropdown\">\n                                <span class=\"dropdown-text\"\n                                      ng-bind=\"ach.selectedAccountType.Description\"></span>\n                                <span class=\"icon\"></span>\n                            </a>\n                            <ul class=\"dropdown-menu address-breakdown-small\" uib-dropdown-menu>\n                                <li ng-repeat=\"type in ach.accountTypes\"\n                                    ng-class=\"{'active': ach.selectedAccountType.BankAccountTypeId === type.BankAccountTypeId }\"\n                                    ng-click=\"ach.accountTypeClicked(type)\">\n                                    <span>{{type.Description}}</span>\n                                </li>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row office-finance-label-container\">\n                    <div class=\"col-md-12\">\n                        <span>Routing Number</span>\n                    </div>\n                </div>\n                <div class=\"row office-finance-field-container\">\n                    <div class=\"col-md-12\">\n                        <input id=\"txt-account-routing-number\" name=\"txtAccountRoutingNumber\" type=\"text\" ng-required=\"ach.editOfficeFinance.$submitted\"\n                               ng-model=\"ach.routingNumber\" hp-numeric-only maxlength=\"50\">\n\n                        <div class=\"error-message-container\">\n                            <p class=\"error-message\"\n                               ng-if=\"ach.editOfficeFinance.txtAccountRoutingNumber.$error.required && ach.editOfficeFinance.$submitted\">Required</p>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row office-finance-label-container\">\n                    <div class=\"col-md-12\">\n                        <span>Account Number</span>\n                    </div>\n                </div>\n                <div class=\"row office-finance-field-container\">\n                    <div class=\"col-md-12\">\n                        <span class=\"icon icon-todo\" ng-if=\"ach.isAcctNumberConfirmed\"></span>\n                        <input id=\"txt-account-number\" name=\"txtAccountNumber\" type=\"text\" ng-required=\"ach.editOfficeFinance.$submitted\"\n                               ng-model=\"ach.accountNumber\" hp-numeric-only ng-change=\"ach.checkAccountNumber()\" maxlength=\"50\" >\n\n                        <div class=\"error-message-container\">\n                            <p class=\"error-message\"\n                               ng-if=\"ach.editOfficeFinance.txtAccountNumber.$error.required && ach.editOfficeFinance.$submitted\">Required</p>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row office-finance-label-container\" ng-if=\"ach.isEditAccountNumber\">\n                    <div class=\"col-md-12\">\n                        <span>Verify Account Number</span>\n                    </div>\n                </div>\n                <div class=\"row office-finance-field-container\" ng-if=\"ach.isEditAccountNumber\">\n                    <div class=\"col-md-12\">\n                        <span class=\"icon icon-todo\" ng-if=\"ach.isAcctNumberConfirmed\"></span>\n                        <input id=\"txt-verify-account-number\" name=\"txtVerifyAccountNumber\" type=\"text\" ng-required=\"ach.isEditAccountNumber && ach.editOfficeFinance.$submitted\"\n                               ng-model=\"ach.verifyAccountNumber\" hp-numeric-only ng-change=\"ach.checkAccountNumberChange()\" maxlength=\"50\" >\n\n                        <div class=\"error-message-container\">\n                            <p class=\"error-message\"\n                               ng-if=\"ach.editOfficeFinance.txtVerifyAccountNumber.$error.required && ach.editOfficeFinance.$submitted\">Required</p>\n                            <p class=\"error-message \" ng-show=\"ach.errorMessage !== ''\" ng-bind=\"ach.errorMessage\"></p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"office-finance-edit-right-column\" ng-class=\"{'col-md-5' : ach.notificationView === false, 'col-md-12': ach.notificationView === true}\">\n                <div class=\"row\">\n                    <div class=\"col-md-12\">\n                        <ng-include src=\"'app/accounts/offices/financing/checkUpload/checkUpload.html'\"></ng-include>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12 edit-button-container\" ng-class=\"{'text-center': ach.notificationView === true}\">\n                <div ng-class=\"{'pull-left' : ach.notificationView === false, 'inline': ach.notificationView === true}\">\n                    <hp-spinner-button button-text=\"Save\" button-name=\"btn-office-info-save\" is-primary-btn=\"true\"\n                                       is-submit-button=\"true\" display-spinner=\"ach.saving\"></hp-spinner-button>\n                </div>\n                <div ng-class=\"{'pull-left' : ach.notificationView === false, 'inline': ach.notificationView === true}\">\n                    <button type=\"button\" class=\"btn btn-default\" id=\"btn-office-info-cancel\"\n                            ng-click=\"ach.onCancelClick()\">Cancel\n                    </button>\n                </div>\n            </div>\n        </div>\n    </form>\n";

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports = "<div class=\"check-upload-container\">\n    <ng-form name=\"ach.imageUpload\">\n        <div class=\"row\">\n            <div class=\"col-md-12 upload-header\">\n                <div class=\"upload-label pull-left\">Voided Check</div>\n                <div class=\"approval-container pull-right\">\n                    <span class=\"approval-status\" ng-bind=\"ach.achData.currentStatusMessage\"\n                          ng-class=\"{ 'approval-needed' : ach.achData.PaymentMethodStatusId === 1,\n                      'approved': ach.achData.PaymentMethodStatusId === 2,\n                      'denied': ach.achData.PaymentMethodStatusId === 3}\" ></span>\n                    <span class=\"hp-badge approval-needed\"\n                          ng-if=\"ach.achData.PaymentMethodStatusId === 1\">!</span>\n                    <span class=\"hp-badge approved\" ng-if=\"ach.achData.PaymentMethodStatusId === 2\"><span\n                        class=\"icon icon-complete\"></span></span>\n                    <span class=\"hp-badge denied\" ng-if=\"ach.achData.PaymentMethodStatusId === 3\"><span\n                        class=\"icon icon-delete\"></span></span>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"dropzone hp-dropzone\" dropzone=\"\" id=\"dropzone\"\n                        ng-class=\"{'no-check': ach.displayApprovalBadge === false && ach.submitted === 'true'}\"\n                        dropzone-accepted-files=\".jpg,.jpeg,.png,.gif,.tif,.bmp,.pdf\"\n                        drop-zone-max-file-size=\"10\">\n                    <div class=\"dz-default dz-message\">\n                        <p class=\"icon icon-checkbook\"></p>\n                        <p class=\"draganddrop-message\">Drag and drop a file here</p>\n                        <p class=\"draganddrop-message\">or <span class=\"link\" >Choose file</span>\n                        </p>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12 upload-instructions-container\">\n                <p>Max accepted file size is 10 MB.</p>\n\n                <p>Supported file types: jpeg, jpg, tiff, gif, bmp, png, pdf</p>\n            </div>\n        </div>\n    </ng-form>\n</div>\n";

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _officeProfileController = __webpack_require__(452);

var _officeProfileController2 = _interopRequireDefault(_officeProfileController);

__webpack_require__(454);

__webpack_require__(455);

__webpack_require__(456);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.accounts.offices.profile', []).controller('OfficeProfileController', _officeProfileController2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/accounts/offices/profile/additionalServices/additionalServices.html', __webpack_require__(457)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/offices/profile/editProfile.html', __webpack_require__(458)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/offices/profile/officeProfile.html', __webpack_require__(459)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/offices/profile/viewProfile.html', __webpack_require__(80)); // eslint-disable-line global-require


    $templateCache.put('app/accounts/offices/profile/additionalServices/viewProfile.html', __webpack_require__(80)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/offices/profile/counties/counties.html', __webpack_require__(460)); // eslint-disable-line global-require
    $templateCache.put('app/accounts/offices/profile/logoUpload/logoUpload.html', __webpack_require__(461)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = officeProfileController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(453);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

officeProfileController.$inject = ['OfficesFactory', '$stateParams', '$window', '$rootScope', '$analytics', 'UserData', 'HPRoles', 'HPConfig', 'CommonDataFactory']; // angular
// 	.module("HeroPRO")
// 	.controller("OfficeProfileController", officeProfileController);

/* @ngInject */
function officeProfileController(OfficesFactory, $stateParams, $window, $rootScope, $analytics, UserData, HPRoles, HPConfig, CommonDataFactory) {
    var vm = this;

    vm.profileDetail = {};
    vm.locationDetail = {};
    vm.officeDescription = '';
    vm.officeWebsite = '';
    vm.maxDescriptionLength = 8000;

    // Flags
    vm.canViewACH = false;
    vm.isEditingProfile = false;
    vm.submitted = false;
    vm.canEditDescription = true;

    // Logo
    vm.logoImage = null;
    vm.logoFileName = '';
    vm.displayLogo = false;

    // Errors
    vm.description = '';
    vm.uploadErrorMessage = '';
    vm.countiesErrorMessage = '';

    // state
    vm.selectedState = {
        IsActive: true,
        Name: '',
        StateAbbreviation: '',
        StateFIPSPrefix: '',
        StateGeoId: -1
    };
    vm.activeStates = [];
    var allStates = [];

    // Counties/Municipalities
    vm.counties = [];
    vm.currentCounties = [];
    var fullCountyList = [];

    // Primary Service
    vm.selectedPrimaryService = null;
    vm.defaultServiceType = {
        Description: 'Choose one',
        Name: 'null',
        ContractorTypeId: -1
    };

    // Additional Services
    vm.primaryService = {};
    vm.secondaryServices = [];
    vm.availableServices = [];
    vm.contractorServiceTypes = [];

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    vm.editProfile = function () {
        vm.isEditingProfile = true;

        // If a Primary Service does not exist, set the select Primary Service to the default value
        if (!hasPrimaryService()) {
            vm.selectedPrimaryService = vm.defaultServiceType;
        }
    };

    vm.cancelEditProfile = function () {
        // Reordered function calls to clear state and then restore last loaded values on cancel.
        clearUIState();
        setDatabindings();
        getContractorServices();
        // Added function call to reload counties
        getCounties(vm.selectedState);
        // Null out Selected Primary Service if the default is currently "selected"
        if (!hasPrimaryService()) {
            vm.selectedPrimaryService = null;
        }
        vm.isEditingProfile = false;
        vm.submitted = false;
    };

    vm.submitOfficeProfile = function () {
        // Refactored to set submitted flag and corrected validation.
        vm.submitted = true;
        if (vm.editOfficeProfile.$valid && hasPrimaryService()) {
            var data = {
                ContractorLocationId: $stateParams.accountId,
                ProfileDetail: {
                    CompanyOverview: vm.officeDescription,
                    CompanyURL: vm.officeWebsite,
                    LogoFilename: vm.logoFileName,
                    ContractorTypes: prepServicesForSave(),
                    Munis: prepMunisForSave()
                }
            };
            saveProfile(data);
        }
    };

    vm.selectCounty = function (selectedCounty) {
        var county = _lodash2.default.find(vm.counties[0], function (item) {
            return item.MuniId === selectedCounty.MuniId;
        });
        if (county !== null && county !== undefined) {
            county.isSelected = !county.isSelected;
        } else {
            county = _lodash2.default.find(vm.counties[1], function (item) {
                return item.MuniId === selectedCounty.MuniId;
            });
            if (county !== null && county !== undefined) {
                county.isSelected = !county.isSelected;
            }
        }
    };

    vm.primaryServiceClicked = function (service) {
        service.isSelected = true;
        vm.selectedPrimaryService = service;
        vm.contractorServiceTypes = _lodash2.default.without(vm.contractorServiceTypes, vm.defaultServiceType);
        vm.availableServices = _lodash2.default.without(vm.contractorServiceTypes, _lodash2.default.findWhere(vm.contractorServiceTypes, vm.selectedPrimaryService));

        // Check if selected primary is a secondary
        var secService = _lodash2.default.find(vm.secondaryServices, function (secSvc) {
            return secSvc.ContractorTypeId === service.ContractorTypeId;
        });

        if (secService !== undefined && secService !== null) {
            vm.secondaryServices = _lodash2.default.without(vm.secondaryServices, secService);
        }

        _lodash2.default.each(vm.secondaryServices, function (secSvc) {
            vm.availableServices = _lodash2.default.without(vm.availableServices, _lodash2.default.find(vm.availableServices, function (service) {
                return service.ContractorTypeId === secSvc.ContractorTypeId;
            }));
        });

        validatePrimaryService();
    };

    vm.addService = function () {
        vm.secondaryServices.push({});
    };

    vm.secondaryServiceClicked = function (type, index) {
        vm.secondaryServices[index] = type;
        vm.availableServices = _lodash2.default.map(vm.contractorServiceTypes, _lodash2.default.clone);
        vm.availableServices = _lodash2.default.without(vm.availableServices, _lodash2.default.find(vm.availableServices, function (svc) {
            return svc.ContractorTypeId === vm.selectedPrimaryService.ContractorTypeId;
        }));
        // Rebuild available list
        _lodash2.default.each(vm.secondaryServices, function (selSvc) {
            vm.availableServices = _lodash2.default.without(vm.availableServices, _lodash2.default.find(vm.availableServices, function (availSvc) {
                return availSvc.ContractorTypeId === selSvc.ContractorTypeId;
            }));
        });
    };

    vm.removeService = function (type) {
        vm.secondaryServices = _lodash2.default.without(vm.secondaryServices, _lodash2.default.find(vm.secondaryServices, function (svc) {
            return svc.ContractorTypeId === type.ContractorTypeId;
        }));
        vm.availableServices = _lodash2.default.map(vm.contractorServiceTypes, _lodash2.default.clone);
        vm.availableServices = _lodash2.default.without(vm.availableServices, _lodash2.default.find(vm.availableServices, function (svc) {
            return svc.ContractorTypeId === vm.selectedPrimaryService.ContractorTypeId;
        }));
        // Rebuild available list
        _lodash2.default.each(vm.secondaryServices, function (selSvc) {
            vm.availableServices = _lodash2.default.without(vm.availableServices, _lodash2.default.find(vm.availableServices, function (availSvc) {
                return availSvc.ContractorTypeId === selSvc.ContractorTypeId;
            }));
        });
        vm.availableServices = _lodash2.default.sortBy(vm.availableServices, 'ContractorTypeId');
    };

    vm.calcCharactersRemaining = function () {
        if (vm.officeDescription !== undefined && vm.officeDescription !== null && vm.officeDescription !== '') {
            return vm.maxDescriptionLength - vm.officeDescription.replace(/\n/g, '\r\n').length;
        }
        return vm.maxDescriptionLength;
    };

    vm.navigateToWebsite = function () {
        var url = vm.profileDetail.CompanyURL.toLowerCase().indexOf('http://') >= 0 ? vm.profileDetail.CompanyURL : 'http://' + vm.profileDetail.CompanyURL;
        $window.open(url, '_blank');
    };

    vm.uploadButtonClicked = function ($event) {
        $event.preventDefault();
    };

    vm.checkState = function () {
        // Removed indexOf condition and replaced with _.filter() to find activeState object in activeStates collection.
        var activeState = _lodash2.default.filter(vm.activeStates, function (state) {
            return state.StateGeoId === vm.selectedState.StateGeoId;
        });

        // Added condition to check activeState length. Filter returns an empty array if no records match condition.
        // Refactored condition to return condition rather than explicit true/false
        return vm.selectedState !== null && activeState !== undefined && activeState.length > 0;
    };

    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */
    function init() {
        getOfficeProfile();

        //		$scope.$on("HPFileUploaded", function (event, args) {
        //			var fileName = args.Data.FileName;
        //			alert("Finish upload: " + fileName);
        //		});
    }

    function getOfficeProfile() {
        var data = {
            ContractorLocationId: Number($stateParams.accountId)
        };
        UserData.getUserData().then(function (response) {
            var currentRole = _lodash2.default.find(HPRoles, function (key, other) {
                return other === response.Roles[0];
            });

            data.IncludeACHInfo = currentRole.isAdmin;
            OfficesFactory.getOfficeProfile(data).then(function (response) {
                vm.profileDetail = response.data.ProfileDetail;
                vm.locationDetail = response.data.LocationDetail;
                vm.selectedState.StateAbbreviation = response.data.LocationDetail.State;
                getActiveStates(vm.selectedState);
                setDatabindings();
                getContractorServices();
            });
        });
    }

    function setDatabindings() {
        if (!!vm.profileDetail.CompanyOverview && vm.profileDetail.CompanyOverview.length > vm.maxDescriptionLength) {
            vm.officeDescription = vm.profileDetail.CompanyOverview.substring(0, vm.maxDescriptionLength).replace(/\n/g, '');
        } else if (vm.profileDetail.CompanyOverview) {
            vm.officeDescription = vm.profileDetail.CompanyOverview.replace(/\n/g, '');
        }

        if (!!vm.profileDetail.IsCompliancePageEnabled && vm.profileDetail.IsCompliancePageEnabled === true) {
            vm.canEditDescription = false;
        }

        vm.officeWebsite = vm.profileDetail.CompanyURL;

        if (!!vm.profileDetail.LogoFilename && vm.profileDetail.LogoFilename !== '') {
            var logoUrl = HPConfig.rackspaceCdn + vm.profileDetail.LogoFilename;
            displayValidImage(logoUrl);
        }
    }

    function getContractorServices() {
        OfficesFactory.getServices().then(function (response) {
            vm.contractorServiceTypes = _lodash2.default.sortBy(response.data.Data, 'ContractorTypeId');
            vm.availableServices = vm.contractorServiceTypes;
            getCurrentContractorServices();
        });
    }

    function getCurrentContractorServices() {
        var primary = _lodash2.default.filter(vm.profileDetail.ContractorTypes, function (serviceType) {
            return serviceType.IsPrimaryType === true;
        });
        if (primary[0] !== undefined) {
            vm.selectedPrimaryService = primary[0];
            _lodash2.default.each(vm.contractorServiceTypes, function (svcType) {
                if (svcType.ContractorTypeId === vm.selectedPrimaryService.ContractorTypeId) {
                    vm.selectedPrimaryService.Description = svcType.Description;
                }
            });
            vm.availableServices = _lodash2.default.without(vm.availableServices, _lodash2.default.find(vm.availableServices, function (service) {
                return service.ContractorTypeId === vm.selectedPrimaryService.ContractorTypeId;
            }));
        } else {
            // Added missing else when no Primary Service Type exists.
            if (_lodash2.default.findWhere(vm.contractorServiceTypes, { ContractorTypeId: -1 }) === undefined) {
                vm.contractorServiceTypes.unshift(vm.defaultServiceType);
            }
        }

        vm.secondaryServices = _lodash2.default.filter(vm.profileDetail.ContractorTypes, function (serviceType) {
            return serviceType.IsPrimaryType === false;
        });

        _lodash2.default.each(vm.contractorServiceTypes, function (svcType) {
            _lodash2.default.each(vm.secondaryServices, function (secSvc) {
                if (svcType.ContractorTypeId === secSvc.ContractorTypeId) {
                    secSvc.Description = svcType.Description;
                }
            });
        });

        _lodash2.default.each(vm.secondaryServices, function (secSvc) {
            vm.availableServices = _lodash2.default.without(vm.availableServices, _lodash2.default.find(vm.availableServices, function (service) {
                return service.ContractorTypeId === secSvc.ContractorTypeId;
            }));
        });
    }

    /* modified need to return getStates to true and not use var allStates */
    function getActiveStates(currentState) {
        if (vm.activeStates.length > 0) {
            setActiveState(vm.activeStates, currentState);
            getCounties(vm.selectedState);
        } else {
            CommonDataFactory.getStates(true).then(function (response) {
                allStates = response.data.Data;
                setSelectedState(allStates, vm.selectedState.StateAbbreviation);
                vm.activeStates = response.data.Data;
                setActiveState(allStates, currentState);
                if (vm.isEditingProfile === true) {
                    getCounties(vm.selectedState);
                } else {
                    loadCountiesByProfile();
                }
            });
        }
    }

    /* temp function to set state based on saved info */
    function setSelectedState(states, currentStateAbbr) {
        var matchedState = _lodash2.default.find(states, function (s) {
            return s.StateAbbreviation === currentStateAbbr;
        });

        if (matchedState) {
            angular.copy(matchedState, vm.selectedState);
        }
    }

    function setActiveState(activeStates, currentState) {
        _lodash2.default.each(activeStates, function (s) {
            if (s === currentState) {
                vm.selectedState = currentState;
            }
        });

        if (!vm.selectedState) {
            vm.selectedState = activeStates[0];
        }
    }

    function getCounties(state) {
        console.log(state);
        vm.counties = [];
        if (fullCountyList.length === 0) {
            OfficesFactory.getCounties().then(function (response) {
                fullCountyList = _lodash2.default.each(_lodash2.default.sortBy(response.data.Data.Munis, 'Name'), function (item) {
                    var matchingItem = _lodash2.default.find(vm.profileDetail.Munis, function (county) {
                        return county.MuniId === item.MuniId;
                    });
                    if (matchingItem !== null && matchingItem !== undefined) {
                        return _lodash2.default.extend(item, {
                            isSelected: true
                        });
                    }

                    return _lodash2.default.extend(item, {
                        isSelected: false
                    });
                });

                if (!state) {
                    return;
                }

                createFilteredCountyListByState(state);
            });
        } else {
            createFilteredCountyListByState(state);
        }
    }

    // (jb 9/6/2016) added this to show all selected counties regardless of states on profile view
    function loadCountiesByProfile() {
        if (fullCountyList.length === 0) {
            OfficesFactory.getCounties().then(function (response) {
                fullCountyList = _lodash2.default.each(_lodash2.default.sortBy(response.data.Data.Munis, 'Name'), function (item) {
                    var matchingItem = _lodash2.default.find(vm.profileDetail.Munis, function (county) {
                        return county.MuniId === item.MuniId;
                    });
                    if (matchingItem !== null && matchingItem !== undefined) {
                        return _lodash2.default.extend(item, {
                            isSelected: true
                        });
                    }

                    return _lodash2.default.extend(item, {
                        isSelected: false
                    });
                });
                formatCounties(filterCountiesByState(vm.selectedState));
                getCurrentCounties(fullCountyList);
            });
        } else {
            formatCounties(filterCountiesByState(vm.selectedState));
            getCurrentCounties(fullCountyList);
        }
    }

    function createFilteredCountyListByState(state) {
        formatCounties(filterCountiesByState(state));
        getCurrentCounties(filterCountiesByState(state));
    }

    function filterCountiesByState(state) {
        if (!state) {
            return fullCountyList;
        }

        return _lodash2.default.filter(fullCountyList, function (f) {
            return f.StateGeoId === state.StateGeoId;
        } // angular.equals(f.FIPSCode.substring(0, 2), state.StateFIPSPrefix);
        );
    }

    function formatCounties(counties) {
        vm.counties = [];
        var firstHalfCounties = [],
            secondHalfCounties = [];

        if (counties.length > 1) {
            firstHalfCounties = counties.slice(0, counties.length / 2);
            vm.counties.push(firstHalfCounties);

            secondHalfCounties = counties.slice(counties.length / 2);
            vm.counties.push(secondHalfCounties);
        } else {
            vm.counties.push(counties);
        }
    }

    function getCurrentCounties(fullCountyList) {
        vm.currentCounties = [];
        var currentCounties = _lodash2.default.filter(fullCountyList, function (county) {
            return county.isSelected === true;
        });

        var position = currentCounties.length % 2 === 0 ? currentCounties.length / 2 : currentCounties.length / 2 + 1;

        var firstHalfCurrentCounties = currentCounties.slice(0, position);
        var secondHalfCurrentCounties = currentCounties.slice(position);
        vm.currentCounties.push(firstHalfCurrentCounties);
        vm.currentCounties.push(secondHalfCurrentCounties);
    }

    function prepServicesForSave() {
        var currentSelectedServices = [];
        _lodash2.default.each(vm.secondaryServices, function (service) {
            if (service.ContractorTypeId !== undefined && service.ContractorTypeId !== null) {
                currentSelectedServices.push({
                    ContractorTypeId: service.ContractorTypeId,
                    IsPrimaryType: false
                });
            }
        });
        currentSelectedServices.push({
            ContractorTypeId: vm.selectedPrimaryService.ContractorTypeId,
            IsPrimaryType: true
        });
        return currentSelectedServices;
    }

    function prepMunisForSave() {
        // var munis = vm.counties[0].slice();
        // munis.push.apply(munis, vm.counties[1]);
        /* temporary fix for production MO offices */
        var filteredMunis = _lodash2.default.filter(fullCountyList, function (muni) {
            return muni.isSelected === true;
        });
        var currentMunis = [];
        _lodash2.default.each(filteredMunis, function (muni) {
            currentMunis.push({
                MuniId: muni.MuniId
            });
        });
        return currentMunis;
    }

    // Boolean function to test if a ContractorType is selected
    function hasPrimaryService() {
        if (!vm.selectedPrimaryService || vm.selectedPrimaryService.ContractorTypeId === -1) {
            return false;
        }

        return true;
    }

    // Function to set form validity based on if ContractorType is set.
    function validatePrimaryService() {
        if (hasPrimaryService()) {
            vm.editOfficeProfile.$setValidity('noservicetype', true);
        } else {
            vm.editOfficeProfile.$setValidity('noservicetype', false);
        }
    }

    // j.b. can no longer save munis by single state
    function saveProfile(data) {
        OfficesFactory.saveProfile(data).then(function (response) {
            vm.isEditingProfile = false;
            vm.profileDetail = response.data.Data.ProfileDetail;
            setDatabindings();
            getContractorServices();
            // getCounties(vm.selectedState);
            loadCountiesByProfile();
        });
    }

    function clearUIState() {
        // Added additional values to clear.
        fullCountyList = [];
        vm.officeDescription = '';
        vm.officeWebsite = '';
        vm.selectedPrimaryService = null;
        vm.logoImage = null;
        vm.uploadErrorMessage = '';
        vm.countiesErrorMessage = '';
    }

    function displayValidImage(url) {
        OfficesFactory.validateImage(url).then(function (response) {
            vm.displayLogo = response;
            if (vm.displayLogo) {
                vm.logoFileName = vm.profileDetail.LogoFilename;
                vm.logoImage = HPConfig.rackspaceCdn + vm.profileDetail.LogoFilename;
            }
        });
    }

    $rootScope.$watch(function () {
        return vm.logoImage;
    }, function (val) {
        if (val !== undefined && val !== null) {
            vm.uploadErrorMessage = '';
            vm.displayLogo = true;
        }
    });

    $rootScope.$watch(function () {
        return vm.selectedState;
    }, function (val, oldval) {
        if (!angular.equals(val, oldval)) {
            if (!val) {
                return;
            }
            getCounties(vm.selectedState);
        }
    });

    $rootScope.$on('editLogoInvalidUploadType', function (event, payload) {
        vm.uploadErrorMessage = 'That file is not a jpeg, jpg, tiff, gif, bmp, or png.';
        $analytics.eventTrack('Invalid Logo Upload', { category: 'Edit Office', label: 'File Extension: ' + payload.fileType });
    });

    $rootScope.$on('editLogoInvalidUploadSize', function () {
        vm.uploadErrorMessage = 'That file is larger than 10 MB.';
    });

    $rootScope.$on('editLogoStartUpload', function (event, payload) {
        OfficesFactory.saveLogo(payload).then(function (response) {
            vm.logoImage = HPConfig.rackspaceCdn + response.data.Data.FileName;
            vm.logoFileName = response.data.Data.FileName;
            vm.uploadErrorMessage = '';
        });
    });
}

/***/ }),
/* 453 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 454 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 456 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports = "<div class=\"additional-services-container\">\n    <div class=\"row\">\n        <div class=\"col-md-12 additional-services-dropdown-container\">\n            <div ng-repeat=\"service in officeProfile.secondaryServices\">\n                <div class=\"dropdown-container\">\n                    <div class=\"dropdown\" uib-dropdown dropdown-small-popup>\n                        <a blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle data-toggle=\"dropdown\">\n                            <span class=\"dropdown-text\" ng-bind=\"officeProfile.secondaryServices[$index].Description\"></span>\n                            <span class=\"icon\"></span>\n                        </a>\n                        <ul class=\"dropdown-menu address-breakdown-small\" uib-dropdown-menu>\n                            <li ng-repeat=\"type in officeProfile.availableServices\"\n                                ng-class=\"{'active': service.ContractorTypeId === type.ContractorTypeId }\"\n                                ng-click=\"officeProfile.secondaryServiceClicked(type,$parent.$index)\">\n                                <span>{{type.Description}}</span>\n                            </li>\n                        </ul>\n                    </div>\n                    <span class=\"icon icon-zoom-out remove-service-icon\" ng-click=\"officeProfile.removeService(service)\"></span>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n           <div class=\"add-service-container\" ng-click=\"officeProfile.addService()\" ng-if=\"officeProfile.availableServices.length > 0\"\n                ng-class=\"{'disabled': (officeProfile.selectedPrimaryService === null || officeProfile.selectedPrimaryService === undefined) }\" >\n               <div class=\"icon icon-zoom-in add-service-icon\"></div><div class=\"add-service-label\"> Add Service</div>\n           </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row office-profile-edit-container\" ng-class=\"{ 'edit-background' : officeProfile.isEditingProfile }\">\n    <form name=\"officeProfile.editOfficeProfile\" ng-submit=\"officeProfile.submitOfficeProfile()\" novalidate>\n        <div class=\"row\">\n            <div class=\"col-md-12 office-profile-edit-right-column\">\n                <div class=\"row office-profile-label-container\">\n                    <div class=\"col-md-12\">\n                        <span>Office Logo</span>\n                    </div>\n                </div>\n                <div class=\"row office-profile-logo-upload-container\">\n                    <div class=\"col-md-12\">\n                        <ng-include src=\"'app/accounts/offices/profile/logoUpload/logoUpload.html'\"></ng-include>\n                    </div>\n                </div>\n                <div class=\"row office-profile-label-container\">\n                    <div class=\"col-md-12\">\n                        <span>Office Website</span>\n                    </div>\n                </div>\n                <div class=\"row office-profile-field-container\">\n                    <div class=\"col-md-12\">\n                        <input id=\"txt-company-url\" ng-class=\"{'required': officeProfile.editOfficeProfile.txtCompanyUrl.$error.required && officeProfile.submitted}\"\n                               name=\"txtCompanyUrl\" type=\"text\" ng-required=\"true\" ng-model=\"officeProfile.officeWebsite\" \\>\n                        <div class=\"error-message-container\">\n                            <p class=\"error-message\" ng-if=\"officeProfile.editOfficeProfile.txtCompanyUrl.$error.required && officeProfile.submitted\">Required</p>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row office-profile-label-container service-label-spacer\">\n                    <div class=\"col-md-12\">\n                        <span>Most of Your Jobs are:</span>\n                    </div>\n                </div>\n                <div class=\"row office-profile-dropdown-container\">\n                    <div class=\"col-md-12\">\n                        <div class=\"dropdown\" uib-dropdown dropdown-small-popup dropdown-title=\"PrimaryJob\"\n                             ng-class=\"{ 'invalid-type': officeProfile.selectedPrimaryService.ContractorTypeId === -1 && officeProfile.submitted}\">\n                            <a id=\"ddl-primary-job\" blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle data-toggle=\"dropdown\">\n                                <span class=\"dropdown-text\" ng-bind=\"officeProfile.selectedPrimaryService.Description\"></span>\n                                <span class=\"icon\"></span>\n                            </a>\n                            <ul class=\"dropdown-menu address-breakdown-small\" uib-dropdown-menu>\n                                <li ng-repeat=\"type in officeProfile.contractorServiceTypes\" ng-class=\"{'active': officeProfile.selectedPrimaryService.ContractorTypeId === type.ContractorTypeId }\"\n                                    ng-click=\"officeProfile.primaryServiceClicked(type)\">\n                                    <span>{{type.Description}}</span>\n                                </li>\n                            </ul>\n                        </div>\n                        <div class=\"error-message-container\">\n                            <p class=\"error-message\" ng-if=\"officeProfile.selectedPrimaryService.ContractorTypeId === -1 && officeProfile.submitted\">Required</p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <!-- <div class=\"col-md-7 office-profile-edit-left-column\">\n                <div class=\"office-counties-container\">\n                    <div class=\"row office-profile-label-container label-spacer\">\n                        <div class=\"col-md-12\">\n                            <div> \n                                <span>In Which State Does This Office Do Business?</span>\n                                <div class=\"office-counties-subtext\">(At least one must be selected)</div>\n                                <hp-active-states required=\"officeProfile.editOfficeProfile.submitted\" current-state=\"officeProfile.selectedState\" active-states=\"officeProfile.activeStates\"></hp-active-states>\n                            </div>\n                        </div>\n                        <div class=\"col-md-12\" ng-hide=\"!officeProfile.checkState();\">\n                            <span>In Which Counties Do You Do Business?</span>\n                            <div class=\"office-counties-subtext\">(At least one must be selected)</div>\n                        </div>\n                    </div>\n                    <div class=\"row office-counties-container\" ng-hide=\"!officeProfile.checkState();\">\n                        <div class=\"col-md-12\">\n                            <div> \n                                <ng-include src=\"'app/accounts/offices/profile/counties/counties.html'\"></ng-include>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div> -->\n            <div class=\"col-md-5 office-profile-edit-right-column\">\n                <div class=\"row office-profile-label-container label-spacer\">\n                    <div class=\"col-md-12\">\n                        <span>Other Jobs Include:</span>\n                    </div>\n                </div>\n                <ng-include src=\"'app/accounts/offices/profile/additionalServices/additionalServices.html'\"></ng-include>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"pull-left\">\n                    <span>Your changes will go live in 24 hours.</span>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12 edit-button-container\">\n                <div class=\"pull-left\">\n                    <button class=\"btn btn-primary\" id=\"btn-office-info-save\">\n                        Save\n                    </button>\n                </div>\n                <div class=\"pull-left\">\n                    <button type=\"button\" class=\"btn btn-default\" id=\"btn-office-info-cancel\" ng-click=\"officeProfile.cancelEditProfile()\">\n                        Cancel\n                    </button>\n                </div>\n            </div>\n        </div>\n    </form>\n</div>\n";

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports = "<div class=\"office-profile-container\" ng-controller=\"OfficeProfileController as officeProfile\">\n    <div class=\"row office-profile-header-container\">\n        <div class=\"col-md-6\">\n            <h2>Office Profile</h2>\n        </div>\n        <div class=\"col-md-6\">\n            <button class=\"btn btn-default pull-right\" id=\"btn-office-profile-edit\" ng-if=\"!officeProfile.isEditingProfile\"\n                    ng-click=\"officeProfile.editProfile()\">Edit\n            </button>\n        </div>\n    </div>\n    <div class=\"row message-container\"\n         ng-class=\"{ 'success': (officeProfile.isOfficeProfileError === false ), 'error': (officeProfile.isOfficeProfileError === true), 'edit-background' : (officeProfile.isEditingProfile === true)  }\"\n         ng-show=\"officeProfile.officeProfileStatusMessage !== ''\">\n        <div class=\"col-md-12\">\n            <p ng-bind=\"officeProfile.officeProfileStatusMessage\"></p>\n        </div>\n    </div>\n    <ng-include src=\"'app/accounts/offices/profile/viewProfile.html'\" ng-if=\"!officeProfile.isEditingProfile\"></ng-include>\n    <ng-include src=\"'app/accounts/offices/profile/editProfile.html'\" ng-if=\"officeProfile.isEditingProfile\"></ng-include>\n</div>\n";

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports = "<div class=\"counties-container\">\n    <div class=\"row\">\n        <div class=\"col-md-6\">\n            <div class=\"row\">\n                <div class=\"col-md-12 county-row\" ng-repeat=\"county in officeProfile.counties[0]\" ng-attr-id=\"{{ 'cb' + county.Name }}\"\n                    ng-click=\"officeProfile.selectCounty(county)\">\n                    <span class=\"icon icon-complete\" ng-if=\"county.isSelected === true\"></span>\n                    <span class=\"empty-checkbox\" ng-if=\"county.isSelected === false\"></span>\n                    <span ng-bind=\"county.Name\"></span>\n                </div>\n            </div>\n        </div>\n        <div class=\"col-md-6\">\n            <div class=\"row\">\n                <div class=\"col-md-12 county-row\" ng-repeat=\"county in officeProfile.counties[1]\" ng-attr-id=\"{{ 'cb' + county.Name }}\"\n                     ng-click=\"officeProfile.selectCounty(county)\">\n                    <span class=\"icon icon-complete\" ng-if=\"county.isSelected === true\"></span>\n                    <span class=\"empty-checkbox\" ng-if=\"county.isSelected === false\"></span>\n                    <span ng-bind=\"county.Name\"></span>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-md-12 error-message-container\" ng-if=\"officeProfile.countiesErrorMessage.length > 0 && officeProfile.submitted\">\n            <p class=\"error-message\" ng-bind=\"officeProfile.countiesErrorMessage\"></p>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports = "<div class=\"logo-upload-container\">\n    <ng-form name=\"officeProfile.imageUpload\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"logo-image-container\" ng-if=\"officeProfile.displayLogo\"\n                     ng-class=\"{ 'upload-error' : officeProfile.uploadErrorMessage !== '', 'upload' : officeProfile.uploadErrorMessage === ''}\">\n                    <img id=\"imgLogoPreview\" ng-src=\"{{officeProfile.logoImage}}\"/>\n                </div>\n                <div class=\"logo-image-placeholder\" ng-if=\"!officeProfile.displayLogo\"\n                     ng-class=\"{ 'upload-error' : officeProfile.uploadErrorMessage !== '', 'upload' : officeProfile.uploadErrorMessage === ''}\">\n                    <div class=\"placeholder-content-container\">\n                        <div class=\"icon icon-company-default\"></div>\n                        <div class=\"placeholder-text\">Add Company Logo</div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"logo-upload-button-container\">\n                    <div class=\"btn btn-primary btn-overlay\">Choose File</div>\n                    <input type=\"file\" id=\"btn-logo-upload\" class=\"btn-browse\" size=\"100\"\n                           fileread=\"officeProfile.logoImage\" source=\"editLogo\">\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12 upload-instructions-container\">\n                <p>Max accepted file size is 10 MB.</p>\n                <p>Supported file types: jpeg, jpg, tiff, gif, bmp, png</p>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12 error-message-container\">\n                <p class=\"error-message\" ng-bind=\"officeProfile.uploadErrorMessage\" ng-if=\"officeProfile.uploadErrorMessage !== ''\"></p>\n            </div>\n        </div>\n    </ng-form>\n</div>\n";

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = officesController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(463);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

officesController.$inject = ['$scope', '$stateParams', 'UserData', 'ModalService', 'HPRoles'];


/* @ngInject */
function officesController($scope, $stateParams, UserData, ModalService, HPRoles) {
    var vm = this;

    vm.isEditingOffice = false;

    vm.addOffice = function () {
        var modal = ModalService.launchLgModal({
            templateUrl: 'app/accounts/offices/addOffice/addOffice.html',
            windowClass: 'add-office full-screen',
            controller: 'AddOfficeController',
            controllerAs: 'addOffice',
            size: 'full-screen'
        });

        modal.result.then(function (result) {
            if (result === true) {
                $scope.$broadcast('refreshOffices');
            }
            ModalService.closeLgModal();
        });
    };

    function initializeEditMode() {
        if ($stateParams.accountId !== null) {
            vm.isEditingOffice = true;
        } else {
            vm.isEditingOffice = false;
        }
    }

    function getUserSettings() {
        UserData.getUserData().then(function (response) {
            var currentRole = _lodash2.default.find(HPRoles, function (key, other) {
                return other === response.Roles[0];
            });
            vm.canAddOffices = !!currentRole && currentRole.rank === 1;
            initializeEditMode();
        });
    }

    function init() {
        getUserSettings();
    }

    init();
}

/***/ }),
/* 463 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = officeDetailController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

officeDetailController.$inject = ['$state', 'OfficesFactory', '$stateParams', 'UserData', '$scope', '$rootScope', 'HPRoles', 'ModalService'];


/* @ngInject */
function officeDetailController($state, OfficesFactory, $stateParams, UserData, $scope, $rootScope, HPRoles, ModalService) {
    var vm = this;

    vm.canViewACH = false;
    vm.showDeleteOfficeButton = false;

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    vm.backToOffices = function () {
        $state.go('accounts', { accountsPage: 'offices', accountId: null });
    };

    vm.deleteOffice = function () {
        var modal = ModalService.launchLgModal({
            templateUrl: 'app/accounts/offices/deleteOffice/deleteOffice.html',
            windowClass: 'delete-office',
            controller: 'DeleteOfficeController',
            controllerAs: 'deleteOffice',
            size: 'full-screen',
            resolve: {
                selectedOffice: function selectedOffice() {
                    return vm.officeProfile;
                }
            }
        });

        modal.result.then(function (result) {
            if (result === true) {
                // If user is successfully deleted, take the user to the users page
                $state.go('accounts', { accountsPage: 'offices', accountId: null });
            }
            ModalService.closeLgModal();
        });
    };

    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */
    function init() {
        getOfficeProfile();

        $rootScope.$on('LocationNicknameUpdated', function (event, payload) {
            vm.officeProfile.LocationDetail.LocationNickname = payload.LocationNickname;
        });
    }

    function getOfficeProfile() {
        var data = {
            ContractorLocationId: Number($stateParams.accountId)
        };
        UserData.getUserData().then(function (response) {
            var currentRole = _lodash2.default.find(HPRoles, function (key, other) {
                return other === response.Roles[0];
            });
            vm.canViewACH = currentRole.isAdmin;
            data.IncludeACHInfo = currentRole.isAdmin;
            OfficesFactory.getOfficeProfile(data).then(function (response) {
                vm.officeProfile = response.data;
                // (ajt - 6/24/2016) Add check to ensure delete button is only displayed if number of offices > 1 or office is not Main Office
                // (ajt - 7/7/2016) Add additional check for UserRole Rank = 1 (Company level user)
                UserData.getKBYGLocations().then(function (response) {
                    vm.showDeleteOfficeButton = !vm.officeProfile.LocationDetail.IsMaster && response.length > 1 && !!currentRole && currentRole.rank === 1;
                });
            });
        });
    }
}

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = officesTableController;
officesTableController.$inject = ['$state', 'OfficesFactory', '$scope'];

/* @ngInject */
function officesTableController($state, OfficesFactory, $scope) {
    var vm = this;

    vm.officesList = [];

    vm.officesHeader = '';
    vm.loadingOffices = true;

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    vm.viewOffice = function (office) {
        $state.go('accounts', { accountsPage: 'offices', accountId: office.ContractorId });
    };

    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */
    function init() {
        getOfficeLocations();
    }

    function getOfficeLocations() {
        vm.loadingOffices = true;
        OfficesFactory.getOffices().then(function (response) {
            vm.officesList = response.data.Data;
            buildOfficeTableHeader();
            vm.loadingOffices = false;
        });
    }

    function buildOfficeTableHeader() {
        if (vm.officesList.length > 1) {
            vm.officesHeader = 'Offices'; // HPF-233 removing "California" from the "offices" title page
        } else {
            vm.officesHeader = 'Office'; // HPF-233 removing "California" from the "offices" title page
        }
    }

    $scope.$on('refreshOffices', function () {
        getOfficeLocations();
    });
}

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = deleteOfficeController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(467);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

deleteOfficeController.$inject = ['$uibModalInstance', 'selectedOffice', 'UserData', 'OfficesFactory', '$rootScope']; // angular
//  .module("HeroPRO")
//  .controller("DeleteOfficeController", deleteOfficeController);


/* @ngInject */
function deleteOfficeController($uibModalInstance, selectedOffice, UserData, OfficesFactory, $rootScope) {
    var vm = this;
    vm.selectedOffice = selectedOffice;
    vm.selectedlocation = {};
    vm.contentShown = 'deleteInProgress';
    vm.processing = false;
    vm.locations = [];
    vm.successData = [];

    vm.defaultLocation = {
        ContractorId: -1,
        LocationNickname: 'Choose Office'
    };

    vm.closeModal = function () {
        var result = false;

        if (vm.contentShown === 'deleteSuccess') {
            result = true;
        }

        $uibModalInstance.close(result);
    };

    // Check if default Office dropdown value is selected
    function validateOfficeSelection() {
        if (!vm.selectedLocation || vm.selectedLocation.ContractorId === -1) {
            vm.selectLocationForm.$setValidity('office-not-selected', false);
        } else {
            vm.selectLocationForm.$setValidity('office-not-selected', true);
        }
    }

    vm.locationClicked = function (location) {
        vm.selectedLocation = location;
        validateOfficeSelection();
    };

    function deleteOffice(payload) {
        OfficesFactory.reassignUsersAndDeleteOffice(payload).then(function () {
            vm.processing = false;
            vm.contentShown = 'deleteSuccess';
            vm.successData.push([vm.selectedLocation.LocationNickname]);
            UserData.resetPromises().then(function () {
                $rootScope.$broadcast('officesUpdated');
            });
        });
    }

    vm.reassignEmployeesAndDeleteOffice = function () {
        // (ajt - 5/17/2016) Replace with general validation function if additional fields are added.
        validateOfficeSelection();
        if (vm.selectLocationForm.$valid) {
            vm.processing = true;
            var payload = {
                DeleteContractorLocationId: vm.selectedOffice.ContractorId,
                NewContractorLocationId: vm.selectedLocation.ContractorId
            };
            deleteOffice(payload);
        } else {
            // console.log('Not valid');
        }
    };

    // Loads locations for dropdown
    function getLocations() {
        UserData.getKBYGLocations().then(function (response) {
            vm.locations = response;
            if (_lodash2.default.findWhere(vm.locations, { ContractorId: -1 }) === undefined) {
                vm.locations.unshift(vm.defaultLocation);
            }
            // (ajt - 6/24/2016) Remove selected office from DropDown selection list.
            vm.locations = _lodash2.default.filter(vm.locations, function (location) {
                return location.ContractorId !== vm.selectedOffice.ContractorId;
            });
            vm.selectedLocation = vm.locations[0];
        });
    }

    function init() {
        getLocations();
    }
    init();
}

/***/ }),
/* 467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = officesFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

officesFactory.$inject = ['$http', 'HPConfig', '$q', '$window'];


/* @ngInject */
function officesFactory($http, HPConfig, $q, $window) {
    var isEditingOffice = false;

    var accountTypes = [{
        BankAccountTypeId: 1,
        Name: 'Checking',
        Description: 'Checking'
    }, {
        BankAccountTypeId: 2,
        Name: 'Savings',
        Description: 'Savings'
    }];

    var paymentStatuses = [{
        PaymentMethodStatusId: 1,
        Name: 'In Review',
        Description: 'In Review'
    }, {
        PaymentMethodStatusId: 2,
        Name: 'Approved',
        Description: 'Approved'
    }, {
        PaymentMethodStatusId: 3,
        Name: 'Rejected',
        Description: 'Rejected'
    }];

    return {
        getOffices: getOffices,
        getOfficeProfile: getOfficeProfile,
        getStates: getStates,
        getServices: getServices,
        getCounties: getCounties,
        getPaymentStatuses: getPaymentStatuses,
        getAccountTypes: getAccountTypes,
        saveLogo: saveLogo,
        saveInfo: saveInfo,
        saveProfile: saveProfile,
        saveContacts: saveContacts,
        saveFinanceInfo: saveFinanceInfo,
        saveNewOffice: saveNewOffice,
        reassignUsersAndDeleteOffice: reassignUsersAndDeleteOffice,
        validateImage: validateImage,
        isEditingOffice: isEditingOffice
    };

    function getOfficeProfile(params) {
        return $http({
            url: HPConfig.heroProApi + 'Contractor/Info',
            method: 'GET',
            params: params
        });
    }
    /** **
     *  HPF removing actual call to database. using reference to all 50 states instead
     *
     *
     *** */
    function getOffices() {
        return $http({
            url: HPConfig.heroProApi + 'Contractor/Location',
            method: 'GET',
            params: {
                includeServiceStates: false,
                contractorStatusList: [2, 3, 10, 11]
            }
        });
    }

    function validateImage(src) {
        var deferred = $q.defer();

        var image = new $window.Image();

        image.onerror = function () {
            deferred.resolve(false);
        };
        image.onload = function () {
            deferred.resolve(true);
        };
        image.src = src;
        /* jshint ignore:end */
        return deferred.promise;
    }

    /* adding all 50 states instead of restricting to just CA */
    function getStates(_excludeInactive) {
        var _data = _excludeInactive || false;

        return $http({
            url: HPConfig.heroProApi + 'Address/States?excludeInactive=' + _data,
            method: 'GET'
        });
    }

    function getServices() {
        return $http({
            url: HPConfig.heroProApi + 'Contractor/ContractorTypes',
            method: 'GET',
            cache: true
        });
    }

    function getCounties(stateGeoId) {
        var _params = {
            MuniStatusId: 1, // 1 == active munis, 2 == inactive munis currently defaulted to active munis
            StateGeoId: stateGeoId
        };
        return $http({
            url: HPConfig.heroProApi + 'Contractor/Munis',
            method: 'GET',
            params: _params,
            cache: true
        });
    }

    function getPaymentStatuses() {
        var deferred = $q.defer();

        deferred.resolve(paymentStatuses);
        return deferred.promise;
    }

    function getAccountTypes() {
        var deferred = $q.defer();

        deferred.resolve(accountTypes);
        return deferred.promise;
    }

    function saveLogo(data) {
        return $http({
            url: HPConfig.heroProApi + 'Contractor/UploadLogo',
            method: 'POST',
            headers: {
                'Content-Type': undefined
            },
            processData: false,
            data: data
        });
    }

    function saveInfo(data) {
        return $http({
            url: HPConfig.heroProApi + 'Contractor/Information',
            method: 'POST',
            data: data
        });
    }

    function saveProfile(data) {
        return $http({
            url: HPConfig.heroProApi + 'Contractor/Profile',
            method: 'POST',
            data: data
        });
    }

    function saveContacts(data) {
        return $http({
            url: HPConfig.heroProApi + 'Contractor/Contacts',
            method: 'POST',
            data: data
        });
    }

    function saveFinanceInfo(data) {
        return $http({
            url: HPConfig.heroProApi + 'Contractor/ACH',
            method: 'POST',
            data: data
        });
    }

    function saveNewOffice(data) {
        return $http({
            url: HPConfig.heroProApi + 'Contractor/Location',
            method: 'POST',
            data: data
        });
    }

    function reassignUsersAndDeleteOffice(data) {
        return $http({
            url: HPConfig.heroProApi + 'Contractor/Delete',
            method: 'POST',
            data: data
        });
    }
}

/***/ }),
/* 469 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 470 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports = "<div class=\"office-detail-container\" ng-controller=\"OfficeDetailController as officeDetail\">\n    <ng-include src=\"'app/accounts/offices/header/detailHeader.html'\"></ng-include>\n    <ng-include src=\"'app/accounts/offices/info/officeInfo.html'\"></ng-include>\n    <ng-include src=\"'app/accounts/offices/profile/officeProfile.html'\"></ng-include>\n    <ng-include src=\"'app/accounts/offices/financing/officeFinancing.html'\" ng-if=\"officeDetail.canViewACH\"></ng-include>\n    <!--<ng-include src=\"'app/accounts/offices/licensure/officeLicensure.html'\"></ng-include>-->\n</div>\n";

/***/ }),
/* 472 */
/***/ (function(module, exports) {

module.exports = "<div class=\"offices-table-container\" ng-controller=\"OfficesTableController as officesTable\">\n    <div class=\"row offices-header-container\">\n        <div class=\"col-md-6\">\n            <h2 ng-bind=\"officesTable.officesHeader\"></h2>\n        </div>\n        <div class=\"col-md-6\" style=\"text-align: right;\">\n            <button class=\"btn btn-default\" id=\"btn-add-office\" ng-click=\"offices.addOffice()\" ng-if=\"offices.canAddOffices\">Add Office</button>\n        </div>\n    </div>\n    <div class=\"hp-loading-spinner\" ra-spinner name=\"officesSpinner\" show=\"officesTable.loadingOffices === true\" hide-content-when-shown=\"true\">\n        <div class=\"row offices-row-header\">\n            <div class=\"col-md-4\"><span>Office name</span></div>\n            <div class=\"col-md-4\"><span>Address</span></div>\n            <div class=\"col-md-4\"><span>Office contact</span></div>\n        </div>\n        <div class=\"row offices-row\" ng-repeat=\"office in officesTable.officesList\"\n             ng-class=\"{'offices-row-border' : $index < officesTable.officesList.length - 1}\"\n             ng-click=\"officesTable.viewOffice(office)\">\n            <div class=\"col-md-4\">\n                <p ng-bind=\"office.LocationNickname\"></p>\n                <span class=\"hp-badge\" ng-if=\"office.IsMaster === true\"> <span class=\"icon icon-main-office\"></span> Main Office</span>\n            </div>\n            <div class=\"col-md-4\">\n                <p ng-bind=\"office.Address\"></p>\n\n                <p ng-bind=\"office.City + ', ' + office.State + ' ' + office.Zip\"></p>\n            </div>\n            <div class=\"col-md-4\">\n                <p ng-bind=\"office.ContactFirstName + ' ' + office.ContactLastName\"></p>\n                <p ng-bind=\"office.ContactPhone | tel\"></p>\n                <p ng-bind=\"office.ContactEmail\"></p>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 473 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <span class=\"icon icon-delete\" ng-click=\"deleteOffice.closeModal()\"></span>\n</div>\n\n<div class=\"row\">\n    <div class=\"col-md-10 col-md-offset-1\">\n        <div class=\"modal-body\">\n            <p class=\"modal-title\">Delete Office</p>\n\n            <div class=\"delete-office\" ng-if=\"deleteOffice.contentShown === 'deleteInProgress'\">\n                <form name=\"deleteOffice.selectLocationForm\" ng-submit=\"deleteOffice.reassignEmployeesAndDeleteOffice()\">\n                <div class=\"row\">\n                    <!-- Reassign jobs and delete office -->\n                    <div class=\"col-md-10 col-md-offset-1 text-center\">\n                        <div class=\"current-location-message\">\n                            <h2>Are you sure you want to delete the {{deleteOffice.selectedOffice.LocationDetail.LocationNickname}} office? This cannot be undone.</h2>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <!-- Reassign jobs and delete office -->\n                    <div class=\"col-md-8 col-md-offset-2 text-center\">\n                        <div class=\"location-selection-container\">\n                            <p>To delete, you must re-assign the users. The jobs will stay with the existing users </p>\n                            <div class=\"dropdown\" uib-dropdown dropdown-small-popup dropdown-title=\"Location\"\n                                 ng-class=\"{'no-selection': deleteOffice.selectLocationForm.$invalid && deleteOffice.selectLocationForm.$submitted }\">\n                                <a id=\"ddl-office-locations\" blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle\n                                   data-toggle=\"dropdown\">\n                                    <span class=\"dropdown-text\">{{deleteOffice.selectedLocation.LocationNickname}}</span>\n                                    <span class=\"icon\"></span>\n                                </a>\n                                <ul class=\"dropdown-menu\" uib-dropdown-menu>\n                                    <li ng-repeat=\"location in deleteOffice.locations\"\n                                        ng-class=\"{'active': deleteOffice.selectedLocation.ContractorId === location.ContractorId }\"\n                                        ng-click=\"deleteOffice.locationClicked(location, $event)\">\n                                        <span>{{location.LocationNickname}}</span>\n                                    </li>\n                                </ul>\n                            </div>\n                            <div class=\"error-message-container\">\n                                <p class=\"error-message\" ng-show=\"deleteOffice.selectLocationForm.$invalid && deleteOffice.selectLocationForm.$submitted\">\n                                    Required</p>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"modal-buttons text-center\">\n                    <hp-spinner-button button-text=\"Delete\" button-name=\"btnDeleteOffice\" is-primary-btn=\"true\"\n                                       is-submit-button=\"true\" display-spinner=\"deleteOffice.processing\"></hp-spinner-button>\n                    <button type=\"button\" class=\"btn btn-default\" ng-click=\"deleteOffice.closeModal()\">Cancel</button>\n                </div>\n                </form>\n            </div>\n\n            <full-screen-modal-success ng-if=\"deleteOffice.contentShown === 'deleteSuccess'\"\n                                       primary-text=\"{{deleteOffice.selectedOffice.LocationDetail.LocationNickname}} has been deleted\"\n                                       secondary-text=\"HERO accounts for {{deleteOffice.selectedOffice.LocationDetail.LocationNickname}} have been re-assigned to:\"\n                                       content-list=\"deleteOffice.successData\"\n                                       button-text=\"Done\"\n                                       button-fn=\"deleteOffice.closeModal()\">\n            </full-screen-modal-success>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports = "<div class=\"office-detail-header-container\">\n    <div class=\"row back-to-offices-link-container\">\n        <div class=\"col-md-12\">\n            <span class=\"link\" id=\"edit-office-back\" ng-click=\"officeDetail.backToOffices()\">&lt; Back</span>\n        </div>\n    </div>\n    <div class=\"row office-name-container\">\n        <div class=\"col-md-6\">\n            <p class=\"office-name\" ng-bind=\"officeDetail.officeProfile.LocationDetail.LocationNickname\"></p>\n        </div>\n        <div class=\"col-md-6\">\n            <div class=\"pull-right\" ng-if=\"false\">\n                <button class=\"btn btn-default\" id=\"btn-office-add-user\" ng-click=\"\">Add User</button>\n            </div>\n            <div class=\"pull-right btn-space\">\n                <button class=\"btn btn-default\" id=\"btn-delete-office\" ng-click=\"officeDetail.deleteOffice()\" ng-if=\"officeDetail.showDeleteOfficeButton\">Delete Office</button>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 475 */
/***/ (function(module, exports) {

module.exports = "<div class=\"office-licensure-container\">\n    <div class=\"row office-licensure-header-container\">\n        <div class=\"col-md-12\">\n            <h2>Licensure</h2>\n        </div>\n    </div>\n    <ng-include src=\"'app/accounts/offices/licensure/viewLicensure.html'\"></ng-include> \n</div>\n";

/***/ }),
/* 476 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row office-license-container\">\n    <div class=\"col-md-3\">\n        <p>CSLB# 1255789</p>\n        <p>Joe Smith</span>\n    </div>\n    <div class=\"col-md-4\">\n        <p>2198 S. James Street</p>\n        <p>San Diego, CA 92126</p>\n    </div>\n    <div class=\"col-md-3 license-contact-info\">\n        <p>(855) 410-4700</p>\n        <p>office345@a1solarpower.com</p>\n    </div>\n    <div class=\"col-md-2\">\n\n    </div>\n</div>\n";

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = accountsController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(478);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

accountsController.$inject = ['AccountsFactory', '$stateParams', '$state', 'UiDisplayFactory', 'UserData', 'PermissionsFactory'];


/* @ngInject */
function accountsController(AccountsFactory, $stateParams, $state, UiDisplayFactory, UserData, PermissionsFactory) {
    var vm = this;

    vm.accountsPages = [];
    vm.currentPage = {};
    vm.pageUrl = '';
    vm.isEditingUser = false;
    vm.hasElevatedAccess = PermissionsFactory.hasPermission('Contractor.HasElevatedAccess') === true;

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    vm.switchPage = function (page) {
        $state.go('accounts', { accountsPage: page.pageName, accountId: null });
    };

    vm.init = init;
    vm.getAccountsPages = getAccountsPages;
    vm.setInitialPage = setInitialPage;
    vm.setEditUserState = setEditUserState;
    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Code to Run                =
    ======================================== */

    vm.init();

    /* -----  End of Code to Run  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */
    function init() {
        getAccountsPages();
        setInitialPage();
        setEditUserState();
    }

    function getAccountsPages() {
        // Unfortunately have to wrap the retrieval of pages in these nested promises because
        // checkForBenji() in mainController.js needs to be completed before this executes
        UserData.getUserData().then(function () {
            UserData.getUserLocations().then(function (userLocations) {
                var tempPages = AccountsFactory.getAccountsPages();
                var rules = UiDisplayFactory.getDisplayRules();
                var isCaliforniaUser = _lodash2.default.some(userLocations, function (location) {
                    return location.State === 'CA';
                });
                if (rules.isBenjiOnlyUser === true) {
                    tempPages = filterPagesForBenjiUser(tempPages);
                    tempPages = filterPagesForNonCaliforniaUser(tempPages);
                } else if (isCaliforniaUser === false) {
                    tempPages = filterPagesForNonCaliforniaUser(tempPages);
                }
                vm.accountsPages = tempPages;
            });
        });
    }

    function setInitialPage() {
        vm.currentPage = AccountsFactory.getCurrentAccountPage($stateParams.accountsPage);
        vm.pageUrl = vm.currentPage.url;
    }

    function setEditUserState() {
        if ($stateParams.accountsPage === 'users' && $stateParams.accountId !== null) {
            vm.isEditingUser = true;
        }
    }

    function filterPagesForBenjiUser(tempPages) {
        return _lodash2.default.reject(tempPages, function (page) {
            return page.pageName === 'financing';
        });
    }

    function filterPagesForNonCaliforniaUser(tempPages) {
        return _lodash2.default.reject(tempPages, function (page) {
            return page.pageName === 'pcc';
        });
    }
}

/***/ }),
/* 478 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = accountsFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

accountsFactory.$inject = ['$http', 'HPConfig'];

/* @ngInject */
function accountsFactory($http, HPConfig) {
    var accountsPages = [{
        pageName: 'licenses',
        pageDisplayName: 'Licenses',
        isEnabled: true,
        url: 'app/accounts/licenses/licenses.html',
        isPublic: false
    }, {
        pageName: 'company',
        pageDisplayName: 'Company',
        isEnabled: false,
        url: 'app/accounts/company/company.html',
        isPublic: false
    }, {
        pageName: 'offices',
        pageDisplayName: 'Offices',
        isEnabled: true,
        url: 'app/accounts/offices/offices.html',
        isPublic: false
    }, {
        pageName: 'users',
        pageDisplayName: 'Users',
        isEnabled: true,
        url: 'app/accounts/user/users.html',
        isPublic: false
    }, {
        pageName: 'myprofile',
        pageDisplayName: 'My Profile',
        isEnabled: true,
        url: 'app/accounts/user/myprofile.html',
        isPublic: true
    }, {
        pageName: 'pcc',
        pageDisplayName: 'My PACE Status',
        isEnabled: false,
        url: 'app/accounts/user/paceCredential/paceCredential.html',
        isPublic: false
    }, {
        pageName: 'financing',
        pageDisplayName: 'Financing',
        isEnabled: false,
        url: 'app/accounts/financing/financing.html',
        isPublic: false
    }];

    var userTableColumns = {
        firstName: {
            key: 'First',
            sort: true,
            val: function val(row) {
                if (row === undefined || row === null) {
                    return '';
                }
                return row.FirstName;
            },

            apiColumnId: 1
        },
        lastName: {
            key: 'Last',
            sort: true,
            val: function val(row) {
                if (row === undefined || row === null) {
                    return '';
                }
                return row.LastName;
            },

            apiColumnId: 2
        },
        offices: {
            key: 'Office(s)',
            sort: false,
            val: function val(row) {
                if (row === undefined || row === null) {
                    return '';
                }
                var locations = '';
                _lodash2.default.each(row.LocationNames, function (location) {
                    if (location.Nickname !== undefined && location.Nickname !== null) {
                        locations = locations + location.Nickname + ', ';
                    }
                });
                return locations.slice(0, locations.length - 2);
            }
        },
        role: {
            key: 'Role',
            sort: false,
            val: function val(row) {
                if (row === undefined || row === null) {
                    return '';
                }
                return row.RoleName;
            }
        }
    };

    return {
        getAccountsPages: getAccountsPages,
        getCurrentAccountPage: getCurrentAccountPage,
        getContractorUser: getContractorUser,
        updateContractorUser: updateContractorUser,
        updateContactPreferences: updateContactPreferences,
        validateContractorUserLicenseLicense: validateContractorUserLicenseLicense,
        getContractorUserTrainings: getContractorUserTrainings,
        getUsers: getUsers,
        getUserTableColumns: getUserTableColumns,
        getUserRoles: getUserRoles,
        addOfficeToUser: addOfficeToUser,
        addUser: addUser,
        reassignJobsAndRemoveOffice: reassignJobsAndRemoveOffice,
        reassignJobsAndDeleteUser: reassignJobsAndDeleteUser,
        disableUser: disableUser,
        enableUser: enableUser,
        getContractorJobLocations: getContractorJobLocations,
        getContractorUsersByLocation: getContractorUsersByLocation,
        getContractorUserHISRequirementsStatus: getContractorUserHISRequirementsStatus,
        getContractorUserHISTrainingRedirectURI: getContractorUserHISTrainingRedirectURI,
        adjustContractorUserHISStatus: adjustContractorUserHISStatus,
        getCSLBLicenseHolders: getCSLBLicenseHolders,
        setHISLicenseExemptionStatus: setHISLicenseExemptionStatus,
        confirmContractorUserContactInfo: confirmContractorUserContactInfo
        //		getEditProfileDirtyFlag: getEditProfileDirtyFlag,
        //		setEditProfileDirtyFlag: setEditProfileDirtyFlag
    };

    function getAccountsPages() {
        return _lodash2.default.filter(accountsPages, function (page) {
            return page.isEnabled === true;
        });
    }

    function getCurrentAccountPage(pageName) {
        if (pageName === undefined || pageName === null) {
            return accountsPages[0];
        }
        var pages = _lodash2.default.filter(accountsPages, function (page) {
            return page.pageName === pageName;
        });
        if (pages !== undefined && pages !== null && pages.length > 0) {
            return pages[0];
        }

        return accountsPages[0];
    }

    function getContractorUser(userId) {
        var url = HPConfig.heroProApi + 'ContractorUser/Profile';
        if (userId !== undefined && userId !== null) {
            url += '?ContractorUserId=' + userId.toString();
        }
        return $http({
            url: url,
            method: 'GET'
        });
    }

    function updateContractorUser(params) {
        return $http({
            url: HPConfig.heroProApi + 'ContractorUser/Update',
            method: 'POST',
            data: params
        });
    }

    function confirmContractorUserContactInfo(params) {
        return $http({
            url: HPConfig.heroProApi + 'ContractorUser/ConfirmContactInfo',
            method: 'POST',
            data: params
        });
    }

    function updateContactPreferences(params) {
        return $http({
            url: HPConfig.heroProApi + 'ContractorUser/UpdateContactPreferences',
            method: 'POST',
            data: params
        });
    }

    function getContractorUsersByLocation(params) {
        return $http.get(HPConfig.heroProApi + 'Contractor/ContractorUsers', {
            params: params
        });
    }

    function getContractorJobLocations(params) {
        return $http.get(HPConfig.heroProApi + 'ContractorUser/JobLocations', {
            params: params
        });
    }

    function validateContractorUserLicenseLicense(params) {
        return $http.get(HPConfig.heroProApi + 'ContractorUser/Licenses/Validate', {
            params: params
        });
    }

    function getContractorUserTrainings() {
        return $http.get(HPConfig.heroProApi + 'ContractorUser/Trainings');
    }

    function getContractorUserHISRequirementsStatus(params) {
        return $http.get(HPConfig.heroProApi + 'ContractorUser/GetHISRequirementsStatus', {
            params: params
        });
    }

    function getContractorUserHISTrainingRedirectURI(params) {
        return $http.get(HPConfig.heroProApi + 'ContractorUser/GetHISTrainingRedirectURI', {
            params: params
        });
    }

    function adjustContractorUserHISStatus(params) {
        return $http.post(HPConfig.heroProApi + 'ContractorUser/AdjustHISStatus', params);
    }

    function getUsers(params) {
        return $http.post(HPConfig.heroProApi + 'ContractorUser/Management', params);
    }

    function getUserTableColumns() {
        return userTableColumns;
    }

    function getUserRoles() {
        return $http({
            url: HPConfig.heroProApi + 'ContractorUser/Roles',
            method: 'GET'
        });
    }

    function reassignJobsAndRemoveOffice(office, currentUser, newUser) {
        return $http.post(HPConfig.heroProApi + 'ContractorUser/RemoveFromLocation', {
            ContractorLocationId: office.ContractorId,
            SalesRepContractorUserId: currentUser.ContractorUserId || null,
            NewSalesRepContractorUserId: newUser.ContractorUserId
        });
    }

    function addOfficeToUser(params) {
        return $http.post(HPConfig.heroProApi + 'ContractorUser/AddLocation', params);
    }

    function addUser(data) {
        return $http.post(HPConfig.heroProApi + 'ContractorUser/Add', data);
    }

    function reassignJobsAndDeleteUser(params) {
        return $http.post(HPConfig.heroProApi + 'ContractorUser/Delete', params);
    }

    function disableUser(params) {
        return $http.post(HPConfig.heroProApi + 'ContractorUser/Disable', params);
    }

    function enableUser(params) {
        return $http.post(HPConfig.heroProApi + 'ContractorUser/Enable', params);
    }

    function getCSLBLicenseHolders(params) {
        return $http.get(HPConfig.heroProApi + 'Organization/CSLBUsers', {
            params: params
        });
    }

    function setHISLicenseExemptionStatus(params) {
        return $http.post(HPConfig.heroProApi + 'ContractorUser/HISLicenseExemption', params);
    }
}

/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports = "<div class=\"accounts-myprofile-content-container\" ng-controller=\"UserController as user\">\n    <ng-include src=\"'app/accounts/user/personalInformation/personalInformationHeader.html'\"></ng-include>\n    <ng-include ng-if=\"!user.editPersonalInfoMode\"\n                src=\"'app/accounts/user/personalInformation/personalInformation.html'\"></ng-include>\n    <ng-include ng-if=\"user.editPersonalInfoMode\"\n                src=\"'app/accounts/user/personalInformation/editPersonalInformation.html'\"></ng-include>\n    <ng-include ng-if=\"!user.changePreferencesMode\"\n                src=\"'app/accounts/user/preferences/preferences.html'\"></ng-include>\n    <ng-include ng-if=\"user.changePreferencesMode\"\n                src=\"'app/accounts/user/preferences/changePreferences.html'\"></ng-include>\n    <ng-include src=\"'app/accounts/user/profilePassword/profilePassword.html'\"></ng-include>\n    <ng-include src=\"'app/accounts/user/officeAssignments/officeAssignments.html'\"></ng-include>\n</div>\n";

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports = "<div class=\"pcc-container\" ng-controller=\"PaceCredentialController as pcc\">\n    <div class=\"row pcc-row\" ng-if=\"pcc.isLoading\">\n        <div class=\"col-md-12\">\n            <h3>Loading...</h3>\n        </div>\n    </div>\n    <div class=\"row pcc-row\" ng-if=\"!pcc.isLoading\">\n        <div class=\"col-md-12\">\n            <h2>My Status</h2>\n            <div class=\"my-status-box\">\n                <div class=\"current-status-advertiser\" ng-show=\"pcc.isSolicitor !== true\">\n                    <h3 class=\"pace-status-h3\">\n                        <img class='pace-status-checkmark' src=\"src/assets/images/icon-checkmark-solid.svg\" ng-show=\"pcc.advertiserRequirements_HasTraining === true\"\n                            alt=\"PACE Participant\">\n                        PACE Participant\n                        <a href=\"#\" class=\"icon icon-pipeline-tip\" hp-popover popover-placement=\"right\" popover-trigger=\"show\"\n                            popover-title=\"\" uib-popover-template=\"'app/accounts/user/paceCredential/popoverTemplates/paceParticipant.html'\"></a>\n                    </h3>\n                    <div ng-show=\"pcc.advertiserRequirements_HasTraining !== true\">\n                        <hr />\n                        <h4>Unfulfilled Requirements</h4>\n                        <strong>PACE Training:</strong> Incomplete<br />\n                        <button ng-click=\"pcc.GoToTraining('advertiser');\" class=\"btn btn-default his-button\">Go to Training</button>\n                    </div>\n                </div>\n                <div class=\"current-status-solicitor\" ng-show=\"pcc.isSolicitor === true\">\n                    <h3 class=\"pace-status-h3\">\n                        <img class='pace-status-checkmark' src=\"src/assets/images/icon-checkmark-solid.svg\" ng-show=\"pcc.solicitorRequirements_HasTraining === true && pcc.solicitorRequirements_HasLicenseNumber === true\"\n                            alt=\"Certified PACE Professional\">\n                        Certified PACE Professional\n                        <a href=\"#\" class=\"icon icon-pipeline-tip\" hp-popover popover-placement=\"right\" popover-trigger=\"show\"\n                            popover-title=\"\" uib-popover-template=\"'app/accounts/user/paceCredential/popoverTemplates/certifiedPaceProfessional.html'\"></a>\n                    </h3>\n                    <div ng-show=\"pcc.solicitorRequirements_HasTraining !== true || pcc.solicitorRequirements_HasLicenseNumber !== true\">\n                        <hr />\n                        <h4>Unfulfilled Requirements</h4>\n                    </div>\n                    <div class=\"unfulfilled-requirement-block\" ng-show=\"pcc.solicitorRequirements_HasTraining !== true\">\n                        <strong>PACE Pro Training:</strong> Incomplete<br />\n                        <button ng-click=\"pcc.GoToTraining('solicitor');\" class=\"btn btn-default his-button\">Go to Training</button>\n                    </div>\n                    <div class=\"unfulfilled-requirement-block\" ng-show=\"pcc.solicitorRequirements_HasLicenseNumber !== true\">\n                        <strong>Home Improvement Salesperson (HIS) registration number:</strong><br />\n                        <button class=\"btn btn-default his-button\" ng-click=\"pcc.openContractorUserLicenseRegistrationModal()\">Enter HIS number</button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row pcc-row\" ng-if=\"!pcc.isLoading\">\n        <div class=\"col-md-12\" ng-show=\"pcc.isSolicitor !== true\">\n            <h2>Need access to HERO Pro's sales tools?</h2>\n            <p>\n                Become a Certified PACE Professional to access the Calculator, Proposal Plus and more.\n                <a ng-click=\"pcc.openStatusComparisonModal()\">Learn More</a>\n            </p>\n        </div>\n        <div class=\"col-md-12\" ng-show=\"pcc.isSolicitor === true\">\n            <h2>Adjust Status</h2>\n        </div>\n        <div class=\"col-md-12\">\n            <div class=\"my-status-box\">\n                <div class=\"switch-status-to-advertiser\" ng-show=\"pcc.isSolicitor === true\">\n                    <h3 class=\"pace-status-h3\">\n                        Switch to be a PACE Participant\n                        <a href=\"#\" class=\"icon icon-pipeline-tip\" hp-popover popover-placement=\"right\" popover-trigger=\"show\"\n                            popover-title=\"\" uib-popover-template=\"'app/accounts/user/paceCredential/popoverTemplates/paceParticipant.html'\"></a>\n                    </h3>\n                    <div ng-show=\"pcc.advertiserRequirements_Eligible === true\">\n                        <hr />\n                        <button class=\"btn btn-default his-button\" ng-click=\"pcc.adjustContractorUserHISStatus('advertiser')\">Switch to be a PACE Participant</button>\n                    </div>\n                    <div ng-show=\"pcc.advertiserRequirements_Eligible !== true\">\n                        <hr />\n                        In order to switch to a PACE Participant, you must first complete the following requirements:\n                    </div>\n                    <div class=\"unfulfilled-requirement-block\" ng-show=\"pcc.advertiserRequirements_HasTraining !== true\">\n                        <strong>PACE Training:</strong> Incomplete<br />\n                        <button ng-click=\"pcc.GoToTraining('advertiser');\" class=\"btn btn-default his-button\">Go to Training</button>\n                    </div>\n                </div>\n                <div class=\"switch-status-to-solicitor\" ng-show=\"pcc.isSolicitor !== true\">\n                    <h3 class=\"pace-status-h3\">\n                        Switch to be a Certified PACE Professional\n                        <a href=\"#\" class=\"icon icon-pipeline-tip\" hp-popover popover-placement=\"right\" popover-trigger=\"show\"\n                            popover-title=\"\" uib-popover-template=\"'app/accounts/user/paceCredential/popoverTemplates/certifiedPaceProfessional.html'\"></a>\n                    </h3>\n                    <div ng-show=\"pcc.solicitorRequirements_Eligible === true\">\n                        <hr/>\n                        <button class=\"btn btn-default his-button\" ng-click=\"pcc.adjustContractorUserHISStatus('solicitor')\">Switch to be a Certified PACE Professional</button>\n                    </div>\n                    <div ng-show=\"pcc.solicitorRequirements_Eligible !== true\">\n                        <hr />\n                        In order to switch to a Certified PACE Professional, you must first complete the following\n                        requirements:\n                    </div>\n                    <div class=\"unfulfilled-requirement-block\" ng-show=\"pcc.solicitorRequirements_HasTraining !== true\">\n                        <strong>PACE Pro Training:</strong> Incomplete<br />\n                        <button ng-click=\"pcc.GoToTraining('solicitor');\" class=\"btn btn-default his-button\">Go to Training</button>\n                    </div>\n                    <div class=\"unfulfilled-requirement-block\">\n                        <strong>Home Improvement Salesperson (HIS) registration number:</strong><br />\n                        <button class=\"btn btn-default his-button\" ng-show=\"pcc.solicitorRequirements_HasLicenseNumber !== true\" ng-click=\"pcc.openContractorUserLicenseRegistrationModal()\">Enter HIS number</button>\n                        <span ng-show=\"pcc.solicitorRequirements_HasLicenseNumber === true\">Completed ({{pcc.HISLicenseNumber}})</span>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 482 */
/***/ (function(module, exports) {

module.exports = "<div class=\"users-container\">\n    <ng-include src=\"'app/accounts/user/userTable.html'\" ng-if=\"!accounts.isEditingUser\"></ng-include>\n    <ng-include src=\"'app/accounts/user/myprofile.html'\" ng-if=\"accounts.isEditingUser\"></ng-include>\n</div>\n";

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports = "<div class=\"accounts-offices-content-container\" ng-controller=\"OfficesController as offices\">\n    <ng-include src=\"'app/accounts/offices/officesTable/officesTable.html'\" ng-if=\"!offices.isEditingOffice\"></ng-include>\n    <ng-include src=\"'app/accounts/offices/officeDetail.html'\" ng-if=\"offices.isEditingOffice\"></ng-include>\n</div>\n";

/***/ }),
/* 484 */
/***/ (function(module, exports) {

module.exports = "<div class=\"finance-content-container\"  ng-controller=\"FinancingController as financing\">\n    <div class=\"financing-header-container\">\n        <img src=\"src/assets/images/HEROPgm-Logo.png\" alt=\"HEROPro\"/>\n        <p class=\"pull-right\">To learn more about Renovate America premier dealer program, <a href=\"https://cdn.renovateamerica.com/contractor/RA-Premier-Dealer-One-Sheet.pdf\" target= \"_blank\">click here</a></P>\n    </div>\n\n    <ng-include src=\"'app/accounts/financing/financingTermSets.html'\"></ng-include>\n\n\n    <div ng-if=\"financing.isCompanyAdmin && financing.financingOptions.IsDirectPay === true\" class=\"financing-header-container\">\n        <h2>Direct Pay</h2>\n        <p>With Direct Pay, you eliminate upfront, out-of-pocket costs on material purchases.</p>\n    </div>\n\n    <div ng-if=\"financing.isCompanyAdmin && financing.financingOptions.IsProjectAdvance === true\" class=\"financing-header-container\">\n        <h2>Project Advance</h2>\n        <p>Project Advance allows you to eliminate working capital constraints and grow your business – with a portion of your HERO project amount paid up front</p>\n    </div>\n</div>\n\n";

/***/ }),
/* 485 */
/***/ (function(module, exports) {

module.exports = "<div class=\"accounts-licenses-content-container\" >\n    <ng-include src=\"'app/accounts/licenses/licensesTable/licensesTable.html'\"></ng-include>    \n</div>";

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _modal = __webpack_require__(487);

var _modal2 = _interopRequireDefault(_modal);

var _leadController = __webpack_require__(500);

var _leadController2 = _interopRequireDefault(_leadController);

var _leadFactory = __webpack_require__(504);

var _leadFactory2 = _interopRequireDefault(_leadFactory);

var _leadResultTextDirective = __webpack_require__(505);

var _leadResultTextDirective2 = _interopRequireDefault(_leadResultTextDirective);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.lead', [_modal2.default]).controller('LeadController', _leadController2.default).service('LeadFactory', _leadFactory2.default).directive("leadResultText", _leadResultTextDirective2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/lead/lead.html', __webpack_require__(506)); // eslint-disable-line global-require

    // results
    $templateCache.put('app/lead/results/duplicateResult.html', __webpack_require__(507)); // eslint-disable-line global-require
    $templateCache.put('app/lead/results/greenResult.html', __webpack_require__(508)); // eslint-disable-line global-require
    $templateCache.put('app/lead/results/leadMessage.html', __webpack_require__(509)); // eslint-disable-line global-require
    $templateCache.put('app/lead/results/modalActions.html', __webpack_require__(510)); // eslint-disable-line global-require
    $templateCache.put('app/lead/results/multipleAddressesResult.html', __webpack_require__(511)); // eslint-disable-line global-require
    $templateCache.put('app/lead/results/noliensResult.html', __webpack_require__(512)); // eslint-disable-line global-require
    $templateCache.put('app/lead/results/outOfBoundsResult.html', __webpack_require__(513)); // eslint-disable-line global-require
    $templateCache.put('app/lead/results/pageActions.html', __webpack_require__(514)); // eslint-disable-line global-require
    $templateCache.put('app/lead/results/propertyInformation.html', __webpack_require__(515)); // eslint-disable-line global-require
    $templateCache.put('app/lead/results/pvNotFoundResult.html', __webpack_require__(516)); // eslint-disable-line global-require
    $templateCache.put('app/lead/results/redResult.html', __webpack_require__(517)); // eslint-disable-line global-require
    $templateCache.put('app/lead/results/results.html', __webpack_require__(518)); // eslint-disable-line global-require
    $templateCache.put('app/lead/results/undeterminedResult.html', __webpack_require__(519)); // eslint-disable-line global-require
    $templateCache.put('app/lead/results/yellowResult.html', __webpack_require__(520)); // eslint-disable-line global-require

    // walkthrough
    $templateCache.put('app/lead/walkthrough/greenWalkthrough.html', __webpack_require__(521)); // eslint-disable-line global-require
    $templateCache.put('app/lead/walkthrough/leadWalkthroughs.html', __webpack_require__(522)); // eslint-disable-line global-require
    $templateCache.put('app/lead/walkthrough/noliensWalkthrough.html', __webpack_require__(523)); // eslint-disable-line global-require
    $templateCache.put('app/lead/walkthrough/pvNotFoundWalkthrough.html', __webpack_require__(524)); // eslint-disable-line global-require
    $templateCache.put('app/lead/walkthrough/redWalkthrough.html', __webpack_require__(525)); // eslint-disable-line global-require
    $templateCache.put('app/lead/walkthrough/walkthroughActions.html', __webpack_require__(526)); // eslint-disable-line global-require
    $templateCache.put('app/lead/walkthrough/yellowWalkthrough.html', __webpack_require__(527)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _KBYGModalController = __webpack_require__(488);

var _KBYGModalController2 = _interopRequireDefault(_KBYGModalController);

var _KBYGFactory = __webpack_require__(492);

var _KBYGFactory2 = _interopRequireDefault(_KBYGFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.lead.modal', []).controller('KBYGModalController', _KBYGModalController2.default).service('KBYGFactory', _KBYGFactory2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/lead/kbyg/modal/KBYGModalTemplate.html', __webpack_require__(493)); // eslint-disable-line global-require
    $templateCache.put('app/lead/kbyg/modal/KBYGBasicContentTemplate.html', __webpack_require__(494)); // eslint-disable-line global-require
    $templateCache.put('app/lead/kbyg/modal/address/KBYGAddressTemplate.html', __webpack_require__(495)); // eslint-disable-line global-require
    $templateCache.put('app/lead/kbyg/modal/addressBreakdown/KBYGAddressBreakdownTemplate.html', __webpack_require__(496)); // eslint-disable-line global-require
    $templateCache.put('app/lead/kbyg/modal/internalForm/KBYGInternalForm.html', __webpack_require__(497)); // eslint-disable-line global-require
    $templateCache.put('app/lead/kbyg/modal/zipcodeCheck/KBYGZipcodeCheckTemplate.html', __webpack_require__(498)); // eslint-disable-line global-require
    $templateCache.put('app/lead/kbyg/modal/basicForm/KBYGBasicFormTemplate.html', __webpack_require__(499)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = kbygModalController;

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(489);

__webpack_require__(490);

__webpack_require__(491);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

kbygModalController.$inject = ['KBYGFactory', 'UserData', 'raSpinnerService', '$uibModalInstance', '$analytics', 'ModalService', '$document', 'UserAuthFactory', 'HPRoles', 'CommonDataFactory', '$rootScope', '$timeout', 'PermissionsFactory']; // angular
// .module("HeroPRO")
// .controller("KBYGModalController", kbygModalController);

/* @ngInject */
function kbygModalController(KBYGFactory, UserData, raSpinnerService, $uibModalInstance, $analytics, ModalService, $document, UserAuthFactory, HPRoles, CommonDataFactory, $rootScope, $timeout, PermissionsFactory) {
    var vm = this;

    vm.kbygData = {};
    vm.kbygResponse = {};

    vm.organizations = [];
    // vm.originalOrganizations = [];
    vm.selectedOrganization = {};
    // vm.originalReps = [];
    vm.typeaheadReps = [];

    vm.selectedItem = '';
    vm.selectedSalesRep = { ContractorUserId: null }; // Adjusted from '' to prevent trying to read ContractorUserId off undefined object.
    vm.selectedLocation = {};
    vm.selectedCity = {};
    vm.selectedDirection = {};
    vm.selectedSuffix = '';
    vm.selectedState = {};
    vm.matchingAddress = null;
    vm.loadingText = 'Loading';
    vm.stateFilter = '';

    vm.selectedTypeaheadRep = '';
    vm.selectedOrg = '';

    vm.loading = true;
    vm.isMultipleAddresses = false;
    vm.isSmartyBreakdown = false;
    vm.isZipcodeLookup = false;
    vm.isZipCodeOutOfBounds = false;
    vm.hasResultsReturned = false;
    vm.isRaUser = false;
    vm.isEditingSalesRepLocation = false;
    vm.isSolicitor = PermissionsFactory.hasPermission('IsSolicitor');

    vm.editSalesRepLocation = function editSalesRepLocation() {
        vm.isEditingSalesRepLocation = !vm.isEditingSalesRepLocation;
    };

    vm.closeKBYGModal = function closeKBYGModal() {
        raSpinnerService._unregister('kbygSpinner'); // eslint-disable-line no-underscore-dangle
        ModalService.closeLgModal();
    };

    $uibModalInstance.result.then(function () {}, function () {
        ModalService.closeLgModal();
        raSpinnerService._unregister('kbygSpinner'); // eslint-disable-line no-underscore-dangle
    });

    vm.clickNext = function clickNext() {
        vm.isZipcodeLookup = true;
    };

    vm.openZipcodeCheck = function openZipcodeCheck() {
        vm.isZipcodeLookup = true;
        if (!!vm.kbygData && !!vm.kbygData.smartyAddress) {
            vm.kbygData.smartyAddress.zipcode = '';
        }
    };

    vm.cancelZipcodeCheck = function cancelZipcodeCheck() {
        vm.isZipcodeLookup = false;
        $timeout(function () {
            $rootScope.$broadcast('triggerShowInvalidAddressDropDown');
        });
    };

    vm.getCompany = function getCompany(val) {
        var params = {
            Name: val,
            PageSize: 10,
            Operator: 2
        };
        return KBYGFactory.getTypeaheadCompany(params).then(function (response) {
            vm.organizations = response.data.Data;
            if (response.data.Data) {
                return response.data.Data.map(function (item) {
                    return item.Name;
                });
            }

            return [];
        });
    };

    vm.getSalesRep = function getSalesRep(val) {
        if (!vm.selectedOrganization || !vm.selectedOrganization.OrganizationId) {
            return [];
        }
        var params = {
            SalesRepName: val || '',
            OrgId: vm.selectedOrganization.OrganizationId,
            PageSize: 10
        };
        return KBYGFactory.getTypeaheadSalesReps(params).then(function (response) {
            vm.typeaheadReps = response.data.Data;
            if (response.data.Data) {
                return response.data.Data.map(function (item) {
                    return item.FullName;
                });
            }

            return [];
        });
    };

    // Clears previously selected Org and set Selected Org for Sales Rep typeahead
    vm.onCompanySelect = function onCompanySelect() {
        vm.selectedOrganization = _lodash2.default.find(vm.organizations, function (origOrg) {
            return origOrg.Name === vm.selectedOrg;
        });
        vm.selectedTypeaheadRep = '';
    };

    // Sets Selected Sales Rep object to perform a lookup on Contractor User's available locations.
    vm.onSalesRepSelect = function onSalesRepSelect() {
        vm.selectedSalesRep = _lodash2.default.find(vm.typeaheadReps, function (origRep) {
            return origRep.FullName === vm.selectedTypeaheadRep;
        });

        var payload = {
            ContractorUserId: vm.selectedSalesRep.ContractorUserId,
            OrganizationId: vm.selectedOrganization.OrganizationId
        };
        KBYGFactory.getContractorLocations(payload).then(function (response) {
            vm.locations = response.data.Data;
            vm.selectedLocation = vm.locations[0];
        });
    };

    vm.typeClicked = function typeClicked(item) {
        if (item !== undefined) {
            vm.selectedItem = item;
        }
        $analytics.eventTrack('Change Property Type', { category: 'KBYG' });
    };

    vm.salesRepClicked = function salesRepClicked(item) {
        if (item !== undefined) {
            vm.selectedSalesRep = item;
        }
        $analytics.eventTrack('Change Sales Rep', { category: 'KBYG' });
    };

    vm.cityClicked = function cityClicked(item) {
        if (item !== undefined) {
            vm.selectedCity = item;
        }
        vm.kbygData.smartyAddress.city = vm.selectedCity.Name;
    };

    vm.directionClicked = function directionClicked(item) {
        if (item !== undefined) {
            vm.selectedDirection = item;
        }
        vm.kbygData.smartyAddress.addressData.street_predirection = vm.selectedDirection.value;
    };

    vm.suffixClicked = function suffixClicked(item) {
        if (item !== undefined) {
            vm.selectedSuffix = item;
        }
        vm.kbygData.smartyAddress.addressData.street_suffix = vm.selectedSuffix;
    };

    vm.stateClicked = function stateClicked(item) {
        if (item !== undefined) {
            vm.selectedState = item;
        }
        vm.kbygData.smartyAddress.state = vm.selectedState.StateAbbreviation;
    };

    vm.kbygSpinnerLoaded = function kbygSpinnerLoaded() {
        raSpinnerService.show('kbygSpinner');
    };

    vm.selectMatchingAddress = function selectMatchingAddress(address) {
        vm.matchingAddress = {
            MatchingAddress: address
        };
    };

    vm.processMatchingAddress = function processMatchingAddress() {
        vm.loadingText = 'Checking Address';
        vm.isMultipleAddresses = false;
        vm.submitKBYG(true);
    };

    function constructStreetAddress(addressData) {
        var number = addressData.primary_number !== undefined && addressData.primary_number !== null && addressData.primary_number.trim() !== '' ? addressData.primary_number.toString() : '';
        var direction = addressData.street_predirection !== undefined && addressData.street_predirection !== null && addressData.street_predirection.trim() !== '' ? addressData.street_predirection + ' ' : '';
        var name = addressData.street_name !== undefined && addressData.street_name !== null && addressData.street_name.trim() !== '' ? addressData.street_name : '';
        var suffix = addressData.street_suffix !== undefined && addressData.street_suffix !== null && addressData.street_suffix.trim() !== '' && addressData.street_suffix.trim() !== 'N/A' ? ' ' + addressData.street_suffix : '';
        return {
            StreetNumber: number, StreetPrefix: direction, Street: name, StreetSuffix: suffix
        };
    }

    function constructStreetAddressLine(addressData) {
        var number = addressData.primary_number !== undefined && addressData.primary_number !== null ? addressData.primary_number + ' ' : '';
        var predirection = addressData.street_predirection !== undefined && addressData.street_predirection !== null ? addressData.street_predirection + ' ' : '';
        var name = addressData.street_name !== undefined && addressData.street_name !== null ? addressData.street_name : '';
        var suffix = addressData.street_suffix !== undefined && addressData.street_suffix !== null && addressData.street_suffix.trim() !== 'N/A' ? ' ' + addressData.street_suffix : '';
        var postdirection = addressData.street_postdirection !== undefined && addressData.street_postdirection !== null ? ' ' + addressData.street_postdirection : '';
        return number + predirection + name + suffix + postdirection;
    }

    // Function to create single line address
    function constructAddressLine(smartyAddress) {
        var unitDesignator = vm.kbygData.smartyAddress.addressData.secondary_designator !== undefined && vm.kbygData.smartyAddress.addressData.secondary_designator !== null ? vm.kbygData.smartyAddress.addressData.secondary_designator + ' ' : '';
        var unitNumber = vm.kbygData.smartyAddress.addressData.secondary_number !== undefined && vm.kbygData.smartyAddress.addressData.secondary_number !== null ? vm.kbygData.smartyAddress.addressData.secondary_number.toString() : '';
        var city = smartyAddress.city;
        var state = smartyAddress.state;
        var zip = smartyAddress.zipcode !== undefined ? smartyAddress.zipcode : '';
        return constructStreetAddressLine(smartyAddress.addressData) + ' ' + unitDesignator + unitNumber + ' ' + city + ', ' + state + ' ' + zip;
    }

    function getActiveStates() {
        CommonDataFactory.getStates(true).then(function (response) {
            vm.stateFilter = _lodash2.default.pluck(response.data.Data, 'StateAbbreviation').join();
        });
    }

    function getLocations() {
        UserData.getKBYGLocations().then(function (response) {
            // console.log("response",response.length,response);
            // var locations = _.where(response, {'ContractorStatusId': 2});
            // console.log("locations",locations.length,locations);
            vm.locations = response;
        });
    }

    function getSalesReps() {
        UserAuthFactory.getAuthorization().then(function (authResponse) {
            var elevatedAccess = authResponse.HasElevatedAccess !== undefined && authResponse.HasElevatedAccess !== null && authResponse.HasElevatedAccess !== '' ? authResponse.HasElevatedAccess : false;
            var currentRole = _lodash2.default.find(HPRoles, function (key, role) {
                return role === authResponse.Roles[0];
            });
            vm.isRaUser = currentRole.Name === HPRoles.COPO_RAEMPLOYEE.Name;
            KBYGFactory.getSalesReps(vm.selectedLocation.ContractorId, !elevatedAccess).then(function (response) {
                vm.salesReps = response.data.Data;

                if (!vm.isRaUser) {
                    var currentSalesRep = _lodash2.default.find(vm.salesReps, function (rep) {
                        return rep.ContractorUserId === authResponse.ContractorUserId;
                    });

                    if (currentSalesRep !== undefined && currentSalesRep !== null) {
                        vm.selectedSalesRep = currentSalesRep;
                    } else {
                        vm.selectedSalesRep = vm.salesReps[0];
                    }
                }
                vm.loading = false;
            });
        });
    }

    vm.locationClicked = function locationClicked(item) {
        // Need to check for undefined since the native browser dropdowns used for small presentation
        // will not pass in an item when clicked but will set selectedLocation using ng-model instead.
        // The same is true for all kbyg modal dropdowns
        if (item !== undefined) {
            vm.selectedLocation = item;
        }
        $analytics.eventTrack('Change Location', { category: 'KBYG' });
        if (!vm.isRaUser) {
            getSalesReps();
        }
    };

    function getCurrentLocation() {
        UserData.getCurrentKBYGLocation().then(function (response) {
            vm.selectedLocation = response;
            getSalesReps();
        });
    }

    vm.enterNewAddressClicked = function enterNewAddressClicked() {
        vm.kbygData = {};
        if (!vm.isRaUser) {
            getCurrentLocation();
        }
        vm.selectedItem = vm.propertyTypes[0];
        vm.hasResultsReturned = false;
        vm.kbygResponse.Address = undefined;
        vm.kbygResponse.isZipCodeOutOfBounds = false;
        vm.isSmartyBreakdown = false;
        vm.isMultipleAddresses = false;

        vm.matchingAddress = null;
    };

    function getPropertyTypes() {
        KBYGFactory.getPropertyType().then(function (response) {
            vm.propertyTypes = response;
            vm.selectedItem = vm.propertyTypes[0];
        });
    }

    function getDirections() {
        KBYGFactory.getDirections().then(function (response) {
            vm.directions = response;
            vm.selectedDirection = vm.directions[0];
            vm.kbygData.smartyAddress.addressData.street_predirection = vm.selectedDirection.value;
        });
    }

    function getStreetSuffixes() {
        KBYGFactory.getStreetSuffixes().then(function (response) {
            vm.suffixes = response;
            vm.selectedSuffix = vm.suffixes[0];
            vm.kbygData.smartyAddress.addressData.street_suffix = vm.selectedSuffix;
        });
    }

    function getStatesForZipCode() {
        vm.states = [];
        _lodash2.default.each(vm.cities, function (city) {
            var state = _lodash2.default.find(vm.states, function (findState) {
                return findState.StateAbbreviation === city.StateGeo.StateAbbreviation;
            });

            if (!state) {
                var stateName = city.StateGeo.Name.toLowerCase();
                city.StateGeo.Name = stateName.charAt(0).toUpperCase() + stateName.slice(1);
                vm.states.push(city.StateGeo);
            }
        });

        vm.selectedState = vm.states[0];
        vm.kbygData.smartyAddress.state = vm.selectedState.StateAbbreviation;
    }

    function setKbygResponse(payload, kbygResponse) {
        kbygResponse.Address = {
            Address1: payload.PropertyStreet1,
            City: payload.PropertyCity,
            State: payload.PropertyState,
            ZIPCode: payload.PropertyZip
        };
        // Set Unit Number in KBYG Payload when an address is selected for Multiple Addresses.
        if (payload.MatchingAddress && payload.MatchingAddress.SITUS_UNIT_NUMBER) {
            kbygResponse.Address.Address2 = payload.MatchingAddress.SITUS_UNIT_NUMBER;
        } else {
            kbygResponse.Address.Address2 = payload.PropertyUnitNumber;
        }
        // if RA employee running for org, check for term sets
        if (!_lodash2.default.isEmpty(vm.selectedOrganization)) {
            kbygResponse.OrganizationId = vm.selectedOrganization.OrganizationId;
        }
        kbygResponse.Owner1FirstName = kbygResponse.Owner1FirstName === undefined || kbygResponse.Owner1FirstName === null || kbygResponse.Owner1FirstName === '' ? payload.PropertyOwnerFirstName : kbygResponse.Owner1FirstName;
        kbygResponse.Owner1LastName = kbygResponse.Owner1LastName === undefined || kbygResponse.Owner1LastName === null || kbygResponse.Owner1LastName === '' ? payload.PropertyOwnerLastName : kbygResponse.Owner1LastName;
        kbygResponse.AllOwner = kbygResponse.AllOwner === undefined || kbygResponse.AllOwner === null || kbygResponse.AllOwner === '' ? null : kbygResponse.AllOwner;
        kbygResponse.ApprovedAmount = kbygResponse.PreQualAmount === undefined || kbygResponse.PreQualAmount === '' || kbygResponse.PreQualAmount === null ? payload.ApprovedAmount : kbygResponse.PreQualAmount;

        vm.kbygResponse = kbygResponse;
        vm.hasResultsReturned = true;
    }

    function performKBYGLookup(payload) {
        if (vm.matchingAddress !== null) {
            // We are performing a kbyg lookup as a result of a selection from a multiple result list
            payload.MatchingAddress = vm.matchingAddress.MatchingAddress;
        }

        KBYGFactory.submit(payload).then(function (response) {
            var kbygResponse = response.data.Data;

            if (!_lodash2.default.isEmpty(kbygResponse) && kbygResponse.IsPropertyInBounds) {
                // Most common scenario. Green, Yellow or Red
                setKbygResponse(payload, kbygResponse);
                vm.isZipCodeOutOfBounds = false;
            } else if (!!kbygResponse.MatchingAddresses && kbygResponse.MatchingAddresses.length > 0) {
                // Multiple addresses were returned from the server
                vm.isMultipleAddresses = true;
                vm.hasResultsReturned = true;
                setKbygResponse(payload, kbygResponse);
            } else if (!kbygResponse.IsPropertyInBounds) {
                vm.kbygResponse.Address = {
                    Address1: payload.PropertyStreet1,
                    Address2: payload.PropertyUnitNumber,
                    City: payload.PropertyCity,
                    State: payload.PropertyState,
                    ZIPCode: payload.PropertyZip
                };
                // Add Out of bounds result
                vm.kbygResponse.PreQualResult = 'OutOfBounds';
                //  vm.kbygResponse.IsPropertyInBounds = false;
                vm.hasResultsReturned = true;
                vm.isZipcodeLookup = false;
                vm.isZipCodeOutOfBounds = true;
            } else {
                // Add Undetermined result
                setKbygResponse(payload, {});
                // Force to Undetermined result when data is empty or null
                vm.kbygResponse.ApprovedAmount = 0;
                vm.kbygResponse.CreatedDate = new Date();
                vm.kbygResponse.PreQualResult = 'Undetermined';
            }
            vm.loading = false;
        }, function () {
            vm.closeKBYGModal();
        });
    }

    vm.submitKBYG = function submitKBYG(isValid) {
        if (isValid) {
            vm.loadingText = 'Checking Address';
            vm.loading = true;

            var payload = {};

            if (vm.isSmartyBreakdown === true) {
                payload = {
                    ContractorLocationId: vm.selectedLocation.ContractorId,
                    ContractorUserId: vm.selectedSalesRep.ContractorUserId,
                    PropertyOwnerFirstName: vm.kbygData.poFirstName !== undefined ? vm.kbygData.poFirstName : '',
                    PropertyOwnerLastName: vm.kbygData.poLastName !== undefined ? vm.kbygData.poLastName : '',
                    PropertyStreet1: constructStreetAddressLine(vm.kbygData.smartyAddress.addressData),
                    PropertyStreetComposed: constructStreetAddress(vm.kbygData.smartyAddress.addressData),
                    PropertyUnitDesignator: vm.kbygData.smartyAddress.addressData.secondary_designator !== undefined && vm.kbygData.smartyAddress.addressData.secondary_designator !== null ? vm.kbygData.smartyAddress.addressData.secondary_designator : '',
                    PropertyUnitNumber: vm.kbygData.smartyAddress.addressData.secondary_number !== undefined && vm.kbygData.smartyAddress.addressData.secondary_number !== null ? vm.kbygData.smartyAddress.addressData.secondary_number.toString() : '',
                    PropertyCity: vm.kbygData.smartyAddress.city,
                    PropertyState: vm.kbygData.smartyAddress.state,
                    PropertyZip: vm.kbygData.smartyAddress.zipcode !== undefined ? vm.kbygData.smartyAddress.zipcode : '',
                    AddressRequiresValidation: true,
                    PropertyType: vm.selectedItem.id
                };
                // Add analytics when KBYG is submitted from Breakdown
                $analytics.eventTrack('Individual Address Fields', { category: 'KBYG', label: constructAddressLine(vm.kbygData.smartyAddress) });
            } else {
                payload = {
                    ContractorLocationId: vm.selectedLocation.ContractorId,
                    ContractorUserId: vm.selectedSalesRep.ContractorUserId,
                    PropertyOwnerFirstName: vm.kbygData.poFirstName !== undefined ? vm.kbygData.poFirstName : '',
                    PropertyOwnerLastName: vm.kbygData.poLastName !== undefined ? vm.kbygData.poLastName : '',
                    PropertyStreet1: constructStreetAddressLine(vm.kbygData.smartyAddress.addressData),
                    PropertyUnitDesignator: vm.kbygData.smartyAddress.addressData.secondary_designator !== undefined && vm.kbygData.smartyAddress.addressData.secondary_designator !== null ? vm.kbygData.smartyAddress.addressData.secondary_designator : '',
                    PropertyUnitNumber: vm.kbygData.smartyAddress.addressData.secondary_number !== undefined && vm.kbygData.smartyAddress.addressData.secondary_number !== null ? vm.kbygData.smartyAddress.addressData.secondary_number.toString() : '',
                    PropertyCity: vm.kbygData.smartyAddress.city,
                    PropertyState: vm.kbygData.smartyAddress.state,
                    PropertyZip: vm.kbygData.smartyAddress.zipcode !== undefined ? vm.kbygData.smartyAddress.zipcode : '',
                    IsAddressVerified: vm.kbygData.smartyAddress.isValid,
                    AddressRequiresValidation: vm.kbygData.smartyAddress.dpvMatchCode === 'D',
                    PropertyType: vm.selectedItem.id,
                    PropertyStreetComposed: constructStreetAddress(vm.kbygData.smartyAddress.addressData),
                    PropertyProfileData: {
                        Apn: vm.kbygData.smartyAddress.addressData.apn,
                        FipsCode: vm.kbygData.smartyAddress.addressData.fips_code
                    }
                };
            }
            $analytics.eventTrack('Submit KBYG', { category: 'KBYG' });
            performKBYGLookup(payload);
        } else {
            var invalidFields = _angular2.default.element($document[0].querySelectorAll('input.ng-invalid-required'));
            if (invalidFields.length > 0) {
                invalidFields[0].focus();
            }
        }
    };

    function performZipcodeLookup(data) {
        KBYGFactory.submitZipcode(data).then(function (response) {
            if (response.data.Data === undefined || response.data.Data === null) {
                vm.kbygResponse.PreQualID = -1;
                vm.kbygResponse.PreQualResult = 'OutOfBounds';
                vm.kbygResponse.isZipCodeOutOfBounds = true;
                vm.hasResultsReturned = true;
                vm.isZipcodeLookup = false;
                // vm.isZipCodeOutOfBounds = true;
            } else {
                vm.cities = response.data.Data;
                vm.selectedCity = vm.cities[0];
                vm.kbygData.smartyAddress.city = vm.selectedCity.Name;
                vm.isSmartyBreakdown = true;
                vm.isZipcodeLookup = false;
                getDirections();
                getStreetSuffixes();
                getStatesForZipCode();
                vm.kbygData.smartyAddress.addressData = {};
                vm.kbygData.smartyAddress.addressText = '';
            }
            vm.loading = false;
        }, function () {
            vm.closeKBYGModal();
        });
    }

    vm.submitZipcode = function submitZipcode(isValid) {
        if (isValid) {
            vm.loadingText = 'Checking Address';
            vm.loading = true;
            performZipcodeLookup({
                ZipCode: vm.kbygData.smartyAddress.zipcode.toString(),
                IncludeWebsiteDetails: false
            });
        }
    };

    function init() {
        vm.loading = true;
        getActiveStates();
        getCurrentLocation();
        getLocations();
        getPropertyTypes();
    }

    init();
}

/***/ }),
/* 489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = KBYGFactory;
KBYGFactory.$inject = ['HPConfig', '$http', '$q'];
// angular
//     .module("HeroPRO")
//     .factory("KBYGFactory", KBYGFactory);

/* @ngInject */
function KBYGFactory(HPConfig, $http, $q) {
    var propertyTypes = [{ id: 1, value: 'Single Family Home' }, { id: 2, value: 'Multi-family Home' }, { id: 3, value: 'Mobile Home' }, { id: 5, value: 'Town Home' }, { id: 6, value: 'Condominium' }];

    var directions = [{ text: 'N/A', value: '' }, { text: 'North', value: 'N' }, { text: 'South', value: 'S' }, { text: 'East', value: 'E' }, { text: 'West', value: 'W' }];

    var suffixes = ['N/A', 'AVE', 'BLV', 'CIR', 'CT', 'CTR', 'CYN', 'DR', 'EXY', 'HWY', 'LN', 'MNR', 'PKY', 'PL', 'RD', 'RT', 'SQ', 'ST', 'TER', 'TR', 'WAY'];

    //	var states = [
    //		{
    //			'Name': 'California',
    //			'Code': 'CA'
    //		}
    //	];

    return {
        getPropertyType: getPropertyType,
        getSalesReps: getSalesReps,
        getTypeaheadSalesReps: getTypeaheadSalesReps,
        getTypeaheadCompany: getTypeaheadCompany,
        getContractorLocations: getContractorLocations,
        getDirections: getDirections,
        getStreetSuffixes: getStreetSuffixes,
        submitZipcode: submitZipcode,
        submit: submit,
        getOneAppLink: getOneAppLink
    };

    function getPropertyType() {
        var deferred = $q.defer();
        deferred.resolve(propertyTypes);
        return deferred.promise;
    }

    function getSalesReps(contractorId, elevatedAccess) {
        return $http({
            url: HPConfig.heroProApi + 'ContractorUser',
            method: 'GET',
            params: {
                ContractorLocationIds: contractorId,
                FilterBySalesRep: elevatedAccess
            }
        });
    }

    function getTypeaheadSalesReps(payload) {
        return $http({
            url: HPConfig.heroProApi + 'ContractorUser/SearchByOrganization',
            method: 'GET',
            params: {
                Name: payload.SalesRepName,
                OrganizationId: payload.OrgId,
                PageSize: payload.PageSize
            }
        });
    }

    function getTypeaheadCompany(params) {
        return $http.get(HPConfig.heroProApi + 'Organization/SearchContractorOrganizations', {
            params: params
        });
    }

    function getContractorLocations(payload) {
        return $http({
            url: HPConfig.heroProApi + 'Contractor/Locations',
            method: 'GET',
            params: {
                ContractorUserId: payload.ContractorUserId,
                OrganizationId: payload.OrganizationId
            }
        });
    }

    function getDirections() {
        var deferred = $q.defer();
        deferred.resolve(directions);
        return deferred.promise;
    }

    function getStreetSuffixes() {
        var deferred = $q.defer();
        deferred.resolve(suffixes);
        return deferred.promise;
    }

    function submitZipcode(params) {
        return $http({
            url: HPConfig.heroProApi + 'Geo/Search',
            method: 'POST',
            data: params
        });
    }

    function submit(params) {
        return $http({
            url: HPConfig.heroProApi + 'KBYG/ContractorLead',
            method: 'POST',
            data: params
        });
    }

    function getOneAppLink(contractorLocationId) {
        var params = {
            "request.contractorLocationId": contractorLocationId,
            "request.getFinancingOptions": true
        };
        return $http.get(HPConfig.heroProApi + 'KBYG/OneAppUrl', {
            params: params
        });
    }
}

/***/ }),
/* 493 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <span class=\"icon icon-delete-circle\" ng-click=\"kbygModal.closeKBYGModal();\"></span>\n</div>\n\n<div class=\"modal-body\">\n\t<div class=\"hp-loading-spinner\" ra-spinner name=\"kbygSpinner\" hide-content-when-shown=\"true\" show=\"kbygModal.loading\" text=\"{{kbygModal.loadingText}}\"\n          register=\"false\">\n\n    \t<ng-include src=\"'app/lead/kbyg/modal/KBYGBasicContentTemplate.html'\" ng-if=\"!kbygModal.isZipcodeLookup && !kbygModal.isMultipleAddresses\"></ng-include>\n\n\t\t<ng-include src=\"'app/lead/results/multipleAddressesResult.html'\" ng-if=\"kbygModal.isMultipleAddresses === true\"></ng-include>\n\n    \t<ng-include src=\"'app/lead/kbyg/modal/zipcodeCheck/KBYGZipcodeCheckTemplate.html'\" ng-if=\"kbygModal.isZipcodeLookup\"></ng-include>\n\t</div>\n</div>\n";

/***/ }),
/* 494 */
/***/ (function(module, exports) {

module.exports = "<div class=\"kbyg-modal-title-container\">\n    <p class=\"modal-title\">Know Before You Go</p>\n</div>\n<div>\n\t<ng-include src=\"'app/lead/kbyg/modal/basicForm/KBYGBasicFormTemplate.html'\" ng-if=\"!kbygModal.hasResultsReturned && !kbygModal.kbygResponse.isZipCodeOutOfBounds && !kbygModal.isRaUser\">\n\t</ng-include>\n    <ng-include src=\"'app/lead/kbyg/modal/internalForm/KBYGInternalForm.html'\" ng-if=\"!kbygModal.hasResultsReturned && !kbygModal.kbygResponse.isZipCodeOutOfBounds && kbygModal.isRaUser\">\n    </ng-include>\n\n\t<div ng-if=\"kbygModal.hasResultsReturned\" ng-controller=\"LeadController as lead\">\n\t\t<ng-include src=\"'app/lead/results/results.html'\"></ng-include>\n\t    <div class=\"row lead-result\">\n\t        <div class=\"col-xs-12\">\n\t            <div class=\"row\">\n\t                <div class=\"col-xs-12\">\n\t                    <ng-include src=\"'app/lead/results/modalActions.html'\"></ng-include>\n\t                </div>\n\t            </div>\n\t        </div>\n\t    </div>\n\t</div>\n</div>\n";

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row kbyg-address\">\n  <div class=\"col-md-12\">\n    <smarty-streets-input smarty-model=\"kbygModal.kbygData.smartyAddress\" smarty-class=\"form-control kbyg-field\"\n                          smarty-id=\"txt-smarty-streets\" smarty-zipcode=\"kbygModal.openZipcodeCheck()\"\n                          smarty-name=\"smartyStreets\" smarty-placeholder=\"Address\"\n                          ng-cloak id=\"smarty-kbyg-address\" state-filter=\"kbygModal.stateFilter\">\n    </smarty-streets-input>\n    <p class=\"kbyg-error-message\" ng-show=\"kbygForm.smartyStreets.$error.required && kbygForm.$submitted\">Required</p>\n  </div>\n</div>\n";

/***/ }),
/* 496 */
/***/ (function(module, exports) {

module.exports = "<div class=\"kbyg-address-breakdown-container\">\n    <div class=\"row\">\n        <div class=\"col-md-2 row-left-end\">\n            <div class=\"kbyg-label-container\">\n                <label>Street Number </label>\n\n                <div class=\"required-indicator\">*</div>\n            </div>\n            <div>\n                <input id=\"txt-street-number\" name=\"txtStreetNumber\" class=\"form-control kbyg-field\" type=\"text\" required\n                       ng-model=\"kbygModal.kbygData.smartyAddress.addressData.primary_number\" autocomplete=\"off\"\n                       maxlength=\"10\"/>\n\n                <p class=\"kbyg-error-message\" ng-show=\"kbygForm.txtStreetNumber.$invalid && kbygForm.$submitted\">\n                    Required</p>\n            </div>\n        </div>\n        <div class=\"col-md-2\">\n            <div class=\"kbyg-label-container\">\n                <label>Direction </label>\n            </div>\n            <div>\n                <div>\n                    <div class=\"dropdown\" uib-dropdown dropdown-small-popup dropdown-title=\"Direction\"\n                         ng-if=\"$root.screenSize ==='large'\">\n                        <a id=\"ddl-direction\" blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle\n                           data-toggle=\"dropdown\">\n                            <span class=\"dropdown-text\">{{kbygModal.selectedDirection.text}}</span>\n                            <span class=\"icon\"></span>\n                        </a>\n                        <ul class=\"dropdown-menu address-breakdown-small\" uib-dropdown-menu>\n                            <li ng-repeat=\"direction in kbygModal.directions\"\n                                ng-class=\"{'active': kbygModal.selectedDirection.value === direction.value }\"\n                                ng-click=\"kbygModal.directionClicked(direction, $event)\">\n                                <span>{{direction.text}}</span>\n                            </li>\n                        </ul>\n                    </div>\n\n                    <select class=\"dropdown-native\" ng-if=\"$root.screenSize==='small'\"\n                            ng-model=\"kbygModal.selectedDirection\" ng-change=\"kbygModal.directionClicked()\"\n                            ng-options=\"direction as direction.text for direction in kbygModal.directions\"></select>\n                </div>\n            </div>\n        </div>\n        <div class=\"col-md-4\">\n            <div class=\"kbyg-label-container\">\n                <label>Street Name </label>\n\n                <div class=\"required-indicator\">*</div>\n            </div>\n            <div>\n                <input id=\"txt-street-name\" name=\"txtStreetName\" class=\"form-control kbyg-field\" type=\"text\" required\n                       ng-model=\"kbygModal.kbygData.smartyAddress.addressData.street_name\" autocomplete=\"off\"\n                       maxlength=\"30\">\n\n                <p class=\"kbyg-error-message\" ng-show=\"kbygForm.txtStreetName.$invalid && kbygForm.$submitted\">Required</p>\n            </div>\n        </div>\n        <div class=\"col-md-2\">\n            <div class=\"kbyg-label-container\">\n                <label>Suffix </label>\n            </div>\n            <div>\n                <div>\n                    <div class=\"dropdown\" uib-dropdown dropdown-small-popup dropdown-title=\"Suffix\"\n                         ng-if=\"$root.screenSize ==='large'\">\n                        <a id=\"ddl-suffix\" blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle\n                           data-toggle=\"dropdown\">\n                            <span class=\"dropdown-text\">{{kbygModal.selectedSuffix}}</span>\n                            <span class=\"icon\"></span>\n                        </a>\n                        <ul class=\"dropdown-menu address-breakdown-small\" uib-dropdown-menu>\n                            <li ng-repeat=\"suffix in kbygModal.suffixes\"\n                                ng-class=\"{'active': kbygModal.selectedSuffix === suffix }\"\n                                ng-click=\"kbygModal.suffixClicked(suffix, $event)\">\n                                <span>{{suffix}}</span>\n                            </li>\n                        </ul>\n                    </div>\n\n                    <select class=\"dropdown-native\" ng-if=\"$root.screenSize==='small'\" ng-model=\"kbygModal.selectedSuffix\"\n                            ng-change=\"kbygModal.suffixClicked()\"\n                            ng-options=\"suffix as suffix for suffix in kbygModal.suffixes\"></select>\n                </div>\n            </div>\n        </div>\n        <div class=\"col-md-2 row-right-end\">\n            <div class=\"kbyg-label-container\">\n                <label>Unit </label>\n            </div>\n            <div>\n                <input id=\"txt-unit\" class=\"form-control kbyg-field\" type=\"text\" maxlength=\"50\"\n                       ng-model=\"kbygModal.kbygData.smartyAddress.addressData.secondary_number\" autocomplete=\"off\"/>\n            </div>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-md-6 row-left-end\">\n            <div class=\"kbyg-label-container\">\n                <label>City </label>\n\n                <div class=\"required-indicator\">*</div>\n            </div>\n            <div>\n                <div>\n                    <div class=\"dropdown\" uib-dropdown dropdown-small-popup dropdown-title=\"City\"\n                         ng-if=\"$root.screenSize ==='large'\">\n                        <a id=\"ddl-city\" blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle\n                           data-toggle=\"dropdown\">\n                            <span class=\"dropdown-text\">{{kbygModal.selectedCity.Name}}</span>\n                            <span class=\"icon\"></span>\n                        </a>\n                        <ul class=\"dropdown-menu address-breakdown-small\" uib-dropdown-menu>\n                            <li ng-repeat=\"city in kbygModal.cities\"\n                                ng-class=\"{'active': kbygModal.selectedCity.GeoId === city.GeoId }\"\n                                ng-click=\"kbygModal.cityClicked(city, $event)\">\n                                <span>{{city.Name}}</span>\n                            </li>\n                        </ul>\n                    </div>\n\n                    <select class=\"dropdown-native\" ng-if=\"$root.screenSize==='small'\" ng-model=\"kbygModal.selectedCity\"\n                            ng-change=\"kbygModal.cityClicked()\"\n                            ng-options=\"city as city.Name for city in kbygModal.cities\"></select>\n                </div>\n            </div>\n        </div>\n        <div class=\"col-md-4\">\n            <div class=\"kbyg-label-container\">\n                <label>State </label>\n\n                <div class=\"required-indicator\">*</div>\n            </div>\n            <div>\n                <div>\n                    <div class=\"dropdown\" uib-dropdown dropdown-small-popup dropdown-title=\"State\"\n                         ng-if=\"$root.screenSize ==='large'\">\n                        <a id=\"ddl-state\" blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle\n                           data-toggle=\"dropdown\">\n                            <span class=\"dropdown-text\">{{kbygModal.selectedState.Name}}</span>\n                            <span class=\"icon\"></span>\n                        </a>\n                        <ul class=\"dropdown-menu\" uib-dropdown-menu>\n                            <li ng-repeat=\"state in kbygModal.states\"\n                                ng-class=\"{'active': kbygModal.selectedState.Name === state.Name }\"\n                                ng-click=\"kbygModal.directionClicked(state, $event)\">\n                                <span>{{state.Name}}</span>\n                            </li>\n                        </ul>\n                    </div>\n\n                    <select class=\"dropdown-native\" ng-if=\"$root.screenSize==='small'\" ng-model=\"kbygModal.selectedState\"\n                            ng-change=\"kbygModal.stateClicked()\"\n                            ng-options=\"state as state.Name for state in kbygModal.states\"></select>\n                </div>\n            </div>\n        </div>\n        <div class=\"col-md-2 row-right-end\">\n            <div class=\"kbyg-label-container\">\n                <label>Zipcode </label>\n            </div>\n            <div>\n                <input id=\"txt-zipcode\" name=\"txtZipcode\" class=\"form-control kbyg-field\" type=\"text\" ng-disabled=\"true\"\n                       ng-model=\"kbygModal.kbygData.smartyAddress.zipcode\"/>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 497 */
/***/ (function(module, exports) {

module.exports = "<form id=\"kbyg-form\" name=\"kbygForm\" class=\"kbyg-form\" ng-submit=\"kbygModal.submitKBYG(kbygForm.$valid)\" novalidate>\n    <div class=\"row\">\n        <div class=\"col-md-12 kbyg-preview\">\n            <span class=\"preview-title\">Preview eligible finance options</span>\n        </div>\n    </div>    \n    <div class=\"row kbyg-internal\">\n        <div class=\"col-md-12\">\n            <div class=\"kbyg-typeahead\">\n                <input id=\"txt-company\" name=\"txtCompany\" class=\"form-control kbyg-field\" type=\"text\" ng-model=\"kbygModal.selectedOrg\" autocomplete=\"off\" ng-required=\"true\"\n                       placeholder=\"Company\" uib-typeahead=\"organization for organization in kbygModal.getCompany($viewValue)\" typeahead-on-select=\"kbygModal.onCompanySelect($event)\">\n                <p class=\"kbyg-error-message\" ng-show=\"kbygForm.txtCompany.$invalid && kbygForm.$submitted\">Required</p>\n            </div>\n        </div>\n\n    </div>\n    <div class=\"row kbyg-internal\">\n        <div class=\"col-md-6\">\n            <div class=\"kbyg-typeahead\">\n                <input id=\"txt-sales-rep-name\" name=\"txtSalesRepName\" class=\"form-control kbyg-field\" type=\"text\" ng-required=\"true\"\n                       maxlength=\"60\" autocomplete=\"off\" ng-model=\"kbygModal.selectedTypeaheadRep\" placeholder=\"Sales Rep\"\n                       uib-typeahead=\"salesRep for salesRep in kbygModal.getSalesRep($viewValue)\"\n                       typeahead-on-select=\"kbygModal.onSalesRepSelect($event)\"/>\n                <p class=\"kbyg-error-message\" ng-show=\"kbygForm.txtSalesRepName.$invalid && kbygForm.$submitted\">Required</p>\n            </div>\n        </div>\n        <div class=\"col-md-6\">\n            <div class=\"dropdown\" uib-dropdown dropdown-title=\"Location\" ng-if=\"$root.screenSize ==='large'\">\n                <a id=\"ddl-location\" blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle\n                   data-toggle=\"dropdown\">\n                    <span class=\"dropdown-text\">{{kbygModal.selectedLocation.LocationNickname}}</span>\n                    <span class=\"icon\"></span>\n                </a>\n                <ul class=\"dropdown-menu\" uib-dropdown-menu>\n                    <li ng-repeat=\"location in kbygModal.locations\"\n                        ng-class=\"{'active': kbygModal.selectedLocation.LocationNickname === location.LocationNickname }\"\n                        ng-click=\"kbygModal.locationClicked(location, $event)\">\n                        <span>{{location.LocationNickname}}</span>\n                    </li>\n                </ul>\n            </div>\n\n            <select class=\"dropdown-native\" ng-if=\"$root.screenSize==='small'\" ng-model=\"kbygModal.selectedLocation\"\n                    ng-change=\"kbygModal.locationClicked()\"\n                    ng-options=\"location as location.LocationNickname for location in kbygModal.locations track by location.ContractorId\"></select>\n        </div>\n    </div>\n    <ng-include src=\"'app/lead/kbyg/modal/address/KBYGAddressTemplate.html'\"\n                ng-if=\"!kbygModal.isSmartyBreakdown\"></ng-include>\n    <ng-include src=\"'app/lead/kbyg/modal/addressBreakdown/KBYGAddressBreakdownTemplate.html'\"\n                ng-if=\"kbygModal.isSmartyBreakdown\"></ng-include>\n    <div class=\"row\">\n        <div class=\"col-md-4 next-button-centered-container\">\n            <button class=\"btn btn-primary\" id=\"btn-kbyg-submit\">Next</button>\n        </div>\n    </div>\n</form>\n\n";

/***/ }),
/* 498 */
/***/ (function(module, exports) {

module.exports = "<div class=\"col-md-12 zipcode-modal-container\">\n    <div class=\"modal-title-container\">\n        <p class=\"modal-title\">What's the ZIP code of the address you'd like to check?</p>\n    </div>\n\n    <form id=\"kbygZipcodeForm\" name=\"kbygZipcodeForm\" ng-submit=\"kbygModal.submitZipcode(kbygZipcodeForm.$valid)\"\n          novalidate>\n        <div class=\"kbyg-zipcode-form-container\">\n            <div class=\"zipcode-field-container\">\n                <input id=\"txt-zipcode\" name=\"txtZipcode\" type=\"text\" class=\"kbyg-field\"\n                       placeholder=\"Enter a ZIP code\" ng-model=\"kbygModal.kbygData.smartyAddress.zipcode\"\n                       maxlength=\"5\" required autocomplete=\"off\" hp-numeric-only ng-minlength=\"5\"/>\n\n                <p class=\"kbyg-error-message zipcode-error\"\n                   ng-show=\"kbygZipcodeForm.txtZipcode.$error.required && kbygZipcodeForm.$submitted\">Required</p>\n                <p class=\"kbyg-error-message zipcode-error\"\n                   ng-show=\"kbygZipcodeForm.txtZipcode.$error.minlength && kbygZipcodeForm.$submitted\">Zipcode must be 5 digits</p>\n            </div>\n            <div class=\"zipcode-check-button-container\">\n                <button type=\"submit\" class=\"btn btn-primary\">Check</button>\n                <button class=\"btn btn-default\" ng-click=\"kbygModal.cancelZipcodeCheck()\">Cancel</button>\n            </div>\n        </div>\n    </form>\n</div>\n";

/***/ }),
/* 499 */
/***/ (function(module, exports) {

module.exports = "<form id=\"kbyg-form\" name=\"kbygForm\" class=\"kbyg-form\" ng-submit=\"kbygModal.submitKBYG(kbygForm.$valid)\" novalidate>\n    <div class=\"row\">\n        <div class=\"col-md-12 kbyg-preview\">\n            <span class=\"preview-title\">Preview eligible finance options</span>\n            <div ng-show=\"!kbygModal.isEditingSalesRepLocation\">\n                <span class=\"kbyg-edit\" ng-click=\"kbygModal.editSalesRepLocation()\">Edit</span>\n                <span class=\"kbyg-sales-rep-location\">This will be automatically assigned to <b>{{kbygModal.selectedSalesRep.FirstName}} {{kbygModal.selectedSalesRep.LastName}}</b> in the <b>{{kbygModal.selectedLocation.LocationNickname}}</b> office</span>\n            </div>\n        </div>\n    </div>\n    <div class=\"row kbyg-editing\" ng-show=\"kbygModal.isEditingSalesRepLocation\">\n        <div class=\"col-md-12 kbyg-editing-title\">\n            <span>Assign this prospect to a sales rep and location.</span>\n        </div>\n        <div class=\"col-md-6 kbyg-editing-field\">\n            <div class=\"kbyg-label-container\">\n                <label>Sales Rep Name </label>\n            </div>\n\n            <div class=\"dropdown\" uib-dropdown dropdown-title=\"Sales Rep Name\" ng-if=\"$root.screenSize ==='large'\">\n                <a id=\"ddl-sales-rep\" blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle\n                   data-toggle=\"dropdown\">\n                    <span class=\"dropdown-text\">{{kbygModal.selectedSalesRep.FirstName}} {{kbygModal.selectedSalesRep.LastName}}</span>\n                    <span class=\"icon\"></span>\n                </a>\n                <ul class=\"dropdown-menu\" uib-dropdown-menu>\n                    <li ng-repeat=\"salesRep in kbygModal.salesReps\"\n                        ng-class=\"{'active': kbygModal.selectedSalesRep === salesRep }\"\n                        ng-click=\"kbygModal.salesRepClicked(salesRep, $event)\">\n                        <span>{{salesRep.FirstName}} {{salesRep.LastName}}</span>\n                    </li>\n                </ul>\n            </div>\n\n            <select class=\"dropdown-native\" ng-if=\"$root.screenSize==='small'\" ng-model=\"kbygModal.selectedSalesRep\"\n                    ng-change=\"kbygModal.salesRepClicked()\"\n                    ng-options=\"salesRep as salesRep.FirstName + ' ' + salesRep.LastName for salesRep in kbygModal.salesReps\"></select>\n\n        </div>\n        <div class=\"col-md-6 kbyg-editing-field\">\n            <div class=\"kbyg-label-container\">\n                <label>Location </label>\n            </div>\n            <div class=\"dropdown\" uib-dropdown dropdown-title=\"Location\" ng-if=\"$root.screenSize ==='large'\">\n                <a id=\"ddl-location\" blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle\n                   data-toggle=\"dropdown\">\n                    <span class=\"dropdown-text\">{{kbygModal.selectedLocation.LocationNickname}}</span>\n                    <span class=\"icon\"></span>\n                </a>\n                <ul class=\"dropdown-menu\" uib-dropdown-menu>\n                    <li ng-repeat=\"location in kbygModal.locations\"\n                        ng-class=\"{'active': kbygModal.selectedLocation.LocationNickname === location.LocationNickname }\"\n                        ng-click=\"kbygModal.locationClicked(location, $event)\">\n                        <span>{{location.LocationNickname}}</span>\n                    </li>\n                </ul>\n            </div>\n\n            <select class=\"dropdown-native\" ng-if=\"$root.screenSize==='small'\" ng-model=\"kbygModal.selectedLocation\"\n                    ng-change=\"kbygModal.locationClicked()\"\n                    ng-options=\"location as location.LocationNickname for location in kbygModal.locations track by location.ContractorId\"></select>\n        </div>\n    </div>\n\n    <ng-include src=\"'app/lead/kbyg/modal/address/KBYGAddressTemplate.html'\"\n                ng-if=\"!kbygModal.isSmartyBreakdown\"></ng-include>\n    <ng-include src=\"'app/lead/kbyg/modal/addressBreakdown/KBYGAddressBreakdownTemplate.html'\"\n                ng-if=\"kbygModal.isSmartyBreakdown\"></ng-include>\n\n    <div class=\"row\" ng-if=\"!kbygModal.isSmartyBreakdown\">\n        <div class=\"col-md-4 next-button-centered-container\">\n            <button class=\"btn btn-primary\" id=\"btn-kbyg-submit\">Next</button>\n        </div>\n    </div>\n    <div ng-if=\"kbygModal.isSmartyBreakdown\">\n        <div class=\"row\">\n            <div class=\"col-md-3 next-button-container\">\n                <button class=\"btn btn-primary\" id=\"btn-kbyg-submit\">Next</button>\n            </div>\n            <div class=\"col-md-3 zip-button-container\">\n                <button type=\"button\" class=\"btn btn-default\" id=\"btn-change-zip\" ng-click=\"kbygModal.openZipcodeCheck()\">Change Zip Code</button>\n            </div>\n        </div>\n        <div class=\"row new-address-modal\">\n            <div class=\"col-xs-12\">\n                <div class=\"text-center\">\n                    <p ng-click=\"kbygModal.enterNewAddressClicked()\"><span class=\"icon icon-reload\"></span>Enter New\n                        Address\n                    </p>\n                </div>\n            </div>\n        </div>\n    </div>\n</form>\n";

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = leadController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(501);

__webpack_require__(502);

__webpack_require__(503);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

leadController.$inject = ['LeadFactory', '$stateParams', '$window', 'HPConfig', '$scope', 'ModalService', '$analytics', 'UserData', 'HPGeoStates', '$timeout', 'UiDisplayFactory', 'PartnerAppsFactory', 'PermissionsFactory']; // angular
// 	.module("HeroPRO")
// 	.controller("LeadController", leadController);

/* @ngInject */
function leadController(LeadFactory, $stateParams, $window, HPConfig, $scope, ModalService, $analytics, UserData, HPGeoStates, $timeout, UiDisplayFactory, PartnerAppsFactory, PermissionsFactory) {
    var vm = this;
    var prequalId = void 0;

    vm.isFullPrequal = false;
    vm.isOpen = true;
    vm.leadData = {};
    vm.showLeadMessage = false;
    vm.leadMessage = {};
    vm.kbygModalOpen = false;
    vm.leadResult = '';
    vm.primaryInformationLoading = true;
    vm.primaryInformationSticky = false;
    vm.loading = false;
    vm.displayActions = true;
    vm.proposalPlusEnabled = false;
    vm.isSolicitor = PermissionsFactory.hasPermission('IsSolicitor');

    vm.stages = [];

    init(vm.proposalPlusEnabled = PermissionsFactory.hasPermission('ProposalPlus.Enabled'));

    $scope.$watch(function () {
        if ($scope.kbygModal !== undefined) {
            return $scope.kbygModal.kbygResponse;
        }
    }, function () {
        init();
    });

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.scrollPointTriggered = function (distance, element, edge) {
        vm.primaryInformationSticky = edge !== undefined;
        // Need to force a digest here so that the $observe in primaryInformationDirective is triggered
        $scope.$digest();
    };

    vm.participatingCitiesClick = function () {
        $window.location.href = HPConfig.renovateLink + 'communities';
    };

    vm.proPitchClick = function (params) {
        var label = vm.kbygModalOpen === true ? 'KBYG' : 'Leads';
        if (vm.proposalPlusEnabled === true) {
            $analytics.eventTrack('Proposal Plus Open', { category: params.source, label: label });
            $window.open(PartnerAppsFactory.getProPitchLink(), '_blank');
        } else {
            $analytics.eventTrack('Financing Tab Open');
            $window.location.href = '/accounts/financing/';
            // $analytics.eventTrack('Calculator Open', { category: params.source, label });
            // $window.open(PartnerAppsFactory.getHeroCalcLink(), '_blank');
        }
    };

    vm.applyNowClick = function (params) {
        if (vm.isFullPrequal) {
            var input = btoa(vm.leadData.RAApplicationID + '|' + vm.leadData.AllOwners);
            $window.open(HPConfig.applyLink + 'application-results/' + input, '_blank');
        } else {
            // Click handler for the 'Get Approved' button
            var label = vm.kbygModalOpen === true ? 'KBYG' : 'Leads';
            $analytics.eventTrack('Get Approved Click', { category: params.source, label: label });
            $window.open(vm.leadData.ApplicationLink, '_blank');
        }
    };

    vm.submitAnApplicationClick = function () {
        // Click handler for the 'submit an application' text link in the next steps section of kbyg results
        var category = vm.kbygModalOpen === true ? 'Modal: Next Steps' : 'Module: Next Steps';
        var label = vm.kbygModalOpen === true ? 'KBYG' : 'Leads';
        $analytics.eventTrack('Submit an application', { category: category, label: label });
        $window.location.href = vm.leadData.ApplicationLink;
    };

    vm.checkPropertyOwner = function () {
        return vm.leadData.Owner1LastName !== null || vm.leadData.Owner1LastName !== undefined || vm.leadData.Owner1FirstName !== null || vm.leadData.Owner1FirstName !== undefined || vm.leadData.AllOwners !== null || vm.leadData.AllOwners !== undefined;
    };

    vm.displayNoPropertyOwnerMessage = function () {
        return !vm.leadData.Owner1LastName && !vm.leadData.Owner1FirstName && !vm.leadData.AllOwners;
    };

    vm.displayPropertyOwnerCounty = function () {
        if (vm.leadData.Owner1LastName === null || vm.leadData.Owner1LastName === undefined || vm.leadData.Owner1LastName === '') {
            return true;
        }
        return false;
    };

    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */

    function init() {
        trackKbygModal();

        if (vm.kbygModalOpen === false) {
            prequalId = $stateParams.prequalId;
        } else {
            prequalId = $scope.kbygModal.kbygResponse.PreQualID;
        }

        if (prequalId === undefined) {
            // This may happen for some kbyg results
            vm.leadData = $scope.kbygModal.kbygResponse;
            setLeadResult();
        } else if ($scope.kbygModal === null || $scope.kbygModal === undefined) {
            vm.loading = true;
            LeadFactory.getLeadData(prequalId).then(function (leadData) {
                vm.leadData = leadData;
                setLeadResult();
                vm.loading = false;
            });
        } else {
            vm.leadData = $scope.kbygModal.kbygResponse;
            setLeadResult();
        }

        // TODO: Remove after refactoring system to load rules on page refresh.
        UserData.getUserData().then(function (response) {
            if (response.IsSuspendedCompliance === true) {
                UiDisplayFactory.setDisplayRule('suspendedCompliance', response.IsSuspendedCompliance);
                vm.displayActions = false;
            }
        });
    }

    function trackKbygModal() {
        var kbygModal = ModalService.getLgModal();
        if (kbygModal !== undefined && kbygModal !== null) {
            vm.kbygModalOpen = true;
        } else {
            vm.kbygModalOpen = false;
        }
    }

    function setLeadResult() {
        var result = '',
            enteredAddress = '';

        vm.isFullPrequal = !!vm.leadData.RAApplicationID;

        if (vm.isFullPrequal) {
            switch (vm.leadData.PrequalResultDecisionTypeID) {
                case 1:
                case 2:
                    result = 'Green';break;
                case 0:
                case 3:
                    result = 'Yellow';break;
                case 4:
                    result = 'Red';break;
                default:
                    result = 'Undetermined';break;
            }
        } else if (!!vm.leadData.PreQualResult && typeof vm.leadData.PreQualResult === 'string') {
            // Perform a case insensitive check
            switch (vm.leadData.PreQualResult.toLowerCase()) {
                case 'pass':
                    result = 'Green';
                    break;
                case 'borderline':
                case 'maybe':
                case 'passconditionally':
                    result = 'Yellow';
                    break;
                case 'maybenoliens':
                    result = 'MaybeNoLiens';
                    break;
                case 'fail':
                    result = 'Red';
                    break;
                case 'outofbounds':
                    result = 'OutOfBounds';
                    break;
                case 'duplicate':
                    result = 'Duplicate';
                    break;
                case 'pvnotfound':
                    result = 'PVNotFound';
                    break;
                default:
                    result = 'Undetermined';
                    break;
            }
        }

        if (vm.leadData.Address) {
            // (ajt 4/15/2016) - Added GA for KBYG Results
            if (vm.kbygModalOpen === true && !vm.leadData.isZipCodeOutOfBounds) {
                enteredAddress = vm.leadData.Address.Address1 + ' ' + (vm.leadData.Address.Address2 ? vm.leadData.Address.Address2 + ' ' : '') + vm.leadData.Address.City + ' ' + vm.leadData.Address.State + ' ' + vm.leadData.Address.ZIPCode;
                $analytics.eventTrack(result, { category: 'KBYG', label: enteredAddress });
            }
        }

        vm.leadResult = result;
        vm.primaryInformationLoading = false;
        LeadFactory.getLeadMessages(prequalId, vm.leadData.OrganizationId).then(function (message) {
            if (message !== undefined && message !== null) {
                vm.showLeadMessage = message.show;
                vm.leadMessage = message;
            }
        });
    }
}

/***/ }),
/* 501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 502 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = leadFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

leadFactory.$inject = ['$http', 'HPConfig', '$q', 'UserData', 'HPAppDetailTypes']; // angular
//     .module('HeroPRO')
//     .factory("LeadFactory", leadFactory);

/* @ngInject */
function leadFactory($http, HPConfig, $q, UserData, HPAppDetailTypes) {
    var leadData = {};

    return {
        getLeadData: getLeadData,
        setLeadData: setLeadData,
        getLeadMessages: getLeadMessages
    };

    function setLeadData(newLeadData) {
        leadData[newLeadData.PreQualID] = newLeadData;
    }

    function getLeadData(prequalId) {
        if (_lodash2.default.has(leadData, prequalId)) {
            // Prequal is in the cache and the data is complete
            var deferred = $q.defer();
            deferred.resolve(leadData[prequalId]);
            return deferred.promise;
        }
        // Prequal is not in the cache
        return $q(function (resolve) {
            requestLeadData(prequalId).then(function (response) {
                setLeadData(response.data.Data);
                resolve(leadData[prequalId]);
            });
        });
    }

    function getLeadMessages(prequalId, organizationId) {
        return $q(function (resolve) {
            var message = {
                show: false,
                header: '',
                text: ''
            };

            // prequalId comes through as string for lead detail
            if (!_lodash2.default.isEmpty(prequalId) && _lodash2.default.isString(prequalId)) {
                prequalId = parseInt(prequalId);
            }
            // if somehow there is no prequalId don't show any messaging
            if (!_lodash2.default.isNumber(prequalId) || prequalId < 1) {
                resolve(message);
            } else {
                getOrgTermSets(organizationId).then(function (orgTermSets) {
                    checkForMatterhorn(prequalId, orgTermSets, message).then(function (response) {
                        // resolve(response); // response is message returned
                        resolve(); // just resolve with the false message for now
                    });
                });
            }
        });
    }

    function checkForMatterhorn(prequalId, orgTermSets, message) {
        return $q(function (resolve) {
            getLeadData(prequalId).then(function (leadDataResponse) {
                // Check if the organization has a buydown rate
                var buydownTermSets = _lodash2.default.findWhere(orgTermSets, {
                    TermSetTypeId: HPAppDetailTypes.TermSetTypes.BuyDown
                });
                if (buydownTermSets !== undefined) {
                    // Check if the property address belongs to a program that has mattherhorn term set rates
                    if (_lodash2.default.findWhere(orgTermSets, {
                        ProgramId: leadDataResponse.ProgramId
                    }) !== undefined) {
                        setMatterhornMessage(message);
                    } else {
                        setNonMatterhorn(message);
                    }
                }
                resolve(message);
            });
        });
    }

    function setNonMatterhorn(message) {
        message.header = 'Standard HERO rates apply on this home.';
        message.text = 'For rate details, contact your account manager.';
        message.class = 'lead-message warn';
        message.show = true;
    }

    function setMatterhornMessage(message) {
        message.header = 'Good News! Promotional rates apply on this home.';
        message.text = 'For rate details, contact your account manager.';
        message.class = 'lead-message good';
        message.show = true;
    }

    // ////////
    // private functions
    // ////////

    function getOrgTermSets(orgId) {
        return $q(function (resolve) {
            if (_lodash2.default.isNumber(orgId)) {
                // RA Employee is running KBYG for a CO, get CO Org TermSets
                $http({
                    url: HPConfig.heroProApi + 'Organization/TermSets',
                    method: 'GET',
                    params: {
                        organizationId: orgId
                    }
                }).then(function (response) {
                    resolve(response.data.Data);
                });
            } else {
                // CO is running a KBYG, get their term sets
                UserData.getCurrentLocation().then(function (locationDataResponse) {
                    resolve(locationDataResponse.OrganizationTermSets);
                });
            }
        });
    }

    function requestLeadData(prequalId) {
        return $http({
            url: HPConfig.heroProApi + 'KBYG',
            method: 'GET',
            cache: true,
            params: {
                PreQualId: prequalId
            }
        });
    }
}

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = LeadResultTextDirective;
// .directive('hpOverlay',

function LeadResultTextDirective() {
    return {
        restrict: 'E',
        scope: {
            lead: '=',
            nonPrequalText: '@'
        },
        link: function link(scope, elem, attr) {
            if (!!scope.lead.leadData) {
                scope.PrequalResultDecisionTypeID = scope.lead.leadData.PrequalResultDecisionTypeID;
            } else {
                scope.PrequalResultDecisionTypeID = scope.lead.PrequalResultDecisionTypeID;
            }
        },

        template: '\n        <div>\n            <p class="result-summary" ng-if="lead.isFullPrequal && (PrequalResultDecisionTypeID == 1 || PrequalResultDecisionTypeID == 2)">Excellent news! It looks like this homeowner can qualify for HERO. We may only need income information in order to get this homeowner approved. </p>\n            <p class="result-summary" ng-if="lead.isFullPrequal && (PrequalResultDecisionTypeID == 0 || PrequalResultDecisionTypeID == 3)"> Great news! It looks like this homeowner may qualify for HERO. We may need additional information about the homeowner and their home.</p>\n            <p class="result-summary" ng-if="lead.isFullPrequal && (PrequalResultDecisionTypeID == 4 || PrequalResultDecisionTypeID == 5)">This homeowner is in a HERO approved area. We will need additional information about the homeowner and their home during the application process.</p>\n            <p class="result-summary" ng-if="!lead.isFullPrequal"> {{nonPrequalText}} </p>\n        </div>\n        '
    };
}

/***/ }),
/* 506 */
/***/ (function(module, exports) {

module.exports = "<div class=\"lead-detail\">\n    <primary-information pi-information-type=\"lead\" pi-set-fixed-height=\"{{lead.primaryInformationSticky}}\"\n                         ui-scrollpoint ui-scrollpoint-enabled=\"{{lead.primaryInformationLoading === false}}\"\n                         ui-scrollpoint-action=\"lead.scrollPointTriggered\">\n    </primary-information>\n    <hp-pipeline-stage-indicator stage=\"1\"></hp-pipeline-stage-indicator>\n    <div class=\"app-detail-content\">\n        <div ng-controller=\"LeadController as lead\">\n            <ng-include src=\"'app/lead/walkthrough/leadWalkthroughs.html'\"></ng-include>\n            <div class=\"lead-detail-loading hp-loading-template\" ra-spinner name=\"leadDetailSpinner\"\n                 hide-content-when-shown=\"true\" show=\"lead.loading\" register=\"false\"\n                 template=\"indeterminateSpinner\">\n                <div class=\"lead-result-detail\" ng-class=\"{'no-walkthrough' : lead.leadResult === 'Duplicate' }\">\n                    <ng-include src=\"'app/lead/results/results.html'\"></ng-include>\n                    <ng-include src=\"'app/lead/results/pageActions.html'\"></ng-include>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 507 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row lead-result\">\n\t<div class=\"col-md-12 duplicate-result\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-12\">\n\t\t\t\t<div class=\"row\">\n\t\t\t\t\t<div class=\"col-md-2 col-xs-12 exclamation-container\">\n\t\t\t\t\t\t<h2 class=\"result-exclamation icon icon-exclamation\"></h2>\n\t\t\t\t\t</div>\n                    <div class=\"duplicate-details col-md-10\">\n                        <div class=\"duplicate-details-label-container\" ng-class=\"{'modal-details' : lead.kbygModalOpen === true}\">\n                        \t<p class=\"duplicate-label\">A HERO Application has Already Been Received</p>\n                        </div>\n                        <div class=\"pro-tip-lead\" ng-if=\"lead.kbygModalOpen === false\">\n                            <div class=\"pro-tip-lead-icon\">\n                                <span class=\"icon icon-tip\"></span>\n                                <span>Pro Tip</span>\n                            </div>\n                            <div class=\"pro-tip-lead-content\">\n                                <p>The Know-Before-You Go result lets you know the chances that a property owner will\n                                    qualify for HERO. Review this before visiting or calling the property owner.</p>\n                            </div>\n                        </div>\n                    </div>\n\t\t\t\t</div>\n\t\t\t\t<ng-include ng-class=\"lead.kbygModalOpen ? 'duplicate-property-owner' : ''\" src=\"'app/lead/results/propertyInformation.html'\"></ng-include>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n";

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row lead-result\">\n    <div class=\"col-md-12 green-result\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"row\">\n                    <div class=\"col-md-2 col-xs-12 result-percent-container\">\n                        <h2 class=\"result-percentage\"></h2>\n                    </div>\n                    <div class=\"col-md-10 col-xs-12 result-text-container\" >\n                        <lead-result-text lead=\"lead\" non-prequal-text=\"Good News! This home is in a HERO approved territory and passes the home equity check.\"></lead-result-text>\n                        <p>Application approval is subject to additional underwriting guidelines.</p>\n                        <p ng-if=\"userData.IsSuspendedCompliance\" class=\"result-note\"><strong>NEXT STEP:</strong> Have the homeowner\n                            <span class=\"link\" ng-click=\"lead.submitAnApplicationClick()\"> submit an application </span>\n                            so we can find out if they qualify.</p>\n                        <div class=\"pro-tip-lead\" ng-if=\"lead.kbygModalOpen === false\">\n                            <div class=\"pro-tip-lead-icon\">\n                                <span class=\"icon icon-tip\"></span>\n                                <span>Pro Tip</span>\n                            </div>\n                            <div class=\"pro-tip-lead-content\">\n                                <p>The Know-Before-You Go result lets you know the chances that a property owner will qualify for HERO. Review this before visiting or calling the property owner.</p>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <ng-include src=\"'app/lead/results/propertyInformation.html'\"></ng-include>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 509 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row col-md-12 lead-message-container\">\n    <div ng-class=\"lead.leadMessage.class\">\n        <span class=\"icon icon-delete\" ng-show=\"lead.kbygModalOpen\" ng-click=\"lead.showLeadMessage = false;\"></span>\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"row\">\n                    <div class=\"lead-message-header\">{{lead.leadMessage.header}}</div>\n                    <div class=\"lead-message-text\">{{lead.leadMessage.text}}</div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row modal-actions\" ng-class=\"{'pvnotfound-actions': lead.leadResult === 'PVNotFound'}\" ng-if=\"(lead.leadResult !== 'OutOfBounds' && lead.leadResult !== 'Duplicate') && (lead.leadData.IsPropertyInBounds === undefined || lead.leadData.IsPropertyInBounds === true) &&\n     lead.displayActions === true\">\n    <div>\n        <div class=\"col-md-4 col-md-offset-2 button-container-top\">\n            <button class=\"btn btn-default\" ng-click=\"lead.proPitchClick({source: 'Modal'})\">\n                <span ng-if=\"lead.proposalPlusEnabled === true\">Estimate Payments</span>\n                <span ng-if=\"lead.proposalPlusEnabled === false\">View Rates</span>\n            </button>\n        </div>\n        <div class=\"col-md-4 button-container\">\n            <button class=\"btn btn-primary right-button\" ng-click=\"lead.applyNowClick({source: 'Modal'})\">\n                <span ng-if=\"!lead.isFullPrequal && kbygModal.isSolicitor\">Get Approved</span>\n                <span ng-if=\"!lead.isFullPrequal && !kbygModal.isSolicitor\">Homeowner Apply</span>\n                <span ng-if=\"lead.isFullPrequal\">Resume Application</span>\n            </button>\n        </div>\n    </div>\n</div>\n<div class=\"row\">\n    <div class=\"col-xs-12\">\n        <div class=\"text-center new-address\">\n            <p ng-click=\"kbygModal.enterNewAddressClicked()\"><span class=\"icon icon-reload\"></span>Enter New Address</p>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 511 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row lead-result\">\n\t<div class=\"col-md-12 multiple-addresses-result\" ng-class=\"lead.kbygModalOpen ? 'multiple-addresses-modal' : ''\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-12\">\n\t\t\t\t<h3>Confirm Your Address</h3>\n\t\t\t\t<p>\n\t\t\t\t\tWe found the following addresses in the County property address database. Please select the address that you believe to be yours.\n\t\t\t\t</p>\n\t\t\t\t<table>\n\t\t\t\t\t<thead>\n\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t<th class=\"property-owner\">Property Owner</th>\n\t\t\t\t\t\t\t<th class=\"address\">Address</th>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t</thead>\n\t\t\t\t\t<tbody>\n\t\t\t\t\t\t<tr ng-repeat=\"address in kbygModal.kbygResponse.MatchingAddresses\" ng-class=\"{'selected' : kbygModal.matchingAddress.MatchingAddress === address}\" ng-click=\"kbygModal.selectMatchingAddress(address)\">\n\t\t\t\t\t\t\t<td class=\"property-owner\">{{address.ASSESSEE_LAST_1}}</td>\n\t\t\t\t\t\t\t<td class=\"address\">\n\t\t\t\t\t\t\t\t{{address.SITUS_HOUSE_NO}} {{address.SITUS_STREET}} {{address.SITUS_SUFFIX}}\n\t\t\t\t\t\t\t\t<span ng-if=\"address.SITUS_UNIT_NUMBER !== ''\">, #</span>{{address.SITUS_UNIT_NUMBER}}\n\t\t\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t\t\t{{address.SITUS_CITY}}\n\t\t\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t\t\t{{address.SITUS_ZIP}}\n\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t</tbody>\n\t\t\t\t</table>\n\t\t\t\t<div class=\"text-center\">\n\t\t\t\t\t<button class=\"btn btn-primary\" ng-disabled=\"kbygModal.matchingAddress === null\" ng-click=\"kbygModal.processMatchingAddress()\">Confirm</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"row\">\n\t\t    <div class=\"col-xs-12\">\n\t\t        <div class=\"text-center new-address\">\n\t\t            <p ng-click=\"kbygModal.enterNewAddressClicked()\"><span class=\"icon icon-reload\"></span>Enter New Address</p>\n\t\t        </div>\n\t\t    </div>\n\t\t</div>\n\t</div>\n</div>";

/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row lead-result\">\n    <div class=\"col-md-12 noliens-result\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"row\">\n                    <div class=\"col-md-2 col-xs-12 result-percent-container\">\n                        <h2 class=\"result-percentage\"></h2>\n                    </div>\n                    <div class=\"col-md-10 col-xs-12 result-text-container\">\n                        <lead-result-text lead=\"lead\" non-prequal-text=\"Good News! This home is in a HERO approved territory.\"></lead-result-text>\n                        <p class=\"result-summary\">We may need additional information about this property during the application process.</p>\n                        <p>Application approval is subject to additional underwriting guidelines.</p>\n                        <p ng-if=\"userData.IsSuspendedCompliance\" class=\"result-note\"><strong>NEXT STEP:</strong> Have the homeowner <span class=\"link\" ng-click=\"lead.submitAnApplicationClick()\"> submit an application </span> so we can find out the loan-to-value-ratio on the house, since we weren't able to access the required mortgage lien info.</p>\n                        <div class=\"pro-tip-lead\" ng-if=\"lead.kbygModalOpen === false\">\n                            <div class=\"pro-tip-lead-icon\">\n                                <span class=\"icon icon-tip\"></span>\n                                <span>Pro Tip</span>\n                            </div>\n                            <div class=\"pro-tip-lead-content\">\n                                <p>The Know-Before-You Go result lets you know the chances that a property owner will\n                                    qualify for HERO. Review this before visiting or calling the property owner.</p>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <ng-include src=\"'app/lead/results/propertyInformation.html'\"></ng-include>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row lead-result\">\n\t<div class=\"col-xs-12 out-of-bounds-result\">\n\t\t<hp-hint id=\"outOfBoundsResult\" ng-if=\"lead.kbygModalOpen === false\" copy=\"The Know-Before-You Go result lets you know the chances that a property owner will qualify for HERO. Review this before visiting or calling the property owner.\"></hp-hint>\n\t\t<div class=\"row\">\n\t\t\t<div ng-class=\"lead.kbygModalOpen ? 'col-xs-12' : 'col-xs-10 col-xs-offset-2'\">\n\t\t\t\t<div class=\"row\">\n\t\t\t\t\t<div class=\"text-center\" ng-class=\"lead.kbygModalOpen ? 'col-xs-12' : 'col-xs-11'\">\n\t\t\t\t\t\t<h3>Address Not in HERO Program City or County</h3>\n                        <h4 class=\"out-of-bounds-address\" ng-if=\"lead.leadData.Address\">{{lead.leadData.Address.Address1 + \" \" + (lead.leadData.Address.Address2 ? lead.leadData.Address.Address2 + \" \" : \"\") + lead.leadData.Address.City + \", \" + lead.leadData.Address.State + \" \" + lead.leadData.Address.ZIPCode}}</h4>\n\t\t\t\t\t\t<h4>The address you entered does not appear to be in a city or county participating in the HERO program</h4>\n\t\t\t\t\t\t<button class=\"btn btn-default participating-cities\" ng-click=\"lead.participatingCitiesClick()\">List of Participating Cities/Counties</button>\n\t\t\t\t\t\t<p class=\"out-of-bounds-note\">If you think the address is in a HERO-participating city or county, please <a href=\"https://www.heroprogram.com/contact\">contact us</a>.</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n";

/***/ }),
/* 514 */
/***/ (function(module, exports) {

module.exports = "<div class=\"lead-result page-actions\" ng-if=\"lead.leadResult !== 'Duplicate' && lead.displayActions === true\">\n    <div class=\"row action\">\n        <div class=\"col-xs-4\">\n            <h3 ng-if=\"lead.proposalPlusEnabled === true\">Create Proposal</h3>\n            <h3 ng-if=\"lead.proposalPlusEnabled === false\">View Rates</h3>\n        </div>\n        <div class=\"col-xs-8\">\n            <button type=\"button\" id=\"btn-detail-proposal-plus\" class=\"btn btn-default pull-right\" ng-click=\"lead.proPitchClick({source: 'Module'})\">\n                <span ng-if=\"lead.proposalPlusEnabled === true\">Estimate Payments</span>\n                <span ng-if=\"lead.proposalPlusEnabled === false\">View Rates</span>\n            </button>\n        </div>\n    </div>\n    <div class=\"row action\">\n        <div class=\"col-xs-4\">\n            <h3>Homeowner Apply</h3>\n        </div>\n        <div class=\"col-xs-8\">\n            <button type=\"button\" id=\"btn-detail-apply\" class=\"btn btn-primary pull-right\" ng-click=\"lead.applyNowClick({source: 'Module'})\">\n                <span ng-if=\"!lead.isFullPrequal\"> \n                    <span ng-if='lead.isSolicitor'>Get Approved</span>\n                    <span ng-if='!lead.isSolicitor'>Homeowner Apply</span>\n                </span>\n                <span ng-if=\"lead.isFullPrequal\">Resume Application</span>\n            </button>\n        </div>\n    </div>\n    <div class=\"row action\" ng-if=\"lead.proposalPlusEnabled === true\">\n        <div class=\"col-xs-4\">\n            <h3>Download Application</h3>\n        </div>\n        <div class=\"col-xs-8\">\n            <a href=\"https://e5ba42824be3ad90847f-3608ad1b944f1b4a386fab4a8bac1b83.ssl.cf2.rackcdn.com/HEROProgramApplications.zip\" class=\"pull-right\" analytics-on=\"click\"\n                analytics-event=\"Download Application\" analytics-category=\"Module\" analytics-label=\"Leads\">Download</a>\n        </div>\n    </div>\n    <div class=\"row action\">\n        <div class=\"col-xs-4\">\n            <h3>Call HERO</h3>\n        </div>\n        <div class=\"col-xs-8\">\n            <p class=\"pull-right phone-number\"> 844-722-7759</p>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 515 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row property-information\">\n    <div class=\"col-md-5 property-owner-container\" ng-if=\"lead.checkPropertyOwner()\">\n        <div class=\"property-owner-inner-container\">\n            <h3 ng-if=\"lead.checkPropertyOwner()\">Property Owners</h3>\n            <h4 ng-if=\"lead.leadData.Owner1LastName\" class=\"property-owner\">{{lead.leadData.Owner1FirstName}}\n                {{lead.leadData.Owner1LastName}}</h4>\n            <div ng-if=\"lead.displayPropertyOwnerCounty()\" class=\"property-owner-county-data\">\n                <h4 class=\"property-owner\">{{lead.leadData.AllOwners}}</h4>\n                <p ng-if=\"!lead.displayNoPropertyOwnerMessage()\">According to County property records, the person(s) listed above own the property.</p>\n            </div>\n            <div ng-if=\"lead.displayNoPropertyOwnerMessage()\">\n                <p>We weren't able to locate the property owner's information from the county property records..</p>\n            </div>\n        </div>\n    </div>\n    <div class=\"col-md-6 col-md-offset-1 property-address-container\">\n        <h3>Property Address</h3>\n\n        <div class=\"property-address-value-container\">\n            <p>{{lead.leadData.Address.Address1 | uppercase}}</p>\n\n            <p>{{lead.leadData.Address.Address2 | uppercase}}</p>\n\n            <p>{{lead.leadData.Address.City | uppercase}}, {{lead.leadData.Address.State | uppercase}}\n                {{lead.leadData.Address.ZIPCode}}</p>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row lead-result\">\n\t<div class=\"col-md-12 pvnotfound-result\" ng-class=\"lead.kbygModalOpen ? 'pvnotfound-modal' : ''\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"row\">\n                    <div class=\"col-md-2 col-xs-12 result-percent-container\">\n                        <h2 class=\"result-percentage\"></h2>\n                    </div>\n                    <div class=\"col-md-10 col-xs-12 result-text-container\">\n                        <lead-result-text lead=\"lead\" non-prequal-text=\"Good News! This home is in a HERO approved territory.\"></lead-result-text>\n                        <p class=\"result-summary\">We may need additional information about this property during the application process.</p>\n                        <p>Application approval is subject to additional underwriting guidelines.</p>\n                        <p class=\"pv-not-found-address\">{{lead.leadData.Address.Address1 + \" \" + (lead.leadData.Address.Address2 ? lead.leadData.Address.Address2 + \" \" : \"\") + lead.leadData.Address.City + \", \" + lead.leadData.Address.State + \" \" + lead.leadData.Address.ZIPCode}}</p>\n                        <div class=\"pro-tip-lead\" ng-if=\"lead.kbygModalOpen === false\">\n                            <div class=\"pro-tip-lead-icon\">\n                                <span class=\"icon icon-tip\"></span>\n                                <span>Pro Tip</span>\n                            </div>\n                            <div class=\"pro-tip-lead-content\">\n                                <p>The Know-Before-You Go result lets you know the chances that a property owner will\n                                    qualify for HERO. Review this before visiting or calling the property owner.</p>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n\t</div>\n</div>\n";

/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row lead-result\">\n\t<div class=\"col-md-12 red-result\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-12\">\n\t\t\t\t<div class=\"row\">\n\t\t\t\t\t<div class=\"col-md-2 col-xs-12 result-percent-container\">\n\t\t\t\t\t\t<h2 class=\"result-percentage\"></h2>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"col-md-10 col-xs-12 result-text-container\">\n\t\t\t\t\t\t<lead-result-text lead=\"lead\" non-prequal-text=\"This is in a HERO approved territory. We will most likely need additional information about this property during the application process. \"></lead-result-text>\n\t\t\t\t\t\t<p>Application approval is subject to additional underwriting guidelines.</p>\n\t\t\t\t\t\t<div class=\"pro-tip-lead\" ng-if=\"lead.kbygModalOpen === false\">\n                            <div class=\"pro-tip-lead-icon\">\n                                <span class=\"icon icon-tip\"></span>\n                                <span>Pro Tip</span>\n                            </div>\n                            <div class=\"pro-tip-lead-content\">\n                                <p>The Know-Before-You Go result lets you know the chances that a property owner will\n                                    qualify for HERO. Review this before visiting or calling the property owner.</p>\n                            </div>\n                        </div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<ng-include src=\"'app/lead/results/propertyInformation.html'\"></ng-include>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n";

/***/ }),
/* 518 */
/***/ (function(module, exports) {

module.exports = "<div class=\"lead-color-result-container\">\n    <ng-include src=\"'app/lead/results/leadMessage.html'\" ng-if=\"lead.showLeadMessage && lead.kbygModalOpen\"></ng-include>\n\n    <ng-include src=\"'app/lead/results/greenResult.html'\" ng-if=\"lead.leadResult === 'Green'\"></ng-include>\n\n    <ng-include src=\"'app/lead/results/yellowResult.html'\" ng-if=\"lead.leadResult === 'Yellow'\"></ng-include>\n\n    <ng-include src=\"'app/lead/results/noliensResult.html'\" ng-if=\"lead.leadResult === 'MaybeNoLiens'\"></ng-include>\n\n    <ng-include src=\"'app/lead/results/redResult.html'\" ng-if=\"lead.leadResult === 'Red'\"></ng-include>\n\n    <ng-include src=\"'app/lead/results/duplicateResult.html'\" ng-if=\"lead.leadResult === 'Duplicate'\"></ng-include>\n\n    <ng-include src=\"'app/lead/results/pvNotFoundResult.html'\" ng-if=\"lead.leadResult === 'PVNotFound'\"></ng-include>\n\n    <ng-include src=\"'app/lead/results/undeterminedResult.html'\" ng-if=\"lead.leadResult === 'Undetermined'\"></ng-include>\n\n    <ng-include src=\"'app/lead/results/outOfBoundsResult.html'\" ng-if=\"(lead.leadResult === 'OutOfBounds') || (lead.leadData.IsPropertyInBounds === false || (kbygModal !== undefined && kbygModal.isZipCodeOutOfBounds === true))\"></ng-include>\n</div>\n";

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row lead-result\">\n\t<div class=\"col-md-12 undetermined-result\">\n\t\t<hp-hint id=\"undeterminedResult\" ng-if=\"lead.kbygModalOpen === false\" copy=\"The Know-Before-You Go result lets you know the chances that a property owner will qualify for HERO. Review this before visiting or calling the property owner.\"></hp-hint>\n\t\t<div class=\"row\">\n\t\t\t<div ng-class=\"lead.kbygModalOpen ? 'col-md-12' : 'col-md-10 col-md-offset-2'\">\n\t\t\t\t<div class=\"row\">\n\t\t\t\t\t<div ng-class=\"lead.kbygModalOpen ? 'col-md-2 col-xs-12 exclamation-container' : 'col-md-1'\">\n\t\t\t\t\t\t<h2 class=\"result-exclamation icon icon-exclamation\"></h2>\n\t\t\t\t\t</div>\n                    <div class=\"undetermined-details\">\n                        <div class=\"col-md-6 col-xs-6 undetermined-details-label-container\" ng-class=\"{'modal-details' : lead.kbygModalOpen === true}\">\n                            <p>Result:</p>\n                            <p>Date Pulled:</p>\n                        </div>\n                        <div class=\"col-md-3 col-xs-6\" ng-class=\"{'modal-details' : lead.kbygModalOpen === true}\">\n                            <p class=\"undetermined-label\">Undetermined</p>\n                            <p>{{ lead.leadData.CreatedDate | date : 'shortDate' }}</p>\n                        </div>\n                    </div>\n\t\t\t\t</div>\n\t\t\t\t<ng-include src=\"'app/lead/results/propertyInformation.html'\"></ng-include>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n";

/***/ }),
/* 520 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row lead-result\">\n\t<div class=\"col-md-12 yellow-result\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-12\">\n\t\t\t\t<div class=\"row\">\n\t\t\t\t\t<div class=\"col-md-2 col-xs-12 result-percent-container\">\n\t\t\t\t\t\t<h2 class=\"result-percentage\"></h2>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"col-md-10 col-xs-12 result-text-container\">\n\t\t\t\t\t\t<lead-result-text lead=\"lead\" non-prequal-text=\"Good news! This is in a HERO approved territory. We may need additional information about this property during the application process.\"></lead-result-text>\n                        <p>Application approval is subject to additional underwriting guidelines.</p>\n                        <p ng-if=\"userData.IsSuspendedCompliance\" class=\"result-note\"><strong>NEXT STEP:</strong> Have the homeowner <span class=\"link\" ng-click=\"lead.submitAnApplicationClick()\"> submit an application </span> so we can find out the loan-to-value-ratio on the house.</p>\n                        <div class=\"pro-tip-lead\" ng-if=\"lead.kbygModalOpen === false\">\n                            <div class=\"pro-tip-lead-icon\">\n                                <span class=\"icon icon-tip\"></span>\n                                <span>Pro Tip</span>\n                            </div>\n                            <div class=\"pro-tip-lead-content\">\n                                <p>The Know-Before-You Go result lets you know the chances that a property owner will\n                                    qualify for HERO. Review this before visiting or calling the property owner.</p>\n                            </div>\n                        </div>\n                    </div>\n\t\t\t\t</div>\n\t\t\t\t<ng-include src=\"'app/lead/results/propertyInformation.html'\"></ng-include>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n";

/***/ }),
/* 521 */
/***/ (function(module, exports) {

module.exports = "    <div class=\"col-md-12 green-result\">\n        <div class=\"row results-container\">\n            <div class=\"col-md-8 col-xs-12 col-md-offset-2 result-text-container\">\n                <lead-result-text lead=\"lead\" non-prequal-text=\"Good News! This home is in a HERO approved territory and passes the home equity check.\"></lead-result-text>\n            </div>\n        </div>\n        <div class=\"row walkthrough-actions-container\">\n            <div class=\"col-md-12\">\n                <ng-include src=\"'app/lead/walkthrough/walkthroughActions.html'\"></ng-include>\n            </div>\n        </div>\n    </div>";

/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports = "<div class=\"lead-color-walkthrough-container\" ng-if=\"lead.leadResult !== 'Duplicate'\">\n    <div class=\"lead-walkthrough-loading hp-loading-template\" ra-spinner name=\"leadWalkthroughSpinner\"\n         hide-content-when-shown=\"true\"\n         show=\"lead.loading\" register=\"false\" template=\"indeterminateSpinner\">\n        <div class=\"row lead-result\">\n            <ng-include src=\"'app/lead/results/leadMessage.html'\" ng-if=\"lead.showLeadMessage\"></ng-include>\n            <ng-include src=\"'app/lead/walkthrough/greenWalkthrough.html'\" ng-if=\"lead.leadResult === 'Green'\"></ng-include>\n\n            <ng-include src=\"'app/lead/walkthrough/yellowWalkthrough.html'\"\n                        ng-if=\"lead.leadResult === 'Yellow'\"></ng-include>\n\n            <ng-include src=\"'app/lead/walkthrough/noliensWalkthrough.html'\"\n                        ng-if=\"lead.leadResult === 'MaybeNoLiens'\"></ng-include>\n\n            <ng-include src=\"'app/lead/walkthrough/redWalkthrough.html'\" ng-if=\"lead.leadResult === 'Red'\"></ng-include>\n\n            <ng-include src=\"'app/lead/walkthrough/pvNotFoundWalkthrough.html'\"\n                        ng-if=\"lead.leadResult === 'PVNotFound'\"></ng-include>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 523 */
/***/ (function(module, exports) {

module.exports = "    <div class=\"col-md-12 noliens-result\">\n        <div class=\"row results-container\">\n            <div class=\"col-md-8 col-xs-12 col-md-offset-2 result-text-container\">\n            <lead-result-text lead=\"lead\" non-prequal-text=\"Good news! This is in a HERO approved territory.\"></lead-result-text>\n            </div>\n        </div>\n        <div class=\"row walkthrough-actions-container\">\n            <div class=\"col-md-12\">\n                <ng-include src=\"'app/lead/walkthrough/walkthroughActions.html'\"></ng-include>\n            </div>\n        </div>\n    </div>";

/***/ }),
/* 524 */
/***/ (function(module, exports) {

module.exports = "    <div class=\"col-md-12 pvnotfound-result\">\n        <div class=\"row results-container\">\n            <div class=\"col-md-8 col-xs-12 col-md-offset-2 result-text-container\">\n                <lead-result-text lead=\"lead\" non-prequal-text=\"Good news! This is in a HERO approved territory.\"></lead-result-text>\n            </div>\n        </div>\n        <div class=\"row walkthrough-actions-container\">\n            <div class=\"col-md-12\">\n                <ng-include src=\"'app/lead/walkthrough/walkthroughActions.html'\"></ng-include>\n            </div>\n        </div>\n    </div>";

/***/ }),
/* 525 */
/***/ (function(module, exports) {

module.exports = "    <div class=\"col-md-12 red-result\">\n        <div class=\"row results-container\">\n            <div class=\"col-md-8 col-xs-12 col-md-offset-2 result-text-container\">\n                <lead-result-text lead=\"lead\" non-prequal-text=\"Good news! This is in a HERO approved territory.\"></lead-result-text>\n            </div>\n        </div>\n        <div class=\"row walkthrough-actions-container\">\n            <div class=\"col-md-12\">\n                <ng-include src=\"'app/lead/walkthrough/walkthroughActions.html'\"></ng-include>\n            </div>\n        </div>\n    </div>";

/***/ }),
/* 526 */
/***/ (function(module, exports) {

module.exports = "<div class=\"walkthrough-actions\" ng-class=\"{'pvnotfound-actions': lead.leadResult === 'PVNotFound'}\" ng-if=\"(lead.leadResult !== 'OutOfBounds' && lead.leadResult !== 'Duplicate') && (lead.leadData.IsPropertyInBounds === undefined || lead.leadData.IsPropertyInBounds === true)\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <p class=\"eyecatch\" ng-if=\"lead.displayActions === true\">Next Steps</p>\n        </div>\n    </div>\n    <div class=\"row\" ng-if=\"lead.leadResult === 'PVNotFound'\">\n        <div class=\"col-md-12\">\n            <p class=\"next-steps-pvnotfound-description\" ng-if=\"lead.displayActions === true\">Submit an application in order to determine the value of the home and see if it's eligible for HERO.</p>\n        </div>\n    </div>\n    <div class=\"row\" ng-if=\"lead.leadResult === 'MaybeNoLiens'\">\n        <div class=\"col-md-8 col-md-offset-2\">\n            <p class=\"next-steps-maybenoliens-description\" ng-if=\"lead.displayActions === true\">Submit an application by clicking \n                <span ng-if='lead.isSolicitor'>\"Get Approved\"</span> <span ng-if='!lead.isSolicitor'>\"Homeowner Apply\"</span> \n                so we can find out the loan-to-value ratio on the house. The eligibility\n                may not be accurate since we weren't able to access the required mortgage lien info.</p>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div ng-if=\"lead.displayActions === true\">\n            <div class=\"col-md-4 col-md-offset-2 button-container-top\">\n                <button type=\"button\" id=\"btn-walkthrough-apply\" class=\"btn btn-primary right-button\" ng-click=\"lead.applyNowClick({source: 'Walkthrough'})\">\n                    <span ng-if=\"!lead.isFullPrequal\">\n                        <span ng-if='lead.isSolicitor'>Get Approved</span> \n                        <span ng-if='!lead.isSolicitor'>Homeowner Apply</span> \n                    </span>\n                    <span ng-if=\"lead.isFullPrequal\">Resume Application</span>\n                </button>\n            </div>\n            <div class=\"col-md-4 button-container\">\n                <button type=\"button\" id=\"btn-walkthrough-proposal-plus\" class=\"btn btn-default\" ng-click=\"lead.proPitchClick({source: 'Walkthrough'})\">\n                    <span ng-if=\"lead.proposalPlusEnabled === true\">Estimate Payments</span>\n                    <span ng-if=\"lead.proposalPlusEnabled === false\">View Rates</span>\n                </button>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports = "    <div class=\"col-md-12 yellow-result\">\n        <div class=\"row results-container\">\n            <div class=\"col-md-8 col-xs-12 col-md-offset-2 result-text-container\">\n                <lead-result-text lead=\"lead\" non-prequal-text=\"Good news! This is in a HERO approved territory.\"></lead-result-text>\n            </div>\n        </div>\n        <div class=\"row walkthrough-actions-container\">\n            <div class=\"col-md-12\">\n                <ng-include src=\"'app/lead/walkthrough/walkthroughActions.html'\"></ng-include>\n            </div>\n        </div>\n    </div>";

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _actionItemFiltersController = __webpack_require__(529);

var _actionItemFiltersController2 = _interopRequireDefault(_actionItemFiltersController);

var _actionItemFiltersFactory = __webpack_require__(531);

var _actionItemFiltersFactory2 = _interopRequireDefault(_actionItemFiltersFactory);

var _actionItemsController = __webpack_require__(532);

var _actionItemsController2 = _interopRequireDefault(_actionItemsController);

var _actionItemsDirective = __webpack_require__(534);

var _actionItemsDirective2 = _interopRequireDefault(_actionItemsDirective);

var _actionItemsFactory = __webpack_require__(535);

var _actionItemsFactory2 = _interopRequireDefault(_actionItemsFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.common.actionItems', []).controller('ActionItemFiltersController', _actionItemFiltersController2.default).controller('actionItemsController', _actionItemsController2.default).factory('ActionItemFiltersFactory', _actionItemFiltersFactory2.default).factory('actionItemsFactory', _actionItemsFactory2.default).directive('actionItemsDirective', _actionItemsDirective2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/common/actionItems/actionItemFiltersTemplate.html', __webpack_require__(536)); // eslint-disable-line global-require
    $templateCache.put('app/common/actionItems/actionItems.html', __webpack_require__(537)); // eslint-disable-line global-require
    $templateCache.put('app/common/actionItems/actionItemsTemplate.html', __webpack_require__(538)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = actionItemFiltersController;

__webpack_require__(530);

actionItemFiltersController.$inject = ['actionItemFiltersFactory', '$timeout', '$analytics', '$scope', '$rootScope']; // angular
// 	.module("HeroPRO")
// 	.controller("actionItemFiltersController", actionItemFiltersController);

/* @ngInject */
function actionItemFiltersController(actionItemFiltersFactory, $timeout, $analytics, $scope, $rootScope) {
    var vm = this;
    vm.filtersOpen = false;
    vm.labelOptions = [];
    vm.statusOptions = [];
    vm.activeLabel = {};
    vm.activeStatus = {};

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.toggleFilters = function () {
        // The timeout is needed so that any open filter dropdowns close before the filters section collapses
        $timeout(function () {
            vm.filtersOpen = !vm.filtersOpen;
        });
    };

    vm.statusFilterChange = function (newStatus) {
        vm.activeStatus = newStatus;
        actionItemFiltersFactory.setActionItemFilter('ActionItemStatuses', vm.activeStatus.ActionItemStatusId);
        $analytics.eventTrack('Status Filter', { category: 'ActionItem', label: vm.activeStatus.ActionItemStatusName });
    };

    vm.labelFilterChange = function (newLabel) {
        vm.activeLabel = newLabel;
        actionItemFiltersFactory.setActionItemFilter('ActionItemLabels', vm.activeLabel.ActionItemLabelId);
        $analytics.eventTrack('Label Filter', { category: 'ActionItem', label: vm.activeLabel.ActionItemLabelDescription });
    };
    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */
    function init() {
        resetFilters();

        // Retrieve all the action item filter options
        actionItemFiltersFactory.getActionItemFilterOptions().then(function (response) {
            vm.labelOptions = response.ActionItemLabels;
            vm.statusOptions = response.ActionItemStatuses;
        });

        // Reset action item filters when the location dropdown is changed
        $scope.$on('HPLocationChange', function () {
            resetFilters();
        });

        // When leaving the todo state reset the action item filters
        var stateChangeListener = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState) {
            if (fromState.name === 'todo') {
                actionItemFiltersFactory.resetFilters();
                stateChangeListener(); // Unregister the existing listener
            }
        });
    }

    function resetFilters() {
        vm.filtersOpen = false;
        vm.activeLabel = { ActionItemLabelId: 0, ActionItemLabelDescription: 'All' };
        vm.activeStatus = { ActionItemStatusId: 1, ActionItemStatusName: 'Open' };
    }
    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 530 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = actionItemFiltersFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

actionItemFiltersFactory.$inject = ['HPConfig', '$http']; // angular
// 	.module("HeroPRO")
// 	.factory("actionItemFiltersFactory", actionItemFiltersFactory);

/* @ngInject */
function actionItemFiltersFactory(HPConfig, $http) {
    var filterOptions = {};
    // Default Filters
    var selectedFilters = {
        ActionItemStatuses: [1, 4]
    };

    return {
        getActionItemFilterOptions: getActionItemFilterOptions,
        getSelectedActionItemFilters: getSelectedActionItemFilters,
        setActionItemFilter: setActionItemFilter,
        resetFilters: resetFilters
    };

    /*= ========================================
    =            Public Functions            =
    ========================================= */
    function getActionItemFilterOptions() {
        var request = $http({
            url: HPConfig.heroProApi + 'ActionItem/getFilters',
            method: 'GET',
            params: {}
        });

        return request.then(handleSuccess, handleError);
    }

    function getSelectedActionItemFilters() {
        return selectedFilters;
    }

    function setActionItemFilter(filterName, value) {
        switch (filterName) {
            case 'ActionItemStatuses':
                selectedFilters.ActionItemStatuses = setActionItemStatusId(value);
                break;
            case 'ActionItemLabels':
                if (value === 0) {
                    delete selectedFilters.ActionItemLabels;
                } else {
                    selectedFilters.ActionItemLabels = [value];
                }
                break;
            default:
                selectedFilters[filterName] = value;
        }
    }

    function resetFilters() {
        selectedFilters = {
            ActionItemStatuses: [1, 4]
        };
    }
    /* -----  End of Public Functions  ------*/

    /*= ========================================
    =            Private Functions            =
    ========================================= */
    function setActionItemStatusId(status) {
        var actionItemStatuses = [];

        switch (status) {
            case 0:
                actionItemStatuses.push(1);
                actionItemStatuses.push(3);
                actionItemStatuses.push(4);
                actionItemStatuses.push(5);
                break;
            case 1:
                actionItemStatuses.push(1);
                actionItemStatuses.push(4);
                break;
            case 3:
                actionItemStatuses.push(3);
                break;
            case 5:
                actionItemStatuses.push(5);
                break;
        }

        return actionItemStatuses;
    }

    function modifyLabelOptions(data) {
        filterOptions.ActionItemLabels = data;
        // Add an All option
        filterOptions.ActionItemLabels.unshift({ ActionItemLabelId: 0, ActionItemLabelDescription: 'All' });
    }

    function modifyStatusOptions(data) {
        filterOptions.ActionItemStatuses = data;
        // Remove the Dismissed and Invalidated options
        filterOptions.ActionItemStatuses = _lodash2.default.filter(filterOptions.ActionItemStatuses, function (status) {
            return status.ActionItemStatusName !== 'Invalidated' && status.ActionItemStatusName !== 'Initiated';
        });
        // Add an All option
        filterOptions.ActionItemStatuses.unshift({ ActionItemStatusId: 0, ActionItemStatusName: 'All' });
    }

    function handleSuccess(response) {
        modifyLabelOptions(response.data.ActionItemLabels);
        modifyStatusOptions(response.data.ActionItemStatuses);

        return filterOptions;
    }

    function handleError(response) {
        return response.data;
    }
    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = actionItemsController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(533);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

actionItemsController.$inject = ['$scope', '$state', '$location', 'ActionItemsFactory', 'actionItemFiltersFactory', '$analytics', 'UserData', 'Timestamp', 'coachmark', '$timeout', 'HPConfig', '$window']; // angular
// 	.module("HeroPRO")
// 	.controller("actionItemsController", actionItemsController);


/* @ngInject */
function actionItemsController($scope, $state, $location, ActionItemsFactory, actionItemFiltersFactory, $analytics, UserData, Timestamp, coachmark, $timeout, HPConfig, $window) {
    var vm = this;
    var defaultActionItemParams = {}; // Action item params without any of the filters included
    var actionItemParams = {}; // Complete set of params used to request action items
    vm.loading = false;
    vm.contextMenuIsOpen = false;

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.contextMenuClick = function ($event) {
        $event.preventDefault();
        $event.stopPropagation();
    };

    vm.contextMenuOpened = function (open) {
        vm.contextMenuIsOpen = open;
    };

    vm.actionItemClick = function (action, fromCallToAction) {
        if ((fromCallToAction === true || !vm.contextMenuIsOpen && $window.innerWidth <= HPConfig.screenSizes.screen_md) && (action.ActionItemStatusId === 1 || action.ActionItemStatusId === 4)) {
            if (action.ActionItemStatusId === 1) {
                // If the action item has a status of open, set its status to initiated.
                ActionItemsFactory.setActionItemStatus({
                    ActionItemId: action.ActionItemId,
                    ActionItemStatus: 4
                });
            }

            // Google Analytics for action item click. Taking timezone offset into consideration.
            var actionItemClickTime = new Date().getTime() - (new Date(action.WarningDate).getTime() + new Date().getTimezoneOffset() * 60 * 1000);
            $analytics.eventTrack('Open:' + action.ActionItemTypeName, { category: 'ActionItem', label: vm.source, value: actionItemClickTime });

            action.click();
        }
    };

    vm.dismissActionItem = function (action) {
        ActionItemsFactory.setActionItemStatus({
            ActionItemId: action.ActionItemId,
            ActionItemStatus: 5
        });

        action.ActionItemStatusId = 5;
        action.dismissed = true;
        $analytics.eventTrack('Dismiss', { category: 'ActionItem', label: vm.source });
    };

    vm.undismissActionItem = function (action, $event) {
        ActionItemsFactory.setActionItemStatus({
            ActionItemId: action.ActionItemId,
            ActionItemStatus: 1
        });

        action.ActionItemStatusId = 1;
        action.dismissed = false;
        $analytics.eventTrack('UnDismiss', { category: 'ActionItem', label: vm.source });

        $event.preventDefault();
        $event.stopPropagation();
    };
    /* -----  End of Public Functions  ------*/

    /*= ========================================
    =            Private Functions            =
    ========================================= */
    function init() {
        // If maxActionItems was set on the directive, use that value as the page size
        if (vm.maxActionItems !== undefined) {
            defaultActionItemParams.PageNumber = 0;
            defaultActionItemParams.PageSize = vm.maxActionItems;
        }

        // Set the params for the initial action items request
        actionItemParams = _lodash2.default.extend({}, defaultActionItemParams, actionItemFiltersFactory.getSelectedActionItemFilters());

        // Load action items on page load
        UserData.getCurrentLocation().then(function (location) {
            setLocationContractorId(location);
            getActionItems(actionItemParams);
        });

        // Update action items when the location dropdown is changed
        $scope.$on('HPLocationChange', function (event, data) {
            setLocationContractorId(data);
            getActionItems(actionItemParams);
        });

        // Update action items when filters are changed
        $scope.$watchCollection(actionItemFiltersFactory.getSelectedActionItemFilters, function (newFilters, oldFilters) {
            if (!_lodash2.default.isEqual(newFilters, oldFilters)) {
                getActionItems(_lodash2.default.extend({}, defaultActionItemParams, newFilters));
            }
        });
    }

    function getActionItems(params) {
        vm.loading = true;
        ActionItemsFactory.getActionItems(params).then(function (data) {
            vm.loading = false;
            vm.actions = data;
            var actionItemsLoadTime = new Date().getTime() - Timestamp.getTimestamp('stateChangeTimestamp');
            $analytics.eventTrack('Initialize', { category: 'ActionItem', label: vm.source, value: actionItemsLoadTime });

            // Auto start coachmark tour after the action items have been loaded
            if (vm.source === 'summaryView' && $window.innerWidth >= HPConfig.screenSizes.screen_md) {
                $timeout(function () {
                    coachmark.startCoachmarkTour(true);
                });
            }
        });
    }

    function setLocationContractorId(newLocation) {
        if (newLocation.ContractorId === '') {
            delete actionItemParams.ContractorLocationId;
            delete defaultActionItemParams.ContractorLocationId;
        } else {
            actionItemParams.ContractorLocationId = newLocation.ContractorId;
            defaultActionItemParams.ContractorLocationId = newLocation.ContractorId;
        }
    }
    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ActionItemsDirective;
// angular
//   .module("HeroPRO")
//   .directive("actionItems", ActionItemsDirective);


function ActionItemsDirective() {
    return {
        restrict: 'E',
        templateUrl: 'app/actionItems/actionItemsTemplate.html',
        controller: 'actionItemsController',
        controllerAs: 'actionItems',
        bindToController: true,
        scope: {
            source: '@source', // string
            showFilters: '=showFilters', // true/false
            showRefreshButton: '=showRefreshButton', // true/false
            showSeeAll: '=showSeeAll', // true/false
            showCompletedToday: '=showCompletedToday', // true/false
            maxActionItems: '=maxActionItems' // integer
        }
    };
}

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ActionItemsFactory;
ActionItemsFactory.$inject = ['HPConfig', '$http', '$location', 'raSpinnerService', '$window'];
// angular
// 	.module("HeroPRO")
// 	.factory("ActionItemsFactory", ActionItemsFactory);

/* @ngInject */
function ActionItemsFactory(HPConfig, $http, $location, raSpinnerService, $window) {
    /*= ========================================
    =            Private Functions            =
    ========================================= */
    function handleSuccess(response) {
        if (raSpinnerService.isRegistered('todoListSpinner')) {
            raSpinnerService.hide('todoListSpinner');
        }

        if (response.data.Data === undefined) {
            return null;
        }

        return setupActionItems(response.data.Data);
    }

    function handleError(response) {
        return response.data;
    }

    function setupActionItems(actionItems) {
        for (var i = 0; i < actionItems.length; i++) {
            // Attach click handlers
            actionItems[i].click = createClickHandler(actionItems[i]);

            // Determine date to display
            actionItems[i].displayDate = setDisplayDate(actionItems[i]);

            actionItems[i].dismissed = actionItems[i].ActionItemStatusId === 5;
        }

        return actionItems;
    }

    function createClickHandler(actionItem) {
        var clickHandler = void 0;

        switch (actionItem.ActionItemTypeId) {
            case 1:
                clickHandler = function clickHandler() {
                    $location.url('/app-detail/' + actionItem.FundingRequestId);
                };
                break;
            case 2:
                clickHandler = function clickHandler() {
                    $location.url('/app-detail/' + actionItem.FundingRequestId);
                };
                break;
            case 3:
                clickHandler = function clickHandler() {
                    $location.url('/app-detail/' + actionItem.FundingRequestId);
                };
                break;
            case 4:
                clickHandler = function clickHandler() {
                    $location.url('/app-detail/' + actionItem.FundingRequestId);
                };
                break;
            case 5:
                clickHandler = function clickHandler() {
                    $location.url('/app-detail/' + actionItem.FundingRequestId);
                };
                break;
            case 6:
                clickHandler = function clickHandler() {
                    $location.url('/app-detail/' + actionItem.FundingRequestId);
                };
                break;
            default:
                clickHandler = function clickHandler() {
                    $window.alert('Cannot determine action item type ID. Please contact support.');
                };
                break;
        }

        return clickHandler;
    }

    function setDisplayDate(actionItem) {
        var displayDate = void 0;

        if (actionItem.DaysDueCount >= 1) {
            displayDate = 'Past Due';
        } else if (actionItem.DaysDueCount === 0) {
            displayDate = 'Due Today';
        } else if (actionItem.DaysDueCount === -1) {
            displayDate = 'Due Tomorrow';
        } else {
            displayDate = actionItem.DueDate;
        }

        return displayDate;
    }
    /* -----  End of Private Functions  ------*/

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    return {
        getActionItems: function getActionItems(params) {
            if (raSpinnerService.isRegistered('todoListSpinner')) {
                raSpinnerService.show('todoListSpinner');
            }

            var request = $http({
                url: HPConfig.heroProApi + 'ActionItem/search',
                method: 'GET',
                params: params
            });

            return request.then(handleSuccess, handleError);
        },
        setActionItemStatus: function setActionItemStatus(params) {
            var request = $http({
                url: HPConfig.heroProApi + 'ActionItem/UpdateStatus',
                method: 'POST',
                data: params
            });

            return request.then(handleSuccess, handleError);
        }
    };
    /* -----  End of Public Functions  ------*/
}

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports = "<div ng-controller=\"actionItemFiltersController as actionItemFilters\">\n\t<div class=\"row\">\n\t\t<div class=\"col-xs-12 col-md-6 action-items-header\">\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-xs-10 col-md-5\">\n\t\t\t\t\t<h1>To-Do List Items</h1>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-xs-2 col-md-7\">\n\t\t\t\t\t<a href=\"#\" class=\"icon icon-pipeline-tip\" hp-popover popover-placement=\"bottom\" popover-trigger=\"show\" popover-title=\"To-Do List Items\" uib-popover=\"To-Do List items are reminders from HERO Pro. They only show after a little time has passed. Visit your Pipeline to see all your projects.\"></a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"col-xs-12 col-md-6\" ng-show=\"actionItems.showFilters\">\n\t\t\t<span class=\"link toggle-filters pull-right\" ng-click=\"actionItemFilters.toggleFilters()\">Filters</span>\n\t\t</div>\n\t\t<div class=\"col-xs-12 col-md-6\" ng-show=\"!actionItems.showFilters\">\n\t\t\t<a href=\"/todo\" class=\"see-all-top pull-right\">See All</a>\n\t\t</div>\n\t</div>\n\t<div class=\"row action-item-filters\" uib-collapse=\"!actionItemFilters.filtersOpen\">\n\t\t<div class=\"col-xs-12 col-md-4\">\n\t\t\t<div class=\"filter-container\">\n\t\t\t\t<div class=\"dropdown\" uib-dropdown dropdown-small-popup dropdown-title=\"Task\">\n\t                <a blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle data-toggle=\"dropdown\">\n\t                \t<p>Task</p>\n\t                    <span class=\"dropdown-text\">{{actionItemFilters.activeLabel.ActionItemLabelDescription}}</span>\n\t                    <span class=\"icon\"></span>\n\t                </a>\n\t                <ul class=\"dropdown-menu\" uib-dropdown-menu>\n\t                    <li ng-repeat=\"label in actionItemFilters.labelOptions\" ng-class=\"{'active': actionItemFilters.activeLabel.ActionItemLabelDescription === label.ActionItemLabelDescription}\" ng-click=\"actionItemFilters.labelFilterChange(label)\">\n\t                        {{label.ActionItemLabelDescription}}\n\t                    </li>\n\t                </ul>\n\t            </div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"col-xs-12 col-md-3\">\n\t\t\t<div class=\"filter-container\">\n\t\t\t\t<div class=\"dropdown\" uib-dropdown dropdown-small-popup dropdown-title=\"Show\">\n\t                <a blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle data-toggle=\"dropdown\">\n\t                \t<p>Show</p>\n\t                    <span class=\"dropdown-text\">{{actionItemFilters.activeStatus.ActionItemStatusName}}</span>\n\t                    <span class=\"icon\"></span>\n\t                </a>\n\t                <ul class=\"dropdown-menu\" uib-dropdown-menu>\n\t                    <li ng-repeat=\"status in actionItemFilters.statusOptions\" ng-class=\"{'active': actionItemFilters.activeStatus.ActionItemStatusName === status.ActionItemStatusName}\" ng-click=\"actionItemFilters.statusFilterChange(status)\">\n\t                        {{status.ActionItemStatusName}}\n\t                    </li>\n\t                </ul>\n\t            </div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n";

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-module\">\n\t<div class=\"hp-inner\">\n\t\t<action-items show-filters=\"true\" show-refresh-button=\"true\" show-see-all=\"false\" show-completed-today=\"true\" source=\"all_items\"></action-items>\n\t</div>\n</div>\n";

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports = "<ng-include src=\"'app/actionItems/actionItemFiltersTemplate.html'\"></ng-include>\n\n<div class=\"row hp-loading-spinner\" ra-spinner name=\"todoListSpinner\" hide-content-when-shown=\"true\" show=\"actionItems.loading\" register=\"false\">\n\t<div ng-repeat=\"action in actionItems.actions\" class=\"action-item col-xs-12\"  ng-class=\"{completed: action.ActionItemStatusId == 3, dismissed: action.ActionItemStatusId == 5}\" ng-show=\"!actionItems.loading\" ng-click=\"actionItems.actionItemClick(action, false)\">\n\t\t<div class=\"row\">\n\n\t\t\t<div class=\"col-xs-12 col-md-3 col-md-push-9\" ng-hide=\"action.dismissed\">\n\t\t\t\t<p class=\"text-right\" ng-class=\"(action.displayDate == 'Past Due' || action.displayDate == 'Due Today') ? 'date-due warning' : 'date-due'\" ng-hide=\"action.ActionItemStatusId == 3 || (!action.dismissed && actionItems.status == 'Dismissed')\">{{action.displayDate | date: \"'Due' M/d/yyyy\"}}</p>\n\t\t\t\t<div class=\"text-right call-to-action\" ng-hide=\"action.ActionItemStatusId == 3 || (!action.dismissed && actionItems.status == 'Dismissed')\">\n\t\t\t\t    <div class=\"btn-group\" uib-dropdown dropdown-small-popup dropdown-title=\"Action\" on-toggle=\"actionItems.contextMenuOpened(open)\">\n\t\t\t    \t\t<button type=\"button\" class=\"btn btn-primary\" ng-click=\"actionItems.actionItemClick(action, true)\")>{{action.CallToActionText}}</button>\n\t\t\t\t    \t<button type=\"button\" class=\"btn btn-primary\" uib-dropdown-toggle ng-click=\"actionItems.contextMenuClick($event)\">\n\t\t\t\t        \t<span class=\"icon\"></span>\n\t\t\t      \t\t</button>\n\t\t\t\t      \t<ul class=\"dropdown-menu dropdown-menu-action-items-context dropdown-menu-right\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"split-button\">\n\t\t\t\t\t        <li role=\"menuitem\" ng-click=\"actionItems.dismissActionItem(action)\">Dismiss</li>\n\t\t\t      \t\t</ul>\n\t\t\t    \t</div>\n\t\t\t\t</div>\n\t\t\t\t<p class=\"completed-label text-right\" ng-show=\"action.ActionItemStatusId == 3\">\n\t\t\t\t\t<span class=\"icon icon-todo\"></span>\n\t\t\t\t\t<span>Completed</span>\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<div class=\"col-xs-12 col-md-9 col-md-pull-3\" ng-show=\"(!action.dismissed && actionItems.status != 'Dismissed') || (action.dismissed && actionItems.status == 'Dismissed')\">\n\t\t\t\t<p class=\"loan-information\">{{action.Owner1LastName}}, {{action.Owner1FirstName}} <span>{{action.ActionItemLabelDescription}}</span></p>\n\t\t\t\t<p class=\"action-description\">\n\t\t\t\t\t{{action.Detail}}\n\t\t\t\t</p>\n\t\t\t\t<p class=\"action-detail\">\n\t\t\t\t\t{{action.Description}}\n\t\t\t\t</p>\n\t\t\t</div>\n\n\t\t\t<div class=\"col-xs-3 col-md-push-9 dismissed\" ng-show=\"action.dismissed\">\n\t\t\t\t<span ng-click=\"actionItems.undismissActionItem(action, $event)\" class=\"link pull-right\">Un-dismiss</span>\n\t\t\t</div>\n\t\t\t<div class=\"col-xs-9 col-md-pull-3 dismissed\" ng-show=\"action.dismissed && actionItems.status != 'Dismissed'\">\n\t\t\t\t<p>This item has been dismissed. All dismissed items will appear in your dismissed To Do List view.</p>\n\t\t\t</div>\n\t\t\t<div class=\"col-xs-9 col-md-pull-3 dismissed\" ng-show=\"!action.dismissed && actionItems.status == 'Dismissed'\">\n\t\t\t\t<p>This item has been undismissed and will reappear in your open To Do List view.</p>\n\t\t\t</div>\n\n\t\t\t<div class=\"col-xs-12\" ng-show=\"action.ActionItemStatusId == 3\">\n\t\t\t\t<p class=\"completed-text\">Completed <span ng-hide=\"action.CompletedBy == null\">by {{action.CompletedBy}}</span> on {{action.CompletedDate | date:'M/d/yyyy h:mma'}} (Pacific Time Zone)</p>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n\n<div class=\"row\" ng-show=\"actionItems.actions === null && !actionItems.loading\">\n\t<div class=\"col-xs-12 action-items-header no-action-items\">\n\t\t<p class=\"text-center\">There are no action items available.</p>\n\t</div>\n</div>\n\n<div class=\"row\" ng-show=\"actionItems.showSeeAll\">\n\t<div class=\"see-all-bottom col-xs-12 text-center\">\n\t\t<a href=\"/todo\">See All To-Do List Items</a>\n\t</div>\n</div>\n";

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _addProducts = __webpack_require__(540);

var _addProducts2 = _interopRequireDefault(_addProducts);

var _documents = __webpack_require__(546);

var _documents2 = _interopRequireDefault(_documents);

var _ESign = __webpack_require__(573);

var _ESign2 = _interopRequireDefault(_ESign);

var _getClosingSignaturesModal = __webpack_require__(578);

var _getClosingSignaturesModal2 = _interopRequireDefault(_getClosingSignaturesModal);

var _makeChangesModal = __webpack_require__(584);

var _makeChangesModal2 = _interopRequireDefault(_makeChangesModal);

var _paymentInstructions = __webpack_require__(594);

var _paymentInstructions2 = _interopRequireDefault(_paymentInstructions);

var _pipelineStageIndicator = __webpack_require__(604);

var _pipelineStageIndicator2 = _interopRequireDefault(_pipelineStageIndicator);

var _projectDetails = __webpack_require__(608);

var _projectDetails2 = _interopRequireDefault(_projectDetails);

var _projectHistory = __webpack_require__(614);

var _projectHistory2 = _interopRequireDefault(_projectHistory);

var _projectInformation = __webpack_require__(621);

var _projectInformation2 = _interopRequireDefault(_projectInformation);

var _walkthrough = __webpack_require__(624);

var _walkthrough2 = _interopRequireDefault(_walkthrough);

var _appDetailController = __webpack_require__(691);

var _appDetailController2 = _interopRequireDefault(_appDetailController);

var _fundingRequestClosingFactory = __webpack_require__(693);

var _fundingRequestClosingFactory2 = _interopRequireDefault(_fundingRequestClosingFactory);

var _fundingRequestDisbursementsFactory = __webpack_require__(694);

var _fundingRequestDisbursementsFactory2 = _interopRequireDefault(_fundingRequestDisbursementsFactory);

var _fundingRequestDocumentsFactory = __webpack_require__(695);

var _fundingRequestDocumentsFactory2 = _interopRequireDefault(_fundingRequestDocumentsFactory);

var _fundingRequestInformationFactory = __webpack_require__(696);

var _fundingRequestInformationFactory2 = _interopRequireDefault(_fundingRequestInformationFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.appDetail', [_addProducts2.default, _documents2.default, _ESign2.default, _getClosingSignaturesModal2.default, _makeChangesModal2.default, _paymentInstructions2.default, _pipelineStageIndicator2.default, _projectDetails2.default, _projectHistory2.default, _projectInformation2.default, _walkthrough2.default]).controller('AppDetailController', _appDetailController2.default).factory('FRClosingFactory', _fundingRequestClosingFactory2.default).factory('FRDisbursementsFactory', _fundingRequestDisbursementsFactory2.default).factory('FRDocumentsFactory', _fundingRequestDocumentsFactory2.default).factory('FRInformationFactory', _fundingRequestInformationFactory2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/appDetail/appDetail.html', __webpack_require__(697)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _dealType = __webpack_require__(541);

var _dealType2 = _interopRequireDefault(_dealType);

var _selectedProducts = __webpack_require__(543);

var _selectedProducts2 = _interopRequireDefault(_selectedProducts);

var _addProductsFactory = __webpack_require__(545);

var _addProductsFactory2 = _interopRequireDefault(_addProductsFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.appDetail.addProducts', [_dealType2.default, _selectedProducts2.default]).factory('AddProductsFactory', _addProductsFactory2.default).run().name;

// add product features

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _dealTypeFactory = __webpack_require__(542);

var _dealTypeFactory2 = _interopRequireDefault(_dealTypeFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.appDetail.addProducts.dealType', []).factory('DealTypeFactory', _dealTypeFactory2.default).run().name;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = dealTypeFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

dealTypeFactory.$inject = ['HPConfig', '$http', '$rootScope']; // angular
// 	.module("HeroPRO")
// 	.factory("DealTypeFactory", dealTypeFactory);

/* @ngInject */
function dealTypeFactory(HPConfig, $http, $rootScope) {
    var _availableDealTypes = {}; // _availableDealTypes[Purchase] and _availableDealTypes[Lease]
    var _selectedDealType = {}; // This object may look different depending on the selected deal type

    return {
        getSelectedDealType: getSelectedDealType,
        setSelectedDealType: setSelectedDealType,
        getAvailableDealTypes: getAvailableDealTypes,
        fetchAvailableDealTypes: fetchAvailableDealTypes,
        submitSelectedDealType: submitSelectedDealType,
        hasLeaseDealType: hasLeaseDealType,
        hasDirectPayDealType: hasDirectPayDealType,
        resetDealType: resetDealType
    };

    function getSelectedDealType() {
        // Get the selected deal type from the factory
        return _selectedDealType;
    }

    function setSelectedDealType(newDealType) {
        // Set the _selectedDealType in the factory
        angular.copy(newDealType, _selectedDealType);
    }

    function getAvailableDealTypes(category) {
        // Get the available deal types from the factory
        if (category === undefined) {
            return _availableDealTypes;
        }

        return _availableDealTypes[category];
    }

    function fetchAvailableDealTypes(params) {
        // Fetch available deal types from the API
        return $http.get(HPConfig.heroProApi + 'Loan/DealTypeOptions', { params: params }).then(function (response) {
            _availableDealTypes = response.data.Data;
        });
    }

    function submitSelectedDealType(dealTypeData) {
        // Submit the selected deal type along with all pertinent data to the API
        return $http.post(HPConfig.heroProApi + 'Loan/FundingRequest/DealType', dealTypeData).then(function (response) {
            setSelectedDealType(response.data.Data.DealType);
            $rootScope.$broadcast('DealTypeSubmitted', response.data.Data);
        });
    }

    function hasLeaseDealType() {
        // Function that returns whether any lease deal type is available
        return _availableDealTypes.Lease !== undefined;
    }

    function hasDirectPayDealType() {
        // Function that returns whether direct pay deal type is available
        var directPayDealType = _lodash2.default.find(_availableDealTypes.Purchase, function (purchaseDealType) {
            return purchaseDealType.DealTypeId === 3;
        });

        return directPayDealType !== undefined;
    }

    function resetDealType() {
        // Reset the deal type factory
        _availableDealTypes = [];
        _selectedDealType = {};
    }
}

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _selectedProductsFactory = __webpack_require__(544);

var _selectedProductsFactory2 = _interopRequireDefault(_selectedProductsFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.appDetail.addProducts.selectedProducts', []).factory('SelectedProductsFactory', _selectedProductsFactory2.default).run().name;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = selectedProductsFactory;

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

selectedProductsFactory.$inject = ['HPConfig', '$http', '$q', 'AddProductsConfig', '$filter']; // angular
// .module("HeroPRO")
// .factory("SelectedProductsFactory", selectedProductsFactory);

/* @ngInject */
function selectedProductsFactory(HPConfig, $http, $q, AddProductsConfig, $filter) {
  var getProductPromise = void 0;
  var getMaxTermPromise = void 0;
  var PREPAY_RESET = {
    title: 'No Prepayment', amount: 0, prepayCAPI: false, prepayFees: false
  };
  var savedProducts = []; // Copy of products that have been saved to the server
  var selectedProducts = []; // Working copy of products
  var selectedTerm = void 0;
  var interestAndFees = {
    ClosingCosts: 0, CAPI: 0, ProjectAmount: 0, TotalCost: 0
  };
  var prepayOptions = [];
  var selectedPrepayment = PREPAY_RESET;
  var isDirty = false;
  var refreshModal = false;

  function getIsCartDirty() {
    return isDirty;
  }

  function setIsCartDirty(isDirtySetter) {
    isDirty = isDirtySetter;
  }

  function getRefreshModal() {
    return refreshModal;
  }

  function setRefreshModal(refreshModalSetter) {
    refreshModal = refreshModalSetter;
  }

  function removeProducts(FundingRequestId, prodsToDelete) {
    return $http.post(HPConfig.heroProApi + 'Product/RemoveProducts', { FundingRequestId: FundingRequestId, ImprovementIds: prodsToDelete });
  }

  function reset() {
    selectedProducts = _angular2.default.copy(savedProducts);
    isDirty = false;
  }

  function resetSelectedProducts() {
    savedProducts = [];
    selectedProducts = [];
  }

  function buildProductForSaving(product) {
    var prodToSave = {
      DiscountAmount: 0,
      FinancingAmount: product.InitialRequested,
      ImprovementId: product.ImprovementId === undefined ? 0 : product.ImprovementId,
      IsDiscountApplied: false,
      MonthlyFinancingAmount: 0,
      ProductId: product.EEProductId === undefined ? product.Product.EEProductId : product.EEProductId,
      ProductTypeId: product.EETypeId === undefined ? product.Product.ProductCategory.ProductType.EETypeId : product.EETypeId,
      Attributes: []
    };
    var isQuantityAdded = false;
    if (!_lodash2.default.isEmpty(product.ImprovementDetails)) {
      _lodash2.default.each(product.ImprovementDetails, function (option) {
        var optToSave = {
          EEProductAttributeName: option.EEProductAttributeName,
          EEProductAttributeNameId: option.EEProductAttributeNameId,
          ImprovementDetailId: option.ImprovementDetailId,
          Options: []
        };
        if (option.Value !== undefined) {
          optToSave.ImprovementDetailValue = option.Value;
        }
        if (_lodash2.default.contains(AddProductsConfig.quantityEEProductAttributeNameIds, option.EEProductAttributeNameId)) {
          optToSave.ImprovementDetailValue = product.quantity;
          isQuantityAdded = true;
        }
        _lodash2.default.each(option.AtrributeOptionDetails, function (optDetail) {
          var optDetailToSave = {
            EEProductAttributeOptionId: optDetail.EEProductAttributeOptionId,
            OptionName: optDetail.EEProductAttributeOptionName
          };
          optToSave.Options.push(optDetailToSave);
        });
        prodToSave.Attributes.push(optToSave);
      });
    }
    if (!isQuantityAdded) {
      // if quantity wasn't added
      var attributes = product.InputAttributes || product.Product.Attributes;
      var quantAttribute = _lodash2.default.find(attributes, function (attribute) {
        return _lodash2.default.contains(AddProductsConfig.quantityEEProductAttributeNameIds, attribute.ProductAttributeNameId);
      });
      if (quantAttribute !== undefined && quantAttribute !== null) {
        var qtyToSave = {
          EEProductAttributeName: quantAttribute.Name,
          EEProductAttributeNameId: quantAttribute.ProductAttributeNameId,
          ImprovementDetailId: 0,
          ImprovementDetailValue: product.quantity,
          Options: []
        };
        prodToSave.Attributes.push(qtyToSave);
      }
    }
    return prodToSave;
  }

  function getProductsForSaving() {
    var productSet = [];
    _lodash2.default.each(selectedProducts, function (category) {
      _lodash2.default.each(category.products, function (prodContainer) {
        var newProdContainer = {};
        if (!prodContainer.primaryProduct.IsDeleted) {
          var primaryProdToSave = buildProductForSaving(prodContainer.primaryProduct);
          newProdContainer.primaryProduct = primaryProdToSave;
        }
        _lodash2.default.each(prodContainer.relatedProducts, function (related) {
          if (!related.IsDeleted) {
            newProdContainer.relatedProducts = newProdContainer.relatedProducts || [];
            var relatedProdToSave = buildProductForSaving(related);
            newProdContainer.relatedProducts.push(relatedProdToSave);
          }
        });
        productSet.push(newProdContainer);
      });
    });
    return productSet;
  }

  function updateInstallDetails(product, details) {
    details = details || product.ImprovementDetails;
    // get input attributes
    var inputAttributeIds = [];
    _lodash2.default.each(_lodash2.default.where(product.Attributes, { IsInputAttribute: true }), function (input) {
      // we only want input attributes that are populated on the product screen
      if (_lodash2.default.contains(AddProductsConfig.quantityEEProductAttributeNameIds, input.ProductAttributeNameId)) {
        inputAttributeIds.push(input.ProductAttributeNameId);
      }
    });

    var installDetails = '';
    _lodash2.default.each(details, function (detail) {
      // is it an install detail
      if (!_lodash2.default.contains(inputAttributeIds, detail.EEProductAttributeNameId) && !_lodash2.default.contains(AddProductsConfig.quantityEEProductAttributeNameIds, detail.EEProductAttributeNameId)) {
        // is it a number or text input
        if (_lodash2.default.isNumber(detail.Value) || !_lodash2.default.isEmpty(detail.Value)) {
          installDetails += _lodash2.default.isEmpty(installDetails) ? '' : ',  ';
          installDetails += (detail.DisplayName || detail.EEProductAttributeName) + ': ';
          installDetails += ' ' + detail.Value;
        } else if (!_lodash2.default.isEmpty(detail.AtrributeOptionDetails)) {
          // it was a radio, dropdown, checkbox
          // was there a choice made - could be an unselected checkbox install detail
          installDetails += _lodash2.default.isEmpty(installDetails) ? '' : ',  ';
          installDetails += (detail.DisplayName || detail.EEProductAttributeName) + ': ';
          _lodash2.default.each(detail.AtrributeOptionDetails, function (optionDetail) {
            installDetails += ' ' + optionDetail.EEProductAttributeOptionName;
          });
        }
      }
    });
    return installDetails;
  }

  function setProductCartAttributes(product, rawProduct) {
    var productTypeId = rawProduct.Product.ProductCategory.ProductType.ProductTypeId;
    product.AmountField = true;
    product.AmountPlaceholder = '$0.00';
    product.QtyField = true;
    product.QtyPlaceholder = 'QTY';
    product.IsDeleted = false;
    product.HasInstallDetails = false;
    product.InstallationDetails = '';
    product.HideEditInstallDetails = false;

    // making sure we pull attributes from the Product if they are missing
    var attributes = rawProduct.Attributes || rawProduct.Product.Attributes;

    // pull the input attributes out, so processRawProductQuantity can find them
    product.InputAttributes = _lodash2.default.filter(attributes, { IsInputAttribute: true });

    // set non input attributes
    product.Attributes = _lodash2.default.reject(attributes, { IsInputAttribute: true });

    // Installation details
    if (!_lodash2.default.isEmpty(product.ImprovementDetails) && _lodash2.default.isEmpty(rawProduct.ImprovementDetails)) {
      product.InstallationDetails = updateInstallDetails(rawProduct, product.ImprovementDetails);
    }
    // local Install details will always overwrite db
    if (!_lodash2.default.isEmpty(rawProduct.ImprovementDetails)) {
      product.ImprovementDetails = rawProduct.ImprovementDetails;
      product.InstallationDetails = updateInstallDetails(rawProduct);
    }
    product.HasInstallDetails = !_lodash2.default.isEmpty(product.InstallationDetails);

    // amount for inverter and copy solar panel install details
    if (_lodash2.default.contains(AddProductsConfig.solarInverterProductTypeIds, productTypeId) && product.ParentId) {
      product.AmountField = false;
      product.InitialRequested = 0;
    }
    if (_lodash2.default.contains(AddProductsConfig.hideQtyFieldProductTypes, productTypeId)) {
      product.QtyField = false;
      product.quantity = 1;
    }
    if (_lodash2.default.contains(AddProductsConfig.hideEditInstallDetailsProductTypes, productTypeId)) {
      product.HideEditInstallDetails = true;
    }
    // hide install details for product types without install detail requirements
    if (_lodash2.default.contains(AddProductsConfig.solarPanelProductTypeIds, productTypeId) || AddProductsConfig.miniSplitHeatPumpProductTypeId === productTypeId) {
      product.HasInstallDetails = false;
    }

    if (_lodash2.default.contains(AddProductsConfig.lnftProductTypes, productTypeId)) {
      product.QtyPlaceholder = 'Ft';
    } else if (_lodash2.default.contains(AddProductsConfig.sqftProductTypes, productTypeId)) {
      product.QtyPlaceholder = 'Sq/Ft';
    }
  }

  function processRawProductQuantity(rawProduct) {
    // Look for the value of the quantity attribute in improvement details
    var EEQuantityAttribute = _lodash2.default.find(rawProduct.ImprovementDetails, function (improvementDetail) {
      return _lodash2.default.contains(AddProductsConfig.quantityEEProductAttributeNameIds, improvementDetail.EEProductAttributeNameId);
    });
    rawProduct.quantity = EEQuantityAttribute !== undefined ? Number(EEQuantityAttribute.Value) : '';

    // Look for the definition of the quantity attribute from Product.Attributes
    var quantityAttribute = _lodash2.default.find(rawProduct.InputAttributes, function (attribute) {
      return _lodash2.default.contains(AddProductsConfig.quantityEEProductAttributeNameIds, attribute.ProductAttributeNameId);
    });

    rawProduct.quantityAttribute = quantityAttribute;
    // Parse the min and max values from the Format string
    if (rawProduct.quantityAttribute && rawProduct.quantityAttribute.Format) {
      rawProduct.quantityAttribute.minValue = rawProduct.quantityAttribute.Format.slice(rawProduct.quantityAttribute.Format.indexOf('min:') + 4, rawProduct.quantityAttribute.Format.indexOf('|'));
      rawProduct.quantityAttribute.maxValue = rawProduct.quantityAttribute.Format.slice(rawProduct.quantityAttribute.Format.indexOf('max:') + 4, rawProduct.quantityAttribute.Format.lastIndexOf('|'));
    }

    return rawProduct;
  }

  function processContainerInstallationDetails(prodContainer) {
    // currently only solar needs Install details at the container level
    if (prodContainer.primaryProduct.Product.ProductCategory.ProductCategoryId === 2 && prodContainer.relatedProducts && prodContainer.relatedProducts.length > 0) {
      // if there are not related products i.e. we have a single solar inverter, don't copy install details.
      prodContainer.ContainerDeleted = false;
      prodContainer.InstallationDetails = '';
      prodContainer.InstallationDetails += prodContainer.primaryProduct.InstallationDetails;
      _lodash2.default.each(prodContainer.relatedProducts, function (prod) {
        prodContainer.InstallationDetails += prod.InstallationDetails;
      });
      prodContainer.HasInstallDetails = !_lodash2.default.isEmpty(prodContainer.InstallationDetails);
    }
  }

  function processRawProducts(rawProductData) {
    // This function takes the raw product data from the API and transforms
    // it into a format that is better suited for display in the UI
    var processedProductData = [];

    _lodash2.default.each(rawProductData, function (prodContainer) {
      // set the attributes used by the UI
      setProductCartAttributes(prodContainer.primaryProduct, prodContainer.primaryProduct);
      processRawProductQuantity(prodContainer.primaryProduct);
      // set the attributes for the related products
      _lodash2.default.each(prodContainer.relatedProducts, function (relatedProd) {
        setProductCartAttributes(relatedProd, relatedProd);
        processRawProductQuantity(relatedProd);
      });
      // process the install details at the container level for solar
      processContainerInstallationDetails(prodContainer);

      // See if the category of this product already exists in processedProductData
      var categoryFound = _lodash2.default.find(processedProductData, function (processedProduct) {
        return prodContainer.primaryProduct.Product.ProductCategory.ProductCategoryId === processedProduct.category.ProductCategoryId;
      });

      if (_lodash2.default.isEmpty(categoryFound)) {
        // Category does not exist in processedProductData
        var newCategory = {
          category: _lodash2.default.omit(prodContainer.primaryProduct.Product.ProductCategory, 'ProductType'),
          products: []
        };
        newCategory.products.push(prodContainer);
        processedProductData.push(newCategory);
      } else {
        // Category already exists in processedProductData
        categoryFound.products.push(prodContainer);
      }
    });

    return processedProductData;
  }

  function setSavedProducts(newSavedProducts) {
    savedProducts = newSavedProducts;
  }

  function setSelectedProducts(newSelectedProducts) {
    if (selectedProducts.length === 0) {
      selectedProducts = newSelectedProducts;
    } else {
      _lodash2.default.each(newSelectedProducts, function (newCategory) {
        var categoryFound = _lodash2.default.find(selectedProducts, function (currentCategory) {
          return newCategory.category.ProductCategoryId === currentCategory.category.ProductCategoryId;
        });
        if (categoryFound === undefined) {
          // it's a new category
          selectedProducts.push(newCategory);
        } else {
          // category exists now lets merge the products
          _lodash2.default.each(newCategory.products, function (newProduct) {
            // find the product
            var foundProduct = _lodash2.default.find(categoryFound.products, function (product) {
              return newProduct.EEProductId === product.EEProductId;
            });
            // if there is no product, add it, otherwise leave it.
            if (foundProduct === undefined) {
              categoryFound.products.push(newProduct);
            }
          });
        }
      });
    }
  }

  function saveAddProducts(FundingRequestId, callback) {
    var addProds = {
      FundingRequestId: FundingRequestId,
      Products: getProductsForSaving()
    };
    $http.post(HPConfig.heroProApi + 'Loan/FundingRequest/Products', addProds).then(function (response) {
      // ResultCode will only be present with a number, currently only code 1 is an error
      if (response.data.ResultCode && response.data.ResultCode !== 1) {
        // Shouldn't really need to do this, but the API is returning PrimaryProduct & RelatedProducts
        // and I made the code on the front-end reference primaryProduct & relatedProducts (case sensitive) - MS
        _lodash2.default.each(response.data.Data.SavedProducts, function (productContainer) {
          productContainer.primaryProduct = _angular2.default.copy(productContainer.PrimaryProduct);
          delete productContainer.PrimaryProduct;
          productContainer.relatedProducts = _angular2.default.copy(productContainer.RelatedProducts);
          delete productContainer.RelatedProducts;
        });

        // done to reset cart, selected products should be moved to saved products after a
        // successful save.
        resetSelectedProducts();
        var processedProductData = processRawProducts(response.data.Data.SavedProducts);
        setSavedProducts(_angular2.default.copy(processedProductData));
        setSelectedProducts(_angular2.default.copy(processedProductData));
      }
      callback(response);
    });
  }

  function saveProducts(FundingRequestId, callback) {
    // remove deleted products
    var productsToDelete = [];
    _lodash2.default.each(savedProducts, function (category) {
      var currentStateCategory = _lodash2.default.find(selectedProducts, function (foundCat) {
        return category.category.ProductCategoryId === foundCat.category.ProductCategoryId;
      });

      // All products in the category have been deleted, add them all to productsToDelete
      if (currentStateCategory === undefined) {
        _lodash2.default.each(category.products, function (prodContainer) {
          productsToDelete.push(prodContainer.primaryProduct.ImprovementId);
          _lodash2.default.each(prodContainer.relatedProducts, function (related) {
            productsToDelete.push(related.ImprovementId);
          });
        });
      }

      // Not all products in the category have been deleted, determine which to add to productsToDelete
      if (currentStateCategory !== undefined) {
        _lodash2.default.each(category.products, function (prodContainer) {
          var currentStateProd = _lodash2.default.find(currentStateCategory.products, function (foundProd) {
            return prodContainer.primaryProduct.ImprovementId === foundProd.primaryProduct.ImprovementId && foundProd.primaryProduct.IsDeleted === false;
          });
          if (currentStateProd === undefined) {
            productsToDelete.push(prodContainer.primaryProduct.ImprovementId);
            // we assume all related products will be deleted with the primary product
            _lodash2.default.each(prodContainer.relatedProducts, function (related) {
              productsToDelete.push(related.ImprovementId);
            });
          }
        });
      }
    });

    if (productsToDelete.length > 0) {
      // remove product first wait for the response then save products
      removeProducts(FundingRequestId, productsToDelete).then(function () {
        // add/update remaining products
        saveAddProducts(FundingRequestId, callback);
      });
    } else {
      // add/update remaining products
      saveAddProducts(FundingRequestId, callback);
    }
  }

  function createDocuments(data) {
    return $http.post(HPConfig.heroProApi + 'Loan/GenerateFinancingDocs', data).then(function (response) {
      return response;
    });
  }

  function getAddedProducts(params, clearSelectedProducts) {
    if (clearSelectedProducts) {
      resetSelectedProducts();

      return $http.get(HPConfig.heroProApi + 'Loan/FundingRequest/Products', { params: params }).then(function (response) {
        // Shouldn't really need to do this, but the API is returning PrimaryProduct & RelatedProducts
        // and I made the code on the front-end reference primaryProduct & relatedProducts (case sensitive) - MS
        _lodash2.default.each(response.data.Data.SavedProducts, function (productContainer) {
          productContainer.primaryProduct = _angular2.default.copy(productContainer.PrimaryProduct);
          delete productContainer.PrimaryProduct;
          productContainer.relatedProducts = _angular2.default.copy(productContainer.RelatedProducts);
          delete productContainer.RelatedProducts;
        });

        var processedProductData = processRawProducts(response.data.Data.SavedProducts);
        setSavedProducts(_angular2.default.copy(processedProductData));
        setSelectedProducts(_angular2.default.copy(processedProductData));
      });
    }

    // This needs to be optimized. Returning an empty promise for now since the caller expects it. - MS
    return $q(function (resolve) {
      // update the container for any possible edits
      _lodash2.default.each(selectedProducts, function (category) {
        _lodash2.default.each(category.products, function (prodContainer) {
          processContainerInstallationDetails(prodContainer);
        });
      });
      resolve();
    });
  }

  function getProduct(params) {
    getProductPromise = $q(function (resolve) {
      $http.get(HPConfig.heroProApi + 'Product/GetProduct', { params: params }).then(function (response) {
        resolve(response);
      });
    });
    return getProductPromise;
  }

  function getMaxTerm(data) {
    getMaxTermPromise = $q(function (resolve) {
      $http.post(HPConfig.heroProApi + 'Product/GetMaxTerm', data).then(function (response) {
        resolve(response);
      });
    });
    return getMaxTermPromise;
  }

  function getSelectedProducts() {
    return selectedProducts;
  }

  function getSelectedProductsCount() {
    var totalProducts = 0;

    _lodash2.default.each(selectedProducts, function (productCategory) {
      totalProducts += productCategory.products.length;
    });

    return totalProducts;
  }

  function getSavedProducts() {
    return savedProducts;
  }

  function processProductContainer(rawProductContainer) {
    var newProductContainer = {
      primaryProduct: {},
      relatedProducts: []
    };

    // PrimaryProduct
    setProductCartAttributes(newProductContainer.primaryProduct, rawProductContainer.primaryProduct);
    newProductContainer.primaryProduct.InitialRequested = '';
    newProductContainer.primaryProduct.quantity = '';
    newProductContainer.primaryProduct.Product = _angular2.default.copy(rawProductContainer.primaryProduct.Product);
    newProductContainer.primaryProduct.Years = '';
    processRawProductQuantity(newProductContainer.primaryProduct);

    // RelatedProducts
    _lodash2.default.each(rawProductContainer.relatedProducts, function (relatedProduct, index) {
      newProductContainer.relatedProducts.push(relatedProduct);
      setProductCartAttributes(newProductContainer.relatedProducts[index], relatedProduct);
      newProductContainer.relatedProducts[index].AmountField = false;
      newProductContainer.relatedProducts[index].InitialRequested = 0;
      newProductContainer.relatedProducts[index].quantity = '';
      newProductContainer.relatedProducts[index].Product = _angular2.default.copy(relatedProduct.Product);
      newProductContainer.relatedProducts[index].Years = '';
      processRawProductQuantity(relatedProduct);
    });

    // add category level attributes
    processContainerInstallationDetails(newProductContainer);

    var categoryFound = _lodash2.default.find(selectedProducts, function (selectedProduct) {
      return rawProductContainer.primaryProduct.Product.ProductCategory.ProductCategoryId === selectedProduct.category.ProductCategoryId;
    });

    if (categoryFound !== undefined) {
      categoryFound.products.unshift(newProductContainer);
      // move category to top
      var index = _lodash2.default.findIndex(selectedProducts, function (selectedProduct) {
        return rawProductContainer.primaryProduct.Product.ProductCategory.ProductCategoryId === selectedProduct.category.ProductCategoryId;
      });
      selectedProducts.splice(index, 1);
      selectedProducts.unshift(categoryFound);
    } else {
      // Category does not exist in processedProductData
      categoryFound = {
        category: _lodash2.default.omit(newProductContainer.primaryProduct.Product.ProductCategory, 'ProductType'),
        products: []
      };
      categoryFound.products.unshift(newProductContainer);
      // push into current state
      selectedProducts.unshift(categoryFound);
    }
  }

  function extractProductAmount(product) {
    if (product.InitialRequested !== undefined && product.InitialRequested !== null && product.InitialRequested !== '') {
      if (typeof product.InitialRequested === 'string') {
        product.InitialRequested = product.InitialRequested.replace(/[^0-9.]+/g, '');
      }
      return product.IsDeleted ? 0 : parseFloat(product.InitialRequested);
    }
    return 0;
  }

  function getProductSubtotal(products) {
    var subTotal = 0.00;
    // might need to new-up this
    var productSet = selectedProducts;
    // this allows controllers to use this logic on external set of products
    // and maintains DRY
    if (!_lodash2.default.isEmpty(products)) {
      productSet = products;
    }

    _lodash2.default.each(productSet, function (productCategory) {
      _lodash2.default.each(productCategory.products, function (product) {
        subTotal += extractProductAmount(product.primaryProduct);
        _lodash2.default.each(product.relatedProducts, function (relatedProd) {
          subTotal += extractProductAmount(relatedProd);
        });
      });
    });

    return subTotal;
  }

  function getFinancingTerm() {
    if (!_lodash2.default.isEmpty(selectedTerm)) {
      return selectedTerm.years;
    }
    if (selectedProducts[0] !== undefined) {
      return selectedProducts[0].products[0].primaryProduct.Years;
    }
    return undefined;
  }

  function setSelectedTerm(term) {
    selectedTerm = term;
  }

  function buildPrePayOptions() {
    var totalIntFees = interestAndFees.TotalCost - interestAndFees.ProjectAmount;
    prepayOptions = [];
    prepayOptions.push({
      title: 'No Prepayment', amount: 0, prepayCAPI: false, prepayFees: false
    });
    prepayOptions.push({
      title: 'Prepay Interest (' + $filter('currency')(interestAndFees.CAPI, '$', 2) + ')', amount: interestAndFees.CAPI, prepayCAPI: true, prepayFees: false
    });
    prepayOptions.push({
      title: 'Prepay Fees (' + $filter('currency')(interestAndFees.ClosingCosts, '$', 2) + ')', amount: interestAndFees.ClosingCosts, prepayCAPI: false, prepayFees: true
    });
    prepayOptions.push({
      title: 'Prepay Interest & Fees (' + $filter('currency')(totalIntFees, '$', 2) + ')', amount: totalIntFees, prepayCAPI: true, prepayFees: true
    });
  }

  function getInterestAndFees(appInfo) {
    selectedPrepayment = PREPAY_RESET;
    return $q(function (resolve) {
      if (_lodash2.default.isEmpty(appInfo) || !_lodash2.default.isObject(appInfo)) {
        resolve(interestAndFees = {
          ClosingCosts: 0, CAPI: 0, ProjectAmount: 0, TotalCost: 0
        });
      } else {
        var loanData = {
          PlanId: appInfo.PlanId,
          PlanTermSetId: appInfo.PlanTermSetId,
          TermSetId: appInfo.TermSetId,
          Term: getFinancingTerm(),
          ProjectAmount: getProductSubtotal(),
          PrepayCAPI: appInfo.ClosingPrepayCAPI,
          PrepayFees: appInfo.ClosingPrepayFees,
          ApplicationDate: appInfo.ApplicationDate,
          ApprovedThroughDate: appInfo.ApplicationExpirationDate
        };
        $http.post(HPConfig.heroProApi + 'Product/GetFeesAndCAPI', loanData).then(function (response) {
          if (!_lodash2.default.isEmpty(response.data.Data)) {
            interestAndFees = response.data.Data;
            buildPrePayOptions();
          }
          resolve(interestAndFees);
        });
      }
    });
  }

  function getPrepayOptions() {
    return prepayOptions;
  }

  function setPrepayment(prepayOption) {
    selectedPrepayment = prepayOption;
  }

  function getPrePayment() {
    return selectedPrepayment;
  }

  function getProjectTotal(products) {
    var fees = interestAndFees.TotalCost - interestAndFees.ProjectAmount - selectedPrepayment.amount;
    return getProductSubtotal(products) + fees;
  }

  function addProductContainer(productContainer) {
    return $q(function (resolve) {
      processProductContainer(productContainer);
      getSelectedProductsCount();
      isDirty = true;
      resolve();
    });
  }

  function removeDeletedProducts(cartState) {
    _lodash2.default.each(cartState, function (category) {
      _lodash2.default.each(category.products, function (product) {
        if (product.IsDeleted) {
          category.products = _lodash2.default.without(category.products, product);
        }
      });
      if (category.products.length === 0) {
        cartState = _lodash2.default.reject(cartState, function (cartcategory) {
          return category.category.ProductCategoryId === cartcategory.category.ProductCategoryId;
        });
      }
    });
    selectedProducts = cartState;
  }

  /*
  function reorderSolarProducts(category) {
      if (!_.isEmpty(category) && category.category.ProductCategoryId === 2) {
          category.products = _.sortBy(category.products, function (product) {
              return product.Product.ProductCategory.ProductType.ProductTypeId;
          });
      }
  }
  */

  function allProductsDeleted() {
    return _lodash2.default.every(selectedProducts, function (category) {
      return category.CategoryDeleted === true;
    });
  }

  return {
    getAddedProducts: getAddedProducts,
    getSelectedProducts: getSelectedProducts,
    getSelectedProductsCount: getSelectedProductsCount,
    getSavedProducts: getSavedProducts,
    getProductSubtotal: getProductSubtotal,
    getFinancingTerm: getFinancingTerm,
    getInterestAndFees: getInterestAndFees,
    getPrePayment: getPrePayment,
    getProjectTotal: getProjectTotal,
    getMaxTerm: getMaxTerm,
    getProduct: getProduct,
    addProductContainer: addProductContainer,
    removeDeletedProducts: removeDeletedProducts,
    saveProducts: saveProducts,
    createDocuments: createDocuments,
    allProductsDeleted: allProductsDeleted,
    setSelectedTerm: setSelectedTerm,
    getPrepayOptions: getPrepayOptions,
    setPrepayment: setPrepayment,
    getIsCartDirty: getIsCartDirty,
    setIsCartDirty: setIsCartDirty,
    getRefreshModal: getRefreshModal,
    setRefreshModal: setRefreshModal,
    reset: reset,
    updateInstallDetails: updateInstallDetails
  };
}

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = addProductsFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

addProductsFactory.$inject = ["$http", "HPConfig", "FRInformationFactory", "$q"]; // angular
//     .module("HeroPRO")
//     .factory("AddProductsFactory", addProductsFactory);

/* @ngInject */
function addProductsFactory($http, HPConfig, FRInformationFactory, $q) {
    var _docGenPromise = null;
    var _moduleData = null;
    var _modules = {
        dealTypePurchase: {
            visible: false
        },
        dealTypeLease: {
            visible: false
        },
        productTypes: {
            visible: false
        },
        recentProducts: {
            visible: false
        },
        filterProducts: {
            visible: false
        },
        activeProduct: {
            visible: false
        },
        selectedProducts: {
            visible: false
        },
        caseCreation: {
            visible: false
        },
        docGenProcessing: {
            visible: false
        }
    };

    return {
        getModules: getModules,
        setVisibleModules: setVisibleModules,
        getAddedProductsCase: getAddedProductsCase,
        setDocGenPromise: setDocGenPromise,
        getDocGenPromise: getDocGenPromise,
        createAddProductCase: createAddProductCase,
        getModuleData: getModuleData,
        setModuleData: setModuleData,
        resetAddProductsFactory: resetAddProductsFactory,
        openAddProductsWebsite: openAddProductsWebsite
    };

    function getModules() {
        return _modules;
    }

    // visibleModules: array of stings, names of modules
    function setVisibleModules(visibleModules) {
        // Sets visible=false for all modules except for those passed in
        _lodash2.default.each(_modules, function (module, moduleKey) {
            var moduleFound = _lodash2.default.find(visibleModules, function (visibleModule) {
                return moduleKey === visibleModule;
            });
            module.visible = moduleFound !== undefined;
        });
    }

    // moduleData: json object, generic data to be shared between modules, outside of factories
    function setModuleData(key, value) {
        _moduleData = _moduleData || {};
        _moduleData[key] = value;
    }

    // this is for retrieving shared module data
    function getModuleData(key) {
        return _moduleData[key];
    }

    function getAddedProductsCase(fundingRequestId) {
        return $http.get(HPConfig.heroProApi + "Case/AddProductCase", {
            params: { fundingRequestId: fundingRequestId }
        });
    }

    function setDocGenPromise(newDocGenPromise) {
        _docGenPromise = newDocGenPromise;
    }

    function getDocGenPromise() {
        return _docGenPromise;
    }

    function createAddProductCase(data) {
        if (_moduleData.caseCreation && _lodash2.default.isObject(_moduleData.caseCreation)) {
            data.Notes = _moduleData.caseCreation.ResultStatus + ", MessageSubject: " + _moduleData.caseCreation.Data.MessageSubject + ", Message: " + _moduleData.caseCreation.Data.Message;
        }
        return $http.post(HPConfig.heroProApi + "Case/AddProductCase", data).then(function (response) {
            return response;
        }).catch(function (response) {
            return $q.reject(response.data);
        });
    }

    function resetAddProductsFactory() {
        _moduleData = null;
    }

    function openAddProductsWebsite() {
        var appInfo = FRInformationFactory.getAppInfo();
        var link = HPConfig.addProductsWebLink;
        link += "/overview/" + appInfo.FundingRequestId + "/false";
        link += "?token=" + btoa(localStorage.getItem("ls.authorizationData")) + "&returnUrl=" + btoa(window.location.href);
        window.open(link, "_self");
    }
}

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _uploadDocumentsModal = __webpack_require__(547);

var _uploadDocumentsModal2 = _interopRequireDefault(_uploadDocumentsModal);

var _esignDocumentsController = __webpack_require__(563);

var _esignDocumentsController2 = _interopRequireDefault(_esignDocumentsController);

var _fundingDocumentsController = __webpack_require__(564);

var _fundingDocumentsController2 = _interopRequireDefault(_fundingDocumentsController);

var _documentLinkFactory = __webpack_require__(566);

var _documentLinkFactory2 = _interopRequireDefault(_documentLinkFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.appDetail.documents', [_uploadDocumentsModal2.default]).controller('EsignDocumentsController', _esignDocumentsController2.default).controller('FundingDocumentsController', _fundingDocumentsController2.default).factory('DocumentLink', _documentLinkFactory2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/appDetail/documents/disabledDocuments.html', __webpack_require__(567)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/documents/esignDocumentsTemplate.html', __webpack_require__(568)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/documents/financialDocumentsTemplate.html', __webpack_require__(569)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/documents/fundingDocumentsTemplate.html', __webpack_require__(570)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/documents/invalidDocumentsTemplate.html', __webpack_require__(571)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/documents/otherDocumentsTemplate.html', __webpack_require__(572)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _documentPreviewController = __webpack_require__(548);

var _documentPreviewController2 = _interopRequireDefault(_documentPreviewController);

var _fileUploadController = __webpack_require__(550);

var _fileUploadController2 = _interopRequireDefault(_fileUploadController);

var _uploadModalController = __webpack_require__(551);

var _uploadModalController2 = _interopRequireDefault(_uploadModalController);

__webpack_require__(553);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// no controller


exports.default = _angular2.default.module('app.appDetail.documents.uploadDocuments', []).controller('DocumentPreviewController', _documentPreviewController2.default).controller('FileUploadController', _fileUploadController2.default).controller('UploadModalController', _uploadModalController2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/appDetail/documents/uploadDocumentsModal/completionCertificateChecklistTemplate.html', __webpack_require__(554)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/documents/uploadDocumentsModal/documentDesignation.html', __webpack_require__(555)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/documents/uploadDocumentsModal/documentPreviewTemplate.html', __webpack_require__(556)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/documents/uploadDocumentsModal/fileUploadTemplate.html', __webpack_require__(557)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/documents/uploadDocumentsModal/hicChecklistTemplate.html', __webpack_require__(558)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/documents/uploadDocumentsModal/invoiceChecklistTemplate.html', __webpack_require__(559)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/documents/uploadDocumentsModal/permitChecklistTemplate.html', __webpack_require__(560)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/documents/uploadDocumentsModal/solarLeaseAgreementChecklistTemplate.html', __webpack_require__(561)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/documents/uploadDocumentsModal/uploadModalTemplate.html', __webpack_require__(562)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = documentPreviewController;

__webpack_require__(549);

documentPreviewController.$inject = ['$scope']; // angular
//     .module("HeroPRO")
//     .controller("DocumentPreviewController", documentPreviewController);

/* @ngInject */
function documentPreviewController($scope) {
    $scope.pdfUrl = '';

    $scope.$on('HPFileUploaded', function (event, data, file) {
        var uploadedFile = file;
        $scope.$apply(function () {
            $scope.pdfUrl = uploadedFile.downloadUrl;
        });
    });
}

/***/ }),
/* 549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = fileUploadController;
fileUploadController.$inject = ["$scope"];
// angular
//     .module("HeroPRO")
//     .controller("FileUploadController", fileUploadController);

/* @ngInject */
function fileUploadController($scope) {
    var vm = this;

    vm.uploadFile = function () {
        $scope.processDropzone();
    };

    vm.reset = function () {
        $scope.resetDropzone();
    };

    vm.uploadButtonClicked = function ($event) {
        $event.preventDefault();
    };
}

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = uploadModalController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(552);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

uploadModalController.$inject = ['$scope', 'documentInfo', 'FRInformationFactory', 'FRClosingFactory', 'raSpinnerService', '$rootScope', '$state', '$stateParams', '$analytics', 'HPPipelineStages', 'HPConditionTypes']; // angular
//     .module("HeroPRO")
//     .controller("UploadModalController", uploadModalController);

/* @ngInject */
function uploadModalController($scope, documentInfo, FRInformationFactory, FRClosingFactory, raSpinnerService, $rootScope, $state, $stateParams, $analytics, HPPipelineStages, HPConditionTypes) {
    var vm = this;
    var paymentInstructionsConfirmed = false;
    vm.fileUploaded = false;
    vm.attachmendId = null;
    vm.conditionIds = [];
    vm.isGlobalFileUpload = false;
    vm.designatingDocuments = false;
    vm.designationError = false;
    vm.originalFilename = '';
    vm.documentHelperSteps = [];
    vm.designationOptions = [];
    vm.optionsByConditionType = {};
    vm.toggleDesignationOption = toggleDesignationOption;
    vm.conditionTypeName = documentInfo !== undefined ? documentInfo.ConditionTypeDetail.Name : '';
    vm.conditionTypeId = documentInfo !== undefined ? documentInfo.ConditionTypeDetail.ConditionTypeId : '';
    vm.showPDFPreviewError = false;
    vm.fundingRequest = {};
    vm.currentPipelineStageName = '';
    vm.tempFileKey = '';
    vm.hasHIC = false;
    vm.HPConditionTypes = HPConditionTypes;

    init();

    function init() {
        // Listen for the completion of the file upload
        $scope.$on('HPFileUploaded', function (event, args, file) {
            fileUploadComplete(args, file);
        });

        FRClosingFactory.getFundingRequestClosingPromise().then(function () {
            vm.fundingRequest = FRClosingFactory.getFundingRequest();
            paymentInstructionsConfirmed = FRClosingFactory.getPaymentInstructionsConfirmed();
            vm.currentPipelineStageName = _lodash2.default.find(HPPipelineStages, function (pipelineStage) {
                return pipelineStage.pipelineStageId === FRInformationFactory.getStateMachineData().PipelineStageId;
            }).name;

            if (documentInfo !== undefined) {
                // Uploading a specific document type
                vm.isGlobalFileUpload = false;
                processUploadByDocumentType();
                groupdDesignationOptionsByConditionType();

                // Set the document that was clicked on as designated
                toggleDesignationOption({
                    conditionId: documentInfo.ConditionId,
                    conditionTypeId: documentInfo.ConditionTypeDetail.ConditionTypeId,
                    selected: true,
                    label: documentInfo.Description
                });
            } else {
                // Global document upload
                vm.isGlobalFileUpload = true;
                processGlobalUpload();
                groupdDesignationOptionsByConditionType();
            }
        });
    }

    function processUploadByDocumentType() {
        _lodash2.default.each(vm.fundingRequest.ConditionDetails, function (condition) {
            if (condition.ConditionTypeDetail.ConditionTypeId === documentInfo.ConditionTypeDetail.ConditionTypeId) {
                var productName = !!condition.ConditionImprovementDetail ? condition.ConditionImprovementDetail.EETypeDetail.Name : '';
                var selected = condition.ConditionId === documentInfo.ConditionId;

                addDesignationOption(false, condition.ConditionId, condition.ConditionTypeDetail.ConditionTypeId, selected, condition.ConditionTypeDetail.Name, productName);
            }
        });
    }

    function processGlobalUpload() {
        _lodash2.default.each(vm.fundingRequest.ConditionDetails, function (condition) {
            var productName = !!condition.ConditionImprovementDetail ? condition.ConditionImprovementDetail.EETypeDetail.Name : '';
            addDesignationOption(true, condition.ConditionId, condition.ConditionTypeDetail.ConditionTypeId, false, condition.ConditionTypeDetail.Name, productName);
        });
    }

    function groupdDesignationOptionsByConditionType() {
        var showDocumentDesignation = void 0;

        // Find if there's an HIC condition
        vm.hasHIC = _lodash2.default.findWhere(vm.designationOptions, { conditionTypeId: HPConditionTypes.HIC }) !== undefined;

        vm.optionsByConditionType = _lodash2.default.groupBy(vm.designationOptions, function (option) {
            return option.conditionTypeId;
        });

        if (_lodash2.default.keys(vm.optionsByConditionType).length > 1) {
            showDocumentDesignation = true;
        } else {
            // Determine if we need to add document designation as the first helper screen
            showDocumentDesignation = _lodash2.default.find(vm.optionsByConditionType, function (option) {
                return option.length >= 1;
            });
        }

        if (showDocumentDesignation !== undefined && documentInfo === undefined) {
            vm.documentHelperSteps.unshift({
                conditionTypeId: 0,
                template: 'app/appDetail/documents/uploadDocumentsModal/documentDesignation.html'
            });
        }
    }

    function fileUploadComplete(args, file) {
        vm.tempFileKey = file.tempFileKey;
        vm.originalFilename = file.name;

        $scope.$apply(function () {
            vm.fileUploaded = true;
        });
    }

    function addDesignationOption(globalUpload, conditionId, conditionTypeId, selected, documentName, productName) {
        // Extra check to determine whether Completion Certificate or Final Invoice should be shown as an upload option
        // Also do not show Completion Certificate if the user does not have elevated access
        if ((conditionTypeId === HPConditionTypes.CompletionCertificate || conditionTypeId === HPConditionTypes.Invoice || conditionTypeId === HPConditionTypes.HIC) && paymentInstructionsConfirmed === false || conditionTypeId === HPConditionTypes.CompletionCertificate && $scope.main.userData.HasElevatedAccess === undefined) {
            return;
        }

        var designationOption = {
            conditionId: conditionId,
            conditionTypeId: conditionTypeId,
            selected: selected,
            label: globalUpload === true ? documentName + (productName !== '' ? ' for ' + productName : '') : productName
        };

        vm.designationOptions.push(designationOption);
    }

    function updateDocumentHelperSteps(toggledOption) {
        // Trying to add new helper step
        if (toggledOption.selected === true) {
            var exists = _lodash2.default.find(vm.documentHelperSteps, function (helperStep) {
                return helperStep.conditionTypeId === toggledOption.conditionTypeId;
            });

            if (exists === undefined) {
                addDocumentHelperStep(toggledOption);
            }
        }
        //
        // Trying to remove an existing helper step
        if (toggledOption.selected === false) {
            var numSelectedDocuments = 0;
            _lodash2.default.each(vm.optionsByConditionType[toggledOption.conditionTypeId], function (option) {
                if (option.selected === true) {
                    numSelectedDocuments++;
                }
            });

            if (numSelectedDocuments === 0) {
                removeDocumentHelperStep(toggledOption);
            }
        }
    }

    function addDocumentHelperStep(toggledOption) {
        switch (toggledOption.conditionTypeId) {
            case HPConditionTypes.CompletionCertificate:
                vm.documentHelperSteps.push({
                    conditionTypeId: toggledOption.conditionTypeId,
                    template: 'app/appDetail/documents/uploadDocumentsModal/completionCertificateChecklistTemplate.html'
                });
                break;
            case HPConditionTypes.Invoice:
                vm.documentHelperSteps.push({
                    conditionTypeId: toggledOption.conditionTypeId,
                    template: 'app/appDetail/documents/uploadDocumentsModal/invoiceChecklistTemplate.html'
                });
                break;
            case HPConditionTypes.InitialBuildingPermitPaperwork:
            case HPConditionTypes.ProofFinalPermitInspection:
            case HPConditionTypes.ProofInitialFinalPermit:
                vm.documentHelperSteps.push({
                    conditionTypeId: toggledOption.conditionTypeId,
                    template: 'app/appDetail/documents/uploadDocumentsModal/permitChecklistTemplate.html'
                });
                break;
            case HPConditionTypes.SolarLeasePPAAgreement:
                vm.documentHelperSteps.push({
                    conditionTypeId: toggledOption.conditionTypeId,
                    template: 'app/appDetail/documents/uploadDocumentsModal/solarLeaseAgreementChecklistTemplate.html'
                });
                break;
            case HPConditionTypes.HIC:
                vm.documentHelperSteps.push({
                    conditionTypeId: toggledOption.conditionTypeId,
                    template: 'app/appDetail/documents/uploadDocumentsModal/hicChecklistTemplate.html'
                });
                break;
        }
    }

    function removeDocumentHelperStep(toggledOption) {
        _lodash2.default.find(vm.documentHelperSteps, function (step, index) {
            if (step.conditionTypeId === toggledOption.conditionTypeId) {
                vm.documentHelperSteps.splice(index, 1);
                return true;
            }
        });
    }

    function toggleConditionSatisfied(conditionId) {
        if (_lodash2.default.contains(vm.conditionIds, conditionId)) {
            // Remove an existing conditionId
            vm.conditionIds = _lodash2.default.without(vm.conditionIds, conditionId);
        } else {
            // Add a new conditionId
            vm.conditionIds.push(conditionId);
        }
    }

    function toggleDesignationOption(toggledOption) {
        toggleConditionSatisfied(toggledOption.conditionId);
        updateDocumentHelperSteps(toggledOption);
    }

    vm.handlePrimaryButtonClick = function () {
        if (vm.documentHelperSteps.length === 1 && vm.conditionIds.length !== 0) {
            vm.finishUpload();
        } else {
            // Show the next step
            vm.documentHelperSteps.shift();
        }
    };

    vm.getPrimaryButtonText = function () {
        if (vm.documentHelperSteps.length === 1 && vm.conditionIds.length !== 0) {
            return 'Finish Upload';
        }

        return 'Next';
    };

    vm.getCurrentHelperStep = function () {
        if (!!vm.documentHelperSteps && vm.documentHelperSteps.length > 0 && vm.documentHelperSteps[0].template) {
            return vm.documentHelperSteps[0].template;
        }
    };

    vm.closeModal = function () {
        $scope.$close();
        raSpinnerService._unregister('documentUploadSpinner');
    };

    vm.finishUpload = function () {
        var eventName = vm.conditionTypeName === '' ? 'Global Upload' : vm.conditionTypeName;
        eventName = vm.currentPipelineStageName + ' ' + eventName;
        $analytics.eventTrack('Upload Project Docs', { category: 'DocsModule', label: eventName });

        vm.designatingDocuments = true;
        raSpinnerService.show('documentUploadSpinner');

        var requestTask = null;
        var params = {
            ConditionIds: vm.conditionIds
        };

        params.TempFileKey = vm.tempFileKey;
        params.FileName = vm.originalFilename;
        params.HEROId = vm.fundingRequest.FundingRequestDetail.HEROId;
        params.LoanId = vm.fundingRequest.FundingRequestDetail.LoanId;
        params.FundingRequestId = vm.fundingRequest.FundingRequestDetail.FundingRequestId;
        params.ContractorId = vm.fundingRequest.FundingRequestDetail.ContractorId;

        if (vm.conditionIds.length) {
            // Grab the first conditionId in the list and find the corresponding ConditionDetail item
            var conditionDetail = _lodash2.default.find(vm.fundingRequest.ConditionDetails, function (cd) {
                return cd.ConditionId === vm.conditionIds[0];
            });
            params.DMAttachmentTypeId = conditionDetail.ConditionTypeDetail.DMAttachmentTypeId;
        }

        requestTask = FRClosingFactory.commitAttachment(params);

        requestTask.then(function (response) {
            raSpinnerService.hide('documentUploadSpinner');
            vm.designatingDocuments = false;
            if (response.data.ResultText === 'Success') {
                vm.closeModal();
            } else {
                vm.designationError = true;
            }
            // TODO: temporarily refreshing route while we can get the new Loan anc CC state from the assignAttachmentToConditions function
            $state.go($state.current, $stateParams, { reload: true, inherit: false });
        });
    };

    $rootScope.$on('PDFPreviewError', function () {
        vm.showPDFPreviewError = true;
        $scope.$apply();
    });
}

/***/ }),
/* 552 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 553 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 554 */
/***/ (function(module, exports) {

module.exports = "<h2>Check Your Completion Certificate</h2>\n\n<ul>\n\t<li>All pages are uploaded</li>\n\t<li>All pages have the same date and time stamp</li>\n\t<li>You have signed and dated the document</li>\n\t<li>Property Owner has signed and dated the document</li>\n\t<li>If applicable, payment designees are listed</li>\n</ul>\n\n<p class=\"closing-note\">All uploaded documents will be reviewed by our closing team.</p>";

/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports = "<p class=\"designation-title\" ng-if=\"!uploadModal.isGlobalFileUpload\">What Products are Included In this {{uploadModal.conditionTypeName}}?</p>\n\n<div ng-if=\"uploadModal.isGlobalFileUpload\">\n\t<p class=\"designation-title\">Your Uploaded File</p>\n\t<p class=\"original-filename\">{{uploadModal.originalFilename}}</p>\n\t<p class=\"designation-subtitle\">Which documents are included?</p>\n</div>\n\n<div class=\"designation-option\" ng-repeat=\"option in uploadModal.designationOptions\">\n\t<div class=\"row\">\n\t\t<div class=\"col-xs-10\">\n\t\t\t<label for=\"{{option.conditionId}}\">{{option.label}}</label>\n\t\t</div>\n\t\t<div class=\"col-xs-2 text-right\">\n\t\t\t<input id=\"{{option.conditionId}}\" type=\"checkbox\" ng-model=\"option.selected\" class=\"checkbox\" ng-click=\"uploadModal.toggleDesignationOption(option)\" ng-checked=\"option.selected\">\n\t\t</div>\n\t</div>\n</div>\n";

/***/ }),
/* 556 */
/***/ (function(module, exports) {

module.exports = "\n<div>\n    <div class=\"canvas-container\">\n        <div class=\"pdf-preview-error\" ng-show=\"uploadModal.showPDFPreviewError\">\n            <p>We are sorry, preview is only available for pdf files.</p>\n            <p class=\"pdf-preview-error-note\">You can still continue with the process.</p>\n        </div>\n        <canvas id=\"pdf-canvas\"></canvas>\n    </div>\n\n    <ul class=\"document-page-numbers\">\n    \t<li ng-repeat=\"n in getArrayNumPages() track by $index\" ng-click=\"goToPage($index + 1)\" ng-class=\"{ 'selected': getCurrentPage() === $index + 1 }\">\n    \t\t<p>{{$index + 1}}</p>\n\t\t</li>\n    </ul>\n\n    <div class=\"zoom-controls\" ng-hide=\"uploadModal.showPDFPreviewError\">\n\t    <span class=\"icon icon-zoom-out\" ng-click=\"zoomOut()\"></span>\n\t    <span class=\"icon icon-zoom-in\" ng-click=\"zoomIn()\"></span>\n\t</div>\n</div>";

/***/ }),
/* 557 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n    <div class=\"col-md-12 \">\n        <form action=\"\" class=\"dropzone hp-dropzone\" dropzone=\"\" id=\"dropzone\" drop-zone-max-file-size=\"10\">\n            <div class=\"dz-default dz-message\">\n                <p class=\"icon icon-upload-document\"></p>\n                <button class=\"btn btn-primary\" ng-click=\"fileUpload.uploadButtonClicked($event)\">Click to upload</button>\n                <p class=\"draganddrop-message\">&hellip;or drag and drop a file here</p>\n            </div>\n        </form>\n    </div>\n</div>\n";

/***/ }),
/* 558 */
/***/ (function(module, exports) {

module.exports = "<h2>Check your Home Improvement Contract</h2>\n\n<p class=\"intro-note\">\n    The Contract should include the information listed below.\n    <br/><br/>\n    <b>Be sure the Contract is legible and matches the information on the Completion Certificate to avoid any funding delays.</b>\n</p>\n\n<p class=\"information-requirement\">\n    Contractor Name and License Number (if license is applicable per state guidelines)\n</p>\n\n<p class=\"information-requirement\">\n    Property Owner Name and / or Address\n</p>\n\n<p class=\"requirement-list-heading\">Project/Scope of Work</p>\n<ul>\n    <li>Contract and any addendums must be signed by the Customer.</li>\n    <li>Product information that relates to the HERO Completion Certificate.</li>\n    <li>Financing Amount</li>\n    <li class=\"no-bullet\">\n        <ul>\n            <li>If applicable, clearly indicate amounts to be paid for with HERO financing versus any amounts paid for with other financing.</li>\n        </ul>\n    </li>\n</ul>\n<p class=\"closing-note\">All uploaded documents will be reviewed by our closing team.</p>\n";

/***/ }),
/* 559 */
/***/ (function(module, exports) {

module.exports = "<h2>Check Your Invoice</h2>\n\n<p class=\"intro-note\">\n\tDoes the information below on the invoice match the information on the Completion Certificate?\n</p>\n\n<p class=\"information-requirement\">\n\tName of Contractor\n</p>\n\n<p class=\"information-requirement\">\n\tProperty Owner Name and Address\n</p>\n\n<p class=\"requirement-list-heading\">Project/Scope of Work</p>\n<ul>\n\t<li>Model #</li>\n\t<li>Manufacturer</li>\n\t<li>Quantity</li>\n\t<li>Financing Amount</li>\n\t<li>Square Foot (for Roofing, Turf, and Insulation products)</li>\n\t<li>AHRI (for HVAC products)</li>\n\t<li>R-Value (for Duct Work and Insulation products)</li>\n</ul>\n\n<p class=\"closing-note\">All uploaded documents will be reviewed by our closing team.</p>";

/***/ }),
/* 560 */
/***/ (function(module, exports) {

module.exports = "<h2>Check Your Permit</h2>\n\n<ul>\n\t<li>Property Address is correct</li>\n\t<li>Scope of Work is included</li>\n\t<li>Permit Number is visible</li>\n\t<li>City/Couny Name is visible</li>\n\t<li>Permit is final (for Roofing products)</li>\n</ul>\n\n<p class=\"closing-note\">All uploaded documents will be reviewed by our closing team.</p>";

/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports = "<h2>Check Your Solar Lease / PPA Agreement</h2>\n\n<p>Does the information below match the information on the Solar Lease / PPA Agreeement?</p>\n\n<ul>\n\t<li>Lease / PPA Company is listed on the Lease / PPA Agreement</li>\n\t<li>Property Address</li>\n\t<li>Total Amount</li>\n</ul>\n\n<p class=\"closing-note\">All uploaded documents will be reviewed by our closing team.</p>";

/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-loading-spinner\" ra-spinner name=\"documentUploadSpinner\" hide-content-when-shown=\"true\" show=\"uploadModal.desinatingDocuments\" text=\"Attaching Documents...\">\n\t<div class=\"modal-header\">\n\t    <span class=\"icon icon-delete-circle\" ng-click=\"uploadModal.closeModal();\"></span>\n\t</div>\n\n\t<div class=\"modal-body\">\n\t\t<div class=\"container\" ng-if=\"!uploadModal.designationError\">\n            <div class=\"alert alert-warning\" ng-if=\"(uploadModal.isGlobalFileUpload && uploadModal.hasHIC === true) || uploadModal.conditionTypeId === uploadModal.HPConditionTypes.HIC\">\n                <span class=\"icon icon-alert-circle-thick\"></span>\n                <b>Invoice is no longer accepted.</b> Please ensure you've uploaded a Home Improvement Contract.\n            </div>\n\t\t\t<!-- Dropzone -->\n\t\t\t<div class=\"row\" ng-if=\"!uploadModal.fileUploaded\">\n\t\t\t\t<div class=\"col-xs-12 text-center\">\n\t\t\t\t\t<div ng-include=\"'app/appDetail/documents/uploadDocumentsModal/fileUploadTemplate.html'\" ng-controller=\"FileUploadController as fileUpload\"></div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Dropzone -->\n\n\t\t\t<div class=\"row\" ng-if=\"uploadModal.fileUploaded\">\n\t\t\t\t<!-- PDF Preview -->\n\t\t\t\t<div class=\"col-xs-6 ng-pdf\" ng-controller=\"DocumentPreviewController as documentPreview\">\n\t                <ng-pdf template-url=\"app/appDetail/documents/uploadDocumentsModal/documentPreviewTemplate.html\" scale=\".6\"></ng-pdf>\n\t\t\t\t</div>\n\t\t\t\t<!-- PDF Preview -->\n\n\t\t\t\t<!-- Right column beside PDF Preview -->\n\t\t\t\t<div class=\"col-xs-6\">\n\t\t\t\t\t<div class=\"document-checklist\" ng-include=\"uploadModal.getCurrentHelperStep()\"></div>\n\t\t\t\t</div>\n\t\t\t\t<!-- Right column beside PDF Preview -->\n\t\t\t</div>\n\t\t\t<div class=\"row\" ng-if=\"uploadModal.fileUploaded\">\n\t\t\t\t<div class=\"modal-buttons col-xs-12\">\n\t\t\t\t\t<button class=\"btn btn-default pull-right\" ng-click=\"uploadModal.closeModal()\">Cancel</button>\n\t\t\t\t\t<button class=\"btn btn-primary pull-right\" ng-click=\"uploadModal.handlePrimaryButtonClick()\" ng-disabled=\"uploadModal.conditionIds.length === 0\">{{uploadModal.getPrimaryButtonText()}}</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"container\" ng-if=\"uploadModal.designationError\">\n\t\t\t<p class=\"designation-error\">Sorry, an error has occured while attaching documents. Please click <span class=\"link\" ng-click=\"uploadModal.closeModal()\">here</span> to close the modal and try again.</p>\n\t\t</div>\n\t</div>\n</div>\n";

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = eSignDocumentsController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

eSignDocumentsController.$inject = ['$scope', 'HPStateMachineConfig', 'FRInformationFactory', 'FRDocumentsFactory', '$stateParams', 'DocumentLink']; // angular
//     .module("HeroPRO")
//     .controller("EsignDocumentsController", eSignDocumentsController);

/* @ngInject */
function eSignDocumentsController($scope, HPStateMachineConfig, FRInformationFactory, FRDocumentsFactory, $stateParams, DocumentLink) {
    var vm = this;
    vm.showGetSignaturesButton = false;
    vm.CCDocument = null;
    vm.ACADocument = null;
    vm.HPStateMachineConfig = HPStateMachineConfig;
    vm.stateMachineData = {};

    init();

    /*= =======================================
     =            Public Functions            =
     ======================================== */
    vm.completionCertificateLink = function () {
        return DocumentLink.getCompletionCertificateLinkFunding($stateParams.appId, vm.CCDocument);
    };

    vm.getACALink = function () {
        return DocumentLink.getFinancialDocumentsLink(FRDocumentsFactory.getACADocument());
    };

    vm.getUploadButtonText = function () {
        if (vm.CCDocument.status.CCUploaded === true) {
            return 'Replace';
        }
        return 'Upload';
    };
    /* -----  End of Public Functions  ------*/

    function init() {
        FRInformationFactory.getFundingRequestInformationPromise().then(function () {
            vm.stateMachineData = FRInformationFactory.getStateMachineData();
        });

        FRDocumentsFactory.getFundingRequestDocumentsPromise().then(function () {
            vm.showGetSignaturesButton = FRDocumentsFactory.getSignaturesButtonVisibility();
            vm.CCDocument = FRDocumentsFactory.getCCDocument();
            vm.ACADocument = FRDocumentsFactory.getACADocument();
        });
    }
}

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = fundingDocumentsController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(565);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

fundingDocumentsController.$inject = ['$scope', '$uibModal', 'DocumentLink', '$q', 'HPStateMachineConfig', 'FRInformationFactory', 'FRClosingFactory', 'FRDocumentsFactory', 'HPPipelineStages', 'HPConditionTypes']; // angular
//     .module("HeroPRO")
//     .controller("FundingDocumentsController", fundingDocumentsController);

/* @ngInject */
function fundingDocumentsController($scope, $uibModal, DocumentLink, $q, HPStateMachineConfig, FRInformationFactory, FRClosingFactory, FRDocumentsFactory, HPPipelineStages, HPConditionTypes) {
    var vm = this;
    vm.financialDocumentsCollapsed = true;
    vm.isDocumentsSectionVisible = false;
    vm.currentPipelineStageName = '';
    vm.isLoaded = false;
    vm.invalidDocuments = [];
    vm.financialDocuments = [];
    vm.otherDocuments = [];
    vm.eSignDocuments = [];
    vm.HPConditionTypes = HPConditionTypes;

    init();

    /*= =======================================
     =            Public Functions            =
     ======================================== */
    vm.getOtherDocumentsLink = function (document) {
        if (document.LatestAttachment !== undefined) {
            return DocumentLink.getOtherDocumentsLink(document);
        }
    };

    vm.getFinancialDocumentsLink = function (document) {
        return DocumentLink.getFinancialDocumentsLink(document);
    };
    /* -----  End of Public Functions  ------*/

    /*= =======================================
     =            Private Functions            =
     ======================================== */
    function init() {
        FRDocumentsFactory.getFundingRequestDocumentsPromise().then(function () {
            vm.invalidDocuments = FRDocumentsFactory.getInvalidDocuments();
            vm.financialDocuments = FRDocumentsFactory.getFinancialDocuments();
            vm.otherDocuments = FRDocumentsFactory.getOtherDocuments();
            vm.eSignDocuments = FRDocumentsFactory.getESignDocuments();
            vm.currentPipelineStageName = _lodash2.default.find(HPPipelineStages, function (pipelineStage) {
                return pipelineStage.pipelineStageId === FRInformationFactory.getStateMachineData().PipelineStageId;
            }).name;

            // Set a flag to hide the documents section when there are no documents available
            vm.isDocumentsSectionVisible = vm.invalidDocuments.length > 0 || vm.financialDocuments.length > 0 || vm.otherDocuments.length > 0 || vm.eSignDocuments.length > 0;
            vm.isLoaded = true;
        });
    }
    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 565 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = DocumentLinkFactory;
DocumentLinkFactory.$inject = ['HPConfig', 'FRInformationFactory'];
// angular
// 	.module("HeroPRO")
// 	.factory("DocumentLink", DocumentLinkFactory);

/* @ngInject */
function DocumentLinkFactory(HPConfig, FRInformationFactory) {
    return {
        getCompletionCertificateLinkFunding: getCompletionCertificateLinkFunding,
        getOtherDocumentsLink: getOtherDocumentsLink,
        getFinancialDocumentsLink: getFinancialDocumentsLink
    };

    function getCompletionCertificateLinkFunding(fundingRequestId, document) {
        // Temporary function until all document links are coming from HEROPro API
        var attachmentLink = '',
            appInfo = FRInformationFactory.getAppInfo();

        // If attachment details do not exist, the latest attachment object is undefined. Added condition to check for CC data in appInfo for this case.
        if (document !== undefined && document !== null && document.LatestAttachment === undefined) {
            if (appInfo !== undefined && appInfo.CompletionCertificateDMDocumentID !== undefined && appInfo.CompletionCertificateDMDocumentID !== null) {
                attachmentLink = HPConfig.heroProApi + 'DocumentManagement/DownloadDocument/?dmdocumentid=' + appInfo.CompletionCertificateDMDocumentID;
            }
            return attachmentLink;
        }

        if (document.LatestAttachment !== undefined && document.LatestAttachment.AttachmentDetail.DMDocumentId !== undefined && document.LatestAttachment.AttachmentDetail.DMDocumentId !== null && document.LatestAttachment.AttachmentDetail.DMDocumentId !== '') {
            attachmentLink = HPConfig.heroProApi + 'DocumentManagement/DownloadDocument/?dmdocumentid=' + document.LatestAttachment.AttachmentDetail.DMDocumentId;
        } else if (document.LatestAttachment !== undefined && document.LatestAttachment.AttachmentDetail.DocumentId !== undefined && document.LatestAttachment.AttachmentDetail.DocumentId !== null && document.LatestAttachment.AttachmentDetail.DocumentId !== '') {
            attachmentLink = HPConfig.heroProApi + 'DocumentManagement/DownloadDocument/?dmdocumentid=' + document.LatestAttachment.AttachmentDetail.DocumentId;
        }

        return attachmentLink;
    }

    function getOtherDocumentsLink(document) {
        var attachmentLink = '';
        if (document.LatestAttachment !== undefined && document.LatestAttachment.AttachmentDetail.DMDocumentId !== undefined && document.LatestAttachment.AttachmentDetail.DMDocumentId !== null && document.LatestAttachment.AttachmentDetail.DMDocumentId !== '') {
            attachmentLink = HPConfig.heroProApi + 'DocumentManagement/DownloadDocument/?dmdocumentid=' + document.LatestAttachment.AttachmentDetail.DMDocumentId;
        } else if (document.LatestAttachment !== undefined && document.LatestAttachment.AttachmentDetail.DocumentId !== undefined && document.LatestAttachment.AttachmentDetail.DocumentId !== null && document.LatestAttachment.AttachmentDetail.DocumentId !== '') {
            attachmentLink = HPConfig.heroProApi + 'DocumentManagement/DownloadDocument/?dmdocumentid=' + document.LatestAttachment.AttachmentDetail.DocumentId;
        }

        return attachmentLink;
    }

    function getFinancialDocumentsLink(document) {
        var attachmentLink = '';
        if (document !== undefined && document !== null && document.DMDocumentID !== undefined && document.DMDocumentID !== null && document.DMDocumentID !== '') {
            attachmentLink = HPConfig.heroProApi + 'DocumentManagement/DownloadDocument/?dmdocumentid=' + document.DMDocumentID;
        } else if (document !== undefined && document !== null && document.DocumentId !== undefined && document.DocumentId !== null && document.DocumentId !== '') {
            attachmentLink = HPConfig.heroProApi + 'DocumentManagement/DownloadDocument/?dmdocumentid=' + document.DocumentId;
        }

        return attachmentLink;
    }
}

/***/ }),
/* 567 */
/***/ (function(module, exports) {

module.exports = "<p>Documents will appear here when they are available. This will include HERO Documents, Project Documents, and Financial Documents.</p>";

/***/ }),
/* 568 */
/***/ (function(module, exports) {

module.exports = "<p class=\"documents-group-title\">HERO Documents</p>\n\n<div class=\"document\" ng-repeat=\"document in fundingDocuments.eSignDocuments\">\n   <!-- Completion Certificate -->\n   <div class=\"row\" ng-class=\"{ 'completed' : eSignDocuments.CCDocument.status.CCUploaded === true || eSignDocuments.CCDocument.status.eSigned === true }\"  ng-if=\"document.ESignDocumentType === 'CC'\">\n       <div class=\"col-xs-1\">\n           <p class=\"icon icon-upload-document text-center\"></p>\n       </div>\n\n\t\t<div class=\"col-xs-9 document-details\">\n\t\t   <p class=\"document-name\" ng-class=\"{'disabled': appDetail.paymentInstructionsConfirmed() === false}\">{{ document.Description }}</p>\n\n\t\t\t<div class=\"esign-status\">\n\t\t\t\t<div ng-if=\"eSignDocuments.CCDocument.status.CCUploaded === false\">\n\t\t\t\t\t<span ng-if=\"eSignDocuments.CCDocument.status.eSigned === false\">Needs signature</span>\n\t\t\t\t\t<span ng-if=\"eSignDocuments.CCDocument.status.eSigned === true\">eSigned</span>\n\t\t\t\t</div>\n\t\t\t\t<span ng-if=\"eSignDocuments.CCDocument.status.CCUploaded === true\">Attached</span>\n\t\t   </div>\n\n\t\t   <a hp-download-link href=\"{{eSignDocuments.completionCertificateLink()}}\">Download</a>\n\t\t   <span class=\"link upload-link\" ng-if=\"appDetail.paymentInstructionsConfirmed() && appDetail.showDocumentUploadLinks() && main.userData.HasElevatedAccess === true\"\n\t\t         ng-click=\"appDetail.openUploadDocumentsModal(document)\">{{eSignDocuments.getUploadButtonText()}}</span>\n\t\t</div>\n\n\t\t<div class=\"col-xs-2 text-right document-approved\">\n\t\t\t<p ng-show=\"document.ConditionResultTypeId == 3\" class=\"step-completed icon icon-complete\"></p>\n\t\t\t<p class=\"admin-only\" ng-if=\"main.userData.HasElevatedAccess === undefined\"><span class=\"icon icon-lock\"></span>ADMIN</p>\n\t\t</div>\n\t</div>\n   <!-- Completion Certificate -->\n\n   <!-- ACA -->\n   <div class=\"row\" ng-class=\"{ 'completed' : eSignDocuments.ACADocument.status.eSigned === true || eSignDocuments.ACADocument.status.ACAUploaded === true }\" ng-if=\"document.ESignDocumentType === 'ACA'\">\n       <div class=\"col-xs-1\">\n           <p class=\"icon icon-upload-document text-center\"></p>\n       </div>\n\n       <div class=\"col-xs-9 document-details\">\n           <p class=\"document-name\">{{ document.Description }}</p>\n\n           <div class=\"esign-status\">\n\t           <span ng-if=\"eSignDocuments.ACADocument.status.ACAUploaded === true\">Attached</span>\n\t           <span ng-if=\"eSignDocuments.ACADocument.status.propertyOwnersSignatureStatus.signed === 0 && eSignDocuments.ACADocument.status.ACAUploaded === false\">Needs signature</span>\n\t           <span ng-if=\"eSignDocuments.ACADocument.status.eSigned === false && eSignDocuments.ACADocument.status.propertyOwnersSignatureStatus.signed !== 0\">Sent for eSign ({{eSignDocuments.ACADocument.status.propertyOwnersSignatureStatus.signed}} of {{eSignDocuments.ACADocument.status.numberOfPropertyOwners}} signed)</span>\n\t           <span ng-if=\"eSignDocuments.ACADocument.status.eSigned === true\">eSigned</span>\n           </div>\n\n           <a hp-download-link href=\"{{eSignDocuments.getACALink()}}\" ng-if=\"eSignDocuments.ACADocument.status.eSigned || eSignDocuments.ACADocument.status.ACAUploaded\">Download</a>\n       </div>\n\n       <div class=\"col-xs-2 text-right document-approved\">\n\t\t\t<p ng-show=\"eSignDocuments.stateMachineData.ACAStateId === eSignDocuments.HPStateMachineConfig.ACA.ACA_Signed_By_All_PO ||\n\t\t\t                eSignDocuments.stateMachineData.ACAStateId === eSignDocuments.HPStateMachineConfig.ACA.COG_Countersigned_ACA\" class=\"step-completed icon icon-complete\"></p>\n            <p class=\"admin-only\" ng-if=\"main.userData.HasElevatedAccess === undefined\"><span class=\"icon icon-lock\"></span>ADMIN</p>\n\t\t</div>\n   </div>\n   <!-- ACA -->\n</div>\n\n<div class=\"row get-signatures-button\" ng-if=\"eSignDocuments.showGetSignaturesButton === true\">\n\t<div class=\"col-xs-10 col-xs-offset-1\">\n\t\t<button class=\"btn btn-default\" ng-click=\"appDetail.openGetSignaturesModal(1)\">Get Signatures</button>\n\t</div>\n</div>\n";

/***/ }),
/* 569 */
/***/ (function(module, exports) {

module.exports = "<p class=\"documents-group-title\" ng-click=\"fundingDocuments.financialDocumentsCollapsed = !fundingDocuments.financialDocumentsCollapsed\" ng-class=\"{'active': fundingDocuments.financialDocumentsCollapsed === false}\">Financial Documents <span class=\"icon icon-angle-up step-arrow pull-right\"></span></p>\n\n<div class=\"documents-list\" uib-collapse=\"fundingDocuments.financialDocumentsCollapsed === true\">\n\t<div class=\"document\"  ng-repeat=\"document in fundingDocuments.financialDocuments\">\n\t\t<div class=\"row completed\">\n\t\t\t<div class=\"col-xs-1\">\n\t\t\t\t<p class=\"icon icon-upload-document text-center\"></p>\n\t\t\t</div>\n\t\t\t<div class=\"col-xs-9 document-details\">\n\t\t\t\t<p class=\"document-name\">{{ document.ContentTypeName }}</p>\n                <a hp-download-link href=\"{{fundingDocuments.getFinancialDocumentsLink(document)}}\" class=\"link\" analytics-on=\"click\" analytics-event=\"Download Fin Docs\" analytics-category=\"DocsModule\" analytics-label=\"{{fundingDocuments.currentPipelineStageName}} {{document.ContentTypeName}}\">Download</a>\n\t\t\t</div>\n\t\t\t<div class=\"col-xs-2 document-approved\">\n\t\t\t\t<span class=\"step-completed icon icon-complete\"></span>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n";

/***/ }),
/* 570 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n\t<div class=\"col-md-12\">\n\t\t<div class=\"documents-header\">\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-xs-8\">\n\t\t\t\t\t<h2>Documents</h2>\n\t\t\t\t\t<!-- <p class=\"document-requirements-link\"><span class=\"link\">See Document Requirements</span></p> -->\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-xs-4\">\n\t\t\t\t\t<p class=\"upload-button pull-right\" ng-if=\"appDetail.showGlobalDocumentUploadLink() === true\" ng-click=\"appDetail.openUploadDocumentsModal()\">\n\t\t\t\t\t\t<span class=\"icon icon-upload\"></span>\n\t\t\t\t\t\tUpload\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"documents-group documents-group-invalid\" ng-if=\"fundingDocuments.invalidDocuments.length !== 0\">\n\t\t\t<div ng-include=\"'app/appDetail/documents/invalidDocumentsTemplate.html'\"></div>\n\t\t</div>\n\n\t\t<div class=\"documents-group documents-group-esign\" ng-if=\"fundingDocuments.eSignDocuments.length !== 0\">\n\t\t\t<div ng-include=\"'app/appDetail/documents/esignDocumentsTemplate.html'\" ng-controller=\"EsignDocumentsController as eSignDocuments\"></div>\n\t\t</div>\n\n\t\t<div class=\"documents-group documents-group-other\" ng-if=\"fundingDocuments.otherDocuments.length !== 0\" ng-class=\"{'bordered': fundingDocuments.financialDocuments.length !== 0}\">\n\t\t\t<div ng-include=\"'app/appDetail/documents/otherDocumentsTemplate.html'\"></div>\n\t\t</div>\n\n\t\t<div class=\"documents-group documents-group-financial\" ng-if=\"fundingDocuments.financialDocuments.length !== 0\">\n\t\t\t<div ng-include=\"'app/appDetail/documents/financialDocumentsTemplate.html'\"></div>\n\t\t</div>\n\n\t\t<div class=\"documents-group documents-group-disabled\" ng-if=\"fundingDocuments.isDocumentsSectionVisible === false\">\n\t\t\t<div ng-include=\"'app/appDetail/documents/disabledDocuments.html'\"></div>\n\t\t</div>\n\t</div>\n</div>";

/***/ }),
/* 571 */
/***/ (function(module, exports) {

module.exports = "<p class=\"documents-group-title\">Needs attention</p>\n\n\n<div class=\"document\" ng-repeat=\"document in fundingDocuments.invalidDocuments\">\n    <div class=\"row\">\n        <div class=\"col-xs-1\">\n            <p class=\"icon icon-upload-document text-center\"></p>\n        </div>\n        <div class=\"col-xs-9 document-details\">\n            <p class=\"document-name\">{{ document.Description }}</p>\n            <a hp-download-link ng-if=\"document.ConditionTypeDetail.ConditionTypeId === fundingDocuments.HPConditionTypes.CompletionCertificate\" href=\"{{eSignDocuments.completionCertificateLink()}}\" ng-if=\"appDetail.paymentInstructionsConfirmed()\">Download</a>\n\t\t\t<span class=\"link\" ng-class=\"{'upload-link' : document.ConditionTypeDetail.ConditionTypeId === fundingDocuments.HPConditionTypes.CompletionCertificate}\" ng-click=\"appDetail.openUploadDocumentsModal(document)\" ng-if=\"main.userData.HasElevatedAccess === true\">Upload</span>\n            <p class=\"error-msg\" ng-repeat=\"rejection in document.LatestAttachment.RejectionDetails\">{{rejection.RejectionTypeDetail.Name}}</p>\n        </div>\n        <div class=\"col-xs-2 text-right document-rejected\">\n            <p class=\"step-warning icon icon-exclamation\"></p>\n            <p class=\"admin-only\" ng-if=\"main.userData.HasElevatedAccess === undefined\"><span class=\"icon icon-lock\"></span>ADMIN</p>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 572 */
/***/ (function(module, exports) {

module.exports = "<p class=\"documents-group-title\">Project Documents</p>\n\n<div class=\"document\" ng-repeat=\"document in fundingDocuments.otherDocuments\">\n\t<div class=\"row\" ng-class=\"{ 'completed' : !!(document.AttachmentDetails && document.AttachmentDetails.length > 0) }\">\n\t\t<div class=\"col-xs-1\">\n\t\t\t<p class=\"icon icon-upload-document text-center\"></p>\n\t\t</div>\n\t\t<div class=\"col-xs-9 document-details\">\n\t\t\t<p class=\"document-name\" ng-class=\"{'disabled': document.Invoice && appDetail.paymentInstructionsConfirmed() === false}\">{{ document.Description }}</p>\n\t\t\t<span class=\"link\" ng-show=\"(!document.Invoice || (document.Invoice && appDetail.paymentInstructionsConfirmed())) && appDetail.showDocumentUploadLinks() && (!document.AttachmentDetails || document.AttachmentDetails.length == 0)\" ng-click=\"appDetail.openUploadDocumentsModal(document)\">Upload</span>\n\n\t\t\t<a hp-download-link href=\"{{fundingDocuments.getOtherDocumentsLink(document)}}\" class=\"link\" ng-show=\"(!document.Invoice || (document.Invoice && appDetail.paymentInstructionsConfirmed())) && !!document.AttachmentDetails && document.AttachmentDetails.length > 0\">Download</a>\n\n  \t\t\t<span class=\"link replace-link\" ng-show=\"(!document.Invoice || (document.Invoice && appDetail.paymentInstructionsConfirmed())) && appDetail.showDocumentUploadLinks() && !!document.AttachmentDetails && document.AttachmentDetails.length > 0\" ng-click=\"appDetail.openUploadDocumentsModal(document)\">Replace</span>\n\t\t\t<span class=\"verify-payment-note\" ng-show=\"document.Invoice && appDetail.paymentInstructionsConfirmed() === false\">Verify Project Details and Payment Instructions</span>\n\t\t</div>\n\t\t<div class=\"col-xs-2 text-right document-approved\">\n\t\t\t<span ng-show=\"document.ConditionResultTypeId == 3\" class=\"step-completed icon icon-complete\"></span>\n\t\t</div>\n\t</div>\n</div>\n";

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _ESignRedirectController = __webpack_require__(574);

var _ESignRedirectController2 = _interopRequireDefault(_ESignRedirectController);

var _EDocUpdateFactory = __webpack_require__(576);

var _EDocUpdateFactory2 = _interopRequireDefault(_EDocUpdateFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.appDetail.esign', []).controller('ESignRedirectController', _ESignRedirectController2.default).factory('EDocUpdate', _EDocUpdateFactory2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/appDetail/ESign/ESign.html', __webpack_require__(577)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ESignRedirectController;

__webpack_require__(575);

ESignRedirectController.$inject = ['$location', 'EDocUpdate']; // angular
// 	.module("HeroPRO")
// 	.controller("ESignRedirectController", ESignRedirectController);

/* @ngInject */
function ESignRedirectController($location, EDocUpdate) {
    var queryStringParams = $location.search();

    EDocUpdate.update(queryStringParams).then(function () {
        $location.path('/app-detail/' + queryStringParams.FundingRequestId);
    });
}

/***/ }),
/* 575 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = EDocUpdateFactory;
EDocUpdateFactory.$inject = ["HPConfig", "$http"];
// angular
// 	.module("HeroPRO")
// 	.factory("EDocUpdate", EDocUpdateFactory);

/* @ngInject */
function EDocUpdateFactory(HPConfig, $http) {
    return {
        update: update
    };

    function update(routeParams) {
        var params = {
            FundingRequestId: routeParams.FundingRequestId,
            EDocumentRecipientId: routeParams.EDocumentRecipientId,
            RecipientStatus: routeParams.event,
            DocumentType: routeParams.DocumentType
        };

        return $http.post(HPConfig.heroProApi + "ESign/UpdateEDocumentRecipientStatus", params);
    }
}

/***/ }),
/* 577 */
/***/ (function(module, exports) {

module.exports = "<div class=\"esign-loader\">\n\t<img src=\"src/assets/images/HERO-Logo.png\" />\n\t<h1>Finalizing Documents</h1>\n\t<p>Page will be automatically refreshed in a few seconds</p>\n\t<div class=\"scale-cont\">\n\t\t<div class=\"loading\"></div>\n\t</div>\n</div>";

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _getSignaturesModalController = __webpack_require__(579);

var _getSignaturesModalController2 = _interopRequireDefault(_getSignaturesModalController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.appDetail.getClosingSignaturesModal', []).controller('GetSignaturesModalController', _getSignaturesModalController2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/appDetail/getClosingSignaturesModal/getSignaturesModal.html', __webpack_require__(581)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/getClosingSignaturesModal/propertyOwners.html', __webpack_require__(582)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/getClosingSignaturesModal/representative.html', __webpack_require__(583)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getSignaturesModalController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(580);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

getSignaturesModalController.$inject = ['$uibModalInstance', '$scope', 'EDocumentsFactory', '$stateParams', '$q', '$window', 'activeTab', 'HPConfig', 'HPStateMachineConfig', 'FRInformationFactory', 'AccountsFactory', 'FRDocumentsFactory', 'UserData', 'PermissionsFactory']; // angular
//     .module("HeroPRO")
//     .controller("GetSignaturesModalController", getSignaturesModalController);

/* @ngInject */
function getSignaturesModalController($uibModalInstance, $scope, EDocumentsFactory, $stateParams, $q, $window, activeTab, HPConfig, HPStateMachineConfig, FRInformationFactory, AccountsFactory, FRDocumentsFactory, UserData, PermissionsFactory) {
    var vm = this;
    vm.stateMachineData = {};
    vm.recipients = {};
    vm.pendingSignatures = false;
    vm.signNow = signNow;
    vm.sendEmail = sendEmail;
    vm.sendRepresentativeEmail = sendRepresentativeEmail;
    vm.setActiveTab = setActiveTab;
    vm.sendEmailButtons = [];
    vm.sendRepresentativeEmailButtonStatus = 0;
    vm.CCDocument = null;
    vm.ACADocument = null;
    vm.userProfile = {};
    vm.contractorUserId = '';
    vm.OrganizationId = '';

    FRDocumentsFactory.getFundingRequestDocumentsPromise().then(function () {
        vm.stateMachineData = FRInformationFactory.getStateMachineData();
        vm.CCDocument = FRDocumentsFactory.getCCDocument();
        vm.ACADocument = FRDocumentsFactory.getACADocument();
        init();
    });

    function init() {
        getCurrentLocation();
        getContractorUser();

        if (vm.CCDocument !== null) {
            if (vm.stateMachineData.CompletionCertificateStateId !== HPStateMachineConfig.CC.Completion_Cert_Generated && vm.stateMachineData.CompletionCertificateStateId !== HPStateMachineConfig.CC.Product_Details_Confirmed && vm.stateMachineData.CompletionCertificateStateId !== HPStateMachineConfig.CC.Payment_Instructions_Confirmed) {
                var CCRecipients = vm.CCDocument.ESignDocumentEnvelope ? vm.CCDocument.ESignDocumentEnvelope.EDocumentRecipients : [];
                for (var i = 0; i < CCRecipients.length; i++) {
                    vm.recipients[CCRecipients[i].OrdinalInRole] = {
                        FirstName: CCRecipients[i].FirstName,
                        LastName: CCRecipients[i].LastName,
                        Email: CCRecipients[i].Email,
                        OrdinalInRole: CCRecipients[i].OrdinalInRole,
                        AllDocsSigned: CCRecipients[i].EDocumentRecipientStatus === 5 || vm.CCDocument.status.CCUploaded,
                        CC: CCRecipients[i],
                        ACA: null
                    };
                }
            }
        }

        if (vm.ACADocument !== null) {
            var ACARecipients = vm.ACADocument.ESignDocumentEnvelope ? vm.ACADocument.ESignDocumentEnvelope.EDocumentRecipients : [];
            for (var j = 0; j < ACARecipients.length; j++) {
                if (vm.recipients[ACARecipients[j].OrdinalInRole] !== undefined) {
                    vm.recipients[ACARecipients[j].OrdinalInRole].ACA = ACARecipients[j];
                    vm.recipients[ACARecipients[j].OrdinalInRole].AllDocsSigned = vm.recipients[ACARecipients[j].OrdinalInRole].AllDocsSigned && ACARecipients[j].EDocumentRecipientStatus === 5;
                } else {
                    vm.recipients[ACARecipients[j].OrdinalInRole] = {
                        FirstName: ACARecipients[j].FirstName,
                        LastName: ACARecipients[j].LastName,
                        Email: ACARecipients[j].Email,
                        OrdinalInRole: ACARecipients[j].OrdinalInRole,
                        AllDocsSigned: ACARecipients[j].EDocumentRecipientStatus === 5,
                        ACA: ACARecipients[j],
                        CC: null
                    };
                }
            }
        }

        for (var k = 0; k < Object.keys(vm.recipients).length; k++) {
            vm.sendEmailButtons.push({ status: 0 });
        }

        setActiveTab(activeTab);

        vm.pendingSignatures = _lodash2.default.some(vm.recipients, function (recipient) {
            return !recipient.AllDocsSigned;
        });
    }

    vm.closeModal = function () {
        $uibModalInstance.close();
    };

    function setActiveTab(newActiveTab) {
        vm.activeTab = newActiveTab;
    }

    function signNow(recipient, documentType) {
        if (documentType === 'AssesmentContractAddendum') {
            $window.open(HPConfig.idVerifyLink + '#app/' + recipient.ACA.EDocumentRecipientID + '/' + vm.ACADocument.ESignDocumentEnvelope.EnvelopeID);
        } else if (documentType === 'CompletionCertificate') {
            $window.open(HPConfig.idVerifyLink + '#app/' + recipient.CC.EDocumentRecipientID + '/' + vm.CCDocument.ESignDocumentEnvelope.EnvelopeID);
        }
    }
    function sendEmail(recipient, recipientIndex) {
        // EDocumentRecipientStatusDate
        if (recipient.Email && recipient.Email.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i)) {
            if (vm.sendEmailButtons[recipientIndex].status === 0) {
                vm.sendEmailButtons[recipientIndex].status = 1;

                var fundingRequestId = $stateParams.appId;
                var loanId = FRDocumentsFactory.getESignDocuments()[0].ESignDocumentEnvelope.LoanId;

                var emailPromise1 = void 0;
                var emailPromise2 = void 0;

                if (recipient.ACA && recipient.ACA.EDocumentRecipientStatus !== 5) {
                    emailPromise1 = EDocumentsFactory.emailDocusignLink(fundingRequestId, recipient.ACA.EDocumentRecipientID, 'AssesmentContractAddendum', recipient.Email, recipient.OrdinalInRole, loanId);
                }
                if (recipient.CC && recipient.CC.EDocumentRecipientStatus !== 5) {
                    emailPromise2 = EDocumentsFactory.emailDocusignLink(fundingRequestId, recipient.CC.EDocumentRecipientID, 'CompletionCertificate', recipient.Email, recipient.OrdinalInRole, loanId);
                }

                $q.all([emailPromise1, emailPromise2]).then(function () {
                    vm.sendEmailButtons[recipientIndex].status = 2;
                });
            }
        } else {
            $window.alert('Invalid Email');
        }
    }

    function sendRepresentativeEmail(representativeEmail) {
        if (representativeEmail && representativeEmail.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i)) {
            if (vm.sendRepresentativeEmailButtonStatus === 0) {
                vm.sendRepresentativeEmailButtonStatus = 1;

                EDocumentsFactory.emailInstaller($stateParams.appId, representativeEmail).then(function () {
                    vm.sendRepresentativeEmailButtonStatus = 2;
                });
            }
        } else {
            $window.alert('Invalid Email');
        }
    }

    function getCurrentLocation() {
        UserData.getCurrentLocation().then(function (data) {
            vm.OrganizationId = data.OrganizationId;
        });
    }

    function getContractorUser() {
        AccountsFactory.getContractorUser($stateParams.accountId).then(function (response) {
            if (response.data.Data !== undefined || response.data.Data !== null) {
                vm.userProfile = response.data.Data;
                vm.contractorUserId = vm.userProfile.ContractorUserId;
            }
        });
    }
}

/***/ }),
/* 580 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 581 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <h3>Get Signatures</h3>\n    <span class=\"icon icon-delete-circle\"  ng-click=\"getSignaturesModal.closeModal()\"></span>\n</div>\n\n<div class=\"modal-body modal-body-get-signatures\">\n    <uib-tabset class=\"hp-tabset\" active=\"getSignaturesModal.activeTab\">\n        <uib-tab heading=\"Property Owners\" index=\"1\" ng-click=\"getSignaturesModal.setActiveTab(1)\">\n            <ng-include src=\"'app/appDetail/getClosingSignaturesModal/propertyOwners.html'\"></ng-include>\n        </uib-tab>\n        <uib-tab heading=\"Send to Installer\" index=\"2\" ng-click=\"getSignaturesModal.setActiveTab(2)\">\n            <ng-include src=\"'app/appDetail/getClosingSignaturesModal/representative.html'\"></ng-include>\n        </uib-tab>\n    </uib-tabset>\n</div>";

/***/ }),
/* 582 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row-po\" ng-repeat=\"recipient in getSignaturesModal.recipients\">\n\n    <div ng-if=\"recipient.AllDocsSigned\">\n        <h4 class=\"all-signed-message\">{{recipient.FirstName}} {{recipient.LastName}}  has signed all documents so far.</h4>\n    </div>\n\n    <div ng-if=\"!recipient.AllDocsSigned\">\n        <h4>Send Outstanding Documents to {{recipient.FirstName}} {{recipient.LastName}}</h4>\n\n        <!-- ACA -->\n        <div class=\"row row-document\" ng-if=\"recipient.ACA\" ng-class=\"{ 'completed' :  recipient.ACA.EDocumentRecipientStatus === 5}\">\n            <div class=\"col-md-7\">\n                <span class=\"icon icon-upload-document text-center\"></span> Change Order\n                <p class=\"email-status\">\n                    <span ng-if=\"recipient.ACA.EDocumentRecipientStatus !== 5\">Needs Signature</span>\n                    <span ng-if=\"recipient.ACA.EDocumentRecipientStatus === 100\">&mdash; Email sent on: {{recipient.ACA.EDocumentRecipientStatusDate | date : 'short'}} (Pacific Time Zone)</span>\n                </p>\n            </div>\n            <div class=\"col-md-5 document-status\">\n                <span ng-if=\"recipient.ACA.EDocumentRecipientStatus === 5\">eSigned on {{recipient.ACA.EDocumentRecipientStatusDate | date : 'short'}} (Pacific Time Zone)</span>\n                <button ng-if=\"recipient.ACA.EDocumentRecipientStatus !== 5\" class=\"btn btn-default\" ng-click=\"getSignaturesModal.signNow(recipient, 'AssesmentContractAddendum')\">Sign Now</button>\n            </div>\n        </div>\n        <!-- ACA -->\n\n        <!-- Completion Certificate -->\n        <div class=\"row row-document\"  ng-if=\"recipient.CC || getSignaturesModal.CCDocument.status.CCUploaded\"  ng-class=\"{ 'completed' : recipient.CC.EDocumentRecipientStatus === 5 || recipient.CC.EDocumentRecipientStatus === 101 || getSignaturesModal.CCDocument.status.CCUploaded === true }\">\n            <div class=\"col-md-7\">\n                <span class=\"icon icon-upload-document text-center\"></span> Completion Certificate\n                <p class=\"email-status\">\n                    <span ng-if=\"recipient.CC.EDocumentRecipientStatus !== 5 && recipient.CC.EDocumentRecipientStatus !== 101 && !getSignaturesModal.CCDocument.status.CCUploaded\">Needs Signature</span>\n                    <span ng-if=\"recipient.CC.EDocumentRecipientStatus === 100\">&mdash; Email sent on: {{recipient.CC.EDocumentRecipientStatusDate | date : 'short'}} (Pacific Time Zone)</span>\n                </p>\n            </div>\n            <div class=\"col-md-5 document-status\">\n                <span ng-if=\"recipient.CC.EDocumentRecipientStatus === 5\">eSigned on {{recipient.CC.EDocumentRecipientStatusDate | date : 'short'}} (Pacific Time Zone)</span>\n                <span ng-if=\"recipient.CC.EDocumentRecipientStatus === 101\">eSigned by another Property Owner</span>\n                <button ng-if=\"recipient.CC.EDocumentRecipientStatus !== 5 && recipient.CC.EDocumentRecipientStatus !== 101 && !getSignaturesModal.CCDocument.status.CCUploaded\" class=\"btn btn-default\" ng-click=\"getSignaturesModal.signNow(recipient, 'CompletionCertificate')\">Sign Now</button>\n                <span ng-if=\"getSignaturesModal.CCDocument.status.CCUploaded === true\">Attached</span>\n            </div>\n        </div>\n        <!-- Completion Certificate -->\n\n        <div class=\"row row-send-email form-inline\">\n            <div class=\"col-md-12\">\n                <input type=\"email\" class=\"form-control\" ng-model=\"recipient.Email\"/>\n                <button ng-click=\"getSignaturesModal.sendEmail(recipient, $index)\" class=\"form-control btn btn-primary\" hp-dynamic-text-button=\"Send Email\"\n                        hp-spinner-button-texts=\"['Send Email','Sending...','Sent']\"\n                        hp-spinner-button-status=\"getSignaturesModal.sendEmailButtons[$index].status\"\n                        hp-spinner-button-styles=\"true\"></button>\n            </div>\n        </div>\n    </div>\n\n</div>\n\n";

/***/ }),
/* 583 */
/***/ (function(module, exports) {

module.exports = "<p class=\"representative-header\" ng-if=\"getSignaturesModal.pendingSignatures\">Send Outstanding Documents for Signature to Installer:</p>\n\n<div class=\"row-po send-to-representative\" ng-repeat=\"recipient in getSignaturesModal.recipients\" ng-class=\"{'first': $index == 0}\">\n    <div ng-if=\"recipient.AllDocsSigned\">\n        <h4 class=\"all-signed-message\">{{recipient.FirstName}} {{recipient.LastName}}  has signed all documents so far.</h4>\n    </div>\n\n    <div ng-if=\"!recipient.AllDocsSigned\">\n        <h4>{{recipient.FirstName}} {{recipient.LastName}}</h4>\n        <!-- ACA -->\n        <div class=\"row row-document\" ng-if=\"recipient.ACA\" ng-class=\"{ 'completed' :  recipient.ACA.EDocumentRecipientStatus === 5}\">\n            <div class=\"col-md-8\">\n                <span class=\"icon icon-upload-document text-center\"></span>\n                Change Order\n            </div>\n\n            <div class=\"col-md-4 document-status\">\n                <span ng-if=\"recipient.ACA.EDocumentRecipientStatus !== 5\">Needs Signature</span>\n                <span ng-if=\"recipient.ACA.EDocumentRecipientStatus === 5\">eSigned on {{recipient.ACA.EDocumentRecipientStatusDate | date : 'short'}} (Pacific Time Zone)</span>\n            </div>\n        </div>\n        <!-- ACA -->\n\n        <!-- Completion Certificate -->\n        <div class=\"row row-document\"  ng-if=\"recipient.CC || getSignaturesModal.CCDocument.status.CCUploaded\"  ng-class=\"{ 'completed' : recipient.CC.EDocumentRecipientStatus === 5 || recipient.CC.EDocumentRecipientStatus === 101 || getSignaturesModal.CCDocument.status.CCUploaded === true }\">\n            <div class=\"col-md-8\">\n                <span class=\"icon icon-upload-document text-center\"></span>\n                Completion Certificate\n            </div>\n            <div class=\"col-md-4 document-status\">\n                <span ng-if=\"recipient.CC.EDocumentRecipientStatus !== 5 && recipient.CC.EDocumentRecipientStatus !== 101 && !getSignaturesModal.CCDocument.status.CCUploaded\">Needs Signature</span>\n                <span ng-if=\"recipient.CC.EDocumentRecipientStatus === 5\">eSigned on {{recipient.CC.EDocumentRecipientStatusDate | date : 'short'}} (Pacific Time Zone)</span>\n                <span ng-if=\"recipient.CC.EDocumentRecipientStatus === 101\">eSigned by another Property Owner</span>\n                <span ng-if=\"getSignaturesModal.CCDocument.status.CCUploaded === true\">Attached</span>\n            </div>\n        </div>\n        <!-- Completion Certificate -->\n    </div>\n</div>\n\n<div class=\"row row-send-email form-inline\" ng-if=\"getSignaturesModal.pendingSignatures\">\n    <div class=\"col-md-12\">\n        <input type=\"email\" class=\"form-control\" ng-model=\"representativeEmail\"/>\n        <button ng-click=\"getSignaturesModal.sendRepresentativeEmail(representativeEmail)\" class=\"form-control btn btn-primary\" hp-dynamic-text-button=\"Send Email\"\n                hp-spinner-button-texts=\"['Send Email','Sending...','Sent']\"\n                hp-spinner-button-status=\"getSignaturesModal.sendRepresentativeEmailButtonStatus\"\n                hp-spinner-button-styles=\"true\"></button>\n    </div>\n</div>\n\n<div class=\"row-representative-message\" ng-if=\"getSignaturesModal.pendingSignatures\">\n    <p>This email will be sent to your representative on-site and will include a personalized link for each property owner who needs to sign.</p>\n</div>\n";

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _makeChangesModalController = __webpack_require__(585);

var _makeChangesModalController2 = _interopRequireDefault(_makeChangesModalController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.appDetail.makeChangesModal', []).controller('MakeChangesModalController', _makeChangesModalController2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/appDetail/makeChangesModal/makeChangesGenerateACA.html', __webpack_require__(587)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/makeChangesModal/makeChangesMenu.html', __webpack_require__(588)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/makeChangesModal/makeChangesModal.html', __webpack_require__(589)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/makeChangesModal/makeChangesNewCC.html', __webpack_require__(590)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/makeChangesModal/makeChangesNewFinDocs.html', __webpack_require__(591)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/makeChangesModal/makeChangesModalLocked.html', __webpack_require__(592)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/makeChangesModal/makeChangesOpenAPL.html', __webpack_require__(593)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = makeChangesModalController;

__webpack_require__(586);

makeChangesModalController.$inject = ['$scope', 'AddProductsFactory', 'PermissionsFactory', 'FRInformationFactory']; // angular
//     .module("HeroPRO")
//     .controller("MakeChangesModalController", makeChangesModalController);

/* @ngInject */
function makeChangesModalController($scope, AddProductsFactory, PermissionsFactory, FRInformationFactory) {
    var vm = this;

    var defaultItem = {
        title: 'Choose One',
        templateUrl: ''
    };
    vm.selectedItem = defaultItem;

    var appInfo = FRInformationFactory.getAppInfo();
    vm.isMultiFr = appInfo.IsMultiFundingRequest;

    var openInAPLTemplateUrl = 'app/appDetail/makeChangesModal/makeChangesOpenAPL.html';
    var generateACATemplateUrl = 'app/appDetail/makeChangesModal/makeChangesGenerateACA.html';

    vm.makeChangesMenu = [{
        title: 'Changes in Financing',
        type: 'heading'
    }, {
        title: 'Increase the Project Financing Amount',
        templateUrl: openInAPLTemplateUrl,
        type: 'item'
    }, {
        title: 'Decrease the Project Financing Amount',
        templateUrl: openInAPLTemplateUrl,
        type: 'item'
    }, {
        title: 'Increase the Maximum Approval Amount',
        templateUrl: 'app/appDetail/makeChangesModal/makeChangesNewFinDocs.html',
        type: 'item'
    }, {
        title: 'Change the Financing Term',
        templateUrl: openInAPLTemplateUrl,
        type: 'item'
    }, {
        title: 'Change Pre-payment Options',
        templateUrl: openInAPLTemplateUrl,
        type: 'item'
    }, {
        type: 'divider'
    }, {
        title: 'Changes in Products',
        type: 'heading'
    }, {
        title: 'Change the Product Details',
        templateUrl: openInAPLTemplateUrl,
        type: 'item'
    }, {
        title: 'Change the Product Type or Category',
        templateUrl: openInAPLTemplateUrl,
        type: 'item'
    }, {
        title: 'Add or Remove Products',
        templateUrl: openInAPLTemplateUrl,
        type: 'item'
    }, {
        type: 'divider'
    }, {
        title: 'Other Changes',
        type: 'heading'
    }, {
        title: 'Change the Contractor',
        templateUrl: generateACATemplateUrl,
        type: 'item'
    }, {
        title: 'Change Property Owner',
        templateUrl: generateACATemplateUrl,
        type: 'item'
    }, {
        title: 'Fix a Clerical Error',
        templateUrl: generateACATemplateUrl,
        type: 'item'
    }];

    // if the user is not a solicitor 
    if (!PermissionsFactory.hasPermission('IsSolicitor')) {
        // exclude the Change Pre-payment Options
        // as part of the menu 
        vm.makeChangesMenu = vm.makeChangesMenu.filter(function (item) {
            return item.title !== "Change Pre-payment Options";
        });
    }

    vm.menuItemClicked = function (item, $event) {
        if (item.type === 'item') {
            vm.selectedItem = item;
        } else {
            $event.preventDefault();
            $event.stopPropagation();
        }
    };

    vm.getTemplate = function () {
        return vm.selectedItem.templateUrl;
    };

    vm.closeModal = function () {
        $scope.$close();
    };

    vm.openAddProductsWebsite = function () {
        AddProductsFactory.openAddProductsWebsite();
    };
}

/***/ }),
/* 586 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 587 */
/***/ (function(module, exports) {

module.exports = "<div class=\"make-changes-content\">\n\t<div class=\"row\">\n\t\t<div class=\"col-md-6\">\n\t\t\t<p class=\"step-header\">Next Steps</p>\n\t\t\t<ol>\n\t\t\t\t<li>Call HERO to make changes 844-722-7759</li>\n\t\t\t\t<li>HERO will create a Change Order (also known as an Assessment Contract Addendum) and generate an\n\t\t\t\t\tupdated Completion Certificate</li>\n\t\t\t\t<li>The Property Owner must sign the Change Order.</li>\n\t\t\t</ol>\n\t\t</div>\n\t\t<div class=\"col-md-6\">\n\t\t\t<p class=\"step-header\">When the Project is Complete</p>\n\t\t\t<ol>\n\t\t\t\t<li>Make sure the Property Owner signs the latest version of the Completion Certificate.</li>\n\t\t\t\t<li>Use eSign to get signatures for faster funding.</li>\n\t\t\t</ol>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col-md-12\">\n\t\t\t<button class=\"btn btn-primary pull-right\" ng-click=\"makeChangesModal.closeModal()\">Ok, Got it</button>\n\t\t</div>\n\t</div>\n</div>";

/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports = "<div class=\"menu-heading\">\n\t<p>What do you want to change in your project?</p>\n</div>\n\n<div class=\"dropdown\" uib-dropdown dropdown-small-popup dropdown-title=\"Make Changes\">\n    <a blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle data-toggle=\"dropdown\">\n    \t<span class=\"dropdown-text\">{{makeChangesModal.selectedItem.title}}</span>\n        <span class=\"icon\"></span>\n    </a>\n    <ul class=\"dropdown-menu\" uib-dropdown-menu>\n        <li ng-repeat=\"menuItem in makeChangesModal.makeChangesMenu\" ng-class=\"{'active': makeChangesModal.selectedItem.title === menuItem.title, 'divider': menuItem.type == 'divider', 'heading': menuItem.type === 'heading'}\" ng-click=\"makeChangesModal.menuItemClicked(menuItem, $event)\">\n        \t<span ng-if=\"menuItem.type !== 'divider'\">{{menuItem.title}}</span>\n        </li>\n    </ul>\n</div>";

/***/ }),
/* 589 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <span class=\"icon icon-delete-circle\" ng-click=\"makeChangesModal.closeModal();\"></span>\n</div>\n\n<div class=\"modal-body\">\n\t<p class=\"modal-title\">Make Changes</p>\n\t<div ng-include=\"'app/appDetail/makeChangesModal/makeChangesMenu.html'\"></div>\n    <ng-include ng-if=\"makeChangesModal.getTemplate() !== ''\" src=\"makeChangesModal.getTemplate()\"></ng-include>\n</div>\n";

/***/ }),
/* 590 */
/***/ (function(module, exports) {

module.exports = "<div class=\"make-changes-content\">\n\t<div class=\"row\">\n\t\t<div class=\"col-xs-6\">\n\t\t\t<p class=\"step-header\">Next Steps</p>\n\t\t\t<ol>\n\t\t\t\t<li>Call HERO to make changes 844-722-7759</li>\n\t\t\t\t<li>HERO will generate an updated Completion Certificate</li>\n\t\t\t</ol>\n\t\t</div>\n\t\t<div class=\"col-xs-6\">\n\t\t\t<p class=\"step-header\">When the Project is Complete</p>\n\t\t\t<ol>\n\t\t\t\t<li>Make sure the Property Owner signs the latest version of the Completion Certificate.</li>\n\t\t\t\t<li>Use eSign to get signatures for faster funding.</li>\n\t\t\t</ol>\n\t\t</div>\n\t</div>\n\t<button class=\"btn btn-primary pull-right\" ng-click=\"makeChangesModal.closeModal()\">Ok, Got it</button>\n</div>\n";

/***/ }),
/* 591 */
/***/ (function(module, exports) {

module.exports = "<div class=\"make-changes-content\">\n\t<div class=\"row\">\n\t\t<div class=\"col-md-6\">\n\t\t\t<p class=\"step-header\">Next Steps</p>\n\t\t\t<ol>\n\t\t\t\t<li>Call HERO to make changes 844-722-7759</li>\n\t\t\t\t<li>Since this is a request to increase the maximum approval amount, HERO will need to generate new set\n\t\t\t\t\tof Financing Documents that will need to be signed.</li>\n\t\t\t</ol>\n\t\t</div>\n\t\t<div class=\"col-md-6\">\n\t\t\t<p class=\"step-header\">When the Project is Complete</p>\n\t\t\t<ol>\n\t\t\t\t<li>Make sure the Property Owner signs the latest version of the Completion Certificate.</li>\n\t\t\t\t<li>Use eSign to get signatures for faster funding.</li>\n\t\t\t</ol>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col-md-12\">\n\t\t\t<button class=\"btn btn-primary pull-right\" ng-click=\"makeChangesModal.closeModal()\">Ok, Got it</button>\n\t\t</div>\n\t</div>\n</div>";

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\r\n    <span class=\"icon icon-delete-circle\" ng-click=\"makeChangesModal.closeModal();\"></span>\r\n</div>\r\n\r\n<div class=\"modal-body\">\r\n\t<p class=\"modal-title\">Make Changes</p>\t\r\n    <div class=\"make-changes-content\">\r\n        <div class=\"row\">\r\n            <div class=\"col-md-8\">\r\n                <p class=\"step-header\">Next Steps</p>\r\n                <ul>\r\n                    <li>Changes are not able to be made to the project at this time.</li>\r\n                    <li>Call HERO with any questions at 844-722-7759.</li>\r\n                </ul>\r\n            </div>\r\n        </div>\r\n        <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n                <button class=\"btn btn-primary pull-right\" ng-click=\"makeChangesModal.closeModal()\">Ok, Got it</button>\r\n            </div>\r\n        </div>\r\n    </div>    \r\n</div>\r\n";

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports = "<div class=\"make-changes-content\">\n\t<div class=\"row\">\n\t\t<div class=\"col-md-6\">\n\t\t\t<p class=\"step-header\">Next Steps</p>\n\t\t\t<ol>\n\t\t\t\t<li>Complete your change order in Add Products.</li>\n\t\t\t\t<li>A Change Order (known as an Assessment Contract Addemndum) and a new completion certificate will be\n\t\t\t\t\tgenerated.</li>\n\t\t\t\t<li>The property owner will have to sign the change order.</li>\n\t\t\t</ol>\n\t\t</div>\n\t\t<div class=\"col-md-6\">\n\t\t\t<p class=\"step-header\">When the Project is Complete</p>\n\t\t\t<ol>\n\t\t\t\t<li>Make sure the Property Owner signs the latest version of the Completion Certificate.</li>\n\t\t\t\t<li>Use eSign to get signatures for faster funding.</li>\n\t\t\t</ol>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col-sm-12\">\n\t\t\t<p class=\"step-header\">Ready to go to Add Products and make a change?</p>\n\t\t</div>\n\t</div>\n\t<div class=\"row\" ng-if=\"!makeChangesModal.isMultiFr\">\n\t\t<div class=\"col-sm-12\">\n\t\t\t<button class=\"btn btn-primary pull-right\" ng-click=\"makeChangesModal.openAddProductsWebsite()\">I'm ready to\n\t\t\t\tMake a Change</button>\n\t\t</div>\n\t</div>\n</div>";

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _paymentInstructionsController = __webpack_require__(595);

var _paymentInstructionsController2 = _interopRequireDefault(_paymentInstructionsController);

var _paymentInstructionsModalController = __webpack_require__(597);

var _paymentInstructionsModalController2 = _interopRequireDefault(_paymentInstructionsModalController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.appDetail.paymentInstructions', []).controller('PaymentInstructionsController', _paymentInstructionsController2.default).controller('PaymentInstructionsModalController', _paymentInstructionsModalController2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/appDetail/paymentInstructions/disabledPaymentInstructions.html', __webpack_require__(598)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/paymentInstructions/paymentDetailsProjectAdvance.html', __webpack_require__(599)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/paymentInstructions/paymentInstructionsCommonTemplate.html', __webpack_require__(600)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/paymentInstructions/paymentInstructionsLeaseCommonTemplate.html', __webpack_require__(601)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/paymentInstructions/paymentInstructionsModal.html', __webpack_require__(602)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/paymentInstructions/paymentInstructionsTemplate.html', __webpack_require__(603)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = paymentInstructionsController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(596);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

paymentInstructionsController.$inject = ['$scope', 'FRClosingFactory']; // angular
// 	.module("HeroPRO")
// 	.controller("PaymentInstructionsController", paymentInstructionsController);

/* @ngInject */
function paymentInstructionsController($scope, FRClosingFactory) {
    var vm = this;
    vm.isCollapsed = true;
    vm.projectAdvanceData = {};
    vm.fundingRequest = [];
    vm.totalLabel = 'Total';

    vm.lateText = 'PA Delinquent';

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */

    function init() {
        FRClosingFactory.getFundingRequestClosingPromise().then(function () {
            vm.fundingRequest = FRClosingFactory.getFundingRequest();
            vm.projectDetails = FRClosingFactory.getProjectDetails();
            if (vm.fundingRequest.FundingRequestDetail.FundingDisbursementModelTypeId === 11) {
                vm.projectAdvanceData = FRClosingFactory.getProjectAdvanceDetails();
                if (vm.projectAdvanceData === undefined) {
                    vm.projectAdvanceData = {};
                }
            }
            var contractorDisbursement = _lodash2.default.find(FRClosingFactory.getPaymentInstructions().newDisbursements, function (disbursement) {
                return disbursement.PayeeType === 'Contractor';
            });
            if (contractorDisbursement) {
                vm.totalLabel = 'Payment to Contractor';
            }
        });
    }

    $scope.$watch(function () {
        return FRClosingFactory.getPaymentInstructionsConfirmed();
    }, function (newValue) {
        vm.isCollapsed = newValue;
    });

    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 596 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = paymentInstructionsModalController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

paymentInstructionsModalController.$inject = ['$scope', '$state', 'raSpinnerService', '$stateParams', 'FRInformationFactory', 'FRClosingFactory']; // angular
//     .module("HeroPRO")
// 	.controller("PaymentInstructionsModalController", paymentInstructionsModalController);

/* @ngInject */
function paymentInstructionsModalController($scope, $state, raSpinnerService, $stateParams, FRInformationFactory, FRClosingFactory) {
    var vm = this;
    vm.displayForm = true;
    vm.paymentInstructions = {};
    vm.advancePayment = {};
    vm.contractor = {};
    vm.propertyOwner = {};
    vm.designee = {};
    vm.contractorDisbursementAmount = null;
    vm.propertyOwnerDisbursementAmount = null;
    vm.designeeDisbursementAmount = null;

    init();

    vm.addressPOCollapsed = function () {
        return vm.propertyOwnerDisbursementAmount <= 0;
    };

    vm.addressPOValid = function (form) {
        return form.paymentInstructionsPOName.$valid && form.paymentInstructionsPOAddress.$valid && form.paymentInstructionsPOCity.$valid && form.paymentInstructionsPOState.$valid && form.paymentInstructionsPOZip.$valid;
    };

    vm.addressPOUntouched = function (form) {
        return form.paymentInstructionsPOName.$untouched || form.paymentInstructionsPOAddress.$untouched || form.paymentInstructionsPOCity.$untouched || form.paymentInstructionsPOState.$untouched || form.paymentInstructionsPOZip.$untouched;
    };

    vm.addressDesigneeCollapsed = function () {
        return vm.designeeDisbursementAmount <= 0;
    };

    vm.addressDesigneeValid = function (form) {
        return form.paymentInstructionsDesigneeName.$valid && form.paymentInstructionsDesigneeAddress.$valid && form.paymentInstructionsDesigneeCity.$valid && form.paymentInstructionsDesigneeState.$valid && form.paymentInstructionsDesigneeZip.$valid;
    };

    vm.addressDesigneeUntouched = function (form) {
        return form.paymentInstructionsDesigneeName.$untouched && form.paymentInstructionsDesigneeAddress.$untouched && form.paymentInstructionsDesigneeCity.$untouched && form.paymentInstructionsDesigneeState.$untouched && form.paymentInstructionsDesigneeZip.$untouched;
    };

    vm.totalAmount = function () {
        return vm.contractorDisbursementAmount + vm.propertyOwnerDisbursementAmount + vm.designeeDisbursementAmount;
    };

    vm.isTotalExceeded = function () {
        return vm.totalAmount() > vm.paymentInstructions.InitialRequested;
    };

    vm.saveChanges = function (form) {
        if (vm.isTotalExceeded() === true || !form.$valid) {
            return;
        }

        // Now that the changes are being saved, set the application variables
        vm.contractor.DisbursementAmount = vm.contractorDisbursementAmount;
        vm.propertyOwner.DisbursementAmount = vm.propertyOwnerDisbursementAmount;
        vm.designee.DisbursementAmount = vm.designeeDisbursementAmount;

        var params = {};

        if (vm.paymentInstructions.LockDisbursements === true) {
            params = {
                PaymentInstructions: {
                    FundingRequestId: $stateParams.appId
                }
            };
        } else {
            params = {
                PaymentInstructions: {
                    FundingRequestId: $stateParams.appId,
                    TotalApproved: vm.totalAmount(),
                    Disbursements: _lodash2.default.filter(vm.paymentInstructions.newDisbursements, function (disbursement) {
                        return disbursement.DisbursementAmount > 0;
                    })
                }
            };
        }

        vm.displayForm = false;
        raSpinnerService.show('paymentInstructionsModalSpinner');

        confirmPaymentInstructions(params);
    };

    vm.closeModal = function () {
        raSpinnerService.hide('paymentInstructionsModalSpinner');
        raSpinnerService._unregister('paymentInstructionsModalSpinner');
        $scope.$close();
    };

    function init() {
        FRClosingFactory.getFundingRequestClosingPromise().then(function () {
            vm.paymentInstructions = FRClosingFactory.getPaymentInstructions();
            vm.advancePayment = vm.paymentInstructions.advancePayment;
            vm.contractor = vm.paymentInstructions.newDisbursements[0];
            vm.propertyOwner = vm.paymentInstructions.newDisbursements[1];
            vm.designee = vm.paymentInstructions.newDisbursements[2];
            // Copy values for use in the modal so that the application variables aren't modified
            vm.contractorDisbursementAmount = vm.contractor.DisbursementAmount;
            vm.propertyOwnerDisbursementAmount = vm.propertyOwner.DisbursementAmount;
            vm.designeeDisbursementAmount = vm.designee.DisbursementAmount;
        });
    }

    function confirmPaymentInstructions(params) {
        raSpinnerService.show('walkthroughSpinner');
        FRClosingFactory.confirmPaymentInstructions(params).then(function (response) {
            FRInformationFactory.setStateMachineData(response.data.Data.PipelineStageId, response.data.Data.FundingRequestPipelineStageId, response.data.Data.LoanStateId, response.data.Data.FundingRequestStateId, response.data.Data.CompletionCertificateStateId);
            FRClosingFactory.setPaymentInstructions(_lodash2.default.omit(response.data.Data, 'FundingRequestId', 'LoanStateId'));
            // Refresh the page so that the information for the newly generated CC is available on the page
            $state.go($state.current, $stateParams, { reload: true, inherit: false });
        });
    }
}

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports = "<div class=\"disabled-payment-instructions\">\n    <h1>\n        Payment Details\n    </h1>\n\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"\">\n                <p>Payment details will appear when Financing Documents are complete.</p>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports = "<div class=\"funding-table payment-details-project-advance\">\n    <div uib-collapse=\"paymentInstructions.isCollapsed\" class=\"details\">\n        <div class=\"row row-border-top\">\n            <div class=\"col-md-8 col-xs-6\">\n                <p class=\"text-label\">Product Cost<br/>\n                    <span>This amount appears on the Completion Certificate</span>\n                </p>\n            </div>\n            <div class=\"col-md-4 col-xs-6 text-amount\">\n                <p>\n                    <span ng-bind=\"appDetail.paymentInstructions.FinancingAmount | currency\"></span>\n                </p>\n            </div>\n        </div>\n\n        <!-- Deductions section -->\n        <div class=\"row row-border-top\">\n            <div class=\"col-md-12 col-xs-12\">\n                <h4>Deductions</h4>\n            </div>\n        </div>\n\n        <!-- PEFI deductions (advance, interest, late fee) -->\n        <div class=\"row\">\n            <div class=\"col-md-8 col-xs-6\">\n                <p class=\"text-label\">Advanced payment</p>\n                <p class=\"text-notes\" ng-if=\"paymentInstructions.projectAdvanceData.ContractorOptedOut === false && paymentInstructions.projectAdvanceData.ProjectAdvanceAmount !== undefined\">\n                    <span ng-bind=\"paymentInstructions.projectAdvanceData.ProjectAdvanceRate\"></span>\n                    <span ng-bind=\"paymentInstructions.projectAdvanceData.ProjectAdvanceRateUnitName\"></span> of financed amount sent on <span ng-bind=\"paymentInstructions.projectAdvanceData.ProjectAdvanceDateSent |  date : 'MM/dd/yyyy'\"></span></p>\n                <p class=\"text-notes\" ng-if=\"paymentInstructions.projectAdvanceData.ContractorOptedOut === true\">Opted out for this project on <span ng-bind=\"paymentInstructions.projectAdvanceData.ContractorOptedOutDate  |  date : 'MM/dd/yyyy'\"></span></p>\n            </div>\n            <div class=\"col-md-4 col-xs-6 text-amount\">\n                <p>\n                    - <span ng-bind=\"((paymentInstructions.projectAdvanceData.ProjectAdvanceAmount !== undefined) ? paymentInstructions.projectAdvanceData.ProjectAdvanceAmount : 0 )| currency\"></span>\n                </p>\n            </div>\n        </div>\n        <div class=\"row\" ng-if=\"paymentInstructions.projectAdvanceData.ContractorOptedOut === false\">\n            <div class=\"col-md-8 col-xs-6\">\n                <p class=\"text-label\">Interest accrued to date</p>\n                <p class=\"text-notes\" ng-if=\"paymentInstructions.projectAdvanceData.InterestStartDate !== undefined\">Starting <span ng-bind=\"paymentInstructions.projectAdvanceData.InterestStartDate |  date : 'MM/dd/yyyy'\"></span>, interest will accrue daily until project is funded.</p>\n            </div>\n            <div class=\"col-md-4 col-xs-6 text-amount\">\n                <p>\n                    - <span ng-bind=\"paymentInstructions.projectAdvanceData.InterestAccrued | currency\"></span>\n                </p>\n            </div>\n        </div>\n        <div class=\"row\" ng-if=\"paymentInstructions.projectAdvanceData.ContractorOptedOut === false && paymentInstructions.projectAdvanceData.StatusName === paymentInstructions.lateText\">\n            <div class=\"col-md-8 col-xs-6\">\n                <p class=\"text-label\">Late fee</p>\n                <p class=\"text-notes\">Starting <span ng-bind=\"paymentInstructions.projectAdvanceData.LateFeeDate |  date : 'MM/dd/yyyy'\"></span>, if advance has not been repaid within 20 days of notice to proceed.</p>\n            </div>\n            <div class=\"col-md-4 col-xs-6 text-amount\">\n                <p>\n                    - <span ng-bind=\"paymentInstructions.projectAdvanceData.LateFeeAmount | currency\"></span>\n                </p>\n            </div>\n        </div>\n\n        <!-- HERO deductions (eg. dealer fee) -->\n\n        <div class=\"row\" ng-repeat=\"deduction in appDetail.paymentInstructions.Deductions | filter: { DeductionName:'Contractor Fee'}\">\n            <div class=\"col-md-8 col-xs-6 text-label\">\n                {{deduction.DeductionName}} <br/>\n                <span ng-if=\"deduction.DeductionRate\">\n                    A fee of {{appDetail.rateAfterDiscount(deduction.DeductionRate,appDetail.paymentInstructions.PremierTierDetail.BuydownRateDiscountRate)}}% will be withheld from the funds for this project.\n                </span>\n            </div>\n            <div class=\"col-md-4 col-xs-6 text-amount\">- {{deduction.DeductionAmount  | currency : '$'}}</div>\n        </div>\n\n    </div>\n    <!-- Total section -->\n    <div class=\"row row-border-top\">\n        <div class=\"col-md-8 col-xs-6 text-label\">\n            <p class=\"text-label\">\n                Payment to contractor\n            </p>\n            <p class=\"text-notes\">\n                The amount paid after project completion.\n            </p>\n        </div>\n        <div class=\"col-md-4 col-xs-6 text-amount\">\n            <p>\n                <span ng-bind=\"appDetail.paymentInstructions.TotalFundingAmount | currency\"></span>\n            </p>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports = "<div class=\"funding-table\">\n\n    <div uib-collapse=\"paymentInstructions.isCollapsed\" class=\"details\">\n\n        <!-- Financed amount section -->\n        <div class=\"row row-border-top\">\n            <div class=\"col-md-9 col-xs-6\">\n                <p class=\"text-label\">\n                    Product Cost <br/>\n                    <span>This amount appears on the Completion Certificate</span>\n                </p>\n            </div>\n            <div class=\"col-md-3 col-xs-6 text-amount\">\n                <p>\n                    <span ng-bind=\"appDetail.paymentInstructions.FinancingAmount | currency\"></span>\n                </p>\n            </div>\n        </div>\n\n        <!-- PAY TO section (Disbursements) -->\n        <div class=\"row\">\n            <div class=\"col-md-12 col-xs-12\">\n                <h4>Pay To</h4>\n            </div>\n        </div>\n\n        <div class=\"row\" ng-repeat=\"disbursement in appDetail.paymentInstructions.newDisbursements\">\n            <div class=\"col-md-8 col-xs-6 text-label\">{{disbursement.PayeeType}}</div>\n            <div class=\"col-md-4 col-xs-6 text-amount\">{{disbursement.DisbursementAmount  | currency : '$'}}</div>\n        </div>\n\n        <!-- Pre-funding Deductions section -->\n        <div class=\"row row-border-top\" ng-if=\"appDetail.paymentInstructions.Deductions && appDetail.paymentInstructions.isProjectFunded === false\">\n            <div class=\"col-md-12 col-xs-12\">\n                <h4>Deductions</h4>\n            </div>\n        </div>\n        <div class=\"row\" ng-repeat=\"deduction in appDetail.paymentInstructions.Deductions\" ng-if=\"appDetail.paymentInstructions.isProjectFunded === false\">\n            <div class=\"col-md-8 col-xs-6 text-label\">\n                {{deduction.DeductionName}} <br/>\n                <span ng-if=\"deduction.DeductionRate && deduction.DeductionName == 'Contractor Fee'\">\n                    A fee of {{appDetail.rateAfterDiscount(deduction.DeductionRate,appDetail.paymentInstructions.PremierTierDetail.BuydownRateDiscountRate)}}% will be withheld from the funds for this project.\n                </span>\n                <span ng-if=\"deduction.DeductionRate && deduction.DeductionName != 'Contractor Fee'\">\n                    A fee of {{deduction.DeductionRate}}% will be withheld from the funds for this project.\n                </span>\n\n            </div>\n            <div class=\"col-md-4 col-xs-6 text-amount\">- {{deduction.DeductionAmount  | currency : '$'}}</div>\n        </div>\n\n        <!-- Post-funding Deductions section -->\n        <div class=\"row\" ng-repeat=\"deduction in appDetail.paymentInstructions.Deductions\" ng-if=\"appDetail.paymentInstructions.isProjectFunded === true\">\n            <div class=\"col-md-12 col-xs-12 text-label\">\n                <span ng-if=\"deduction.DeductionRate && deduction.DeductionName == 'Contractor Fee'\">\n                    A {{appDetail.rateAfterDiscount(deduction.DeductionRate,appDetail.paymentInstructions.PremierTierDetail.BuydownRateDiscountRate)}}% contractor fee of {{deduction.DeductionAmount  | currency : '$'}} has been withheld from the funds for this project.\n                </span>\n                <span ng-if=\"deduction.DeductionRate && deduction.DeductionName != 'Contractor Fee'\">\n                    A {{deduction.DeductionRate}}% contractor fee of {{deduction.DeductionAmount  | currency : '$'}} has been withheld from the funds for this project.\n                </span>                \n            </div>\n        </div>\n\n    </div>\n\n    <!-- Total section -->\n    <div class=\"row row-footer\" ng-if=\"appDetail.paymentInstructions.isProjectFunded === false\">\n        <div class=\"col-md-8 col-xs-6 text-label\">\n            {{paymentInstructions.totalLabel || paymentInstructionsWalkthrough.totalLabel}}<br/>\n            <span>The amount paid after project completion</span>\n        </div>\n        <div class=\"col-md-4 col-xs-6 text-amount\">\n            {{appDetail.paymentInstructions.TotalFundingAmount | currency : '$'}}\n        </div>\n    </div>\n\n    <div class=\"row\" ng-if=\"appDetail.paymentInstructions.advancePayment\">\n        <div class=\"col-xs-12\">\n            <p class=\"advance-payment\">The total reflects a {{appDetail.paymentInstructions.advancePayment.DisbursementAmount | currency : '$'}} Advance Payment</p>\n        </div>\n    </div>\n\n</div>\n";

/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports = "<div class=\"funding-table\">\n    <div uib-collapse=\"paymentInstructions.isCollapsed\" class=\"details\">\n        <div class=\"row row-border-top lease-information\">\n            <div class=\"col-md-8 col-xs-6 text-label\">{{appDetail.projectDetails.FinanceOrganizationName}}</div>\n            <div class=\"col-md-4 col-xs-6 text-amount\">{{appDetail.projectDetails.FinancingProductTypeDescription}}</div>\n        </div>\n        <div class=\"row row-border-top\">\n            <div class=\"col-md-8 col-xs-6 text-label\">Monthly</div>\n            <div class=\"col-md-4 col-xs-6 text-amount\">{{appDetail.projectDetails.MonthlyPayment | currency : '$'}}</div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-8 col-xs-6 text-label\">Annual</div>\n            <div class=\"col-md-4 col-xs-6 text-amount\">{{appDetail.projectDetails.YearlyPayment | currency : '$'}}</div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-8 col-xs-6 text-label\">Lifetime</div>\n            <div class=\"col-md-4 col-xs-6 text-amount\">{{appDetail.projectDetails.InitialRequested | currency : '$'}}</div>\n        </div>\n        <div class=\"row row-border-top\">\n            <div class=\"col-md-8 col-xs-6 text-label\">Term</div>\n            <div class=\"col-md-4 col-xs-6 text-amount\">{{appDetail.projectDetails.Term}} Years</div>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <span class=\"icon icon-delete-circle\" ng-show=\"paymentInstructionsModal.displayForm\" ng-click=\"paymentInstructionsModal.closeModal()\"></span>\n</div>\n\n<div class=\"modal-body form-horizontal hp-loading-spinner\" ra-spinner name=\"paymentInstructionsModalSpinner\" text=\"Saving Changes\">\n\t<form name=\"modifyPaymentInstructionsForm\" novalidate ng-show=\"paymentInstructionsModal.displayForm\">\n\t\t<p class=\"modal-title\">Modify Payment Details</p>\n\n\t\t<div class=\"form-group\">\n\t\t\t<label class=\"col-sm-8\" for=\"paymentInstructionsContractor\">Contractor</label>\n\t\t\t<div class=\"col-sm-4\">\n\t\t\t\t<input type=\"text\" id=\"paymentInstructionsContractor\" class=\"form-control input-lg payment-amount\" ng-model=\"paymentInstructionsModal.contractorDisbursementAmount\" ng-disabled=\"appDetail.paymentInstructions.LockDisbursements\" ra-currency=\"$:2\">\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"form-group\">\n\t\t\t<label class=\"col-sm-2\" for=\"paymentInstructionsPO\">Property Owner</label>\n\t\t\t<div class=\"col-sm-5\">\n\t\t\t\t<p class=\"address-invalid\" ng-if=\"!paymentInstructionsModal.addressPOValid(modifyPaymentInstructionsForm) && !paymentInstructionsModal.addressPOUntouched(modifyPaymentInstructionsForm)\"><span class=\"icon icon-error\"></span>Please enter valid values for all the fields below</p>\n\t\t\t</div>\n\t\t\t<div class=\"col-sm-4 col-sm-offset-1\">\n\t\t\t\t<input type=\"text\" id=\"paymentInstructionsPO\" class=\"form-control input-lg payment-amount\" ng-model=\"paymentInstructionsModal.propertyOwnerDisbursementAmount\" ng-keyup=\"paymentInstructionsModal.addressPOCollapsed()\" ng-disabled=\"appDetail.paymentInstructions.LockDisbursements\" ra-currency=\"$:2\">\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"payee-address payee-address-po\" uib-collapse=\"paymentInstructionsModal.addressPOCollapsed()\">\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-xs-3\">\n\t\t\t\t\t<label for=\"paymentInstructionsPOName\" class=\"sr-only\">Name</label>\n\t\t\t\t\t<input type=\"text\" id=\"paymentInstructionsPOName\" name=\"paymentInstructionsPOName\" class=\"form-control input-lg\" placeholder=\"NAME\" ng-model=\"paymentInstructionsModal.propertyOwner.Payee\" ng-required=\"!paymentInstructionsModal.addressPOCollapsed()\">\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-xs-3\">\n\t\t\t\t\t<label for=\"paymentInstructionsPOAddress\" class=\"sr-only\">Address</label>\n\t\t\t\t\t<input type=\"text\" id=\"paymentInstructionsPOAddress\" name=\"paymentInstructionsPOAddress\" class=\"form-control input-lg\" placeholder=\"ADDRESS\" ng-model=\"paymentInstructionsModal.propertyOwner.PayeeAddress\" ng-required=\"!paymentInstructionsModal.addressPOCollapsed()\">\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-xs-2\">\n\t\t\t\t\t<label for=\"paymentInstructionsPOCity\" class=\"sr-only\">City</label>\n\t\t\t\t\t<input type=\"text\" id=\"paymentInstructionsPOCity\" name=\"paymentInstructionsPOCity\" class=\"form-control input-lg\" placeholder=\"CITY\" ng-model=\"paymentInstructionsModal.propertyOwner.PayeeCity\" ng-required=\"!paymentInstructionsModal.addressPOCollapsed()\">\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-xs-2\">\n\t\t\t\t\t<label for=\"paymentInstructionsPOState\" class=\"sr-only\">State</label>\n\t\t\t\t\t<select id=\"paymentInstructionsPOState\" name=\"paymentInstructionsPOState\" class=\"form-control input-lg\" placeholder=\"STATE\" ng-model=\"paymentInstructionsModal.propertyOwner.PayeeState\" ng-required=\"!paymentInstructionsModal.addressPOCollapsed()\" ng-class=\"{ 'default-value': paymentInstructionsModal.propertyOwner.PayeeState === undefined }\">\n\t\t\t\t\t\t<option value=\"\">STATE</option>\n\t\t\t\t\t\t<option ng-repeat=\"state in ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY']\" value=\"{{state}}\" ng-selected=\"state === paymentInstructionsModal.propertyOwner.PayeeState\">{{state}}</option>\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-xs-2\">\n\t\t\t\t\t<label for=\"paymentInstructionsPOZip\" class=\"sr-only\">Zip</label>\n\t\t\t\t\t<input type=\"text\" id=\"paymentInstructionsPOZip\" name=\"paymentInstructionsPOZip\" class=\"form-control input-lg\" placeholder=\"ZIP\" ng-model=\"paymentInstructionsModal.propertyOwner.PayeeZip\" ng-required=\"!paymentInstructionsModal.addressPOCollapsed()\" ng-minlength=\"5\" ng-maxlength=\"5\">\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"form-group\">\n\t\t\t<label class=\"col-sm-2\" for=\"paymentInstructionsDesignee\">Designee</label>\n\t\t\t<div class=\"col-sm-5\">\n\t\t\t\t<p class=\"address-invalid\" ng-if=\"!paymentInstructionsModal.addressDesigneeValid(modifyPaymentInstructionsForm) && !paymentInstructionsModal.addressDesigneeUntouched(modifyPaymentInstructionsForm)\"><span class=\"icon icon-error\"></span>Please enter valid values for all the fields below</p>\n\t\t\t</div>\n\t\t\t<div class=\"col-sm-4 col-sm-offset-1\">\n\t\t\t\t<input type=\"text\" id=\"paymentInstructionsDesignee\" class=\"form-control input-lg payment-amount\" ng-model=\"paymentInstructionsModal.designeeDisbursementAmount\" ng-keyup=\"paymentInstructionsModal.addressDesigneeCollapsed()\" ng-disabled=\"appDetail.paymentInstructions.LockDisbursements\" ra-currency=\"$:2\">\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"payee-address payee-address-designee\" uib-collapse=\"paymentInstructionsModal.addressDesigneeCollapsed()\">\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-xs-3\">\n\t\t\t\t\t<label for=\"paymentInstructionsDesigneeName\" class=\"sr-only\">Name</label>\n\t\t\t\t\t<input type=\"text\" id=\"paymentInstructionsDesigneeName\" name=\"paymentInstructionsDesigneeName\" class=\"form-control input-lg\" placeholder=\"NAME\" ng-model=\"paymentInstructionsModal.designee.Payee\" ng-required=\"!paymentInstructionsModal.addressDesigneeCollapsed()\">\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-xs-3\">\n\t\t\t\t\t<label for=\"paymentInstructionsDesigneeAddress\" class=\"sr-only\">Address</label>\n\t\t\t\t\t<input type=\"text\" id=\"paymentInstructionsDesigneeAddress\" name=\"paymentInstructionsDesigneeAddress\" class=\"form-control input-lg\" placeholder=\"ADDRESS\" ng-model=\"paymentInstructionsModal.designee.PayeeAddress\" ng-required=\"!paymentInstructionsModal.addressDesigneeCollapsed()\">\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-xs-2\">\n\t\t\t\t\t<label for=\"paymentInstructionsDesigneeCity\" class=\"sr-only\">City</label>\n\t\t\t\t\t<input type=\"text\" id=\"paymentInstructionsDesigneeCity\" name=\"paymentInstructionsDesigneeCity\" class=\"form-control input-lg\" placeholder=\"CITY\" ng-model=\"paymentInstructionsModal.designee.PayeeCity\" ng-required=\"!paymentInstructionsModal.addressDesigneeCollapsed()\">\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-xs-2\">\n\t\t\t\t\t<label for=\"paymentInstructionsDesigneeState\" class=\"sr-only\">State</label>\n\t\t\t\t\t<select id=\"paymentInstructionsDesigneeState\" name=\"paymentInstructionsDesigneeState\" class=\"form-control input-lg\" placeholder=\"STATE\" ng-model=\"paymentInstructionsModal.designee.PayeeState\" ng-required=\"!paymentInstructionsModal.addressDesigneeCollapsed()\" ng-class=\"{ 'default-value': paymentInstructionsModal.designee.PayeeState === undefined }\">\n\t\t\t\t\t\t<option value=\"\">STATE</option>\n\t\t\t\t\t\t<option ng-repeat=\"state in ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY']\" value=\"{{state}}\" ng-selected=\"state === paymentInstructionsModal.designee.PayeeState\">{{state}}</option>\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-xs-2\">\n\t\t\t\t\t<label for=\"paymentInstructionsDesigneeZip\" class=\"sr-only\">Zip</label>\n\t\t\t\t\t<input type=\"text\" id=\"paymentInstructionsDesigneeZip\" name=\"paymentInstructionsDesigneeZip\" class=\"form-control input-lg\" placeholder=\"ZIP\" ng-model=\"paymentInstructionsModal.designee.PayeeZip\" ng-required=\"!paymentInstructionsModal.addressDesigneeCollapsed()\"  ng-minlength=\"5\" ng-maxlength=\"5\">\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"payment-instructions-totals\">\n\t\t\t<div class=\"form-group\">\n\t\t\t\t<label class=\"col-sm-8\">\n\t\t\t\t\t<p>Total</p>\n\t\t\t\t\t<p class=\"total-exceed-warning\" ng-class=\"{ 'exceeded' : paymentInstructionsModal.isTotalExceeded() }\">Total cannot exceed {{ appDetail.paymentInstructions.InitialRequested | currency : '$'}} </p>\n\t\t\t\t</label>\n\t\t\t\t<div class=\"col-sm-4\">\n\t\t\t\t\t<p class=\"form-control-static pull-right\">{{ paymentInstructionsModal.totalAmount() | currency }}</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"form-group\" ng-if=\"paymentInstructionsModal.advancePayment\">\n\t\t\t\t<label class=\"col-sm-8\">\n\t\t\t\t\tAdvance Payment {{ paymentInstructionsModal.advancePayment.CreatedDate | date: \"shortDate\" }}\n\t\t\t\t</label>\n\t\t\t\t<div class=\"col-sm-4\">\n\t\t\t\t\t<p class=\"form-control-static col-sm-4 pull-right\">{{ paymentInstructionsModal.advancePayment.DisbursementAmount | currency }}</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"modal-buttons\">\n\t\t\t<button class=\"btn btn-default pull-right\" ng-click=\"paymentInstructionsModal.closeModal()\">Cancel</button>\n\t\t\t<button class=\"btn btn-primary pull-right\" ng-click=\"paymentInstructionsModal.saveChanges(modifyPaymentInstructionsForm)\" ng-disabled=\"paymentInstructionsModal.isTotalExceeded() || !modifyPaymentInstructionsForm.$valid\">Save Changes</button>\n\t\t</div>\n\t</form>\n</div>\n";

/***/ }),
/* 603 */
/***/ (function(module, exports) {

module.exports = "<h1>\n    Payment Details\n     <span ng-if=\"appDetail.paymentInstructionsConfirmed()\" class=\"step-completed icon icon-complete\"></span>\n</h1>\n\n<p ng-if=\"appDetail.paymentInstructionsConfirmed()\">\n    Verified {{appDetail.paymentInstructions.PaymentVerifiedDate | date : 'shortDate' }}\n    <span ng-if=\"appDetail.paymentInstructions.PaymentVerifiedBy.toLowerCase() !== 'system' \">by {{appDetail.paymentInstructions.PaymentVerifiedBy}}</span>\n</p>\n\n<div class=\"row\">\n    <div class=\"col-md-9\">\n        <div class=\"link-list\" ng-if=\"!appDetail.paymentInstructionsConfirmed() && appDetail.projectDetailsConfirmed() && main.userData.HasElevatedAccess === true && appDetail.paymentInstructions.ContractorPaymentMethodStatusId === 2 && appDetail.fundingRequest.FundingRequestDetail.IsDisbursementLocked === false\">\n            <a href=\"#\" ng-click=\"appDetail.openPaymentInstructionsModal()\">Make Changes</a>\n        </div>\n    </div>\n    <div class=\"col-md-3 text-right\">\n        <a href=\"#\" ng-if=\"appDetail.paymentInstructionsConfirmed()\" ng-click=\"paymentInstructions.isCollapsed = !paymentInstructions.isCollapsed\">{{ paymentInstructions.isCollapsed ? 'Show' : 'Hide' }} Details</a>\n    </div>\n</div>\n\n<div ng-include=\"'app/appDetail/paymentInstructions/paymentInstructionsCommonTemplate.html'\" ng-if=\"appDetail.fundingRequest.FundingRequestDetail.FundingDisbursementModelTypeId !== 40 && appDetail.fundingRequest.FundingRequestDetail.FundingDisbursementModelTypeId !== 50 && appDetail.fundingRequest.FundingRequestDetail.FundingDisbursementModelTypeId !== 11\"></div>\n\n<div ng-include=\"'app/appDetail/paymentInstructions/paymentInstructionsLeaseCommonTemplate.html'\" ng-if=\"(appDetail.fundingRequest.FundingRequestDetail.FundingDisbursementModelTypeId === 40 || appDetail.fundingRequest.FundingRequestDetail.FundingDisbursementModelTypeId === 50) && appDetail.fundingRequest.FundingRequestDetail.FundingDisbursementModelTypeId !== 11\"></div>\n\n<div ng-include=\"'app/appDetail/paymentInstructions/paymentDetailsProjectAdvance.html'\" ng-if=\"appDetail.fundingRequest.FundingRequestDetail.FundingDisbursementModelTypeId === 11\"></div>\n";

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _hpPipelineStageIndicator = __webpack_require__(605);

var _hpPipelineStageIndicator2 = _interopRequireDefault(_hpPipelineStageIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.appDetail.pipelineStageIndicator', []).directive('hpPipelineStageIndicator', _hpPipelineStageIndicator2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/appDetail/pipelineStageIndicator/pipelineStageIndicator.html', __webpack_require__(607)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = pipelineStageIndicator;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(606);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

pipelineStageIndicator.$inject = ['HPPipelineStages', 'FRInformationFactory']; // angular
// 	.module("HeroPRO")
// 	.directive('hpPipelineStageIndicator', pipelineStageIndicator);

/* @ngInject */
function pipelineStageIndicator(HPPipelineStages, FRInformationFactory) {
    var stageIndicatorLink = function stageIndicatorLink(scope) {
        scope.stages = [];
        _lodash2.default.each(HPPipelineStages, function (val) {
            scope.stages.push(val);
        });
        scope.stageList = _lodash2.default.map(scope.stages, _lodash2.default.clone);
        if (scope.stage === null || scope.stage === undefined) {
            FRInformationFactory.getFundingRequestInformationPromise().then(function () {
                var stateMachineData = FRInformationFactory.getStateMachineData();
                if (stateMachineData.PipelineStageId === HPPipelineStages.GetPaid.pipelineStageId || stateMachineData.PipelineStageId === HPPipelineStages.Closed.pipelineStageId) {
                    // (ajt 8/8/2016) Use the FundingRequest pipeline stage id and not the loan stage id for GetPaid and Closed.
                    scope.currentStage = stateMachineData.FundingRequestPipelineStageId;
                } else {
                    // (ajt 8/8/2016) For all other pipeline stages, the use the loan stage id
                    scope.currentStage = stateMachineData.PipelineStageId;
                }
            });
        } else {
            _lodash2.default.delay(function () {
                scope.currentStage = scope.stage;
            });
        }
    };

    return {
        transclude: true,
        replace: true,
        restrict: 'E',
        scope: {
            stage: '@?'
        },
        templateUrl: 'app/appDetail/pipelineStageIndicator/pipelineStageIndicator.html',
        link: stageIndicatorLink
    };
}

/***/ }),
/* 606 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 607 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-pipeline-stage-indicator-container\">\n    <div class=\"pipeline-stage-element\" ng-repeat=\"stage in stageList\"\n         ng-class=\"{'completed': $index < currentStage, 'completed-text' : $index < currentStage, 'end-segment' : $index === currentStage - 1}\">\n        {{stage.name}}\n        <div ng-class=\"{'chevron': $index < stageList.length - 1 && $index === currentStage - 1}\"></div>\n        <div ng-class=\"{'chevron-arrow': $index !== stageList.length - 1, 'active': $index === currentStage - 1,\n                        'overlap': $index < stageList.length - 1 && $index === currentStage - 1,\n                        'completed': $index < currentStage - 1 }\"></div>\n    </div>\n</div>\n";

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _projectdetailsController = __webpack_require__(609);

var _projectdetailsController2 = _interopRequireDefault(_projectdetailsController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.appDetail.productDetails', []).controller('ProjectDetailsController', _projectdetailsController2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/appDetail/projectDetails/disabledProjectDetails.html', __webpack_require__(611)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/projectDetails/projectDetailsSummaryTemplate.html', __webpack_require__(612)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/projectDetails/projectDetailsTemplate.html', __webpack_require__(613)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = projectDetailsController;

__webpack_require__(610);

projectDetailsController.$inject = ['$scope', 'FRClosingFactory', 'FRInformationFactory']; // angular
// 	.module("HeroPRO")
// 	.controller("ProjectDetailsController", projectDetailsController);

/* @ngInject */
function projectDetailsController($scope, FRClosingFactory, FRInformationFactory) {
    var vm = this;
    vm.isCollapsed = true;
    vm.approvalAmount = null;

    init();

    function init() {
        FRInformationFactory.getFundingRequestInformationPromise().then(function () {
            vm.approvalAmount = FRInformationFactory.getAppInfo().ApprovalAmount;
        });

        $scope.$watch(function () {
            return FRClosingFactory.getProjectDetailsConfirmed();
        }, function (newValue) {
            vm.isCollapsed = newValue;
        });
    }
}

/***/ }),
/* 610 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 611 */
/***/ (function(module, exports) {

module.exports = "<div class=\"disabled-project-details\">\n    <h1>\n        Project Details\n    </h1>\n\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"\">\n                <p>Project details will appear here when project is confirmed by HERO. This will include products, total costs, and financing terms.</p>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports = "<div class=\"details funding-table\">\n    <div uib-collapse=\"projectDetails.isCollapsed\">\n        <div class=\"row row-header\">\n            <div class=\"col-md-7 text-left\">Product Info</div>\n            <div class=\"col-md-2 text-right\">QTY</div>\n            <div class=\"col-md-3 text-right\">Amount</div>\n        </div>\n\n        <div class=\"row\" ng-repeat=\"product in appDetail.projectDetails.Improvements\">\n            <div class=\"col-md-7 text-left\">\n                <div class=\"product-name\">{{product.ProductTypeName}}</div>\n                <div class=\"product-attribute\" ng-repeat=\"productAttribute in product.ProductAttributes\">{{productAttribute.AttributeName}} {{productAttribute.AttributeValue}}</div>\n            </div>\n            <div class=\"col-md-2 text-right\">{{product.Quantity}}</div>\n            <div class=\"col-md-3 text-right\">{{product.TotalApproved || product.InitialRequested | currency}}</div>\n        </div>\n    </div>\n\n    <div class=\"row row-footer\">\n        <div class=\"col-md-9 text-right\"><b>Total</b></div>\n        <div class=\"col-md-3 text-right\">{{appDetail.projectDetails.TotalRequested || appDetail.projectDetails.InitialRequested | currency}}</div>\n    </div>\n\n    <div class=\"row\">\n        <div class=\"col-md-9 text-right\"><b>Term</b></div>\n        <div class=\"col-md-3 text-right\">{{appDetail.projectDetails.Term}} Years</div>\n    </div>\n</div>\n";

/***/ }),
/* 613 */
/***/ (function(module, exports) {

module.exports = "<div class=\"funding-table\">\r\n  <h1>\r\n    Project Details\r\n    <span ng-if=\"appDetail.projectDetailsConfirmed()\" class=\"step-completed icon icon-complete\"></span>\r\n  </h1>\r\n\r\n  <p ng-if=\"appDetail.projectDetailsConfirmed()\">\r\n    Verified {{appDetail.projectDetails.ProjectDetailsVerifiedDate | date: \"shortDate\"}}\r\n    <span ng-if=\"appDetail.projectDetails.ProjectDetailsVerifiedBy.toLowerCase() !== 'system' \">by {{appDetail.projectDetails.ProjectDetailsVerifiedBy}}</span>\r\n  </p>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-md-9\">\r\n      <div class=\"link-list\">\r\n        <a ng-if=\"!appDetail.appInfo.UnderwriterLock\" href=\"#\" ng-click=\"appDetail.openMakeChangesModal()\">Make Changes</a>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-md-3 text-right\">\r\n      <a href=\"#\" ng-if=\"appDetail.projectDetailsConfirmed()\"\r\n         ng-click=\"projectDetails.isCollapsed = !projectDetails.isCollapsed\">{{ projectDetails.isCollapsed ? 'Show' :\r\n        'Hide' }} Details</a>\r\n    </div>\r\n  </div>\r\n  <div ng-include=\"'app/appDetail/projectDetails/projectDetailsSummaryTemplate.html'\" id=\"project-details-summary\"></div>\r\n</div>\r\n";

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _projectHistoryModalController = __webpack_require__(615);

var _projectHistoryModalController2 = _interopRequireDefault(_projectHistoryModalController);

var _projectHistoryFactory = __webpack_require__(617);

var _projectHistoryFactory2 = _interopRequireDefault(_projectHistoryFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.appDetail.projectHistory', []).controller('ProjectHistoryModalController', _projectHistoryModalController2.default).factory('ProjectHistoryFactory', _projectHistoryFactory2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/appDetail/projectHistory/noProjectHistory.html', __webpack_require__(618)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/projectHistory/projectHistoryContent.html', __webpack_require__(619)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/projectHistory/projectHistoryModal.html', __webpack_require__(620)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = projectHistoryModalController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(616);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

projectHistoryModalController.$inject = ['fundingRequestId', '$uibModalInstance', 'ProjectHistoryFactory']; // angular
// 	.module("HeroPRO")
// 	.controller("ProjectHistoryModalController", projectHistoryModalController);

/* @ngInject */
function projectHistoryModalController(fundingRequestId, $uibModalInstance, ProjectHistoryFactory) {
    var vm = this;

    vm.loaded = false;
    vm.history = [];

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    vm.closeModal = function () {
        var result = false;

        $uibModalInstance.close(result);
    };

    /* -----  End of Public Functions  ------*/

    /*= ========================================
    =            Private Functions            =
    ========================================= */

    function init() {
        getProjectHistory();
    }

    function getProjectHistory() {
        var params = {
            FundingRequestId: fundingRequestId
        };

        ProjectHistoryFactory.getProjectHistory(params).then(function (response) {
            buildHistorySet(response.data.Data.ProjectHistoryDetails);
            vm.loaded = true;
        });
    }

    function buildHistorySet(historyCollection) {
        var groupedHistoryItems = _lodash2.default.groupBy(historyCollection, function (item) {
            return item.CreatedDate.substring(5, 7);
        });

        _lodash2.default.each(groupedHistoryItems, function (groupedItem, key) {
            var newRecord = {
                month: Number(key),
                records: []
            };
            vm.history.push(newRecord);
            _lodash2.default.each(groupedItem, function (item) {
                newRecord.records.push(item);
            });
        });
    }

    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 616 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = projectHistoryFactory;
projectHistoryFactory.$inject = ["$http", "HPConfig"];
// angular
// 	.module("HeroPRO")
// 	.factory("ProjectHistoryFactory", projectHistoryFactory);

/* @ngInject */
function projectHistoryFactory($http, HPConfig) {
    return {
        getProjectHistory: getProjectHistory
    };

    function getProjectHistory(params) {
        return $http.get(HPConfig.heroProApi + "Loan/FundingRequest/ProjectHistory", {
            params: params
        });
    }
}

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports = "<div class=\"no-project-history row\">\n    <div class=\"col-md-8 col-md-offset-2\">\n        <span class=\"icon icon-history-thin\"></span>\n        <p class=\"no-project-history-message\">History only available for projects started on or after 10/27/16</p>\n    </div>\n</div>\n";

/***/ }),
/* 619 */
/***/ (function(module, exports) {

module.exports = "<div class=\"project-history-group\" ng-repeat=\"group in projectHistoryModal.history\">\n    <div class=\"row\">\n        <div class=\"col-md-2\">\n            <h3 class=\"project-history-month-header\" ng-bind=\"group.month | monthName\"></h3>\n        </div>\n        <div class=\"col-md-10 project-history-header-placeholder\" ng-if=\"$index !== 0\">\n\n        </div>\n    </div>\n    <div class=\"row project-history-row\" ng-repeat=\"row in group.records\">\n        <div class=\"row\">\n            <div class=\"col-md-2 text-left\">\n                <div class=\"project-history-datetime\">\n                    <div class=\"project-history-date\">\n                        <span ng-bind=\"row.CreatedDate | date : 'M/dd/yyyy'\"></span>\n                    </div>\n                    <div class=\"project-history-time\">\n                        <span ng-bind=\"row.CreatedDate | date : 'hh:mm a'\"></span>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-md-10\">\n                <span class=\"icon icon-history-thick\"></span>\n                <span class=\"project-history-message\" ng-bind=\"row.Message\"></span>\n            </div>\n        </div>\n\n        <div class=\"row\">\n            <div class=\"col-md-2 project-history-datetime-placeholder\">\n            </div>\n            <div class=\"col-md-10 project-history-message-placeholder\" ng-if=\"$index < group.records.length - 1\">\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports = "\n<div class=\"modal-header\">\n    <span class=\"icon icon-close-thin\" ng-click=\"projectHistoryModal.closeModal()\"></span>\n</div>\n\n<div class=\"row\">\n    <div class=\"col-md-10 col-md-offset-1\">\n\n        <div class=\"modal-body hp-loading-spinner\" ra-spinner name=\"projectHistorySpinner\" hide-content-when-shown=\"true\"\n             show=\"projectHistory.loaded\"\n             register=\"false\" template=\"indeterminateSpinner\">\n            <p class=\"modal-title\">Project History</p>\n\n            <div class=\"project-history-details-container\">\n                <div ng-include=\"'app/appDetail/projectHistory/projectHistoryContent.html'\" ng-if=\"projectHistoryModal.history.length > 0\"></div>\n                <div ng-include=\"'app/appDetail/projectHistory/noProjectHistory.html'\" ng-if=\"projectHistoryModal.history.length === 0\"></div>\n            </div>\n        </div>\n\n    </div>\n</div>\n\n\n\n";

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _projectInformationController = __webpack_require__(622);

var _projectInformationController2 = _interopRequireDefault(_projectInformationController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.appDetail.projectInformation', []).controller('ProjectInformationController', _projectInformationController2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/appDetail/projectInformation/projectInformation.html', __webpack_require__(623)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = projectInformationController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

projectInformationController.$inject = ['FRClosingFactory']; // angular
// 	.module("HeroPRO")
// 	.controller("ProjectInformationController", projectInformationController);

/* @ngInject */
function projectInformationController(FRClosingFactory) {
    var vm = this;
    vm.projectDetails = {};
    vm.paymentInstructions = {};
    vm.isProjectDetailsDisplayed = false;
    vm.isLoaded = false;
    vm.isPaymentInstructionsDisplayed = false;

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */
    function init() {
        FRClosingFactory.getFundingRequestClosingPromise().then(function () {
            vm.projectDetails = FRClosingFactory.getProjectDetails();
            vm.paymentInstructions = FRClosingFactory.getPaymentInstructions();
            vm.isProjectDetailsDisplayed = !_lodash2.default.isEmpty(vm.projectDetails);
            vm.isPaymentInstructionsDisplayed = !_lodash2.default.isEmpty(vm.paymentInstructions) && vm.paymentInstructions.InitialRequested !== undefined;
            vm.isLoaded = true;
        });
    }
    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n\t<div class=\"col-md-12\">\n    \t<div ng-include=\"'app/appDetail/projectDetails/projectDetailsTemplate.html'\" id=\"project-details\" ng-controller=\"ProjectDetailsController as projectDetails\" ng-if=\"projectInformation.isProjectDetailsDisplayed && projectInformation.isLoaded\"></div>\n        <div ng-include=\"'app/appDetail/projectDetails/disabledProjectDetails.html'\" id=\"disabled-project-instructions\" ng-if=\"!projectInformation.isProjectDetailsDisplayed && projectInformation.isLoaded\"></div>\n    </div>\n</div>\n<div class=\"row\">\n    <div class=\"col-md-12\">\n        <div ng-include=\"'app/appDetail/paymentInstructions/paymentInstructionsTemplate.html'\" ng-if=\"projectInformation.isPaymentInstructionsDisplayed && projectInformation.isLoaded\" id=\"payment-instructions\" ng-controller=\"PaymentInstructionsController as paymentInstructions\"></div>\n        <div ng-include=\"'app/appDetail/paymentInstructions/disabledPaymentInstructions.html'\" id=\"disabled-payment-instructions\" ng-if=\"!projectInformation.isPaymentInstructionsDisplayed && projectInformation.isLoaded\"></div>\n    </div>\n</div>\n";

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _application = __webpack_require__(625);

var _application2 = _interopRequireDefault(_application);

var _closed = __webpack_require__(640);

var _closed2 = _interopRequireDefault(_closed);

var _getPaid = __webpack_require__(646);

var _getPaid2 = _interopRequireDefault(_getPaid);

var _startWork = __webpack_require__(667);

var _startWork2 = _interopRequireDefault(_startWork);

var _walkthroughController = __webpack_require__(686);

var _walkthroughController2 = _interopRequireDefault(_walkthroughController);

var _walkthroughFactory = __webpack_require__(688);

var _walkthroughFactory2 = _interopRequireDefault(_walkthroughFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.appDetail.walkthrough', [_application2.default, _closed2.default, _getPaid2.default, _startWork2.default]).controller('WalkthroughController', _walkthroughController2.default).factory('WalkthroughFactory', _walkthroughFactory2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/appDetail/walkthrough/walkthrough.html', __webpack_require__(689)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/walkthrough/walkthroughNotFound.html', __webpack_require__(690)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _applicationMessageController = __webpack_require__(626);

var _applicationMessageController2 = _interopRequireDefault(_applicationMessageController);

var _applicationResultsController = __webpack_require__(628);

var _applicationResultsController2 = _interopRequireDefault(_applicationResultsController);

var _CallInProductsController = __webpack_require__(630);

var _CallInProductsController2 = _interopRequireDefault(_CallInProductsController);

var _productAddedController = __webpack_require__(632);

var _productAddedController2 = _interopRequireDefault(_productAddedController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.appDetail.walkthrough.application', []).controller('ApplicationMessageController', _applicationMessageController2.default).controller('ApplicationResultsController', _applicationResultsController2.default).controller('CallInProductsController', _CallInProductsController2.default).controller('ProductAddedController', _productAddedController2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/appDetail/walkthrough/application/addProductsOnline.html', __webpack_require__(634)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/walkthrough/application/applicationMessage.html', __webpack_require__(635)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/walkthrough/application/applicationResults.html', __webpack_require__(636)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/walkthrough/application/callInProducts.html', __webpack_require__(637)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/walkthrough/application/productAdded.html', __webpack_require__(638)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/walkthrough/application/productsSubmitted.html', __webpack_require__(639)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ApplicationMessageController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(627);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

ApplicationMessageController.$inject = ['FRInformationFactory', 'UserData', 'HPAppDetailTypes']; // angular
// 	.module("HeroPRO")
// 	.controller("ApplicationMessageController", ApplicationMessageController);

/* @ngInject */
function ApplicationMessageController(FRInformationFactory, UserData, HPAppDetailTypes) {
    var vm = this;
    vm.appInfo = {};
    vm.showMessage = true;
    vm.message = { header: '', text: '' };

    vm.init = function () {
        FRInformationFactory.getFundingRequestInformationPromise().then(function () {
            vm.appInfo = FRInformationFactory.getAppInfo();
            vm.applicationMessages();
        });
    };

    vm.applicationMessages = function () {
        UserData.getCurrentLocation().then(function (locationDataResponse) {
            // Check if the organization has a buydown rate
            var buydownTermSets = _lodash2.default.findWhere(locationDataResponse.OrganizationTermSets, { TermSetTypeId: HPAppDetailTypes.TermSetTypes.BuyDown });
            // if (buydownTermSets !== undefined) {
            //     // Check if the property address belongs to a program that has mattherhorn term set rates
            //     if (_.findWhere(locationDataResponse.OrganizationTermSets, { ProgramId: vm.appInfo.ProgramId } !== undefined)) {
            //         vm.setMatterhornMessage();
            //     } else {
            //         vm.setNonMatterhorn();
            //     }
            // }
        });
    };

    vm.setNonMatterhorn = function () {
        vm.message.header = 'Standard HERO rates apply on this home.';
        vm.message.text = 'For rate details, contact your account manager.';
        vm.message.class = 'col-md-12 app-message warn';
        vm.showMessage = true;
    };

    vm.setMatterhornMessage = function () {
        vm.message.header = 'Good news! Promotional rates apply on this home.';
        vm.message.text = 'For rate details, contact your account manager.';
        vm.message.class = 'col-md-12 app-message good';
        vm.showMessage = true;
    };

    vm.init();
}

/***/ }),
/* 627 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ApplicationResultsController;

__webpack_require__(629);

ApplicationResultsController.$inject = ['FRInformationFactory', 'HPStateMachineConfig', 'HPConfig']; // angular
// 	.module("HeroPRO")
// 	.controller("ApplicationResultsController", ApplicationResultsController);

/* @ngInject */
function ApplicationResultsController(FRInformationFactory, HPStateMachineConfig, HPConfig) {
    var vm = this;
    vm.appInfo = {};
    vm.applicationStatus = '';
    vm.isConditionallyApproved = false;
    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */
    function init() {
        vm.isDevelopment = HPConfig.environment == 'DEV';
        FRInformationFactory.getFundingRequestInformationPromise().then(function () {
            vm.appInfo = FRInformationFactory.getAppInfo();
            var stateMachineData = FRInformationFactory.getStateMachineData();
            vm.isConditionallyApproved = stateMachineData.LoanStateId === HPStateMachineConfig.Loan.AUS_Conditionally_Approved;
            updateStatus();
        });
    }

    function updateStatus() {
        switch (vm.appInfo.ApplicationStatus) {
            case 'Cancelled':
                vm.applicationStatus = 'Approved';
                break;
            case 'Final - Canceled 1':
            case 'Final - Canceled 2':
            case 'Final - Canceled 3':
                vm.applicationStatus = 'Approved';
                break;
            case 'Final - Denied':
                vm.applicationStatus = 'Denied';
                break;
            case 'Final - Funded':
                vm.applicationStatus = 'Denied';
                break;
            default:
                vm.applicationStatus = vm.appInfo.ApplicationStatus;
                break;
        }
    }
}

/***/ }),
/* 629 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CallInProductsController;

__webpack_require__(631);

CallInProductsController.$inject = ['FRInformationFactory', 'HPConfig', 'ModalService', '$analytics', 'DealTypeFactory', 'AddProductsFactory']; // angular
// 	.module("HeroPRO")
// 	.controller("CallInProductsController", CallInProductsController);

/* @ngInject */
function CallInProductsController(FRInformationFactory, HPConfig, ModalService, $analytics, DealTypeFactory, AddProductsFactory) {
    var vm = this;
    vm.appInfo = {};
    vm.address = '';
    vm.showLeaseOption = false;
    vm.showDirectPayOption = false;
    vm.dealTypeDataLoaded = false;
    vm.selectedDealType = null;

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.openAddProductsModal = function (_visibleModules) {
        ModalService.launchLgModal({
            templateUrl: 'app/appDetail/addProducts/addProductsModal.html',
            windowClass: 'add-products-modal full-screen',
            controller: 'AddProductsModalController',
            controllerAs: 'addProductsModal',
            size: 'full-screen',
            animation: false,
            resolve: {
                visibleModules: function visibleModules() {
                    return _visibleModules || [];
                }
            }
        });

        $analytics.eventTrack('Open Add Product Modal', { category: 'Walkthrough' });
    };

    vm.openAddProductsWebsite = function () {
        AddProductsFactory.openAddProductsWebsite();
    };
    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */
    function init() {
        FRInformationFactory.getFundingRequestInformationPromise().then(function () {
            vm.appInfo = FRInformationFactory.getAppInfo();
            vm.address = vm.appInfo.Address.Address1 + ' ' + vm.appInfo.Address.City + ', ' + vm.appInfo.Address.State + ' ' + vm.appInfo.Address.ZIPCode;
            vm.productsLink = HPConfig.heroProLink + '/product-lookup/directory/' + vm.appInfo.Address.State + '/';

            vm.callInProductsReason = 'Call us to specify product, total costs and financing terms.';

            if (vm.appInfo.CanAddProductsOnline === 1) {
                // UncommonOwnership = 1,
                vm.callInProductsReason = 'Call us to specify product, total costs and financing terms.';
            } else if (vm.appInfo.CanAddProductsOnline === 2) {
                // LoanHasMultiRate = 2,
                vm.callInProductsReason = 'Call us to specify product, total costs and financing terms.';
            } else if (vm.appInfo.CanAddProductsOnline === 3) {
                // ApplicationExpired = 3,
                vm.callInProductsReason = 'This file is expired. Please contact us at';
            } else if (vm.appInfo.CanAddProductsOnline === 4) {
                // LoanLocked = 4
                vm.callInProductsReason = 'This file requires additional information. Please contact us at';
            }

            processDealType();
        });
    }

    function processDealType() {
        // Check if the deal type has already been set
        if (DealTypeFactory.getSelectedDealType().DealTypeId) {
            // Deal type has been set
            vm.selectedDealType = DealTypeFactory.getSelectedDealType();
            vm.dealTypeDataLoaded = true;
        } else {
            // Deal type has not been set, retrieve available deal types
            var params = {
                LoanId: vm.appInfo.LoanId,
                ContractorLocationId: vm.appInfo.Contractor.ContractorLocationId
            };

            DealTypeFactory.fetchAvailableDealTypes(params).then(function () {
                if (DealTypeFactory.hasLeaseDealType() === true) {
                    vm.showLeaseOption = true;
                }

                if (DealTypeFactory.hasDirectPayDealType() === true) {
                    vm.showDirectPayOption = true;
                }

                vm.dealTypeDataLoaded = true;
            });
        }
    }
}

/***/ }),
/* 631 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = productAddedController;

__webpack_require__(633);

productAddedController.$inject = ['FRInformationFactory', 'FRClosingFactory', 'SelectedProductsFactory', 'ModalService', '$analytics', 'HPStateMachineConfig', 'AddProductsFactory']; // angular
// 	.module("HeroPRO")
// 	.controller("ProductAddedController", productAddedController);


/* @ngInject */
function productAddedController(FRInformationFactory, FRClosingFactory, SelectedProductsFactory, ModalService, $analytics, HPStateMachineConfig, AddProductsFactory) {
    var vm = this;
    vm.appInfo = {};
    vm.products = {};
    vm.productSubtotal = 0;
    vm.financingTerm = 0;
    vm.interestAndFees = 0;
    vm.prePayment = 0;
    vm.projectTotal = 0;
    vm.productsLoaded = false;
    vm.addedProductCaseInfo = {};

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.openAddProductsModal = function (_visibleModules) {
        ModalService.launchLgModal({
            templateUrl: 'app/appDetail/addProducts/addProductsModal.html',
            windowClass: 'add-products-modal full-screen',
            controller: 'AddProductsModalController',
            controllerAs: 'addProductsModal',
            size: 'full-screen',
            animation: false,
            resolve: {
                visibleModules: function visibleModules() {
                    return _visibleModules || [];
                }
            }
        });

        if (_visibleModules === undefined) {
            $analytics.eventTrack('Add More Products', { category: 'Walkthrough' });
        } else {
            $analytics.eventTrack('Set Term', { category: 'Walkthrough' });
        }
    };

    vm.openAddProductsWebsite = function () {
        AddProductsFactory.openAddProductsWebsite();
    };

    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */

    function init() {
        FRInformationFactory.getFundingRequestInformationPromise().then(function () {
            vm.appInfo = FRInformationFactory.getAppInfo();

            SelectedProductsFactory.getAddedProducts({ FundingRequestId: vm.appInfo.FundingRequestId }, true).then(function () {
                vm.products = angular.copy(SelectedProductsFactory.getSelectedProducts());
                if (vm.products.length > 0) {
                    vm.productSubtotal = SelectedProductsFactory.getProductSubtotal();
                    vm.financingTerm = SelectedProductsFactory.getFinancingTerm();
                    SelectedProductsFactory.getInterestAndFees(vm.appInfo).then(function (response) {
                        vm.interestAndFees = response;
                        if (vm.appInfo.ClosingPrepayCAPI !== undefined && vm.appInfo.ClosingPrepayCAPI === true) {
                            vm.prePayment += vm.interestAndFees.CAPI || vm.interestAndFees.CAPIPrepay;
                        }
                        if (vm.appInfo.ClosingPrepayFees !== undefined && vm.appInfo.ClosingPrepayFees === true) {
                            vm.prePayment += vm.interestAndFees.ClosingCosts || vm.interestAndFees.ClosingCostsPrepay;
                        }
                        vm.projectTotal = SelectedProductsFactory.getProjectTotal(); // - vm.prePayment;
                        vm.productsLoaded = true;
                    });
                }
            });

            // If the application is in the Products_Submitted state, get the case information
            if (vm.appInfo.LoanStateId === HPStateMachineConfig.Loan.Products_Submitted) {
                AddProductsFactory.getAddedProductsCase(vm.appInfo.FundingRequestId).then(function (response) {
                    vm.addedProductCaseInfo = response.data;
                });
            }
        });
    }
}

/***/ }),
/* 633 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports = "<ng-include src=\"'app/appDetail/walkthrough/application/applicationMessage.html'\"></ng-include>\n<div class=\"call-in-products\" ng-controller=\"CallInProductsController as callInProducts\">\n\t<div class=\"row\" ng-show=\"callInProducts.dealTypeDataLoaded === true\">\n\t\t<div class=\"col-md-12\">\n\t\t\t<div class=\"row section-title\">\n\t\t\t\t<div class=\"col-md-12 text-center call-in-products-information\">\n\t\t\t\t\t<h5>This application is approved.</h5>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-md-12 call-in-products-actions text-center\">\n\t\t\t\t\t<p class=\"eyecatch\">Next Steps</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-md-12 new-add-products text-center\">\n\t\t\t\t\t<p class=\"font-weight-bold\"><span class=\"new-tag\">New</span> Add Products has been redesigned!</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-md-8 col-md-offset-2 text-center\">\n\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\tAdd products to this project.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<!-- <button class=\"btn btn-primary\" ng-if=\"callInProducts.dealTypeDataLoaded === true && callInProducts.showDirectPayOption === true\" ng-click=\"callInProducts.openAddProductsModal(['dealTypePurchase'])\" ng-disabled=\"false\">Select Products for Purchase</button>\n\n\t\t\t\t\t\t<button class=\"btn btn-primary\" ng-if=\"callInProducts.dealTypeDataLoaded === true && callInProducts.showDirectPayOption === false && (callInProducts.selectedDealType.DealTypeId === undefined || callInProducts.selectedDealType.DealTypeId === 1 || callInProducts.selectedDealType.DealTypeId === 3)\" ng-click=\"callInProducts.openAddProductsModal()\" ng-disabled=\"false\">Select Products for Purchase</button>\n\n\t\t\t\t\t\t<button class=\"btn btn-primary\" ng-if=\"callInProducts.dealTypeDataLoaded === true && callInProducts.showDirectPayOption === false && callInProducts.selectedDealType.DealTypeId !== undefined && callInProducts.selectedDealType.DealTypeId !== 1 && callInProducts.selectedDealType.DealTypeId !== 3\" ng-click=\"callInProducts.openAddProductsModal()\" ng-disabled=\"false\">Select Products</button> -->\n\n\t\t\t\t\t\t<button class=\"btn btn-primary\" ng-click=\"callInProducts.openAddProductsWebsite()\">Add Products</button>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- <div ng-if=\"callInProducts.showLeaseOption === true\">\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\tWhat deal type would you like to use to start this transaction?\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<button class=\"btn btn-default\" ng-click=\"callInProducts.openAddProductsModal(['dealTypeLease'])\" ng-disabled=\"false\">Prepaid Lease or PPA</button>\n\t\t\t\t\t\t<button class=\"btn btn-default\" ng-if=\"callInProducts.showDirectPayOption === true\" ng-click=\"callInProducts.openAddProductsModal(['dealTypePurchase'])\" ng-disabled=\"false\">Purchase</button>\n\t\t\t\t\t\t<button class=\"btn btn-default\" ng-if=\"callInProducts.showDirectPayOption === false\" ng-click=\"callInProducts.openAddProductsModal()\" ng-disabled=\"false\">Purchase</button>\n\t\t\t\t\t</div> -->\n\n\n\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-md-12 text-center how-to-add-products-title\">\n\t\t\t\t\t<h6 class=\"font-weight-bold\">Add products in three easy steps:</h6>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row how-to-add-products\">\n\t\t\t\t<div class=\"col-md-4 text-center\">\n\t\t\t\t\t<h6>1 <span></span> Pick a product</h6>\n\t\t\t\t\t<p>Choose a product category and product type, or select from recently selected products.</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-4 text-center\">\n\t\t\t\t\t<h6>2 <span></span> Add product details</h6>\n\t\t\t\t\t<p>Enter the product details, quantity and any additional work scope required.</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-4 text-center\">\n\t\t\t\t\t<h6>3 <span></span> Set price &amp; terms</h6>\n\t\t\t\t\t<p>Enter the price per product and financing details. That’s it! Now you can generate financing\n\t\t\t\t\t\tdocs.</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-md-12 text-center\">\n\t\t\t\t\t<p>\n\t\t\t\t\t\tNot sure what is eligible? Explore our database of <a ng-href=\"{{callInProducts.productsLink}}\"\n\t\t\t\t\t\t\ttarget=\"_blank\" analytics-on=\"click\" analytics-event=\"Open Product Library\"\n\t\t\t\t\t\t\tanalytics-category=\"Walkthrough\">eligible products.</a>\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\t\t</div>\n\t</div>";

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports = "<div class=\"app-message-container\" ng-controller=\"ApplicationMessageController as appMsg\">\n    <div class=\"row\" ng-show=\"appMsg.showMessage\">\n        <div ng-class=\"appMsg.message.class\">\n            <div class=\"row\">\n                <div class=\"col-md-12\">\n                    <div class=\"row\">\n                        <div class=\"app-message-header\">{{appMsg.message.header}}</div>\n                        <div class=\"app-message-text\">{{appMsg.message.text}}</div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports = "<ng-include src=\"'app/appDetail/walkthrough/application/applicationMessage.html'\"></ng-include>\r\n<div class=\"application-results\" ng-controller=\"ApplicationResultsController as applicationResults\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <div class=\"row\">\r\n                <div class=\"col-md-10 col-md-offset-1 application-information\">\r\n                    <h5>This application has been submitted on {{ applicationResults.appInfo.ApplicationDate | date : 'shortDate' }}\r\n                        <span ng-if=\"!applicationResults.isConditionallyApproved\">and is in review.</span>\r\n                        <span ng-if=\"applicationResults.isConditionallyApproved\">and has been conditionally approved.</span>\r\n                    </h5>\r\n                </div>\r\n                <div class=\"col-md-10 col-md-offset-1\" ng-if=\"applicationResults.appInfo.UnderwritingStateId == 1\">\r\n                    <p class=\"text-center\">Our underwriting team will review the application and provide you an update. You should see an update within 15 minutes.</p>\r\n                </div>\r\n                <div class=\"col-md-10 col-md-offset-1\" ng-if=\"applicationResults.appInfo.UnderwritingStateId == 2\">\r\n                    <p class=\"text-center\">Our underwriting team is currently reviewing, you should see an update within 15 minutes.</p>\r\n                </div>\r\n                <div class=\"col-md-10 col-md-offset-1\" ng-if=\"applicationResults.appInfo.UnderwritingStateId == 3\">\r\n                    <p class=\"text-center\">Our underwriting team has requested documentation from the homeowner via email and you have been copied.</p>\r\n                    <div class='conditions-list'>\r\n                    <ul>\r\n                        <li ng-repeat=\"condition in applicationResults.appInfo.Conditions\">\r\n                            {{condition.Name}}\r\n                        </li>\r\n                    </ul>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-10 col-md-offset-1\" ng-if=\"applicationResults.appInfo.UnderwritingStateId == 4\">\r\n                    <p class=\"text-center\">The homeowner has submitted the requested documents and they are pending Underwriting review.</p>\r\n                </div>\r\n                <div class=\"col-md-10 col-md-offset-1\" ng-if=\"applicationResults.appInfo.UnderwritingStateId == 5\">\r\n                    <p class=\"text-center\">The homeowner has submitted the requested documents and our underwriting team is now reviewing.</p>\r\n                </div>          \r\n                <div class=\"col-md-10 col-md-offset-1\" ng-if=\"applicationResults.appInfo.UnderwritingStateId == 6\">\r\n                    <p class=\"text-center\">This application is pending decision.</p>\r\n                </div>                                      \r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"col-md-12 application-actions text-center\">\r\n                    <p class=\"eyecatch\">Next Steps</p>\r\n                </div>\r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"col-md-8 col-md-offset-2 text-center\">\r\n                    <p ng-if=\"applicationResults.appInfo.UnderwritingStateId == 1 || applicationResults.appInfo.UnderwritingStateId == 2\">You and the homeowner will get detailed instructions via email once the underwriter has completed their review. This page will also update with additional information.</p>\r\n                    <p ng-if=\"applicationResults.appInfo.UnderwritingStateId == 3\">Please check your email and work with your homeowner to get the required documentation uploaded.</p>\r\n                    <p ng-if=\"applicationResults.appInfo.UnderwritingStateId == 4 || applicationResults.appInfo.UnderwritingStateId == 5\">Our underwriting team will complete their review and let you know next steps. This process usually takes around 15 minutes from document submission.</p>\r\n                    <p ng-if=\"applicationResults.appInfo.UnderwritingStateId == 6\">Our underwriting team will complete their review and let you know next steps.</p>\r\n                </div>\r\n            </div>           \r\n        </div>\r\n    </div>\r\n</div>\r\n";

/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports = "<ng-include src=\"'app/appDetail/walkthrough/application/applicationMessage.html'\"></ng-include>\n<div class=\"call-in-products\" ng-controller=\"CallInProductsController as callInProducts\">\n\n\t<div class=\"row\">\n\t\t<div class=\"col-md-12\">\n\t\t\t<div class=\"row section-title\">\n\t\t\t\t<div class=\"col-md-12 text-center call-in-products-information\">\n\t\t\t\t\t<h5 ng-bind=\"callInProducts.address\"></h5>\n                    <h5>is approved for up to {{callInProducts.appInfo.ApprovalAmount | currency}}</h5>\n\t\t\t\t</div>\n\t\t\t</div>\n            <div class=\"row\">\n                <div class=\"col-md-12 call-in-products-actions text-center\">\n                    <p class=\"eyecatch\">Next Steps</p>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-8 col-md-offset-2 text-center\">\n                    <p ng-if=\"callInProducts.appInfo.LoanStateId !== 13\">\n                        {{callInProducts.callInProductsReason}}\n                    </p>\n                    <p ng-if=\"callInProducts.appInfo.LoanStateId === 13\">\n                        There are a couple of details we still need before we can generate your financing docs. Please give us a call.\n                    </p>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-8 col-md-offset-2 text-center\">\n                    <p class=\"contact-number\">844-722-7759</p>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-8 col-md-offset-2 text-center\">\n                    <p>Need to see if your products qualify for HERO? <a ng-href=\"{{callInProducts.productsLink}}\" target=\"_blank\" analytics-on=\"click\" analytics-event=\"View HERO Eligible Products\" analytics-category=\"Walkthrough\" analytics-label=\"Application\">View HERO Eligible Products ></a></p>\n                </div>\n            </div>\n\t\t</div>\n\t</div>\n</div>\n";

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports = "<ng-include src=\"'app/appDetail/walkthrough/application/applicationMessage.html'\"></ng-include>\n<div class=\"product-added\" ng-controller=\"ProductAddedController as productAdded\">\n\t<div class=\"row\" ng-if=\"!productAdded.productsLoaded\">\n\t\t<div class=\"col-md-12\">\n\t\t\t<div class=\"row section-title\">\n\t\t\t\t<div class=\"col-md-10 col-md-offset-1 text-center call-in-products-information\">\n\t\t\t\t\t<h5>Loading...</h5>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div> \n\t<div class=\"row\" ng-if=\"productAdded.productsLoaded === true\">\n\t\t<div class=\"col-md-12\">\n\t\t\t<div class=\"row section-title\">\n\t\t\t\t<div class=\"col-md-10 col-md-offset-1 text-center call-in-products-information\">\n\t\t\t\t\t<h5>Look over your product details and set the term when you're ready.</h5>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-md-11 col-md-offset-1\">\n\t\t\t\t\t<table cellpadding=\"0\" cellspacing=\"0\" ng-repeat=\"productCategory in productAdded.products\">\n\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<th colspan=\"3\">{{productCategory.category.DisplayName}}</th>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t</thead>\n\t\t\t\t\t    <tbody ng-repeat=\"product in productCategory.products\">\n\t\t\t\t\t    <tr ng-class=\"{'no-product': !product.primaryProduct.Product.DisplayName }\">\n\t\t\t\t\t        <td class=\"product-info\">\n\t\t\t\t\t            <p class=\"product-type\">{{product.primaryProduct.Product.ProductCategory.ProductType.DisplayName}}</p>\n\t\t\t\t\t            <p ng-show=\"product.primaryProduct.Product.DisplayName\" class=\"product-name\">{{product.primaryProduct.Product.DisplayName}}</p>\n\t\t\t\t\t        </td>\n\t\t\t\t\t        <td class=\"quantity\">{{product.primaryProduct.quantity}}</td>\n\t\t\t\t\t        <td class=\"price\">{{product.primaryProduct.InitialRequested | currency}}</td>\n\t\t\t\t\t        <td class=\"action\"><span ng-if=\"!productAdded.appInfo.UnderwriterLock\" class=\"link\" ng-click=\"productAdded.openAddProductsWebsite()\">Edit</span></td>\n\t\t\t\t\t    </tr>\n\t\t\t\t\t    <tr ng-repeat=\"relatedProduct in product.relatedProducts\" ng-class=\"{'no-product': !relatedProduct.Product.DisplayName }\">\n\t\t\t\t\t        <td class=\"product-info\">\n\t\t\t\t\t            <p class=\"product-type\">{{relatedProduct.Product.ProductCategory.ProductType.DisplayName}}</p>\n\t\t\t\t\t            <p ng-show=\"relatedProduct.Product.DisplayName\" class=\"product-name\">{{relatedProduct.Product.DisplayName}}</p>\n\t\t\t\t\t        </td>\n\t\t\t\t\t        <td class=\"quantity\">{{relatedProduct.quantity}}</td>\n\t\t\t\t\t        <td class=\"price\"></td>\n\t\t\t\t\t        <td class=\"action\"></td>\n\t\t\t\t\t    </tr>\n\t\t\t\t\t    </tbody>\n\t\t    \t\t</table>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-md-11 col-md-offset-1\">\n\t\t\t\t\t<div class=\"project-subtotal\">\n\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t<div class=\"col-md-3 col-md-offset-7\">\n\t\t\t\t\t\t\t\t<p class=\"pull-right\">Product Subtotal</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t\t\t\t<p class=\"pull-right\">{{productAdded.productSubtotal | currency}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=\"hp-inner-center\">\n\t\t\t\t<div class=\"row\">\n\t\t\t        <div class=\"col-md-12 walkthrough-next-steps\">\n\t\t\t            <p class=\"header\">Next Steps</p>\n\t\t\t\t\t    <p>Resume session to look over your product selection and set term.</p>\n\t\t\t\t\t    <div class=\"hp-buttons\">\n\t\t\t\t\t        <button class=\"btn btn-default\" ng-click=\"productAdded.openAddProductsWebsite()\">Add More Products</button>\n\t\t\t\t\t        <button class=\"btn btn-primary\" ng-click=\"productAdded.openAddProductsWebsite()\">Resume</button>\n\t\t\t\t\t    </div>\n\t\t\t\t\t    <p>or give us a call at <span class=\"medium\">844-722-7759</span> with any questions.</p>\n\t\t\t        </div>\n\t\t\t    </div>\n\t\t    </div>\n\t\t</div>\n\t</div>\n</div>";

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports = "<div class=\"product-added products-submitted\" ng-controller=\"ProductAddedController as productAdded\">\n\t<div class=\"row\" ng-if=\"productAdded.productsLoaded === true\">\n\t\t<div class=\"col-md-12\">\n\t\t\t<div class=\"row section-title\">\n\t\t\t\t<div class=\"col-md-8 col-md-offset-2 text-center call-in-products-information\">\n\t\t\t\t\t<div ng-if=\"productAdded.addedProductCaseInfo.CaseTypeTypeId === 40\">\n\t\t\t\t\t\t<h5 class=\"has-subtitle\">Got it! We're reviewing your products and will show your financing documents here when they're ready to review.</h5>\n\t\t\t\t\t\t<p>If you haven't received an email in 20 minutes, or if you need to make changes, you can reach us at <span>844-722-7759</span>. If you submitted after hours, we'll be in touch during normal service hours.</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div ng-if=\"productAdded.addedProductCaseInfo.CaseTypeTypeId === 39\">\n\t\t\t\t\t\t<h5 class=\"has-subtitle\">Got it! We're reviewing your products and will call you at {{productAdded.addedProductCaseInfo.Phone | tel}}.</h5>\n\t\t\t\t\t\t<p>If you haven't received a call in 5 minutes, or if you need to make changes, you can reach us at <span>844-722-7759</span>. If you submitted after hours, we'll be in touch during normal service hours.</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-md-11 col-md-offset-1\">\n\t\t\t\t\t<table cellpadding=\"0\" cellspacing=\"0\" ng-repeat=\"productCategory in productAdded.products\">\n\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<th colspan=\"3\">{{productCategory.category.DisplayName}}</th>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t</thead>\n\t\t\t\t\t    <tbody ng-repeat=\"product in productCategory.products\">\n\t\t\t\t\t    <tr>\n\t\t\t\t\t        <td class=\"product-info\">\n\t\t\t\t\t            <p class=\"product-type\">{{product.PrimaryProduct.Product.ProductCategory.ProductType.DisplayName}}</p>\n\t\t\t\t\t            <p class=\"product-name\">{{product.PrimaryProduct.Product.DisplayName}}</p>\n\t\t\t\t\t        </td>\n\t\t\t\t\t        <td class=\"quantity\">{{product.PrimaryProduct.quantity}}</td>\n\t\t\t\t\t        <td class=\"price\">{{product.PrimaryProduct.InitialRequested | currency}}</td>\n\t\t\t\t\t        <td class=\"action\"></td>\n\t\t\t\t\t    </tr>\n\t\t\t\t\t    <tr ng-repeat=\"relatedProduct in product.RelatedProducts\">\n\t\t\t\t\t        <td class=\"product-info\">\n\t\t\t\t\t            <p class=\"product-type\">{{relatedProduct.Product.ProductCategory.ProductType.DisplayName}}</p>\n\t\t\t\t\t            <p class=\"product-name\">{{relatedProduct.Product.DisplayName}}</p>\n\t\t\t\t\t            <p class=\"product-details-popover\"></p>\n\t\t\t\t\t        </td>\n\t\t\t\t\t        <td class=\"quantity\">{{relatedProduct.quantity}}</td>\n\t\t\t\t\t        <td class=\"price\"><span ng-hide=\"relatedProduct.AmountField\">{{relatedProduct.InitialRequested | currency}}</span></td>\n\t\t\t\t\t        <td class=\"action\"></td>\n\t\t\t\t\t    </tr>\n\t\t\t\t\t    </tbody>\n\t\t    \t\t</table>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-md-11 col-md-offset-1\">\n\t\t\t\t\t<div class=\"project-price-summary\">\n\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t<div class=\"col-md-5 col-md-offset-5\">\n\t\t\t\t\t\t\t\t<p class=\"pull-right\">Product Subtotal</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t\t\t\t<p class=\"pull-right\">{{productAdded.productSubtotal | currency}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t<div class=\"col-md-5 col-md-offset-5\">\n\t\t\t\t\t\t\t\t<p class=\"pull-right\">Financing Term</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t\t\t\t<p class=\"pull-right\">{{productAdded.financingTerm}}-Years</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t<div class=\"col-md-5 col-md-offset-5\">\n\t\t\t\t\t\t\t\t<p class=\"pull-right\">Estimated Interest &amp; Fees</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"col-md-2\">\n                                <p class=\"pull-right\">{{(productAdded.interestAndFees.CAPI || productAdded.interestAndFees.CAPIPrepay) + (productAdded.interestAndFees.ClosingCosts || productAdded.interestAndFees.ClosingCostsPrepay) | currency}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"row\" ng-if=\"productAdded.prePayment !== 0\">\n\t\t\t\t\t\t\t<div class=\"col-md-5 col-md-offset-5\">\n\t\t\t\t\t\t\t\t<p class=\"pull-right\">Pre-Payment</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t\t\t\t<p class=\"pull-right pre-payment-value\">- {{productAdded.prePayment | currency}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-md-11 col-md-offset-1\">\n\t\t\t\t\t<div class=\"project-total\">\n\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t<div class=\"col-md-3 col-md-offset-7\">\n\t\t\t\t\t\t\t\t<p class=\"pull-right\">Project Total</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t\t\t\t<p class=\"pull-right\">{{productAdded.projectTotal | currency}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=\"hp-inner-center\">\n\t\t\t\t<div class=\"row\">\n\t\t\t        <div class=\"col-md-12 walkthrough-next-steps\">\n\t\t\t            <p class=\"header\">Next Steps</p>\n\t\t\t\t\t    <p>\n\t\t\t\t\t\t\tOnce we've approved your products, we'll generate the financing documents and<br/>\n\t\t\t\t\t\t\tsend a link for you to review and sign.\n\t\t\t\t\t\t</p>\n\t\t\t        </div>\n\t\t\t    </div>\n\t\t    </div>\n\t\t</div>\n\t</div>\n</div>";

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _closedWalkthroughController = __webpack_require__(641);

var _closedWalkthroughController2 = _interopRequireDefault(_closedWalkthroughController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.appDetail.walkthrough.closed', []).controller('ClosedWalkthroughController', _closedWalkthroughController2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/appDetail/walkthrough/closed/applicationDeniedTemplate.html', __webpack_require__(643)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/walkthrough/closed/defaultClosedTemplate.html', __webpack_require__(644)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/walkthrough/closed/heroFundedTemplate.html', __webpack_require__(645)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = closedWalkthroughController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(642);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

closedWalkthroughController.$inject = ['FRClosingFactory', 'HPProjectAdvance']; // angular
// 	.module("HeroPRO")
// 	.controller("ClosedWalkthroughController", closedWalkthroughController);

/* @ngInject */
function closedWalkthroughController(FRClosingFactory, HPProjectAdvance) {
    var vm = this;
    vm.projectAdvanceData = {};
    vm.fundingRequest = [];

    vm.closedWalkthroughInstructions = '';
    vm.canDisplayContactNumber = false;

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */

    function init() {
        FRClosingFactory.getFundingRequestClosingPromise().then(function () {
            vm.fundingRequest = FRClosingFactory.getFundingRequest();
            if (vm.fundingRequest.FundingRequestDetail.FundingDisbursementModelTypeId === 11) {
                vm.projectAdvanceData = FRClosingFactory.getProjectAdvanceDetails();

                switch (vm.projectAdvanceData.StatusName) {
                    case _lodash2.default.keys(HPProjectAdvance)[3]:
                        vm.closedWalkthroughInstructions = 'Since an advance was paid on this project, you now have to repay it.';
                        vm.canDisplayContactNumber = true;
                        break;
                    case _lodash2.default.keys(HPProjectAdvance)[4]:
                        vm.closedWalkthroughInstructions = 'An advance was paid on this project and the amount due back to us is past due.';
                        vm.canDisplayContactNumber = true;
                        break;
                    case _lodash2.default.keys(HPProjectAdvance)[5]:
                        vm.closedWalkthroughInstructions = 'The advance payment on this project has been paid back.';
                        vm.canDisplayContactNumber = false;
                        break;
                    default:
                        break;
                }
            }
        });
    }

    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 642 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports = "<div id=\"closed-walkthrough-container\">\n\t<div class=\"hp-inner-center project-denied-walkthrough\">\n\t\t<h1>\n\t\t\tApplication for <br/>\n\t\t\t{{walkthrough.appInfo.Address.StreetNumber}} {{walkthrough.appInfo.Address.StreetPrefix}} {{walkthrough.appInfo.Address.StreetName}} {{walkthrough.appInfo.Address.StreetSuffix}} {{walkthrough.appInfo.Address.City}}, {{walkthrough.appInfo.Address.State}} {{walkthrough.appInfo.Address.ZIPCode}}\n\t\t\t<br/>was not approved for HERO\n\t\t</h1>\n\t\t<p>We will email the homeowner with the reason for their application not being approved.</p>\n\t</div>\n</div>";

/***/ }),
/* 644 */
/***/ (function(module, exports) {

module.exports = "<div id=\"closed-walkthrough-container\" ng-controller=\"ClosedWalkthroughController as closed\">\n\t<div class=\"hp-inner-center project-denied-walkthrough\">\n\t\t<h1>This project was cancelled or has expired.</h1>\n\t\t<p ng-if=\"closed.fundingRequest.FundingRequestDetail.FundingDisbursementModelTypeId !== 11\" >Please call HERO at 844-722-7759 if you have any questions.</p>\n        <p ng-class=\"{'project-advance-instruction' : closed.canDisplayContactNumber === true}\" ng-if=\"closed.fundingRequest.FundingRequestDetail.FundingDisbursementModelTypeId === 11\" ng-bind=\"closed.closedWalkthroughInstructions\"></p>\n        <p class=\"project-advance-contact\" ng-if=\"closed.fundingRequest.FundingRequestDetail.FundingDisbursementModelTypeId === 11 && closed.canDisplayContactNumber === true\" >Call us at 844-722-7759.</p>\n\t</div>\n</div>\n";

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports = "<div id=\"closed-walkthrough-container\">\n\t<div class=\"hp-inner-center project-paid-walkthrough\">\n\t\t<span class=\"icon icon-thumbs-up\"></span>\n\t    <h1>{{appDetail.paymentInstructions.TotalApproved | currency}} was paid on {{appDetail.fundingRequest.FundingRequestDetail.DisbursementDate | date: 'EEEE, MMMM d'}}. <br/> You can expect to receive the funds within 1-2 business days</h1>\n\t</div>\n</div>";

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _paymentInstructionsWalkthroughController = __webpack_require__(647);

var _paymentInstructionsWalkthroughController2 = _interopRequireDefault(_paymentInstructionsWalkthroughController);

var _projectDetailsWalkthroughController = __webpack_require__(648);

var _projectDetailsWalkthroughController2 = _interopRequireDefault(_projectDetailsWalkthroughController);

var _getSignaturesWalkthroughController = __webpack_require__(649);

var _getSignaturesWalkthroughController2 = _interopRequireDefault(_getSignaturesWalkthroughController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.appDetail.walkthrough.getPaid', []).controller('PaymentInstructionsWalkthroughController', _paymentInstructionsWalkthroughController2.default).controller('ProjectDetailsWalkthroughController', _projectDetailsWalkthroughController2.default).controller('GetSignaturesWalkthroughController', _getSignaturesWalkthroughController2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/appDetail/walkthrough/getPaid/resumeAddProducts.html', __webpack_require__(650)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/walkthrough/getPaid/achNotApprovedWalkthrough.html', __webpack_require__(651)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/walkthrough/getPaid/getACASignaturesWalkthroughTemplate.html', __webpack_require__(652)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/walkthrough/getPaid/getCOSignaturesWalkthrough.html', __webpack_require__(653)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/walkthrough/getPaid/getPOSignaturesWalkthrough.html', __webpack_require__(654)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/walkthrough/getPaid/outstandingDocumentsWalkthroughTemplate.html', __webpack_require__(655)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/walkthrough/getPaid/paymentDetailsProjectAdvanceWalkthrough.html', __webpack_require__(656)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/walkthrough/getPaid/paymentInstructionsWalkthroughTemplate.html', __webpack_require__(657)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/walkthrough/getPaid/projectApprovedWalkthroughTemplate.html', __webpack_require__(658)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/walkthrough/getPaid/projectCloserAcceptedTemplate.html', __webpack_require__(659)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/walkthrough/getPaid/projectDetailsWalkthroughTemplate.html', __webpack_require__(660)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/walkthrough/getPaid/projectReadyForReSubmissionTemplate.html', __webpack_require__(661)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/walkthrough/getPaid/projectReadyForSubmissionTemplate.html', __webpack_require__(662)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/walkthrough/getPaid/projectSubmittedTemplate.html', __webpack_require__(663)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/walkthrough/getPaid/rejectionsTemplate.html', __webpack_require__(664)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/walkthrough/getPaid/salesRepAfterFundingWalkthroughTemplate.html', __webpack_require__(665)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/walkthrough/getPaid/salesRepBeforeFundingWalkthroughTemplate.html', __webpack_require__(666)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = paymentInstructionsWalkthroughController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

paymentInstructionsWalkthroughController.$inject = ['$scope', '$state', '$stateParams', 'FRInformationFactory', 'FRClosingFactory', 'HPStateMachineConfig', 'raSpinnerService']; // angular
//     .module("HeroPRO")
//     .controller("PaymentInstructionsWalkthroughController", paymentInstructionsWalkthroughController);

/* @ngInject */
function paymentInstructionsWalkthroughController($scope, $state, $stateParams, FRInformationFactory, FRClosingFactory, HPStateMachineConfig, raSpinnerService) {
    var vm = this;
    vm.stateMachineData = {};
    vm.HPStateMachineConfig = HPStateMachineConfig;
    vm.totalLabel = 'Total';
    vm.contractorLocationOfficeId = "";

    init();

    vm.confirmPaymentInstructions = function () {
        raSpinnerService.show('walkthroughSpinner');

        var params = {
            PaymentInstructions: {
                FundingRequestId: $stateParams.appId
            }
        };

        FRClosingFactory.confirmPaymentInstructions(params).then(function (response) {
            FRInformationFactory.setStateMachineData(response.data.Data.PipelineStageId, response.data.Data.FundingRequestPipelineStageId, response.data.Data.LoanStateId, response.data.Data.FundingRequestStateId, response.data.Data.CompletionCertificateStateId);
            FRClosingFactory.setPaymentInstructions(_lodash2.default.omit(response.data.Data, 'FundingRequestId', 'LoanStateId'));
            // Refresh the page so that the information for the newly generated CC is available on the page
            $state.go($state.current, $stateParams, { reload: true, inherit: false });
        });
    };

    function init() {
        FRInformationFactory.getFundingRequestInformationPromise().then(function () {
            vm.stateMachineData = FRInformationFactory.getStateMachineData();
        });

        FRClosingFactory.getFundingRequestClosingPromise().then(function () {

            var contractorId = FRClosingFactory.getFundingRequest().FundingRequestDetail.ContractorId || "";

            vm.contractorOfficeLocationId = contractorId;

            var contractorDisbursement = _lodash2.default.find(FRClosingFactory.getPaymentInstructions().newDisbursements, function (disbursement) {
                return disbursement.PayeeType === 'Contractor';
            });

            if (contractorDisbursement) {
                vm.totalLabel = 'Payment to Contractor';
            }
        });
    }
}

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = projectDetailsWalkthroughController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

projectDetailsWalkthroughController.$inject = ['FRInformationFactory', 'FRClosingFactory', 'FRDocumentsFactory', 'HPStateMachineConfig', 'raSpinnerService', 'WalkthroughFactory']; // angular
//     .module("HeroPRO")
//     .controller("ProjectDetailsWalkthroughController", projectDetailsWalkthroughController);


/* @ngInject */
function projectDetailsWalkthroughController(FRInformationFactory, FRClosingFactory, FRDocumentsFactory, HPStateMachineConfig, raSpinnerService, WalkthroughFactory) {
    var vm = this;
    vm.stateMachineData = {};
    vm.HPStateMachineConfig = HPStateMachineConfig;

    init();

    vm.isCompletionCertificateRegenerated = function () {
        return FRDocumentsFactory.getCompletionCertificateRegenerated();
    };

    vm.confirmProjectDetails = function () {
        raSpinnerService.show('walkthroughSpinner');
        FRClosingFactory.confirmProjectDetails().then(function (response) {
            FRInformationFactory.setStateMachineData(response.data.PipelineStageId, response.data.FundingRequestPipelineStageId, response.data.LoanStateId, response.data.FundingRequestStateId, response.data.CompletionCertificateStateId);
            FRClosingFactory.setProjectDetails(_lodash2.default.omit(response.data, 'FundingRequestId', 'LoanStateId'));
            FRClosingFactory.setProjectDetailsConfirmed();
            WalkthroughFactory.loadWalkthrough();
            raSpinnerService.hide('walkthroughSpinner');
        });
    };

    function init() {
        FRInformationFactory.getFundingRequestInformationPromise().then(function () {
            vm.stateMachineData = FRInformationFactory.getStateMachineData();
        });
    }
}

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = GetSignaturesWalkthroughController;
GetSignaturesWalkthroughController.$inject = ['$stateParams', 'EDocumentsFactory', '$window', 'AuthenticationFactory', '$scope', 'FRInformationFactory', 'HPStateMachineConfig', 'FRDocumentsFactory', 'raSpinnerService'];
// angular
//     .module("HeroPRO")
//     .controller("GetSignaturesWalkthroughController", getSignaturesWalkthroughController);

/* @ngInject */
function GetSignaturesWalkthroughController($stateParams, EDocumentsFactory, $window, AuthenticationFactory, $scope, FRInformationFactory, HPStateMachineConfig, FRDocumentsFactory, raSpinnerService) {
    var vm = this;
    vm.stateMachineData = {};
    vm.HPStateMachineConfig = HPStateMachineConfig;
    vm.showGetSignaturesButton = false;

    init();

    vm.signNow = function () {
        raSpinnerService.show('walkthroughSpinner');
        EDocumentsFactory.getDocusignLink($stateParams.appId, 'CompletionCertificate').then(function (data) {
            AuthenticationFactory.stopAuthenticationInterval();
            $window.location.href = data.data.returnUrl;
        });
    };

    function init() {
        FRInformationFactory.getFundingRequestInformationPromise().then(function () {
            vm.stateMachineData = FRInformationFactory.getStateMachineData();
        });

        FRDocumentsFactory.getFundingRequestDocumentsPromise().then(function () {
            vm.showGetSignaturesButton = FRDocumentsFactory.getSignaturesButtonVisibility();
        });
    }
}

/***/ }),
/* 650 */
/***/ (function(module, exports) {

module.exports = "<div class=\"product-added\" ng-controller=\"ProductAddedController as productAdded\">\n\t<div class=\"row\" ng-if=\"productAdded.productsLoaded === true\">\n\t\t<div class=\"col-md-12\">\n\t\t\t<div class=\"row section-title\">\n\t\t\t\t<div class=\"col-md-10 col-md-offset-1 text-center call-in-products-information\">\n\t\t\t\t\t<h5>Resume Adding Products</h5>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-md-11 col-md-offset-1\">\n\t\t\t\t\t<table cellpadding=\"0\" cellspacing=\"0\" ng-repeat=\"productCategory in productAdded.products\">\n\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<th colspan=\"3\">{{productCategory.category.DisplayName}}</th>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t</thead>\n\t\t\t\t\t    <tbody ng-repeat=\"product in productCategory.products\">\n\t\t\t\t\t    <tr ng-class=\"{'no-product': !product.primaryProduct.Product.DisplayName }\">\n\t\t\t\t\t        <td class=\"product-info\">\n\t\t\t\t\t            <p class=\"product-type\">{{product.primaryProduct.Product.ProductCategory.ProductType.DisplayName}}</p>\n\t\t\t\t\t            <p ng-show=\"product.primaryProduct.Product.DisplayName\" class=\"product-name\">{{product.primaryProduct.Product.DisplayName}}</p>\n\t\t\t\t\t        </td>\n\t\t\t\t\t        <td class=\"quantity\">{{product.primaryProduct.quantity}}</td>\n\t\t\t\t\t        <td class=\"price\">{{product.primaryProduct.InitialRequested | currency}}</td>\n\t\t\t\t\t        <td class=\"action\"><span ng-if=\"!productAdded.appInfo.UnderwriterLock\" class=\"link\" ng-click=\"productAdded.openAddProductsWebsite()\">Edit</span></td>\n\t\t\t\t\t    </tr>\n\t\t\t\t\t    <tr ng-repeat=\"relatedProduct in product.relatedProducts\" ng-class=\"{'no-product': !relatedProduct.Product.DisplayName }\">\n\t\t\t\t\t        <td class=\"product-info\">\n\t\t\t\t\t            <p class=\"product-type\">{{relatedProduct.Product.ProductCategory.ProductType.DisplayName}}</p>\n\t\t\t\t\t            <p ng-show=\"relatedProduct.Product.DisplayName\" class=\"product-name\">{{relatedProduct.Product.DisplayName}}</p>\n\t\t\t\t\t        </td>\n\t\t\t\t\t        <td class=\"quantity\">{{relatedProduct.quantity}}</td>\n\t\t\t\t\t        <td class=\"price\"></td>\n\t\t\t\t\t        <td class=\"action\"></td>\n\t\t\t\t\t    </tr>\n\t\t\t\t\t    </tbody>\n\t\t    \t\t</table>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-md-11 col-md-offset-1\">\n\t\t\t\t\t<div class=\"project-subtotal\">\n\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t<div class=\"col-md-3 col-md-offset-7\">\n\t\t\t\t\t\t\t\t<p class=\"pull-right\">Product Subtotal</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t\t\t\t<p class=\"pull-right\">{{productAdded.productSubtotal | currency}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=\"hp-inner-center\">\n\t\t\t\t<div class=\"row\">\n\t\t\t        <div ng-if=\"!productAdded.appInfo.UnderwriterLock\" class=\"col-md-12 walkthrough-next-steps\">\n\t\t\t\t\t\t<p class=\"header\">Next Steps</p>\n\t\t\t\t\t    <p>Resume session to look over your product selection and set term.</p>\n\t\t\t\t\t    <div class=\"hp-buttons\">\n\t\t\t\t\t        <button class=\"btn btn-default\" ng-click=\"productAdded.openAddProductsWebsite()\">Add More Products</button>\n\t\t\t\t\t        <button class=\"btn btn-primary\" ng-click=\"productAdded.openAddProductsWebsite()\">Resume</button>\n\t\t\t\t\t    </div>\n\t\t\t\t\t    <p>or give us a call at <span class=\"medium\">844-722-7759</span> with any questions.</p>\n\t\t\t\t\t</div>\n\t\t\t        <div ng-if=\"productAdded.appInfo.UnderwriterLock\" class=\"col-md-12 walkthrough-next-steps\">\n\t\t\t\t\t\t<p class=\"header\">Next Steps</p>\n\t\t\t\t\t    <p>Changes cannot be made at this time.</p>\n\t\t\t\t\t    <p>Give us a call at <span class=\"medium\">844-722-7759</span> with any questions.</p>\n\t\t\t        </div>\t\t\t\t\t\n\t\t\t    </div>\n\t\t    </div>\n\t\t</div>\n\t</div>\n</div>";

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports = "<div class=\"ach-not-approved-walkthrough\">\n\t<div class=\"row\">\n\t\t<div class=\"col-md-12\">\n\t\t\t<h1>The office's banking information is not active</h1>\n            <p>It looks like you don't have direct deposit set up for this office. Please click <a ng-href=\"/accounts/offices/{{paymentInstructionsWalkthrough.contractorOfficeLocationId}}\">here</a> to begin the quick and easy process to set up direct deposit now.</p>\n    </div>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n\t    <div class=\"col-md-12 walkthrough-next-steps\">\n\t        <p class=\"header\">Next Steps</p>\n\t\t\t<p>Questions? Call 844-722-7759.</p>\n\t\t\t<div class=\"pro-tip\">\n\t\t\t\t<span>Pro Tip</span> Get paid 7-10 days faster and avoid a $35 check issuance fee when you provide your banking information for ACH payments.\n\t\t\t</div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-inner-center\">\n\t<div class=\"row\">\n\t\t<div class=\"col-md-12\">\n\t\t    <h1 class=\"walkthrough-header\">Customer Signature Required</h1>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n        <div class=\"col-md-12 walkthrough-next-steps\">\n            <p class=\"header\">Next Steps</p>\n\t\t    <p>Send the Change Order (also known as Assessment Contract Addendum) to your customer for their signature.</p>\n\t\t    <div class=\"pro-tip\">\n\t\t    \t<span>Pro Tip</span> Did you know the Change Order can also be sent to the customer for signature as soon as it's created?\n\t\t    </div>\n\t\t    <div class=\"hp-buttons\">\n\t\t        <button class=\"btn btn-primary\" ng-click=\"appDetail.openGetSignaturesModal(1)\" ng-if=\"walkthrough.showGetSignaturesButton === true\">Get Signatures</button>\n\t\t        <button class=\"btn btn-default\" ng-click=\"appDetail.openMakeChangesModal()\">Make Changes</button>\n\t\t    </div>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-inner-center\" ng-controller=\"GetSignaturesWalkthroughController as getSignaturesWalkthrough\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <h1 class=\"walkthrough-header\">Sign Completion Certificate</h1>        \n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-md-12 walkthrough-next-steps\">\n            <p class=\"header\">Next Steps</p>\n            <p>The Completion Certificate is ready for your signature.</p>\n            <p>Please click <span>Sign Now</span> if you're ready, or <span>Make Changes</span> if not.</p>\n            <div class=\"hp-buttons\">\n                <button class=\"btn btn-primary\" ng-click=\"getSignaturesWalkthrough.signNow()\">Sign Now</button>\n                <button class=\"btn btn-default\" ng-click=\"appDetail.openMakeChangesModal()\">Make Changes</button>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-inner-center\" ng-controller=\"GetSignaturesWalkthroughController as getSignaturesWalkthrough\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <h1 class=\"walkthrough-header\">Completion Certificate signed and ready to be sent to the homeowner(s).</h1>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-md-12 walkthrough-next-steps\">\n            <p class=\"header\">Next Steps</p>\n            <p>Request signatures via email or sign them now.</p>\n            <div class=\"pro-tip\">\n                <span>Pro Tip</span> Click the <b>Send to Installer</b> button below to enable your installer to capture customer signatures on-site.\n            </div>\n            <div class=\"hp-buttons\">\n                <button class=\"btn btn-primary\" ng-click=\"appDetail.openGetSignaturesModal(1)\" ng-if=\"getSignaturesWalkthrough.showGetSignaturesButton === true\">Get Signatures</button>\n                <button class=\"btn btn-default\" ng-click=\"appDetail.openGetSignaturesModal(2)\" ng-if=\"getSignaturesWalkthrough.showGetSignaturesButton === true\">Send to Installer</button>\n                <button class=\"btn btn-default\" ng-click=\"appDetail.openMakeChangesModal()\">Make Changes</button>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-inner-center outstanding-documents-walkthrough\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <h1 class=\"walkthrough-header\">Documents have been signed by the homeowner(s).</h1>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-md-12 walkthrough-next-steps\">\n            <p class=\"header\">Next Steps</p>\n            <p>In order to submit this project for funding, please upload the following:</p>\n            <ul>\n                <li ng-repeat=\"outstandingDocument in walkthrough.outstandingDocuments\">\n                    {{outstandingDocument.Description}}\n                </li>\n            </ul>\n            <div class=\"hp-buttons\">\n                <button class=\"btn btn-primary\" ng-click=\"appDetail.openUploadDocumentsModal()\">Upload</button>\n                <button class=\"btn btn-default\" ng-click=\"appDetail.openMakeChangesModal()\">Make Changes</button>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports = "<div ng-controller=\"PaymentInstructionsWalkthroughController as paymentInstructionsWalkthrough\">\n    <!-- FundingDisbursementModelTypeId === 11 PEFI -->\n    <div ng-if=\"paymentInstructionsWalkthrough.stateMachineData.CompletionCertificateStateId === paymentInstructionsWalkthrough.HPStateMachineConfig.CC.Product_Details_Confirmed && appDetail.paymentInstructions.ContractorPaymentMethodStatusId === 2\" class=\"hp-inner-center\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <h1>Project details have been confirmed. Now, confirm payment details.</h1>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div ng-include=\"'app/appDetail/paymentInstructions/paymentDetailsProjectAdvance.html'\" id=\"project-details\" ng-controller=\"PaymentInstructionsController as paymentInstructions\"></div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12 walkthrough-next-steps\">\n                <p class=\"header\">Next Steps</p>\n                <div ng-if=\"appDetail.fundingRequest.FundingRequestDetail.IsDisbursementLocked === true\">\n                    <p class=\"instructions-text\">If these payment details are correct, <span class=\"text-callout\">Confirm and Continue</span>.</p>\n                    <p class=\"instructions-text\">If changes are needed, call us at 844-722-7759.</p>\n                </div>\n                <div class=\"hp-buttons\">\n                    <button class=\"btn btn-primary\" ng-if=\"appDetail.fundingRequest.FundingRequestDetail.IsDisbursementLocked === true\" ng-click=\"paymentInstructionsWalkthrough.confirmPaymentInstructions()\">Confirm and Continue</button>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <!-- ACH Not Approved -->\n    <div ng-if=\"paymentInstructionsWalkthrough.stateMachineData.CompletionCertificateStateId === paymentInstructionsWalkthrough.HPStateMachineConfig.CC.Product_Details_Confirmed && (appDetail.paymentInstructions.ContractorPaymentMethodStatusId === undefined || appDetail.paymentInstructions.ContractorPaymentMethodStatusId !== 2)\" class=\"hp-inner-center\">\n        <ng-include src=\"'app/appDetail/walkthrough/getPaid/achNotApprovedWalkthrough.html'\"></ng-include>\n    </div>\n    <!-- ACH Not Approved -->\n</div>\n";

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports = "<div ng-controller=\"PaymentInstructionsWalkthroughController as paymentInstructionsWalkthrough\">\n    <!-- FundingDisbursementModelTypeId === 40 || 50 refers to a Lease -->\n    <div ng-if=\"paymentInstructionsWalkthrough.stateMachineData.CompletionCertificateStateId === paymentInstructionsWalkthrough.HPStateMachineConfig.CC.Product_Details_Confirmed && appDetail.paymentInstructions.ContractorPaymentMethodStatusId === 2\" class=\"hp-inner-center\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <h1>Project details have been confirmed. Now, confirm payment details.</h1>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div ng-if=\"appDetail.fundingRequest.FundingRequestDetail.FundingDisbursementModelTypeId !== 40 && appDetail.fundingRequest.FundingRequestDetail.FundingDisbursementModelTypeId !== 50\" ng-include=\"'app/appDetail/paymentInstructions/paymentInstructionsCommonTemplate.html'\" id=\"project-details\"></div>\n\n                <div ng-if=\"appDetail.fundingRequest.FundingRequestDetail.FundingDisbursementModelTypeId === 40 || appDetail.fundingRequest.FundingRequestDetail.FundingDisbursementModelTypeId === 50\" ng-include=\"'app/appDetail/paymentInstructions/paymentInstructionsLeaseCommonTemplate.html'\" id=\"project-details\"></div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12 walkthrough-next-steps\">\n                <p class=\"header\">Next Steps</p>\n                <div ng-if=\"appDetail.fundingRequest.FundingRequestDetail.IsDisbursementLocked === false\">\n                    <p>Select <span class=\"text-callout\">Yes</span> if the payment details are correct. If not, you can <span class=\"text-callout\">Change Payments</span>.</p>\n                </div>\n                <div ng-if=\"appDetail.fundingRequest.FundingRequestDetail.IsDisbursementLocked === true\">\n                    <p>If these payment details are correct, <span class=\"text-callout\">Confirm and Continue</span>. If changes are needed, call us at 844-722-7759.</p>\n                </div>\n                <div class=\"hp-buttons\">\n                    <button class=\"btn btn-primary\" ng-if=\"appDetail.fundingRequest.FundingRequestDetail.IsDisbursementLocked === false\" ng-click=\"paymentInstructionsWalkthrough.confirmPaymentInstructions()\">Yes</button>\n                    <button class=\"btn btn-primary\" ng-if=\"appDetail.fundingRequest.FundingRequestDetail.IsDisbursementLocked === true\" ng-click=\"paymentInstructionsWalkthrough.confirmPaymentInstructions()\">Confirm and Continue</button>\n                    <button class=\"btn btn-default\" ng-if=\"appDetail.fundingRequest.FundingRequestDetail.IsDisbursementLocked === false\" ng-click=\"appDetail.openPaymentInstructionsModal()\">Change Payments</button>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <!-- ACH Not Approved -->\n    <div ng-if=\"paymentInstructionsWalkthrough.stateMachineData.CompletionCertificateStateId === paymentInstructionsWalkthrough.HPStateMachineConfig.CC.Product_Details_Confirmed && (appDetail.paymentInstructions.ContractorPaymentMethodStatusId === undefined || appDetail.paymentInstructions.ContractorPaymentMethodStatusId !== 2)\" class=\"hp-inner-center\">\n        <ng-include src=\"'app/appDetail/walkthrough/getPaid/achNotApprovedWalkthrough.html'\"></ng-include>\n    </div>\n    <!-- ACH Not Approved -->\n</div>\n";

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-inner-center project-approved-walkthrough\">\n    <h1>This project has been approved and payment is scheduled for {{appDetail.fundingRequest.FundingRequestDetail.ScheduledDisbursementDate | date: 'EEEE, MMMM d'}}.</h1>\n</div>\n";

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-inner-center project-submitted-walkthrough\">\n\t<div class=\"row\">\n\t\t<div class=\"col-md-12\">\n\t\t    <h1 class=\"walkthrough-header\">Your project is under review by our Specialist, and if approved, you should receive a disbursement date within 1 business day.</h1>\n\t\t</div>\n\t</div>\n</div>";

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports = "<div ng-controller=\"ProjectDetailsWalkthroughController as projectDetailsWalkthrough\">\n\t<div class=\"hp-inner-center\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-12\">\n\t\t\t\t<h1>Project has been marked as complete! Now, confirm project details.</h1>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-12\">\n\t\t\t\t<div ng-include=\"'app/appDetail/projectDetails/projectDetailsSummaryTemplate.html'\" ng-controller=\"ProjectDetailsController as projectDetails\" id=\"project-details-walkthrough-summary\"></div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-12 walkthrough-next-steps\">\n\t\t\t\t<p class=\"header\">Next Steps</p>\n\t\t\t\t<p>Does the information above accurately reflect the work that was performed?</p>\n\t\t\t\t<p>Please click <span>Yes</span> if so, or <span>No, Make Changes</span> if not.</p>\n\t\t\t\t<div class=\"hp-buttons\">\n\t\t\t\t\t<button class=\"btn btn-primary\" ng-click=\"projectDetailsWalkthrough.confirmProjectDetails()\">Yes</button>\n\t\t\t\t\t<button class=\"btn btn-default\" ng-click=\"appDetail.openMakeChangesModal()\">No, Make Changes</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n";

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-inner-center\">\n    <div class=\"row\">\n\t\t<div class=\"col-md-12\">\n\t\t    <h1 class=\"walkthrough-header\">The project is ready to be re-submitted to HERO for Review</h1>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n        <div class=\"col-md-12 walkthrough-next-steps\">\n            <p class=\"header\">Next Steps</p>\n            <p>Re-submit to HERO for review</p>\n\t\t    <div class=\"hp-buttons\">\n\t\t        <button class=\"btn btn-primary\" ng-click=\"appDetail.submitProjectForFunding(12)\">Re-Submit Now</button>\n\t\t    </div>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 662 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-inner-center\">\n\t<div class=\"row\">\n\t\t<div class=\"col-md-12\">\n\t\t    <h1 class=\"walkthrough-header\">The project is ready to be submitted to HERO for Review</h1>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n\t    <div class=\"col-md-12 walkthrough-next-steps\">\n\t        <p class=\"header\">Next Steps</p>\n\t\t\t<p>Submit to HERO for review</p>\n\t\t    <div class=\"hp-buttons\">\n\t\t        <button class=\"btn btn-primary\" ng-click=\"appDetail.submitProjectForFunding(11)\">Submit Now</button>\n\t\t    </div>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-inner-center project-submitted-walkthrough\">\n\t<div class=\"row\">\n\t\t<div class=\"col-md-12\">\n\t\t    <h1 class=\"walkthrough-header\">Your project documents were submitted successfully!</h1>\n\n            <div ng-if=\"(!walkthrough.appInfo.IsNoticeToLenderRequired && walkthrough.appInfo.isCountersigned === false) ||\n                        (walkthrough.appInfo.IsNoticeToLenderRequired && walkthrough.appInfo.isIssuerReviewed === false) ||\n                        walkthrough.appInfo.isNTPSent === false\">\n\t\t\t\t<p>Here's what we're waiting on before we can fund it...</p>\n\t\t\t\t<ul>\n                    <li ng-if=\"!walkthrough.appInfo.IsNoticeToLenderRequired && walkthrough.appInfo.isCountersigned === false \">\n                        <span>Countersign</span>\n                    </li>\n\n                    <li ng-if=\"walkthrough.appInfo.IsNoticeToLenderRequired && walkthrough.appInfo.isIssuerReviewed === false\">\n                        Issuer Review\n                    </li>\n\n\t\t\t\t\t<li ng-if=\"walkthrough.appInfo.isNTPSent === false\">Notice to Proceed</li>\n\t\t\t\t</ul>\n\t\t\t</div>\n\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n\t    <div class=\"col-md-12 walkthrough-next-steps\">\n\t        <p class=\"header\">Next Steps</p>\n\t        <p>Our Specialist will review your submission and will notify you of a disbursement date within 24-48 business hours.</p>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-inner-center rejections-walkthrough\">\n    <div class=\"row\">\n        <div class=\"col-md-12 walkthrough-header-warning\">\n            <p><span class=\"step-warning icon icon-exclamation\"></span></p>\n            <h1>Your project has been reviewed by our closers and needs to <br/> be updated before it can be funded.</h1>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-md-12 walkthrough-next-steps\">\n            <p class=\"header\">Next Steps</p>\n\n            <!-- If CC has been regenerated -->\n            <div ng-if=\"walkthrough.stateMachineData.CompletionCertificateStateId !== walkthrough.HPStateMachineConfig.CC.Completion_Cert_Uploaded_Or_eSigned\" class=\"condition-rejection-details\">\n                <div class=\"row\">\n                    <div class=\"col-xs-9\">\n                        <p class=\"condition-name\">Completion Certificate</p>\n                    </div>\n                    <div class=\"col-xs-3 text-right\">\n                        <button class=\"btn btn-primary\" ng-click=\"walkthrough.setCompletionCertificateRegenerated(true)\">Start</button>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-xs-9\">\n                        <p class=\"rejection-reason\">The Completion Certificate has been regenerated. Please reconfirm the Project Details, Payment Instructions and obtain signatures.</p>\n                    </div>\n                </div>\n            </div>\n            <!-- If CC has been regenerated -->\n\n            <div ng-repeat=\"document in walkthrough.invalidDocuments track by $index\">\n                <!-- If other document or CC that has not been regenerated -->\n                <div ng-if=\"document.ConditionTypeDetail.ConditionTypeId !== walkthrough.HPConditionTypes.CompletionCertificate ||\n                            (document.ConditionTypeDetail.ConditionTypeId === walkthrough.HPConditionTypes.CompletionCertificate && walkthrough.stateMachineData.CompletionCertificateStateId === walkthrough.HPStateMachineConfig.CC.Completion_Cert_Uploaded_Or_eSigned)\" class=\"condition-rejection-details\">\n                    <div class=\"row\">\n                        <div class=\"col-xs-9\">\n                            <p class=\"condition-name\">{{document.Description}}</p>\n                        </div>\n                        <div class=\"col-xs-3 text-right\">\n                            <button class=\"btn\" ng-click=\"appDetail.openUploadDocumentsModal(document)\"\n                                    ng-class=\"{ 'btn-default': $index !== 0 || walkthrough.stateMachineData.CompletionCertificateStateId !== walkthrough.HPStateMachineConfig.CC.Completion_Cert_Uploaded_Or_eSigned,\n                                                'btn-primary': $index === 0 && walkthrough.stateMachineData.CompletionCertificateStateId === walkthrough.HPStateMachineConfig.CC.Completion_Cert_Uploaded_Or_eSigned }\">Upload</button>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-xs-9\">\n                            <div ng-repeat=\"rejection in document.LatestAttachment.RejectionDetails\">\n                                <p class=\"error-msg\">{{rejection.RejectionTypeDetail.Name}}</p>\n                                <p class=\"rejection-reason\">{{rejection.Reason}}</p>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <!-- If other document or CC that has not been regenerated -->\n            </div>\n\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-inner-center salesrep-after-funding-walkthrough\">\n\t<div class=\"row\">\n\t\t<div class=\"col-md-12\">\n\t\t    <h1>The project has been submitted to HERO for review!</h1>\n\t\t    <p>Your company's admin has submitted the project for funding.</p>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n        <div class=\"col-md-12 walkthrough-next-steps\">\n            <p class=\"header\">Next Steps</p>\n\t\t    <p>Our closers will review this project.</p>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-inner-center salesrep-before-funding-walkthrough\">\n\t<div class=\"row\">\n\t\t<div class=\"col-md-12\">\n\t\t    <h1>Upload Documents</h1>\n\t\t    <p>Your company's admin is preparing this document to be submitted.</p>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n        <div class=\"col-md-12 walkthrough-next-steps\">\n            <p class=\"header\">Next Steps</p>\n\t\t    <p>If you have any of the documents, you can upload them at any time.</p>\n\t\t    <div class=\"hp-buttons\">\n\t\t\t\t<button type=\"button\" class=\"btn btn-primary\" ng-if=\"appDetail.showDocumentUploadLinks()\" ng-click=\"appDetail.openUploadDocumentsModal()\")>Upload</button>  \n\t\t\t</div>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _EDocumentsFactory = __webpack_require__(668);

var _EDocumentsFactory2 = _interopRequireDefault(_EDocumentsFactory);

var _COReviewController = __webpack_require__(669);

var _COReviewController2 = _interopRequireDefault(_COReviewController);

var _HEROCountersignController = __webpack_require__(671);

var _HEROCountersignController2 = _interopRequireDefault(_HEROCountersignController);

var _POSignController = __webpack_require__(674);

var _POSignController2 = _interopRequireDefault(_POSignController);

var _POSignModalController = __webpack_require__(676);

var _POSignModalController2 = _interopRequireDefault(_POSignModalController);

var _POSignFactory = __webpack_require__(678);

var _POSignFactory2 = _interopRequireDefault(_POSignFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.appDetail.walkthrough.startWork', []).controller('COReviewController', _COReviewController2.default).controller('HEROCountersignController', _HEROCountersignController2.default).controller('POSignController', _POSignController2.default).controller('POSignModalController', _POSignModalController2.default).factory('EDocumentsFactory', _EDocumentsFactory2.default).factory('POSignFactory', _POSignFactory2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/appDetail/walkthrough/startWork/CO-Review/CO-Review.html', __webpack_require__(679)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/walkthrough/startWork/CO-Review/financialSummary.html', __webpack_require__(680)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/walkthrough/startWork/CO-Review/financialSummaryLease.html', __webpack_require__(681)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/walkthrough/startWork/HERO-Countersign/HERO-Countersign.html', __webpack_require__(682)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/walkthrough/startWork/PO-Sign/PO-Email.html', __webpack_require__(683)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/walkthrough/startWork/PO-Sign/PO-Modal.html', __webpack_require__(684)); // eslint-disable-line global-require
    $templateCache.put('app/appDetail/walkthrough/startWork/PO-Sign/PO-Sign.html', __webpack_require__(685)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = eDocumentsFactory;
eDocumentsFactory.$inject = ["HPConfig", "$http"];
// angular
//     .module("HeroPRO")
//     .factory("EDocumentsFactory", eDocumentsFactory);

/* @ngInject */
function eDocumentsFactory(HPConfig, $http) {
    return {
        getDocusignLink: getDocusignLink,
        emailDocusignLink: emailDocusignLink,
        emailInstaller: emailInstaller
    };

    function getDocusignLink(fundingRequestId, documentType) {
        return $http.post(HPConfig.heroProApi + "ESign/GeneratePropertyOwnerSignsDocsEnvelope", {
            FundingRequestId: fundingRequestId,
            DocumentType: documentType
        });
    }

    function emailDocusignLink(fundingRequestId, eDocumentRecipientId, documentType, email, ordinalInRole, loanid) {
        return $http.post(HPConfig.heroProApi + "ESign/EmailPropertyOwnerSignDocsEnvelope", {
            FundingRequestId: fundingRequestId,
            LoanId: loanid,
            EDocumentRecipientId: eDocumentRecipientId,
            DocumentType: documentType, // "FinancingDocs",
            Email: email,
            OwnerOrdinal: ordinalInRole
        });
    }

    function emailInstaller(fundingRequestId, email) {
        return $http.post(HPConfig.heroProApi + "ESign/EmailInstaller", {
            FundingRequestId: fundingRequestId,
            InstallerEmail: email
        });
    }
}

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = COReviewController;

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

__webpack_require__(670);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

COReviewController.$inject = ['$scope', 'EDocumentsFactory', '$stateParams', 'AuthenticationFactory', '$analytics', 'Timestamp', '$q', '$state', 'FRClosingFactory', 'FRInformationFactory', 'SelectedProductsFactory', 'DealTypeFactory', 'raSpinnerService', '$uibModal']; // angular
// 	.module("HeroPRO")
// 	.controller("COReviewController", COReviewController);

/* @ngInject */
function COReviewController($scope, EDocumentsFactory, $stateParams, AuthenticationFactory, $analytics, Timestamp, $q, $state, FRClosingFactory, FRInformationFactory, SelectedProductsFactory, DealTypeFactory, raSpinnerService, $uibModal) {
    var vm = this;
    var p1 = void 0;
    vm.appInfo = {};
    vm.products = {};
    vm.productSubtotal = 0;
    vm.financingTerm = 0;
    vm.interestAndFees = 0;
    vm.prePayment = 0;
    vm.projectTotal = 0;
    vm.productsLoaded = false;
    vm.selectedDealType = null;

    vm.approvingDocs = false;

    vm.approveDocs = function () {
        vm.approvingDocs = true;
        EDocumentsFactory.getDocusignLink($stateParams.appId, 'FinancingDocs').then(function (response) {
            vm.approvingDocs = false;
            $state.go($state.$current, null, { reload: true });
        }, function (error) {
            vm.approvingDocs = false;
        });
    };

    vm.init = function () {

        FRClosingFactory.getFundingRequestClosingPromise().then(function () {
            vm.selectedDealType = DealTypeFactory.getSelectedDealType();

            vm.fundingRequestDetail = FRClosingFactory.getFundingRequest().FundingRequestDetail;

            // only load the products if it's a purchase deal
            if (vm.fundingRequestDetail.FundingDisbursementModelTypeId && vm.fundingRequestDetail.FundingDisbursementModelTypeId !== 40 && vm.fundingRequestDetail.FundingDisbursementModelTypeId !== 50) {
                vm.loadProducts();
            }
        });
    };

    vm.loadProducts = function () {
        FRInformationFactory.getFundingRequestInformationPromise().then(function () {
            vm.appInfo = FRInformationFactory.getAppInfo();

            SelectedProductsFactory.getAddedProducts({ FundingRequestId: vm.appInfo.FundingRequestId }, true).then(function () {
                vm.products = _angular2.default.copy(SelectedProductsFactory.getSelectedProducts());
                if (vm.products.length > 0) {
                    vm.productSubtotal = SelectedProductsFactory.getProductSubtotal();
                    vm.financingTerm = SelectedProductsFactory.getFinancingTerm();
                    SelectedProductsFactory.getInterestAndFees(vm.appInfo).then(function (response) {
                        vm.interestAndFees = response;
                        if (vm.appInfo.ClosingPrepayCAPI !== undefined && vm.appInfo.ClosingPrepayCAPI === true) {
                            vm.prePayment += vm.interestAndFees.CAPI || vm.interestAndFees.CAPIPrepay;
                        }
                        if (vm.appInfo.ClosingPrepayFees !== undefined && vm.appInfo.ClosingPrepayFees === true) {
                            vm.prePayment += vm.interestAndFees.ClosingCosts || vm.interestAndFees.ClosingCostsPrepay;
                        }
                        vm.projectTotal = SelectedProductsFactory.getProjectTotal(); // - vm.prePayment;
                        vm.productsLoaded = true;
                    });
                }
            });
        });
    };

    vm.init();
}

/***/ }),
/* 670 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = HEROCountersignController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(672);

__webpack_require__(673);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

HEROCountersignController.$inject = ['$stateParams', '$filter', '$analytics', 'DocumentLink', 'FRInformationFactory', 'Timestamp', 'FRDisbursementsFactory', 'FRClosingFactory', 'raSpinnerService', 'WalkthroughFactory']; // angular
//   .module('HeroPRO')
//   .controller('HEROCountersignController', HEROCountersignController);

/* @ngInject */
function HEROCountersignController($stateParams, $filter, $analytics, DocumentLink, FRInformationFactory, Timestamp, FRDisbursementsFactory, FRClosingFactory, raSpinnerService, WalkthroughFactory) {
    var vm = this;
    var advancePaymentDisbursementTypeId = 3;
    vm.stepSubjects = [];
    vm.stepDescription = '';
    vm.advancePaymentHistory = null;
    vm.advancePaymentCollapsed = true;
    vm.appDetails = {};

    // Flags
    vm.hasBypassedNTP = false;

    /*= ========================================
    =            Private Functions            =
    ========================================= */

    FRInformationFactory.getFundingRequestInformationPromise().then(function () {
        vm.appDetails = FRInformationFactory.getAppInfo();
    });

    FRDisbursementsFactory.getDisbursementStatusHistory({ FundingRequestId: $stateParams.appId, DisbursementType: advancePaymentDisbursementTypeId }).then(function (response) {
        setAdvancePaymentInfo(response.data);
    });

    function setAdvancePaymentInfo(advancePaymentHistoryData) {
        if (!!advancePaymentHistoryData.Data && advancePaymentHistoryData.Data.length > 0) {
            vm.advancePaymentHistory = {};
            vm.advancePaymentHistory.disbursementStatusInfos = advancePaymentHistoryData.Data[0].DisbursementStatusInfos;
            vm.advancePaymentHistory.disbursementAmount = advancePaymentHistoryData.Data[0].DisbursementAmount;
            vm.advancePaymentHistory.latestDisbursementStatus = vm.advancePaymentHistory.disbursementStatusInfos[vm.advancePaymentHistory.disbursementStatusInfos.length - 1];

            switch (vm.advancePaymentHistory.latestDisbursementStatus.DisbursementStatusId) {
                case 1:
                    // Created
                    var apDate = new Date(vm.advancePaymentHistory.latestDisbursementStatus.CreatedDate);
                    apDate.setDate(apDate.getDate() + 3);
                    vm.advancePaymentHistory.headerTitle = 'Advance Payment expected between ' + $filter('date')(vm.advancePaymentHistory.latestDisbursementStatus.CreatedDate, 'shortDate') + ' - ' + $filter('date')(apDate, 'shortDate');
                    break;
                case 2:
                    // Disbursed/Sent
                    vm.advancePaymentHistory.headerTitle = 'Advance Payment sent on ' + $filter('date')(vm.advancePaymentHistory.latestDisbursementStatus.CreatedDate, 'shortDate');
                    break;
                case 3: // Repaid
                case 6:
                    // HERO Funded
                    vm.advancePaymentHistory.headerTitle = $filter('currency')(vm.advancePaymentHistory.disbursementAmount, '$', 2) + ' Advance Payment was repaid on ' + $filter('date')(vm.advancePaymentHistory.latestDisbursementStatus.CreatedDate, 'shortDate');
                    break;
                case 4:
                    // Cancelled
                    vm.advancePaymentHistory.headerTitle = $filter('currency')(vm.advancePaymentHistory.disbursementAmount, '$', 2) + ' Advance Payment cancelled';
                    break;
                case 5:
                    // Invoiced
                    vm.advancePaymentHistory.headerTitle = $filter('currency')(vm.advancePaymentHistory.disbursementAmount, '$', 2) + ' Advance Payment invoiced on ' + $filter('date')(vm.advancePaymentHistory.latestDisbursementStatus.CreatedDate, 'shortDate');
                    break;
            }
        }
    }

    /* -----  End of Private Functions  ------*/

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    vm.confirmProjectComplete = function () {
        raSpinnerService.show('walkthroughSpinner');
        FRClosingFactory.confirmProjectComplete().then(function (response) {
            FRInformationFactory.setStateMachineData(response.data.PipelineStageId, response.data.FundingRequestPipelineStageId, response.data.LoanStateId, response.data.FundingRequestStateId);
            FRClosingFactory.setProjectDetails(_lodash2.default.omit(response.data, 'FundingRequestId', 'LoanStateId'));
            FRClosingFactory.setProjectDetailsConfirmed();
            WalkthroughFactory.loadWalkthrough();
            raSpinnerService.hide('walkthroughSpinner');
        });
    };

    vm.isCountersignNTPComplete = function () {
        return (vm.appDetails.isIssuerReviewed || vm.appDetails.isCountersigned) && vm.appDetails.isNTPSent;
    };

    vm.clickContinue = function () {
        vm.hasBypassedNTP = true;
    };
}

/***/ }),
/* 672 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 673 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = POSignController;

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

__webpack_require__(675);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

POSignController.$inject = ['POSignFactory', '$stateParams', '$state', '$analytics', 'Timestamp', '$window', 'FRInformationFactory', 'ModalService']; // angular
//     .module("HeroPRO")
//     .controller("POSignController", POSignController);

/* @ngInject */
function POSignController(POSignFactory, $stateParams, $state, $analytics, Timestamp, $window, FRInformationFactory, ModalService) {
    var vm = this;
    vm.appInfo = {};
    vm.POs = [];
    vm.loadingPOs = true;

    /*= ========================================
    =            Private Functions            =
    ========================================= */

    FRInformationFactory.getFundingRequestInformationPromise().then(function () {
        vm.appInfo = FRInformationFactory.getAppInfo();
    });

    function determineEDocStatus(_POs) {
        var POs = _angular2.default.copy(_POs);

        // (ajt - 4/8/2016) Added null check
        if (POs) {
            POs.map(function (po) {
                var stat = po.Owner.EDocumentRecipientStatus;

                po.signed = stat === 3 || stat === 5;
                po.sent = stat === 100;
                po.emailSending = false;
                return po;
            });
        }
        return POs;
    }

    POSignFactory.getPOInfo($stateParams.appId).then(function (data) {
        var poSignLoadTime = new Date().getTime() - Timestamp.getTimestamp('stateChangeTimestamp');
        $analytics.eventTrack('Module Initialize', { category: 'Module:POSign', value: poSignLoadTime });
        vm.POs = determineEDocStatus(data.data.PropertyOwnerData);
        vm.loadingPOs = false;
    });

    /* -----  End of Private Functions  ------*/

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    vm.displayPOSign = function displayPOSign() {
        if (vm.loadingPOs === false) {
            ModalService.launchLgModal({
                templateUrl: 'app/appDetail/walkthrough/startWork/PO-Sign/PO-Modal.html',
                windowClass: 'po-sign-modal',
                controller: 'POSignModalController',
                controllerAs: 'POSignModal',
                resolve: {
                    data: function data() {
                        return {
                            POs: vm.POs,
                            AppInfo: vm.appInfo
                        };
                    }
                }
            });

            if (vm.POs && vm.POs.length > 0) {
                // Added to prevent trying to read 0 off undefined object.
                var emailSentToPO1 = vm.checkIfEmailSent(vm.POs[0]) === true ? 'DocsSent' : 'SendDocs';
                $analytics.eventTrack('Get Signatures Modal Open', { category: 'Walkthrough', label: 'Start Work ' + emailSentToPO1 });
            }
        }
    };

    vm.checkIfEmailSent = function checkIfEmailSent(po) {
        return po.Owner.EDocumentRecipientStatusDate && po.Owner.EDocumentRecipientStatusDate !== null && po.Owner.EDocumentRecipientStatusDate !== '' && po.Owner.EDocumentRecipientStatusDate !== 'undefined' && po.Owner.EDocumentRecipientStatus === 100;
    };
}

/***/ }),
/* 675 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = POSignModalController;

__webpack_require__(677);

POSignModalController.$inject = ['POSignFactory', '$stateParams', '$state', '$analytics', 'Timestamp', 'FRInformationFactory', 'ModalService', 'data']; // angular
// 	.module("HeroPRO")
// 	.controller("POSignModalController", POSignModalController);

/* @ngInject */
function POSignModalController(POSignFactory, $stateParams, $state, $analytics, Timestamp, FRInformationFactory, ModalService, data) {
    var vm = this;
    vm.appInfo = data.AppInfo;
    vm.POs = data.POs;

    /*= ========================================
    =            Private Functions            =
    ========================================= */
    function sendEmail(po, emailOnly) {
        POSignFactory.emailPO($stateParams.appId, po).then(function () {
            if (emailOnly) {
                po.emailSending = false;
                po.emailSent = true;
                po.Owner.EDocumentRecipientStatusDate = new Date();
            }
        });
    }

    /* -----  End of Private Functions  ------*/

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    vm.emailPO = function (po) {
        po.ctaClicked = true;
        var eventName = po.sent === true ? 'Resend Email Click' : 'Send Email Click';
        $analytics.eventTrack(eventName, { category: 'Modal: GetSigs', label: 'Start Work' });

        if (vm.validateEmail(po)) {
            po.emailSending = true;
            sendEmail(po, true);
        } else {
            po.hasValidEmail = false;
        }
    };

    vm.closePOSignModal = function () {
        $analytics.eventTrack('Get Signatures Modal Close', { category: 'Modal: GetSigs', label: 'Start Work' });
        ModalService.closeLgModal();
        $state.go($state.$current, null, { reload: true });
    };

    vm.trackSignNowClick = function (po) {
        po.ctaClicked = true;
        if (po.hasValidEmail) {
            sendEmail(po, false);
        }
    };

    vm.validateEmail = function (po) {
        po.hasValidEmail = false;
        if (po.Owner.Email && po.Owner.Email.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i)) {
            po.hasValidEmail = true;
        }
        return po.hasValidEmail;
    };
}

/***/ }),
/* 677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = POSignFactory;
POSignFactory.$inject = ['$http', 'HPConfig'];
// angular
//     .module("HeroPRO")
//     .factory("POSignFactory", POSignFactory);

/* @ngInject */
function POSignFactory($http, HPConfig) {
    return {
        getPOInfo: getPOInfo,
        emailPO: emailPO
    };

    function getPOInfo(id) {
        return $http.get(HPConfig.heroProApi + 'ESign/GetPropertyOwnerSignatures?FundingRequestId=' + id);
    }

    function emailPO(id, po) {
        return $http.post(HPConfig.heroProApi + 'ESign/EmailPropertyOwnerSignDocsEnvelope', {
            FundingRequestId: id,
            EDocumentRecipientId: po.Owner.EDocumentRecipientID,
            DocumentType: 'FinancingDocs',
            Email: po.Owner.Email,
            OwnerOrdinal: po.Owner.OrdinalInRole
        });
    }
}

/***/ }),
/* 679 */
/***/ (function(module, exports) {

module.exports = "<div ng-controller=\"COReviewController as COReview\" class=\"co-review-step\">\n\t<div class=\"row\">\n\t\t<div class=\"col-md-12\">\n\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-md-12 text-center\">\n\t\t\t\t\t<h5>Approve your project details<span ng-if=\"COReview.appInfo.Address.State.toUpperCase() === 'CA'\"> and certify that the home improvement contract has not yet been executed</span>.</h5>\n\t\t\t\t</div>\n\t\t\t</div>\n            <div class=\"row co-review-subtitle\" ng-if=\"COReview.selectedDealType.DealTypeId !== 1\">\n                <div class=\"col-md-11 col-md-offset-1\">\n                    <p>\n                        <span ng-if=\"COReview.selectedDealType.DealTypeCategoryId === 1\">Purchase -</span>\n                        <span>{{COReview.selectedDealType.DealTypeName}}</span>\n                        <span ng-if=\"COReview.selectedDealType.FinanceOrganization\">- {{COReview.selectedDealType.FinanceOrganization.FinanceOrganizationName}}</span>\n                        <span ng-if=\"COReview.selectedDealType.LeaseTerm\">- {{COReview.selectedDealType.LeaseTerm}} years </span>\n                    </p>\n                </div>\n            </div>\n            <ng-include ng-if=\"COReview.fundingRequestDetail.FundingDisbursementModelTypeId !== 40 && COReview.fundingRequestDetail.FundingDisbursementModelTypeId !== 50\" src=\"'app/appDetail/walkthrough/startWork/CO-Review/financialSummary.html'\"></ng-include>\n\n            <ng-include ng-if=\"COReview.fundingRequestDetail.FundingDisbursementModelTypeId === 40 || COReview.fundingRequestDetail.FundingDisbursementModelTypeId === 50\" src=\"'app/appDetail/walkthrough/startWork/CO-Review/financialSummaryLease.html'\"></ng-include>\n\n            <div class=\"row\">\n                <div class=\"col-md-12 co-review-actions text-center\">\n                    <p class=\"eyecatch\">Approve And Certify</p>\n                </div>\n            </div>\n\n            <div class=\"row\">\n                <div class=\"col-md-12 text-center\">\n                    <p>By clicking \"I AGREE\" below, you acknowledge and agree that the project information shown above is true, accurate, and complete<span ng-if=\"COReview.appInfo.Address.State.toUpperCase() === 'CA'\">, and you certify that the home improvement contract related to this project was not executed before the related application was fully approved</span>.</p>\n                    <p>I attest that the prices included above are the same that the homeowner would have paid if they had used cash to complete the project.</p>\n                </div>\n            </div>\n\n            <div class=\"row\">\n                <div class=\"col-md-12 text-center\">\n                        <hp-spinner-button is-disabled=\"COReview.approvingDocs\" button-text=\"I AGREE\" button-name=\"btnApproveDocs\" is-primary-btn=\"true\" is-submit-button=\"false\" display-spinner=\"COReview.approvingDocs\" ng-click=\"COReview.approveDocs();\"></hp-spinner-button>\n                </div>\n            </div>\n\t\t</div>\n\t</div>\n</div>\n";

/***/ }),
/* 680 */
/***/ (function(module, exports) {

module.exports = "<div class=\"product-added products-submitted\">\n    <div class=\"row\" ng-if=\"COReview.productsLoaded === true\">\n        <div class=\"col-md-12\">\n            <div class=\"row\">\n                <div class=\"col-md-11 col-md-offset-1\">\n                    <table cellpadding=\"0\" cellspacing=\"0\" ng-repeat=\"productCategory in COReview.products\">\n                        <thead>\n                        <tr>\n                            <th colspan=\"3\">{{productCategory.category.DisplayName}}</th>\n                        </tr>\n                        </thead>\n                        <tbody ng-repeat=\"product in productCategory.products\">\n                        <tr>\n                            <td class=\"product-info\">\n                                <p class=\"product-type\">{{product.primaryProduct.Product.ProductCategory.ProductType.DisplayName}}</p>\n                                <p class=\"product-name\">{{product.primaryProduct.Product.DisplayName}}</p>\n                            </td>\n                            <td class=\"quantity\">{{product.primaryProduct.quantity}}</td>\n                            <td class=\"price\">{{product.primaryProduct.InitialRequested | currency}}</td>\n                            <td class=\"action\"></td>\n                        </tr>\n                        <tr ng-repeat=\"relatedProduct in product.relatedProducts\">\n                            <td class=\"product-info\">\n                                <p class=\"product-type\">{{relatedProduct.Product.ProductCategory.ProductType.DisplayName}}</p>\n                                <p class=\"product-name\">{{relatedProduct.Product.DisplayName}}</p>\n                            </td>\n                            <td class=\"quantity\">{{relatedProduct.quantity}}</td>\n                            <td class=\"price\"><span ng-hide=\"relatedProduct.AmountField\">{{relatedProduct.InitialRequested | currency}}</span></td>\n                            <td class=\"action\"></td>\n                        </tr>\n                        </tbody>\n                    </table>\n                </div>\n            </div>\n\n            <div class=\"row\">\n                <div class=\"col-md-11 col-md-offset-1\">\n                    <div class=\"project-price-summary\">\n                        <div class=\"row\">\n                            <div class=\"col-md-5 col-md-offset-5\">\n                                <p class=\"pull-right\">Product Subtotal</p>\n                            </div>\n                            <div class=\"col-md-2\">\n                                <p class=\"pull-right\">{{COReview.productSubtotal | currency}}</p>\n                            </div>\n                        </div>\n                        <div class=\"row\">\n                            <div class=\"col-md-5 col-md-offset-5\">\n                                <p class=\"pull-right\">Financing Term</p>\n                            </div>\n                            <div class=\"col-md-2\">\n                                <p class=\"pull-right\">{{COReview.financingTerm}}-Years</p>\n                            </div>\n                        </div>\n                        <div class=\"row\">\n                            <div class=\"col-md-5 col-md-offset-5\">\n                                <p class=\"pull-right\">Estimated Interest &amp; Fees</p>\n                            </div>\n                            <div class=\"col-md-2\">\n                                <p class=\"pull-right\">{{(COReview.interestAndFees.CAPI || COReview.interestAndFees.CAPIPrepay) + (COReview.interestAndFees.ClosingCosts || COReview.interestAndFees.ClosingCostsPrepay) | currency}}</p>\n                            </div>\n                        </div>\n                        <div class=\"row\" ng-if=\"COReview.prePayment !== 0\">\n                            <div class=\"col-md-5 col-md-offset-5\">\n                                <p class=\"pull-right\">Pre-Payment</p>\n                            </div>\n                            <div class=\"col-md-2\">\n                                <p class=\"pull-right pre-payment-value\">- {{COReview.prePayment | currency}}</p>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"row\">\n                <div class=\"col-md-11 col-md-offset-1\">\n                    <div class=\"project-total\">\n                        <div class=\"row\">\n                            <div class=\"col-md-3 col-md-offset-7\">\n                                <p class=\"pull-right\">Project Total</p>\n                            </div>\n                            <div class=\"col-md-2\">\n                                <p class=\"pull-right\">{{COReview.projectTotal | currency}}</p>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 681 */
/***/ (function(module, exports) {

module.exports = "<div class=\"financial-summary text-center\">\n    <div class=\"row\">\n        <div class=\"col-md-6 col-md-offset-3\">\n            <div class=\"row row-header\">\n                <div class=\"col-md-7 text-left\">Product Info</div>\n                <div class=\"col-md-2 text-right\">QTY</div>\n                <div class=\"col-md-3 text-right\">Amount</div>\n            </div>\n            <div class=\"row\" ng-repeat=\"improvement in appDetail.projectDetails.Improvements\">\n                <div class=\"col-md-7 text-left\">\n                    <div class=\"product-name\">{{improvement.ProductTypeName}}</div>\n                </div>\n                <div class=\"col-md-2 text-right\">{{improvement.Quantity}}</div>\n                <div class=\"col-md-3 text-right\">{{improvement.TotalApproved || improvement.InitialRequested | currency}}</div>\n            </div>\n            <div class=\"row row-footer\">\n                <div class=\"col-md-9 text-right\"><b>Total</b></div>\n                <div class=\"col-md-3 text-right\">{{appDetail.projectDetails.TotalRequested || appDetail.projectDetails.InitialRequested | currency}}</div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-9 text-right\"><b>Term</b></div>\n                <div class=\"col-md-3 text-right\">{{appDetail.projectDetails.Term}}-Years</div>\n            </div>\n            <div class=\"row row-border-top lease-information\">\n                <div class=\"col-md-8 col-xs-6 text-label company\">{{appDetail.projectDetails.FinanceOrganizationName}}</div>\n                <div class=\"col-md-4 col-xs-6 text-amount\">{{appDetail.projectDetails.FinancingProductTypeDescription}}</div>\n            </div>\n            <div class=\"row row-border-top\">\n                <div class=\"col-md-8 col-xs-6 text-label\">Monthly</div>\n                <div class=\"col-md-4 col-xs-6 text-amount\">{{appDetail.projectDetails.MonthlyPayment | currency : '$'}}</div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-8 col-xs-6 text-label\">Annual</div>\n                <div class=\"col-md-4 col-xs-6 text-amount\">{{appDetail.projectDetails.YearlyPayment | currency : '$'}}</div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-8 col-xs-6 text-label\">Lifetime</div>\n                <div class=\"col-md-4 col-xs-6 text-amount\">{{appDetail.projectDetails.InitialRequested | currency : '$'}}</div>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 682 */
/***/ (function(module, exports) {

module.exports = "<div ng-controller=\"HEROCountersignController as HEROCountersign\" class=\"ntp-countersign-container\">\n    <div class=\"row ntp-late-container\" ng-if=\"HEROCountersign.appDetails.isNTPLate\">\n        <div class=\"col-md-12\">\n            <span class=\"hp-badge late\">!</span>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-md-6 col-md-offset-3 text-center\" ng-if=\"!HEROCountersign.isCountersignNTPComplete()\">\n            <h5>Homeowner(s) has signed the financial documents.</h5>\n            <p class=\"instructions\">\n                Awaiting\n                <span ng-if=\"!HEROCountersign.appDetails.IsNoticeToLenderRequired\">Countersign</span>\n                <span ng-if=\"HEROCountersign.appDetails.IsNoticeToLenderRequired\">Review</span>\n                and Notice to Proceed.\n            </p>\n        </div>\n        <div class=\"col-md-8 col-md-offset-2 text-center\" ng-if=\"HEROCountersign.isCountersignNTPComplete()\">\n            <h5 class=\"ntp-countersign-complete\">HERO has issued the Notice to Proceed and the project is in\n                progress!</h5>\n        </div>\n    </div>\n    <div class=\"row\" ng-if=\"!HEROCountersign.isCountersignNTPComplete()\">\n        <div class=\"col-md-6 col-md-offset-3 ntp-countersign-status\">\n            <div class=\"row\">\n                <div class=\"col-md-6 text-left\">\n                    <p ng-if=\"!HEROCountersign.appDetails.IsNoticeToLenderRequired\">Countersign</p>\n                    <p ng-if=\"HEROCountersign.appDetails.IsNoticeToLenderRequired\">Review</p>\n                </div>\n                <div class=\"col-md-6 text-left\">\n                    <p class=\"countersign-date\" ng-if=\"!HEROCountersign.appDetails.isCountersigned && !HEROCountersign.appDetails.isIssuerReviewed\">\n                        Approx: {{HEROCountersign.appDetails.ReceivedFinancingDocumentsDate | date : 'M/d/yyyy'}}\n                    </p>\n                    <p class=\"countersign-date\" ng-if=\"HEROCountersign.appDetails.isCountersigned || HEROCountersign.appDetails.isIssuerReviewed\">\n                        <span ng-if=\"!HEROCountersign.appDetails.IsNoticeToLenderRequired\">\n                            Signed: {{HEROCountersign.appDetails.CountersignedDate | date : 'M/d/yyyy'}}\n                        </span>\n                        <span ng-if=\"HEROCountersign.appDetails.IsNoticeToLenderRequired\">\n                            Reviewed: {{HEROCountersign.appDetails.IssuerReviewedDate | date : 'M/d/yyyy'}}\n                        </span>\n                    </p>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-6 text-left\">\n                    <p class=\"\">\n                        Notice to Proceed Issued\n                    </p>\n                </div>\n                <div class=\"col-md-6 text-left\">\n                    <p class=\"ntp-date\" ng-if=\"!HEROCountersign.appDetails.isNTPSent\">\n                        Approx:\n                        <span\n                            ng-bind=\"HEROCountersign.appDetails.ReceivedFinancingDocumentsDate | date : 'M/d/yyyy'\"></span>\n                    </p>\n                    <p class=\"ntp-date\" ng-if=\"HEROCountersign.appDetails.isNTPSent\">\n                        Issued:\n                        <span ng-bind=\"HEROCountersign.appDetails.NoticeToProceedSentDate | date : 'M/d/yyyy'\"></span>\n                    </p>\n                </div>\n            </div>\n            <div class=\"row ntp-late-message-container\" ng-if=\"HEROCountersign.appDetails.isNTPLate\">\n                <div class=\"col-md-12 text-center\">\n                    <p class=\"ntp-late-message\">The documents are still in the final review stage.</p>\n                    <p class=\"ntp-late-message\">No action is needed on your part.</p>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-md-12 countersign-actions text-center\">\n            <p class=\"eyecatch\">Next Steps</p>\n        </div>\n    </div>\n    <div class=\"row\" ng-if=\"!HEROCountersign.hasBypassedNTP && !HEROCountersign.isCountersignNTPComplete()\">\n        <div class=\"col-md-10 col-md-offset-1 text-center\">\n            <p class=\"next-steps-notice\" ng-if=\"!HEROCountersign.appDetails.IsNoticeToLenderRequired\">\n                Homeowner(s) have the right to review countersigned documents for {{HEROCountersign.appDetails.RightToCancelDays }} days.\n                Following this, HERO will send you a \"Notice to Proceed\" and only then may installation work begin.\n            </p>\n            <p class=\"next-steps-notice\" ng-if=\"HEROCountersign.appDetails.IsNoticeToLenderRequired\">\n                The homeowner may review their documents for 3 days. Then, HERO will send you a \"Notice to Proceed.\" Installation work can begin at that time.\n                Upload permits to document center when ready or continue without Notice to Proceed.\n            </p>\n        </div>\n    </div>\n    <div class=\"row\" ng-if=\"!HEROCountersign.hasBypassedNTP && !HEROCountersign.isCountersignNTPComplete()\">\n        <div class=\"col-md-12 text-center\">\n            <p class=\"next-steps-instruction\">Upload permits to Document Center when ready or <span class=\"link\"\n                                                                                                    ng-click=\"HEROCountersign.clickContinue()\">continue</span>\n                without Notice to Proceed.</p>\n        </div>\n    </div>\n    <div class=\"row\" ng-if=\"HEROCountersign.hasBypassedNTP || HEROCountersign.isCountersignNTPComplete()\">\n        <div class=\"col-md-6 col-md-offset-3 text-center\">\n            <p class=\"next-steps-notice\">You can <span class=\"emphasis\">Make Changes</span> to the project, if needed.\n                When it's finished, select <span class=\"emphasis\">Project Complete</span> to kick off funding.</p>\n        </div>\n    </div>\n    <div class=\"row ntp-bypass-btn-container\"\n         ng-if=\"HEROCountersign.hasBypassedNTP || HEROCountersign.isCountersignNTPComplete()\">\n        <div class=\"col-md-6 text-right\">\n            <button type=\"button\" class=\"btn btn-primary\" id=\"btnProjectComplete\"\n                    ng-click=\"HEROCountersign.confirmProjectComplete()\">Project Complete\n            </button>\n        </div>\n        <div class=\"col-md-6 text-left\">\n            <button type=\"button\" class=\"btn btn-default\" id=\"btnMakeChanges\"\n                    ng-click=\"appDetail.openMakeChangesModal()\">Make Changes\n            </button>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 683 */
/***/ (function(module, exports) {

module.exports = "<div ng-controller=\"POSignController as POSign\" class=\"po-review-step\">\n    <div class=\"row\">\n        <div class=\"col-md-6 col-md-offset-3 text-center po-review-instructions\">\n            <h5>Financial documents reviewed and ready to be sent to the homeowner(s).</h5>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-md-12 po-review-actions text-center\">\n            <p class=\"eyecatch\">Next Steps</p>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-md-12 text-center po-review-walkthrough-instruction\">\n            <p>Request signatures via email or sign them now.</p>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-md-12 po-review-buttons text-center\">\n            <hp-spinner-button button-text=\"Get Signatures\" button-name=\"btnSendToPO\" button-id=\"btnSendToPO\" is-primary-btn=\"true\"\n                               is-submit-button=\"false\" display-spinner=\"POSign.loadingPOs\" button-fn=\"POSign.displayPOSign()\"></hp-spinner-button>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 684 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <span class=\"icon icon-delete-circle\" ng-click=\"POSignModal.closePOSignModal()\"></span>\n</div>\n\n<div class=\"modal-body\">\n    <p class=\"modal-title\">Get Signatures</p>\n    <div class=\"row\">\n        <div class=\"col-md-12 text-center po-sign-modal-instructions\">\n            <p>If you are with the property owner(s), you can have them sign now by clicking Sign Now. You can also send the property owner(s) an e-mail with detail instructions to review and sign by clicking Send Email.</p>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div ng-repeat=\"po in POSignModal.POs\" class=\"po-sign-fin-docs\">\n                <div class=\"row\">\n                    <div class=\"col-md-12\">\n                        <p class=\"po-name\">\n                            <span ng-bind=\"po.Owner.FirstName\"></span>\n                            <span ng-bind=\"po.Owner.LastName\"></span>\n                        </p>\n                    </div>\n\n                </div>\n                <div class=\"row\" ng-show=\"!po.hasValidEmail && po.ctaClicked\">\n                    <div class=\"col-md-12 col-xs-12 error-message-container\">\n                        <div class=\"error-message\">Invalid Email.</div>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-md-6 col-xs-12\">\n                        <input type=\"text\" ng-class=\"{ 'error': !po.hasValidEmail && po.ctaClicked }\" class=\"form-control\" ng-if=\"!po.signed\" ng-model=\"po.Owner.Email\" ng-change=\"POSignModal.validateEmail(po)\" ng-init=\"POSignModal.validateEmail(po)\"/>\n                        <p ng-if=\"po.signed\" class=\"po-owner-email-signed\" ng-bind=\"po.Owner.Email\"></p>\n                    </div>\n                    <div class=\"col-md-3\">\n                        <div class=\"btn-row\">\n                            <div>\n                                <a ng-if=\"!po.signed\" target=\"{{ po.hasValidEmail ? '_blank': '' }}\" href=\"{{po.hasValidEmail ? po.ESignUrl : '#'}}\" class=\"form-control btn btn-default\" \n                                   ng-click=\"POSignModal.trackSignNowClick(po)\" analytics-on=\"click\" analytics-event=\"Sign Now Click\" analytics-category=\"Modal: GetSigs\" analytics-label=\"Start Work\">Sign Now</a>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"col-md-3 col-xs-12\">\n                        <div class=\"btn-row\">\n                            <div ng-hide=\"po.emailSending || po.emailSent\">\n                                <a ng-if=\"!po.signed\" ng-click=\"POSignModal.emailPO(po);\"\n                                   class=\"form-control btn btn-primary\">\n                                    <span ng-if=\"!po.emailSending && !po.sent\">Send Email</span>\n                                    <span ng-if=\"!po.emailSending && po.sent\">Resend</span>\n                                </a>\n                            </div>\n                            <div ng-show=\"po.emailSending || po.emailSent\">\n                                <a class=\"btn\"\n                                   ng-class=\"{ 'btn-default': po.emailSending === true , 'btn-success': po.emailSent === true }\"\n                                   disabled=\"disabled\">\n                                    <span ng-show=\"po.emailSending\">Sending...</span>\n                                    <span ng-show=\"po.emailSent\">Sent</span>\n                                </a>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"edoc-statuses\">\n                    <p class=\"has-signed\" ng-if=\"po.signed\">\n                        <strong ng-bind=\"po.Owner.FirstName\"></strong>\n                        <strong ng-bind=\"po.Owner.LastName\"></strong>\n                        <span>has signed the document on: </span>\n                        <span ng-bind=\"po.Owner.EDocumentRecipientStatusDate | date : 'M/d/yyyy'\"></span>\n                    </p>\n                    <p class=\"not-signed-warning \" ng-if=\"(!po.signed && POSign.checkIfEmailSent(po)) || po.emailSent\">\n                        <span class=\"icon icon-error\"></span>\n                        <span>Property owner has not signed. Call</span>\n                        <span ng-bind=\"po.Owner.FirstName\"></span>\n                        <span ng-bind=\"po.Owner.LastName\"></span>\n                        <a href=\"tel:{{POSignModal.appInfo.Owner1Phone1}}\" ng-bind=\"POSignModal.appInfo.Owner1Phone1 | tel\"></a>\n                    </p>\n                    <p class=\"distributed-date\" ng-if=\"!po.signed && po.Owner.EDocumentRecipientStatus !== 100 && !po.emailSent\">\n                        <span>Ready for distribution:</span>\n                        <span ng-bind=\"po.Owner.EDocumentRecipientStatusDate | date : 'M/d/yyyy'\"></span>\n                    </p>\n                    <p class=\"distributed-date\" ng-if=\"po.Owner.EDocumentRecipientStatus === 100 || po.emailSent\">\n                        <span>Email sent on:</span>\n                        <span ng-bind=\"po.Owner.EDocumentRecipientStatusDate | date : 'M/d/yyyy'\"></span>\n                    </p>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 685 */
/***/ (function(module, exports) {

module.exports = "<div ng-controller=\"POSignController as POSign\" class=\"po-review-step\">\n    <div class=\"row\">\n        <div class=\"col-md-6 col-md-offset-3 text-center po-emailed-instructions\">\n            <h5>Financial documents have been sent to the homeowner(s) but have not yet been signed.</h5>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-md-8 col-md-offset-2 po-email-status\">\n            <div ng-repeat=\"po in POSign.POs\" class=\"app-detail-po\">\n                <div class=\"row\">\n                    <div class=\"col-md-6 text-right\">\n                        <p class=\"po-name\">\n                            <span ng-bind=\"po.Owner.FirstName\"></span>\n                            <span ng-bind=\"po.Owner.LastName\"></span>\n                        </p>\n                    </div>\n                    <div class=\"col-md-6 text-left\">\n                        <p class=\"po-email-status-date\" ng-if=\"po.signed\">\n                            Signed:\n                            <span ng-bind=\"po.Owner.EDocumentRecipientStatusDate | date : 'M/d/yyyy'\"></span>\n                        </p>\n                        <p class=\"po-email-status-date\" ng-if=\"POSign.checkIfEmailSent(po)\">\n                            Sent:\n                            <span ng-bind=\"po.Owner.EDocumentRecipientStatusDate | date : 'M/d/yyyy'\"></span>\n                        </p>\n                        <p class=\"po-email-status-date\" ng-if=\"!po.signed && !POSign.checkIfEmailSent(po)\">\n                            Ready for distribution:\n                            <span ng-bind=\"po.Owner.EDocumentRecipientStatusDate | date : 'M/d/yyyy'\"></span>\n                        </p>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-md-12 po-review-actions text-center\">\n            <p class=\"eyecatch\">Next Steps</p>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-md-12 po-review-walkthrough-instruction text-center\">\n            <p>Resend documents via email, or sign them now.</p>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-md-12 po-review-buttons text-center\">\n            <hp-spinner-button button-text=\"Get Signatures\" button-name=\"btnSendToPO\" button-id=\"btnSendToPO\" is-primary-btn=\"true\"\n                               is-submit-button=\"true\" display-spinner=\"POSign.loadingPOs\" button-fn=\"POSign.displayPOSign()\"></hp-spinner-button>\n        </div>\n    </div>\n\n</div>\n";

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = walkthroughController;

__webpack_require__(687);

walkthroughController.$inject = ['$scope', 'HPStateMachineConfig', 'FRInformationFactory', 'FRClosingFactory', 'FRDocumentsFactory', 'WalkthroughFactory', 'HPConditionTypes', 'PermissionsFactory']; // angular
// 	.module("HeroPRO")
// 	.controller("WalkthroughController", walkthroughController);

/* @ngInject */
function walkthroughController($scope, HPStateMachineConfig, FRInformationFactory, FRClosingFactory, FRDocumentsFactory, WalkthroughFactory, HPConditionTypes, PermissionsFactory) {
    var vm = this;
    vm.HPStateMachineConfig = HPStateMachineConfig;
    vm.appInfo = {};
    vm.activeWalkthroughTemplate = '';
    vm.stateMachineData = {};
    vm.isFundingScheduled = false;
    vm.showGetSignaturesButton = false;
    vm.outstandingDocuments = [];
    vm.invalidDocuments = [];
    vm.HPConditionTypes = HPConditionTypes;
    vm.isSolicitor = PermissionsFactory.hasPermission('IsSolicitor');

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.setCompletionCertificateRegenerated = function (newValue) {
        FRDocumentsFactory.setCompletionCertificateRegenerated(newValue);
        // Refresh the walkthrough since CompletionCertificateRegenerated is one of the values used to determine the active walkthrough
        WalkthroughFactory.loadWalkthrough();
    };

    vm.isProjectApproved = function () {
        return (vm.stateMachineData.FundingRequestStateId === vm.HPStateMachineConfig.FR.HERO_Funding_Scheduled || vm.stateMachineData.FundingRequestStateId === vm.HPStateMachineConfig.FR.HLP_Recording_Scheduled) && vm.isFundingScheduled;
    };
    /* -----  End of Public Functions  ------*/

    /*= ========================================
    =            Private Functions            =
    ========================================= */
    function init() {
        // Set the initial walkthrough that is shown
        WalkthroughFactory.loadWalkthrough().then(function () {
            vm.activeWalkthroughTemplate = WalkthroughFactory.getActiveWalkthroughTemplate();

            // Watch for changes to the activeWalkthroughTemplate that occur as the user processes a loan (w/o refreshing the page)
            $scope.$watch(WalkthroughFactory.getActiveWalkthroughTemplate, function (newTemplate) {
                vm.activeWalkthroughTemplate = newTemplate;
            });
        });

        FRInformationFactory.getFundingRequestInformationPromise().then(function () {
            vm.stateMachineData = FRInformationFactory.getStateMachineData();
            vm.appInfo = FRInformationFactory.getAppInfo();
        });

        FRClosingFactory.getFundingRequestClosingPromise().then(function () {
            vm.isFundingScheduled = FRClosingFactory.getIsFundingScheduled();
        });

        FRDocumentsFactory.getFundingRequestDocumentsPromise().then(function () {
            vm.showGetSignaturesButton = FRDocumentsFactory.getSignaturesButtonVisibility();
            vm.outstandingDocuments = FRDocumentsFactory.getOutstandingDocuments();
            vm.invalidDocuments = FRDocumentsFactory.getInvalidDocuments();
        });
    }
    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 687 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = walkthroughFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

walkthroughFactory.$inject = ['$q', 'FRInformationFactory', 'FRClosingFactory', 'FRDocumentsFactory', 'HPStateMachineConfig', 'UserAuthFactory', 'HPPipelineStages', 'hpLoggerService', 'PermissionsFactory', 'SelectedProductsFactory']; // angular
// 	.module("HeroPRO")
// 	.factory("WalkthroughFactory", walkthroughFactory);

/* @ngInject */
function walkthroughFactory($q, FRInformationFactory, FRClosingFactory, FRDocumentsFactory, HPStateMachineConfig, UserAuthFactory, HPPipelineStages, hpLoggerService, PermissionsFactory, SelectedProductsFactory) {
    var _walkthroughPromise = void 0;
    var _activeWalkthroughTemplate = '';
    var _stateMachineData = {};
    var _appInfo = {};
    var _fundingRequest = {};
    var _userAccess = '';
    var _isFundingScheduled = false;
    var _hasProducts = false;
    var _hasRequiredDocs = false;

    return {
        getActiveWalkthroughTemplate: getActiveWalkthroughTemplate,
        loadWalkthrough: loadWalkthrough
    };

    function loadWalkthrough() {

        _walkthroughPromise = $q(function (resolve) {
            // Before setting the active walkthrough template, ensure that all async data that is needed is available
            $q.all([FRInformationFactory.getFundingRequestInformationPromise(), FRClosingFactory.getFundingRequestClosingPromise(), UserAuthFactory.getAuthorization(), FRInformationFactory.getRequiredDocGenSetType()]).then(function (response) {
                _stateMachineData = FRInformationFactory.getStateMachineData();
                _appInfo = FRInformationFactory.getAppInfo();
                _userAccess = response[2] != null && response[2].HasElevatedAccess == true ? 'elevatedUser' : 'nonElevatedUser';
                _isFundingScheduled = FRClosingFactory.getIsFundingScheduled();
                _fundingRequest = FRClosingFactory.getFundingRequest();

                _hasRequiredDocs = !!response[3].DocGenSetType;

                // adding this to always check for 
                // products so that add products template shows up when needed.
                SelectedProductsFactory.getAddedProducts({ FundingRequestId: _appInfo.FundingRequestId }, true).then(function () {
                    _hasProducts = SelectedProductsFactory.getSelectedProductsCount() > 0;

                    var HAS_DOCS_STATES = [HPStateMachineConfig.Loan.Fin_Docs_Sent, HPStateMachineConfig.Loan.Fin_Docs_Signed_By_All_PO];

                    if (!_appInfo.IsMultiFundingRequest && HAS_DOCS_STATES.indexOf(_stateMachineData.LoanStateId) > -1 && _hasRequiredDocs) {
                        _activeWalkthroughTemplate = 'app/appDetail/walkthrough/getPaid/resumeAddProducts.html';
                    } else {
                        setActiveWalkthroughTemplate();
                    }

                    resolve();
                });
            });
        });

        return _walkthroughPromise;
    }

    function setActiveWalkthroughTemplate() {
        var activeWalkthrough = null;
        if (_stateMachineData.PipelineStageId === HPPipelineStages.GetPaid.pipelineStageId || _stateMachineData.PipelineStageId === HPPipelineStages.Closed.pipelineStageId) {
            // If PipelineStageId === 4 || 5, then look at the FundingRequestPipelineStageId instead of PipelineStageId
            if (_stateMachineData.FundingRequestPipelineStageId === HPPipelineStages.GetPaid.pipelineStageId) {
                activeWalkthrough = _lodash2.default.find(getWalkthroughConfig()[_stateMachineData.FundingRequestPipelineStageId][_userAccess].walkthroughs, function (walkthrough) {
                    return walkthrough.condition();
                });
            }

            if (_stateMachineData.FundingRequestPipelineStageId === HPPipelineStages.Closed.pipelineStageId) {
                activeWalkthrough = _lodash2.default.find(getWalkthroughConfig()[_stateMachineData.FundingRequestPipelineStageId].walkthroughs, function (walkthrough) {
                    return walkthrough.condition();
                });
            }
        } else {
            // For all other pipeline stages, the walk throughs are the same regardless of user access
            activeWalkthrough = _lodash2.default.find(getWalkthroughConfig()[_stateMachineData.PipelineStageId].walkthroughs, function (walkthrough) {
                return walkthrough.condition();
            });
        }

        // If no appropriate template was found, use the catch all walkthrough template
        if (activeWalkthrough === undefined) {
            activeWalkthrough = {};
            activeWalkthrough.template = 'app/appDetail/walkthrough/walkthroughNotFound.html';

            // (ajt 8/8/2016) Added logging for states that do not match a predefined walkthrough
            var payload = {
                UserAccess: _userAccess !== null && _userAccess !== undefined && _userAccess !== '' ? _userAccess : 'No User Access Info'
            };
            hpLoggerService.error('Walkthrough template was not found', 'WalkthroughFactory', 'setActiveWalkthroughTemplate', payload);
        }
        _activeWalkthroughTemplate = activeWalkthrough.template;
    }

    function getActiveWalkthroughTemplate() {
        return _activeWalkthroughTemplate;
    }

    function isUserProcessingRegeneratedCC() {
        return _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Closer_Rejected_Documents && FRDocumentsFactory.getCompletionCertificateRegenerated() === true;
    }

    function isSelfServiceAddProductsEnabled() {
        // Remove DealType condition when HLP is supported.
        return PermissionsFactory.hasPermission('AddProducts.Enabled') === true && _appInfo.CanAddProductsOnline === 0 && !(_appInfo.DealType && _appInfo.DealType.DealTypeId === 5);
    }

    function getWalkthroughConfig() {
        return {
            // Begin: Application -> PipelineStageId = 2
            2: {
                walkthroughs: [{
                    condition: function condition() {
                        return (_stateMachineData.LoanStateId === HPStateMachineConfig.Loan.Application_Submitted || _stateMachineData.LoanStateId === HPStateMachineConfig.Loan.AUS_Reviewed || _stateMachineData.LoanStateId === HPStateMachineConfig.Loan.AUS_Denied || _stateMachineData.LoanStateId === HPStateMachineConfig.Loan.AUS_Conditionally_Approved || _stateMachineData.LoanStateId === HPStateMachineConfig.Loan.UW_Reviewed_Info_Needed || _stateMachineData.LoanStateId === HPStateMachineConfig.Loan.Decision_Info_Received) && _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Project_Started;
                    },

                    template: 'app/appDetail/walkthrough/application/applicationResults.html'
                }, {
                    condition: function condition() {
                        return !_hasProducts && _stateMachineData.LoanStateId !== HPStateMachineConfig.Loan.Application_Approved;
                    },

                    template: 'app/appDetail/walkthrough/application/applicationResults.html'
                }, {
                    condition: function condition() {
                        return (_stateMachineData.LoanStateId === HPStateMachineConfig.Loan.Application_Approved || _stateMachineData.LoanStateId === HPStateMachineConfig.Loan.Product_And_Price_Added) && (_stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Project_Started || _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Documents_Submitted) && isSelfServiceAddProductsEnabled() === false;
                    },

                    template: 'app/appDetail/walkthrough/application/callInProducts.html'
                }, {
                    condition: function condition() {
                        return (_stateMachineData.LoanStateId === HPStateMachineConfig.Loan.Application_Approved || _stateMachineData.LoanStateId === HPStateMachineConfig.Loan.Product_And_Price_Added && !_hasProducts) && (_stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Project_Started || _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Documents_Submitted) && isSelfServiceAddProductsEnabled() === true;
                    },

                    template: 'app/appDetail/walkthrough/application/addProductsOnline.html'
                }, {
                    condition: function condition() {
                        return _stateMachineData.LoanStateId === HPStateMachineConfig.Loan.Product_And_Price_Added && _hasProducts && _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Project_Started && isSelfServiceAddProductsEnabled() === true;
                    },

                    template: 'app/appDetail/walkthrough/application/productAdded.html'
                }, {
                    condition: function condition() {
                        return _stateMachineData.LoanStateId === HPStateMachineConfig.Loan.Products_Submitted && _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Project_Started && isSelfServiceAddProductsEnabled() === true;
                    },

                    template: 'app/appDetail/walkthrough/application/productsSubmitted.html'
                }]
            },
            // End: Application -> PipelineStageId = 2
            // Begin: Start Work -> PipelineStageId = 3
            3: {
                walkthroughs: [{
                    condition: function condition() {
                        return !_hasProducts && _stateMachineData.LoanStateId !== HPStateMachineConfig.Loan.Application_Approved;
                    },

                    template: 'app/appDetail/walkthrough/application/addProductsOnline.html'
                }, {
                    condition: function condition() {
                        return _stateMachineData.FinDocsStateId === HPStateMachineConfig.FD.Fin_Docs_Created && _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Project_Started;
                    },

                    template: 'app/appDetail/walkthrough/startWork/CO-Review/CO-Review.html'
                }, {
                    condition: function condition() {
                        return _stateMachineData.FinDocsStateId === HPStateMachineConfig.FD.Fin_Docs_Approved_By_CO && _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Project_Started;
                    },

                    template: 'app/appDetail/walkthrough/startWork/PO-Sign/PO-Email.html'
                }, {
                    condition: function condition() {
                        return (_stateMachineData.FinDocsStateId === HPStateMachineConfig.FD.Fin_Docs_Emailed_To_PO || _stateMachineData.FinDocsStateId === HPStateMachineConfig.FD.Fin_Docs_eSign_Initiated_By_PO || _stateMachineData.FinDocsStateId === HPStateMachineConfig.FD.Fin_Docs_Signed_By_PO) && _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Project_Started;
                    },

                    template: 'app/appDetail/walkthrough/startWork/PO-Sign/PO-Sign.html'
                }]
            },
            // End: Start Work -> PipelineStageId = 3
            // Begin: Get Paid -> PipelineStageId = 4
            4: {
                elevatedUser: {
                    walkthroughs: [{
                        condition: function condition() {
                            return _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Project_Started || _stateMachineData.LoanStateId === HPStateMachineConfig.FR.Project_Completed && _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Project_Started;
                        },

                        template: 'app/appDetail/walkthrough/startWork/HERO-Countersign/HERO-Countersign.html'
                    }, {
                        condition: function condition() {
                            return _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Project_Completed && _stateMachineData.CompletionCertificateStateId === HPStateMachineConfig.CC.Completion_Cert_Generated || isUserProcessingRegeneratedCC() === true && _stateMachineData.CompletionCertificateStateId === HPStateMachineConfig.CC.Completion_Cert_Generated;
                        },

                        template: 'app/appDetail/walkthrough/getPaid/projectDetailsWalkthroughTemplate.html'
                    }, {
                        condition: function condition() {
                            return _fundingRequest.FundingRequestDetail.FundingDisbursementModelTypeId === 11 && (_stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Project_Completed && _stateMachineData.CompletionCertificateStateId === HPStateMachineConfig.CC.Product_Details_Confirmed || isUserProcessingRegeneratedCC() === true && _stateMachineData.CompletionCertificateStateId === HPStateMachineConfig.CC.Product_Details_Confirmed);
                        },

                        template: 'app/appDetail/walkthrough/getPaid/paymentDetailsProjectAdvanceWalkthrough.html'
                    }, {
                        condition: function condition() {
                            return _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Project_Completed && _stateMachineData.CompletionCertificateStateId === HPStateMachineConfig.CC.Product_Details_Confirmed || isUserProcessingRegeneratedCC() === true && _stateMachineData.CompletionCertificateStateId === HPStateMachineConfig.CC.Product_Details_Confirmed;
                        },

                        template: 'app/appDetail/walkthrough/getPaid/paymentInstructionsWalkthroughTemplate.html'
                    }, {
                        condition: function condition() {
                            return _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Project_Completed && _stateMachineData.CompletionCertificateStateId === HPStateMachineConfig.CC.Payment_Instructions_Confirmed || isUserProcessingRegeneratedCC() === true && _stateMachineData.CompletionCertificateStateId === HPStateMachineConfig.CC.Payment_Instructions_Confirmed;
                        },

                        template: 'app/appDetail/walkthrough/getPaid/getCOSignaturesWalkthrough.html'
                    }, {
                        condition: function condition() {
                            return _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Project_Completed && (_stateMachineData.CompletionCertificateStateId === HPStateMachineConfig.CC.CO_Signed_Completion_Cert || _stateMachineData.CompletionCertificateStateId === HPStateMachineConfig.CC.CO_Emailed_PO_Completion_Cert || _stateMachineData.CompletionCertificateStateId === HPStateMachineConfig.CC.Completion_Cert_Sent_To_Installer || _stateMachineData.CompletionCertificateStateId === HPStateMachineConfig.CC.PO_Initiated_Completion_Cert_eSign || _stateMachineData.CompletionCertificateStateId === HPStateMachineConfig.CC.PO_Completed_Completion_Cert_eSign) || isUserProcessingRegeneratedCC() === true && (_stateMachineData.CompletionCertificateStateId === HPStateMachineConfig.CC.CO_Signed_Completion_Cert || _stateMachineData.CompletionCertificateStateId === HPStateMachineConfig.CC.CO_Emailed_PO_Completion_Cert || _stateMachineData.CompletionCertificateStateId === HPStateMachineConfig.CC.Completion_Cert_Sent_To_Installer || _stateMachineData.CompletionCertificateStateId === HPStateMachineConfig.CC.PO_Initiated_Completion_Cert_eSign || _stateMachineData.CompletionCertificateStateId === HPStateMachineConfig.CC.PO_Completed_Completion_Cert_eSign);
                        },

                        template: 'app/appDetail/walkthrough/getPaid/getPOSignaturesWalkthrough.html'
                    }, {
                        condition: function condition() {
                            return _stateMachineData.CompletionCertificateStateId === HPStateMachineConfig.CC.Completion_Cert_Uploaded_Or_eSigned && _stateMachineData.ACAStateId !== undefined && _stateMachineData.ACAStateId !== HPStateMachineConfig.ACA.No_ACA && _stateMachineData.ACAStateId !== HPStateMachineConfig.ACA.ACA_Signed_By_All_PO && _stateMachineData.ACAStateId !== HPStateMachineConfig.ACA.COG_Countersigned_ACA;
                        },

                        template: 'app/appDetail/walkthrough/getPaid/getACASignaturesWalkthroughTemplate.html'
                    }, {
                        // TODO: Check optimizations turned off
                        condition: function condition() {
                            return FRDocumentsFactory.getOutstandingDocuments().length > 0 && FRDocumentsFactory.getSignaturesButtonVisibility() === false && FRClosingFactory.getPaymentInstructionsConfirmed() === true && _stateMachineData.CompletionCertificateStateId === HPStateMachineConfig.CC.Completion_Cert_Uploaded_Or_eSigned && (_stateMachineData.ACAStateId === HPStateMachineConfig.ACA.No_ACA || _stateMachineData.ACAStateId === HPStateMachineConfig.ACA.ACA_Signed_By_All_PO || _stateMachineData.ACAStateId === HPStateMachineConfig.ACA.COG_Countersigned_ACA);
                        },

                        template: 'app/appDetail/walkthrough/getPaid/outstandingDocumentsWalkthroughTemplate.html'
                    }, {
                        condition: function condition() {
                            return _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.All_Documents_Uploaded_Or_Signed;
                        },

                        template: 'app/appDetail/walkthrough/getPaid/projectReadyForSubmissionTemplate.html'
                    }, {
                        condition: function condition() {
                            return _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Documents_Submitted;
                        },

                        template: 'app/appDetail/walkthrough/getPaid/projectSubmittedTemplate.html'
                    }, {
                        condition: function condition() {
                            return _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Closer_Accepted_Case || (_stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.HERO_Funding_Scheduled || _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.HLP_Recording_Scheduled || _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Project_Completed) && _isFundingScheduled === false;
                        },

                        template: 'app/appDetail/walkthrough/getPaid/projectCloserAcceptedTemplate.html'
                    }, {
                        condition: function condition() {
                            return (_stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.HERO_Funding_Scheduled || _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.HLP_Recording_Scheduled) && _isFundingScheduled === true;
                        },

                        template: 'app/appDetail/walkthrough/getPaid/projectApprovedWalkthroughTemplate.html'
                    }, {
                        condition: function condition() {
                            return _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Closer_Rejected_Documents && FRDocumentsFactory.getCompletionCertificateRegenerated() === false;
                        },

                        template: 'app/appDetail/walkthrough/getPaid/rejectionsTemplate.html'
                    }, {
                        condition: function condition() {
                            return _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.CO_Corrects_Documents;
                        },

                        template: 'app/appDetail/walkthrough/getPaid/projectReadyForReSubmissionTemplate.html'
                    }]
                },
                nonElevatedUser: {
                    walkthroughs: [{
                        condition: function condition() {
                            return _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Project_Started || _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Project_Completed || _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.All_Documents_Uploaded_Or_Signed;
                        },

                        template: 'app/appDetail/walkthrough/getPaid/salesRepBeforeFundingWalkthroughTemplate.html'
                    }, {
                        condition: function condition() {
                            return _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.HERO_Funding_Scheduled || _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.HLP_Recording_Scheduled;
                        },

                        template: 'app/appDetail/walkthrough/getPaid/projectApprovedWalkthroughTemplate.html'
                    }, {
                        condition: function condition() {
                            return _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Documents_Submitted || _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Closer_Accepted_Case || _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Closer_Rejected_Documents || _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.CO_Corrects_Documents || _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Final;
                        },

                        template: 'app/appDetail/walkthrough/getPaid/salesRepAfterFundingWalkthroughTemplate.html'
                    }]
                }
            },
            // End: Get Paid -> PipelineStageId = 4
            // Begin: Closed -> PipelineStageId = 5
            5: {
                walkthroughs: [{
                    condition: function condition() {
                        return _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.HERO_Funded || _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.HLP_Completed;
                    },

                    template: 'app/appDetail/walkthrough/closed/heroFundedTemplate.html'
                }, {
                    condition: function condition() {
                        return _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Application_Denied;
                    },

                    template: 'app/appDetail/walkthrough/closed/applicationDeniedTemplate.html'
                }, {
                    condition: function condition() {
                        return _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Final;
                    },

                    template: 'app/appDetail/walkthrough/closed/defaultClosedTemplate.html'
                }]
            }
            // End: Closed -> PipelineStageId = 5
        };
    }
}

/***/ }),
/* 689 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n\t<div class=\"col-md-12\">\n\t\t<div class=\"row\">\n    \t\t<div class=\"col-md-12\" ng-controller=\"WalkthroughController as walkthrough\">\n\t\t\t\t<div id=\"walkthrough-container\" class=\"hp-module hp-loading-spinner\" ra-spinner name=\"walkthroughSpinner\" hide-content-when-shown=\"true\" show=\"true\" text=\"\" template=\"indeterminateSpinner\" ng-class=\"{'project-approved' : walkthrough.isProjectApproved() === true}\">\n                    <div class=\"hp-inner\">\n\t\t\t\t\t\t<div ng-include=\"walkthrough.activeWalkthroughTemplate\"></div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n";

/***/ }),
/* 690 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-error\">\n\t<img class=\"error-image\" src=\"/src/assets/images/icon-guy.png\" alt=\"Error\" />\n\t<h1>Oops! That wasn't right.</h1>\n\t<p>Please contact us at 844-722-7759 <br/> or <a href=\"mailto:info@heroprogram.com\" class=\"link\">info@heroprogram.com</a> if you have any questions.</p>\n</div>";

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = AppDetailController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(692);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

AppDetailController.$inject = ['$state', '$scope', 'FRInformationFactory', 'FRClosingFactory', 'FRDocumentsFactory', '$q', '$stateParams', 'ConfirmLeaveFactory', '$analytics', '$window', 'HPConfig', 'HPStateMachineConfig', '$uibModal', 'raSpinnerService', 'WalkthroughFactory', 'HPPipelineStages', 'hpLoggerService']; // angular
// 	.module("HeroPRO")
// 	.controller("AppDetailController", AppDetailController);

/* @ngInject */
function AppDetailController($state, $scope, FRInformationFactory, FRClosingFactory, FRDocumentsFactory, $q, $stateParams, ConfirmLeaveFactory, $analytics, $window, HPConfig, HPStateMachineConfig, $uibModal, raSpinnerService, WalkthroughFactory, HPPipelineStages, hpLoggerService) {
    var vm = this;
    var pipelineStageName = '';

    vm.primaryInformationSticky = false;
    vm.primaryInformationLoading = true;
    vm.stateMachineData = {};
    vm.projectDetails = {};
    vm.paymentInstructions = {};
    vm.fundingRequest = {};
    vm.otherDocuments = {};
    vm.CCDocument = null;

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.submitProjectForFunding = function (caseType) {
        var attachments = [];
        // Loop through the otherDocuments and retrieve the AttachmentID of documents with a status of 1
        for (var i = 0; i < vm.otherDocuments.length; i++) {
            for (var j = 0; j < vm.otherDocuments[i].AttachmentDetails.length; j++) {
                if (vm.otherDocuments[i].AttachmentDetails[j].Status === 1) {
                    attachments.push({ AttachmentId: vm.otherDocuments[i].AttachmentDetails[j].AttachmentDetail.AttachmentId });
                }
            }
        }

        // Loop through the CC and retrieve the AttachmentID of documents with a status of 1
        for (var k = 0; k < vm.CCDocument.AttachmentDetails.length; k++) {
            if (vm.CCDocument.AttachmentDetails[k].Status === 1) {
                attachments.push({ AttachmentId: vm.CCDocument.AttachmentDetails[k].AttachmentDetail.AttachmentId });
            }
        }

        var params = {
            FundingRequestId: $stateParams.appId,
            Attachments: attachments,
            CaseType: caseType
            // CaseType 11 = New Funding Submission
            // CaseType 12 = Funding Re-Submission
        };

        raSpinnerService.show('walkthroughSpinner');
        FRClosingFactory.submitProjectForFunding(params).then(function (response) {
            if (!!response.data.Data.CaseId) {
                FRInformationFactory.setStateMachineData(4, 4, HPStateMachineConfig.Loan.Fin_Docs_Signed_By_All_PO, HPStateMachineConfig.FR.Documents_Submitted);
            }
            WalkthroughFactory.loadWalkthrough();
            raSpinnerService.hide('walkthroughSpinner');
        });
    };

    vm.projectDetailsConfirmed = function () {
        return FRClosingFactory.getProjectDetailsConfirmed();
    };

    vm.paymentInstructionsConfirmed = function () {
        return FRClosingFactory.getPaymentInstructionsConfirmed();
    };

    vm.showDocumentUploadLinks = function () {
        // Hide the document upload links after the project has been submitted
        // Show the document upload links if the project has been rejected or if it is ready for resubmission
        return !!vm.fundingRequest.FundingRequestDetail && !!vm.fundingRequest.FundingRequestDetail.ContractorCaseSubmissionAllowed && vm.fundingRequest.FundingRequestDetail.ContractorCaseSubmissionAllowed !== false || vm.stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Closer_Rejected_Documents || vm.stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.CO_Corrects_Documents;
    };

    vm.showGlobalDocumentUploadLink = function () {
        // Hide the global document upload link until payment instructions have been confirmed
        // Hide the global document upload link after the project has been submitted
        // Show the global document upload link if the project has been rejected or if it is ready for resubmission
        return !!vm.fundingRequest.FundingRequestDetail && !!vm.fundingRequest.FundingRequestDetail.ContractorCaseSubmissionAllowed && vm.fundingRequest.FundingRequestDetail.ContractorCaseSubmissionAllowed !== false && vm.paymentInstructionsConfirmed() === true || vm.stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Closer_Rejected_Documents || vm.stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.CO_Corrects_Documents;
    };

    vm.scrollPointTriggered = function (distance, element, edge) {
        vm.primaryInformationSticky = !!edge;
        // Need to force a digest here so that the $observe in primaryInformationDirective is triggered
        $scope.$digest();
    };

    vm.openMakeChangesModal = function () {
        if (vm.appInfo.UnderwriterLock) {
            $uibModal.open({
                templateUrl: 'app/appDetail/makeChangesModal/makeChangesModalLocked.html',
                windowClass: 'make-changes-modal',
                controller: 'MakeChangesModalController',
                controllerAs: 'makeChangesModal',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                animation: false,
                scope: $scope
            });
        } else {
            $uibModal.open({
                templateUrl: 'app/appDetail/makeChangesModal/makeChangesModal.html',
                windowClass: 'make-changes-modal',
                controller: 'MakeChangesModalController',
                controllerAs: 'makeChangesModal',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                animation: false,
                scope: $scope
            });
        }
    };

    vm.openPaymentInstructionsModal = function () {
        $uibModal.open({
            templateUrl: 'app/appDetail/paymentInstructions/paymentInstructionsModal.html',
            windowClass: 'payment-instructions-modal',
            controller: 'PaymentInstructionsModalController',
            controllerAs: 'paymentInstructionsModal',
            size: 'lg',
            backdrop: 'static',
            keyboard: false,
            animation: false,
            scope: $scope
        });
    };

    vm.openGetSignaturesModal = function (_activeTab) {
        $uibModal.open({
            templateUrl: 'app/appDetail/getClosingSignaturesModal/getSignaturesModal.html',
            controller: 'GetSignaturesModalController',
            controllerAs: 'getSignaturesModal',
            size: 'lg',
            backdrop: 'static',
            keyboard: false,
            animation: false,
            scope: $scope,
            resolve: {
                activeTab: function activeTab() {
                    return _activeTab;
                }
            }
        });
    };

    vm.rateAfterDiscount = function (rate, discountRate) {
        rate = rate || 0;
        discountRate = discountRate || 0;

        rate = parseFloat(rate);
        discountRate = parseFloat(discountRate);

        var r = rate - discountRate;
        r *= 100;
        r = Math.round(r);
        r /= 100;
        if (r <= 0) r = 0;
        return r;
    };

    vm.openUploadDocumentsModal = function (_documentInfo) {

        hpLoggerService.info("collecting documentInfo", "AppDetailController", "openUploadDocumentsModal", _documentInfo);

        $uibModal.open({
            templateUrl: 'app/appDetail/documents/uploadDocumentsModal/uploadModalTemplate.html',
            windowClass: 'upload-documents-modal',
            controller: 'UploadModalController',
            controllerAs: 'uploadModal',
            size: 'lg',
            backdrop: 'static',
            keyboard: false,
            animation: false,
            scope: $scope,
            resolve: {
                documentInfo: function documentInfo() {
                    return _documentInfo;
                }
            }
        });
    };

    vm.openProjectHistoryModal = function () {
        $analytics.eventTrack('View Project History', { category: pipelineStageName });
        $uibModal.open({
            templateUrl: 'app/appDetail/projectHistory/projectHistoryModal.html',
            windowClass: 'project-history-modal',
            controller: 'ProjectHistoryModalController',
            controllerAs: 'projectHistoryModal',
            size: 'full-screen',
            scope: $scope,
            resolve: {
                fundingRequestId: function fundingRequestId() {
                    return $stateParams.appId;
                }
            }
        });
    };
    /* -----  End of Public Functions  ------*/

    /*= ========================================
    =            Private Functions            =
    ========================================= */
    function init() {
        $scope.$on('HPLocationChange', ConfirmLeaveFactory);

        FRInformationFactory.getFundingRequestInformation().then(function () {
            vm.appInfo = FRInformationFactory.getAppInfo();
            vm.stateMachineData = FRInformationFactory.getStateMachineData();
            vm.primaryInformationLoading = false;
            setStageName();
        });

        FRClosingFactory.getFundingRequestClosing().then(function () {
            vm.projectDetails = FRClosingFactory.getProjectDetails();
            vm.paymentInstructions = FRClosingFactory.getPaymentInstructions();
            vm.fundingRequest = FRClosingFactory.getFundingRequest();
            raSpinnerService.hide('walkthroughSpinner');
        });

        FRDocumentsFactory.getFundingRequestDocuments().then(function () {
            vm.otherDocuments = FRDocumentsFactory.getOtherDocuments();
            vm.CCDocument = FRDocumentsFactory.getCCDocument();
        });
    }

    function setStageName() {
        var currentStage = '';
        if (vm.stateMachineData.PipelineStageId === HPPipelineStages.GetPaid.pipelineStageId || vm.stateMachineData.PipelineStageId === HPPipelineStages.Closed.pipelineStageId) {
            // Use the FundingRequest pipeline stage id and not the loan stage id for GetPaid and Closed.
            currentStage = vm.stateMachineData.FundingRequestPipelineStageId;
        } else {
            // For all other pipeline stages, the use the loan stage id
            currentStage = vm.stateMachineData.PipelineStageId;
        }
        // Get Stage Name from Pipeline Stages constant
        var stageName = _lodash2.default.filter(HPPipelineStages, function (stage) {
            return stage.pipelineStageId === currentStage;
        });
        pipelineStageName = stageName[0].name;
    }

    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 692 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = fundingRequestClosingFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

fundingRequestClosingFactory.$inject = ['HPConfig', '$http', '$stateParams', '$q', 'FRInformationFactory', 'ProjectAdvanceFactory', 'HPStateMachineConfig', 'HPPipelineStages']; // angular
//   .module('HeroPRO')
//   .factory('FRClosingFactory', fundingRequestClosingFactory);

/* @ngInject */
function fundingRequestClosingFactory(HPConfig, $http, $stateParams, $q, FRInformationFactory, ProjectAdvanceFactory, HPStateMachineConfig, HPPipelineStages) {
    var _fundingRequestClosingPromise = void 0;
    var _projectDetails = {};
    var _paymentInstructions = {};
    var _fundingRequest = {};
    var _eSignDocuments = {};
    var _projectDetailsConfirmed = false;
    var _paymentInstructionsConfirmed = false;
    var _isFundingScheduled = false;
    var _stateMachineData = {};
    var _projectAdvanceDetails = {};

    return {
        getFundingRequestClosing: getFundingRequestClosing,
        getFundingRequestClosingPromise: getFundingRequestClosingPromise,
        setProjectDetails: setProjectDetails,
        getProjectDetails: getProjectDetails,
        setProjectDetailsConfirmed: setProjectDetailsConfirmed,
        getProjectDetailsConfirmed: getProjectDetailsConfirmed,
        setPaymentInstructions: setPaymentInstructions,
        getPaymentInstructions: getPaymentInstructions,
        getPaymentInstructionsConfirmed: getPaymentInstructionsConfirmed,
        getFundingRequest: getFundingRequest,
        getESignDocuments: getESignDocuments,
        getIsFundingScheduled: getIsFundingScheduled,
        confirmProjectComplete: confirmProjectComplete,
        confirmProjectDetails: confirmProjectDetails,
        confirmPaymentInstructions: confirmPaymentInstructions,
        submitProjectForFunding: submitProjectForFunding,
        assignAttachmentToConditions: assignAttachmentToConditions,
        getProjectAdvanceDetails: getProjectAdvanceDetails,
        commitAttachment: commitAttachment
    };

    function getFundingRequestClosing() {
        _stateMachineData = FRInformationFactory.getStateMachineData();

        _fundingRequestClosingPromise = $q(function (resolve) {
            FRInformationFactory.getFundingRequestInformationPromise().then(function () {
                // Once the fundingRequestInformationPromise has resolved, check whether closing information needs to be retrieved
                if (getClosingInfo(_stateMachineData) === true) {
                    // Closing information needs to be retrieved, wait for the funding request closing API call to finish and then resolve _fundingRequestClosingPromise
                    // Project Advance information also needs to be retrieved
                    resetFundingRequestClosing();
                    $http.get(HPConfig.heroProApi + 'Loan/FundingRequest/ProjectClosingInfo', { params: getFundingRequestClosingParams() }).then(function (response) {
                        setProjectDetails(_lodash2.default.omit(response.data.Data.ProjectDetails, 'FundingRequestId', 'LoanStateId'));
                        setProjectDetailsConfirmed();
                        setFundingRequest(_lodash2.default.omit(response.data.Data.FundingRequest, 'FundingRequestId'));
                        setPaymentInstructions(_lodash2.default.omit(response.data.Data.PaymentInstructions, 'FundingRequestId', 'LoanStateId'));
                        setPaymentInstructionsConfirmed();
                        setESignDocuments(response.data.Data.ESignDocuments);
                        setIsFundingScheduled();

                        _projectAdvanceDetails = response.data.Data.ProjectAdvance;

                        resolve();
                    });
                } else {
                    // Closing information does not need to be retrieved, reset local variables to defaults then resolve _fundingRequestClosingPromise
                    resetFundingRequestClosing();
                    resolve();
                }
            });
        });
        return _fundingRequestClosingPromise;
    }

    function getFundingRequestClosingPromise() {
        return _fundingRequestClosingPromise;
    }

    function resetFundingRequestClosing() {
        _projectDetails = {};
        _paymentInstructions = {};
        _fundingRequest = {};
        _eSignDocuments = {};
        _projectDetailsConfirmed = false;
        _paymentInstructionsConfirmed = false;
        _isFundingScheduled = false;
        _projectAdvanceDetails = {};
    }

    function getFundingRequestClosingParams() {
        return {
            FundingRequestId: $stateParams.appId,
            FilterByConditionTypeCategoryIds: 4,
            ExcludeClearedConditions: false,
            ExcludeWaivedConditions: true,
            IncludePremierTierData: true,
            // The following parameters can be toggled depending on what data is needed based on the state of the funding request
            includeProjectDetails: true,
            includePaymentDetails: true,
            includeConditions: true

        };
    }

    function setProjectDetails(newProjectDetails) {
        _lodash2.default.extend(_projectDetails, newProjectDetails);
    }

    function getProjectDetails() {
        return _projectDetails;
    }

    function setProjectDetailsConfirmed() {
        // NOTE: The right side of the OR clause is temporary. It can be removed once there are no more active loans that have been processed in COPO. - MS 1/15/16
        _projectDetailsConfirmed = !!_projectDetails.ProjectDetailsVerificationStatusId && _projectDetails.ProjectDetailsVerificationStatusId === 2 || _stateMachineData.CompletionCertificateStateId >= 4;
    }

    function getProjectDetailsConfirmed() {
        return _projectDetailsConfirmed;
    }

    function setPaymentInstructions(newPaymentInstructions) {
        _lodash2.default.extend(_paymentInstructions, newPaymentInstructions);
        var disbursements = _paymentInstructions.Disbursements || [];
        var newDisbursements = [{ PayeeType: 'Contractor', DisbursementAmount: 0 }, { PayeeType: 'Property Owner', DisbursementAmount: 0 }, { PayeeType: 'Other', DisbursementAmount: 0 }];
        var advancePayment = null;
        var defaultPayeeTypeId = getFundingRequest().FundingRequestDetail.DefaultPayeeTypeId;
        var fundingDisbursementModelTypeId = getFundingRequest().FundingRequestDetail.FundingDisbursementModelTypeId;
        var isDisbursementLocked = getFundingRequest().FundingRequestDetail.IsDisbursementLocked;

        // Look for any Advance Payment disbursements (CCDisbursementTypeId === 3)
        for (var i = 0; i < disbursements.length; i++) {
            if (disbursements[i].CCDisbursementTypeId === 3) {
                advancePayment = disbursements[i];
                break;
            }
        }

        // Check if there are any HERO Funding disbursements avaiable (CCDisbursementTypeId === 2)
        var heroDisbursements = _lodash2.default.filter(disbursements, function (disbursement) {
            return disbursement.CCDisbursementTypeId === 2;
        });

        if (heroDisbursements.length > 0) {
            // Use the HERO Funding disbursements returned from the server
            _lodash2.default.each(heroDisbursements, function (disbursement) {
                if (fundingDisbursementModelTypeId === 11) {
                    // Purchase PEFI - Always assign the disbursement to the contractor regardless of what the server returns
                    newDisbursements[0] = disbursement;
                    newDisbursements[0].PayeeType = 'Contractor';
                } else if (disbursement.PayeeType === 'Contractor') {
                    newDisbursements[0] = disbursement;
                    // If there is a contractor disbursement and an AP set their sum as the contractor disbursement amount
                    if (advancePayment !== null) {
                        newDisbursements[0].DisbursementAmount = newDisbursements[0].DisbursementAmount + advancePayment.DisbursementAmount;
                    }
                } else if (disbursement.PayeeType === 'Property Owner') {
                    newDisbursements[1] = disbursement;
                } else {
                    newDisbursements[2] = disbursement;
                }
            });
        } else {
            // Set disbursement defaults since no HERO Funding disbursements were returned from the server
            if (fundingDisbursementModelTypeId === 11) {
                // Purchase PEFI - Always set the default to contractor
                newDisbursements[0] = {
                    PayeeType: 'Contractor',
                    DisbursementAmount: _paymentInstructions.InitialRequested
                };
            } else if (defaultPayeeTypeId === 1) {
                newDisbursements[0] = {
                    PayeeType: 'Contractor',
                    DisbursementAmount: _paymentInstructions.InitialRequested
                };
            } else if (defaultPayeeTypeId === 2) {
                newDisbursements[2] = {
                    PayeeType: 'Other',
                    DisbursementAmount: _paymentInstructions.InitialRequested
                };
            }
        }

        _paymentInstructions.PremierTierDetail = getFundingRequest().PremierTierDetail;

        // If disbursements are locked, remove disbursements that have a value of 0
        if (isDisbursementLocked === true) {
            newDisbursements = _lodash2.default.reject(newDisbursements, function (disbursement) {
                return disbursement.DisbursementAmount === 0;
            });
        }

        _paymentInstructions.newDisbursements = newDisbursements;
        _paymentInstructions.advancePayment = advancePayment;

        // used to show deductions, this is for dealer fee CCDisbursement amount discrepancy before and after funding
        _paymentInstructions.isProjectFunded = FRInformationFactory.getStateMachineData().FundingRequestStateId === HPStateMachineConfig.FR.HERO_Funded || FRInformationFactory.getStateMachineData().FundingRequestStateId === HPStateMachineConfig.FR.HERO_Funding_Scheduled || FRInformationFactory.getStateMachineData().FundingRequestStateId === HPStateMachineConfig.FR.HLP_Completed || FRInformationFactory.getStateMachineData().FundingRequestStateId === HPStateMachineConfig.FR.HLP_Recording_Scheduled;
    }

    function getPaymentInstructions() {
        return _paymentInstructions;
    }

    function setPaymentInstructionsConfirmed() {
        // NOTE: The right side of the OR clause is temporary. It can be removed once there are no more active loans that have been processed in COPO. - MS 1/15/16
        _paymentInstructionsConfirmed = !!_paymentInstructions.PaymentVerificationStatusId && _paymentInstructions.PaymentVerificationStatusId === 2 || _stateMachineData.CompletionCertificateStateId >= 4;
    }

    function getPaymentInstructionsConfirmed() {
        return _paymentInstructionsConfirmed;
    }

    function setFundingRequest(newFundingRequest) {
        _lodash2.default.extend(_fundingRequest, newFundingRequest);
    }

    function getFundingRequest() {
        return _fundingRequest;
    }

    function setESignDocuments(newESignDocuments) {
        _lodash2.default.extend(_eSignDocuments, newESignDocuments);
    }

    function getESignDocuments() {
        return _eSignDocuments;
    }

    function getClosingInfo(stateMachineData) {
        // stateMachineData.LoanStateId === HPStateMachineConfig.Loan.Product_And_Price_Added ||
        return stateMachineData.FinDocsStateId === HPStateMachineConfig.FD.Fin_Docs_Created || stateMachineData.FinDocsStateId === HPStateMachineConfig.FD.Fin_Docs_Approved_By_CO || stateMachineData.FinDocsStateId === HPStateMachineConfig.FD.Fin_Docs_Emailed_To_PO || stateMachineData.FinDocsStateId === HPStateMachineConfig.FD.Fin_Docs_eSign_Initiated_By_PO || stateMachineData.FinDocsStateId === HPStateMachineConfig.FD.Fin_Docs_Signed_By_PO || stateMachineData.FinDocsStateId === HPStateMachineConfig.FD.Fin_Docs_Signed_By_All_PO || stateMachineData.FinDocsStateId === HPStateMachineConfig.FD.Issuer_Reviewed || stateMachineData.FinDocsStateId === HPStateMachineConfig.FD.Issuer_Countersigned || stateMachineData.LoanStateId === HPStateMachineConfig.Loan.Final || stateMachineData.PipelineStageId === HPPipelineStages.Closed.pipelineStageId;
    }

    function setIsFundingScheduled() {
        _isFundingScheduled = !!_fundingRequest && !!_fundingRequest.FundingRequestDetail && !!_fundingRequest.FundingRequestDetail.ScheduledDisbursementDate;
    }

    function getIsFundingScheduled() {
        return _isFundingScheduled;
    }

    function getProjectAdvanceDetails() {
        return _projectAdvanceDetails;
    }

    function confirmProjectComplete() {
        return $http({
            url: HPConfig.heroProApi + 'Loan/FundingRequest/ConfirmProjectComplete',
            method: 'POST',
            data: { FundingRequestId: $stateParams.appId }
        });
    }

    function confirmProjectDetails() {
        return $http({
            url: HPConfig.heroProApi + 'Loan/FundingRequest/ConfirmProjectDetails',
            method: 'POST',
            data: { FundingRequestId: $stateParams.appId }
        });
    }

    function confirmPaymentInstructions(params) {
        return $http({
            url: HPConfig.heroProApi + 'Loan/FundingRequest/ConfirmPaymentInstructions',
            method: 'POST',
            data: params
        });
    }

    function submitProjectForFunding(params) {
        return $http({
            url: HPConfig.heroProApi + 'Case/Create',
            method: 'POST',
            data: params
        });
    }

    function assignAttachmentToConditions(params) {
        return $http({
            url: HPConfig.heroProApi + 'Conditions/Attachment/Assign',
            method: 'POST',
            data: params
        });
    }

    function commitAttachment(params) {
        return $http({
            url: HPConfig.heroProApi + 'DocumentManagement/CommitAttachment/',
            method: 'POST',
            data: params
        });
    }
}

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = fundingRequestDisbursementsFactory;
fundingRequestDisbursementsFactory.$inject = ["HPConfig", "$http"];
// angular
//     .module("HeroPRO")
//     .factory("FRDisbursementsFactory", fundingRequestDisbursementsFactory);

/* @ngInject */
function fundingRequestDisbursementsFactory(HPConfig, $http) {
    return {
        getDisbursementStatusHistory: getDisbursementStatusHistory
    };

    function getDisbursementStatusHistory(params) {
        return $http.get(HPConfig.heroProApi + "Loan/Disbursements/StatusHistory", {
            params: params
        });
    }
}

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = fundingRequestDocumentsFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

fundingRequestDocumentsFactory.$inject = ['HPStateMachineConfig', '$q', 'FRInformationFactory', 'FRClosingFactory', 'HPConditionTypes']; // angular
//     .module("HeroPRO")
//     .factory("FRDocumentsFactory", fundingRequestDocumentsFactory);

/* @ngInject */
function fundingRequestDocumentsFactory(HPStateMachineConfig, $q, FRInformationFactory, FRClosingFactory, HPConditionTypes) {
    var _fundingRequestDocumentsPromise = void 0;
    var _completionCertificateRegenerated = false;
    var _appInfo = {};
    var _stateMachineData = {};
    var _fundingRequest = {};
    var _eSignDocumentsRaw = {}; // _eSignDocumentsRaw refers to the data objrvy returned from the server accessible via FRClosingFactory.getESignDocuments()
    var _invalidDocuments = [];
    var _otherDocuments = [];
    var _financialDocuments = [];
    var _eSignDocuments = []; // _eSignDocuments refers to the array of documents that need to be eSigned. This is dynamically contstructed from within this factory
    var _outstandingDocuments = [];
    var _CCDocument = null;
    var _ACADocument = null;
    var _signaturesButtonVisible = false;

    return {
        getFundingRequestDocuments: getFundingRequestDocuments,
        getFundingRequestDocumentsPromise: getFundingRequestDocumentsPromise,
        setCompletionCertificateRegenerated: setCompletionCertificateRegenerated,
        getCompletionCertificateRegenerated: getCompletionCertificateRegenerated,
        getInvalidDocuments: getInvalidDocuments,
        getOtherDocuments: getOtherDocuments,
        getFinancialDocuments: getFinancialDocuments,
        getESignDocuments: getESignDocuments,
        getCCDocument: getCCDocument,
        getACADocument: getACADocument,
        getSignaturesButtonVisibility: getSignaturesButtonVisibility,
        getOutstandingDocuments: getOutstandingDocuments
    };

    function getFundingRequestDocuments() {
        resetFundingRequestDocuments();
        _fundingRequestDocumentsPromise = $q(function (resolve) {
            // Before processing the documents, ensure that all async data that is needed is available
            $q.all([FRInformationFactory.getFundingRequestInformationPromise(), FRClosingFactory.getFundingRequestClosingPromise()]).then(function () {
                _appInfo = FRInformationFactory.getAppInfo();
                _stateMachineData = FRInformationFactory.getStateMachineData();
                _fundingRequest = FRClosingFactory.getFundingRequest();
                _eSignDocumentsRaw = FRClosingFactory.getESignDocuments();

                processACA();
                processCompletionCertificate();
                processOtherDocuments();
                processFinancialDocuments();
                setSignaturesButtonVisibility();
                processOutstandingDocuments();

                // Resolve the _fundingRequestDocumentsPromise now that all the documents have been processed
                resolve();
            });
        });

        return _fundingRequestDocumentsPromise;
    }

    function getFundingRequestDocumentsPromise() {
        return _fundingRequestDocumentsPromise;
    }

    function resetFundingRequestDocuments() {
        _completionCertificateRegenerated = false;
        _appInfo = {};
        _stateMachineData = {};
        _fundingRequest = {};
        _eSignDocumentsRaw = {};
        _invalidDocuments = [];
        _otherDocuments = [];
        _financialDocuments = [];
        _eSignDocuments = [];
        _outstandingDocuments = [];
        _CCDocument = null;
        _ACADocument = null;
        _signaturesButtonVisible = false;
    }

    function getInvalidDocuments() {
        return _invalidDocuments;
    }

    function getOtherDocuments() {
        return _otherDocuments;
    }

    function getFinancialDocuments() {
        return _financialDocuments;
    }

    function getESignDocuments() {
        return _eSignDocuments;
    }

    function getCCDocument() {
        return _CCDocument;
    }

    function getACADocument() {
        return _ACADocument;
    }

    function processOtherDocuments() {
        _lodash2.default.each(_fundingRequest.ConditionDetails, function (condition) {
            setLatestAttachment(condition);
            if (condition.ConditionTypeDetail.ConditionTypeId !== HPConditionTypes.CompletionCertificate) {
                if (conditionHasRejections(condition) === true && _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Closer_Rejected_Documents) {
                    _invalidDocuments.push(condition);
                } else {
                    _otherDocuments.push(condition);
                }
            }
        });

        // Flag the invoice/s
        _lodash2.default.each(_otherDocuments, function (document) {
            document.Invoice = !!(document.ConditionTypeDetail.ConditionTypeId === HPConditionTypes.Invoice || document.ConditionTypeDetail.ConditionTypeId === HPConditionTypes.HIC);
        });
    }

    function processFinancialDocuments() {
        if (!!FRInformationFactory.getFinancialDocuments().Documents) {
            _financialDocuments = FRInformationFactory.getFinancialDocuments().Documents;
        }
    }

    function processACA() {
        if (!!_appInfo.AssessmentContractAddendums && _appInfo.AssessmentContractAddendums.length > 0) {
            var pendingOrCompletedACAs = _lodash2.default.filter(_appInfo.AssessmentContractAddendums, function (document) {
                return (
                    // Take only Pending or Completed ACA's
                    document.AssessmentContractAddendumStatusId === 1 || document.AssessmentContractAddendumStatusId === 2
                );
            });
            if (pendingOrCompletedACAs.length !== 0) {
                _ACADocument = _lodash2.default.max(pendingOrCompletedACAs, function (document) {
                    return (
                        // Take the most recent ACA
                        Date.parse(document.CreatedDate)
                    );
                });

                _eSignDocuments[_eSignDocuments.length] = _ACADocument;
                _ACADocument.Description = 'Change Order';
                _ACADocument.ESignDocumentType = 'ACA';

                // Grab esign document envelope information if available
                if (!_eSignDocumentsRaw.AssesmentContractAddendum) {
                    _ACADocument.ESignDocumentEnvelope = null;
                } else {
                    _ACADocument.ESignDocumentEnvelope = _eSignDocumentsRaw.AssesmentContractAddendum;
                    _ACADocument.ESignDocumentEnvelope.EDocumentRecipients = _lodash2.default.filter(_ACADocument.ESignDocumentEnvelope.EDocumentRecipients, function (recipient) {
                        return !recipient.EDocumentRole;
                    });
                    setACADocumentStatus();
                }
            }
        }
    }

    function setACADocumentStatus() {
        _ACADocument.status = {};
        _ACADocument.status.numberOfPropertyOwners = _ACADocument.ESignDocumentEnvelope.EDocumentRecipients.length;
        _ACADocument.status.propertyOwnersSignatureStatus = _lodash2.default.defaults(_lodash2.default.countBy(_ACADocument.ESignDocumentEnvelope.EDocumentRecipients, function (recipient) {
            return recipient.EDocumentRecipientStatus === 5 ? 'signed' : 'unsigned';
        }), { signed: 0, unsigned: 0 });
        _ACADocument.status.eSigned = _ACADocument.status.numberOfPropertyOwners === _ACADocument.status.propertyOwnersSignatureStatus.signed;
        // ACA can be uploaded from OpsWeb, but not from HEROPro
        _ACADocument.status.ACAUploaded = _ACADocument.status.propertyOwnersSignatureStatus.signed === 0 && _stateMachineData.ACAStateId === HPStateMachineConfig.ACA.COG_Countersigned_ACA;
    }

    function processCompletionCertificate() {
        _CCDocument = _lodash2.default.find(_fundingRequest.ConditionDetails, function (condition) {
            return condition.ConditionTypeDetail.ConditionTypeId === HPConditionTypes.CompletionCertificate;
        });

        if (!!_CCDocument) {
            setLatestAttachment(_CCDocument);
            _CCDocument.ESignDocumentType = 'CC';

            if (conditionHasRejections(_CCDocument) === true && _stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Closer_Rejected_Documents) {
                _invalidDocuments.push(_CCDocument);
            } else {
                _eSignDocuments.push(_CCDocument);
            }
            // Grab esign document envelope information if available
            if (!_eSignDocumentsRaw.CompletionCertificate) {
                _CCDocument.ESignDocumentEnvelope = null;
            } else {
                _CCDocument.ESignDocumentEnvelope = _eSignDocumentsRaw.CompletionCertificate;
                _CCDocument.ESignDocumentEnvelope.EDocumentRecipients = _lodash2.default.filter(_CCDocument.ESignDocumentEnvelope.EDocumentRecipients, function (recipient) {
                    return !recipient.EDocumentRole;
                });
            }

            setCCDocumentStatus();
        } else {
            _CCDocument = null;
        }
    }

    function setCCDocumentStatus() {
        _CCDocument.status = {};
        _CCDocument.status.CCUploaded = false;

        if (_CCDocument.ESignDocumentEnvelope !== null) {
            _CCDocument.status.numberOfPropertyOwners = _CCDocument.ESignDocumentEnvelope.EDocumentRecipients.length;
            _CCDocument.status.propertyOwnersSignatureStatus = _lodash2.default.defaults(_lodash2.default.countBy(_CCDocument.ESignDocumentEnvelope.EDocumentRecipients, function (recipient) {
                return recipient.EDocumentRecipientStatus === 5 ? 'signed' : 'unsigned';
            }), { signed: 0, unsigned: 0 });
        }

        _CCDocument.status.eSigned = _stateMachineData.CompletionCertificateStateId === HPStateMachineConfig.CC.Completion_Cert_Uploaded_Or_eSigned;

        if (!!_CCDocument.AttachmentDetails && _CCDocument.AttachmentDetails.length > 0) {
            _CCDocument.status.CCUploaded = _lodash2.default.max(_CCDocument.AttachmentDetails, function (document) {
                return (
                    // Retrieve the most recent attachment
                    // Keep the === undefined here. ¯\_(ツ)_/¯
                    Date.parse(document.CreatedDate)
                );
            }).AttachmentDetail.ESigned === undefined;
        }
    }

    function setLatestAttachment(condition) {
        if (!!condition.AttachmentDetails && condition.AttachmentDetails.length > 0) {
            condition.LatestAttachment = _lodash2.default.max(condition.AttachmentDetails, function (attachment) {
                return Date.parse(attachment.CreatedDate);
            });
        } else {
            condition.LatestAttachment = undefined;
        }
    }

    function setSignaturesButtonVisibility() {
        var ACANeedsSignatures = _ACADocument !== null && _ACADocument.ESignDocumentEnvelope !== null && !_ACADocument.status.eSigned && !_ACADocument.status.ACAUploaded;

        var CCNeedsSignatures = _stateMachineData.CompletionCertificateStateId === HPStateMachineConfig.CC.CO_Signed_Completion_Cert || _stateMachineData.CompletionCertificateStateId === HPStateMachineConfig.CC.CO_Emailed_PO_Completion_Cert || _stateMachineData.CompletionCertificateStateId === HPStateMachineConfig.CC.Completion_Cert_Sent_To_Installer || _stateMachineData.CompletionCertificateStateId === HPStateMachineConfig.CC.PO_Initiated_Completion_Cert_eSign || _stateMachineData.CompletionCertificateStateId === HPStateMachineConfig.CC.PO_Completed_Completion_Cert_eSign;

        _signaturesButtonVisible = ACANeedsSignatures || CCNeedsSignatures;
    }

    function getSignaturesButtonVisibility() {
        return _signaturesButtonVisible;
    }

    function processOutstandingDocuments() {
        _lodash2.default.each(_otherDocuments, function (document) {
            if (!document.AttachmentDetails || document.AttachmentDetails.length == 0) {
                _outstandingDocuments[_outstandingDocuments.length] = document;
            }
        });
    }

    function getOutstandingDocuments() {
        return _outstandingDocuments;
    }

    function conditionHasRejections(condition) {
        return !!condition.LatestAttachment && !!condition.LatestAttachment.RejectionDetails && condition.LatestAttachment.RejectionDetails.length > 0;
    }

    function setCompletionCertificateRegenerated(newValue) {
        _completionCertificateRegenerated = newValue;
    }

    function getCompletionCertificateRegenerated() {
        return _completionCertificateRegenerated;
    }
}

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = fundingRequestInformationFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

fundingRequestInformationFactory.$inject = ['HPConfig', 'DealTypeFactory', '$http', '$q', '$stateParams']; // angular
//   .module('HeroPRO')
//   .factory('FRInformationFactory', fundingRequestInformationFactory);

/* @ngInject */
function fundingRequestInformationFactory(HPConfig, DealTypeFactory, $http, $q, $stateParams) {
    var _fundingRequestInformationPromise = void 0;
    var _stateMachineData = {};
    var _appInfo = {};
    var _financialDocuments = {};
    var _planInformation = {};

    return {
        getFundingRequestInformation: getFundingRequestInformation,
        getFundingRequestInformationPromise: getFundingRequestInformationPromise,
        getPlanInformation: getPlanInformation,
        getPlanInformationData: getPlanInformationData,
        getAppInfo: getAppInfo,
        getFinancialDocuments: getFinancialDocuments,
        getStateMachineData: getStateMachineData,
        setStateMachineData: setStateMachineData,
        setPlanTermData: setPlanTermData,
        getRequiredDocGenSetType: getRequiredDocGenSetType
    };

    function getRequiredDocGenSetType() {
        return $http.get(HPConfig.heroProApi + 'Loan/FundingRequest/RequiredDocGenSetType?FundingRequestId=' + $stateParams.appId).then(function (response) {
            return response.data.Data;
        });
    }

    function getFundingRequestInformation() {
        resetFundingRequestInformation();
        _fundingRequestInformationPromise = $q(function (resolve) {
            $http.get(HPConfig.heroProApi + 'Loan/FundingRequest/Pipeline/' + $stateParams.appId).then(function (response) {
                setAppInfo(response.data.Data.AppDetail);
                setDealType(response.data.Data.AppDetail);
                setStateMachineData(_appInfo.PipelineStageId, _appInfo.FundingRequestPipelineStageId, _appInfo.LoanStateId, _appInfo.FundingRequestStateId, _appInfo.CompletionCertificateStateId, getACAStateId(), _appInfo.FinDocsStateId);
                _financialDocuments = response.data.Data.FinancialDocuments;
                resolve();
            });
        });
        return _fundingRequestInformationPromise;
    }

    function getFundingRequestInformationPromise() {
        return _fundingRequestInformationPromise;
    }

    function resetFundingRequestInformation() {
        _stateMachineData = {};
        _appInfo = {};
        _financialDocuments = {};
    }

    function getPlanInformation() {
        var params = {
            planId: _appInfo.PlanId,
            planTermSetId: _appInfo.PlanTermSetId,
            termSetId: _appInfo.TermSetId
        };

        return $http.get(HPConfig.heroProApi + 'Plan', { params: params }).then(function (response) {
            setPlanInformation(response.data.Data);
        });
    }

    function setPlanInformation(data) {
        _planInformation = data;
    }

    function getPlanInformationData() {
        return _planInformation;
    }

    function setAppInfo(data) {
        _appInfo = data;
        _appInfo.isCountersigned = _appInfo.CountersignedDate !== undefined && _appInfo.CountersignedDate !== null && _appInfo.CountersignedDate !== '';
        _appInfo.isIssuerReviewed = _appInfo.IssuerReviewedDate !== undefined && _appInfo.IssuerReviewedDate !== null && _appInfo.IssuerReviewedDate !== '';
        _appInfo.isNTPSent = _appInfo.NoticeToProceedSentDate !== undefined && _appInfo.NoticeToProceedSentDate !== null && _appInfo.NoticeToProceedSentDate !== '';
        _appInfo.isNTPLate = _appInfo.IsNoticeToProceedLate !== undefined ? _appInfo.IsNoticeToProceedLate : false;
    }

    function setDealType(data) {
        DealTypeFactory.setSelectedDealType(data.DealType);
    }

    function getAppInfo() {
        return _appInfo;
    }

    function setStateMachineData(newPipelineStageId, newFundingRequestPipelineStageId, newLoanStateId, newFundingRequestStateId, newCompletionCertificateStateId, newACAStateId, newFinDocsStateId) {
        _stateMachineData.PipelineStageId = newPipelineStageId;
        _stateMachineData.LoanStateId = newLoanStateId;

        if (newFundingRequestPipelineStageId !== undefined) {
            _stateMachineData.FundingRequestPipelineStageId = newFundingRequestPipelineStageId;
        }
        if (newFundingRequestStateId !== undefined) {
            _stateMachineData.FundingRequestStateId = newFundingRequestStateId;
        }
        if (newCompletionCertificateStateId !== undefined) {
            _stateMachineData.CompletionCertificateStateId = newCompletionCertificateStateId;
        }
        if (newACAStateId !== undefined) {
            _stateMachineData.ACAStateId = newACAStateId;
        }
        if (newFinDocsStateId !== undefined) {
            _stateMachineData.FinDocsStateId = newFinDocsStateId;
        }
    }

    function getStateMachineData() {
        return _stateMachineData;
    }

    function getACAStateId() {
        return !!_appInfo.AssessmentContractAddendums && _appInfo.AssessmentContractAddendums.length > 0 ? _lodash2.default.max(_appInfo.AssessmentContractAddendums, function (addendum) {
            return (
                // Take the most recent ACA
                Date.parse(addendum.CreatedDate)
            );
        }).AssessmentContractAddendumStateId : 0;
    }

    function getFinancialDocuments() {
        return _financialDocuments;
    }

    function setPlanTermData(newPlanTermData) {
        _appInfo.PlanId = newPlanTermData.PlanId;
        _appInfo.PlanTermSetId = newPlanTermData.PlanTermSetId;
        _appInfo.TermSetId = newPlanTermData.TermSetId;
    }
}

/***/ }),
/* 697 */
/***/ (function(module, exports) {

module.exports = "<div class=\"app-detail-container\">\n    <primary-information pi-information-type=\"fundingRequest\" text=\"fundingRequest\"  pi-set-fixed-height=\"{{appDetail.primaryInformationSticky}}\" ui-scrollpoint ui-scrollpoint-enabled=\"{{appDetail.primaryInformationLoading === false}}\" ui-scrollpoint-action=\"appDetail.scrollPointTriggered\">\n    </primary-information>\n\n    <div class=\"app-detail-content\">\n        <hp-pipeline-stage-indicator></hp-pipeline-stage-indicator>\n\n\t\t<div ng-include=\"'app/appDetail/walkthrough/walkthrough.html'\"></div>\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-12\">\n\t\t\t\t<div id=\"project-information-container\" class=\"hp-module\">\n                    <div id=\"project-history-container\" class=\"row hp-inner\" ng-if=\"appDetail.primaryInformationLoading === false\">\n                        <div class=\"col-md-12 text-right\">\n                            <div class=\"project-history-link-container\" ng-click=\"appDetail.openProjectHistoryModal()\">\n                                <span class=\"icon icon-history-thick\"></span>\n                                <span id=\"project-history-link\" class=\"link\">View Project History</span>\n                            </div>\n                        </div>\n                    </div>\n\t\t\t\t\t<div id=\"project-details-container\" class=\"row hp-inner\">\n\t\t\t\t\t\t<div class=\"col-md-6\">\n\t\t\t\t\t\t\t<div ng-include=\"'app/appDetail/projectInformation/projectInformation.html'\" ng-controller=\"ProjectInformationController as projectInformation\"></div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"col-md-6\" ng-controller=\"FundingDocumentsController as fundingDocuments\">\n\t\t\t\t\t\t\t<div ng-include=\"'app/appDetail/documents/fundingDocumentsTemplate.html'\" id=\"funding-documents\" ng-if=\"fundingDocuments.isLoaded === true\"></div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t    </div>\n\t\t</div>\n    </div><!-- app-detail-content -->\n</div><!-- app-detail-container -->\n";

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _modalService = __webpack_require__(699);

var _modalService2 = _interopRequireDefault(_modalService);

var _confirmLeaveController = __webpack_require__(701);

var _confirmLeaveController2 = _interopRequireDefault(_confirmLeaveController);

var _ConfirmLeaveFactory = __webpack_require__(702);

var _ConfirmLeaveFactory2 = _interopRequireDefault(_ConfirmLeaveFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.modals', []).controller('ConfirmLeaveController', _confirmLeaveController2.default).service('ModalService', _modalService2.default).factory('ConfirmLeaveFactory', _ConfirmLeaveFactory2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/modals/confirmLeave/confirmLeave.html', __webpack_require__(703)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

__webpack_require__(700);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* @ngInject */
var ModalService = function () {
    function ModalService($uibModal, $window, $document, HPConfig) {
        _classCallCheck(this, ModalService);

        this.$document = $document;
        this.$window = $window;
        this.HPConfig = HPConfig;
        this.$uibModal = $uibModal;
        this.lgModal = null;
        this.filterModal = null;
        this.scrollX = null;
        this.scrollY = null;
    }

    _createClass(ModalService, [{
        key: 'getLgModal',
        value: function getLgModal() {
            return this.lgModal;
        }
    }, {
        key: 'launchLgModal',
        value: function launchLgModal(params) {
            var _this = this;

            this.lgModal = this.$uibModal.open({
                templateUrl: params.templateUrl,
                windowClass: params.windowClass,
                controller: params.controller,
                controllerAs: params.controllerAs,
                size: params.size || 'lg',
                keyboard: true,
                animation: false,
                resolve: params.resolve
            });

            // Once the modal has been rendered, set the body of the page to position: fixed
            // and store the x and y scroll values
            this.lgModal.rendered.then(function () {
                if (_this.$window.innerWidth < _this.HPConfig.screenSizes.screen_md) {
                    _this.scrollX = _this.$window.pageXOffset;
                    _this.scrollY = _this.$window.pageYOffset;
                    _angular2.default.element(_this.$document[0].body).addClass('fixed-body');
                }
            });

            // Before the modal is closed, set the body of the page to position: static
            // and scroll the page back to the x and y scroll values before the modal was opened
            this.lgModal.result.then(function () {
                if (_this.$window.innerWidth < _this.HPConfig.screenSizes.screen_md) {
                    _angular2.default.element(_this.$document[0].body).removeClass('fixed-body');
                    _this.$window.scroll(_this.scrollX, _this.scrollY);
                }
            });

            return this.lgModal;
        }
    }, {
        key: 'closeLgModal',
        value: function closeLgModal() {
            if (this.lgModal) {
                this.lgModal.close();
                this.lgModal = null;
            }
        }
    }, {
        key: 'getPipelineFilterModal',
        value: function getPipelineFilterModal() {
            return this.filterModal;
        }
    }, {
        key: 'launchPipelineFilterModal',
        value: function launchPipelineFilterModal(params) {
            this.filterModal = this.$uibModal.open({
                templateUrl: params.templateUrl,
                windowClass: params.windowClass,
                controller: params.controller,
                controllerAs: params.controllerAs,
                size: 'lg',
                keyboard: true,
                animation: false
            });
        }
    }]);

    return ModalService;
}();

ModalService.$inject = ['$uibModal', '$window', '$document', 'HPConfig'];
exports.default = ModalService;

/***/ }),
/* 700 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ConfirmLeaveController;
ConfirmLeaveController.$inject = ['_$event', '$uibModalInstance', 'cancelLocationChange', '$location'];
// angular
//   .module("HeroPRO")
//   .controller("ConfirmLeaveController", ConfirmLeaveController);

/* @ngInject */
function ConfirmLeaveController(_$event, $uibModalInstance, cancelLocationChange, $location) {
    var vm = this;

    vm.switch = function () {
        $location.path('/');
        $uibModalInstance.close();
    };

    vm.cancel = function () {
        cancelLocationChange();
        $uibModalInstance.close();
    };
}

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ConfirmLeaveFactory;
ConfirmLeaveFactory.$inject = ['$uibModal'];
// angular
//     .module("HeroPRO")
//     .factory("ConfirmLeaveFactory", ConfirmLeaveFactory);

/* @ngInject */
function ConfirmLeaveFactory($uibModal) {
    return function ($event, loc, _cancelLocationChange) {
        $uibModal.open({
            templateUrl: 'app/modals/confirmLeave/confirmLeave.html',
            controller: 'ConfirmLeaveController',
            controllerAs: 'confirmLeave',
            backdrop: 'static',
            keyboard: false,
            animation: false,
            resolve: {
                _$event: function _$event() {
                    return $event;
                },
                cancelLocationChange: function cancelLocationChange() {
                    return _cancelLocationChange;
                }
            }
        });
    };
}

/***/ }),
/* 703 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <!--<h3>You are leaving this page</h3>-->\n    <span class=\"icon icon-delete-circle\" ng-click=\"confirmLeave.cancel();\"></span>\n</div>\n<div class=\"modal-body\">\n    <p class=\"text-center\">If you switch offices, you will not be able to see this application.</p>\n    <p class=\"text-center\">Are you sure you want to change locations?</p>\n</div>\n<div class=\"modal-footer\">\n    <div class=\"text-center\">\n    <button ng-click=\"confirmLeave.switch();\" class=\"btn btn-primary\">Switch</button>\n    <button ng-click=\"confirmLeave.cancel();\" class=\"btn btn-default\">Cancel</button>\n    </div>\n</div>\n";

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _modal = __webpack_require__(705);

var _modal2 = _interopRequireDefault(_modal);

var _notificationFactory = __webpack_require__(792);

var _notificationFactory2 = _interopRequireDefault(_notificationFactory);

var _notificationUtilityFactory = __webpack_require__(793);

var _notificationUtilityFactory2 = _interopRequireDefault(_notificationUtilityFactory);

var _notificationFooterController = __webpack_require__(794);

var _notificationFooterController2 = _interopRequireDefault(_notificationFooterController);

var _notificationFooterDirective = __webpack_require__(796);

var _notificationFooterDirective2 = _interopRequireDefault(_notificationFooterDirective);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.notificationCenter', [_modal2.default]).controller('NotificationFooterController', _notificationFooterController2.default).factory('NotificationCenterFactory', _notificationFactory2.default).factory('NotificationUtility', _notificationUtilityFactory2.default).directive('hpNotificationFooter', _notificationFooterDirective2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/notificationCenter/footer/notificationFooter.html', __webpack_require__(797)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _notificationMenu = __webpack_require__(706);

var _notificationMenu2 = _interopRequireDefault(_notificationMenu);

var _templates = __webpack_require__(711);

var _templates2 = _interopRequireDefault(_templates);

var _training = __webpack_require__(748);

var _training2 = _interopRequireDefault(_training);

var _notificationModalController = __webpack_require__(788);

var _notificationModalController2 = _interopRequireDefault(_notificationModalController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.notificationCenter.modal', [_notificationMenu2.default, _templates2.default, _training2.default]).controller('NotificationModalController', _notificationModalController2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/notificationCenter/modal/notificationModal.html', __webpack_require__(791)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _notificationMenuController = __webpack_require__(707);

var _notificationMenuController2 = _interopRequireDefault(_notificationMenuController);

var _notificationMenuDirective = __webpack_require__(709);

var _notificationMenuDirective2 = _interopRequireDefault(_notificationMenuDirective);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.notificationCenter.modal.notificationMenu', []).controller('NotificationMenuController', _notificationMenuController2.default).directive('hpNotificationMenu', _notificationMenuDirective2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/notificationCenter/modal/notificationMenu/notificationMenu.html', __webpack_require__(710)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
   value: true
});
exports.default = notificationMenuController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(708);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

notificationMenuController.$inject = ['$scope', 'NotificationCenterFactory']; // angular
// 	.module("HeroPRO")
// 	.controller("NotificationMenuController", notificationMenuController);

/* @ngInject */
function notificationMenuController($scope, NotificationCenterFactory) {
   var vm = this;

   vm.menuHeader = 'Looks like we need your...';
   vm.toggleClicked = false;

   init();

   /*= =======================================
   =            Public Functions            =
   ======================================== */

   vm.menuItemOnClick = function (notification) {
      var currentNotification = NotificationCenterFactory.getActiveNotification();
      if (currentNotification.CanBeDismissedByUser === false) {
         return;
      }

      if (notification.isComplete !== true) {
         _lodash2.default.each(vm.notifications, function (notification) {
            if (notification.isActive === true) {
               notification.isActive = false;
            }
         });
         notification.isActive = true;
      }

      //NotificationCenterFactory.setActiveTemplate(notification.template);
      NotificationCenterFactory.setActiveNotification(notification);
      $scope.$emit("notificationsMenuClick");
   };

   vm.toggle = function () {
      vm.toggleClicked = !vm.toggleClicked;
      $scope.$emit('notificationMenuToggleClick', { toggleClicked: vm.toggleClicked });
   };

   /* -----  End of Public Functions  ------*/

   /*= ========================================
   =            Private Functions            =
   ========================================= */

   function init() {}

   /* -----  End of Private Functions  ------*/

   /*= ========================================
   =            Pub/Sub Handlers            =
   ========================================= */

   /* -----  End of Pub/Sub Handlers  ------*/
}

/***/ }),
/* 708 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = notificationMenuDirective;
// angular
// 	.module("HeroPRO")
// 	.directive('hpNotificationMenu', notificationMenuDirective);

function notificationMenuDirective() {
    return {
        restrict: 'E',
        controller: 'NotificationMenuController',
        controllerAs: 'notificationMenu',
        bindToController: true,
        scope: {
            notifications: '='
        },
        templateUrl: 'app/notificationCenter/modal/notificationMenu/notificationMenu.html',
        link: link
    };

    function link() {}
}

/***/ }),
/* 710 */
/***/ (function(module, exports) {

module.exports = "<div class=\"notifications-menu-container\">\n    <div class=\"notification-menu-header\">\n        <div class=\"renovate-header-container\">\n            <button class=\"navbar-toggle\" ng-click=\"notificationMenu.toggle();\" ng-if=\"false\">\n                <span class=\"icon-bar\"></span>\n                <span class=\"icon-bar\"></span>\n                <span class=\"icon-bar\"></span>\n            </button>\n            <div class=\"renovate-header\"></div>\n            <div class=\"close-space\"></div>\n        </div>\n        <span ng-hide=\"true\" ng-bind=\"notificationMenu.menuHeader\"></span>\n    </div>\n    <div class=\"notification-menu-item-container\" ng-class=\"{'collapsed': !notificationMenu.toggleClicked }\">\n        <div class=\"notification-menu-item\" ng-repeat=\"notification in notificationMenu.notifications\"\n            ng-click=\"notificationMenu.menuItemOnClick(notification)\"\n             ng-class=\"{'active': notification.isActive === true}\" id=\"notificationItem{{$index + 1}}\">\n            <div class=\"notification-circle\" ng-class=\"{'complete' : notification.isComplete === true}\"></div>\n            <span class=\"icon icon-checkmark-thick\" ng-if=\"notification.isComplete === true\"></span>\n            <span class=\"notification-menu-text\" ng-class=\"{'complete' : notification.isComplete === true}\" ng-bind=\"notification.Message\"></span>\n            <div class=\"notification-menu-completed\" ng-if=\"notification.isComplete === true\">Completed</div>\n\n        </div>\n    </div>\n\n</div>\n";

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _advancedRegistration = __webpack_require__(712);

var _advancedRegistration2 = _interopRequireDefault(_advancedRegistration);

var _addBankInfoController = __webpack_require__(732);

var _addBankInfoController2 = _interopRequireDefault(_addBankInfoController);

var _termsSignController = __webpack_require__(733);

var _termsSignController2 = _interopRequireDefault(_termsSignController);

var _pccController = __webpack_require__(735);

var _pccController2 = _interopRequireDefault(_pccController);

__webpack_require__(737);

__webpack_require__(738);

var _hisCodeOfConduct = __webpack_require__(739);

var _hisCodeOfConduct2 = _interopRequireDefault(_hisCodeOfConduct);

var _accounts = __webpack_require__(77);

var _accounts2 = _interopRequireDefault(_accounts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// no controller
exports.default = _angular2.default.module('app.notificationCenter.modal.templates', [_advancedRegistration2.default, _accounts2.default]).controller('AddBankInfoController', _addBankInfoController2.default).controller('HISCodeOfConductController', _hisCodeOfConduct2.default).controller('TermsSignController', _termsSignController2.default).controller('PCCController', _pccController2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/notificationCenter/modal/templates/addBankInfo/addBankInfo.html', __webpack_require__(741)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/templates/territoryUpdate/territoryUpdate.html', __webpack_require__(742)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/templates/territoryUpdate/territoryUpdateLAC.html', __webpack_require__(743)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/templates/termsSign/termsSign.html', __webpack_require__(744)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/templates/hisCodeOfConduct/hisCodeOfConduct.html', __webpack_require__(745)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/templates/contractorCSLB/contractorCSLB.html', __webpack_require__(746)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/templates/pcc/pcc.html', __webpack_require__(747)); // eslint-disable-line global-require        
}]).name; // no controller

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _advancedRegistrationModalController = __webpack_require__(713);

var _advancedRegistrationModalController2 = _interopRequireDefault(_advancedRegistrationModalController);

var _advancedRegistrationFactory = __webpack_require__(715);

var _advancedRegistrationFactory2 = _interopRequireDefault(_advancedRegistrationFactory);

var _personalInfoController = __webpack_require__(716);

var _personalInfoController2 = _interopRequireDefault(_personalInfoController);

var _questionsController = __webpack_require__(718);

var _questionsController2 = _interopRequireDefault(_questionsController);

var _successController = __webpack_require__(720);

var _successController2 = _interopRequireDefault(_successController);

var _uploadIdController = __webpack_require__(722);

var _uploadIdController2 = _interopRequireDefault(_uploadIdController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.notificationCenter.modal.templates.advancedRegistration', []).controller('AdvancedRegistrationModalController', _advancedRegistrationModalController2.default).controller('PersonalInfoController', _personalInfoController2.default).controller('QuestionsController', _questionsController2.default).controller('SuccessController', _successController2.default).controller('UploadIdController', _uploadIdController2.default).factory('AdvancedRegistrationFactory', _advancedRegistrationFactory2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/notificationCenter/modal/templates/advancedRegistration/advancedRegistration.html', __webpack_require__(724)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/templates/advancedRegistration/emailUs/emailUs.html', __webpack_require__(725)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/templates/advancedRegistration/emailUs/banned.html', __webpack_require__(726)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/templates/advancedRegistration/personalInfo/personalInfo.html', __webpack_require__(727)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/templates/advancedRegistration/questions/questions.html', __webpack_require__(728)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/templates/advancedRegistration/success/success.html', __webpack_require__(729)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/templates/advancedRegistration/tryAgain/tryAgain.html', __webpack_require__(730)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/templates/advancedRegistration/uploadId/uploadId.html', __webpack_require__(731)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = AdvancedRegistrationModalController;

__webpack_require__(714);

AdvancedRegistrationModalController.$inject = ['AdvancedRegistrationFactory']; // angular
// 	.module("HeroPRO")
// 	.controller("AdvancedRegistrationModalController", advancedRegistrationModalController);


/* @ngInject */
function AdvancedRegistrationModalController(AdvancedRegistrationFactory) {
    var vm = this;
    var pages = [];

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.setVisiblePages = function (activePages) {
        setVisiblePages(activePages);
    };

    vm.isPageVisible = function (page) {
        return pages[page] !== undefined && pages[page].visible === true;
    };
    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */
    function init() {
        pages = AdvancedRegistrationFactory.getPages();
        setVisiblePages();
    }

    function setVisiblePages(pages) {
        if (pages === undefined || pages.length === 0) {
            AdvancedRegistrationFactory.setVisiblePages(['personalInfo']);
        } else {
            AdvancedRegistrationFactory.setVisiblePages(pages);
        }
    }
    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 714 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = AdvancedRegistrationFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

AdvancedRegistrationFactory.$inject = ['$q', '$http', 'HPConfig']; // angular
//   .module('HeroPRO')
//   .factory('AdvancedRegistrationFactory', advancedRegistrationFactory);

/* @ngInject */
function AdvancedRegistrationFactory($q, $http, HPConfig) {
    var _personalInfo = {};
    var _personIdentityId = null;
    var _contractorUserId = null;
    var _idNumber = null;
    var _questions = [];
    var _pages = {
        personalInfo: {
            visible: false
        },
        tryAgain: {
            visible: false
        },
        questions: {
            visible: false
        },
        emailUs: {
            visible: false
        },
        uploadId: {
            visible: false
        },
        success: {
            visible: false
        },
        banned: {
            visible: false
        }
    };

    return {
        getPages: getPages,
        setVisiblePages: setVisiblePages,
        getStates: getStates,
        attempAutoIDV: attempAutoIDV,
        completeAdvancedRegistration: completeAdvancedRegistration,
        getPersonalInfo: getPersonalInfo,
        setPersonalInfo: setPersonalInfo,
        getPersonIdentityId: getPersonIdentityId,
        setPersonIdentityId: setPersonIdentityId,
        getContractorUserId: getContractorUserId,
        setContractorUserId: setContractorUserId,
        getIdNumber: getIdNumber,
        setIdNumber: setIdNumber,
        getQuestions: getQuestions,
        setQuestions: setQuestions,
        commitIDUpload: commitIDUpload,
        completeAdvancedRegActionItem: completeAdvancedRegActionItem
    };

    function getPages() {
        return _pages;
    }

    // visiblePages: array of strings, names of pages
    function setVisiblePages(visiblePages) {
        // Sets visible=false for all pages except for those passed in
        _lodash2.default.each(_pages, function (page, pageKey) {
            var pageFound = _lodash2.default.find(visiblePages, function (visiblePage) {
                return pageKey === visiblePage;
            });
            page.visible = pageFound !== undefined;
        });
    }

    function attempAutoIDV(params) {
        return $http.post(HPConfig.heroProApi + 'identity/questions', params).then(function (response) {
            return response;
        });
    }

    function completeAdvancedRegistration(params) {
        return $http.post(HPConfig.heroProApi + 'ContractorUser/CompleteAdvancedRegistration', params).then(function (response) {
            return response;
        });
    }

    function commitIDUpload(params) {
        return $http.post(HPConfig.heroProApi + 'DocumentManagement/CommitPhotoUploadContractorUser', params).then(function (response) {
            return response;
        });
    }

    function getPersonalInfo() {
        return _personalInfo;
    }

    function setPersonalInfo(newPersonalInfo) {
        _personalInfo = newPersonalInfo;
    }

    function getPersonIdentityId() {
        return _personIdentityId;
    }

    function setPersonIdentityId(newPersonIdentityId) {
        _personIdentityId = newPersonIdentityId;
    }

    function getContractorUserId() {
        return _contractorUserId;
    }

    function setContractorUserId(newContractorUserId) {
        _contractorUserId = newContractorUserId;
    }

    function getIdNumber() {
        return _idNumber;
    }

    function setIdNumber(newIdNumber) {
        _idNumber = newIdNumber;
    }

    function getQuestions() {
        return _questions;
    }

    function setQuestions(newQuestions) {
        _questions = newQuestions;
    }

    function completeAdvancedRegActionItem(params) {
        return $http.post(HPConfig.heroProApi + 'ActionItem/CompleteContractorUserActionItem', params).then(function (response) {
            return response;
        });
    }

    function getStates() {
        var deferred = $q.defer();
        var states = [{ StateAbbreviation: 'AL', Name: 'Alabama' }, { StateAbbreviation: 'AK', Name: 'Alaska' }, { StateAbbreviation: 'AZ', Name: 'Arizona' }, { StateAbbreviation: 'AR', Name: 'Arkansas' }, { StateAbbreviation: 'CA', Name: 'California' }, { StateAbbreviation: 'CO', Name: 'Colorado' }, { StateAbbreviation: 'CT', Name: 'Connecticut' }, { StateAbbreviation: 'DE', Name: 'Delaware' }, { StateAbbreviation: 'DC', Name: 'District Of Columbia' }, { StateAbbreviation: 'FL', Name: 'Florida' }, { StateAbbreviation: 'GA', Name: 'Georgia' }, { StateAbbreviation: 'HI', Name: 'Hawaii' }, { StateAbbreviation: 'ID', Name: 'Idaho' }, { StateAbbreviation: 'IL', Name: 'Illinois' }, { StateAbbreviation: 'IN', Name: 'Indiana' }, { StateAbbreviation: 'IA', Name: 'Iowa' }, { StateAbbreviation: 'KS', Name: 'Kansas' }, { StateAbbreviation: 'KY', Name: 'Kentucky' }, { StateAbbreviation: 'LA', Name: 'Louisiana' }, { StateAbbreviation: 'ME', Name: 'Maine' }, { StateAbbreviation: 'MD', Name: 'Maryland' }, { StateAbbreviation: 'MA', Name: 'Massachusetts' }, { StateAbbreviation: 'MI', Name: 'Michigan' }, { StateAbbreviation: 'MN', Name: 'Minnesota' }, { StateAbbreviation: 'MS', Name: 'Mississippi' }, { StateAbbreviation: 'MO', Name: 'Missouri' }, { StateAbbreviation: 'MT', Name: 'Montana' }, { StateAbbreviation: 'NE', Name: 'Nebraska' }, { StateAbbreviation: 'NV', Name: 'Nevada' }, { StateAbbreviation: 'NH', Name: 'New Hampshire' }, { StateAbbreviation: 'NJ', Name: 'New Jersey' }, { StateAbbreviation: 'NM', Name: 'New Mexico' }, { StateAbbreviation: 'NY', Name: 'New York' }, { StateAbbreviation: 'NC', Name: 'North Carolina' }, { StateAbbreviation: 'ND', Name: 'North Dakota' }, { StateAbbreviation: 'OH', Name: 'Ohio' }, { StateAbbreviation: 'OK', Name: 'Oklahoma' }, { StateAbbreviation: 'OR', Name: 'Oregon' }, { StateAbbreviation: 'PA', Name: 'Pennsylvania' }, { StateAbbreviation: 'RI', Name: 'Rhode Island' }, { StateAbbreviation: 'SC', Name: 'South Carolina' }, { StateAbbreviation: 'SD', Name: 'South Dakota' }, { StateAbbreviation: 'TN', Name: 'Tennessee' }, { StateAbbreviation: 'TX', Name: 'Texas' }, { StateAbbreviation: 'UT', Name: 'Utah' }, { StateAbbreviation: 'VT', Name: 'Vermont' }, { StateAbbreviation: 'VA', Name: 'Virginia' }, { StateAbbreviation: 'WA', Name: 'Washington' }, { StateAbbreviation: 'WV', Name: 'West Virginia' }, { StateAbbreviation: 'WI', Name: 'Wisconsin' }, { StateAbbreviation: 'WY', Name: 'Wyoming' }, { StateAbbreviation: 'AS', Name: 'American Samoa' }, { StateAbbreviation: 'GU', Name: 'Guam' }, { StateAbbreviation: 'PR', Name: 'Puerto Rico' }, { StateAbbreviation: 'VI', Name: 'Virgin Islands' }];

        deferred.resolve(states);
        return deferred.promise;
    }
}

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = personalInfoController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(717);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

personalInfoController.$inject = ['AdvancedRegistrationFactory', 'UserData', 'AccountsFactory', 'raSpinnerService']; // angular
// .module("HeroPRO")
// .controller("PersonalInfoController", personalInfoController);

/* @ngInject */
function personalInfoController(AdvancedRegistrationFactory, UserData, AccountsFactory, raSpinnerService) {
  var vm = this;

  vm.globalError = 'Please complete all required fields before proceeding.';
  vm.ownerFirstName = null;
  vm.ownerLastName = null;
  vm.ownerDOB = null;
  vm.ownerDOBMonth = null;
  vm.ownerDOBDay = null;
  vm.ownerDOBYear = null;
  vm.ownerCityName = null;
  vm.ownerPhone = null;
  vm.ownerSSN = null;
  vm.ownerAddress1 = null;
  vm.ownerState = null;
  vm.ownerZipcode = null;
  vm.isStateOpen = false;
  vm.states = null;
  vm.ownerEmail = null;
  vm.loading = false;

  var savedPersonalInfo = null;

  init();

  /*= =======================================
  =            Public Functions            =
  ======================================== */
  vm.validateDob = function () {
    if (!isValidDate(vm.ownerDOB)) {
      vm.ownerInfoForm.ownerDob.$setValidity('invalidDate', false);
    } else {
      vm.ownerInfoForm.ownerDob.$setValidity('invalidDate', true);
      processDOB();

      if (!isDate18orMoreYearsOld(vm.ownerDOBDay, vm.ownerDOBMonth, vm.ownerDOBYear)) {
        vm.ownerInfoForm.ownerDob.$setValidity('underAge', false);
      } else {
        vm.ownerInfoForm.ownerDob.$setValidity('underAge', true);
      }
    }
  };

  vm.numbersOnly = function (evt) {
    var isNumber = numbersOnly(evt);

    if (!isNumber) {
      evt.preventDefault();
    }
  };

  vm.submitForm = function (isValid) {
    if (isValid) {
      vm.loading = true;
      processDOB();
      savePersonalInfo();

      var params = {
        IdVerifyInfo: {
          FirstName: vm.ownerFirstName,
          LastName: vm.ownerLastName,
          Address: vm.ownerAddress1,
          City: vm.ownerCityName,
          State: vm.ownerState,
          Zip: vm.ownerZipcode,
          SsnLast4: vm.ownerSSN,
          DobDay: vm.ownerDOBDay,
          DobMonth: vm.ownerDOBMonth,
          DobYear: vm.ownerDOBYear
        },
        PersonIdentityId: null,
        Email: vm.ownerEmail,
        MobilePhone: vm.ownerPhone
      };

      AdvancedRegistrationFactory.attempAutoIDV(params).then(function (response) {

        var res = response.data.Data;

        AdvancedRegistrationFactory.setPersonIdentityId(res.PersonIdentityId);

        if (res.Status === 4) {
          // FAIL, User has been banned
          vm.closeModal();
          AdvancedRegistrationFactory.setVisiblePages(['banned']);
        } else if (res.Status === 5 || res.Status === 3 && res.ErrorMessage === 'Too many attempts within 24 hours') {
          // ID Found but no questions returned. Show upload screen
          // OR:
          // FAIL, TOO MANY ATTEMPTS
          vm.closeModal();
          AdvancedRegistrationFactory.setVisiblePages(['uploadId']);
        } else if (res.Status === 6) {
          // FAIL, FOUND
          vm.closeModal();
          AdvancedRegistrationFactory.setIdNumber(res.Questions.ResponseInfo.IdNumber);
          AdvancedRegistrationFactory.setQuestions(res.Questions.ResponseInfo.Questions);
          AdvancedRegistrationFactory.setVisiblePages(['questions']);
        } else if (res.Status === 1) {
          // vm.closeModal();
          // return;
          // PASS
          // complete Adv Reg
          // TODO: Check into what the value of getIdNumber was here before optimizations were turned off.
          var idNumber = AdvancedRegistrationFactory.getIdNumber() || 0;

          AdvancedRegistrationFactory.completeAdvancedRegistration({
            PersonIdentityId: AdvancedRegistrationFactory.getPersonIdentityId(),
            ContractorUserId: AdvancedRegistrationFactory.getContractorUserId(),
            IdNumber: idNumber,
            isAutoIDV: true
          });

          var _params = {
            // Hardcoding needs to be changed to a dynamic value once
            // the API is returning the ActionItemTypeConfigurationId
            ActionItemTypeConfigurationId: 32
          };

          AdvancedRegistrationFactory.completeAdvancedRegActionItem(_params).then(function () {
            vm.closeModal();
            AdvancedRegistrationFactory.setVisiblePages(['success']);
          });
        } else if (res.Status === 2) {
          // FAIL, NOT FOUND
          vm.closeModal();
          AdvancedRegistrationFactory.setVisiblePages(['tryAgain']);
        }
      });
    }
  };
  /* -----  End of Public Functions  ------*/

  /*= =======================================
  =            Private Functions            =
  ======================================== */
  function init() {
    vm.loading = false;
    AdvancedRegistrationFactory.getStates().then(function (response) {
      vm.states = response;
    });

    UserData.getUserData().then(function (response) {
      vm.ownerEmail = response.UserName;
      vm.ownerFirstName = response.FirstName;
      vm.ownerLastName = response.LastName;
      AdvancedRegistrationFactory.setContractorUserId(response.ContractorUserId);
      AccountsFactory.getContractorUser(response.ContractorUserId).then(function (responseUser) {
        vm.ownerPhone = responseUser.data.Data.Phone;
      });
    });

    savedPersonalInfo = AdvancedRegistrationFactory.getPersonalInfo();
    if (!_lodash2.default.isEmpty(savedPersonalInfo)) {
      loadPersonalInfo();
    }
  }

  function loadPersonalInfo() {
    vm.ownerFirstName = savedPersonalInfo.ownerFirstName;
    vm.ownerLastName = savedPersonalInfo.ownerLastName;
    vm.ownerDOB = savedPersonalInfo.ownerDOB;
    vm.ownerDOBMonth = savedPersonalInfo.ownerDOBMonth;
    vm.ownerDOBDay = savedPersonalInfo.ownerDOBDay;
    vm.ownerDOBYear = savedPersonalInfo.ownerDOBYear;
    vm.ownerCityName = savedPersonalInfo.ownerCityName;
    vm.ownerPhone = savedPersonalInfo.ownerPhone;
    vm.ownerSSN = savedPersonalInfo.ownerSSN;
    vm.ownerAddress1 = savedPersonalInfo.ownerAddress1;
    vm.ownerState = savedPersonalInfo.ownerState;
    vm.ownerZipcode = savedPersonalInfo.ownerZipcode;
  }

  function savePersonalInfo() {
    var personalInfo = {};

    personalInfo.ownerFirstName = vm.ownerFirstName;
    personalInfo.ownerLastName = vm.ownerLastName;
    personalInfo.ownerDOB = vm.ownerDOB;
    personalInfo.ownerDOBMonth = vm.ownerDOBMonth;
    personalInfo.ownerDOBDay = vm.ownerDOBDay;
    personalInfo.ownerDOBYear = vm.ownerDOBYear;
    personalInfo.ownerCityName = vm.ownerCityName;
    personalInfo.ownerPhone = vm.ownerPhone;
    personalInfo.ownerSSN = vm.ownerSSN;
    personalInfo.ownerAddress1 = vm.ownerAddress1;
    personalInfo.ownerState = vm.ownerState;
    personalInfo.ownerZipcode = vm.ownerZipcode;

    AdvancedRegistrationFactory.setPersonalInfo(personalInfo);
  }

  function processDOB() {
    vm.ownerDOBMonth = vm.ownerDOB.substr(0, 2);
    vm.ownerDOBDay = vm.ownerDOB.substr(2, 2);
    vm.ownerDOBYear = vm.ownerDOB.substr(4, 4);
  }

  function numbersOnly(e) {
    var numbers = [8, 9, 46];

    for (var i = 48; i <= 57; i++) {
      numbers.push(i);
    }

    var nonNumber = _lodash2.default.find(numbers, function (n) {
      return n === e.which;
    });

    return !angular.isUndefined(nonNumber);
  }

  vm.closeModal = function () {
    vm.loading = false;
    raSpinnerService._unregister('personalInfoSpinner');
  };

  function isDate18orMoreYearsOld(day, month, year) {
    var mydate = new Date();
    mydate.setFullYear(year, month - 1, day);
    var age = 18;
    var currdate = new Date();
    currdate.setFullYear(currdate.getFullYear() - age);

    var more18Years = currdate >= mydate;
    return more18Years;
  }

  function isValidDate(dateString, checkToday) {
    // First check for the pattern
    if (!/^(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])(19|20)\d\d$/.test(dateString)) {
      return false;
    }

    if (angular.isUndefined(checkToday)) {
      checkToday = false;
    }

    // Parse the date parts to integers
    var day = parseInt(dateString.substring(2, 4), 10);
    var month = parseInt(dateString.substring(0, 2), 10);
    var year = parseInt(dateString.substring(4), 10);

    // Set date values
    var date = new Date(year, month - 1, day);
    var currentDate = Date.now();
    var minDate = new Date(1920, 0, 1);
    var msPerDay = 86400000;

    var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    // Adjust for leap years
    if (year % 400 === 0 || year % 100 !== 0 && year % 4 === 0) {
      monthLength[1] = 29;
    }

    if (date.getTime() > currentDate && !checkToday) {
      // Check if date is greater than today
      return false;
    }

    if (date.getTime() < currentDate - msPerDay && checkToday) {
      return false;
    }

    if (date < minDate) {
      // Check if date is less than the min date
      return false;
    }

    // Check the range of the day
    return day > 0 && day <= monthLength[month - 1]; // Month is 0 based
  }
  /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 717 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = questionsController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(719);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

questionsController.$inject = ['AdvancedRegistrationFactory']; // angular
// .module("HeroPRO")
// .controller("QuestionsController", questionsController);

/* @ngInject */
function questionsController(AdvancedRegistrationFactory) {
    var vm = this;
    vm.questions = null;
    vm.invalidAnswers = false;
    vm.globalError = 'You must answer all questions before proceeding.';

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.setAnswer = function (question, selectedAnswer) {
        question.selectedAnswer = selectedAnswer;
    };
    vm.submitAnswers = function () {
        vm.invalidAnswers = false;
        validateAnswers();

        if (vm.idVerifyQuestionsForm.$valid) {
            var params = {
                PersonIdentityId: AdvancedRegistrationFactory.getPersonIdentityId(),
                ContractorUserId: AdvancedRegistrationFactory.getContractorUserId(),
                IdNumber: AdvancedRegistrationFactory.getIdNumber(),
                isAutoIDV: false
            };

            _lodash2.default.each(vm.questions, function (question, index) {
                params['Question' + (index + 1) + 'Type'] = question.Type;
                params['Question' + (index + 1) + 'Answer'] = question.selectedAnswer;
            });

            AdvancedRegistrationFactory.completeAdvancedRegistration(params).then(function (response) {

                if (!!response.data.Data.Result && !!response.data.Data.Result.ResponseInfo && !!response.data.Data.Result.ResponseInfo.IdLiveQResult && !!response.data.Data.Result.ResponseInfo.IdLiveQResult.Key && response.data.Data.Result.ResponseInfo.IdLiveQResult.Key === 3) {
                    // PASS
                    var _params = {
                        // Hardcoding needs to be changed to a dynamic value once
                        // the API is returning the ActionItemTypeConfigurationId
                        ActionItemTypeConfigurationId: 32
                    };

                    AdvancedRegistrationFactory.completeAdvancedRegActionItem(_params).then(function () {
                        AdvancedRegistrationFactory.setVisiblePages(['success']);
                    });
                } else {
                    // FAIL
                    vm.invalidAnswers = true;
                    vm.idVerifyQuestionsForm.$submitted = false;
                    vm.idVerifyQuestionsForm.$valid = true;

                    var autoIDVParams = {
                        IdVerifyInfo: {
                            FirstName: vm.personalInfo.ownerFirstName,
                            LastName: vm.personalInfo.ownerLastName,
                            Address: vm.personalInfo.ownerAddress1,
                            City: vm.personalInfo.ownerCityName,
                            State: vm.personalInfo.ownerState,
                            Zip: vm.personalInfo.ownerZipcode,
                            SsnLast4: vm.personalInfo.ownerSSN,
                            DobDay: vm.personalInfo.ownerDOBDay,
                            DobMonth: vm.personalInfo.ownerDOBMonth,
                            DobYear: vm.personalInfo.ownerDOBYear
                        },
                        PersonIdentityId: null,
                        Email: vm.personalInfo.ownerEmail,
                        MobilePhone: vm.personalInfo.ownerPhone
                    };

                    AdvancedRegistrationFactory.attempAutoIDV(autoIDVParams).then(function (response) {
                        if (response.data.Data.Status === 3 && response.data.Data.ErrorMessage === 'Too many attempts within 24 hours') {
                            // FAIL, TOO MANY ATTEMPTS
                            AdvancedRegistrationFactory.setVisiblePages(['uploadId']);
                        } else if (!!response.data.Data.Questions && !!response.data.Data.Questions.ResponseInfo && !!response.data.Data.Questions.ResponseInfo.IdNumber && !!response.data.Data.Questions.ResponseInfo.Questions) {
                            // FAIL, FOUND
                            var questions = response.data.Data.Questions.ResponseInfo.Questions;
                            AdvancedRegistrationFactory.setIdNumber(response.data.Data.Questions.ResponseInfo.IdNumber);
                            AdvancedRegistrationFactory.setQuestions(!!questions && questions.length > 0 ? questions : null);
                            init();
                        }
                    });
                }
            });
        }
    };
    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */
    function init() {
        vm.questions = AdvancedRegistrationFactory.getQuestions();
        vm.personalInfo = AdvancedRegistrationFactory.getPersonalInfo();

        _lodash2.default.each(vm.questions, function (question) {
            question.selectedAnswer = null;
        });
    }

    function validateAnswers() {
        var isFormValid = _lodash2.default.every(vm.questions, function (question) {
            return question.selectedAnswer !== null;
        });

        if (isFormValid === true) {
            vm.idVerifyQuestionsForm.$setValidity('questionsAnswered', true);
        } else {
            vm.idVerifyQuestionsForm.$setValidity('questionsAnswered', false);
        }
    }
    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 719 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = successController;

__webpack_require__(721);

successController.$inject = ['NotificationCenterFactory', '$rootScope']; // angular
// .module("HeroPRO")
// .controller("SuccessController", successController);

/* @ngInject */
function successController(NotificationCenterFactory, $rootScope) {
    var vm = this;
    vm.isLastActiveNotification = null;

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.nextClicked = function () {
        NotificationCenterFactory.setNextNotificationAsActive();
        $rootScope.$broadcast('notificationCompleted');
    };

    vm.closeClicked = function () {
        $rootScope.$broadcast('closeNotificationModal');
    };
    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */
    function init() {
        var activeNotification = NotificationCenterFactory.getActiveNotification();
        NotificationCenterFactory.markNotificationComplete(activeNotification.ActionItemId);
        vm.isLastActiveNotification = NotificationCenterFactory.isLastActiveNotification();
    }
    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 721 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = uploadIdController;

__webpack_require__(723);

uploadIdController.$inject = ['AdvancedRegistrationFactory', '$rootScope']; // angular
// .module("HeroPRO")
// .controller("UploadIdController", uploadIdController);

/* @ngInject */
function uploadIdController(AdvancedRegistrationFactory, $rootScope) {
    var vm = this;

    vm.uploaded = false;
    vm.isUploading = false;

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */
    function init() {
        $rootScope.$on('HPFileUploaded', onFileUpload);
    }

    function onFileUpload(ev, response, file) {
        vm.isUploading = true;
        AdvancedRegistrationFactory.commitIDUpload({
            ContractorUserId: AdvancedRegistrationFactory.getContractorUserId(),
            PhotoIDTempFileKey: file.tempFileKey,
            PhotoIDFileName: file.name,
            PhotoIDDocumentTypeId: 128,
            PersonIdentityId: AdvancedRegistrationFactory.getPersonIdentityId()
        }).then(function () {
            vm.uploaded = true;
            vm.isUploading = false;
        });
    }
    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 723 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 724 */
/***/ (function(module, exports) {

module.exports = "<div class=\"advanced-registration-container\" ng-controller=\"AdvancedRegistrationModalController as advancedRegistrationModal\">\n    <ng-include src=\"'app/notificationCenter/modal/templates/advancedRegistration/personalInfo/personalInfo.html'\" ng-if=\"advancedRegistrationModal.isPageVisible('personalInfo') === true\"></ng-include>\n    <ng-include src=\"'app/notificationCenter/modal/templates/advancedRegistration/tryAgain/tryAgain.html'\" ng-if=\"advancedRegistrationModal.isPageVisible('tryAgain') === true\"></ng-include>\n    <ng-include src=\"'app/notificationCenter/modal/templates/advancedRegistration/questions/questions.html'\" ng-if=\"advancedRegistrationModal.isPageVisible('questions') === true\"></ng-include>\n    <ng-include src=\"'app/notificationCenter/modal/templates/advancedRegistration/emailUs/emailUs.html'\" ng-if=\"advancedRegistrationModal.isPageVisible('emailUs') === true\"></ng-include>\n    <ng-include src=\"'app/notificationCenter/modal/templates/advancedRegistration/emailUs/banned.html'\" ng-if=\"advancedRegistrationModal.isPageVisible('banned') === true\"></ng-include>\n    <ng-include src=\"'app/notificationCenter/modal/templates/advancedRegistration/uploadId/uploadId.html'\" ng-if=\"advancedRegistrationModal.isPageVisible('uploadId') === true\"></ng-include>\n    <ng-include src=\"'app/notificationCenter/modal/templates/advancedRegistration/success/success.html'\" ng-if=\"advancedRegistrationModal.isPageVisible('success') === true\"></ng-include>\n</div>";

/***/ }),
/* 725 */
/***/ (function(module, exports) {

module.exports = "<div class=\"advancedreg-emailus\"></div>\n    <div class=\"row\">\n        <div class=\"col-xs-12 text-center\">\n            <h3>We weren't able to verify your information.</h3>\n            <p class=\"subtitle\">\n                Please send a photo of your driver's license to <a href=\"mailto:ContractorESignCountersign@heroprogram.com\">ContractorESignCountersign@heroprogram.com</a> so we can verify your information.\n            </p>\n        </div>\n    </div>\n</div>\n\n";

/***/ }),
/* 726 */
/***/ (function(module, exports) {

module.exports = "<div class=\"advancedreg-emailus\"></div>\n    <div class=\"row\">\n        <div class=\"col-xs-12 text-center\">\n            <h3>It looks like we've worked with you before.</h3>\n            <p class=\"subtitle\">\n                Unfortunately, we aren't able to let you proceed with registration at this time.\n            </p>\n            <p class=\"subtitle\">\n                If you have any questions or concerns please email <a href=\"mailto:contractorreg@renovateamerica.com\">contractorreg@renovateamerica.com</a>.\n            </p>\n        </div>\n    </div>\n</div>\n\n";

/***/ }),
/* 727 */
/***/ (function(module, exports) {

module.exports = "<div class=\"body\">\n\n<div class=\"advancedreg-personalinfo\" ng-controller=\"PersonalInfoController as personalInfo\">\n  <div class=\"hp-loading-spinner\" ra-spinner  name=\"personalInfoSpinner\" show=\"personalInfo.loading===true\" hide-content-when-shown=\"true\">\n    <div class=\"row\">\n        <div class=\"col-xs-12 text-center\">\n            <h3>To confirm your identity, we need a few details.</h3>\n        </div>\n    </div>\n    <form name=\"personalInfo.ownerInfoForm\" ng-submit=\"personalInfo.submitForm(personalInfo.ownerInfoForm.$valid);\" novalidate autocomplete=\"off\">\n        <div class=\"page-content-container\">\n            <div class=\"row\">\n                <div class=\"form-group col-sm-6\">\n                    <label class=\"required\">Legal first name</label>\n                    <input ng-model=\"personalInfo.ownerFirstName\" class=\"form-control\" placeholder=\"Enter First Name\" ng-required=\"true\" maxlength=\"30\" tabindex=\"200\"/>\n                </div>\n                <div class=\"form-group col-sm-6\">\n                    <label class=\"required\">Legal Last Name</label>\n                    <input ng-model=\"personalInfo.ownerLastName\" class=\"form-control\" placeholder=\"Enter Last Name\" ng-required=\"true\" maxlength=\"30\" tabindex=\"201\" />\n                </div>\n            </div>\n\n            <div class=\"row\">\n                <div class=\"form-group col-sm-3\">\n                    <label class=\"required\">Date of birth</label>\n                    <input name=\"ownerDob\"\n                           class=\"dob form-control\"\n                           placeholder=\"MM/DD/YYYY\"\n                           type=\"text\"\n                           ng-model=\"personalInfo.ownerDOB\"\n                           ui-mask=\"99/99/9999\"\n                           ng-required=\"true\"\n                           ng-keypress=\"personalInfo.numbersOnly($event);\"\n                           ng-minlength=\"10\"\n                           ng-change=\"personalInfo.validateDob()\"\n                           tabindex=\"202\"/>\n                    <div class=\"pull-left\">\n                        <div class=\"error-message\" ng-if=\"personalInfo.ownerInfoForm.ownerDob.$error.minlength && personalInfo.ownerInfoForm.$submitted\">\n                            <p>Please check your entry, 8 digits are required.</p>\n                        </div>\n                        <div class=\"error-message\" ng-if=\"personalInfo.ownerInfoForm.ownerDob.$error.invalidDate && !personalInfo.ownerInfoForm.ownerDob.$error.minlength && personalInfo.ownerInfoForm.$submitted\">\n                            <p>Date must be in the past.</p>\n                        </div>\n                        <div class=\"error-message\" ng-if=\"personalInfo.ownerInfoForm.ownerDob.$error.underAge && !personalInfo.ownerInfoForm.ownerDob.$error.invalidDate && personalInfo.ownerInfoForm.$submitted\">\n                            <p>You must be 18 years or older to complete registration with Renovate America.</p>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"form-group col-sm-4\">\n                    <label class=\"required\">Phone</label>\n                    <input name=\"ownerPhone\" ng-model=\"personalInfo.ownerPhone\" type=\"tel\" class=\"form-control\" placeholder=\"\" ui-mask=\"(999) 999-9999\" ui-mask-placeholder ui-mask-placeholder-char=\"space\" ng-minlength=\"14\" ng-maxlength=\"14\" ng-required=\"true\" ng-keypress=\"personalInfo.numbersOnly($event);\" tabindex=\"203\"/>\n                    <div class=\"pull-left\">\n                        <div class=\"error-message\" ng-if=\"personalInfo.ownerInfoForm.ownerPhone.$error.minlength && personalInfo.ownerInfoForm.$submitted\">\n                            <p>Please check your entry, 10 digits are required.</p>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"form-group col-sm-5\">\n                    <label class=\"required\">Last 4 of Social Security number</label>\n                    <input name=\"ownerSsn\" type=\"password\" ng-model=\"personalInfo.ownerSSN\" ng-minlength=\"4\" placeholder=\"\" class=\"form-control private\" numeric-only maxlength=\"4\" ng-required=\"true\" ng-keypress=\"personalInfo.numbersOnly($event);\" ng-pattern=\"/^[0-9]*$/\" tabindex=\"204\"/>\n                    <div class=\"icon icon-lock lock\"></div>\n                    <div class=\"pull-left\">\n                        <div class=\"error-message\" ng-if=\"(personalInfo.ownerInfoForm.ownerSsn.$error.minlength) && personalInfo.ownerInfoForm.$submitted\">\n                            <p>Please check your entry, 4 digits are required.</p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"row\">\n                <div class=\"form-group\">\n                    <div class=\"col-xs-12\">\n                        <label class=\"required\">Residential address</label>\n                        <input type=\"text\" class=\"form-control clearfix\" ng-model=\"personalInfo.ownerAddress1\" tabindex=\"205\" required />\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"row\">\n                <div class=\"form-group\">\n                    <div class=\"col-sm-5\">\n                        <label class=\"required\">City</label>\n                        <input type=\"text\" class=\"form-control city\" ng-model=\"personalInfo.ownerCityName\"ng-required=\"true\" tabindex=\"207\"/>\n                    </div>\n                    <div class=\"col-sm-4\">\n                        <label class=\"required\">State</label>\n                        <select class=\"form-control\" ng-required=\"true\" ng-model=\"personalInfo.ownerState\" tabindex=\"208\">\n                            <option value=\"\">Select</option>\n                            <option ng-repeat=\"state in personalInfo.states\" value=\"{{state.StateAbbreviation}}\">\n                                {{state.Name}}\n                            </option>\n                        </select>\n                    </div>\n                    <div class=\"col-sm-3\">\n                        <label class=\"required\">Zip</label>\n                        <input name=\"ownerZip\" type=\"text\" class=\"form-control zipcode\" ng-model=\"personalInfo.ownerZipcode\" ui-mask=\"99999\" ui-mask-placeholder ui-mask-placeholder-char=\"space\" ng-minlength=\"5\" ng-maxlength=\"5\" tabindex=\"209\" ng-required=\"true\" maxlength=\"5\"/>\n                    </div>\n                </div>\n            </div>\n\n        </div>\n        <div class=\"row\" ng-if=\"personalInfo.ownerInfoForm.$invalid && personalInfo.ownerInfoForm.$submitted\">\n            <div class=\"col-xs-12 text-center error-message global-error-message\">\n                <p>{{personalInfo.globalError}}</p>\n            </div>\n        </div>\n        <div class=\"row button-row\">\n            <div class=\"col-xs-12 text-center\">\n                <button class=\"btn btn-primary\" type=\"submit\">Next</button>\n            </div>\n        </div>\n   </form>\n</div>\n</div>\n</div>";

/***/ }),
/* 728 */
/***/ (function(module, exports) {

module.exports = "<div class=\"advancedreg-questions\" ng-controller=\"QuestionsController as questions\">\n    <div class=\"row\">\n        <div class=\"col-xs-12 text-center\">\n            <h3>These questions help us make sure you're really {{questions.personalInfo.ownerFirstName}}</h3>\n        </div>\n    </div>\n\n    <form name=\"questions.idVerifyQuestionsForm\" ng-submit=\"questions.submitAnswers()\">\n        <div class=\"row\">\n            <div class=\"col-xs-6 question-col\" ng-repeat=\"question in questions.questions\">\n                <label>{{$index + 1}}. {{question.Prompt}}</label>\n                <ul>\n                    <li ng-repeat=\"answer in question.Answer\" ng-click=\"questions.setAnswer(question, answer);\">\n                        <span class=\"icon icon-radio-default\" ng-cloak ng-if=\"answer !== question.selectedAnswer\"\n                            ng-class=\"{'not-answered': question.selectedAnswer === null && questions.idVerifyQuestionsForm.$submitted}\"></span>\n                        <span class=\"icon icon-radio-select\" ng-cloak ng-if=\"answer === question.selectedAnswer\"></span>\n                        <span class=\"radio-text\">{{answer}}</span>\n                    </li>\n                </ul>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-xs-12 text-center\">\n                <div class=\"text-center error-message global-error-message\">\n                    <span ng-bind=\"questions.globalError\" ng-show=\"questions.idVerifyQuestionsForm.$invalid && questions.idVerifyQuestionsForm.$submitted\"></span>\n                    <span ng-show=\"questions.invalidAnswers === true\">Looks like that wasn't quite right. Please try answering these questions again.</span>\n                </div>\n            </div>\n        </div>\n        <div class=\"row button-row\">\n            <div class=\"col-xs-12 text-center\">\n                <button class=\"btn btn-primary\" type=\"submit\">Next</button>\n            </div>\n        </div>\n    </form>\n</div>";

/***/ }),
/* 729 */
/***/ (function(module, exports) {

module.exports = "<div class=\"advancedreg-success\" ng-controller=\"SuccessController as success\">\n    <div class=\"row\">\n        <div class=\"col-xs-12 text-center\">\n            <div class=\"icon-check-circle-thin\"></div>\n            <h3>Success, your identity has been verified.</h3>\n        </div>\n    </div>\n\n    <div class=\"row button-row\">\n        <div class=\"col-xs-12 text-center\">\n            <button class=\"btn btn-primary\" ng-if=\"success.isLastActiveNotification === false\" ng-click=\"success.nextClicked()\">Next</button>\n            <button class=\"btn btn-primary\" ng-if=\"success.isLastActiveNotification === true\" ng-click=\"success.closeClicked()\">Close</button>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 730 */
/***/ (function(module, exports) {

module.exports = "<div class=\"advancedreg-tryagain\">\n    <div class=\"row\">\n        <div class=\"col-xs-12 text-center\">\n            <h3>Hmm, we aren’t able to find you.</h3>\n            <p class=\"subtitle\">Let's take another look at your information to make sure everything is correct.</p>\n        </div>\n    </div>\n\n    <div class=\"row button-row\">\n        <div class=\"col-xs-12 text-center\">\n            <button class=\"btn btn-primary\" ng-click=\"advancedRegistrationModal.setVisiblePages(['personalInfo'])\">Go Back</button>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 731 */
/***/ (function(module, exports) {

module.exports = "<div class=\"advancedreg-upload-id\" ng-controller=\"UploadIdController as uploadId\">\n    <div class=\"row\" ng-show=\"uploadId.uploaded\">\n        <div class=\"col-xs-12 text-center reg-content\">\n            <h2>Success! We will send you an email once everything is ready to move on to the next step!</h2>\n        </div>\n    </div>\n    <div ng-show=\"!uploadId.uploaded\">\n        <div class=\"row\">\n            <div class=\"col-xs-12 text-center reg-content\">\n                <h2>Apologies, we're unable to identify you.</h2>\n                <p>We apologize our online identification system is unable to verify you.<br />Please upload a copy of your\n                    photo ID to continue</p>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-xs-12 reg-content\">\n                <p>Acceptable forms of ID:</p>\n                <p>1. A picture of the front of your State Driver License OR</p>\n                <p>2. A picture of the photo ID page of your passport</p>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-xs-12 text-center\">\n                <div class=\"dropzone hp-dropzone\" dropzone=\"\" id=\"dropzone\" dropzone-url=\"DocumentManagement/UploadAttachment\" dropzone-form-data=\"{}\"\n                    dropzone-form-data-field=\"Payload\" dropzone-accepted-files=\".jpg,.jpeg,.png,.gif,.tif,.bmp,.pdf,.doc,.docx\"\n                    drop-zone-max-file-size=\"10\">\n                    <div class=\"dz-default dz-message\">\n                        <p class=\"draganddrop-message\">Drag and drop a file here</p>\n                        <p class=\"or\">OR</p>\n                        <button class=\"btn btn-primary\" ng-click=\"uploadId.uploadButtonClicked($event)\">UPLOAD</button>\n                        <p class=\"sizes\">\n                            Size limit is 10MB<br /> Supported file types: pdf,jpg,jpeg,png,gif,tif,bmp,doc,docx\n                        </p>\n                    </div>\n            </div>\n        </div>\n                <div ra-spinner register=\"false\" show=\"uploadId.isUploading\" hide-content-when-shown=\"false\"></div>\n    </div>\n</div>\n</div>";

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = addBankInfoController;
addBankInfoController.$inject = ['$rootScope'];
// angular
// 	.module("HeroPRO")
// 	.controller("AddBankInfoController", addBankInfoController);

/* @ngInject */
function addBankInfoController($rootScope) {
    var vm = this;

    vm.notifications = [];

    vm.financeInfo = {};

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    vm.cancelAdd = function () {
        $rootScope.$broadcast('closeNotificationModal', { result: false, errorStatus: null });
    };

    vm.add = function () {};

    /* -----  End of Public Functions  ------*/

    /*= ========================================
    =            Private Functions            =
    ========================================= */

    function init() {}

    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TermsSignController;

__webpack_require__(734);

TermsSignController.$inject = ['$state', 'AdvancedRegistrationFactory', 'NotificationCenterFactory', '$rootScope']; // angular
//     .module("HeroPRO")
//     .controller("TermsSignController", termsSignController);

/* @ngInject */
function TermsSignController($state, AdvancedRegistrationFactory, NotificationCenterFactory, $rootScope) {
    var vm = this;

    vm.checkboxClicked = false;
    vm.isSubmitting = false;
    vm.invalid = false;

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    vm.acknowledgeTerms = function () {
        if (!vm.checkboxClicked) {
            vm.invalid = true;
        } else {
            vm.invalid = false;
            vm.isSubmitting = true;
            AdvancedRegistrationFactory.completeAdvancedRegActionItem({
                ActionItemTypeConfigurationId: 25
            }).then(function () {
                vm.isSubmitting = false;
                var activeNotification = NotificationCenterFactory.getActiveNotification();
                NotificationCenterFactory.markNotificationComplete(activeNotification.ActionItemId);

                if (NotificationCenterFactory.isLastActiveNotification()) {
                    vm.closeClicked();
                } else {
                    vm.nextClicked();
                }
            });
        }
    };

    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.nextClicked = function () {
        NotificationCenterFactory.setNextNotificationAsActive();
        $rootScope.$broadcast('notificationCompleted');
    };

    vm.closeClicked = function () {
        $rootScope.$broadcast('closeNotificationModal');
    };
    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */
    function init() {}
    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 734 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = PCCController;

__webpack_require__(736);

PCCController.$inject = ['$location', 'NotificationCenterFactory', '$rootScope', 'AccountsFactory'];


/* @ngInject */
function PCCController($location, NotificationCenterFactory, $rootScope, AccountsFactory) {
    var vm = this;
    var activeNotification = NotificationCenterFactory.getActiveNotification();

    // ActionItemTypeId 23 = Mandatory PCC Notification
    // ActionItemTypeId 24 = Reminder PCC Notification

    vm.hisExempt = null;
    vm.loading = false;

    vm.continueClicked = function () {
        vm.loading = true;
        AccountsFactory.setHISLicenseExemptionStatus({
            ActionItemId: activeNotification.ActionItemId,
            IsHISExempt: vm.hisExempt
        }).then(function () {
            vm.loading = false;

            NotificationCenterFactory.markNotificationComplete(activeNotification.ActionItemId);
            if (NotificationCenterFactory.isLastActiveNotification()) {
                vm.closeClicked();
            } else {
                vm.nextClicked();
            }
        });
    };

    vm.nextClicked = function () {
        NotificationCenterFactory.setNextNotificationAsActive();
        $rootScope.$broadcast('notificationCompleted');
    };

    vm.closeClicked = function () {
        $rootScope.$broadcast('closeNotificationModal');
    };

    function updateNotificationStatus(newStatus) {
        NotificationCenterFactory.setActionItemStatus({
            ActionItemId: activeNotification.ActionItemId,
            ActionItemStatus: newStatus
        }).then(function () {
            NotificationCenterFactory.markNotificationComplete(activeNotification.ActionItemId);

            if (NotificationCenterFactory.isLastActiveNotification()) {
                vm.closeClicked();
            } else {
                vm.nextClicked();
            }
        });
    }
}

/***/ }),
/* 736 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 737 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 738 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = HISCodeOfConductController;

__webpack_require__(740);

HISCodeOfConductController.$inject = ['NotificationCenterFactory', '$rootScope']; // angular
//     .module("HeroPRO")
//     .controller("TermsSignController", termsSignController);

/* @ngInject */
function HISCodeOfConductController(NotificationCenterFactory, $rootScope) {
    var vm = this;

    vm.checkboxClicked = false;
    vm.isSubmitting = false;
    vm.invalid = false;

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    vm.acknowledgeTerms = function () {
        if (!vm.checkboxClicked) {
            vm.invalid = true;
        } else {
            vm.invalid = false;
            vm.isSubmitting = true;
            var activeNotification = NotificationCenterFactory.getActiveNotification();

            NotificationCenterFactory.setActionItemStatus({
                ActionItemId: activeNotification.ActionItemId,
                ActionItemStatus: 3
            }).then(function () {
                vm.isSubmitting = false;
                NotificationCenterFactory.markNotificationComplete(activeNotification.ActionItemId);

                if (NotificationCenterFactory.isLastActiveNotification()) {
                    vm.closeClicked();
                } else {
                    vm.nextClicked();
                }
            });
        }
    };

    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.nextClicked = function () {
        NotificationCenterFactory.setNextNotificationAsActive();
        $rootScope.$broadcast('notificationCompleted');
    };

    vm.closeClicked = function () {
        $rootScope.$broadcast('closeNotificationModal');
    };

    vm.doLater = function () {
        if (NotificationCenterFactory.isLastActiveNotification()) {
            $rootScope.$broadcast('closeNotificationModal');
        } else {
            NotificationCenterFactory.setNextNotificationAsActive();
        }
    };
    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */
    function init() {}
    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 740 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 741 */
/***/ (function(module, exports) {

module.exports = "<div class=\"add-bank-info\" ng-controller=\"AddBankInfoController as addBankInfo\">\n    <hp-ach cancel-click=\"addBankInfo.cancelAdd()\" ach-data=\"addBankInfo.financeInfo\" save-click=\"addBankInfo.add()\" display-logo=\"false\" notification-view=\"true\"></hp-ach>\n</div>\n";

/***/ }),
/* 742 */
/***/ (function(module, exports) {

module.exports = "\n<div class=\"territory-update\">\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <div class=\"text-center\">\n                <h5 class=\"\">UPDATE</h5>\n                <h3>Changes to HERO territory in your area</h3>\n            </div>\n            <div>\n                <p>\n                    On June 15 the HERO Program began its partnership with the California Statewide Communities Development Authority (CSCDA) as the new issuer in San Bernardino County. The CSCDA HERO Program will cover all San Bernardino County territories with the exception of the six below.\n                </p>\n                \n                <p class=\"bold increase-line-height\">\n                    At the end of June, the following communities will not be available under HERO until further notice:\n                </p>\n\n                <p>\n                    <ul>\n                        <li>Apple Valley</li>\n                        <li>Grand Terrace</li>\n                        <li>Needles</li>\n                        <li>Victorville</li>\n                        <li>Yucaipa</li>\n                        <li>Yucca Valley</li>\n                    </ul>\n                </p>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <p>\n                We will continue working with these six cities to adopt HERO under CSCDA and will update you as progress is made. For questions, contact us at 855-HERO-411.\n            </p>\n        </div>\n    </div>\n    \n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <div class=\"btn-container\">\n                <button class=\"btn btn-primary\" ng-click=\"notificationModal.closeModal(false)\">OK\n                </button>\n            </div>\n        </div>\n    </div>\n</div>\n\n";

/***/ }),
/* 743 */
/***/ (function(module, exports) {

module.exports = "\r\n<div class=\"territory-update\">\r\n    <div class=\"row\">\r\n        <div class=\"col-xs-12\">\r\n            <div class=\"text-center\">\r\n                <h5 class=\"\">UPDATE</h5>\r\n                <h3>Changes to HERO territory in your area</h3>\r\n            </div>\r\n            <div>\r\n                <p>\r\n                    Renovate America is transitioning its Los Angeles HERO Program and making adjustments to eligible territories in that region. During this time, application submissions will be paused in Los Angeles County. We apologize for any inconvenience and appreciate your patience.\r\n                    </p>\r\n            </div>\r\n        </div>\r\n    </div>    \r\n    <div class=\"row\">\r\n        <div class=\"col-xs-12\">\r\n            <div class=\"btn-container\">\r\n                <button class=\"btn btn-primary\" ng-click=\"notificationModal.completeNotification(false)\">OK</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n";

/***/ }),
/* 744 */
/***/ (function(module, exports) {

module.exports = "<div class=\"terms-sign\" ng-controller=\"TermsSignController as termsSign\">\n    <form ng-submit=\"termsSign.acknowledgeTerms()\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div class=\"text-center\">\n                    <h5>Terms and Conditions</h5>\n                    <h3>\n                        <a target=\"_blank\" href=\"http://7144b0b2ad28a8e9d39f-c7daaeaa05869c3b736fd3d320921c0f.r39.cf2.rackcdn.com/Contractor%20Participation%20Agreement%20-%20FOAHI.pdf\">The Finance of America Home Improvement Registered Contractor Terms and Conditions</a> contain\n                        requirements for all home improvement contractors that register with Finance of America Home Improvement and any\n                        individuals who register or attempt to register with Finance of America Home Improvement to introduce and/or\n                        access any financing product offered by Finance of America Home Improvement or its affiliates.\n                    </h3>\n                </div>\n                <div class=\"sign-terms-checkbox row\" ng-click=\"termsSign.checkboxClicked = !termsSign.checkboxClicked\">\n                    <div class=\"sign-terms-checkbox-input\">\n                        <span class=\"icon icon-complete\" ng-if=\"termsSign.checkboxClicked\"></span>\n                        <span class=\"empty-checkbox\" ng-if=\"!termsSign.checkboxClicked\" ng-model=\"termsSign.checkboxClicked\"\n                            ng-required=\"termsSign.checkboxClicked\"></span>\n                    </div>\n                    <p>\n                        By clicking “I AGREE” below, you agree to comply with and be subject to the most recent version\n                        of the Finance of America Home Improvement Registered Contractor Terms and Conditions (including but not limited\n                        to any addenda thereto and any documents referenced therein) that apply to registered\n                        individuals, including but not limited to the Registered Contractor Code of Conduct.\n                    </p>\n                </div>\n                <div class=\"text-center\">\n                    <div class=\"error-message\" ng-if=\"termsSign.invalid\">\n                        <p>Please acknowledge before moving forward</p>\n                    </div>\n                    <button class=\"btn btn-primary\" type=\"submit\">I Agree</button>\n                </div>\n\n                <div ra-spinner register=\"false\" show=\"termsSign.isSubmitting\" hide-content-when-shown=\"false\"></div>\n            </div>\n        </div>\n    </form>\n</div>";

/***/ }),
/* 745 */
/***/ (function(module, exports) {

module.exports = "<div class=\"his-code-of-conduct\" ng-controller=\"HISCodeOfConductController as coc\">\n    <form>\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div>\n                    <h5>PACE Participant vs. Certified PACE Professional Roles</h5>\n                    <p>As of January 1, 2019, all registered contractors who perform services in connection with Renovate America’s HERO financing product will be defined as either a PACE Participant or a Certified PACE Professional, and must act in accordance with the code of conduct for their respective role, as defined below. </p>\n                    <p>A <strong>PACE Participant</strong> is an individual who has successfully registered with\n                        Renovate America.</p>\n                    <p>PACE Participant Permissions: </p>\n                    <ul>\n\t\t\t\t\t\t<li>May advertise HERO </li>\n\t\t\t\t\t\t<li>May only use predefined marketing collateral and resources to discuss the benefits and procedures of using HERO financing</li>\n\t\t\t\t\t\t<li>May only use general payment estimation tools to review payment options available to customers using HERO financing</li> \n\t\t\t\t\t\t<li>May only provide customers with access to complete and submit a HERO financing application on their own behalf</li>\n\t\t\t\t\t\t<li>May direct customers to either <a href=\"www.foahomeimprovement.com\" target=\"_blank\">www.foahomeimprovement.com</a> or to call Renovate America directly to apply for HERO financing</li>\n\t\t\t\t\t\t<li>May complete administrative tasks related to facilitating a HERO financing project after the application submittal stage (post-application through funding)</li>\n                    </ul>\n                    <p>PACE Participant Restrictions:</p>\n                    <ul>\n                        <li>Limited to advertising HERO only</li>\n                        <li>May not discuss the benefits and/or procedures of using HERO financing with customers outside of the guidelines specified in predefined marketing collateral and resources made available by Renovate America</li>\n                        <li>May not actively sell HERO financing and/or solicit customers into HERO financing agreements</li>\n                        <li>May not specify and/or negotiate terms of a HERO financing agreement</li>\n\t\t\t\t\t\t<li>May not use specific financial payment calculators or quoting tools to review specific HERO financing details with customers</li>\n\t\t\t\t\t\t<li>May not take, fill out, and/or submit a HERO financing application on behalf of their customer</li>\n                    </ul>\n                    <p>A <strong>Certified PACE Professional</strong>  is an individual who has successfully registered with Renovate America and successfully completed the Certified PACE Professional enrollment process, which includes:</p>\n                    <ul>\n                        <li>Providing proof of their Home Improvement Salesperson (HIS) license from the California State License Board (CLSB) that is active and in good standing, and</li>\n                        <li>Providing proof of completing a series of PACE-specific regulatory compliance training requirements.</li>\n                    </ul>\n                    <p>Certified PACE Professional Permissions:</p>\n                    <ul>\n                        <li>May use predefined marketing collateral and resources made available by Renovate America, as well as any other conforming content, to discuss the benefits and procedures of using HERO financing with customers</li>\n\t\t\t\t\t\t<li>May use general payment estimation tools, as well as specific financial payment calculators or quoting tools, to review HERO financing payment details with customers</li>\n\t\t\t\t\t\t<li>May actively sell HERO financing and/or solicit customers into HERO financing agreements</li>\n\t\t\t\t\t\t<li>May specify and/or negotiate terms of a HERO financing agreement</li>\n\t\t\t\t\t\t<li>May provide customers with access to complete and submit a HERO financing application</li>\n\t\t\t\t\t\t<li>May complete administrative tasks related facilitating a HERO financing project throughout the project lifecycle (application through funding)</li>\n                    </ul>\n                    <p>Certified PACE Professional Restrictions:</p>\n                    <ul>\n                        <li>May not take, fill out, and/or submit a HERO financing application on behalf of their customer</li>\n                    </ul>\n                </div>\n                <div class=\"sign-terms-checkbox row\" ng-click=\"coc.checkboxClicked = !coc.checkboxClicked\">\n                    <div class=\"sign-terms-checkbox-input\">\n                        <span class=\"icon icon-complete\" ng-if=\"coc.checkboxClicked\"></span>\n                        <span class=\"empty-checkbox\" ng-if=\"!coc.checkboxClicked\" ng-model=\"coc.checkboxClicked\"\n                            ng-required=\"coc.checkboxClicked\"></span>\n                    </div>\n                    <p>As a registered user of Renovate America, I understand the permissions and restrictions for the PACE Participant or the Certified PACE Professional and agree to act in accordance with the code of conduct for my role, as described in this section.</p>\n                </div>\n                <div class=\"text-center\">\n                    <div class=\"error-message\" ng-if=\"coc.invalid\">\n                        <p>Please acknowledge before moving forward</p>\n                    </div>\n                    <button class=\"btn btn-primary\" ng-click=\"coc.acknowledgeTerms()\">Agree</button>\n                </div>\n\n                <div ra-spinner register=\"false\" show=\"coc.isSubmitting\" hide-content-when-shown=\"false\"></div>\n            </div>\n        </div>\n    </form>\n</div>";

/***/ }),
/* 746 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n    <div class=\"col-xs-12 contractor-cslb\">\n        <div class=\"cslb-title\"><span>Tell us who is on record with the CSLB as the one in charge of your company's construction operations.</span></div>\n        <div class=\"cslb-instruction\">Follow these easy steps or <a href=\"http://ba6f6a1e2f0fdb36571e-96f3848a50256afc7db699af5389ae43.r99.cf2.rackcdn.com/CSLBQualifierCleanup_FAQ.pdf\" target=\"_new\">read this PDF</a> to identify your company's CSLB qualifier.</div>\n        <div class=\"cslb-list\">\n            <div class=\"reg-step\">\n                <div class=\"reg-step-num\"><p>1</p></div>\n                <div class=\"reg-step-text\"><span>Add or update a user</span></div>\n            </div>\n            <div class=\"reg-step\">\n                <div class=\"reg-step-num\"><p>2</p></div>\n                <div class=\"reg-step-text\">Select Company Admin as the user role</div>\n            </div>\n            <div class=\"reg-step\">\n                <div class=\"reg-step-num\"><p>3</p></div>\n                <div class=\"reg-step-text\">Select qualifier and Save</div>\n            </div>\n        </div>\n        <div class=\"cslb-buttons\">\n            <a href=\"accounts/users/\" ng-click=\"notificationModal.closeModal(false)\" class=\"btn btn-primary\">FIX IT NOW</a>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 747 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\" ng-controller=\"PCCController as pcc\">\n    <div class=\"col-xs-6 col-xs-offset-0 col-sm-6 col-sm-offset-2 pcc-notification\">\n        <h2 class=\"pcc-notification__title\">What's your Home Improvement Salesperson (HIS) status?</h2>\n        <p>In order to participate in HERO, you must certify that you have registered as a home improvement salesperson\n            (\"HIS\") with the Contractors' State License Board (\"CSLB\"), or that your registration as an HIS is pending\n            or not required. You must also acknowledge and agree to the <a target=\"_blank\" href=\"http://ba6f6a1e2f0fdb36571e-96f3848a50256afc7db699af5389ae43.r99.cf2.rackcdn.com/California%20HERO%20Code%20of%20Conduct.pdf\">California\n                HERO Code of Conduct</a></p>\n        <div class=\"ul-container his-wizard\">\n            <ul class=\"radio-options\">\n                <li>\n                    <div class=\"option-container\">\n                        <div class=\"option-header\">\n                            <p class=\"option-header-title\">PACE Participant</p>\n                            <span class=\"icon\" ng-class=\"{'icon-radio-select': pcc.hisExempt === true, 'icon-radio-default': !pcc.hisExempt}\"\n                                ng-click=\"pcc.hisExempt = true\"></span>\n                            <div class=\"text\" ng-click=\"pcc.hisExempt = true\">By making this selection, I hereby\n                                agree that I am registering with Renovate America as a PACE Participant and that I will\n                                timely satisfy the registration and training requirements of a PACE Participant and\n                                agree to the California HERO PACE Participant Code of Conduct.</div>\n                            <p>As a PACE Participant: <a ng-show=\"!learnMoreExempt\" ng-click=\"learnMoreExempt = !learnMoreExempt\">Learn\n                                    more</a></p>\n                        </div>\n                        <div class=\"option-drawer\" ng-if=\"learnMoreExempt\">\n                            <ul class=\"his-list\">\n                                <li>You can introduce and provide general information about HERO financing to customers\n                                    using resources provided to you by Renovate America. You can also perform\n                                    administrative or clerical tasks related to HERO financing. You cannot, however,\n                                    discuss the financing details of a specific HERO financing assessment contract with\n                                    a customer.</li>\n                                <li>Renovate America will provide you with resources that you can use to introduce HERO\n                                    financing, such as responses to FAQs, scripts, a HERO overview video, and\n                                    brochures. You will not have access to the financial payment calculator, quoting\n                                    and similar tools in HEROPro.</li>\n                                <li>You will need to complete applicable registration and training requirements,\n                                    including:</li>\n                                <li style=\"list-style: none;\">\n                                    <ul>\n                                        <li>Complete the introductory training and less than thirty minute PACE\n                                            Participant training specific to advertising HERO financing</li>\n                                        <li>Agree to the California HERO PACE Participant Code of Conduct</li>\n                                    </ul>\n                                </li>\n                            </ul>\n                            <p>You will have 5 days from the time that you make this\n                                election to complete these requirements.</p>\n                        </div>\n                    </div>\n                </li>\n                <li>\n                    <div class=\"option-container\">\n                        <div class=\"option-header\">\n                            <p class=\"option-header-title\">Certified PACE Professional</p>\n                            <span class=\"icon\" ng-class=\"{'icon-radio-select': pcc.hisExempt === false, 'icon-radio-default': (pcc.hisExempt === null || !!pcc.hisExempt)}\"\n                                ng-click=\"pcc.hisExempt = false\"></span>\n                            <div class=\"text\" ng-click=\"pcc.hisExempt = false\">By making this selection, I hereby\n                                agree that I am registering with Renovate America as a Certified PACE Professional and\n                                that I will timely satisfy the registration and training requirements of a Certified\n                                PACE Professional and agree to the California HERO Certified PACE Professional Code of\n                                Conduct.</div>\n                            <p>As a Certified PACE Professional: <a ng-show=\"!learnMoreNotExempt\" ng-click=\"learnMoreNotExempt = !learnMoreNotExempt\">Learn\n                                    more</a></p>\n                        </div>\n                        <div class=\"option-drawer\" ng-if=\"learnMoreNotExempt\">\n                            <ul class=\"his-list\">\n                                <li>You can discuss the financing terms of specific HERO financing assessment contracts\n                                    with your customers. You can also perform administrative, clerical and other\n                                    approved tasks related to HERO financing.</li>\n                                <li>You will have full access to Renovate America’s Proposal Plus, Payment Calculator,\n                                    variety of marketing materials and other resources in HEROPro.</li>\n                                <li>You will need to complete applicable registration and training requirements,\n                                    including:</li>\n                                <li style=\"list-style: none;\">\n                                    <ul>\n                                        <li>Provide Renovate America with your Home Improvement Salesperson (HIS)\n                                            registration number</li>\n                                        <li>Complete the introductory training and 6-hour PACE certification training\n                                            course</li>\n                                        <li>Agree to California HERO Certified PACE Professional Code of Conduct.</li>\n                                    </ul>\n                                </li>\n                            </ul>\n                            <p>You will have 90 days to complete the 6-hour training\n                                course requirements. We’ll remind you every time you log in that it’s still pending,\n                                but it won’t affect your ability to use the tools.</p>\n                        </div>\n                    </div>\n                </li>\n            </ul>\n\n        </div>\n        <div class=\"pcc-notification__button-container\">\n            <button class=\"btn btn-primary pcc-notification__get-credential\" ng-click=\"pcc.continueClicked()\"\n                ng-disabled=\"pcc.loading || pcc.hisExempt === null\">{{ pcc.loading ? 'Loading' : 'Continue' }}</button>\n        </div>\n        <p class=\"none-of-the-above\">If none of the above apply to you or if you've completed HIS with another PACE\n            provider, then call us at (844)827-7591</p>\n    </div>\n</div>";

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _directives = __webpack_require__(749);

var _directives2 = _interopRequireDefault(_directives);

var _trainingController = __webpack_require__(758);

var _trainingController2 = _interopRequireDefault(_trainingController);

var _trainingFactory = __webpack_require__(760);

var _trainingFactory2 = _interopRequireDefault(_trainingFactory);

var _benjiController = __webpack_require__(761);

var _benjiController2 = _interopRequireDefault(_benjiController);

var _guidelinesController = __webpack_require__(762);

var _guidelinesController2 = _interopRequireDefault(_guidelinesController);

var _heroProgramController = __webpack_require__(763);

var _heroProgramController2 = _interopRequireDefault(_heroProgramController);

var _completeController = __webpack_require__(764);

var _completeController2 = _interopRequireDefault(_completeController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.notificationCenter.modal.training', [_directives2.default]).controller('TrainingController', _trainingController2.default).controller('BenjiController', _benjiController2.default).controller('GuidelinesController', _guidelinesController2.default).controller('HeroProgramController', _heroProgramController2.default).controller('CompleteController', _completeController2.default).factory('TrainingFactory', _trainingFactory2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/notificationCenter/modal/training/trainingContent.html', __webpack_require__(765)); // eslint-disable-line global-require

    $templateCache.put('app/notificationCenter/modal/training/benji/benji.html', __webpack_require__(766)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/training/complete/complete.html', __webpack_require__(767)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/training/concerns/concerns.html', __webpack_require__(768)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/training/deliver/deliver.html', __webpack_require__(769)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/training/elders/elders.html', __webpack_require__(770)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/training/guidelines/guidelines.html', __webpack_require__(771)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/training/heroProgram/heroProgram.html', __webpack_require__(772)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/training/heroTable/heroTable.html', __webpack_require__(773)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/training/interacting/interacting.html', __webpack_require__(774)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/training/practices/practices.html', __webpack_require__(775)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/training/welcome/welcome.html', __webpack_require__(776)); // eslint-disable-line global-require

    $templateCache.put('app/notificationCenter/modal/training/fraud/fraud.html', __webpack_require__(777)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/training/fraud2/fraud2.html', __webpack_require__(778)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/training/fraud3/fraud3.html', __webpack_require__(779)); // eslint-disable-line global-require

    $templateCache.put('app/notificationCenter/modal/training/paceDisclosures/paceDisclosures.html', __webpack_require__(780)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/training/paceDisclosures2/paceDisclosures2.html', __webpack_require__(781)); // eslint-disable-line global-require

    $templateCache.put('app/notificationCenter/modal/training/ethics/ethics.html', __webpack_require__(782)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/training/ethics2/ethics2.html', __webpack_require__(783)); // eslint-disable-line global-require

    $templateCache.put('app/notificationCenter/modal/training/nondiscrimination/nondiscrimination.html', __webpack_require__(784)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/training/seniorAbuse/seniorAbuse.html', __webpack_require__(785)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/training/consumerProtection/consumerProtection.html', __webpack_require__(786)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/training/consumerProtection2/consumerProtection2.html', __webpack_require__(787)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _trainingBtnController = __webpack_require__(750);

var _trainingBtnController2 = _interopRequireDefault(_trainingBtnController);

var _trainingBtnDirective = __webpack_require__(752);

var _trainingBtnDirective2 = _interopRequireDefault(_trainingBtnDirective);

var _trainingQAndAController = __webpack_require__(753);

var _trainingQAndAController2 = _interopRequireDefault(_trainingQAndAController);

var _trainingQAndADirective = __webpack_require__(755);

var _trainingQAndADirective2 = _interopRequireDefault(_trainingQAndADirective);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.notificationCenter.modal.directives', []).controller('TrainingBtnController', _trainingBtnController2.default).controller('TrainingQAndAController', _trainingQAndAController2.default).directive('hpTrainingBtn', _trainingBtnDirective2.default).directive('hpTrainingQAndA', _trainingQAndADirective2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/notificationCenter/modal/training/directives/trainingBtn/trainingBtn.html', __webpack_require__(756)); // eslint-disable-line global-require
    $templateCache.put('app/notificationCenter/modal/training/directives/trainingQA/trainingQAndA.html', __webpack_require__(757)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = trainingTopicController;

__webpack_require__(751);

trainingTopicController.$inject = ['$scope', '$document']; // angular
// 	.module("HeroPRO")
// 	.controller("TrainingBtnController", trainingTopicController);

/* @ngInject */
function trainingTopicController($scope, $document) {
    var vm = this;
    var valid = false;

    vm.showNoSelection = false;
    vm.showWrongSelection = false;

    vm.next = function () {
        valid = validate($scope.validate, $scope.current);

        if (valid) {
            $scope.advance();
        }
    };

    vm.prev = function () {
        getRadioButtons($scope.parentClass, $document[0]).removeClass('no-selection');
        vm.showNoSelection = false;
        vm.showWrongSelection = false;
        $scope.retreat();
    };

    $scope.$on('answerSelected', function (e, data) {
        vm.showNoSelection = false;
        if ($scope.current && $scope.current.SelectedAnswer !== data.selection) {
            vm.showWrongSelection = false;
        }
    });

    function validate(isValidated, topic) {
        var isValid = false;
        if (!isValidated || !topic) {
            return true;
        }
        if (topic.SelectedAnswer === topic.CorrectAnswer) {
            isValid = true;
        } else if (!topic.SelectedAnswer) {
            getRadioButtons($scope.parentClass, $document[0]).addClass('no-selection');
            vm.showNoSelection = true;
        } else if (topic.SelectedAnswer !== topic.CorrectAnswer) {
            vm.showWrongSelection = true;
        }

        return isValid;
    }

    function getRadioButtons(container, document) {
        return angular.element(document.querySelectorAll('.' + container + ' .icon-radio-default'));
    }
}

/***/ }),
/* 751 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = trainingDirective;
// angular
// 	.module("HeroPRO")
// 	.directive('hpTrainingBtn', trainingDirective);

function trainingDirective() {
    return {
        restrict: 'E',
        controller: 'TrainingBtnController',
        controllerAs: 'topic',
        // bindToController: true,
        scope: {
            advance: '&',
            retreat: '&',
            validate: '=',
            current: '=',
            parentClass: '@'
        },
        templateUrl: 'app/notificationCenter/modal/training/directives/trainingBtn/trainingBtn.html',
        link: link
    };

    function link(scope, element) {
        element.on('click', function (e) {
            var target = e.target;
            target.blur();
        });
    }
}

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = testController;

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

__webpack_require__(754);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

testController.$inject = ['$scope', '$rootScope', '$document']; // angular
// 	.module("HeroPRO")
// 	.controller("TrainingQAndAController", testController);

/* @ngInject */
function testController($scope, $rootScope, $document) {
    $scope.qAnda.select = function (answer) {
        $rootScope.$broadcast('answerSelected', { selection: answer });
        if ($scope.qAnda.current) $scope.qAnda.current.SelectedAnswer = answer;
        _angular2.default.element($document[0].querySelectorAll('.' + $scope.qAnda.parentClass + ' .icon-radio-default')).removeClass('no-selection');
    };
}

/***/ }),
/* 754 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = testDirective;
// angular
// 	.module("HeroPRO")
// 	.directive('hpTrainingQAndA', testDirective);

function testDirective() {
    return {
        restrict: 'E',
        controller: 'TrainingQAndAController',
        controllerAs: 'qAnda',
        bindToController: true,
        scope: {
            current: '=',
            parentClass: '@'
        },
        templateUrl: 'app/notificationCenter/modal/training/directives/trainingQA/trainingQAndA.html',
        link: link
    };

    function link() {}
}

/***/ }),
/* 756 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row training-btn\">\n    <div class=\"col-xs-12\">\n        <div>\n            <p ng-if=\"topic.showNoSelection\">Select an answer to continue.</p>\n            <p ng-if=\"topic.showWrongSelection\">Hmm, try again. That's incorrect.</p>\n        </div>\n        <div class=\"btn-group\">\n            <div>\n                <button class=\"btn btn-default\" ng-click=\"topic.prev();\">\n                    Back\n                </button>\n                <button class=\"btn btn-primary\" ng-click=\"topic.next();\">\n                    Next\n                </button>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 757 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row training-Q-A\">\n    <div class=\"col-xs-12\">\n        <p ng-bind=\"qAnda.current.Questions.Question\"></p>\n        <div class=\"ul-container\">\n            <ul class=\"answers\">\n                <li ng-click=\"qAnda.select(answer)\" ng-repeat=\"answer in qAnda.current.Answers\">\n                    <div class=\"answer-container\">\n                        <span ng-class=\"{'icon-radio-select': qAnda.current.SelectedAnswer == answer, 'icon-radio-default' : qAnda.current.SelectedAnswer != answer}\"></span>\n                        <div class=\"text\" ng-bind=\"answer.Answer\"></div>\n                    </div>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = trainingController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(759);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

trainingController.$inject = ['TrainingFactory', 'UserData', 'HPActionItemUrls', '$rootScope', '$document']; // angular
// 	.module("HeroPRO")
// 	.controller("TrainingController", trainingController);

/* @ngInject */
function trainingController(TrainingFactory, UserData, HPActionItemUrls, $rootScope, $document) {
    var vm = this;
    var trainingModule = null;
    vm.currentTopic = null;
    vm.prevTopic = null;
    vm.totalSlides = null;

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    vm.next = function () {
        var next = _lodash2.default.find(trainingModule.Topics, function (t) {
            return t.TemplateName === vm.currentTopic.next;
        });

        if (next) {
            next.IsCurrent = true;
            vm.currentTopic.IsCurrent = !next.IsCurrent;
            vm.prevTopic = vm.currentTopic;
            vm.currentTopic = next;

            if (typeof next.onEnter === 'function') {
                next.onEnter().then(function () {
                    $rootScope.$broadcast('notificationCompleted');
                }, function (error) {
                    if (error.status === 500) {
                        $rootScope.$broadcast('HPErrorServer');
                    } else {
                        $rootScope.$broadcast('HPErrorUnknown');
                    }
                });
            }
        }

        scrollToTop();
    };

    vm.getCurrentSlideNumber = function () {
        for (var i = 0; i < trainingModule.Topics.length; i++) {
            var mod = trainingModule.Topics[i];

            if (mod.IsCurrent) return i;
        }

        return -1;
    };

    vm.prev = function () {
        var prev = _lodash2.default.find(trainingModule.Topics, function (t) {
            return t.TemplateName === vm.currentTopic.prev;
        });
        if (prev) {
            prev.IsCurrent = true;
            vm.currentTopic.IsCurrent = !prev.IsCurrent;
            vm.prevTopic = vm.currentTopic;
            vm.currentTopic = prev;
        }

        scrollToTop();
    };

    vm.complete = function () {
        TrainingFactory.complete().then(function () {
            vm.currentTopic.templateUrl = HPActionItemUrls.Completed;
            $rootScope.$broadcast('notificationCompleted');
        }, function (error) {
            $rootScope.$broadcast('closeNotificationModal', { result: false, errorStatus: error.status });
        });

        scrollToTop();
    };

    vm.scrollToTop = function () {
        scrollToTop();
    };

    /*= ========================================
    =            Private Functions            =
    ========================================= */
    function init() {
        TrainingFactory.getContractorType(UserData.getUserLocations()).then(function (type) {
            TrainingFactory.getPages(type).then(function (response) {
                trainingModule = response;
                vm.totalSlides = trainingModule.Topics.length - 2;
                vm.currentTopic = _lodash2.default.find(response.Topics, function (r) {
                    return r.IsCurrent === true;
                });
            });
        });
    }

    function scrollToTop() {
        angular.element($document[0].querySelector('.modal-content'))[0].scrollTop = 0;
    }
}

/***/ }),
/* 759 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = trainingFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

trainingFactory.$inject = ['$http', '$q', 'HPConfig', 'HPTrainingType']; // angular
// 	.module("HeroPRO")
// 	.factory("TrainingFactory", trainingFactory);

/* @ngInject */
function trainingFactory($http, $q, HPConfig, HPTrainingType) {
    return {
        getPages: getPages,
        getContractorType: getContractorType,
        complete: complete
    };

    function getPages(type) {
        var questions = $q(function (resolve) {
            getQuestions(type).then(function (response) {
                var q = {
                    TrainingModule: response.TrainingModule,
                    ContractorTrainingId: response.ContractorTrainingId,
                    Topics: []
                };

                for (var y = 0; y < response.Topics.length; y++) {
                    q.Topics.push({
                        ContractorTrainingTopicId: response.Topics[y].ContractorTrainingTopicId,
                        TemplateName: response.Topics[y].Topic,
                        templateUrl: 'app/notificationCenter/modal/training/' + formatTemplateName(response.Topics[y].Topic) + '/' + formatTemplateName(response.Topics[y].Topic) + '.html',
                        Questions: response.Topics[y].Questions,
                        SectionNumber: response.Topics[y].SectionNumber,
                        Answers: response.Topics[y].Answers,
                        CorrectAnswer: response.Topics[y].CorrectAnswer,
                        SelectedAnswer: null,
                        IsCurrent: y === 0,
                        prev: y === 0 || y === 1 ? null : response.Topics[y - 1].Topic,
                        next: y === response.Topics.length - 1 || y + 1 > response.Topics.length - 1 ? null : response.Topics[y + 1].Topic
                    });
                }

                addTrainingComplete(q);

                resolve(q);
            });
        });

        return questions;
    }

    function complete() {
        var result = $q(function (resolve, reject) {
            $http.post(HPConfig.heroProApi + 'ActionItem/CompleteTrainingActionItem').then(function (response) {
                resolve(response);
            }, function (error) {
                reject(error);
            });
        });

        return result;
    }

    function getContractorType(userLocations) {
        return $q.when(userLocations, function (locations) {
            return processLocations(locations);
        });
    }

    /*= ========================================
    =            Private Functions            =
    ========================================= */

    function getQuestions(type) {
        var results = $q(function (resolve) {
            $http.get(HPConfig.heroProApi + 'Contractor/GetContractorTrainingProduct', { params: { ModuleType: type } }).then(function (response) {
                var data = response.data.Data;

                var qS = {
                    ContractorTrainingId: 0,
                    TrainingModule: null,
                    Topics: []
                };
                qS.ContractorTrainingId = data.ContractorTrainingId;
                qS.TrainingModule = data.Name;

                _lodash2.default.each(data.Topics, function (t) {
                    qS.Topics.push({
                        Topic: t.TemplateName,
                        SectionNumber: t.ContractorTrainingProductModuleId,
                        ContractorTrainingTopicId: t.ContractorTrainingTopicId,
                        Questions: !!t.Questions ? { Question: t.Questions[0].Question, ContractorTrainingQuestionId: t.Questions[0].ContractorTrainingQuestionId, IsActive: t.Questions[0].IsActive } : null,
                        Answers: !!t.Questions && t.Questions[0].Answers ? t.Questions[0].Answers : null,
                        CorrectAnswer: !!t.Questions && t.Questions[0].Answers ? _lodash2.default.find(t.Questions[0].Answers, function (a) {
                            return a.IsCorrectResponse === true;
                        }) : null
                    });
                });

                resolve(qS);
            });
        });

        return results;
    }

    function formatTemplateName(name) {
        return name.charAt(0).toLowerCase() + name.slice(1);
    }

    function addTrainingComplete(trainings) {
        trainings.Topics[trainings.Topics.length - 1].next = 'complete';
        trainings.Topics.push({
            ContractorTrainingTopicId: null,
            TemplateName: 'complete',
            templateUrl: 'app/notificationCenter/modal/training/complete/complete.html',
            Questions: [],
            Answers: [],
            CorrectAnswer: [],
            SelectedAnswer: null,
            IsCurrent: false,
            onEnter: function onEnter() {
                return complete();
            },

            prev: trainings.Topics[trainings.Topics.length - 1].Topic,
            next: null
        });
    }

    function processLocations(locations) {
        var isHero = null;
        var isBenji = null;
        var type = HPTrainingType.BENJI;
        // const users = _.filter(locations, u => u.hasOwnProperty('FinancingProducts'));

        // _.each(users, (value) => {
        //     if (!isHero && _.contains(value.FinancingProducts, 'HERO')) {
        //         isHero = true; // _.contains(value, "HERO");
        //     }
        //     if (!isBenji && _.contains(value.FinancingProducts, 'BENJI')) {
        //         isBenji = true; // _.contains(value, "BENJI");
        //     }
        // });

        // if (!isHero && isBenji) {
        //     type = HPTrainingType.BENJI;
        // } else if (isHero && !isBenji) {
        //     type = HPTrainingType.HERO;
        // }

        return type;
    }
}

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = benjiController;
benjiController.$inject = ["$scope"];
// angular
// 	.module("HeroPRO")
// 	.controller("BenjiController", benjiController);

/* @ngInject */
function benjiController($scope) {
    var vm = this;
    vm.showBenjiPt1 = true;
    vm.totalSlides = $scope.totalSlides;

    vm.next = function () {
        if (!vm.showBenjiPt1) {
            //$scope.training.complete();
            $scope.training.next();
        } else {
            vm.showBenjiPt1 = !vm.showBenjiPt1;
            $scope.training.scrollToTop();
        }
    };

    vm.prev = function () {
        if (vm.showBenjiPt1) {
            $scope.training.prev();
        } else {
            vm.showBenjiPt1 = !vm.showBenjiPt1;
            $scope.training.scrollToTop();
        }
    };
}

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = guidelinesController;
guidelinesController.$inject = ["$scope"];
// angular
// 	.module("HeroPRO")
// 	.controller("GuidelinesController", guidelinesController);

/* @ngInject */
function guidelinesController($scope) {
    var vm = this;
    vm.showPart1 = true;

    vm.next = function () {
        if (!vm.showPart1) {
            $scope.training.next();
        } else {
            vm.showPart1 = !vm.showPart1;
            $scope.training.scrollToTop();
        }
    };

    vm.prev = function () {
        if (vm.showPart1) {
            $scope.training.prev();
        } else {
            vm.showPart1 = !vm.showPart1;
            $scope.training.scrollToTop();
        }
    };

    vm.init = function () {
        if ($scope.training.prevTopic.TemplateName === $scope.training.currentTopic.next) {
            vm.showPart1 = false;
        }
    };
}

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = HeroProgramController;
HeroProgramController.$inject = ["$scope"];
// angular
// 	.module("HeroPRO")
// 	.controller("HeroProgramController", heroProgramController);

/* @ngInject */
function HeroProgramController($scope) {
    var vm = this;
    vm.showHeroProgramPt1 = true;
    vm.showHeroProgramPt2 = false;

    vm.prev = function () {
        if (vm.showHeroProgramPt1) {
            $scope.training.prev();
        } else {
            vm.showHeroProgramPt1 = true;
            vm.showHeroProgramPt2 = !vm.showHeroProgramPt2;
            $scope.training.scrollToTop();
        }
    };

    vm.next = function () {
        if (vm.showHeroProgramPt2) {
            $scope.training.next();
        } else {
            vm.showHeroProgramPt2 = true;
            vm.showHeroProgramPt1 = !vm.showHeroProgramPt2;
            $scope.training.scrollToTop();
        }
    };

    vm.init = function () {
        if ($scope.training.prevTopic.TemplateName === $scope.training.currentTopic.next) {
            vm.showHeroProgramPt1 = false;
        }
    };
}

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = completeController;
completeController.$inject = ['NotificationCenterFactory', '$rootScope'];
// angular
// .module("HeroPRO")
// .controller("CompleteController", completeController);

/* @ngInject */
function completeController(NotificationCenterFactory, $rootScope) {
    var vm = this;

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.doneClicked = function () {
        $rootScope.$broadcast('notificationCompleted');
        $rootScope.$broadcast('closeNotificationModal');
    };
    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */

    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports = "<div class=\"required-training\" ng-controller=\"TrainingController as training\">\n    <div ng-include=\"training.currentTopic.templateUrl\"></div>\n</div>";

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports = "<div class=\"benji\" ng-controller=\"BenjiController as benji\">\n    <div class=\"benji-pt1-container\" ng-show=\"benji.showBenjiPt1\">\n        <div class=\"header\">\n            <div class=\"row\">\n                <div class=\"col-xs-12\">\n                    <div class=\"header\">\n                        <p class=\"bold\">Section {{ training.currentTopic.SectionNumber }}</p>\n                        <h3>Offer Benji Financing</h3>\n                        <p class=\"bold\">{{ training.getCurrentSlideNumber() }}a of {{ training.totalSlides }}</p>\n                    </div>\n                </div>\n            </div>\n        </div>\n        \n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div class=\"paragraph\">\n                    <p class=\"bold\">\n                        What is Benji?\n                    </p>\n                    <p>\n                        Benji is a dynamic and flexible financing option that provides \n                        contractors and homeowners financing for any type of home improvement project. \n                    </p>\n                    <p>\n                        With Benji, you can extend credit to homeowners through the use of promissory note or a retail \n                        installment contract, which is then assigned to Finance of America Home Improvement, a trade name of Finance of America Mortgage LLC. \n                    </p>\n                </div>\n                <div class=\"paragraph\">\n                    <p class=\"bold\">\n                        Familiarize yourself with the details of all offerings\n                    </p>\n                    <p>\n                        Since Benji has several financing term options, you must be able to clearly and \n                        accurately explain the terms of all available plans to homeowners to help avoid \n                        confusion.\n                    </p>\n                    <p>\n                        We’re here to help train you on the specific of Benji and its special financing \n                        plans. \n                    </p>\n                </div>\n            </div>\n        </div>\n    </div>\n    \n    <div class=\"benji-pt2-container\" ng-show=\"!benji.showBenjiPt1\">\n        <div class=\"header\">\n            <div class=\"row\">\n                <div class=\"col-xs-12\">\n                    <div class=\"header\">\n                        <p class=\"bold\">Section {{ training.currentTopic.SectionNumber }}</p>\n                        <h3>Offer Benji Financing</h3>\n                        <p class=\"bold\">{{ training.getCurrentSlideNumber() }}b of {{ training.totalSlides }}</p>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div class=\"paragraph-container\">\n                    <div class=\"paragraph\">\n                        <p class=\"bold\">\n                        Follow the rules and regs\n                        </p>\n                        <p>\n                            Because you are originating credit to homeowners, you must ensure that you’re \n                            complying with local, state, and federal laws that apply to credit transactions. \n                            These include the federal Truth in Lending Act and the Equal Credit Opportunity \n                            Act, so you should familiarize yourself with the requirements under these laws. \n                        </p>\n                    </div>\n                    <div class=\"paragraph\">\n                        <p class=\"bold\">\n                        Check IDs\n                        </p>\n                        <p>\n                            Don’t run a Benji application if the information on the identification doesn’t \n                            match what they’ve provided on the application.\n                        </p>\n                    </div>\n                    <div class=\"paragraph\">\n                        <p class=\"bold\">\n                        Avoid extra fees\n                        </p>\n                        <p>\n                            We prohibit charging any fees or extra costs for financing their project \n                            through Benji. \n                        </p>\n                    </div>\n                </div>\n            </div>\n        </div>\n        \n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <hp-training-q-and-a current=\"training.currentTopic\" parent-class=\"benji\"></hp-training-q-and-a>\n            </div>\n        </div>\n    </div>\n    \n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <div class=\"benji-btn-container\" ng-class=\"{'add-margin-top': !benji.showBenjiPt1}\">\n                <hp-training-btn advance=\"benji.next();\" retreat=\"benji.prev();\" validate=\"!benji.showBenjiPt1\" current=\"training.currentTopic\" parent-class=\"benji\"></hp-training-btn>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 767 */
/***/ (function(module, exports) {

module.exports = "<div class=\"complete\" ng-controller=\"CompleteController as complete\">\n    <div class=\"row\">\n        <div class=\"col-xs-12 text-center\">\n            <div class=\"icon-check-circle-thin\"></div>\n            <div class=\"success-container\">\n                <h3>Success, you've completed our required training!</h3>\n                <p>This is an annual training, so we'll let you know when it's time to take it again.</p>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"row\">\n        <div class=\"col-xs-12 text-center\">\n            <button class=\"btn btn-primary\" ng-click=\"complete.doneClicked()\">Done</button>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 768 */
/***/ (function(module, exports) {

module.exports = "<div class=\"concerns\">\n    <div class=\"header\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div class=\"header\">\n                    <p class=\"bold\">Section {{ training.currentTopic.SectionNumber }}</p>\n                    <h3>Interacting with homeowners</h3>\n                    <p class=\"bold\">{{ training.getCurrentSlideNumber() }} of {{ training.totalSlides }}</p>\n                </div>\n            </div>\n        </div>\n    </div>\n    \n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <div class=\"paragraph-container\">\n                <div class=\"paragraph\">\n                    <p class=\"bold\">\n                        Respond to concerns \n                    </p>\n                    <p>\n                        All disputes between homeowners and registered contractors must be addressed by the registered contractor. \n                        We understand that some disputes may be difficult to resolve, but also expect you to fully investigate complaints, \n                        and make every reasonable effort to address any legitimate concerns that homeowners may have.\n                    </p>\n                </div>\n                <div class=\"paragraph\">\n                    <p>\n                        We’re here to assist with resolving disputes, if needed, and can also help with training on how to address common \n                        customer complaints. \n                    </p>\n                </div>\n            </div>\n        </div>\n    </div>\n    \n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <hp-training-q-and-a current=\"training.currentTopic\" parent-class=\"concerns\"></hp-training-q-and-a>\n        </div>\n    </div>\n    \n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <hp-training-btn advance=\"training.next();\" retreat=\"training.prev();\" validate=\"true\" current=\"training.currentTopic\" parent-class=\"concerns\"></hp-training-btn>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports = "<div class=\"deliver\">\n    <div class=\"header\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div class=\"header\">\n                    <p class=\"bold\">Section {{ training.currentTopic.SectionNumber }}</p>\n                    <h3>First, here are the basic things we require</h3>\n                    <p class=\"bold\">{{ training.getCurrentSlideNumber() }} of {{ training.totalSlides }}</p>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <p>All registered contractors and all individuals who perform services for registered contractors in connection with Finance of America Home Improvement’s financing products must do the following.</p>\n            <div class=\"ul-container\">\n                <ul>\n                    <li>\n                        Register with Finance of America,\n                    </li>\n                    <li>\n                        Adhere to our Code of Conduct, which is designed to support and guide you as you work with us.\n                    </li>\n                    <li>\n                        Comply with our contractor Terms and Conditions,\n                    </li>\n                    <li>\n                        Act responsibly and professionally when offering financing to homeowners,\n                    </li>\n                    <li>\n                        Complete the following training course on some of our most important compliance expectations. \n                    </li>\n                </ul>\n            </div>\n            <p>Next, we’ll walk you through the training course. Once you’ve gone through the four sections and answered a few questions, you’ll be ready for business!</p>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <div class=\"deliver-btn-container\">\n                <button class=\"btn btn-primary\" ng-click=\"training.next();\">\n                    Next\n                </button>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 770 */
/***/ (function(module, exports) {

module.exports = "<div class=\"elders\">\n\n    <div class=\"header\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div class=\"header\">\n                    <p class=\"bold\">Section {{ training.currentTopic.SectionNumber }}</p>\n                    <h3>Interacting with homeowners</h3>\n                    <p class=\"bold\">{{ training.getCurrentSlideNumber() }} of {{ training.totalSlides }}</p>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <div class=\"paragraph-container\">\n                <div class=\"paragraph\">\n                    <p class=\"bold\">Respect elders</p>\n                    <p>\n                        Elderly individuals are more vulnerable to deceptive and abusive practices, so we closely monitor any transactions with them. As a rule of thumb, you should treat elders with heightened respect, like you would treat your own family members. Be aware of their ability to understand the project and financing details, confirm that they can make payments, and do not pressure them during a sale. If you have any concerns, see if a family member is available to help them through the process, and contact us immediately.\n                    </p>\n                </div>\n            </div>\n        </div>\n    </div>\n    \n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <hp-training-q-and-a current=\"training.currentTopic\" parent-class=\"elders\"></hp-training-q-and-a>\n        </div>\n    </div>\n    \n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <hp-training-btn advance=\"training.next();\" retreat=\"training.prev();\" validate=\"true\" current=\"training.currentTopic\" parent-class=\"elders\"></hp-training-btn>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 771 */
/***/ (function(module, exports) {

module.exports = "<div class=\"guidelines\" ng-controller=\"GuidelinesController as guidelines\" ng-init=\"guidelines.init();\" ng-cloak>\n    <div class=\"guidelines-pt-1-container\" id=\"div-guidelines-pt-1\" ng-if=\"guidelines.showPart1\">\n        <div class=\"header\">\n            <div class=\"row\">\n                <div class=\"col-xs-12\">\n                    <div class=\"header\">\n                        <p class=\"bold\">Section {{ training.currentTopic.SectionNumber }}</p>\n                        <h3>Using your Finance of America Home Improvement account</h3>\n                        <p class=\"bold\">{{ training.getCurrentSlideNumber() }}a of {{ training.totalSlides }}</p>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div class=\"paragraph\">\n                    <p class=\"bold\">Use tools as intended</p>\n                    <p>By registering with us, you have access to sophisticated sales tools. \n                    We provide these to help you identify potential customers and to explain the potential benefits of our financing products. </p>\n                    <p>To make sure our tools are being used as intended, we may monitor your usage. \n                    If we identify attempts to coerce, mislead, or deceive a potential customer, your account will be terminated. </p>\n                </div>\n                <div class=\"paragraph\">\n                    <p class=\"bold\">Keep personal info safe</p>\n                    <p>You can use your Finance of America Home Improvement account to monitor your pipeline of projects, \n                    which includes info about your customers and their financing. \n                    Remember that this personal information is sensitive and should not be shared or used for any reason beyond managing and completing your projects. </p>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"guidelines-pt-2-container\" id=\"div-guidelines-pt-2\" ng-show=\"!guidelines.showPart1\">\n        <div class=\"header\">\n            <div class=\"row\">\n                <div class=\"col-xs-12\">\n                    <div class=\"header\">\n                        <p class=\"bold\">Section {{ training.currentTopic.SectionNumber }}</p>\n                        <h3>Using your Finance of America Home Improvement account</h3>\n                        <p class=\"bold\">{{ training.getCurrentSlideNumber() }}b of {{ training.totalSlides }}</p>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div class=\"guidelines-pt-2-paragraph paragraph-container\">\n                    <div class=\"paragraph\">\n                        <p class=\"bold\">Never share your login</p>\n                        <p>Under no circumstance should any unregistered individual be permitted to access the account of a registered user. \n                        Sharing usernames and passwords is strictly prohibited.  </p>\n                        <p>If you suspect that your account has been accessed by an unauthorized user, notify us immediately.</p>\n                    </div>\n                </div>\n            </div>\n        </div>\n        \n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <hp-training-q-and-a current=\"training.currentTopic\" parent-class=\"guidelines\"></hp-training-q-and-a>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <div class=\"guidelines-btn-container\" ng-class=\"{'no-margin-top': !guidelines.showPart1}\">\n                <hp-training-btn advance=\"guidelines.next();\" retreat=\"guidelines.prev();\" validate=\"!guidelines.showPart1\" current=\"training.currentTopic\" parent-class=\"guidelines\"></hp-training-btn>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 772 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hero-program\" ng-controller=\"HeroProgramController as hero\" ng-init=\"hero.init();\" ng-cloak>\n    <div class=\"hero-program-pt-1-container\" ng-if=\"hero.showHeroProgramPt1\">\n        <div class=\"header\">\n            <div class=\"row\">\n                <div class=\"col-xs-12\">\n                    <div class=\"header\">\n                        <p class=\"bold\">Section {{ training.currentTopic.SectionNumber }}</p>\n                        <h3>Talking about the HERO Program</h3>\n                        <p class=\"bold\">{{ training.getCurrentSlideNumber() }}a of {{ training.totalSlides }}</p>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div class=\"paragraph-container\">\n                    <div class=\"paragraph\">\n                        <p class=\"bold\">PACE Programs and Assessment Contracts</p>\n                        <p class=\"paragraph\">\n                            In this section, we will provide some basic background regarding PACE programs, \n                            which includes a brief explanation of PACE programs and assessment contracts.\n                        </p>\n\n                        <p class=\"paragraph\">\n                            PACE is an acronym which stands for Property Assessed Clean Energy.  \"Property Assessed\" \n                            refers to how customers pay, via a line item on their property tax bill.\n                            \"Clean Energy\" refers generally to the types of home improvements that are eligible to \n                            be financed this way.\n                        </p class=\"paragraph\">\n                        \n                        <p class=\"paragraph\">\n                            Sponsoring public agencies play a role in making PACE possible. Municipalities must affirmatively \n                            permit PACE to be offered in their jurisdictions, creating a public-private partnership between\n                            them(the issuer) and the PACE provider (HERO).\n                        </p>\n\n                        <p class=\"paragraph\">\n                            PACE programs provide an avenue for these communities and their homeowners to experience public\n                            benefits like job creation, energy and water savings, reduction of greenhouse gas emissions,\n                            disaster hardening and resiliency measures, etc.\n                        </p>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n        \n    <div class=\"hero-program-pt-2-container\" ng-if=\"!hero.showHeroProgramPt1\">\n            <div class=\"header\">\n                <div class=\"row\">\n                    <div class=\"col-xs-12\">\n                        <div class=\"header\">\n                            <p class=\"bold\">Section {{ training.currentTopic.SectionNumber }}</p>\n                            <h3>PACE Programs and Assessment Contracts</h3>\n                            <p class=\"bold\">{{ training.getCurrentSlideNumber() }}b of {{ training.totalSlides }}</p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div class=\"paragraph-container\">\n                    <div>\n                        <p class=\"paragraph\">\n                            Qualifying homeowners who want to pay for eligible improvements like these using a PACE program\n                            to provide their project financing will sign an assessment contract.\n                        </p>\n\n                        <p class=\"paragraph\">\n                            This document, which contains details about the project, applicable financing terms and disclosures,\n                            is recorded with the county and places a first-position lien on the property.  This means that the \n                            outstanding balance PACE assessment is coequal to that of the rest of the property taxes.\n                            Homeowners should understand the consequences and risks of their PACE financing being in the first\n                            lien position.\n                        </p>\n\n                        <p class=\"paragraph\">\n                            This may have an effect on transferability in transactions like a sale or refinance. Although PACE assessments\n                            may be able to transfer to the new owner upon sale of a property, property owners who sell or refinance may be\n                            required by the buyer's lender or refinancing lender to repay their assessments at the time of closing.\n                            I fan installment of the PACE assessment is not paid when it is due, the issuer has the right to have the delinquent\n                            installment, plus penalties and interest, taken off the tax roll and enforced through a judicial fore closure action.\n                            This could result in the sale of the property for payment.\n                        </p>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"row\">\n                <div class=\"col-xs-12\">\n                    <hp-training-q-and-a current=\"training.currentTopic\" parent-class=\"hero-program-pt-2-container\"></hp-training-q-and-a>\n                </div>\n            </div>\n    </div>\n\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <hp-training-btn advance=\"hero.next();\" retreat=\"hero.prev();\" validate=\"false\" parent-class=\"hero-program\"></hp-training-btn>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 773 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hero-table\">\n    <div class=\"header\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div class=\"header\">\n                    <p class=\"bold\">Section {{ training.currentTopic.SectionNumber }}</p>\n                    <h3>Talking about the HERO Program</h3>\n                    <p class=\"bold\">{{ training.getCurrentSlideNumber() }} of {{ training.totalSlides }}</p>\n                </div>\n            </div>\n        </div>\n    </div>\n    \n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <hp-training-q-and-a current=\"training.currentTopic\" parent-class=\"hero-table\" class=\"no-top-margin\"></hp-training-q-and-a>\n        </div>\n    </div>\n    \n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <div class=\"hero-table-btn-container\">\n                <hp-training-btn advance=\"training.next();\" retreat=\"training.prev();\" validate=\"true\" current=\"training.currentTopic\" parent-class=\"hero-table\"></hp-training-btn>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 774 */
/***/ (function(module, exports) {

module.exports = "<div class=\"interacting\">\n\n    <div class=\"header\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div class=\"header\">\n                    <p class=\"bold\">Section {{ training.currentTopic.SectionNumber }}</p>\n                    <h3>Interacting with homeowners</h3>\n                    <p class=\"bold\">{{ training.getCurrentSlideNumber() }} of {{ training.totalSlides }}</p>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <div class=\"paragraph-container\">\n                <div class=\"paragraph\">\n                    <p class=\"bold\">Handle applications with care</p>\n                    <p>\n                        Remember, the decision to apply for financing is the homeowner’s, not yours. \n                        All applications must be completed and submitted by homeowners at their choosing, without pressure from anyone else. \n                        No personal information contained in applications, like birthdate and Social Security number, can be shared or stored outside of the application.\n                    </p>\n                </div>\n                <div class=\"paragraph\">\n                    <p class=\"bold\">Never force or forge a signature</p>\n                    <p>\n                        Financing documents must be signed by the homeowner. \n                        It’s never acceptable to sign any documents on their behalf, even if the homeowner gives permission to do so, or to pressure them to sign any documents, \n                        including completion certificates. Homeowners must be given adequate time to read and sign their financing documents, and to get any questions answered \n                        by us before they decide to sign. \n                    </p>\n                </div>\n            </div>\n        </div>\n    </div>\n    \n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <hp-training-q-and-a current=\"training.currentTopic\" parent-class=\"interacting\"></hp-training-q-and-a>\n        </div>\n    </div>\n    \n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <hp-training-btn advance=\"training.next();\" retreat=\"training.prev();\" validate=\"true\" current=\"training.currentTopic\" parent-class=\"interacting\"></hp-training-btn>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 775 */
/***/ (function(module, exports) {

module.exports = "<div class=\"practices\">\n    <div class=\"header\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div class=\"header\">\n                    <p class=\"bold\">Section {{ training.currentTopic.SectionNumber }}</p>\n                    <h3>Interacting with homeowners</h3>\n                    <p class=\"bold\">{{ training.getCurrentSlideNumber() }} of {{ training.totalSlides }}</p>\n                </div>\n            </div>\n        </div>\n    </div>\n    \n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <div class=\"paragraph-container\">\n                <div class=\"paragraph\">\n                    <p class=\"bold\">Follow honest sales practices</p>\n                    <p>\n                        All individuals registered with Finance of America Home Improvement are required to treat homeowners with respect, and to be honest about project pricing, improvements installed, and any estimated utility savings. Misrepresenting improvements or costs, including financing terms, can result in account termination.\n                    </p>\n                    <p>\n                        We prohibit price gouging, as well as any deceptive pricing and sales strategies. We encourage you to provide competitive pricing to homeowners, which improves close rates, provides higher customer satisfaction, and ultimately leads to more customer referrals. Keep in mind, we have the right to inspect all projects and products installed to verify pricing and work quality. \n                    </p>\n                </div>\n            </div>\n        </div>\n    </div>\n    \n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <hp-training-q-and-a current=\"training.currentTopic\" parent-class=\"practices\"></hp-training-q-and-a>\n        </div>\n    </div>\n    \n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <hp-training-btn advance=\"training.next();\" retreat=\"training.prev();\" validate=\"true\" current=\"training.currentTopic\" parent-class=\"practices\"></hp-training-btn>\n        </div>\n    </div>\n\n</div>\n";

/***/ }),
/* 776 */
/***/ (function(module, exports) {

module.exports = "<div class=\"welcome\">\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <div class=\"welcome-header text-center\">\n                <h3>Welcome!</h3>\n                <p>We’re proud to support the home improvement industry by providing home financing through a variety of financing products. \n                Finance of America Home Improvement offers advanced contractor sales tools, industry-leading consumer safeguards, and dedicated support seven days a week.</p>\n                <p>To deliver the highest level of service to you and to homeowners through these programs, we’d like to go over some expectations we have of you. </p>\n            </div>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <div class=\"welcome-btn-container\">\n                <button class=\"btn btn-primary\" ng-click=\"training.next();\">\n                    Get Started\n                </button>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 777 */
/***/ (function(module, exports) {

module.exports = "<div class=\"fraudPrevention\">\n    <div class=\"header\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div class=\"header\">\n                    <p class=\"bold\">Section {{ training.currentTopic.SectionNumber }}</p>\n                    <h3>Fraud Prevention</h3>\n                    <p class=\"bold\">{{ training.getCurrentSlideNumber() }} of {{ training.totalSlides }}</p>\n                </div>\n            </div>\n        </div>\n    </div>\n    \n        \n    <div class=\"row\">\n            <div class=\"col-xs-12\">\n        <p>\n            In this section, we will review some specifics about preventing fraud and making fraudulent claims in the sales process.\n        </p>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <p>\n                Never inaccurately market, communicate, or represent the government sponsorship of PACE.  \n                This includes claims that PACE is a free government program or a public assistance program, \n                or implications that PACE does not involve a financial obligation to be repaid by the customer.  \n                These activities are strictly prohibited.\n            </p>\n            <p>\n                Never attempt to explain or represent the tax benefits of PACE, or provide any type of tax advice.  \n                Direct your customers to consult with their tax advisor regarding any potential tax benefits that may apply to their PACE financing.  \n            </p>\n            <p>\n                Always follow sound and compliant practices when dealing with customer information and identification.  \n            </p>\n            <p>\n                Always report any suspected fraud to the proper channels.  \n            </p>\n        </div>\n\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <hp-training-q-and-a current=\"training.currentTopic\" parent-class=\"fraudPrevention\"></hp-training-q-and-a>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <hp-training-btn advance=\"training.next();\" retreat=\"training.prev();\" validate=\"true\" current=\"training.currentTopic\" parent-class=\"fraudPrevention\"></hp-training-btn>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 778 */
/***/ (function(module, exports) {

module.exports = "<div class=\"fraudPrevention2\">\n    <div class=\"header\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div class=\"header\">\n                    <p class=\"bold\">Section {{ training.currentTopic.SectionNumber }}</p>\n                    <h3>Fraud Prevention</h3>\n                    <p class=\"bold\">{{ training.getCurrentSlideNumber() }} of {{ training.totalSlides }}</p>\n                </div>\n            </div>\n        </div>\n    </div>\n    \n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <hp-training-q-and-a current=\"training.currentTopic\" parent-class=\"fraudPrevention2\"></hp-training-q-and-a>\n        </div>\n    </div>\n\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <hp-training-btn advance=\"training.next();\" retreat=\"training.prev();\" validate=\"true\" current=\"training.currentTopic\" parent-class=\"fraudPrevention2\"></hp-training-btn>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 779 */
/***/ (function(module, exports) {

module.exports = "<div class=\"fraudPrevention3\">\n    <div class=\"header\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div class=\"header\">\n                    <p class=\"bold\">Section {{ training.currentTopic.SectionNumber }}</p>\n                    <h3>Fraud Prevention</h3>\n                    <p class=\"bold\">{{ training.getCurrentSlideNumber() }} of {{ training.totalSlides }}</p>\n                </div>\n            </div>\n        </div>\n    </div>\n    \n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <hp-training-q-and-a current=\"training.currentTopic\" parent-class=\"fraudPrevention3\"></hp-training-q-and-a>\n        </div>\n    </div>\n\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <hp-training-btn advance=\"training.next();\" retreat=\"training.prev();\" validate=\"true\" current=\"training.currentTopic\" parent-class=\"fraudPrevention3\"></hp-training-btn>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 780 */
/***/ (function(module, exports) {

module.exports = "<div class=\"paceDisclosures\">\n    <div class=\"header\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div class=\"header\">\n                    <p class=\"bold\">Section {{ training.currentTopic.SectionNumber }}</p>\n                    <h3>PACE Disclosures</h3>\n                    <p class=\"bold\">{{ training.getCurrentSlideNumber() }} of {{ training.totalSlides }}</p>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n        <p>In this section, we will provide an overview of PACE disclosures and how they are provided to the homeowner. </p>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <p>Key financial disclosures of the PACE financing include the annual assessment cost, the term of the assessment contract, \n                the applicable fees and interest, the assessment repayment process, and the consequences of non-payment.\n            </p>\n            <p>The disclosures are reflected in the financing documentation provided to the customer by the PACE provider; \n                these include documents like the assessment contract, financing estimate and disclosure, and right to cancel form.  \n            </p>\n            <p>The disclosures are also provided to the customer during a recorded oral confirmation \n                call during which the PACE provider confirms with the customer their understanding of these disclosures.  \n                This will occur before the customer signs the assessment contract.\n            </p>\n            <p>Any time that the customer needs help understanding their disclosures, \n                you should refer them to the PACE provider for detailed answers.  \n            </p>\n        </div>\n\n        <div class=\"row\">\n                <div class=\"col-xs-12\">\n                    <hp-training-q-and-a current=\"training.currentTopic\" parent-class=\"paceDisclosures\"></hp-training-q-and-a>\n                </div>\n            </div>\n    </div>\n    \n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <hp-training-btn advance=\"training.next();\" retreat=\"training.prev();\" validate=\"true\" current=\"training.currentTopic\" parent-class=\"concerns\"></hp-training-btn>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 781 */
/***/ (function(module, exports) {

module.exports = "<div class=\"paceDisclosures2\">\n    <div class=\"header\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div class=\"header\">\n                    <p class=\"bold\">Section {{ training.currentTopic.SectionNumber }}</p>\n                    <h3>PACE Disclosures</h3>\n                    <p class=\"bold\">{{ training.getCurrentSlideNumber() }} of {{ training.totalSlides }}</p>\n                </div>\n            </div>\n        </div>\n    </div>\n    \n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <hp-training-q-and-a current=\"training.currentTopic\" parent-class=\"paceDisclosures2\"></hp-training-q-and-a>\n        </div>\n    </div>\n\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <hp-training-btn advance=\"training.next();\" retreat=\"training.prev();\" validate=\"true\" current=\"training.currentTopic\" parent-class=\"paceDisclosures2\"></hp-training-btn>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 782 */
/***/ (function(module, exports) {

module.exports = "<div class=\"ethics\">\n    <div class=\"header\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div class=\"header\">\n                    <p class=\"bold\">Section {{ training.currentTopic.SectionNumber }}</p>\n                    <h3>Ethics</h3>\n                    <p class=\"bold\">{{ training.getCurrentSlideNumber() }} of {{ training.totalSlides }}</p>\n                </div>\n            </div>\n        </div>\n    </div>\n    \n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n        <p>\n            In this section, we will review some of the key expectations we have of our contractor sales reps' ethics.  \n            This is not a comprehensive list.  You should comply with your terms and conditions, code of conduct, \n            and applicable local and federal laws and ordinances.  \n        </p>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <p>Always avoid conflicts of interest that may lead to actions that are not in compliance with \n                applicable law or regulations, or prohibit you from acting ethically and in good faith.  \n            </p>\n            <p>Be transparent in all dealings with customers and maintain the highest standards of \n                integrity in all business dealings  \n            </p>\n            <p>Never receive payment, or other items of material value, from a PACE provider that is \n                in excess of the amount charged to the customer for their project.\n            </p>\n            <p>Never charge a customer a different price for a home improvement project financed \n                by a PACE assessment than you would charge if that project were paid in cash. \n            </p>\n            <p>Always maintain an ethical sales process.  Pressure, intimidation and any other tactics that \n                limit a customer from exercising their rights should never be used.  This includes, but is not \n                limited to, bait-and-switch sales tactics and similarly misleading sales tactics.\n            </p>\n            <p>Remember, failure to act ethically may lead to legal liability, consumer harm, and reputational \n                harm to your business.  It may also result in the loss of your privilege to offer PACE \n                financing to your customers.\n            </p>\n        </div>\n\n        <div class=\"row\">\n                <div class=\"col-xs-12\">\n                    <hp-training-q-and-a current=\"training.currentTopic\" parent-class=\"ethics\"></hp-training-q-and-a>\n                </div>\n            </div>\n    </div>\n    \n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <hp-training-btn advance=\"training.next();\" retreat=\"training.prev();\" validate=\"true\" current=\"training.currentTopic\" parent-class=\"concerns\"></hp-training-btn>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 783 */
/***/ (function(module, exports) {

module.exports = "<div class=\"ethics2\">\n    <div class=\"header\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div class=\"header\">\n                    <p class=\"bold\">Section {{ training.currentTopic.SectionNumber }}</p>\n                    <h3>Ethics</h3>\n                    <p class=\"bold\">{{ training.getCurrentSlideNumber() }} of {{ training.totalSlides }}</p>\n                </div>\n            </div>\n        </div>\n    </div>\n    \n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <hp-training-q-and-a current=\"training.currentTopic\" parent-class=\"ethics2\"></hp-training-q-and-a>\n        </div>\n    </div>\n\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <hp-training-btn advance=\"training.next();\" retreat=\"training.prev();\" validate=\"true\" current=\"training.currentTopic\" parent-class=\"ethics2\"></hp-training-btn>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 784 */
/***/ (function(module, exports) {

module.exports = "<div class=\"nondiscrimination\">\n    <div class=\"header\">\n            <div class=\"row\">\n                <div class=\"col-xs-12\">\n                    <div class=\"header\">\n                        <p class=\"bold\">Section {{ training.currentTopic.SectionNumber }}</p>\n                        <h3>Nondiscrimination</h3>\n                        <p class=\"bold\">{{ training.getCurrentSlideNumber() }} of {{ training.totalSlides }}</p>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n            <p>\n                In this section, we will review some of the key ways that you can practice nondiscrimination in your sales process.\n            </p>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <p>\n                    Always exercise appropriate levels of care when dealing with customers in vulnerable populations.  \n                    This means someone who, due to their personal circumstances, is especially susceptible to detriment.\n                </p>\n                <p>\n                    Never discriminate on the basis of race, religion, color, marital status, gender, sexual orientation, \n                    national origin, citizenship, presence of children, disability, gender, age, veteran status, \n                    genetic information, ancestry or other protected classes under applicable law.\n                </p>\n            </div>\n    \n            <div class=\"row\">\n                    <div class=\"col-xs-12\">\n                        <hp-training-q-and-a current=\"training.currentTopic\" parent-class=\"nondiscrimination\"></hp-training-q-and-a>\n                    </div>\n                </div>\n        </div>\n        \n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <hp-training-btn advance=\"training.next();\" retreat=\"training.prev();\" validate=\"true\" current=\"training.currentTopic\" parent-class=\"concerns\"></hp-training-btn>\n            </div>\n        </div>\n    </div>";

/***/ }),
/* 785 */
/***/ (function(module, exports) {

module.exports = "<div class=\"seniorAbuse\">\n        <div class=\"header\">\n            <div class=\"row\">\n                <div class=\"col-xs-12\">\n                    <div class=\"header\">\n                        <p class=\"bold\">Section {{ training.currentTopic.SectionNumber }}</p>\n                        <h3>Senior Financial Abuse</h3>\n                        <p class=\"bold\">{{ training.getCurrentSlideNumber() }} of {{ training.totalSlides }}</p>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <p>In this section, we will review some of the key ways that you can avoid and prevent senior financial abuse.</p>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <p>\n                    Activities that may constitute senior financial abuse include, but are not limited to, \n                    predatory or unnecessary lending, identity theft, charitable giving scams, \n                    fraudulent contracts and insurance schemes.\n                </p>\n                <p>\n                    Suggested practices are to:\n                </p>\n                <div class=\"ul-container\">\n                    <ul>\n                        <li>Always ensure that your home improvement contract and sales processes comply with applicable laws and regulations</li>\n                        <li>Always provide, and take the time to explain, key disclosures and project terms</li>\n                        <li>Never exert any undue influence over the customer</li>\n                        <li>Always document the pre- and post-construction site conditions with photographs and \n                            videos to demonstrate that the contract work was truly needed and beneficial to the customer</li>\n                        <li>If concerned about the homeowner's understanding, ask if they would like to have a friend of family member present.</li>\n                    </ul> \n                </div>\n                <p>\n                    Report any actual or suspected physical abuse, abandonment, isolation, financial abuse or neglect which is observed, \n                    evident, or described during the course of dealing with a customer.  Elder abuse concerns should be reported to the \n                    appropriate authorities, and certain parties are required by law to make these reports.\n                </p>\n                <p>\n                    Always report any suspected fraud to the proper channels.  \n                </p>\n\n                <div class=\"paragraph-container\">\n                <p>\n                    <b>Special Note for California Contractors:</b> <br />\n                    Elders have special protections in law. California civil and criminal laws prohibit acts of elder abuse, \n                    such as (but not limited to) physical abuse, neglect, financial abuse, and other treatments resulting in \n                    physical harm, pain or mental suffering of an elder.\n                </p>\n                <p>\n                    Suspected abuse can be reported by contacting Adult Protective Services (APS) agencies in California counties.  \n                    These organizations provide assistance for elder adults (65 years and older) and dependent adults \n                    (ages 18-64 who are disabled) when these adults are unable to meet their own needs, or are victims of abuse, \n                    neglect or exploitation.\n                </p>\n            </div>\n            </div>\n    \n            <div class=\"row\">\n                <div class=\"col-xs-12\">\n                    <hp-training-q-and-a current=\"training.currentTopic\" parent-class=\"seniorAbuse\"></hp-training-q-and-a>\n                </div>\n            </div>\n        </div>\n        \n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <hp-training-btn advance=\"training.next();\" retreat=\"training.prev();\" validate=\"true\" current=\"training.currentTopic\" parent-class=\"concerns\"></hp-training-btn>\n            </div>\n        </div>\n    </div>";

/***/ }),
/* 786 */
/***/ (function(module, exports) {

module.exports = "<div class=\"consumerProtection\">        \n    <div class=\"header\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div class=\"header\">\n                    <p class=\"bold\">Section {{ training.currentTopic.SectionNumber }}</p>\n                    <h3>Consumer Protection</h3>\n                    <p class=\"bold\">{{ training.getCurrentSlideNumber() }} of {{ training.totalSlides }}</p>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row\">\n        <p>\n            In this section, we will review some of the most important ways that you can protect your customers and follow good consumer protection practices.\n        </p>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <p>\n                Always engage in fair trade practices to help protect customers from inaccurate information, \n                lack of options, and unfair pricing in the marketplace.\n            </p>\n            <p>\n                Practices that are unfair, deceptive, abusive, misleading, or that otherwise violate applicable laws \n                or regulations when dealing with customers are prohibited activities.\n \n            </p>\n            <p>\n                Failure to comply with local and federal fair trade laws is a liability; treating customers unfairly may \n                lead to regulatory fines and private actions by aggrieved parties.\n            </p>\n            <p>\n                PACE financing has some built-in consumer protections as well, such as the terms confirmation call mentioned earlier.  \n                Additionally, once the project is complete, the customer will sign a completion certificate which confirms the work \n                was done to their satisfaction; this has to be submitted by the customer, before the contractor gets paid for the work.\n\n            </p>\n        </div>\n\n        <div class=\"row\">\n                <div class=\"col-xs-12\">\n                    <hp-training-q-and-a current=\"training.currentTopic\" parent-class=\"consumerProtection\"></hp-training-q-and-a>\n                </div>\n            </div>\n    </div>\n    \n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <hp-training-btn advance=\"training.next();\" retreat=\"training.prev();\" validate=\"true\" current=\"training.currentTopic\" parent-class=\"concerns\"></hp-training-btn>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 787 */
/***/ (function(module, exports) {

module.exports = "<div class=\"consumerProtection2\">\n    <div class=\"header\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div class=\"header\">\n                    <p class=\"bold\">Section {{ training.currentTopic.SectionNumber }}</p>\n                    <h3>Consumer Protection</h3>\n                    <p class=\"bold\">{{ training.getCurrentSlideNumber() }} of {{ training.totalSlides }}</p>\n                </div>\n            </div>\n        </div>\n    </div>\n    \n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <hp-training-q-and-a current=\"training.currentTopic\" parent-class=\"consumerProtection2\"></hp-training-q-and-a>\n        </div>\n    </div>\n\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <hp-training-btn advance=\"training.next();\" retreat=\"training.prev();\" validate=\"true\" current=\"training.currentTopic\" parent-class=\"consumerProtection2\"></hp-training-btn>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = notificationModalController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(789);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

notificationModalController.$inject = ['$scope', '$uibModalInstance', 'NotificationCenterFactory', 'HPConfig', '$window', '$rootScope', '$analytics', 'TopNavFactory', 'authenticationService', 'UserAuthFactory', '$state']; // angular
// 	.module("HeroPRO")
// 	.controller("NotificationModalController", notificationModalController);

/* @ngInject */
function notificationModalController($scope, $uibModalInstance, NotificationCenterFactory, HPConfig, $window, $rootScope, $analytics, TopNavFactory, authenticationService, UserAuthFactory, $state) {
    var vm = this;

    vm.notifications = [];
    vm.currentTemplate = '';
    vm.canDismissModal = false;
    vm.currentNotification = null;
    vm.toggleClicked = false;
    vm.hisTrainingMandate = {};

    init();
    /*= =======================================
    =            Public Functions            =
    ======================================== */

    vm.completeNotification = function (result) {
        NotificationCenterFactory.setActionItemStatus({
            ActionItemId: vm.currentNotification.ActionItemId,
            ActionItemStatus: 3
        }).then(function () {
            NotificationCenterFactory.markNotificationComplete(vm.currentNotification.ActionItemId);
            vm.currentNotification.isComplete = true;
            NotificationCenterFactory.markNotificationComplete(vm.currentNotification.ActionItemId);
            $uibModalInstance.close({ result: result, errorStatus: null });
            $rootScope.$broadcast('HideMainSpinner');
            window.location.reload();
        });
    };

    vm.closeModal = function (result) {
        $uibModalInstance.close({ result: result, errorStatus: null });
        $rootScope.$broadcast('HideMainSpinner');
        window.location.reload();
    };

    vm.logout = function () {
        $analytics.eventTrack('Logout', {
            category: 'TopNav',
            label: $state.current.name
        });

        TopNavFactory.logout().then(function () {
            authenticationService.logOut();
            UserAuthFactory.deleteAuthorization();

            var logoutUrl = HPConfig.heroProLoginLink;

            logoutUrl += '?logout=true';

            $window.location.href = logoutUrl;
        });
    };
    /* -----  End of Public Functions  ------*/

    /*= ========================================
    =            Private Functions            =
    ========================================= */

    function init() {
        vm.notifications = NotificationCenterFactory.getNotificationData();
        vm.currentNotification = vm.notifications[0];
        NotificationCenterFactory.setActiveNotification(vm.currentNotification);
        vm.canDismissModal = vm.currentNotification.Priority !== 1;
    }
    /* -----  End of Private Functions  ------*/

    /*= ========================================
    =            Pub/Sub Handlers            =
    ========================================= */

    $scope.$on('notificationsMenuClick', function () {
        vm.currentNotification = NotificationCenterFactory.getActiveNotification();
    });

    $scope.$on('notificationCompleted', function () {
        vm.currentNotification.isComplete = true;
        NotificationCenterFactory.markNotificationComplete(vm.currentNotification.ActionItemId);
        vm.currentNotification = NotificationCenterFactory.getActiveNotification();
        vm.canDismissModal = NotificationCenterFactory.getActiveNotification().Priority !== 1;
    });

    $scope.$on('notificationMenuToggleClick', function (evt, data) {
        if (data.hasOwnProperty('toggleClicked')) {
            vm.toggleClicked = data.toggleClicked;
        }
    });

    $scope.$on('closeNotificationModal', function (evt, data) {
        data = data || { result: false, errorStatus: null };
        vm.closeModal(data);
    });

    /* -----  End of Pub/Sub Handlers  ------*/
}

/***/ }),
/* 789 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/bg-grey-column.jpg?bb6d5fe73118638627049c2a2f9d7b4f";

/***/ }),
/* 791 */
/***/ (function(module, exports) {

module.exports = "\n<div class=\"row\">\n    <div class=\"col-xs-12\">\n        <div class=\"modal-header\" id=\"notificationModal-modal-header\">\n            <span class=\"icon icon-close-thin\" ng-if=\"notificationModal.canDismissModal\" ng-click=\"notificationModal.closeModal(false)\"></span>\n            <a href=\"#\" ng-if=\"!notificationModal.canDismissModal\" ng-click=\"notificationModal.logout()\">Logout</a>\n        </div>\n    </div>\n</div>\n\n<div class=\"row\">\n    <div class=\"col-xs-12 notification-modal-content\">\n        <div class=\"notification-menu-column\" ng-class=\"{'nav-toggle-expanded': !notificationModal.toggleClicked}\">\n            <hp-notification-menu notifications=\"notificationModal.notifications\"></hp-notification-menu>\n        </div>\n        <div class=\"notification-content-column\">\n            <div ng-include=\"notificationModal.currentNotification.template\"></div>\n        </div>\n    </div>\n\n</div>";

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = notificationCenterFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

notificationCenterFactory.$inject = ['$http', '$q', 'moment', 'HPConfig', 'HPActionItemStatuses', 'HPActionItemCategories', 'HPNotifications']; // angular
// 	.module("HeroPRO")
// 	.factory("NotificationCenterFactory", notificationCenterFactory);

/* @ngInject */
function notificationCenterFactory($http, $q, moment, HPConfig, HPActionItemStatuses, HPActionItemCategories, HPNotifications) {
    var _notifications = [];
    var _activeNotification = null;

    return {
        getNotifications: getNotifications,
        getNotificationData: getNotificationData,
        markNotificationComplete: markNotificationComplete,
        getActiveNotification: getActiveNotification,
        setActiveNotification: setActiveNotification,
        isLastActiveNotification: isLastActiveNotification,
        setNextNotificationAsActive: setNextNotificationAsActive,
        setActionItemStatus: setActionItemStatus
    };

    function getNotifications() {
        // Pass in contractorId to include action items based on contractorId
        var params = {
            actionItemStatuses: HPActionItemStatuses.Open,
            actionItemCategories: [HPActionItemCategories.Compliance, HPActionItemCategories.Setup]
        };

        return $http.get(HPConfig.heroProApi + 'ActionItem/GetActionItems', { params: params }).then(function (response) {
            return processNotifications(response.data.Data || []);
        });
    }

    function processNotifications(notifications) {
        _notifications = [];
        return $q(function (resolve) {
            _lodash2.default.each(notifications, function (notification) {
                if (notification.PriorityOrder === undefined) {
                    notification.PriorityOrder = 1;
                }
            });

            // We want to sort by Priority first, then by PriorityOrder.
            // To do this using underscore, we use least significant -> most significant
            var sortedNotifications = _lodash2.default.sortBy(_lodash2.default.sortBy(notifications, 'PriorityOrder'), 'Priority');

            _lodash2.default.each(sortedNotifications, function (notification, index) {
                var config = findConfig(notification);

                _notifications.push(_lodash2.default.extend(notification, {
                    Message: notification.CallToActionText,
                    isComplete: false,
                    isActive: index === 0,
                    template: config ? config.template : '',
                    menuText: config ? config.menuText : '',
                    showModal: angular.isDefined(config) ? config.showModal || false : false
                }));

                if (index === 0) {
                    _activeNotification = notification;
                }
            });

            var index = _lodash2.default.findIndex(_notifications, function (notification) {
                return notification.ActionItemTypeId === HPNotifications.DelayedMandatoryTraining.actionItemTypeId;
            });

            if (index > -1) {
                $http.post(HPConfig.heroProApi + 'Contractor/UpdateTrainingDueDate', { data: { DueDate: _notifications[index].DueDate } }).then(function (response) {
                    var data = response.data.Data;
                    if (data.DueDate) {
                        _notifications[index].DaysDueCount = data.DaysDueCount;

                        if (_notifications[index].DaysDueCount < 0) {
                            _notifications[index].showModal = true;
                            _notifications[index].CanBeDismissedByUser = false;
                        }
                    }
                    resolve(_notifications);
                });
            } else {
                resolve(_notifications);
            }
        });
    }

    function getNotificationData() {
        return _lodash2.default.filter(_notifications, function (notification) {
            return notification.isComplete === false;
        }) || [];
    }

    function markNotificationComplete(id) {
        var completedNotification = _lodash2.default.filter(_notifications, function (notification) {
            return notification.ActionItemId === id;
        });
        completedNotification[0].isComplete = true;
        return _notifications;
    }

    function getActiveNotification() {
        return _activeNotification;
    }

    function setActiveNotification(notification) {
        _activeNotification = notification;
    }

    function setNextNotificationAsActive() {
        var currentIndex = _lodash2.default.findIndex(_notifications, function (notification) {
            return notification.ActionItemId === _activeNotification.ActionItemId;
        });

        _notifications[currentIndex].isActive = false;
        setActiveNotification(_notifications[currentIndex + 1]);
        _notifications[currentIndex + 1].isActive = true;
    }

    function isLastActiveNotification() {
        return _activeNotification.ActionItemId === _lodash2.default.last(_notifications).ActionItemId;
    }

    function findConfig(notification) {
        return _lodash2.default.find(HPNotifications, function (notificationConfig) {
            return notificationConfig.actionItemTypeId === notification.ActionItemTypeId;
        });
    }

    function setActionItemStatus(params) {
        return $http({
            url: HPConfig.heroProApi + 'ActionItem/UpdateStatus',
            method: 'POST',
            data: params
        });
    }
}

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = notificationUtilityFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

notificationUtilityFactory.$inject = ['HPNotificationPriority', 'HPNotifications']; // angular
// 	.module("HeroPRO")
// 	.factory("NotificationUtility", notificationUtilityFactory);

/* @ngInject */
function notificationUtilityFactory(HPNotificationPriority, HPNotifications) {
    return {
        buildNotificationConfiguration: buildNotificationConfiguration,
        buildRequiredNotifications: buildRequiredNotifications
    };

    function buildNotificationConfiguration(notifications) {
        var messagePrefix = 'ACTION REQUIRED - ';
        var messages = [];
        var concatenatedMessage = '';
        var openNonMandatoryNotifications = [];
        var notificationColor = 'default'; // default || warning

        // Only process notifications that are not mandatory
        openNonMandatoryNotifications = _lodash2.default.filter(notifications, function (notification) {
            return notification.Priority !== HPNotificationPriority.Mandatory && !notification.isComplete;
        });

        _lodash2.default.each(openNonMandatoryNotifications, function (notification, index) {
            if (index > 0) {
                messages.push('and');
            }

            if (notification.ActionItemTypeId === HPNotifications.DelayedMandatoryTraining.actionItemTypeId) {
                var trainingMessage = ' - You have {0} day(s) to go through our guidelines on working together.';
                messages.push(trainingMessage.replace('{0}', notification.DaysDueCount.toString()));
            } else {
                messages.push(notification.Message);
            }

            if (notification.ActionItemTypeId === 22) {
                // Show as warning if CSLB notification is present
                notificationColor = 'warning';
            }
        });

        concatenatedMessage = messages.join(' ');

        if (concatenatedMessage !== '') {
            return {
                message: messagePrefix + messages.join(' ') + '.',
                color: notificationColor
            };
        }

        return {
            message: concatenatedMessage,
            color: notificationColor
        };
    }

    function buildRequiredNotifications(notifications) {
        var required = [];

        _lodash2.default.each(notifications, function (notification) {
            if (notification.Priority === HPNotificationPriority.Mandatory) {
                required.push(notification);
            }
        });

        return required;
    }
}

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = notificationFooterController;

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(795);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

notificationFooterController.$inject = ['$q', '$uibModal', '$analytics', 'NotificationUtility', 'NotificationCenterFactory', '$window', '$state', '$scope', 'UserData', 'HPNotificationPriority', 'BenjiUserFactory', '$rootScope', 'HISWizardFactory']; // angular
// 	.module("HeroPRO")
// 	.controller("NotificationFooterController", notificationFooterController);

/* @ngInject */
function notificationFooterController($q, $uibModal, $analytics, NotificationUtility, NotificationCenterFactory, $window, $state, $scope, UserData, HPNotificationPriority, BenjiUserFactory, $rootScope, HISWizardFactory) {
    var vm = this;
    var notificationFooter = void 0;
    var wrappedNotificationFooter = void 0;
    var modalInstance = null;

    vm.footerHeight = 0;
    vm.loaded = false;
    vm.notificationMessage = '';
    vm.notificationFooterVisible = true;
    vm.notificationColor = 'default'; // default || warning
    vm.hisTrainingMandate = {};

    $scope.$on('loadNotifications', function () {
        init();
    });

    $scope.$on('CSLB-Qualifier-Fixed', function () {
        vm.notificationFooterVisible = false;
    });
    /*= =======================================
       =            Public Functions            =
       ======================================== */

    vm.openNotificationModal = function (event, category) {
        $analytics.eventTrack(event, { category: category });
        if (vm.hisTrainingMandate && (vm.hisTrainingMandate.IsTrainingRequired || vm.hisTrainingMandate.IsLicenseEntryRequired || vm.hisTrainingMandate.IsLicenseExpired || vm.hisTrainingMandate.IsLicenseExpiring || vm.hisTrainingMandate.IsLicenseSuspended)) {
            HISWizardFactory.openHISWizardModal(false);
        } else {
            openNotificationsCenterModal();
        }
    };

    /* -----  End of Public Functions  ------*/

    /*= ========================================
       =            Private Functions            =
       ========================================= */

    function init() {
        notificationFooter = $window.document.getElementsByClassName('notification-footer');
        wrappedNotificationFooter = _angular2.default.element(notificationFooter);

        var animation = 'bottom 0.5s ease-in-out';
        wrappedNotificationFooter.css('-webkit-transition', animation);
        wrappedNotificationFooter.css('-moz-transition', animation);
        wrappedNotificationFooter.css('-o-transition', animation);
        wrappedNotificationFooter.css('-ms-transition', animation);
        wrappedNotificationFooter.css('transition', animation);

        getNotificationMessage();
    }

    function getNotificationMessage() {
        var requests = [UserData.getHISTrainingMandate(), NotificationCenterFactory.getNotifications()];

        $q.all(requests).then(function (responses) {
            $rootScope.$broadcast('HideMainSpinner');

            var hisTrainingMandateResponse = responses[0];
            var notificationResponse = responses[1];
            var hasMandatoryActions = notificationResponse != null && _lodash2.default.some(notificationResponse, function (ai) {
                return ai.ActionItemTypeId == 14 || ai.ActionItemTypeId == 18 || ai.ActionItemTypeId == 21;
            });
            vm.hisTrainingMandate = hisTrainingMandateResponse;

            if (BenjiUserFactory.getIsBenjiUserOnly() && BenjiUserFactory.getShouldBenjiRedirect() && !hasMandatoryActions) {
                BenjiUserFactory.redirectUserToBenji();
            } else {
                if (hisTrainingMandateResponse.IsTrainingRequired || hisTrainingMandateResponse.IsLicenseEntryRequired) {
                    var daysLeftToComplete = UserData.getTrainingDaysRemaining(hisTrainingMandateResponse.TrainingRequiredBy);
                    if (!hisTrainingMandateResponse.IsTrainingRequired) {
                        vm.notificationMessage = 'HIS License # Required. You have ' + daysLeftToComplete + ' days to complete this.';
                    } else {
                        vm.notificationMessage = 'HIS Training Required. You have ' + daysLeftToComplete + ' days to complete this training.';
                    }
                    vm.notificationFooterVisible = true;
                    showFooter();
                } else if (hisTrainingMandateResponse.IsLicenseExpiring || hisTrainingMandateResponse.IsLicenseExpired || hisTrainingMandateResponse.IsLicenseSuspended) {
                    if (hisTrainingMandateResponse.IsLicenseExpiring) {
                        vm.notificationMessage = "It looks like your HIS license is expiring soon, click here to find out what steps you need to take.";
                    } else if (hisTrainingMandateResponse.IsLicenseExpired) {
                        vm.notificationMessage = "It looks like your HIS license is expired, click here to find out what steps you need to take.";
                    } else if (hisTrainingMandateResponse.IsLicenseSuspended) {
                        vm.notificationMessage = "It looks like there is an issue with your HIS license. Please, click here to learn more.";
                    }

                    vm.notificationFooterVisible = true;
                    showFooter();
                } else if (notificationResponse.length > 0) {
                    buildNotifications(notificationResponse);
                }
            }
        });
    }

    function buildNotifications(response) {
        var requiredNotifications = NotificationUtility.buildRequiredNotifications(response);
        var notificationConfiguration = NotificationUtility.buildNotificationConfiguration(response);
        vm.notificationMessage = notificationConfiguration.message;
        vm.notificationColor = notificationConfiguration.color;

        if (requiredNotifications.length > 0 && requiredNotifications[0].Priority === HPNotificationPriority.Mandatory) {
            vm.openNotificationModal('View Notifications', 'Required Nofitication');
        }

        if (vm.notificationMessage === '') {
            vm.loaded = false;
        } else {
            showFooter();
        }
    }

    function showFooter() {
        vm.loaded = true;
        _lodash2.default.delay(function () {
            wrappedNotificationFooter.css('bottom', '-' + wrappedNotificationFooter[0].offsetHeight + 'px');
            _lodash2.default.delay(function () {
                wrappedNotificationFooter.css('bottom', '0px');
            }, 10);
        }, 10);
    }

    function getNotificationsModalConfiguration(notifications) {
        var config = {
            templateUrl: 'app/notificationCenter/modal/notificationModal.html',
            windowClass: 'notification-modal full-screen',
            controller: 'NotificationModalController',
            controllerAs: 'notificationModal',
            size: 'full-screen',
            animation: false,
            keyboard: true
        };

        var openNotifications = _lodash2.default.filter(notifications, function (n) {
            return n.Priority === HPNotificationPriority.Mandatory;
        });

        if (openNotifications.length > 0) {
            config.backdrop = 'static';
            config.keyboard = false;
        }
        return config;
    }

    function openNotificationsCenterModal() {
        modalInstance = $uibModal.open(getNotificationsModalConfiguration(NotificationCenterFactory.getNotificationData()));

        modalInstance.result.then(function (response) {
            var notification = NotificationCenterFactory.getActiveNotification();

            if (response.result) {
                NotificationCenterFactory.markNotificationComplete(notification.ActionItemId);
            }

            if (notification.CanBeDismissedByUser) {
                notification.showModal = false;
            }

            if (response.errorStatus) {
                $state.go('httpError1', { status: response.errorStatus });
            }

            buildNotifications(NotificationCenterFactory.getNotificationData());
        });
    }
    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 795 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = notificationFooterDirective;
// angular
// 	.module("HeroPRO")
// 	.directive('hpNotificationFooter', notificationFooterDirective);

function notificationFooterDirective() {
    return {
        restrict: 'E',
        controller: 'NotificationFooterController',
        controllerAs: 'notificationFooter',
        bindToController: true,
        scope: {
            notificationMessage: '=?'
        },
        templateUrl: 'app/notificationCenter/footer/notificationFooter.html',
        link: link
    };

    function link() {}
}

/***/ }),
/* 797 */
/***/ (function(module, exports) {

module.exports = "<div class=\"notification-footer\" ng-show=\"notificationFooter.loaded === true && notificationFooter.notificationFooterVisible === true && notificationFooter.notificationMessage !== ''\" ng-class=\"{ 'footer-warning' : notificationFooter.notificationColor === 'warning' }\">\n    <div class=\"notification-footer-container\">\n        <p class=\"notification-footer-message\" ng-bind=\"notificationFooter.notificationMessage\"></p>\n        <div class=\"notification-footer-buttons\">\n            <button type=\"button\" id=\"btnOpenNotificationCenter\" class=\"btn btn-default-notification\" ng-click=\"notificationFooter.openNotificationModal('View Notifications', 'Notifications Banner')\">VIEW</button>\n        </div>\n    </div>\n    <span class=\"icon icon-delete-circle\" ng-click=\"notificationFooter.notificationFooterVisible = !notificationFooter.notificationFooterVisible\"></span>\n</div>";

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _hisWizardController = __webpack_require__(799);

var _hisWizardController2 = _interopRequireDefault(_hisWizardController);

var _hisWizardFactory = __webpack_require__(801);

var _hisWizardFactory2 = _interopRequireDefault(_hisWizardFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.notificationCenter').controller('HISWizardController', _hisWizardController2.default).factory('HISWizardFactory', _hisWizardFactory2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/hisWizard/hisWizard.html', __webpack_require__(802)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = hisWizardController;

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(800);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

hisWizardController.$inject = ['UserData', 'HISWizardFactory', 'AccountsFactory', '$rootScope', '$uibModalInstance', 'TopNavFactory', 'authenticationService', 'UserAuthFactory', 'HPConfig', '$analytics', 'PartnerAppsFactory', '$window', 'UiDisplayFactory', 'PermissionsFactory']; // angular
// 	.module("HeroPRO")
// 	.controller("HISWizardController", hisWizardController);

var HISWizardStages = {
    Intro: 0,
    HISStatusPrompt: 1,
    HISLicenseLookup: 2,
    PhoneNumberVerification: 3,
    RedirectToTLMS: 4,
    Error: 5,
    IsExpiring: 6,
    IsExpired: 7,
    IsSuspended: 8
};

/* @ngInject */
function hisWizardController(UserData, HISWizardFactory, AccountsFactory, $rootScope, $uibModalInstance, TopNavFactory, authenticationService, UserAuthFactory, HPConfig, $analytics, PartnerAppsFactory, $window, UiDisplayFactory, PermissionsFactory) {
    var vm = this;

    vm.stage = HISWizardStages.Intro;
    vm.stageHistory = [];
    vm.canDismissModal = false;
    vm.hisExempt = null;
    vm.checkboxClicked = false;
    vm.hisNumber = '';
    vm.loading = false;
    vm.hisErrorMsg = '';
    vm.hisLicenseName = '';
    vm.phoneNumber = '';
    vm.email = '';
    vm.redirectUrl = '';
    vm.daysLeftToComplete = 0;
    vm.isBenjiUser = UiDisplayFactory.getDisplayRules().isBenjiUser;
    vm.isSolicitor = PermissionsFactory.hasPermission('IsSolicitor');
    vm.isAdvertiser = PermissionsFactory.hasPermission('IsAdvertiser');

    init();

    /*= =======================================
       =            Public Functions            =
       ======================================== */
    vm.closeModal = closeModal;
    vm.logout = logout;
    vm.validateHIS = validateHIS;
    vm.saveAndContinue = saveAndContinue;
    vm.savePhoneNumber = savePhoneNumber;
    vm.validatePhoneNumber = validatePhoneNumber;
    vm.setExemptionStatus = setExemptionStatus;
    vm.back = back;
    vm.getStarted = getStarted;
    vm.gotoBenji = gotoBenji;
    vm.gotoStage = gotoStage;

    function back() {

        if (vm.stageHistory.length > 0) {
            vm.stage = vm.stageHistory.pop();
        }

        /*
        if(vm.stage == HISWizardStages.HISLicenseLookup)
        {
            vm.stage = HISWizardStages.Intro;
            vm.prevStage = 0;
        }
        else
        {
            vm.stage = vm.prevStage;
                vm.stage--;
            if (vm.stage == HISWizardStages.HISLicenseLookup) vm.stage--;
            vm.stage = Math.max(0, vm.stage);            
        }
        */
    }

    function gotoBenji() {
        $window.open(PartnerAppsFactory.getBenjiLink(), '_blank');
    }

    function gotoStage(stageId) {
        vm.stageHistory.push(vm.stage);
        vm.stage = stageId;
    }

    function validateHIS() {
        if (vm.loading) return;

        vm.checkboxClicked = false;
        vm.loading = true;
        $rootScope.$broadcast('ShowMainSpinner');

        vm.hisErrorMsg = '';
        vm.hisLicenseName = '';

        HISWizardFactory.validateHISNumber(vm.hisNumber).then(function (data) {
            console.log(data);
            if (data.Error) {
                vm.hisErrorMsg = data.Error;
            } else {
                vm.hisErrorMsg = '';
                vm.hisLicenseName = data.Metadata.FirstName + ' ' + data.Metadata.LastName;
            }
            vm.loading = false;
            $rootScope.$broadcast('HideMainSpinner');
        }, handleError);
    }

    function setExemptionStatus() {
        if (vm.hisExempt) {
            saveAndContinue();
        } else {
            vm.gotoStage(HISWizardStages.HISLicenseLookup);
        }
    }

    function getStarted() {
        if (!vm.IsDesignationRequired) {
            if (vm.IsLicenseEntryRequired) {
                vm.gotoStage(HISWizardStages.HISLicenseLookup);
            } else if (vm.IsContactInfoRequired) {
                vm.gotoStage(HISWizardStages.PhoneNumberVerification);
            } else {
                vm.gotoStage(HISWizardStages.RedirectToTLMS);
                _redirectToTraining();
            }
        } else {
            vm.gotoStage(HISWizardStages.HISStatusPrompt);
        }
    }

    function savePhoneNumber() {
        if (vm.loading) return;

        vm.loading = true;
        $rootScope.$broadcast('ShowMainSpinner');

        AccountsFactory.confirmContractorUserContactInfo({
            PhoneNumber: vm.phoneNumber,
            Email: vm.email
        }).then(function () {
            vm.gotoStage(HISWizardStages.RedirectToTLMS);
            UserData.getHISTrainingMandate().then(function (mandate) {
                if (mandate.IsTrainingRequired) {
                    _redirectToTraining();
                } else {
                    $uibModalInstance.close();
                    window.location.reload();
                }
            }, handleError);
        }, handleError);
    }

    function validatePhoneNumber() {
        return !!vm.phoneNumber && vm.phoneNumber.length >= 9;
    }

    function saveAndContinue() {
        if (vm.loading) return;

        vm.loading = true;
        $rootScope.$broadcast('ShowMainSpinner');

        AccountsFactory.setHISLicenseExemptionStatus({
            IsHISExempt: vm.hisExempt,
            LicenseNumber: vm.hisNumber
        }).then(function () {
            vm.gotoStage(HISWizardStages.PhoneNumberVerification);
            vm.loading = false;
            $rootScope.$broadcast('HideMainSpinner');
        }, handleError);
    }

    function closeModal() {
        $uibModalInstance.close();
    }

    function logout() {
        /*
         * THIS CODE IS A DUPLICATION OF
         * TopNavController#logout()
         *
         * TODO: Move this into a central location
         */
        $analytics.eventTrack('Logout', {
            category: 'TopNav',
            label: 'HISWizard'
        });

        TopNavFactory.logout().then(function () {
            // (ajt 3/23/16) PBI 414 Implement IDV validation
            authenticationService.logOut();

            UserAuthFactory.deleteAuthorization();

            var logoutUrl = HPConfig.heroProLoginLink;

            logoutUrl += '?logout=true';

            $window.location.href = logoutUrl;
        });
    }
    /* -----  End of Public Functions  ------*/

    /*= ========================================
       =            Private Functions            =
       ========================================= */
    function init() {
        $rootScope.$broadcast('ShowMainSpinner');
        vm.loading = true;
        UserData.getHISTrainingMandate().then(function (mandate) {
            var today = new Date();
            var gpExpire = mandate.TrainingRequiredBy;
            vm.IsContactInfoRequired = mandate.IsContactInfoRequired;
            vm.IsDesignationRequired = mandate.IsDesignationRequired;
            vm.IsLicenseEntryRequired = mandate.IsLicenseEntryRequired;
            vm.IsTrainingRequired = mandate.IsTrainingRequired;
            vm.IsLicenseExpiring = mandate.IsLicenseExpiring;
            vm.IsLicenseExpired = mandate.IsLicenseExpired;
            vm.IsLicenseSuspended = mandate.IsLicenseSuspended;

            vm.daysLeftToComplete = UserData.getTrainingDaysRemaining(gpExpire);
            vm.canDismissModal = vm.daysLeftToComplete > 1;

            if (!vm.IsDesignationRequired) {
                if (mandate.PersonIdentityLicenseTypeId == 3) {
                    vm.hisExempt = true;
                } else {
                    vm.hisExempt = false;
                }
            }

            if (vm.IsLicenseExpiring) {
                vm.stage = HISWizardStages.IsExpiring;
                vm.canDismissModal = true;
            } else if (vm.IsLicenseExpired) {
                vm.stage = HISWizardStages.IsExpired;
                vm.canDismissModal = false;
            } else if (vm.IsLicenseSuspended) {
                vm.stage = HISWizardStages.IsSuspended;
                vm.canDismissModal = false;
            } else {
                vm.stage = HISWizardStages.Intro;
            }

            vm.loading = false;
            $rootScope.$broadcast('HideMainSpinner');
        }, handleError);
    }

    function handleError() {
        $rootScope.$broadcast('HideMainSpinner');
        vm.stage = HISWizardStages.Error;
    }

    function _redirectToTraining() {
        return HISWizardFactory.getHISTrainingRedirectURI().then(function (response) {
            $rootScope.$broadcast('HideMainSpinner');
            vm.loading = false;
            var redirectUrl = response.Data.RedirectURI;
            vm.redirectUrl = redirectUrl;
            window.open(redirectUrl, '_blank');
        }, handleError);
    }
    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 800 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = HISWizardFactory;
HISWizardFactory.$inject = ['$uibModal', '$http', 'HPConfig', '$q'];
/* @ngInject */
function HISWizardFactory($uibModal, $http, HPConfig, $q) {
    var modalInstance = null;

    return {
        openHISWizardModal: function openHISWizardModal(mandatory) {
            if (!!modalInstance) {
                return;
            }

            modalInstance = $uibModal.open({
                templateUrl: 'app/hisWizard/hisWizard.html',
                controller: 'HISWizardController',
                controllerAs: 'hisWizard',
                size: 'full-screen',
                animation: false,
                keyboard: !mandatory
            });

            modalInstance.closed.then(function () {
                modalInstance = null;
            });

            console.log(modalInstance);
        },
        validateHISNumber: function validateHISNumber(licenseNumber) {
            return $http.get(HPConfig.heroProApi + 'ContractorUser/ValidateHISLicense?licenseNumber=' + licenseNumber).then(function (response) {
                return response.data;
            });
        },
        getHISTrainingRedirectURI: function getHISTrainingRedirectURI() {
            return $http.get(HPConfig.heroProApi + 'ContractorUser/GetHISTrainingRedirectURI').then(function (response) {
                return response.data;
            });
        }
    };
}

/***/ }),
/* 802 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container his-wizard-container\">\r\n    <div class=\"row\">\r\n        <div class=\"col-xs-12\">\r\n            <div class=\"modal-header\">\r\n                <div class=\"pull-left\">\r\n                    <a ng-click=\"hisWizard.back()\" ng-if=\"hisWizard.stageHistory.length > 0\">\r\n                        <svg style=\"position: relative; top: 3px;\" width=\"16px\" height=\"16px\" viewBox=\"0 0 24 24\"\r\n                            version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">j\r\n                            <g id=\"ic_arrow_left_24x24\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\r\n                                <polyline id=\"Shape\" stroke=\"#499CC6\" stroke-width=\"2\" transform=\"translate(12.000000, 12.000000) rotate(-270.000000) translate(-12.000000, -12.000000) \"\r\n                                    points=\"4 8 12 16 20 8\"></polyline>\r\n                            </g>\r\n                        </svg>\r\n                        Back\r\n                    </a>\r\n                </div>\r\n                <div class=\"pull-right\">\r\n                    <span class=\"icon icon-close-thin\" ng-if=\"hisWizard.canDismissModal\" ng-click=\"hisWizard.closeModal()\"></span>\r\n                    <a href=\"#\" ng-if=\"!hisWizard.canDismissModal\" ng-click=\"hisWizard.logout()\">Logout</a>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-xs-12\">\r\n            <div class=\"his-wizard\">\r\n                <ng-include src=\"'hisWizardStage' + hisWizard.stage\"></ng-include>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<script type=\"text/ng-template\" id=\"hisWizardStage0\">\r\n    <img class=\"his-logo\" src=\"https://s3-us-west-2.amazonaws.com/cdn.renovateamerica.com/Logos/logo_RA_stacked_color.svg\" />\r\n    <h2 class=\"his-stage-title\">PACE Status &amp; Training</h2>\r\n    <p>In order to manage and fund HERO projects, we need you to do the following:</p>\r\n    <ul class=\"his-list\">\r\n        <li ng-if=\"hisWizard.IsDesignationRequired\">Choose a PACE status</li>\r\n        <li ng-if=\"hisWizard.IsContactInfoRequired\">Provide your mobile number</li>\r\n        <li ng-if=\"hisWizard.IsTrainingRequired\">Complete PACE training</li>\r\n    </ul>\r\n    <button ng-click=\"hisWizard.getStarted()\" class=\"btn btn-primary\">Get Started</button>\r\n    <div class=\"skip-to-benji\" ng-if=\"hisWizard.isBenjiUser\">\r\n        <a ng-click=\"hisWizard.gotoBenji()\">Skip and go to Benji &rsaquo;</a>\r\n        <br />\r\n        <p><strong>Important:</strong> If you skip this, you will be able to complete a OneApp (Benji &amp; HERO application), but you will not be able to manage or receive funds for a HERO project until you complete PACE status and training.</p>\r\n    </div>\r\n</script>\r\n\r\n<script type=\"text/ng-template\" id=\"hisWizardStage1\">\r\n    <p class=\"his-stage-title\">Select from the options below</p>\r\n    <ul class=\"radio-options\">\r\n        <li>\r\n            <div class=\"option-container\">\r\n                <div class=\"option-header\">\r\n                    <p class=\"option-header-title\">PACE Participant</p>\r\n                    <span class=\"icon\" ng-class=\"{'icon-radio-select': hisWizard.hisExempt === true, 'icon-radio-default': !hisWizard.hisExempt}\"\r\n                        ng-click=\"hisWizard.hisExempt = true\"></span>\r\n                    <div class=\"text\" ng-click=\"hisWizard.hisExempt = true\">By making this selection, I hereby agree that I am registering with Renovate America as a PACE Participant and that I will timely satisfy the registration and training requirements of a PACE Participant and agree to the California HERO PACE Participant Code of Conduct.</div>\r\n                    <p>As a PACE Participant: <a ng-show=\"!learnMoreExempt\" ng-click=\"learnMoreExempt = !learnMoreExempt\">Learn more</a></p>\r\n                </div>\r\n                <div class=\"option-drawer\" ng-if=\"learnMoreExempt\">\r\n                    <ul class=\"his-list\">\r\n                        <li>You can introduce and provide general information about HERO financing to customers using resources provided to you by Renovate America. You can also perform administrative or clerical tasks related to HERO financing. You cannot, however, discuss the financing details of a specific HERO financing assessment contract with a customer.</li>\r\n                        <li>Renovate America will provide you with resources that you can use to introduce HERO financing, such as responses to FAQs, scripts, a HERO overview video, and brochures. You will not have access to the financial payment calculator, quoting and similar tools in HEROPro.</li>\r\n                        <li>You will need to complete applicable registration and training requirements, including:</li>\r\n                        <li style=\"list-style: none;\">\r\n                            <ul>\r\n                                <li>Complete the introductory training and less than thirty minute PACE Participant training specific to advertising HERO financing</li>\r\n                                <li>Agree to the California HERO PACE Participant Code of Conduct</li>\r\n                            </ul>\r\n                        </li>\r\n                    </ul>\r\n                    <p>You will have {{ hisWizard.canDismissModal ? hisWizard.daysLeftToComplete : 0 }} days from the time that you make this election to complete these requirements.</p>\r\n                </div>\r\n            </div>\r\n        </li>\r\n        <li>\r\n            <div class=\"option-container\">\r\n                <div class=\"option-header\">\r\n                    <p class=\"option-header-title\">Certified PACE Professional</p>\r\n                    <span class=\"icon\" ng-class=\"{'icon-radio-select': hisWizard.hisExempt === false, 'icon-radio-default': (hisWizard.hisExempt === null || !!hisWizard.hisExempt)}\"\r\n                        ng-click=\"hisWizard.hisExempt = false\"></span>\r\n                    <div class=\"text\" ng-click=\"hisWizard.hisExempt = false\">By making this selection, I hereby agree that I am registering with Renovate America as a Certified PACE Professional and that I will timely satisfy the registration and training requirements of a Certified PACE Professional and agree to the California HERO Certified PACE Professional Code of Conduct.</div>\r\n                    <p>As a Certified PACE Professional: <a ng-show=\"!learnMoreNotExempt\" ng-click=\"learnMoreNotExempt = !learnMoreNotExempt\">Learn more</a></p>\r\n                </div>\r\n                <div class=\"option-drawer\" ng-if=\"learnMoreNotExempt\">\r\n                    <ul class=\"his-list\">\r\n                        <li>You can discuss the financing terms of specific HERO financing assessment contracts with your customers. You can also perform administrative, clerical and other approved tasks related to HERO financing.</li>\r\n                        <li>You will have full access to Renovate America’s Proposal Plus, Payment Calculator, variety of marketing materials and other resources in HEROPro.</li>\r\n                        <li>You will need to complete applicable registration and training requirements, including:</li>\r\n                        <li style=\"list-style: none;\">\r\n                            <ul>\r\n                                <li>Provide Renovate America with your Home Improvement Salesperson (HIS) registration number</li>\r\n                                <li>Complete the introductory training and 6-hour PACE certification training course</li>\r\n                                <li>Agree to California HERO Certified PACE Professional Code of Conduct.</li>\r\n                            </ul>\r\n                        </li>\r\n                    </ul>\r\n                    <p>You will have {{ hisWizard.canDismissModal ? hisWizard.daysLeftToComplete : 0 }} days to complete the 6-hour training course requirements. We'll remind you every time you log in that it's still pending, but it won't affect your ability to use the tools.</p>\r\n                </div>\r\n            </div>\r\n        </li>\r\n    </ul>\r\n    <button ng-click=\"hisWizard.setExemptionStatus()\" ng-disabled=\"hisWizard.hisExempt === null\" class=\"btn btn-primary\">Save\r\n        &amp; Continue</button>\r\n\r\n</script>\r\n\r\n<script type=\"text/ng-template\" id=\"hisWizardStage2\">\r\n    <p class=\"his-stage-title\">Please enter your HIS number below.</p>\r\n    <div class=\"his-number-validator\">\r\n        <div class=\"his-number-validator-body\">\r\n            <input type=\"text\" maxlength=\"8\" class=\"form-control\" ng-model=\"hisWizard.hisNumber\" placeholder=\"Up to 8 digits.\" />\r\n            <span>SP</span>\r\n            <button ng-click=\"hisWizard.validateHIS()\" ng-disabled=\"hisWizard.hisNumber.length < 2\"\r\n                class=\"btn btn-primary\">Check #</button>\r\n        </div>\r\n    </div>\r\n    <p ng-if=\"!!hisWizard.hisErrorMsg\" class=\"error-message\">{{hisWizard.hisErrorMsg}}</p>\r\n    <div ng-if=\"!!hisWizard.hisLicenseName\">\r\n        <p>This HIS number belongs to <strong>{{hisWizard.hisLicenseName}}</strong>. Is\r\n            this you?</p>\r\n        <div class=\"checkbox-container\">\r\n            <span class=\"icon icon-checkbox-default\" ng-class=\"{'icon-checkbox-selected':hisWizard.checkboxClicked}\"></span>\r\n            <input id=\"check_same\" name=\"check_same\" type=\"checkbox\" class=\"icon-checkbox-default\" ng-model=\"hisWizard.checkboxClicked\" />\r\n            <label for=\"check_same\">\r\n                Yes, I confirm this is my HIS number\r\n            </label>\r\n        </div>\r\n        <button ng-click=\"hisWizard.saveAndContinue()\" ng-disabled=\"!hisWizard.checkboxClicked\" class=\"btn btn-primary\">Save\r\n            &amp; Continue</button>\r\n    </div>\r\n</script>\r\n\r\n<script type=\"text/ng-template\" id=\"hisWizardStage3\">\r\n    <p class=\"his-stage-title\">Please update your mobile number so that we can better serve you.</p>\r\n    <label for=\"phone\">Mobile phone</label>\r\n    <input type=\"text\" class=\"form-control phone-number-entry\" name=\"phone\" placeholder=\"(xxx) xxx-xxxx\" ui-mask=\"(999) 999-9999\" ng-model=\"hisWizard.phoneNumber\" />\r\n    <p class=\"subtext\">We do not share your information. View our <a target=\"_blank\" href=\"https://www.foahomeimprovement.com/privacy-policy\">Privacy\r\n            Policy</a></p>\r\n    <button ng-click=\"hisWizard.savePhoneNumber()\" ng-disabled=\"!hisWizard.validatePhoneNumber()\" class=\"btn btn-primary\">Save\r\n        &amp; Continue</button>\r\n</script>\r\n\r\n<script type=\"text/ng-template\" id=\"hisWizardStage4\">\r\n    <p class=\"his-stage-title\">Redirecting to training. Feel free to close this tab or refresh this page after your training is\r\n        complete.</p>\r\n    <p class=\"subtext\">If no window opens, please click <a href=\"{{ hisWizard.redirectUrl }}\" target=\"_blank\">here</a>\r\n        to access your training.</p>\r\n</script>\r\n\r\n<script type=\"text/ng-template\" id=\"hisWizardStage5\">\r\n    <div class=\"hp-error\">\r\n        <img class=\"error-image\" src=\"/src/assets/images/icon-guy.png\" alt=\"Error\" />\r\n        <h1>Oops! That wasn't right.</h1>\r\n        <p>Please contact us at 844-722-7759 <br/> or <a href=\"mailto:info@heroprogram.com\" class=\"link\">info@heroprogram.com</a> if you have any questions.</p>\r\n    </div>\r\n</script>\r\n\r\n<script type=\"text/ng-template\" id=\"hisWizardStage6\">\r\n <h1 class=\"his-stage-title\">HIS License Expiring Soon</h1>\r\n <p class=\"subtext\">\r\n        It looks like your HIS license is expiring within the next 30 days. If you’ve already completed the steps required for renewal, as soon as the CSLB updates your status we’ll be notified and this notice will go away.\r\n\r\n        The CSLB should send you a letter via the US Postal Service with instructions on how to complete renewal. If you have questions or concerns on how to perform this update, please see the <a target=\"_blank\" href=\"http://www.cslb.ca.gov/Contractors/Applicants/Home_Improvement_Registration\">CLSB’s guide here</a>.\r\n        \r\n        Alternately, you can update your PACE registration status with us <a ng-click=\"hisWizard.gotoStage(1)\">here</a>\r\n </p>\r\n</script>\r\n\r\n<script type=\"text/ng-template\" id=\"hisWizardStage7\">\r\n    <h1 class=\"his-stage-title\">HIS License Expired</h1>\r\n    <p>It looks like your HIS license has expired. There are a couple of ways we can resolve this:</p>\r\n    <h2 class=\"his-stage-title\">Renew your license with the CSLB</h2>\r\n    <p>Renew your license with the CSLB - you should have recieved communication via the US Postal Service from the CSLB about how to complete this step. If this is still pending or you never recieved instructions, please refer to the <a target=\"_blank\" href=\"http://www.cslb.ca.gov/Contractors/Applicants/Home_Improvement_Registration\">CSLB website</a> for more information.</p>\r\n    <h2 class=\"his-stage-title\">Update your PACE enrollment status with us</h2>\r\n    <p>\r\n        If you need immediate access to your pipeline and the HERO homeowner application you can update your PACE enrollment status to be a PACE Participant. To complete this enrollment you'll need to complete some additional training and agree to a participation agreement. Learn more about this role by clicking the button below.<br/>        \r\n    </p>\r\n    <p><a class=\"btn btn-primary\" target=\"_blank\" ng-click=\"hisWizard.gotoStage(1)\">Update Pace Status</a></p>\r\n    <div class=\"skip-to-benji\" ng-if=\"hisWizard.isBenjiUser\">\r\n            <a ng-click=\"hisWizard.gotoBenji()\">Skip and go to Benji &rsaquo;</a>\r\n            <br />\r\n            <p><strong>Important:</strong> If you skip this, you will be able to complete a OneApp (Benji &amp; HERO application), but you will not be able to manage or receive funds for a HERO project until you complete PACE status and training.</p>\r\n    </div>    \r\n</script>\r\n\r\n<script type=\"text/ng-template\" id=\"hisWizardStage8\">\r\n    <h1 class=\"his-stage-title\">HIS License Ineligible</h1>\r\n    <p>It looks like your HIS license is in an ineligible status. There are a couple of ways we can resolve this:</p>\r\n    <h2 class=\"his-stage-title\">Resolve outstanding issues with the CSLB directly</h2>\r\n    <p>You should have received communication via the US Postal Service from the CSLB about this status change and next steps. If this is still pending or you never received instructions, please refer to the <a target=\"_blank\" href=\"http://www.cslb.ca.gov/Contractors/Applicants/Home_Improvement_Registration\">CSLB website</a> for more information.</p>\r\n        <h2 class=\"his-stage-title\">Update your PACE enrollment status with us</h2>\r\n        <p>\r\n            If you need immediate access to your pipeline and the HERO homeowner application you can update your PACE enrollment status to be a PACE Participant. To complete this enrollment you'll need to complete some additional training and agree to a participation agreement. Learn more about this role by clicking the button below.<br/>        \r\n        </p>\r\n        <p><a class=\"btn btn-primary\" target=\"_blank\" ng-click=\"hisWizard.gotoStage(1)\">Update Pace Status</a></p>\r\n        <div class=\"skip-to-benji\" ng-if=\"hisWizard.isBenjiUser\">\r\n                <a ng-click=\"hisWizard.gotoBenji()\">Skip and go to Benji &rsaquo;</a>\r\n                <br />\r\n                <p><strong>Important:</strong> If you skip this, you will be able to complete a OneApp (Benji &amp; HERO application), but you will not be able to manage or receive funds for a HERO project until you complete PACE status and training.</p>\r\n        </div>    \r\n\r\n</script>\r\n";

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _spinnerController = __webpack_require__(804);

var _spinnerController2 = _interopRequireDefault(_spinnerController);

var _spinnerDirective = __webpack_require__(806);

var _spinnerDirective2 = _interopRequireDefault(_spinnerDirective);

var _spinnerService = __webpack_require__(807);

var _spinnerService2 = _interopRequireDefault(_spinnerService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.common.spinner', []).controller('SpinnerController', _spinnerController2.default).service('raSpinnerService', _spinnerService2.default).directive('raSpinner', _spinnerDirective2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/common/spinner/template/defaultSpinnerTemplate.html', __webpack_require__(808)); // eslint-disable-line global-require
    $templateCache.put('app/common/spinner/template/indeterminateSpinner.html', __webpack_require__(809)); // eslint-disable-line global-require
    $templateCache.put('app/common/spinner/template/indeterminateSpinnerSmall.html', __webpack_require__(810)); // eslint-disable-line global-require
    $templateCache.put('app/common/spinner/template/indeterminateSpinnerSmallBlue.html', __webpack_require__(811)); // eslint-disable-line global-require
    $templateCache.put('app/common/spinner/template/indeterminateSpinnerSmallGreen.html', __webpack_require__(812)); // eslint-disable-line global-require
    $templateCache.put('app/common/spinner/template/indeterminateSpinnerSmallRed.html', __webpack_require__(813)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = PipelineController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(805);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

PipelineController.$inject = ['$scope', 'raSpinnerService']; // angular
// 	.module("HeroPRO")
// 	.controller("PipelineController", PipelineController);

/* @ngInject */
function PipelineController($scope, raSpinnerService) {
    // register should be true by default if not specified.
    if (!$scope.hasOwnProperty('register')) {
        $scope.register = true;
    } else {
        $scope.register = $scope.register.toLowerCase() !== 'false';
    }

    if (!$scope.hasOwnProperty('text')) {
        $scope.text = 'Loading';
    }

    // Declare a mini-API to hand off to our service so the service
    // doesn't have a direct reference to this directive's scope.
    var api = {
        name: $scope.name,
        group: $scope.group,
        show: function show() {
            $scope.show = true;
        },
        hide: function hide() {
            $scope.show = false;
        },
        toggle: function toggle() {
            $scope.show = !$scope.show;
        }
    };

    // Register this spinner with the spinner service.
    if ($scope.register === true) {
        raSpinnerService._register(api);
    }

    // If an onShow or onHide expression was provided, register a watcher
    // that will fire the relevant expression when show's value changes.
    if ($scope.onShow || $scope.onHide) {
        $scope.$watch('show', function (show) {
            if (show && $scope.onShow) {
                $scope.onShow({ raSpinnerService: raSpinnerService, spinnerApi: api });
            } else if (!show && $scope.onHide) {
                $scope.onHide({ raSpinnerService: raSpinnerService, spinnerApi: api });
            }
        });
    }

    // This spinner is good to go. Fire the onLoaded expression.
    if ($scope.onLoaded) {
        $scope.onLoaded({ raSpinnerService: raSpinnerService, spinnerApi: api });
    }
}

/***/ }),
/* 805 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = SpinnerDirective;
// angular.module('raSpinner')
// .directive('raSpinner',

/* @ngInject */
function SpinnerDirective() {
    return {
        restrict: 'EA',
        replace: true,
        transclude: true,
        scope: {
            name: '@?',
            group: '@?',
            show: '=?',
            hideContentWhenShown: '=?',
            imgSrc: '@?',
            register: '@?',
            onLoaded: '&?',
            onShow: '&?',
            onHide: '&?',
            template: '@?',
            text: '@?'
        },

        templateUrl: function templateUrl(element, attr) {
            var templateName = attr.template || 'defaultSpinnerTemplate';
            return 'app/common/spinner/template/' + templateName + '.html';
        },


        controller: 'SpinnerController'
    };
}

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = SpinnerService;
// angular.module('raSpinner', [])
// .factory('raSpinnerService',

function SpinnerService() {
    var spinners = {};
    return {
        _register: function _register(data) {
            if (!data.hasOwnProperty('name')) {
                throw new Error('Spinner must specify a name when registering with the spinner service.');
            }
            // if (spinners.hasOwnProperty(data.name)) {
            // 	//throw new Error("A spinner with the name '" + data.name + "' has already been registered.");
            // } else {
            // 	spinners[data.name] = data;
            // }
            spinners[data.name] = data;
        },
        _unregister: function _unregister(name) {
            if (spinners.hasOwnProperty(name)) {
                delete spinners[name];
            }
        },
        _unregisterGroup: function _unregisterGroup(group) {
            for (var name in spinners) {
                if (spinners[name].group === group) {
                    delete spinners[name];
                }
            }
        },
        unregisterAll: function unregisterAll() {
            for (var name in spinners) {
                delete spinners[name];
            }
        },
        isRegistered: function isRegistered(name) {
            return spinners.hasOwnProperty(name);
        },
        show: function show(name) {
            var spinner = spinners[name];
            if (!spinner) {
                throw new Error('No spinner named \'' + name + '\' is registered.');
            }
            spinner.show();
        },
        hide: function hide(name) {
            var spinner = spinners[name];
            if (!spinner) {
                throw new Error('No spinner named \'' + name + '\' is registered.');
            }
            spinner.hide();
        },
        showGroup: function showGroup(group) {
            var groupExists = false;
            for (var name in spinners) {
                var spinner = spinners[name];
                if (spinner.group === group) {
                    spinner.show();
                    groupExists = true;
                }
            }
            if (!groupExists) {
                throw new Error('No spinners found with group \'' + group + '\'.');
            }
        },
        hideGroup: function hideGroup(group) {
            var groupExists = false;
            for (var name in spinners) {
                var spinner = spinners[name];
                if (spinner.group === group) {
                    spinner.hide();
                    groupExists = true;
                }
            }
            if (!groupExists) {
                throw new Error('No spinners found with group \'' + group + '\'.');
            }
        },
        showAll: function showAll() {
            for (var name in spinners) {
                spinners[name].show();
            }
        },
        hideAll: function hideAll() {
            for (var name in spinners) {
                spinners[name].hide();
            }
        }
    };
}

/***/ }),
/* 808 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-loading-spinner\">\n\t<div class=\"ra-spinner\" ng-show=\"show\">\n\t\t<img ng-show=\"imgSrc\" ng-src=\"{{imgSrc}}\" />\n\t\t<div class=\"spinner-container-legacy\">\n\t\t\t<div class=\"spinner\"></div>\n\t\t</div>\n\t\t<p>{{text}}</p>\n\t</div>\n\t<div ng-transclude ng-hide=\"hideContentWhenShown && show\"></div>\n</div>\n";

/***/ }),
/* 809 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-indeterminate-spinner\">\n    <div class=\"spinner-container-large\">\n        <div class=\"ra-spinner\" ng-show=\"show\">\n            <!--<img ng-show=\"imgSrc\" ng-src=\"{{imgSrc}}\" />-->\n            <div class=\"Spinner\"><!--\n    --><div class=\"Spinner-line Spinner-line--1\"><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--left\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-ticker\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--center\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--right\"></div><!--\n        --></div><!--\n    --></div><!--\n    --><div class=\"Spinner-line Spinner-line--2\"><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--left\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-ticker\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--center\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--right\"></div><!--\n        --></div><!--\n    --></div><!--\n    --><div class=\"Spinner-line Spinner-line--3\"><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--left\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-ticker\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--center\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--right\"></div><!--\n        --></div><!--\n    --></div><!--\n    --><div class=\"Spinner-line Spinner-line--4\"><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--left\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-ticker\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--center\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--right\"></div><!--\n        --></div><!--\n    --></div><!--\n-->\n            </div><!--/spinner -->\n        </div>\n    </div>\n\n    <div ng-transclude ng-hide=\"hideContentWhenShown && show\"></div>\n</div>\n";

/***/ }),
/* 810 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-indeterminate-spinner-small\">\n    <div class=\"spinner-container-small\">\n        <div class=\"ra-spinner\" ng-show=\"show\">\n            <!--<img ng-show=\"imgSrc\" ng-src=\"{{imgSrc}}\" />-->\n            <div class=\"Spinner\"><!--\n    --><div class=\"Spinner-line Spinner-line--1\"><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--left\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-ticker\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--center\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--right\"></div><!--\n        --></div><!--\n    --></div><!--\n    --><div class=\"Spinner-line Spinner-line--2\"><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--left\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-ticker\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--center\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--right\"></div><!--\n        --></div><!--\n    --></div><!--\n    --><div class=\"Spinner-line Spinner-line--3\"><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--left\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-ticker\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--center\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--right\"></div><!--\n        --></div><!--\n    --></div><!--\n    --><div class=\"Spinner-line Spinner-line--4\"><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--left\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-ticker\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--center\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--right\"></div><!--\n        --></div><!--\n    --></div><!--\n-->\n            </div><!--/spinner -->\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 811 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-indeterminate-spinner-small-blue\">\n    <div class=\"spinner-container-small\">\n        <div class=\"ra-spinner\" ng-show=\"show\">\n            <!--<img ng-show=\"imgSrc\" ng-src=\"{{imgSrc}}\" />-->\n            <div class=\"Spinner\"><!--\n    --><div class=\"Spinner-line Spinner-line--1\"><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--left\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-ticker\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--center\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--right\"></div><!--\n        --></div><!--\n    --></div><!--\n    --><div class=\"Spinner-line Spinner-line--2\"><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--left\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-ticker\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--center\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--right\"></div><!--\n        --></div><!--\n    --></div><!--\n    --><div class=\"Spinner-line Spinner-line--3\"><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--left\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-ticker\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--center\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--right\"></div><!--\n        --></div><!--\n    --></div><!--\n    --><div class=\"Spinner-line Spinner-line--4\"><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--left\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-ticker\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--center\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--right\"></div><!--\n        --></div><!--\n    --></div><!--\n-->\n            </div><!--/spinner -->\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 812 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-indeterminate-spinner-small-green\">\n    <div class=\"spinner-container-small\">\n        <div class=\"ra-spinner\" ng-show=\"show\">\n            <!--<img ng-show=\"imgSrc\" ng-src=\"{{imgSrc}}\" />-->\n            <div class=\"Spinner\"><!--\n    --><div class=\"Spinner-line Spinner-line--1\"><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--left\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-ticker\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--center\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--right\"></div><!--\n        --></div><!--\n    --></div><!--\n    --><div class=\"Spinner-line Spinner-line--2\"><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--left\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-ticker\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--center\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--right\"></div><!--\n        --></div><!--\n    --></div><!--\n    --><div class=\"Spinner-line Spinner-line--3\"><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--left\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-ticker\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--center\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--right\"></div><!--\n        --></div><!--\n    --></div><!--\n    --><div class=\"Spinner-line Spinner-line--4\"><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--left\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-ticker\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--center\"></div><!--\n        --></div><!--\n        --><div class=\"Spinner-line-cog\"><!--\n            --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--right\"></div><!--\n        --></div><!--\n    --></div><!--\n-->\n            </div><!--/spinner -->\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 813 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-indeterminate-spinner-small-red\">\n    <div class=\"spinner-container-small\">\n        <div class=\"ra-spinner\" ng-show=\"show\">\n            <!--<img ng-show=\"imgSrc\" ng-src=\"{{imgSrc}}\" />-->\n            <div class=\"Spinner\"><!--\n                --><div class=\"Spinner-line Spinner-line--1\"><!--\n                    --><div class=\"Spinner-line-cog\"><!--\n                        --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--left\"></div><!--\n                        --></div><!--\n                    --><div class=\"Spinner-line-ticker\"><!--\n                        --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--center\"></div><!--\n                        --></div><!--\n                    --><div class=\"Spinner-line-cog\"><!--\n                        --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--right\"></div><!--\n                        --></div><!--\n                    --></div><!--\n                --><div class=\"Spinner-line Spinner-line--2\"><!--\n                    --><div class=\"Spinner-line-cog\"><!--\n                        --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--left\"></div><!--\n                        --></div><!--\n                    --><div class=\"Spinner-line-ticker\"><!--\n                        --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--center\"></div><!--\n                        --></div><!--\n                    --><div class=\"Spinner-line-cog\"><!--\n                        --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--right\"></div><!--\n                        --></div><!--\n                    --></div><!--\n                --><div class=\"Spinner-line Spinner-line--3\"><!--\n                    --><div class=\"Spinner-line-cog\"><!--\n                        --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--left\"></div><!--\n                        --></div><!--\n                    --><div class=\"Spinner-line-ticker\"><!--\n                        --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--center\"></div><!--\n                        --></div><!--\n                    --><div class=\"Spinner-line-cog\"><!--\n                        --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--right\"></div><!--\n                        --></div><!--\n                    --></div><!--\n                --><div class=\"Spinner-line Spinner-line--4\"><!--\n                    --><div class=\"Spinner-line-cog\"><!--\n                        --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--left\"></div><!--\n                        --></div><!--\n                    --><div class=\"Spinner-line-ticker\"><!--\n                        --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--center\"></div><!--\n                        --></div><!--\n                    --><div class=\"Spinner-line-cog\"><!--\n                        --><div class=\"Spinner-line-cog-inner Spinner-line-cog-inner--right\"></div><!--\n                        --></div><!--\n                    --></div><!--\n                -->\n            </div><!--/spinner -->\n        </div>\n    </div>\n    <div ng-transclude ng-hide=\"hideContentWhenShown && show\"></div>\n</div>\n";

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _changePasswordController = __webpack_require__(815);

var _changePasswordController2 = _interopRequireDefault(_changePasswordController);

var _changePasswordFactory = __webpack_require__(79);

var _changePasswordFactory2 = _interopRequireDefault(_changePasswordFactory);

var _emailDirective = __webpack_require__(817);

var _emailDirective2 = _interopRequireDefault(_emailDirective);

var _passwordDirective = __webpack_require__(818);

var _passwordDirective2 = _interopRequireDefault(_passwordDirective);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.common.controls', []).controller('ChangePasswordController', _changePasswordController2.default).service('ChangePasswordService', _changePasswordFactory2.default).directive('hpEmailInput', _emailDirective2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/common/controls/changePassword/changePassword.html', __webpack_require__(819)); // eslint-disable-line global-require
    $templateCache.put('app/common/controls/email/emailTemplate.html', __webpack_require__(820)); // eslint-disable-line global-require
    $templateCache.put('app/common/controls/password/passwordTemplate.html', __webpack_require__(821)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = changePasswordController;

__webpack_require__(816);

changePasswordController.$inject = ['$scope', 'ChangePasswordFactory', 'CommonValidationFactory']; // angular
// 	.module("HeroPRO")
// 	.controller("ChangePasswordController", changePasswordController);

/* @ngInject */
function changePasswordController($scope, ChangePasswordFactory, CommonValidationFactory) {
    var vm = this;

    vm.originalPassword = '';
    vm.newPassword = '';
    vm.newConfirmPassword = '';
    vm.isEmailSent = false;
    vm.user = {};
    vm.passwordHint = '';

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    vm.submitPasswordChange = function (isValid) {
        if (isValid && $scope.password.changePassword.$dirty) {
            var data = {
                curXWord: vm.originalPassword,
                newXWord: vm.newPassword
            };
            submitPasswordChange(data);
        } else {
            vm.cancelChangePassword();
        }
    };

    vm.cancelChangePassword = function () {
        ChangePasswordFactory.isPasswordDirty = false;
        ChangePasswordFactory.changePasswordEnable = false;
    };

    vm.checkPassword = function () {
        //		console.log(vm.newPassword);
        vm.passwordHint = CommonValidationFactory.validatePassword(vm.newPassword);
        if (vm.passwordHint && vm.passwordHint.length > 0) {
            $scope.password.changePassword.txtNewPassword.$setValidity('invalid-password', false);
        } else {
            $scope.password.changePassword.txtNewPassword.$setValidity('invalid-password', true);
        }

        vm.checkConfirmPassword();
    };

    vm.checkConfirmPassword = function () {
        ChangePasswordFactory.isPasswordDirty = true;
        if (vm.newPassword !== vm.newConfirmPassword && vm.newConfirmPassword !== '' && vm.newConfirmPassword !== undefined) {
            $scope.password.changePassword.txtNewPassword.$setValidity('nomatch', false);
            $scope.password.changePassword.txtNewConfirmPassword.$setValidity('nomatch', false);
            vm.noMatchEerrorMessage = 'Passwords do not match';
            vm.isPasswordConfirmed = false;
        } else {
            $scope.password.changePassword.txtNewPassword.$setValidity('nomatch', true);
            $scope.password.changePassword.txtNewConfirmPassword.$setValidity('nomatch', true);
            vm.noMatchEerrorMessage = '';
            if (vm.newPassword === vm.newConfirmPassword) {
                vm.isPasswordConfirmed = true;
            }
        }

        if ($scope.password.changePassword.txtNewPassword.$invalid || $scope.password.changePassword.txtNewConfirmPassword.$invalid) {
            vm.isPasswordConfirmed = false;
        }
    };

    vm.requestPassword = function () {
        sendForgotPasswordEmail(vm.user.Email);
    };

    vm.clearOriginalPassword = function () {
        ChangePasswordFactory.isPasswordDirty = true;
        $scope.password.changePassword.txtOriginalPassword.$setValidity('incorrect', true);
        vm.errorMessage = '';
    };

    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */

    function init() {
        vm.user = ChangePasswordFactory.userObj;
        resetPasswordFields();
    }

    function submitPasswordChange(data) {
        ChangePasswordFactory.changeUserPassword(data).then(function (response) {
            if (response.data.ResultCode === 2) {
                $scope.password.changePassword.txtOriginalPassword.$setValidity('incorrect', false);
                vm.errorMessage = 'Password incorrect.';
                vm.isEmailConfirmed = false;
            } else if (response.data.ResultCode === 1) {
                resetPasswordFields();
                ChangePasswordFactory.changePasswordEnable = false;
                ChangePasswordFactory.statusMessage = 'Your password has been saved.';
            }
        });
    }

    function sendForgotPasswordEmail(email) {
        ChangePasswordFactory.requestRecoverPasswordEmail(email).then(function (response) {
            if (response.data.Result || response.data.Data) {
                ChangePasswordFactory.statusMessage = 'We\'ve sent a reset password link to ' + vm.user.Email;
            }
        });
    }

    function resetPasswordFields() {
        vm.originalPassword = '';
        vm.newPassword = '';
        vm.newConfirmPassword = '';
        vm.errorMessage = '';
    }

    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 816 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = EmailInput;
// angular
// 	.module("HeroPRO")
// 	.directive("hpEmailInput", EmailInput);

function EmailInput() {
    return {
        require: '^form',
        restrict: 'E',
        //		controller: "EmailController",
        //		controllerAs: "email",
        //		bindToController: true,
        templateUrl: 'app/common/controls/email/emailTemplate.html',
        scope: {
            value: '@?',
            emailId: '@?',
            placeholderText: '@?',
            isRequired: '@?',
            isLabelVisible: '@',
            emailLabel: '@?',
            isFormSubmitted: '@?',
            isVisible: '@?',
            onBlur: '&?',
            onClick: '&?'
        },
        transclude: true,
        link: link
    };

    function link(scope, element, attr, ctrl) {
        scope.$watch(scope.isFormSubmitted, function () {
            if (scope.value === '' && scope.isVisible) {
                ctrl.emailForm.emailName.$setValidity('required', false);
                scope.errorMessage = 'Required';
            } else if (scope.isVisible) {
                ctrl.emailForm.emailName.$setValidity('required', true);
                scope.errorMessage = '';
            }
        });
    }
}

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = PasswordInput;
// angular
// 	.module("HeroPRO")
// 	.directive("hpPasswordInput", PasswordInput);

function PasswordInput() {
    return {
        restrict: 'E',
        controller: 'PasswordController',
        controllerAs: 'password',
        bindToController: true,
        templateUrl: 'app/common/controls/password/passwordTemplate.html',
        scope: {
            value: '@',
            passwordId: '@?',
            passwordName: '@?',
            isLabelVisible: '@',
            passwordLabel: '@?',
            errorDisplayCondition: '@?',
            onBlur: '&?'
        }
        // ,link: link
    };

    // function link(scope, element, attr, ctrl) {

    // }
}

/***/ }),
/* 819 */
/***/ (function(module, exports) {

module.exports = "<div class=\"change-password-container\" ng-controller=\"ChangePasswordController as password\">\n    <form id=\"change-password-form\" name=\"password.changePassword\" class=\"change-password-form\"\n          ng-submit=\"password.submitPasswordChange(password.changePassword.$valid)\" novalidate>\n        <div class=\"change-password-edit-container\">\n            <div class=\"row\">\n                <div class=\"col-md-12 change-password-field-container\">\n                    <input type=\"password\" id=\"txt-original-password\" name=\"txtOriginalPassword\"\n                           class=\"password-field\" placeholder=\"Current Password\" autocomplete=\"false\"\n                           ng-required=\"password.changePassword.txtOriginalPassword.$dirty || password.changePassword.txtNewPassword.$dirty || password.changePassword.txtNewConfirmPassword.$dirty\"\n                           ng-model=\"password.originalPassword\" minlength=\"5\" ng-change=\"password.clearOriginalPassword()\"/>\n                    <div class=\"error-message-container\">\n                        <p class=\"error-message\"\n                           ng-show=\"password.changePassword.txtOriginalPassword.$error.required\">\n                            Required</p>\n                        <p class=\"error-message\"\n                           ng-show=\"password.changePassword.txtOriginalPassword.$error.minlength\">\n                            Password needs to be at least 5 characters</p>\n                        <p class=\"error-message\" ng-show=\"password.errorMessage !== ''\" ng-bind=\"password.errorMessage\"></p>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-12 change-password-field-container\">\n                    <span class=\"icon icon-todo\" ng-if=\"password.isPasswordConfirmed\"></span>\n                    <input type=\"password\" id=\"txt-new-password\" name=\"txtNewPassword\" class=\"password-field confirm-password-padding\"\n                           ng-model=\"password.newPassword\" ng-required=\"password.changePassword.txtOriginalPassword.$dirty\" placeholder=\"New Password\" ng-change=\"password.checkPassword()\"/>\n                    <div class=\"field-message-container\">\n                        <div class=\"tip\">\n                            <p ng-bind=\"password.passwordHint\"></p>\n                        </div>\n                        <p class=\"error-message\"\n                           ng-show=\"password.changePassword.txtNewPassword.$error.required && password.passwordHint.length === 0\">\n                            Required</p>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-12 change-password-field-container\">\n                    <span class=\"icon icon-todo\" ng-if=\"password.isPasswordConfirmed\"></span>\n                    <input type=\"password\" id=\"txt-new-confirm-password\" name=\"txtNewConfirmPassword\" class=\"password-field confirm-password-padding\" minlength=\"5\"\n                           ng-model=\"password.newConfirmPassword\" required placeholder=\"Confirm New Password\" ng-change=\"password.checkConfirmPassword()\"\n                           ng-required=\"password.changePassword.txtOriginalPassword.$dirty || password.changePassword.txtNewPassword.$dirty\"/>\n\n                    <div class=\"error-message-container\">\n                        <p class=\"error-message\"\n                           ng-show=\"password.changePassword.txtNewConfirmPassword.$error.required\">\n                            Required</p>\n                        <p class=\"error-message\"\n                           ng-show=\"password.changePassword.txtNewConfirmPassword.$error.minlength\">\n                            Password needs to be at least 5 characters</p>\n                        <p class=\"error-message\" ng-show=\"password.noMatchEerrorMessage !== ''\" ng-bind=\"password.noMatchEerrorMessage\"></p>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-12\">\n                    <div class=\"change-password-button-container\">\n                        <div class=\"change-password-save-container pull-left\">\n                            <button class=\"btn btn-primary\" id=\"btn-change-password-save\" ng-disabled=\"password.changePassword.$invalid\">Save</button>\n                        </div>\n                        <div class=\"change-password-cancel-container pull-left\">\n                            <button class=\"btn btn-default\" id=\"btn-change-password-cancel\"\n                                    ng-click=\"password.cancelChangePassword()\">Cancel\n                            </button>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </form>\n</div>\n";

/***/ }),
/* 820 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"label-container\" ng-if=\"isLabelVisible\">\n        <label ng-bind=\"emailLabel\"></label>\n        <div class=\"required-indicator\"></div>\n    </div>\n    <div>\n        <ng-form name=\"emailForm\">\n            <input ng-attr-id=\"{{emailId}}\" name=\"emailName\" class=\"form-control email-field\" type=\"text\" required\n                   ng-model=\"value\" autocomplete=\"off\" maxlength=\"60\" ng-blur=\"onBlur()\" ng-click=\"onClick()\" ng-required=\"!value\"\n                   ng-attr-placeholder=\"{{placeholderText}}\">\n            <div class=\"error-message-container\">\n                <p class=\"error-message\" ng-show=\"errorMessage.length > 0\" ng-bind=\"errorMessage\"></p>\n            </div>\n        </ng-form>\n    </div>\n</div>\n";

/***/ }),
/* 821 */
/***/ (function(module, exports) {

module.exports = "<div class=\"password-container\">\n    <div class=\"label-container\" ng-if=\"isLabelVisible\">\n        <label ng-bind=\"passwordLabel\"></label>\n        <div class=\"required-indicator\"></div>\n    </div>\n    <div>\n        <input id=\"passwordId\" name=\"passwordName\" class=\"form-control password-field\" type=\"password\" required\n               ng-model=\"value\" autocomplete=\"off\" maxlength=\"30\" ng-blur=\"onBlur\">\n        <p class=\"password-error-message\" ng-show=\"errorDisplayCondition\" ng-bind=\"errorMessage\"></p>\n    </div>\n</div>\n";

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _smartyProvider = __webpack_require__(823);

var _smartyProvider2 = _interopRequireDefault(_smartyProvider);

var _disableArrows = __webpack_require__(824);

var _disableArrows2 = _interopRequireDefault(_disableArrows);

var _raSmartyStreets = __webpack_require__(825);

var _raSmartyStreets2 = _interopRequireDefault(_raSmartyStreets);

var _smartyValidator = __webpack_require__(826);

var _smartyValidator2 = _interopRequireDefault(_smartyValidator);

var _app = __webpack_require__(76);

var HPConfig = _interopRequireWildcard(_app);

__webpack_require__(827);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.smarty', []).constant('HPConfig', HPConfig.default).provider('raSmarty', _smartyProvider2.default).directive('disableArrows', _disableArrows2.default).directive('smartyStreetsInput', _raSmartyStreets2.default).directive('smartyValidator', _smartyValidator2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/common/smarty/smarty-template.html', __webpack_require__(828)); // eslint-disable-line global-require
}]).name;

// no controller

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = raSmarty;
raSmarty.$inject = ['HPConfig'];
// angular.module('HeroPRO')
//     .provider('raSmarty', raSmarty);

var smartyDefaults = {
    authID: '2619780531663440111',
    suggestions: '4',
    errorMessage: "Hmm, didn't find a match for this address.",
    noSuggestionsMessage: 'No more suggestions...'
};

/* @ngInject */
function raSmarty(HPConfig) {
    var p = this;
    var config = void 0;

    p.configure = function (_config) {
        config = _config;
    };

    p.$get = function ($http, $q) {
        var Smarty = function Smarty(_config) {
            this.config = angular.extend({}, smartyDefaults, _config);
        };

        Smarty.prototype.getAddress = function (address, stateFilter) {
            if (HPConfig.splashMtnEnabled === 'true') {
                return getSplashMountainSuggestions(HPConfig, $http, address).then(function (result) {
                    return processSplashMtnResults(result.data.addresses);
                });
            } else if (HPConfig.splashMtnEnabled === 'both') {
                var splashMountainSuggestionsPromise = getSplashMountainSuggestions(HPConfig, $http, address);
                var smartySuggestionsPromise = getSmartySuggestions($http, this.config, address, stateFilter);
                var splashMountainSuggestions = void 0;
                var smartySuggestions = void 0;
                splashMountainSuggestionsPromise.then(function (response) {
                    // console.log("splashMountainSuggestions",response);
                    splashMountainSuggestions = response.data.addresses;
                });
                smartySuggestionsPromise.then(function (response) {
                    // console.log("smartySuggestions",response);
                    smartySuggestions = response.data;
                });
                var _config2 = this.config;
                return $q.all([splashMountainSuggestionsPromise, smartySuggestionsPromise]).then(function () {
                    var combinedResults = combineResults(processSplashMtnResults(splashMountainSuggestions).suggestions, smartySuggestions.suggestions, _config2.suggestions);
                    return combinedResults;
                });
            }
            return getSmartySuggestions($http, this.config, address, stateFilter).then(function (result) {
                return result.data;
            });
        };

        // TODO: Make endpoint available in the config phase
        Smarty.prototype.verifyAddress = function (street, secondary, city, state, propertyId, source) {
            var url = void 0,
                http = void 0;
            var headers = {
                'Content-Type': 'application/json'
            };
            if (source === 'splash') {
                url = HPConfig.splashMtnUrl + '/propertyprofiles/' + encodeURIComponent(propertyId);
                headers = {
                    'Content-Type': 'application/json',
                    'X-RACtx': undefined,
                    'X-Requested-With': undefined,
                    'x-api-key': HPConfig.splashMtnApiKey
                };
                http = $http({
                    url: url,
                    method: 'GET',
                    headers: headers,
                    withCredentials: false
                });
                return http.then(function (result) {
                    return processSplashMtnVerifyResults(result);
                });
            }
            if (secondary === undefined || secondary === null) {
                url = HPConfig.heroProApi + 'Address/VerifyWithSmarty?street=' + processAddress(street) + '&city=' + processAddress(city) + '&state=' + state;
            } else {
                url = HPConfig.heroProApi + 'Address/VerifyWithSmarty?street=' + processAddress(street) + '&secondary=' + processAddress(secondary) + '&city=' + processAddress(city) + '&state=' + state;
            }
            http = $http({
                url: url,
                method: 'GET',
                headers: headers,
                withCredentials: false
            });
            return http;
        };

        return new Smarty(config);
    };
    p.$get.$inject = ['$http', '$q'];
}

function getSmartySuggestions($http, config, address, stateFilter) {
    return $http({
        // url: 'https://autocomplete-api.smartystreets.com/suggest?auth-id=' + config.authID + '&prefix=' + processAddress(address) + '&suggestions=' + config.suggestions,
        url: 'https://autocomplete-api.smartystreets.com/suggest?auth-id=' + config.authID + '&prefix=' + processAddress(address) + '&state_filter=' + stateFilter + '&suggestions=' + config.suggestions,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-RACtx': undefined,
            'X-Requested-With': undefined
        },
        withCredentials: false
    });
}

function getSplashMountainSuggestions(HPConfig, $http, address) {
    return $http({
        url: HPConfig.splashMtnUrl + '/propertyprofiles/lookup?address=' + encodeURIComponent(address),
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-RACtx': undefined,
            'X-Requested-With': undefined,
            'x-api-key': HPConfig.splashMtnApiKey
        },
        withCredentials: false
    });
}

function combineResults(splashMountainSuggestions, smartySuggestions, maxResultCount) {
    splashMountainSuggestions = splashMountainSuggestions !== null ? splashMountainSuggestions : [];
    smartySuggestions = smartySuggestions !== null ? smartySuggestions : [];

    var results = splashMountainSuggestions.slice(0);

    var numberOfSmartyResultsToKeep = maxResultCount - splashMountainSuggestions.length;
    var smartyAdded = 0;
    for (var i = 0; i < smartySuggestions.length && smartyAdded < numberOfSmartyResultsToKeep; i++) {
        smartySuggestions[i].text = smartySuggestions[i].text.toUpperCase();
        var compareAgainst = smartySuggestions[i].text.split(',')[0];
        var found = false;
        for (var j = 0; j < splashMountainSuggestions.length; j += 1) {
            if (splashMountainSuggestions[j].text.indexOf(compareAgainst) >= 0) {
                found = true;
                break;
            }
        }

        if (found === false) {
            smartySuggestions[i].source = 'smarty';
            results.push(smartySuggestions[i]);
            smartyAdded++;
            if (results.length === maxResultCount) {
                break;
            }
        }
    }

    return { suggestions: results };
}

function processAddress(address) {
    var encodedAddress = '';
    if (address !== undefined && address.length > 0) {
        var addressComponents = address.split(' ');
        for (var index = 0; index < addressComponents.length; index++) {
            encodedAddress += encodeURIComponent(addressComponents[index]);
            if (index < addressComponents.length - 1) {
                encodedAddress += '+';
            }
        }
    }
    return encodedAddress;
}

function processSplashMtnResults(results) {
    if (results.length <= 0) {
        return { suggestions: null };
    }
    var newResults = [];
    var max = results.length > 4 ? 4 : results.length;
    for (var i = 0; i < results.length; i++) {
        var addressBreakout = results[i].address.split(',');
        var propertyKeyBreakout = results[i].propertyKey.split('_');
        var item = {
            street_line: addressBreakout[0].trim(),
            // we can't assume there will be a city, addressBreakout may only have two
            // items in the array ([address_line, who_knows_what]) if there is a second comma
            // (three items in the array) then we can assume the second position is a city ([address_line, city, who_knows_what])
            // who_knows_what could be state and/or zip
            city: addressBreakout.length > 2 ? addressBreakout[1].trim() : '',
            // we can be sure state is in position 6 on the property key, assuming no changes to splash mtn
            state: propertyKeyBreakout[6],
            zip: propertyKeyBreakout[7],
            text: results[i].address,
            propertyId: results[i].propertyProfileId,
            source: 'splash'
        };

        // must have city and zip
        if (item.zip && item.zip !== '' && item.city && item.city !== '') {
            newResults.push(item);
        }

        if (newResults.length === max) {
            i = results.length;
        }
    }
    return { suggestions: newResults };
}

function processSplashMtnVerifyResults(results) {
    if (!results.data) {
        return results;
    }
    var result = angular.copy(results.data);
    var line1 = result.AddressParts.HouseNumber;
    line1 += result.AddressParts.StreetPreDirection ? ' ' + result.AddressParts.StreetPreDirection : '';
    line1 += ' ' + result.AddressParts.Street;
    line1 += result.AddressParts.StreetSuffix ? ' ' + result.AddressParts.StreetSuffix : '';
    line1 += result.AddressParts.StreetPostDirection ? ' ' + result.AddressParts.StreetPostDirection : '';

    var lastLine = result.AddressParts.City + ', ' + result.AddressParts.State + ' ' + result.AddressParts.ZipCode;
    var zipCode = result.AddressParts.ZipCode;
    lastLine += zipCode;

    // ra-smarty-streets.js expects a smart object
    var smartyObject = {
        Address: result.Address,
        delivery_line_1: line1,
        last_line: lastLine,
        analysis: { dpv_match_code: 'Y' },
        components: {
            primary_number: result.AddressParts.HouseNumber,
            city_name: result.AddressParts.City,
            state_abbreviation: result.AddressParts.State,
            secondary_number: result.AddressParts.StreetSecondaryNumber,
            zipcode: zipCode,
            plus4_code: result.AddressParts.ZipCodePlus4,
            street_name: result.AddressParts.Street,
            street_suffix: result.AddressParts.StreetSuffix,
            street_predirection: result.AddressParts.StreetPreDirection,
            street_postdirection: result.AddressParts.StreetPostDirection,
            apn: result.APN,
            fips_code: result.FIPSCode
        }
    };

    // replace the original splash mtn object with the smart object

    results.data.Data = [smartyObject];
    // reattach
    results.data.Data[0].splashMtnObject = result;

    return results;
}

function filterOutNonZipcodeSuggestions(addresses) {
    return addresses.suggestions.filter(function (address) {
        return address.zip;
    });
}

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = DisableArrowsDirective;
// angular.module('HeroPRO')
//   .directive('disableArrows',


function DisableArrowsDirective() {
    function disableArrows(event) {
        if (event.keyCode === 38 || event.keyCode === 40 || event.keyCode === 9 || event.keyCode === 13) {
            event.preventDefault();
        }
    }
    return {
        link: function link(scope, element) {
            element.on('keydown', disableArrows);
        }
    };
}

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = smartyStreetsInput;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

smartyStreetsInput.$inject = ['raSmarty']; // angular.module('HeroPRO')
//     .directive('smartyStreetsInput', smartyStreetsInput);

/* @ngInject */
function smartyStreetsInput(raSmarty) {
    var directive = {
        restrict: 'EA',
        controller: smartyController,
        scope: {
            smartyModel: '=',
            labelAbove: '=',
            labelBelow: '=',
            smartyClass: '@',
            smartyId: '@',
            smartyName: '@',
            smartyPlaceholder: '@',
            labelName: '@',
            smartyZipcode: '&',
            stateFilter: '='
        },

        templateUrl: function templateUrl(element, attr) {
            return attr.template || 'app/common/smarty/smarty-template.html';
        },

        controllerAs: 'smartyCtrl',
        bindToController: true,
        transclude: true
    };
    smartyController.$inject = ["$rootScope"];
    return directive;

    function smartyController($rootScope) {
        var vm = this,
            dataObject = {},
            suggestionObject = {},
            suggestionNumber = 0,
            canBlur = true,
            street = '',
            city = '',
            state = '',
            suggestionText = '';
        vm.listAddresses = [];
        vm.noSuggestions = raSmarty.config.noSuggestionsMessage;
        vm.sorryMessage = raSmarty.config.errorMessage;

        vm.showList = false;
        vm.showResults = true;
        vm.successResult = false;
        vm.selected = 0;
        vm.getSmartyAddress = getSmartyAddress;
        vm.verifySmartyAddress = verifySmartyAddress;
        vm.hideList = hideList;
        vm.revealList = revealList;
        vm.handleBlur = handleBlur;
        vm.handleResultMouseDown = handleResultMouseDown;

        // init smarty in the pristine state
        smartyPristine();

        function getSmartyAddress(address, keyCode) {
            revealList();
            // 40 = down arrow, 38 = up arrow, 39 = right arrow, 37 = left arrow, 13 = enter, 9 = tab
            if (keyCode !== 40 && keyCode !== 38 && keyCode !== 39 && keyCode !== 37 && keyCode !== 13 && keyCode !== 9) {
                raSmarty.getAddress(address, vm.stateFilter).then(function (data) {
                    if (data.suggestions !== null && (data.suggestions.length !== undefined || data.suggestions.length !== null)) {
                        vm.selected = 0;
                        vm.showResults = true;
                        vm.pristine = true;
                        vm.invalid = false;
                        vm.valid = false;
                        if (data.suggestions[vm.selected] !== undefined) {
                            suggestionObject = data.suggestions;
                            vm.listAddresses = suggestionObject;
                            suggestionNumber = data.suggestions.length;
                            street = data.suggestions[vm.selected].street_line;
                            city = data.suggestions[vm.selected].city;
                            state = data.suggestions[vm.selected].state;
                            suggestionText = data.suggestions[vm.selected].text;
                        }
                    } else {
                        vm.showResults = false;
                        vm.selected = -1;
                    }
                });
            }

            // KEY COMMANDS
            if (keyCode === 40) {
                // down
                vm.selected++;
                if (vm.selected > suggestionNumber - 1) {
                    vm.selected = 0;
                }
            }
            if (keyCode === 38) {
                // up
                vm.selected--;
                if (vm.selected < 0) {
                    vm.selected = suggestionNumber - 1;
                }
            }

            if (suggestionObject[vm.selected] !== undefined) {
                if (keyCode === 13 || keyCode === 9) {
                    vm.verifySelectedSmartyAddress(vm.selected);
                }
            } else if (keyCode === 13 || keyCode === 9) {
                hideList();
                smartyInvalid();
            }
        }

        // Added method to extract secondary information with # if it exists.
        // Extracting secondary is not needed for all cases where Secondary contains alphanumeric values such as Unit 161.
        vm.verifySelectedSmartyAddress = function (index) {
            // console.log(suggestionObject[index]);
            var secondaryLine = '';

            var indexOfPound = suggestionObject[index].street_line.indexOf('#');
            // Check if address even has a #
            if (indexOfPound > -1) {
                var splitAddress = suggestionObject[index].street_line.split(' ');
                var address = suggestionObject[index].street_line.substring(0, indexOfPound);
                var poundIndex = _lodash2.default.indexOf(splitAddress, '#');

                // Handle case where the # is spaced separate from the number.
                if (splitAddress[poundIndex].length > 1) {
                    secondaryLine = splitAddress[poundIndex];
                } else {
                    secondaryLine = splitAddress[poundIndex] + ' ' + splitAddress[poundIndex + 1];
                }
                verifySmartyAddress(address, secondaryLine, suggestionObject[index].city, suggestionObject[index].state, index, suggestionObject[index].propertyId, suggestionObject[index].source);
            } else {
                // No secondary with #, so verify normally.
                verifySmartyAddress(suggestionObject[index].street_line, null, suggestionObject[index].city, suggestionObject[index].state, index, suggestionObject[index].propertyId, suggestionObject[index].source);
            }
        };

        function verifySmartyAddress(street, secondary, city, state, index, propertyId, source) {
            hideList();
            vm.selected = index;
            raSmarty.verifyAddress(street, secondary, city, state, propertyId, source).then(function (result) {
                vm.successResult = true;
                if (!!result.data.Data && result.data.Data.length > 0) {
                    var res = result.data.Data[0];
                    vm.smartyModel.isValid = true;
                    vm.smartyModel.addressText = res.Address || res.delivery_line_1 + ' ' + res.last_line;
                    vm.smartyModel.dpvMatchCode = res.analysis.dpv_match_code;
                    dataObject = {
                        street: res.delivery_line_1,
                        city: res.components.city_name,
                        state: res.components.state_abbreviation,
                        unit: res.components.secondary_number,
                        zipcode: res.components.zipcode,
                        addressData: res.components
                    };
                    angular.extend(vm.smartyModel, dataObject);
                    smartyValid();
                } else {
                    vm.successResult = false;
                    vm.smartyModel.isValid = false;
                    smartyInvalid();

                    if (vm.selected && suggestionObject[vm.selected]) {
                        vm.smartyModel.addressText = suggestionObject[vm.selected].text;
                    }

                    dataObject = {};
                    angular.extend(vm.smartyModel, dataObject);
                }
            });
        }

        function hideList() {
            vm.showList = false;
        }

        function revealList() {
            vm.showList = true;
        }

        function handleResultMouseDown() {
            canBlur = false;
        }

        // this will hide our list if we can blur, along with selecting the suggestion on select
        function handleBlur() {
            if (canBlur) {
                hideList();
                if (suggestionObject[vm.selected] !== undefined) {
                    vm.verifySelectedSmartyAddress(vm.selected);
                }
            } else {
                canBlur = true;
            }
        }

        /* Private Functions */
        function smartyValid() {
            vm.valid = true;
            vm.pristine = false;
            vm.invalid = false;
        }

        function smartyInvalid() {
            vm.valid = false;
            vm.pristine = false;
            vm.invalid = true;
        }

        function smartyPristine() {
            vm.valid = false;
            vm.invalid = false;
            vm.pristine = true;
        }

        function showInvalidAddressDropDown() {
            hideList();
            smartyInvalid();
        }

        $rootScope.$on("triggerShowInvalidAddressDropDown", function () {
            showInvalidAddressDropDown();
        });
    }
}

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = SmartyValidatorDirective;
// angular.module('HeroPRO')
//   .directive('smartyValidator', smartyValidator);

function SmartyValidatorDirective() {
    var directiveSmarty = {
        require: 'ngModel',
        link: function link(scope, elem, attrs, ctrl) {
            scope.$watch(function () {
                if (scope.smartyCtrl.invalid || scope.smartyCtrl.pristine) {
                    ctrl.$setValidity('smarty', false);
                }
                if (scope.smartyCtrl.valid) {
                    ctrl.$setValidity('smarty', true);
                }
            });
        }
    };

    return directiveSmarty;
}

/***/ }),
/* 827 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 828 */
/***/ (function(module, exports) {

module.exports = "<div class=\"smarty-container\">\n  <input type=\"text\" class=\"{{smartyCtrl.smartyClass}}\" id=\"{{smartyCtrl.smartyId}}\" name=\"{{smartyCtrl.smartyName}}\"\n         ng-class=\"{'ra-smarty-invalid': smartyCtrl.invalid, 'ra-smarty-valid': smartyCtrl.valid, 'ra-smarty-pristine': smartyCtrl.pristine}\"\n         ng-model=\"smartyCtrl.smartyModel.addressText\" ng-keyup=\"smartyCtrl.getSmartyAddress(smartyCtrl.smartyModel.addressText, $event.keyCode)\"\n         ng-blur=\"smartyCtrl.handleBlur();\" placeholder=\"{{smartyCtrl.smartyPlaceholder}}\" required disable-arrows smarty-validator autocomplete=\"off\"\n         hp-alphanumeric-only/>\n  <label for=\"{{smartyCtrl.smartyId}}\" ng-if=\"smartyCtrl.labelBelow\" ng-bind=\"smartyCtrl.labelName\"></label>\n  <div class=\"smarty-tooltip\" ng-if=\"!smartyCtrl.showList && !smartyCtrl.pristine && smartyCtrl.invalid\">\n    <div class=\"smarty-sorry-message\" ng-bind=\"smartyCtrl.sorryMessage\"></div>\n    <div class=\"smarty-zipcode-link btn btn-default\" ng-click=\"smartyCtrl.smartyZipcode()\">Try entering it another way here.</div>\n  </div>\n  <div class=\"smarty-result\" ng-mousedown=\"smartyCtrl.handleResultMouseDown()\" ng-if=\"smartyCtrl.showList\">\n    <div class=\"smarty-suggestion\" ng-repeat=\"address in smartyCtrl.listAddresses track by $index\" ng-bind=\"address.text\"\n         ng-click=\"smartyCtrl.verifySelectedSmartyAddress($index)\" ng-class=\"{selected: $index === smartyCtrl.selected}\"\n         ng-if=\"smartyCtrl.showResults\">\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _jobFactory = __webpack_require__(830);

var _jobFactory2 = _interopRequireDefault(_jobFactory);

var _assignJobController = __webpack_require__(831);

var _assignJobController2 = _interopRequireDefault(_assignJobController);

var _hideJobController = __webpack_require__(833);

var _hideJobController2 = _interopRequireDefault(_hideJobController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.common.job', []).controller('AssignJobController', _assignJobController2.default).controller('HideJobController', _hideJobController2.default).factory('JobFactory', _jobFactory2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/common/job/assign/assignJobTemplate.html', __webpack_require__(835)); // eslint-disable-line global-require
    $templateCache.put('app/common/job/hide/hideJob.html', __webpack_require__(836)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = JobFactory;
JobFactory.$inject = ['HPConfig', '$http'];
// angular
// 	.module("HeroPRO")
// 	.factory("JobFactory", jobFactory);

/* @ngInject */
function JobFactory(HPConfig, $http) {
    var activeJob = {},
        isAssignJob = false;

    return {
        assignLead: assignLead,
        assignApplication: assignApplication,
        hideLead: hideLead,
        hideApplication: hideApplication,
        unhideLead: unhideLead,
        unhideApplication: unhideApplication,
        getSalesReps: getSalesReps,
        getHideReasons: getHideReasons,
        setActiveJob: setActiveJob,
        getActiveJob: getActiveJob,
        setAssignJobFlag: setAssignJobFlag,
        getAssignJobFlag: getAssignJobFlag
    };

    /*
    HP-162: Assign a Job Modal (Leads/KBYG)
    Params: {"PreQualId":1509532,
    "ContractorUserId":24041,
    "ContractorLocationId":"18857"}
    Returns:
    ContractorUserId: the user that triggered the changed
    PreQualId
    PreviosSalesRepContractorUserId
    PreviosContractorLocationId
    NewSalesRepContractorUserId: if null means nothing changed
    NewContractorLocationId: if null means nothing changed
    */
    function assignLead(params) {
        return $http({
            url: HPConfig.heroProApi + 'KBYG/LocationAndContractorUser',
            method: 'POST',
            data: params
        });
    }

    /*
    HP-162: Assign a Job Modal (Applications/Loans)
    Params: {"FundingRequestId":319294,
    "ContractorUserId":24041,
    "ContractorLocationId":"18857"}
    Returns:
    ContractorUserId: the user that triggered the changed
    FundingRequestId
    LoanId
    PreviosSalesRepContractorUserId
    PreviosContractorLocationId
    NewSalesRepContractorUserId: if null means nothing changed
    NewContractorLocationId: if null means nothing changed
    */
    function assignApplication(params) {
        return $http({
            url: HPConfig.heroProApi + 'Loan/FundingRequest/LocationAndContractorUser',
            method: 'POST',
            data: params
        });
    }

    /*
    HP-1061: Hide a Job Modal (Leads/KBYG)
    Params: {"PreQualId": (int),
    "ContractorJobHideReasonTypeId":(int),
    "Reason": (string)}
    Returns:
    PreQualId
    IsContractorJobHidden
    ContractorJobHideReasonTypeId
    ContractorJobHideReason
    ContractorJobHideDate
    */
    function hideLead(params) {
        return $http({
            url: HPConfig.heroProApi + 'KBYG/HideFromContractor',
            method: 'POST',
            data: params
        });
    }

    /*
    HP-46: Hide a Job Modal (Applications/Loans)
    Params: {"FundingRequestId":(int),
    "ContractorUserId":(int),
    "ContractorLocationId":(string)}
    Returns:
    FundingRequestId
    IsContractorJobHidden
    ContractorJobHideReasonTypeId
    ContractorJobHideReason
    ContractorJobHideDate
    */
    function hideApplication(params) {
        return $http({
            url: HPConfig.heroProApi + 'Loan/FundingRequest/HideFromContractor',
            method: 'POST',
            data: params
        });
    }

    function unhideLead(params) {
        return $http({
            url: HPConfig.heroProApi + 'KBYG/UnhideFromContractor',
            method: 'POST',
            data: params
        });
    }

    function unhideApplication(params) {
        return $http({
            url: HPConfig.heroProApi + 'Loan/FundingRequest/UnhideFromContractor',
            method: 'POST',
            data: params
        });
    }

    function getSalesReps(contractorId) {
        return $http({
            url: HPConfig.heroProApi + 'ContractorUser',
            method: 'GET',
            params: {
                ContractorLocationIds: contractorId,
                FilterBySalesRep: false
            }
        });
    }

    function getHideReasons() {
        return $http({
            url: HPConfig.heroProApi + 'Contractor/ContractorJobHideReasonTypes',
            method: 'GET'
        });
    }

    function setActiveJob(job) {
        activeJob = job;
    }

    function getActiveJob() {
        return activeJob;
    }

    function setAssignJobFlag(isAssign) {
        isAssignJob = isAssign;
    }

    function getAssignJobFlag() {
        return isAssignJob;
    }
}

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = assignJobController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(832);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

assignJobController.$inject = ['$rootScope', 'JobFactory', 'UserData', 'raSpinnerService', 'ModalService', '$analytics']; // angular
// 	.module("HeroPRO")
// 	.controller("AssignJobController", assignJobController);

/* @ngInject */
function assignJobController($rootScope, JobFactory, UserData, raSpinnerService, ModalService, $analytics) {
    var vm = this;

    vm.selectedLocation = {};
    vm.selectedSalesRep = {};
    vm.locations = [];
    vm.salesReps = [];
    vm.loading = true;
    vm.isAssignmentDisabled = true;
    vm.activeJob = {};
    vm.originalLocationId = null;
    vm.originalSalesRepId = null;

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    vm.locationClicked = function (item) {
        vm.selectedLocation = item;
        getSalesReps();
    };

    vm.salesRepClicked = function (item) {
        vm.selectedSalesRep = item;
        vm.isAssignmentDisabled = validateSelections();
    };

    vm.submitAssignment = function (isValid) {
        if (isValid) {
            raSpinnerService.show('jobSpinner');
            var params = {};
            if (vm.activeJob.PreQualId !== undefined && vm.activeJob.PreQualId !== null && vm.activeJob.PreQualId !== '') {
                params = {
                    PreQualId: vm.activeJob.PreQualId,
                    ContractorUserId: vm.selectedSalesRep.ContractorUserId,
                    ContractorLocationId: vm.selectedLocation.ContractorId
                };
                JobFactory.assignLead(params).then(function () {
                    $rootScope.$broadcast('pipelineJobAssignment', {
                        data: {
                            PreQualId: vm.activeJob.PreQualId,
                            Location: vm.selectedLocation.LocationNickname,
                            SalesRepName: vm.selectedSalesRep.FirstName + ' ' + vm.selectedSalesRep.LastName
                        }
                    });
                    raSpinnerService.hide('jobSpinner');
                    raSpinnerService._unregister('jobSpinner');
                    ModalService.closeLgModal();
                });
            } else {
                params = {
                    FundingRequestId: vm.activeJob.FundingRequestId,
                    ContractorUserId: vm.selectedSalesRep.ContractorUserId,
                    ContractorLocationId: vm.selectedLocation.ContractorId
                };
                JobFactory.assignApplication(params).then(function () {
                    $rootScope.$broadcast('pipelineJobAssignment', {
                        data: {
                            FundingRequestId: vm.activeJob.FundingRequestId,
                            Location: vm.selectedLocation.LocationNickname,
                            SalesRepName: vm.selectedSalesRep.FirstName + ' ' + vm.selectedSalesRep.LastName
                        }
                    });
                    raSpinnerService.hide('jobSpinner');
                    raSpinnerService._unregister('jobSpinner');
                    ModalService.closeLgModal();
                });
            }

            $analytics.eventTrack('Assign Job Clicked', { category: 'AssignJob' });
        }
    };

    vm.cancelAssignment = function () {
        raSpinnerService._unregister('jobSpinner');
        ModalService.closeLgModal();
    };

    vm.jobSpinnerLoaded = function () {
        raSpinnerService.show('jobSpinner');
    };

    vm.showSpinner = function () {
        if (raSpinnerService.isRegistered('jobSpinner')) {
            raSpinnerService.show('jobSpinner');
        } else {
            raSpinnerService._register('jobSpinner');
            raSpinnerService.show('jobSpinner');
        }
    };

    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */
    function init() {
        getLocations();
        vm.activeJob = JobFactory.getActiveJob();
    }

    function getLocations() {
        UserData.getKBYGLocations().then(function (response) {
            vm.locations = response;
            var activeLocation = {};
            if (vm.activeJob.ContractorId !== undefined && vm.activeJob.ContractorId !== null && vm.activeJob.ContractorId !== '') {
                activeLocation = _lodash2.default.where(vm.locations, { ContractorId: vm.activeJob.ContractorId });
                vm.selectedLocation = activeLocation[0];
            } else if (vm.activeJob.ContractorLocationId !== undefined && vm.activeJob.ContractorLocationId !== null && vm.activeJob.ContractorLocationId !== '') {
                activeLocation = _lodash2.default.where(vm.locations, { ContractorId: vm.activeJob.ContractorLocationId });
                vm.selectedLocation = activeLocation[0];
            } else {
                vm.selectedLocation = vm.locations[0];
            }

            if (vm.originalLocationId === null) {
                vm.originalLocationId = vm.selectedLocation.ContractorId;
            }

            vm.isAssignmentDisabled = validateSelections();

            getSalesReps();
        });
    }

    function getSalesReps() {
        JobFactory.getSalesReps(vm.selectedLocation.ContractorId).then(function (result) {
            vm.salesReps = result.data.Data;
            if (vm.activeJob.ContractorUserId !== undefined && vm.activeJob.ContractorUserId !== null && vm.activeJob.ContractorUserId !== '') {
                var activeRep = _lodash2.default.where(vm.salesReps, { ContractorUserId: vm.activeJob.ContractorUserId });

                if (activeRep.length === 0) {
                    vm.selectedSalesRep = vm.salesReps[0];
                } else {
                    vm.selectedSalesRep = activeRep[0];
                }
            } else {
                vm.selectedSalesRep = vm.salesReps[0];
            }

            if (vm.originalSalesRepId === null) {
                vm.originalSalesRepId = vm.selectedSalesRep.ContractorUserId;
            }

            vm.isAssignmentDisabled = validateSelections();

            raSpinnerService.hide('jobSpinner');
        });
    }

    function validateSelections() {
        return vm.selectedLocation.ContractorId === vm.originalLocationId && vm.selectedSalesRep.ContractorUserId === vm.originalSalesRepId;
    }
}

/***/ }),
/* 832 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = hideJobController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(834);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

hideJobController.$inject = ['$rootScope', 'JobFactory', 'UserData', 'raSpinnerService', 'ModalService', '$analytics']; // angular
// 	.module("HeroPRO")
// 	.controller("HideJobController", hideJobController);

/* @ngInject */
function hideJobController($rootScope, JobFactory, UserData, raSpinnerService, ModalService, $analytics) {
    var vm = this;

    vm.selectedReason = {};
    vm.otherReason = '';
    vm.reasons = [];
    vm.isHideDisabled = false;
    vm.activeJob = {};

    vm.defaultReason = {
        Name: 'Choose One',
        Reason: 'Choose One',
        ContractorJobHideReasonTypeId: -1
    };

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    vm.reasonClicked = function (item) {
        vm.selectedReason = item;
        vm.isHideDisabled = isButtonDisabled();
        vm.hideJobForm.$setPristine();
    };

    vm.hideProject = function (isValid) {
        if (isValid) {
            var params = {};
            if (vm.activeJob.PreQualId !== undefined && vm.activeJob.PreQualId !== null && vm.activeJob.PreQualId !== '') {
                params = {
                    PreQualId: vm.activeJob.PreQualId,
                    ContractorJobHideReasonTypeId: vm.selectedReason.ContractorJobHideReasonTypeId,
                    Reason: vm.otherReason === '' ? vm.selectedReason.Reason : vm.otherReason.trim()
                };
                JobFactory.hideLead(params).then(function () {
                    $rootScope.$broadcast('pipelineHideJob', {
                        data: {
                            PreQualId: vm.activeJob.PreQualId,
                            Address: vm.activeJob.Address.trim().toLocaleUpperCase() + ', ' + vm.activeJob.City.toLocaleUpperCase()
                        }
                    });
                    ModalService.closeLgModal();
                });
            } else {
                params = {
                    FundingRequestId: vm.activeJob.FundingRequestId,
                    ContractorJobHideReasonTypeId: vm.selectedReason.ContractorJobHideReasonTypeId,
                    Reason: vm.otherReason === '' ? vm.selectedReason.Reason : vm.otherReason.trim()
                };
                JobFactory.hideApplication(params).then(function () {
                    $rootScope.$broadcast('pipelineHideJob', {
                        data: {
                            FundingRequestId: vm.activeJob.FundingRequestId,
                            Address: vm.activeJob.PropertyAddress1 + ' ' + vm.activeJob.PropertyCity + ', ' + vm.activeJob.PropertyState + ' ' + vm.activeJob.PropertyZip
                        }
                    });
                    ModalService.closeLgModal();
                });
            }

            $analytics.eventTrack('Hide Job Clicked', { category: 'HideAJob', label: vm.otherReason === '' ? vm.selectedReason.Reason : vm.otherReason.trim() });
        }
    };

    vm.cancelHide = function () {
        ModalService.closeLgModal();
    };

    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */
    function init() {
        getReasons();
        vm.activeJob = JobFactory.getActiveJob();
    }

    function getReasons() {
        JobFactory.getHideReasons().then(function (response) {
            vm.reasons = response.data.Data;
            if (_lodash2.default.findWhere(vm.reasons, { ContractorJobHideReasonTypeId: -1 }) === undefined) {
                _lodash2.default.each(vm.reasons, function (reason) {
                    if (reason.Name === 'Other') {
                        reason.Reason = 'Other';
                    }
                });
                vm.reasons.unshift(vm.defaultReason);
                vm.selectedReason = vm.reasons[0];
                vm.isHideDisabled = isButtonDisabled();
            }
        });
    }

    function isButtonDisabled() {
        return vm.selectedReason.ContractorJobHideReasonTypeId === -1;
    }
}

/***/ }),
/* 834 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 835 */
/***/ (function(module, exports) {

module.exports = "<div ng-controller=\"AssignJobController as assignJob\" class=\"assign-job-container\">\n    <form id=\"assign-job-form\" name=\"assignJobForm\" class=\"assign-job-form\"\n          ng-submit=\"assignJob.submitAssignment(assignJobForm.$valid)\" novalidate>\n        <div class=\"hp-loading-spinner assign-job-field-container\" ra-spinner name=\"jobSpinner\" hide-content-when-shown=\"true\"\n             show=\"assignJob.loading\" text=\"Loading...\" on-loaded=\"assignJob.jobSpinnerLoaded\">\n            <div class=\"row\">\n                <div class=\"col-md-12\">\n                    <div class=\"assign-job-label-container\">\n                        <label>Location </label>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-12\">\n                    <div class=\"dropdown dropdown-bordered\" uib-dropdown dropdown-title=\"Location\" ng-if=\"$root.screenSize ==='large'\">\n                        <a id=\"ddl-assign-job-location\" blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle\n                           data-toggle=\"dropdown\">\n                            <span class=\"dropdown-text\">{{assignJob.selectedLocation.LocationNickname}}</span>\n                            <span class=\"icon\"></span>\n                        </a>\n                        <ul class=\"dropdown-menu\" uib-dropdown-menu>\n                            <li ng-repeat=\"location in assignJob.locations\"\n                                ng-class=\"{'active': assignJob.selectedLocation.ContractorId === location.ContractorId }\"\n                                ng-click=\"assignJob.locationClicked(location, $event)\">\n                                <span>{{location.LocationNickname}}</span>\n                            </li>\n                        </ul>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-12\">\n                    <div class=\"assign-job-label-container\">\n                        <label>Sales Rep </label>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-12\">\n                    <div class=\"dropdown dropdown-bordered\" uib-dropdown dropdown-title=\"Sales Rep\">\n                        <a id=\"ddl-assign-job-sales-rep\" blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle\n                           data-toggle=\"dropdown\">\n                            <span class=\"dropdown-text\">{{assignJob.selectedSalesRep.FirstName}} {{assignJob.selectedSalesRep.LastName}}</span>\n                            <span class=\"icon\"></span>\n                        </a>\n                        <ul class=\"dropdown-menu\" uib-dropdown-menu>\n                            <li ng-repeat=\"salesRep in assignJob.salesReps\"\n                                ng-class=\"{'active': assignJob.selectedSalesRep.ContractorUserId === salesRep.ContractorUserId }\"\n                                ng-click=\"assignJob.salesRepClicked(salesRep, $event)\">\n                                <span>{{salesRep.FirstName}} {{salesRep.LastName}}</span>\n                            </li>\n                        </ul>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12 assign-job-button-container\">\n                <button type=\"submit\" class=\"btn btn-primary\" id=\"btn-assign-job-submit\" ng-disabled=\"assignJob.isAssignmentDisabled\">Assign</button>\n                <button type=\"button\" class=\"btn btn-default\" id=\"btn-assign-job-cancel\" ng-click=\"assignJob.cancelAssignment()\">\n                    Cancel\n                </button>\n            </div>\n        </div>\n    </form>\n\n</div>\n\n";

/***/ }),
/* 836 */
/***/ (function(module, exports) {

module.exports = "<div ng-controller=\"HideJobController as hideJob\" class=\"hide-job-container\">\r\n    <form id=\"hide-job-form\" name=\"hideJob.hideJobForm\" class=\"hide-job-form\"\r\n          ng-submit=\"hideJob.hideProject(hideJob.hideJobForm.$valid)\" novalidate>\r\n        <!--<div class=\"hp-loading-spinner assign-job-field-container\" ra-spinner name=\"jobSpinner\" hide-content-when-shown=\"true\"-->\r\n        <!--show=\"hideJob.loading\" text=\"Loading...\" on-loaded=\"hideJob.jobSpinnerLoaded\">-->\r\n        <div class=\"hide-job-field-container\">\r\n            <div class=\"row\">\r\n                <div class=\"col-md-12\">\r\n                    <div class=\"hide-job-label-container\">\r\n                        <label>Why do you want to hide this project? </label>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"col-md-12\">\r\n                    <div class=\"dropdown dropdown-bordered\" uib-dropdown dropdown-title=\"Reason\" ng-if=\"$root.screenSize ==='large'\">\r\n                        <a id=\"ddl-hide-job-reason\" blur-element href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle\r\n                           data-toggle=\"dropdown\">\r\n                            <span class=\"dropdown-text\">{{hideJob.selectedReason.Reason}}</span>\r\n                            <span class=\"icon\"></span>\r\n                        </a>\r\n                        <ul class=\"dropdown-menu\" uib-dropdown-menu>\r\n                            <li ng-repeat=\"reason in hideJob.reasons\"\r\n                                ng-class=\"{'active': hideJob.selectedReason.ContractorJobHideReasonTypeId === reason.ContractorJobHideReasonTypeId }\"\r\n                                ng-click=\"hideJob.reasonClicked(reason, $event)\">\r\n                                <span>{{reason.Reason}}</span>\r\n                            </li>\r\n                        </ul>\r\n                    </div>\r\n\r\n                    <select class=\"dropdown-native\" ng-if=\"$root.screenSize==='small'\" ng-model=\"hideJob.selectedReason\" ng-change=\"hideJob.reasonClicked()\"\r\n                            ng-options=\"reason as reason.Description for reason in hideJob.reasons track by reason.ReasonId\"></select>\r\n                </div>\r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"col-md-12 other-option-container\">\r\n                    <input id=\"txt-other-reason\" name=\"txtOtherReason\" class=\"form-control other-reason-field\" type=\"text\"\r\n                           placeholder=\"Other Reason\" ng-class=\"{ 'is-required' : hideJob.hideJobForm.txtOtherReason.$invalid && hideJob.hideJobForm.$submitted}\"\r\n                           ng-model=\"hideJob.otherReason\" maxlength=\"120\" autocomplete=\"off\" ng-required=\"hideJob.selectedReason.Name === 'Other'\"\r\n                           ng-if=\"hideJob.selectedReason.Name === 'Other'\"/>\r\n                    <p class=\"error-message\" ng-if=\"hideJob.hideJobForm.txtOtherReason.$invalid && hideJob.hideJobForm.$submitted \" >Required</p>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class=\"row\">\r\n            <div class=\"col-md-12 hide-job-button-container\">\r\n                <button type=\"submit\" class=\"btn btn-primary\" id=\"btn-hide-job-submit\"\r\n                        ng-disabled=\"hideJob.isHideDisabled\">Hide\r\n                </button>\r\n                <button type=\"button\" class=\"btn btn-default\" id=\"btn-hide-job-cancel\"\r\n                        ng-click=\"hideJob.cancelHide()\">\r\n                    Cancel\r\n                </button>\r\n            </div>\r\n        </div>\r\n    </form>\r\n\r\n</div>\r\n\r\n";

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _jobNumberPopoverController = __webpack_require__(838);

var _jobNumberPopoverController2 = _interopRequireDefault(_jobNumberPopoverController);

var _jobNumberPopoverFactory = __webpack_require__(839);

var _jobNumberPopoverFactory2 = _interopRequireDefault(_jobNumberPopoverFactory);

var _primaryInformationController = __webpack_require__(840);

var _primaryInformationController2 = _interopRequireDefault(_primaryInformationController);

var _primaryInformationDirective = __webpack_require__(842);

var _primaryInformationDirective2 = _interopRequireDefault(_primaryInformationDirective);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.common.primaryInformation', []).controller('JobNumberPopoverController', _jobNumberPopoverController2.default).controller('PrimaryInformationController', _primaryInformationController2.default).factory('JobNumberPopoverFactory', _jobNumberPopoverFactory2.default).directive('primaryInformation', _primaryInformationDirective2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/common/primaryInformation/jobNumberPopoverTemplate.html', __webpack_require__(843)); // eslint-disable-line global-require
    $templateCache.put('app/common/primaryInformation/primaryInformationTemplate.html', __webpack_require__(844)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = jobNumberPopoverController;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

jobNumberPopoverController.$inject = ['FRInformationFactory', '$scope', '$stateParams', 'JobNumberPopoverFactory']; // angular
//     .module("HeroPRO")
//     .controller("JobNumberPopoverController", jobNumberPopoverController);

/* @ngInject */
function jobNumberPopoverController(FRInformationFactory, $scope, $stateParams, JobNumberPopoverFactory) {
    var vm = this;
    vm.newJobNumber = '';

    init();

    /*= ========================================
    =            Private Functions            =
    ========================================= */
    function init() {
        FRInformationFactory.getFundingRequestInformationPromise().then(function () {
            if (FRInformationFactory.getAppInfo().ContractorJobs !== undefined) {
                $scope.primaryInformation.contractorJobs = FRInformationFactory.getAppInfo().ContractorJobs;
                _lodash2.default.each($scope.primaryInformation.contractorJobs, function (job) {
                    job.editing = false;
                });
            }
        });
    }
    /*= ====  End of Private Functions  ====== */

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.deleteContractorJob = function (contractorJob) {
        $scope.primaryInformation.contractorJobs = _lodash2.default.reject($scope.primaryInformation.contractorJobs, function (job) {
            return job.FundingRequestToContractorJobId === contractorJob.FundingRequestToContractorJobId;
        });

        JobNumberPopoverFactory.deleteContractorJobNumber(contractorJob.FundingRequestToContractorJobId).then(function () {});
    };

    vm.addContractorJob = function (jobNumber, form) {
        if (jobNumber !== '') {
            var newJobNumber = {
                FundingRequestId: $stateParams.appId,
                ContractorSystemJobId: jobNumber,
                editing: false
            };

            $scope.primaryInformation.contractorJobs.push(newJobNumber);
            vm.newJobNumber = '';
            form.newJobNumber.$setValidity('newJobNumber', true);

            JobNumberPopoverFactory.addEditContractorJobNumber(newJobNumber).then(function (response) {
                $scope.primaryInformation.contractorJobs[$scope.primaryInformation.contractorJobs.length - 1].FundingRequestToContractorJobId = response.data.Data.FundingRequestToContractorJobId;
            });
        } else {
            form.newJobNumber.$setValidity('newJobNumber', false);
        }
    };

    vm.editContractorJob = function (contractorJob) {
        contractorJob.editing = true;
    };

    vm.saveContractorJob = function (contractorJob) {
        contractorJob.editing = false;
        JobNumberPopoverFactory.addEditContractorJobNumber(contractorJob);
    };
    /*= ====  End of Public Functions  ====== */
}

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = jobNumberPopoverFactory;
jobNumberPopoverFactory.$inject = ['HPConfig', '$http'];
// angular
//     .module("HeroPRO")
//     .factory("JobNumberPopoverFactory", jobNumberPopoverFactory);

/* @ngInject */
function jobNumberPopoverFactory(HPConfig, $http) {
    return {
        deleteContractorJobNumber: deleteContractorJobNumber,
        addEditContractorJobNumber: addEditContractorJobNumber
    };

    function deleteContractorJobNumber(jobId) {
        var params = { FundingRequestToContractorJobId: jobId };

        return $http({
            url: HPConfig.heroProApi + 'Loan/FundingRequests/ContractorJobs/Delete',
            method: 'POST',
            data: params
        });
    }

    function addEditContractorJobNumber(params) {
        return $http({
            url: HPConfig.heroProApi + 'Loan/FundingRequests/ContractorJobs',
            method: 'POST',
            data: params
        });
    }
}

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = PrimaryInformationController;

__webpack_require__(841);

PrimaryInformationController.$inject = ['$window', 'HPConfig', 'FRInformationFactory', 'LeadFactory', '$scope', '$stateParams', 'FundingRequestDatastore', 'JobFactory', '$attrs']; // angular
//     .module("HeroPRO")
//     .controller("PrimaryInformationController", primaryInformationController);

/* @ngInject */
function PrimaryInformationController($window, HPConfig, FRInformationFactory, LeadFactory, $scope, $stateParams, FundingRequestDatastore, JobFactory, $attrs) {
    var vm = this;

    vm.isInfoCollapsed = $window.innerWidth < HPConfig.screenSizes.screen_md;
    vm.showCollapseIcon = vm.isInfoCollapsed;
    vm.jobNumberLinkText = '';
    vm.contractorJobs = [];
    vm.primaryData = null;
    vm.recentlyUnhidden = false;
    // vm.proPitchClick = proPitchClick;


    function setJobNumberLinkText(data) {
        if (data !== undefined && data.length !== 0) {
            var firstJobId = data[0].ContractorSystemJobId;

            if (firstJobId.length > 12) {
                firstJobId = firstJobId.substring(0, 12) + '...';
            }

            vm.jobNumberLinkText = firstJobId;
        } else {
            vm.jobNumberLinkText = 'Add Number';
        }
    }

    function init() {
        if ($attrs.piInformationType === 'fundingRequest') {
            FRInformationFactory.getFundingRequestInformationPromise().then(function () {
                vm.primaryData = FRInformationFactory.getAppInfo();
                FundingRequestDatastore.setPrimaryInformation(vm.primaryData);
                setJobNumberLinkText(vm.primaryData.ContractorJobs);
            });

            $scope.$watch('primaryInformation.contractorJobs', function () {
                setJobNumberLinkText(vm.contractorJobs);
            }, true);
        } else if ($attrs.piInformationType === 'lead') {
            LeadFactory.getLeadData($stateParams.prequalId).then(function (leadData) {
                vm.primaryData = leadData;
                FundingRequestDatastore.setPrimaryInformation(vm.primaryData);
            });
        }
    }

    vm.unhideProject = function () {
        if ($attrs.piInformationType === 'fundingRequest') {
            JobFactory.unhideApplication({ FundingRequestId: vm.primaryData.FundingRequestId }).then(function () {
                vm.primaryData.IsContractorJobHidden = false;
                vm.recentlyUnhidden = true;
            });
        } else if ($attrs.piInformationType === 'lead') {
            JobFactory.unhideLead({ PreQualId: vm.primaryData.PreQualID }).then(function () {
                vm.primaryData.IsContractorJobHidden = false;
                vm.recentlyUnhidden = true;
            });
        }
    };

    init();
}

/***/ }),
/* 841 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = PrimaryInformationDirective;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

PrimaryInformationDirective.$inject = ['$window', '$timeout', 'HPConfig']; // angular
//     .module("HeroPRO")
//     .directive("primaryInformation", PrimaryInformationDirective);


/* @ngInject */
function PrimaryInformationDirective($window, $timeout, HPConfig) {
    function link(scope, element, attrs, ctrl) {
        var piParent = element.parent();
        var primaryInformation = piParent.children()[0];
        var appStepsDetail = piParent.children()[1];

        // Listen for window resize events and use a debounce function so that
        // setPrimaryInformationWidth is only called 200ms after the user has finished resizing.
        var debouncedCheckWindow = _lodash2.default.debounce(function () {
            setPrimaryInformationWidth(1);
            resetIsCollapsed(scope);
        }, 200);
        _angular2.default.element($window).bind('resize', debouncedCheckWindow);

        // To avoid an infinite loop, try to set the width for a maximum of 10 times
        setPrimaryInformationWidth(10);

        function setPrimaryInformationWidth(tries) {
            if (tries > 0) {
                if ($window.innerWidth >= HPConfig.screenSizes.screen_md) {
                    // Dynamically set the width of the primary-information element based on its parent
                    var elementWidth = element[0].parentNode.clientWidth;

                    // If the elementWidth is 0 the DOM has yet to be rendered. Recurse on this function if there are tries remaining.
                    if (elementWidth !== 0) {
                        element.css({ width: elementWidth + 'px' });
                    } else {
                        $timeout(function () {
                            setPrimaryInformationWidth(tries - 1);
                        }, 300);
                    }
                    appStepsDetail.style.marginTop = '25px';
                } else {
                    element.css({ width: 'auto' });
                    appStepsDetail.style.marginTop = '0';
                }
            }
        }

        function resetIsCollapsed(scope) {
            ctrl.isInfoCollapsed = $window.innerWidth < HPConfig.screenSizes.screen_md;
            ctrl.showCollapseIcon = $window.innerWidth < HPConfig.screenSizes.screen_md;
            scope.$apply();
        }

        // Observe piSetFixedHeight to determine whether the primary information header should have a fixed position
        attrs.$observe('piSetFixedHeight', setFixedHeaderStyles);

        function setFixedHeaderStyles(value) {
            var fixedHeight = scope.$eval(value);

            if ($window.innerWidth >= HPConfig.screenSizes.screen_md) {
                if (fixedHeight === true) {
                    primaryInformation.style.height = primaryInformation.clientHeight + 'px';
                    appStepsDetail.style.marginTop = primaryInformation.clientHeight + 1 + 25 + 'px';
                    // margin-top = primary information height + 1px border + 25px default top margin of appStepsDetail
                } else {
                    primaryInformation.style.height = 'auto';
                    appStepsDetail.style.marginTop = '25px';
                }
            }
        }
    }

    return {
        restrict: 'E',
        controller: 'PrimaryInformationController',
        controllerAs: 'primaryInformation',
        bindToController: true,
        templateUrl: 'app/common/primaryInformation/primaryInformationTemplate.html',
        scope: {
            piInformationType: '@'
        },
        link: link
    };
}

/***/ }),
/* 843 */
/***/ (function(module, exports) {

module.exports = "<div class=\"job-number-popover\">\n\t<div class=\"container\">\n\t\t<div class=\"row job-id-item\" ng-repeat=\"contractorJob in primaryInformation.contractorJobs\">\n\t\t\t<!-- viewing -->\n\t\t\t<div class=\"col-xs-7\" ng-if=\"contractorJob.editing === false\">\n\t\t\t\t<p class=\"job-id\">{{contractorJob.ContractorSystemJobId}}</p>\n\t\t\t</div>\n\t\t\t<div class=\"col-xs-5\" ng-if=\"contractorJob.editing === false\">\n\t\t\t\t<p class=\"job-id-actions pull-right\">\n\t\t\t\t\t<span class=\"link\" ng-click=\"jobNumberPopover.editContractorJob(contractorJob)\">Edit</span> &nbsp;|&nbsp; <span class=\"link\" ng-click=\"jobNumberPopover.deleteContractorJob(contractorJob)\">Delete</span>\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<!-- viewing -->\n\n\t\t\t<!-- editing -->\n\t\t\t<div class=\"col-xs-10\" ng-if=\"contractorJob.editing === true\">\n\t\t\t\t<input type=\"text\" maxlength=\"30\" class=\"form-control\" ng-model=\"contractorJob.ContractorSystemJobId\">\n\t\t\t</div>\n\t\t\t<div class=\"col-xs-2\" ng-if=\"contractorJob.editing === true\">\n\t\t\t\t<p class=\"job-id-actions pull-right\">\n\t\t\t\t\t<span class=\"link\" ng-click=\"jobNumberPopover.saveContractorJob(contractorJob)\">Save</span>\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t\t<!-- editing -->\n\t\t</div>\n\n\t\t<div class=\"row new-job-id\">\n\t\t\t<form name=\"addJobNumberForm\">\n\t\t\t\t<div class=\"col-xs-10\">\n\t\t\t\t\t<input type=\"text\" name=\"newJobNumber\" maxlength=\"30\" class=\"form-control\" ng-model=\"jobNumberPopover.newJobNumber\">\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-xs-2\">\n\t\t\t\t\t<p class=\"pull-right\">\n\t\t\t\t\t\t<span class=\"link\" ng-click=\"jobNumberPopover.addContractorJob(jobNumberPopover.newJobNumber, addJobNumberForm)\">Add</span>\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</form>\n\t\t</div>\n\t\t<div class=\"row job-id-message\">\n\t\t\t<div class=\"col-xs-12\">\n\t\t\t\t<p>Add a job number to match your internal tracking system.</p>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>";

/***/ }),
/* 844 */
/***/ (function(module, exports) {

module.exports = "\r\n<div class=\"row primary-information-visibilty\" ng-if=\"primaryInformation.primaryData.IsContractorJobHidden === true || primaryInformation.recentlyUnhidden === true\" ng-class=\"{'unhidden': primaryInformation.recentlyUnhidden === true}\">\r\n    <div class=\"col-md-6\">\r\n        <p class=\"visibility-message\" ng-if=\"primaryInformation.primaryData.IsContractorJobHidden === true\">This Project is Hidden</p>\r\n        <p class=\"visibility-message\" ng-if=\"primaryInformation.primaryData.IsContractorJobHidden === false\">This Project is Now Active</p>\r\n    </div>\r\n    <div class=\"col-md-6\">\r\n        <p class=\"pull-right unhide\" ng-if=\"primaryInformation.primaryData.IsContractorJobHidden === true\" ng-click=\"primaryInformation.unhideProject()\">Unhide</p>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"row primary-information-content\">\r\n    <div class=\"col-md-4\">\r\n        <p class=\"po-name\" ng-if=\"primaryInformation.primaryData.Owner1FirstName !== undefined && primaryInformation.primaryData.Owner1FirstName !== ''\">\r\n            <a href=\"\" class=\"collapse-icon\" ng-show=\"primaryInformation.showCollapseIcon\" ng-click=\"primaryInformation.isInfoCollapsed = !primaryInformation.isInfoCollapsed\">\r\n                <span class=\"icon icon-expand\" ng-class=\"{'icon-expand-rotated': !primaryInformation.isInfoCollapsed}\"></span>\r\n            </a>\r\n            <strong ng-bind=\"primaryInformation.primaryData.Owner1FirstName\"></strong>\r\n            <strong ng-bind=\"primaryInformation.primaryData.Owner1LastName\"></strong>\r\n        </p>\r\n        <p class=\"po-address\">\r\n            <span ng-bind=\"primaryInformation.primaryData.Address.Address1\"></span>\r\n            <span ng-bind=\"primaryInformation.primaryData.Address.Address2\"></span>\r\n            <span ng-bind=\"primaryInformation.primaryData.Address.City\"></span>\r\n            <span ng-bind=\"primaryInformation.primaryData.Address.State\"></span>\r\n            <span ng-bind=\"primaryInformation.primaryData.Address.ZIPCode\"></span>\r\n        </p>\r\n        <!--<p>-->\r\n            <!--<button class=\"btn btn-default\" ng-click=\"primaryInformation.proPitchClick()\">Proposal Plus</button>-->\r\n        <!--</p>-->\r\n    </div>\r\n    <div class=\"col-md-4\" uib-collapse=\"primaryInformation.isInfoCollapsed\">\r\n        <p class=\"po-email\" ng-if=\"primaryInformation.primaryData.Owner1Email !== undefined\">\r\n            <span class=\"icon icon-envelope\"></span>\r\n            <a href=\"mailto:{{primaryInformation.primaryData.Owner1Email}}\" ng-bind=\"primaryInformation.primaryData.Owner1Email\"></a>\r\n        </p>\r\n        <p class=\"po-phone\" ng-if=\"primaryInformation.primaryData.Owner1Phone1 !== undefined\">\r\n            <span class=\"icon icon-phone-handset\"></span>\r\n            <a href=\"tel:{{primaryInformation.primaryData.Owner1Phone1}}\" ng-bind=\"primaryInformation.primaryData.Owner1Phone1 | tel\"></a>\r\n        </p>\r\n    </div>\r\n    <!-- Only show the column below if we are displaying information for a funding request -->\r\n    <div class=\"col-md-4\" uib-collapse=\"primaryInformation.isInfoCollapsed\" ng-if=\"primaryInformation.piInformationType === 'fundingRequest'\">\r\n        <p class=\"hero-id\">\r\n            <strong>HERO ID:</strong>\r\n            <span ng-bind=\"primaryInformation.primaryData.HEROId\"></span>\r\n        </p>\r\n        <div class=\"job-number\" ng-controller=\"JobNumberPopoverController as jobNumberPopover\">\r\n            <p>\r\n                <strong>Job Number:</strong>\r\n                <span class=\"link\" uib-popover-template=\"'app/common/primaryInformation/jobNumberPopoverTemplate.html'\" popover-placement=\"bottom\">{{primaryInformation.jobNumberLinkText}}</span>\r\n            </p>\r\n        </div>\r\n    </div>\r\n</div>\r\n";

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _benjiUserFactory = __webpack_require__(846);

var _benjiUserFactory2 = _interopRequireDefault(_benjiUserFactory);

var _commonDataFactory = __webpack_require__(847);

var _commonDataFactory2 = _interopRequireDefault(_commonDataFactory);

var _commonValidationFactory = __webpack_require__(848);

var _commonValidationFactory2 = _interopRequireDefault(_commonValidationFactory);

var _tempDocumentFactory = __webpack_require__(849);

var _tempDocumentFactory2 = _interopRequireDefault(_tempDocumentFactory);

var _uiDisplayFactory = __webpack_require__(850);

var _uiDisplayFactory2 = _interopRequireDefault(_uiDisplayFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.common.dataFactories', []).service('CommonDataFactory', _commonDataFactory2.default).service('CommonValidationFactory', _commonValidationFactory2.default).factory('TempDocumentFactory', _tempDocumentFactory2.default).factory('BenjiUserFactory', _benjiUserFactory2.default).service('UiDisplayFactory', _uiDisplayFactory2.default).name;

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _ngInjectExport;
_ngInjectExport.$inject = ['$window', 'PartnerAppsFactory'];
// angular
//     .module('HeroPRO')
//     .factory('BenjiUserFactory',

/* @ngInject */
function _ngInjectExport($window, PartnerAppsFactory) {
    var isBenjiOnlyUser = false;
    var shouldBenjiRedirect = false;

    return {
        setIsBenjiUserOnly: setIsBenjiUserOnly,
        getIsBenjiUserOnly: getIsBenjiUserOnly,
        setShouldBenjiRedirect: setShouldBenjiRedirect,
        getShouldBenjiRedirect: getShouldBenjiRedirect,
        redirectUserToBenji: redirectUserToBenji,
        doNotRedirectOnAccountPages: doNotRedirectOnAccountPages
    };

    function setIsBenjiUserOnly(isBenjiOnly) {
        if (typeof isBenjiOnly === 'boolean') {
            isBenjiOnlyUser = isBenjiOnly;
        }
        return this;
    }

    function getIsBenjiUserOnly() {
        return isBenjiOnlyUser;
    }

    function setShouldBenjiRedirect(benjiRedirect) {
        if (typeof benjiRedirect === 'boolean') {
            shouldBenjiRedirect = benjiRedirect;
        }
    }

    function getShouldBenjiRedirect() {
        return shouldBenjiRedirect;
    }

    function redirectUserToBenji() {
        $window.location.href = PartnerAppsFactory.getBenjiLink();
        return;
    }

    function doNotRedirectOnAccountPages() {
        var userOnAccountPages = document.location.pathname.indexOf("/accounts/") !== -1;

        if (userOnAccountPages) {
            setShouldBenjiRedirect(false);
        } else {
            setShouldBenjiRedirect(true);
        }
    }
}

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = commonDataFactory;
commonDataFactory.$inject = ['$http', '$q', 'HPConfig'];

/* @ngInject */
function commonDataFactory($http, $q, HPConfig) {
    return {
        getStates: getStates
    };

    function getStates(excludeInactive) {
        var data = excludeInactive || false;
        return $http({
            url: HPConfig.heroProApi + 'Address/States?excludeInactive=' + data,
            method: 'GET'
        });
    }
}

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = commonValidationFactory;
// angular
// 	.module("HeroPRO")
// 	.factory("CommonValidationFactory", commonValidationFactory);

/* @ngInject */
function commonValidationFactory() {
    return {
        validatePassword: validatePassword
    };

    function validatePassword(password) {
        if (password && password.length > 0) {
            // Minimum 8 characters, must contain upper, lower, numeric, and special characters
            var message = '';

            var regExErrors = [];

            message += password.length >= 8 ? '' : 'minimum 8 characters';
            checkForUpperCase(password, regExErrors);
            checkForLowerCase(password, regExErrors);
            checkForNumeric(password, regExErrors);
            checkForSpecialChar(password, regExErrors);

            // Construct error message
            if (regExErrors.length > 0) {
                message += message.length > 0 ? ', must contain ' : 'must contain ';
                for (var i = 0; i < regExErrors.length; i++) {
                    message += regExErrors[i];
                    if (i + 2 < regExErrors.length) {
                        message += ', ';
                    } else if (i + 2 === regExErrors.length) {
                        message += ', and ';
                    }
                }
            }
            return message.charAt(0).toUpperCase() + message.slice(1);
        }
        return '';
    }

    function checkForUpperCase(password, regExErrors) {
        var regExUpperAlpha = /^(?=.*?[A-Z]).+$/;
        if (!regExUpperAlpha.test(password)) {
            regExErrors.push('upper');
        }
    }

    function checkForLowerCase(password, regExErrors) {
        var regExLowerAlpha = /^(?=.*?[a-z]).+$/;
        if (!regExLowerAlpha.test(password)) {
            regExErrors.push('lower');
        }
    }

    function checkForNumeric(password, regExErrors) {
        var regExNumeric = /^(?=.*?[0-9]).+$/;
        if (!regExNumeric.test(password)) {
            regExErrors.push('numeric');
        }
    }

    function checkForSpecialChar(password, regExErrors) {
        var regExSpecChar = /^(?=.*?[#?!@$%^&*-]).+$/;
        if (!regExSpecChar.test(password)) {
            regExErrors.push('special characters');
        }
    }
}

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = tempDocumentFactory;
tempDocumentFactory.$inject = ['$http', 'HPConfig'];
// angular
// 	.module("HeroPRO")
// 	.factory("TempDocumentFactory", tempDocumentFactory);

/* @ngInject */
function tempDocumentFactory($http, HPConfig) {
    return {
        generateTempDocument: generateTempDocument
    };

    function generateTempDocument(fileName) {
        var getTempDocumentRequest = {
            FileName: fileName
        };

        return $http({
            url: HPConfig.heroProApi + 'DocumentManagement/GenerateTempDocument',
            method: 'POST',
            processData: false,
            data: getTempDocumentRequest
        });
    }
}

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = uiDisplayFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

uiDisplayFactory.$inject = ['$rootScope', '$state', 'HPGeoStates', 'HPDisplayRules', 'HPTopNavRules', 'HPSidebarRules', 'HPDashboardRules', 'PermissionsFactory']; // angular
// .module("HeroPRO")
// .factory("UiDisplayFactory", uiDisplayFactory);

/* @ngInject */

function uiDisplayFactory($rootScope, $state, HPGeoStates, HPDisplayRules, HPTopNavRules, HPSidebarRules, HPDashboardRules, PermissionsFactory) {
    var currentDisplayRules = {
        rulesLoaded: false
    };

    var _blacklistStateName = '';

    return {
        getDisplayRules: getDisplayRules,
        setDisplayData: setDisplayData,
        setDisplayRule: setDisplayRule,
        getBlacklistStateName: getBlacklistStateName
    };
    /*= =======================================
     =            Public Functions            =
     ======================================== */

    // TODO: Add private method to retrieve and store DisplayData. setDisplayData is temporary for calculations.
    function setDisplayData(data) {
        var accessLevel = void 0;
        // TODO: Re-write logic here to calculate currentDisplayRules from claims.

        if (data.ServiceStateDetails !== undefined && data.ServiceStateDetails !== null && data.ServiceStateDetails.length > 0) {
            accessLevel = getAccessLevel(data.ServiceStateDetails);
        } else {
            accessLevel = 'whitelist';
        }

        switch (accessLevel) {
            case _lodash2.default.keys(HPGeoStates)[0]:
                // whitelist rules

                getTopNavRules(currentDisplayRules);
                getSidebarRules(currentDisplayRules);
                getDashboardRules(currentDisplayRules);

                // TODO: Update with better way to find specific states
                var caServiceLocation = _lodash2.default.find(data.ServiceStateDetails, function (svcState) {
                    return svcState.StateGeoId === HPGeoStates.whitelist.California;
                });

                _lodash2.default.extend(currentDisplayRules, HPDisplayRules[_lodash2.default.keys(HPGeoStates)[0]]);

                // Condition to display CSLB under Account Info for CA Service Locations.
                if (caServiceLocation) {
                    currentDisplayRules.showCSLB = true;
                } else {
                    currentDisplayRules.showCSLB = false;
                }

                break;
            case '': // blacklist rules
            case _lodash2.default.keys(HPGeoStates)[1]:
                // blacklist rules
                setBlacklistStateName(data.ServiceStateDetails[0]);

                // Set rule to configure TopNav and Sidebar to use reduced Benji Contractor view
                setDisplayRule('benjiView', true);

                getTopNavRules(currentDisplayRules);
                getSidebarRules(currentDisplayRules);
                getDashboardRules(currentDisplayRules);

                _lodash2.default.extend(currentDisplayRules, HPDisplayRules[_lodash2.default.keys(HPGeoStates)[1]]);

                break;
        }

        currentDisplayRules.rulesLoaded = true;
        // TODO: Remove payload if the rules processing can be performed synchronously.
        $rootScope.$broadcast('UpdateDisplay');
    }

    function setDisplayRule(propertyName, flag) {
        currentDisplayRules[propertyName] = flag;
    }

    function getDisplayRules() {
        return currentDisplayRules;
    }

    function getBlacklistStateName() {
        return _blacklistStateName;
    }

    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Private Functions            =
    ======================================== */

    function getAccessLevel(serviceStates) {
        var accessLevel = '';
        var accessLevelMatchFound = false;
        _lodash2.default.each(HPGeoStates, function (states, key) {
            var matchFound = false;
            if (accessLevelMatchFound === false) {
                angular.forEach(states, function (stateCode) {
                    if (matchFound === false) {
                        for (var i = 0; i < serviceStates.length; i++) {
                            if (serviceStates[i].StateGeoId === stateCode) {
                                matchFound = true;
                                accessLevelMatchFound = true;
                                accessLevel = key;
                                break;
                            }
                        }
                    }
                });
            }
        });
        return accessLevel;
    }

    function setBlacklistStateName(serviceState) {
        var matchFound = false;
        _lodash2.default.each(HPGeoStates.blacklist, function (code, key) {
            if (matchFound === false) {
                if (code === serviceState.StateGeoId) {
                    matchFound = true;
                    _blacklistStateName = key;
                }
            }
        });
    }

    function getDashboardRules(currentDisplayRules) {
        var topDashboardFound = false;
        var customRules = HPDashboardRules.standard;
        _lodash2.default.each(currentDisplayRules, function (rule, displayKeys) {
            if (topDashboardFound === false && rule === true) {
                var matchingRuleSet = _lodash2.default.find(HPDashboardRules, function (value, ruleKey) {
                    return ruleKey === displayKeys;
                });
                if (matchingRuleSet !== undefined && matchingRuleSet !== null) {
                    topDashboardFound = true;
                    customRules = matchingRuleSet;
                }
            }
        });
        _lodash2.default.extend(currentDisplayRules, customRules);
    }

    function getTopNavRules(currentDisplayRules) {
        var topNavRuleFound = false;
        var customRules = HPTopNavRules.standard;
        _lodash2.default.each(currentDisplayRules, function (rule, displayKeys) {
            if (topNavRuleFound === false && rule === true) {
                var matchingRuleSet = _lodash2.default.find(HPTopNavRules, function (value, ruleKey) {
                    return ruleKey === displayKeys;
                });
                if (matchingRuleSet !== undefined && matchingRuleSet !== null) {
                    topNavRuleFound = true;
                    customRules = matchingRuleSet;
                }
            }
        });
        _lodash2.default.extend(currentDisplayRules, customRules);
    }

    function getSidebarRules(currentDisplayRules) {
        var sidebarRuleFound = false;
        var customRules = HPSidebarRules.standard;
        if (!PermissionsFactory.hasPermission('IsSolicitor')) {
            customRules = HPSidebarRules.PACEParticipant;
        }
        _lodash2.default.each(currentDisplayRules, function (rule, displayKeys) {
            if (sidebarRuleFound === false && rule === true) {
                var matchingRuleSet = _lodash2.default.find(HPSidebarRules, function (value, ruleKey) {
                    return ruleKey === displayKeys;
                });
                if (matchingRuleSet !== undefined && matchingRuleSet !== null) {
                    sidebarRuleFound = true;
                    customRules = matchingRuleSet;
                }
            }
        });
        _lodash2.default.extend(currentDisplayRules, customRules);
    }

    /* -----  End of Private Functions  ------*/
}

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _FooterController = __webpack_require__(852);

var _FooterController2 = _interopRequireDefault(_FooterController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* @ngInject */
exports.default = _angular2.default.module('app.common.footer', []).controller('FooterController', _FooterController2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/common/footer/footer.html', __webpack_require__(854)); // eslint-disable-line global-require
    $templateCache.put('app/common/footer/legalDocuments/legalDocuments.html', __webpack_require__(855)); // eslint-disable-line global-require
    $templateCache.put('app/common/footer/legalDocuments/eSignatureDisclosures.html', __webpack_require__(856)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(853);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FooterController = function FooterController() {
    _classCallCheck(this, FooterController);

    this.eSignatureLink = '/EsignatureDisclosure';
};

exports.default = FooterController;

/***/ }),
/* 853 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 854 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container-fluid footer-container\" ng-controller=\"FooterController as footer\">\n    <div class='container footer'>\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <a href=\"{{footer.privacyLink}}\" target=\"_blank\" tabindex=\"-9888\">Privacy Policy</a>&nbsp;&nbsp;&nbsp;&nbsp;\n                <a href=\"{{footer.TOS}}\" target=\"_blank\" tabindex=\"-9888\">Terms &amp; Conditions</a>&nbsp;&nbsp;&nbsp;&nbsp;\n            </div>\n            <div class=\"col-xs-12\" style='margin-top:24px;'>\n                &copy;2021 Finance of America Home Improvement is a division of Finance of America Mortgage LLC | NMLS ID #1071 (<a target=\"_blank\"\n                    href=\"https://www.nmlsconsumeraccess.org/\">https://www.nmlsconsumeraccess.org/</a>) | 300 Welsh Rd, Building 5, Horsham, PA 19044 | Rhode Island Licensed\n                Lender | Loans made or arranged pursuant to a California Finance Lenders Law License #603E026 | Finance of America Home Improvement does business as Finance of America Mortgage LLC in California, Nevada and New York.\n            </div>\n            <div class=\"col-xs-12\" style='margin-top:16px;'>\n                Finance of America Home Improvement is not affiliated with and does not endorse any home improvement contractor. Benji&copy; refers to non-mortgage lending\n                products for\n                home improvement. Finance of America Home Improvement does not offer the mortgage products available through Finance of America Mortgage LLC and no mortgage\n                loan applications can be\n                accepted through this site. For information about mortgage products, please visit <a href=\"https://www.foamortgage.com\" target=\"_blank\">www.foamortgage.com</a> and see\n                <a href=\"https://www.foamortgage.com/licensing\" target=\"_blank\">www.foamortgage.com/licensing</a> for complete licensing information.\n            </div>\n            <div class=\"col-xs-12\" style='margin-top:16px;'>\n                Complaints? Email us at <a href=\"mailto:customerrelations@financeofamerica.com\">customerrelations@financeofamerica.com</a>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 855 */
/***/ (function(module, exports) {

module.exports = "    <div class=\"hp-module\">\n        <div class=\"hp-inner\">\n            <ng-include src=\"'app/common/footer/legalDocuments/eSignatureDisclosures.html'\"></ng-include>\n        </div>\n    </div>";

/***/ }),
/* 856 */
/***/ (function(module, exports) {

module.exports = "\n<div>\n    <div >\n        <div >\n            <div >\n                <div id=\"LegalBody\" class=\"RoundedShadows\">\n                    <div class=\"resources-header\"><h1>eSignature Disclosures<h1></div>\n\n                    <ol class=\"ulLegalBody\">\n                        <li>\n                            <strong>Consumer Disclosure </strong>\n                            <p>\n                                The HERO Financing Program, Renovate America Inc., and Municipal Partners (collectively, “HERO”) may be required by law to provide to you certain written notices or disclosures.  Described below are the terms and conditions for providing to you such notices and disclosures electronically through the DocuSign, Inc. (“DocuSign”) electronic signing system.  Please read the information below carefully and thoroughly and verify that you can access this information electronically to your satisfaction. If you agree to all of these terms and conditions, then confirm your agreement via the DocuSign system.\n                            </p>\n                        </li>\n                        <li>\n                            <strong>Getting paper copies</strong>\n                            <p>\n                                At any time, you may request from HERO a paper copy of any record provided or made available electronically to you by HERO. You will have the ability to download and print documents HERO sends to you through the DocuSign system during and immediately after signing session and, if you elect to create a DocuSign signer account, you may access such documents. After such time, you can request for HERO to send you paper copies of any such documents to you. You may request delivery of such paper copies from us by following the procedure described below.\n                            </p>\n                        </li>\n                        <li>\n                            <strong>Withdrawing your consent to electronic delivery</strong>\n                            <p>\n                                If you initially decide to receive notices and disclosures from HERO electronically, you may at any time thereafter change your mind and tell HERO that thereafter you want to receive required notices and disclosures only in paper format.\n                            </p>\n                        </li>\n                        <li>\n                            <strong>Consequences of changing your mind </strong>\n                            <p>\n                                If you elect to receive required notices and disclosures only in paper format, it will slow the speed at which HERO can complete certain steps in transactions with you and delivering services to you because HERO will need first to send the required notices or disclosures to you in paper format, and then wait until HERO receives back from you your acknowledgment of your receipt of such paper notices or disclosures. Instructions for how to withdraw consent to receive notices and disclosures from HERO electronically are outlined in section 6.3 of this disclosure.\n                            </p>\n                        </li>\n                        <li>\n                            <strong>All notices and disclosures will be sent to you electronically</strong>\n                            <p>\n                                Unless you tell HERO otherwise in accordance with the procedures described herein, HERO will provide electronically to you through the DocuSign system all required notices, disclosures, authorizations, acknowledgements, and other documents that are required to be provided or made available to you during the course of HERO’s relationship with you. To reduce the chance of you inadvertently not receiving any notice or disclosure, HERO prefers to provide all of the required notices and disclosures to you by the same method and to the same address that you have provided. Thus, you can receive all the disclosures and notices electronically or in paper format through the paper mail delivery system. If you do not agree with this process, please let HERO know as described below. Please also see the paragraph immediately above that describes the consequences of your electing not to receive delivery of the notices and disclosures electronically from HERO.\n                            </p>\n                        </li>\n                        <li>\n                            <strong>How to contact the HERO Financing Program</strong>\n                            <p>\n                                You may contact HERO to change how HERO may contact you electronically, to request paper copies of certain information from HERO, and to withdraw your prior consent to receive notices and disclosures electronically as follows:\n                                <br><br>\n                                To contact us by email send messages to: <a href=\"mailto:edoc@heroprogram.com\">edoc@heroprogram.com</a>\n                            </p>\n\n                            <ul style=\"list-style-type:none;\">\n                                <li>\n                                    <strong>6.1. To advise the HERO Financing Program of your new e-mail address</strong>\n                                    <p>\n                                        To change your e-mail address where HERO should send notices and disclosures electronically to you, you must send an email message to edoc@heroprogram.com and in the body of such request you must state: your previous e-mail address and your new e-mail address.  HERO does not require any other information from you to change your email address.\n                                        <br><br>\n                                        In addition, you must notify DocuSign, Inc. to arrange for your new email address to be reflected in your DocuSign account by following the process for changing e-mail in the DocuSign system.\n                                    </p>\n                                </li>\n                                <li>\n                                    <strong>6.2. To request paper copies from the HERO Financing Program</strong>\n                                    <p>\n                                        To request delivery of paper copies of the notices and disclosures previously provided by HERO to you electronically, you must send us an e-mail to edoc@heroprogram.com and in the body of such request you must state your e-mail address, full name, US Postal address, and telephone number.\n                                    </p>\n                                </li>\n                                <li>\n                                    <strong>6.3. To withdraw your consent to electronic delivery with HERO Financing Program</strong>\n                                    <p>\n                                        To inform HERO that you no longer want to receive future notices and disclosures in electronic format you may:\n                                    </p>\n                                </li>\n                                <li>\n\n                                    <p>\n                                        6.4. Decline to sign a document from within your DocuSign session, and on the subsequent page, select the check-box indicating you wish to withdraw your consent, or you may;\n                                    </p>\n                                </li>\n                                <li>\n                                    <p>\n                                        6.5. Send us an e-mail to edoc@heroprogram.com and in the body of such request you must state your e-mail, full name, US Postal Address, and telephone number. HERO does not need any other information from you to withdraw consent.  The consequences of your withdrawing consent for online documents will be that transactions may take a longer time to process.\n                                    </p>\n                                </li>\n                            </ul>\n\n                        </li>\n                        <li>\n                            <strong>Required hardware and software</strong>\n\n                            <table style=\"margin:20px; \">\n                                <tbody>\n                                    <tr>\n                                        <td style=\"width:200px; vertical-align:middle; padding-bottom:10px;\">Operating Systems:</td>\n                                        <td>Windows® 2000, Windows® XP, Windows Vista®, Mac OS® X</td>\n                                    </tr>\n                                    <tr>\n                                        <td style=\"width:200px; vertical-align:middle; padding-bottom:10px;\">Browsers:</td>\n                                        <td>\n                                            Final release versions of Internet Explorer® 7.0 or above (Windows only); Mozilla Firefox 3.0 or above (Windows and Mac); Safari™ 6.0 or above (Mac only)\n                                        </td>\n                                    </tr>\n                                    <tr>\n                                        <td style=\"width:200px; vertical-align:middle; padding-bottom:10px;\">PDF Reader:</td>\n                                        <td>\n                                            Acrobat® or similar software may be required to view and print PDF files\n                                        </td>\n                                    </tr>\n                                    <tr>\n                                        <td style=\"width:200px; vertical-align:middle; padding-bottom:10px;\">Screen Resolution:</td>\n                                        <td>\n                                            800 x 600 minimum\n                                        </td>\n                                    </tr>\n                                </tbody>\n                            </table>\n\n                            <p>\n                                ** These minimum requirements are subject to change. If these requirements change, you will be asked to re-accept the disclosure. Pre-release (e.g. beta) versions of operating systems and browsers are not supported.\n                            </p>\n                        </li>\n                        <li>\n                            <strong>Acknowledging your access and consent to receive materials electronically</strong>\n                            <p>\n                                To confirm to us that you can access this information electronically, which will be similar to other electronic notices and disclosures that HERO will provide to you, please verify that you were able to read the electronic disclosure within the DocuSign system, and that you are able to print it out on paper or electronically for future reference and access, or that you were able to email the disclosure and consent to an address where you will be able to print on paper or save it for your future reference and access.  If you consent to receiving notices and disclosures exclusively in electronic format on the terms and conditions listed above, please indicate this by following the directions to indicate consent within the DocuSign system.\n                            </p>\n                        </li>\n                    </ol>\n\n                </div>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _hintsController = __webpack_require__(858);

var _hintsController2 = _interopRequireDefault(_hintsController);

var _hintsDirective = __webpack_require__(860);

var _hintsDirective2 = _interopRequireDefault(_hintsDirective);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.common.hints', []).controller('hintsController', _hintsController2.default).directive('hpHint', _hintsDirective2.default).run(['$templateCache', function ($templateCache) {
    $templateCache.put('app/common/hints/hints.html', __webpack_require__(861)); // eslint-disable-line global-require
}]).name;

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = hintsController;

__webpack_require__(859);

function hintsController($analytics) {
    var vm = this;
    vm.feedbackProvided = false;
    vm.open = false;

    vm.toggleHintState = function () {
        vm.open = !vm.open;
        var hintEvent = vm.open ? 'Reveal Hint' : 'Close Hint';
        var hintLabel = vm.open ? 'Open' : 'Close';
        $analytics.eventTrack(hintEvent, { category: 'Hints:' + vm.id, label: hintLabel });
    };

    vm.feedback = function (selection, $event) {
        $event.preventDefault();
        $analytics.eventTrack('Feedback', { category: 'Hints:' + vm.id, label: selection });
        vm.feedbackProvided = true;
    };
} // angular
//     .module("HeroPRO")
//     .controller("hintsController", hintsController);

/***/ }),
/* 859 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = hpHint;
// angular
//     .module("HeroPRO")
//     .directive("hpHint", hpHint);

function hpHint() {
    return {
        templateUrl: 'app/common/hints/hints.html',
        controller: 'hintsController',
        controllerAs: 'hint',
        bindToController: true,
        scope: {
            id: '@',
            copy: '@'
        },
        restrict: 'E'
    };
}

/***/ }),
/* 861 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row hint\" ng-class=\"{open: hint.open}\">\n\n    <div class=\"col-md-2 tips\">\n        <a href=\"#\" ng-click=\"hint.toggleHintState();\">\n            <span class=\"icon icon-tip\"></span>\n            <span>Pro Tip</span>\n        </a>\n    </div>\n\n    <div class=\"col-md-10\" uib-collapse=\"!hint.open\">\n        <div class=\"hint-content\">\n            <span class=\"icon icon-delete-circle\" ng-click=\"hint.toggleHintState();\"></span>\n            <p class=\"copy\" ng-bind=\"hint.copy\"></p>\n            <p class=\"feedback\" ng-hide=\"hint.feedbackProvided\">\n                <span>Was this helpful?</span>\n                <a href=\"#\" ng-click=\"hint.feedback('Yes',$event)\">Yes</a>\n                <a href=\"#\" ng-click=\"hint.feedback('No',$event)\">No</a>\n            </p>\n            <p class=\"feedback\" ng-show=\"hint.feedbackProvided\">\n                <span>Thank you for your feedback!</span>\n            </p>\n        </div>\n    </div>\n\n</div>\n";

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _directives = __webpack_require__(863);

var _directives2 = _interopRequireDefault(_directives);

var _filters = __webpack_require__(879);

var _filters2 = _interopRequireDefault(_filters);

var _globalFactories = __webpack_require__(887);

var _globalFactories2 = _interopRequireDefault(_globalFactories);

var _dropzoneDirective = __webpack_require__(892);

var _dropzoneDirective2 = _interopRequireDefault(_dropzoneDirective);

var _ngPDFDirective = __webpack_require__(893);

var _ngPDFDirective2 = _interopRequireDefault(_ngPDFDirective);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.common.angular', [_directives2.default, _filters2.default, _globalFactories2.default]).directive('dropzone', _dropzoneDirective2.default).directive('ngPdf', _ngPDFDirective2.default).run(['$templateCache', function ($templateCache) {}]).name;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _overlay = __webpack_require__(864);

var _overlay2 = _interopRequireDefault(_overlay);

var _hpimage = __webpack_require__(865);

var _hpimage2 = _interopRequireDefault(_hpimage);

var _hpDynamicTextButton = __webpack_require__(866);

var _hpDynamicTextButton2 = _interopRequireDefault(_hpDynamicTextButton);

var _iframeOnload = __webpack_require__(867);

var _iframeOnload2 = _interopRequireDefault(_iframeOnload);

var _hpUISelect = __webpack_require__(868);

var _hpUISelect2 = _interopRequireDefault(_hpUISelect);

var _modalScrollToTop = __webpack_require__(869);

var _modalScrollToTop2 = _interopRequireDefault(_modalScrollToTop);

var _fileread = __webpack_require__(870);

var _fileread2 = _interopRequireDefault(_fileread);

var _hpDownloadLink = __webpack_require__(871);

var _hpDownloadLink2 = _interopRequireDefault(_hpDownloadLink);

var _hpAlphanumericOnly = __webpack_require__(872);

var _hpAlphanumericOnly2 = _interopRequireDefault(_hpAlphanumericOnly);

var _hpMax = __webpack_require__(873);

var _hpMax2 = _interopRequireDefault(_hpMax);

var _hpNumericOnly = __webpack_require__(874);

var _hpNumericOnly2 = _interopRequireDefault(_hpNumericOnly);

var _hpPopover = __webpack_require__(875);

var _hpPopover2 = _interopRequireDefault(_hpPopover);

var _hpRequired = __webpack_require__(876);

var _hpRequired2 = _interopRequireDefault(_hpRequired);

var _hpValidDate = __webpack_require__(877);

var _hpValidDate2 = _interopRequireDefault(_hpValidDate);

var _raCurrency = __webpack_require__(878);

var _raCurrency2 = _interopRequireDefault(_raCurrency);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.common.angular.directives', []).directive('hpOverlay', _overlay2.default).directive('hpImage', _hpimage2.default).directive('hpDynamicTextButton', _hpDynamicTextButton2.default).directive('iframeOnload', _iframeOnload2.default).directive('hpUiSelect', _hpUISelect2.default).directive('modalScrollToTop', _modalScrollToTop2.default).directive('fileread', _fileread2.default).directive('hpDownloadLink', _hpDownloadLink2.default).directive('hpAlphanumericOnly', _hpAlphanumericOnly2.default).directive('hpMax', _hpMax2.default).directive('hpNumericOnly', _hpNumericOnly2.default).directive('hpRequired', _hpRequired2.default).directive('hpValidDate', _hpValidDate2.default).directive('raCurrency', _raCurrency2.default).directive('hpPopover', _hpPopover2.default).run(['$templateCache', function ($templateCache) {
  // $templateCache.put('app/common/spinner/template/defaultSpinnerTemplate.html', require('./template/defaultSpinnerTemplate.html')); // eslint-disable-line global-require
}]).name;

/**

hpDownloadLink
hpAlphanumericOnly
hpMax
hpNumericOnly
hpPopover
hpRequired
hpValidDate
raCurrency
 */

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = OverlayDirective;
// .directive('hpOverlay',

function OverlayDirective() {
    return {
        restrict: 'E',
        scope: {
            show: '='
        },
        replace: true, // Replace with the template below
        transclude: true, // we want to insert custom content inside the directive
        link: function link() {},

        template: "<div ng-show='show'> <div class='hp-overlay'></div> <div class='hp-overlay-container' ng-transclude> </div> </div>"
    };
}

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = HPImageDirective;
HPImageDirective.$inject = ['$http', 'HPConfig'];
// .directive('hpImage',

/* @ngInject */
function HPImageDirective($http, HPConfig) {
    return {
        restrict: 'A',
        scope: {
            hpSrc: '@'
        },
        link: function link(scope, element) {
            scope.$watch('hpSrc', function (hpSrc) {
                $http.get(hpSrc).then(function (result) {
                    element[0].src = result.data;
                });
            });
        }
    };
}

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    return {
        restrict: 'A',
        scope: {
            hpSpinnerButtonStatus: '=',
            hpSpinnerButtonTexts: '=',
            hpSpinnerButtonStyles: '='
        },
        link: function link(scope, element, attr) {
            element.html(attr.hpSpinnerButton);
            scope.$watch('hpSpinnerButtonStatus', function () {
                element.html(scope.hpSpinnerButtonTexts[scope.hpSpinnerButtonStatus]);
                if (scope.hpSpinnerButtonStatus === 2 && scope.hpSpinnerButtonStyles === true) {
                    element.addClass('btn-success');
                    element[0].blur();
                }
            });
        }
    };
};

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = iframeOnload;
function iframeOnload() {
    return {
        scope: {
            callBack: '&iframeOnload'
        },
        link: function link(scope, element) {
            element.on('load', function () {
                return scope.callBack();
            });
        }
    };
}

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = hpUiSelect;
function hpUiSelect() {
    return {
        require: 'uiSelect',
        restrict: 'A',
        link: function link(scope, element, attrs, $select) {
            scope.$watch('$select.items', function (newValue) {
                if (newValue.length === 0) {
                    scope.$emit('hpUiSelectNoChoice', { Name: attrs.hpUiSelectName, Value: $select.search });
                }
            });
        }
    };
}

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = modalScrollToTop;
modalScrollToTop.$inject = ['DirectiveService', '$document', '$timeout'];

/* @ngInject */
function modalScrollToTop(DirectiveService, $document, $timeout) {
    return {
        replace: true,
        restrict: 'A',
        scope: {
            scroll: '='
        },
        link: function link(scope, element) {
            DirectiveService.subscribe(function (msg) {
                var msgSplit = msg.split(' ');
                if (msgSplit.length === 1 && msg === 'scroll') {
                    element.parent()[0].scrollTop = 0;
                } else if (msgSplit.length === 2 && msgSplit[0] === 'scroll') {
                    $timeout(function () {
                        console.log('$document[0].getElementById(msgSplit[1]).offsetTop', $document[0].getElementById(msgSplit[1]).offsetTop);
                        element.parent()[0].scrollTop = $document[0].getElementById(msgSplit[1]).offsetTop + 150;
                    });
                }
            });
        }
    };
}

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = fileread;
fileread.$inject = ['$rootScope', '$window'];


/* @ngInject */
function fileread($rootScope, $window) {
    return {
        scope: {
            fileread: '=',
            filereadTypes: '=?'
        },
        link: function link(scope, element, attrs) {
            var fileTypes = scope.filereadTypes === null || scope.filereadTypes === undefined ? ['jpg', 'jpeg', 'png', 'gif', 'tiff', 'bmp'] : scope.filereadTypes;
            var maxSize = 10 * (1024 * 1024); // 10 MB

            element.bind('change', function (changeEvent) {
                if (changeEvent.target.files && changeEvent.target.files[0]) {
                    var extension = changeEvent.target.files[0].name.split('.').pop().toLowerCase();
                    var isValidExtension = fileTypes.indexOf(extension) > -1;

                    if (isValidExtension) {
                        var fileSize = changeEvent.target.files[0].size / maxSize;
                        if (fileSize <= 1) {
                            var reader = new $window.FileReader();
                            reader.onload = function (loadEvent) {
                                scope.$apply(function () {
                                    scope.fileread = loadEvent.target.result;
                                });
                            };
                            reader.readAsDataURL(changeEvent.target.files[0]);
                            var formData = new $window.FormData();
                            //								formData.append("Payload", "{'ContractorId':" + $stateParams.accountId + "}");
                            formData.append('uploadFile', changeEvent.target.files[0]);

                            $rootScope.$broadcast(attrs.source + 'StartUpload', formData);
                        } else {
                            $rootScope.$apply(function () {
                                $rootScope.$broadcast(attrs.source + 'InvalidUploadSize');
                            });
                        }
                    } else {
                        $rootScope.$apply(function () {
                            $rootScope.$broadcast(attrs.source + 'InvalidUploadType', { fileType: extension });
                        });
                    }
                }
            });
        }
    };
}

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = hpDownloadLink;
hpDownloadLink.$inject = ['$http', '$window', 'HPConfig'];

/* @ngInject */
function hpDownloadLink($http, $window, HPConfig) {
    return {
        restrict: 'A',
        link: function link(scope, element) {
            element.on('click', function (e) {
                e.preventDefault();
                var urlSplit = element[0].href.split('?');
                var downloadUrl = element[0].href;
                if (urlSplit[0].indexOf('DocumentManagement/DownloadDocument') >= 0) {
                    downloadUrl = HPConfig.heroProApi + 'DocumentManagement/DownloadDocumentUrl?' + urlSplit[1];
                } else if (urlSplit[0].indexOf('Pipeline/SpreadSheet') >= 0) {
                    downloadUrl = HPConfig.heroProApi + 'Pipeline/SpreadSheetUrl';
                } else if (urlSplit[0].indexOf('ELearning/UserCertificate') >= 0) {
                    downloadUrl = HPConfig.heroProApi + 'ELearning/UserCertificateUrl';
                }
                $http.get(downloadUrl).then(function (result) {
                    $window.location = result.data;
                });
            });
        }
    };
}

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = hpAlphanumericOnly;
function hpAlphanumericOnly() {
    return {
        require: 'ngModel',
        restrict: 'A',
        link: function link(scope, element, attr, ngModelCtrl) {
            function validateEntry(text) {
                var filteredEntry = text.replace(/[^0-9A-Za-z ,/\-#]/g, '');
                if (filteredEntry !== text) {
                    ngModelCtrl.$setViewValue(filteredEntry);
                    ngModelCtrl.$render();
                }
                return filteredEntry;
            }

            ngModelCtrl.$parsers.push(validateEntry);
        }
    };
}

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = hpMax;
function hpMax() {
    return {
        require: 'ngModel',
        restrict: 'A',
        link: function link(scope, element, attr, ngModelCtrl) {
            function validateEntry(text) {
                var max = parseInt(attr.hpMax || 999);
                var truncatedEntry = text;

                if (text.length > max) {
                    truncatedEntry = text.substring(0, max);
                }

                if (truncatedEntry !== text) {
                    ngModelCtrl.$setViewValue(truncatedEntry);
                    ngModelCtrl.$render();
                }

                return truncatedEntry;
            }

            ngModelCtrl.$parsers.push(validateEntry);
        }
    };
}

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = hpNumericOnly;
function hpNumericOnly() {
    return {
        require: 'ngModel',
        restrict: 'A',
        link: function link(scope, element, attr, ngModelCtrl) {
            function validateEntry(text) {
                var filteredEntry = text.replace(/[^0-9]/g, '');
                if (filteredEntry !== text) {
                    ngModelCtrl.$setViewValue(filteredEntry);
                    ngModelCtrl.$render();
                }
                return filteredEntry;
            }

            ngModelCtrl.$parsers.push(validateEntry);
        }
    };
}

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = hpPopover;
hpPopover.$inject = ['$window'];

/* @ngInject */
function hpPopover($window) {
    return {
        restrict: 'A',
        link: function link(scope, element) {
            element.bind('click', function (event) {
                event.preventDefault();
                event.stopPropagation();

                if (element.hasClass('selected')) {
                    element.removeClass('selected');
                    element.triggerHandler('hide');
                } else {
                    element.addClass('selected');
                    element.triggerHandler('show');
                }

                var popups = $window.document.querySelectorAll('*[hp-popover]');
                for (var i = 0; i < popups.length; i++) {
                    var popup = popups[i];
                    var popupElement = angular.element(popup);

                    if (popup !== element[0]) {
                        if (popupElement.hasClass('selected')) {
                            popupElement.triggerHandler('hide');
                            popupElement.removeClass('selected');
                        }
                    }
                }
            });
        }
    };
}

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = hpRequired;

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hpRequired() {
    return {
        require: 'ngModel',
        restrict: 'A',

        link: function link(scope, element, attr, ngModelCtrl) {
            var submitted = false;

            function validateEntry(text) {
                if (_angular2.default.isUndefined(submitted)) {
                    // if value isn't entered
                    if (text === '' || text === null) {
                        element.addClass('invalid');
                    } else {
                        element.removeClass('invalid');
                    }
                }

                if (submitted && (text === '' || text === null)) {
                    element.addClass('invalid');
                } else {
                    element.removeClass('invalid');
                }

                return text;
            }

            scope.$watch(attr.hpRequired, function (value) {
                submitted = value;
                validateEntry(element.val());
            });

            scope.$on('submitted', function () {
                submitted = true;
                validateEntry(element.val());
            });

            scope.$on('reset', function () {
                submitted = false;
                validateEntry(element.val());
            });

            ngModelCtrl.$parsers.push(validateEntry);
        }
    };
}

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = hpValidDate;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

hpValidDate.$inject = ['moment'];


/* @ngInject */
function hpValidDate(moment) {
    return {
        require: 'ngModel',
        restrict: 'A',

        link: function link(scope, element, attrs, ngModelCtrl) {
            function validateEntry(text) {
                if (!text || text.length < 8) {
                    ngModelCtrl.$setValidity('valid', true);
                    element.removeClass('invalid');
                } else {
                    var parsedDate = void 0;
                    var today = moment();
                    if (text.length > 10) {
                        parsedDate = text;
                    } else if (text.length === 10) {
                        var date1 = text.split('/');
                        var date2 = text.split('-');
                        var dateArray = [];

                        var splitDate = date1.length > 1 ? date1 : date2;

                        _lodash2.default.each(splitDate, function (d, index) {
                            if (index === 1) {
                                dateArray.push(parseInt(d) - 1);
                            } else {
                                dateArray.push(parseInt(d));
                            }
                        });

                        parsedDate = dateArray;
                    } else {
                        parsedDate = [];
                        parsedDate.push(parseInt(text.substring(4)));
                        parsedDate.push(parseInt(text.substring(0, 2)) - 1);
                        parsedDate.push(parseInt(text.substring(2, 4)));
                    }

                    if (moment(parsedDate).isAfter(today, 'date')) {
                        ngModelCtrl.$setValidity('valid', true);
                        element.removeClass('invalid');
                    } else {
                        ngModelCtrl.$setValidity('valid', false);
                        element.addClass('invalid');
                    }
                }

                return text;
            }

            scope.$on('reset', function () {
                validateEntry(null);
            });

            ngModelCtrl.$parsers.push(validateEntry);
        }
    };
}

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = raCurrency;
raCurrency.$inject = ['$filter', '$browser'];

/* @ngInject */
function raCurrency($filter, $browser) {
    return {
        require: 'ngModel',

        // attributes on elements only (input/textarea)
        restrict: 'A',

        // link for DOM manipulation
        link: function link($scope, $element, $attrs, ngModelCtrl) {
            var listener = function listener() {
                // $element.val($filter('currency')(getCleanValue($element.val()), '$', 0));
                $element.val(renderCurrencyFilter(getCleanValue($element.val()), $attrs));
            };

            // This runs when we update the text field
            ngModelCtrl.$parsers.push(function (viewValue) {
                return getCleanValue(viewValue);
            });

            // This runs when the model gets updated on the scope directly and keeps our view in sync
            ngModelCtrl.$render = function () {
                // $element.val($filter('currency')(ngModelCtrl.$viewValue, '$', 0));
                if (ngModelCtrl.$viewValue) {
                    $element.val(renderCurrencyFilter(getCleanValue(ngModelCtrl.$viewValue), $attrs));
                }
            };

            $element.bind('change', listener);

            $element.bind('paste cut', function () {
                $browser.defer(listener);
            });

            // returns the decimal value or 0 if fails isNaN check
            function getCleanValue(value) {
                var cleanValue = parseFloat(value.replace(/,|\$/g, ''));
                return isNaN(cleanValue) ? 0 : cleanValue;
            }

            // using the attributes and the default currency filter - generates the currency as a string
            function renderCurrencyFilter(value) {
                var filterArgs = $attrs.raCurrency.split(':');

                var symbol = filterArgs[0] ? filterArgs[0] : '$';
                var fractionSize = filterArgs[1] ? filterArgs[1] : 0;

                return $filter('currency')(value, symbol, fractionSize);
            }
        }
    };
}

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _monthName = __webpack_require__(880);

var _monthName2 = _interopRequireDefault(_monthName);

var _telFilter = __webpack_require__(881);

var _telFilter2 = _interopRequireDefault(_telFilter);

var _capitalize = __webpack_require__(882);

var _capitalize2 = _interopRequireDefault(_capitalize);

var _dashPercentage = __webpack_require__(883);

var _dashPercentage2 = _interopRequireDefault(_dashPercentage);

var _numericMask = __webpack_require__(884);

var _numericMask2 = _interopRequireDefault(_numericMask);

var _range = __webpack_require__(885);

var _range2 = _interopRequireDefault(_range);

var _zeroDashCurrency = __webpack_require__(886);

var _zeroDashCurrency2 = _interopRequireDefault(_zeroDashCurrency);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.common.filters', []).filter('monthName', _monthName2.default).filter('tel', _telFilter2.default).filter('capitalize', _capitalize2.default).filter('dashPercentage', _dashPercentage2.default).filter('numMask', _numericMask2.default).filter('makeRange', _range2.default).filter('zeroDashCurrency', _zeroDashCurrency2.default).name;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = monthName;
// angular
// 	.module("HeroPRO")
// 	.filter("monthName", monthName);

function monthName() {
    return function getMonthName(monthNumber) {
        var monthNames = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'];
        return monthNames[Number(monthNumber) - 1];
    };
}

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = tel;
// angular.module('HeroPRO').filter('tel', function () {

//   });

function tel() {
    return function telFilter(tel) {
        if (!tel) {
            return '';
        }

        var value = tel.toString().trim().replace(/^\+/, '');

        if (value.match(/[^0-9]/)) {
            return tel;
        }

        var country = void 0;
        var city = void 0;
        var number = void 0;

        switch (value.length) {
            case 10:
                // +1PPP####### -> C (PPP) ###-####
                country = 1;
                city = value.slice(0, 3);
                number = value.slice(3);
                break;

            case 11:
                // +CPPP####### -> CCC (PP) ###-####
                country = value[0];
                city = value.slice(1, 4);
                number = value.slice(4);
                break;

            case 12:
                // +CCCPP####### -> CCC (PP) ###-####
                country = value.slice(0, 3);
                city = value.slice(3, 5);
                number = value.slice(5);
                break;

            default:
                return tel;
        }

        if (country === 1) {
            country = '';
        }

        number = number.slice(0, 3) + '-' + number.slice(3);

        return (country + ' (' + city + ') ' + number).trim();
    };
}

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = capitalize;
function capitalize() {
    return function capitalizeFilter(input) {
        if (input !== undefined) {
            input = input.toLowerCase();
            return input.substring(0, 1).toUpperCase() + input.substring(1);
        }
        return input;
    };
}

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = dashPercentage;
/* @ngInject */
function dashPercentage() {
    return function (input) {
        if (input === undefined || input === null) {
            return '-';
        }

        return input + '%';
    };
}

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = NumMaskFilter;
// angular.module('HeroPRO').filter('numMask',

function NumMaskFilter() {
    return function numMaskFilter(number, visibleNumbers) {
        var length = 0;
        var maskedNumber = '';
        var numMaskedDigits = 0;
        var defaultVisibleNumbers = 3;
        var maskChars = '';
        var i = 0;

        if (!number) {
            return '';
        }

        var value = number.toString().trim().replace(/^\+/, '');

        if (value.match(/[^0-9]/)) {
            return number;
        }

        length = number.length;
        if (visibleNumbers !== undefined && visibleNumbers !== null && visibleNumbers > 1) {
            numMaskedDigits = length - Number(visibleNumbers);
            maskedNumber = number.toString().substring(numMaskedDigits);
            for (i = 0; i < numMaskedDigits; i++) {
                maskChars += '*';
            }
        } else {
            numMaskedDigits = length - defaultVisibleNumbers;
            maskedNumber = number.toString().substring(numMaskedDigits);
            for (i = 0; i < numMaskedDigits; i++) {
                maskChars += '*';
            }
        }
        maskedNumber = maskChars + maskedNumber;

        return maskedNumber;
    };
}

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = makeRange;
// angular
//   .module("HeroPRO")
//   .filter("makeRange", makeRange);

function makeRange() {
    return function makeRangeFilter(input) {
        var lowBound = void 0;
        var highBound = void 0;
        switch (input.length) {
            case 1:
                lowBound = 0;
                highBound = parseInt(input[0]) - 1;
                break;
            case 2:
                lowBound = parseInt(input[0]);
                highBound = parseInt(input[1]);
                break;
            default:
                return input;
        }
        var result = [];
        for (var i = lowBound; i <= highBound; i++) {
            result.push(i);
        }
        return result;
    };
}

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = zeroDashCurrency;

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

zeroDashCurrency.$inject = ['$filter', '$locale']; // angular
//     .module("HeroPRO")
//     .filter("zeroDashCurrency",["$filter","$locale", zeroDashCurrency]);

/* @ngInject */
function zeroDashCurrency($filter, $locale) {
    var currencyFilter = $filter('currency');
    var formats = $locale.NUMBER_FORMATS;
    return function zeroDashCurrencyFilter(amount, currencySymbol) {
        if (_angular2.default.isUndefined(currencySymbol)) {
            currencySymbol = formats.CURRENCY_SYM;
        }
        if (amount === 0) {
            return '-';
        }
        return currencyFilter(amount, currencySymbol);
    };
}

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _documentFactory = __webpack_require__(888);

var _documentFactory2 = _interopRequireDefault(_documentFactory);

var _timestampFactory = __webpack_require__(889);

var _timestampFactory2 = _interopRequireDefault(_timestampFactory);

var _dropzoneFactory = __webpack_require__(890);

var _dropzoneFactory2 = _interopRequireDefault(_dropzoneFactory);

var _mapBoxFactory = __webpack_require__(891);

var _mapBoxFactory2 = _interopRequireDefault(_mapBoxFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.common.angular.globalFactories', []).factory('document', _documentFactory2.default).factory('Timestamp', _timestampFactory2.default).factory('DropzoneFactory', _dropzoneFactory2.default).factory('mapBoxGL', _mapBoxFactory2.default).name;

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _ngInjectExport;
_ngInjectExport.$inject = ["$window"];
// angular
//     .module('document', [])

/* @ngInject */
function _ngInjectExport($window) {
    return $window.document;
}

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TimestampFactory;
// angular
//   .module('HeroPRO')
//   .factory('Timestamp', TimestampFactory);

function TimestampFactory() {
    var timestamps = {};

    return {
        setTimestamp: function setTimestamp(name) {
            timestamps[name] = new Date().getTime();
        },
        getTimestamp: function getTimestamp(name) {
            return timestamps[name];
        }
    };
}

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = DropzoneFactory;
DropzoneFactory.$inject = ["$window"];
// angular
//     .module("Dropzone", [])
//     .factory("DropzoneFactory", DropzoneFactory);

/* @ngInject */
function DropzoneFactory($window) {
    return $window.Dropzone;
}

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = mapBoxGLFactory;
mapBoxGLFactory.$inject = ["$window"];
// angular
//     .module("mapBoxGL", [])
//     .factory("mapBoxGL", mapBoxGLFactory);

/* @ngInject */
function mapBoxGLFactory($window) {
    return $window.mapboxgl;
}

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = dropzone;
dropzone.$inject = ['HPConfig', '$rootScope', 'DropzoneFactory', 'AuthenticationFactory', 'TempDocumentFactory'];
// angular
//   .module('HeroPRO')
//   .directive('dropzone', dropzone);

/* @ngInject */
function dropzone(HPConfig, $rootScope, DropzoneFactory, AuthenticationFactory, TempDocumentFactory) {
    return {
        restrict: 'C',
        scope: {
            dropzoneFormDataField: '@',
            dropzoneFormData: '=?',
            dropzoneUrl: '@',
            dropZoneMaxFileSize: '=',
            dropzoneAcceptedFiles: '@'
        },
        link: function link(scope, element) {
            // console.log("scope.dropzoneUrl",scope.dropzoneUrl);
            var dropzoneUrl = scope.dropzoneUrl === null || scope.dropzoneUrl === undefined ? 'DocumentManagement/UploadAttachment' : scope.dropzoneUrl;
            var dropzoneAcceptedFiles = scope.dropzoneAcceptedFiles === null || scope.dropzoneAcceptedFiles === undefined ? '.pdf,.jpg,.jpeg,.png,.gif,.tif,.bmp,.doc,.docx,.ppt,.pptx' : scope.dropzoneAcceptedFiles;
            var dropzoneMaxFileSize = scope.dropZoneMaxFileSize === null || scope.dropZoneMaxFileSize === undefined ? 10 : scope.dropZoneMaxFileSize;

            var config = {
                url: HPConfig.heroProApi + dropzoneUrl,
                paramName: 'uploadfile',
                uploadMultiple: false,
                addRemoveLinks: true,
                maxThumbnailFilesize: 10,
                parallelUploads: 1,
                withCredentials: false,
                maxFilesize: dropzoneMaxFileSize, // in MB
                acceptedFiles: dropzoneAcceptedFiles,
                method: 'PUT',
                accept: function accept(file, done) {
                    TempDocumentFactory.generateTempDocument(file.name).then(function (response) {
                        file.uploadURL = response.data.Data.PreSignedUploadUrl;
                        file.downloadUrl = response.data.Data.DownloadUrl;
                        file.tempFileKey = response.data.Data.TempFileKey;
                        done();
                    }).catch(function () {
                        done('Error obtaining temporary upload url.');
                    });
                }
            };

            var dropzone = new DropzoneFactory(element[0], config);

            var eventHandlers = {
                addedfile: function addedfile(file) {
                    scope.file = file;
                    // Ignored if condition below has to be != and NOT !==
                    /* jshint ignore:start */
                    if (this.files[1] != null) {
                        this.removeFile(this.files[0]);
                    }
                    /* jshint ignore:end */
                    scope.$apply(function () {
                        scope.fileAdded = true;
                    });
                },
                removedfile: function removedfile() {
                    $rootScope.$broadcast('HPFileRemoved');
                },
                success: function success(file, response) {
                    // console.log('success');
                    $rootScope.$broadcast('HPFileUploaded', response, file);
                },
                error: function error() {
                    // 'error': function (file, errorMessage ,xhr ) {
                    // console.log(errorMessage , xhr);
                },
                sending: function sending(file, request) {
                    request.setRequestHeader('x-amz-server-side-encryption', 'AES256');
                    request.setRequestHeader('Content-Type', file.type);
                    var _send = request.send;
                    request.send = function () {
                        _send.call(request, file);
                    };
                    $rootScope.$broadcast('HPFileUploading');
                },
                processing: function processing(file) {
                    dropzone.options.url = file.uploadURL;
                    $rootScope.$broadcast('HPFileProcessing');
                }
            };

            angular.forEach(eventHandlers, function (handler, event) {
                dropzone.on(event, handler);
            });

            scope.processDropzone = function () {
                dropzone.processQueue();
            };

            scope.resetDropzone = function () {
                dropzone.removeAllFiles();
            };
        }
    };
}

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ngPdf;
ngPdf.$inject = ['$window', '$rootScope'];
var PDFJs = __webpack_require__(894);

/*! Angular-PDF Version: 1.2.0 | (C) Sayanee Basu 2015, released under an MIT license */

// angular
//     .module("HeroPRO")
//     .directive('ngPdf', ngPdf);

/* @ngInject */
function ngPdf($window, $rootScope) {
    var backingScale = function backingScale(canvas) {
        var ctx = canvas.getContext('2d');
        var dpr = $window.devicePixelRatio || 1;
        var bsr = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;

        return dpr / bsr;
    };

    var setCanvasDimensions = function setCanvasDimensions(canvas, w, h) {
        var ratio = backingScale(canvas);
        canvas.width = Math.floor(w * ratio);
        canvas.height = Math.floor(h * ratio);
        canvas.style.width = Math.floor(w) + 'px';
        canvas.style.height = Math.floor(h) + 'px';
        canvas.getContext('2d').setTransform(ratio, 0, 0, ratio, 0, 0);
        return canvas;
    };
    return {
        restrict: 'E',
        templateUrl: function templateUrl(element, attr) {
            return attr.templateUrl ? attr.templateUrl : 'partials/viewer.html';
        },
        link: function link(scope, element, attrs) {
            var url = scope.pdfUrl;
            var pdfDoc = null;
            var pageNum = attrs.page ? attrs.page : 1;
            var scale = attrs.scale > 0 ? attrs.scale : 1;
            var canvas = attrs.canvasid ? $window.document.getElementById(attrs.canvasid) : $window.document.getElementById('pdf-canvas');
            var ctx = canvas.getContext('2d');
            var windowEl = angular.element($window);

            windowEl.on('scroll', function () {
                scope.$apply(function () {
                    scope.scroll = windowEl[0].scrollY;
                });
            });

            PDFJS.disableWorker = true;
            scope.pageNum = pageNum;

            scope.renderPage = function (num) {
                pdfDoc.getPage(num).then(function (page) {
                    var viewport = void 0;
                    var pageWidthScale = void 0;
                    var pageHeightScale = void 0;
                    var renderContext = {};

                    if (attrs.scale === 'page-fit' && !scale) {
                        viewport = page.getViewport(1);
                        pageWidthScale = element[0].clientWidth / viewport.width;
                        pageHeightScale = element[0].clientHeight / viewport.height;
                        scale = Math.min(pageWidthScale, pageHeightScale);
                    } else {
                        viewport = page.getViewport(scale);
                    }

                    setCanvasDimensions(canvas, viewport.width, viewport.height);

                    renderContext = {
                        canvasContext: ctx,
                        viewport: viewport
                    };

                    page.render(renderContext).promise.then(function () {
                        if (typeof scope.onPageRender === 'function') {
                            scope.onPageRender();
                        }
                    });
                });
            };

            scope.getArrayNumPages = function () {
                if (pdfDoc !== null) {
                    return new Array(parseInt(pdfDoc.numPages));
                }
            };

            scope.goPrevious = function () {
                if (scope.pageToDisplay <= 1) {
                    return;
                }
                scope.pageNum = parseInt(scope.pageNum) - 1;
            };

            scope.goNext = function () {
                if (scope.pageToDisplay >= pdfDoc.numPages) {
                    return;
                }
                scope.pageNum = parseInt(scope.pageNum) + 1;
            };

            scope.goToPage = function (newPageNum) {
                scope.pageNum = parseInt(newPageNum);
            };

            scope.getCurrentPage = function () {
                return scope.pageToDisplay;
            };

            scope.zoomIn = function () {
                scale = parseFloat(scale) + 0.2;
                scope.renderPage(scope.pageToDisplay);
                return scale;
            };

            scope.zoomOut = function () {
                scale = parseFloat(scale) - 0.2;
                scope.renderPage(scope.pageToDisplay);
                return scale;
            };

            scope.changePage = function () {
                scope.renderPage(scope.pageToDisplay);
            };

            scope.rotate = function () {
                if (canvas.getAttribute('class') === 'rotate0') {
                    canvas.setAttribute('class', 'rotate90');
                } else if (canvas.getAttribute('class') === 'rotate90') {
                    canvas.setAttribute('class', 'rotate180');
                } else if (canvas.getAttribute('class') === 'rotate180') {
                    canvas.setAttribute('class', 'rotate270');
                } else {
                    canvas.setAttribute('class', 'rotate0');
                }
            };

            function renderPDF() {
                if (url && url.length) {
                    var params = {
                        url: url,
                        withCredentials: false
                    };
                    PDFJS.getDocument(params, null, null, scope.onProgress).then(function (_pdfDoc) {
                        if (typeof scope.onLoad === 'function') {
                            scope.onLoad();
                        }

                        pdfDoc = _pdfDoc;
                        scope.renderPage(scope.pageToDisplay);

                        scope.$apply(function () {
                            scope.pageCount = _pdfDoc.numPages;
                        });
                    }, function (error) {
                        $rootScope.$broadcast('PDFPreviewError', error);
                        if (error) {
                            if (typeof scope.onError === 'function') {
                                scope.onError(error);
                            }
                        }
                    });
                }
            }

            scope.$watch('pageNum', function (newVal) {
                scope.pageToDisplay = parseInt(newVal);
                if (pdfDoc !== null) {
                    scope.renderPage(scope.pageToDisplay);
                }
            });

            scope.$watch('pdfUrl', function (newVal) {
                if (newVal !== '') {
                    // console.log('pdfUrl value change detected: ', scope.pdfUrl);
                    url = newVal;
                    scope.pageToDisplay = 1;
                    renderPDF();
                }
            });
        }
    };
}

/***/ }),
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 902 */,
/* 903 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 926 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 927 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

windowResizeDirective.$inject = ['$window', 'HPConfig', '$rootScope']; // angular
// 	.module("HeroPRO")
//     .directive("windowResize", windowResizeDirective);

/* @ngInject */
function windowResizeDirective($window, HPConfig, $rootScope) {
    return {
        restrict: 'A',
        link: link
    };

    function link(scope) {
        // Listen for window resize events and use a debounce function so that
        // setScreenSize is only called 200ms after the window has finished resizing.
        var debouncedCheckWindow = _lodash2.default.debounce(function () {
            setScreenSize();
            scope.$apply();
        }, 200);

        setScreenSize();
        angular.element($window).bind('resize', debouncedCheckWindow);

        function setScreenSize() {
            $rootScope.screenSize = $window.innerWidth >= HPConfig.screenSizes.screen_md ? 'large' : 'small';
        }
    }
}

exports.default = angular.module('directives.windowResize', []).directive('windowResize', windowResizeDirective).name;

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = hpFullScreenModalSuccess;

__webpack_require__(935);

function hpFullScreenModalSuccess() {
    return {
        restrict: 'E',
        scope: {
            primaryText: '@',
            secondaryText: '@',
            contentList: '=',
            proTipText: '@',
            buttonText: '@',
            buttonFn: '&'
        },
        templateUrl: 'app/common/fullScreenModalSuccess/fullScreenModalSuccess.html'
    };
}

/***/ }),
/* 935 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = DropdownSmallPopupDirective;

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

__webpack_require__(937);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

DropdownSmallPopupDirective.$inject = ['$window', '$document', 'HPConfig']; // angular.module('HeroPRO')
// .directive('dropdownSmallPopup',

/* @ngInject */
function DropdownSmallPopupDirective($window, $document, HPConfig) {
    return {
        restrict: 'A',
        scope: { dropdownTitle: '@' },
        link: function link(scope, element) {
            var dropdown = _angular2.default.element(element[0].querySelector('.dropdown-menu'));
            var dropdownToggle = _angular2.default.element(element[0].querySelector('.dropdown-toggle'));

            if (element[0].querySelector('.dropdown-menu') !== null && dropdown[0].localName === 'ul') {
                var ddTitle = scope.dropdownTitle || '&nbsp;';
                dropdown.prepend('<li class=\'close-icon\'>' + ddTitle + '<span class=\'icon icon-delete-circle\'></span></li>');
            } else {
                dropdown.prepend("<div class='close-icon'><span class='icon icon-delete-circle'></span></div>");
            }
            dropdown.bind('click', function () {
                if ($window.innerWidth < HPConfig.screenSizes.screen_md) {
                    _angular2.default.element($document[0].body).removeClass('fixed-body');
                    $window.scroll(scope.scrollX, scope.scrollY);
                }
            });
            dropdownToggle.bind('click', function () {
                var userDropdown = $window.document.querySelector('.dropdown-menu-user-info');
                var contactDropdown = $window.document.querySelector('.dropdown-menu-contact-info');

                if ($window.innerWidth < HPConfig.screenSizes.screen_md) {
                    scope.scrollX = $window.pageXOffset;
                    scope.scrollY = $window.pageYOffset;
                    _angular2.default.element($document[0].body).addClass('fixed-body');
                } else if ($window.innerWidth !== $window.document.documentElement.clientWidth && userDropdown && contactDropdown) {
                    // HACK: If desktop and scrollbars are being shown explicitly set position of contact and user drodpown menus
                    userDropdown.style.right = '30px';
                    contactDropdown.style.right = '104px';
                }

                return true;
            });
        }
    };
}

/***/ }),
/* 937 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = spinnerButton;

__webpack_require__(939);

function spinnerButton() {
    return {
        restrict: 'E',
        scope: {
            buttonFn: '&?',
            buttonName: '@',
            buttonId: '@?',
            buttonText: '@',
            displaySpinner: '=',
            isPrimaryBtn: '=',
            isSubmitButton: '=?',
            isDisabled: '=?'
        },
        templateUrl: 'app/common/controls/spinnerButton/spinnerButton.html',
        link: function link(scope, element) {
            var button = element[0].querySelector('.btn');
            button.setAttribute('name', scope.buttonName);
            if (!scope.isSubmitButton) {
                button.setAttribute('type', 'button');
            }
        }
    };
} // angular
// 	.module("HeroPRO")
// 	.directive('hpSpinnerButton', spinnerButton);

/***/ }),
/* 939 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = spinnerLink;

__webpack_require__(941);

function spinnerLink() {
    return {
        restrict: 'E',
        scope: {
            linkFn: '&?',
            linkText: '@',
            linkUrl: '=',
            displaySpinner: '=',
            icon: '@'
        },
        templateUrl: 'app/common/controls/spinnerLink/spinnerLink.html'
    };
} // angular
// 	.module("HeroPRO")
// 	.directive('hpSpinnerLink', spinnerLink);

/***/ }),
/* 941 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-module\">\n\t<div class=\"hp-inner\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-12\">\n                <div class=\"hp-loading-spinner\" ra-spinner name=\"applicationSpinner\" hide-content-when-shown=\"true\" show=\"true\"></div>\n\t\t\t</div>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 946 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n        <span class=\"icon icon-delete-circle\" ng-click=\"main.closeSpecialNotice();\"></span>\n</div>\n<div class=\"modal-body special-notice\">\n        <div class=\"icons\">\n            <div class=\"new-app\">\n                <img src=\"src/assets/images/PACE_credential.svg\" alt=\"PACE Credential\" class=\"new-app\">\n            </div>\n        </div>\n        <div class=\"title\">\n            <h2>Add a Home Improvement Salesperson (HIS) registration number to your account.</h2>\n        </div>\n        <div class=\"subtitle\">\n            <h4>Only contractors with a valid Home Improvement Salesperson registration number can become a Certified PACE Professional and access HERO Pro's full suite of sales tools.</h4>\n        </div>\n        <div class=\"subtitle\">\n            <h4>Already have an HIS registration number? Add it to your profile now.</h4>\n        </div>\n        <div class=\"buttons\">\n            <a class=\"btn btn-primary\" ng-click=\"main.closeSpecialNotice(true);\" href=\"/accounts/pcc/\">Add Now</a>\n        </div>\n</div>\n";

/***/ }),
/* 947 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n\n</div>\n<div class=\"modal-body\">\n    <div class=\"hp-error\">\n        <img class=\"error-image\" src=\"/src/assets/images/icon-guy.png\" alt=\"Error\" />\n        <h1>Oops! That wasn't right.</h1>\n        <br/>\n        <h3>User needs to sign Terms & Conditions</h3>\n        <br/><br/>\n        <p>Please contact us at 844-722-7759 <br/> or <a href=\"mailto:info@heroprogram.com\" class=\"link\">info@heroprogram.com</a> if you have any questions.</p>\n    </div>\n</div>\n";

/***/ }),
/* 948 */
/***/ (function(module, exports) {

module.exports = "<div ng-controller=\"TopNavController as topNav\">\n    <div class='mobile-popover-overlay hidden-lg hidden-md' ng-if='topNav.isPopoverOpen' ng-click=\"topNav.isPopoverOpen = false\"></div>\n    <nav class=\"navbar navbar-default navbar-static-top\">\n        <div class=\"container-fluid\">\n            <div class=\"navbar-header\">\n\n                <!-- Benji only user -->\n                <div ng-if=\"topNav.isBenjiOnlyUser === true\" class=\"navbar-brand\">\n                    <img ng-src=\"https://cdn.foahomeimprovement.com/graphics/logos/FOAHI_Logo_Horizontal_WEB.svg\" alt=\"Benji\" />\n                </div>\n\n                <div class=\"hidden-lg hidden-md\">\n                    <div type=\"button\" class=\"navbar-toggle collapsed\" ng-click=\"topNav.isCollapsed = !topNav.isCollapsed\" ng-class=\"{'open' : !topNav.isCollapsed }\">\n                        <div ng-show=\"topNav.isCollapsed === true\">\n                            <span class=\"icon-bar\"></span>\n                            <span class=\"icon-bar\"></span>\n                            <span class=\"icon-bar\"></span>\n                        </div>\n\n                        <span class=\"icon icon-close-thick\" ng-show=\"topNav.isCollapsed === false\"></span>\n\n                    </div>\n                    <button class=\"btn btn-primary pull-right apply-now-mobile\" ng-click=\"topNav.applicationClick(); topNav.isCollapsed = true; main.applicationClick()\">\n\n\n                        <ng-container ng-if=\"topNav.isSolicitor\">\n                            <div class=\"hidden-xs\">Get Approved</div>\n                            <span class=\"hidden-lg hidden-md hidden-sm\">Get Approved</span>\n                        </ng-container>\n\n                        <ng-container ng-if=\"!topNav.isSolicitor\">\n                            <span>Apply</span>\n                        </ng-container>\n\n\n                    </button>\n                </div>\n            </div>\n            <div class=\"collapse navbar-collapse \" ng-class=\"{'in' : !topNav.isCollapsed}\" id=\"heroProNavbar\">\n                <div class=\"animate-nav-show animated-top-nav-container\" ng-show=\"topNav.showTopNav\" ng-class=\"{'benji-enabled' : topNav.showBenji }\">\n                    <ul class=\"navbar-nav navbar-location\" ng-show=\"topNav.showTopNavLocation\">\n                        <li class=\"company\">\n                            <span class=\"full-name hidden-md\">{{main.currentLocation.CompanyName}}: </span>\n                            <span class=\"partial-name hidden-xs hidden-sm hidden-lg\">{{main.currentLocation.CompanyName | limitTo: 6}}...: </span>\n\n                        </li>\n                        <li class=\"company-nickname\" ng-if=\"main.userLocations.length == 1\">\n                            <span class=\"hidden-md full-name\">{{main.currentLocation.LocationNickname}}</span>\n                            <span class=\"hidden-xs hidden-sm hidden-lg\">{{main.currentLocation.LocationNickname | limitTo: 6}}...</span>\n                        </li>\n                        <li class=\"locations\" ng-if=\"main.userLocations.length > 1\" uib-popover-template=\"'app/common/topNav/popovers/locationSwitcher.html'\" ng-click=\"topNav.isPopoverOpen = true\" popover-trigger=\"'outsideClick'\"\n                            popover-class=\"popover-location-selector\" popover-placement=\"bottom\" popover-append-to-body=\"true\" popover-is-open=\"topNav.isPopoverOpen\">\n                            <span class=\"dropdown-text full-name hidden-md\">{{main.currentLocation.LocationNickname}}</span>\n                            <span class=\"dropdown-text partial-name  hidden-xs hidden-sm hidden-lg\">{{main.currentLocation.LocationNickname | limitTo: 6}}...</span>\n                            <span class=\"icon icon-ra-angle-down\"></span>\n                        </li>\n\n                    </ul>\n\n                    <ul class=\"contractor-name hidden-md hidden-lg\">\n                        <li>{{main.userData.FirstName}} {{main.userData.LastName}}</li>\n                    </ul>\n\n                    <!-- <ul class=\"hidden-md hidden-lg mobile-nav-options\">\n\n                        <li ng-repeat=\"menuItem in topNav.navItems\" class=\"animate-sidebar-show ng-animate\">\n                            <a ng-class=\"{'active' : topNav.isPageActive(menuItem.pageName)}\" ng-href=\"{{menuItem.link}}\" ng-if=\"menuItem.pageName !== 'benji'\" analytics-on analytics-category=\"MobileNav\" analytics-event=\"{{menuItem.analyticsEvent}}\"\n                                ng-click=\"topNav.isCollapsed = true;\">\n                                <span class=\"icon\" ng-class=\"menuItem.icon\"></span>\n                                <span class='label-icon'>{{menuItem.name}}</span>\n                            </a>\n                            <a ng-click=\"main.benjiLinkClick(true); topNav.isCollapsed = true;\" ng-href=\"{{menuItem.link}}\" ng-if=\"menuItem.pageName === 'benji'\" analytics-on analytics-category=\"MobileNav\" analytics-event=\"{{menuItem.analyticsEvent}}\">\n                                <span class=\"icon\" ng-class=\"menuItem.icon\"></span>\n                            </a>\n                            <span class='label-icon'>{{menuItem.name}}</span>\n                        </li>\n                    </ul> -->\n\n                    <ul class=\"navbar-nav navbar-right animate-nav-show\" ng-show=\"topNav.showTopNav\">\n\n                        <!-- <li class=\"topNav-quality-rating\" ng-show=\"topNav.showCoQR\">\n                            <a blur-element href=\"sso/quality-rating\" target=\"_blank\" ng-click=\"topNav.coQRClick(main.userData.UserName, main.currentLocation.OrganizationId); topNav.isCollapsed = true\">\n                                Quality Rating\n                            </a>\n                        </li>\n                        <li class=\"topNav-kbyg\" ng-show=\"topNav.showKbyg\">\n                            <a blur-element ng-click=\"topNav.kbygClick(); topNav.isCollapsed = true\">\n                                Know Before You Go\n                            </a>\n                        </li> -->\n\n                        <li class=\"topNav-proposal\" ng-show=\"topNav.showProposal === true && topNav.isSolicitor\">\n                            <span class='top-nav-link uib-popover-link' uib-popover-template=\"'app/common/topNav/popovers/proposalOptions.html'\" popover-class=\"popover-proposal-selector\" popover-trigger=\"'outsideClick click'\"\n                                popover-placement=\"bottom-right\" popover-append-to-body=\"true\" ng-click=\"topNav.isPopoverOpen = true\" popover-is-open=\"topNav.proposalPopoverIsOpen\" ng-class=\"{'selected': topNav.proposalPopoverIsOpen}\">\n                                <span>Proposal</span>\n                                <span class=\"icon icon-ra-angle-down\"></span>\n                            </span>\n                        </li>\n\n                        <!-- <li class=\"topNav-proposal\" ng-hide=\"topNav.showProposal === true || !topNav.isSolicitor\">\n                            <a blur-element ng-click=\"topNav.toolClick('Calculator')\">\n                                Calculator\n                            </a>\n                        </li> -->\n\n                        <li class=\"apply-now visible-lg visible-md\" ng-show=\"topNav.showApply\" ng-class=\"{'no-quality-rating' : !topNav.showCoQR}\">\n                            <button class=\"btn btn-primary\" ng-show=\"topNav.isSolicitor === true\" ng-click=\"topNav.applicationClick(); topNav.isCollapsed = true; main.applicationClick()\">\n                                Get Approved\n                            </button>\n                            <button class=\"btn btn-primary\" ng-show=\"topNav.isSolicitor !== true\" ng-click=\"topNav.applicationClick(); topNav.isCollapsed = true; main.applicationClick()\">\n                                Apply\n                            </button>\n                        </li>\n                        <li class=\"topNav-contact-info visible-lg visible-md\" ng-show=\"topNav.showContact\">\n                            <span id=\"topNav-contact-info-coach-target\" uib-popover-template=\"'app/common/topNav/popovers/contactInfo.html'\" popover-class=\"header-icon-popover\" popover-trigger=\"'outsideClick'\"\n                                popover-placement=\"bottom-right\" class=\"icon icon-ra-phone-lrg header-icon\" popover-is-open=\"topNav.contactInfoPopoverIsOpen\" ng-class=\"{'selected': topNav.contactInfoPopoverIsOpen}\"></span>\n                        </li>\n                        <li class=\"topNav-user-info visible-lg visible-md\" ng-show=\"topNav.showPersonalInfo\">\n                            <span id=\"topNav-user-info-coach-target\" uib-popover-template=\"'app/common/topNav/popovers/userInfo.html'\" popover-class=\"header-icon-popover\" popover-trigger=\"'outsideClick'\" popover-placement=\"bottom-right\"\n                                class=\"icon icon-ra-account-lrg header-icon\" popover-is-open=\"topNav.userInfoPopoverIsOpen\" ng-class=\"{'selected': topNav.userInfoPopoverIsOpen}\"></span>\n                        </li>\n                        <li ng-show=\"topNav.backToProjects\" class=\"back-to-projects-desktop\">\n                            <a href=\"{{topNav.benjiLink}}\">Back to projects &rsaquo;</a>\n                        </li>\n                    </ul>\n                    <!-- <div class=\"contact-info visible-xs visible-sm\">\n                        <ng-include src=\"'app/common/topNav/popovers/contactInfo.html'\"></ng-include>\n                    </div> -->\n                </div>\n            </div>\n        </div>\n    </nav>\n</div>";

/***/ }),
/* 949 */
/***/ (function(module, exports) {

module.exports = "<div class=\"sidebar-container\" ng-controller=\"SidebarController as sidebar\">\n    <ul>\n        <li ng-repeat=\"menuItem in sidebar.navItems\" class=\"animate-sidebar-show ng-animate\">\n            <a ng-class=\"{'active' : sidebar.isPageActive(menuItem.pageName)}\" ng-href=\"{{menuItem.link}}\" ng-if=\"menuItem.pageName !== 'benji' && menuItem.pageName !== 'reports'\"\n               analytics-on analytics-category=\"LeftNav\" analytics-event=\"{{menuItem.analyticsEvent}}\">\n                <span class=\"icon\" ng-class=\"menuItem.icon\"></span>\n                <span>{{menuItem.name}}</span>\n            </a>\n            <a ng-click=\"main.benjiLinkClick(true)\" ng-href=\"{{menuItem.link}}\" ng-if=\"menuItem.pageName === 'benji'\"\n               analytics-on analytics-category=\"LeftNav\" analytics-event=\"{{menuItem.analyticsEvent}}\">\n                <span class=\"icon\" ng-class=\"menuItem.icon\"></span>\n                <span>{{menuItem.name}}</span>\n            </a>\n            <a ng-href=\"{{menuItem.link}}\" target=\"_blank\" ng-if=\"sidebar.showReports && menuItem.pageName === 'reports'\"\n               analytics-on analytics-category=\"LeftNav\" analytics-event=\"{{menuItem.analyticsEvent}}\">\n                <span class=\"icon\" ng-class=\"menuItem.icon\"></span>\n                <span>{{menuItem.name}}</span>\n            </a>\n        </li>\n    </ul>\n</div>\n";

/***/ }),
/* 950 */
/***/ (function(module, exports) {

module.exports = "<div ng-controller=\"ContactInfoController as contactInfoController\" class=\"dropdown-menu-contact-info popover-content-container contact-info\">\r\n    <div class=\"container-fluid\">\r\n        <div class=\"contact-info-title\">Contact Us</div>\r\n        <a class=\"hero-phone\" ng-href=\"tel:contactInfoController.contactInfo.phone\">{{contactInfoController.contactInfo.phone}}</a>\r\n        <p class=\"hero-phone-alpha\" ng-if=\"contactInfoController.contactInfo.phoneAlphaNumeric\">{{contactInfoController.contactInfo.phoneAlphaNumeric}}</p>\r\n        <p class=\"contact-info-email\"><a href=\"mailto:info@foahi.com\">info@foahi.com</a></p>\r\n        <p class=\"contact-info-hours-title\">Hours of operation</p>\r\n        <p class=\"contact-info-time-zone\">(Pacific Time)</p>\r\n        <ul class=\"contact-info-hours\">\r\n            <li ng-repeat=\"h in contactInfoController.contactInfo.callHours\">\r\n                <span>{{h.Days}}</span>\r\n                <span ng-if=\"h.IsClosed == false\">{{h.StartOfWork}} - {{h.EndOfWork}}</span>\r\n                <span ng-if=\"h.IsClosed == true\">Closed</span>\r\n            </li>\r\n        </ul>\r\n    </div>\r\n    <div class=\"container-fluid account-info-cam-container\" ng-if=\"main.currentLocation.AccountManager\">\r\n        <h5 class=\"text-muted\">Your account manager</h5>\r\n        <span ng-hide=\"true\">{{main.currentLocation.AccountManager.UserId}}</span>\r\n        <div class=\"contact-info-cam\">\r\n            <div>\r\n                <span class=\"contact-info-cam-name\">\r\n                    {{main.currentLocation.AccountManager.FirstName}} {{main.currentLocation.AccountManager.LastName}}\r\n                </span>\r\n                <span class=\"contact-info-cam-phone\" ng-if=\"main.currentLocation.AccountManager.MobilePhone\">\r\n                    <a href=\"tel:{{main.currentLocation.AccountManager.MobilePhone}}\">{{main.currentLocation.AccountManager.MobilePhone}}</a>\r\n                </span>\r\n                <span class=\"contact-info-cam-phone\" ng-if=\"main.currentLocation.AccountManager.Phone && !main.currentLocation.AccountManager.MobilePhone\">\r\n                    <a href=\"tel:{{main.currentLocation.AccountManager.Phone}}\">{{main.currentLocation.AccountManager.Phone}}</a>\r\n                    <span ng-if=\"main.currentLocation.AccountManager.PhoneExt\">Ext. {{main.currentLocation.AccountManager.PhoneExt}}</span>\r\n                </span>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>";

/***/ }),
/* 951 */
/***/ (function(module, exports) {

module.exports = "<div class=\"brand-switcher\">\n    <a href=\"#\" ng-click=\"main.benjiLinkClick(false)\">Switch to Benji</a>\n</div>";

/***/ }),
/* 952 */
/***/ (function(module, exports) {

module.exports = "\n\n    <ul class=\"location-selections\">\n        <li ng-repeat=\"userLocation in main.userLocations\" ng-class=\"{'active': main.currentLocation.ContractorId === userLocation.ContractorId}\"\n            ng-click=\"main.updateLocation($event,userLocation); topNav.isCollapsed = true; topNav.isPopoverOpen = false\">\n            <span>{{userLocation.LocationNickname}}</span>\n        </li>\n    </ul>\n";

/***/ }),
/* 953 */
/***/ (function(module, exports) {

module.exports = "<ul class=\"popover-content-container\">\n    <li ng-repeat=\"tool in topNav.proposalTools\" ng-click=\"topNav.toolClick(tool)\">\n        <span>{{tool}}</span>\n    </li>\n</ul>\n";

/***/ }),
/* 954 */
/***/ (function(module, exports) {

module.exports = "<div class=\"dropdown-menu-user-info popover-content-container\">\n    <div class=\"container-fluid\">\n        <h5>Hi, {{main.userData.FirstName}}</h5>\n        <ul class=\"user-info-links\">\n            <li><a href=\"/accounts/myprofile/\">Account</a></li>\n            <li><a href=\"#\" ng-click=\"topNav.logout()\">Logout</a></li>\n        </ul>\n    </div>\n    <hr/>\n    <div class=\"container-fluid\">\n        <ul>\n            <li>\n                {{main.currentLocation.CompanyName}} - {{main.currentLocation.LocationNickname}}\n            </li>\n            <li>\n                {{main.currentLocation.Address}}<br/>\n                {{main.currentLocation.City}}, {{main.currentLocation.State}} {{main.currentLocation.Zip}}\n            </li>\n            <li class=\"cslb\" ng-if=\"topNav.showCSLB === true\">\n                CSLB # {{main.currentLocation.LicenseNumber}}\n            </li>\n        </ul>\n    </div>\n</div>\n";

/***/ }),
/* 955 */
/***/ (function(module, exports) {

module.exports = "<div class=\"full-screen-modal-success\">\n\t<div class=\"row\">\n\t\t<div class=\"col-md-8 col-md-offset-2 text-center\">\n\t\t\t<span class=\"icon icon-todo\"></span>\n\t\t\t<p class=\"primary-text\">{{primaryText}}</p>\n\t\t\t<p class=\"secondary-text\">{{secondaryText}}</p>\n\t\t</div>\n\t</div>\n\n\t<div class=\"row\" ng-if=\"contentList !== undefined\">\n\t\t<div class=\"col-md-8 col-md-offset-2 content-list text-center\">\n\t\t\t<div ng-repeat=\"content in contentList track by $index\" class=\"content-list-item\">\n\t\t\t\t<p ng-repeat=\"value in content\">{{value}}</p>\n\t\t\t</div>\n\t\t</div>\n\t</div>\t\n\n\t<div class=\"row\" ng-if=\"proTipText !== undefined\">\n\t\t<div class=\"col-md-6 col-md-offset-3 modal-pro-tip\">\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-md-2\">\n\t\t\t\t\t<span class=\"icon icon-tip\"></span>\n\t\t\t\t\t<span>Pro Tip</span>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-10\">\n\t\t\t\t\t<p>{{proTipText}}</p>\t\t\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class=\"modal-buttons text-center\">\n\t\t<button class=\"btn btn-primary\" ng-click=\"buttonFn()\">{{buttonText}}</button>\n\t</div>\n</div>";

/***/ }),
/* 956 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hopscotch-bubble-container\" style=\"width: <%= step.width %>px; padding: <%= step.padding %>px;\">\n    <% if(tour.isTour){ %>\n        <span class=\"hopscotch-bubble-number\"><%= i18n.stepNum %>/<%= tour.numSteps %></span>\n    <% } %>\n    <div class=\"hopscotch-bubble-content\">\n        <% if(step.title !== ''){ %><h3 class=\"hopscotch-title\"><%= step.title %></h3><% } %>\n        <% if(step.content  !== ''){ %><div class=\"hopscotch-content\"><%= step.content %></div><% } %>\n        <div class=\"hopscotch-actions\">\n            <% if(buttons.showPrev){ %><button class=\"hopscotch-nav-button prev hopscotch-prev\"><%= i18n.prevBtn %></button><% } %>\n            <% if(buttons.showCTA){ %><button class=\"hopscotch-nav-button next hopscotch-cta\"><%= buttons.ctaLabel %></button><% } %>\n            <% if(buttons.showNext){ %><button class=\"btn btn-primary hopscotch-next\"><%= i18n.nextBtn %></button><% } %>\n        </div>\n    </div>\n    <% if(buttons.showClose){ %>\n        <span class=\"link hopscotch-close\"><%= tour.customData.dismissText %></span>\n    <% } %>\n</div>\n<div class=\"hopscotch-bubble-arrow-container hopscotch-arrow\">\n    <div class=\"hopscotch-bubble-arrow-border\"></div>\n    <div class=\"hopscotch-bubble-arrow\"></div>\n</div>";

/***/ }),
/* 957 */
/***/ (function(module, exports) {

module.exports = "<div class=\"hp-module hp-error\">\n\t<img class=\"error-image\" src=\"/src/assets/images/icon-guy.png\" alt=\"Error\" />\n\t<h1>Oops! That wasn't right.</h1>\n\t<p>Please contact us at 844-722-7759 <br/> or <a href=\"mailto:info@heroprogram.com\" class=\"link\">info@heroprogram.com</a> if you have any questions.</p>\n\t<a ui-sref=\"dashboard\" class=\"btn btn-primary\">Go to My Dashboard </a>\n</div>\n";

/***/ }),
/* 958 */
/***/ (function(module, exports) {

module.exports = "<button ng-click=\"buttonFn()\" class=\"spinner-button btn\"  ng-attr-id=\"{{ buttonId }}\"\n        ng-class=\"{'btn-primary': isPrimaryBtn === true, 'btn-default': isPrimaryBtn === false, 'clicked': displaySpinner === true}\" ng-disabled=\"isDisabled\">\n    <span ng-bind=\"buttonText\" ng-if=\"displaySpinner === false\"></span>\n    <div class=\"spinner-button-container\">\n        <div ra-spinner name=\"btnSpinner\" show=\"displaySpinner === true\" template=\"indeterminateSpinnerSmall\" register=\"false\"></div>\n    </div>\n</button>";

/***/ }),
/* 959 */
/***/ (function(module, exports) {

module.exports = "<div class=\"spinner-link\" ng-class=\"{'in-progress': displaySpinner === true}\" ng-click=\"linkFn()\">\n\t<div class=\"symbol-container\">\n\t\t<span class=\"icon icon-{{icon}}\" ng-if=\"displaySpinner === false\"></span>\n\t\t<div class=\"spinner-button-container\" ng-if=\"displaySpinner === true\">\n\t        <div ra-spinner name=\"btnSpinner\" show=\"displaySpinner === true\" template=\"indeterminateSpinnerSmallBlue\" register=\"false\"></div>\n\t    </div>\n\t</div>\n\t<!-- If a linkUrl is provided use it with an <a> tag, otherwise use a <span> -->\n\t<span ng-if=\"linkUrl === undefined\" class=\"link\" ng-bind=\"linkText\"></span>\n\t<a hp-download-link ng-if=\"linkUrl !== undefined\" ng-href=\"{{linkUrl}}\">{{linkText}}</a>\n</div>\n";

/***/ }),
/* 960 */
/***/ (function(module, exports) {

module.exports = "<div class=\"sso container\">\n    <div class=\"hp-loading-spinner\" ra-spinner name=\"ssoLoadingSpinner\" hide-content-when-shown=\"true\" show=\"true\">\n\n    </div>\n    \n</div>";

/***/ }),
/* 961 */
/***/ (function(module, exports) {

module.exports = "<p>As a PACE Participant: </p>\n<ul class='popover-list'>\n    <li>You can introduce and provide general information about HERO financing to customers using resources provided to you by Renovate America. You can also perform administrative or clerical tasks related to HERO financing. You cannot, however, discuss the financing details of a specific HERO financing assessment contract with a customer.</li>\n    <li>Renovate America will provide you with resources that you can use to introduce HERO financing, such as responses to FAQs, scripts, a HERO overview video, and brochures. You will not have access to the financial payment calculator, quoting and similar tools in HEROPro.</li>\n    <li>\n        You will need to complete applicable registration and training requirements, including:\n        <ul class='popover-list'>\n            <li>Complete the introductory training and approximately thirty minute PACE Participant training specific to advertising HERO financing; and</li>\n            <li>Agree to the California HERO PACE Participant Code of Conduct.</li>\n        </ul>\n    </li>\n</ul>";

/***/ }),
/* 962 */
/***/ (function(module, exports) {

module.exports = "<p>\n    As a Certified PACE Professional:\n</p>\n<ul class='popover-list'>\n    <li>You can discuss the financing terms of specific HERO financing assessment contracts with your customers. You\n        can also perform administrative, clerical and other approved tasks related to HERO financing.</li>\n    <li>You will have full access to Renovate America’s Proposal Plus, Payment Calculator, a variety of marketing\n        materials and other resources in HEROPro. </li>\n    <li>\n        You will need to complete applicable registration and training requirements, including:\n        <ul class='popover-list'>\n            <li>Provide Renovate America with your Home Improvement Salesperson (HIS) registration number; </li>\n            <li>Complete the introductory training and 6-hour PACE certification training course; and</li>\n            <li>Agree to California HERO Certified PACE Professional Code of Conduct.</li>\n        </ul>\n    </li>\n</ul>";

/***/ }),
/* 963 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <span class=\"icon icon-delete pull-right\" ng-click=\"ParticipantVsCertifiedProfessionalComparisonController.closeModal()\"></span>\n    <h2>PACE Roles</h2>\n    <table class='comparison-table'>\n        <tr>\n            <th>\n                PACE Participant (PP)<br />\n                Certified PACE Professional (CPP)\n            </th>\n            <th>PP</th>\n            <th>CPP</th>\n        </tr>\n        <tr>\n            <td>Discuss the financing terms of specific HERO financing assessment contracts with your customers</td>\n            <td><img src=\"src/assets/images/ic_x.svg\" /></td>\n            <td><img src=\"src/assets/images/ic_check.svg\" /></td>\n        </tr>\n        <tr>\n            <td>Access to Renovate America’s Proposal Plus, Payment Calculator, and similar resources in HEROPro</td>\n            <td><img src=\"src/assets/images/ic_x.svg\" /></td>\n            <td><img src=\"src/assets/images/ic_check.svg\" /></td>\n        </tr>\n        <tr>\n            <td>Provide general info about HERO financing to customers using only PACE Participant resources provided to you by Renovate America</td>\n            <td><img src=\"src/assets/images/ic_check.svg\" /></td>\n            <td><img src=\"src/assets/images/ic_x.svg\" /></td>\n        </tr>\n        <tr>\n            <td>Must direct customers to renovateamerica.com or to call us directly to apply</td>\n            <td><img src=\"src/assets/images/ic_check.svg\" /></td>\n            <td><img src=\"src/assets/images/ic_x.svg\" /></td>\n        </tr>\n        <tr>\n            <td>Perform administrative or clerical tasks related to HERO financing</td>\n            <td><img src=\"src/assets/images/ic_check.svg\" /></td>\n            <td><img src=\"src/assets/images/ic_check.svg\" /></td>\n        </tr>\n    </table>\n</div>";

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./glyphicons-halflings-regular.eot": 965,
	"./glyphicons-halflings-regular.svg": 966,
	"./glyphicons-halflings-regular.ttf": 967,
	"./glyphicons-halflings-regular.woff": 968,
	"./glyphicons-halflings-regular.woff2": 969,
	"./hero-pro-full-v2.eot": 970,
	"./hero-pro-full-v2.svg": 971,
	"./hero-pro-full-v2.ttf": 972,
	"./hero-pro-full-v2.woff": 973
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 964;

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/fonts/glyphicons-halflings-regular.eot?f43ff11521dd89de1385b0a6aef065ea";

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/fonts/glyphicons-halflings-regular.svg?89889688147bd7575d6327160d64e760";

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/fonts/glyphicons-halflings-regular.ttf?c227050c1152e4b46f1717820c907b9a";

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/fonts/glyphicons-halflings-regular.woff";

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/fonts/glyphicons-halflings-regular.woff2";

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/fonts/hero-pro-full-v2.eot?7581482c46f19f027e1b0fd1942ea2f6";

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/fonts/hero-pro-full-v2.svg?dc87de297e7f7591c54b7c6da39b855d";

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/fonts/hero-pro-full-v2.ttf?908f5c40381555db3102d0e81ba53f4d";

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/fonts/hero-pro-full-v2.woff";

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./HERO-Logo-Lg.png": 975,
	"./HERO-Logo.png": 976,
	"./HERO-new-app-modal.svg": 977,
	"./HEROPgm-Logo.png": 978,
	"./Notifications_RA.png": 979,
	"./PACE_credential.svg": 980,
	"./PACEcredential.svg": 981,
	"./RA-Logo.png": 982,
	"./bar-graph.jpg": 983,
	"./bg-grey-column.jpg": 790,
	"./cam_icon.png": 984,
	"./cert-error-load.png": 985,
	"./cert-error-load2x.png": 986,
	"./chartup.svg": 987,
	"./close-btn.png": 988,
	"./exc-alert.png": 989,
	"./favicon.ico": 990,
	"./hero-check-sample.jpg": 991,
	"./hero-pro-beta-logo-red.png": 992,
	"./hero-pro-beta-logo-white.png": 993,
	"./hero_certificate.png": 994,
	"./hp-bg.png": 995,
	"./ic_RA_inline_color.svg": 996,
	"./ic_check.svg": 997,
	"./ic_x.svg": 998,
	"./icon-checkmark-solid.svg": 999,
	"./icon-cone.png": 1000,
	"./icon-contractor.svg": 1001,
	"./icon-guy.png": 1002,
	"./icon-homeowner.svg": 1003,
	"./icon-pipeline-summary-app.png": 1004,
	"./icon-pipeline-summary-closed.png": 1005,
	"./icon-pipeline-summary-docs.png": 1006,
	"./icon-pipeline-summary-leads.png": 1007,
	"./icon-tab-chat.png": 1008,
	"./icon-tab-close.png": 1009,
	"./icon_speech_bubbles.svg": 1010,
	"./illustration_safeguards_laptop.svg": 1011,
	"./logo-RA.png": 1012,
	"./logo-RA@2x.png": 1013,
	"./logo-benji-color.svg": 1014,
	"./logo-benji.png": 1015,
	"./logo-benji@2x.png": 1016,
	"./logo-hero-color.svg": 1017,
	"./logo-heropro-white.png": 1018,
	"./logo_hero@2x.png": 1019,
	"./logo_hero_color.png": 1020,
	"./logo_hero_color@2x.png": 1021,
	"./marketing-materials-bg.jpg": 1022,
	"./marketing-materials-bg.png": 1023,
	"./product-icons/icon-altenergy.png": 1024,
	"./product-icons/icon-altenergy.svg": 1025,
	"./product-icons/icon-altenergy@2x.png": 1026,
	"./product-icons/icon-hvac.png": 1027,
	"./product-icons/icon-hvac.svg": 1028,
	"./product-icons/icon-hvac@2x.png": 1029,
	"./product-icons/icon-insulation.png": 1030,
	"./product-icons/icon-insulation.svg": 1031,
	"./product-icons/icon-insulation@2x.png": 1032,
	"./product-icons/icon-landscaping.png": 1033,
	"./product-icons/icon-landscaping.svg": 1034,
	"./product-icons/icon-landscaping@2x.png": 1035,
	"./product-icons/icon-lighting.png": 1036,
	"./product-icons/icon-lighting.svg": 1037,
	"./product-icons/icon-lighting@2x.png": 1038,
	"./product-icons/icon-plumbing.png": 1039,
	"./product-icons/icon-plumbing.svg": 1040,
	"./product-icons/icon-plumbing@2x.png": 1041,
	"./product-icons/icon-pool.png": 1042,
	"./product-icons/icon-pool.svg": 1043,
	"./product-icons/icon-pool@2x.png": 1044,
	"./product-icons/icon-roofing.png": 1045,
	"./product-icons/icon-roofing.svg": 1046,
	"./product-icons/icon-roofing@2x.png": 1047,
	"./product-icons/icon-solar.png": 1048,
	"./product-icons/icon-solar.svg": 1049,
	"./product-icons/icon-solar@2x.png": 1050,
	"./product-icons/icon-waterheating.png": 1051,
	"./product-icons/icon-waterheating.svg": 1052,
	"./product-icons/icon-waterheating@2x.png": 1053,
	"./product-icons/icon-wind.png": 1054,
	"./product-icons/icon-wind.svg": 1055,
	"./product-icons/icon-wind@2x.png": 1056,
	"./product-icons/icon-windowdoor.png": 1057,
	"./product-icons/icon-windowdoor.svg": 1058,
	"./product-icons/icon-windowdoor@2x.png": 1059,
	"./select-sprite.png": 1060,
	"./shield.svg": 1061,
	"./target.svg": 1062,
	"./tips.png": 1063
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 974;

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/HERO-Logo-Lg.png?7eaf71f7981b5758fdae989850e863fa";

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/HERO-Logo.png?d0502c46d59750a8a9a22abab1926d25";

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/HERO-new-app-modal.svg?e3f8abf2bf92b326c5350484e027cdcf";

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/HEROPgm-Logo.png?d0502c46d59750a8a9a22abab1926d25";

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/Notifications_RA.png?7827e43e498f4b3312b47bd59d23b4a9";

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/PACE_credential.svg?67dd38d935d360036dd28f2356ccd4e6";

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/PACEcredential.svg?67dd38d935d360036dd28f2356ccd4e6";

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/RA-Logo.png?9b73638e48d7003d46ea6fa7ceae5165";

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/bar-graph.jpg?8123db63ce29aa2161d17547973940b6";

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/cam_icon.png?fcd5af089c62fbf9df49b405dae4f2a4";

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/cert-error-load.png?309bb4188fdefca18b66457bfe6c531b";

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/cert-error-load2x.png?e8e7d4b111146471bcb6eee0d86ac643";

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/chartup.svg?b3269331c3dea2ca76726ef4b737f03a";

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/close-btn.png?e3a035cb30aba35bbc0fdfe3956a953a";

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/exc-alert.png?8d1c1a302554dfb1dfe73d84996d9d64";

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/favicon.ico?6ed63f652a7ad59664d8c0bf35339560";

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/hero-check-sample.jpg?48857e43c2cb045c3e696d9264040798";

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/hero-pro-beta-logo-red.png?a2145e1030dfed81408bf7391ff0545a";

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/hero-pro-beta-logo-white.png?7775dd6b71b7cdc15bff6179a25d756c";

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/hero_certificate.png?3f2c143fde3e0f87f45369295487dc1f";

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/hp-bg.png?340538d8f541975e8290487699e9c9c4";

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/ic_RA_inline_color.svg?01a5ec58acd4010dc3cd9f6a847e5b94";

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/ic_check.svg?3db7c1a6c4b7f53d7c6621234e5dd768";

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/ic_x.svg?d3149b01e0c1a8fe253418e810d6e0ca";

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/icon-checkmark-solid.svg?2c900908752ef1a10adbec520fdbad46";

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/icon-cone.png?6997934ed9bb266f75c13bd06e26ae32";

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/icon-contractor.svg?cc359e9dd9b96d00494d767dad2753b1";

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/icon-guy.png?e3b3a5aaa0a79ba80c88e3c1a3a6ac31";

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/icon-homeowner.svg?6215892a4493812fc417e334b70b0763";

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/icon-pipeline-summary-app.png?d63a1589117054454d13107e32d9fcd1";

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/icon-pipeline-summary-closed.png?39e89206da7940018e1772ad14263827";

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/icon-pipeline-summary-docs.png?e5804a3fc887bccf60624be0a783e17b";

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/icon-pipeline-summary-leads.png?48804b2603cd829082e10dbe2d97ca06";

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/icon-tab-chat.png?9198a4358929975a5d89e3f65c4ac8dd";

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/icon-tab-close.png?5e0e5b9b769522adca32bb6b94c61559";

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/icon_speech_bubbles.svg?6e29348a3d83eb798a329b31d5371cda";

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/illustration_safeguards_laptop.svg?825d783b9d312871e197c2af0b57a7de";

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/logo-RA.png?c8939807393e86b4dab5c6ae9544c5ee";

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/logo-RA@2x.png?58d83b257c4f861f1fdd3f00d83581cb";

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/logo-benji-color.svg?01d9999b0ba6566d63d6ea410cb18e65";

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/logo-benji.png?a91bb6467c8c805f6f8aef72998e4aa4";

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/logo-benji@2x.png?5bac5cb80171fb2fe3a7e748a36bb1f8";

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/logo-hero-color.svg?282f46d423b769a6a8b18a65c96ad993";

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/logo-heropro-white.png?b876a3db2333b25d365b6cc7f48a331a";

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/logo_hero@2x.png?a35e68b62d4177f0c99be05c0337ceef";

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/logo_hero_color.png?d7d089d5363ce6cd1f7874ebb9a3beb4";

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/logo_hero_color@2x.png?94fa66edbd563760a80113624952061e";

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/marketing-materials-bg.jpg?07fd794cd72540936e5d8f305ac531e8";

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/marketing-materials-bg.png?3e095a370dd55080c1143ba08e5c7e49";

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-altenergy.png?e59b9e4b2f16f431d64c2f187196e04d";

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-altenergy.svg?46e7866cb3b3f90f57bbef533d4a7fb4";

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-altenergy@2x.png?1ce831b7489b76ba1bdf0798d89b4fb3";

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-hvac.png?61caa0ad4a81bf3e93609c8568b5d870";

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-hvac.svg?d86ca05b4b4b401447bc8beef43dd076";

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-hvac@2x.png?9cbef77d9dbf47052b7103979e6fd732";

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-insulation.png?c0a321c2cd31214938975246aa27108b";

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-insulation.svg?d993dc88b8eee052680f72f5e91c8fb7";

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-insulation@2x.png?707f404b388c7b5d7ba09a1faba6b0a9";

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-landscaping.png?f0f5c4bc9a91da9401f4445b8afad1a5";

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-landscaping.svg?19cc5113115bc3687e725590e95d24e6";

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-landscaping@2x.png?a443a5db6a15079768a92b014dba8150";

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-lighting.png?e84dda148108758586c3f7f28a3f69d2";

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-lighting.svg?c526efda7aaae43ff846728d3018662c";

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-lighting@2x.png?5a4e9ad4d6947bba2cedab47ed4e7d25";

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-plumbing.png?904f3a66d2dad29c65f0ce6225e9e44b";

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-plumbing.svg?3c156af3a752444c6b86948227778205";

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-plumbing@2x.png?8245ddf6a81c2c70defbadbdea52971d";

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-pool.png?aa4dc56e352400c0293ce90cfe5e7a0e";

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-pool.svg?7cca9a85ea2e3a3a7e9bce1a0d36f570";

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-pool@2x.png?19c80521fa1f4a4f895a1f40c343762a";

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-roofing.png?02422edb6e9d620b414cb6510218f9d2";

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-roofing.svg?dbe8f39c9945bfbd6c28959bf261a925";

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-roofing@2x.png?c1d42cc672f3ff6a330ade0a1a232e76";

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-solar.png?68860150ba6780645e0c4c4623f0503d";

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-solar.svg?2286ab89129a5a3bf242c160a9d17b99";

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-solar@2x.png?2961debdd1bdd6aefcfcad7678bbd1fc";

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-waterheating.png?3bb2287eeec37e2462abdbd60f3ffc26";

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-waterheating.svg?c4c19952678a99a54187da99b8ff3ae3";

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-waterheating@2x.png?fc315c72de1543241485b6d0fb7a406a";

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-wind.png?51fb987571d4f6f5f09e889edd065d22";

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-wind.svg?da3325ca5272452e2c8fb3226d7b9512";

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-wind@2x.png?71ab8d28c43b312c0fb12dfc5c525430";

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-windowdoor.png?447384d6765742c40049d5a7d4e05e34";

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-windowdoor.svg?f6a2ef2f5f671aaf76cc228e0ec56804";

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/product-icons/icon-windowdoor@2x.png?f3737c1e64df4c47c9f30d9a7ffc8538";

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/select-sprite.png?ce6626aa52bb37dc385aab9494737d55";

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/shield.svg?576b0bc7c884c243f1a93706528db727";

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/target.svg?159d366bd9c269c445b15eaf764b80f2";

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/images/tips.png?0411e5a895b45ca99990e5b0fe144373";

/***/ })
]),[91]);


// WEBPACK FOOTER //
// main.7afb2e18e3677ea55594.js?